/* eslint-disable */
import { gql } from '@apollo/client';
import * as ApolloReact from '@apollo/client/react';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  Json: { input: any; output: any; }
  NEVER: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type Address = {
  __typename?: 'Address';
  Person: Person;
  city?: Maybe<Scalars['String']['output']>;
  complement?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  neighborhood?: Maybe<Scalars['String']['output']>;
  personId: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type AddressAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type AddressCountOrderByAggregateInput = {
  city?: InputMaybe<SortOrder>;
  complement?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  neighborhood?: InputMaybe<SortOrder>;
  personId?: InputMaybe<SortOrder>;
  postalCode?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  street?: InputMaybe<SortOrder>;
};

export type AddressCreateInput = {
  Person: PersonCreateNestedOneWithoutAddressInput;
  city?: InputMaybe<Scalars['String']['input']>;
  complement?: InputMaybe<Scalars['String']['input']>;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type AddressCreateManyInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  complement?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  personId: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type AddressCreateNestedOneWithoutPersonInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutPersonInput>;
  create?: InputMaybe<AddressCreateWithoutPersonInput>;
};

export type AddressCreateOrConnectWithoutPersonInput = {
  create: AddressCreateWithoutPersonInput;
  where: AddressWhereUniqueInput;
};

export type AddressCreateWithoutPersonInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  complement?: InputMaybe<Scalars['String']['input']>;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  complement?: InputMaybe<Scalars['String']['input']>;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type AddressMaxOrderByAggregateInput = {
  city?: InputMaybe<SortOrder>;
  complement?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  neighborhood?: InputMaybe<SortOrder>;
  personId?: InputMaybe<SortOrder>;
  postalCode?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  street?: InputMaybe<SortOrder>;
};

export type AddressMinOrderByAggregateInput = {
  city?: InputMaybe<SortOrder>;
  complement?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  neighborhood?: InputMaybe<SortOrder>;
  personId?: InputMaybe<SortOrder>;
  postalCode?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  street?: InputMaybe<SortOrder>;
};

export type AddressNullableRelationFilter = {
  is?: InputMaybe<AddressWhereInput>;
  isNot?: InputMaybe<AddressWhereInput>;
};

export type AddressOrderByWithAggregationInput = {
  _avg?: InputMaybe<AddressAvgOrderByAggregateInput>;
  _count?: InputMaybe<AddressCountOrderByAggregateInput>;
  _max?: InputMaybe<AddressMaxOrderByAggregateInput>;
  _min?: InputMaybe<AddressMinOrderByAggregateInput>;
  _sum?: InputMaybe<AddressSumOrderByAggregateInput>;
  city?: InputMaybe<SortOrder>;
  complement?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  neighborhood?: InputMaybe<SortOrder>;
  personId?: InputMaybe<SortOrder>;
  postalCode?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  street?: InputMaybe<SortOrder>;
};

export type AddressOrderByWithRelationInput = {
  Person?: InputMaybe<PersonOrderByWithRelationInput>;
  city?: InputMaybe<SortOrder>;
  complement?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  neighborhood?: InputMaybe<SortOrder>;
  personId?: InputMaybe<SortOrder>;
  postalCode?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  street?: InputMaybe<SortOrder>;
};

export enum AddressScalarFieldEnum {
  City = 'city',
  Complement = 'complement',
  Id = 'id',
  Neighborhood = 'neighborhood',
  PersonId = 'personId',
  PostalCode = 'postalCode',
  State = 'state',
  Street = 'street'
}

export type AddressScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<AddressScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<AddressScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<AddressScalarWhereWithAggregatesInput>>;
  city?: InputMaybe<StringNullableWithAggregatesFilter>;
  complement?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  neighborhood?: InputMaybe<StringNullableWithAggregatesFilter>;
  personId?: InputMaybe<StringWithAggregatesFilter>;
  postalCode?: InputMaybe<StringNullableWithAggregatesFilter>;
  state?: InputMaybe<StringNullableWithAggregatesFilter>;
  street?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type AddressSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type AddressUpdateInput = {
  Person?: InputMaybe<PersonUpdateOneRequiredWithoutAddressNestedInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  complement?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neighborhood?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  street?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type AddressUpdateManyMutationInput = {
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  complement?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neighborhood?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  street?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type AddressUpdateOneWithoutPersonNestedInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutPersonInput>;
  create?: InputMaybe<AddressCreateWithoutPersonInput>;
  delete?: InputMaybe<AddressWhereInput>;
  disconnect?: InputMaybe<AddressWhereInput>;
  update?: InputMaybe<AddressUpdateToOneWithWhereWithoutPersonInput>;
  upsert?: InputMaybe<AddressUpsertWithoutPersonInput>;
};

export type AddressUpdateToOneWithWhereWithoutPersonInput = {
  data: AddressUpdateWithoutPersonInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressUpdateWithoutPersonInput = {
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  complement?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  neighborhood?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  street?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type AddressUpsertWithoutPersonInput = {
  create: AddressCreateWithoutPersonInput;
  update: AddressUpdateWithoutPersonInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressWhereInput = {
  AND?: InputMaybe<Array<AddressWhereInput>>;
  NOT?: InputMaybe<Array<AddressWhereInput>>;
  OR?: InputMaybe<Array<AddressWhereInput>>;
  Person?: InputMaybe<PersonWhereInput>;
  city?: InputMaybe<StringNullableFilter>;
  complement?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  neighborhood?: InputMaybe<StringNullableFilter>;
  personId?: InputMaybe<StringFilter>;
  postalCode?: InputMaybe<StringNullableFilter>;
  state?: InputMaybe<StringNullableFilter>;
  street?: InputMaybe<StringNullableFilter>;
};

export type AddressWhereUniqueInput = {
  AND?: InputMaybe<Array<AddressWhereInput>>;
  NOT?: InputMaybe<Array<AddressWhereInput>>;
  OR?: InputMaybe<Array<AddressWhereInput>>;
  Person?: InputMaybe<PersonWhereInput>;
  city?: InputMaybe<StringNullableFilter>;
  complement?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  neighborhood?: InputMaybe<StringNullableFilter>;
  personId?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<StringNullableFilter>;
  state?: InputMaybe<StringNullableFilter>;
  street?: InputMaybe<StringNullableFilter>;
};

export type ApiKey = {
  __typename?: 'ApiKey';
  Team: Team;
  User: CommonUser;
  commonUserId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  hashedKey: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  teamId: Scalars['Int']['output'];
};

export type ApiKeyAvgOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type ApiKeyCountOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  hashedKey?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type ApiKeyCreateInput = {
  Team: TeamCreateNestedOneWithoutApiKeyInput;
  User: CommonUserCreateNestedOneWithoutApiKeyInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  hashedKey: Scalars['String']['input'];
};

export type ApiKeyCreateManyInput = {
  commonUserId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  hashedKey: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
};

export type ApiKeyCreateManyTeamInput = {
  commonUserId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  hashedKey: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type ApiKeyCreateManyTeamInputEnvelope = {
  data: Array<ApiKeyCreateManyTeamInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApiKeyCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  hashedKey: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
};

export type ApiKeyCreateManyUserInputEnvelope = {
  data: Array<ApiKeyCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApiKeyCreateNestedManyWithoutTeamInput = {
  connect?: InputMaybe<Array<ApiKeyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ApiKeyCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<ApiKeyCreateWithoutTeamInput>>;
  createMany?: InputMaybe<ApiKeyCreateManyTeamInputEnvelope>;
};

export type ApiKeyCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<ApiKeyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ApiKeyCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ApiKeyCreateWithoutUserInput>>;
  createMany?: InputMaybe<ApiKeyCreateManyUserInputEnvelope>;
};

export type ApiKeyCreateOrConnectWithoutTeamInput = {
  create: ApiKeyCreateWithoutTeamInput;
  where: ApiKeyWhereUniqueInput;
};

export type ApiKeyCreateOrConnectWithoutUserInput = {
  create: ApiKeyCreateWithoutUserInput;
  where: ApiKeyWhereUniqueInput;
};

export type ApiKeyCreateWithoutTeamInput = {
  User: CommonUserCreateNestedOneWithoutApiKeyInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  hashedKey: Scalars['String']['input'];
};

export type ApiKeyCreateWithoutUserInput = {
  Team: TeamCreateNestedOneWithoutApiKeyInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  hashedKey: Scalars['String']['input'];
};

export type ApiKeyListRelationFilter = {
  every?: InputMaybe<ApiKeyWhereInput>;
  none?: InputMaybe<ApiKeyWhereInput>;
  some?: InputMaybe<ApiKeyWhereInput>;
};

export type ApiKeyMaxOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  hashedKey?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type ApiKeyMinOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  hashedKey?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type ApiKeyOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ApiKeyOrderByWithAggregationInput = {
  _avg?: InputMaybe<ApiKeyAvgOrderByAggregateInput>;
  _count?: InputMaybe<ApiKeyCountOrderByAggregateInput>;
  _max?: InputMaybe<ApiKeyMaxOrderByAggregateInput>;
  _min?: InputMaybe<ApiKeyMinOrderByAggregateInput>;
  _sum?: InputMaybe<ApiKeySumOrderByAggregateInput>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  hashedKey?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type ApiKeyOrderByWithRelationInput = {
  Team?: InputMaybe<TeamOrderByWithRelationInput>;
  User?: InputMaybe<CommonUserOrderByWithRelationInput>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  hashedKey?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export enum ApiKeyScalarFieldEnum {
  CommonUserId = 'commonUserId',
  CreatedAt = 'createdAt',
  Description = 'description',
  HashedKey = 'hashedKey',
  Id = 'id',
  TeamId = 'teamId'
}

export type ApiKeyScalarWhereInput = {
  AND?: InputMaybe<Array<ApiKeyScalarWhereInput>>;
  NOT?: InputMaybe<Array<ApiKeyScalarWhereInput>>;
  OR?: InputMaybe<Array<ApiKeyScalarWhereInput>>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  hashedKey?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  teamId?: InputMaybe<IntFilter>;
};

export type ApiKeyScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ApiKeyScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ApiKeyScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ApiKeyScalarWhereWithAggregatesInput>>;
  commonUserId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringWithAggregatesFilter>;
  hashedKey?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  teamId?: InputMaybe<IntWithAggregatesFilter>;
};

export type ApiKeySumOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type ApiKeyUpdateInput = {
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutApiKeyNestedInput>;
  User?: InputMaybe<CommonUserUpdateOneRequiredWithoutApiKeyNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  hashedKey?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ApiKeyUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  hashedKey?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ApiKeyUpdateManyWithWhereWithoutTeamInput = {
  data: ApiKeyUpdateManyMutationInput;
  where: ApiKeyScalarWhereInput;
};

export type ApiKeyUpdateManyWithWhereWithoutUserInput = {
  data: ApiKeyUpdateManyMutationInput;
  where: ApiKeyScalarWhereInput;
};

export type ApiKeyUpdateManyWithoutTeamNestedInput = {
  connect?: InputMaybe<Array<ApiKeyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ApiKeyCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<ApiKeyCreateWithoutTeamInput>>;
  createMany?: InputMaybe<ApiKeyCreateManyTeamInputEnvelope>;
  delete?: InputMaybe<Array<ApiKeyWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ApiKeyScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ApiKeyWhereUniqueInput>>;
  set?: InputMaybe<Array<ApiKeyWhereUniqueInput>>;
  update?: InputMaybe<Array<ApiKeyUpdateWithWhereUniqueWithoutTeamInput>>;
  updateMany?: InputMaybe<Array<ApiKeyUpdateManyWithWhereWithoutTeamInput>>;
  upsert?: InputMaybe<Array<ApiKeyUpsertWithWhereUniqueWithoutTeamInput>>;
};

export type ApiKeyUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<ApiKeyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ApiKeyCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<ApiKeyCreateWithoutUserInput>>;
  createMany?: InputMaybe<ApiKeyCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<ApiKeyWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ApiKeyScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ApiKeyWhereUniqueInput>>;
  set?: InputMaybe<Array<ApiKeyWhereUniqueInput>>;
  update?: InputMaybe<Array<ApiKeyUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<ApiKeyUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<ApiKeyUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ApiKeyUpdateWithWhereUniqueWithoutTeamInput = {
  data: ApiKeyUpdateWithoutTeamInput;
  where: ApiKeyWhereUniqueInput;
};

export type ApiKeyUpdateWithWhereUniqueWithoutUserInput = {
  data: ApiKeyUpdateWithoutUserInput;
  where: ApiKeyWhereUniqueInput;
};

export type ApiKeyUpdateWithoutTeamInput = {
  User?: InputMaybe<CommonUserUpdateOneRequiredWithoutApiKeyNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  hashedKey?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ApiKeyUpdateWithoutUserInput = {
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutApiKeyNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  hashedKey?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ApiKeyUpsertWithWhereUniqueWithoutTeamInput = {
  create: ApiKeyCreateWithoutTeamInput;
  update: ApiKeyUpdateWithoutTeamInput;
  where: ApiKeyWhereUniqueInput;
};

export type ApiKeyUpsertWithWhereUniqueWithoutUserInput = {
  create: ApiKeyCreateWithoutUserInput;
  update: ApiKeyUpdateWithoutUserInput;
  where: ApiKeyWhereUniqueInput;
};

export type ApiKeyWhereInput = {
  AND?: InputMaybe<Array<ApiKeyWhereInput>>;
  NOT?: InputMaybe<Array<ApiKeyWhereInput>>;
  OR?: InputMaybe<Array<ApiKeyWhereInput>>;
  Team?: InputMaybe<TeamWhereInput>;
  User?: InputMaybe<CommonUserWhereInput>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  hashedKey?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  teamId?: InputMaybe<IntFilter>;
};

export type ApiKeyWhereUniqueInput = {
  AND?: InputMaybe<Array<ApiKeyWhereInput>>;
  NOT?: InputMaybe<Array<ApiKeyWhereInput>>;
  OR?: InputMaybe<Array<ApiKeyWhereInput>>;
  Team?: InputMaybe<TeamWhereInput>;
  User?: InputMaybe<CommonUserWhereInput>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  hashedKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  teamId?: InputMaybe<IntFilter>;
};

/** Batch payloads from prisma. */
export type BatchPayload = {
  __typename?: 'BatchPayload';
  /** Prisma Batch Payload */
  count: Scalars['Int']['output'];
};

export type BigIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['BigInt']['input']>;
  divide?: InputMaybe<Scalars['BigInt']['input']>;
  increment?: InputMaybe<Scalars['BigInt']['input']>;
  multiply?: InputMaybe<Scalars['BigInt']['input']>;
  set?: InputMaybe<Scalars['BigInt']['input']>;
};

export type BigIntFilter = {
  equals?: InputMaybe<Scalars['BigInt']['input']>;
  gt?: InputMaybe<Scalars['BigInt']['input']>;
  gte?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lt?: InputMaybe<Scalars['BigInt']['input']>;
  lte?: InputMaybe<Scalars['BigInt']['input']>;
  not?: InputMaybe<NestedBigIntFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type BigIntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedBigIntFilter>;
  _min?: InputMaybe<NestedBigIntFilter>;
  _sum?: InputMaybe<NestedBigIntFilter>;
  equals?: InputMaybe<Scalars['BigInt']['input']>;
  gt?: InputMaybe<Scalars['BigInt']['input']>;
  gte?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lt?: InputMaybe<Scalars['BigInt']['input']>;
  lte?: InputMaybe<Scalars['BigInt']['input']>;
  not?: InputMaybe<NestedBigIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type BoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type BoolNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedBoolNullableFilter>;
  _min?: InputMaybe<NestedBoolNullableFilter>;
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableWithAggregatesFilter>;
};

export type BoolWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedBoolFilter>;
  _min?: InputMaybe<NestedBoolFilter>;
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

export type BulkCertificateRecord = {
  __typename?: 'BulkCertificateRecord';
  DocumentCertificates: Array<DocumentCertificate>;
  Team: Team;
  bulkCertificateRecordName: Scalars['String']['output'];
  countDocumentCertificates: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  educationLevel: EducationLevelType;
  id: Scalars['String']['output'];
  status: DocumentCertificateStatus;
  teamId: Scalars['Int']['output'];
  totalCertificates: Scalars['Int']['output'];
};


export type BulkCertificateRecordDocumentCertificatesArgs = {
  cursor?: InputMaybe<DocumentCertificateWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentCertificateScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentCertificateOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentCertificateWhereInput>;
};


export type BulkCertificateRecordCountDocumentCertificatesArgs = {
  where?: InputMaybe<DocumentCertificateWhereInput>;
};

export type BulkCertificateRecordAvgOrderByAggregateInput = {
  teamId?: InputMaybe<SortOrder>;
  totalCertificates?: InputMaybe<SortOrder>;
};

export type BulkCertificateRecordCountOrderByAggregateInput = {
  bulkCertificateRecordName?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  educationLevel?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  totalCertificates?: InputMaybe<SortOrder>;
};

export type BulkCertificateRecordCreateInput = {
  DocumentCertificates?: InputMaybe<DocumentCertificateCreateNestedManyWithoutBulkCertificateRecordInput>;
  Team: TeamCreateNestedOneWithoutBulkCertificateRecordInput;
  bulkCertificateRecordName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentCertificateStatus>;
  totalCertificates: Scalars['Int']['input'];
};

export type BulkCertificateRecordCreateManyInput = {
  bulkCertificateRecordName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentCertificateStatus>;
  teamId: Scalars['Int']['input'];
  totalCertificates: Scalars['Int']['input'];
};

export type BulkCertificateRecordCreateManyTeamInput = {
  bulkCertificateRecordName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentCertificateStatus>;
  totalCertificates: Scalars['Int']['input'];
};

export type BulkCertificateRecordCreateManyTeamInputEnvelope = {
  data: Array<BulkCertificateRecordCreateManyTeamInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkCertificateRecordCreateNestedManyWithoutTeamInput = {
  connect?: InputMaybe<Array<BulkCertificateRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BulkCertificateRecordCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<BulkCertificateRecordCreateWithoutTeamInput>>;
  createMany?: InputMaybe<BulkCertificateRecordCreateManyTeamInputEnvelope>;
};

export type BulkCertificateRecordCreateNestedOneWithoutDocumentCertificatesInput = {
  connect?: InputMaybe<BulkCertificateRecordWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BulkCertificateRecordCreateOrConnectWithoutDocumentCertificatesInput>;
  create?: InputMaybe<BulkCertificateRecordCreateWithoutDocumentCertificatesInput>;
};

export type BulkCertificateRecordCreateOrConnectWithoutDocumentCertificatesInput = {
  create: BulkCertificateRecordCreateWithoutDocumentCertificatesInput;
  where: BulkCertificateRecordWhereUniqueInput;
};

export type BulkCertificateRecordCreateOrConnectWithoutTeamInput = {
  create: BulkCertificateRecordCreateWithoutTeamInput;
  where: BulkCertificateRecordWhereUniqueInput;
};

export type BulkCertificateRecordCreateWithoutDocumentCertificatesInput = {
  Team: TeamCreateNestedOneWithoutBulkCertificateRecordInput;
  bulkCertificateRecordName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentCertificateStatus>;
  totalCertificates: Scalars['Int']['input'];
};

export type BulkCertificateRecordCreateWithoutTeamInput = {
  DocumentCertificates?: InputMaybe<DocumentCertificateCreateNestedManyWithoutBulkCertificateRecordInput>;
  bulkCertificateRecordName: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentCertificateStatus>;
  totalCertificates: Scalars['Int']['input'];
};

export type BulkCertificateRecordListRelationFilter = {
  every?: InputMaybe<BulkCertificateRecordWhereInput>;
  none?: InputMaybe<BulkCertificateRecordWhereInput>;
  some?: InputMaybe<BulkCertificateRecordWhereInput>;
};

export type BulkCertificateRecordMaxOrderByAggregateInput = {
  bulkCertificateRecordName?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  educationLevel?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  totalCertificates?: InputMaybe<SortOrder>;
};

export type BulkCertificateRecordMinOrderByAggregateInput = {
  bulkCertificateRecordName?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  educationLevel?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  totalCertificates?: InputMaybe<SortOrder>;
};

export type BulkCertificateRecordNullableRelationFilter = {
  is?: InputMaybe<BulkCertificateRecordWhereInput>;
  isNot?: InputMaybe<BulkCertificateRecordWhereInput>;
};

export type BulkCertificateRecordOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BulkCertificateRecordOrderByWithAggregationInput = {
  _avg?: InputMaybe<BulkCertificateRecordAvgOrderByAggregateInput>;
  _count?: InputMaybe<BulkCertificateRecordCountOrderByAggregateInput>;
  _max?: InputMaybe<BulkCertificateRecordMaxOrderByAggregateInput>;
  _min?: InputMaybe<BulkCertificateRecordMinOrderByAggregateInput>;
  _sum?: InputMaybe<BulkCertificateRecordSumOrderByAggregateInput>;
  bulkCertificateRecordName?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  educationLevel?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  totalCertificates?: InputMaybe<SortOrder>;
};

export type BulkCertificateRecordOrderByWithRelationInput = {
  DocumentCertificates?: InputMaybe<DocumentCertificateOrderByRelationAggregateInput>;
  Team?: InputMaybe<TeamOrderByWithRelationInput>;
  bulkCertificateRecordName?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  educationLevel?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  totalCertificates?: InputMaybe<SortOrder>;
};

export enum BulkCertificateRecordScalarFieldEnum {
  BulkCertificateRecordName = 'bulkCertificateRecordName',
  CreatedAt = 'createdAt',
  EducationLevel = 'educationLevel',
  Id = 'id',
  Status = 'status',
  TeamId = 'teamId',
  TotalCertificates = 'totalCertificates'
}

export type BulkCertificateRecordScalarWhereInput = {
  AND?: InputMaybe<Array<BulkCertificateRecordScalarWhereInput>>;
  NOT?: InputMaybe<Array<BulkCertificateRecordScalarWhereInput>>;
  OR?: InputMaybe<Array<BulkCertificateRecordScalarWhereInput>>;
  bulkCertificateRecordName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFilter>;
  id?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumDocumentCertificateStatusFilter>;
  teamId?: InputMaybe<IntFilter>;
  totalCertificates?: InputMaybe<IntFilter>;
};

export type BulkCertificateRecordScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<BulkCertificateRecordScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<BulkCertificateRecordScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<BulkCertificateRecordScalarWhereWithAggregatesInput>>;
  bulkCertificateRecordName?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  status?: InputMaybe<EnumDocumentCertificateStatusWithAggregatesFilter>;
  teamId?: InputMaybe<IntWithAggregatesFilter>;
  totalCertificates?: InputMaybe<IntWithAggregatesFilter>;
};

export type BulkCertificateRecordSumOrderByAggregateInput = {
  teamId?: InputMaybe<SortOrder>;
  totalCertificates?: InputMaybe<SortOrder>;
};

export type BulkCertificateRecordUpdateInput = {
  DocumentCertificates?: InputMaybe<DocumentCertificateUpdateManyWithoutBulkCertificateRecordNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutBulkCertificateRecordNestedInput>;
  bulkCertificateRecordName?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  totalCertificates?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type BulkCertificateRecordUpdateManyMutationInput = {
  bulkCertificateRecordName?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  totalCertificates?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type BulkCertificateRecordUpdateManyWithWhereWithoutTeamInput = {
  data: BulkCertificateRecordUpdateManyMutationInput;
  where: BulkCertificateRecordScalarWhereInput;
};

export type BulkCertificateRecordUpdateManyWithoutTeamNestedInput = {
  connect?: InputMaybe<Array<BulkCertificateRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BulkCertificateRecordCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<BulkCertificateRecordCreateWithoutTeamInput>>;
  createMany?: InputMaybe<BulkCertificateRecordCreateManyTeamInputEnvelope>;
  delete?: InputMaybe<Array<BulkCertificateRecordWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BulkCertificateRecordScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BulkCertificateRecordWhereUniqueInput>>;
  set?: InputMaybe<Array<BulkCertificateRecordWhereUniqueInput>>;
  update?: InputMaybe<Array<BulkCertificateRecordUpdateWithWhereUniqueWithoutTeamInput>>;
  updateMany?: InputMaybe<Array<BulkCertificateRecordUpdateManyWithWhereWithoutTeamInput>>;
  upsert?: InputMaybe<Array<BulkCertificateRecordUpsertWithWhereUniqueWithoutTeamInput>>;
};

export type BulkCertificateRecordUpdateOneWithoutDocumentCertificatesNestedInput = {
  connect?: InputMaybe<BulkCertificateRecordWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BulkCertificateRecordCreateOrConnectWithoutDocumentCertificatesInput>;
  create?: InputMaybe<BulkCertificateRecordCreateWithoutDocumentCertificatesInput>;
  delete?: InputMaybe<BulkCertificateRecordWhereInput>;
  disconnect?: InputMaybe<BulkCertificateRecordWhereInput>;
  update?: InputMaybe<BulkCertificateRecordUpdateToOneWithWhereWithoutDocumentCertificatesInput>;
  upsert?: InputMaybe<BulkCertificateRecordUpsertWithoutDocumentCertificatesInput>;
};

export type BulkCertificateRecordUpdateToOneWithWhereWithoutDocumentCertificatesInput = {
  data: BulkCertificateRecordUpdateWithoutDocumentCertificatesInput;
  where?: InputMaybe<BulkCertificateRecordWhereInput>;
};

export type BulkCertificateRecordUpdateWithWhereUniqueWithoutTeamInput = {
  data: BulkCertificateRecordUpdateWithoutTeamInput;
  where: BulkCertificateRecordWhereUniqueInput;
};

export type BulkCertificateRecordUpdateWithoutDocumentCertificatesInput = {
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutBulkCertificateRecordNestedInput>;
  bulkCertificateRecordName?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  totalCertificates?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type BulkCertificateRecordUpdateWithoutTeamInput = {
  DocumentCertificates?: InputMaybe<DocumentCertificateUpdateManyWithoutBulkCertificateRecordNestedInput>;
  bulkCertificateRecordName?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  totalCertificates?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type BulkCertificateRecordUpsertWithWhereUniqueWithoutTeamInput = {
  create: BulkCertificateRecordCreateWithoutTeamInput;
  update: BulkCertificateRecordUpdateWithoutTeamInput;
  where: BulkCertificateRecordWhereUniqueInput;
};

export type BulkCertificateRecordUpsertWithoutDocumentCertificatesInput = {
  create: BulkCertificateRecordCreateWithoutDocumentCertificatesInput;
  update: BulkCertificateRecordUpdateWithoutDocumentCertificatesInput;
  where?: InputMaybe<BulkCertificateRecordWhereInput>;
};

export type BulkCertificateRecordWhereInput = {
  AND?: InputMaybe<Array<BulkCertificateRecordWhereInput>>;
  DocumentCertificates?: InputMaybe<DocumentCertificateListRelationFilter>;
  NOT?: InputMaybe<Array<BulkCertificateRecordWhereInput>>;
  OR?: InputMaybe<Array<BulkCertificateRecordWhereInput>>;
  Team?: InputMaybe<TeamWhereInput>;
  bulkCertificateRecordName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFilter>;
  id?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumDocumentCertificateStatusFilter>;
  teamId?: InputMaybe<IntFilter>;
  totalCertificates?: InputMaybe<IntFilter>;
};

export type BulkCertificateRecordWhereUniqueInput = {
  AND?: InputMaybe<Array<BulkCertificateRecordWhereInput>>;
  DocumentCertificates?: InputMaybe<DocumentCertificateListRelationFilter>;
  NOT?: InputMaybe<Array<BulkCertificateRecordWhereInput>>;
  OR?: InputMaybe<Array<BulkCertificateRecordWhereInput>>;
  Team?: InputMaybe<TeamWhereInput>;
  bulkCertificateRecordName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumDocumentCertificateStatusFilter>;
  teamId?: InputMaybe<IntFilter>;
  totalCertificates?: InputMaybe<IntFilter>;
};

export type CertificateBase = {
  __typename?: 'CertificateBase';
  CertificateCourse?: Maybe<CertificateCourse>;
  CertificateCurriculum?: Maybe<CertificateCurriculum>;
  CertificateDiscipline?: Maybe<CertificateDiscipline>;
  CertificateEvent?: Maybe<CertificateEvent>;
  CertificateTeacher?: Maybe<CertificateTeacher>;
  CourseLevel?: Maybe<CertificateCourseLevel>;
  Team: Team;
  UserOwner: CommonUser;
  commonUserId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  educationLevel: EducationLevelType;
  id: Scalars['String']['output'];
  teamId: Scalars['Int']['output'];
  /** course, discipline, teacher */
  type: CertificateTypes;
};

export type CertificateBaseAvgOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type CertificateBaseCountOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  educationLevel?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type CertificateBaseCreateInput = {
  CertificateCourse?: InputMaybe<CertificateCourseCreateNestedOneWithoutCertificateBaseInput>;
  CertificateCurriculum?: InputMaybe<CertificateCurriculumCreateNestedOneWithoutCertificateBaseInput>;
  CertificateDiscipline?: InputMaybe<CertificateDisciplineCreateNestedOneWithoutCertificateBaseInput>;
  CertificateEvent?: InputMaybe<CertificateEventCreateNestedOneWithoutCertificateBaseInput>;
  CertificateTeacher?: InputMaybe<CertificateTeacherCreateNestedOneWithoutCertificateBaseInput>;
  CourseLevel?: InputMaybe<CertificateCourseLevelCreateNestedOneWithoutCertificateBaseInput>;
  Team: TeamCreateNestedOneWithoutCertificateBaseInput;
  UserOwner: CommonUserCreateNestedOneWithoutCertificateBaseInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  id?: InputMaybe<Scalars['String']['input']>;
  type: CertificateTypes;
};

export type CertificateBaseCreateManyInput = {
  commonUserId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  id?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
  type: CertificateTypes;
};

export type CertificateBaseCreateManyTeamInput = {
  commonUserId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  id?: InputMaybe<Scalars['String']['input']>;
  type: CertificateTypes;
};

export type CertificateBaseCreateManyTeamInputEnvelope = {
  data: Array<CertificateBaseCreateManyTeamInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CertificateBaseCreateManyUserOwnerInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  id?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
  type: CertificateTypes;
};

export type CertificateBaseCreateManyUserOwnerInputEnvelope = {
  data: Array<CertificateBaseCreateManyUserOwnerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CertificateBaseCreateNestedManyWithoutTeamInput = {
  connect?: InputMaybe<Array<CertificateBaseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CertificateBaseCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<CertificateBaseCreateWithoutTeamInput>>;
  createMany?: InputMaybe<CertificateBaseCreateManyTeamInputEnvelope>;
};

export type CertificateBaseCreateNestedManyWithoutUserOwnerInput = {
  connect?: InputMaybe<Array<CertificateBaseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CertificateBaseCreateOrConnectWithoutUserOwnerInput>>;
  create?: InputMaybe<Array<CertificateBaseCreateWithoutUserOwnerInput>>;
  createMany?: InputMaybe<CertificateBaseCreateManyUserOwnerInputEnvelope>;
};

export type CertificateBaseCreateNestedOneWithoutCertificateCourseInput = {
  connect?: InputMaybe<CertificateBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateBaseCreateOrConnectWithoutCertificateCourseInput>;
  create?: InputMaybe<CertificateBaseCreateWithoutCertificateCourseInput>;
};

export type CertificateBaseCreateNestedOneWithoutCertificateCurriculumInput = {
  connect?: InputMaybe<CertificateBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateBaseCreateOrConnectWithoutCertificateCurriculumInput>;
  create?: InputMaybe<CertificateBaseCreateWithoutCertificateCurriculumInput>;
};

export type CertificateBaseCreateNestedOneWithoutCertificateDisciplineInput = {
  connect?: InputMaybe<CertificateBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateBaseCreateOrConnectWithoutCertificateDisciplineInput>;
  create?: InputMaybe<CertificateBaseCreateWithoutCertificateDisciplineInput>;
};

export type CertificateBaseCreateNestedOneWithoutCertificateEventInput = {
  connect?: InputMaybe<CertificateBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateBaseCreateOrConnectWithoutCertificateEventInput>;
  create?: InputMaybe<CertificateBaseCreateWithoutCertificateEventInput>;
};

export type CertificateBaseCreateNestedOneWithoutCertificateTeacherInput = {
  connect?: InputMaybe<CertificateBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateBaseCreateOrConnectWithoutCertificateTeacherInput>;
  create?: InputMaybe<CertificateBaseCreateWithoutCertificateTeacherInput>;
};

export type CertificateBaseCreateNestedOneWithoutCourseLevelInput = {
  connect?: InputMaybe<CertificateBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateBaseCreateOrConnectWithoutCourseLevelInput>;
  create?: InputMaybe<CertificateBaseCreateWithoutCourseLevelInput>;
};

export type CertificateBaseCreateOrConnectWithoutCertificateCourseInput = {
  create: CertificateBaseCreateWithoutCertificateCourseInput;
  where: CertificateBaseWhereUniqueInput;
};

export type CertificateBaseCreateOrConnectWithoutCertificateCurriculumInput = {
  create: CertificateBaseCreateWithoutCertificateCurriculumInput;
  where: CertificateBaseWhereUniqueInput;
};

export type CertificateBaseCreateOrConnectWithoutCertificateDisciplineInput = {
  create: CertificateBaseCreateWithoutCertificateDisciplineInput;
  where: CertificateBaseWhereUniqueInput;
};

export type CertificateBaseCreateOrConnectWithoutCertificateEventInput = {
  create: CertificateBaseCreateWithoutCertificateEventInput;
  where: CertificateBaseWhereUniqueInput;
};

export type CertificateBaseCreateOrConnectWithoutCertificateTeacherInput = {
  create: CertificateBaseCreateWithoutCertificateTeacherInput;
  where: CertificateBaseWhereUniqueInput;
};

export type CertificateBaseCreateOrConnectWithoutCourseLevelInput = {
  create: CertificateBaseCreateWithoutCourseLevelInput;
  where: CertificateBaseWhereUniqueInput;
};

export type CertificateBaseCreateOrConnectWithoutTeamInput = {
  create: CertificateBaseCreateWithoutTeamInput;
  where: CertificateBaseWhereUniqueInput;
};

export type CertificateBaseCreateOrConnectWithoutUserOwnerInput = {
  create: CertificateBaseCreateWithoutUserOwnerInput;
  where: CertificateBaseWhereUniqueInput;
};

export type CertificateBaseCreateWithoutCertificateCourseInput = {
  CertificateCurriculum?: InputMaybe<CertificateCurriculumCreateNestedOneWithoutCertificateBaseInput>;
  CertificateDiscipline?: InputMaybe<CertificateDisciplineCreateNestedOneWithoutCertificateBaseInput>;
  CertificateEvent?: InputMaybe<CertificateEventCreateNestedOneWithoutCertificateBaseInput>;
  CertificateTeacher?: InputMaybe<CertificateTeacherCreateNestedOneWithoutCertificateBaseInput>;
  CourseLevel?: InputMaybe<CertificateCourseLevelCreateNestedOneWithoutCertificateBaseInput>;
  Team: TeamCreateNestedOneWithoutCertificateBaseInput;
  UserOwner: CommonUserCreateNestedOneWithoutCertificateBaseInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  id?: InputMaybe<Scalars['String']['input']>;
  type: CertificateTypes;
};

export type CertificateBaseCreateWithoutCertificateCurriculumInput = {
  CertificateCourse?: InputMaybe<CertificateCourseCreateNestedOneWithoutCertificateBaseInput>;
  CertificateDiscipline?: InputMaybe<CertificateDisciplineCreateNestedOneWithoutCertificateBaseInput>;
  CertificateEvent?: InputMaybe<CertificateEventCreateNestedOneWithoutCertificateBaseInput>;
  CertificateTeacher?: InputMaybe<CertificateTeacherCreateNestedOneWithoutCertificateBaseInput>;
  CourseLevel?: InputMaybe<CertificateCourseLevelCreateNestedOneWithoutCertificateBaseInput>;
  Team: TeamCreateNestedOneWithoutCertificateBaseInput;
  UserOwner: CommonUserCreateNestedOneWithoutCertificateBaseInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  id?: InputMaybe<Scalars['String']['input']>;
  type: CertificateTypes;
};

export type CertificateBaseCreateWithoutCertificateDisciplineInput = {
  CertificateCourse?: InputMaybe<CertificateCourseCreateNestedOneWithoutCertificateBaseInput>;
  CertificateCurriculum?: InputMaybe<CertificateCurriculumCreateNestedOneWithoutCertificateBaseInput>;
  CertificateEvent?: InputMaybe<CertificateEventCreateNestedOneWithoutCertificateBaseInput>;
  CertificateTeacher?: InputMaybe<CertificateTeacherCreateNestedOneWithoutCertificateBaseInput>;
  CourseLevel?: InputMaybe<CertificateCourseLevelCreateNestedOneWithoutCertificateBaseInput>;
  Team: TeamCreateNestedOneWithoutCertificateBaseInput;
  UserOwner: CommonUserCreateNestedOneWithoutCertificateBaseInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  id?: InputMaybe<Scalars['String']['input']>;
  type: CertificateTypes;
};

export type CertificateBaseCreateWithoutCertificateEventInput = {
  CertificateCourse?: InputMaybe<CertificateCourseCreateNestedOneWithoutCertificateBaseInput>;
  CertificateCurriculum?: InputMaybe<CertificateCurriculumCreateNestedOneWithoutCertificateBaseInput>;
  CertificateDiscipline?: InputMaybe<CertificateDisciplineCreateNestedOneWithoutCertificateBaseInput>;
  CertificateTeacher?: InputMaybe<CertificateTeacherCreateNestedOneWithoutCertificateBaseInput>;
  CourseLevel?: InputMaybe<CertificateCourseLevelCreateNestedOneWithoutCertificateBaseInput>;
  Team: TeamCreateNestedOneWithoutCertificateBaseInput;
  UserOwner: CommonUserCreateNestedOneWithoutCertificateBaseInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  id?: InputMaybe<Scalars['String']['input']>;
  type: CertificateTypes;
};

export type CertificateBaseCreateWithoutCertificateTeacherInput = {
  CertificateCourse?: InputMaybe<CertificateCourseCreateNestedOneWithoutCertificateBaseInput>;
  CertificateCurriculum?: InputMaybe<CertificateCurriculumCreateNestedOneWithoutCertificateBaseInput>;
  CertificateDiscipline?: InputMaybe<CertificateDisciplineCreateNestedOneWithoutCertificateBaseInput>;
  CertificateEvent?: InputMaybe<CertificateEventCreateNestedOneWithoutCertificateBaseInput>;
  CourseLevel?: InputMaybe<CertificateCourseLevelCreateNestedOneWithoutCertificateBaseInput>;
  Team: TeamCreateNestedOneWithoutCertificateBaseInput;
  UserOwner: CommonUserCreateNestedOneWithoutCertificateBaseInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  id?: InputMaybe<Scalars['String']['input']>;
  type: CertificateTypes;
};

export type CertificateBaseCreateWithoutCourseLevelInput = {
  CertificateCourse?: InputMaybe<CertificateCourseCreateNestedOneWithoutCertificateBaseInput>;
  CertificateCurriculum?: InputMaybe<CertificateCurriculumCreateNestedOneWithoutCertificateBaseInput>;
  CertificateDiscipline?: InputMaybe<CertificateDisciplineCreateNestedOneWithoutCertificateBaseInput>;
  CertificateEvent?: InputMaybe<CertificateEventCreateNestedOneWithoutCertificateBaseInput>;
  CertificateTeacher?: InputMaybe<CertificateTeacherCreateNestedOneWithoutCertificateBaseInput>;
  Team: TeamCreateNestedOneWithoutCertificateBaseInput;
  UserOwner: CommonUserCreateNestedOneWithoutCertificateBaseInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  id?: InputMaybe<Scalars['String']['input']>;
  type: CertificateTypes;
};

export type CertificateBaseCreateWithoutTeamInput = {
  CertificateCourse?: InputMaybe<CertificateCourseCreateNestedOneWithoutCertificateBaseInput>;
  CertificateCurriculum?: InputMaybe<CertificateCurriculumCreateNestedOneWithoutCertificateBaseInput>;
  CertificateDiscipline?: InputMaybe<CertificateDisciplineCreateNestedOneWithoutCertificateBaseInput>;
  CertificateEvent?: InputMaybe<CertificateEventCreateNestedOneWithoutCertificateBaseInput>;
  CertificateTeacher?: InputMaybe<CertificateTeacherCreateNestedOneWithoutCertificateBaseInput>;
  CourseLevel?: InputMaybe<CertificateCourseLevelCreateNestedOneWithoutCertificateBaseInput>;
  UserOwner: CommonUserCreateNestedOneWithoutCertificateBaseInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  id?: InputMaybe<Scalars['String']['input']>;
  type: CertificateTypes;
};

export type CertificateBaseCreateWithoutUserOwnerInput = {
  CertificateCourse?: InputMaybe<CertificateCourseCreateNestedOneWithoutCertificateBaseInput>;
  CertificateCurriculum?: InputMaybe<CertificateCurriculumCreateNestedOneWithoutCertificateBaseInput>;
  CertificateDiscipline?: InputMaybe<CertificateDisciplineCreateNestedOneWithoutCertificateBaseInput>;
  CertificateEvent?: InputMaybe<CertificateEventCreateNestedOneWithoutCertificateBaseInput>;
  CertificateTeacher?: InputMaybe<CertificateTeacherCreateNestedOneWithoutCertificateBaseInput>;
  CourseLevel?: InputMaybe<CertificateCourseLevelCreateNestedOneWithoutCertificateBaseInput>;
  Team: TeamCreateNestedOneWithoutCertificateBaseInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  id?: InputMaybe<Scalars['String']['input']>;
  type: CertificateTypes;
};

export type CertificateBaseListRelationFilter = {
  every?: InputMaybe<CertificateBaseWhereInput>;
  none?: InputMaybe<CertificateBaseWhereInput>;
  some?: InputMaybe<CertificateBaseWhereInput>;
};

export type CertificateBaseMaxOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  educationLevel?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type CertificateBaseMinOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  educationLevel?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type CertificateBaseOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CertificateBaseOrderByWithAggregationInput = {
  _avg?: InputMaybe<CertificateBaseAvgOrderByAggregateInput>;
  _count?: InputMaybe<CertificateBaseCountOrderByAggregateInput>;
  _max?: InputMaybe<CertificateBaseMaxOrderByAggregateInput>;
  _min?: InputMaybe<CertificateBaseMinOrderByAggregateInput>;
  _sum?: InputMaybe<CertificateBaseSumOrderByAggregateInput>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  educationLevel?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type CertificateBaseOrderByWithRelationInput = {
  CertificateCourse?: InputMaybe<CertificateCourseOrderByWithRelationInput>;
  CertificateCurriculum?: InputMaybe<CertificateCurriculumOrderByWithRelationInput>;
  CertificateDiscipline?: InputMaybe<CertificateDisciplineOrderByWithRelationInput>;
  CertificateEvent?: InputMaybe<CertificateEventOrderByWithRelationInput>;
  CertificateTeacher?: InputMaybe<CertificateTeacherOrderByWithRelationInput>;
  CourseLevel?: InputMaybe<CertificateCourseLevelOrderByWithRelationInput>;
  Team?: InputMaybe<TeamOrderByWithRelationInput>;
  UserOwner?: InputMaybe<CommonUserOrderByWithRelationInput>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  educationLevel?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type CertificateBaseRelationFilter = {
  is?: InputMaybe<CertificateBaseWhereInput>;
  isNot?: InputMaybe<CertificateBaseWhereInput>;
};

export enum CertificateBaseScalarFieldEnum {
  CommonUserId = 'commonUserId',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  EducationLevel = 'educationLevel',
  Id = 'id',
  TeamId = 'teamId',
  Type = 'type'
}

export type CertificateBaseScalarWhereInput = {
  AND?: InputMaybe<Array<CertificateBaseScalarWhereInput>>;
  NOT?: InputMaybe<Array<CertificateBaseScalarWhereInput>>;
  OR?: InputMaybe<Array<CertificateBaseScalarWhereInput>>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFilter>;
  id?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<IntFilter>;
  type?: InputMaybe<EnumCertificateTypesFilter>;
};

export type CertificateBaseScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CertificateBaseScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CertificateBaseScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CertificateBaseScalarWhereWithAggregatesInput>>;
  commonUserId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  teamId?: InputMaybe<IntWithAggregatesFilter>;
  type?: InputMaybe<EnumCertificateTypesWithAggregatesFilter>;
};

export type CertificateBaseSumOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type CertificateBaseUpdateInput = {
  CertificateCourse?: InputMaybe<CertificateCourseUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateCurriculum?: InputMaybe<CertificateCurriculumUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateDiscipline?: InputMaybe<CertificateDisciplineUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateEvent?: InputMaybe<CertificateEventUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateTeacher?: InputMaybe<CertificateTeacherUpdateOneWithoutCertificateBaseNestedInput>;
  CourseLevel?: InputMaybe<CertificateCourseLevelUpdateOneWithoutCertificateBaseNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCertificateTypesFieldUpdateOperationsInput>;
};

export type CertificateBaseUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCertificateTypesFieldUpdateOperationsInput>;
};

export type CertificateBaseUpdateManyWithWhereWithoutTeamInput = {
  data: CertificateBaseUpdateManyMutationInput;
  where: CertificateBaseScalarWhereInput;
};

export type CertificateBaseUpdateManyWithWhereWithoutUserOwnerInput = {
  data: CertificateBaseUpdateManyMutationInput;
  where: CertificateBaseScalarWhereInput;
};

export type CertificateBaseUpdateManyWithoutTeamNestedInput = {
  connect?: InputMaybe<Array<CertificateBaseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CertificateBaseCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<CertificateBaseCreateWithoutTeamInput>>;
  createMany?: InputMaybe<CertificateBaseCreateManyTeamInputEnvelope>;
  delete?: InputMaybe<Array<CertificateBaseWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CertificateBaseScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CertificateBaseWhereUniqueInput>>;
  set?: InputMaybe<Array<CertificateBaseWhereUniqueInput>>;
  update?: InputMaybe<Array<CertificateBaseUpdateWithWhereUniqueWithoutTeamInput>>;
  updateMany?: InputMaybe<Array<CertificateBaseUpdateManyWithWhereWithoutTeamInput>>;
  upsert?: InputMaybe<Array<CertificateBaseUpsertWithWhereUniqueWithoutTeamInput>>;
};

export type CertificateBaseUpdateManyWithoutUserOwnerNestedInput = {
  connect?: InputMaybe<Array<CertificateBaseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CertificateBaseCreateOrConnectWithoutUserOwnerInput>>;
  create?: InputMaybe<Array<CertificateBaseCreateWithoutUserOwnerInput>>;
  createMany?: InputMaybe<CertificateBaseCreateManyUserOwnerInputEnvelope>;
  delete?: InputMaybe<Array<CertificateBaseWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CertificateBaseScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CertificateBaseWhereUniqueInput>>;
  set?: InputMaybe<Array<CertificateBaseWhereUniqueInput>>;
  update?: InputMaybe<Array<CertificateBaseUpdateWithWhereUniqueWithoutUserOwnerInput>>;
  updateMany?: InputMaybe<Array<CertificateBaseUpdateManyWithWhereWithoutUserOwnerInput>>;
  upsert?: InputMaybe<Array<CertificateBaseUpsertWithWhereUniqueWithoutUserOwnerInput>>;
};

export type CertificateBaseUpdateOneRequiredWithoutCertificateCourseNestedInput = {
  connect?: InputMaybe<CertificateBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateBaseCreateOrConnectWithoutCertificateCourseInput>;
  create?: InputMaybe<CertificateBaseCreateWithoutCertificateCourseInput>;
  update?: InputMaybe<CertificateBaseUpdateToOneWithWhereWithoutCertificateCourseInput>;
  upsert?: InputMaybe<CertificateBaseUpsertWithoutCertificateCourseInput>;
};

export type CertificateBaseUpdateOneRequiredWithoutCertificateCurriculumNestedInput = {
  connect?: InputMaybe<CertificateBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateBaseCreateOrConnectWithoutCertificateCurriculumInput>;
  create?: InputMaybe<CertificateBaseCreateWithoutCertificateCurriculumInput>;
  update?: InputMaybe<CertificateBaseUpdateToOneWithWhereWithoutCertificateCurriculumInput>;
  upsert?: InputMaybe<CertificateBaseUpsertWithoutCertificateCurriculumInput>;
};

export type CertificateBaseUpdateOneRequiredWithoutCertificateDisciplineNestedInput = {
  connect?: InputMaybe<CertificateBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateBaseCreateOrConnectWithoutCertificateDisciplineInput>;
  create?: InputMaybe<CertificateBaseCreateWithoutCertificateDisciplineInput>;
  update?: InputMaybe<CertificateBaseUpdateToOneWithWhereWithoutCertificateDisciplineInput>;
  upsert?: InputMaybe<CertificateBaseUpsertWithoutCertificateDisciplineInput>;
};

export type CertificateBaseUpdateOneRequiredWithoutCertificateEventNestedInput = {
  connect?: InputMaybe<CertificateBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateBaseCreateOrConnectWithoutCertificateEventInput>;
  create?: InputMaybe<CertificateBaseCreateWithoutCertificateEventInput>;
  update?: InputMaybe<CertificateBaseUpdateToOneWithWhereWithoutCertificateEventInput>;
  upsert?: InputMaybe<CertificateBaseUpsertWithoutCertificateEventInput>;
};

export type CertificateBaseUpdateOneRequiredWithoutCertificateTeacherNestedInput = {
  connect?: InputMaybe<CertificateBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateBaseCreateOrConnectWithoutCertificateTeacherInput>;
  create?: InputMaybe<CertificateBaseCreateWithoutCertificateTeacherInput>;
  update?: InputMaybe<CertificateBaseUpdateToOneWithWhereWithoutCertificateTeacherInput>;
  upsert?: InputMaybe<CertificateBaseUpsertWithoutCertificateTeacherInput>;
};

export type CertificateBaseUpdateOneRequiredWithoutCourseLevelNestedInput = {
  connect?: InputMaybe<CertificateBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateBaseCreateOrConnectWithoutCourseLevelInput>;
  create?: InputMaybe<CertificateBaseCreateWithoutCourseLevelInput>;
  update?: InputMaybe<CertificateBaseUpdateToOneWithWhereWithoutCourseLevelInput>;
  upsert?: InputMaybe<CertificateBaseUpsertWithoutCourseLevelInput>;
};

export type CertificateBaseUpdateToOneWithWhereWithoutCertificateCourseInput = {
  data: CertificateBaseUpdateWithoutCertificateCourseInput;
  where?: InputMaybe<CertificateBaseWhereInput>;
};

export type CertificateBaseUpdateToOneWithWhereWithoutCertificateCurriculumInput = {
  data: CertificateBaseUpdateWithoutCertificateCurriculumInput;
  where?: InputMaybe<CertificateBaseWhereInput>;
};

export type CertificateBaseUpdateToOneWithWhereWithoutCertificateDisciplineInput = {
  data: CertificateBaseUpdateWithoutCertificateDisciplineInput;
  where?: InputMaybe<CertificateBaseWhereInput>;
};

export type CertificateBaseUpdateToOneWithWhereWithoutCertificateEventInput = {
  data: CertificateBaseUpdateWithoutCertificateEventInput;
  where?: InputMaybe<CertificateBaseWhereInput>;
};

export type CertificateBaseUpdateToOneWithWhereWithoutCertificateTeacherInput = {
  data: CertificateBaseUpdateWithoutCertificateTeacherInput;
  where?: InputMaybe<CertificateBaseWhereInput>;
};

export type CertificateBaseUpdateToOneWithWhereWithoutCourseLevelInput = {
  data: CertificateBaseUpdateWithoutCourseLevelInput;
  where?: InputMaybe<CertificateBaseWhereInput>;
};

export type CertificateBaseUpdateWithWhereUniqueWithoutTeamInput = {
  data: CertificateBaseUpdateWithoutTeamInput;
  where: CertificateBaseWhereUniqueInput;
};

export type CertificateBaseUpdateWithWhereUniqueWithoutUserOwnerInput = {
  data: CertificateBaseUpdateWithoutUserOwnerInput;
  where: CertificateBaseWhereUniqueInput;
};

export type CertificateBaseUpdateWithoutCertificateCourseInput = {
  CertificateCurriculum?: InputMaybe<CertificateCurriculumUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateDiscipline?: InputMaybe<CertificateDisciplineUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateEvent?: InputMaybe<CertificateEventUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateTeacher?: InputMaybe<CertificateTeacherUpdateOneWithoutCertificateBaseNestedInput>;
  CourseLevel?: InputMaybe<CertificateCourseLevelUpdateOneWithoutCertificateBaseNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCertificateTypesFieldUpdateOperationsInput>;
};

export type CertificateBaseUpdateWithoutCertificateCurriculumInput = {
  CertificateCourse?: InputMaybe<CertificateCourseUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateDiscipline?: InputMaybe<CertificateDisciplineUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateEvent?: InputMaybe<CertificateEventUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateTeacher?: InputMaybe<CertificateTeacherUpdateOneWithoutCertificateBaseNestedInput>;
  CourseLevel?: InputMaybe<CertificateCourseLevelUpdateOneWithoutCertificateBaseNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCertificateTypesFieldUpdateOperationsInput>;
};

export type CertificateBaseUpdateWithoutCertificateDisciplineInput = {
  CertificateCourse?: InputMaybe<CertificateCourseUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateCurriculum?: InputMaybe<CertificateCurriculumUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateEvent?: InputMaybe<CertificateEventUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateTeacher?: InputMaybe<CertificateTeacherUpdateOneWithoutCertificateBaseNestedInput>;
  CourseLevel?: InputMaybe<CertificateCourseLevelUpdateOneWithoutCertificateBaseNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCertificateTypesFieldUpdateOperationsInput>;
};

export type CertificateBaseUpdateWithoutCertificateEventInput = {
  CertificateCourse?: InputMaybe<CertificateCourseUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateCurriculum?: InputMaybe<CertificateCurriculumUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateDiscipline?: InputMaybe<CertificateDisciplineUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateTeacher?: InputMaybe<CertificateTeacherUpdateOneWithoutCertificateBaseNestedInput>;
  CourseLevel?: InputMaybe<CertificateCourseLevelUpdateOneWithoutCertificateBaseNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCertificateTypesFieldUpdateOperationsInput>;
};

export type CertificateBaseUpdateWithoutCertificateTeacherInput = {
  CertificateCourse?: InputMaybe<CertificateCourseUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateCurriculum?: InputMaybe<CertificateCurriculumUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateDiscipline?: InputMaybe<CertificateDisciplineUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateEvent?: InputMaybe<CertificateEventUpdateOneWithoutCertificateBaseNestedInput>;
  CourseLevel?: InputMaybe<CertificateCourseLevelUpdateOneWithoutCertificateBaseNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCertificateTypesFieldUpdateOperationsInput>;
};

export type CertificateBaseUpdateWithoutCourseLevelInput = {
  CertificateCourse?: InputMaybe<CertificateCourseUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateCurriculum?: InputMaybe<CertificateCurriculumUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateDiscipline?: InputMaybe<CertificateDisciplineUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateEvent?: InputMaybe<CertificateEventUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateTeacher?: InputMaybe<CertificateTeacherUpdateOneWithoutCertificateBaseNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCertificateTypesFieldUpdateOperationsInput>;
};

export type CertificateBaseUpdateWithoutTeamInput = {
  CertificateCourse?: InputMaybe<CertificateCourseUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateCurriculum?: InputMaybe<CertificateCurriculumUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateDiscipline?: InputMaybe<CertificateDisciplineUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateEvent?: InputMaybe<CertificateEventUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateTeacher?: InputMaybe<CertificateTeacherUpdateOneWithoutCertificateBaseNestedInput>;
  CourseLevel?: InputMaybe<CertificateCourseLevelUpdateOneWithoutCertificateBaseNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCertificateTypesFieldUpdateOperationsInput>;
};

export type CertificateBaseUpdateWithoutUserOwnerInput = {
  CertificateCourse?: InputMaybe<CertificateCourseUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateCurriculum?: InputMaybe<CertificateCurriculumUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateDiscipline?: InputMaybe<CertificateDisciplineUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateEvent?: InputMaybe<CertificateEventUpdateOneWithoutCertificateBaseNestedInput>;
  CertificateTeacher?: InputMaybe<CertificateTeacherUpdateOneWithoutCertificateBaseNestedInput>;
  CourseLevel?: InputMaybe<CertificateCourseLevelUpdateOneWithoutCertificateBaseNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutCertificateBaseNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCertificateTypesFieldUpdateOperationsInput>;
};

export type CertificateBaseUpsertWithWhereUniqueWithoutTeamInput = {
  create: CertificateBaseCreateWithoutTeamInput;
  update: CertificateBaseUpdateWithoutTeamInput;
  where: CertificateBaseWhereUniqueInput;
};

export type CertificateBaseUpsertWithWhereUniqueWithoutUserOwnerInput = {
  create: CertificateBaseCreateWithoutUserOwnerInput;
  update: CertificateBaseUpdateWithoutUserOwnerInput;
  where: CertificateBaseWhereUniqueInput;
};

export type CertificateBaseUpsertWithoutCertificateCourseInput = {
  create: CertificateBaseCreateWithoutCertificateCourseInput;
  update: CertificateBaseUpdateWithoutCertificateCourseInput;
  where?: InputMaybe<CertificateBaseWhereInput>;
};

export type CertificateBaseUpsertWithoutCertificateCurriculumInput = {
  create: CertificateBaseCreateWithoutCertificateCurriculumInput;
  update: CertificateBaseUpdateWithoutCertificateCurriculumInput;
  where?: InputMaybe<CertificateBaseWhereInput>;
};

export type CertificateBaseUpsertWithoutCertificateDisciplineInput = {
  create: CertificateBaseCreateWithoutCertificateDisciplineInput;
  update: CertificateBaseUpdateWithoutCertificateDisciplineInput;
  where?: InputMaybe<CertificateBaseWhereInput>;
};

export type CertificateBaseUpsertWithoutCertificateEventInput = {
  create: CertificateBaseCreateWithoutCertificateEventInput;
  update: CertificateBaseUpdateWithoutCertificateEventInput;
  where?: InputMaybe<CertificateBaseWhereInput>;
};

export type CertificateBaseUpsertWithoutCertificateTeacherInput = {
  create: CertificateBaseCreateWithoutCertificateTeacherInput;
  update: CertificateBaseUpdateWithoutCertificateTeacherInput;
  where?: InputMaybe<CertificateBaseWhereInput>;
};

export type CertificateBaseUpsertWithoutCourseLevelInput = {
  create: CertificateBaseCreateWithoutCourseLevelInput;
  update: CertificateBaseUpdateWithoutCourseLevelInput;
  where?: InputMaybe<CertificateBaseWhereInput>;
};

export type CertificateBaseWhereInput = {
  AND?: InputMaybe<Array<CertificateBaseWhereInput>>;
  CertificateCourse?: InputMaybe<CertificateCourseWhereInput>;
  CertificateCurriculum?: InputMaybe<CertificateCurriculumWhereInput>;
  CertificateDiscipline?: InputMaybe<CertificateDisciplineWhereInput>;
  CertificateEvent?: InputMaybe<CertificateEventWhereInput>;
  CertificateTeacher?: InputMaybe<CertificateTeacherWhereInput>;
  CourseLevel?: InputMaybe<CertificateCourseLevelWhereInput>;
  NOT?: InputMaybe<Array<CertificateBaseWhereInput>>;
  OR?: InputMaybe<Array<CertificateBaseWhereInput>>;
  Team?: InputMaybe<TeamWhereInput>;
  UserOwner?: InputMaybe<CommonUserWhereInput>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFilter>;
  id?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<IntFilter>;
  type?: InputMaybe<EnumCertificateTypesFilter>;
};

export type CertificateBaseWhereUniqueInput = {
  AND?: InputMaybe<Array<CertificateBaseWhereInput>>;
  CertificateCourse?: InputMaybe<CertificateCourseWhereInput>;
  CertificateCurriculum?: InputMaybe<CertificateCurriculumWhereInput>;
  CertificateDiscipline?: InputMaybe<CertificateDisciplineWhereInput>;
  CertificateEvent?: InputMaybe<CertificateEventWhereInput>;
  CertificateTeacher?: InputMaybe<CertificateTeacherWhereInput>;
  CourseLevel?: InputMaybe<CertificateCourseLevelWhereInput>;
  NOT?: InputMaybe<Array<CertificateBaseWhereInput>>;
  OR?: InputMaybe<Array<CertificateBaseWhereInput>>;
  Team?: InputMaybe<TeamWhereInput>;
  UserOwner?: InputMaybe<CommonUserWhereInput>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<IntFilter>;
  type?: InputMaybe<EnumCertificateTypesFilter>;
};

export type CertificateCourse = {
  __typename?: 'CertificateCourse';
  CertificateBase: CertificateBase;
  CertificateCurriculum: Array<CertificateCurriculum>;
  CourseLevel?: Maybe<CertificateCourseLevel>;
  areaKnowledge: Scalars['String']['output'];
  certificateBaseId: Scalars['String']['output'];
  courseLevelCertificateBaseId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  metaData: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};


export type CertificateCourseCertificateCurriculumArgs = {
  cursor?: InputMaybe<CertificateCurriculumWhereUniqueInput>;
  distinct?: InputMaybe<Array<CertificateCurriculumScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CertificateCurriculumOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CertificateCurriculumWhereInput>;
};

export type CertificateCourseCountOrderByAggregateInput = {
  areaKnowledge?: InputMaybe<SortOrder>;
  certificateBaseId?: InputMaybe<SortOrder>;
  courseLevelCertificateBaseId?: InputMaybe<SortOrder>;
  metaData?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type CertificateCourseCreateInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCertificateCourseInput;
  CertificateCurriculum?: InputMaybe<CertificateCurriculumCreateNestedManyWithoutCertificateCourseInput>;
  CourseLevel?: InputMaybe<CertificateCourseLevelCreateNestedOneWithoutCertificateCourseInput>;
  areaKnowledge: Scalars['String']['input'];
  metaData?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
};

export type CertificateCourseCreateManyCourseLevelInput = {
  areaKnowledge: Scalars['String']['input'];
  certificateBaseId: Scalars['String']['input'];
  metaData?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
};

export type CertificateCourseCreateManyCourseLevelInputEnvelope = {
  data: Array<CertificateCourseCreateManyCourseLevelInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CertificateCourseCreateManyInput = {
  areaKnowledge: Scalars['String']['input'];
  certificateBaseId: Scalars['String']['input'];
  courseLevelCertificateBaseId?: InputMaybe<Scalars['String']['input']>;
  metaData?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
};

export type CertificateCourseCreateNestedManyWithoutCourseLevelInput = {
  connect?: InputMaybe<Array<CertificateCourseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CertificateCourseCreateOrConnectWithoutCourseLevelInput>>;
  create?: InputMaybe<Array<CertificateCourseCreateWithoutCourseLevelInput>>;
  createMany?: InputMaybe<CertificateCourseCreateManyCourseLevelInputEnvelope>;
};

export type CertificateCourseCreateNestedOneWithoutCertificateBaseInput = {
  connect?: InputMaybe<CertificateCourseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateCourseCreateOrConnectWithoutCertificateBaseInput>;
  create?: InputMaybe<CertificateCourseCreateWithoutCertificateBaseInput>;
};

export type CertificateCourseCreateNestedOneWithoutCertificateCurriculumInput = {
  connect?: InputMaybe<CertificateCourseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateCourseCreateOrConnectWithoutCertificateCurriculumInput>;
  create?: InputMaybe<CertificateCourseCreateWithoutCertificateCurriculumInput>;
};

export type CertificateCourseCreateOrConnectWithoutCertificateBaseInput = {
  create: CertificateCourseCreateWithoutCertificateBaseInput;
  where: CertificateCourseWhereUniqueInput;
};

export type CertificateCourseCreateOrConnectWithoutCertificateCurriculumInput = {
  create: CertificateCourseCreateWithoutCertificateCurriculumInput;
  where: CertificateCourseWhereUniqueInput;
};

export type CertificateCourseCreateOrConnectWithoutCourseLevelInput = {
  create: CertificateCourseCreateWithoutCourseLevelInput;
  where: CertificateCourseWhereUniqueInput;
};

export type CertificateCourseCreateWithoutCertificateBaseInput = {
  CertificateCurriculum?: InputMaybe<CertificateCurriculumCreateNestedManyWithoutCertificateCourseInput>;
  CourseLevel?: InputMaybe<CertificateCourseLevelCreateNestedOneWithoutCertificateCourseInput>;
  areaKnowledge: Scalars['String']['input'];
  metaData?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
};

export type CertificateCourseCreateWithoutCertificateCurriculumInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCertificateCourseInput;
  CourseLevel?: InputMaybe<CertificateCourseLevelCreateNestedOneWithoutCertificateCourseInput>;
  areaKnowledge: Scalars['String']['input'];
  metaData?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
};

export type CertificateCourseCreateWithoutCourseLevelInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCertificateCourseInput;
  CertificateCurriculum?: InputMaybe<CertificateCurriculumCreateNestedManyWithoutCertificateCourseInput>;
  areaKnowledge: Scalars['String']['input'];
  metaData?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
};

export type CertificateCourseCreatemetaDataInput = {
  set: Array<Scalars['String']['input']>;
};

export type CertificateCourseLevel = {
  __typename?: 'CertificateCourseLevel';
  CertificateBase: CertificateBase;
  CertificateCourse: Array<CertificateCourse>;
  certificateBaseId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};


export type CertificateCourseLevelCertificateCourseArgs = {
  cursor?: InputMaybe<CertificateCourseWhereUniqueInput>;
  distinct?: InputMaybe<Array<CertificateCourseScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CertificateCourseOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CertificateCourseWhereInput>;
};

export type CertificateCourseLevelCountOrderByAggregateInput = {
  certificateBaseId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type CertificateCourseLevelCreateInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCourseLevelInput;
  CertificateCourse?: InputMaybe<CertificateCourseCreateNestedManyWithoutCourseLevelInput>;
  name: Scalars['String']['input'];
};

export type CertificateCourseLevelCreateManyInput = {
  certificateBaseId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CertificateCourseLevelCreateNestedOneWithoutCertificateBaseInput = {
  connect?: InputMaybe<CertificateCourseLevelWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateCourseLevelCreateOrConnectWithoutCertificateBaseInput>;
  create?: InputMaybe<CertificateCourseLevelCreateWithoutCertificateBaseInput>;
};

export type CertificateCourseLevelCreateNestedOneWithoutCertificateCourseInput = {
  connect?: InputMaybe<CertificateCourseLevelWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateCourseLevelCreateOrConnectWithoutCertificateCourseInput>;
  create?: InputMaybe<CertificateCourseLevelCreateWithoutCertificateCourseInput>;
};

export type CertificateCourseLevelCreateOrConnectWithoutCertificateBaseInput = {
  create: CertificateCourseLevelCreateWithoutCertificateBaseInput;
  where: CertificateCourseLevelWhereUniqueInput;
};

export type CertificateCourseLevelCreateOrConnectWithoutCertificateCourseInput = {
  create: CertificateCourseLevelCreateWithoutCertificateCourseInput;
  where: CertificateCourseLevelWhereUniqueInput;
};

export type CertificateCourseLevelCreateWithoutCertificateBaseInput = {
  CertificateCourse?: InputMaybe<CertificateCourseCreateNestedManyWithoutCourseLevelInput>;
  name: Scalars['String']['input'];
};

export type CertificateCourseLevelCreateWithoutCertificateCourseInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCourseLevelInput;
  name: Scalars['String']['input'];
};

export type CertificateCourseLevelMaxOrderByAggregateInput = {
  certificateBaseId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type CertificateCourseLevelMinOrderByAggregateInput = {
  certificateBaseId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type CertificateCourseLevelNullableRelationFilter = {
  is?: InputMaybe<CertificateCourseLevelWhereInput>;
  isNot?: InputMaybe<CertificateCourseLevelWhereInput>;
};

export type CertificateCourseLevelOrderByWithAggregationInput = {
  _count?: InputMaybe<CertificateCourseLevelCountOrderByAggregateInput>;
  _max?: InputMaybe<CertificateCourseLevelMaxOrderByAggregateInput>;
  _min?: InputMaybe<CertificateCourseLevelMinOrderByAggregateInput>;
  certificateBaseId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type CertificateCourseLevelOrderByWithRelationInput = {
  CertificateBase?: InputMaybe<CertificateBaseOrderByWithRelationInput>;
  CertificateCourse?: InputMaybe<CertificateCourseOrderByRelationAggregateInput>;
  certificateBaseId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export enum CertificateCourseLevelScalarFieldEnum {
  CertificateBaseId = 'certificateBaseId',
  Name = 'name'
}

export type CertificateCourseLevelScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CertificateCourseLevelScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CertificateCourseLevelScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CertificateCourseLevelScalarWhereWithAggregatesInput>>;
  certificateBaseId?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
};

export type CertificateCourseLevelUpdateInput = {
  CertificateBase?: InputMaybe<CertificateBaseUpdateOneRequiredWithoutCourseLevelNestedInput>;
  CertificateCourse?: InputMaybe<CertificateCourseUpdateManyWithoutCourseLevelNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCourseLevelUpdateManyMutationInput = {
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCourseLevelUpdateOneWithoutCertificateBaseNestedInput = {
  connect?: InputMaybe<CertificateCourseLevelWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateCourseLevelCreateOrConnectWithoutCertificateBaseInput>;
  create?: InputMaybe<CertificateCourseLevelCreateWithoutCertificateBaseInput>;
  delete?: InputMaybe<CertificateCourseLevelWhereInput>;
  disconnect?: InputMaybe<CertificateCourseLevelWhereInput>;
  update?: InputMaybe<CertificateCourseLevelUpdateToOneWithWhereWithoutCertificateBaseInput>;
  upsert?: InputMaybe<CertificateCourseLevelUpsertWithoutCertificateBaseInput>;
};

export type CertificateCourseLevelUpdateOneWithoutCertificateCourseNestedInput = {
  connect?: InputMaybe<CertificateCourseLevelWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateCourseLevelCreateOrConnectWithoutCertificateCourseInput>;
  create?: InputMaybe<CertificateCourseLevelCreateWithoutCertificateCourseInput>;
  delete?: InputMaybe<CertificateCourseLevelWhereInput>;
  disconnect?: InputMaybe<CertificateCourseLevelWhereInput>;
  update?: InputMaybe<CertificateCourseLevelUpdateToOneWithWhereWithoutCertificateCourseInput>;
  upsert?: InputMaybe<CertificateCourseLevelUpsertWithoutCertificateCourseInput>;
};

export type CertificateCourseLevelUpdateToOneWithWhereWithoutCertificateBaseInput = {
  data: CertificateCourseLevelUpdateWithoutCertificateBaseInput;
  where?: InputMaybe<CertificateCourseLevelWhereInput>;
};

export type CertificateCourseLevelUpdateToOneWithWhereWithoutCertificateCourseInput = {
  data: CertificateCourseLevelUpdateWithoutCertificateCourseInput;
  where?: InputMaybe<CertificateCourseLevelWhereInput>;
};

export type CertificateCourseLevelUpdateWithoutCertificateBaseInput = {
  CertificateCourse?: InputMaybe<CertificateCourseUpdateManyWithoutCourseLevelNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCourseLevelUpdateWithoutCertificateCourseInput = {
  CertificateBase?: InputMaybe<CertificateBaseUpdateOneRequiredWithoutCourseLevelNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCourseLevelUpsertWithoutCertificateBaseInput = {
  create: CertificateCourseLevelCreateWithoutCertificateBaseInput;
  update: CertificateCourseLevelUpdateWithoutCertificateBaseInput;
  where?: InputMaybe<CertificateCourseLevelWhereInput>;
};

export type CertificateCourseLevelUpsertWithoutCertificateCourseInput = {
  create: CertificateCourseLevelCreateWithoutCertificateCourseInput;
  update: CertificateCourseLevelUpdateWithoutCertificateCourseInput;
  where?: InputMaybe<CertificateCourseLevelWhereInput>;
};

export type CertificateCourseLevelWhereInput = {
  AND?: InputMaybe<Array<CertificateCourseLevelWhereInput>>;
  CertificateBase?: InputMaybe<CertificateBaseWhereInput>;
  CertificateCourse?: InputMaybe<CertificateCourseListRelationFilter>;
  NOT?: InputMaybe<Array<CertificateCourseLevelWhereInput>>;
  OR?: InputMaybe<Array<CertificateCourseLevelWhereInput>>;
  certificateBaseId?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type CertificateCourseLevelWhereUniqueInput = {
  AND?: InputMaybe<Array<CertificateCourseLevelWhereInput>>;
  CertificateBase?: InputMaybe<CertificateBaseWhereInput>;
  CertificateCourse?: InputMaybe<CertificateCourseListRelationFilter>;
  NOT?: InputMaybe<Array<CertificateCourseLevelWhereInput>>;
  OR?: InputMaybe<Array<CertificateCourseLevelWhereInput>>;
  certificateBaseId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringFilter>;
};

export type CertificateCourseListRelationFilter = {
  every?: InputMaybe<CertificateCourseWhereInput>;
  none?: InputMaybe<CertificateCourseWhereInput>;
  some?: InputMaybe<CertificateCourseWhereInput>;
};

export type CertificateCourseMaxOrderByAggregateInput = {
  areaKnowledge?: InputMaybe<SortOrder>;
  certificateBaseId?: InputMaybe<SortOrder>;
  courseLevelCertificateBaseId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type CertificateCourseMinOrderByAggregateInput = {
  areaKnowledge?: InputMaybe<SortOrder>;
  certificateBaseId?: InputMaybe<SortOrder>;
  courseLevelCertificateBaseId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type CertificateCourseNullableRelationFilter = {
  is?: InputMaybe<CertificateCourseWhereInput>;
  isNot?: InputMaybe<CertificateCourseWhereInput>;
};

export type CertificateCourseOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CertificateCourseOrderByWithAggregationInput = {
  _count?: InputMaybe<CertificateCourseCountOrderByAggregateInput>;
  _max?: InputMaybe<CertificateCourseMaxOrderByAggregateInput>;
  _min?: InputMaybe<CertificateCourseMinOrderByAggregateInput>;
  areaKnowledge?: InputMaybe<SortOrder>;
  certificateBaseId?: InputMaybe<SortOrder>;
  courseLevelCertificateBaseId?: InputMaybe<SortOrder>;
  metaData?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type CertificateCourseOrderByWithRelationInput = {
  CertificateBase?: InputMaybe<CertificateBaseOrderByWithRelationInput>;
  CertificateCurriculum?: InputMaybe<CertificateCurriculumOrderByRelationAggregateInput>;
  CourseLevel?: InputMaybe<CertificateCourseLevelOrderByWithRelationInput>;
  areaKnowledge?: InputMaybe<SortOrder>;
  certificateBaseId?: InputMaybe<SortOrder>;
  courseLevelCertificateBaseId?: InputMaybe<SortOrder>;
  metaData?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type CertificateCourseRelationFilter = {
  is?: InputMaybe<CertificateCourseWhereInput>;
  isNot?: InputMaybe<CertificateCourseWhereInput>;
};

export enum CertificateCourseScalarFieldEnum {
  AreaKnowledge = 'areaKnowledge',
  CertificateBaseId = 'certificateBaseId',
  CourseLevelCertificateBaseId = 'courseLevelCertificateBaseId',
  MetaData = 'metaData',
  Name = 'name'
}

export type CertificateCourseScalarWhereInput = {
  AND?: InputMaybe<Array<CertificateCourseScalarWhereInput>>;
  NOT?: InputMaybe<Array<CertificateCourseScalarWhereInput>>;
  OR?: InputMaybe<Array<CertificateCourseScalarWhereInput>>;
  areaKnowledge?: InputMaybe<StringFilter>;
  certificateBaseId?: InputMaybe<StringFilter>;
  courseLevelCertificateBaseId?: InputMaybe<StringNullableFilter>;
  metaData?: InputMaybe<StringNullableListFilter>;
  name?: InputMaybe<StringFilter>;
};

export type CertificateCourseScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CertificateCourseScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CertificateCourseScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CertificateCourseScalarWhereWithAggregatesInput>>;
  areaKnowledge?: InputMaybe<StringWithAggregatesFilter>;
  certificateBaseId?: InputMaybe<StringWithAggregatesFilter>;
  courseLevelCertificateBaseId?: InputMaybe<StringNullableWithAggregatesFilter>;
  metaData?: InputMaybe<StringNullableListFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
};

export type CertificateCourseUpdateInput = {
  CertificateBase?: InputMaybe<CertificateBaseUpdateOneRequiredWithoutCertificateCourseNestedInput>;
  CertificateCurriculum?: InputMaybe<CertificateCurriculumUpdateManyWithoutCertificateCourseNestedInput>;
  CourseLevel?: InputMaybe<CertificateCourseLevelUpdateOneWithoutCertificateCourseNestedInput>;
  areaKnowledge?: InputMaybe<StringFieldUpdateOperationsInput>;
  metaData?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCourseUpdateManyMutationInput = {
  areaKnowledge?: InputMaybe<StringFieldUpdateOperationsInput>;
  metaData?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCourseUpdateManyWithWhereWithoutCourseLevelInput = {
  data: CertificateCourseUpdateManyMutationInput;
  where: CertificateCourseScalarWhereInput;
};

export type CertificateCourseUpdateManyWithoutCourseLevelNestedInput = {
  connect?: InputMaybe<Array<CertificateCourseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CertificateCourseCreateOrConnectWithoutCourseLevelInput>>;
  create?: InputMaybe<Array<CertificateCourseCreateWithoutCourseLevelInput>>;
  createMany?: InputMaybe<CertificateCourseCreateManyCourseLevelInputEnvelope>;
  delete?: InputMaybe<Array<CertificateCourseWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CertificateCourseScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CertificateCourseWhereUniqueInput>>;
  set?: InputMaybe<Array<CertificateCourseWhereUniqueInput>>;
  update?: InputMaybe<Array<CertificateCourseUpdateWithWhereUniqueWithoutCourseLevelInput>>;
  updateMany?: InputMaybe<Array<CertificateCourseUpdateManyWithWhereWithoutCourseLevelInput>>;
  upsert?: InputMaybe<Array<CertificateCourseUpsertWithWhereUniqueWithoutCourseLevelInput>>;
};

export type CertificateCourseUpdateOneRequiredWithoutCertificateCurriculumNestedInput = {
  connect?: InputMaybe<CertificateCourseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateCourseCreateOrConnectWithoutCertificateCurriculumInput>;
  create?: InputMaybe<CertificateCourseCreateWithoutCertificateCurriculumInput>;
  update?: InputMaybe<CertificateCourseUpdateToOneWithWhereWithoutCertificateCurriculumInput>;
  upsert?: InputMaybe<CertificateCourseUpsertWithoutCertificateCurriculumInput>;
};

export type CertificateCourseUpdateOneWithoutCertificateBaseNestedInput = {
  connect?: InputMaybe<CertificateCourseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateCourseCreateOrConnectWithoutCertificateBaseInput>;
  create?: InputMaybe<CertificateCourseCreateWithoutCertificateBaseInput>;
  delete?: InputMaybe<CertificateCourseWhereInput>;
  disconnect?: InputMaybe<CertificateCourseWhereInput>;
  update?: InputMaybe<CertificateCourseUpdateToOneWithWhereWithoutCertificateBaseInput>;
  upsert?: InputMaybe<CertificateCourseUpsertWithoutCertificateBaseInput>;
};

export type CertificateCourseUpdateToOneWithWhereWithoutCertificateBaseInput = {
  data: CertificateCourseUpdateWithoutCertificateBaseInput;
  where?: InputMaybe<CertificateCourseWhereInput>;
};

export type CertificateCourseUpdateToOneWithWhereWithoutCertificateCurriculumInput = {
  data: CertificateCourseUpdateWithoutCertificateCurriculumInput;
  where?: InputMaybe<CertificateCourseWhereInput>;
};

export type CertificateCourseUpdateWithWhereUniqueWithoutCourseLevelInput = {
  data: CertificateCourseUpdateWithoutCourseLevelInput;
  where: CertificateCourseWhereUniqueInput;
};

export type CertificateCourseUpdateWithoutCertificateBaseInput = {
  CertificateCurriculum?: InputMaybe<CertificateCurriculumUpdateManyWithoutCertificateCourseNestedInput>;
  CourseLevel?: InputMaybe<CertificateCourseLevelUpdateOneWithoutCertificateCourseNestedInput>;
  areaKnowledge?: InputMaybe<StringFieldUpdateOperationsInput>;
  metaData?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCourseUpdateWithoutCertificateCurriculumInput = {
  CertificateBase?: InputMaybe<CertificateBaseUpdateOneRequiredWithoutCertificateCourseNestedInput>;
  CourseLevel?: InputMaybe<CertificateCourseLevelUpdateOneWithoutCertificateCourseNestedInput>;
  areaKnowledge?: InputMaybe<StringFieldUpdateOperationsInput>;
  metaData?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCourseUpdateWithoutCourseLevelInput = {
  CertificateBase?: InputMaybe<CertificateBaseUpdateOneRequiredWithoutCertificateCourseNestedInput>;
  CertificateCurriculum?: InputMaybe<CertificateCurriculumUpdateManyWithoutCertificateCourseNestedInput>;
  areaKnowledge?: InputMaybe<StringFieldUpdateOperationsInput>;
  metaData?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCourseUpdatemetaDataInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CertificateCourseUpsertWithWhereUniqueWithoutCourseLevelInput = {
  create: CertificateCourseCreateWithoutCourseLevelInput;
  update: CertificateCourseUpdateWithoutCourseLevelInput;
  where: CertificateCourseWhereUniqueInput;
};

export type CertificateCourseUpsertWithoutCertificateBaseInput = {
  create: CertificateCourseCreateWithoutCertificateBaseInput;
  update: CertificateCourseUpdateWithoutCertificateBaseInput;
  where?: InputMaybe<CertificateCourseWhereInput>;
};

export type CertificateCourseUpsertWithoutCertificateCurriculumInput = {
  create: CertificateCourseCreateWithoutCertificateCurriculumInput;
  update: CertificateCourseUpdateWithoutCertificateCurriculumInput;
  where?: InputMaybe<CertificateCourseWhereInput>;
};

export type CertificateCourseWhereInput = {
  AND?: InputMaybe<Array<CertificateCourseWhereInput>>;
  CertificateBase?: InputMaybe<CertificateBaseWhereInput>;
  CertificateCurriculum?: InputMaybe<CertificateCurriculumListRelationFilter>;
  CourseLevel?: InputMaybe<CertificateCourseLevelWhereInput>;
  NOT?: InputMaybe<Array<CertificateCourseWhereInput>>;
  OR?: InputMaybe<Array<CertificateCourseWhereInput>>;
  areaKnowledge?: InputMaybe<StringFilter>;
  certificateBaseId?: InputMaybe<StringFilter>;
  courseLevelCertificateBaseId?: InputMaybe<StringNullableFilter>;
  metaData?: InputMaybe<StringNullableListFilter>;
  name?: InputMaybe<StringFilter>;
};

export type CertificateCourseWhereUniqueInput = {
  AND?: InputMaybe<Array<CertificateCourseWhereInput>>;
  CertificateBase?: InputMaybe<CertificateBaseWhereInput>;
  CertificateCurriculum?: InputMaybe<CertificateCurriculumListRelationFilter>;
  CourseLevel?: InputMaybe<CertificateCourseLevelWhereInput>;
  NOT?: InputMaybe<Array<CertificateCourseWhereInput>>;
  OR?: InputMaybe<Array<CertificateCourseWhereInput>>;
  areaKnowledge?: InputMaybe<StringFilter>;
  certificateBaseId?: InputMaybe<Scalars['String']['input']>;
  courseLevelCertificateBaseId?: InputMaybe<StringNullableFilter>;
  metaData?: InputMaybe<StringNullableListFilter>;
  name?: InputMaybe<StringFilter>;
};

export type CertificateCurriculum = {
  __typename?: 'CertificateCurriculum';
  CertificateBase: CertificateBase;
  CertificateCourse: CertificateCourse;
  CertificateCurriculumSelectedDisciplines: Array<CertificateCurriculumSelectedDiscipline>;
  DocumentCertificate: Array<DocumentCertificate>;
  amountOfHours?: Maybe<Scalars['Int']['output']>;
  certificateBaseId: Scalars['String']['output'];
  certificateCourseCertificateBaseId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};


export type CertificateCurriculumCertificateCurriculumSelectedDisciplinesArgs = {
  cursor?: InputMaybe<CertificateCurriculumSelectedDisciplineWhereUniqueInput>;
  distinct?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CertificateCurriculumSelectedDisciplineWhereInput>;
};


export type CertificateCurriculumDocumentCertificateArgs = {
  cursor?: InputMaybe<DocumentCertificateWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentCertificateScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentCertificateOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentCertificateWhereInput>;
};

export type CertificateCurriculumAvgOrderByAggregateInput = {
  amountOfHours?: InputMaybe<SortOrder>;
};

export type CertificateCurriculumCountOrderByAggregateInput = {
  amountOfHours?: InputMaybe<SortOrder>;
  certificateBaseId?: InputMaybe<SortOrder>;
  certificateCourseCertificateBaseId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type CertificateCurriculumCreateInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCertificateCurriculumInput;
  CertificateCourse: CertificateCourseCreateNestedOneWithoutCertificateCurriculumInput;
  CertificateCurriculumSelectedDisciplines?: InputMaybe<CertificateCurriculumSelectedDisciplineCreateNestedManyWithoutCertificateCurriculumInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedManyWithoutCurriculumInput>;
  amountOfHours?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type CertificateCurriculumCreateManyCertificateCourseInput = {
  amountOfHours?: InputMaybe<Scalars['Int']['input']>;
  certificateBaseId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CertificateCurriculumCreateManyCertificateCourseInputEnvelope = {
  data: Array<CertificateCurriculumCreateManyCertificateCourseInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CertificateCurriculumCreateManyInput = {
  amountOfHours?: InputMaybe<Scalars['Int']['input']>;
  certificateBaseId: Scalars['String']['input'];
  certificateCourseCertificateBaseId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CertificateCurriculumCreateNestedManyWithoutCertificateCourseInput = {
  connect?: InputMaybe<Array<CertificateCurriculumWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CertificateCurriculumCreateOrConnectWithoutCertificateCourseInput>>;
  create?: InputMaybe<Array<CertificateCurriculumCreateWithoutCertificateCourseInput>>;
  createMany?: InputMaybe<CertificateCurriculumCreateManyCertificateCourseInputEnvelope>;
};

export type CertificateCurriculumCreateNestedOneWithoutCertificateBaseInput = {
  connect?: InputMaybe<CertificateCurriculumWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateCurriculumCreateOrConnectWithoutCertificateBaseInput>;
  create?: InputMaybe<CertificateCurriculumCreateWithoutCertificateBaseInput>;
};

export type CertificateCurriculumCreateNestedOneWithoutCertificateCurriculumSelectedDisciplinesInput = {
  connect?: InputMaybe<CertificateCurriculumWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateCurriculumCreateOrConnectWithoutCertificateCurriculumSelectedDisciplinesInput>;
  create?: InputMaybe<CertificateCurriculumCreateWithoutCertificateCurriculumSelectedDisciplinesInput>;
};

export type CertificateCurriculumCreateNestedOneWithoutDocumentCertificateInput = {
  connect?: InputMaybe<CertificateCurriculumWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateCurriculumCreateOrConnectWithoutDocumentCertificateInput>;
  create?: InputMaybe<CertificateCurriculumCreateWithoutDocumentCertificateInput>;
};

export type CertificateCurriculumCreateOrConnectWithoutCertificateBaseInput = {
  create: CertificateCurriculumCreateWithoutCertificateBaseInput;
  where: CertificateCurriculumWhereUniqueInput;
};

export type CertificateCurriculumCreateOrConnectWithoutCertificateCourseInput = {
  create: CertificateCurriculumCreateWithoutCertificateCourseInput;
  where: CertificateCurriculumWhereUniqueInput;
};

export type CertificateCurriculumCreateOrConnectWithoutCertificateCurriculumSelectedDisciplinesInput = {
  create: CertificateCurriculumCreateWithoutCertificateCurriculumSelectedDisciplinesInput;
  where: CertificateCurriculumWhereUniqueInput;
};

export type CertificateCurriculumCreateOrConnectWithoutDocumentCertificateInput = {
  create: CertificateCurriculumCreateWithoutDocumentCertificateInput;
  where: CertificateCurriculumWhereUniqueInput;
};

export type CertificateCurriculumCreateWithoutCertificateBaseInput = {
  CertificateCourse: CertificateCourseCreateNestedOneWithoutCertificateCurriculumInput;
  CertificateCurriculumSelectedDisciplines?: InputMaybe<CertificateCurriculumSelectedDisciplineCreateNestedManyWithoutCertificateCurriculumInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedManyWithoutCurriculumInput>;
  amountOfHours?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type CertificateCurriculumCreateWithoutCertificateCourseInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCertificateCurriculumInput;
  CertificateCurriculumSelectedDisciplines?: InputMaybe<CertificateCurriculumSelectedDisciplineCreateNestedManyWithoutCertificateCurriculumInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedManyWithoutCurriculumInput>;
  amountOfHours?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type CertificateCurriculumCreateWithoutCertificateCurriculumSelectedDisciplinesInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCertificateCurriculumInput;
  CertificateCourse: CertificateCourseCreateNestedOneWithoutCertificateCurriculumInput;
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedManyWithoutCurriculumInput>;
  amountOfHours?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type CertificateCurriculumCreateWithoutDocumentCertificateInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCertificateCurriculumInput;
  CertificateCourse: CertificateCourseCreateNestedOneWithoutCertificateCurriculumInput;
  CertificateCurriculumSelectedDisciplines?: InputMaybe<CertificateCurriculumSelectedDisciplineCreateNestedManyWithoutCertificateCurriculumInput>;
  amountOfHours?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type CertificateCurriculumListRelationFilter = {
  every?: InputMaybe<CertificateCurriculumWhereInput>;
  none?: InputMaybe<CertificateCurriculumWhereInput>;
  some?: InputMaybe<CertificateCurriculumWhereInput>;
};

export type CertificateCurriculumMaxOrderByAggregateInput = {
  amountOfHours?: InputMaybe<SortOrder>;
  certificateBaseId?: InputMaybe<SortOrder>;
  certificateCourseCertificateBaseId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type CertificateCurriculumMinOrderByAggregateInput = {
  amountOfHours?: InputMaybe<SortOrder>;
  certificateBaseId?: InputMaybe<SortOrder>;
  certificateCourseCertificateBaseId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type CertificateCurriculumNullableRelationFilter = {
  is?: InputMaybe<CertificateCurriculumWhereInput>;
  isNot?: InputMaybe<CertificateCurriculumWhereInput>;
};

export type CertificateCurriculumOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CertificateCurriculumOrderByWithAggregationInput = {
  _avg?: InputMaybe<CertificateCurriculumAvgOrderByAggregateInput>;
  _count?: InputMaybe<CertificateCurriculumCountOrderByAggregateInput>;
  _max?: InputMaybe<CertificateCurriculumMaxOrderByAggregateInput>;
  _min?: InputMaybe<CertificateCurriculumMinOrderByAggregateInput>;
  _sum?: InputMaybe<CertificateCurriculumSumOrderByAggregateInput>;
  amountOfHours?: InputMaybe<SortOrder>;
  certificateBaseId?: InputMaybe<SortOrder>;
  certificateCourseCertificateBaseId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type CertificateCurriculumOrderByWithRelationInput = {
  CertificateBase?: InputMaybe<CertificateBaseOrderByWithRelationInput>;
  CertificateCourse?: InputMaybe<CertificateCourseOrderByWithRelationInput>;
  CertificateCurriculumSelectedDisciplines?: InputMaybe<CertificateCurriculumSelectedDisciplineOrderByRelationAggregateInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateOrderByRelationAggregateInput>;
  amountOfHours?: InputMaybe<SortOrder>;
  certificateBaseId?: InputMaybe<SortOrder>;
  certificateCourseCertificateBaseId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type CertificateCurriculumRelationFilter = {
  is?: InputMaybe<CertificateCurriculumWhereInput>;
  isNot?: InputMaybe<CertificateCurriculumWhereInput>;
};

export enum CertificateCurriculumScalarFieldEnum {
  AmountOfHours = 'amountOfHours',
  CertificateBaseId = 'certificateBaseId',
  CertificateCourseCertificateBaseId = 'certificateCourseCertificateBaseId',
  Name = 'name'
}

export type CertificateCurriculumScalarWhereInput = {
  AND?: InputMaybe<Array<CertificateCurriculumScalarWhereInput>>;
  NOT?: InputMaybe<Array<CertificateCurriculumScalarWhereInput>>;
  OR?: InputMaybe<Array<CertificateCurriculumScalarWhereInput>>;
  amountOfHours?: InputMaybe<IntNullableFilter>;
  certificateBaseId?: InputMaybe<StringFilter>;
  certificateCourseCertificateBaseId?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type CertificateCurriculumScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CertificateCurriculumScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CertificateCurriculumScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CertificateCurriculumScalarWhereWithAggregatesInput>>;
  amountOfHours?: InputMaybe<IntNullableWithAggregatesFilter>;
  certificateBaseId?: InputMaybe<StringWithAggregatesFilter>;
  certificateCourseCertificateBaseId?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
};

export type CertificateCurriculumSelectedDiscipline = {
  __typename?: 'CertificateCurriculumSelectedDiscipline';
  CertificateCurriculum: CertificateCurriculum;
  SelectedDiscipline: CertificateDiscipline;
  SelectedTeacher?: Maybe<CertificateTeacher>;
  amountOfHours?: Maybe<Scalars['Int']['output']>;
  certificateCurriculumId: Scalars['String']['output'];
  certificateDisciplineCertificateBaseId: Scalars['String']['output'];
  certificateTeacherCertificateBaseId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type CertificateCurriculumSelectedDisciplineAvgOrderByAggregateInput = {
  amountOfHours?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type CertificateCurriculumSelectedDisciplineCountOrderByAggregateInput = {
  amountOfHours?: InputMaybe<SortOrder>;
  certificateCurriculumId?: InputMaybe<SortOrder>;
  certificateDisciplineCertificateBaseId?: InputMaybe<SortOrder>;
  certificateTeacherCertificateBaseId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type CertificateCurriculumSelectedDisciplineCreateInput = {
  CertificateCurriculum: CertificateCurriculumCreateNestedOneWithoutCertificateCurriculumSelectedDisciplinesInput;
  SelectedDiscipline: CertificateDisciplineCreateNestedOneWithoutCertificateCurriculumSelectedDisciplinesInput;
  SelectedTeacher?: InputMaybe<CertificateTeacherCreateNestedOneWithoutCertificateCurriculumSelectedDisciplinesInput>;
  amountOfHours?: InputMaybe<Scalars['Int']['input']>;
};

export type CertificateCurriculumSelectedDisciplineCreateManyCertificateCurriculumInput = {
  amountOfHours?: InputMaybe<Scalars['Int']['input']>;
  certificateDisciplineCertificateBaseId: Scalars['String']['input'];
  certificateTeacherCertificateBaseId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type CertificateCurriculumSelectedDisciplineCreateManyCertificateCurriculumInputEnvelope = {
  data: Array<CertificateCurriculumSelectedDisciplineCreateManyCertificateCurriculumInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CertificateCurriculumSelectedDisciplineCreateManyInput = {
  amountOfHours?: InputMaybe<Scalars['Int']['input']>;
  certificateCurriculumId: Scalars['String']['input'];
  certificateDisciplineCertificateBaseId: Scalars['String']['input'];
  certificateTeacherCertificateBaseId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type CertificateCurriculumSelectedDisciplineCreateManySelectedDisciplineInput = {
  amountOfHours?: InputMaybe<Scalars['Int']['input']>;
  certificateCurriculumId: Scalars['String']['input'];
  certificateTeacherCertificateBaseId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type CertificateCurriculumSelectedDisciplineCreateManySelectedDisciplineInputEnvelope = {
  data: Array<CertificateCurriculumSelectedDisciplineCreateManySelectedDisciplineInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CertificateCurriculumSelectedDisciplineCreateManySelectedTeacherInput = {
  amountOfHours?: InputMaybe<Scalars['Int']['input']>;
  certificateCurriculumId: Scalars['String']['input'];
  certificateDisciplineCertificateBaseId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type CertificateCurriculumSelectedDisciplineCreateManySelectedTeacherInputEnvelope = {
  data: Array<CertificateCurriculumSelectedDisciplineCreateManySelectedTeacherInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CertificateCurriculumSelectedDisciplineCreateNestedManyWithoutCertificateCurriculumInput = {
  connect?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineCreateOrConnectWithoutCertificateCurriculumInput>>;
  create?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineCreateWithoutCertificateCurriculumInput>>;
  createMany?: InputMaybe<CertificateCurriculumSelectedDisciplineCreateManyCertificateCurriculumInputEnvelope>;
};

export type CertificateCurriculumSelectedDisciplineCreateNestedManyWithoutSelectedDisciplineInput = {
  connect?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineCreateOrConnectWithoutSelectedDisciplineInput>>;
  create?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineCreateWithoutSelectedDisciplineInput>>;
  createMany?: InputMaybe<CertificateCurriculumSelectedDisciplineCreateManySelectedDisciplineInputEnvelope>;
};

export type CertificateCurriculumSelectedDisciplineCreateNestedManyWithoutSelectedTeacherInput = {
  connect?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineCreateOrConnectWithoutSelectedTeacherInput>>;
  create?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineCreateWithoutSelectedTeacherInput>>;
  createMany?: InputMaybe<CertificateCurriculumSelectedDisciplineCreateManySelectedTeacherInputEnvelope>;
};

export type CertificateCurriculumSelectedDisciplineCreateOrConnectWithoutCertificateCurriculumInput = {
  create: CertificateCurriculumSelectedDisciplineCreateWithoutCertificateCurriculumInput;
  where: CertificateCurriculumSelectedDisciplineWhereUniqueInput;
};

export type CertificateCurriculumSelectedDisciplineCreateOrConnectWithoutSelectedDisciplineInput = {
  create: CertificateCurriculumSelectedDisciplineCreateWithoutSelectedDisciplineInput;
  where: CertificateCurriculumSelectedDisciplineWhereUniqueInput;
};

export type CertificateCurriculumSelectedDisciplineCreateOrConnectWithoutSelectedTeacherInput = {
  create: CertificateCurriculumSelectedDisciplineCreateWithoutSelectedTeacherInput;
  where: CertificateCurriculumSelectedDisciplineWhereUniqueInput;
};

export type CertificateCurriculumSelectedDisciplineCreateWithoutCertificateCurriculumInput = {
  SelectedDiscipline: CertificateDisciplineCreateNestedOneWithoutCertificateCurriculumSelectedDisciplinesInput;
  SelectedTeacher?: InputMaybe<CertificateTeacherCreateNestedOneWithoutCertificateCurriculumSelectedDisciplinesInput>;
  amountOfHours?: InputMaybe<Scalars['Int']['input']>;
};

export type CertificateCurriculumSelectedDisciplineCreateWithoutSelectedDisciplineInput = {
  CertificateCurriculum: CertificateCurriculumCreateNestedOneWithoutCertificateCurriculumSelectedDisciplinesInput;
  SelectedTeacher?: InputMaybe<CertificateTeacherCreateNestedOneWithoutCertificateCurriculumSelectedDisciplinesInput>;
  amountOfHours?: InputMaybe<Scalars['Int']['input']>;
};

export type CertificateCurriculumSelectedDisciplineCreateWithoutSelectedTeacherInput = {
  CertificateCurriculum: CertificateCurriculumCreateNestedOneWithoutCertificateCurriculumSelectedDisciplinesInput;
  SelectedDiscipline: CertificateDisciplineCreateNestedOneWithoutCertificateCurriculumSelectedDisciplinesInput;
  amountOfHours?: InputMaybe<Scalars['Int']['input']>;
};

export type CertificateCurriculumSelectedDisciplineListRelationFilter = {
  every?: InputMaybe<CertificateCurriculumSelectedDisciplineWhereInput>;
  none?: InputMaybe<CertificateCurriculumSelectedDisciplineWhereInput>;
  some?: InputMaybe<CertificateCurriculumSelectedDisciplineWhereInput>;
};

export type CertificateCurriculumSelectedDisciplineMaxOrderByAggregateInput = {
  amountOfHours?: InputMaybe<SortOrder>;
  certificateCurriculumId?: InputMaybe<SortOrder>;
  certificateDisciplineCertificateBaseId?: InputMaybe<SortOrder>;
  certificateTeacherCertificateBaseId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type CertificateCurriculumSelectedDisciplineMinOrderByAggregateInput = {
  amountOfHours?: InputMaybe<SortOrder>;
  certificateCurriculumId?: InputMaybe<SortOrder>;
  certificateDisciplineCertificateBaseId?: InputMaybe<SortOrder>;
  certificateTeacherCertificateBaseId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type CertificateCurriculumSelectedDisciplineOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CertificateCurriculumSelectedDisciplineOrderByWithAggregationInput = {
  _avg?: InputMaybe<CertificateCurriculumSelectedDisciplineAvgOrderByAggregateInput>;
  _count?: InputMaybe<CertificateCurriculumSelectedDisciplineCountOrderByAggregateInput>;
  _max?: InputMaybe<CertificateCurriculumSelectedDisciplineMaxOrderByAggregateInput>;
  _min?: InputMaybe<CertificateCurriculumSelectedDisciplineMinOrderByAggregateInput>;
  _sum?: InputMaybe<CertificateCurriculumSelectedDisciplineSumOrderByAggregateInput>;
  amountOfHours?: InputMaybe<SortOrder>;
  certificateCurriculumId?: InputMaybe<SortOrder>;
  certificateDisciplineCertificateBaseId?: InputMaybe<SortOrder>;
  certificateTeacherCertificateBaseId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type CertificateCurriculumSelectedDisciplineOrderByWithRelationInput = {
  CertificateCurriculum?: InputMaybe<CertificateCurriculumOrderByWithRelationInput>;
  SelectedDiscipline?: InputMaybe<CertificateDisciplineOrderByWithRelationInput>;
  SelectedTeacher?: InputMaybe<CertificateTeacherOrderByWithRelationInput>;
  amountOfHours?: InputMaybe<SortOrder>;
  certificateCurriculumId?: InputMaybe<SortOrder>;
  certificateDisciplineCertificateBaseId?: InputMaybe<SortOrder>;
  certificateTeacherCertificateBaseId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export enum CertificateCurriculumSelectedDisciplineScalarFieldEnum {
  AmountOfHours = 'amountOfHours',
  CertificateCurriculumId = 'certificateCurriculumId',
  CertificateDisciplineCertificateBaseId = 'certificateDisciplineCertificateBaseId',
  CertificateTeacherCertificateBaseId = 'certificateTeacherCertificateBaseId',
  Id = 'id'
}

export type CertificateCurriculumSelectedDisciplineScalarWhereInput = {
  AND?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineScalarWhereInput>>;
  NOT?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineScalarWhereInput>>;
  OR?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineScalarWhereInput>>;
  amountOfHours?: InputMaybe<IntNullableFilter>;
  certificateCurriculumId?: InputMaybe<StringFilter>;
  certificateDisciplineCertificateBaseId?: InputMaybe<StringFilter>;
  certificateTeacherCertificateBaseId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
};

export type CertificateCurriculumSelectedDisciplineScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineScalarWhereWithAggregatesInput>>;
  amountOfHours?: InputMaybe<IntNullableWithAggregatesFilter>;
  certificateCurriculumId?: InputMaybe<StringWithAggregatesFilter>;
  certificateDisciplineCertificateBaseId?: InputMaybe<StringWithAggregatesFilter>;
  certificateTeacherCertificateBaseId?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
};

export type CertificateCurriculumSelectedDisciplineSumOrderByAggregateInput = {
  amountOfHours?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type CertificateCurriculumSelectedDisciplineUpdateInput = {
  CertificateCurriculum?: InputMaybe<CertificateCurriculumUpdateOneRequiredWithoutCertificateCurriculumSelectedDisciplinesNestedInput>;
  SelectedDiscipline?: InputMaybe<CertificateDisciplineUpdateOneRequiredWithoutCertificateCurriculumSelectedDisciplinesNestedInput>;
  SelectedTeacher?: InputMaybe<CertificateTeacherUpdateOneWithoutCertificateCurriculumSelectedDisciplinesNestedInput>;
  amountOfHours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CertificateCurriculumSelectedDisciplineUpdateManyMutationInput = {
  amountOfHours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CertificateCurriculumSelectedDisciplineUpdateManyWithWhereWithoutCertificateCurriculumInput = {
  data: CertificateCurriculumSelectedDisciplineUpdateManyMutationInput;
  where: CertificateCurriculumSelectedDisciplineScalarWhereInput;
};

export type CertificateCurriculumSelectedDisciplineUpdateManyWithWhereWithoutSelectedDisciplineInput = {
  data: CertificateCurriculumSelectedDisciplineUpdateManyMutationInput;
  where: CertificateCurriculumSelectedDisciplineScalarWhereInput;
};

export type CertificateCurriculumSelectedDisciplineUpdateManyWithWhereWithoutSelectedTeacherInput = {
  data: CertificateCurriculumSelectedDisciplineUpdateManyMutationInput;
  where: CertificateCurriculumSelectedDisciplineScalarWhereInput;
};

export type CertificateCurriculumSelectedDisciplineUpdateManyWithoutCertificateCurriculumNestedInput = {
  connect?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineCreateOrConnectWithoutCertificateCurriculumInput>>;
  create?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineCreateWithoutCertificateCurriculumInput>>;
  createMany?: InputMaybe<CertificateCurriculumSelectedDisciplineCreateManyCertificateCurriculumInputEnvelope>;
  delete?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  set?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  update?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineUpdateWithWhereUniqueWithoutCertificateCurriculumInput>>;
  updateMany?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineUpdateManyWithWhereWithoutCertificateCurriculumInput>>;
  upsert?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineUpsertWithWhereUniqueWithoutCertificateCurriculumInput>>;
};

export type CertificateCurriculumSelectedDisciplineUpdateManyWithoutSelectedDisciplineNestedInput = {
  connect?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineCreateOrConnectWithoutSelectedDisciplineInput>>;
  create?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineCreateWithoutSelectedDisciplineInput>>;
  createMany?: InputMaybe<CertificateCurriculumSelectedDisciplineCreateManySelectedDisciplineInputEnvelope>;
  delete?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  set?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  update?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineUpdateWithWhereUniqueWithoutSelectedDisciplineInput>>;
  updateMany?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineUpdateManyWithWhereWithoutSelectedDisciplineInput>>;
  upsert?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineUpsertWithWhereUniqueWithoutSelectedDisciplineInput>>;
};

export type CertificateCurriculumSelectedDisciplineUpdateManyWithoutSelectedTeacherNestedInput = {
  connect?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineCreateOrConnectWithoutSelectedTeacherInput>>;
  create?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineCreateWithoutSelectedTeacherInput>>;
  createMany?: InputMaybe<CertificateCurriculumSelectedDisciplineCreateManySelectedTeacherInputEnvelope>;
  delete?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  set?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineWhereUniqueInput>>;
  update?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineUpdateWithWhereUniqueWithoutSelectedTeacherInput>>;
  updateMany?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineUpdateManyWithWhereWithoutSelectedTeacherInput>>;
  upsert?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineUpsertWithWhereUniqueWithoutSelectedTeacherInput>>;
};

export type CertificateCurriculumSelectedDisciplineUpdateWithWhereUniqueWithoutCertificateCurriculumInput = {
  data: CertificateCurriculumSelectedDisciplineUpdateWithoutCertificateCurriculumInput;
  where: CertificateCurriculumSelectedDisciplineWhereUniqueInput;
};

export type CertificateCurriculumSelectedDisciplineUpdateWithWhereUniqueWithoutSelectedDisciplineInput = {
  data: CertificateCurriculumSelectedDisciplineUpdateWithoutSelectedDisciplineInput;
  where: CertificateCurriculumSelectedDisciplineWhereUniqueInput;
};

export type CertificateCurriculumSelectedDisciplineUpdateWithWhereUniqueWithoutSelectedTeacherInput = {
  data: CertificateCurriculumSelectedDisciplineUpdateWithoutSelectedTeacherInput;
  where: CertificateCurriculumSelectedDisciplineWhereUniqueInput;
};

export type CertificateCurriculumSelectedDisciplineUpdateWithoutCertificateCurriculumInput = {
  SelectedDiscipline?: InputMaybe<CertificateDisciplineUpdateOneRequiredWithoutCertificateCurriculumSelectedDisciplinesNestedInput>;
  SelectedTeacher?: InputMaybe<CertificateTeacherUpdateOneWithoutCertificateCurriculumSelectedDisciplinesNestedInput>;
  amountOfHours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CertificateCurriculumSelectedDisciplineUpdateWithoutSelectedDisciplineInput = {
  CertificateCurriculum?: InputMaybe<CertificateCurriculumUpdateOneRequiredWithoutCertificateCurriculumSelectedDisciplinesNestedInput>;
  SelectedTeacher?: InputMaybe<CertificateTeacherUpdateOneWithoutCertificateCurriculumSelectedDisciplinesNestedInput>;
  amountOfHours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CertificateCurriculumSelectedDisciplineUpdateWithoutSelectedTeacherInput = {
  CertificateCurriculum?: InputMaybe<CertificateCurriculumUpdateOneRequiredWithoutCertificateCurriculumSelectedDisciplinesNestedInput>;
  SelectedDiscipline?: InputMaybe<CertificateDisciplineUpdateOneRequiredWithoutCertificateCurriculumSelectedDisciplinesNestedInput>;
  amountOfHours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CertificateCurriculumSelectedDisciplineUpsertWithWhereUniqueWithoutCertificateCurriculumInput = {
  create: CertificateCurriculumSelectedDisciplineCreateWithoutCertificateCurriculumInput;
  update: CertificateCurriculumSelectedDisciplineUpdateWithoutCertificateCurriculumInput;
  where: CertificateCurriculumSelectedDisciplineWhereUniqueInput;
};

export type CertificateCurriculumSelectedDisciplineUpsertWithWhereUniqueWithoutSelectedDisciplineInput = {
  create: CertificateCurriculumSelectedDisciplineCreateWithoutSelectedDisciplineInput;
  update: CertificateCurriculumSelectedDisciplineUpdateWithoutSelectedDisciplineInput;
  where: CertificateCurriculumSelectedDisciplineWhereUniqueInput;
};

export type CertificateCurriculumSelectedDisciplineUpsertWithWhereUniqueWithoutSelectedTeacherInput = {
  create: CertificateCurriculumSelectedDisciplineCreateWithoutSelectedTeacherInput;
  update: CertificateCurriculumSelectedDisciplineUpdateWithoutSelectedTeacherInput;
  where: CertificateCurriculumSelectedDisciplineWhereUniqueInput;
};

export type CertificateCurriculumSelectedDisciplineWhereInput = {
  AND?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineWhereInput>>;
  CertificateCurriculum?: InputMaybe<CertificateCurriculumWhereInput>;
  NOT?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineWhereInput>>;
  OR?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineWhereInput>>;
  SelectedDiscipline?: InputMaybe<CertificateDisciplineWhereInput>;
  SelectedTeacher?: InputMaybe<CertificateTeacherWhereInput>;
  amountOfHours?: InputMaybe<IntNullableFilter>;
  certificateCurriculumId?: InputMaybe<StringFilter>;
  certificateDisciplineCertificateBaseId?: InputMaybe<StringFilter>;
  certificateTeacherCertificateBaseId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
};

export type CertificateCurriculumSelectedDisciplineWhereUniqueInput = {
  AND?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineWhereInput>>;
  CertificateCurriculum?: InputMaybe<CertificateCurriculumWhereInput>;
  NOT?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineWhereInput>>;
  OR?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineWhereInput>>;
  SelectedDiscipline?: InputMaybe<CertificateDisciplineWhereInput>;
  SelectedTeacher?: InputMaybe<CertificateTeacherWhereInput>;
  amountOfHours?: InputMaybe<IntNullableFilter>;
  certificateCurriculumId?: InputMaybe<StringFilter>;
  certificateDisciplineCertificateBaseId?: InputMaybe<StringFilter>;
  certificateTeacherCertificateBaseId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type CertificateCurriculumSumOrderByAggregateInput = {
  amountOfHours?: InputMaybe<SortOrder>;
};

export type CertificateCurriculumUpdateInput = {
  CertificateBase?: InputMaybe<CertificateBaseUpdateOneRequiredWithoutCertificateCurriculumNestedInput>;
  CertificateCourse?: InputMaybe<CertificateCourseUpdateOneRequiredWithoutCertificateCurriculumNestedInput>;
  CertificateCurriculumSelectedDisciplines?: InputMaybe<CertificateCurriculumSelectedDisciplineUpdateManyWithoutCertificateCurriculumNestedInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateManyWithoutCurriculumNestedInput>;
  amountOfHours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCurriculumUpdateManyMutationInput = {
  amountOfHours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCurriculumUpdateManyWithWhereWithoutCertificateCourseInput = {
  data: CertificateCurriculumUpdateManyMutationInput;
  where: CertificateCurriculumScalarWhereInput;
};

export type CertificateCurriculumUpdateManyWithoutCertificateCourseNestedInput = {
  connect?: InputMaybe<Array<CertificateCurriculumWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CertificateCurriculumCreateOrConnectWithoutCertificateCourseInput>>;
  create?: InputMaybe<Array<CertificateCurriculumCreateWithoutCertificateCourseInput>>;
  createMany?: InputMaybe<CertificateCurriculumCreateManyCertificateCourseInputEnvelope>;
  delete?: InputMaybe<Array<CertificateCurriculumWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CertificateCurriculumScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CertificateCurriculumWhereUniqueInput>>;
  set?: InputMaybe<Array<CertificateCurriculumWhereUniqueInput>>;
  update?: InputMaybe<Array<CertificateCurriculumUpdateWithWhereUniqueWithoutCertificateCourseInput>>;
  updateMany?: InputMaybe<Array<CertificateCurriculumUpdateManyWithWhereWithoutCertificateCourseInput>>;
  upsert?: InputMaybe<Array<CertificateCurriculumUpsertWithWhereUniqueWithoutCertificateCourseInput>>;
};

export type CertificateCurriculumUpdateOneRequiredWithoutCertificateCurriculumSelectedDisciplinesNestedInput = {
  connect?: InputMaybe<CertificateCurriculumWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateCurriculumCreateOrConnectWithoutCertificateCurriculumSelectedDisciplinesInput>;
  create?: InputMaybe<CertificateCurriculumCreateWithoutCertificateCurriculumSelectedDisciplinesInput>;
  update?: InputMaybe<CertificateCurriculumUpdateToOneWithWhereWithoutCertificateCurriculumSelectedDisciplinesInput>;
  upsert?: InputMaybe<CertificateCurriculumUpsertWithoutCertificateCurriculumSelectedDisciplinesInput>;
};

export type CertificateCurriculumUpdateOneWithoutCertificateBaseNestedInput = {
  connect?: InputMaybe<CertificateCurriculumWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateCurriculumCreateOrConnectWithoutCertificateBaseInput>;
  create?: InputMaybe<CertificateCurriculumCreateWithoutCertificateBaseInput>;
  delete?: InputMaybe<CertificateCurriculumWhereInput>;
  disconnect?: InputMaybe<CertificateCurriculumWhereInput>;
  update?: InputMaybe<CertificateCurriculumUpdateToOneWithWhereWithoutCertificateBaseInput>;
  upsert?: InputMaybe<CertificateCurriculumUpsertWithoutCertificateBaseInput>;
};

export type CertificateCurriculumUpdateOneWithoutDocumentCertificateNestedInput = {
  connect?: InputMaybe<CertificateCurriculumWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateCurriculumCreateOrConnectWithoutDocumentCertificateInput>;
  create?: InputMaybe<CertificateCurriculumCreateWithoutDocumentCertificateInput>;
  delete?: InputMaybe<CertificateCurriculumWhereInput>;
  disconnect?: InputMaybe<CertificateCurriculumWhereInput>;
  update?: InputMaybe<CertificateCurriculumUpdateToOneWithWhereWithoutDocumentCertificateInput>;
  upsert?: InputMaybe<CertificateCurriculumUpsertWithoutDocumentCertificateInput>;
};

export type CertificateCurriculumUpdateToOneWithWhereWithoutCertificateBaseInput = {
  data: CertificateCurriculumUpdateWithoutCertificateBaseInput;
  where?: InputMaybe<CertificateCurriculumWhereInput>;
};

export type CertificateCurriculumUpdateToOneWithWhereWithoutCertificateCurriculumSelectedDisciplinesInput = {
  data: CertificateCurriculumUpdateWithoutCertificateCurriculumSelectedDisciplinesInput;
  where?: InputMaybe<CertificateCurriculumWhereInput>;
};

export type CertificateCurriculumUpdateToOneWithWhereWithoutDocumentCertificateInput = {
  data: CertificateCurriculumUpdateWithoutDocumentCertificateInput;
  where?: InputMaybe<CertificateCurriculumWhereInput>;
};

export type CertificateCurriculumUpdateWithWhereUniqueWithoutCertificateCourseInput = {
  data: CertificateCurriculumUpdateWithoutCertificateCourseInput;
  where: CertificateCurriculumWhereUniqueInput;
};

export type CertificateCurriculumUpdateWithoutCertificateBaseInput = {
  CertificateCourse?: InputMaybe<CertificateCourseUpdateOneRequiredWithoutCertificateCurriculumNestedInput>;
  CertificateCurriculumSelectedDisciplines?: InputMaybe<CertificateCurriculumSelectedDisciplineUpdateManyWithoutCertificateCurriculumNestedInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateManyWithoutCurriculumNestedInput>;
  amountOfHours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCurriculumUpdateWithoutCertificateCourseInput = {
  CertificateBase?: InputMaybe<CertificateBaseUpdateOneRequiredWithoutCertificateCurriculumNestedInput>;
  CertificateCurriculumSelectedDisciplines?: InputMaybe<CertificateCurriculumSelectedDisciplineUpdateManyWithoutCertificateCurriculumNestedInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateManyWithoutCurriculumNestedInput>;
  amountOfHours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCurriculumUpdateWithoutCertificateCurriculumSelectedDisciplinesInput = {
  CertificateBase?: InputMaybe<CertificateBaseUpdateOneRequiredWithoutCertificateCurriculumNestedInput>;
  CertificateCourse?: InputMaybe<CertificateCourseUpdateOneRequiredWithoutCertificateCurriculumNestedInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateManyWithoutCurriculumNestedInput>;
  amountOfHours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCurriculumUpdateWithoutDocumentCertificateInput = {
  CertificateBase?: InputMaybe<CertificateBaseUpdateOneRequiredWithoutCertificateCurriculumNestedInput>;
  CertificateCourse?: InputMaybe<CertificateCourseUpdateOneRequiredWithoutCertificateCurriculumNestedInput>;
  CertificateCurriculumSelectedDisciplines?: InputMaybe<CertificateCurriculumSelectedDisciplineUpdateManyWithoutCertificateCurriculumNestedInput>;
  amountOfHours?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CertificateCurriculumUpsertWithWhereUniqueWithoutCertificateCourseInput = {
  create: CertificateCurriculumCreateWithoutCertificateCourseInput;
  update: CertificateCurriculumUpdateWithoutCertificateCourseInput;
  where: CertificateCurriculumWhereUniqueInput;
};

export type CertificateCurriculumUpsertWithoutCertificateBaseInput = {
  create: CertificateCurriculumCreateWithoutCertificateBaseInput;
  update: CertificateCurriculumUpdateWithoutCertificateBaseInput;
  where?: InputMaybe<CertificateCurriculumWhereInput>;
};

export type CertificateCurriculumUpsertWithoutCertificateCurriculumSelectedDisciplinesInput = {
  create: CertificateCurriculumCreateWithoutCertificateCurriculumSelectedDisciplinesInput;
  update: CertificateCurriculumUpdateWithoutCertificateCurriculumSelectedDisciplinesInput;
  where?: InputMaybe<CertificateCurriculumWhereInput>;
};

export type CertificateCurriculumUpsertWithoutDocumentCertificateInput = {
  create: CertificateCurriculumCreateWithoutDocumentCertificateInput;
  update: CertificateCurriculumUpdateWithoutDocumentCertificateInput;
  where?: InputMaybe<CertificateCurriculumWhereInput>;
};

export type CertificateCurriculumWhereInput = {
  AND?: InputMaybe<Array<CertificateCurriculumWhereInput>>;
  CertificateBase?: InputMaybe<CertificateBaseWhereInput>;
  CertificateCourse?: InputMaybe<CertificateCourseWhereInput>;
  CertificateCurriculumSelectedDisciplines?: InputMaybe<CertificateCurriculumSelectedDisciplineListRelationFilter>;
  DocumentCertificate?: InputMaybe<DocumentCertificateListRelationFilter>;
  NOT?: InputMaybe<Array<CertificateCurriculumWhereInput>>;
  OR?: InputMaybe<Array<CertificateCurriculumWhereInput>>;
  amountOfHours?: InputMaybe<IntNullableFilter>;
  certificateBaseId?: InputMaybe<StringFilter>;
  certificateCourseCertificateBaseId?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type CertificateCurriculumWhereUniqueInput = {
  AND?: InputMaybe<Array<CertificateCurriculumWhereInput>>;
  CertificateBase?: InputMaybe<CertificateBaseWhereInput>;
  CertificateCourse?: InputMaybe<CertificateCourseWhereInput>;
  CertificateCurriculumSelectedDisciplines?: InputMaybe<CertificateCurriculumSelectedDisciplineListRelationFilter>;
  DocumentCertificate?: InputMaybe<DocumentCertificateListRelationFilter>;
  NOT?: InputMaybe<Array<CertificateCurriculumWhereInput>>;
  OR?: InputMaybe<Array<CertificateCurriculumWhereInput>>;
  amountOfHours?: InputMaybe<IntNullableFilter>;
  certificateBaseId?: InputMaybe<Scalars['String']['input']>;
  certificateCourseCertificateBaseId?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type CertificateDiscipline = {
  __typename?: 'CertificateDiscipline';
  CertificateBase: CertificateBase;
  CertificateCurriculumSelectedDisciplines: Array<CertificateCurriculumSelectedDiscipline>;
  certificateBaseId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  viewOnDegree: Scalars['Boolean']['output'];
};


export type CertificateDisciplineCertificateCurriculumSelectedDisciplinesArgs = {
  cursor?: InputMaybe<CertificateCurriculumSelectedDisciplineWhereUniqueInput>;
  distinct?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CertificateCurriculumSelectedDisciplineWhereInput>;
};

export type CertificateDisciplineCountOrderByAggregateInput = {
  certificateBaseId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  viewOnDegree?: InputMaybe<SortOrder>;
};

export type CertificateDisciplineCreateInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCertificateDisciplineInput;
  CertificateCurriculumSelectedDisciplines?: InputMaybe<CertificateCurriculumSelectedDisciplineCreateNestedManyWithoutSelectedDisciplineInput>;
  name: Scalars['String']['input'];
  viewOnDegree: Scalars['Boolean']['input'];
};

export type CertificateDisciplineCreateManyInput = {
  certificateBaseId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  viewOnDegree: Scalars['Boolean']['input'];
};

export type CertificateDisciplineCreateNestedOneWithoutCertificateBaseInput = {
  connect?: InputMaybe<CertificateDisciplineWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateDisciplineCreateOrConnectWithoutCertificateBaseInput>;
  create?: InputMaybe<CertificateDisciplineCreateWithoutCertificateBaseInput>;
};

export type CertificateDisciplineCreateNestedOneWithoutCertificateCurriculumSelectedDisciplinesInput = {
  connect?: InputMaybe<CertificateDisciplineWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateDisciplineCreateOrConnectWithoutCertificateCurriculumSelectedDisciplinesInput>;
  create?: InputMaybe<CertificateDisciplineCreateWithoutCertificateCurriculumSelectedDisciplinesInput>;
};

export type CertificateDisciplineCreateOrConnectWithoutCertificateBaseInput = {
  create: CertificateDisciplineCreateWithoutCertificateBaseInput;
  where: CertificateDisciplineWhereUniqueInput;
};

export type CertificateDisciplineCreateOrConnectWithoutCertificateCurriculumSelectedDisciplinesInput = {
  create: CertificateDisciplineCreateWithoutCertificateCurriculumSelectedDisciplinesInput;
  where: CertificateDisciplineWhereUniqueInput;
};

export type CertificateDisciplineCreateWithoutCertificateBaseInput = {
  CertificateCurriculumSelectedDisciplines?: InputMaybe<CertificateCurriculumSelectedDisciplineCreateNestedManyWithoutSelectedDisciplineInput>;
  name: Scalars['String']['input'];
  viewOnDegree: Scalars['Boolean']['input'];
};

export type CertificateDisciplineCreateWithoutCertificateCurriculumSelectedDisciplinesInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCertificateDisciplineInput;
  name: Scalars['String']['input'];
  viewOnDegree: Scalars['Boolean']['input'];
};

export type CertificateDisciplineMaxOrderByAggregateInput = {
  certificateBaseId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  viewOnDegree?: InputMaybe<SortOrder>;
};

export type CertificateDisciplineMinOrderByAggregateInput = {
  certificateBaseId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  viewOnDegree?: InputMaybe<SortOrder>;
};

export type CertificateDisciplineNullableRelationFilter = {
  is?: InputMaybe<CertificateDisciplineWhereInput>;
  isNot?: InputMaybe<CertificateDisciplineWhereInput>;
};

export type CertificateDisciplineOrderByWithAggregationInput = {
  _count?: InputMaybe<CertificateDisciplineCountOrderByAggregateInput>;
  _max?: InputMaybe<CertificateDisciplineMaxOrderByAggregateInput>;
  _min?: InputMaybe<CertificateDisciplineMinOrderByAggregateInput>;
  certificateBaseId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  viewOnDegree?: InputMaybe<SortOrder>;
};

export type CertificateDisciplineOrderByWithRelationInput = {
  CertificateBase?: InputMaybe<CertificateBaseOrderByWithRelationInput>;
  CertificateCurriculumSelectedDisciplines?: InputMaybe<CertificateCurriculumSelectedDisciplineOrderByRelationAggregateInput>;
  certificateBaseId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  viewOnDegree?: InputMaybe<SortOrder>;
};

export type CertificateDisciplineRelationFilter = {
  is?: InputMaybe<CertificateDisciplineWhereInput>;
  isNot?: InputMaybe<CertificateDisciplineWhereInput>;
};

export enum CertificateDisciplineScalarFieldEnum {
  CertificateBaseId = 'certificateBaseId',
  Name = 'name',
  ViewOnDegree = 'viewOnDegree'
}

export type CertificateDisciplineScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CertificateDisciplineScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CertificateDisciplineScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CertificateDisciplineScalarWhereWithAggregatesInput>>;
  certificateBaseId?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  viewOnDegree?: InputMaybe<BoolWithAggregatesFilter>;
};

export type CertificateDisciplineUpdateInput = {
  CertificateBase?: InputMaybe<CertificateBaseUpdateOneRequiredWithoutCertificateDisciplineNestedInput>;
  CertificateCurriculumSelectedDisciplines?: InputMaybe<CertificateCurriculumSelectedDisciplineUpdateManyWithoutSelectedDisciplineNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  viewOnDegree?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type CertificateDisciplineUpdateManyMutationInput = {
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  viewOnDegree?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type CertificateDisciplineUpdateOneRequiredWithoutCertificateCurriculumSelectedDisciplinesNestedInput = {
  connect?: InputMaybe<CertificateDisciplineWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateDisciplineCreateOrConnectWithoutCertificateCurriculumSelectedDisciplinesInput>;
  create?: InputMaybe<CertificateDisciplineCreateWithoutCertificateCurriculumSelectedDisciplinesInput>;
  update?: InputMaybe<CertificateDisciplineUpdateToOneWithWhereWithoutCertificateCurriculumSelectedDisciplinesInput>;
  upsert?: InputMaybe<CertificateDisciplineUpsertWithoutCertificateCurriculumSelectedDisciplinesInput>;
};

export type CertificateDisciplineUpdateOneWithoutCertificateBaseNestedInput = {
  connect?: InputMaybe<CertificateDisciplineWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateDisciplineCreateOrConnectWithoutCertificateBaseInput>;
  create?: InputMaybe<CertificateDisciplineCreateWithoutCertificateBaseInput>;
  delete?: InputMaybe<CertificateDisciplineWhereInput>;
  disconnect?: InputMaybe<CertificateDisciplineWhereInput>;
  update?: InputMaybe<CertificateDisciplineUpdateToOneWithWhereWithoutCertificateBaseInput>;
  upsert?: InputMaybe<CertificateDisciplineUpsertWithoutCertificateBaseInput>;
};

export type CertificateDisciplineUpdateToOneWithWhereWithoutCertificateBaseInput = {
  data: CertificateDisciplineUpdateWithoutCertificateBaseInput;
  where?: InputMaybe<CertificateDisciplineWhereInput>;
};

export type CertificateDisciplineUpdateToOneWithWhereWithoutCertificateCurriculumSelectedDisciplinesInput = {
  data: CertificateDisciplineUpdateWithoutCertificateCurriculumSelectedDisciplinesInput;
  where?: InputMaybe<CertificateDisciplineWhereInput>;
};

export type CertificateDisciplineUpdateWithoutCertificateBaseInput = {
  CertificateCurriculumSelectedDisciplines?: InputMaybe<CertificateCurriculumSelectedDisciplineUpdateManyWithoutSelectedDisciplineNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  viewOnDegree?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type CertificateDisciplineUpdateWithoutCertificateCurriculumSelectedDisciplinesInput = {
  CertificateBase?: InputMaybe<CertificateBaseUpdateOneRequiredWithoutCertificateDisciplineNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  viewOnDegree?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type CertificateDisciplineUpsertWithoutCertificateBaseInput = {
  create: CertificateDisciplineCreateWithoutCertificateBaseInput;
  update: CertificateDisciplineUpdateWithoutCertificateBaseInput;
  where?: InputMaybe<CertificateDisciplineWhereInput>;
};

export type CertificateDisciplineUpsertWithoutCertificateCurriculumSelectedDisciplinesInput = {
  create: CertificateDisciplineCreateWithoutCertificateCurriculumSelectedDisciplinesInput;
  update: CertificateDisciplineUpdateWithoutCertificateCurriculumSelectedDisciplinesInput;
  where?: InputMaybe<CertificateDisciplineWhereInput>;
};

export type CertificateDisciplineWhereInput = {
  AND?: InputMaybe<Array<CertificateDisciplineWhereInput>>;
  CertificateBase?: InputMaybe<CertificateBaseWhereInput>;
  CertificateCurriculumSelectedDisciplines?: InputMaybe<CertificateCurriculumSelectedDisciplineListRelationFilter>;
  NOT?: InputMaybe<Array<CertificateDisciplineWhereInput>>;
  OR?: InputMaybe<Array<CertificateDisciplineWhereInput>>;
  certificateBaseId?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  viewOnDegree?: InputMaybe<BoolFilter>;
};

export type CertificateDisciplineWhereUniqueInput = {
  AND?: InputMaybe<Array<CertificateDisciplineWhereInput>>;
  CertificateBase?: InputMaybe<CertificateBaseWhereInput>;
  CertificateCurriculumSelectedDisciplines?: InputMaybe<CertificateCurriculumSelectedDisciplineListRelationFilter>;
  NOT?: InputMaybe<Array<CertificateDisciplineWhereInput>>;
  OR?: InputMaybe<Array<CertificateDisciplineWhereInput>>;
  certificateBaseId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringFilter>;
  viewOnDegree?: InputMaybe<BoolFilter>;
};

export type CertificateEvent = {
  __typename?: 'CertificateEvent';
  CertificateBase: CertificateBase;
  DocumentCertificate: Array<DocumentCertificate>;
  certificateBaseId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};


export type CertificateEventDocumentCertificateArgs = {
  cursor?: InputMaybe<DocumentCertificateWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentCertificateScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentCertificateOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentCertificateWhereInput>;
};

export type CertificateEventCountOrderByAggregateInput = {
  certificateBaseId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type CertificateEventCreateInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCertificateEventInput;
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedManyWithoutEventInput>;
  name: Scalars['String']['input'];
};

export type CertificateEventCreateManyInput = {
  certificateBaseId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CertificateEventCreateNestedOneWithoutCertificateBaseInput = {
  connect?: InputMaybe<CertificateEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateEventCreateOrConnectWithoutCertificateBaseInput>;
  create?: InputMaybe<CertificateEventCreateWithoutCertificateBaseInput>;
};

export type CertificateEventCreateNestedOneWithoutDocumentCertificateInput = {
  connect?: InputMaybe<CertificateEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateEventCreateOrConnectWithoutDocumentCertificateInput>;
  create?: InputMaybe<CertificateEventCreateWithoutDocumentCertificateInput>;
};

export type CertificateEventCreateOrConnectWithoutCertificateBaseInput = {
  create: CertificateEventCreateWithoutCertificateBaseInput;
  where: CertificateEventWhereUniqueInput;
};

export type CertificateEventCreateOrConnectWithoutDocumentCertificateInput = {
  create: CertificateEventCreateWithoutDocumentCertificateInput;
  where: CertificateEventWhereUniqueInput;
};

export type CertificateEventCreateWithoutCertificateBaseInput = {
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedManyWithoutEventInput>;
  name: Scalars['String']['input'];
};

export type CertificateEventCreateWithoutDocumentCertificateInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCertificateEventInput;
  name: Scalars['String']['input'];
};

export type CertificateEventMaxOrderByAggregateInput = {
  certificateBaseId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type CertificateEventMinOrderByAggregateInput = {
  certificateBaseId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type CertificateEventNullableRelationFilter = {
  is?: InputMaybe<CertificateEventWhereInput>;
  isNot?: InputMaybe<CertificateEventWhereInput>;
};

export type CertificateEventOrderByWithAggregationInput = {
  _count?: InputMaybe<CertificateEventCountOrderByAggregateInput>;
  _max?: InputMaybe<CertificateEventMaxOrderByAggregateInput>;
  _min?: InputMaybe<CertificateEventMinOrderByAggregateInput>;
  certificateBaseId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type CertificateEventOrderByWithRelationInput = {
  CertificateBase?: InputMaybe<CertificateBaseOrderByWithRelationInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateOrderByRelationAggregateInput>;
  certificateBaseId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export enum CertificateEventScalarFieldEnum {
  CertificateBaseId = 'certificateBaseId',
  Name = 'name'
}

export type CertificateEventScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CertificateEventScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CertificateEventScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CertificateEventScalarWhereWithAggregatesInput>>;
  certificateBaseId?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
};

export type CertificateEventUpdateInput = {
  CertificateBase?: InputMaybe<CertificateBaseUpdateOneRequiredWithoutCertificateEventNestedInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateManyWithoutEventNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CertificateEventUpdateManyMutationInput = {
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CertificateEventUpdateOneWithoutCertificateBaseNestedInput = {
  connect?: InputMaybe<CertificateEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateEventCreateOrConnectWithoutCertificateBaseInput>;
  create?: InputMaybe<CertificateEventCreateWithoutCertificateBaseInput>;
  delete?: InputMaybe<CertificateEventWhereInput>;
  disconnect?: InputMaybe<CertificateEventWhereInput>;
  update?: InputMaybe<CertificateEventUpdateToOneWithWhereWithoutCertificateBaseInput>;
  upsert?: InputMaybe<CertificateEventUpsertWithoutCertificateBaseInput>;
};

export type CertificateEventUpdateOneWithoutDocumentCertificateNestedInput = {
  connect?: InputMaybe<CertificateEventWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateEventCreateOrConnectWithoutDocumentCertificateInput>;
  create?: InputMaybe<CertificateEventCreateWithoutDocumentCertificateInput>;
  delete?: InputMaybe<CertificateEventWhereInput>;
  disconnect?: InputMaybe<CertificateEventWhereInput>;
  update?: InputMaybe<CertificateEventUpdateToOneWithWhereWithoutDocumentCertificateInput>;
  upsert?: InputMaybe<CertificateEventUpsertWithoutDocumentCertificateInput>;
};

export type CertificateEventUpdateToOneWithWhereWithoutCertificateBaseInput = {
  data: CertificateEventUpdateWithoutCertificateBaseInput;
  where?: InputMaybe<CertificateEventWhereInput>;
};

export type CertificateEventUpdateToOneWithWhereWithoutDocumentCertificateInput = {
  data: CertificateEventUpdateWithoutDocumentCertificateInput;
  where?: InputMaybe<CertificateEventWhereInput>;
};

export type CertificateEventUpdateWithoutCertificateBaseInput = {
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateManyWithoutEventNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CertificateEventUpdateWithoutDocumentCertificateInput = {
  CertificateBase?: InputMaybe<CertificateBaseUpdateOneRequiredWithoutCertificateEventNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CertificateEventUpsertWithoutCertificateBaseInput = {
  create: CertificateEventCreateWithoutCertificateBaseInput;
  update: CertificateEventUpdateWithoutCertificateBaseInput;
  where?: InputMaybe<CertificateEventWhereInput>;
};

export type CertificateEventUpsertWithoutDocumentCertificateInput = {
  create: CertificateEventCreateWithoutDocumentCertificateInput;
  update: CertificateEventUpdateWithoutDocumentCertificateInput;
  where?: InputMaybe<CertificateEventWhereInput>;
};

export type CertificateEventWhereInput = {
  AND?: InputMaybe<Array<CertificateEventWhereInput>>;
  CertificateBase?: InputMaybe<CertificateBaseWhereInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateListRelationFilter>;
  NOT?: InputMaybe<Array<CertificateEventWhereInput>>;
  OR?: InputMaybe<Array<CertificateEventWhereInput>>;
  certificateBaseId?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type CertificateEventWhereUniqueInput = {
  AND?: InputMaybe<Array<CertificateEventWhereInput>>;
  CertificateBase?: InputMaybe<CertificateBaseWhereInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateListRelationFilter>;
  NOT?: InputMaybe<Array<CertificateEventWhereInput>>;
  OR?: InputMaybe<Array<CertificateEventWhereInput>>;
  certificateBaseId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringFilter>;
};

export type CertificateTeacher = {
  __typename?: 'CertificateTeacher';
  CertificateBase: CertificateBase;
  CertificateCurriculumSelectedDisciplines: Array<CertificateCurriculumSelectedDiscipline>;
  certificateBaseId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  titration: Scalars['String']['output'];
};


export type CertificateTeacherCertificateCurriculumSelectedDisciplinesArgs = {
  cursor?: InputMaybe<CertificateCurriculumSelectedDisciplineWhereUniqueInput>;
  distinct?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CertificateCurriculumSelectedDisciplineOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CertificateCurriculumSelectedDisciplineWhereInput>;
};

export type CertificateTeacherCountOrderByAggregateInput = {
  certificateBaseId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  titration?: InputMaybe<SortOrder>;
};

export type CertificateTeacherCreateInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCertificateTeacherInput;
  CertificateCurriculumSelectedDisciplines?: InputMaybe<CertificateCurriculumSelectedDisciplineCreateNestedManyWithoutSelectedTeacherInput>;
  name: Scalars['String']['input'];
  titration: Scalars['String']['input'];
};

export type CertificateTeacherCreateManyInput = {
  certificateBaseId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  titration: Scalars['String']['input'];
};

export type CertificateTeacherCreateNestedOneWithoutCertificateBaseInput = {
  connect?: InputMaybe<CertificateTeacherWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateTeacherCreateOrConnectWithoutCertificateBaseInput>;
  create?: InputMaybe<CertificateTeacherCreateWithoutCertificateBaseInput>;
};

export type CertificateTeacherCreateNestedOneWithoutCertificateCurriculumSelectedDisciplinesInput = {
  connect?: InputMaybe<CertificateTeacherWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateTeacherCreateOrConnectWithoutCertificateCurriculumSelectedDisciplinesInput>;
  create?: InputMaybe<CertificateTeacherCreateWithoutCertificateCurriculumSelectedDisciplinesInput>;
};

export type CertificateTeacherCreateOrConnectWithoutCertificateBaseInput = {
  create: CertificateTeacherCreateWithoutCertificateBaseInput;
  where: CertificateTeacherWhereUniqueInput;
};

export type CertificateTeacherCreateOrConnectWithoutCertificateCurriculumSelectedDisciplinesInput = {
  create: CertificateTeacherCreateWithoutCertificateCurriculumSelectedDisciplinesInput;
  where: CertificateTeacherWhereUniqueInput;
};

export type CertificateTeacherCreateWithoutCertificateBaseInput = {
  CertificateCurriculumSelectedDisciplines?: InputMaybe<CertificateCurriculumSelectedDisciplineCreateNestedManyWithoutSelectedTeacherInput>;
  name: Scalars['String']['input'];
  titration: Scalars['String']['input'];
};

export type CertificateTeacherCreateWithoutCertificateCurriculumSelectedDisciplinesInput = {
  CertificateBase: CertificateBaseCreateNestedOneWithoutCertificateTeacherInput;
  name: Scalars['String']['input'];
  titration: Scalars['String']['input'];
};

export type CertificateTeacherMaxOrderByAggregateInput = {
  certificateBaseId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  titration?: InputMaybe<SortOrder>;
};

export type CertificateTeacherMinOrderByAggregateInput = {
  certificateBaseId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  titration?: InputMaybe<SortOrder>;
};

export type CertificateTeacherNullableRelationFilter = {
  is?: InputMaybe<CertificateTeacherWhereInput>;
  isNot?: InputMaybe<CertificateTeacherWhereInput>;
};

export type CertificateTeacherOrderByWithAggregationInput = {
  _count?: InputMaybe<CertificateTeacherCountOrderByAggregateInput>;
  _max?: InputMaybe<CertificateTeacherMaxOrderByAggregateInput>;
  _min?: InputMaybe<CertificateTeacherMinOrderByAggregateInput>;
  certificateBaseId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  titration?: InputMaybe<SortOrder>;
};

export type CertificateTeacherOrderByWithRelationInput = {
  CertificateBase?: InputMaybe<CertificateBaseOrderByWithRelationInput>;
  CertificateCurriculumSelectedDisciplines?: InputMaybe<CertificateCurriculumSelectedDisciplineOrderByRelationAggregateInput>;
  certificateBaseId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  titration?: InputMaybe<SortOrder>;
};

export enum CertificateTeacherScalarFieldEnum {
  CertificateBaseId = 'certificateBaseId',
  Name = 'name',
  Titration = 'titration'
}

export type CertificateTeacherScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CertificateTeacherScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CertificateTeacherScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CertificateTeacherScalarWhereWithAggregatesInput>>;
  certificateBaseId?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  titration?: InputMaybe<StringWithAggregatesFilter>;
};

export type CertificateTeacherUpdateInput = {
  CertificateBase?: InputMaybe<CertificateBaseUpdateOneRequiredWithoutCertificateTeacherNestedInput>;
  CertificateCurriculumSelectedDisciplines?: InputMaybe<CertificateCurriculumSelectedDisciplineUpdateManyWithoutSelectedTeacherNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  titration?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CertificateTeacherUpdateManyMutationInput = {
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  titration?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CertificateTeacherUpdateOneWithoutCertificateBaseNestedInput = {
  connect?: InputMaybe<CertificateTeacherWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateTeacherCreateOrConnectWithoutCertificateBaseInput>;
  create?: InputMaybe<CertificateTeacherCreateWithoutCertificateBaseInput>;
  delete?: InputMaybe<CertificateTeacherWhereInput>;
  disconnect?: InputMaybe<CertificateTeacherWhereInput>;
  update?: InputMaybe<CertificateTeacherUpdateToOneWithWhereWithoutCertificateBaseInput>;
  upsert?: InputMaybe<CertificateTeacherUpsertWithoutCertificateBaseInput>;
};

export type CertificateTeacherUpdateOneWithoutCertificateCurriculumSelectedDisciplinesNestedInput = {
  connect?: InputMaybe<CertificateTeacherWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateTeacherCreateOrConnectWithoutCertificateCurriculumSelectedDisciplinesInput>;
  create?: InputMaybe<CertificateTeacherCreateWithoutCertificateCurriculumSelectedDisciplinesInput>;
  delete?: InputMaybe<CertificateTeacherWhereInput>;
  disconnect?: InputMaybe<CertificateTeacherWhereInput>;
  update?: InputMaybe<CertificateTeacherUpdateToOneWithWhereWithoutCertificateCurriculumSelectedDisciplinesInput>;
  upsert?: InputMaybe<CertificateTeacherUpsertWithoutCertificateCurriculumSelectedDisciplinesInput>;
};

export type CertificateTeacherUpdateToOneWithWhereWithoutCertificateBaseInput = {
  data: CertificateTeacherUpdateWithoutCertificateBaseInput;
  where?: InputMaybe<CertificateTeacherWhereInput>;
};

export type CertificateTeacherUpdateToOneWithWhereWithoutCertificateCurriculumSelectedDisciplinesInput = {
  data: CertificateTeacherUpdateWithoutCertificateCurriculumSelectedDisciplinesInput;
  where?: InputMaybe<CertificateTeacherWhereInput>;
};

export type CertificateTeacherUpdateWithoutCertificateBaseInput = {
  CertificateCurriculumSelectedDisciplines?: InputMaybe<CertificateCurriculumSelectedDisciplineUpdateManyWithoutSelectedTeacherNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  titration?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CertificateTeacherUpdateWithoutCertificateCurriculumSelectedDisciplinesInput = {
  CertificateBase?: InputMaybe<CertificateBaseUpdateOneRequiredWithoutCertificateTeacherNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  titration?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CertificateTeacherUpsertWithoutCertificateBaseInput = {
  create: CertificateTeacherCreateWithoutCertificateBaseInput;
  update: CertificateTeacherUpdateWithoutCertificateBaseInput;
  where?: InputMaybe<CertificateTeacherWhereInput>;
};

export type CertificateTeacherUpsertWithoutCertificateCurriculumSelectedDisciplinesInput = {
  create: CertificateTeacherCreateWithoutCertificateCurriculumSelectedDisciplinesInput;
  update: CertificateTeacherUpdateWithoutCertificateCurriculumSelectedDisciplinesInput;
  where?: InputMaybe<CertificateTeacherWhereInput>;
};

export type CertificateTeacherWhereInput = {
  AND?: InputMaybe<Array<CertificateTeacherWhereInput>>;
  CertificateBase?: InputMaybe<CertificateBaseWhereInput>;
  CertificateCurriculumSelectedDisciplines?: InputMaybe<CertificateCurriculumSelectedDisciplineListRelationFilter>;
  NOT?: InputMaybe<Array<CertificateTeacherWhereInput>>;
  OR?: InputMaybe<Array<CertificateTeacherWhereInput>>;
  certificateBaseId?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  titration?: InputMaybe<StringFilter>;
};

export type CertificateTeacherWhereUniqueInput = {
  AND?: InputMaybe<Array<CertificateTeacherWhereInput>>;
  CertificateBase?: InputMaybe<CertificateBaseWhereInput>;
  CertificateCurriculumSelectedDisciplines?: InputMaybe<CertificateCurriculumSelectedDisciplineListRelationFilter>;
  NOT?: InputMaybe<Array<CertificateTeacherWhereInput>>;
  OR?: InputMaybe<Array<CertificateTeacherWhereInput>>;
  certificateBaseId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringFilter>;
  titration?: InputMaybe<StringFilter>;
};

/** Guarda o modelo para criação dos certificados / representações visuais de diploma */
export type CertificateTemplate = {
  __typename?: 'CertificateTemplate';
  DocumentCertificate: Array<DocumentCertificate>;
  Team: Team;
  TeamUsingAsPrimary?: Maybe<Team>;
  UserCreated: CommonUser;
  commonUserId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** ![PrismaJson.AnyJson] */
  data: Scalars['Json']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Undergraduate -> Degree RVDD
   * Postgraduate -> Certificate of Post Graduation
   * Generic Certificates -> Any Certificate
   */
  educationLevel: EducationLevelType;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  teamId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** Guarda o modelo para criação dos certificados / representações visuais de diploma */
export type CertificateTemplateDocumentCertificateArgs = {
  cursor?: InputMaybe<DocumentCertificateWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentCertificateScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentCertificateOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentCertificateWhereInput>;
};

export type CertificateTemplateAvgOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type CertificateTemplateCountOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  educationLevel?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CertificateTemplateCreateInput = {
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedManyWithoutTemplateInput>;
  Team: TeamCreateNestedOneWithoutCertificateTemplatesInput;
  TeamUsingAsPrimary?: InputMaybe<TeamCreateNestedOneWithoutDefaultDegreeCertificateTemplateInput>;
  UserCreated: CommonUserCreateNestedOneWithoutCreatedCertificateTemplatesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CertificateTemplateCreateManyInput = {
  commonUserId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CertificateTemplateCreateManyTeamInput = {
  commonUserId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CertificateTemplateCreateManyTeamInputEnvelope = {
  data: Array<CertificateTemplateCreateManyTeamInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CertificateTemplateCreateManyUserCreatedInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CertificateTemplateCreateManyUserCreatedInputEnvelope = {
  data: Array<CertificateTemplateCreateManyUserCreatedInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CertificateTemplateCreateNestedManyWithoutTeamInput = {
  connect?: InputMaybe<Array<CertificateTemplateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CertificateTemplateCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<CertificateTemplateCreateWithoutTeamInput>>;
  createMany?: InputMaybe<CertificateTemplateCreateManyTeamInputEnvelope>;
};

export type CertificateTemplateCreateNestedManyWithoutUserCreatedInput = {
  connect?: InputMaybe<Array<CertificateTemplateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CertificateTemplateCreateOrConnectWithoutUserCreatedInput>>;
  create?: InputMaybe<Array<CertificateTemplateCreateWithoutUserCreatedInput>>;
  createMany?: InputMaybe<CertificateTemplateCreateManyUserCreatedInputEnvelope>;
};

export type CertificateTemplateCreateNestedOneWithoutDocumentCertificateInput = {
  connect?: InputMaybe<CertificateTemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateTemplateCreateOrConnectWithoutDocumentCertificateInput>;
  create?: InputMaybe<CertificateTemplateCreateWithoutDocumentCertificateInput>;
};

export type CertificateTemplateCreateNestedOneWithoutTeamUsingAsPrimaryInput = {
  connect?: InputMaybe<CertificateTemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateTemplateCreateOrConnectWithoutTeamUsingAsPrimaryInput>;
  create?: InputMaybe<CertificateTemplateCreateWithoutTeamUsingAsPrimaryInput>;
};

export type CertificateTemplateCreateOrConnectWithoutDocumentCertificateInput = {
  create: CertificateTemplateCreateWithoutDocumentCertificateInput;
  where: CertificateTemplateWhereUniqueInput;
};

export type CertificateTemplateCreateOrConnectWithoutTeamInput = {
  create: CertificateTemplateCreateWithoutTeamInput;
  where: CertificateTemplateWhereUniqueInput;
};

export type CertificateTemplateCreateOrConnectWithoutTeamUsingAsPrimaryInput = {
  create: CertificateTemplateCreateWithoutTeamUsingAsPrimaryInput;
  where: CertificateTemplateWhereUniqueInput;
};

export type CertificateTemplateCreateOrConnectWithoutUserCreatedInput = {
  create: CertificateTemplateCreateWithoutUserCreatedInput;
  where: CertificateTemplateWhereUniqueInput;
};

export type CertificateTemplateCreateWithoutDocumentCertificateInput = {
  Team: TeamCreateNestedOneWithoutCertificateTemplatesInput;
  TeamUsingAsPrimary?: InputMaybe<TeamCreateNestedOneWithoutDefaultDegreeCertificateTemplateInput>;
  UserCreated: CommonUserCreateNestedOneWithoutCreatedCertificateTemplatesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CertificateTemplateCreateWithoutTeamInput = {
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedManyWithoutTemplateInput>;
  TeamUsingAsPrimary?: InputMaybe<TeamCreateNestedOneWithoutDefaultDegreeCertificateTemplateInput>;
  UserCreated: CommonUserCreateNestedOneWithoutCreatedCertificateTemplatesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CertificateTemplateCreateWithoutTeamUsingAsPrimaryInput = {
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedManyWithoutTemplateInput>;
  Team: TeamCreateNestedOneWithoutCertificateTemplatesInput;
  UserCreated: CommonUserCreateNestedOneWithoutCreatedCertificateTemplatesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CertificateTemplateCreateWithoutUserCreatedInput = {
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedManyWithoutTemplateInput>;
  Team: TeamCreateNestedOneWithoutCertificateTemplatesInput;
  TeamUsingAsPrimary?: InputMaybe<TeamCreateNestedOneWithoutDefaultDegreeCertificateTemplateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CertificateTemplateListRelationFilter = {
  every?: InputMaybe<CertificateTemplateWhereInput>;
  none?: InputMaybe<CertificateTemplateWhereInput>;
  some?: InputMaybe<CertificateTemplateWhereInput>;
};

export type CertificateTemplateMaxOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  educationLevel?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CertificateTemplateMinOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  educationLevel?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CertificateTemplateNullableRelationFilter = {
  is?: InputMaybe<CertificateTemplateWhereInput>;
  isNot?: InputMaybe<CertificateTemplateWhereInput>;
};

export type CertificateTemplateOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CertificateTemplateOrderByWithAggregationInput = {
  _avg?: InputMaybe<CertificateTemplateAvgOrderByAggregateInput>;
  _count?: InputMaybe<CertificateTemplateCountOrderByAggregateInput>;
  _max?: InputMaybe<CertificateTemplateMaxOrderByAggregateInput>;
  _min?: InputMaybe<CertificateTemplateMinOrderByAggregateInput>;
  _sum?: InputMaybe<CertificateTemplateSumOrderByAggregateInput>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  educationLevel?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CertificateTemplateOrderByWithRelationInput = {
  DocumentCertificate?: InputMaybe<DocumentCertificateOrderByRelationAggregateInput>;
  Team?: InputMaybe<TeamOrderByWithRelationInput>;
  TeamUsingAsPrimary?: InputMaybe<TeamOrderByWithRelationInput>;
  UserCreated?: InputMaybe<CommonUserOrderByWithRelationInput>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  educationLevel?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

/** Presets for Certificate Templates that user can use to create a new template */
export type CertificateTemplatePreset = {
  __typename?: 'CertificateTemplatePreset';
  UserCreated: CommonUser;
  commonUserId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** ![PrismaJson.AnyJson] */
  data: Scalars['Json']['output'];
  id: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CertificateTemplatePresetAvgOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
};

export type CertificateTemplatePresetCountOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type CertificateTemplatePresetCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CertificateTemplatePresetCreateManyInput = {
  commonUserId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CertificateTemplatePresetCreateManyUserCreatedInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CertificateTemplatePresetCreateManyUserCreatedInputEnvelope = {
  data: Array<CertificateTemplatePresetCreateManyUserCreatedInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CertificateTemplatePresetCreateNestedManyWithoutUserCreatedInput = {
  connect?: InputMaybe<Array<CertificateTemplatePresetWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CertificateTemplatePresetCreateOrConnectWithoutUserCreatedInput>>;
  create?: InputMaybe<Array<CertificateTemplatePresetCreateWithoutUserCreatedInput>>;
  createMany?: InputMaybe<CertificateTemplatePresetCreateManyUserCreatedInputEnvelope>;
};

export type CertificateTemplatePresetCreateOrConnectWithoutUserCreatedInput = {
  create: CertificateTemplatePresetCreateWithoutUserCreatedInput;
  where: CertificateTemplatePresetWhereUniqueInput;
};

export type CertificateTemplatePresetCreateWithoutUserCreatedInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CertificateTemplatePresetListRelationFilter = {
  every?: InputMaybe<CertificateTemplatePresetWhereInput>;
  none?: InputMaybe<CertificateTemplatePresetWhereInput>;
  some?: InputMaybe<CertificateTemplatePresetWhereInput>;
};

export type CertificateTemplatePresetMaxOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type CertificateTemplatePresetMinOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type CertificateTemplatePresetOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CertificateTemplatePresetOrderByWithAggregationInput = {
  _avg?: InputMaybe<CertificateTemplatePresetAvgOrderByAggregateInput>;
  _count?: InputMaybe<CertificateTemplatePresetCountOrderByAggregateInput>;
  _max?: InputMaybe<CertificateTemplatePresetMaxOrderByAggregateInput>;
  _min?: InputMaybe<CertificateTemplatePresetMinOrderByAggregateInput>;
  _sum?: InputMaybe<CertificateTemplatePresetSumOrderByAggregateInput>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type CertificateTemplatePresetOrderByWithRelationInput = {
  UserCreated?: InputMaybe<CommonUserOrderByWithRelationInput>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export enum CertificateTemplatePresetScalarFieldEnum {
  CommonUserId = 'commonUserId',
  CreatedAt = 'createdAt',
  Data = 'data',
  Id = 'id',
  ImageUrl = 'imageUrl',
  Name = 'name'
}

export type CertificateTemplatePresetScalarWhereInput = {
  AND?: InputMaybe<Array<CertificateTemplatePresetScalarWhereInput>>;
  NOT?: InputMaybe<Array<CertificateTemplatePresetScalarWhereInput>>;
  OR?: InputMaybe<Array<CertificateTemplatePresetScalarWhereInput>>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<StringFilter>;
  imageUrl?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type CertificateTemplatePresetScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CertificateTemplatePresetScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CertificateTemplatePresetScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CertificateTemplatePresetScalarWhereWithAggregatesInput>>;
  commonUserId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  data?: InputMaybe<JsonWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  imageUrl?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
};

export type CertificateTemplatePresetSumOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
};

export type CertificateTemplatePresetUpdateInput = {
  UserCreated?: InputMaybe<CommonUserUpdateOneRequiredWithoutCreatedCertificateTemplatePresetsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CertificateTemplatePresetUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CertificateTemplatePresetUpdateManyWithWhereWithoutUserCreatedInput = {
  data: CertificateTemplatePresetUpdateManyMutationInput;
  where: CertificateTemplatePresetScalarWhereInput;
};

export type CertificateTemplatePresetUpdateManyWithoutUserCreatedNestedInput = {
  connect?: InputMaybe<Array<CertificateTemplatePresetWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CertificateTemplatePresetCreateOrConnectWithoutUserCreatedInput>>;
  create?: InputMaybe<Array<CertificateTemplatePresetCreateWithoutUserCreatedInput>>;
  createMany?: InputMaybe<CertificateTemplatePresetCreateManyUserCreatedInputEnvelope>;
  delete?: InputMaybe<Array<CertificateTemplatePresetWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CertificateTemplatePresetScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CertificateTemplatePresetWhereUniqueInput>>;
  set?: InputMaybe<Array<CertificateTemplatePresetWhereUniqueInput>>;
  update?: InputMaybe<Array<CertificateTemplatePresetUpdateWithWhereUniqueWithoutUserCreatedInput>>;
  updateMany?: InputMaybe<Array<CertificateTemplatePresetUpdateManyWithWhereWithoutUserCreatedInput>>;
  upsert?: InputMaybe<Array<CertificateTemplatePresetUpsertWithWhereUniqueWithoutUserCreatedInput>>;
};

export type CertificateTemplatePresetUpdateWithWhereUniqueWithoutUserCreatedInput = {
  data: CertificateTemplatePresetUpdateWithoutUserCreatedInput;
  where: CertificateTemplatePresetWhereUniqueInput;
};

export type CertificateTemplatePresetUpdateWithoutUserCreatedInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CertificateTemplatePresetUpsertWithWhereUniqueWithoutUserCreatedInput = {
  create: CertificateTemplatePresetCreateWithoutUserCreatedInput;
  update: CertificateTemplatePresetUpdateWithoutUserCreatedInput;
  where: CertificateTemplatePresetWhereUniqueInput;
};

export type CertificateTemplatePresetWhereInput = {
  AND?: InputMaybe<Array<CertificateTemplatePresetWhereInput>>;
  NOT?: InputMaybe<Array<CertificateTemplatePresetWhereInput>>;
  OR?: InputMaybe<Array<CertificateTemplatePresetWhereInput>>;
  UserCreated?: InputMaybe<CommonUserWhereInput>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<StringFilter>;
  imageUrl?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type CertificateTemplatePresetWhereUniqueInput = {
  AND?: InputMaybe<Array<CertificateTemplatePresetWhereInput>>;
  NOT?: InputMaybe<Array<CertificateTemplatePresetWhereInput>>;
  OR?: InputMaybe<Array<CertificateTemplatePresetWhereInput>>;
  UserCreated?: InputMaybe<CommonUserWhereInput>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export enum CertificateTemplateScalarFieldEnum {
  CommonUserId = 'commonUserId',
  CreatedAt = 'createdAt',
  Data = 'data',
  Description = 'description',
  EducationLevel = 'educationLevel',
  Id = 'id',
  Name = 'name',
  TeamId = 'teamId',
  UpdatedAt = 'updatedAt'
}

export type CertificateTemplateScalarWhereInput = {
  AND?: InputMaybe<Array<CertificateTemplateScalarWhereInput>>;
  NOT?: InputMaybe<Array<CertificateTemplateScalarWhereInput>>;
  OR?: InputMaybe<Array<CertificateTemplateScalarWhereInput>>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  description?: InputMaybe<StringNullableFilter>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type CertificateTemplateScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CertificateTemplateScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CertificateTemplateScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CertificateTemplateScalarWhereWithAggregatesInput>>;
  commonUserId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  data?: InputMaybe<JsonWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  teamId?: InputMaybe<IntWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type CertificateTemplateSumOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type CertificateTemplateUpdateInput = {
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateManyWithoutTemplateNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutCertificateTemplatesNestedInput>;
  TeamUsingAsPrimary?: InputMaybe<TeamUpdateOneWithoutDefaultDegreeCertificateTemplateNestedInput>;
  UserCreated?: InputMaybe<CommonUserUpdateOneRequiredWithoutCreatedCertificateTemplatesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CertificateTemplateUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CertificateTemplateUpdateManyWithWhereWithoutTeamInput = {
  data: CertificateTemplateUpdateManyMutationInput;
  where: CertificateTemplateScalarWhereInput;
};

export type CertificateTemplateUpdateManyWithWhereWithoutUserCreatedInput = {
  data: CertificateTemplateUpdateManyMutationInput;
  where: CertificateTemplateScalarWhereInput;
};

export type CertificateTemplateUpdateManyWithoutTeamNestedInput = {
  connect?: InputMaybe<Array<CertificateTemplateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CertificateTemplateCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<CertificateTemplateCreateWithoutTeamInput>>;
  createMany?: InputMaybe<CertificateTemplateCreateManyTeamInputEnvelope>;
  delete?: InputMaybe<Array<CertificateTemplateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CertificateTemplateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CertificateTemplateWhereUniqueInput>>;
  set?: InputMaybe<Array<CertificateTemplateWhereUniqueInput>>;
  update?: InputMaybe<Array<CertificateTemplateUpdateWithWhereUniqueWithoutTeamInput>>;
  updateMany?: InputMaybe<Array<CertificateTemplateUpdateManyWithWhereWithoutTeamInput>>;
  upsert?: InputMaybe<Array<CertificateTemplateUpsertWithWhereUniqueWithoutTeamInput>>;
};

export type CertificateTemplateUpdateManyWithoutUserCreatedNestedInput = {
  connect?: InputMaybe<Array<CertificateTemplateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CertificateTemplateCreateOrConnectWithoutUserCreatedInput>>;
  create?: InputMaybe<Array<CertificateTemplateCreateWithoutUserCreatedInput>>;
  createMany?: InputMaybe<CertificateTemplateCreateManyUserCreatedInputEnvelope>;
  delete?: InputMaybe<Array<CertificateTemplateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CertificateTemplateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CertificateTemplateWhereUniqueInput>>;
  set?: InputMaybe<Array<CertificateTemplateWhereUniqueInput>>;
  update?: InputMaybe<Array<CertificateTemplateUpdateWithWhereUniqueWithoutUserCreatedInput>>;
  updateMany?: InputMaybe<Array<CertificateTemplateUpdateManyWithWhereWithoutUserCreatedInput>>;
  upsert?: InputMaybe<Array<CertificateTemplateUpsertWithWhereUniqueWithoutUserCreatedInput>>;
};

export type CertificateTemplateUpdateOneWithoutDocumentCertificateNestedInput = {
  connect?: InputMaybe<CertificateTemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateTemplateCreateOrConnectWithoutDocumentCertificateInput>;
  create?: InputMaybe<CertificateTemplateCreateWithoutDocumentCertificateInput>;
  delete?: InputMaybe<CertificateTemplateWhereInput>;
  disconnect?: InputMaybe<CertificateTemplateWhereInput>;
  update?: InputMaybe<CertificateTemplateUpdateToOneWithWhereWithoutDocumentCertificateInput>;
  upsert?: InputMaybe<CertificateTemplateUpsertWithoutDocumentCertificateInput>;
};

export type CertificateTemplateUpdateOneWithoutTeamUsingAsPrimaryNestedInput = {
  connect?: InputMaybe<CertificateTemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CertificateTemplateCreateOrConnectWithoutTeamUsingAsPrimaryInput>;
  create?: InputMaybe<CertificateTemplateCreateWithoutTeamUsingAsPrimaryInput>;
  delete?: InputMaybe<CertificateTemplateWhereInput>;
  disconnect?: InputMaybe<CertificateTemplateWhereInput>;
  update?: InputMaybe<CertificateTemplateUpdateToOneWithWhereWithoutTeamUsingAsPrimaryInput>;
  upsert?: InputMaybe<CertificateTemplateUpsertWithoutTeamUsingAsPrimaryInput>;
};

export type CertificateTemplateUpdateToOneWithWhereWithoutDocumentCertificateInput = {
  data: CertificateTemplateUpdateWithoutDocumentCertificateInput;
  where?: InputMaybe<CertificateTemplateWhereInput>;
};

export type CertificateTemplateUpdateToOneWithWhereWithoutTeamUsingAsPrimaryInput = {
  data: CertificateTemplateUpdateWithoutTeamUsingAsPrimaryInput;
  where?: InputMaybe<CertificateTemplateWhereInput>;
};

export type CertificateTemplateUpdateWithWhereUniqueWithoutTeamInput = {
  data: CertificateTemplateUpdateWithoutTeamInput;
  where: CertificateTemplateWhereUniqueInput;
};

export type CertificateTemplateUpdateWithWhereUniqueWithoutUserCreatedInput = {
  data: CertificateTemplateUpdateWithoutUserCreatedInput;
  where: CertificateTemplateWhereUniqueInput;
};

export type CertificateTemplateUpdateWithoutDocumentCertificateInput = {
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutCertificateTemplatesNestedInput>;
  TeamUsingAsPrimary?: InputMaybe<TeamUpdateOneWithoutDefaultDegreeCertificateTemplateNestedInput>;
  UserCreated?: InputMaybe<CommonUserUpdateOneRequiredWithoutCreatedCertificateTemplatesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CertificateTemplateUpdateWithoutTeamInput = {
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateManyWithoutTemplateNestedInput>;
  TeamUsingAsPrimary?: InputMaybe<TeamUpdateOneWithoutDefaultDegreeCertificateTemplateNestedInput>;
  UserCreated?: InputMaybe<CommonUserUpdateOneRequiredWithoutCreatedCertificateTemplatesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CertificateTemplateUpdateWithoutTeamUsingAsPrimaryInput = {
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateManyWithoutTemplateNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutCertificateTemplatesNestedInput>;
  UserCreated?: InputMaybe<CommonUserUpdateOneRequiredWithoutCreatedCertificateTemplatesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CertificateTemplateUpdateWithoutUserCreatedInput = {
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateManyWithoutTemplateNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutCertificateTemplatesNestedInput>;
  TeamUsingAsPrimary?: InputMaybe<TeamUpdateOneWithoutDefaultDegreeCertificateTemplateNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CertificateTemplateUpsertWithWhereUniqueWithoutTeamInput = {
  create: CertificateTemplateCreateWithoutTeamInput;
  update: CertificateTemplateUpdateWithoutTeamInput;
  where: CertificateTemplateWhereUniqueInput;
};

export type CertificateTemplateUpsertWithWhereUniqueWithoutUserCreatedInput = {
  create: CertificateTemplateCreateWithoutUserCreatedInput;
  update: CertificateTemplateUpdateWithoutUserCreatedInput;
  where: CertificateTemplateWhereUniqueInput;
};

export type CertificateTemplateUpsertWithoutDocumentCertificateInput = {
  create: CertificateTemplateCreateWithoutDocumentCertificateInput;
  update: CertificateTemplateUpdateWithoutDocumentCertificateInput;
  where?: InputMaybe<CertificateTemplateWhereInput>;
};

export type CertificateTemplateUpsertWithoutTeamUsingAsPrimaryInput = {
  create: CertificateTemplateCreateWithoutTeamUsingAsPrimaryInput;
  update: CertificateTemplateUpdateWithoutTeamUsingAsPrimaryInput;
  where?: InputMaybe<CertificateTemplateWhereInput>;
};

export type CertificateTemplateWhereInput = {
  AND?: InputMaybe<Array<CertificateTemplateWhereInput>>;
  DocumentCertificate?: InputMaybe<DocumentCertificateListRelationFilter>;
  NOT?: InputMaybe<Array<CertificateTemplateWhereInput>>;
  OR?: InputMaybe<Array<CertificateTemplateWhereInput>>;
  Team?: InputMaybe<TeamWhereInput>;
  TeamUsingAsPrimary?: InputMaybe<TeamWhereInput>;
  UserCreated?: InputMaybe<CommonUserWhereInput>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  description?: InputMaybe<StringNullableFilter>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type CertificateTemplateWhereUniqueInput = {
  AND?: InputMaybe<Array<CertificateTemplateWhereInput>>;
  DocumentCertificate?: InputMaybe<DocumentCertificateListRelationFilter>;
  NOT?: InputMaybe<Array<CertificateTemplateWhereInput>>;
  OR?: InputMaybe<Array<CertificateTemplateWhereInput>>;
  Team?: InputMaybe<TeamWhereInput>;
  TeamUsingAsPrimary?: InputMaybe<TeamWhereInput>;
  UserCreated?: InputMaybe<CommonUserWhereInput>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  description?: InputMaybe<StringNullableFilter>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export enum CertificateTypes {
  Course = 'COURSE',
  CourseLevel = 'COURSE_LEVEL',
  Curriculum = 'CURRICULUM',
  Discipline = 'DISCIPLINE',
  Event = 'EVENT',
  Teacher = 'TEACHER'
}

export type CirriculumSelectedDiscipline = {
  amountOfHours?: InputMaybe<Scalars['Int']['input']>;
  disciplineId: Scalars['String']['input'];
  teacherId?: InputMaybe<Scalars['String']['input']>;
};

export type CommonUser = {
  __typename?: 'CommonUser';
  ApiKey: Array<ApiKey>;
  CertificateBase: Array<CertificateBase>;
  Charges: Array<FinancialCharge>;
  CreatedCertificateTemplatePresets: Array<CertificateTemplatePreset>;
  CreatedCertificateTemplates: Array<CertificateTemplate>;
  CreatedSignatureImages: Array<SignSignatureImage>;
  CreatedSubscriptions: Array<FinancialTeamWalletSubscription>;
  CreditCardSaveds: Array<FinancialCreditCardSaved>;
  DefaultImage?: Maybe<SignSignatureImage>;
  DocumentBase: Array<DocumentBase>;
  DocumentBaseHistory: Array<DocumentBaseHistory>;
  DocumentBaseSignatureInviteSignature: Array<DocumentBaseSignatureInviteSignature>;
  MaintainerAdmin?: Maybe<MaintainerAdmin>;
  Recharges: Array<FinancialRecharge>;
  ReusableFormDataCurriculumList: Array<ReusableFormDataCurriculum>;
  ReusableFormDatas: Array<ReusableFormData>;
  SystemAuditLogs: Array<SystemAuditLog>;
  SystemGlobalAlertUserDismisses: Array<SystemGlobalAlertUserDismiss>;
  SystemLog: Array<SystemLog>;
  Team: Team;
  TeamMember: Array<TeamMember>;
  TeamsCreated: Array<Team>;
  /** Notificações não fechadas e notificações 'fixadas' */
  UserAlerts: Array<SystemGlobalAlert>;
  UserConfigs: Array<CommonUserConfig>;
  computedResolvedAt: Scalars['String']['output'];
  /** From LedgerSign, if empty -> user was invited without logged yet */
  cpf?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  defaultSignatureImageId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  hasInvite: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  /** Id of the user created/authed at LedgerSign */
  idLedgerSign?: Maybe<Scalars['Int']['output']>;
  institutionCnpj?: Maybe<Scalars['String']['output']>;
  lastActivityAt: Scalars['DateTime']['output'];
  loggedAs?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions: Array<Scalars['String']['output']>;
  /** Photo without signUrl, from DOC, updated every login */
  photo?: Maybe<Scalars['String']['output']>;
  teamId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CommonUserApiKeyArgs = {
  cursor?: InputMaybe<ApiKeyWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApiKeyScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApiKeyOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ApiKeyWhereInput>;
};


export type CommonUserCertificateBaseArgs = {
  cursor?: InputMaybe<CertificateBaseWhereUniqueInput>;
  distinct?: InputMaybe<Array<CertificateBaseScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CertificateBaseOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CertificateBaseWhereInput>;
};


export type CommonUserChargesArgs = {
  cursor?: InputMaybe<FinancialChargeWhereUniqueInput>;
  distinct?: InputMaybe<Array<FinancialChargeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FinancialChargeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FinancialChargeWhereInput>;
};


export type CommonUserCreatedCertificateTemplatePresetsArgs = {
  cursor?: InputMaybe<CertificateTemplatePresetWhereUniqueInput>;
  distinct?: InputMaybe<Array<CertificateTemplatePresetScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CertificateTemplatePresetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CertificateTemplatePresetWhereInput>;
};


export type CommonUserCreatedCertificateTemplatesArgs = {
  cursor?: InputMaybe<CertificateTemplateWhereUniqueInput>;
  distinct?: InputMaybe<Array<CertificateTemplateScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CertificateTemplateOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CertificateTemplateWhereInput>;
};


export type CommonUserCreatedSignatureImagesArgs = {
  cursor?: InputMaybe<SignSignatureImageWhereUniqueInput>;
  distinct?: InputMaybe<Array<SignSignatureImageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SignSignatureImageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SignSignatureImageWhereInput>;
};


export type CommonUserCreatedSubscriptionsArgs = {
  cursor?: InputMaybe<FinancialTeamWalletSubscriptionWhereUniqueInput>;
  distinct?: InputMaybe<Array<FinancialTeamWalletSubscriptionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FinancialTeamWalletSubscriptionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FinancialTeamWalletSubscriptionWhereInput>;
};


export type CommonUserCreditCardSavedsArgs = {
  cursor?: InputMaybe<FinancialCreditCardSavedWhereUniqueInput>;
  distinct?: InputMaybe<Array<FinancialCreditCardSavedScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FinancialCreditCardSavedOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FinancialCreditCardSavedWhereInput>;
};


export type CommonUserDocumentBaseArgs = {
  cursor?: InputMaybe<DocumentBaseWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentBaseScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentBaseOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentBaseWhereInput>;
};


export type CommonUserDocumentBaseHistoryArgs = {
  cursor?: InputMaybe<DocumentBaseHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentBaseHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentBaseHistoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentBaseHistoryWhereInput>;
};


export type CommonUserDocumentBaseSignatureInviteSignatureArgs = {
  cursor?: InputMaybe<DocumentBaseSignatureInviteSignatureWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentBaseSignatureInviteSignatureWhereInput>;
};


export type CommonUserRechargesArgs = {
  cursor?: InputMaybe<FinancialRechargeWhereUniqueInput>;
  distinct?: InputMaybe<Array<FinancialRechargeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FinancialRechargeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FinancialRechargeWhereInput>;
};


export type CommonUserReusableFormDataCurriculumListArgs = {
  cursor?: InputMaybe<ReusableFormDataCurriculumWhereUniqueInput>;
  distinct?: InputMaybe<Array<ReusableFormDataCurriculumScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ReusableFormDataCurriculumOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReusableFormDataCurriculumWhereInput>;
};


export type CommonUserReusableFormDatasArgs = {
  cursor?: InputMaybe<ReusableFormDataWhereUniqueInput>;
  distinct?: InputMaybe<Array<ReusableFormDataScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ReusableFormDataOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReusableFormDataWhereInput>;
};


export type CommonUserSystemAuditLogsArgs = {
  cursor?: InputMaybe<SystemAuditLogWhereUniqueInput>;
  distinct?: InputMaybe<Array<SystemAuditLogScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SystemAuditLogOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SystemAuditLogWhereInput>;
};


export type CommonUserSystemGlobalAlertUserDismissesArgs = {
  cursor?: InputMaybe<SystemGlobalAlertUserDismissWhereUniqueInput>;
  distinct?: InputMaybe<Array<SystemGlobalAlertUserDismissScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SystemGlobalAlertUserDismissOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SystemGlobalAlertUserDismissWhereInput>;
};


export type CommonUserSystemLogArgs = {
  cursor?: InputMaybe<SystemLogWhereUniqueInput>;
  distinct?: InputMaybe<Array<SystemLogScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SystemLogOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SystemLogWhereInput>;
};


export type CommonUserTeamMemberArgs = {
  cursor?: InputMaybe<TeamMemberWhereUniqueInput>;
  distinct?: InputMaybe<Array<TeamMemberScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TeamMemberOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeamMemberWhereInput>;
};


export type CommonUserTeamsCreatedArgs = {
  cursor?: InputMaybe<TeamWhereUniqueInput>;
  distinct?: InputMaybe<Array<TeamScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TeamOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeamWhereInput>;
};


export type CommonUserUserConfigsArgs = {
  cursor?: InputMaybe<CommonUserConfigWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommonUserConfigScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommonUserConfigOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommonUserConfigWhereInput>;
};

export type CommonUserAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  idLedgerSign?: InputMaybe<SortOrder>;
};

/**
 * Created to store Onboarding Watched Videos
 * Ids are frontend generated, so there's no links to other tables
 */
export type CommonUserConfig = {
  __typename?: 'CommonUserConfig';
  CommonUser: CommonUser;
  commonUserId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ![PrismaJson.AnyJson] */
  value: Scalars['Json']['output'];
};

export type CommonUserConfigAvgOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
};

export type CommonUserConfigCommonUserIdKeyCompoundUniqueInput = {
  commonUserId: Scalars['Int']['input'];
  key: Scalars['String']['input'];
};

export type CommonUserConfigCountOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type CommonUserConfigCreateInput = {
  CommonUser: CommonUserCreateNestedOneWithoutUserConfigsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  key: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  value: Scalars['Json']['input'];
};

export type CommonUserConfigCreateManyCommonUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  key: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  value: Scalars['Json']['input'];
};

export type CommonUserConfigCreateManyCommonUserInputEnvelope = {
  data: Array<CommonUserConfigCreateManyCommonUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CommonUserConfigCreateManyInput = {
  commonUserId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  key: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  value: Scalars['Json']['input'];
};

export type CommonUserConfigCreateNestedManyWithoutCommonUserInput = {
  connect?: InputMaybe<Array<CommonUserConfigWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CommonUserConfigCreateOrConnectWithoutCommonUserInput>>;
  create?: InputMaybe<Array<CommonUserConfigCreateWithoutCommonUserInput>>;
  createMany?: InputMaybe<CommonUserConfigCreateManyCommonUserInputEnvelope>;
};

export type CommonUserConfigCreateOrConnectWithoutCommonUserInput = {
  create: CommonUserConfigCreateWithoutCommonUserInput;
  where: CommonUserConfigWhereUniqueInput;
};

export type CommonUserConfigCreateWithoutCommonUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  key: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  value: Scalars['Json']['input'];
};

export enum CommonUserConfigKeys {
  OnboardingProgress = 'onboardingProgress'
}

export type CommonUserConfigListRelationFilter = {
  every?: InputMaybe<CommonUserConfigWhereInput>;
  none?: InputMaybe<CommonUserConfigWhereInput>;
  some?: InputMaybe<CommonUserConfigWhereInput>;
};

export type CommonUserConfigMaxOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CommonUserConfigMinOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CommonUserConfigOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CommonUserConfigOrderByWithAggregationInput = {
  _avg?: InputMaybe<CommonUserConfigAvgOrderByAggregateInput>;
  _count?: InputMaybe<CommonUserConfigCountOrderByAggregateInput>;
  _max?: InputMaybe<CommonUserConfigMaxOrderByAggregateInput>;
  _min?: InputMaybe<CommonUserConfigMinOrderByAggregateInput>;
  _sum?: InputMaybe<CommonUserConfigSumOrderByAggregateInput>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type CommonUserConfigOrderByWithRelationInput = {
  CommonUser?: InputMaybe<CommonUserOrderByWithRelationInput>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export enum CommonUserConfigScalarFieldEnum {
  CommonUserId = 'commonUserId',
  CreatedAt = 'createdAt',
  Key = 'key',
  UpdatedAt = 'updatedAt',
  Value = 'value'
}

export type CommonUserConfigScalarWhereInput = {
  AND?: InputMaybe<Array<CommonUserConfigScalarWhereInput>>;
  NOT?: InputMaybe<Array<CommonUserConfigScalarWhereInput>>;
  OR?: InputMaybe<Array<CommonUserConfigScalarWhereInput>>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  key?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  value?: InputMaybe<JsonFilter>;
};

export type CommonUserConfigScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CommonUserConfigScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CommonUserConfigScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CommonUserConfigScalarWhereWithAggregatesInput>>;
  commonUserId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  key?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  value?: InputMaybe<JsonWithAggregatesFilter>;
};

export type CommonUserConfigSumOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
};

export type CommonUserConfigUpdateInput = {
  CommonUser?: InputMaybe<CommonUserUpdateOneRequiredWithoutUserConfigsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  value?: InputMaybe<Scalars['Json']['input']>;
};

export type CommonUserConfigUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  value?: InputMaybe<Scalars['Json']['input']>;
};

export type CommonUserConfigUpdateManyWithWhereWithoutCommonUserInput = {
  data: CommonUserConfigUpdateManyMutationInput;
  where: CommonUserConfigScalarWhereInput;
};

export type CommonUserConfigUpdateManyWithoutCommonUserNestedInput = {
  connect?: InputMaybe<Array<CommonUserConfigWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CommonUserConfigCreateOrConnectWithoutCommonUserInput>>;
  create?: InputMaybe<Array<CommonUserConfigCreateWithoutCommonUserInput>>;
  createMany?: InputMaybe<CommonUserConfigCreateManyCommonUserInputEnvelope>;
  delete?: InputMaybe<Array<CommonUserConfigWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CommonUserConfigScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CommonUserConfigWhereUniqueInput>>;
  set?: InputMaybe<Array<CommonUserConfigWhereUniqueInput>>;
  update?: InputMaybe<Array<CommonUserConfigUpdateWithWhereUniqueWithoutCommonUserInput>>;
  updateMany?: InputMaybe<Array<CommonUserConfigUpdateManyWithWhereWithoutCommonUserInput>>;
  upsert?: InputMaybe<Array<CommonUserConfigUpsertWithWhereUniqueWithoutCommonUserInput>>;
};

export type CommonUserConfigUpdateWithWhereUniqueWithoutCommonUserInput = {
  data: CommonUserConfigUpdateWithoutCommonUserInput;
  where: CommonUserConfigWhereUniqueInput;
};

export type CommonUserConfigUpdateWithoutCommonUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  value?: InputMaybe<Scalars['Json']['input']>;
};

export type CommonUserConfigUpsertWithWhereUniqueWithoutCommonUserInput = {
  create: CommonUserConfigCreateWithoutCommonUserInput;
  update: CommonUserConfigUpdateWithoutCommonUserInput;
  where: CommonUserConfigWhereUniqueInput;
};

export type CommonUserConfigWhereInput = {
  AND?: InputMaybe<Array<CommonUserConfigWhereInput>>;
  CommonUser?: InputMaybe<CommonUserWhereInput>;
  NOT?: InputMaybe<Array<CommonUserConfigWhereInput>>;
  OR?: InputMaybe<Array<CommonUserConfigWhereInput>>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  key?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  value?: InputMaybe<JsonFilter>;
};

export type CommonUserConfigWhereUniqueInput = {
  AND?: InputMaybe<Array<CommonUserConfigWhereInput>>;
  CommonUser?: InputMaybe<CommonUserWhereInput>;
  NOT?: InputMaybe<Array<CommonUserConfigWhereInput>>;
  OR?: InputMaybe<Array<CommonUserConfigWhereInput>>;
  commonUserId?: InputMaybe<IntFilter>;
  commonUserId_key?: InputMaybe<CommonUserConfigCommonUserIdKeyCompoundUniqueInput>;
  createdAt?: InputMaybe<DateTimeFilter>;
  key?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  value?: InputMaybe<JsonFilter>;
};

export type CommonUserCountOrderByAggregateInput = {
  cpf?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  defaultSignatureImageId?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  idLedgerSign?: InputMaybe<SortOrder>;
  lastActivityAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  photo?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CommonUserCreateInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetCreateNestedManyWithoutUserCreatedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: InputMaybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: InputMaybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: InputMaybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: InputMaybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: InputMaybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  idLedgerSign?: InputMaybe<Scalars['Int']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonUserCreateManyInput = {
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  defaultSignatureImageId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  idLedgerSign?: InputMaybe<Scalars['Int']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonUserCreateNestedOneWithoutApiKeyInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutApiKeyInput>;
  create?: InputMaybe<CommonUserCreateWithoutApiKeyInput>;
};

export type CommonUserCreateNestedOneWithoutCertificateBaseInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutCertificateBaseInput>;
  create?: InputMaybe<CommonUserCreateWithoutCertificateBaseInput>;
};

export type CommonUserCreateNestedOneWithoutChargesInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutChargesInput>;
  create?: InputMaybe<CommonUserCreateWithoutChargesInput>;
};

export type CommonUserCreateNestedOneWithoutCreatedCertificateTemplatePresetsInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutCreatedCertificateTemplatePresetsInput>;
  create?: InputMaybe<CommonUserCreateWithoutCreatedCertificateTemplatePresetsInput>;
};

export type CommonUserCreateNestedOneWithoutCreatedCertificateTemplatesInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutCreatedCertificateTemplatesInput>;
  create?: InputMaybe<CommonUserCreateWithoutCreatedCertificateTemplatesInput>;
};

export type CommonUserCreateNestedOneWithoutCreatedSignatureImagesInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutCreatedSignatureImagesInput>;
  create?: InputMaybe<CommonUserCreateWithoutCreatedSignatureImagesInput>;
};

export type CommonUserCreateNestedOneWithoutCreatedSubscriptionsInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutCreatedSubscriptionsInput>;
  create?: InputMaybe<CommonUserCreateWithoutCreatedSubscriptionsInput>;
};

export type CommonUserCreateNestedOneWithoutCreditCardSavedsInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutCreditCardSavedsInput>;
  create?: InputMaybe<CommonUserCreateWithoutCreditCardSavedsInput>;
};

export type CommonUserCreateNestedOneWithoutDefaultImageInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutDefaultImageInput>;
  create?: InputMaybe<CommonUserCreateWithoutDefaultImageInput>;
};

export type CommonUserCreateNestedOneWithoutDocumentBaseHistoryInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutDocumentBaseHistoryInput>;
  create?: InputMaybe<CommonUserCreateWithoutDocumentBaseHistoryInput>;
};

export type CommonUserCreateNestedOneWithoutDocumentBaseInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutDocumentBaseInput>;
  create?: InputMaybe<CommonUserCreateWithoutDocumentBaseInput>;
};

export type CommonUserCreateNestedOneWithoutDocumentBaseSignatureInviteSignatureInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutDocumentBaseSignatureInviteSignatureInput>;
  create?: InputMaybe<CommonUserCreateWithoutDocumentBaseSignatureInviteSignatureInput>;
};

export type CommonUserCreateNestedOneWithoutMaintainerAdminInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutMaintainerAdminInput>;
  create?: InputMaybe<CommonUserCreateWithoutMaintainerAdminInput>;
};

export type CommonUserCreateNestedOneWithoutRechargesInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutRechargesInput>;
  create?: InputMaybe<CommonUserCreateWithoutRechargesInput>;
};

export type CommonUserCreateNestedOneWithoutReusableFormDataCurriculumListInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutReusableFormDataCurriculumListInput>;
  create?: InputMaybe<CommonUserCreateWithoutReusableFormDataCurriculumListInput>;
};

export type CommonUserCreateNestedOneWithoutReusableFormDatasInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutReusableFormDatasInput>;
  create?: InputMaybe<CommonUserCreateWithoutReusableFormDatasInput>;
};

export type CommonUserCreateNestedOneWithoutSystemAuditLogsInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutSystemAuditLogsInput>;
  create?: InputMaybe<CommonUserCreateWithoutSystemAuditLogsInput>;
};

export type CommonUserCreateNestedOneWithoutSystemGlobalAlertUserDismissesInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutSystemGlobalAlertUserDismissesInput>;
  create?: InputMaybe<CommonUserCreateWithoutSystemGlobalAlertUserDismissesInput>;
};

export type CommonUserCreateNestedOneWithoutSystemLogInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutSystemLogInput>;
  create?: InputMaybe<CommonUserCreateWithoutSystemLogInput>;
};

export type CommonUserCreateNestedOneWithoutTeamMemberInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutTeamMemberInput>;
  create?: InputMaybe<CommonUserCreateWithoutTeamMemberInput>;
};

export type CommonUserCreateNestedOneWithoutTeamsCreatedInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutTeamsCreatedInput>;
  create?: InputMaybe<CommonUserCreateWithoutTeamsCreatedInput>;
};

export type CommonUserCreateNestedOneWithoutUserConfigsInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutUserConfigsInput>;
  create?: InputMaybe<CommonUserCreateWithoutUserConfigsInput>;
};

export type CommonUserCreateOrConnectWithoutApiKeyInput = {
  create: CommonUserCreateWithoutApiKeyInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutCertificateBaseInput = {
  create: CommonUserCreateWithoutCertificateBaseInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutChargesInput = {
  create: CommonUserCreateWithoutChargesInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutCreatedCertificateTemplatePresetsInput = {
  create: CommonUserCreateWithoutCreatedCertificateTemplatePresetsInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutCreatedCertificateTemplatesInput = {
  create: CommonUserCreateWithoutCreatedCertificateTemplatesInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutCreatedSignatureImagesInput = {
  create: CommonUserCreateWithoutCreatedSignatureImagesInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutCreatedSubscriptionsInput = {
  create: CommonUserCreateWithoutCreatedSubscriptionsInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutCreditCardSavedsInput = {
  create: CommonUserCreateWithoutCreditCardSavedsInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutDefaultImageInput = {
  create: CommonUserCreateWithoutDefaultImageInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutDocumentBaseHistoryInput = {
  create: CommonUserCreateWithoutDocumentBaseHistoryInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutDocumentBaseInput = {
  create: CommonUserCreateWithoutDocumentBaseInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutDocumentBaseSignatureInviteSignatureInput = {
  create: CommonUserCreateWithoutDocumentBaseSignatureInviteSignatureInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutMaintainerAdminInput = {
  create: CommonUserCreateWithoutMaintainerAdminInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutRechargesInput = {
  create: CommonUserCreateWithoutRechargesInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutReusableFormDataCurriculumListInput = {
  create: CommonUserCreateWithoutReusableFormDataCurriculumListInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutReusableFormDatasInput = {
  create: CommonUserCreateWithoutReusableFormDatasInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutSystemAuditLogsInput = {
  create: CommonUserCreateWithoutSystemAuditLogsInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutSystemGlobalAlertUserDismissesInput = {
  create: CommonUserCreateWithoutSystemGlobalAlertUserDismissesInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutSystemLogInput = {
  create: CommonUserCreateWithoutSystemLogInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutTeamMemberInput = {
  create: CommonUserCreateWithoutTeamMemberInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutTeamsCreatedInput = {
  create: CommonUserCreateWithoutTeamsCreatedInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateOrConnectWithoutUserConfigsInput = {
  create: CommonUserCreateWithoutUserConfigsInput;
  where: CommonUserWhereUniqueInput;
};

export type CommonUserCreateWithoutApiKeyInput = {
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetCreateNestedManyWithoutUserCreatedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: InputMaybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: InputMaybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: InputMaybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: InputMaybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: InputMaybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  idLedgerSign?: InputMaybe<Scalars['Int']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonUserCreateWithoutCertificateBaseInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetCreateNestedManyWithoutUserCreatedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: InputMaybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: InputMaybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: InputMaybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: InputMaybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: InputMaybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  idLedgerSign?: InputMaybe<Scalars['Int']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonUserCreateWithoutChargesInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetCreateNestedManyWithoutUserCreatedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: InputMaybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: InputMaybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: InputMaybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: InputMaybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: InputMaybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  idLedgerSign?: InputMaybe<Scalars['Int']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonUserCreateWithoutCreatedCertificateTemplatePresetsInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: InputMaybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: InputMaybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: InputMaybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: InputMaybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: InputMaybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  idLedgerSign?: InputMaybe<Scalars['Int']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonUserCreateWithoutCreatedCertificateTemplatesInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: InputMaybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: InputMaybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: InputMaybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: InputMaybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: InputMaybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  idLedgerSign?: InputMaybe<Scalars['Int']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonUserCreateWithoutCreatedSignatureImagesInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetCreateNestedManyWithoutUserCreatedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: InputMaybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: InputMaybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: InputMaybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: InputMaybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: InputMaybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  idLedgerSign?: InputMaybe<Scalars['Int']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonUserCreateWithoutCreatedSubscriptionsInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetCreateNestedManyWithoutUserCreatedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: InputMaybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: InputMaybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: InputMaybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: InputMaybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: InputMaybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  idLedgerSign?: InputMaybe<Scalars['Int']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonUserCreateWithoutCreditCardSavedsInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetCreateNestedManyWithoutUserCreatedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: InputMaybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: InputMaybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: InputMaybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: InputMaybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: InputMaybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  idLedgerSign?: InputMaybe<Scalars['Int']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonUserCreateWithoutDefaultImageInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetCreateNestedManyWithoutUserCreatedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DocumentBase?: InputMaybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: InputMaybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: InputMaybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: InputMaybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: InputMaybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  idLedgerSign?: InputMaybe<Scalars['Int']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonUserCreateWithoutDocumentBaseHistoryInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetCreateNestedManyWithoutUserCreatedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: InputMaybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: InputMaybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: InputMaybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: InputMaybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: InputMaybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  idLedgerSign?: InputMaybe<Scalars['Int']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonUserCreateWithoutDocumentBaseInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetCreateNestedManyWithoutUserCreatedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: InputMaybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: InputMaybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: InputMaybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: InputMaybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  idLedgerSign?: InputMaybe<Scalars['Int']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonUserCreateWithoutDocumentBaseSignatureInviteSignatureInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetCreateNestedManyWithoutUserCreatedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: InputMaybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: InputMaybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: InputMaybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: InputMaybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: InputMaybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  idLedgerSign?: InputMaybe<Scalars['Int']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonUserCreateWithoutMaintainerAdminInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetCreateNestedManyWithoutUserCreatedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: InputMaybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  Recharges?: InputMaybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: InputMaybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: InputMaybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: InputMaybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  idLedgerSign?: InputMaybe<Scalars['Int']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonUserCreateWithoutRechargesInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetCreateNestedManyWithoutUserCreatedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: InputMaybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: InputMaybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: InputMaybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: InputMaybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  idLedgerSign?: InputMaybe<Scalars['Int']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonUserCreateWithoutReusableFormDataCurriculumListInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetCreateNestedManyWithoutUserCreatedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: InputMaybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: InputMaybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: InputMaybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: InputMaybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: InputMaybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  idLedgerSign?: InputMaybe<Scalars['Int']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonUserCreateWithoutReusableFormDatasInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetCreateNestedManyWithoutUserCreatedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: InputMaybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: InputMaybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: InputMaybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: InputMaybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: InputMaybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  idLedgerSign?: InputMaybe<Scalars['Int']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonUserCreateWithoutSystemAuditLogsInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetCreateNestedManyWithoutUserCreatedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: InputMaybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: InputMaybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: InputMaybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: InputMaybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: InputMaybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  idLedgerSign?: InputMaybe<Scalars['Int']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonUserCreateWithoutSystemGlobalAlertUserDismissesInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetCreateNestedManyWithoutUserCreatedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: InputMaybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: InputMaybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemLog?: InputMaybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: InputMaybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: InputMaybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  idLedgerSign?: InputMaybe<Scalars['Int']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonUserCreateWithoutSystemLogInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetCreateNestedManyWithoutUserCreatedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: InputMaybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: InputMaybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: InputMaybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: InputMaybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  idLedgerSign?: InputMaybe<Scalars['Int']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonUserCreateWithoutTeamMemberInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetCreateNestedManyWithoutUserCreatedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: InputMaybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: InputMaybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: InputMaybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamsCreated?: InputMaybe<TeamCreateNestedManyWithoutOwnerInput>;
  UserConfigs?: InputMaybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  idLedgerSign?: InputMaybe<Scalars['Int']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonUserCreateWithoutTeamsCreatedInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetCreateNestedManyWithoutUserCreatedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: InputMaybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: InputMaybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: InputMaybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutUserInput>;
  UserConfigs?: InputMaybe<CommonUserConfigCreateNestedManyWithoutCommonUserInput>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  idLedgerSign?: InputMaybe<Scalars['Int']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonUserCreateWithoutUserConfigsInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutUserInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutUserOwnerInput>;
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutUserExecutedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetCreateNestedManyWithoutUserCreatedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutUserCreatedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageCreateNestedManyWithoutUserCreatedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput>;
  DocumentBase?: InputMaybe<DocumentBaseCreateNestedManyWithoutUserOwnerInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminCreateNestedOneWithoutUserInput>;
  Recharges?: InputMaybe<FinancialRechargeCreateNestedManyWithoutUserExecutedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataCreateNestedManyWithoutUserOwnerInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutUserInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput>;
  SystemLog?: InputMaybe<SystemLogCreateNestedManyWithoutUserInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutUserInput>;
  TeamsCreated?: InputMaybe<TeamCreateNestedManyWithoutOwnerInput>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  idLedgerSign?: InputMaybe<Scalars['Int']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommonUserMaxOrderByAggregateInput = {
  cpf?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  defaultSignatureImageId?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  idLedgerSign?: InputMaybe<SortOrder>;
  lastActivityAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  photo?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CommonUserMinOrderByAggregateInput = {
  cpf?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  defaultSignatureImageId?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  idLedgerSign?: InputMaybe<SortOrder>;
  lastActivityAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  photo?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CommonUserNullableRelationFilter = {
  is?: InputMaybe<CommonUserWhereInput>;
  isNot?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserOrderByWithAggregationInput = {
  _avg?: InputMaybe<CommonUserAvgOrderByAggregateInput>;
  _count?: InputMaybe<CommonUserCountOrderByAggregateInput>;
  _max?: InputMaybe<CommonUserMaxOrderByAggregateInput>;
  _min?: InputMaybe<CommonUserMinOrderByAggregateInput>;
  _sum?: InputMaybe<CommonUserSumOrderByAggregateInput>;
  cpf?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  defaultSignatureImageId?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  idLedgerSign?: InputMaybe<SortOrder>;
  lastActivityAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  photo?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CommonUserOrderByWithRelationInput = {
  ApiKey?: InputMaybe<ApiKeyOrderByRelationAggregateInput>;
  CertificateBase?: InputMaybe<CertificateBaseOrderByRelationAggregateInput>;
  Charges?: InputMaybe<FinancialChargeOrderByRelationAggregateInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetOrderByRelationAggregateInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateOrderByRelationAggregateInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageOrderByRelationAggregateInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionOrderByRelationAggregateInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedOrderByRelationAggregateInput>;
  DefaultImage?: InputMaybe<SignSignatureImageOrderByWithRelationInput>;
  DocumentBase?: InputMaybe<DocumentBaseOrderByRelationAggregateInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryOrderByRelationAggregateInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureOrderByRelationAggregateInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminOrderByWithRelationInput>;
  Recharges?: InputMaybe<FinancialRechargeOrderByRelationAggregateInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumOrderByRelationAggregateInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataOrderByRelationAggregateInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogOrderByRelationAggregateInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissOrderByRelationAggregateInput>;
  SystemLog?: InputMaybe<SystemLogOrderByRelationAggregateInput>;
  TeamMember?: InputMaybe<TeamMemberOrderByRelationAggregateInput>;
  TeamsCreated?: InputMaybe<TeamOrderByRelationAggregateInput>;
  UserConfigs?: InputMaybe<CommonUserConfigOrderByRelationAggregateInput>;
  cpf?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  defaultSignatureImageId?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  idLedgerSign?: InputMaybe<SortOrder>;
  lastActivityAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  photo?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CommonUserRelationFilter = {
  is?: InputMaybe<CommonUserWhereInput>;
  isNot?: InputMaybe<CommonUserWhereInput>;
};

export enum CommonUserScalarFieldEnum {
  Cpf = 'cpf',
  CreatedAt = 'createdAt',
  DefaultSignatureImageId = 'defaultSignatureImageId',
  Email = 'email',
  Id = 'id',
  IdLedgerSign = 'idLedgerSign',
  LastActivityAt = 'lastActivityAt',
  Name = 'name',
  Photo = 'photo',
  UpdatedAt = 'updatedAt'
}

export type CommonUserScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CommonUserScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CommonUserScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CommonUserScalarWhereWithAggregatesInput>>;
  cpf?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  defaultSignatureImageId?: InputMaybe<StringNullableWithAggregatesFilter>;
  email?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  idLedgerSign?: InputMaybe<IntNullableWithAggregatesFilter>;
  lastActivityAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  name?: InputMaybe<StringNullableWithAggregatesFilter>;
  photo?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type CommonUserSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  idLedgerSign?: InputMaybe<SortOrder>;
};

export type CommonUserUpdateInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetUpdateManyWithoutUserCreatedNestedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: InputMaybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: InputMaybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: InputMaybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: InputMaybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  photo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateManyMutationInput = {
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  photo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateOneRequiredWithoutApiKeyNestedInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutApiKeyInput>;
  create?: InputMaybe<CommonUserCreateWithoutApiKeyInput>;
  update?: InputMaybe<CommonUserUpdateToOneWithWhereWithoutApiKeyInput>;
  upsert?: InputMaybe<CommonUserUpsertWithoutApiKeyInput>;
};

export type CommonUserUpdateOneRequiredWithoutCertificateBaseNestedInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutCertificateBaseInput>;
  create?: InputMaybe<CommonUserCreateWithoutCertificateBaseInput>;
  update?: InputMaybe<CommonUserUpdateToOneWithWhereWithoutCertificateBaseInput>;
  upsert?: InputMaybe<CommonUserUpsertWithoutCertificateBaseInput>;
};

export type CommonUserUpdateOneRequiredWithoutChargesNestedInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutChargesInput>;
  create?: InputMaybe<CommonUserCreateWithoutChargesInput>;
  update?: InputMaybe<CommonUserUpdateToOneWithWhereWithoutChargesInput>;
  upsert?: InputMaybe<CommonUserUpsertWithoutChargesInput>;
};

export type CommonUserUpdateOneRequiredWithoutCreatedCertificateTemplatePresetsNestedInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutCreatedCertificateTemplatePresetsInput>;
  create?: InputMaybe<CommonUserCreateWithoutCreatedCertificateTemplatePresetsInput>;
  update?: InputMaybe<CommonUserUpdateToOneWithWhereWithoutCreatedCertificateTemplatePresetsInput>;
  upsert?: InputMaybe<CommonUserUpsertWithoutCreatedCertificateTemplatePresetsInput>;
};

export type CommonUserUpdateOneRequiredWithoutCreatedCertificateTemplatesNestedInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutCreatedCertificateTemplatesInput>;
  create?: InputMaybe<CommonUserCreateWithoutCreatedCertificateTemplatesInput>;
  update?: InputMaybe<CommonUserUpdateToOneWithWhereWithoutCreatedCertificateTemplatesInput>;
  upsert?: InputMaybe<CommonUserUpsertWithoutCreatedCertificateTemplatesInput>;
};

export type CommonUserUpdateOneRequiredWithoutCreatedSignatureImagesNestedInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutCreatedSignatureImagesInput>;
  create?: InputMaybe<CommonUserCreateWithoutCreatedSignatureImagesInput>;
  update?: InputMaybe<CommonUserUpdateToOneWithWhereWithoutCreatedSignatureImagesInput>;
  upsert?: InputMaybe<CommonUserUpsertWithoutCreatedSignatureImagesInput>;
};

export type CommonUserUpdateOneRequiredWithoutCreatedSubscriptionsNestedInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutCreatedSubscriptionsInput>;
  create?: InputMaybe<CommonUserCreateWithoutCreatedSubscriptionsInput>;
  update?: InputMaybe<CommonUserUpdateToOneWithWhereWithoutCreatedSubscriptionsInput>;
  upsert?: InputMaybe<CommonUserUpsertWithoutCreatedSubscriptionsInput>;
};

export type CommonUserUpdateOneRequiredWithoutCreditCardSavedsNestedInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutCreditCardSavedsInput>;
  create?: InputMaybe<CommonUserCreateWithoutCreditCardSavedsInput>;
  update?: InputMaybe<CommonUserUpdateToOneWithWhereWithoutCreditCardSavedsInput>;
  upsert?: InputMaybe<CommonUserUpsertWithoutCreditCardSavedsInput>;
};

export type CommonUserUpdateOneRequiredWithoutDocumentBaseNestedInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutDocumentBaseInput>;
  create?: InputMaybe<CommonUserCreateWithoutDocumentBaseInput>;
  update?: InputMaybe<CommonUserUpdateToOneWithWhereWithoutDocumentBaseInput>;
  upsert?: InputMaybe<CommonUserUpsertWithoutDocumentBaseInput>;
};

export type CommonUserUpdateOneRequiredWithoutDocumentBaseSignatureInviteSignatureNestedInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutDocumentBaseSignatureInviteSignatureInput>;
  create?: InputMaybe<CommonUserCreateWithoutDocumentBaseSignatureInviteSignatureInput>;
  update?: InputMaybe<CommonUserUpdateToOneWithWhereWithoutDocumentBaseSignatureInviteSignatureInput>;
  upsert?: InputMaybe<CommonUserUpsertWithoutDocumentBaseSignatureInviteSignatureInput>;
};

export type CommonUserUpdateOneRequiredWithoutMaintainerAdminNestedInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutMaintainerAdminInput>;
  create?: InputMaybe<CommonUserCreateWithoutMaintainerAdminInput>;
  update?: InputMaybe<CommonUserUpdateToOneWithWhereWithoutMaintainerAdminInput>;
  upsert?: InputMaybe<CommonUserUpsertWithoutMaintainerAdminInput>;
};

export type CommonUserUpdateOneRequiredWithoutRechargesNestedInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutRechargesInput>;
  create?: InputMaybe<CommonUserCreateWithoutRechargesInput>;
  update?: InputMaybe<CommonUserUpdateToOneWithWhereWithoutRechargesInput>;
  upsert?: InputMaybe<CommonUserUpsertWithoutRechargesInput>;
};

export type CommonUserUpdateOneRequiredWithoutReusableFormDataCurriculumListNestedInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutReusableFormDataCurriculumListInput>;
  create?: InputMaybe<CommonUserCreateWithoutReusableFormDataCurriculumListInput>;
  update?: InputMaybe<CommonUserUpdateToOneWithWhereWithoutReusableFormDataCurriculumListInput>;
  upsert?: InputMaybe<CommonUserUpsertWithoutReusableFormDataCurriculumListInput>;
};

export type CommonUserUpdateOneRequiredWithoutReusableFormDatasNestedInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutReusableFormDatasInput>;
  create?: InputMaybe<CommonUserCreateWithoutReusableFormDatasInput>;
  update?: InputMaybe<CommonUserUpdateToOneWithWhereWithoutReusableFormDatasInput>;
  upsert?: InputMaybe<CommonUserUpsertWithoutReusableFormDatasInput>;
};

export type CommonUserUpdateOneRequiredWithoutSystemGlobalAlertUserDismissesNestedInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutSystemGlobalAlertUserDismissesInput>;
  create?: InputMaybe<CommonUserCreateWithoutSystemGlobalAlertUserDismissesInput>;
  update?: InputMaybe<CommonUserUpdateToOneWithWhereWithoutSystemGlobalAlertUserDismissesInput>;
  upsert?: InputMaybe<CommonUserUpsertWithoutSystemGlobalAlertUserDismissesInput>;
};

export type CommonUserUpdateOneRequiredWithoutTeamMemberNestedInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutTeamMemberInput>;
  create?: InputMaybe<CommonUserCreateWithoutTeamMemberInput>;
  update?: InputMaybe<CommonUserUpdateToOneWithWhereWithoutTeamMemberInput>;
  upsert?: InputMaybe<CommonUserUpsertWithoutTeamMemberInput>;
};

export type CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutTeamsCreatedInput>;
  create?: InputMaybe<CommonUserCreateWithoutTeamsCreatedInput>;
  update?: InputMaybe<CommonUserUpdateToOneWithWhereWithoutTeamsCreatedInput>;
  upsert?: InputMaybe<CommonUserUpsertWithoutTeamsCreatedInput>;
};

export type CommonUserUpdateOneRequiredWithoutUserConfigsNestedInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutUserConfigsInput>;
  create?: InputMaybe<CommonUserCreateWithoutUserConfigsInput>;
  update?: InputMaybe<CommonUserUpdateToOneWithWhereWithoutUserConfigsInput>;
  upsert?: InputMaybe<CommonUserUpsertWithoutUserConfigsInput>;
};

export type CommonUserUpdateOneWithoutDefaultImageNestedInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutDefaultImageInput>;
  create?: InputMaybe<CommonUserCreateWithoutDefaultImageInput>;
  delete?: InputMaybe<CommonUserWhereInput>;
  disconnect?: InputMaybe<CommonUserWhereInput>;
  update?: InputMaybe<CommonUserUpdateToOneWithWhereWithoutDefaultImageInput>;
  upsert?: InputMaybe<CommonUserUpsertWithoutDefaultImageInput>;
};

export type CommonUserUpdateOneWithoutDocumentBaseHistoryNestedInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutDocumentBaseHistoryInput>;
  create?: InputMaybe<CommonUserCreateWithoutDocumentBaseHistoryInput>;
  delete?: InputMaybe<CommonUserWhereInput>;
  disconnect?: InputMaybe<CommonUserWhereInput>;
  update?: InputMaybe<CommonUserUpdateToOneWithWhereWithoutDocumentBaseHistoryInput>;
  upsert?: InputMaybe<CommonUserUpsertWithoutDocumentBaseHistoryInput>;
};

export type CommonUserUpdateOneWithoutSystemAuditLogsNestedInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutSystemAuditLogsInput>;
  create?: InputMaybe<CommonUserCreateWithoutSystemAuditLogsInput>;
  delete?: InputMaybe<CommonUserWhereInput>;
  disconnect?: InputMaybe<CommonUserWhereInput>;
  update?: InputMaybe<CommonUserUpdateToOneWithWhereWithoutSystemAuditLogsInput>;
  upsert?: InputMaybe<CommonUserUpsertWithoutSystemAuditLogsInput>;
};

export type CommonUserUpdateOneWithoutSystemLogNestedInput = {
  connect?: InputMaybe<CommonUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommonUserCreateOrConnectWithoutSystemLogInput>;
  create?: InputMaybe<CommonUserCreateWithoutSystemLogInput>;
  delete?: InputMaybe<CommonUserWhereInput>;
  disconnect?: InputMaybe<CommonUserWhereInput>;
  update?: InputMaybe<CommonUserUpdateToOneWithWhereWithoutSystemLogInput>;
  upsert?: InputMaybe<CommonUserUpsertWithoutSystemLogInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutApiKeyInput = {
  data: CommonUserUpdateWithoutApiKeyInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutCertificateBaseInput = {
  data: CommonUserUpdateWithoutCertificateBaseInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutChargesInput = {
  data: CommonUserUpdateWithoutChargesInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutCreatedCertificateTemplatePresetsInput = {
  data: CommonUserUpdateWithoutCreatedCertificateTemplatePresetsInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutCreatedCertificateTemplatesInput = {
  data: CommonUserUpdateWithoutCreatedCertificateTemplatesInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutCreatedSignatureImagesInput = {
  data: CommonUserUpdateWithoutCreatedSignatureImagesInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutCreatedSubscriptionsInput = {
  data: CommonUserUpdateWithoutCreatedSubscriptionsInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutCreditCardSavedsInput = {
  data: CommonUserUpdateWithoutCreditCardSavedsInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutDefaultImageInput = {
  data: CommonUserUpdateWithoutDefaultImageInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutDocumentBaseHistoryInput = {
  data: CommonUserUpdateWithoutDocumentBaseHistoryInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutDocumentBaseInput = {
  data: CommonUserUpdateWithoutDocumentBaseInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutDocumentBaseSignatureInviteSignatureInput = {
  data: CommonUserUpdateWithoutDocumentBaseSignatureInviteSignatureInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutMaintainerAdminInput = {
  data: CommonUserUpdateWithoutMaintainerAdminInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutRechargesInput = {
  data: CommonUserUpdateWithoutRechargesInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutReusableFormDataCurriculumListInput = {
  data: CommonUserUpdateWithoutReusableFormDataCurriculumListInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutReusableFormDatasInput = {
  data: CommonUserUpdateWithoutReusableFormDatasInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutSystemAuditLogsInput = {
  data: CommonUserUpdateWithoutSystemAuditLogsInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutSystemGlobalAlertUserDismissesInput = {
  data: CommonUserUpdateWithoutSystemGlobalAlertUserDismissesInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutSystemLogInput = {
  data: CommonUserUpdateWithoutSystemLogInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutTeamMemberInput = {
  data: CommonUserUpdateWithoutTeamMemberInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutTeamsCreatedInput = {
  data: CommonUserUpdateWithoutTeamsCreatedInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpdateToOneWithWhereWithoutUserConfigsInput = {
  data: CommonUserUpdateWithoutUserConfigsInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpdateWithoutApiKeyInput = {
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetUpdateManyWithoutUserCreatedNestedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: InputMaybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: InputMaybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: InputMaybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: InputMaybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  photo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutCertificateBaseInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetUpdateManyWithoutUserCreatedNestedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: InputMaybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: InputMaybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: InputMaybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: InputMaybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  photo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutChargesInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetUpdateManyWithoutUserCreatedNestedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: InputMaybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: InputMaybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: InputMaybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: InputMaybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  photo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutCreatedCertificateTemplatePresetsInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: InputMaybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: InputMaybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: InputMaybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: InputMaybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  photo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutCreatedCertificateTemplatesInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: InputMaybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: InputMaybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: InputMaybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: InputMaybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  photo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutCreatedSignatureImagesInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetUpdateManyWithoutUserCreatedNestedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: InputMaybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: InputMaybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: InputMaybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: InputMaybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  photo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutCreatedSubscriptionsInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetUpdateManyWithoutUserCreatedNestedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: InputMaybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: InputMaybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: InputMaybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: InputMaybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  photo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutCreditCardSavedsInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetUpdateManyWithoutUserCreatedNestedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: InputMaybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: InputMaybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: InputMaybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: InputMaybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  photo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutDefaultImageInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetUpdateManyWithoutUserCreatedNestedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: InputMaybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: InputMaybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: InputMaybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: InputMaybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  photo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutDocumentBaseHistoryInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetUpdateManyWithoutUserCreatedNestedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: InputMaybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: InputMaybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: InputMaybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: InputMaybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  photo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutDocumentBaseInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetUpdateManyWithoutUserCreatedNestedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: InputMaybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: InputMaybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: InputMaybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: InputMaybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  photo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutDocumentBaseSignatureInviteSignatureInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetUpdateManyWithoutUserCreatedNestedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: InputMaybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: InputMaybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: InputMaybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: InputMaybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  photo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutMaintainerAdminInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetUpdateManyWithoutUserCreatedNestedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  Recharges?: InputMaybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: InputMaybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: InputMaybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: InputMaybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  photo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutRechargesInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetUpdateManyWithoutUserCreatedNestedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: InputMaybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: InputMaybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: InputMaybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  photo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutReusableFormDataCurriculumListInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetUpdateManyWithoutUserCreatedNestedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: InputMaybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: InputMaybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: InputMaybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: InputMaybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  photo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutReusableFormDatasInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetUpdateManyWithoutUserCreatedNestedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: InputMaybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: InputMaybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: InputMaybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: InputMaybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  photo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutSystemAuditLogsInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetUpdateManyWithoutUserCreatedNestedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: InputMaybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: InputMaybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: InputMaybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: InputMaybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  photo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutSystemGlobalAlertUserDismissesInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetUpdateManyWithoutUserCreatedNestedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: InputMaybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemLog?: InputMaybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: InputMaybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: InputMaybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  photo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutSystemLogInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetUpdateManyWithoutUserCreatedNestedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: InputMaybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: InputMaybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: InputMaybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  photo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutTeamMemberInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetUpdateManyWithoutUserCreatedNestedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: InputMaybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: InputMaybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: InputMaybe<TeamUpdateManyWithoutOwnerNestedInput>;
  UserConfigs?: InputMaybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  photo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutTeamsCreatedInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetUpdateManyWithoutUserCreatedNestedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: InputMaybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: InputMaybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  UserConfigs?: InputMaybe<CommonUserConfigUpdateManyWithoutCommonUserNestedInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  photo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpdateWithoutUserConfigsInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutUserNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutUserOwnerNestedInput>;
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutUserExecutedNestedInput>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetUpdateManyWithoutUserCreatedNestedInput>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageUpdateManyWithoutUserCreatedNestedInput>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput>;
  DefaultImage?: InputMaybe<SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateManyWithoutUserOwnerNestedInput>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminUpdateOneWithoutUserNestedInput>;
  Recharges?: InputMaybe<FinancialRechargeUpdateManyWithoutUserExecutedNestedInput>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataUpdateManyWithoutUserOwnerNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutUserNestedInput>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput>;
  SystemLog?: InputMaybe<SystemLogUpdateManyWithoutUserNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutUserNestedInput>;
  TeamsCreated?: InputMaybe<TeamUpdateManyWithoutOwnerNestedInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  idLedgerSign?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  photo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CommonUserUpsertWithoutApiKeyInput = {
  create: CommonUserCreateWithoutApiKeyInput;
  update: CommonUserUpdateWithoutApiKeyInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutCertificateBaseInput = {
  create: CommonUserCreateWithoutCertificateBaseInput;
  update: CommonUserUpdateWithoutCertificateBaseInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutChargesInput = {
  create: CommonUserCreateWithoutChargesInput;
  update: CommonUserUpdateWithoutChargesInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutCreatedCertificateTemplatePresetsInput = {
  create: CommonUserCreateWithoutCreatedCertificateTemplatePresetsInput;
  update: CommonUserUpdateWithoutCreatedCertificateTemplatePresetsInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutCreatedCertificateTemplatesInput = {
  create: CommonUserCreateWithoutCreatedCertificateTemplatesInput;
  update: CommonUserUpdateWithoutCreatedCertificateTemplatesInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutCreatedSignatureImagesInput = {
  create: CommonUserCreateWithoutCreatedSignatureImagesInput;
  update: CommonUserUpdateWithoutCreatedSignatureImagesInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutCreatedSubscriptionsInput = {
  create: CommonUserCreateWithoutCreatedSubscriptionsInput;
  update: CommonUserUpdateWithoutCreatedSubscriptionsInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutCreditCardSavedsInput = {
  create: CommonUserCreateWithoutCreditCardSavedsInput;
  update: CommonUserUpdateWithoutCreditCardSavedsInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutDefaultImageInput = {
  create: CommonUserCreateWithoutDefaultImageInput;
  update: CommonUserUpdateWithoutDefaultImageInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutDocumentBaseHistoryInput = {
  create: CommonUserCreateWithoutDocumentBaseHistoryInput;
  update: CommonUserUpdateWithoutDocumentBaseHistoryInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutDocumentBaseInput = {
  create: CommonUserCreateWithoutDocumentBaseInput;
  update: CommonUserUpdateWithoutDocumentBaseInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutDocumentBaseSignatureInviteSignatureInput = {
  create: CommonUserCreateWithoutDocumentBaseSignatureInviteSignatureInput;
  update: CommonUserUpdateWithoutDocumentBaseSignatureInviteSignatureInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutMaintainerAdminInput = {
  create: CommonUserCreateWithoutMaintainerAdminInput;
  update: CommonUserUpdateWithoutMaintainerAdminInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutRechargesInput = {
  create: CommonUserCreateWithoutRechargesInput;
  update: CommonUserUpdateWithoutRechargesInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutReusableFormDataCurriculumListInput = {
  create: CommonUserCreateWithoutReusableFormDataCurriculumListInput;
  update: CommonUserUpdateWithoutReusableFormDataCurriculumListInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutReusableFormDatasInput = {
  create: CommonUserCreateWithoutReusableFormDatasInput;
  update: CommonUserUpdateWithoutReusableFormDatasInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutSystemAuditLogsInput = {
  create: CommonUserCreateWithoutSystemAuditLogsInput;
  update: CommonUserUpdateWithoutSystemAuditLogsInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutSystemGlobalAlertUserDismissesInput = {
  create: CommonUserCreateWithoutSystemGlobalAlertUserDismissesInput;
  update: CommonUserUpdateWithoutSystemGlobalAlertUserDismissesInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutSystemLogInput = {
  create: CommonUserCreateWithoutSystemLogInput;
  update: CommonUserUpdateWithoutSystemLogInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutTeamMemberInput = {
  create: CommonUserCreateWithoutTeamMemberInput;
  update: CommonUserUpdateWithoutTeamMemberInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutTeamsCreatedInput = {
  create: CommonUserCreateWithoutTeamsCreatedInput;
  update: CommonUserUpdateWithoutTeamsCreatedInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserUpsertWithoutUserConfigsInput = {
  create: CommonUserCreateWithoutUserConfigsInput;
  update: CommonUserUpdateWithoutUserConfigsInput;
  where?: InputMaybe<CommonUserWhereInput>;
};

export type CommonUserWhereInput = {
  AND?: InputMaybe<Array<CommonUserWhereInput>>;
  ApiKey?: InputMaybe<ApiKeyListRelationFilter>;
  CertificateBase?: InputMaybe<CertificateBaseListRelationFilter>;
  Charges?: InputMaybe<FinancialChargeListRelationFilter>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetListRelationFilter>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateListRelationFilter>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageListRelationFilter>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionListRelationFilter>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedListRelationFilter>;
  DefaultImage?: InputMaybe<SignSignatureImageWhereInput>;
  DocumentBase?: InputMaybe<DocumentBaseListRelationFilter>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryListRelationFilter>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureListRelationFilter>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminWhereInput>;
  NOT?: InputMaybe<Array<CommonUserWhereInput>>;
  OR?: InputMaybe<Array<CommonUserWhereInput>>;
  Recharges?: InputMaybe<FinancialRechargeListRelationFilter>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumListRelationFilter>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataListRelationFilter>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogListRelationFilter>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissListRelationFilter>;
  SystemLog?: InputMaybe<SystemLogListRelationFilter>;
  TeamMember?: InputMaybe<TeamMemberListRelationFilter>;
  TeamsCreated?: InputMaybe<TeamListRelationFilter>;
  UserConfigs?: InputMaybe<CommonUserConfigListRelationFilter>;
  cpf?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  defaultSignatureImageId?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  idLedgerSign?: InputMaybe<IntNullableFilter>;
  lastActivityAt?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringNullableFilter>;
  photo?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type CommonUserWhereUniqueInput = {
  AND?: InputMaybe<Array<CommonUserWhereInput>>;
  ApiKey?: InputMaybe<ApiKeyListRelationFilter>;
  CertificateBase?: InputMaybe<CertificateBaseListRelationFilter>;
  Charges?: InputMaybe<FinancialChargeListRelationFilter>;
  CreatedCertificateTemplatePresets?: InputMaybe<CertificateTemplatePresetListRelationFilter>;
  CreatedCertificateTemplates?: InputMaybe<CertificateTemplateListRelationFilter>;
  CreatedSignatureImages?: InputMaybe<SignSignatureImageListRelationFilter>;
  CreatedSubscriptions?: InputMaybe<FinancialTeamWalletSubscriptionListRelationFilter>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedListRelationFilter>;
  DefaultImage?: InputMaybe<SignSignatureImageWhereInput>;
  DocumentBase?: InputMaybe<DocumentBaseListRelationFilter>;
  DocumentBaseHistory?: InputMaybe<DocumentBaseHistoryListRelationFilter>;
  DocumentBaseSignatureInviteSignature?: InputMaybe<DocumentBaseSignatureInviteSignatureListRelationFilter>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminWhereInput>;
  NOT?: InputMaybe<Array<CommonUserWhereInput>>;
  OR?: InputMaybe<Array<CommonUserWhereInput>>;
  Recharges?: InputMaybe<FinancialRechargeListRelationFilter>;
  ReusableFormDataCurriculumList?: InputMaybe<ReusableFormDataCurriculumListRelationFilter>;
  ReusableFormDatas?: InputMaybe<ReusableFormDataListRelationFilter>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogListRelationFilter>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissListRelationFilter>;
  SystemLog?: InputMaybe<SystemLogListRelationFilter>;
  TeamMember?: InputMaybe<TeamMemberListRelationFilter>;
  TeamsCreated?: InputMaybe<TeamListRelationFilter>;
  UserConfigs?: InputMaybe<CommonUserConfigListRelationFilter>;
  cpf?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  defaultSignatureImageId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  idLedgerSign?: InputMaybe<IntNullableFilter>;
  lastActivityAt?: InputMaybe<DateTimeFilter>;
  name?: InputMaybe<StringNullableFilter>;
  photo?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type CompleteSignatureImage = {
  base64Image: Scalars['String']['input'];
  createdAt: Scalars['String']['input'];
  id: Scalars['String']['input'];
  percentageBelowTheLine: Scalars['Float']['input'];
};

export type CreateOneEnabledInstitutionInput = {
  cnpj: Scalars['String']['input'];
  educationLevelType: Array<EducationLevelType>;
  email: Scalars['String']['input'];
  isMaintainer: Scalars['Boolean']['input'];
  isNSF: Scalars['Boolean']['input'];
  placeholderName: Scalars['String']['input'];
  showCreateDiploma: Scalars['Boolean']['input'];
  showImportDiploma: Scalars['Boolean']['input'];
  syncWithLedgerDoc: Scalars['Boolean']['input'];
};

export type CreateOneFinancialRechargeInput = {
  creditCard?: InputMaybe<InputFinancialPurchaseCreditCard>;
  creditsCount: Scalars['Int']['input'];
  /** To avoid charge different value than expected (shown in frontend) */
  expectedCost: Scalars['Float']['input'];
  savedCreditCard?: InputMaybe<InputFinancialPurchaseSavedCreditCard>;
  service: FinancialChargeableService;
};

export type CreateOneSignSignatureImageData = {
  base64Image: Scalars['String']['input'];
  description: Scalars['String']['input'];
  percentageBelowTheLine: Scalars['Float']['input'];
};

export type CurriculumDisciplineVariable = {
  certificateBaseId: Scalars['String']['input'];
  data: CurriculumDisciplineVariableData;
};

export type CurriculumDisciplineVariableData = {
  frequency?: InputMaybe<Scalars['String']['input']>;
  testGrade?: InputMaybe<Scalars['String']['input']>;
};

export type CustomReturnType = {
  __typename?: 'CustomReturnType';
  id: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  total: Scalars['Int']['output'];
};

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDateTimeNullableFilter>;
  _min?: InputMaybe<NestedDateTimeNullableFilter>;
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DecimalFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Decimal']['input']>;
  divide?: InputMaybe<Scalars['Decimal']['input']>;
  increment?: InputMaybe<Scalars['Decimal']['input']>;
  multiply?: InputMaybe<Scalars['Decimal']['input']>;
  set?: InputMaybe<Scalars['Decimal']['input']>;
};

export type DecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type DecimalWithAggregatesFilter = {
  _avg?: InputMaybe<NestedDecimalFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDecimalFilter>;
  _min?: InputMaybe<NestedDecimalFilter>;
  _sum?: InputMaybe<NestedDecimalFilter>;
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export enum DegreeValidationVerdict {
  Indeterminated = 'INDETERMINATED',
  Invalid = 'INVALID',
  Valid = 'VALID'
}

/** Descontos em porcentagem que começam a partir de uma quantidade */
export type Discount = {
  __typename?: 'Discount';
  count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  valueInPercent: Scalars['Float']['output'];
};

export type DocumentAcademicDocumentation = {
  __typename?: 'DocumentAcademicDocumentation';
  /** Lista os históricos finais */
  ChildDocuments: Array<DocumentFinalAcademicTranscript>;
  ChildRevokedDocumentList: Array<DocumentAcademicDocumentation>;
  /** View for search */
  DocumentAcademicDocumentationSearchView?: Maybe<DocumentAcademicDocumentationSearchView>;
  DocumentBase: DocumentBase;
  LinkedDegreeList: Array<DocumentDegree>;
  ParentRevokedDocument?: Maybe<DocumentAcademicDocumentation>;
  documentBaseId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isSentToRegistrar: Scalars['Boolean']['output'];
  parentRevokedDocumentId?: Maybe<Scalars['String']['output']>;
  searchCPF: Scalars['String']['output'];
  searchCourse: Scalars['String']['output'];
  searchEmecCode: Scalars['String']['output'];
  searchStudentName: Scalars['String']['output'];
  /** Esse status é transformado */
  status: DocumentAcademicDocumentationStatus;
  type: DocumentAcademicDocumentationType;
  validationAttempts: Scalars['Int']['output'];
};


export type DocumentAcademicDocumentationChildRevokedDocumentListArgs = {
  cursor?: InputMaybe<DocumentAcademicDocumentationWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentAcademicDocumentationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentAcademicDocumentationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
};


export type DocumentAcademicDocumentationLinkedDegreeListArgs = {
  cursor?: InputMaybe<DocumentDegreeWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentDegreeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentDegreeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentDegreeWhereInput>;
};

export type DocumentAcademicDocumentationAvgOrderByAggregateInput = {
  validationAttempts?: InputMaybe<SortOrder>;
};

export type DocumentAcademicDocumentationCountOrderByAggregateInput = {
  documentBaseId?: InputMaybe<SortOrder>;
  isSentToRegistrar?: InputMaybe<SortOrder>;
  parentRevokedDocumentId?: InputMaybe<SortOrder>;
  searchCPF?: InputMaybe<SortOrder>;
  searchCourse?: InputMaybe<SortOrder>;
  searchEmecCode?: InputMaybe<SortOrder>;
  searchStudentName?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  validationAttempts?: InputMaybe<SortOrder>;
};

export type DocumentAcademicDocumentationCreateInput = {
  ChildDocuments?: InputMaybe<DocumentFinalAcademicTranscriptCreateNestedManyWithoutParentDocumentInput>;
  ChildRevokedDocumentList?: InputMaybe<DocumentAcademicDocumentationCreateNestedManyWithoutParentRevokedDocumentInput>;
  DocumentAcademicDocumentationSearchView?: InputMaybe<DocumentAcademicDocumentationSearchViewCreateNestedOneWithoutDocumentAcademicDocumentationInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentAcademicDocumentationInput;
  LinkedDegreeList?: InputMaybe<DocumentDegreeCreateNestedManyWithoutParentAcademicDocumentationInput>;
  ParentRevokedDocument?: InputMaybe<DocumentAcademicDocumentationCreateNestedOneWithoutChildRevokedDocumentListInput>;
  isSentToRegistrar?: InputMaybe<Scalars['Boolean']['input']>;
  searchCPF?: InputMaybe<Scalars['String']['input']>;
  searchCourse?: InputMaybe<Scalars['String']['input']>;
  searchEmecCode?: InputMaybe<Scalars['String']['input']>;
  searchStudentName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentAcademicDocumentationStatus>;
  type?: InputMaybe<DocumentAcademicDocumentationType>;
  validationAttempts?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentAcademicDocumentationCreateManyInput = {
  documentBaseId: Scalars['String']['input'];
  isSentToRegistrar?: InputMaybe<Scalars['Boolean']['input']>;
  parentRevokedDocumentId?: InputMaybe<Scalars['String']['input']>;
  searchCPF?: InputMaybe<Scalars['String']['input']>;
  searchCourse?: InputMaybe<Scalars['String']['input']>;
  searchEmecCode?: InputMaybe<Scalars['String']['input']>;
  searchStudentName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentAcademicDocumentationStatus>;
  type?: InputMaybe<DocumentAcademicDocumentationType>;
  validationAttempts?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentAcademicDocumentationCreateManyParentRevokedDocumentInput = {
  documentBaseId: Scalars['String']['input'];
  isSentToRegistrar?: InputMaybe<Scalars['Boolean']['input']>;
  searchCPF?: InputMaybe<Scalars['String']['input']>;
  searchCourse?: InputMaybe<Scalars['String']['input']>;
  searchEmecCode?: InputMaybe<Scalars['String']['input']>;
  searchStudentName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentAcademicDocumentationStatus>;
  type?: InputMaybe<DocumentAcademicDocumentationType>;
  validationAttempts?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentAcademicDocumentationCreateManyParentRevokedDocumentInputEnvelope = {
  data: Array<DocumentAcademicDocumentationCreateManyParentRevokedDocumentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentAcademicDocumentationCreateNestedManyWithoutParentRevokedDocumentInput = {
  connect?: InputMaybe<Array<DocumentAcademicDocumentationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentAcademicDocumentationCreateOrConnectWithoutParentRevokedDocumentInput>>;
  create?: InputMaybe<Array<DocumentAcademicDocumentationCreateWithoutParentRevokedDocumentInput>>;
  createMany?: InputMaybe<DocumentAcademicDocumentationCreateManyParentRevokedDocumentInputEnvelope>;
};

export type DocumentAcademicDocumentationCreateNestedOneWithoutChildDocumentsInput = {
  connect?: InputMaybe<DocumentAcademicDocumentationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentAcademicDocumentationCreateOrConnectWithoutChildDocumentsInput>;
  create?: InputMaybe<DocumentAcademicDocumentationCreateWithoutChildDocumentsInput>;
};

export type DocumentAcademicDocumentationCreateNestedOneWithoutChildRevokedDocumentListInput = {
  connect?: InputMaybe<DocumentAcademicDocumentationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentAcademicDocumentationCreateOrConnectWithoutChildRevokedDocumentListInput>;
  create?: InputMaybe<DocumentAcademicDocumentationCreateWithoutChildRevokedDocumentListInput>;
};

export type DocumentAcademicDocumentationCreateNestedOneWithoutDocumentAcademicDocumentationSearchViewInput = {
  connect?: InputMaybe<DocumentAcademicDocumentationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentAcademicDocumentationCreateOrConnectWithoutDocumentAcademicDocumentationSearchViewInput>;
  create?: InputMaybe<DocumentAcademicDocumentationCreateWithoutDocumentAcademicDocumentationSearchViewInput>;
};

export type DocumentAcademicDocumentationCreateNestedOneWithoutDocumentBaseInput = {
  connect?: InputMaybe<DocumentAcademicDocumentationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentAcademicDocumentationCreateOrConnectWithoutDocumentBaseInput>;
  create?: InputMaybe<DocumentAcademicDocumentationCreateWithoutDocumentBaseInput>;
};

export type DocumentAcademicDocumentationCreateNestedOneWithoutLinkedDegreeListInput = {
  connect?: InputMaybe<DocumentAcademicDocumentationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentAcademicDocumentationCreateOrConnectWithoutLinkedDegreeListInput>;
  create?: InputMaybe<DocumentAcademicDocumentationCreateWithoutLinkedDegreeListInput>;
};

export type DocumentAcademicDocumentationCreateOrConnectWithoutChildDocumentsInput = {
  create: DocumentAcademicDocumentationCreateWithoutChildDocumentsInput;
  where: DocumentAcademicDocumentationWhereUniqueInput;
};

export type DocumentAcademicDocumentationCreateOrConnectWithoutChildRevokedDocumentListInput = {
  create: DocumentAcademicDocumentationCreateWithoutChildRevokedDocumentListInput;
  where: DocumentAcademicDocumentationWhereUniqueInput;
};

export type DocumentAcademicDocumentationCreateOrConnectWithoutDocumentAcademicDocumentationSearchViewInput = {
  create: DocumentAcademicDocumentationCreateWithoutDocumentAcademicDocumentationSearchViewInput;
  where: DocumentAcademicDocumentationWhereUniqueInput;
};

export type DocumentAcademicDocumentationCreateOrConnectWithoutDocumentBaseInput = {
  create: DocumentAcademicDocumentationCreateWithoutDocumentBaseInput;
  where: DocumentAcademicDocumentationWhereUniqueInput;
};

export type DocumentAcademicDocumentationCreateOrConnectWithoutLinkedDegreeListInput = {
  create: DocumentAcademicDocumentationCreateWithoutLinkedDegreeListInput;
  where: DocumentAcademicDocumentationWhereUniqueInput;
};

export type DocumentAcademicDocumentationCreateOrConnectWithoutParentRevokedDocumentInput = {
  create: DocumentAcademicDocumentationCreateWithoutParentRevokedDocumentInput;
  where: DocumentAcademicDocumentationWhereUniqueInput;
};

export type DocumentAcademicDocumentationCreateWithoutChildDocumentsInput = {
  ChildRevokedDocumentList?: InputMaybe<DocumentAcademicDocumentationCreateNestedManyWithoutParentRevokedDocumentInput>;
  DocumentAcademicDocumentationSearchView?: InputMaybe<DocumentAcademicDocumentationSearchViewCreateNestedOneWithoutDocumentAcademicDocumentationInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentAcademicDocumentationInput;
  LinkedDegreeList?: InputMaybe<DocumentDegreeCreateNestedManyWithoutParentAcademicDocumentationInput>;
  ParentRevokedDocument?: InputMaybe<DocumentAcademicDocumentationCreateNestedOneWithoutChildRevokedDocumentListInput>;
  isSentToRegistrar?: InputMaybe<Scalars['Boolean']['input']>;
  searchCPF?: InputMaybe<Scalars['String']['input']>;
  searchCourse?: InputMaybe<Scalars['String']['input']>;
  searchEmecCode?: InputMaybe<Scalars['String']['input']>;
  searchStudentName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentAcademicDocumentationStatus>;
  type?: InputMaybe<DocumentAcademicDocumentationType>;
  validationAttempts?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentAcademicDocumentationCreateWithoutChildRevokedDocumentListInput = {
  ChildDocuments?: InputMaybe<DocumentFinalAcademicTranscriptCreateNestedManyWithoutParentDocumentInput>;
  DocumentAcademicDocumentationSearchView?: InputMaybe<DocumentAcademicDocumentationSearchViewCreateNestedOneWithoutDocumentAcademicDocumentationInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentAcademicDocumentationInput;
  LinkedDegreeList?: InputMaybe<DocumentDegreeCreateNestedManyWithoutParentAcademicDocumentationInput>;
  ParentRevokedDocument?: InputMaybe<DocumentAcademicDocumentationCreateNestedOneWithoutChildRevokedDocumentListInput>;
  isSentToRegistrar?: InputMaybe<Scalars['Boolean']['input']>;
  searchCPF?: InputMaybe<Scalars['String']['input']>;
  searchCourse?: InputMaybe<Scalars['String']['input']>;
  searchEmecCode?: InputMaybe<Scalars['String']['input']>;
  searchStudentName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentAcademicDocumentationStatus>;
  type?: InputMaybe<DocumentAcademicDocumentationType>;
  validationAttempts?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentAcademicDocumentationCreateWithoutDocumentAcademicDocumentationSearchViewInput = {
  ChildDocuments?: InputMaybe<DocumentFinalAcademicTranscriptCreateNestedManyWithoutParentDocumentInput>;
  ChildRevokedDocumentList?: InputMaybe<DocumentAcademicDocumentationCreateNestedManyWithoutParentRevokedDocumentInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentAcademicDocumentationInput;
  LinkedDegreeList?: InputMaybe<DocumentDegreeCreateNestedManyWithoutParentAcademicDocumentationInput>;
  ParentRevokedDocument?: InputMaybe<DocumentAcademicDocumentationCreateNestedOneWithoutChildRevokedDocumentListInput>;
  isSentToRegistrar?: InputMaybe<Scalars['Boolean']['input']>;
  searchCPF?: InputMaybe<Scalars['String']['input']>;
  searchCourse?: InputMaybe<Scalars['String']['input']>;
  searchEmecCode?: InputMaybe<Scalars['String']['input']>;
  searchStudentName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentAcademicDocumentationStatus>;
  type?: InputMaybe<DocumentAcademicDocumentationType>;
  validationAttempts?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentAcademicDocumentationCreateWithoutDocumentBaseInput = {
  ChildDocuments?: InputMaybe<DocumentFinalAcademicTranscriptCreateNestedManyWithoutParentDocumentInput>;
  ChildRevokedDocumentList?: InputMaybe<DocumentAcademicDocumentationCreateNestedManyWithoutParentRevokedDocumentInput>;
  DocumentAcademicDocumentationSearchView?: InputMaybe<DocumentAcademicDocumentationSearchViewCreateNestedOneWithoutDocumentAcademicDocumentationInput>;
  LinkedDegreeList?: InputMaybe<DocumentDegreeCreateNestedManyWithoutParentAcademicDocumentationInput>;
  ParentRevokedDocument?: InputMaybe<DocumentAcademicDocumentationCreateNestedOneWithoutChildRevokedDocumentListInput>;
  isSentToRegistrar?: InputMaybe<Scalars['Boolean']['input']>;
  searchCPF?: InputMaybe<Scalars['String']['input']>;
  searchCourse?: InputMaybe<Scalars['String']['input']>;
  searchEmecCode?: InputMaybe<Scalars['String']['input']>;
  searchStudentName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentAcademicDocumentationStatus>;
  type?: InputMaybe<DocumentAcademicDocumentationType>;
  validationAttempts?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentAcademicDocumentationCreateWithoutLinkedDegreeListInput = {
  ChildDocuments?: InputMaybe<DocumentFinalAcademicTranscriptCreateNestedManyWithoutParentDocumentInput>;
  ChildRevokedDocumentList?: InputMaybe<DocumentAcademicDocumentationCreateNestedManyWithoutParentRevokedDocumentInput>;
  DocumentAcademicDocumentationSearchView?: InputMaybe<DocumentAcademicDocumentationSearchViewCreateNestedOneWithoutDocumentAcademicDocumentationInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentAcademicDocumentationInput;
  ParentRevokedDocument?: InputMaybe<DocumentAcademicDocumentationCreateNestedOneWithoutChildRevokedDocumentListInput>;
  isSentToRegistrar?: InputMaybe<Scalars['Boolean']['input']>;
  searchCPF?: InputMaybe<Scalars['String']['input']>;
  searchCourse?: InputMaybe<Scalars['String']['input']>;
  searchEmecCode?: InputMaybe<Scalars['String']['input']>;
  searchStudentName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentAcademicDocumentationStatus>;
  type?: InputMaybe<DocumentAcademicDocumentationType>;
  validationAttempts?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentAcademicDocumentationCreateWithoutParentRevokedDocumentInput = {
  ChildDocuments?: InputMaybe<DocumentFinalAcademicTranscriptCreateNestedManyWithoutParentDocumentInput>;
  ChildRevokedDocumentList?: InputMaybe<DocumentAcademicDocumentationCreateNestedManyWithoutParentRevokedDocumentInput>;
  DocumentAcademicDocumentationSearchView?: InputMaybe<DocumentAcademicDocumentationSearchViewCreateNestedOneWithoutDocumentAcademicDocumentationInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentAcademicDocumentationInput;
  LinkedDegreeList?: InputMaybe<DocumentDegreeCreateNestedManyWithoutParentAcademicDocumentationInput>;
  isSentToRegistrar?: InputMaybe<Scalars['Boolean']['input']>;
  searchCPF?: InputMaybe<Scalars['String']['input']>;
  searchCourse?: InputMaybe<Scalars['String']['input']>;
  searchEmecCode?: InputMaybe<Scalars['String']['input']>;
  searchStudentName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentAcademicDocumentationStatus>;
  type?: InputMaybe<DocumentAcademicDocumentationType>;
  validationAttempts?: InputMaybe<Scalars['Int']['input']>;
};

export enum DocumentAcademicDocumentationCreationType {
  ApiExternalSign = 'API_EXTERNAL_SIGN',
  ApiJson = 'API_JSON',
  ApiXml = 'API_XML',
  Form = 'FORM',
  GenerateXml = 'GENERATE_XML'
}

export type DocumentAcademicDocumentationListRelationFilter = {
  every?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
  none?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
  some?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
};

export type DocumentAcademicDocumentationMaxOrderByAggregateInput = {
  documentBaseId?: InputMaybe<SortOrder>;
  isSentToRegistrar?: InputMaybe<SortOrder>;
  parentRevokedDocumentId?: InputMaybe<SortOrder>;
  searchCPF?: InputMaybe<SortOrder>;
  searchCourse?: InputMaybe<SortOrder>;
  searchEmecCode?: InputMaybe<SortOrder>;
  searchStudentName?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  validationAttempts?: InputMaybe<SortOrder>;
};

export type DocumentAcademicDocumentationMinOrderByAggregateInput = {
  documentBaseId?: InputMaybe<SortOrder>;
  isSentToRegistrar?: InputMaybe<SortOrder>;
  parentRevokedDocumentId?: InputMaybe<SortOrder>;
  searchCPF?: InputMaybe<SortOrder>;
  searchCourse?: InputMaybe<SortOrder>;
  searchEmecCode?: InputMaybe<SortOrder>;
  searchStudentName?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  validationAttempts?: InputMaybe<SortOrder>;
};

export type DocumentAcademicDocumentationNullableRelationFilter = {
  is?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
  isNot?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
};

export type DocumentAcademicDocumentationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DocumentAcademicDocumentationOrderByWithAggregationInput = {
  _avg?: InputMaybe<DocumentAcademicDocumentationAvgOrderByAggregateInput>;
  _count?: InputMaybe<DocumentAcademicDocumentationCountOrderByAggregateInput>;
  _max?: InputMaybe<DocumentAcademicDocumentationMaxOrderByAggregateInput>;
  _min?: InputMaybe<DocumentAcademicDocumentationMinOrderByAggregateInput>;
  _sum?: InputMaybe<DocumentAcademicDocumentationSumOrderByAggregateInput>;
  documentBaseId?: InputMaybe<SortOrder>;
  isSentToRegistrar?: InputMaybe<SortOrder>;
  parentRevokedDocumentId?: InputMaybe<SortOrder>;
  searchCPF?: InputMaybe<SortOrder>;
  searchCourse?: InputMaybe<SortOrder>;
  searchEmecCode?: InputMaybe<SortOrder>;
  searchStudentName?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  validationAttempts?: InputMaybe<SortOrder>;
};

export type DocumentAcademicDocumentationOrderByWithRelationInput = {
  ChildDocuments?: InputMaybe<DocumentFinalAcademicTranscriptOrderByRelationAggregateInput>;
  ChildRevokedDocumentList?: InputMaybe<DocumentAcademicDocumentationOrderByRelationAggregateInput>;
  DocumentAcademicDocumentationSearchView?: InputMaybe<DocumentAcademicDocumentationSearchViewOrderByWithRelationInput>;
  DocumentBase?: InputMaybe<DocumentBaseOrderByWithRelationInput>;
  LinkedDegreeList?: InputMaybe<DocumentDegreeOrderByRelationAggregateInput>;
  ParentRevokedDocument?: InputMaybe<DocumentAcademicDocumentationOrderByWithRelationInput>;
  documentBaseId?: InputMaybe<SortOrder>;
  isSentToRegistrar?: InputMaybe<SortOrder>;
  parentRevokedDocumentId?: InputMaybe<SortOrder>;
  searchCPF?: InputMaybe<SortOrder>;
  searchCourse?: InputMaybe<SortOrder>;
  searchEmecCode?: InputMaybe<SortOrder>;
  searchStudentName?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  validationAttempts?: InputMaybe<SortOrder>;
};

export type DocumentAcademicDocumentationRelationFilter = {
  is?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
  isNot?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
};

export enum DocumentAcademicDocumentationScalarFieldEnum {
  DocumentBaseId = 'documentBaseId',
  IsSentToRegistrar = 'isSentToRegistrar',
  ParentRevokedDocumentId = 'parentRevokedDocumentId',
  SearchCpf = 'searchCPF',
  SearchCourse = 'searchCourse',
  SearchEmecCode = 'searchEmecCode',
  SearchStudentName = 'searchStudentName',
  Status = 'status',
  Type = 'type',
  ValidationAttempts = 'validationAttempts'
}

export type DocumentAcademicDocumentationScalarWhereInput = {
  AND?: InputMaybe<Array<DocumentAcademicDocumentationScalarWhereInput>>;
  NOT?: InputMaybe<Array<DocumentAcademicDocumentationScalarWhereInput>>;
  OR?: InputMaybe<Array<DocumentAcademicDocumentationScalarWhereInput>>;
  documentBaseId?: InputMaybe<StringFilter>;
  isSentToRegistrar?: InputMaybe<BoolFilter>;
  parentRevokedDocumentId?: InputMaybe<StringNullableFilter>;
  searchCPF?: InputMaybe<StringFilter>;
  searchCourse?: InputMaybe<StringFilter>;
  searchEmecCode?: InputMaybe<StringFilter>;
  searchStudentName?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumDocumentAcademicDocumentationStatusFilter>;
  type?: InputMaybe<EnumDocumentAcademicDocumentationTypeFilter>;
  validationAttempts?: InputMaybe<IntFilter>;
};

export type DocumentAcademicDocumentationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DocumentAcademicDocumentationScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DocumentAcademicDocumentationScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DocumentAcademicDocumentationScalarWhereWithAggregatesInput>>;
  documentBaseId?: InputMaybe<StringWithAggregatesFilter>;
  isSentToRegistrar?: InputMaybe<BoolWithAggregatesFilter>;
  parentRevokedDocumentId?: InputMaybe<StringNullableWithAggregatesFilter>;
  searchCPF?: InputMaybe<StringWithAggregatesFilter>;
  searchCourse?: InputMaybe<StringWithAggregatesFilter>;
  searchEmecCode?: InputMaybe<StringWithAggregatesFilter>;
  searchStudentName?: InputMaybe<StringWithAggregatesFilter>;
  status?: InputMaybe<EnumDocumentAcademicDocumentationStatusWithAggregatesFilter>;
  type?: InputMaybe<EnumDocumentAcademicDocumentationTypeWithAggregatesFilter>;
  validationAttempts?: InputMaybe<IntWithAggregatesFilter>;
};

export type DocumentAcademicDocumentationSearchView = {
  __typename?: 'DocumentAcademicDocumentationSearchView';
  DocumentAcademicDocumentation: DocumentAcademicDocumentation;
  documentBaseId: Scalars['String']['output'];
  normalizedSearchCPF: Scalars['String']['output'];
  normalizedSearchCourse: Scalars['String']['output'];
  normalizedSearchEmecCode: Scalars['String']['output'];
  normalizedSearchStudentName: Scalars['String']['output'];
};

export type DocumentAcademicDocumentationSearchViewCountOrderByAggregateInput = {
  documentBaseId?: InputMaybe<SortOrder>;
  normalizedSearchCPF?: InputMaybe<SortOrder>;
  normalizedSearchCourse?: InputMaybe<SortOrder>;
  normalizedSearchEmecCode?: InputMaybe<SortOrder>;
  normalizedSearchStudentName?: InputMaybe<SortOrder>;
};

export type DocumentAcademicDocumentationSearchViewCreateInput = {
  DocumentAcademicDocumentation: DocumentAcademicDocumentationCreateNestedOneWithoutDocumentAcademicDocumentationSearchViewInput;
  normalizedSearchCPF: Scalars['String']['input'];
  normalizedSearchCourse: Scalars['String']['input'];
  normalizedSearchEmecCode: Scalars['String']['input'];
  normalizedSearchStudentName: Scalars['String']['input'];
};

export type DocumentAcademicDocumentationSearchViewCreateManyInput = {
  documentBaseId: Scalars['String']['input'];
  normalizedSearchCPF: Scalars['String']['input'];
  normalizedSearchCourse: Scalars['String']['input'];
  normalizedSearchEmecCode: Scalars['String']['input'];
  normalizedSearchStudentName: Scalars['String']['input'];
};

export type DocumentAcademicDocumentationSearchViewCreateNestedOneWithoutDocumentAcademicDocumentationInput = {
  connect?: InputMaybe<DocumentAcademicDocumentationSearchViewWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentAcademicDocumentationSearchViewCreateOrConnectWithoutDocumentAcademicDocumentationInput>;
  create?: InputMaybe<DocumentAcademicDocumentationSearchViewCreateWithoutDocumentAcademicDocumentationInput>;
};

export type DocumentAcademicDocumentationSearchViewCreateOrConnectWithoutDocumentAcademicDocumentationInput = {
  create: DocumentAcademicDocumentationSearchViewCreateWithoutDocumentAcademicDocumentationInput;
  where: DocumentAcademicDocumentationSearchViewWhereUniqueInput;
};

export type DocumentAcademicDocumentationSearchViewCreateWithoutDocumentAcademicDocumentationInput = {
  normalizedSearchCPF: Scalars['String']['input'];
  normalizedSearchCourse: Scalars['String']['input'];
  normalizedSearchEmecCode: Scalars['String']['input'];
  normalizedSearchStudentName: Scalars['String']['input'];
};

export type DocumentAcademicDocumentationSearchViewMaxOrderByAggregateInput = {
  documentBaseId?: InputMaybe<SortOrder>;
  normalizedSearchCPF?: InputMaybe<SortOrder>;
  normalizedSearchCourse?: InputMaybe<SortOrder>;
  normalizedSearchEmecCode?: InputMaybe<SortOrder>;
  normalizedSearchStudentName?: InputMaybe<SortOrder>;
};

export type DocumentAcademicDocumentationSearchViewMinOrderByAggregateInput = {
  documentBaseId?: InputMaybe<SortOrder>;
  normalizedSearchCPF?: InputMaybe<SortOrder>;
  normalizedSearchCourse?: InputMaybe<SortOrder>;
  normalizedSearchEmecCode?: InputMaybe<SortOrder>;
  normalizedSearchStudentName?: InputMaybe<SortOrder>;
};

export type DocumentAcademicDocumentationSearchViewNullableRelationFilter = {
  is?: InputMaybe<DocumentAcademicDocumentationSearchViewWhereInput>;
  isNot?: InputMaybe<DocumentAcademicDocumentationSearchViewWhereInput>;
};

export type DocumentAcademicDocumentationSearchViewOrderByWithAggregationInput = {
  _count?: InputMaybe<DocumentAcademicDocumentationSearchViewCountOrderByAggregateInput>;
  _max?: InputMaybe<DocumentAcademicDocumentationSearchViewMaxOrderByAggregateInput>;
  _min?: InputMaybe<DocumentAcademicDocumentationSearchViewMinOrderByAggregateInput>;
  documentBaseId?: InputMaybe<SortOrder>;
  normalizedSearchCPF?: InputMaybe<SortOrder>;
  normalizedSearchCourse?: InputMaybe<SortOrder>;
  normalizedSearchEmecCode?: InputMaybe<SortOrder>;
  normalizedSearchStudentName?: InputMaybe<SortOrder>;
};

export type DocumentAcademicDocumentationSearchViewOrderByWithRelationInput = {
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationOrderByWithRelationInput>;
  documentBaseId?: InputMaybe<SortOrder>;
  normalizedSearchCPF?: InputMaybe<SortOrder>;
  normalizedSearchCourse?: InputMaybe<SortOrder>;
  normalizedSearchEmecCode?: InputMaybe<SortOrder>;
  normalizedSearchStudentName?: InputMaybe<SortOrder>;
};

export enum DocumentAcademicDocumentationSearchViewScalarFieldEnum {
  DocumentBaseId = 'documentBaseId',
  NormalizedSearchCpf = 'normalizedSearchCPF',
  NormalizedSearchCourse = 'normalizedSearchCourse',
  NormalizedSearchEmecCode = 'normalizedSearchEmecCode',
  NormalizedSearchStudentName = 'normalizedSearchStudentName'
}

export type DocumentAcademicDocumentationSearchViewScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DocumentAcademicDocumentationSearchViewScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DocumentAcademicDocumentationSearchViewScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DocumentAcademicDocumentationSearchViewScalarWhereWithAggregatesInput>>;
  documentBaseId?: InputMaybe<StringWithAggregatesFilter>;
  normalizedSearchCPF?: InputMaybe<StringWithAggregatesFilter>;
  normalizedSearchCourse?: InputMaybe<StringWithAggregatesFilter>;
  normalizedSearchEmecCode?: InputMaybe<StringWithAggregatesFilter>;
  normalizedSearchStudentName?: InputMaybe<StringWithAggregatesFilter>;
};

export type DocumentAcademicDocumentationSearchViewUpdateInput = {
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationUpdateOneRequiredWithoutDocumentAcademicDocumentationSearchViewNestedInput>;
  normalizedSearchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalizedSearchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalizedSearchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalizedSearchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DocumentAcademicDocumentationSearchViewUpdateManyMutationInput = {
  normalizedSearchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalizedSearchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalizedSearchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalizedSearchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DocumentAcademicDocumentationSearchViewUpdateOneWithoutDocumentAcademicDocumentationNestedInput = {
  connect?: InputMaybe<DocumentAcademicDocumentationSearchViewWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentAcademicDocumentationSearchViewCreateOrConnectWithoutDocumentAcademicDocumentationInput>;
  create?: InputMaybe<DocumentAcademicDocumentationSearchViewCreateWithoutDocumentAcademicDocumentationInput>;
  delete?: InputMaybe<DocumentAcademicDocumentationSearchViewWhereInput>;
  disconnect?: InputMaybe<DocumentAcademicDocumentationSearchViewWhereInput>;
  update?: InputMaybe<DocumentAcademicDocumentationSearchViewUpdateToOneWithWhereWithoutDocumentAcademicDocumentationInput>;
  upsert?: InputMaybe<DocumentAcademicDocumentationSearchViewUpsertWithoutDocumentAcademicDocumentationInput>;
};

export type DocumentAcademicDocumentationSearchViewUpdateToOneWithWhereWithoutDocumentAcademicDocumentationInput = {
  data: DocumentAcademicDocumentationSearchViewUpdateWithoutDocumentAcademicDocumentationInput;
  where?: InputMaybe<DocumentAcademicDocumentationSearchViewWhereInput>;
};

export type DocumentAcademicDocumentationSearchViewUpdateWithoutDocumentAcademicDocumentationInput = {
  normalizedSearchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalizedSearchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalizedSearchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalizedSearchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DocumentAcademicDocumentationSearchViewUpsertWithoutDocumentAcademicDocumentationInput = {
  create: DocumentAcademicDocumentationSearchViewCreateWithoutDocumentAcademicDocumentationInput;
  update: DocumentAcademicDocumentationSearchViewUpdateWithoutDocumentAcademicDocumentationInput;
  where?: InputMaybe<DocumentAcademicDocumentationSearchViewWhereInput>;
};

export type DocumentAcademicDocumentationSearchViewWhereInput = {
  AND?: InputMaybe<Array<DocumentAcademicDocumentationSearchViewWhereInput>>;
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
  NOT?: InputMaybe<Array<DocumentAcademicDocumentationSearchViewWhereInput>>;
  OR?: InputMaybe<Array<DocumentAcademicDocumentationSearchViewWhereInput>>;
  documentBaseId?: InputMaybe<StringFilter>;
  normalizedSearchCPF?: InputMaybe<StringFilter>;
  normalizedSearchCourse?: InputMaybe<StringFilter>;
  normalizedSearchEmecCode?: InputMaybe<StringFilter>;
  normalizedSearchStudentName?: InputMaybe<StringFilter>;
};

export type DocumentAcademicDocumentationSearchViewWhereUniqueInput = {
  AND?: InputMaybe<Array<DocumentAcademicDocumentationSearchViewWhereInput>>;
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
  NOT?: InputMaybe<Array<DocumentAcademicDocumentationSearchViewWhereInput>>;
  OR?: InputMaybe<Array<DocumentAcademicDocumentationSearchViewWhereInput>>;
  documentBaseId?: InputMaybe<Scalars['String']['input']>;
  normalizedSearchCPF?: InputMaybe<StringFilter>;
  normalizedSearchCourse?: InputMaybe<StringFilter>;
  normalizedSearchEmecCode?: InputMaybe<StringFilter>;
  normalizedSearchStudentName?: InputMaybe<StringFilter>;
};

export enum DocumentAcademicDocumentationStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  FastValidation = 'FAST_VALIDATION',
  InCorrection = 'IN_CORRECTION',
  InSignature = 'IN_SIGNATURE',
  Issued = 'ISSUED',
  PendingReview = 'PENDING_REVIEW',
  Revoked = 'REVOKED',
  ValidationImpossibleToValidate = 'VALIDATION_IMPOSSIBLE_TO_VALIDATE',
  ValidationIndeterminated = 'VALIDATION_INDETERMINATED',
  ValidationInvalid = 'VALIDATION_INVALID',
  ValidationInValidation = 'VALIDATION_IN_VALIDATION'
}

export type DocumentAcademicDocumentationSumOrderByAggregateInput = {
  validationAttempts?: InputMaybe<SortOrder>;
};

export enum DocumentAcademicDocumentationType {
  CourtDecision = 'COURT_DECISION',
  FirstCopy = 'FIRST_COPY',
  SecondCopy = 'SECOND_COPY'
}

export type DocumentAcademicDocumentationUpdateInput = {
  ChildDocuments?: InputMaybe<DocumentFinalAcademicTranscriptUpdateManyWithoutParentDocumentNestedInput>;
  ChildRevokedDocumentList?: InputMaybe<DocumentAcademicDocumentationUpdateManyWithoutParentRevokedDocumentNestedInput>;
  DocumentAcademicDocumentationSearchView?: InputMaybe<DocumentAcademicDocumentationSearchViewUpdateOneWithoutDocumentAcademicDocumentationNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentAcademicDocumentationNestedInput>;
  LinkedDegreeList?: InputMaybe<DocumentDegreeUpdateManyWithoutParentAcademicDocumentationNestedInput>;
  ParentRevokedDocument?: InputMaybe<DocumentAcademicDocumentationUpdateOneWithoutChildRevokedDocumentListNestedInput>;
  isSentToRegistrar?: InputMaybe<BoolFieldUpdateOperationsInput>;
  searchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentAcademicDocumentationStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentAcademicDocumentationTypeFieldUpdateOperationsInput>;
  validationAttempts?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentAcademicDocumentationUpdateManyMutationInput = {
  isSentToRegistrar?: InputMaybe<BoolFieldUpdateOperationsInput>;
  searchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentAcademicDocumentationStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentAcademicDocumentationTypeFieldUpdateOperationsInput>;
  validationAttempts?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentAcademicDocumentationUpdateManyWithWhereWithoutParentRevokedDocumentInput = {
  data: DocumentAcademicDocumentationUpdateManyMutationInput;
  where: DocumentAcademicDocumentationScalarWhereInput;
};

export type DocumentAcademicDocumentationUpdateManyWithoutParentRevokedDocumentNestedInput = {
  connect?: InputMaybe<Array<DocumentAcademicDocumentationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentAcademicDocumentationCreateOrConnectWithoutParentRevokedDocumentInput>>;
  create?: InputMaybe<Array<DocumentAcademicDocumentationCreateWithoutParentRevokedDocumentInput>>;
  createMany?: InputMaybe<DocumentAcademicDocumentationCreateManyParentRevokedDocumentInputEnvelope>;
  delete?: InputMaybe<Array<DocumentAcademicDocumentationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentAcademicDocumentationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentAcademicDocumentationWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentAcademicDocumentationWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentAcademicDocumentationUpdateWithWhereUniqueWithoutParentRevokedDocumentInput>>;
  updateMany?: InputMaybe<Array<DocumentAcademicDocumentationUpdateManyWithWhereWithoutParentRevokedDocumentInput>>;
  upsert?: InputMaybe<Array<DocumentAcademicDocumentationUpsertWithWhereUniqueWithoutParentRevokedDocumentInput>>;
};

export type DocumentAcademicDocumentationUpdateOneRequiredWithoutDocumentAcademicDocumentationSearchViewNestedInput = {
  connect?: InputMaybe<DocumentAcademicDocumentationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentAcademicDocumentationCreateOrConnectWithoutDocumentAcademicDocumentationSearchViewInput>;
  create?: InputMaybe<DocumentAcademicDocumentationCreateWithoutDocumentAcademicDocumentationSearchViewInput>;
  update?: InputMaybe<DocumentAcademicDocumentationUpdateToOneWithWhereWithoutDocumentAcademicDocumentationSearchViewInput>;
  upsert?: InputMaybe<DocumentAcademicDocumentationUpsertWithoutDocumentAcademicDocumentationSearchViewInput>;
};

export type DocumentAcademicDocumentationUpdateOneWithoutChildDocumentsNestedInput = {
  connect?: InputMaybe<DocumentAcademicDocumentationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentAcademicDocumentationCreateOrConnectWithoutChildDocumentsInput>;
  create?: InputMaybe<DocumentAcademicDocumentationCreateWithoutChildDocumentsInput>;
  delete?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
  disconnect?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
  update?: InputMaybe<DocumentAcademicDocumentationUpdateToOneWithWhereWithoutChildDocumentsInput>;
  upsert?: InputMaybe<DocumentAcademicDocumentationUpsertWithoutChildDocumentsInput>;
};

export type DocumentAcademicDocumentationUpdateOneWithoutChildRevokedDocumentListNestedInput = {
  connect?: InputMaybe<DocumentAcademicDocumentationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentAcademicDocumentationCreateOrConnectWithoutChildRevokedDocumentListInput>;
  create?: InputMaybe<DocumentAcademicDocumentationCreateWithoutChildRevokedDocumentListInput>;
  delete?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
  disconnect?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
  update?: InputMaybe<DocumentAcademicDocumentationUpdateToOneWithWhereWithoutChildRevokedDocumentListInput>;
  upsert?: InputMaybe<DocumentAcademicDocumentationUpsertWithoutChildRevokedDocumentListInput>;
};

export type DocumentAcademicDocumentationUpdateOneWithoutDocumentBaseNestedInput = {
  connect?: InputMaybe<DocumentAcademicDocumentationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentAcademicDocumentationCreateOrConnectWithoutDocumentBaseInput>;
  create?: InputMaybe<DocumentAcademicDocumentationCreateWithoutDocumentBaseInput>;
  delete?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
  disconnect?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
  update?: InputMaybe<DocumentAcademicDocumentationUpdateToOneWithWhereWithoutDocumentBaseInput>;
  upsert?: InputMaybe<DocumentAcademicDocumentationUpsertWithoutDocumentBaseInput>;
};

export type DocumentAcademicDocumentationUpdateOneWithoutLinkedDegreeListNestedInput = {
  connect?: InputMaybe<DocumentAcademicDocumentationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentAcademicDocumentationCreateOrConnectWithoutLinkedDegreeListInput>;
  create?: InputMaybe<DocumentAcademicDocumentationCreateWithoutLinkedDegreeListInput>;
  delete?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
  disconnect?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
  update?: InputMaybe<DocumentAcademicDocumentationUpdateToOneWithWhereWithoutLinkedDegreeListInput>;
  upsert?: InputMaybe<DocumentAcademicDocumentationUpsertWithoutLinkedDegreeListInput>;
};

export type DocumentAcademicDocumentationUpdateToOneWithWhereWithoutChildDocumentsInput = {
  data: DocumentAcademicDocumentationUpdateWithoutChildDocumentsInput;
  where?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
};

export type DocumentAcademicDocumentationUpdateToOneWithWhereWithoutChildRevokedDocumentListInput = {
  data: DocumentAcademicDocumentationUpdateWithoutChildRevokedDocumentListInput;
  where?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
};

export type DocumentAcademicDocumentationUpdateToOneWithWhereWithoutDocumentAcademicDocumentationSearchViewInput = {
  data: DocumentAcademicDocumentationUpdateWithoutDocumentAcademicDocumentationSearchViewInput;
  where?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
};

export type DocumentAcademicDocumentationUpdateToOneWithWhereWithoutDocumentBaseInput = {
  data: DocumentAcademicDocumentationUpdateWithoutDocumentBaseInput;
  where?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
};

export type DocumentAcademicDocumentationUpdateToOneWithWhereWithoutLinkedDegreeListInput = {
  data: DocumentAcademicDocumentationUpdateWithoutLinkedDegreeListInput;
  where?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
};

export type DocumentAcademicDocumentationUpdateWithWhereUniqueWithoutParentRevokedDocumentInput = {
  data: DocumentAcademicDocumentationUpdateWithoutParentRevokedDocumentInput;
  where: DocumentAcademicDocumentationWhereUniqueInput;
};

export type DocumentAcademicDocumentationUpdateWithoutChildDocumentsInput = {
  ChildRevokedDocumentList?: InputMaybe<DocumentAcademicDocumentationUpdateManyWithoutParentRevokedDocumentNestedInput>;
  DocumentAcademicDocumentationSearchView?: InputMaybe<DocumentAcademicDocumentationSearchViewUpdateOneWithoutDocumentAcademicDocumentationNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentAcademicDocumentationNestedInput>;
  LinkedDegreeList?: InputMaybe<DocumentDegreeUpdateManyWithoutParentAcademicDocumentationNestedInput>;
  ParentRevokedDocument?: InputMaybe<DocumentAcademicDocumentationUpdateOneWithoutChildRevokedDocumentListNestedInput>;
  isSentToRegistrar?: InputMaybe<BoolFieldUpdateOperationsInput>;
  searchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentAcademicDocumentationStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentAcademicDocumentationTypeFieldUpdateOperationsInput>;
  validationAttempts?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentAcademicDocumentationUpdateWithoutChildRevokedDocumentListInput = {
  ChildDocuments?: InputMaybe<DocumentFinalAcademicTranscriptUpdateManyWithoutParentDocumentNestedInput>;
  DocumentAcademicDocumentationSearchView?: InputMaybe<DocumentAcademicDocumentationSearchViewUpdateOneWithoutDocumentAcademicDocumentationNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentAcademicDocumentationNestedInput>;
  LinkedDegreeList?: InputMaybe<DocumentDegreeUpdateManyWithoutParentAcademicDocumentationNestedInput>;
  ParentRevokedDocument?: InputMaybe<DocumentAcademicDocumentationUpdateOneWithoutChildRevokedDocumentListNestedInput>;
  isSentToRegistrar?: InputMaybe<BoolFieldUpdateOperationsInput>;
  searchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentAcademicDocumentationStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentAcademicDocumentationTypeFieldUpdateOperationsInput>;
  validationAttempts?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentAcademicDocumentationUpdateWithoutDocumentAcademicDocumentationSearchViewInput = {
  ChildDocuments?: InputMaybe<DocumentFinalAcademicTranscriptUpdateManyWithoutParentDocumentNestedInput>;
  ChildRevokedDocumentList?: InputMaybe<DocumentAcademicDocumentationUpdateManyWithoutParentRevokedDocumentNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentAcademicDocumentationNestedInput>;
  LinkedDegreeList?: InputMaybe<DocumentDegreeUpdateManyWithoutParentAcademicDocumentationNestedInput>;
  ParentRevokedDocument?: InputMaybe<DocumentAcademicDocumentationUpdateOneWithoutChildRevokedDocumentListNestedInput>;
  isSentToRegistrar?: InputMaybe<BoolFieldUpdateOperationsInput>;
  searchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentAcademicDocumentationStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentAcademicDocumentationTypeFieldUpdateOperationsInput>;
  validationAttempts?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentAcademicDocumentationUpdateWithoutDocumentBaseInput = {
  ChildDocuments?: InputMaybe<DocumentFinalAcademicTranscriptUpdateManyWithoutParentDocumentNestedInput>;
  ChildRevokedDocumentList?: InputMaybe<DocumentAcademicDocumentationUpdateManyWithoutParentRevokedDocumentNestedInput>;
  DocumentAcademicDocumentationSearchView?: InputMaybe<DocumentAcademicDocumentationSearchViewUpdateOneWithoutDocumentAcademicDocumentationNestedInput>;
  LinkedDegreeList?: InputMaybe<DocumentDegreeUpdateManyWithoutParentAcademicDocumentationNestedInput>;
  ParentRevokedDocument?: InputMaybe<DocumentAcademicDocumentationUpdateOneWithoutChildRevokedDocumentListNestedInput>;
  isSentToRegistrar?: InputMaybe<BoolFieldUpdateOperationsInput>;
  searchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentAcademicDocumentationStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentAcademicDocumentationTypeFieldUpdateOperationsInput>;
  validationAttempts?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentAcademicDocumentationUpdateWithoutLinkedDegreeListInput = {
  ChildDocuments?: InputMaybe<DocumentFinalAcademicTranscriptUpdateManyWithoutParentDocumentNestedInput>;
  ChildRevokedDocumentList?: InputMaybe<DocumentAcademicDocumentationUpdateManyWithoutParentRevokedDocumentNestedInput>;
  DocumentAcademicDocumentationSearchView?: InputMaybe<DocumentAcademicDocumentationSearchViewUpdateOneWithoutDocumentAcademicDocumentationNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentAcademicDocumentationNestedInput>;
  ParentRevokedDocument?: InputMaybe<DocumentAcademicDocumentationUpdateOneWithoutChildRevokedDocumentListNestedInput>;
  isSentToRegistrar?: InputMaybe<BoolFieldUpdateOperationsInput>;
  searchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentAcademicDocumentationStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentAcademicDocumentationTypeFieldUpdateOperationsInput>;
  validationAttempts?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentAcademicDocumentationUpdateWithoutParentRevokedDocumentInput = {
  ChildDocuments?: InputMaybe<DocumentFinalAcademicTranscriptUpdateManyWithoutParentDocumentNestedInput>;
  ChildRevokedDocumentList?: InputMaybe<DocumentAcademicDocumentationUpdateManyWithoutParentRevokedDocumentNestedInput>;
  DocumentAcademicDocumentationSearchView?: InputMaybe<DocumentAcademicDocumentationSearchViewUpdateOneWithoutDocumentAcademicDocumentationNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentAcademicDocumentationNestedInput>;
  LinkedDegreeList?: InputMaybe<DocumentDegreeUpdateManyWithoutParentAcademicDocumentationNestedInput>;
  isSentToRegistrar?: InputMaybe<BoolFieldUpdateOperationsInput>;
  searchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentAcademicDocumentationStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentAcademicDocumentationTypeFieldUpdateOperationsInput>;
  validationAttempts?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentAcademicDocumentationUpsertWithWhereUniqueWithoutParentRevokedDocumentInput = {
  create: DocumentAcademicDocumentationCreateWithoutParentRevokedDocumentInput;
  update: DocumentAcademicDocumentationUpdateWithoutParentRevokedDocumentInput;
  where: DocumentAcademicDocumentationWhereUniqueInput;
};

export type DocumentAcademicDocumentationUpsertWithoutChildDocumentsInput = {
  create: DocumentAcademicDocumentationCreateWithoutChildDocumentsInput;
  update: DocumentAcademicDocumentationUpdateWithoutChildDocumentsInput;
  where?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
};

export type DocumentAcademicDocumentationUpsertWithoutChildRevokedDocumentListInput = {
  create: DocumentAcademicDocumentationCreateWithoutChildRevokedDocumentListInput;
  update: DocumentAcademicDocumentationUpdateWithoutChildRevokedDocumentListInput;
  where?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
};

export type DocumentAcademicDocumentationUpsertWithoutDocumentAcademicDocumentationSearchViewInput = {
  create: DocumentAcademicDocumentationCreateWithoutDocumentAcademicDocumentationSearchViewInput;
  update: DocumentAcademicDocumentationUpdateWithoutDocumentAcademicDocumentationSearchViewInput;
  where?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
};

export type DocumentAcademicDocumentationUpsertWithoutDocumentBaseInput = {
  create: DocumentAcademicDocumentationCreateWithoutDocumentBaseInput;
  update: DocumentAcademicDocumentationUpdateWithoutDocumentBaseInput;
  where?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
};

export type DocumentAcademicDocumentationUpsertWithoutLinkedDegreeListInput = {
  create: DocumentAcademicDocumentationCreateWithoutLinkedDegreeListInput;
  update: DocumentAcademicDocumentationUpdateWithoutLinkedDegreeListInput;
  where?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
};

export type DocumentAcademicDocumentationWhereInput = {
  AND?: InputMaybe<Array<DocumentAcademicDocumentationWhereInput>>;
  ChildDocuments?: InputMaybe<DocumentFinalAcademicTranscriptListRelationFilter>;
  ChildRevokedDocumentList?: InputMaybe<DocumentAcademicDocumentationListRelationFilter>;
  DocumentAcademicDocumentationSearchView?: InputMaybe<DocumentAcademicDocumentationSearchViewWhereInput>;
  DocumentBase?: InputMaybe<DocumentBaseWhereInput>;
  LinkedDegreeList?: InputMaybe<DocumentDegreeListRelationFilter>;
  NOT?: InputMaybe<Array<DocumentAcademicDocumentationWhereInput>>;
  OR?: InputMaybe<Array<DocumentAcademicDocumentationWhereInput>>;
  ParentRevokedDocument?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
  documentBaseId?: InputMaybe<StringFilter>;
  isSentToRegistrar?: InputMaybe<BoolFilter>;
  parentRevokedDocumentId?: InputMaybe<StringNullableFilter>;
  searchCPF?: InputMaybe<StringFilter>;
  searchCourse?: InputMaybe<StringFilter>;
  searchEmecCode?: InputMaybe<StringFilter>;
  searchStudentName?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumDocumentAcademicDocumentationStatusFilter>;
  type?: InputMaybe<EnumDocumentAcademicDocumentationTypeFilter>;
  validationAttempts?: InputMaybe<IntFilter>;
};

export type DocumentAcademicDocumentationWhereUniqueInput = {
  AND?: InputMaybe<Array<DocumentAcademicDocumentationWhereInput>>;
  ChildDocuments?: InputMaybe<DocumentFinalAcademicTranscriptListRelationFilter>;
  ChildRevokedDocumentList?: InputMaybe<DocumentAcademicDocumentationListRelationFilter>;
  DocumentAcademicDocumentationSearchView?: InputMaybe<DocumentAcademicDocumentationSearchViewWhereInput>;
  DocumentBase?: InputMaybe<DocumentBaseWhereInput>;
  LinkedDegreeList?: InputMaybe<DocumentDegreeListRelationFilter>;
  NOT?: InputMaybe<Array<DocumentAcademicDocumentationWhereInput>>;
  OR?: InputMaybe<Array<DocumentAcademicDocumentationWhereInput>>;
  ParentRevokedDocument?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
  documentBaseId?: InputMaybe<Scalars['String']['input']>;
  isSentToRegistrar?: InputMaybe<BoolFilter>;
  parentRevokedDocumentId?: InputMaybe<StringNullableFilter>;
  searchCPF?: InputMaybe<StringFilter>;
  searchCourse?: InputMaybe<StringFilter>;
  searchEmecCode?: InputMaybe<StringFilter>;
  searchStudentName?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumDocumentAcademicDocumentationStatusFilter>;
  type?: InputMaybe<EnumDocumentAcademicDocumentationTypeFilter>;
  validationAttempts?: InputMaybe<IntFilter>;
};

export type DocumentAuditFileIssuer = {
  __typename?: 'DocumentAuditFileIssuer';
  Degrees: Array<DocumentAuditFileIssuerDegreeItem>;
  DocumentBase: DocumentBase;
  documentBaseId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  searchAuditEndDate: Scalars['String']['output'];
  searchAuditStartDate: Scalars['String']['output'];
  status: DocumentAuditFileIssuerStatus;
};


export type DocumentAuditFileIssuerDegreesArgs = {
  cursor?: InputMaybe<DocumentAuditFileIssuerDegreeItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentAuditFileIssuerDegreeItemWhereInput>;
};

export type DocumentAuditFileIssuerCountOrderByAggregateInput = {
  documentBaseId?: InputMaybe<SortOrder>;
  searchAuditEndDate?: InputMaybe<SortOrder>;
  searchAuditStartDate?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type DocumentAuditFileIssuerCreateInput = {
  Degrees?: InputMaybe<DocumentAuditFileIssuerDegreeItemCreateNestedManyWithoutDocumentAuditFileIssuerInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentAuditFileIssuerInput;
  searchAuditEndDate: Scalars['DateTime']['input'];
  searchAuditStartDate: Scalars['DateTime']['input'];
  status?: InputMaybe<DocumentAuditFileIssuerStatus>;
};

export type DocumentAuditFileIssuerCreateManyInput = {
  documentBaseId: Scalars['String']['input'];
  searchAuditEndDate: Scalars['DateTime']['input'];
  searchAuditStartDate: Scalars['DateTime']['input'];
  status?: InputMaybe<DocumentAuditFileIssuerStatus>;
};

export type DocumentAuditFileIssuerCreateNestedOneWithoutDegreesInput = {
  connect?: InputMaybe<DocumentAuditFileIssuerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentAuditFileIssuerCreateOrConnectWithoutDegreesInput>;
  create?: InputMaybe<DocumentAuditFileIssuerCreateWithoutDegreesInput>;
};

export type DocumentAuditFileIssuerCreateNestedOneWithoutDocumentBaseInput = {
  connect?: InputMaybe<DocumentAuditFileIssuerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentAuditFileIssuerCreateOrConnectWithoutDocumentBaseInput>;
  create?: InputMaybe<DocumentAuditFileIssuerCreateWithoutDocumentBaseInput>;
};

export type DocumentAuditFileIssuerCreateOrConnectWithoutDegreesInput = {
  create: DocumentAuditFileIssuerCreateWithoutDegreesInput;
  where: DocumentAuditFileIssuerWhereUniqueInput;
};

export type DocumentAuditFileIssuerCreateOrConnectWithoutDocumentBaseInput = {
  create: DocumentAuditFileIssuerCreateWithoutDocumentBaseInput;
  where: DocumentAuditFileIssuerWhereUniqueInput;
};

export type DocumentAuditFileIssuerCreateWithoutDegreesInput = {
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentAuditFileIssuerInput;
  searchAuditEndDate: Scalars['DateTime']['input'];
  searchAuditStartDate: Scalars['DateTime']['input'];
  status?: InputMaybe<DocumentAuditFileIssuerStatus>;
};

export type DocumentAuditFileIssuerCreateWithoutDocumentBaseInput = {
  Degrees?: InputMaybe<DocumentAuditFileIssuerDegreeItemCreateNestedManyWithoutDocumentAuditFileIssuerInput>;
  searchAuditEndDate: Scalars['DateTime']['input'];
  searchAuditStartDate: Scalars['DateTime']['input'];
  status?: InputMaybe<DocumentAuditFileIssuerStatus>;
};

export type DocumentAuditFileIssuerDegreeItem = {
  __typename?: 'DocumentAuditFileIssuerDegreeItem';
  DocumentAuditFileIssuer: DocumentAuditFileIssuer;
  DocumentDegree: DocumentDegree;
  documentAuditFileIssuerDocumentBaseId: Scalars['String']['output'];
  documentDegreeDocumentBaseId: Scalars['String']['output'];
};

export type DocumentAuditFileIssuerDegreeItemCountOrderByAggregateInput = {
  documentAuditFileIssuerDocumentBaseId?: InputMaybe<SortOrder>;
  documentDegreeDocumentBaseId?: InputMaybe<SortOrder>;
};

export type DocumentAuditFileIssuerDegreeItemCreateInput = {
  DocumentAuditFileIssuer: DocumentAuditFileIssuerCreateNestedOneWithoutDegreesInput;
  DocumentDegree: DocumentDegreeCreateNestedOneWithoutDocumentAuditFileIssuersInput;
};

export type DocumentAuditFileIssuerDegreeItemCreateManyDocumentAuditFileIssuerInput = {
  documentDegreeDocumentBaseId: Scalars['String']['input'];
};

export type DocumentAuditFileIssuerDegreeItemCreateManyDocumentAuditFileIssuerInputEnvelope = {
  data: Array<DocumentAuditFileIssuerDegreeItemCreateManyDocumentAuditFileIssuerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentAuditFileIssuerDegreeItemCreateManyDocumentDegreeInput = {
  documentAuditFileIssuerDocumentBaseId: Scalars['String']['input'];
};

export type DocumentAuditFileIssuerDegreeItemCreateManyDocumentDegreeInputEnvelope = {
  data: Array<DocumentAuditFileIssuerDegreeItemCreateManyDocumentDegreeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentAuditFileIssuerDegreeItemCreateManyInput = {
  documentAuditFileIssuerDocumentBaseId: Scalars['String']['input'];
  documentDegreeDocumentBaseId: Scalars['String']['input'];
};

export type DocumentAuditFileIssuerDegreeItemCreateNestedManyWithoutDocumentAuditFileIssuerInput = {
  connect?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemCreateOrConnectWithoutDocumentAuditFileIssuerInput>>;
  create?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemCreateWithoutDocumentAuditFileIssuerInput>>;
  createMany?: InputMaybe<DocumentAuditFileIssuerDegreeItemCreateManyDocumentAuditFileIssuerInputEnvelope>;
};

export type DocumentAuditFileIssuerDegreeItemCreateNestedManyWithoutDocumentDegreeInput = {
  connect?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemCreateOrConnectWithoutDocumentDegreeInput>>;
  create?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemCreateWithoutDocumentDegreeInput>>;
  createMany?: InputMaybe<DocumentAuditFileIssuerDegreeItemCreateManyDocumentDegreeInputEnvelope>;
};

export type DocumentAuditFileIssuerDegreeItemCreateOrConnectWithoutDocumentAuditFileIssuerInput = {
  create: DocumentAuditFileIssuerDegreeItemCreateWithoutDocumentAuditFileIssuerInput;
  where: DocumentAuditFileIssuerDegreeItemWhereUniqueInput;
};

export type DocumentAuditFileIssuerDegreeItemCreateOrConnectWithoutDocumentDegreeInput = {
  create: DocumentAuditFileIssuerDegreeItemCreateWithoutDocumentDegreeInput;
  where: DocumentAuditFileIssuerDegreeItemWhereUniqueInput;
};

export type DocumentAuditFileIssuerDegreeItemCreateWithoutDocumentAuditFileIssuerInput = {
  DocumentDegree: DocumentDegreeCreateNestedOneWithoutDocumentAuditFileIssuersInput;
};

export type DocumentAuditFileIssuerDegreeItemCreateWithoutDocumentDegreeInput = {
  DocumentAuditFileIssuer: DocumentAuditFileIssuerCreateNestedOneWithoutDegreesInput;
};

export type DocumentAuditFileIssuerDegreeItemDocumentAuditFileIssuerDocumentBaseIdDocumentDegreeDocumentBaseIdCompoundUniqueInput = {
  documentAuditFileIssuerDocumentBaseId: Scalars['String']['input'];
  documentDegreeDocumentBaseId: Scalars['String']['input'];
};

export type DocumentAuditFileIssuerDegreeItemListRelationFilter = {
  every?: InputMaybe<DocumentAuditFileIssuerDegreeItemWhereInput>;
  none?: InputMaybe<DocumentAuditFileIssuerDegreeItemWhereInput>;
  some?: InputMaybe<DocumentAuditFileIssuerDegreeItemWhereInput>;
};

export type DocumentAuditFileIssuerDegreeItemMaxOrderByAggregateInput = {
  documentAuditFileIssuerDocumentBaseId?: InputMaybe<SortOrder>;
  documentDegreeDocumentBaseId?: InputMaybe<SortOrder>;
};

export type DocumentAuditFileIssuerDegreeItemMinOrderByAggregateInput = {
  documentAuditFileIssuerDocumentBaseId?: InputMaybe<SortOrder>;
  documentDegreeDocumentBaseId?: InputMaybe<SortOrder>;
};

export type DocumentAuditFileIssuerDegreeItemOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DocumentAuditFileIssuerDegreeItemOrderByWithAggregationInput = {
  _count?: InputMaybe<DocumentAuditFileIssuerDegreeItemCountOrderByAggregateInput>;
  _max?: InputMaybe<DocumentAuditFileIssuerDegreeItemMaxOrderByAggregateInput>;
  _min?: InputMaybe<DocumentAuditFileIssuerDegreeItemMinOrderByAggregateInput>;
  documentAuditFileIssuerDocumentBaseId?: InputMaybe<SortOrder>;
  documentDegreeDocumentBaseId?: InputMaybe<SortOrder>;
};

export type DocumentAuditFileIssuerDegreeItemOrderByWithRelationInput = {
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerOrderByWithRelationInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeOrderByWithRelationInput>;
  documentAuditFileIssuerDocumentBaseId?: InputMaybe<SortOrder>;
  documentDegreeDocumentBaseId?: InputMaybe<SortOrder>;
};

export enum DocumentAuditFileIssuerDegreeItemScalarFieldEnum {
  DocumentAuditFileIssuerDocumentBaseId = 'documentAuditFileIssuerDocumentBaseId',
  DocumentDegreeDocumentBaseId = 'documentDegreeDocumentBaseId'
}

export type DocumentAuditFileIssuerDegreeItemScalarWhereInput = {
  AND?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemScalarWhereInput>>;
  NOT?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemScalarWhereInput>>;
  OR?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemScalarWhereInput>>;
  documentAuditFileIssuerDocumentBaseId?: InputMaybe<StringFilter>;
  documentDegreeDocumentBaseId?: InputMaybe<StringFilter>;
};

export type DocumentAuditFileIssuerDegreeItemScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemScalarWhereWithAggregatesInput>>;
  documentAuditFileIssuerDocumentBaseId?: InputMaybe<StringWithAggregatesFilter>;
  documentDegreeDocumentBaseId?: InputMaybe<StringWithAggregatesFilter>;
};

export type DocumentAuditFileIssuerDegreeItemUpdateInput = {
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerUpdateOneRequiredWithoutDegreesNestedInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeUpdateOneRequiredWithoutDocumentAuditFileIssuersNestedInput>;
};

export type DocumentAuditFileIssuerDegreeItemUpdateManyMutationInput = {
  _?: InputMaybe<Scalars['NEVER']['input']>;
};

export type DocumentAuditFileIssuerDegreeItemUpdateManyWithWhereWithoutDocumentAuditFileIssuerInput = {
  data: DocumentAuditFileIssuerDegreeItemUpdateManyMutationInput;
  where: DocumentAuditFileIssuerDegreeItemScalarWhereInput;
};

export type DocumentAuditFileIssuerDegreeItemUpdateManyWithWhereWithoutDocumentDegreeInput = {
  data: DocumentAuditFileIssuerDegreeItemUpdateManyMutationInput;
  where: DocumentAuditFileIssuerDegreeItemScalarWhereInput;
};

export type DocumentAuditFileIssuerDegreeItemUpdateManyWithoutDocumentAuditFileIssuerNestedInput = {
  connect?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemCreateOrConnectWithoutDocumentAuditFileIssuerInput>>;
  create?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemCreateWithoutDocumentAuditFileIssuerInput>>;
  createMany?: InputMaybe<DocumentAuditFileIssuerDegreeItemCreateManyDocumentAuditFileIssuerInputEnvelope>;
  delete?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemUpdateWithWhereUniqueWithoutDocumentAuditFileIssuerInput>>;
  updateMany?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemUpdateManyWithWhereWithoutDocumentAuditFileIssuerInput>>;
  upsert?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemUpsertWithWhereUniqueWithoutDocumentAuditFileIssuerInput>>;
};

export type DocumentAuditFileIssuerDegreeItemUpdateManyWithoutDocumentDegreeNestedInput = {
  connect?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemCreateOrConnectWithoutDocumentDegreeInput>>;
  create?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemCreateWithoutDocumentDegreeInput>>;
  createMany?: InputMaybe<DocumentAuditFileIssuerDegreeItemCreateManyDocumentDegreeInputEnvelope>;
  delete?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemUpdateWithWhereUniqueWithoutDocumentDegreeInput>>;
  updateMany?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemUpdateManyWithWhereWithoutDocumentDegreeInput>>;
  upsert?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemUpsertWithWhereUniqueWithoutDocumentDegreeInput>>;
};

export type DocumentAuditFileIssuerDegreeItemUpdateWithWhereUniqueWithoutDocumentAuditFileIssuerInput = {
  data: DocumentAuditFileIssuerDegreeItemUpdateWithoutDocumentAuditFileIssuerInput;
  where: DocumentAuditFileIssuerDegreeItemWhereUniqueInput;
};

export type DocumentAuditFileIssuerDegreeItemUpdateWithWhereUniqueWithoutDocumentDegreeInput = {
  data: DocumentAuditFileIssuerDegreeItemUpdateWithoutDocumentDegreeInput;
  where: DocumentAuditFileIssuerDegreeItemWhereUniqueInput;
};

export type DocumentAuditFileIssuerDegreeItemUpdateWithoutDocumentAuditFileIssuerInput = {
  DocumentDegree?: InputMaybe<DocumentDegreeUpdateOneRequiredWithoutDocumentAuditFileIssuersNestedInput>;
};

export type DocumentAuditFileIssuerDegreeItemUpdateWithoutDocumentDegreeInput = {
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerUpdateOneRequiredWithoutDegreesNestedInput>;
};

export type DocumentAuditFileIssuerDegreeItemUpsertWithWhereUniqueWithoutDocumentAuditFileIssuerInput = {
  create: DocumentAuditFileIssuerDegreeItemCreateWithoutDocumentAuditFileIssuerInput;
  update: DocumentAuditFileIssuerDegreeItemUpdateWithoutDocumentAuditFileIssuerInput;
  where: DocumentAuditFileIssuerDegreeItemWhereUniqueInput;
};

export type DocumentAuditFileIssuerDegreeItemUpsertWithWhereUniqueWithoutDocumentDegreeInput = {
  create: DocumentAuditFileIssuerDegreeItemCreateWithoutDocumentDegreeInput;
  update: DocumentAuditFileIssuerDegreeItemUpdateWithoutDocumentDegreeInput;
  where: DocumentAuditFileIssuerDegreeItemWhereUniqueInput;
};

export type DocumentAuditFileIssuerDegreeItemWhereInput = {
  AND?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemWhereInput>>;
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerWhereInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeWhereInput>;
  NOT?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemWhereInput>>;
  OR?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemWhereInput>>;
  documentAuditFileIssuerDocumentBaseId?: InputMaybe<StringFilter>;
  documentDegreeDocumentBaseId?: InputMaybe<StringFilter>;
};

export type DocumentAuditFileIssuerDegreeItemWhereUniqueInput = {
  AND?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemWhereInput>>;
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerWhereInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeWhereInput>;
  NOT?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemWhereInput>>;
  OR?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemWhereInput>>;
  documentAuditFileIssuerDocumentBaseId?: InputMaybe<StringFilter>;
  documentAuditFileIssuerDocumentBaseId_documentDegreeDocumentBaseId?: InputMaybe<DocumentAuditFileIssuerDegreeItemDocumentAuditFileIssuerDocumentBaseIdDocumentDegreeDocumentBaseIdCompoundUniqueInput>;
  documentDegreeDocumentBaseId?: InputMaybe<StringFilter>;
};

export type DocumentAuditFileIssuerMaxOrderByAggregateInput = {
  documentBaseId?: InputMaybe<SortOrder>;
  searchAuditEndDate?: InputMaybe<SortOrder>;
  searchAuditStartDate?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type DocumentAuditFileIssuerMinOrderByAggregateInput = {
  documentBaseId?: InputMaybe<SortOrder>;
  searchAuditEndDate?: InputMaybe<SortOrder>;
  searchAuditStartDate?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type DocumentAuditFileIssuerNullableRelationFilter = {
  is?: InputMaybe<DocumentAuditFileIssuerWhereInput>;
  isNot?: InputMaybe<DocumentAuditFileIssuerWhereInput>;
};

export type DocumentAuditFileIssuerOrderByWithAggregationInput = {
  _count?: InputMaybe<DocumentAuditFileIssuerCountOrderByAggregateInput>;
  _max?: InputMaybe<DocumentAuditFileIssuerMaxOrderByAggregateInput>;
  _min?: InputMaybe<DocumentAuditFileIssuerMinOrderByAggregateInput>;
  documentBaseId?: InputMaybe<SortOrder>;
  searchAuditEndDate?: InputMaybe<SortOrder>;
  searchAuditStartDate?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type DocumentAuditFileIssuerOrderByWithRelationInput = {
  Degrees?: InputMaybe<DocumentAuditFileIssuerDegreeItemOrderByRelationAggregateInput>;
  DocumentBase?: InputMaybe<DocumentBaseOrderByWithRelationInput>;
  documentBaseId?: InputMaybe<SortOrder>;
  searchAuditEndDate?: InputMaybe<SortOrder>;
  searchAuditStartDate?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type DocumentAuditFileIssuerRelationFilter = {
  is?: InputMaybe<DocumentAuditFileIssuerWhereInput>;
  isNot?: InputMaybe<DocumentAuditFileIssuerWhereInput>;
};

export enum DocumentAuditFileIssuerScalarFieldEnum {
  DocumentBaseId = 'documentBaseId',
  SearchAuditEndDate = 'searchAuditEndDate',
  SearchAuditStartDate = 'searchAuditStartDate',
  Status = 'status'
}

export type DocumentAuditFileIssuerScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DocumentAuditFileIssuerScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DocumentAuditFileIssuerScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DocumentAuditFileIssuerScalarWhereWithAggregatesInput>>;
  documentBaseId?: InputMaybe<StringWithAggregatesFilter>;
  searchAuditEndDate?: InputMaybe<DateTimeWithAggregatesFilter>;
  searchAuditStartDate?: InputMaybe<DateTimeWithAggregatesFilter>;
  status?: InputMaybe<EnumDocumentAuditFileIssuerStatusWithAggregatesFilter>;
};

export enum DocumentAuditFileIssuerStatus {
  Invalid = 'INVALID',
  InCorrection = 'IN_CORRECTION',
  InSignature = 'IN_SIGNATURE',
  InValidation = 'IN_VALIDATION',
  Issued = 'ISSUED',
  PendingReview = 'PENDING_REVIEW',
  Revoked = 'REVOKED'
}

export type DocumentAuditFileIssuerUpdateInput = {
  Degrees?: InputMaybe<DocumentAuditFileIssuerDegreeItemUpdateManyWithoutDocumentAuditFileIssuerNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentAuditFileIssuerNestedInput>;
  searchAuditEndDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  searchAuditStartDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentAuditFileIssuerStatusFieldUpdateOperationsInput>;
};

export type DocumentAuditFileIssuerUpdateManyMutationInput = {
  searchAuditEndDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  searchAuditStartDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentAuditFileIssuerStatusFieldUpdateOperationsInput>;
};

export type DocumentAuditFileIssuerUpdateOneRequiredWithoutDegreesNestedInput = {
  connect?: InputMaybe<DocumentAuditFileIssuerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentAuditFileIssuerCreateOrConnectWithoutDegreesInput>;
  create?: InputMaybe<DocumentAuditFileIssuerCreateWithoutDegreesInput>;
  update?: InputMaybe<DocumentAuditFileIssuerUpdateToOneWithWhereWithoutDegreesInput>;
  upsert?: InputMaybe<DocumentAuditFileIssuerUpsertWithoutDegreesInput>;
};

export type DocumentAuditFileIssuerUpdateOneWithoutDocumentBaseNestedInput = {
  connect?: InputMaybe<DocumentAuditFileIssuerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentAuditFileIssuerCreateOrConnectWithoutDocumentBaseInput>;
  create?: InputMaybe<DocumentAuditFileIssuerCreateWithoutDocumentBaseInput>;
  delete?: InputMaybe<DocumentAuditFileIssuerWhereInput>;
  disconnect?: InputMaybe<DocumentAuditFileIssuerWhereInput>;
  update?: InputMaybe<DocumentAuditFileIssuerUpdateToOneWithWhereWithoutDocumentBaseInput>;
  upsert?: InputMaybe<DocumentAuditFileIssuerUpsertWithoutDocumentBaseInput>;
};

export type DocumentAuditFileIssuerUpdateToOneWithWhereWithoutDegreesInput = {
  data: DocumentAuditFileIssuerUpdateWithoutDegreesInput;
  where?: InputMaybe<DocumentAuditFileIssuerWhereInput>;
};

export type DocumentAuditFileIssuerUpdateToOneWithWhereWithoutDocumentBaseInput = {
  data: DocumentAuditFileIssuerUpdateWithoutDocumentBaseInput;
  where?: InputMaybe<DocumentAuditFileIssuerWhereInput>;
};

export type DocumentAuditFileIssuerUpdateWithoutDegreesInput = {
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentAuditFileIssuerNestedInput>;
  searchAuditEndDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  searchAuditStartDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentAuditFileIssuerStatusFieldUpdateOperationsInput>;
};

export type DocumentAuditFileIssuerUpdateWithoutDocumentBaseInput = {
  Degrees?: InputMaybe<DocumentAuditFileIssuerDegreeItemUpdateManyWithoutDocumentAuditFileIssuerNestedInput>;
  searchAuditEndDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  searchAuditStartDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentAuditFileIssuerStatusFieldUpdateOperationsInput>;
};

export type DocumentAuditFileIssuerUpsertWithoutDegreesInput = {
  create: DocumentAuditFileIssuerCreateWithoutDegreesInput;
  update: DocumentAuditFileIssuerUpdateWithoutDegreesInput;
  where?: InputMaybe<DocumentAuditFileIssuerWhereInput>;
};

export type DocumentAuditFileIssuerUpsertWithoutDocumentBaseInput = {
  create: DocumentAuditFileIssuerCreateWithoutDocumentBaseInput;
  update: DocumentAuditFileIssuerUpdateWithoutDocumentBaseInput;
  where?: InputMaybe<DocumentAuditFileIssuerWhereInput>;
};

export type DocumentAuditFileIssuerWhereInput = {
  AND?: InputMaybe<Array<DocumentAuditFileIssuerWhereInput>>;
  Degrees?: InputMaybe<DocumentAuditFileIssuerDegreeItemListRelationFilter>;
  DocumentBase?: InputMaybe<DocumentBaseWhereInput>;
  NOT?: InputMaybe<Array<DocumentAuditFileIssuerWhereInput>>;
  OR?: InputMaybe<Array<DocumentAuditFileIssuerWhereInput>>;
  documentBaseId?: InputMaybe<StringFilter>;
  searchAuditEndDate?: InputMaybe<DateTimeFilter>;
  searchAuditStartDate?: InputMaybe<DateTimeFilter>;
  status?: InputMaybe<EnumDocumentAuditFileIssuerStatusFilter>;
};

export type DocumentAuditFileIssuerWhereUniqueInput = {
  AND?: InputMaybe<Array<DocumentAuditFileIssuerWhereInput>>;
  Degrees?: InputMaybe<DocumentAuditFileIssuerDegreeItemListRelationFilter>;
  DocumentBase?: InputMaybe<DocumentBaseWhereInput>;
  NOT?: InputMaybe<Array<DocumentAuditFileIssuerWhereInput>>;
  OR?: InputMaybe<Array<DocumentAuditFileIssuerWhereInput>>;
  documentBaseId?: InputMaybe<Scalars['String']['input']>;
  searchAuditEndDate?: InputMaybe<DateTimeFilter>;
  searchAuditStartDate?: InputMaybe<DateTimeFilter>;
  status?: InputMaybe<EnumDocumentAuditFileIssuerStatusFilter>;
};

export type DocumentBase = {
  __typename?: 'DocumentBase';
  DocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentation>;
  DocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuer>;
  DocumentBaseSignatureInviteGroups: Array<DocumentBaseSignatureInviteGroup>;
  DocumentCertificate?: Maybe<DocumentCertificate>;
  DocumentDegree?: Maybe<DocumentDegree>;
  DocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscript>;
  DocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculum>;
  ExternalSignatureInvite: Array<ExternalSignatureInvite>;
  Histories: Array<DocumentBaseHistory>;
  Renotarizations: Array<DocumentRenotarization>;
  Team: Team;
  UserOwner: CommonUser;
  commonUserId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  creationType: DocumentAcademicDocumentationCreationType;
  /** JSON com diversas opções */
  data: Scalars['Json']['output'];
  /** ![PrismaJson.DocumentJson] */
  dataWithIesAndFiles: Scalars['Json']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  filePath?: Maybe<Scalars['String']['output']>;
  fileSize: Scalars['Int']['output'];
  /** Indica se o documento já possui arquivo gerado. */
  hasFile: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  internalSeqId: Scalars['String']['output'];
  signatureConfig: Array<SignatureType>;
  teamId: Scalars['Int']['output'];
  type: DocumentBaseType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** JSON com diversas opções */
  variableJson: Scalars['Json']['output'];
  /** 1.05 / 1.06 */
  version: Scalars['String']['output'];
  withoutTeamInternalSeqId: Scalars['Int']['output'];
};


export type DocumentBaseDocumentBaseSignatureInviteGroupsArgs = {
  cursor?: InputMaybe<DocumentBaseSignatureInviteGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentBaseSignatureInviteGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentBaseSignatureInviteGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentBaseSignatureInviteGroupWhereInput>;
};


export type DocumentBaseExternalSignatureInviteArgs = {
  cursor?: InputMaybe<ExternalSignatureInviteWhereUniqueInput>;
  distinct?: InputMaybe<Array<ExternalSignatureInviteScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ExternalSignatureInviteOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ExternalSignatureInviteWhereInput>;
};


export type DocumentBaseHistoriesArgs = {
  cursor?: InputMaybe<DocumentBaseHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentBaseHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentBaseHistoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentBaseHistoryWhereInput>;
};


export type DocumentBaseRenotarizationsArgs = {
  cursor?: InputMaybe<DocumentRenotarizationWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentRenotarizationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentRenotarizationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentRenotarizationWhereInput>;
};


export type DocumentBaseVariableJsonArgs = {
  clean?: InputMaybe<Scalars['Boolean']['input']>;
  coverWithMetaAndData?: InputMaybe<Scalars['Boolean']['input']>;
  removeFiles?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentBaseAvgOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  fileSize?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  withoutTeamInternalSeqId?: InputMaybe<SortOrder>;
};

export type DocumentBaseCountOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  creationType?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  filePath?: InputMaybe<SortOrder>;
  fileSize?: InputMaybe<SortOrder>;
  internalSeqId?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  version?: InputMaybe<SortOrder>;
  withoutTeamInternalSeqId?: InputMaybe<SortOrder>;
};

export type DocumentBaseCreateInput = {
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationCreateNestedOneWithoutDocumentBaseInput>;
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerCreateNestedOneWithoutDocumentBaseInput>;
  DocumentBaseSignatureInviteGroups?: InputMaybe<DocumentBaseSignatureInviteGroupCreateNestedManyWithoutDocumentBaseInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedOneWithoutDocumentBaseInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeCreateNestedOneWithoutDocumentBaseInput>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentBaseInput>;
  DocumentSchoolCurriculum?: InputMaybe<DocumentSchoolCurriculumCreateNestedOneWithoutDocumentBaseInput>;
  ExternalSignatureInvite?: InputMaybe<ExternalSignatureInviteCreateNestedManyWithoutDocumentBaseInput>;
  Histories?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutDocumentBaseInput>;
  Renotarizations?: InputMaybe<DocumentRenotarizationCreateNestedManyWithoutDocumentBaseInput>;
  Team: TeamCreateNestedOneWithoutDocumentsInput;
  UserOwner: CommonUserCreateNestedOneWithoutDocumentBaseInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creationType?: InputMaybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  internalSeqId?: InputMaybe<Scalars['String']['input']>;
  type: DocumentBaseType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  withoutTeamInternalSeqId?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentBaseCreateManyInput = {
  commonUserId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creationType?: InputMaybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  internalSeqId?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
  type: DocumentBaseType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  withoutTeamInternalSeqId?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentBaseCreateManyTeamInput = {
  commonUserId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creationType?: InputMaybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  internalSeqId?: InputMaybe<Scalars['String']['input']>;
  type: DocumentBaseType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  withoutTeamInternalSeqId?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentBaseCreateManyTeamInputEnvelope = {
  data: Array<DocumentBaseCreateManyTeamInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentBaseCreateManyUserOwnerInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creationType?: InputMaybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  internalSeqId?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
  type: DocumentBaseType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  withoutTeamInternalSeqId?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentBaseCreateManyUserOwnerInputEnvelope = {
  data: Array<DocumentBaseCreateManyUserOwnerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentBaseCreateNestedManyWithoutTeamInput = {
  connect?: InputMaybe<Array<DocumentBaseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentBaseCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<DocumentBaseCreateWithoutTeamInput>>;
  createMany?: InputMaybe<DocumentBaseCreateManyTeamInputEnvelope>;
};

export type DocumentBaseCreateNestedManyWithoutUserOwnerInput = {
  connect?: InputMaybe<Array<DocumentBaseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentBaseCreateOrConnectWithoutUserOwnerInput>>;
  create?: InputMaybe<Array<DocumentBaseCreateWithoutUserOwnerInput>>;
  createMany?: InputMaybe<DocumentBaseCreateManyUserOwnerInputEnvelope>;
};

export type DocumentBaseCreateNestedOneWithoutDocumentAcademicDocumentationInput = {
  connect?: InputMaybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseCreateOrConnectWithoutDocumentAcademicDocumentationInput>;
  create?: InputMaybe<DocumentBaseCreateWithoutDocumentAcademicDocumentationInput>;
};

export type DocumentBaseCreateNestedOneWithoutDocumentAuditFileIssuerInput = {
  connect?: InputMaybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseCreateOrConnectWithoutDocumentAuditFileIssuerInput>;
  create?: InputMaybe<DocumentBaseCreateWithoutDocumentAuditFileIssuerInput>;
};

export type DocumentBaseCreateNestedOneWithoutDocumentBaseSignatureInviteGroupsInput = {
  connect?: InputMaybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseCreateOrConnectWithoutDocumentBaseSignatureInviteGroupsInput>;
  create?: InputMaybe<DocumentBaseCreateWithoutDocumentBaseSignatureInviteGroupsInput>;
};

export type DocumentBaseCreateNestedOneWithoutDocumentCertificateInput = {
  connect?: InputMaybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseCreateOrConnectWithoutDocumentCertificateInput>;
  create?: InputMaybe<DocumentBaseCreateWithoutDocumentCertificateInput>;
};

export type DocumentBaseCreateNestedOneWithoutDocumentDegreeInput = {
  connect?: InputMaybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseCreateOrConnectWithoutDocumentDegreeInput>;
  create?: InputMaybe<DocumentBaseCreateWithoutDocumentDegreeInput>;
};

export type DocumentBaseCreateNestedOneWithoutDocumentFinalAcademicTranscriptInput = {
  connect?: InputMaybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseCreateOrConnectWithoutDocumentFinalAcademicTranscriptInput>;
  create?: InputMaybe<DocumentBaseCreateWithoutDocumentFinalAcademicTranscriptInput>;
};

export type DocumentBaseCreateNestedOneWithoutDocumentSchoolCurriculumInput = {
  connect?: InputMaybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseCreateOrConnectWithoutDocumentSchoolCurriculumInput>;
  create?: InputMaybe<DocumentBaseCreateWithoutDocumentSchoolCurriculumInput>;
};

export type DocumentBaseCreateNestedOneWithoutExternalSignatureInviteInput = {
  connect?: InputMaybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseCreateOrConnectWithoutExternalSignatureInviteInput>;
  create?: InputMaybe<DocumentBaseCreateWithoutExternalSignatureInviteInput>;
};

export type DocumentBaseCreateNestedOneWithoutHistoriesInput = {
  connect?: InputMaybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseCreateOrConnectWithoutHistoriesInput>;
  create?: InputMaybe<DocumentBaseCreateWithoutHistoriesInput>;
};

export type DocumentBaseCreateNestedOneWithoutRenotarizationsInput = {
  connect?: InputMaybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseCreateOrConnectWithoutRenotarizationsInput>;
  create?: InputMaybe<DocumentBaseCreateWithoutRenotarizationsInput>;
};

export type DocumentBaseCreateOrConnectWithoutDocumentAcademicDocumentationInput = {
  create: DocumentBaseCreateWithoutDocumentAcademicDocumentationInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseCreateOrConnectWithoutDocumentAuditFileIssuerInput = {
  create: DocumentBaseCreateWithoutDocumentAuditFileIssuerInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseCreateOrConnectWithoutDocumentBaseSignatureInviteGroupsInput = {
  create: DocumentBaseCreateWithoutDocumentBaseSignatureInviteGroupsInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseCreateOrConnectWithoutDocumentCertificateInput = {
  create: DocumentBaseCreateWithoutDocumentCertificateInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseCreateOrConnectWithoutDocumentDegreeInput = {
  create: DocumentBaseCreateWithoutDocumentDegreeInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseCreateOrConnectWithoutDocumentFinalAcademicTranscriptInput = {
  create: DocumentBaseCreateWithoutDocumentFinalAcademicTranscriptInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseCreateOrConnectWithoutDocumentSchoolCurriculumInput = {
  create: DocumentBaseCreateWithoutDocumentSchoolCurriculumInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseCreateOrConnectWithoutExternalSignatureInviteInput = {
  create: DocumentBaseCreateWithoutExternalSignatureInviteInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseCreateOrConnectWithoutHistoriesInput = {
  create: DocumentBaseCreateWithoutHistoriesInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseCreateOrConnectWithoutRenotarizationsInput = {
  create: DocumentBaseCreateWithoutRenotarizationsInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseCreateOrConnectWithoutTeamInput = {
  create: DocumentBaseCreateWithoutTeamInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseCreateOrConnectWithoutUserOwnerInput = {
  create: DocumentBaseCreateWithoutUserOwnerInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseCreateWithoutDocumentAcademicDocumentationInput = {
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerCreateNestedOneWithoutDocumentBaseInput>;
  DocumentBaseSignatureInviteGroups?: InputMaybe<DocumentBaseSignatureInviteGroupCreateNestedManyWithoutDocumentBaseInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedOneWithoutDocumentBaseInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeCreateNestedOneWithoutDocumentBaseInput>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentBaseInput>;
  DocumentSchoolCurriculum?: InputMaybe<DocumentSchoolCurriculumCreateNestedOneWithoutDocumentBaseInput>;
  ExternalSignatureInvite?: InputMaybe<ExternalSignatureInviteCreateNestedManyWithoutDocumentBaseInput>;
  Histories?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutDocumentBaseInput>;
  Renotarizations?: InputMaybe<DocumentRenotarizationCreateNestedManyWithoutDocumentBaseInput>;
  Team: TeamCreateNestedOneWithoutDocumentsInput;
  UserOwner: CommonUserCreateNestedOneWithoutDocumentBaseInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creationType?: InputMaybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  internalSeqId?: InputMaybe<Scalars['String']['input']>;
  type: DocumentBaseType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  withoutTeamInternalSeqId?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentBaseCreateWithoutDocumentAuditFileIssuerInput = {
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationCreateNestedOneWithoutDocumentBaseInput>;
  DocumentBaseSignatureInviteGroups?: InputMaybe<DocumentBaseSignatureInviteGroupCreateNestedManyWithoutDocumentBaseInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedOneWithoutDocumentBaseInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeCreateNestedOneWithoutDocumentBaseInput>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentBaseInput>;
  DocumentSchoolCurriculum?: InputMaybe<DocumentSchoolCurriculumCreateNestedOneWithoutDocumentBaseInput>;
  ExternalSignatureInvite?: InputMaybe<ExternalSignatureInviteCreateNestedManyWithoutDocumentBaseInput>;
  Histories?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutDocumentBaseInput>;
  Renotarizations?: InputMaybe<DocumentRenotarizationCreateNestedManyWithoutDocumentBaseInput>;
  Team: TeamCreateNestedOneWithoutDocumentsInput;
  UserOwner: CommonUserCreateNestedOneWithoutDocumentBaseInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creationType?: InputMaybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  internalSeqId?: InputMaybe<Scalars['String']['input']>;
  type: DocumentBaseType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  withoutTeamInternalSeqId?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentBaseCreateWithoutDocumentBaseSignatureInviteGroupsInput = {
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationCreateNestedOneWithoutDocumentBaseInput>;
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerCreateNestedOneWithoutDocumentBaseInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedOneWithoutDocumentBaseInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeCreateNestedOneWithoutDocumentBaseInput>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentBaseInput>;
  DocumentSchoolCurriculum?: InputMaybe<DocumentSchoolCurriculumCreateNestedOneWithoutDocumentBaseInput>;
  ExternalSignatureInvite?: InputMaybe<ExternalSignatureInviteCreateNestedManyWithoutDocumentBaseInput>;
  Histories?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutDocumentBaseInput>;
  Renotarizations?: InputMaybe<DocumentRenotarizationCreateNestedManyWithoutDocumentBaseInput>;
  Team: TeamCreateNestedOneWithoutDocumentsInput;
  UserOwner: CommonUserCreateNestedOneWithoutDocumentBaseInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creationType?: InputMaybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  internalSeqId?: InputMaybe<Scalars['String']['input']>;
  type: DocumentBaseType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  withoutTeamInternalSeqId?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentBaseCreateWithoutDocumentCertificateInput = {
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationCreateNestedOneWithoutDocumentBaseInput>;
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerCreateNestedOneWithoutDocumentBaseInput>;
  DocumentBaseSignatureInviteGroups?: InputMaybe<DocumentBaseSignatureInviteGroupCreateNestedManyWithoutDocumentBaseInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeCreateNestedOneWithoutDocumentBaseInput>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentBaseInput>;
  DocumentSchoolCurriculum?: InputMaybe<DocumentSchoolCurriculumCreateNestedOneWithoutDocumentBaseInput>;
  ExternalSignatureInvite?: InputMaybe<ExternalSignatureInviteCreateNestedManyWithoutDocumentBaseInput>;
  Histories?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutDocumentBaseInput>;
  Renotarizations?: InputMaybe<DocumentRenotarizationCreateNestedManyWithoutDocumentBaseInput>;
  Team: TeamCreateNestedOneWithoutDocumentsInput;
  UserOwner: CommonUserCreateNestedOneWithoutDocumentBaseInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creationType?: InputMaybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  internalSeqId?: InputMaybe<Scalars['String']['input']>;
  type: DocumentBaseType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  withoutTeamInternalSeqId?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentBaseCreateWithoutDocumentDegreeInput = {
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationCreateNestedOneWithoutDocumentBaseInput>;
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerCreateNestedOneWithoutDocumentBaseInput>;
  DocumentBaseSignatureInviteGroups?: InputMaybe<DocumentBaseSignatureInviteGroupCreateNestedManyWithoutDocumentBaseInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedOneWithoutDocumentBaseInput>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentBaseInput>;
  DocumentSchoolCurriculum?: InputMaybe<DocumentSchoolCurriculumCreateNestedOneWithoutDocumentBaseInput>;
  ExternalSignatureInvite?: InputMaybe<ExternalSignatureInviteCreateNestedManyWithoutDocumentBaseInput>;
  Histories?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutDocumentBaseInput>;
  Renotarizations?: InputMaybe<DocumentRenotarizationCreateNestedManyWithoutDocumentBaseInput>;
  Team: TeamCreateNestedOneWithoutDocumentsInput;
  UserOwner: CommonUserCreateNestedOneWithoutDocumentBaseInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creationType?: InputMaybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  internalSeqId?: InputMaybe<Scalars['String']['input']>;
  type: DocumentBaseType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  withoutTeamInternalSeqId?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentBaseCreateWithoutDocumentFinalAcademicTranscriptInput = {
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationCreateNestedOneWithoutDocumentBaseInput>;
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerCreateNestedOneWithoutDocumentBaseInput>;
  DocumentBaseSignatureInviteGroups?: InputMaybe<DocumentBaseSignatureInviteGroupCreateNestedManyWithoutDocumentBaseInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedOneWithoutDocumentBaseInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeCreateNestedOneWithoutDocumentBaseInput>;
  DocumentSchoolCurriculum?: InputMaybe<DocumentSchoolCurriculumCreateNestedOneWithoutDocumentBaseInput>;
  ExternalSignatureInvite?: InputMaybe<ExternalSignatureInviteCreateNestedManyWithoutDocumentBaseInput>;
  Histories?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutDocumentBaseInput>;
  Renotarizations?: InputMaybe<DocumentRenotarizationCreateNestedManyWithoutDocumentBaseInput>;
  Team: TeamCreateNestedOneWithoutDocumentsInput;
  UserOwner: CommonUserCreateNestedOneWithoutDocumentBaseInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creationType?: InputMaybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  internalSeqId?: InputMaybe<Scalars['String']['input']>;
  type: DocumentBaseType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  withoutTeamInternalSeqId?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentBaseCreateWithoutDocumentSchoolCurriculumInput = {
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationCreateNestedOneWithoutDocumentBaseInput>;
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerCreateNestedOneWithoutDocumentBaseInput>;
  DocumentBaseSignatureInviteGroups?: InputMaybe<DocumentBaseSignatureInviteGroupCreateNestedManyWithoutDocumentBaseInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedOneWithoutDocumentBaseInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeCreateNestedOneWithoutDocumentBaseInput>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentBaseInput>;
  ExternalSignatureInvite?: InputMaybe<ExternalSignatureInviteCreateNestedManyWithoutDocumentBaseInput>;
  Histories?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutDocumentBaseInput>;
  Renotarizations?: InputMaybe<DocumentRenotarizationCreateNestedManyWithoutDocumentBaseInput>;
  Team: TeamCreateNestedOneWithoutDocumentsInput;
  UserOwner: CommonUserCreateNestedOneWithoutDocumentBaseInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creationType?: InputMaybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  internalSeqId?: InputMaybe<Scalars['String']['input']>;
  type: DocumentBaseType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  withoutTeamInternalSeqId?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentBaseCreateWithoutExternalSignatureInviteInput = {
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationCreateNestedOneWithoutDocumentBaseInput>;
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerCreateNestedOneWithoutDocumentBaseInput>;
  DocumentBaseSignatureInviteGroups?: InputMaybe<DocumentBaseSignatureInviteGroupCreateNestedManyWithoutDocumentBaseInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedOneWithoutDocumentBaseInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeCreateNestedOneWithoutDocumentBaseInput>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentBaseInput>;
  DocumentSchoolCurriculum?: InputMaybe<DocumentSchoolCurriculumCreateNestedOneWithoutDocumentBaseInput>;
  Histories?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutDocumentBaseInput>;
  Renotarizations?: InputMaybe<DocumentRenotarizationCreateNestedManyWithoutDocumentBaseInput>;
  Team: TeamCreateNestedOneWithoutDocumentsInput;
  UserOwner: CommonUserCreateNestedOneWithoutDocumentBaseInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creationType?: InputMaybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  internalSeqId?: InputMaybe<Scalars['String']['input']>;
  type: DocumentBaseType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  withoutTeamInternalSeqId?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentBaseCreateWithoutHistoriesInput = {
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationCreateNestedOneWithoutDocumentBaseInput>;
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerCreateNestedOneWithoutDocumentBaseInput>;
  DocumentBaseSignatureInviteGroups?: InputMaybe<DocumentBaseSignatureInviteGroupCreateNestedManyWithoutDocumentBaseInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedOneWithoutDocumentBaseInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeCreateNestedOneWithoutDocumentBaseInput>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentBaseInput>;
  DocumentSchoolCurriculum?: InputMaybe<DocumentSchoolCurriculumCreateNestedOneWithoutDocumentBaseInput>;
  ExternalSignatureInvite?: InputMaybe<ExternalSignatureInviteCreateNestedManyWithoutDocumentBaseInput>;
  Renotarizations?: InputMaybe<DocumentRenotarizationCreateNestedManyWithoutDocumentBaseInput>;
  Team: TeamCreateNestedOneWithoutDocumentsInput;
  UserOwner: CommonUserCreateNestedOneWithoutDocumentBaseInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creationType?: InputMaybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  internalSeqId?: InputMaybe<Scalars['String']['input']>;
  type: DocumentBaseType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  withoutTeamInternalSeqId?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentBaseCreateWithoutRenotarizationsInput = {
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationCreateNestedOneWithoutDocumentBaseInput>;
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerCreateNestedOneWithoutDocumentBaseInput>;
  DocumentBaseSignatureInviteGroups?: InputMaybe<DocumentBaseSignatureInviteGroupCreateNestedManyWithoutDocumentBaseInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedOneWithoutDocumentBaseInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeCreateNestedOneWithoutDocumentBaseInput>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentBaseInput>;
  DocumentSchoolCurriculum?: InputMaybe<DocumentSchoolCurriculumCreateNestedOneWithoutDocumentBaseInput>;
  ExternalSignatureInvite?: InputMaybe<ExternalSignatureInviteCreateNestedManyWithoutDocumentBaseInput>;
  Histories?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutDocumentBaseInput>;
  Team: TeamCreateNestedOneWithoutDocumentsInput;
  UserOwner: CommonUserCreateNestedOneWithoutDocumentBaseInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creationType?: InputMaybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  internalSeqId?: InputMaybe<Scalars['String']['input']>;
  type: DocumentBaseType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  withoutTeamInternalSeqId?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentBaseCreateWithoutTeamInput = {
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationCreateNestedOneWithoutDocumentBaseInput>;
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerCreateNestedOneWithoutDocumentBaseInput>;
  DocumentBaseSignatureInviteGroups?: InputMaybe<DocumentBaseSignatureInviteGroupCreateNestedManyWithoutDocumentBaseInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedOneWithoutDocumentBaseInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeCreateNestedOneWithoutDocumentBaseInput>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentBaseInput>;
  DocumentSchoolCurriculum?: InputMaybe<DocumentSchoolCurriculumCreateNestedOneWithoutDocumentBaseInput>;
  ExternalSignatureInvite?: InputMaybe<ExternalSignatureInviteCreateNestedManyWithoutDocumentBaseInput>;
  Histories?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutDocumentBaseInput>;
  Renotarizations?: InputMaybe<DocumentRenotarizationCreateNestedManyWithoutDocumentBaseInput>;
  UserOwner: CommonUserCreateNestedOneWithoutDocumentBaseInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creationType?: InputMaybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  internalSeqId?: InputMaybe<Scalars['String']['input']>;
  type: DocumentBaseType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  withoutTeamInternalSeqId?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentBaseCreateWithoutUserOwnerInput = {
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationCreateNestedOneWithoutDocumentBaseInput>;
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerCreateNestedOneWithoutDocumentBaseInput>;
  DocumentBaseSignatureInviteGroups?: InputMaybe<DocumentBaseSignatureInviteGroupCreateNestedManyWithoutDocumentBaseInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedOneWithoutDocumentBaseInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeCreateNestedOneWithoutDocumentBaseInput>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentBaseInput>;
  DocumentSchoolCurriculum?: InputMaybe<DocumentSchoolCurriculumCreateNestedOneWithoutDocumentBaseInput>;
  ExternalSignatureInvite?: InputMaybe<ExternalSignatureInviteCreateNestedManyWithoutDocumentBaseInput>;
  Histories?: InputMaybe<DocumentBaseHistoryCreateNestedManyWithoutDocumentBaseInput>;
  Renotarizations?: InputMaybe<DocumentRenotarizationCreateNestedManyWithoutDocumentBaseInput>;
  Team: TeamCreateNestedOneWithoutDocumentsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creationType?: InputMaybe<DocumentAcademicDocumentationCreationType>;
  data: Scalars['Json']['input'];
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  internalSeqId?: InputMaybe<Scalars['String']['input']>;
  type: DocumentBaseType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  withoutTeamInternalSeqId?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentBaseDefaultSignatureInviteConfiguration = {
  __typename?: 'DocumentBaseDefaultSignatureInviteConfiguration';
  Groups: Array<DocumentBaseDefaultSignatureInviteConfigurationGroup>;
  Team: Team;
  addSignersNode: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  signatureConfig: Array<SignatureType>;
  teamId: Scalars['Int']['output'];
  type: DocumentBaseType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type DocumentBaseDefaultSignatureInviteConfigurationGroupsArgs = {
  cursor?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationCountOrderByAggregateInput = {
  addSignersNode?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationCreateInput = {
  Groups?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupCreateNestedManyWithoutConfigurationInput>;
  Team: TeamCreateNestedOneWithoutDefaultSignatureInviteConfigurationsInput;
  addSignersNode?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  type: DocumentBaseType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationCreateManyInput = {
  addSignersNode?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
  type: DocumentBaseType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationCreateManyTeamInput = {
  addSignersNode?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  type: DocumentBaseType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationCreateManyTeamInputEnvelope = {
  data: Array<DocumentBaseDefaultSignatureInviteConfigurationCreateManyTeamInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput = {
  connect?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationCreateWithoutTeamInput>>;
  createMany?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationCreateManyTeamInputEnvelope>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationCreateNestedOneWithoutGroupsInput = {
  connect?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationCreateOrConnectWithoutGroupsInput>;
  create?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationCreateWithoutGroupsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationCreateOrConnectWithoutGroupsInput = {
  create: DocumentBaseDefaultSignatureInviteConfigurationCreateWithoutGroupsInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationCreateOrConnectWithoutTeamInput = {
  create: DocumentBaseDefaultSignatureInviteConfigurationCreateWithoutTeamInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationCreateWithoutGroupsInput = {
  Team: TeamCreateNestedOneWithoutDefaultSignatureInviteConfigurationsInput;
  addSignersNode?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  type: DocumentBaseType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationCreateWithoutTeamInput = {
  Groups?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupCreateNestedManyWithoutConfigurationInput>;
  addSignersNode?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  type: DocumentBaseType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroup = {
  __typename?: 'DocumentBaseDefaultSignatureInviteConfigurationGroup';
  Configuration: DocumentBaseDefaultSignatureInviteConfiguration;
  Items: Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItem>;
  configurationId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** Order index from 0 to 2 */
  order: Scalars['Int']['output'];
};


export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemsArgs = {
  cursor?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupAvgOrderByAggregateInput = {
  configurationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupCountOrderByAggregateInput = {
  configurationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupCreateInput = {
  Configuration: DocumentBaseDefaultSignatureInviteConfigurationCreateNestedOneWithoutGroupsInput;
  Items?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateNestedManyWithoutGroupInput>;
  order: Scalars['Int']['input'];
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupCreateManyConfigurationInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  order: Scalars['Int']['input'];
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupCreateManyConfigurationInputEnvelope = {
  data: Array<DocumentBaseDefaultSignatureInviteConfigurationGroupCreateManyConfigurationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupCreateManyInput = {
  configurationId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  order: Scalars['Int']['input'];
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupCreateNestedManyWithoutConfigurationInput = {
  connect?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupCreateOrConnectWithoutConfigurationInput>>;
  create?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupCreateWithoutConfigurationInput>>;
  createMany?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupCreateManyConfigurationInputEnvelope>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupCreateNestedOneWithoutItemsInput = {
  connect?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupCreateOrConnectWithoutItemsInput>;
  create?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupCreateWithoutItemsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupCreateOrConnectWithoutConfigurationInput = {
  create: DocumentBaseDefaultSignatureInviteConfigurationGroupCreateWithoutConfigurationInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupCreateOrConnectWithoutItemsInput = {
  create: DocumentBaseDefaultSignatureInviteConfigurationGroupCreateWithoutItemsInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupCreateWithoutConfigurationInput = {
  Items?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateNestedManyWithoutGroupInput>;
  order: Scalars['Int']['input'];
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupCreateWithoutItemsInput = {
  Configuration: DocumentBaseDefaultSignatureInviteConfigurationCreateNestedOneWithoutGroupsInput;
  order: Scalars['Int']['input'];
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItem = {
  __typename?: 'DocumentBaseDefaultSignatureInviteConfigurationGroupItem';
  Group: DocumentBaseDefaultSignatureInviteConfigurationGroup;
  /** If empty, its a "Institutional signature" */
  TeamMember?: Maybe<TeamMember>;
  groupId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  teamMemberId?: Maybe<Scalars['Int']['output']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemAvgOrderByAggregateInput = {
  groupId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemCountOrderByAggregateInput = {
  groupId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateInput = {
  Group: DocumentBaseDefaultSignatureInviteConfigurationGroupCreateNestedOneWithoutItemsInput;
  TeamMember?: InputMaybe<TeamMemberCreateNestedOneWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateManyGroupInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  teamMemberId?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateManyGroupInputEnvelope = {
  data: Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateManyGroupInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateManyInput = {
  groupId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  teamMemberId?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateManyTeamMemberInput = {
  groupId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateManyTeamMemberInputEnvelope = {
  data: Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateManyTeamMemberInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateNestedManyWithoutGroupInput = {
  connect?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateOrConnectWithoutGroupInput>>;
  create?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateWithoutGroupInput>>;
  createMany?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateManyGroupInputEnvelope>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateNestedManyWithoutTeamMemberInput = {
  connect?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateOrConnectWithoutTeamMemberInput>>;
  create?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateWithoutTeamMemberInput>>;
  createMany?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateManyTeamMemberInputEnvelope>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateOrConnectWithoutGroupInput = {
  create: DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateWithoutGroupInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateOrConnectWithoutTeamMemberInput = {
  create: DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateWithoutTeamMemberInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateWithoutGroupInput = {
  TeamMember?: InputMaybe<TeamMemberCreateNestedOneWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateWithoutTeamMemberInput = {
  Group: DocumentBaseDefaultSignatureInviteConfigurationGroupCreateNestedOneWithoutItemsInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemListRelationFilter = {
  every?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput>;
  none?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput>;
  some?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemMaxOrderByAggregateInput = {
  groupId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemMinOrderByAggregateInput = {
  groupId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemOrderByWithAggregationInput = {
  _avg?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemAvgOrderByAggregateInput>;
  _count?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCountOrderByAggregateInput>;
  _max?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemMaxOrderByAggregateInput>;
  _min?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemMinOrderByAggregateInput>;
  _sum?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemSumOrderByAggregateInput>;
  groupId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemOrderByWithRelationInput = {
  Group?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupOrderByWithRelationInput>;
  TeamMember?: InputMaybe<TeamMemberOrderByWithRelationInput>;
  groupId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
};

export enum DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarFieldEnum {
  GroupId = 'groupId',
  Id = 'id',
  TeamMemberId = 'teamMemberId'
}

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarWhereInput = {
  AND?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarWhereInput>>;
  NOT?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarWhereInput>>;
  OR?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarWhereInput>>;
  groupId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  teamMemberId?: InputMaybe<IntNullableFilter>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarWhereWithAggregatesInput>>;
  groupId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  teamMemberId?: InputMaybe<IntNullableWithAggregatesFilter>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemSumOrderByAggregateInput = {
  groupId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateInput = {
  Group?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateOneRequiredWithoutItemsNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateOneWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsNestedInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyMutationInput = {
  _?: InputMaybe<Scalars['NEVER']['input']>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithWhereWithoutGroupInput = {
  data: DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyMutationInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarWhereInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithWhereWithoutTeamMemberInput = {
  data: DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyMutationInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarWhereInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithoutGroupNestedInput = {
  connect?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateOrConnectWithoutGroupInput>>;
  create?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateWithoutGroupInput>>;
  createMany?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateManyGroupInputEnvelope>;
  delete?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateWithWhereUniqueWithoutGroupInput>>;
  updateMany?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithWhereWithoutGroupInput>>;
  upsert?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpsertWithWhereUniqueWithoutGroupInput>>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithoutTeamMemberNestedInput = {
  connect?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateOrConnectWithoutTeamMemberInput>>;
  create?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateWithoutTeamMemberInput>>;
  createMany?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateManyTeamMemberInputEnvelope>;
  delete?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateWithWhereUniqueWithoutTeamMemberInput>>;
  updateMany?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithWhereWithoutTeamMemberInput>>;
  upsert?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpsertWithWhereUniqueWithoutTeamMemberInput>>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateWithWhereUniqueWithoutGroupInput = {
  data: DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateWithoutGroupInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateWithWhereUniqueWithoutTeamMemberInput = {
  data: DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateWithoutTeamMemberInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateWithoutGroupInput = {
  TeamMember?: InputMaybe<TeamMemberUpdateOneWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsNestedInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateWithoutTeamMemberInput = {
  Group?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateOneRequiredWithoutItemsNestedInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpsertWithWhereUniqueWithoutGroupInput = {
  create: DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateWithoutGroupInput;
  update: DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateWithoutGroupInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpsertWithWhereUniqueWithoutTeamMemberInput = {
  create: DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateWithoutTeamMemberInput;
  update: DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateWithoutTeamMemberInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput = {
  AND?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput>>;
  Group?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>;
  NOT?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput>>;
  OR?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput>>;
  TeamMember?: InputMaybe<TeamMemberWhereInput>;
  groupId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  teamMemberId?: InputMaybe<IntNullableFilter>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput = {
  AND?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput>>;
  Group?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>;
  NOT?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput>>;
  OR?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput>>;
  TeamMember?: InputMaybe<TeamMemberWhereInput>;
  groupId?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  teamMemberId?: InputMaybe<IntNullableFilter>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupListRelationFilter = {
  every?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>;
  none?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>;
  some?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupMaxOrderByAggregateInput = {
  configurationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupMinOrderByAggregateInput = {
  configurationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupOrderByWithAggregationInput = {
  _avg?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupAvgOrderByAggregateInput>;
  _count?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupCountOrderByAggregateInput>;
  _max?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupMaxOrderByAggregateInput>;
  _min?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupMinOrderByAggregateInput>;
  _sum?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupSumOrderByAggregateInput>;
  configurationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupOrderByWithRelationInput = {
  Configuration?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationOrderByWithRelationInput>;
  Items?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemOrderByRelationAggregateInput>;
  configurationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupRelationFilter = {
  is?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>;
  isNot?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>;
};

export enum DocumentBaseDefaultSignatureInviteConfigurationGroupScalarFieldEnum {
  ConfigurationId = 'configurationId',
  Id = 'id',
  Order = 'order'
}

export type DocumentBaseDefaultSignatureInviteConfigurationGroupScalarWhereInput = {
  AND?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupScalarWhereInput>>;
  NOT?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupScalarWhereInput>>;
  OR?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupScalarWhereInput>>;
  configurationId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  order?: InputMaybe<IntFilter>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupScalarWhereWithAggregatesInput>>;
  configurationId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  order?: InputMaybe<IntWithAggregatesFilter>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupSumOrderByAggregateInput = {
  configurationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateInput = {
  Configuration?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateOneRequiredWithoutGroupsNestedInput>;
  Items?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithoutGroupNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateManyMutationInput = {
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateManyWithWhereWithoutConfigurationInput = {
  data: DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateManyMutationInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupScalarWhereInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateManyWithoutConfigurationNestedInput = {
  connect?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupCreateOrConnectWithoutConfigurationInput>>;
  create?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupCreateWithoutConfigurationInput>>;
  createMany?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupCreateManyConfigurationInputEnvelope>;
  delete?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateWithWhereUniqueWithoutConfigurationInput>>;
  updateMany?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateManyWithWhereWithoutConfigurationInput>>;
  upsert?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupUpsertWithWhereUniqueWithoutConfigurationInput>>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateOneRequiredWithoutItemsNestedInput = {
  connect?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupCreateOrConnectWithoutItemsInput>;
  create?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupCreateWithoutItemsInput>;
  update?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateToOneWithWhereWithoutItemsInput>;
  upsert?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupUpsertWithoutItemsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateToOneWithWhereWithoutItemsInput = {
  data: DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateWithoutItemsInput;
  where?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateWithWhereUniqueWithoutConfigurationInput = {
  data: DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateWithoutConfigurationInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateWithoutConfigurationInput = {
  Items?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithoutGroupNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateWithoutItemsInput = {
  Configuration?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateOneRequiredWithoutGroupsNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupUpsertWithWhereUniqueWithoutConfigurationInput = {
  create: DocumentBaseDefaultSignatureInviteConfigurationGroupCreateWithoutConfigurationInput;
  update: DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateWithoutConfigurationInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupUpsertWithoutItemsInput = {
  create: DocumentBaseDefaultSignatureInviteConfigurationGroupCreateWithoutItemsInput;
  update: DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateWithoutItemsInput;
  where?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput = {
  AND?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>>;
  Configuration?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>;
  Items?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemListRelationFilter>;
  NOT?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>>;
  OR?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>>;
  configurationId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  order?: InputMaybe<IntFilter>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationGroupWhereUniqueInput = {
  AND?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>>;
  Configuration?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>;
  Items?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemListRelationFilter>;
  NOT?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>>;
  OR?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupWhereInput>>;
  configurationId?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<IntFilter>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationListRelationFilter = {
  every?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>;
  none?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>;
  some?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationMaxOrderByAggregateInput = {
  addSignersNode?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationMinOrderByAggregateInput = {
  addSignersNode?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationOrderByWithAggregationInput = {
  _avg?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationAvgOrderByAggregateInput>;
  _count?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationCountOrderByAggregateInput>;
  _max?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationMaxOrderByAggregateInput>;
  _min?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationMinOrderByAggregateInput>;
  _sum?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationSumOrderByAggregateInput>;
  addSignersNode?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationOrderByWithRelationInput = {
  Groups?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupOrderByRelationAggregateInput>;
  Team?: InputMaybe<TeamOrderByWithRelationInput>;
  addSignersNode?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationRelationFilter = {
  is?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>;
  isNot?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>;
};

export enum DocumentBaseDefaultSignatureInviteConfigurationScalarFieldEnum {
  AddSignersNode = 'addSignersNode',
  CreatedAt = 'createdAt',
  Id = 'id',
  TeamId = 'teamId',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type DocumentBaseDefaultSignatureInviteConfigurationScalarWhereInput = {
  AND?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationScalarWhereInput>>;
  NOT?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationScalarWhereInput>>;
  OR?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationScalarWhereInput>>;
  addSignersNode?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  teamId?: InputMaybe<IntFilter>;
  type?: InputMaybe<EnumDocumentBaseTypeFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationScalarWhereWithAggregatesInput>>;
  addSignersNode?: InputMaybe<BoolWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  teamId?: InputMaybe<IntWithAggregatesFilter>;
  type?: InputMaybe<EnumDocumentBaseTypeWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationTeamIdTypeCompoundUniqueInput = {
  teamId: Scalars['Int']['input'];
  type: DocumentBaseType;
};

export type DocumentBaseDefaultSignatureInviteConfigurationUpdateInput = {
  Groups?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateManyWithoutConfigurationNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutDefaultSignatureInviteConfigurationsNestedInput>;
  addSignersNode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationUpdateManyMutationInput = {
  addSignersNode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithWhereWithoutTeamInput = {
  data: DocumentBaseDefaultSignatureInviteConfigurationUpdateManyMutationInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationScalarWhereInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput = {
  connect?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationCreateWithoutTeamInput>>;
  createMany?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationCreateManyTeamInputEnvelope>;
  delete?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationUpdateWithWhereUniqueWithoutTeamInput>>;
  updateMany?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithWhereWithoutTeamInput>>;
  upsert?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationUpsertWithWhereUniqueWithoutTeamInput>>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationUpdateOneRequiredWithoutGroupsNestedInput = {
  connect?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationCreateOrConnectWithoutGroupsInput>;
  create?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationCreateWithoutGroupsInput>;
  update?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateToOneWithWhereWithoutGroupsInput>;
  upsert?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationUpsertWithoutGroupsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationUpdateToOneWithWhereWithoutGroupsInput = {
  data: DocumentBaseDefaultSignatureInviteConfigurationUpdateWithoutGroupsInput;
  where?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationUpdateWithWhereUniqueWithoutTeamInput = {
  data: DocumentBaseDefaultSignatureInviteConfigurationUpdateWithoutTeamInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationUpdateWithoutGroupsInput = {
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutDefaultSignatureInviteConfigurationsNestedInput>;
  addSignersNode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationUpdateWithoutTeamInput = {
  Groups?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupUpdateManyWithoutConfigurationNestedInput>;
  addSignersNode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationUpsertWithWhereUniqueWithoutTeamInput = {
  create: DocumentBaseDefaultSignatureInviteConfigurationCreateWithoutTeamInput;
  update: DocumentBaseDefaultSignatureInviteConfigurationUpdateWithoutTeamInput;
  where: DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput;
};

export type DocumentBaseDefaultSignatureInviteConfigurationUpsertWithoutGroupsInput = {
  create: DocumentBaseDefaultSignatureInviteConfigurationCreateWithoutGroupsInput;
  update: DocumentBaseDefaultSignatureInviteConfigurationUpdateWithoutGroupsInput;
  where?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationWhereInput = {
  AND?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>>;
  Groups?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupListRelationFilter>;
  NOT?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>>;
  OR?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>>;
  Team?: InputMaybe<TeamWhereInput>;
  addSignersNode?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  teamId?: InputMaybe<IntFilter>;
  type?: InputMaybe<EnumDocumentBaseTypeFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput = {
  AND?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>>;
  Groups?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupListRelationFilter>;
  NOT?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>>;
  OR?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>>;
  Team?: InputMaybe<TeamWhereInput>;
  addSignersNode?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  teamId?: InputMaybe<IntFilter>;
  teamId_type?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationTeamIdTypeCompoundUniqueInput>;
  type?: InputMaybe<EnumDocumentBaseTypeFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type DocumentBaseHistory = {
  __typename?: 'DocumentBaseHistory';
  DocumentBase: DocumentBase;
  UserCreated?: Maybe<CommonUser>;
  commonUserCreatedId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** ![PrismaJson.AnyJson] */
  data?: Maybe<Scalars['Json']['output']>;
  /** Reproval reason, revoke reason? -- Documento deletado, validação rápida */
  description?: Maybe<Scalars['String']['output']>;
  documentBaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type DocumentBaseHistoryAvgOrderByAggregateInput = {
  commonUserCreatedId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DocumentBaseHistoryCountOrderByAggregateInput = {
  commonUserCreatedId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  documentBaseId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type DocumentBaseHistoryCreateInput = {
  DocumentBase: DocumentBaseCreateNestedOneWithoutHistoriesInput;
  UserCreated?: InputMaybe<CommonUserCreateNestedOneWithoutDocumentBaseHistoryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentBaseHistoryCreateManyDocumentBaseInput = {
  commonUserCreatedId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentBaseHistoryCreateManyDocumentBaseInputEnvelope = {
  data: Array<DocumentBaseHistoryCreateManyDocumentBaseInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentBaseHistoryCreateManyInput = {
  commonUserCreatedId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentBaseId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentBaseHistoryCreateManyUserCreatedInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentBaseId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentBaseHistoryCreateManyUserCreatedInputEnvelope = {
  data: Array<DocumentBaseHistoryCreateManyUserCreatedInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentBaseHistoryCreateNestedManyWithoutDocumentBaseInput = {
  connect?: InputMaybe<Array<DocumentBaseHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentBaseHistoryCreateOrConnectWithoutDocumentBaseInput>>;
  create?: InputMaybe<Array<DocumentBaseHistoryCreateWithoutDocumentBaseInput>>;
  createMany?: InputMaybe<DocumentBaseHistoryCreateManyDocumentBaseInputEnvelope>;
};

export type DocumentBaseHistoryCreateNestedManyWithoutUserCreatedInput = {
  connect?: InputMaybe<Array<DocumentBaseHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentBaseHistoryCreateOrConnectWithoutUserCreatedInput>>;
  create?: InputMaybe<Array<DocumentBaseHistoryCreateWithoutUserCreatedInput>>;
  createMany?: InputMaybe<DocumentBaseHistoryCreateManyUserCreatedInputEnvelope>;
};

export type DocumentBaseHistoryCreateOrConnectWithoutDocumentBaseInput = {
  create: DocumentBaseHistoryCreateWithoutDocumentBaseInput;
  where: DocumentBaseHistoryWhereUniqueInput;
};

export type DocumentBaseHistoryCreateOrConnectWithoutUserCreatedInput = {
  create: DocumentBaseHistoryCreateWithoutUserCreatedInput;
  where: DocumentBaseHistoryWhereUniqueInput;
};

export type DocumentBaseHistoryCreateWithoutDocumentBaseInput = {
  UserCreated?: InputMaybe<CommonUserCreateNestedOneWithoutDocumentBaseHistoryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentBaseHistoryCreateWithoutUserCreatedInput = {
  DocumentBase: DocumentBaseCreateNestedOneWithoutHistoriesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentBaseHistoryListRelationFilter = {
  every?: InputMaybe<DocumentBaseHistoryWhereInput>;
  none?: InputMaybe<DocumentBaseHistoryWhereInput>;
  some?: InputMaybe<DocumentBaseHistoryWhereInput>;
};

export type DocumentBaseHistoryMaxOrderByAggregateInput = {
  commonUserCreatedId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  documentBaseId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type DocumentBaseHistoryMinOrderByAggregateInput = {
  commonUserCreatedId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  documentBaseId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type DocumentBaseHistoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DocumentBaseHistoryOrderByWithAggregationInput = {
  _avg?: InputMaybe<DocumentBaseHistoryAvgOrderByAggregateInput>;
  _count?: InputMaybe<DocumentBaseHistoryCountOrderByAggregateInput>;
  _max?: InputMaybe<DocumentBaseHistoryMaxOrderByAggregateInput>;
  _min?: InputMaybe<DocumentBaseHistoryMinOrderByAggregateInput>;
  _sum?: InputMaybe<DocumentBaseHistorySumOrderByAggregateInput>;
  commonUserCreatedId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  documentBaseId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type DocumentBaseHistoryOrderByWithRelationInput = {
  DocumentBase?: InputMaybe<DocumentBaseOrderByWithRelationInput>;
  UserCreated?: InputMaybe<CommonUserOrderByWithRelationInput>;
  commonUserCreatedId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  documentBaseId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export enum DocumentBaseHistoryScalarFieldEnum {
  CommonUserCreatedId = 'commonUserCreatedId',
  CreatedAt = 'createdAt',
  Data = 'data',
  Description = 'description',
  DocumentBaseId = 'documentBaseId',
  Id = 'id',
  Status = 'status'
}

export type DocumentBaseHistoryScalarWhereInput = {
  AND?: InputMaybe<Array<DocumentBaseHistoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<DocumentBaseHistoryScalarWhereInput>>;
  OR?: InputMaybe<Array<DocumentBaseHistoryScalarWhereInput>>;
  commonUserCreatedId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  documentBaseId?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  status?: InputMaybe<StringNullableFilter>;
};

export type DocumentBaseHistoryScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DocumentBaseHistoryScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DocumentBaseHistoryScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DocumentBaseHistoryScalarWhereWithAggregatesInput>>;
  commonUserCreatedId?: InputMaybe<IntNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  data?: InputMaybe<JsonNullableWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  documentBaseId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  status?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type DocumentBaseHistorySumOrderByAggregateInput = {
  commonUserCreatedId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DocumentBaseHistoryUpdateInput = {
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutHistoriesNestedInput>;
  UserCreated?: InputMaybe<CommonUserUpdateOneWithoutDocumentBaseHistoryNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DocumentBaseHistoryUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DocumentBaseHistoryUpdateManyWithWhereWithoutDocumentBaseInput = {
  data: DocumentBaseHistoryUpdateManyMutationInput;
  where: DocumentBaseHistoryScalarWhereInput;
};

export type DocumentBaseHistoryUpdateManyWithWhereWithoutUserCreatedInput = {
  data: DocumentBaseHistoryUpdateManyMutationInput;
  where: DocumentBaseHistoryScalarWhereInput;
};

export type DocumentBaseHistoryUpdateManyWithoutDocumentBaseNestedInput = {
  connect?: InputMaybe<Array<DocumentBaseHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentBaseHistoryCreateOrConnectWithoutDocumentBaseInput>>;
  create?: InputMaybe<Array<DocumentBaseHistoryCreateWithoutDocumentBaseInput>>;
  createMany?: InputMaybe<DocumentBaseHistoryCreateManyDocumentBaseInputEnvelope>;
  delete?: InputMaybe<Array<DocumentBaseHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentBaseHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentBaseHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentBaseHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentBaseHistoryUpdateWithWhereUniqueWithoutDocumentBaseInput>>;
  updateMany?: InputMaybe<Array<DocumentBaseHistoryUpdateManyWithWhereWithoutDocumentBaseInput>>;
  upsert?: InputMaybe<Array<DocumentBaseHistoryUpsertWithWhereUniqueWithoutDocumentBaseInput>>;
};

export type DocumentBaseHistoryUpdateManyWithoutUserCreatedNestedInput = {
  connect?: InputMaybe<Array<DocumentBaseHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentBaseHistoryCreateOrConnectWithoutUserCreatedInput>>;
  create?: InputMaybe<Array<DocumentBaseHistoryCreateWithoutUserCreatedInput>>;
  createMany?: InputMaybe<DocumentBaseHistoryCreateManyUserCreatedInputEnvelope>;
  delete?: InputMaybe<Array<DocumentBaseHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentBaseHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentBaseHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentBaseHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentBaseHistoryUpdateWithWhereUniqueWithoutUserCreatedInput>>;
  updateMany?: InputMaybe<Array<DocumentBaseHistoryUpdateManyWithWhereWithoutUserCreatedInput>>;
  upsert?: InputMaybe<Array<DocumentBaseHistoryUpsertWithWhereUniqueWithoutUserCreatedInput>>;
};

export type DocumentBaseHistoryUpdateWithWhereUniqueWithoutDocumentBaseInput = {
  data: DocumentBaseHistoryUpdateWithoutDocumentBaseInput;
  where: DocumentBaseHistoryWhereUniqueInput;
};

export type DocumentBaseHistoryUpdateWithWhereUniqueWithoutUserCreatedInput = {
  data: DocumentBaseHistoryUpdateWithoutUserCreatedInput;
  where: DocumentBaseHistoryWhereUniqueInput;
};

export type DocumentBaseHistoryUpdateWithoutDocumentBaseInput = {
  UserCreated?: InputMaybe<CommonUserUpdateOneWithoutDocumentBaseHistoryNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DocumentBaseHistoryUpdateWithoutUserCreatedInput = {
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutHistoriesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DocumentBaseHistoryUpsertWithWhereUniqueWithoutDocumentBaseInput = {
  create: DocumentBaseHistoryCreateWithoutDocumentBaseInput;
  update: DocumentBaseHistoryUpdateWithoutDocumentBaseInput;
  where: DocumentBaseHistoryWhereUniqueInput;
};

export type DocumentBaseHistoryUpsertWithWhereUniqueWithoutUserCreatedInput = {
  create: DocumentBaseHistoryCreateWithoutUserCreatedInput;
  update: DocumentBaseHistoryUpdateWithoutUserCreatedInput;
  where: DocumentBaseHistoryWhereUniqueInput;
};

export type DocumentBaseHistoryWhereInput = {
  AND?: InputMaybe<Array<DocumentBaseHistoryWhereInput>>;
  DocumentBase?: InputMaybe<DocumentBaseWhereInput>;
  NOT?: InputMaybe<Array<DocumentBaseHistoryWhereInput>>;
  OR?: InputMaybe<Array<DocumentBaseHistoryWhereInput>>;
  UserCreated?: InputMaybe<CommonUserWhereInput>;
  commonUserCreatedId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  documentBaseId?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  status?: InputMaybe<StringNullableFilter>;
};

export type DocumentBaseHistoryWhereUniqueInput = {
  AND?: InputMaybe<Array<DocumentBaseHistoryWhereInput>>;
  DocumentBase?: InputMaybe<DocumentBaseWhereInput>;
  NOT?: InputMaybe<Array<DocumentBaseHistoryWhereInput>>;
  OR?: InputMaybe<Array<DocumentBaseHistoryWhereInput>>;
  UserCreated?: InputMaybe<CommonUserWhereInput>;
  commonUserCreatedId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  documentBaseId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<StringNullableFilter>;
};

export type DocumentBaseListRelationFilter = {
  every?: InputMaybe<DocumentBaseWhereInput>;
  none?: InputMaybe<DocumentBaseWhereInput>;
  some?: InputMaybe<DocumentBaseWhereInput>;
};

export type DocumentBaseMaxOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  creationType?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  filePath?: InputMaybe<SortOrder>;
  fileSize?: InputMaybe<SortOrder>;
  internalSeqId?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  version?: InputMaybe<SortOrder>;
  withoutTeamInternalSeqId?: InputMaybe<SortOrder>;
};

export type DocumentBaseMinOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  creationType?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  filePath?: InputMaybe<SortOrder>;
  fileSize?: InputMaybe<SortOrder>;
  internalSeqId?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  version?: InputMaybe<SortOrder>;
  withoutTeamInternalSeqId?: InputMaybe<SortOrder>;
};

export type DocumentBaseOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DocumentBaseOrderByWithAggregationInput = {
  _avg?: InputMaybe<DocumentBaseAvgOrderByAggregateInput>;
  _count?: InputMaybe<DocumentBaseCountOrderByAggregateInput>;
  _max?: InputMaybe<DocumentBaseMaxOrderByAggregateInput>;
  _min?: InputMaybe<DocumentBaseMinOrderByAggregateInput>;
  _sum?: InputMaybe<DocumentBaseSumOrderByAggregateInput>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  creationType?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  filePath?: InputMaybe<SortOrder>;
  fileSize?: InputMaybe<SortOrder>;
  internalSeqId?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  version?: InputMaybe<SortOrder>;
  withoutTeamInternalSeqId?: InputMaybe<SortOrder>;
};

export type DocumentBaseOrderByWithRelationInput = {
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationOrderByWithRelationInput>;
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerOrderByWithRelationInput>;
  DocumentBaseSignatureInviteGroups?: InputMaybe<DocumentBaseSignatureInviteGroupOrderByRelationAggregateInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateOrderByWithRelationInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeOrderByWithRelationInput>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptOrderByWithRelationInput>;
  DocumentSchoolCurriculum?: InputMaybe<DocumentSchoolCurriculumOrderByWithRelationInput>;
  ExternalSignatureInvite?: InputMaybe<ExternalSignatureInviteOrderByRelationAggregateInput>;
  Histories?: InputMaybe<DocumentBaseHistoryOrderByRelationAggregateInput>;
  Renotarizations?: InputMaybe<DocumentRenotarizationOrderByRelationAggregateInput>;
  Team?: InputMaybe<TeamOrderByWithRelationInput>;
  UserOwner?: InputMaybe<CommonUserOrderByWithRelationInput>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  creationType?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  filePath?: InputMaybe<SortOrder>;
  fileSize?: InputMaybe<SortOrder>;
  internalSeqId?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  version?: InputMaybe<SortOrder>;
  withoutTeamInternalSeqId?: InputMaybe<SortOrder>;
};

export type DocumentBaseRelationFilter = {
  is?: InputMaybe<DocumentBaseWhereInput>;
  isNot?: InputMaybe<DocumentBaseWhereInput>;
};

export enum DocumentBaseScalarFieldEnum {
  CommonUserId = 'commonUserId',
  CreatedAt = 'createdAt',
  CreationType = 'creationType',
  Data = 'data',
  DeletedAt = 'deletedAt',
  FilePath = 'filePath',
  FileSize = 'fileSize',
  InternalSeqId = 'internalSeqId',
  TeamId = 'teamId',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  Version = 'version',
  WithoutTeamInternalSeqId = 'withoutTeamInternalSeqId'
}

export type DocumentBaseScalarWhereInput = {
  AND?: InputMaybe<Array<DocumentBaseScalarWhereInput>>;
  NOT?: InputMaybe<Array<DocumentBaseScalarWhereInput>>;
  OR?: InputMaybe<Array<DocumentBaseScalarWhereInput>>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationType?: InputMaybe<EnumDocumentAcademicDocumentationCreationTypeFilter>;
  data?: InputMaybe<JsonFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  filePath?: InputMaybe<StringNullableFilter>;
  fileSize?: InputMaybe<IntFilter>;
  internalSeqId?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<IntFilter>;
  type?: InputMaybe<EnumDocumentBaseTypeFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  version?: InputMaybe<StringFilter>;
  withoutTeamInternalSeqId?: InputMaybe<IntFilter>;
};

export type DocumentBaseScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DocumentBaseScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DocumentBaseScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DocumentBaseScalarWhereWithAggregatesInput>>;
  commonUserId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  creationType?: InputMaybe<EnumDocumentAcademicDocumentationCreationTypeWithAggregatesFilter>;
  data?: InputMaybe<JsonWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  filePath?: InputMaybe<StringNullableWithAggregatesFilter>;
  fileSize?: InputMaybe<IntWithAggregatesFilter>;
  internalSeqId?: InputMaybe<StringWithAggregatesFilter>;
  teamId?: InputMaybe<IntWithAggregatesFilter>;
  type?: InputMaybe<EnumDocumentBaseTypeWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  version?: InputMaybe<StringWithAggregatesFilter>;
  withoutTeamInternalSeqId?: InputMaybe<IntWithAggregatesFilter>;
};

export type DocumentBaseSignatureInvite = {
  __typename?: 'DocumentBaseSignatureInvite';
  Group: DocumentBaseSignatureInviteGroup;
  Signatures: Array<DocumentBaseSignatureInviteSignature>;
  /** If empty, its a "Institutional signature" */
  TeamMember?: Maybe<TeamMember>;
  createdAt: Scalars['DateTime']['output'];
  groupId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  teamMemberId?: Maybe<Scalars['Int']['output']>;
};


export type DocumentBaseSignatureInviteSignaturesArgs = {
  cursor?: InputMaybe<DocumentBaseSignatureInviteSignatureWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentBaseSignatureInviteSignatureWhereInput>;
};

export type DocumentBaseSignatureInviteAvgOrderByAggregateInput = {
  groupId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
};

export type DocumentBaseSignatureInviteCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  groupId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
};

export type DocumentBaseSignatureInviteCreateInput = {
  Group: DocumentBaseSignatureInviteGroupCreateNestedOneWithoutInvitesInput;
  Signatures?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutInviteInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedOneWithoutInvitesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentBaseSignatureInviteCreateManyGroupInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  teamMemberId?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentBaseSignatureInviteCreateManyGroupInputEnvelope = {
  data: Array<DocumentBaseSignatureInviteCreateManyGroupInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentBaseSignatureInviteCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  groupId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  teamMemberId?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentBaseSignatureInviteCreateManyTeamMemberInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  groupId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentBaseSignatureInviteCreateManyTeamMemberInputEnvelope = {
  data: Array<DocumentBaseSignatureInviteCreateManyTeamMemberInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentBaseSignatureInviteCreateNestedManyWithoutGroupInput = {
  connect?: InputMaybe<Array<DocumentBaseSignatureInviteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentBaseSignatureInviteCreateOrConnectWithoutGroupInput>>;
  create?: InputMaybe<Array<DocumentBaseSignatureInviteCreateWithoutGroupInput>>;
  createMany?: InputMaybe<DocumentBaseSignatureInviteCreateManyGroupInputEnvelope>;
};

export type DocumentBaseSignatureInviteCreateNestedManyWithoutTeamMemberInput = {
  connect?: InputMaybe<Array<DocumentBaseSignatureInviteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentBaseSignatureInviteCreateOrConnectWithoutTeamMemberInput>>;
  create?: InputMaybe<Array<DocumentBaseSignatureInviteCreateWithoutTeamMemberInput>>;
  createMany?: InputMaybe<DocumentBaseSignatureInviteCreateManyTeamMemberInputEnvelope>;
};

export type DocumentBaseSignatureInviteCreateNestedOneWithoutSignaturesInput = {
  connect?: InputMaybe<DocumentBaseSignatureInviteWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseSignatureInviteCreateOrConnectWithoutSignaturesInput>;
  create?: InputMaybe<DocumentBaseSignatureInviteCreateWithoutSignaturesInput>;
};

export type DocumentBaseSignatureInviteCreateOrConnectWithoutGroupInput = {
  create: DocumentBaseSignatureInviteCreateWithoutGroupInput;
  where: DocumentBaseSignatureInviteWhereUniqueInput;
};

export type DocumentBaseSignatureInviteCreateOrConnectWithoutSignaturesInput = {
  create: DocumentBaseSignatureInviteCreateWithoutSignaturesInput;
  where: DocumentBaseSignatureInviteWhereUniqueInput;
};

export type DocumentBaseSignatureInviteCreateOrConnectWithoutTeamMemberInput = {
  create: DocumentBaseSignatureInviteCreateWithoutTeamMemberInput;
  where: DocumentBaseSignatureInviteWhereUniqueInput;
};

export type DocumentBaseSignatureInviteCreateWithoutGroupInput = {
  Signatures?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutInviteInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedOneWithoutInvitesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentBaseSignatureInviteCreateWithoutSignaturesInput = {
  Group: DocumentBaseSignatureInviteGroupCreateNestedOneWithoutInvitesInput;
  TeamMember?: InputMaybe<TeamMemberCreateNestedOneWithoutInvitesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentBaseSignatureInviteCreateWithoutTeamMemberInput = {
  Group: DocumentBaseSignatureInviteGroupCreateNestedOneWithoutInvitesInput;
  Signatures?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutInviteInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentBaseSignatureInviteGroup = {
  __typename?: 'DocumentBaseSignatureInviteGroup';
  DocumentBase: DocumentBase;
  Invites: Array<DocumentBaseSignatureInvite>;
  createdAt: Scalars['DateTime']['output'];
  documentBaseId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
};


export type DocumentBaseSignatureInviteGroupInvitesArgs = {
  cursor?: InputMaybe<DocumentBaseSignatureInviteWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentBaseSignatureInviteScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentBaseSignatureInviteOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentBaseSignatureInviteWhereInput>;
};

export type DocumentBaseSignatureInviteGroupAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
};

export type DocumentBaseSignatureInviteGroupCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  documentBaseId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
};

export type DocumentBaseSignatureInviteGroupCreateInput = {
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentBaseSignatureInviteGroupsInput;
  Invites?: InputMaybe<DocumentBaseSignatureInviteCreateNestedManyWithoutGroupInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  order: Scalars['Int']['input'];
};

export type DocumentBaseSignatureInviteGroupCreateManyDocumentBaseInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  order: Scalars['Int']['input'];
};

export type DocumentBaseSignatureInviteGroupCreateManyDocumentBaseInputEnvelope = {
  data: Array<DocumentBaseSignatureInviteGroupCreateManyDocumentBaseInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentBaseSignatureInviteGroupCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  documentBaseId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  order: Scalars['Int']['input'];
};

export type DocumentBaseSignatureInviteGroupCreateNestedManyWithoutDocumentBaseInput = {
  connect?: InputMaybe<Array<DocumentBaseSignatureInviteGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentBaseSignatureInviteGroupCreateOrConnectWithoutDocumentBaseInput>>;
  create?: InputMaybe<Array<DocumentBaseSignatureInviteGroupCreateWithoutDocumentBaseInput>>;
  createMany?: InputMaybe<DocumentBaseSignatureInviteGroupCreateManyDocumentBaseInputEnvelope>;
};

export type DocumentBaseSignatureInviteGroupCreateNestedOneWithoutInvitesInput = {
  connect?: InputMaybe<DocumentBaseSignatureInviteGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseSignatureInviteGroupCreateOrConnectWithoutInvitesInput>;
  create?: InputMaybe<DocumentBaseSignatureInviteGroupCreateWithoutInvitesInput>;
};

export type DocumentBaseSignatureInviteGroupCreateOrConnectWithoutDocumentBaseInput = {
  create: DocumentBaseSignatureInviteGroupCreateWithoutDocumentBaseInput;
  where: DocumentBaseSignatureInviteGroupWhereUniqueInput;
};

export type DocumentBaseSignatureInviteGroupCreateOrConnectWithoutInvitesInput = {
  create: DocumentBaseSignatureInviteGroupCreateWithoutInvitesInput;
  where: DocumentBaseSignatureInviteGroupWhereUniqueInput;
};

export type DocumentBaseSignatureInviteGroupCreateWithoutDocumentBaseInput = {
  Invites?: InputMaybe<DocumentBaseSignatureInviteCreateNestedManyWithoutGroupInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  order: Scalars['Int']['input'];
};

export type DocumentBaseSignatureInviteGroupCreateWithoutInvitesInput = {
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentBaseSignatureInviteGroupsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  order: Scalars['Int']['input'];
};

export type DocumentBaseSignatureInviteGroupListRelationFilter = {
  every?: InputMaybe<DocumentBaseSignatureInviteGroupWhereInput>;
  none?: InputMaybe<DocumentBaseSignatureInviteGroupWhereInput>;
  some?: InputMaybe<DocumentBaseSignatureInviteGroupWhereInput>;
};

export type DocumentBaseSignatureInviteGroupMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  documentBaseId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
};

export type DocumentBaseSignatureInviteGroupMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  documentBaseId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
};

export type DocumentBaseSignatureInviteGroupOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DocumentBaseSignatureInviteGroupOrderByWithAggregationInput = {
  _avg?: InputMaybe<DocumentBaseSignatureInviteGroupAvgOrderByAggregateInput>;
  _count?: InputMaybe<DocumentBaseSignatureInviteGroupCountOrderByAggregateInput>;
  _max?: InputMaybe<DocumentBaseSignatureInviteGroupMaxOrderByAggregateInput>;
  _min?: InputMaybe<DocumentBaseSignatureInviteGroupMinOrderByAggregateInput>;
  _sum?: InputMaybe<DocumentBaseSignatureInviteGroupSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  documentBaseId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
};

export type DocumentBaseSignatureInviteGroupOrderByWithRelationInput = {
  DocumentBase?: InputMaybe<DocumentBaseOrderByWithRelationInput>;
  Invites?: InputMaybe<DocumentBaseSignatureInviteOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  documentBaseId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
};

export type DocumentBaseSignatureInviteGroupRelationFilter = {
  is?: InputMaybe<DocumentBaseSignatureInviteGroupWhereInput>;
  isNot?: InputMaybe<DocumentBaseSignatureInviteGroupWhereInput>;
};

export enum DocumentBaseSignatureInviteGroupScalarFieldEnum {
  CreatedAt = 'createdAt',
  DocumentBaseId = 'documentBaseId',
  Id = 'id',
  Order = 'order'
}

export type DocumentBaseSignatureInviteGroupScalarWhereInput = {
  AND?: InputMaybe<Array<DocumentBaseSignatureInviteGroupScalarWhereInput>>;
  NOT?: InputMaybe<Array<DocumentBaseSignatureInviteGroupScalarWhereInput>>;
  OR?: InputMaybe<Array<DocumentBaseSignatureInviteGroupScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentBaseId?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  order?: InputMaybe<IntFilter>;
};

export type DocumentBaseSignatureInviteGroupScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DocumentBaseSignatureInviteGroupScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DocumentBaseSignatureInviteGroupScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DocumentBaseSignatureInviteGroupScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  documentBaseId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  order?: InputMaybe<IntWithAggregatesFilter>;
};

export type DocumentBaseSignatureInviteGroupSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
};

export type DocumentBaseSignatureInviteGroupUpdateInput = {
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentBaseSignatureInviteGroupsNestedInput>;
  Invites?: InputMaybe<DocumentBaseSignatureInviteUpdateManyWithoutGroupNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseSignatureInviteGroupUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseSignatureInviteGroupUpdateManyWithWhereWithoutDocumentBaseInput = {
  data: DocumentBaseSignatureInviteGroupUpdateManyMutationInput;
  where: DocumentBaseSignatureInviteGroupScalarWhereInput;
};

export type DocumentBaseSignatureInviteGroupUpdateManyWithoutDocumentBaseNestedInput = {
  connect?: InputMaybe<Array<DocumentBaseSignatureInviteGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentBaseSignatureInviteGroupCreateOrConnectWithoutDocumentBaseInput>>;
  create?: InputMaybe<Array<DocumentBaseSignatureInviteGroupCreateWithoutDocumentBaseInput>>;
  createMany?: InputMaybe<DocumentBaseSignatureInviteGroupCreateManyDocumentBaseInputEnvelope>;
  delete?: InputMaybe<Array<DocumentBaseSignatureInviteGroupWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentBaseSignatureInviteGroupScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentBaseSignatureInviteGroupWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentBaseSignatureInviteGroupWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentBaseSignatureInviteGroupUpdateWithWhereUniqueWithoutDocumentBaseInput>>;
  updateMany?: InputMaybe<Array<DocumentBaseSignatureInviteGroupUpdateManyWithWhereWithoutDocumentBaseInput>>;
  upsert?: InputMaybe<Array<DocumentBaseSignatureInviteGroupUpsertWithWhereUniqueWithoutDocumentBaseInput>>;
};

export type DocumentBaseSignatureInviteGroupUpdateOneRequiredWithoutInvitesNestedInput = {
  connect?: InputMaybe<DocumentBaseSignatureInviteGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseSignatureInviteGroupCreateOrConnectWithoutInvitesInput>;
  create?: InputMaybe<DocumentBaseSignatureInviteGroupCreateWithoutInvitesInput>;
  update?: InputMaybe<DocumentBaseSignatureInviteGroupUpdateToOneWithWhereWithoutInvitesInput>;
  upsert?: InputMaybe<DocumentBaseSignatureInviteGroupUpsertWithoutInvitesInput>;
};

export type DocumentBaseSignatureInviteGroupUpdateToOneWithWhereWithoutInvitesInput = {
  data: DocumentBaseSignatureInviteGroupUpdateWithoutInvitesInput;
  where?: InputMaybe<DocumentBaseSignatureInviteGroupWhereInput>;
};

export type DocumentBaseSignatureInviteGroupUpdateWithWhereUniqueWithoutDocumentBaseInput = {
  data: DocumentBaseSignatureInviteGroupUpdateWithoutDocumentBaseInput;
  where: DocumentBaseSignatureInviteGroupWhereUniqueInput;
};

export type DocumentBaseSignatureInviteGroupUpdateWithoutDocumentBaseInput = {
  Invites?: InputMaybe<DocumentBaseSignatureInviteUpdateManyWithoutGroupNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseSignatureInviteGroupUpdateWithoutInvitesInput = {
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentBaseSignatureInviteGroupsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseSignatureInviteGroupUpsertWithWhereUniqueWithoutDocumentBaseInput = {
  create: DocumentBaseSignatureInviteGroupCreateWithoutDocumentBaseInput;
  update: DocumentBaseSignatureInviteGroupUpdateWithoutDocumentBaseInput;
  where: DocumentBaseSignatureInviteGroupWhereUniqueInput;
};

export type DocumentBaseSignatureInviteGroupUpsertWithoutInvitesInput = {
  create: DocumentBaseSignatureInviteGroupCreateWithoutInvitesInput;
  update: DocumentBaseSignatureInviteGroupUpdateWithoutInvitesInput;
  where?: InputMaybe<DocumentBaseSignatureInviteGroupWhereInput>;
};

export type DocumentBaseSignatureInviteGroupWhereInput = {
  AND?: InputMaybe<Array<DocumentBaseSignatureInviteGroupWhereInput>>;
  DocumentBase?: InputMaybe<DocumentBaseWhereInput>;
  Invites?: InputMaybe<DocumentBaseSignatureInviteListRelationFilter>;
  NOT?: InputMaybe<Array<DocumentBaseSignatureInviteGroupWhereInput>>;
  OR?: InputMaybe<Array<DocumentBaseSignatureInviteGroupWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentBaseId?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  order?: InputMaybe<IntFilter>;
};

export type DocumentBaseSignatureInviteGroupWhereUniqueInput = {
  AND?: InputMaybe<Array<DocumentBaseSignatureInviteGroupWhereInput>>;
  DocumentBase?: InputMaybe<DocumentBaseWhereInput>;
  Invites?: InputMaybe<DocumentBaseSignatureInviteListRelationFilter>;
  NOT?: InputMaybe<Array<DocumentBaseSignatureInviteGroupWhereInput>>;
  OR?: InputMaybe<Array<DocumentBaseSignatureInviteGroupWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentBaseId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<IntFilter>;
};

export type DocumentBaseSignatureInviteListRelationFilter = {
  every?: InputMaybe<DocumentBaseSignatureInviteWhereInput>;
  none?: InputMaybe<DocumentBaseSignatureInviteWhereInput>;
  some?: InputMaybe<DocumentBaseSignatureInviteWhereInput>;
};

export type DocumentBaseSignatureInviteMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  groupId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
};

export type DocumentBaseSignatureInviteMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  groupId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
};

export type DocumentBaseSignatureInviteOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DocumentBaseSignatureInviteOrderByWithAggregationInput = {
  _avg?: InputMaybe<DocumentBaseSignatureInviteAvgOrderByAggregateInput>;
  _count?: InputMaybe<DocumentBaseSignatureInviteCountOrderByAggregateInput>;
  _max?: InputMaybe<DocumentBaseSignatureInviteMaxOrderByAggregateInput>;
  _min?: InputMaybe<DocumentBaseSignatureInviteMinOrderByAggregateInput>;
  _sum?: InputMaybe<DocumentBaseSignatureInviteSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  groupId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
};

export type DocumentBaseSignatureInviteOrderByWithRelationInput = {
  Group?: InputMaybe<DocumentBaseSignatureInviteGroupOrderByWithRelationInput>;
  Signatures?: InputMaybe<DocumentBaseSignatureInviteSignatureOrderByRelationAggregateInput>;
  TeamMember?: InputMaybe<TeamMemberOrderByWithRelationInput>;
  createdAt?: InputMaybe<SortOrder>;
  groupId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
};

export type DocumentBaseSignatureInviteRelationFilter = {
  is?: InputMaybe<DocumentBaseSignatureInviteWhereInput>;
  isNot?: InputMaybe<DocumentBaseSignatureInviteWhereInput>;
};

export enum DocumentBaseSignatureInviteScalarFieldEnum {
  CreatedAt = 'createdAt',
  GroupId = 'groupId',
  Id = 'id',
  TeamMemberId = 'teamMemberId'
}

export type DocumentBaseSignatureInviteScalarWhereInput = {
  AND?: InputMaybe<Array<DocumentBaseSignatureInviteScalarWhereInput>>;
  NOT?: InputMaybe<Array<DocumentBaseSignatureInviteScalarWhereInput>>;
  OR?: InputMaybe<Array<DocumentBaseSignatureInviteScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  groupId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  teamMemberId?: InputMaybe<IntNullableFilter>;
};

export type DocumentBaseSignatureInviteScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DocumentBaseSignatureInviteScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DocumentBaseSignatureInviteScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DocumentBaseSignatureInviteScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  groupId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  teamMemberId?: InputMaybe<IntNullableWithAggregatesFilter>;
};

export type DocumentBaseSignatureInviteSignature = {
  __typename?: 'DocumentBaseSignatureInviteSignature';
  Invite: DocumentBaseSignatureInvite;
  User: CommonUser;
  commonUserId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  inviteId: Scalars['Int']['output'];
};

export type DocumentBaseSignatureInviteSignatureAvgOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviteId?: InputMaybe<SortOrder>;
};

export type DocumentBaseSignatureInviteSignatureCountOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviteId?: InputMaybe<SortOrder>;
};

export type DocumentBaseSignatureInviteSignatureCreateInput = {
  Invite: DocumentBaseSignatureInviteCreateNestedOneWithoutSignaturesInput;
  User: CommonUserCreateNestedOneWithoutDocumentBaseSignatureInviteSignatureInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentBaseSignatureInviteSignatureCreateManyInput = {
  commonUserId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  inviteId: Scalars['Int']['input'];
};

export type DocumentBaseSignatureInviteSignatureCreateManyInviteInput = {
  commonUserId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentBaseSignatureInviteSignatureCreateManyInviteInputEnvelope = {
  data: Array<DocumentBaseSignatureInviteSignatureCreateManyInviteInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentBaseSignatureInviteSignatureCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  inviteId: Scalars['Int']['input'];
};

export type DocumentBaseSignatureInviteSignatureCreateManyUserInputEnvelope = {
  data: Array<DocumentBaseSignatureInviteSignatureCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutInviteInput = {
  connect?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureCreateOrConnectWithoutInviteInput>>;
  create?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureCreateWithoutInviteInput>>;
  createMany?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateManyInviteInputEnvelope>;
};

export type DocumentBaseSignatureInviteSignatureCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureCreateWithoutUserInput>>;
  createMany?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateManyUserInputEnvelope>;
};

export type DocumentBaseSignatureInviteSignatureCreateOrConnectWithoutInviteInput = {
  create: DocumentBaseSignatureInviteSignatureCreateWithoutInviteInput;
  where: DocumentBaseSignatureInviteSignatureWhereUniqueInput;
};

export type DocumentBaseSignatureInviteSignatureCreateOrConnectWithoutUserInput = {
  create: DocumentBaseSignatureInviteSignatureCreateWithoutUserInput;
  where: DocumentBaseSignatureInviteSignatureWhereUniqueInput;
};

export type DocumentBaseSignatureInviteSignatureCreateWithoutInviteInput = {
  User: CommonUserCreateNestedOneWithoutDocumentBaseSignatureInviteSignatureInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentBaseSignatureInviteSignatureCreateWithoutUserInput = {
  Invite: DocumentBaseSignatureInviteCreateNestedOneWithoutSignaturesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentBaseSignatureInviteSignatureListRelationFilter = {
  every?: InputMaybe<DocumentBaseSignatureInviteSignatureWhereInput>;
  none?: InputMaybe<DocumentBaseSignatureInviteSignatureWhereInput>;
  some?: InputMaybe<DocumentBaseSignatureInviteSignatureWhereInput>;
};

export type DocumentBaseSignatureInviteSignatureMaxOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviteId?: InputMaybe<SortOrder>;
};

export type DocumentBaseSignatureInviteSignatureMinOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviteId?: InputMaybe<SortOrder>;
};

export type DocumentBaseSignatureInviteSignatureOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DocumentBaseSignatureInviteSignatureOrderByWithAggregationInput = {
  _avg?: InputMaybe<DocumentBaseSignatureInviteSignatureAvgOrderByAggregateInput>;
  _count?: InputMaybe<DocumentBaseSignatureInviteSignatureCountOrderByAggregateInput>;
  _max?: InputMaybe<DocumentBaseSignatureInviteSignatureMaxOrderByAggregateInput>;
  _min?: InputMaybe<DocumentBaseSignatureInviteSignatureMinOrderByAggregateInput>;
  _sum?: InputMaybe<DocumentBaseSignatureInviteSignatureSumOrderByAggregateInput>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviteId?: InputMaybe<SortOrder>;
};

export type DocumentBaseSignatureInviteSignatureOrderByWithRelationInput = {
  Invite?: InputMaybe<DocumentBaseSignatureInviteOrderByWithRelationInput>;
  User?: InputMaybe<CommonUserOrderByWithRelationInput>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviteId?: InputMaybe<SortOrder>;
};

export enum DocumentBaseSignatureInviteSignatureScalarFieldEnum {
  CommonUserId = 'commonUserId',
  CreatedAt = 'createdAt',
  Id = 'id',
  InviteId = 'inviteId'
}

export type DocumentBaseSignatureInviteSignatureScalarWhereInput = {
  AND?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureScalarWhereInput>>;
  NOT?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureScalarWhereInput>>;
  OR?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureScalarWhereInput>>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  inviteId?: InputMaybe<IntFilter>;
};

export type DocumentBaseSignatureInviteSignatureScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureScalarWhereWithAggregatesInput>>;
  commonUserId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  inviteId?: InputMaybe<IntWithAggregatesFilter>;
};

export type DocumentBaseSignatureInviteSignatureSumOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inviteId?: InputMaybe<SortOrder>;
};

export type DocumentBaseSignatureInviteSignatureUpdateInput = {
  Invite?: InputMaybe<DocumentBaseSignatureInviteUpdateOneRequiredWithoutSignaturesNestedInput>;
  User?: InputMaybe<CommonUserUpdateOneRequiredWithoutDocumentBaseSignatureInviteSignatureNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentBaseSignatureInviteSignatureUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentBaseSignatureInviteSignatureUpdateManyWithWhereWithoutInviteInput = {
  data: DocumentBaseSignatureInviteSignatureUpdateManyMutationInput;
  where: DocumentBaseSignatureInviteSignatureScalarWhereInput;
};

export type DocumentBaseSignatureInviteSignatureUpdateManyWithWhereWithoutUserInput = {
  data: DocumentBaseSignatureInviteSignatureUpdateManyMutationInput;
  where: DocumentBaseSignatureInviteSignatureScalarWhereInput;
};

export type DocumentBaseSignatureInviteSignatureUpdateManyWithoutInviteNestedInput = {
  connect?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureCreateOrConnectWithoutInviteInput>>;
  create?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureCreateWithoutInviteInput>>;
  createMany?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateManyInviteInputEnvelope>;
  delete?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureUpdateWithWhereUniqueWithoutInviteInput>>;
  updateMany?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureUpdateManyWithWhereWithoutInviteInput>>;
  upsert?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureUpsertWithWhereUniqueWithoutInviteInput>>;
};

export type DocumentBaseSignatureInviteSignatureUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureCreateWithoutUserInput>>;
  createMany?: InputMaybe<DocumentBaseSignatureInviteSignatureCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureUpsertWithWhereUniqueWithoutUserInput>>;
};

export type DocumentBaseSignatureInviteSignatureUpdateWithWhereUniqueWithoutInviteInput = {
  data: DocumentBaseSignatureInviteSignatureUpdateWithoutInviteInput;
  where: DocumentBaseSignatureInviteSignatureWhereUniqueInput;
};

export type DocumentBaseSignatureInviteSignatureUpdateWithWhereUniqueWithoutUserInput = {
  data: DocumentBaseSignatureInviteSignatureUpdateWithoutUserInput;
  where: DocumentBaseSignatureInviteSignatureWhereUniqueInput;
};

export type DocumentBaseSignatureInviteSignatureUpdateWithoutInviteInput = {
  User?: InputMaybe<CommonUserUpdateOneRequiredWithoutDocumentBaseSignatureInviteSignatureNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentBaseSignatureInviteSignatureUpdateWithoutUserInput = {
  Invite?: InputMaybe<DocumentBaseSignatureInviteUpdateOneRequiredWithoutSignaturesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentBaseSignatureInviteSignatureUpsertWithWhereUniqueWithoutInviteInput = {
  create: DocumentBaseSignatureInviteSignatureCreateWithoutInviteInput;
  update: DocumentBaseSignatureInviteSignatureUpdateWithoutInviteInput;
  where: DocumentBaseSignatureInviteSignatureWhereUniqueInput;
};

export type DocumentBaseSignatureInviteSignatureUpsertWithWhereUniqueWithoutUserInput = {
  create: DocumentBaseSignatureInviteSignatureCreateWithoutUserInput;
  update: DocumentBaseSignatureInviteSignatureUpdateWithoutUserInput;
  where: DocumentBaseSignatureInviteSignatureWhereUniqueInput;
};

export type DocumentBaseSignatureInviteSignatureWhereInput = {
  AND?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureWhereInput>>;
  Invite?: InputMaybe<DocumentBaseSignatureInviteWhereInput>;
  NOT?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureWhereInput>>;
  OR?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureWhereInput>>;
  User?: InputMaybe<CommonUserWhereInput>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  inviteId?: InputMaybe<IntFilter>;
};

export type DocumentBaseSignatureInviteSignatureWhereUniqueInput = {
  AND?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureWhereInput>>;
  Invite?: InputMaybe<DocumentBaseSignatureInviteWhereInput>;
  NOT?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureWhereInput>>;
  OR?: InputMaybe<Array<DocumentBaseSignatureInviteSignatureWhereInput>>;
  User?: InputMaybe<CommonUserWhereInput>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  inviteId?: InputMaybe<IntFilter>;
};

export type DocumentBaseSignatureInviteSumOrderByAggregateInput = {
  groupId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
};

export type DocumentBaseSignatureInviteUpdateInput = {
  Group?: InputMaybe<DocumentBaseSignatureInviteGroupUpdateOneRequiredWithoutInvitesNestedInput>;
  Signatures?: InputMaybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutInviteNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateOneWithoutInvitesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentBaseSignatureInviteUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentBaseSignatureInviteUpdateManyWithWhereWithoutGroupInput = {
  data: DocumentBaseSignatureInviteUpdateManyMutationInput;
  where: DocumentBaseSignatureInviteScalarWhereInput;
};

export type DocumentBaseSignatureInviteUpdateManyWithWhereWithoutTeamMemberInput = {
  data: DocumentBaseSignatureInviteUpdateManyMutationInput;
  where: DocumentBaseSignatureInviteScalarWhereInput;
};

export type DocumentBaseSignatureInviteUpdateManyWithoutGroupNestedInput = {
  connect?: InputMaybe<Array<DocumentBaseSignatureInviteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentBaseSignatureInviteCreateOrConnectWithoutGroupInput>>;
  create?: InputMaybe<Array<DocumentBaseSignatureInviteCreateWithoutGroupInput>>;
  createMany?: InputMaybe<DocumentBaseSignatureInviteCreateManyGroupInputEnvelope>;
  delete?: InputMaybe<Array<DocumentBaseSignatureInviteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentBaseSignatureInviteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentBaseSignatureInviteWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentBaseSignatureInviteWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentBaseSignatureInviteUpdateWithWhereUniqueWithoutGroupInput>>;
  updateMany?: InputMaybe<Array<DocumentBaseSignatureInviteUpdateManyWithWhereWithoutGroupInput>>;
  upsert?: InputMaybe<Array<DocumentBaseSignatureInviteUpsertWithWhereUniqueWithoutGroupInput>>;
};

export type DocumentBaseSignatureInviteUpdateManyWithoutTeamMemberNestedInput = {
  connect?: InputMaybe<Array<DocumentBaseSignatureInviteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentBaseSignatureInviteCreateOrConnectWithoutTeamMemberInput>>;
  create?: InputMaybe<Array<DocumentBaseSignatureInviteCreateWithoutTeamMemberInput>>;
  createMany?: InputMaybe<DocumentBaseSignatureInviteCreateManyTeamMemberInputEnvelope>;
  delete?: InputMaybe<Array<DocumentBaseSignatureInviteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentBaseSignatureInviteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentBaseSignatureInviteWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentBaseSignatureInviteWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentBaseSignatureInviteUpdateWithWhereUniqueWithoutTeamMemberInput>>;
  updateMany?: InputMaybe<Array<DocumentBaseSignatureInviteUpdateManyWithWhereWithoutTeamMemberInput>>;
  upsert?: InputMaybe<Array<DocumentBaseSignatureInviteUpsertWithWhereUniqueWithoutTeamMemberInput>>;
};

export type DocumentBaseSignatureInviteUpdateOneRequiredWithoutSignaturesNestedInput = {
  connect?: InputMaybe<DocumentBaseSignatureInviteWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseSignatureInviteCreateOrConnectWithoutSignaturesInput>;
  create?: InputMaybe<DocumentBaseSignatureInviteCreateWithoutSignaturesInput>;
  update?: InputMaybe<DocumentBaseSignatureInviteUpdateToOneWithWhereWithoutSignaturesInput>;
  upsert?: InputMaybe<DocumentBaseSignatureInviteUpsertWithoutSignaturesInput>;
};

export type DocumentBaseSignatureInviteUpdateToOneWithWhereWithoutSignaturesInput = {
  data: DocumentBaseSignatureInviteUpdateWithoutSignaturesInput;
  where?: InputMaybe<DocumentBaseSignatureInviteWhereInput>;
};

export type DocumentBaseSignatureInviteUpdateWithWhereUniqueWithoutGroupInput = {
  data: DocumentBaseSignatureInviteUpdateWithoutGroupInput;
  where: DocumentBaseSignatureInviteWhereUniqueInput;
};

export type DocumentBaseSignatureInviteUpdateWithWhereUniqueWithoutTeamMemberInput = {
  data: DocumentBaseSignatureInviteUpdateWithoutTeamMemberInput;
  where: DocumentBaseSignatureInviteWhereUniqueInput;
};

export type DocumentBaseSignatureInviteUpdateWithoutGroupInput = {
  Signatures?: InputMaybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutInviteNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateOneWithoutInvitesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentBaseSignatureInviteUpdateWithoutSignaturesInput = {
  Group?: InputMaybe<DocumentBaseSignatureInviteGroupUpdateOneRequiredWithoutInvitesNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateOneWithoutInvitesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentBaseSignatureInviteUpdateWithoutTeamMemberInput = {
  Group?: InputMaybe<DocumentBaseSignatureInviteGroupUpdateOneRequiredWithoutInvitesNestedInput>;
  Signatures?: InputMaybe<DocumentBaseSignatureInviteSignatureUpdateManyWithoutInviteNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentBaseSignatureInviteUpsertWithWhereUniqueWithoutGroupInput = {
  create: DocumentBaseSignatureInviteCreateWithoutGroupInput;
  update: DocumentBaseSignatureInviteUpdateWithoutGroupInput;
  where: DocumentBaseSignatureInviteWhereUniqueInput;
};

export type DocumentBaseSignatureInviteUpsertWithWhereUniqueWithoutTeamMemberInput = {
  create: DocumentBaseSignatureInviteCreateWithoutTeamMemberInput;
  update: DocumentBaseSignatureInviteUpdateWithoutTeamMemberInput;
  where: DocumentBaseSignatureInviteWhereUniqueInput;
};

export type DocumentBaseSignatureInviteUpsertWithoutSignaturesInput = {
  create: DocumentBaseSignatureInviteCreateWithoutSignaturesInput;
  update: DocumentBaseSignatureInviteUpdateWithoutSignaturesInput;
  where?: InputMaybe<DocumentBaseSignatureInviteWhereInput>;
};

export type DocumentBaseSignatureInviteWhereInput = {
  AND?: InputMaybe<Array<DocumentBaseSignatureInviteWhereInput>>;
  Group?: InputMaybe<DocumentBaseSignatureInviteGroupWhereInput>;
  NOT?: InputMaybe<Array<DocumentBaseSignatureInviteWhereInput>>;
  OR?: InputMaybe<Array<DocumentBaseSignatureInviteWhereInput>>;
  Signatures?: InputMaybe<DocumentBaseSignatureInviteSignatureListRelationFilter>;
  TeamMember?: InputMaybe<TeamMemberWhereInput>;
  createdAt?: InputMaybe<DateTimeFilter>;
  groupId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  teamMemberId?: InputMaybe<IntNullableFilter>;
};

export type DocumentBaseSignatureInviteWhereUniqueInput = {
  AND?: InputMaybe<Array<DocumentBaseSignatureInviteWhereInput>>;
  Group?: InputMaybe<DocumentBaseSignatureInviteGroupWhereInput>;
  NOT?: InputMaybe<Array<DocumentBaseSignatureInviteWhereInput>>;
  OR?: InputMaybe<Array<DocumentBaseSignatureInviteWhereInput>>;
  Signatures?: InputMaybe<DocumentBaseSignatureInviteSignatureListRelationFilter>;
  TeamMember?: InputMaybe<TeamMemberWhereInput>;
  createdAt?: InputMaybe<DateTimeFilter>;
  groupId?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  teamMemberId?: InputMaybe<IntNullableFilter>;
};

export type DocumentBaseSumOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  fileSize?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  withoutTeamInternalSeqId?: InputMaybe<SortOrder>;
};

export enum DocumentBaseType {
  AcademicDocumentation = 'ACADEMIC_DOCUMENTATION',
  AuditFileIssuer = 'AUDIT_FILE_ISSUER',
  Certificate = 'CERTIFICATE',
  Degree = 'DEGREE',
  FinalAcademicTranscript = 'FINAL_ACADEMIC_TRANSCRIPT',
  SchoolCurriculum = 'SCHOOL_CURRICULUM'
}

export type DocumentBaseUpdateInput = {
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentBaseSignatureInviteGroups?: InputMaybe<DocumentBaseSignatureInviteGroupUpdateManyWithoutDocumentBaseNestedInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentSchoolCurriculum?: InputMaybe<DocumentSchoolCurriculumUpdateOneWithoutDocumentBaseNestedInput>;
  ExternalSignatureInvite?: InputMaybe<ExternalSignatureInviteUpdateManyWithoutDocumentBaseNestedInput>;
  Histories?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutDocumentBaseNestedInput>;
  Renotarizations?: InputMaybe<DocumentRenotarizationUpdateManyWithoutDocumentBaseNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutDocumentsNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutDocumentBaseNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creationType?: InputMaybe<EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  filePath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileSize?: InputMaybe<IntFieldUpdateOperationsInput>;
  internalSeqId?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  version?: InputMaybe<StringFieldUpdateOperationsInput>;
  withoutTeamInternalSeqId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creationType?: InputMaybe<EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  filePath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileSize?: InputMaybe<IntFieldUpdateOperationsInput>;
  internalSeqId?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  version?: InputMaybe<StringFieldUpdateOperationsInput>;
  withoutTeamInternalSeqId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseUpdateManyWithWhereWithoutTeamInput = {
  data: DocumentBaseUpdateManyMutationInput;
  where: DocumentBaseScalarWhereInput;
};

export type DocumentBaseUpdateManyWithWhereWithoutUserOwnerInput = {
  data: DocumentBaseUpdateManyMutationInput;
  where: DocumentBaseScalarWhereInput;
};

export type DocumentBaseUpdateManyWithoutTeamNestedInput = {
  connect?: InputMaybe<Array<DocumentBaseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentBaseCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<DocumentBaseCreateWithoutTeamInput>>;
  createMany?: InputMaybe<DocumentBaseCreateManyTeamInputEnvelope>;
  delete?: InputMaybe<Array<DocumentBaseWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentBaseScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentBaseWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentBaseWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentBaseUpdateWithWhereUniqueWithoutTeamInput>>;
  updateMany?: InputMaybe<Array<DocumentBaseUpdateManyWithWhereWithoutTeamInput>>;
  upsert?: InputMaybe<Array<DocumentBaseUpsertWithWhereUniqueWithoutTeamInput>>;
};

export type DocumentBaseUpdateManyWithoutUserOwnerNestedInput = {
  connect?: InputMaybe<Array<DocumentBaseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentBaseCreateOrConnectWithoutUserOwnerInput>>;
  create?: InputMaybe<Array<DocumentBaseCreateWithoutUserOwnerInput>>;
  createMany?: InputMaybe<DocumentBaseCreateManyUserOwnerInputEnvelope>;
  delete?: InputMaybe<Array<DocumentBaseWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentBaseScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentBaseWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentBaseWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentBaseUpdateWithWhereUniqueWithoutUserOwnerInput>>;
  updateMany?: InputMaybe<Array<DocumentBaseUpdateManyWithWhereWithoutUserOwnerInput>>;
  upsert?: InputMaybe<Array<DocumentBaseUpsertWithWhereUniqueWithoutUserOwnerInput>>;
};

export type DocumentBaseUpdateOneRequiredWithoutDocumentAcademicDocumentationNestedInput = {
  connect?: InputMaybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseCreateOrConnectWithoutDocumentAcademicDocumentationInput>;
  create?: InputMaybe<DocumentBaseCreateWithoutDocumentAcademicDocumentationInput>;
  update?: InputMaybe<DocumentBaseUpdateToOneWithWhereWithoutDocumentAcademicDocumentationInput>;
  upsert?: InputMaybe<DocumentBaseUpsertWithoutDocumentAcademicDocumentationInput>;
};

export type DocumentBaseUpdateOneRequiredWithoutDocumentAuditFileIssuerNestedInput = {
  connect?: InputMaybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseCreateOrConnectWithoutDocumentAuditFileIssuerInput>;
  create?: InputMaybe<DocumentBaseCreateWithoutDocumentAuditFileIssuerInput>;
  update?: InputMaybe<DocumentBaseUpdateToOneWithWhereWithoutDocumentAuditFileIssuerInput>;
  upsert?: InputMaybe<DocumentBaseUpsertWithoutDocumentAuditFileIssuerInput>;
};

export type DocumentBaseUpdateOneRequiredWithoutDocumentBaseSignatureInviteGroupsNestedInput = {
  connect?: InputMaybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseCreateOrConnectWithoutDocumentBaseSignatureInviteGroupsInput>;
  create?: InputMaybe<DocumentBaseCreateWithoutDocumentBaseSignatureInviteGroupsInput>;
  update?: InputMaybe<DocumentBaseUpdateToOneWithWhereWithoutDocumentBaseSignatureInviteGroupsInput>;
  upsert?: InputMaybe<DocumentBaseUpsertWithoutDocumentBaseSignatureInviteGroupsInput>;
};

export type DocumentBaseUpdateOneRequiredWithoutDocumentCertificateNestedInput = {
  connect?: InputMaybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseCreateOrConnectWithoutDocumentCertificateInput>;
  create?: InputMaybe<DocumentBaseCreateWithoutDocumentCertificateInput>;
  update?: InputMaybe<DocumentBaseUpdateToOneWithWhereWithoutDocumentCertificateInput>;
  upsert?: InputMaybe<DocumentBaseUpsertWithoutDocumentCertificateInput>;
};

export type DocumentBaseUpdateOneRequiredWithoutDocumentDegreeNestedInput = {
  connect?: InputMaybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseCreateOrConnectWithoutDocumentDegreeInput>;
  create?: InputMaybe<DocumentBaseCreateWithoutDocumentDegreeInput>;
  update?: InputMaybe<DocumentBaseUpdateToOneWithWhereWithoutDocumentDegreeInput>;
  upsert?: InputMaybe<DocumentBaseUpsertWithoutDocumentDegreeInput>;
};

export type DocumentBaseUpdateOneRequiredWithoutDocumentFinalAcademicTranscriptNestedInput = {
  connect?: InputMaybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseCreateOrConnectWithoutDocumentFinalAcademicTranscriptInput>;
  create?: InputMaybe<DocumentBaseCreateWithoutDocumentFinalAcademicTranscriptInput>;
  update?: InputMaybe<DocumentBaseUpdateToOneWithWhereWithoutDocumentFinalAcademicTranscriptInput>;
  upsert?: InputMaybe<DocumentBaseUpsertWithoutDocumentFinalAcademicTranscriptInput>;
};

export type DocumentBaseUpdateOneRequiredWithoutDocumentSchoolCurriculumNestedInput = {
  connect?: InputMaybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseCreateOrConnectWithoutDocumentSchoolCurriculumInput>;
  create?: InputMaybe<DocumentBaseCreateWithoutDocumentSchoolCurriculumInput>;
  update?: InputMaybe<DocumentBaseUpdateToOneWithWhereWithoutDocumentSchoolCurriculumInput>;
  upsert?: InputMaybe<DocumentBaseUpsertWithoutDocumentSchoolCurriculumInput>;
};

export type DocumentBaseUpdateOneRequiredWithoutExternalSignatureInviteNestedInput = {
  connect?: InputMaybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseCreateOrConnectWithoutExternalSignatureInviteInput>;
  create?: InputMaybe<DocumentBaseCreateWithoutExternalSignatureInviteInput>;
  update?: InputMaybe<DocumentBaseUpdateToOneWithWhereWithoutExternalSignatureInviteInput>;
  upsert?: InputMaybe<DocumentBaseUpsertWithoutExternalSignatureInviteInput>;
};

export type DocumentBaseUpdateOneRequiredWithoutHistoriesNestedInput = {
  connect?: InputMaybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseCreateOrConnectWithoutHistoriesInput>;
  create?: InputMaybe<DocumentBaseCreateWithoutHistoriesInput>;
  update?: InputMaybe<DocumentBaseUpdateToOneWithWhereWithoutHistoriesInput>;
  upsert?: InputMaybe<DocumentBaseUpsertWithoutHistoriesInput>;
};

export type DocumentBaseUpdateOneRequiredWithoutRenotarizationsNestedInput = {
  connect?: InputMaybe<DocumentBaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentBaseCreateOrConnectWithoutRenotarizationsInput>;
  create?: InputMaybe<DocumentBaseCreateWithoutRenotarizationsInput>;
  update?: InputMaybe<DocumentBaseUpdateToOneWithWhereWithoutRenotarizationsInput>;
  upsert?: InputMaybe<DocumentBaseUpsertWithoutRenotarizationsInput>;
};

export type DocumentBaseUpdateToOneWithWhereWithoutDocumentAcademicDocumentationInput = {
  data: DocumentBaseUpdateWithoutDocumentAcademicDocumentationInput;
  where?: InputMaybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpdateToOneWithWhereWithoutDocumentAuditFileIssuerInput = {
  data: DocumentBaseUpdateWithoutDocumentAuditFileIssuerInput;
  where?: InputMaybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpdateToOneWithWhereWithoutDocumentBaseSignatureInviteGroupsInput = {
  data: DocumentBaseUpdateWithoutDocumentBaseSignatureInviteGroupsInput;
  where?: InputMaybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpdateToOneWithWhereWithoutDocumentCertificateInput = {
  data: DocumentBaseUpdateWithoutDocumentCertificateInput;
  where?: InputMaybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpdateToOneWithWhereWithoutDocumentDegreeInput = {
  data: DocumentBaseUpdateWithoutDocumentDegreeInput;
  where?: InputMaybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpdateToOneWithWhereWithoutDocumentFinalAcademicTranscriptInput = {
  data: DocumentBaseUpdateWithoutDocumentFinalAcademicTranscriptInput;
  where?: InputMaybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpdateToOneWithWhereWithoutDocumentSchoolCurriculumInput = {
  data: DocumentBaseUpdateWithoutDocumentSchoolCurriculumInput;
  where?: InputMaybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpdateToOneWithWhereWithoutExternalSignatureInviteInput = {
  data: DocumentBaseUpdateWithoutExternalSignatureInviteInput;
  where?: InputMaybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpdateToOneWithWhereWithoutHistoriesInput = {
  data: DocumentBaseUpdateWithoutHistoriesInput;
  where?: InputMaybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpdateToOneWithWhereWithoutRenotarizationsInput = {
  data: DocumentBaseUpdateWithoutRenotarizationsInput;
  where?: InputMaybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpdateWithWhereUniqueWithoutTeamInput = {
  data: DocumentBaseUpdateWithoutTeamInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseUpdateWithWhereUniqueWithoutUserOwnerInput = {
  data: DocumentBaseUpdateWithoutUserOwnerInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseUpdateWithoutDocumentAcademicDocumentationInput = {
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentBaseSignatureInviteGroups?: InputMaybe<DocumentBaseSignatureInviteGroupUpdateManyWithoutDocumentBaseNestedInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentSchoolCurriculum?: InputMaybe<DocumentSchoolCurriculumUpdateOneWithoutDocumentBaseNestedInput>;
  ExternalSignatureInvite?: InputMaybe<ExternalSignatureInviteUpdateManyWithoutDocumentBaseNestedInput>;
  Histories?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutDocumentBaseNestedInput>;
  Renotarizations?: InputMaybe<DocumentRenotarizationUpdateManyWithoutDocumentBaseNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutDocumentsNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutDocumentBaseNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creationType?: InputMaybe<EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  filePath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileSize?: InputMaybe<IntFieldUpdateOperationsInput>;
  internalSeqId?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  version?: InputMaybe<StringFieldUpdateOperationsInput>;
  withoutTeamInternalSeqId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseUpdateWithoutDocumentAuditFileIssuerInput = {
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentBaseSignatureInviteGroups?: InputMaybe<DocumentBaseSignatureInviteGroupUpdateManyWithoutDocumentBaseNestedInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentSchoolCurriculum?: InputMaybe<DocumentSchoolCurriculumUpdateOneWithoutDocumentBaseNestedInput>;
  ExternalSignatureInvite?: InputMaybe<ExternalSignatureInviteUpdateManyWithoutDocumentBaseNestedInput>;
  Histories?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutDocumentBaseNestedInput>;
  Renotarizations?: InputMaybe<DocumentRenotarizationUpdateManyWithoutDocumentBaseNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutDocumentsNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutDocumentBaseNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creationType?: InputMaybe<EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  filePath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileSize?: InputMaybe<IntFieldUpdateOperationsInput>;
  internalSeqId?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  version?: InputMaybe<StringFieldUpdateOperationsInput>;
  withoutTeamInternalSeqId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseUpdateWithoutDocumentBaseSignatureInviteGroupsInput = {
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentSchoolCurriculum?: InputMaybe<DocumentSchoolCurriculumUpdateOneWithoutDocumentBaseNestedInput>;
  ExternalSignatureInvite?: InputMaybe<ExternalSignatureInviteUpdateManyWithoutDocumentBaseNestedInput>;
  Histories?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutDocumentBaseNestedInput>;
  Renotarizations?: InputMaybe<DocumentRenotarizationUpdateManyWithoutDocumentBaseNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutDocumentsNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutDocumentBaseNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creationType?: InputMaybe<EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  filePath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileSize?: InputMaybe<IntFieldUpdateOperationsInput>;
  internalSeqId?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  version?: InputMaybe<StringFieldUpdateOperationsInput>;
  withoutTeamInternalSeqId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseUpdateWithoutDocumentCertificateInput = {
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentBaseSignatureInviteGroups?: InputMaybe<DocumentBaseSignatureInviteGroupUpdateManyWithoutDocumentBaseNestedInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentSchoolCurriculum?: InputMaybe<DocumentSchoolCurriculumUpdateOneWithoutDocumentBaseNestedInput>;
  ExternalSignatureInvite?: InputMaybe<ExternalSignatureInviteUpdateManyWithoutDocumentBaseNestedInput>;
  Histories?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutDocumentBaseNestedInput>;
  Renotarizations?: InputMaybe<DocumentRenotarizationUpdateManyWithoutDocumentBaseNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutDocumentsNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutDocumentBaseNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creationType?: InputMaybe<EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  filePath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileSize?: InputMaybe<IntFieldUpdateOperationsInput>;
  internalSeqId?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  version?: InputMaybe<StringFieldUpdateOperationsInput>;
  withoutTeamInternalSeqId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseUpdateWithoutDocumentDegreeInput = {
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentBaseSignatureInviteGroups?: InputMaybe<DocumentBaseSignatureInviteGroupUpdateManyWithoutDocumentBaseNestedInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentSchoolCurriculum?: InputMaybe<DocumentSchoolCurriculumUpdateOneWithoutDocumentBaseNestedInput>;
  ExternalSignatureInvite?: InputMaybe<ExternalSignatureInviteUpdateManyWithoutDocumentBaseNestedInput>;
  Histories?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutDocumentBaseNestedInput>;
  Renotarizations?: InputMaybe<DocumentRenotarizationUpdateManyWithoutDocumentBaseNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutDocumentsNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutDocumentBaseNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creationType?: InputMaybe<EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  filePath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileSize?: InputMaybe<IntFieldUpdateOperationsInput>;
  internalSeqId?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  version?: InputMaybe<StringFieldUpdateOperationsInput>;
  withoutTeamInternalSeqId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseUpdateWithoutDocumentFinalAcademicTranscriptInput = {
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentBaseSignatureInviteGroups?: InputMaybe<DocumentBaseSignatureInviteGroupUpdateManyWithoutDocumentBaseNestedInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentSchoolCurriculum?: InputMaybe<DocumentSchoolCurriculumUpdateOneWithoutDocumentBaseNestedInput>;
  ExternalSignatureInvite?: InputMaybe<ExternalSignatureInviteUpdateManyWithoutDocumentBaseNestedInput>;
  Histories?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutDocumentBaseNestedInput>;
  Renotarizations?: InputMaybe<DocumentRenotarizationUpdateManyWithoutDocumentBaseNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutDocumentsNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutDocumentBaseNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creationType?: InputMaybe<EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  filePath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileSize?: InputMaybe<IntFieldUpdateOperationsInput>;
  internalSeqId?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  version?: InputMaybe<StringFieldUpdateOperationsInput>;
  withoutTeamInternalSeqId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseUpdateWithoutDocumentSchoolCurriculumInput = {
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentBaseSignatureInviteGroups?: InputMaybe<DocumentBaseSignatureInviteGroupUpdateManyWithoutDocumentBaseNestedInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptUpdateOneWithoutDocumentBaseNestedInput>;
  ExternalSignatureInvite?: InputMaybe<ExternalSignatureInviteUpdateManyWithoutDocumentBaseNestedInput>;
  Histories?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutDocumentBaseNestedInput>;
  Renotarizations?: InputMaybe<DocumentRenotarizationUpdateManyWithoutDocumentBaseNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutDocumentsNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutDocumentBaseNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creationType?: InputMaybe<EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  filePath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileSize?: InputMaybe<IntFieldUpdateOperationsInput>;
  internalSeqId?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  version?: InputMaybe<StringFieldUpdateOperationsInput>;
  withoutTeamInternalSeqId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseUpdateWithoutExternalSignatureInviteInput = {
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentBaseSignatureInviteGroups?: InputMaybe<DocumentBaseSignatureInviteGroupUpdateManyWithoutDocumentBaseNestedInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentSchoolCurriculum?: InputMaybe<DocumentSchoolCurriculumUpdateOneWithoutDocumentBaseNestedInput>;
  Histories?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutDocumentBaseNestedInput>;
  Renotarizations?: InputMaybe<DocumentRenotarizationUpdateManyWithoutDocumentBaseNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutDocumentsNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutDocumentBaseNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creationType?: InputMaybe<EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  filePath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileSize?: InputMaybe<IntFieldUpdateOperationsInput>;
  internalSeqId?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  version?: InputMaybe<StringFieldUpdateOperationsInput>;
  withoutTeamInternalSeqId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseUpdateWithoutHistoriesInput = {
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentBaseSignatureInviteGroups?: InputMaybe<DocumentBaseSignatureInviteGroupUpdateManyWithoutDocumentBaseNestedInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentSchoolCurriculum?: InputMaybe<DocumentSchoolCurriculumUpdateOneWithoutDocumentBaseNestedInput>;
  ExternalSignatureInvite?: InputMaybe<ExternalSignatureInviteUpdateManyWithoutDocumentBaseNestedInput>;
  Renotarizations?: InputMaybe<DocumentRenotarizationUpdateManyWithoutDocumentBaseNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutDocumentsNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutDocumentBaseNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creationType?: InputMaybe<EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  filePath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileSize?: InputMaybe<IntFieldUpdateOperationsInput>;
  internalSeqId?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  version?: InputMaybe<StringFieldUpdateOperationsInput>;
  withoutTeamInternalSeqId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseUpdateWithoutRenotarizationsInput = {
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentBaseSignatureInviteGroups?: InputMaybe<DocumentBaseSignatureInviteGroupUpdateManyWithoutDocumentBaseNestedInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentSchoolCurriculum?: InputMaybe<DocumentSchoolCurriculumUpdateOneWithoutDocumentBaseNestedInput>;
  ExternalSignatureInvite?: InputMaybe<ExternalSignatureInviteUpdateManyWithoutDocumentBaseNestedInput>;
  Histories?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutDocumentBaseNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutDocumentsNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutDocumentBaseNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creationType?: InputMaybe<EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  filePath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileSize?: InputMaybe<IntFieldUpdateOperationsInput>;
  internalSeqId?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  version?: InputMaybe<StringFieldUpdateOperationsInput>;
  withoutTeamInternalSeqId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseUpdateWithoutTeamInput = {
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentBaseSignatureInviteGroups?: InputMaybe<DocumentBaseSignatureInviteGroupUpdateManyWithoutDocumentBaseNestedInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentSchoolCurriculum?: InputMaybe<DocumentSchoolCurriculumUpdateOneWithoutDocumentBaseNestedInput>;
  ExternalSignatureInvite?: InputMaybe<ExternalSignatureInviteUpdateManyWithoutDocumentBaseNestedInput>;
  Histories?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutDocumentBaseNestedInput>;
  Renotarizations?: InputMaybe<DocumentRenotarizationUpdateManyWithoutDocumentBaseNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutDocumentBaseNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creationType?: InputMaybe<EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  filePath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileSize?: InputMaybe<IntFieldUpdateOperationsInput>;
  internalSeqId?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  version?: InputMaybe<StringFieldUpdateOperationsInput>;
  withoutTeamInternalSeqId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseUpdateWithoutUserOwnerInput = {
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentBaseSignatureInviteGroups?: InputMaybe<DocumentBaseSignatureInviteGroupUpdateManyWithoutDocumentBaseNestedInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptUpdateOneWithoutDocumentBaseNestedInput>;
  DocumentSchoolCurriculum?: InputMaybe<DocumentSchoolCurriculumUpdateOneWithoutDocumentBaseNestedInput>;
  ExternalSignatureInvite?: InputMaybe<ExternalSignatureInviteUpdateManyWithoutDocumentBaseNestedInput>;
  Histories?: InputMaybe<DocumentBaseHistoryUpdateManyWithoutDocumentBaseNestedInput>;
  Renotarizations?: InputMaybe<DocumentRenotarizationUpdateManyWithoutDocumentBaseNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutDocumentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creationType?: InputMaybe<EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  filePath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fileSize?: InputMaybe<IntFieldUpdateOperationsInput>;
  internalSeqId?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  version?: InputMaybe<StringFieldUpdateOperationsInput>;
  withoutTeamInternalSeqId?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type DocumentBaseUpsertWithWhereUniqueWithoutTeamInput = {
  create: DocumentBaseCreateWithoutTeamInput;
  update: DocumentBaseUpdateWithoutTeamInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseUpsertWithWhereUniqueWithoutUserOwnerInput = {
  create: DocumentBaseCreateWithoutUserOwnerInput;
  update: DocumentBaseUpdateWithoutUserOwnerInput;
  where: DocumentBaseWhereUniqueInput;
};

export type DocumentBaseUpsertWithoutDocumentAcademicDocumentationInput = {
  create: DocumentBaseCreateWithoutDocumentAcademicDocumentationInput;
  update: DocumentBaseUpdateWithoutDocumentAcademicDocumentationInput;
  where?: InputMaybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpsertWithoutDocumentAuditFileIssuerInput = {
  create: DocumentBaseCreateWithoutDocumentAuditFileIssuerInput;
  update: DocumentBaseUpdateWithoutDocumentAuditFileIssuerInput;
  where?: InputMaybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpsertWithoutDocumentBaseSignatureInviteGroupsInput = {
  create: DocumentBaseCreateWithoutDocumentBaseSignatureInviteGroupsInput;
  update: DocumentBaseUpdateWithoutDocumentBaseSignatureInviteGroupsInput;
  where?: InputMaybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpsertWithoutDocumentCertificateInput = {
  create: DocumentBaseCreateWithoutDocumentCertificateInput;
  update: DocumentBaseUpdateWithoutDocumentCertificateInput;
  where?: InputMaybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpsertWithoutDocumentDegreeInput = {
  create: DocumentBaseCreateWithoutDocumentDegreeInput;
  update: DocumentBaseUpdateWithoutDocumentDegreeInput;
  where?: InputMaybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpsertWithoutDocumentFinalAcademicTranscriptInput = {
  create: DocumentBaseCreateWithoutDocumentFinalAcademicTranscriptInput;
  update: DocumentBaseUpdateWithoutDocumentFinalAcademicTranscriptInput;
  where?: InputMaybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpsertWithoutDocumentSchoolCurriculumInput = {
  create: DocumentBaseCreateWithoutDocumentSchoolCurriculumInput;
  update: DocumentBaseUpdateWithoutDocumentSchoolCurriculumInput;
  where?: InputMaybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpsertWithoutExternalSignatureInviteInput = {
  create: DocumentBaseCreateWithoutExternalSignatureInviteInput;
  update: DocumentBaseUpdateWithoutExternalSignatureInviteInput;
  where?: InputMaybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpsertWithoutHistoriesInput = {
  create: DocumentBaseCreateWithoutHistoriesInput;
  update: DocumentBaseUpdateWithoutHistoriesInput;
  where?: InputMaybe<DocumentBaseWhereInput>;
};

export type DocumentBaseUpsertWithoutRenotarizationsInput = {
  create: DocumentBaseCreateWithoutRenotarizationsInput;
  update: DocumentBaseUpdateWithoutRenotarizationsInput;
  where?: InputMaybe<DocumentBaseWhereInput>;
};

export type DocumentBaseWhereInput = {
  AND?: InputMaybe<Array<DocumentBaseWhereInput>>;
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerWhereInput>;
  DocumentBaseSignatureInviteGroups?: InputMaybe<DocumentBaseSignatureInviteGroupListRelationFilter>;
  DocumentCertificate?: InputMaybe<DocumentCertificateWhereInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeWhereInput>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptWhereInput>;
  DocumentSchoolCurriculum?: InputMaybe<DocumentSchoolCurriculumWhereInput>;
  ExternalSignatureInvite?: InputMaybe<ExternalSignatureInviteListRelationFilter>;
  Histories?: InputMaybe<DocumentBaseHistoryListRelationFilter>;
  NOT?: InputMaybe<Array<DocumentBaseWhereInput>>;
  OR?: InputMaybe<Array<DocumentBaseWhereInput>>;
  Renotarizations?: InputMaybe<DocumentRenotarizationListRelationFilter>;
  Team?: InputMaybe<TeamWhereInput>;
  UserOwner?: InputMaybe<CommonUserWhereInput>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationType?: InputMaybe<EnumDocumentAcademicDocumentationCreationTypeFilter>;
  data?: InputMaybe<JsonFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  filePath?: InputMaybe<StringNullableFilter>;
  fileSize?: InputMaybe<IntFilter>;
  internalSeqId?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<IntFilter>;
  type?: InputMaybe<EnumDocumentBaseTypeFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  version?: InputMaybe<StringFilter>;
  withoutTeamInternalSeqId?: InputMaybe<IntFilter>;
};

export type DocumentBaseWhereUniqueInput = {
  AND?: InputMaybe<Array<DocumentBaseWhereInput>>;
  DocumentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
  DocumentAuditFileIssuer?: InputMaybe<DocumentAuditFileIssuerWhereInput>;
  DocumentBaseSignatureInviteGroups?: InputMaybe<DocumentBaseSignatureInviteGroupListRelationFilter>;
  DocumentCertificate?: InputMaybe<DocumentCertificateWhereInput>;
  DocumentDegree?: InputMaybe<DocumentDegreeWhereInput>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptWhereInput>;
  DocumentSchoolCurriculum?: InputMaybe<DocumentSchoolCurriculumWhereInput>;
  ExternalSignatureInvite?: InputMaybe<ExternalSignatureInviteListRelationFilter>;
  Histories?: InputMaybe<DocumentBaseHistoryListRelationFilter>;
  NOT?: InputMaybe<Array<DocumentBaseWhereInput>>;
  OR?: InputMaybe<Array<DocumentBaseWhereInput>>;
  Renotarizations?: InputMaybe<DocumentRenotarizationListRelationFilter>;
  Team?: InputMaybe<TeamWhereInput>;
  UserOwner?: InputMaybe<CommonUserWhereInput>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creationType?: InputMaybe<EnumDocumentAcademicDocumentationCreationTypeFilter>;
  data?: InputMaybe<JsonFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  filePath?: InputMaybe<StringNullableFilter>;
  fileSize?: InputMaybe<IntFilter>;
  internalSeqId?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<IntFilter>;
  type?: InputMaybe<EnumDocumentBaseTypeFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  version?: InputMaybe<StringFilter>;
  withoutTeamInternalSeqId?: InputMaybe<IntFilter>;
};

/** Guarda o certificado gerado a partir do template | Ou feito upload direto numa funcionalidade futura */
export type DocumentCertificate = {
  __typename?: 'DocumentCertificate';
  BulkCertificateRecord?: Maybe<BulkCertificateRecord>;
  Curriculum?: Maybe<CertificateCurriculum>;
  DocumentBase: DocumentBase;
  DocumentCertificateHashHistory: Array<DocumentCertificateHashHistory>;
  DocumentCertificateSignatureItems: Array<DocumentCertificateSignatureItem>;
  Event?: Maybe<CertificateEvent>;
  MetadataList: Array<DocumentCertificateMetadata>;
  Person: Person;
  TeamEducationLevel: TeamEducationLevel;
  Template?: Maybe<CertificateTemplate>;
  batchId?: Maybe<Scalars['String']['output']>;
  certificateCurriculumCertificateBaseId?: Maybe<Scalars['String']['output']>;
  certificateEventCertificateBaseId?: Maybe<Scalars['String']['output']>;
  certificateTemplateId?: Maybe<Scalars['String']['output']>;
  documentBaseId: Scalars['String']['output'];
  documentCertificateCPF: Scalars['String']['output'];
  documentCertificateEmail: Scalars['String']['output'];
  documentCertificateName: Scalars['String']['output'];
  hasOnlyPredefinedVisualSignature: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  personId: Scalars['String']['output'];
  status: DocumentCertificateStatus;
  teamEducationLevelId: Scalars['Int']['output'];
  /** Used to validate in public url */
  uuid: Scalars['String']['output'];
};


/** Guarda o certificado gerado a partir do template | Ou feito upload direto numa funcionalidade futura */
export type DocumentCertificateDocumentCertificateHashHistoryArgs = {
  cursor?: InputMaybe<DocumentCertificateHashHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentCertificateHashHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentCertificateHashHistoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentCertificateHashHistoryWhereInput>;
};


/** Guarda o certificado gerado a partir do template | Ou feito upload direto numa funcionalidade futura */
export type DocumentCertificateDocumentCertificateSignatureItemsArgs = {
  cursor?: InputMaybe<DocumentCertificateSignatureItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentCertificateSignatureItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentCertificateSignatureItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentCertificateSignatureItemWhereInput>;
};


/** Guarda o certificado gerado a partir do template | Ou feito upload direto numa funcionalidade futura */
export type DocumentCertificateMetadataListArgs = {
  cursor?: InputMaybe<DocumentCertificateMetadataWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentCertificateMetadataScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentCertificateMetadataOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentCertificateMetadataWhereInput>;
};

export type DocumentCertificateAvgOrderByAggregateInput = {
  teamEducationLevelId?: InputMaybe<SortOrder>;
};

export type DocumentCertificateCountOrderByAggregateInput = {
  batchId?: InputMaybe<SortOrder>;
  certificateCurriculumCertificateBaseId?: InputMaybe<SortOrder>;
  certificateEventCertificateBaseId?: InputMaybe<SortOrder>;
  certificateTemplateId?: InputMaybe<SortOrder>;
  documentBaseId?: InputMaybe<SortOrder>;
  documentCertificateCPF?: InputMaybe<SortOrder>;
  documentCertificateEmail?: InputMaybe<SortOrder>;
  documentCertificateName?: InputMaybe<SortOrder>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<SortOrder>;
  personId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  teamEducationLevelId?: InputMaybe<SortOrder>;
  uuid?: InputMaybe<SortOrder>;
};

export type DocumentCertificateCreateInput = {
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedOneWithoutDocumentCertificatesInput>;
  Curriculum?: InputMaybe<CertificateCurriculumCreateNestedOneWithoutDocumentCertificateInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentCertificateInput;
  DocumentCertificateHashHistory?: InputMaybe<DocumentCertificateHashHistoryCreateNestedManyWithoutDocumentCertificateInput>;
  DocumentCertificateSignatureItems?: InputMaybe<DocumentCertificateSignatureItemCreateNestedManyWithoutDocumentCertificateInput>;
  Event?: InputMaybe<CertificateEventCreateNestedOneWithoutDocumentCertificateInput>;
  MetadataList?: InputMaybe<DocumentCertificateMetadataCreateNestedManyWithoutDocumentCertificateInput>;
  Person: PersonCreateNestedOneWithoutDocumentCertificateInput;
  TeamEducationLevel: TeamEducationLevelCreateNestedOneWithoutDocumentCertificateInput;
  Template?: InputMaybe<CertificateTemplateCreateNestedOneWithoutDocumentCertificateInput>;
  documentCertificateCPF?: InputMaybe<Scalars['String']['input']>;
  documentCertificateEmail?: InputMaybe<Scalars['String']['input']>;
  documentCertificateName?: InputMaybe<Scalars['String']['input']>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<Scalars['Boolean']['input']>;
  status: DocumentCertificateStatus;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentCertificateCreateManyBulkCertificateRecordInput = {
  certificateCurriculumCertificateBaseId?: InputMaybe<Scalars['String']['input']>;
  certificateEventCertificateBaseId?: InputMaybe<Scalars['String']['input']>;
  certificateTemplateId?: InputMaybe<Scalars['String']['input']>;
  documentBaseId: Scalars['String']['input'];
  documentCertificateCPF?: InputMaybe<Scalars['String']['input']>;
  documentCertificateEmail?: InputMaybe<Scalars['String']['input']>;
  documentCertificateName?: InputMaybe<Scalars['String']['input']>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<Scalars['Boolean']['input']>;
  personId: Scalars['String']['input'];
  status: DocumentCertificateStatus;
  teamEducationLevelId: Scalars['Int']['input'];
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentCertificateCreateManyBulkCertificateRecordInputEnvelope = {
  data: Array<DocumentCertificateCreateManyBulkCertificateRecordInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentCertificateCreateManyCurriculumInput = {
  batchId?: InputMaybe<Scalars['String']['input']>;
  certificateEventCertificateBaseId?: InputMaybe<Scalars['String']['input']>;
  certificateTemplateId?: InputMaybe<Scalars['String']['input']>;
  documentBaseId: Scalars['String']['input'];
  documentCertificateCPF?: InputMaybe<Scalars['String']['input']>;
  documentCertificateEmail?: InputMaybe<Scalars['String']['input']>;
  documentCertificateName?: InputMaybe<Scalars['String']['input']>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<Scalars['Boolean']['input']>;
  personId: Scalars['String']['input'];
  status: DocumentCertificateStatus;
  teamEducationLevelId: Scalars['Int']['input'];
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentCertificateCreateManyCurriculumInputEnvelope = {
  data: Array<DocumentCertificateCreateManyCurriculumInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentCertificateCreateManyEventInput = {
  batchId?: InputMaybe<Scalars['String']['input']>;
  certificateCurriculumCertificateBaseId?: InputMaybe<Scalars['String']['input']>;
  certificateTemplateId?: InputMaybe<Scalars['String']['input']>;
  documentBaseId: Scalars['String']['input'];
  documentCertificateCPF?: InputMaybe<Scalars['String']['input']>;
  documentCertificateEmail?: InputMaybe<Scalars['String']['input']>;
  documentCertificateName?: InputMaybe<Scalars['String']['input']>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<Scalars['Boolean']['input']>;
  personId: Scalars['String']['input'];
  status: DocumentCertificateStatus;
  teamEducationLevelId: Scalars['Int']['input'];
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentCertificateCreateManyEventInputEnvelope = {
  data: Array<DocumentCertificateCreateManyEventInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentCertificateCreateManyInput = {
  batchId?: InputMaybe<Scalars['String']['input']>;
  certificateCurriculumCertificateBaseId?: InputMaybe<Scalars['String']['input']>;
  certificateEventCertificateBaseId?: InputMaybe<Scalars['String']['input']>;
  certificateTemplateId?: InputMaybe<Scalars['String']['input']>;
  documentBaseId: Scalars['String']['input'];
  documentCertificateCPF?: InputMaybe<Scalars['String']['input']>;
  documentCertificateEmail?: InputMaybe<Scalars['String']['input']>;
  documentCertificateName?: InputMaybe<Scalars['String']['input']>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<Scalars['Boolean']['input']>;
  personId: Scalars['String']['input'];
  status: DocumentCertificateStatus;
  teamEducationLevelId: Scalars['Int']['input'];
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentCertificateCreateManyPersonInput = {
  batchId?: InputMaybe<Scalars['String']['input']>;
  certificateCurriculumCertificateBaseId?: InputMaybe<Scalars['String']['input']>;
  certificateEventCertificateBaseId?: InputMaybe<Scalars['String']['input']>;
  certificateTemplateId?: InputMaybe<Scalars['String']['input']>;
  documentBaseId: Scalars['String']['input'];
  documentCertificateCPF?: InputMaybe<Scalars['String']['input']>;
  documentCertificateEmail?: InputMaybe<Scalars['String']['input']>;
  documentCertificateName?: InputMaybe<Scalars['String']['input']>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<Scalars['Boolean']['input']>;
  status: DocumentCertificateStatus;
  teamEducationLevelId: Scalars['Int']['input'];
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentCertificateCreateManyPersonInputEnvelope = {
  data: Array<DocumentCertificateCreateManyPersonInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentCertificateCreateManyTeamEducationLevelInput = {
  batchId?: InputMaybe<Scalars['String']['input']>;
  certificateCurriculumCertificateBaseId?: InputMaybe<Scalars['String']['input']>;
  certificateEventCertificateBaseId?: InputMaybe<Scalars['String']['input']>;
  certificateTemplateId?: InputMaybe<Scalars['String']['input']>;
  documentBaseId: Scalars['String']['input'];
  documentCertificateCPF?: InputMaybe<Scalars['String']['input']>;
  documentCertificateEmail?: InputMaybe<Scalars['String']['input']>;
  documentCertificateName?: InputMaybe<Scalars['String']['input']>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<Scalars['Boolean']['input']>;
  personId: Scalars['String']['input'];
  status: DocumentCertificateStatus;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentCertificateCreateManyTeamEducationLevelInputEnvelope = {
  data: Array<DocumentCertificateCreateManyTeamEducationLevelInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentCertificateCreateManyTemplateInput = {
  batchId?: InputMaybe<Scalars['String']['input']>;
  certificateCurriculumCertificateBaseId?: InputMaybe<Scalars['String']['input']>;
  certificateEventCertificateBaseId?: InputMaybe<Scalars['String']['input']>;
  documentBaseId: Scalars['String']['input'];
  documentCertificateCPF?: InputMaybe<Scalars['String']['input']>;
  documentCertificateEmail?: InputMaybe<Scalars['String']['input']>;
  documentCertificateName?: InputMaybe<Scalars['String']['input']>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<Scalars['Boolean']['input']>;
  personId: Scalars['String']['input'];
  status: DocumentCertificateStatus;
  teamEducationLevelId: Scalars['Int']['input'];
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentCertificateCreateManyTemplateInputEnvelope = {
  data: Array<DocumentCertificateCreateManyTemplateInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentCertificateCreateNestedManyWithoutBulkCertificateRecordInput = {
  connect?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCertificateCreateOrConnectWithoutBulkCertificateRecordInput>>;
  create?: InputMaybe<Array<DocumentCertificateCreateWithoutBulkCertificateRecordInput>>;
  createMany?: InputMaybe<DocumentCertificateCreateManyBulkCertificateRecordInputEnvelope>;
};

export type DocumentCertificateCreateNestedManyWithoutCurriculumInput = {
  connect?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCertificateCreateOrConnectWithoutCurriculumInput>>;
  create?: InputMaybe<Array<DocumentCertificateCreateWithoutCurriculumInput>>;
  createMany?: InputMaybe<DocumentCertificateCreateManyCurriculumInputEnvelope>;
};

export type DocumentCertificateCreateNestedManyWithoutEventInput = {
  connect?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCertificateCreateOrConnectWithoutEventInput>>;
  create?: InputMaybe<Array<DocumentCertificateCreateWithoutEventInput>>;
  createMany?: InputMaybe<DocumentCertificateCreateManyEventInputEnvelope>;
};

export type DocumentCertificateCreateNestedManyWithoutPersonInput = {
  connect?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCertificateCreateOrConnectWithoutPersonInput>>;
  create?: InputMaybe<Array<DocumentCertificateCreateWithoutPersonInput>>;
  createMany?: InputMaybe<DocumentCertificateCreateManyPersonInputEnvelope>;
};

export type DocumentCertificateCreateNestedManyWithoutTeamEducationLevelInput = {
  connect?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCertificateCreateOrConnectWithoutTeamEducationLevelInput>>;
  create?: InputMaybe<Array<DocumentCertificateCreateWithoutTeamEducationLevelInput>>;
  createMany?: InputMaybe<DocumentCertificateCreateManyTeamEducationLevelInputEnvelope>;
};

export type DocumentCertificateCreateNestedManyWithoutTemplateInput = {
  connect?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCertificateCreateOrConnectWithoutTemplateInput>>;
  create?: InputMaybe<Array<DocumentCertificateCreateWithoutTemplateInput>>;
  createMany?: InputMaybe<DocumentCertificateCreateManyTemplateInputEnvelope>;
};

export type DocumentCertificateCreateNestedOneWithoutDocumentBaseInput = {
  connect?: InputMaybe<DocumentCertificateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentCertificateCreateOrConnectWithoutDocumentBaseInput>;
  create?: InputMaybe<DocumentCertificateCreateWithoutDocumentBaseInput>;
};

export type DocumentCertificateCreateNestedOneWithoutDocumentCertificateHashHistoryInput = {
  connect?: InputMaybe<DocumentCertificateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentCertificateCreateOrConnectWithoutDocumentCertificateHashHistoryInput>;
  create?: InputMaybe<DocumentCertificateCreateWithoutDocumentCertificateHashHistoryInput>;
};

export type DocumentCertificateCreateNestedOneWithoutDocumentCertificateSignatureItemsInput = {
  connect?: InputMaybe<DocumentCertificateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentCertificateCreateOrConnectWithoutDocumentCertificateSignatureItemsInput>;
  create?: InputMaybe<DocumentCertificateCreateWithoutDocumentCertificateSignatureItemsInput>;
};

export type DocumentCertificateCreateNestedOneWithoutMetadataListInput = {
  connect?: InputMaybe<DocumentCertificateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentCertificateCreateOrConnectWithoutMetadataListInput>;
  create?: InputMaybe<DocumentCertificateCreateWithoutMetadataListInput>;
};

export type DocumentCertificateCreateOrConnectWithoutBulkCertificateRecordInput = {
  create: DocumentCertificateCreateWithoutBulkCertificateRecordInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateCreateOrConnectWithoutCurriculumInput = {
  create: DocumentCertificateCreateWithoutCurriculumInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateCreateOrConnectWithoutDocumentBaseInput = {
  create: DocumentCertificateCreateWithoutDocumentBaseInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateCreateOrConnectWithoutDocumentCertificateHashHistoryInput = {
  create: DocumentCertificateCreateWithoutDocumentCertificateHashHistoryInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateCreateOrConnectWithoutDocumentCertificateSignatureItemsInput = {
  create: DocumentCertificateCreateWithoutDocumentCertificateSignatureItemsInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateCreateOrConnectWithoutEventInput = {
  create: DocumentCertificateCreateWithoutEventInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateCreateOrConnectWithoutMetadataListInput = {
  create: DocumentCertificateCreateWithoutMetadataListInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateCreateOrConnectWithoutPersonInput = {
  create: DocumentCertificateCreateWithoutPersonInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateCreateOrConnectWithoutTeamEducationLevelInput = {
  create: DocumentCertificateCreateWithoutTeamEducationLevelInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateCreateOrConnectWithoutTemplateInput = {
  create: DocumentCertificateCreateWithoutTemplateInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateCreateWithoutBulkCertificateRecordInput = {
  Curriculum?: InputMaybe<CertificateCurriculumCreateNestedOneWithoutDocumentCertificateInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentCertificateInput;
  DocumentCertificateHashHistory?: InputMaybe<DocumentCertificateHashHistoryCreateNestedManyWithoutDocumentCertificateInput>;
  DocumentCertificateSignatureItems?: InputMaybe<DocumentCertificateSignatureItemCreateNestedManyWithoutDocumentCertificateInput>;
  Event?: InputMaybe<CertificateEventCreateNestedOneWithoutDocumentCertificateInput>;
  MetadataList?: InputMaybe<DocumentCertificateMetadataCreateNestedManyWithoutDocumentCertificateInput>;
  Person: PersonCreateNestedOneWithoutDocumentCertificateInput;
  TeamEducationLevel: TeamEducationLevelCreateNestedOneWithoutDocumentCertificateInput;
  Template?: InputMaybe<CertificateTemplateCreateNestedOneWithoutDocumentCertificateInput>;
  documentCertificateCPF?: InputMaybe<Scalars['String']['input']>;
  documentCertificateEmail?: InputMaybe<Scalars['String']['input']>;
  documentCertificateName?: InputMaybe<Scalars['String']['input']>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<Scalars['Boolean']['input']>;
  status: DocumentCertificateStatus;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentCertificateCreateWithoutCurriculumInput = {
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedOneWithoutDocumentCertificatesInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentCertificateInput;
  DocumentCertificateHashHistory?: InputMaybe<DocumentCertificateHashHistoryCreateNestedManyWithoutDocumentCertificateInput>;
  DocumentCertificateSignatureItems?: InputMaybe<DocumentCertificateSignatureItemCreateNestedManyWithoutDocumentCertificateInput>;
  Event?: InputMaybe<CertificateEventCreateNestedOneWithoutDocumentCertificateInput>;
  MetadataList?: InputMaybe<DocumentCertificateMetadataCreateNestedManyWithoutDocumentCertificateInput>;
  Person: PersonCreateNestedOneWithoutDocumentCertificateInput;
  TeamEducationLevel: TeamEducationLevelCreateNestedOneWithoutDocumentCertificateInput;
  Template?: InputMaybe<CertificateTemplateCreateNestedOneWithoutDocumentCertificateInput>;
  documentCertificateCPF?: InputMaybe<Scalars['String']['input']>;
  documentCertificateEmail?: InputMaybe<Scalars['String']['input']>;
  documentCertificateName?: InputMaybe<Scalars['String']['input']>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<Scalars['Boolean']['input']>;
  status: DocumentCertificateStatus;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentCertificateCreateWithoutDocumentBaseInput = {
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedOneWithoutDocumentCertificatesInput>;
  Curriculum?: InputMaybe<CertificateCurriculumCreateNestedOneWithoutDocumentCertificateInput>;
  DocumentCertificateHashHistory?: InputMaybe<DocumentCertificateHashHistoryCreateNestedManyWithoutDocumentCertificateInput>;
  DocumentCertificateSignatureItems?: InputMaybe<DocumentCertificateSignatureItemCreateNestedManyWithoutDocumentCertificateInput>;
  Event?: InputMaybe<CertificateEventCreateNestedOneWithoutDocumentCertificateInput>;
  MetadataList?: InputMaybe<DocumentCertificateMetadataCreateNestedManyWithoutDocumentCertificateInput>;
  Person: PersonCreateNestedOneWithoutDocumentCertificateInput;
  TeamEducationLevel: TeamEducationLevelCreateNestedOneWithoutDocumentCertificateInput;
  Template?: InputMaybe<CertificateTemplateCreateNestedOneWithoutDocumentCertificateInput>;
  documentCertificateCPF?: InputMaybe<Scalars['String']['input']>;
  documentCertificateEmail?: InputMaybe<Scalars['String']['input']>;
  documentCertificateName?: InputMaybe<Scalars['String']['input']>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<Scalars['Boolean']['input']>;
  status: DocumentCertificateStatus;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentCertificateCreateWithoutDocumentCertificateHashHistoryInput = {
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedOneWithoutDocumentCertificatesInput>;
  Curriculum?: InputMaybe<CertificateCurriculumCreateNestedOneWithoutDocumentCertificateInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentCertificateInput;
  DocumentCertificateSignatureItems?: InputMaybe<DocumentCertificateSignatureItemCreateNestedManyWithoutDocumentCertificateInput>;
  Event?: InputMaybe<CertificateEventCreateNestedOneWithoutDocumentCertificateInput>;
  MetadataList?: InputMaybe<DocumentCertificateMetadataCreateNestedManyWithoutDocumentCertificateInput>;
  Person: PersonCreateNestedOneWithoutDocumentCertificateInput;
  TeamEducationLevel: TeamEducationLevelCreateNestedOneWithoutDocumentCertificateInput;
  Template?: InputMaybe<CertificateTemplateCreateNestedOneWithoutDocumentCertificateInput>;
  documentCertificateCPF?: InputMaybe<Scalars['String']['input']>;
  documentCertificateEmail?: InputMaybe<Scalars['String']['input']>;
  documentCertificateName?: InputMaybe<Scalars['String']['input']>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<Scalars['Boolean']['input']>;
  status: DocumentCertificateStatus;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentCertificateCreateWithoutDocumentCertificateSignatureItemsInput = {
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedOneWithoutDocumentCertificatesInput>;
  Curriculum?: InputMaybe<CertificateCurriculumCreateNestedOneWithoutDocumentCertificateInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentCertificateInput;
  DocumentCertificateHashHistory?: InputMaybe<DocumentCertificateHashHistoryCreateNestedManyWithoutDocumentCertificateInput>;
  Event?: InputMaybe<CertificateEventCreateNestedOneWithoutDocumentCertificateInput>;
  MetadataList?: InputMaybe<DocumentCertificateMetadataCreateNestedManyWithoutDocumentCertificateInput>;
  Person: PersonCreateNestedOneWithoutDocumentCertificateInput;
  TeamEducationLevel: TeamEducationLevelCreateNestedOneWithoutDocumentCertificateInput;
  Template?: InputMaybe<CertificateTemplateCreateNestedOneWithoutDocumentCertificateInput>;
  documentCertificateCPF?: InputMaybe<Scalars['String']['input']>;
  documentCertificateEmail?: InputMaybe<Scalars['String']['input']>;
  documentCertificateName?: InputMaybe<Scalars['String']['input']>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<Scalars['Boolean']['input']>;
  status: DocumentCertificateStatus;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentCertificateCreateWithoutEventInput = {
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedOneWithoutDocumentCertificatesInput>;
  Curriculum?: InputMaybe<CertificateCurriculumCreateNestedOneWithoutDocumentCertificateInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentCertificateInput;
  DocumentCertificateHashHistory?: InputMaybe<DocumentCertificateHashHistoryCreateNestedManyWithoutDocumentCertificateInput>;
  DocumentCertificateSignatureItems?: InputMaybe<DocumentCertificateSignatureItemCreateNestedManyWithoutDocumentCertificateInput>;
  MetadataList?: InputMaybe<DocumentCertificateMetadataCreateNestedManyWithoutDocumentCertificateInput>;
  Person: PersonCreateNestedOneWithoutDocumentCertificateInput;
  TeamEducationLevel: TeamEducationLevelCreateNestedOneWithoutDocumentCertificateInput;
  Template?: InputMaybe<CertificateTemplateCreateNestedOneWithoutDocumentCertificateInput>;
  documentCertificateCPF?: InputMaybe<Scalars['String']['input']>;
  documentCertificateEmail?: InputMaybe<Scalars['String']['input']>;
  documentCertificateName?: InputMaybe<Scalars['String']['input']>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<Scalars['Boolean']['input']>;
  status: DocumentCertificateStatus;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentCertificateCreateWithoutMetadataListInput = {
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedOneWithoutDocumentCertificatesInput>;
  Curriculum?: InputMaybe<CertificateCurriculumCreateNestedOneWithoutDocumentCertificateInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentCertificateInput;
  DocumentCertificateHashHistory?: InputMaybe<DocumentCertificateHashHistoryCreateNestedManyWithoutDocumentCertificateInput>;
  DocumentCertificateSignatureItems?: InputMaybe<DocumentCertificateSignatureItemCreateNestedManyWithoutDocumentCertificateInput>;
  Event?: InputMaybe<CertificateEventCreateNestedOneWithoutDocumentCertificateInput>;
  Person: PersonCreateNestedOneWithoutDocumentCertificateInput;
  TeamEducationLevel: TeamEducationLevelCreateNestedOneWithoutDocumentCertificateInput;
  Template?: InputMaybe<CertificateTemplateCreateNestedOneWithoutDocumentCertificateInput>;
  documentCertificateCPF?: InputMaybe<Scalars['String']['input']>;
  documentCertificateEmail?: InputMaybe<Scalars['String']['input']>;
  documentCertificateName?: InputMaybe<Scalars['String']['input']>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<Scalars['Boolean']['input']>;
  status: DocumentCertificateStatus;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentCertificateCreateWithoutPersonInput = {
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedOneWithoutDocumentCertificatesInput>;
  Curriculum?: InputMaybe<CertificateCurriculumCreateNestedOneWithoutDocumentCertificateInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentCertificateInput;
  DocumentCertificateHashHistory?: InputMaybe<DocumentCertificateHashHistoryCreateNestedManyWithoutDocumentCertificateInput>;
  DocumentCertificateSignatureItems?: InputMaybe<DocumentCertificateSignatureItemCreateNestedManyWithoutDocumentCertificateInput>;
  Event?: InputMaybe<CertificateEventCreateNestedOneWithoutDocumentCertificateInput>;
  MetadataList?: InputMaybe<DocumentCertificateMetadataCreateNestedManyWithoutDocumentCertificateInput>;
  TeamEducationLevel: TeamEducationLevelCreateNestedOneWithoutDocumentCertificateInput;
  Template?: InputMaybe<CertificateTemplateCreateNestedOneWithoutDocumentCertificateInput>;
  documentCertificateCPF?: InputMaybe<Scalars['String']['input']>;
  documentCertificateEmail?: InputMaybe<Scalars['String']['input']>;
  documentCertificateName?: InputMaybe<Scalars['String']['input']>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<Scalars['Boolean']['input']>;
  status: DocumentCertificateStatus;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentCertificateCreateWithoutTeamEducationLevelInput = {
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedOneWithoutDocumentCertificatesInput>;
  Curriculum?: InputMaybe<CertificateCurriculumCreateNestedOneWithoutDocumentCertificateInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentCertificateInput;
  DocumentCertificateHashHistory?: InputMaybe<DocumentCertificateHashHistoryCreateNestedManyWithoutDocumentCertificateInput>;
  DocumentCertificateSignatureItems?: InputMaybe<DocumentCertificateSignatureItemCreateNestedManyWithoutDocumentCertificateInput>;
  Event?: InputMaybe<CertificateEventCreateNestedOneWithoutDocumentCertificateInput>;
  MetadataList?: InputMaybe<DocumentCertificateMetadataCreateNestedManyWithoutDocumentCertificateInput>;
  Person: PersonCreateNestedOneWithoutDocumentCertificateInput;
  Template?: InputMaybe<CertificateTemplateCreateNestedOneWithoutDocumentCertificateInput>;
  documentCertificateCPF?: InputMaybe<Scalars['String']['input']>;
  documentCertificateEmail?: InputMaybe<Scalars['String']['input']>;
  documentCertificateName?: InputMaybe<Scalars['String']['input']>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<Scalars['Boolean']['input']>;
  status: DocumentCertificateStatus;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentCertificateCreateWithoutTemplateInput = {
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedOneWithoutDocumentCertificatesInput>;
  Curriculum?: InputMaybe<CertificateCurriculumCreateNestedOneWithoutDocumentCertificateInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentCertificateInput;
  DocumentCertificateHashHistory?: InputMaybe<DocumentCertificateHashHistoryCreateNestedManyWithoutDocumentCertificateInput>;
  DocumentCertificateSignatureItems?: InputMaybe<DocumentCertificateSignatureItemCreateNestedManyWithoutDocumentCertificateInput>;
  Event?: InputMaybe<CertificateEventCreateNestedOneWithoutDocumentCertificateInput>;
  MetadataList?: InputMaybe<DocumentCertificateMetadataCreateNestedManyWithoutDocumentCertificateInput>;
  Person: PersonCreateNestedOneWithoutDocumentCertificateInput;
  TeamEducationLevel: TeamEducationLevelCreateNestedOneWithoutDocumentCertificateInput;
  documentCertificateCPF?: InputMaybe<Scalars['String']['input']>;
  documentCertificateEmail?: InputMaybe<Scalars['String']['input']>;
  documentCertificateName?: InputMaybe<Scalars['String']['input']>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<Scalars['Boolean']['input']>;
  status: DocumentCertificateStatus;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentCertificateHashHistory = {
  __typename?: 'DocumentCertificateHashHistory';
  DocumentCertificate: DocumentCertificate;
  createdAt: Scalars['DateTime']['output'];
  documentBaseId: Scalars['String']['output'];
  hash: Scalars['String']['output'];
  hashType: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type DocumentCertificateHashHistoryCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  documentBaseId?: InputMaybe<SortOrder>;
  hash?: InputMaybe<SortOrder>;
  hashType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DocumentCertificateHashHistoryCreateInput = {
  DocumentCertificate: DocumentCertificateCreateNestedOneWithoutDocumentCertificateHashHistoryInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  hash: Scalars['String']['input'];
  hashType: DocumentCertificateSignatureHashHistoryType;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentCertificateHashHistoryCreateManyDocumentCertificateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  hash: Scalars['String']['input'];
  hashType: DocumentCertificateSignatureHashHistoryType;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentCertificateHashHistoryCreateManyDocumentCertificateInputEnvelope = {
  data: Array<DocumentCertificateHashHistoryCreateManyDocumentCertificateInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentCertificateHashHistoryCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  documentBaseId: Scalars['String']['input'];
  hash: Scalars['String']['input'];
  hashType: DocumentCertificateSignatureHashHistoryType;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentCertificateHashHistoryCreateNestedManyWithoutDocumentCertificateInput = {
  connect?: InputMaybe<Array<DocumentCertificateHashHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCertificateHashHistoryCreateOrConnectWithoutDocumentCertificateInput>>;
  create?: InputMaybe<Array<DocumentCertificateHashHistoryCreateWithoutDocumentCertificateInput>>;
  createMany?: InputMaybe<DocumentCertificateHashHistoryCreateManyDocumentCertificateInputEnvelope>;
};

export type DocumentCertificateHashHistoryCreateOrConnectWithoutDocumentCertificateInput = {
  create: DocumentCertificateHashHistoryCreateWithoutDocumentCertificateInput;
  where: DocumentCertificateHashHistoryWhereUniqueInput;
};

export type DocumentCertificateHashHistoryCreateWithoutDocumentCertificateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  hash: Scalars['String']['input'];
  hashType: DocumentCertificateSignatureHashHistoryType;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentCertificateHashHistoryListRelationFilter = {
  every?: InputMaybe<DocumentCertificateHashHistoryWhereInput>;
  none?: InputMaybe<DocumentCertificateHashHistoryWhereInput>;
  some?: InputMaybe<DocumentCertificateHashHistoryWhereInput>;
};

export type DocumentCertificateHashHistoryMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  documentBaseId?: InputMaybe<SortOrder>;
  hash?: InputMaybe<SortOrder>;
  hashType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DocumentCertificateHashHistoryMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  documentBaseId?: InputMaybe<SortOrder>;
  hash?: InputMaybe<SortOrder>;
  hashType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DocumentCertificateHashHistoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DocumentCertificateHashHistoryOrderByWithAggregationInput = {
  _count?: InputMaybe<DocumentCertificateHashHistoryCountOrderByAggregateInput>;
  _max?: InputMaybe<DocumentCertificateHashHistoryMaxOrderByAggregateInput>;
  _min?: InputMaybe<DocumentCertificateHashHistoryMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  documentBaseId?: InputMaybe<SortOrder>;
  hash?: InputMaybe<SortOrder>;
  hashType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DocumentCertificateHashHistoryOrderByWithRelationInput = {
  DocumentCertificate?: InputMaybe<DocumentCertificateOrderByWithRelationInput>;
  createdAt?: InputMaybe<SortOrder>;
  documentBaseId?: InputMaybe<SortOrder>;
  hash?: InputMaybe<SortOrder>;
  hashType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export enum DocumentCertificateHashHistoryScalarFieldEnum {
  CreatedAt = 'createdAt',
  DocumentBaseId = 'documentBaseId',
  Hash = 'hash',
  HashType = 'hashType',
  Id = 'id'
}

export type DocumentCertificateHashHistoryScalarWhereInput = {
  AND?: InputMaybe<Array<DocumentCertificateHashHistoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<DocumentCertificateHashHistoryScalarWhereInput>>;
  OR?: InputMaybe<Array<DocumentCertificateHashHistoryScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentBaseId?: InputMaybe<StringFilter>;
  hash?: InputMaybe<StringFilter>;
  hashType?: InputMaybe<EnumDocumentCertificateSignatureHashHistoryTypeFilter>;
  id?: InputMaybe<StringFilter>;
};

export type DocumentCertificateHashHistoryScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DocumentCertificateHashHistoryScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DocumentCertificateHashHistoryScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DocumentCertificateHashHistoryScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  documentBaseId?: InputMaybe<StringWithAggregatesFilter>;
  hash?: InputMaybe<StringWithAggregatesFilter>;
  hashType?: InputMaybe<EnumDocumentCertificateSignatureHashHistoryTypeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
};

export type DocumentCertificateHashHistoryUpdateInput = {
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateOneRequiredWithoutDocumentCertificateHashHistoryNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  hash?: InputMaybe<StringFieldUpdateOperationsInput>;
  hashType?: InputMaybe<EnumDocumentCertificateSignatureHashHistoryTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateHashHistoryUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  hash?: InputMaybe<StringFieldUpdateOperationsInput>;
  hashType?: InputMaybe<EnumDocumentCertificateSignatureHashHistoryTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateHashHistoryUpdateManyWithWhereWithoutDocumentCertificateInput = {
  data: DocumentCertificateHashHistoryUpdateManyMutationInput;
  where: DocumentCertificateHashHistoryScalarWhereInput;
};

export type DocumentCertificateHashHistoryUpdateManyWithoutDocumentCertificateNestedInput = {
  connect?: InputMaybe<Array<DocumentCertificateHashHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCertificateHashHistoryCreateOrConnectWithoutDocumentCertificateInput>>;
  create?: InputMaybe<Array<DocumentCertificateHashHistoryCreateWithoutDocumentCertificateInput>>;
  createMany?: InputMaybe<DocumentCertificateHashHistoryCreateManyDocumentCertificateInputEnvelope>;
  delete?: InputMaybe<Array<DocumentCertificateHashHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentCertificateHashHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentCertificateHashHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentCertificateHashHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentCertificateHashHistoryUpdateWithWhereUniqueWithoutDocumentCertificateInput>>;
  updateMany?: InputMaybe<Array<DocumentCertificateHashHistoryUpdateManyWithWhereWithoutDocumentCertificateInput>>;
  upsert?: InputMaybe<Array<DocumentCertificateHashHistoryUpsertWithWhereUniqueWithoutDocumentCertificateInput>>;
};

export type DocumentCertificateHashHistoryUpdateWithWhereUniqueWithoutDocumentCertificateInput = {
  data: DocumentCertificateHashHistoryUpdateWithoutDocumentCertificateInput;
  where: DocumentCertificateHashHistoryWhereUniqueInput;
};

export type DocumentCertificateHashHistoryUpdateWithoutDocumentCertificateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  hash?: InputMaybe<StringFieldUpdateOperationsInput>;
  hashType?: InputMaybe<EnumDocumentCertificateSignatureHashHistoryTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateHashHistoryUpsertWithWhereUniqueWithoutDocumentCertificateInput = {
  create: DocumentCertificateHashHistoryCreateWithoutDocumentCertificateInput;
  update: DocumentCertificateHashHistoryUpdateWithoutDocumentCertificateInput;
  where: DocumentCertificateHashHistoryWhereUniqueInput;
};

export type DocumentCertificateHashHistoryWhereInput = {
  AND?: InputMaybe<Array<DocumentCertificateHashHistoryWhereInput>>;
  DocumentCertificate?: InputMaybe<DocumentCertificateWhereInput>;
  NOT?: InputMaybe<Array<DocumentCertificateHashHistoryWhereInput>>;
  OR?: InputMaybe<Array<DocumentCertificateHashHistoryWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentBaseId?: InputMaybe<StringFilter>;
  hash?: InputMaybe<StringFilter>;
  hashType?: InputMaybe<EnumDocumentCertificateSignatureHashHistoryTypeFilter>;
  id?: InputMaybe<StringFilter>;
};

export type DocumentCertificateHashHistoryWhereUniqueInput = {
  AND?: InputMaybe<Array<DocumentCertificateHashHistoryWhereInput>>;
  DocumentCertificate?: InputMaybe<DocumentCertificateWhereInput>;
  NOT?: InputMaybe<Array<DocumentCertificateHashHistoryWhereInput>>;
  OR?: InputMaybe<Array<DocumentCertificateHashHistoryWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentBaseId?: InputMaybe<StringFilter>;
  hash?: InputMaybe<Scalars['String']['input']>;
  hashType?: InputMaybe<EnumDocumentCertificateSignatureHashHistoryTypeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentCertificateListRelationFilter = {
  every?: InputMaybe<DocumentCertificateWhereInput>;
  none?: InputMaybe<DocumentCertificateWhereInput>;
  some?: InputMaybe<DocumentCertificateWhereInput>;
};

export type DocumentCertificateMaxOrderByAggregateInput = {
  batchId?: InputMaybe<SortOrder>;
  certificateCurriculumCertificateBaseId?: InputMaybe<SortOrder>;
  certificateEventCertificateBaseId?: InputMaybe<SortOrder>;
  certificateTemplateId?: InputMaybe<SortOrder>;
  documentBaseId?: InputMaybe<SortOrder>;
  documentCertificateCPF?: InputMaybe<SortOrder>;
  documentCertificateEmail?: InputMaybe<SortOrder>;
  documentCertificateName?: InputMaybe<SortOrder>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<SortOrder>;
  personId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  teamEducationLevelId?: InputMaybe<SortOrder>;
  uuid?: InputMaybe<SortOrder>;
};

export type DocumentCertificateMetadata = {
  __typename?: 'DocumentCertificateMetadata';
  DocumentCertificate: DocumentCertificate;
  certificateId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DocumentCertificateMetadataAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type DocumentCertificateMetadataCountOrderByAggregateInput = {
  certificateId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type DocumentCertificateMetadataCreateInput = {
  DocumentCertificate: DocumentCertificateCreateNestedOneWithoutMetadataListInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type DocumentCertificateMetadataCreateManyDocumentCertificateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type DocumentCertificateMetadataCreateManyDocumentCertificateInputEnvelope = {
  data: Array<DocumentCertificateMetadataCreateManyDocumentCertificateInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentCertificateMetadataCreateManyInput = {
  certificateId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type DocumentCertificateMetadataCreateNestedManyWithoutDocumentCertificateInput = {
  connect?: InputMaybe<Array<DocumentCertificateMetadataWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCertificateMetadataCreateOrConnectWithoutDocumentCertificateInput>>;
  create?: InputMaybe<Array<DocumentCertificateMetadataCreateWithoutDocumentCertificateInput>>;
  createMany?: InputMaybe<DocumentCertificateMetadataCreateManyDocumentCertificateInputEnvelope>;
};

export type DocumentCertificateMetadataCreateOrConnectWithoutDocumentCertificateInput = {
  create: DocumentCertificateMetadataCreateWithoutDocumentCertificateInput;
  where: DocumentCertificateMetadataWhereUniqueInput;
};

export type DocumentCertificateMetadataCreateWithoutDocumentCertificateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type DocumentCertificateMetadataListRelationFilter = {
  every?: InputMaybe<DocumentCertificateMetadataWhereInput>;
  none?: InputMaybe<DocumentCertificateMetadataWhereInput>;
  some?: InputMaybe<DocumentCertificateMetadataWhereInput>;
};

export type DocumentCertificateMetadataMaxOrderByAggregateInput = {
  certificateId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type DocumentCertificateMetadataMinOrderByAggregateInput = {
  certificateId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type DocumentCertificateMetadataOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DocumentCertificateMetadataOrderByWithAggregationInput = {
  _avg?: InputMaybe<DocumentCertificateMetadataAvgOrderByAggregateInput>;
  _count?: InputMaybe<DocumentCertificateMetadataCountOrderByAggregateInput>;
  _max?: InputMaybe<DocumentCertificateMetadataMaxOrderByAggregateInput>;
  _min?: InputMaybe<DocumentCertificateMetadataMinOrderByAggregateInput>;
  _sum?: InputMaybe<DocumentCertificateMetadataSumOrderByAggregateInput>;
  certificateId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type DocumentCertificateMetadataOrderByWithRelationInput = {
  DocumentCertificate?: InputMaybe<DocumentCertificateOrderByWithRelationInput>;
  certificateId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export enum DocumentCertificateMetadataScalarFieldEnum {
  CertificateId = 'certificateId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Key = 'key',
  Value = 'value'
}

export type DocumentCertificateMetadataScalarWhereInput = {
  AND?: InputMaybe<Array<DocumentCertificateMetadataScalarWhereInput>>;
  NOT?: InputMaybe<Array<DocumentCertificateMetadataScalarWhereInput>>;
  OR?: InputMaybe<Array<DocumentCertificateMetadataScalarWhereInput>>;
  certificateId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  key?: InputMaybe<StringFilter>;
  value?: InputMaybe<StringFilter>;
};

export type DocumentCertificateMetadataScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DocumentCertificateMetadataScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DocumentCertificateMetadataScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DocumentCertificateMetadataScalarWhereWithAggregatesInput>>;
  certificateId?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  key?: InputMaybe<StringWithAggregatesFilter>;
  value?: InputMaybe<StringWithAggregatesFilter>;
};

export type DocumentCertificateMetadataSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type DocumentCertificateMetadataUpdateInput = {
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateOneRequiredWithoutMetadataListNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateMetadataUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateMetadataUpdateManyWithWhereWithoutDocumentCertificateInput = {
  data: DocumentCertificateMetadataUpdateManyMutationInput;
  where: DocumentCertificateMetadataScalarWhereInput;
};

export type DocumentCertificateMetadataUpdateManyWithoutDocumentCertificateNestedInput = {
  connect?: InputMaybe<Array<DocumentCertificateMetadataWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCertificateMetadataCreateOrConnectWithoutDocumentCertificateInput>>;
  create?: InputMaybe<Array<DocumentCertificateMetadataCreateWithoutDocumentCertificateInput>>;
  createMany?: InputMaybe<DocumentCertificateMetadataCreateManyDocumentCertificateInputEnvelope>;
  delete?: InputMaybe<Array<DocumentCertificateMetadataWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentCertificateMetadataScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentCertificateMetadataWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentCertificateMetadataWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentCertificateMetadataUpdateWithWhereUniqueWithoutDocumentCertificateInput>>;
  updateMany?: InputMaybe<Array<DocumentCertificateMetadataUpdateManyWithWhereWithoutDocumentCertificateInput>>;
  upsert?: InputMaybe<Array<DocumentCertificateMetadataUpsertWithWhereUniqueWithoutDocumentCertificateInput>>;
};

export type DocumentCertificateMetadataUpdateWithWhereUniqueWithoutDocumentCertificateInput = {
  data: DocumentCertificateMetadataUpdateWithoutDocumentCertificateInput;
  where: DocumentCertificateMetadataWhereUniqueInput;
};

export type DocumentCertificateMetadataUpdateWithoutDocumentCertificateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateMetadataUpsertWithWhereUniqueWithoutDocumentCertificateInput = {
  create: DocumentCertificateMetadataCreateWithoutDocumentCertificateInput;
  update: DocumentCertificateMetadataUpdateWithoutDocumentCertificateInput;
  where: DocumentCertificateMetadataWhereUniqueInput;
};

export type DocumentCertificateMetadataWhereInput = {
  AND?: InputMaybe<Array<DocumentCertificateMetadataWhereInput>>;
  DocumentCertificate?: InputMaybe<DocumentCertificateWhereInput>;
  NOT?: InputMaybe<Array<DocumentCertificateMetadataWhereInput>>;
  OR?: InputMaybe<Array<DocumentCertificateMetadataWhereInput>>;
  certificateId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  key?: InputMaybe<StringFilter>;
  value?: InputMaybe<StringFilter>;
};

export type DocumentCertificateMetadataWhereUniqueInput = {
  AND?: InputMaybe<Array<DocumentCertificateMetadataWhereInput>>;
  DocumentCertificate?: InputMaybe<DocumentCertificateWhereInput>;
  NOT?: InputMaybe<Array<DocumentCertificateMetadataWhereInput>>;
  OR?: InputMaybe<Array<DocumentCertificateMetadataWhereInput>>;
  certificateId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<StringFilter>;
  value?: InputMaybe<StringFilter>;
};

export type DocumentCertificateMinOrderByAggregateInput = {
  batchId?: InputMaybe<SortOrder>;
  certificateCurriculumCertificateBaseId?: InputMaybe<SortOrder>;
  certificateEventCertificateBaseId?: InputMaybe<SortOrder>;
  certificateTemplateId?: InputMaybe<SortOrder>;
  documentBaseId?: InputMaybe<SortOrder>;
  documentCertificateCPF?: InputMaybe<SortOrder>;
  documentCertificateEmail?: InputMaybe<SortOrder>;
  documentCertificateName?: InputMaybe<SortOrder>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<SortOrder>;
  personId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  teamEducationLevelId?: InputMaybe<SortOrder>;
  uuid?: InputMaybe<SortOrder>;
};

export type DocumentCertificateNullableRelationFilter = {
  is?: InputMaybe<DocumentCertificateWhereInput>;
  isNot?: InputMaybe<DocumentCertificateWhereInput>;
};

export type DocumentCertificateOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DocumentCertificateOrderByWithAggregationInput = {
  _avg?: InputMaybe<DocumentCertificateAvgOrderByAggregateInput>;
  _count?: InputMaybe<DocumentCertificateCountOrderByAggregateInput>;
  _max?: InputMaybe<DocumentCertificateMaxOrderByAggregateInput>;
  _min?: InputMaybe<DocumentCertificateMinOrderByAggregateInput>;
  _sum?: InputMaybe<DocumentCertificateSumOrderByAggregateInput>;
  batchId?: InputMaybe<SortOrder>;
  certificateCurriculumCertificateBaseId?: InputMaybe<SortOrder>;
  certificateEventCertificateBaseId?: InputMaybe<SortOrder>;
  certificateTemplateId?: InputMaybe<SortOrder>;
  documentBaseId?: InputMaybe<SortOrder>;
  documentCertificateCPF?: InputMaybe<SortOrder>;
  documentCertificateEmail?: InputMaybe<SortOrder>;
  documentCertificateName?: InputMaybe<SortOrder>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<SortOrder>;
  personId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  teamEducationLevelId?: InputMaybe<SortOrder>;
  uuid?: InputMaybe<SortOrder>;
};

export type DocumentCertificateOrderByWithRelationInput = {
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordOrderByWithRelationInput>;
  Curriculum?: InputMaybe<CertificateCurriculumOrderByWithRelationInput>;
  DocumentBase?: InputMaybe<DocumentBaseOrderByWithRelationInput>;
  DocumentCertificateHashHistory?: InputMaybe<DocumentCertificateHashHistoryOrderByRelationAggregateInput>;
  DocumentCertificateSignatureItems?: InputMaybe<DocumentCertificateSignatureItemOrderByRelationAggregateInput>;
  Event?: InputMaybe<CertificateEventOrderByWithRelationInput>;
  MetadataList?: InputMaybe<DocumentCertificateMetadataOrderByRelationAggregateInput>;
  Person?: InputMaybe<PersonOrderByWithRelationInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelOrderByWithRelationInput>;
  Template?: InputMaybe<CertificateTemplateOrderByWithRelationInput>;
  batchId?: InputMaybe<SortOrder>;
  certificateCurriculumCertificateBaseId?: InputMaybe<SortOrder>;
  certificateEventCertificateBaseId?: InputMaybe<SortOrder>;
  certificateTemplateId?: InputMaybe<SortOrder>;
  documentBaseId?: InputMaybe<SortOrder>;
  documentCertificateCPF?: InputMaybe<SortOrder>;
  documentCertificateEmail?: InputMaybe<SortOrder>;
  documentCertificateName?: InputMaybe<SortOrder>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<SortOrder>;
  personId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  teamEducationLevelId?: InputMaybe<SortOrder>;
  uuid?: InputMaybe<SortOrder>;
};

export type DocumentCertificateRelationFilter = {
  is?: InputMaybe<DocumentCertificateWhereInput>;
  isNot?: InputMaybe<DocumentCertificateWhereInput>;
};

export enum DocumentCertificateScalarFieldEnum {
  BatchId = 'batchId',
  CertificateCurriculumCertificateBaseId = 'certificateCurriculumCertificateBaseId',
  CertificateEventCertificateBaseId = 'certificateEventCertificateBaseId',
  CertificateTemplateId = 'certificateTemplateId',
  DocumentBaseId = 'documentBaseId',
  DocumentCertificateCpf = 'documentCertificateCPF',
  DocumentCertificateEmail = 'documentCertificateEmail',
  DocumentCertificateName = 'documentCertificateName',
  HasOnlyPredefinedVisualSignature = 'hasOnlyPredefinedVisualSignature',
  PersonId = 'personId',
  Status = 'status',
  TeamEducationLevelId = 'teamEducationLevelId',
  Uuid = 'uuid'
}

export type DocumentCertificateScalarWhereInput = {
  AND?: InputMaybe<Array<DocumentCertificateScalarWhereInput>>;
  NOT?: InputMaybe<Array<DocumentCertificateScalarWhereInput>>;
  OR?: InputMaybe<Array<DocumentCertificateScalarWhereInput>>;
  batchId?: InputMaybe<StringNullableFilter>;
  certificateCurriculumCertificateBaseId?: InputMaybe<StringNullableFilter>;
  certificateEventCertificateBaseId?: InputMaybe<StringNullableFilter>;
  certificateTemplateId?: InputMaybe<StringNullableFilter>;
  documentBaseId?: InputMaybe<StringFilter>;
  documentCertificateCPF?: InputMaybe<StringFilter>;
  documentCertificateEmail?: InputMaybe<StringFilter>;
  documentCertificateName?: InputMaybe<StringFilter>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<BoolFilter>;
  personId?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumDocumentCertificateStatusFilter>;
  teamEducationLevelId?: InputMaybe<IntFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type DocumentCertificateScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DocumentCertificateScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DocumentCertificateScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DocumentCertificateScalarWhereWithAggregatesInput>>;
  batchId?: InputMaybe<StringNullableWithAggregatesFilter>;
  certificateCurriculumCertificateBaseId?: InputMaybe<StringNullableWithAggregatesFilter>;
  certificateEventCertificateBaseId?: InputMaybe<StringNullableWithAggregatesFilter>;
  certificateTemplateId?: InputMaybe<StringNullableWithAggregatesFilter>;
  documentBaseId?: InputMaybe<StringWithAggregatesFilter>;
  documentCertificateCPF?: InputMaybe<StringWithAggregatesFilter>;
  documentCertificateEmail?: InputMaybe<StringWithAggregatesFilter>;
  documentCertificateName?: InputMaybe<StringWithAggregatesFilter>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<BoolWithAggregatesFilter>;
  personId?: InputMaybe<StringWithAggregatesFilter>;
  status?: InputMaybe<EnumDocumentCertificateStatusWithAggregatesFilter>;
  teamEducationLevelId?: InputMaybe<IntWithAggregatesFilter>;
  uuid?: InputMaybe<StringWithAggregatesFilter>;
};

export enum DocumentCertificateSignatureHashHistoryType {
  Completed = 'COMPLETED',
  Signed = 'SIGNED'
}

/**
 * Created one for each "Signature Component" in template
 * Needed another model because of the logic of "first of all signatures" and the "pdfSignature" instead of "xmlSignature"
 */
export type DocumentCertificateSignatureItem = {
  __typename?: 'DocumentCertificateSignatureItem';
  DocumentCertificate: DocumentCertificate;
  PossibleSigners: Array<DocumentCertificateSignatureItemPossibleSignerInvite>;
  createdAt: Scalars['DateTime']['output'];
  documentCertificateDocumentBaseId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imageHeight: Scalars['Float']['output'];
  imagePage: Scalars['Int']['output'];
  imagePositionX: Scalars['Float']['output'];
  imagePositionY: Scalars['Float']['output'];
  imageWidth: Scalars['Float']['output'];
  /** In case of VISUAL_REPRESENTATION with predefined image */
  predefinedImageBase64?: Maybe<Scalars['String']['output']>;
  type: DocumentCertificateSignatureItemType;
};


/**
 * Created one for each "Signature Component" in template
 * Needed another model because of the logic of "first of all signatures" and the "pdfSignature" instead of "xmlSignature"
 */
export type DocumentCertificateSignatureItemPossibleSignersArgs = {
  cursor?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>;
};

export type DocumentCertificateSignatureItemAvgOrderByAggregateInput = {
  imageHeight?: InputMaybe<SortOrder>;
  imagePage?: InputMaybe<SortOrder>;
  imagePositionX?: InputMaybe<SortOrder>;
  imagePositionY?: InputMaybe<SortOrder>;
  imageWidth?: InputMaybe<SortOrder>;
};

export type DocumentCertificateSignatureItemCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  documentCertificateDocumentBaseId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageHeight?: InputMaybe<SortOrder>;
  imagePage?: InputMaybe<SortOrder>;
  imagePositionX?: InputMaybe<SortOrder>;
  imagePositionY?: InputMaybe<SortOrder>;
  imageWidth?: InputMaybe<SortOrder>;
  predefinedImageBase64?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type DocumentCertificateSignatureItemCreateInput = {
  DocumentCertificate: DocumentCertificateCreateNestedOneWithoutDocumentCertificateSignatureItemsInput;
  PossibleSigners?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateNestedManyWithoutDocumentCertificateSignatureItemInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageHeight: Scalars['Float']['input'];
  imagePage: Scalars['Int']['input'];
  imagePositionX: Scalars['Float']['input'];
  imagePositionY: Scalars['Float']['input'];
  imageWidth: Scalars['Float']['input'];
  predefinedImageBase64?: InputMaybe<Scalars['String']['input']>;
  type: DocumentCertificateSignatureItemType;
};

export type DocumentCertificateSignatureItemCreateManyDocumentCertificateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageHeight: Scalars['Float']['input'];
  imagePage: Scalars['Int']['input'];
  imagePositionX: Scalars['Float']['input'];
  imagePositionY: Scalars['Float']['input'];
  imageWidth: Scalars['Float']['input'];
  predefinedImageBase64?: InputMaybe<Scalars['String']['input']>;
  type: DocumentCertificateSignatureItemType;
};

export type DocumentCertificateSignatureItemCreateManyDocumentCertificateInputEnvelope = {
  data: Array<DocumentCertificateSignatureItemCreateManyDocumentCertificateInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentCertificateSignatureItemCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  documentCertificateDocumentBaseId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  imageHeight: Scalars['Float']['input'];
  imagePage: Scalars['Int']['input'];
  imagePositionX: Scalars['Float']['input'];
  imagePositionY: Scalars['Float']['input'];
  imageWidth: Scalars['Float']['input'];
  predefinedImageBase64?: InputMaybe<Scalars['String']['input']>;
  type: DocumentCertificateSignatureItemType;
};

export type DocumentCertificateSignatureItemCreateNestedManyWithoutDocumentCertificateInput = {
  connect?: InputMaybe<Array<DocumentCertificateSignatureItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCertificateSignatureItemCreateOrConnectWithoutDocumentCertificateInput>>;
  create?: InputMaybe<Array<DocumentCertificateSignatureItemCreateWithoutDocumentCertificateInput>>;
  createMany?: InputMaybe<DocumentCertificateSignatureItemCreateManyDocumentCertificateInputEnvelope>;
};

export type DocumentCertificateSignatureItemCreateNestedOneWithoutPossibleSignersInput = {
  connect?: InputMaybe<DocumentCertificateSignatureItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentCertificateSignatureItemCreateOrConnectWithoutPossibleSignersInput>;
  create?: InputMaybe<DocumentCertificateSignatureItemCreateWithoutPossibleSignersInput>;
};

export type DocumentCertificateSignatureItemCreateOrConnectWithoutDocumentCertificateInput = {
  create: DocumentCertificateSignatureItemCreateWithoutDocumentCertificateInput;
  where: DocumentCertificateSignatureItemWhereUniqueInput;
};

export type DocumentCertificateSignatureItemCreateOrConnectWithoutPossibleSignersInput = {
  create: DocumentCertificateSignatureItemCreateWithoutPossibleSignersInput;
  where: DocumentCertificateSignatureItemWhereUniqueInput;
};

export type DocumentCertificateSignatureItemCreateWithoutDocumentCertificateInput = {
  PossibleSigners?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateNestedManyWithoutDocumentCertificateSignatureItemInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageHeight: Scalars['Float']['input'];
  imagePage: Scalars['Int']['input'];
  imagePositionX: Scalars['Float']['input'];
  imagePositionY: Scalars['Float']['input'];
  imageWidth: Scalars['Float']['input'];
  predefinedImageBase64?: InputMaybe<Scalars['String']['input']>;
  type: DocumentCertificateSignatureItemType;
};

export type DocumentCertificateSignatureItemCreateWithoutPossibleSignersInput = {
  DocumentCertificate: DocumentCertificateCreateNestedOneWithoutDocumentCertificateSignatureItemsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageHeight: Scalars['Float']['input'];
  imagePage: Scalars['Int']['input'];
  imagePositionX: Scalars['Float']['input'];
  imagePositionY: Scalars['Float']['input'];
  imageWidth: Scalars['Float']['input'];
  predefinedImageBase64?: InputMaybe<Scalars['String']['input']>;
  type: DocumentCertificateSignatureItemType;
};

export type DocumentCertificateSignatureItemListRelationFilter = {
  every?: InputMaybe<DocumentCertificateSignatureItemWhereInput>;
  none?: InputMaybe<DocumentCertificateSignatureItemWhereInput>;
  some?: InputMaybe<DocumentCertificateSignatureItemWhereInput>;
};

export type DocumentCertificateSignatureItemMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  documentCertificateDocumentBaseId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageHeight?: InputMaybe<SortOrder>;
  imagePage?: InputMaybe<SortOrder>;
  imagePositionX?: InputMaybe<SortOrder>;
  imagePositionY?: InputMaybe<SortOrder>;
  imageWidth?: InputMaybe<SortOrder>;
  predefinedImageBase64?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type DocumentCertificateSignatureItemMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  documentCertificateDocumentBaseId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageHeight?: InputMaybe<SortOrder>;
  imagePage?: InputMaybe<SortOrder>;
  imagePositionX?: InputMaybe<SortOrder>;
  imagePositionY?: InputMaybe<SortOrder>;
  imageWidth?: InputMaybe<SortOrder>;
  predefinedImageBase64?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type DocumentCertificateSignatureItemOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DocumentCertificateSignatureItemOrderByWithAggregationInput = {
  _avg?: InputMaybe<DocumentCertificateSignatureItemAvgOrderByAggregateInput>;
  _count?: InputMaybe<DocumentCertificateSignatureItemCountOrderByAggregateInput>;
  _max?: InputMaybe<DocumentCertificateSignatureItemMaxOrderByAggregateInput>;
  _min?: InputMaybe<DocumentCertificateSignatureItemMinOrderByAggregateInput>;
  _sum?: InputMaybe<DocumentCertificateSignatureItemSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  documentCertificateDocumentBaseId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageHeight?: InputMaybe<SortOrder>;
  imagePage?: InputMaybe<SortOrder>;
  imagePositionX?: InputMaybe<SortOrder>;
  imagePositionY?: InputMaybe<SortOrder>;
  imageWidth?: InputMaybe<SortOrder>;
  predefinedImageBase64?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type DocumentCertificateSignatureItemOrderByWithRelationInput = {
  DocumentCertificate?: InputMaybe<DocumentCertificateOrderByWithRelationInput>;
  PossibleSigners?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  documentCertificateDocumentBaseId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageHeight?: InputMaybe<SortOrder>;
  imagePage?: InputMaybe<SortOrder>;
  imagePositionX?: InputMaybe<SortOrder>;
  imagePositionY?: InputMaybe<SortOrder>;
  imageWidth?: InputMaybe<SortOrder>;
  predefinedImageBase64?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

/** Stores a possible signer invite */
export type DocumentCertificateSignatureItemPossibleSignerInvite = {
  __typename?: 'DocumentCertificateSignatureItemPossibleSignerInvite';
  DocumentCertificateSignatureItem: DocumentCertificateSignatureItem;
  DocumentCertificateSignatureItemPossibleSignerInviteSignature: Array<DocumentCertificateSignatureItemPossibleSignerInviteSignature>;
  TeamMember: TeamMember;
  documentCertificateSignatureItemId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  teamMemberId: Scalars['Int']['output'];
};


/** Stores a possible signer invite */
export type DocumentCertificateSignatureItemPossibleSignerInviteDocumentCertificateSignatureItemPossibleSignerInviteSignatureArgs = {
  cursor?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCountOrderByAggregateInput = {
  documentCertificateSignatureItemId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateInput = {
  DocumentCertificateSignatureItem: DocumentCertificateSignatureItemCreateNestedOneWithoutPossibleSignersInput;
  DocumentCertificateSignatureItemPossibleSignerInviteSignature?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateNestedManyWithoutInviteInput>;
  TeamMember: TeamMemberCreateNestedOneWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateManyDocumentCertificateSignatureItemInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  teamMemberId: Scalars['Int']['input'];
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateManyDocumentCertificateSignatureItemInputEnvelope = {
  data: Array<DocumentCertificateSignatureItemPossibleSignerInviteCreateManyDocumentCertificateSignatureItemInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateManyInput = {
  documentCertificateSignatureItemId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  teamMemberId: Scalars['Int']['input'];
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateManyTeamMemberInput = {
  documentCertificateSignatureItemId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateManyTeamMemberInputEnvelope = {
  data: Array<DocumentCertificateSignatureItemPossibleSignerInviteCreateManyTeamMemberInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateNestedManyWithoutDocumentCertificateSignatureItemInput = {
  connect?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteCreateOrConnectWithoutDocumentCertificateSignatureItemInput>>;
  create?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutDocumentCertificateSignatureItemInput>>;
  createMany?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateManyDocumentCertificateSignatureItemInputEnvelope>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateNestedManyWithoutTeamMemberInput = {
  connect?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteCreateOrConnectWithoutTeamMemberInput>>;
  create?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutTeamMemberInput>>;
  createMany?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateManyTeamMemberInputEnvelope>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateNestedOneWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput = {
  connect?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateOrConnectWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput>;
  create?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateOrConnectWithoutDocumentCertificateSignatureItemInput = {
  create: DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutDocumentCertificateSignatureItemInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateOrConnectWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput = {
  create: DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateOrConnectWithoutTeamMemberInput = {
  create: DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutTeamMemberInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutDocumentCertificateSignatureItemInput = {
  DocumentCertificateSignatureItemPossibleSignerInviteSignature?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateNestedManyWithoutInviteInput>;
  TeamMember: TeamMemberCreateNestedOneWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput = {
  DocumentCertificateSignatureItem: DocumentCertificateSignatureItemCreateNestedOneWithoutPossibleSignersInput;
  TeamMember: TeamMemberCreateNestedOneWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutTeamMemberInput = {
  DocumentCertificateSignatureItem: DocumentCertificateSignatureItemCreateNestedOneWithoutPossibleSignersInput;
  DocumentCertificateSignatureItemPossibleSignerInviteSignature?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateNestedManyWithoutInviteInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteListRelationFilter = {
  every?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>;
  none?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>;
  some?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteMaxOrderByAggregateInput = {
  documentCertificateSignatureItemId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteMinOrderByAggregateInput = {
  documentCertificateSignatureItemId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteOrderByWithAggregationInput = {
  _avg?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteAvgOrderByAggregateInput>;
  _count?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteCountOrderByAggregateInput>;
  _max?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteMaxOrderByAggregateInput>;
  _min?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteMinOrderByAggregateInput>;
  _sum?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteSumOrderByAggregateInput>;
  documentCertificateSignatureItemId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteOrderByWithRelationInput = {
  DocumentCertificateSignatureItem?: InputMaybe<DocumentCertificateSignatureItemOrderByWithRelationInput>;
  DocumentCertificateSignatureItemPossibleSignerInviteSignature?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureOrderByRelationAggregateInput>;
  TeamMember?: InputMaybe<TeamMemberOrderByWithRelationInput>;
  documentCertificateSignatureItemId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteRelationFilter = {
  is?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>;
  isNot?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>;
};

export enum DocumentCertificateSignatureItemPossibleSignerInviteScalarFieldEnum {
  DocumentCertificateSignatureItemId = 'documentCertificateSignatureItemId',
  Id = 'id',
  TeamMemberId = 'teamMemberId'
}

export type DocumentCertificateSignatureItemPossibleSignerInviteScalarWhereInput = {
  AND?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteScalarWhereInput>>;
  NOT?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteScalarWhereInput>>;
  OR?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteScalarWhereInput>>;
  documentCertificateSignatureItemId?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  teamMemberId?: InputMaybe<IntFilter>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteScalarWhereWithAggregatesInput>>;
  documentCertificateSignatureItemId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  teamMemberId?: InputMaybe<IntWithAggregatesFilter>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignature = {
  __typename?: 'DocumentCertificateSignatureItemPossibleSignerInviteSignature';
  Invite: DocumentCertificateSignatureItemPossibleSignerInvite;
  createdAt: Scalars['DateTime']['output'];
  documentCertificateSignatureItemPossibleSignerInviteId: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** User IP */
  ip: Scalars['String']['output'];
  /** 1.0.0 */
  signatureApiVersion: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureAvgOrderByAggregateInput = {
  documentCertificateSignatureItemPossibleSignerInviteId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  documentCertificateSignatureItemPossibleSignerInviteId?: InputMaybe<SortOrder>;
  errorMessage?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  ip?: InputMaybe<SortOrder>;
  signatureApiVersion?: InputMaybe<SortOrder>;
  success?: InputMaybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateInput = {
  Invite: DocumentCertificateSignatureItemPossibleSignerInviteCreateNestedOneWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  ip: Scalars['String']['input'];
  signatureApiVersion: Scalars['String']['input'];
  success: Scalars['Boolean']['input'];
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  documentCertificateSignatureItemPossibleSignerInviteId: Scalars['Int']['input'];
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ip: Scalars['String']['input'];
  signatureApiVersion: Scalars['String']['input'];
  success: Scalars['Boolean']['input'];
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateManyInviteInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ip: Scalars['String']['input'];
  signatureApiVersion: Scalars['String']['input'];
  success: Scalars['Boolean']['input'];
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateManyInviteInputEnvelope = {
  data: Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateManyInviteInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateNestedManyWithoutInviteInput = {
  connect?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateOrConnectWithoutInviteInput>>;
  create?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateWithoutInviteInput>>;
  createMany?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateManyInviteInputEnvelope>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateOrConnectWithoutInviteInput = {
  create: DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateWithoutInviteInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereUniqueInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateWithoutInviteInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  ip: Scalars['String']['input'];
  signatureApiVersion: Scalars['String']['input'];
  success: Scalars['Boolean']['input'];
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureListRelationFilter = {
  every?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereInput>;
  none?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereInput>;
  some?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  documentCertificateSignatureItemPossibleSignerInviteId?: InputMaybe<SortOrder>;
  errorMessage?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  ip?: InputMaybe<SortOrder>;
  signatureApiVersion?: InputMaybe<SortOrder>;
  success?: InputMaybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  documentCertificateSignatureItemPossibleSignerInviteId?: InputMaybe<SortOrder>;
  errorMessage?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  ip?: InputMaybe<SortOrder>;
  signatureApiVersion?: InputMaybe<SortOrder>;
  success?: InputMaybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureOrderByWithAggregationInput = {
  _avg?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureAvgOrderByAggregateInput>;
  _count?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureCountOrderByAggregateInput>;
  _max?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureMaxOrderByAggregateInput>;
  _min?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureMinOrderByAggregateInput>;
  _sum?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  documentCertificateSignatureItemPossibleSignerInviteId?: InputMaybe<SortOrder>;
  errorMessage?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  ip?: InputMaybe<SortOrder>;
  signatureApiVersion?: InputMaybe<SortOrder>;
  success?: InputMaybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureOrderByWithRelationInput = {
  Invite?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteOrderByWithRelationInput>;
  createdAt?: InputMaybe<SortOrder>;
  documentCertificateSignatureItemPossibleSignerInviteId?: InputMaybe<SortOrder>;
  errorMessage?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  ip?: InputMaybe<SortOrder>;
  signatureApiVersion?: InputMaybe<SortOrder>;
  success?: InputMaybe<SortOrder>;
};

export enum DocumentCertificateSignatureItemPossibleSignerInviteSignatureScalarFieldEnum {
  CreatedAt = 'createdAt',
  DocumentCertificateSignatureItemPossibleSignerInviteId = 'documentCertificateSignatureItemPossibleSignerInviteId',
  ErrorMessage = 'errorMessage',
  Id = 'id',
  Ip = 'ip',
  SignatureApiVersion = 'signatureApiVersion',
  Success = 'success'
}

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureScalarWhereInput = {
  AND?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureScalarWhereInput>>;
  NOT?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureScalarWhereInput>>;
  OR?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentCertificateSignatureItemPossibleSignerInviteId?: InputMaybe<IntFilter>;
  errorMessage?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  ip?: InputMaybe<StringFilter>;
  signatureApiVersion?: InputMaybe<StringFilter>;
  success?: InputMaybe<BoolFilter>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  documentCertificateSignatureItemPossibleSignerInviteId?: InputMaybe<IntWithAggregatesFilter>;
  errorMessage?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  ip?: InputMaybe<StringWithAggregatesFilter>;
  signatureApiVersion?: InputMaybe<StringWithAggregatesFilter>;
  success?: InputMaybe<BoolWithAggregatesFilter>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureSumOrderByAggregateInput = {
  documentCertificateSignatureItemPossibleSignerInviteId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateInput = {
  Invite?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteUpdateOneRequiredWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  errorMessage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ip?: InputMaybe<StringFieldUpdateOperationsInput>;
  signatureApiVersion?: InputMaybe<StringFieldUpdateOperationsInput>;
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  errorMessage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ip?: InputMaybe<StringFieldUpdateOperationsInput>;
  signatureApiVersion?: InputMaybe<StringFieldUpdateOperationsInput>;
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateManyWithWhereWithoutInviteInput = {
  data: DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateManyMutationInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteSignatureScalarWhereInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateManyWithoutInviteNestedInput = {
  connect?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateOrConnectWithoutInviteInput>>;
  create?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateWithoutInviteInput>>;
  createMany?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateManyInviteInputEnvelope>;
  delete?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateWithWhereUniqueWithoutInviteInput>>;
  updateMany?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateManyWithWhereWithoutInviteInput>>;
  upsert?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpsertWithWhereUniqueWithoutInviteInput>>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateWithWhereUniqueWithoutInviteInput = {
  data: DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateWithoutInviteInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereUniqueInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateWithoutInviteInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  errorMessage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ip?: InputMaybe<StringFieldUpdateOperationsInput>;
  signatureApiVersion?: InputMaybe<StringFieldUpdateOperationsInput>;
  success?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpsertWithWhereUniqueWithoutInviteInput = {
  create: DocumentCertificateSignatureItemPossibleSignerInviteSignatureCreateWithoutInviteInput;
  update: DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateWithoutInviteInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereUniqueInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereInput = {
  AND?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereInput>>;
  Invite?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>;
  NOT?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereInput>>;
  OR?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentCertificateSignatureItemPossibleSignerInviteId?: InputMaybe<IntFilter>;
  errorMessage?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  ip?: InputMaybe<StringFilter>;
  signatureApiVersion?: InputMaybe<StringFilter>;
  success?: InputMaybe<BoolFilter>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereUniqueInput = {
  AND?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereInput>>;
  Invite?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>;
  NOT?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereInput>>;
  OR?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteSignatureWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentCertificateSignatureItemPossibleSignerInviteId?: InputMaybe<IntFilter>;
  errorMessage?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ip?: InputMaybe<StringFilter>;
  signatureApiVersion?: InputMaybe<StringFilter>;
  success?: InputMaybe<BoolFilter>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpdateInput = {
  DocumentCertificateSignatureItem?: InputMaybe<DocumentCertificateSignatureItemUpdateOneRequiredWithoutPossibleSignersNestedInput>;
  DocumentCertificateSignatureItemPossibleSignerInviteSignature?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateManyWithoutInviteNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateOneRequiredWithoutDocumentCertificateSignatureItemPossibleSignerInvitesNestedInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyMutationInput = {
  _?: InputMaybe<Scalars['NEVER']['input']>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithWhereWithoutDocumentCertificateSignatureItemInput = {
  data: DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyMutationInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteScalarWhereInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithWhereWithoutTeamMemberInput = {
  data: DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyMutationInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteScalarWhereInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithoutDocumentCertificateSignatureItemNestedInput = {
  connect?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteCreateOrConnectWithoutDocumentCertificateSignatureItemInput>>;
  create?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutDocumentCertificateSignatureItemInput>>;
  createMany?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateManyDocumentCertificateSignatureItemInputEnvelope>;
  delete?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteUpdateWithWhereUniqueWithoutDocumentCertificateSignatureItemInput>>;
  updateMany?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithWhereWithoutDocumentCertificateSignatureItemInput>>;
  upsert?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteUpsertWithWhereUniqueWithoutDocumentCertificateSignatureItemInput>>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithoutTeamMemberNestedInput = {
  connect?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteCreateOrConnectWithoutTeamMemberInput>>;
  create?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutTeamMemberInput>>;
  createMany?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateManyTeamMemberInputEnvelope>;
  delete?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteUpdateWithWhereUniqueWithoutTeamMemberInput>>;
  updateMany?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithWhereWithoutTeamMemberInput>>;
  upsert?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteUpsertWithWhereUniqueWithoutTeamMemberInput>>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpdateOneRequiredWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureNestedInput = {
  connect?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateOrConnectWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput>;
  create?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput>;
  update?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteUpdateToOneWithWhereWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput>;
  upsert?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteUpsertWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpdateToOneWithWhereWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput = {
  data: DocumentCertificateSignatureItemPossibleSignerInviteUpdateWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput;
  where?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpdateWithWhereUniqueWithoutDocumentCertificateSignatureItemInput = {
  data: DocumentCertificateSignatureItemPossibleSignerInviteUpdateWithoutDocumentCertificateSignatureItemInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpdateWithWhereUniqueWithoutTeamMemberInput = {
  data: DocumentCertificateSignatureItemPossibleSignerInviteUpdateWithoutTeamMemberInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpdateWithoutDocumentCertificateSignatureItemInput = {
  DocumentCertificateSignatureItemPossibleSignerInviteSignature?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateManyWithoutInviteNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateOneRequiredWithoutDocumentCertificateSignatureItemPossibleSignerInvitesNestedInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpdateWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput = {
  DocumentCertificateSignatureItem?: InputMaybe<DocumentCertificateSignatureItemUpdateOneRequiredWithoutPossibleSignersNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateOneRequiredWithoutDocumentCertificateSignatureItemPossibleSignerInvitesNestedInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpdateWithoutTeamMemberInput = {
  DocumentCertificateSignatureItem?: InputMaybe<DocumentCertificateSignatureItemUpdateOneRequiredWithoutPossibleSignersNestedInput>;
  DocumentCertificateSignatureItemPossibleSignerInviteSignature?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureUpdateManyWithoutInviteNestedInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpsertWithWhereUniqueWithoutDocumentCertificateSignatureItemInput = {
  create: DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutDocumentCertificateSignatureItemInput;
  update: DocumentCertificateSignatureItemPossibleSignerInviteUpdateWithoutDocumentCertificateSignatureItemInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpsertWithWhereUniqueWithoutTeamMemberInput = {
  create: DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutTeamMemberInput;
  update: DocumentCertificateSignatureItemPossibleSignerInviteUpdateWithoutTeamMemberInput;
  where: DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteUpsertWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput = {
  create: DocumentCertificateSignatureItemPossibleSignerInviteCreateWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput;
  update: DocumentCertificateSignatureItemPossibleSignerInviteUpdateWithoutDocumentCertificateSignatureItemPossibleSignerInviteSignatureInput;
  where?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteWhereInput = {
  AND?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>>;
  DocumentCertificateSignatureItem?: InputMaybe<DocumentCertificateSignatureItemWhereInput>;
  DocumentCertificateSignatureItemPossibleSignerInviteSignature?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureListRelationFilter>;
  NOT?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>>;
  OR?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>>;
  TeamMember?: InputMaybe<TeamMemberWhereInput>;
  documentCertificateSignatureItemId?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  teamMemberId?: InputMaybe<IntFilter>;
};

export type DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput = {
  AND?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>>;
  DocumentCertificateSignatureItem?: InputMaybe<DocumentCertificateSignatureItemWhereInput>;
  DocumentCertificateSignatureItemPossibleSignerInviteSignature?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteSignatureListRelationFilter>;
  NOT?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>>;
  OR?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>>;
  TeamMember?: InputMaybe<TeamMemberWhereInput>;
  documentCertificateSignatureItemId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  teamMemberId?: InputMaybe<IntFilter>;
};

export type DocumentCertificateSignatureItemRelationFilter = {
  is?: InputMaybe<DocumentCertificateSignatureItemWhereInput>;
  isNot?: InputMaybe<DocumentCertificateSignatureItemWhereInput>;
};

export enum DocumentCertificateSignatureItemScalarFieldEnum {
  CreatedAt = 'createdAt',
  DocumentCertificateDocumentBaseId = 'documentCertificateDocumentBaseId',
  Id = 'id',
  ImageHeight = 'imageHeight',
  ImagePage = 'imagePage',
  ImagePositionX = 'imagePositionX',
  ImagePositionY = 'imagePositionY',
  ImageWidth = 'imageWidth',
  PredefinedImageBase64 = 'predefinedImageBase64',
  Type = 'type'
}

export type DocumentCertificateSignatureItemScalarWhereInput = {
  AND?: InputMaybe<Array<DocumentCertificateSignatureItemScalarWhereInput>>;
  NOT?: InputMaybe<Array<DocumentCertificateSignatureItemScalarWhereInput>>;
  OR?: InputMaybe<Array<DocumentCertificateSignatureItemScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentCertificateDocumentBaseId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  imageHeight?: InputMaybe<FloatFilter>;
  imagePage?: InputMaybe<IntFilter>;
  imagePositionX?: InputMaybe<FloatFilter>;
  imagePositionY?: InputMaybe<FloatFilter>;
  imageWidth?: InputMaybe<FloatFilter>;
  predefinedImageBase64?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumDocumentCertificateSignatureItemTypeFilter>;
};

export type DocumentCertificateSignatureItemScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DocumentCertificateSignatureItemScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DocumentCertificateSignatureItemScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DocumentCertificateSignatureItemScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  documentCertificateDocumentBaseId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  imageHeight?: InputMaybe<FloatWithAggregatesFilter>;
  imagePage?: InputMaybe<IntWithAggregatesFilter>;
  imagePositionX?: InputMaybe<FloatWithAggregatesFilter>;
  imagePositionY?: InputMaybe<FloatWithAggregatesFilter>;
  imageWidth?: InputMaybe<FloatWithAggregatesFilter>;
  predefinedImageBase64?: InputMaybe<StringNullableWithAggregatesFilter>;
  type?: InputMaybe<EnumDocumentCertificateSignatureItemTypeWithAggregatesFilter>;
};

export type DocumentCertificateSignatureItemSumOrderByAggregateInput = {
  imageHeight?: InputMaybe<SortOrder>;
  imagePage?: InputMaybe<SortOrder>;
  imagePositionX?: InputMaybe<SortOrder>;
  imagePositionY?: InputMaybe<SortOrder>;
  imageWidth?: InputMaybe<SortOrder>;
};

export enum DocumentCertificateSignatureItemType {
  Eletronic = 'ELETRONIC',
  OnlyVisualRepresentationWithPredefinedImage = 'ONLY_VISUAL_REPRESENTATION_WITH_PREDEFINED_IMAGE',
  OnlyVisualRepresentationWithSigners = 'ONLY_VISUAL_REPRESENTATION_WITH_SIGNERS',
  QualifiedRa = 'QUALIFIED_RA',
  QualifiedRb = 'QUALIFIED_RB',
  QualifiedRt = 'QUALIFIED_RT'
}

export type DocumentCertificateSignatureItemUpdateInput = {
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateOneRequiredWithoutDocumentCertificateSignatureItemsNestedInput>;
  PossibleSigners?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithoutDocumentCertificateSignatureItemNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageHeight?: InputMaybe<FloatFieldUpdateOperationsInput>;
  imagePage?: InputMaybe<IntFieldUpdateOperationsInput>;
  imagePositionX?: InputMaybe<FloatFieldUpdateOperationsInput>;
  imagePositionY?: InputMaybe<FloatFieldUpdateOperationsInput>;
  imageWidth?: InputMaybe<FloatFieldUpdateOperationsInput>;
  predefinedImageBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentCertificateSignatureItemTypeFieldUpdateOperationsInput>;
};

export type DocumentCertificateSignatureItemUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageHeight?: InputMaybe<FloatFieldUpdateOperationsInput>;
  imagePage?: InputMaybe<IntFieldUpdateOperationsInput>;
  imagePositionX?: InputMaybe<FloatFieldUpdateOperationsInput>;
  imagePositionY?: InputMaybe<FloatFieldUpdateOperationsInput>;
  imageWidth?: InputMaybe<FloatFieldUpdateOperationsInput>;
  predefinedImageBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentCertificateSignatureItemTypeFieldUpdateOperationsInput>;
};

export type DocumentCertificateSignatureItemUpdateManyWithWhereWithoutDocumentCertificateInput = {
  data: DocumentCertificateSignatureItemUpdateManyMutationInput;
  where: DocumentCertificateSignatureItemScalarWhereInput;
};

export type DocumentCertificateSignatureItemUpdateManyWithoutDocumentCertificateNestedInput = {
  connect?: InputMaybe<Array<DocumentCertificateSignatureItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCertificateSignatureItemCreateOrConnectWithoutDocumentCertificateInput>>;
  create?: InputMaybe<Array<DocumentCertificateSignatureItemCreateWithoutDocumentCertificateInput>>;
  createMany?: InputMaybe<DocumentCertificateSignatureItemCreateManyDocumentCertificateInputEnvelope>;
  delete?: InputMaybe<Array<DocumentCertificateSignatureItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentCertificateSignatureItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentCertificateSignatureItemWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentCertificateSignatureItemWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentCertificateSignatureItemUpdateWithWhereUniqueWithoutDocumentCertificateInput>>;
  updateMany?: InputMaybe<Array<DocumentCertificateSignatureItemUpdateManyWithWhereWithoutDocumentCertificateInput>>;
  upsert?: InputMaybe<Array<DocumentCertificateSignatureItemUpsertWithWhereUniqueWithoutDocumentCertificateInput>>;
};

export type DocumentCertificateSignatureItemUpdateOneRequiredWithoutPossibleSignersNestedInput = {
  connect?: InputMaybe<DocumentCertificateSignatureItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentCertificateSignatureItemCreateOrConnectWithoutPossibleSignersInput>;
  create?: InputMaybe<DocumentCertificateSignatureItemCreateWithoutPossibleSignersInput>;
  update?: InputMaybe<DocumentCertificateSignatureItemUpdateToOneWithWhereWithoutPossibleSignersInput>;
  upsert?: InputMaybe<DocumentCertificateSignatureItemUpsertWithoutPossibleSignersInput>;
};

export type DocumentCertificateSignatureItemUpdateToOneWithWhereWithoutPossibleSignersInput = {
  data: DocumentCertificateSignatureItemUpdateWithoutPossibleSignersInput;
  where?: InputMaybe<DocumentCertificateSignatureItemWhereInput>;
};

export type DocumentCertificateSignatureItemUpdateWithWhereUniqueWithoutDocumentCertificateInput = {
  data: DocumentCertificateSignatureItemUpdateWithoutDocumentCertificateInput;
  where: DocumentCertificateSignatureItemWhereUniqueInput;
};

export type DocumentCertificateSignatureItemUpdateWithoutDocumentCertificateInput = {
  PossibleSigners?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithoutDocumentCertificateSignatureItemNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageHeight?: InputMaybe<FloatFieldUpdateOperationsInput>;
  imagePage?: InputMaybe<IntFieldUpdateOperationsInput>;
  imagePositionX?: InputMaybe<FloatFieldUpdateOperationsInput>;
  imagePositionY?: InputMaybe<FloatFieldUpdateOperationsInput>;
  imageWidth?: InputMaybe<FloatFieldUpdateOperationsInput>;
  predefinedImageBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentCertificateSignatureItemTypeFieldUpdateOperationsInput>;
};

export type DocumentCertificateSignatureItemUpdateWithoutPossibleSignersInput = {
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateOneRequiredWithoutDocumentCertificateSignatureItemsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageHeight?: InputMaybe<FloatFieldUpdateOperationsInput>;
  imagePage?: InputMaybe<IntFieldUpdateOperationsInput>;
  imagePositionX?: InputMaybe<FloatFieldUpdateOperationsInput>;
  imagePositionY?: InputMaybe<FloatFieldUpdateOperationsInput>;
  imageWidth?: InputMaybe<FloatFieldUpdateOperationsInput>;
  predefinedImageBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentCertificateSignatureItemTypeFieldUpdateOperationsInput>;
};

export type DocumentCertificateSignatureItemUpsertWithWhereUniqueWithoutDocumentCertificateInput = {
  create: DocumentCertificateSignatureItemCreateWithoutDocumentCertificateInput;
  update: DocumentCertificateSignatureItemUpdateWithoutDocumentCertificateInput;
  where: DocumentCertificateSignatureItemWhereUniqueInput;
};

export type DocumentCertificateSignatureItemUpsertWithoutPossibleSignersInput = {
  create: DocumentCertificateSignatureItemCreateWithoutPossibleSignersInput;
  update: DocumentCertificateSignatureItemUpdateWithoutPossibleSignersInput;
  where?: InputMaybe<DocumentCertificateSignatureItemWhereInput>;
};

export type DocumentCertificateSignatureItemWhereInput = {
  AND?: InputMaybe<Array<DocumentCertificateSignatureItemWhereInput>>;
  DocumentCertificate?: InputMaybe<DocumentCertificateWhereInput>;
  NOT?: InputMaybe<Array<DocumentCertificateSignatureItemWhereInput>>;
  OR?: InputMaybe<Array<DocumentCertificateSignatureItemWhereInput>>;
  PossibleSigners?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentCertificateDocumentBaseId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  imageHeight?: InputMaybe<FloatFilter>;
  imagePage?: InputMaybe<IntFilter>;
  imagePositionX?: InputMaybe<FloatFilter>;
  imagePositionY?: InputMaybe<FloatFilter>;
  imageWidth?: InputMaybe<FloatFilter>;
  predefinedImageBase64?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumDocumentCertificateSignatureItemTypeFilter>;
};

export type DocumentCertificateSignatureItemWhereUniqueInput = {
  AND?: InputMaybe<Array<DocumentCertificateSignatureItemWhereInput>>;
  DocumentCertificate?: InputMaybe<DocumentCertificateWhereInput>;
  NOT?: InputMaybe<Array<DocumentCertificateSignatureItemWhereInput>>;
  OR?: InputMaybe<Array<DocumentCertificateSignatureItemWhereInput>>;
  PossibleSigners?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentCertificateDocumentBaseId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageHeight?: InputMaybe<FloatFilter>;
  imagePage?: InputMaybe<IntFilter>;
  imagePositionX?: InputMaybe<FloatFilter>;
  imagePositionY?: InputMaybe<FloatFilter>;
  imageWidth?: InputMaybe<FloatFilter>;
  predefinedImageBase64?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumDocumentCertificateSignatureItemTypeFilter>;
};

export enum DocumentCertificateStatus {
  InSignature = 'IN_SIGNATURE',
  Issued = 'ISSUED',
  Revoked = 'REVOKED',
  ValidationInvalid = 'VALIDATION_INVALID',
  ValidationInValidation = 'VALIDATION_IN_VALIDATION'
}

export type DocumentCertificateSumOrderByAggregateInput = {
  teamEducationLevelId?: InputMaybe<SortOrder>;
};

export type DocumentCertificateUpdateInput = {
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateOneWithoutDocumentCertificatesNestedInput>;
  Curriculum?: InputMaybe<CertificateCurriculumUpdateOneWithoutDocumentCertificateNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  DocumentCertificateHashHistory?: InputMaybe<DocumentCertificateHashHistoryUpdateManyWithoutDocumentCertificateNestedInput>;
  DocumentCertificateSignatureItems?: InputMaybe<DocumentCertificateSignatureItemUpdateManyWithoutDocumentCertificateNestedInput>;
  Event?: InputMaybe<CertificateEventUpdateOneWithoutDocumentCertificateNestedInput>;
  MetadataList?: InputMaybe<DocumentCertificateMetadataUpdateManyWithoutDocumentCertificateNestedInput>;
  Person?: InputMaybe<PersonUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  Template?: InputMaybe<CertificateTemplateUpdateOneWithoutDocumentCertificateNestedInput>;
  documentCertificateCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentCertificateEmail?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentCertificateName?: InputMaybe<StringFieldUpdateOperationsInput>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateUpdateManyMutationInput = {
  documentCertificateCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentCertificateEmail?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentCertificateName?: InputMaybe<StringFieldUpdateOperationsInput>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateUpdateManyWithWhereWithoutBulkCertificateRecordInput = {
  data: DocumentCertificateUpdateManyMutationInput;
  where: DocumentCertificateScalarWhereInput;
};

export type DocumentCertificateUpdateManyWithWhereWithoutCurriculumInput = {
  data: DocumentCertificateUpdateManyMutationInput;
  where: DocumentCertificateScalarWhereInput;
};

export type DocumentCertificateUpdateManyWithWhereWithoutEventInput = {
  data: DocumentCertificateUpdateManyMutationInput;
  where: DocumentCertificateScalarWhereInput;
};

export type DocumentCertificateUpdateManyWithWhereWithoutPersonInput = {
  data: DocumentCertificateUpdateManyMutationInput;
  where: DocumentCertificateScalarWhereInput;
};

export type DocumentCertificateUpdateManyWithWhereWithoutTeamEducationLevelInput = {
  data: DocumentCertificateUpdateManyMutationInput;
  where: DocumentCertificateScalarWhereInput;
};

export type DocumentCertificateUpdateManyWithWhereWithoutTemplateInput = {
  data: DocumentCertificateUpdateManyMutationInput;
  where: DocumentCertificateScalarWhereInput;
};

export type DocumentCertificateUpdateManyWithoutBulkCertificateRecordNestedInput = {
  connect?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCertificateCreateOrConnectWithoutBulkCertificateRecordInput>>;
  create?: InputMaybe<Array<DocumentCertificateCreateWithoutBulkCertificateRecordInput>>;
  createMany?: InputMaybe<DocumentCertificateCreateManyBulkCertificateRecordInputEnvelope>;
  delete?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentCertificateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentCertificateUpdateWithWhereUniqueWithoutBulkCertificateRecordInput>>;
  updateMany?: InputMaybe<Array<DocumentCertificateUpdateManyWithWhereWithoutBulkCertificateRecordInput>>;
  upsert?: InputMaybe<Array<DocumentCertificateUpsertWithWhereUniqueWithoutBulkCertificateRecordInput>>;
};

export type DocumentCertificateUpdateManyWithoutCurriculumNestedInput = {
  connect?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCertificateCreateOrConnectWithoutCurriculumInput>>;
  create?: InputMaybe<Array<DocumentCertificateCreateWithoutCurriculumInput>>;
  createMany?: InputMaybe<DocumentCertificateCreateManyCurriculumInputEnvelope>;
  delete?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentCertificateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentCertificateUpdateWithWhereUniqueWithoutCurriculumInput>>;
  updateMany?: InputMaybe<Array<DocumentCertificateUpdateManyWithWhereWithoutCurriculumInput>>;
  upsert?: InputMaybe<Array<DocumentCertificateUpsertWithWhereUniqueWithoutCurriculumInput>>;
};

export type DocumentCertificateUpdateManyWithoutEventNestedInput = {
  connect?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCertificateCreateOrConnectWithoutEventInput>>;
  create?: InputMaybe<Array<DocumentCertificateCreateWithoutEventInput>>;
  createMany?: InputMaybe<DocumentCertificateCreateManyEventInputEnvelope>;
  delete?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentCertificateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentCertificateUpdateWithWhereUniqueWithoutEventInput>>;
  updateMany?: InputMaybe<Array<DocumentCertificateUpdateManyWithWhereWithoutEventInput>>;
  upsert?: InputMaybe<Array<DocumentCertificateUpsertWithWhereUniqueWithoutEventInput>>;
};

export type DocumentCertificateUpdateManyWithoutPersonNestedInput = {
  connect?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCertificateCreateOrConnectWithoutPersonInput>>;
  create?: InputMaybe<Array<DocumentCertificateCreateWithoutPersonInput>>;
  createMany?: InputMaybe<DocumentCertificateCreateManyPersonInputEnvelope>;
  delete?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentCertificateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentCertificateUpdateWithWhereUniqueWithoutPersonInput>>;
  updateMany?: InputMaybe<Array<DocumentCertificateUpdateManyWithWhereWithoutPersonInput>>;
  upsert?: InputMaybe<Array<DocumentCertificateUpsertWithWhereUniqueWithoutPersonInput>>;
};

export type DocumentCertificateUpdateManyWithoutTeamEducationLevelNestedInput = {
  connect?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCertificateCreateOrConnectWithoutTeamEducationLevelInput>>;
  create?: InputMaybe<Array<DocumentCertificateCreateWithoutTeamEducationLevelInput>>;
  createMany?: InputMaybe<DocumentCertificateCreateManyTeamEducationLevelInputEnvelope>;
  delete?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentCertificateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentCertificateUpdateWithWhereUniqueWithoutTeamEducationLevelInput>>;
  updateMany?: InputMaybe<Array<DocumentCertificateUpdateManyWithWhereWithoutTeamEducationLevelInput>>;
  upsert?: InputMaybe<Array<DocumentCertificateUpsertWithWhereUniqueWithoutTeamEducationLevelInput>>;
};

export type DocumentCertificateUpdateManyWithoutTemplateNestedInput = {
  connect?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCertificateCreateOrConnectWithoutTemplateInput>>;
  create?: InputMaybe<Array<DocumentCertificateCreateWithoutTemplateInput>>;
  createMany?: InputMaybe<DocumentCertificateCreateManyTemplateInputEnvelope>;
  delete?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentCertificateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentCertificateWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentCertificateUpdateWithWhereUniqueWithoutTemplateInput>>;
  updateMany?: InputMaybe<Array<DocumentCertificateUpdateManyWithWhereWithoutTemplateInput>>;
  upsert?: InputMaybe<Array<DocumentCertificateUpsertWithWhereUniqueWithoutTemplateInput>>;
};

export type DocumentCertificateUpdateOneRequiredWithoutDocumentCertificateHashHistoryNestedInput = {
  connect?: InputMaybe<DocumentCertificateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentCertificateCreateOrConnectWithoutDocumentCertificateHashHistoryInput>;
  create?: InputMaybe<DocumentCertificateCreateWithoutDocumentCertificateHashHistoryInput>;
  update?: InputMaybe<DocumentCertificateUpdateToOneWithWhereWithoutDocumentCertificateHashHistoryInput>;
  upsert?: InputMaybe<DocumentCertificateUpsertWithoutDocumentCertificateHashHistoryInput>;
};

export type DocumentCertificateUpdateOneRequiredWithoutDocumentCertificateSignatureItemsNestedInput = {
  connect?: InputMaybe<DocumentCertificateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentCertificateCreateOrConnectWithoutDocumentCertificateSignatureItemsInput>;
  create?: InputMaybe<DocumentCertificateCreateWithoutDocumentCertificateSignatureItemsInput>;
  update?: InputMaybe<DocumentCertificateUpdateToOneWithWhereWithoutDocumentCertificateSignatureItemsInput>;
  upsert?: InputMaybe<DocumentCertificateUpsertWithoutDocumentCertificateSignatureItemsInput>;
};

export type DocumentCertificateUpdateOneRequiredWithoutMetadataListNestedInput = {
  connect?: InputMaybe<DocumentCertificateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentCertificateCreateOrConnectWithoutMetadataListInput>;
  create?: InputMaybe<DocumentCertificateCreateWithoutMetadataListInput>;
  update?: InputMaybe<DocumentCertificateUpdateToOneWithWhereWithoutMetadataListInput>;
  upsert?: InputMaybe<DocumentCertificateUpsertWithoutMetadataListInput>;
};

export type DocumentCertificateUpdateOneWithoutDocumentBaseNestedInput = {
  connect?: InputMaybe<DocumentCertificateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentCertificateCreateOrConnectWithoutDocumentBaseInput>;
  create?: InputMaybe<DocumentCertificateCreateWithoutDocumentBaseInput>;
  delete?: InputMaybe<DocumentCertificateWhereInput>;
  disconnect?: InputMaybe<DocumentCertificateWhereInput>;
  update?: InputMaybe<DocumentCertificateUpdateToOneWithWhereWithoutDocumentBaseInput>;
  upsert?: InputMaybe<DocumentCertificateUpsertWithoutDocumentBaseInput>;
};

export type DocumentCertificateUpdateToOneWithWhereWithoutDocumentBaseInput = {
  data: DocumentCertificateUpdateWithoutDocumentBaseInput;
  where?: InputMaybe<DocumentCertificateWhereInput>;
};

export type DocumentCertificateUpdateToOneWithWhereWithoutDocumentCertificateHashHistoryInput = {
  data: DocumentCertificateUpdateWithoutDocumentCertificateHashHistoryInput;
  where?: InputMaybe<DocumentCertificateWhereInput>;
};

export type DocumentCertificateUpdateToOneWithWhereWithoutDocumentCertificateSignatureItemsInput = {
  data: DocumentCertificateUpdateWithoutDocumentCertificateSignatureItemsInput;
  where?: InputMaybe<DocumentCertificateWhereInput>;
};

export type DocumentCertificateUpdateToOneWithWhereWithoutMetadataListInput = {
  data: DocumentCertificateUpdateWithoutMetadataListInput;
  where?: InputMaybe<DocumentCertificateWhereInput>;
};

export type DocumentCertificateUpdateWithWhereUniqueWithoutBulkCertificateRecordInput = {
  data: DocumentCertificateUpdateWithoutBulkCertificateRecordInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateUpdateWithWhereUniqueWithoutCurriculumInput = {
  data: DocumentCertificateUpdateWithoutCurriculumInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateUpdateWithWhereUniqueWithoutEventInput = {
  data: DocumentCertificateUpdateWithoutEventInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateUpdateWithWhereUniqueWithoutPersonInput = {
  data: DocumentCertificateUpdateWithoutPersonInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateUpdateWithWhereUniqueWithoutTeamEducationLevelInput = {
  data: DocumentCertificateUpdateWithoutTeamEducationLevelInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateUpdateWithWhereUniqueWithoutTemplateInput = {
  data: DocumentCertificateUpdateWithoutTemplateInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateUpdateWithoutBulkCertificateRecordInput = {
  Curriculum?: InputMaybe<CertificateCurriculumUpdateOneWithoutDocumentCertificateNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  DocumentCertificateHashHistory?: InputMaybe<DocumentCertificateHashHistoryUpdateManyWithoutDocumentCertificateNestedInput>;
  DocumentCertificateSignatureItems?: InputMaybe<DocumentCertificateSignatureItemUpdateManyWithoutDocumentCertificateNestedInput>;
  Event?: InputMaybe<CertificateEventUpdateOneWithoutDocumentCertificateNestedInput>;
  MetadataList?: InputMaybe<DocumentCertificateMetadataUpdateManyWithoutDocumentCertificateNestedInput>;
  Person?: InputMaybe<PersonUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  Template?: InputMaybe<CertificateTemplateUpdateOneWithoutDocumentCertificateNestedInput>;
  documentCertificateCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentCertificateEmail?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentCertificateName?: InputMaybe<StringFieldUpdateOperationsInput>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateUpdateWithoutCurriculumInput = {
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateOneWithoutDocumentCertificatesNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  DocumentCertificateHashHistory?: InputMaybe<DocumentCertificateHashHistoryUpdateManyWithoutDocumentCertificateNestedInput>;
  DocumentCertificateSignatureItems?: InputMaybe<DocumentCertificateSignatureItemUpdateManyWithoutDocumentCertificateNestedInput>;
  Event?: InputMaybe<CertificateEventUpdateOneWithoutDocumentCertificateNestedInput>;
  MetadataList?: InputMaybe<DocumentCertificateMetadataUpdateManyWithoutDocumentCertificateNestedInput>;
  Person?: InputMaybe<PersonUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  Template?: InputMaybe<CertificateTemplateUpdateOneWithoutDocumentCertificateNestedInput>;
  documentCertificateCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentCertificateEmail?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentCertificateName?: InputMaybe<StringFieldUpdateOperationsInput>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateUpdateWithoutDocumentBaseInput = {
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateOneWithoutDocumentCertificatesNestedInput>;
  Curriculum?: InputMaybe<CertificateCurriculumUpdateOneWithoutDocumentCertificateNestedInput>;
  DocumentCertificateHashHistory?: InputMaybe<DocumentCertificateHashHistoryUpdateManyWithoutDocumentCertificateNestedInput>;
  DocumentCertificateSignatureItems?: InputMaybe<DocumentCertificateSignatureItemUpdateManyWithoutDocumentCertificateNestedInput>;
  Event?: InputMaybe<CertificateEventUpdateOneWithoutDocumentCertificateNestedInput>;
  MetadataList?: InputMaybe<DocumentCertificateMetadataUpdateManyWithoutDocumentCertificateNestedInput>;
  Person?: InputMaybe<PersonUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  Template?: InputMaybe<CertificateTemplateUpdateOneWithoutDocumentCertificateNestedInput>;
  documentCertificateCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentCertificateEmail?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentCertificateName?: InputMaybe<StringFieldUpdateOperationsInput>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateUpdateWithoutDocumentCertificateHashHistoryInput = {
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateOneWithoutDocumentCertificatesNestedInput>;
  Curriculum?: InputMaybe<CertificateCurriculumUpdateOneWithoutDocumentCertificateNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  DocumentCertificateSignatureItems?: InputMaybe<DocumentCertificateSignatureItemUpdateManyWithoutDocumentCertificateNestedInput>;
  Event?: InputMaybe<CertificateEventUpdateOneWithoutDocumentCertificateNestedInput>;
  MetadataList?: InputMaybe<DocumentCertificateMetadataUpdateManyWithoutDocumentCertificateNestedInput>;
  Person?: InputMaybe<PersonUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  Template?: InputMaybe<CertificateTemplateUpdateOneWithoutDocumentCertificateNestedInput>;
  documentCertificateCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentCertificateEmail?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentCertificateName?: InputMaybe<StringFieldUpdateOperationsInput>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateUpdateWithoutDocumentCertificateSignatureItemsInput = {
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateOneWithoutDocumentCertificatesNestedInput>;
  Curriculum?: InputMaybe<CertificateCurriculumUpdateOneWithoutDocumentCertificateNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  DocumentCertificateHashHistory?: InputMaybe<DocumentCertificateHashHistoryUpdateManyWithoutDocumentCertificateNestedInput>;
  Event?: InputMaybe<CertificateEventUpdateOneWithoutDocumentCertificateNestedInput>;
  MetadataList?: InputMaybe<DocumentCertificateMetadataUpdateManyWithoutDocumentCertificateNestedInput>;
  Person?: InputMaybe<PersonUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  Template?: InputMaybe<CertificateTemplateUpdateOneWithoutDocumentCertificateNestedInput>;
  documentCertificateCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentCertificateEmail?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentCertificateName?: InputMaybe<StringFieldUpdateOperationsInput>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateUpdateWithoutEventInput = {
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateOneWithoutDocumentCertificatesNestedInput>;
  Curriculum?: InputMaybe<CertificateCurriculumUpdateOneWithoutDocumentCertificateNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  DocumentCertificateHashHistory?: InputMaybe<DocumentCertificateHashHistoryUpdateManyWithoutDocumentCertificateNestedInput>;
  DocumentCertificateSignatureItems?: InputMaybe<DocumentCertificateSignatureItemUpdateManyWithoutDocumentCertificateNestedInput>;
  MetadataList?: InputMaybe<DocumentCertificateMetadataUpdateManyWithoutDocumentCertificateNestedInput>;
  Person?: InputMaybe<PersonUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  Template?: InputMaybe<CertificateTemplateUpdateOneWithoutDocumentCertificateNestedInput>;
  documentCertificateCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentCertificateEmail?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentCertificateName?: InputMaybe<StringFieldUpdateOperationsInput>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateUpdateWithoutMetadataListInput = {
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateOneWithoutDocumentCertificatesNestedInput>;
  Curriculum?: InputMaybe<CertificateCurriculumUpdateOneWithoutDocumentCertificateNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  DocumentCertificateHashHistory?: InputMaybe<DocumentCertificateHashHistoryUpdateManyWithoutDocumentCertificateNestedInput>;
  DocumentCertificateSignatureItems?: InputMaybe<DocumentCertificateSignatureItemUpdateManyWithoutDocumentCertificateNestedInput>;
  Event?: InputMaybe<CertificateEventUpdateOneWithoutDocumentCertificateNestedInput>;
  Person?: InputMaybe<PersonUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  Template?: InputMaybe<CertificateTemplateUpdateOneWithoutDocumentCertificateNestedInput>;
  documentCertificateCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentCertificateEmail?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentCertificateName?: InputMaybe<StringFieldUpdateOperationsInput>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateUpdateWithoutPersonInput = {
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateOneWithoutDocumentCertificatesNestedInput>;
  Curriculum?: InputMaybe<CertificateCurriculumUpdateOneWithoutDocumentCertificateNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  DocumentCertificateHashHistory?: InputMaybe<DocumentCertificateHashHistoryUpdateManyWithoutDocumentCertificateNestedInput>;
  DocumentCertificateSignatureItems?: InputMaybe<DocumentCertificateSignatureItemUpdateManyWithoutDocumentCertificateNestedInput>;
  Event?: InputMaybe<CertificateEventUpdateOneWithoutDocumentCertificateNestedInput>;
  MetadataList?: InputMaybe<DocumentCertificateMetadataUpdateManyWithoutDocumentCertificateNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  Template?: InputMaybe<CertificateTemplateUpdateOneWithoutDocumentCertificateNestedInput>;
  documentCertificateCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentCertificateEmail?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentCertificateName?: InputMaybe<StringFieldUpdateOperationsInput>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateUpdateWithoutTeamEducationLevelInput = {
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateOneWithoutDocumentCertificatesNestedInput>;
  Curriculum?: InputMaybe<CertificateCurriculumUpdateOneWithoutDocumentCertificateNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  DocumentCertificateHashHistory?: InputMaybe<DocumentCertificateHashHistoryUpdateManyWithoutDocumentCertificateNestedInput>;
  DocumentCertificateSignatureItems?: InputMaybe<DocumentCertificateSignatureItemUpdateManyWithoutDocumentCertificateNestedInput>;
  Event?: InputMaybe<CertificateEventUpdateOneWithoutDocumentCertificateNestedInput>;
  MetadataList?: InputMaybe<DocumentCertificateMetadataUpdateManyWithoutDocumentCertificateNestedInput>;
  Person?: InputMaybe<PersonUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  Template?: InputMaybe<CertificateTemplateUpdateOneWithoutDocumentCertificateNestedInput>;
  documentCertificateCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentCertificateEmail?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentCertificateName?: InputMaybe<StringFieldUpdateOperationsInput>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateUpdateWithoutTemplateInput = {
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateOneWithoutDocumentCertificatesNestedInput>;
  Curriculum?: InputMaybe<CertificateCurriculumUpdateOneWithoutDocumentCertificateNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  DocumentCertificateHashHistory?: InputMaybe<DocumentCertificateHashHistoryUpdateManyWithoutDocumentCertificateNestedInput>;
  DocumentCertificateSignatureItems?: InputMaybe<DocumentCertificateSignatureItemUpdateManyWithoutDocumentCertificateNestedInput>;
  Event?: InputMaybe<CertificateEventUpdateOneWithoutDocumentCertificateNestedInput>;
  MetadataList?: InputMaybe<DocumentCertificateMetadataUpdateManyWithoutDocumentCertificateNestedInput>;
  Person?: InputMaybe<PersonUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateOneRequiredWithoutDocumentCertificateNestedInput>;
  documentCertificateCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentCertificateEmail?: InputMaybe<StringFieldUpdateOperationsInput>;
  documentCertificateName?: InputMaybe<StringFieldUpdateOperationsInput>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentCertificateStatusFieldUpdateOperationsInput>;
  uuid?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DocumentCertificateUpsertWithWhereUniqueWithoutBulkCertificateRecordInput = {
  create: DocumentCertificateCreateWithoutBulkCertificateRecordInput;
  update: DocumentCertificateUpdateWithoutBulkCertificateRecordInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateUpsertWithWhereUniqueWithoutCurriculumInput = {
  create: DocumentCertificateCreateWithoutCurriculumInput;
  update: DocumentCertificateUpdateWithoutCurriculumInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateUpsertWithWhereUniqueWithoutEventInput = {
  create: DocumentCertificateCreateWithoutEventInput;
  update: DocumentCertificateUpdateWithoutEventInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateUpsertWithWhereUniqueWithoutPersonInput = {
  create: DocumentCertificateCreateWithoutPersonInput;
  update: DocumentCertificateUpdateWithoutPersonInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateUpsertWithWhereUniqueWithoutTeamEducationLevelInput = {
  create: DocumentCertificateCreateWithoutTeamEducationLevelInput;
  update: DocumentCertificateUpdateWithoutTeamEducationLevelInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateUpsertWithWhereUniqueWithoutTemplateInput = {
  create: DocumentCertificateCreateWithoutTemplateInput;
  update: DocumentCertificateUpdateWithoutTemplateInput;
  where: DocumentCertificateWhereUniqueInput;
};

export type DocumentCertificateUpsertWithoutDocumentBaseInput = {
  create: DocumentCertificateCreateWithoutDocumentBaseInput;
  update: DocumentCertificateUpdateWithoutDocumentBaseInput;
  where?: InputMaybe<DocumentCertificateWhereInput>;
};

export type DocumentCertificateUpsertWithoutDocumentCertificateHashHistoryInput = {
  create: DocumentCertificateCreateWithoutDocumentCertificateHashHistoryInput;
  update: DocumentCertificateUpdateWithoutDocumentCertificateHashHistoryInput;
  where?: InputMaybe<DocumentCertificateWhereInput>;
};

export type DocumentCertificateUpsertWithoutDocumentCertificateSignatureItemsInput = {
  create: DocumentCertificateCreateWithoutDocumentCertificateSignatureItemsInput;
  update: DocumentCertificateUpdateWithoutDocumentCertificateSignatureItemsInput;
  where?: InputMaybe<DocumentCertificateWhereInput>;
};

export type DocumentCertificateUpsertWithoutMetadataListInput = {
  create: DocumentCertificateCreateWithoutMetadataListInput;
  update: DocumentCertificateUpdateWithoutMetadataListInput;
  where?: InputMaybe<DocumentCertificateWhereInput>;
};

export type DocumentCertificateWhereInput = {
  AND?: InputMaybe<Array<DocumentCertificateWhereInput>>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordWhereInput>;
  Curriculum?: InputMaybe<CertificateCurriculumWhereInput>;
  DocumentBase?: InputMaybe<DocumentBaseWhereInput>;
  DocumentCertificateHashHistory?: InputMaybe<DocumentCertificateHashHistoryListRelationFilter>;
  DocumentCertificateSignatureItems?: InputMaybe<DocumentCertificateSignatureItemListRelationFilter>;
  Event?: InputMaybe<CertificateEventWhereInput>;
  MetadataList?: InputMaybe<DocumentCertificateMetadataListRelationFilter>;
  NOT?: InputMaybe<Array<DocumentCertificateWhereInput>>;
  OR?: InputMaybe<Array<DocumentCertificateWhereInput>>;
  Person?: InputMaybe<PersonWhereInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelWhereInput>;
  Template?: InputMaybe<CertificateTemplateWhereInput>;
  batchId?: InputMaybe<StringNullableFilter>;
  certificateCurriculumCertificateBaseId?: InputMaybe<StringNullableFilter>;
  certificateEventCertificateBaseId?: InputMaybe<StringNullableFilter>;
  certificateTemplateId?: InputMaybe<StringNullableFilter>;
  documentBaseId?: InputMaybe<StringFilter>;
  documentCertificateCPF?: InputMaybe<StringFilter>;
  documentCertificateEmail?: InputMaybe<StringFilter>;
  documentCertificateName?: InputMaybe<StringFilter>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<BoolFilter>;
  personId?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumDocumentCertificateStatusFilter>;
  teamEducationLevelId?: InputMaybe<IntFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type DocumentCertificateWhereUniqueInput = {
  AND?: InputMaybe<Array<DocumentCertificateWhereInput>>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordWhereInput>;
  Curriculum?: InputMaybe<CertificateCurriculumWhereInput>;
  DocumentBase?: InputMaybe<DocumentBaseWhereInput>;
  DocumentCertificateHashHistory?: InputMaybe<DocumentCertificateHashHistoryListRelationFilter>;
  DocumentCertificateSignatureItems?: InputMaybe<DocumentCertificateSignatureItemListRelationFilter>;
  Event?: InputMaybe<CertificateEventWhereInput>;
  MetadataList?: InputMaybe<DocumentCertificateMetadataListRelationFilter>;
  NOT?: InputMaybe<Array<DocumentCertificateWhereInput>>;
  OR?: InputMaybe<Array<DocumentCertificateWhereInput>>;
  Person?: InputMaybe<PersonWhereInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelWhereInput>;
  Template?: InputMaybe<CertificateTemplateWhereInput>;
  batchId?: InputMaybe<StringNullableFilter>;
  certificateCurriculumCertificateBaseId?: InputMaybe<StringNullableFilter>;
  certificateEventCertificateBaseId?: InputMaybe<StringNullableFilter>;
  certificateTemplateId?: InputMaybe<StringNullableFilter>;
  documentBaseId?: InputMaybe<Scalars['String']['input']>;
  documentCertificateCPF?: InputMaybe<StringFilter>;
  documentCertificateEmail?: InputMaybe<StringFilter>;
  documentCertificateName?: InputMaybe<StringFilter>;
  hasOnlyPredefinedVisualSignature?: InputMaybe<BoolFilter>;
  personId?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumDocumentCertificateStatusFilter>;
  teamEducationLevelId?: InputMaybe<IntFilter>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentChange = {
  propertyPath: Scalars['String']['input'];
  /** 'updated', 'created', 'deleted' */
  type: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Json']['input']>;
};

export type DocumentDegree = {
  __typename?: 'DocumentDegree';
  DocumentAuditFileIssuers: Array<DocumentAuditFileIssuerDegreeItem>;
  DocumentBase: DocumentBase;
  DocumentDegreeSearchView?: Maybe<DocumentDegreeSearchView>;
  ParentAcademicDocumentation?: Maybe<DocumentAcademicDocumentation>;
  documentBaseId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isSentToGraduate: Scalars['Boolean']['output'];
  parentAcademicDocumentationId?: Maybe<Scalars['String']['output']>;
  searchCPF: Scalars['String']['output'];
  searchCourse: Scalars['String']['output'];
  searchEmecCode: Scalars['String']['output'];
  searchIssueDate?: Maybe<Scalars['DateTime']['output']>;
  searchRegistrationDate?: Maybe<Scalars['DateTime']['output']>;
  searchStudentName: Scalars['String']['output'];
  searchValidationCode?: Maybe<Scalars['String']['output']>;
  status: DocumentDegreeStatus;
  validationAttempts: Scalars['Int']['output'];
  visualRepresentationCreationType: VisualRepresentationCreationType;
  visualRepresentationFileSize: Scalars['Int']['output'];
  visualRepresentationPath?: Maybe<Scalars['String']['output']>;
};


export type DocumentDegreeDocumentAuditFileIssuersArgs = {
  cursor?: InputMaybe<DocumentAuditFileIssuerDegreeItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentAuditFileIssuerDegreeItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentAuditFileIssuerDegreeItemWhereInput>;
};

export type DocumentDegreeAvgOrderByAggregateInput = {
  validationAttempts?: InputMaybe<SortOrder>;
  visualRepresentationFileSize?: InputMaybe<SortOrder>;
};

export type DocumentDegreeCountOrderByAggregateInput = {
  documentBaseId?: InputMaybe<SortOrder>;
  isSentToGraduate?: InputMaybe<SortOrder>;
  parentAcademicDocumentationId?: InputMaybe<SortOrder>;
  searchCPF?: InputMaybe<SortOrder>;
  searchCourse?: InputMaybe<SortOrder>;
  searchEmecCode?: InputMaybe<SortOrder>;
  searchIssueDate?: InputMaybe<SortOrder>;
  searchRegistrationDate?: InputMaybe<SortOrder>;
  searchStudentName?: InputMaybe<SortOrder>;
  searchValidationCode?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  validationAttempts?: InputMaybe<SortOrder>;
  visualRepresentationCreationType?: InputMaybe<SortOrder>;
  visualRepresentationFileSize?: InputMaybe<SortOrder>;
  visualRepresentationPath?: InputMaybe<SortOrder>;
};

export type DocumentDegreeCreateInput = {
  DocumentAuditFileIssuers?: InputMaybe<DocumentAuditFileIssuerDegreeItemCreateNestedManyWithoutDocumentDegreeInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentDegreeInput;
  DocumentDegreeSearchView?: InputMaybe<DocumentDegreeSearchViewCreateNestedOneWithoutDocumentDegreeInput>;
  ParentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationCreateNestedOneWithoutLinkedDegreeListInput>;
  isSentToGraduate?: InputMaybe<Scalars['Boolean']['input']>;
  searchCPF: Scalars['String']['input'];
  searchCourse: Scalars['String']['input'];
  searchEmecCode: Scalars['String']['input'];
  searchIssueDate?: InputMaybe<Scalars['DateTime']['input']>;
  searchRegistrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  searchStudentName: Scalars['String']['input'];
  searchValidationCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentDegreeStatus>;
  validationAttempts?: InputMaybe<Scalars['Int']['input']>;
  visualRepresentationCreationType?: InputMaybe<VisualRepresentationCreationType>;
  visualRepresentationFileSize?: InputMaybe<Scalars['Int']['input']>;
  visualRepresentationPath?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentDegreeCreateManyInput = {
  documentBaseId: Scalars['String']['input'];
  isSentToGraduate?: InputMaybe<Scalars['Boolean']['input']>;
  parentAcademicDocumentationId?: InputMaybe<Scalars['String']['input']>;
  searchCPF: Scalars['String']['input'];
  searchCourse: Scalars['String']['input'];
  searchEmecCode: Scalars['String']['input'];
  searchIssueDate?: InputMaybe<Scalars['DateTime']['input']>;
  searchRegistrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  searchStudentName: Scalars['String']['input'];
  searchValidationCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentDegreeStatus>;
  validationAttempts?: InputMaybe<Scalars['Int']['input']>;
  visualRepresentationCreationType?: InputMaybe<VisualRepresentationCreationType>;
  visualRepresentationFileSize?: InputMaybe<Scalars['Int']['input']>;
  visualRepresentationPath?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentDegreeCreateManyParentAcademicDocumentationInput = {
  documentBaseId: Scalars['String']['input'];
  isSentToGraduate?: InputMaybe<Scalars['Boolean']['input']>;
  searchCPF: Scalars['String']['input'];
  searchCourse: Scalars['String']['input'];
  searchEmecCode: Scalars['String']['input'];
  searchIssueDate?: InputMaybe<Scalars['DateTime']['input']>;
  searchRegistrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  searchStudentName: Scalars['String']['input'];
  searchValidationCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentDegreeStatus>;
  validationAttempts?: InputMaybe<Scalars['Int']['input']>;
  visualRepresentationCreationType?: InputMaybe<VisualRepresentationCreationType>;
  visualRepresentationFileSize?: InputMaybe<Scalars['Int']['input']>;
  visualRepresentationPath?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentDegreeCreateManyParentAcademicDocumentationInputEnvelope = {
  data: Array<DocumentDegreeCreateManyParentAcademicDocumentationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentDegreeCreateNestedManyWithoutParentAcademicDocumentationInput = {
  connect?: InputMaybe<Array<DocumentDegreeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentDegreeCreateOrConnectWithoutParentAcademicDocumentationInput>>;
  create?: InputMaybe<Array<DocumentDegreeCreateWithoutParentAcademicDocumentationInput>>;
  createMany?: InputMaybe<DocumentDegreeCreateManyParentAcademicDocumentationInputEnvelope>;
};

export type DocumentDegreeCreateNestedOneWithoutDocumentAuditFileIssuersInput = {
  connect?: InputMaybe<DocumentDegreeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentDegreeCreateOrConnectWithoutDocumentAuditFileIssuersInput>;
  create?: InputMaybe<DocumentDegreeCreateWithoutDocumentAuditFileIssuersInput>;
};

export type DocumentDegreeCreateNestedOneWithoutDocumentBaseInput = {
  connect?: InputMaybe<DocumentDegreeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentDegreeCreateOrConnectWithoutDocumentBaseInput>;
  create?: InputMaybe<DocumentDegreeCreateWithoutDocumentBaseInput>;
};

export type DocumentDegreeCreateNestedOneWithoutDocumentDegreeSearchViewInput = {
  connect?: InputMaybe<DocumentDegreeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentDegreeCreateOrConnectWithoutDocumentDegreeSearchViewInput>;
  create?: InputMaybe<DocumentDegreeCreateWithoutDocumentDegreeSearchViewInput>;
};

export type DocumentDegreeCreateOrConnectWithoutDocumentAuditFileIssuersInput = {
  create: DocumentDegreeCreateWithoutDocumentAuditFileIssuersInput;
  where: DocumentDegreeWhereUniqueInput;
};

export type DocumentDegreeCreateOrConnectWithoutDocumentBaseInput = {
  create: DocumentDegreeCreateWithoutDocumentBaseInput;
  where: DocumentDegreeWhereUniqueInput;
};

export type DocumentDegreeCreateOrConnectWithoutDocumentDegreeSearchViewInput = {
  create: DocumentDegreeCreateWithoutDocumentDegreeSearchViewInput;
  where: DocumentDegreeWhereUniqueInput;
};

export type DocumentDegreeCreateOrConnectWithoutParentAcademicDocumentationInput = {
  create: DocumentDegreeCreateWithoutParentAcademicDocumentationInput;
  where: DocumentDegreeWhereUniqueInput;
};

export type DocumentDegreeCreateWithoutDocumentAuditFileIssuersInput = {
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentDegreeInput;
  DocumentDegreeSearchView?: InputMaybe<DocumentDegreeSearchViewCreateNestedOneWithoutDocumentDegreeInput>;
  ParentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationCreateNestedOneWithoutLinkedDegreeListInput>;
  isSentToGraduate?: InputMaybe<Scalars['Boolean']['input']>;
  searchCPF: Scalars['String']['input'];
  searchCourse: Scalars['String']['input'];
  searchEmecCode: Scalars['String']['input'];
  searchIssueDate?: InputMaybe<Scalars['DateTime']['input']>;
  searchRegistrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  searchStudentName: Scalars['String']['input'];
  searchValidationCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentDegreeStatus>;
  validationAttempts?: InputMaybe<Scalars['Int']['input']>;
  visualRepresentationCreationType?: InputMaybe<VisualRepresentationCreationType>;
  visualRepresentationFileSize?: InputMaybe<Scalars['Int']['input']>;
  visualRepresentationPath?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentDegreeCreateWithoutDocumentBaseInput = {
  DocumentAuditFileIssuers?: InputMaybe<DocumentAuditFileIssuerDegreeItemCreateNestedManyWithoutDocumentDegreeInput>;
  DocumentDegreeSearchView?: InputMaybe<DocumentDegreeSearchViewCreateNestedOneWithoutDocumentDegreeInput>;
  ParentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationCreateNestedOneWithoutLinkedDegreeListInput>;
  isSentToGraduate?: InputMaybe<Scalars['Boolean']['input']>;
  searchCPF: Scalars['String']['input'];
  searchCourse: Scalars['String']['input'];
  searchEmecCode: Scalars['String']['input'];
  searchIssueDate?: InputMaybe<Scalars['DateTime']['input']>;
  searchRegistrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  searchStudentName: Scalars['String']['input'];
  searchValidationCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentDegreeStatus>;
  validationAttempts?: InputMaybe<Scalars['Int']['input']>;
  visualRepresentationCreationType?: InputMaybe<VisualRepresentationCreationType>;
  visualRepresentationFileSize?: InputMaybe<Scalars['Int']['input']>;
  visualRepresentationPath?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentDegreeCreateWithoutDocumentDegreeSearchViewInput = {
  DocumentAuditFileIssuers?: InputMaybe<DocumentAuditFileIssuerDegreeItemCreateNestedManyWithoutDocumentDegreeInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentDegreeInput;
  ParentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationCreateNestedOneWithoutLinkedDegreeListInput>;
  isSentToGraduate?: InputMaybe<Scalars['Boolean']['input']>;
  searchCPF: Scalars['String']['input'];
  searchCourse: Scalars['String']['input'];
  searchEmecCode: Scalars['String']['input'];
  searchIssueDate?: InputMaybe<Scalars['DateTime']['input']>;
  searchRegistrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  searchStudentName: Scalars['String']['input'];
  searchValidationCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentDegreeStatus>;
  validationAttempts?: InputMaybe<Scalars['Int']['input']>;
  visualRepresentationCreationType?: InputMaybe<VisualRepresentationCreationType>;
  visualRepresentationFileSize?: InputMaybe<Scalars['Int']['input']>;
  visualRepresentationPath?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentDegreeCreateWithoutParentAcademicDocumentationInput = {
  DocumentAuditFileIssuers?: InputMaybe<DocumentAuditFileIssuerDegreeItemCreateNestedManyWithoutDocumentDegreeInput>;
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentDegreeInput;
  DocumentDegreeSearchView?: InputMaybe<DocumentDegreeSearchViewCreateNestedOneWithoutDocumentDegreeInput>;
  isSentToGraduate?: InputMaybe<Scalars['Boolean']['input']>;
  searchCPF: Scalars['String']['input'];
  searchCourse: Scalars['String']['input'];
  searchEmecCode: Scalars['String']['input'];
  searchIssueDate?: InputMaybe<Scalars['DateTime']['input']>;
  searchRegistrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  searchStudentName: Scalars['String']['input'];
  searchValidationCode?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DocumentDegreeStatus>;
  validationAttempts?: InputMaybe<Scalars['Int']['input']>;
  visualRepresentationCreationType?: InputMaybe<VisualRepresentationCreationType>;
  visualRepresentationFileSize?: InputMaybe<Scalars['Int']['input']>;
  visualRepresentationPath?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentDegreeListRelationFilter = {
  every?: InputMaybe<DocumentDegreeWhereInput>;
  none?: InputMaybe<DocumentDegreeWhereInput>;
  some?: InputMaybe<DocumentDegreeWhereInput>;
};

export type DocumentDegreeMaxOrderByAggregateInput = {
  documentBaseId?: InputMaybe<SortOrder>;
  isSentToGraduate?: InputMaybe<SortOrder>;
  parentAcademicDocumentationId?: InputMaybe<SortOrder>;
  searchCPF?: InputMaybe<SortOrder>;
  searchCourse?: InputMaybe<SortOrder>;
  searchEmecCode?: InputMaybe<SortOrder>;
  searchIssueDate?: InputMaybe<SortOrder>;
  searchRegistrationDate?: InputMaybe<SortOrder>;
  searchStudentName?: InputMaybe<SortOrder>;
  searchValidationCode?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  validationAttempts?: InputMaybe<SortOrder>;
  visualRepresentationCreationType?: InputMaybe<SortOrder>;
  visualRepresentationFileSize?: InputMaybe<SortOrder>;
  visualRepresentationPath?: InputMaybe<SortOrder>;
};

export type DocumentDegreeMinOrderByAggregateInput = {
  documentBaseId?: InputMaybe<SortOrder>;
  isSentToGraduate?: InputMaybe<SortOrder>;
  parentAcademicDocumentationId?: InputMaybe<SortOrder>;
  searchCPF?: InputMaybe<SortOrder>;
  searchCourse?: InputMaybe<SortOrder>;
  searchEmecCode?: InputMaybe<SortOrder>;
  searchIssueDate?: InputMaybe<SortOrder>;
  searchRegistrationDate?: InputMaybe<SortOrder>;
  searchStudentName?: InputMaybe<SortOrder>;
  searchValidationCode?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  validationAttempts?: InputMaybe<SortOrder>;
  visualRepresentationCreationType?: InputMaybe<SortOrder>;
  visualRepresentationFileSize?: InputMaybe<SortOrder>;
  visualRepresentationPath?: InputMaybe<SortOrder>;
};

export type DocumentDegreeNullableRelationFilter = {
  is?: InputMaybe<DocumentDegreeWhereInput>;
  isNot?: InputMaybe<DocumentDegreeWhereInput>;
};

export type DocumentDegreeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DocumentDegreeOrderByWithAggregationInput = {
  _avg?: InputMaybe<DocumentDegreeAvgOrderByAggregateInput>;
  _count?: InputMaybe<DocumentDegreeCountOrderByAggregateInput>;
  _max?: InputMaybe<DocumentDegreeMaxOrderByAggregateInput>;
  _min?: InputMaybe<DocumentDegreeMinOrderByAggregateInput>;
  _sum?: InputMaybe<DocumentDegreeSumOrderByAggregateInput>;
  documentBaseId?: InputMaybe<SortOrder>;
  isSentToGraduate?: InputMaybe<SortOrder>;
  parentAcademicDocumentationId?: InputMaybe<SortOrder>;
  searchCPF?: InputMaybe<SortOrder>;
  searchCourse?: InputMaybe<SortOrder>;
  searchEmecCode?: InputMaybe<SortOrder>;
  searchIssueDate?: InputMaybe<SortOrder>;
  searchRegistrationDate?: InputMaybe<SortOrder>;
  searchStudentName?: InputMaybe<SortOrder>;
  searchValidationCode?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  validationAttempts?: InputMaybe<SortOrder>;
  visualRepresentationCreationType?: InputMaybe<SortOrder>;
  visualRepresentationFileSize?: InputMaybe<SortOrder>;
  visualRepresentationPath?: InputMaybe<SortOrder>;
};

export type DocumentDegreeOrderByWithRelationInput = {
  DocumentAuditFileIssuers?: InputMaybe<DocumentAuditFileIssuerDegreeItemOrderByRelationAggregateInput>;
  DocumentBase?: InputMaybe<DocumentBaseOrderByWithRelationInput>;
  DocumentDegreeSearchView?: InputMaybe<DocumentDegreeSearchViewOrderByWithRelationInput>;
  ParentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationOrderByWithRelationInput>;
  documentBaseId?: InputMaybe<SortOrder>;
  isSentToGraduate?: InputMaybe<SortOrder>;
  parentAcademicDocumentationId?: InputMaybe<SortOrder>;
  searchCPF?: InputMaybe<SortOrder>;
  searchCourse?: InputMaybe<SortOrder>;
  searchEmecCode?: InputMaybe<SortOrder>;
  searchIssueDate?: InputMaybe<SortOrder>;
  searchRegistrationDate?: InputMaybe<SortOrder>;
  searchStudentName?: InputMaybe<SortOrder>;
  searchValidationCode?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  validationAttempts?: InputMaybe<SortOrder>;
  visualRepresentationCreationType?: InputMaybe<SortOrder>;
  visualRepresentationFileSize?: InputMaybe<SortOrder>;
  visualRepresentationPath?: InputMaybe<SortOrder>;
};

export type DocumentDegreeRelationFilter = {
  is?: InputMaybe<DocumentDegreeWhereInput>;
  isNot?: InputMaybe<DocumentDegreeWhereInput>;
};

export enum DocumentDegreeScalarFieldEnum {
  DocumentBaseId = 'documentBaseId',
  IsSentToGraduate = 'isSentToGraduate',
  ParentAcademicDocumentationId = 'parentAcademicDocumentationId',
  SearchCpf = 'searchCPF',
  SearchCourse = 'searchCourse',
  SearchEmecCode = 'searchEmecCode',
  SearchIssueDate = 'searchIssueDate',
  SearchRegistrationDate = 'searchRegistrationDate',
  SearchStudentName = 'searchStudentName',
  SearchValidationCode = 'searchValidationCode',
  Status = 'status',
  ValidationAttempts = 'validationAttempts',
  VisualRepresentationCreationType = 'visualRepresentationCreationType',
  VisualRepresentationFileSize = 'visualRepresentationFileSize',
  VisualRepresentationPath = 'visualRepresentationPath'
}

export type DocumentDegreeScalarWhereInput = {
  AND?: InputMaybe<Array<DocumentDegreeScalarWhereInput>>;
  NOT?: InputMaybe<Array<DocumentDegreeScalarWhereInput>>;
  OR?: InputMaybe<Array<DocumentDegreeScalarWhereInput>>;
  documentBaseId?: InputMaybe<StringFilter>;
  isSentToGraduate?: InputMaybe<BoolFilter>;
  parentAcademicDocumentationId?: InputMaybe<StringNullableFilter>;
  searchCPF?: InputMaybe<StringFilter>;
  searchCourse?: InputMaybe<StringFilter>;
  searchEmecCode?: InputMaybe<StringFilter>;
  searchIssueDate?: InputMaybe<DateTimeNullableFilter>;
  searchRegistrationDate?: InputMaybe<DateTimeNullableFilter>;
  searchStudentName?: InputMaybe<StringFilter>;
  searchValidationCode?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumDocumentDegreeStatusFilter>;
  validationAttempts?: InputMaybe<IntFilter>;
  visualRepresentationCreationType?: InputMaybe<EnumVisualRepresentationCreationTypeFilter>;
  visualRepresentationFileSize?: InputMaybe<IntFilter>;
  visualRepresentationPath?: InputMaybe<StringNullableFilter>;
};

export type DocumentDegreeScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DocumentDegreeScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DocumentDegreeScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DocumentDegreeScalarWhereWithAggregatesInput>>;
  documentBaseId?: InputMaybe<StringWithAggregatesFilter>;
  isSentToGraduate?: InputMaybe<BoolWithAggregatesFilter>;
  parentAcademicDocumentationId?: InputMaybe<StringNullableWithAggregatesFilter>;
  searchCPF?: InputMaybe<StringWithAggregatesFilter>;
  searchCourse?: InputMaybe<StringWithAggregatesFilter>;
  searchEmecCode?: InputMaybe<StringWithAggregatesFilter>;
  searchIssueDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  searchRegistrationDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  searchStudentName?: InputMaybe<StringWithAggregatesFilter>;
  searchValidationCode?: InputMaybe<StringNullableWithAggregatesFilter>;
  status?: InputMaybe<EnumDocumentDegreeStatusWithAggregatesFilter>;
  validationAttempts?: InputMaybe<IntWithAggregatesFilter>;
  visualRepresentationCreationType?: InputMaybe<EnumVisualRepresentationCreationTypeWithAggregatesFilter>;
  visualRepresentationFileSize?: InputMaybe<IntWithAggregatesFilter>;
  visualRepresentationPath?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type DocumentDegreeSearchView = {
  __typename?: 'DocumentDegreeSearchView';
  DocumentDegree: DocumentDegree;
  documentBaseId: Scalars['String']['output'];
  normalizedSearchCPF: Scalars['String']['output'];
  normalizedSearchCourse: Scalars['String']['output'];
  normalizedSearchEmecCode: Scalars['String']['output'];
  normalizedSearchStudentName: Scalars['String']['output'];
};

export type DocumentDegreeSearchViewCountOrderByAggregateInput = {
  documentBaseId?: InputMaybe<SortOrder>;
  normalizedSearchCPF?: InputMaybe<SortOrder>;
  normalizedSearchCourse?: InputMaybe<SortOrder>;
  normalizedSearchEmecCode?: InputMaybe<SortOrder>;
  normalizedSearchStudentName?: InputMaybe<SortOrder>;
};

export type DocumentDegreeSearchViewCreateInput = {
  DocumentDegree: DocumentDegreeCreateNestedOneWithoutDocumentDegreeSearchViewInput;
  normalizedSearchCPF: Scalars['String']['input'];
  normalizedSearchCourse: Scalars['String']['input'];
  normalizedSearchEmecCode: Scalars['String']['input'];
  normalizedSearchStudentName: Scalars['String']['input'];
};

export type DocumentDegreeSearchViewCreateManyInput = {
  documentBaseId: Scalars['String']['input'];
  normalizedSearchCPF: Scalars['String']['input'];
  normalizedSearchCourse: Scalars['String']['input'];
  normalizedSearchEmecCode: Scalars['String']['input'];
  normalizedSearchStudentName: Scalars['String']['input'];
};

export type DocumentDegreeSearchViewCreateNestedOneWithoutDocumentDegreeInput = {
  connect?: InputMaybe<DocumentDegreeSearchViewWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentDegreeSearchViewCreateOrConnectWithoutDocumentDegreeInput>;
  create?: InputMaybe<DocumentDegreeSearchViewCreateWithoutDocumentDegreeInput>;
};

export type DocumentDegreeSearchViewCreateOrConnectWithoutDocumentDegreeInput = {
  create: DocumentDegreeSearchViewCreateWithoutDocumentDegreeInput;
  where: DocumentDegreeSearchViewWhereUniqueInput;
};

export type DocumentDegreeSearchViewCreateWithoutDocumentDegreeInput = {
  normalizedSearchCPF: Scalars['String']['input'];
  normalizedSearchCourse: Scalars['String']['input'];
  normalizedSearchEmecCode: Scalars['String']['input'];
  normalizedSearchStudentName: Scalars['String']['input'];
};

export type DocumentDegreeSearchViewMaxOrderByAggregateInput = {
  documentBaseId?: InputMaybe<SortOrder>;
  normalizedSearchCPF?: InputMaybe<SortOrder>;
  normalizedSearchCourse?: InputMaybe<SortOrder>;
  normalizedSearchEmecCode?: InputMaybe<SortOrder>;
  normalizedSearchStudentName?: InputMaybe<SortOrder>;
};

export type DocumentDegreeSearchViewMinOrderByAggregateInput = {
  documentBaseId?: InputMaybe<SortOrder>;
  normalizedSearchCPF?: InputMaybe<SortOrder>;
  normalizedSearchCourse?: InputMaybe<SortOrder>;
  normalizedSearchEmecCode?: InputMaybe<SortOrder>;
  normalizedSearchStudentName?: InputMaybe<SortOrder>;
};

export type DocumentDegreeSearchViewNullableRelationFilter = {
  is?: InputMaybe<DocumentDegreeSearchViewWhereInput>;
  isNot?: InputMaybe<DocumentDegreeSearchViewWhereInput>;
};

export type DocumentDegreeSearchViewOrderByWithAggregationInput = {
  _count?: InputMaybe<DocumentDegreeSearchViewCountOrderByAggregateInput>;
  _max?: InputMaybe<DocumentDegreeSearchViewMaxOrderByAggregateInput>;
  _min?: InputMaybe<DocumentDegreeSearchViewMinOrderByAggregateInput>;
  documentBaseId?: InputMaybe<SortOrder>;
  normalizedSearchCPF?: InputMaybe<SortOrder>;
  normalizedSearchCourse?: InputMaybe<SortOrder>;
  normalizedSearchEmecCode?: InputMaybe<SortOrder>;
  normalizedSearchStudentName?: InputMaybe<SortOrder>;
};

export type DocumentDegreeSearchViewOrderByWithRelationInput = {
  DocumentDegree?: InputMaybe<DocumentDegreeOrderByWithRelationInput>;
  documentBaseId?: InputMaybe<SortOrder>;
  normalizedSearchCPF?: InputMaybe<SortOrder>;
  normalizedSearchCourse?: InputMaybe<SortOrder>;
  normalizedSearchEmecCode?: InputMaybe<SortOrder>;
  normalizedSearchStudentName?: InputMaybe<SortOrder>;
};

export enum DocumentDegreeSearchViewScalarFieldEnum {
  DocumentBaseId = 'documentBaseId',
  NormalizedSearchCpf = 'normalizedSearchCPF',
  NormalizedSearchCourse = 'normalizedSearchCourse',
  NormalizedSearchEmecCode = 'normalizedSearchEmecCode',
  NormalizedSearchStudentName = 'normalizedSearchStudentName'
}

export type DocumentDegreeSearchViewScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DocumentDegreeSearchViewScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DocumentDegreeSearchViewScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DocumentDegreeSearchViewScalarWhereWithAggregatesInput>>;
  documentBaseId?: InputMaybe<StringWithAggregatesFilter>;
  normalizedSearchCPF?: InputMaybe<StringWithAggregatesFilter>;
  normalizedSearchCourse?: InputMaybe<StringWithAggregatesFilter>;
  normalizedSearchEmecCode?: InputMaybe<StringWithAggregatesFilter>;
  normalizedSearchStudentName?: InputMaybe<StringWithAggregatesFilter>;
};

export type DocumentDegreeSearchViewUpdateInput = {
  DocumentDegree?: InputMaybe<DocumentDegreeUpdateOneRequiredWithoutDocumentDegreeSearchViewNestedInput>;
  normalizedSearchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalizedSearchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalizedSearchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalizedSearchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DocumentDegreeSearchViewUpdateManyMutationInput = {
  normalizedSearchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalizedSearchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalizedSearchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalizedSearchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DocumentDegreeSearchViewUpdateOneWithoutDocumentDegreeNestedInput = {
  connect?: InputMaybe<DocumentDegreeSearchViewWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentDegreeSearchViewCreateOrConnectWithoutDocumentDegreeInput>;
  create?: InputMaybe<DocumentDegreeSearchViewCreateWithoutDocumentDegreeInput>;
  delete?: InputMaybe<DocumentDegreeSearchViewWhereInput>;
  disconnect?: InputMaybe<DocumentDegreeSearchViewWhereInput>;
  update?: InputMaybe<DocumentDegreeSearchViewUpdateToOneWithWhereWithoutDocumentDegreeInput>;
  upsert?: InputMaybe<DocumentDegreeSearchViewUpsertWithoutDocumentDegreeInput>;
};

export type DocumentDegreeSearchViewUpdateToOneWithWhereWithoutDocumentDegreeInput = {
  data: DocumentDegreeSearchViewUpdateWithoutDocumentDegreeInput;
  where?: InputMaybe<DocumentDegreeSearchViewWhereInput>;
};

export type DocumentDegreeSearchViewUpdateWithoutDocumentDegreeInput = {
  normalizedSearchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalizedSearchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalizedSearchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalizedSearchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DocumentDegreeSearchViewUpsertWithoutDocumentDegreeInput = {
  create: DocumentDegreeSearchViewCreateWithoutDocumentDegreeInput;
  update: DocumentDegreeSearchViewUpdateWithoutDocumentDegreeInput;
  where?: InputMaybe<DocumentDegreeSearchViewWhereInput>;
};

export type DocumentDegreeSearchViewWhereInput = {
  AND?: InputMaybe<Array<DocumentDegreeSearchViewWhereInput>>;
  DocumentDegree?: InputMaybe<DocumentDegreeWhereInput>;
  NOT?: InputMaybe<Array<DocumentDegreeSearchViewWhereInput>>;
  OR?: InputMaybe<Array<DocumentDegreeSearchViewWhereInput>>;
  documentBaseId?: InputMaybe<StringFilter>;
  normalizedSearchCPF?: InputMaybe<StringFilter>;
  normalizedSearchCourse?: InputMaybe<StringFilter>;
  normalizedSearchEmecCode?: InputMaybe<StringFilter>;
  normalizedSearchStudentName?: InputMaybe<StringFilter>;
};

export type DocumentDegreeSearchViewWhereUniqueInput = {
  AND?: InputMaybe<Array<DocumentDegreeSearchViewWhereInput>>;
  DocumentDegree?: InputMaybe<DocumentDegreeWhereInput>;
  NOT?: InputMaybe<Array<DocumentDegreeSearchViewWhereInput>>;
  OR?: InputMaybe<Array<DocumentDegreeSearchViewWhereInput>>;
  documentBaseId?: InputMaybe<Scalars['String']['input']>;
  normalizedSearchCPF?: InputMaybe<StringFilter>;
  normalizedSearchCourse?: InputMaybe<StringFilter>;
  normalizedSearchEmecCode?: InputMaybe<StringFilter>;
  normalizedSearchStudentName?: InputMaybe<StringFilter>;
};

export enum DocumentDegreeStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  FastValidation = 'FAST_VALIDATION',
  Imported = 'IMPORTED',
  InCorrection = 'IN_CORRECTION',
  InSignature = 'IN_SIGNATURE',
  Issued = 'ISSUED',
  PendingReview = 'PENDING_REVIEW',
  Revoked = 'REVOKED',
  ValidationImpossibleToValidate = 'VALIDATION_IMPOSSIBLE_TO_VALIDATE',
  ValidationIndeterminated = 'VALIDATION_INDETERMINATED',
  ValidationInvalid = 'VALIDATION_INVALID',
  ValidationInValidation = 'VALIDATION_IN_VALIDATION'
}

export type DocumentDegreeSumOrderByAggregateInput = {
  validationAttempts?: InputMaybe<SortOrder>;
  visualRepresentationFileSize?: InputMaybe<SortOrder>;
};

export type DocumentDegreeUpdateInput = {
  DocumentAuditFileIssuers?: InputMaybe<DocumentAuditFileIssuerDegreeItemUpdateManyWithoutDocumentDegreeNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentDegreeNestedInput>;
  DocumentDegreeSearchView?: InputMaybe<DocumentDegreeSearchViewUpdateOneWithoutDocumentDegreeNestedInput>;
  ParentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationUpdateOneWithoutLinkedDegreeListNestedInput>;
  isSentToGraduate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  searchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchIssueDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  searchRegistrationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  searchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentDegreeStatusFieldUpdateOperationsInput>;
  validationAttempts?: InputMaybe<IntFieldUpdateOperationsInput>;
  visualRepresentationCreationType?: InputMaybe<EnumVisualRepresentationCreationTypeFieldUpdateOperationsInput>;
  visualRepresentationFileSize?: InputMaybe<IntFieldUpdateOperationsInput>;
  visualRepresentationPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DocumentDegreeUpdateManyMutationInput = {
  isSentToGraduate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  searchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchIssueDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  searchRegistrationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  searchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentDegreeStatusFieldUpdateOperationsInput>;
  validationAttempts?: InputMaybe<IntFieldUpdateOperationsInput>;
  visualRepresentationCreationType?: InputMaybe<EnumVisualRepresentationCreationTypeFieldUpdateOperationsInput>;
  visualRepresentationFileSize?: InputMaybe<IntFieldUpdateOperationsInput>;
  visualRepresentationPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DocumentDegreeUpdateManyWithWhereWithoutParentAcademicDocumentationInput = {
  data: DocumentDegreeUpdateManyMutationInput;
  where: DocumentDegreeScalarWhereInput;
};

export type DocumentDegreeUpdateManyWithoutParentAcademicDocumentationNestedInput = {
  connect?: InputMaybe<Array<DocumentDegreeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentDegreeCreateOrConnectWithoutParentAcademicDocumentationInput>>;
  create?: InputMaybe<Array<DocumentDegreeCreateWithoutParentAcademicDocumentationInput>>;
  createMany?: InputMaybe<DocumentDegreeCreateManyParentAcademicDocumentationInputEnvelope>;
  delete?: InputMaybe<Array<DocumentDegreeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentDegreeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentDegreeWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentDegreeWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentDegreeUpdateWithWhereUniqueWithoutParentAcademicDocumentationInput>>;
  updateMany?: InputMaybe<Array<DocumentDegreeUpdateManyWithWhereWithoutParentAcademicDocumentationInput>>;
  upsert?: InputMaybe<Array<DocumentDegreeUpsertWithWhereUniqueWithoutParentAcademicDocumentationInput>>;
};

export type DocumentDegreeUpdateOneRequiredWithoutDocumentAuditFileIssuersNestedInput = {
  connect?: InputMaybe<DocumentDegreeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentDegreeCreateOrConnectWithoutDocumentAuditFileIssuersInput>;
  create?: InputMaybe<DocumentDegreeCreateWithoutDocumentAuditFileIssuersInput>;
  update?: InputMaybe<DocumentDegreeUpdateToOneWithWhereWithoutDocumentAuditFileIssuersInput>;
  upsert?: InputMaybe<DocumentDegreeUpsertWithoutDocumentAuditFileIssuersInput>;
};

export type DocumentDegreeUpdateOneRequiredWithoutDocumentDegreeSearchViewNestedInput = {
  connect?: InputMaybe<DocumentDegreeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentDegreeCreateOrConnectWithoutDocumentDegreeSearchViewInput>;
  create?: InputMaybe<DocumentDegreeCreateWithoutDocumentDegreeSearchViewInput>;
  update?: InputMaybe<DocumentDegreeUpdateToOneWithWhereWithoutDocumentDegreeSearchViewInput>;
  upsert?: InputMaybe<DocumentDegreeUpsertWithoutDocumentDegreeSearchViewInput>;
};

export type DocumentDegreeUpdateOneWithoutDocumentBaseNestedInput = {
  connect?: InputMaybe<DocumentDegreeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentDegreeCreateOrConnectWithoutDocumentBaseInput>;
  create?: InputMaybe<DocumentDegreeCreateWithoutDocumentBaseInput>;
  delete?: InputMaybe<DocumentDegreeWhereInput>;
  disconnect?: InputMaybe<DocumentDegreeWhereInput>;
  update?: InputMaybe<DocumentDegreeUpdateToOneWithWhereWithoutDocumentBaseInput>;
  upsert?: InputMaybe<DocumentDegreeUpsertWithoutDocumentBaseInput>;
};

export type DocumentDegreeUpdateToOneWithWhereWithoutDocumentAuditFileIssuersInput = {
  data: DocumentDegreeUpdateWithoutDocumentAuditFileIssuersInput;
  where?: InputMaybe<DocumentDegreeWhereInput>;
};

export type DocumentDegreeUpdateToOneWithWhereWithoutDocumentBaseInput = {
  data: DocumentDegreeUpdateWithoutDocumentBaseInput;
  where?: InputMaybe<DocumentDegreeWhereInput>;
};

export type DocumentDegreeUpdateToOneWithWhereWithoutDocumentDegreeSearchViewInput = {
  data: DocumentDegreeUpdateWithoutDocumentDegreeSearchViewInput;
  where?: InputMaybe<DocumentDegreeWhereInput>;
};

export type DocumentDegreeUpdateWithWhereUniqueWithoutParentAcademicDocumentationInput = {
  data: DocumentDegreeUpdateWithoutParentAcademicDocumentationInput;
  where: DocumentDegreeWhereUniqueInput;
};

export type DocumentDegreeUpdateWithoutDocumentAuditFileIssuersInput = {
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentDegreeNestedInput>;
  DocumentDegreeSearchView?: InputMaybe<DocumentDegreeSearchViewUpdateOneWithoutDocumentDegreeNestedInput>;
  ParentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationUpdateOneWithoutLinkedDegreeListNestedInput>;
  isSentToGraduate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  searchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchIssueDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  searchRegistrationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  searchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentDegreeStatusFieldUpdateOperationsInput>;
  validationAttempts?: InputMaybe<IntFieldUpdateOperationsInput>;
  visualRepresentationCreationType?: InputMaybe<EnumVisualRepresentationCreationTypeFieldUpdateOperationsInput>;
  visualRepresentationFileSize?: InputMaybe<IntFieldUpdateOperationsInput>;
  visualRepresentationPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DocumentDegreeUpdateWithoutDocumentBaseInput = {
  DocumentAuditFileIssuers?: InputMaybe<DocumentAuditFileIssuerDegreeItemUpdateManyWithoutDocumentDegreeNestedInput>;
  DocumentDegreeSearchView?: InputMaybe<DocumentDegreeSearchViewUpdateOneWithoutDocumentDegreeNestedInput>;
  ParentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationUpdateOneWithoutLinkedDegreeListNestedInput>;
  isSentToGraduate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  searchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchIssueDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  searchRegistrationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  searchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentDegreeStatusFieldUpdateOperationsInput>;
  validationAttempts?: InputMaybe<IntFieldUpdateOperationsInput>;
  visualRepresentationCreationType?: InputMaybe<EnumVisualRepresentationCreationTypeFieldUpdateOperationsInput>;
  visualRepresentationFileSize?: InputMaybe<IntFieldUpdateOperationsInput>;
  visualRepresentationPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DocumentDegreeUpdateWithoutDocumentDegreeSearchViewInput = {
  DocumentAuditFileIssuers?: InputMaybe<DocumentAuditFileIssuerDegreeItemUpdateManyWithoutDocumentDegreeNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentDegreeNestedInput>;
  ParentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationUpdateOneWithoutLinkedDegreeListNestedInput>;
  isSentToGraduate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  searchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchIssueDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  searchRegistrationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  searchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentDegreeStatusFieldUpdateOperationsInput>;
  validationAttempts?: InputMaybe<IntFieldUpdateOperationsInput>;
  visualRepresentationCreationType?: InputMaybe<EnumVisualRepresentationCreationTypeFieldUpdateOperationsInput>;
  visualRepresentationFileSize?: InputMaybe<IntFieldUpdateOperationsInput>;
  visualRepresentationPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DocumentDegreeUpdateWithoutParentAcademicDocumentationInput = {
  DocumentAuditFileIssuers?: InputMaybe<DocumentAuditFileIssuerDegreeItemUpdateManyWithoutDocumentDegreeNestedInput>;
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentDegreeNestedInput>;
  DocumentDegreeSearchView?: InputMaybe<DocumentDegreeSearchViewUpdateOneWithoutDocumentDegreeNestedInput>;
  isSentToGraduate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  searchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchIssueDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  searchRegistrationDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  searchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentDegreeStatusFieldUpdateOperationsInput>;
  validationAttempts?: InputMaybe<IntFieldUpdateOperationsInput>;
  visualRepresentationCreationType?: InputMaybe<EnumVisualRepresentationCreationTypeFieldUpdateOperationsInput>;
  visualRepresentationFileSize?: InputMaybe<IntFieldUpdateOperationsInput>;
  visualRepresentationPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DocumentDegreeUpsertWithWhereUniqueWithoutParentAcademicDocumentationInput = {
  create: DocumentDegreeCreateWithoutParentAcademicDocumentationInput;
  update: DocumentDegreeUpdateWithoutParentAcademicDocumentationInput;
  where: DocumentDegreeWhereUniqueInput;
};

export type DocumentDegreeUpsertWithoutDocumentAuditFileIssuersInput = {
  create: DocumentDegreeCreateWithoutDocumentAuditFileIssuersInput;
  update: DocumentDegreeUpdateWithoutDocumentAuditFileIssuersInput;
  where?: InputMaybe<DocumentDegreeWhereInput>;
};

export type DocumentDegreeUpsertWithoutDocumentBaseInput = {
  create: DocumentDegreeCreateWithoutDocumentBaseInput;
  update: DocumentDegreeUpdateWithoutDocumentBaseInput;
  where?: InputMaybe<DocumentDegreeWhereInput>;
};

export type DocumentDegreeUpsertWithoutDocumentDegreeSearchViewInput = {
  create: DocumentDegreeCreateWithoutDocumentDegreeSearchViewInput;
  update: DocumentDegreeUpdateWithoutDocumentDegreeSearchViewInput;
  where?: InputMaybe<DocumentDegreeWhereInput>;
};

export type DocumentDegreeWhereInput = {
  AND?: InputMaybe<Array<DocumentDegreeWhereInput>>;
  DocumentAuditFileIssuers?: InputMaybe<DocumentAuditFileIssuerDegreeItemListRelationFilter>;
  DocumentBase?: InputMaybe<DocumentBaseWhereInput>;
  DocumentDegreeSearchView?: InputMaybe<DocumentDegreeSearchViewWhereInput>;
  NOT?: InputMaybe<Array<DocumentDegreeWhereInput>>;
  OR?: InputMaybe<Array<DocumentDegreeWhereInput>>;
  ParentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
  documentBaseId?: InputMaybe<StringFilter>;
  isSentToGraduate?: InputMaybe<BoolFilter>;
  parentAcademicDocumentationId?: InputMaybe<StringNullableFilter>;
  searchCPF?: InputMaybe<StringFilter>;
  searchCourse?: InputMaybe<StringFilter>;
  searchEmecCode?: InputMaybe<StringFilter>;
  searchIssueDate?: InputMaybe<DateTimeNullableFilter>;
  searchRegistrationDate?: InputMaybe<DateTimeNullableFilter>;
  searchStudentName?: InputMaybe<StringFilter>;
  searchValidationCode?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumDocumentDegreeStatusFilter>;
  validationAttempts?: InputMaybe<IntFilter>;
  visualRepresentationCreationType?: InputMaybe<EnumVisualRepresentationCreationTypeFilter>;
  visualRepresentationFileSize?: InputMaybe<IntFilter>;
  visualRepresentationPath?: InputMaybe<StringNullableFilter>;
};

export type DocumentDegreeWhereUniqueInput = {
  AND?: InputMaybe<Array<DocumentDegreeWhereInput>>;
  DocumentAuditFileIssuers?: InputMaybe<DocumentAuditFileIssuerDegreeItemListRelationFilter>;
  DocumentBase?: InputMaybe<DocumentBaseWhereInput>;
  DocumentDegreeSearchView?: InputMaybe<DocumentDegreeSearchViewWhereInput>;
  NOT?: InputMaybe<Array<DocumentDegreeWhereInput>>;
  OR?: InputMaybe<Array<DocumentDegreeWhereInput>>;
  ParentAcademicDocumentation?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
  documentBaseId?: InputMaybe<Scalars['String']['input']>;
  isSentToGraduate?: InputMaybe<BoolFilter>;
  parentAcademicDocumentationId?: InputMaybe<StringNullableFilter>;
  searchCPF?: InputMaybe<StringFilter>;
  searchCourse?: InputMaybe<StringFilter>;
  searchEmecCode?: InputMaybe<StringFilter>;
  searchIssueDate?: InputMaybe<DateTimeNullableFilter>;
  searchRegistrationDate?: InputMaybe<DateTimeNullableFilter>;
  searchStudentName?: InputMaybe<StringFilter>;
  searchValidationCode?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumDocumentDegreeStatusFilter>;
  validationAttempts?: InputMaybe<IntFilter>;
  visualRepresentationCreationType?: InputMaybe<EnumVisualRepresentationCreationTypeFilter>;
  visualRepresentationFileSize?: InputMaybe<IntFilter>;
  visualRepresentationPath?: InputMaybe<StringNullableFilter>;
};

export type DocumentFinalAcademicTranscript = {
  __typename?: 'DocumentFinalAcademicTranscript';
  DocumentBase: DocumentBase;
  DocumentFinalAcademicTranscriptView?: Maybe<DocumentFinalAcademicTranscriptView>;
  ParentDocument?: Maybe<DocumentAcademicDocumentation>;
  documentBaseId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  parentDocumentId?: Maybe<Scalars['String']['output']>;
  searchCPF: Scalars['String']['output'];
  searchCourse: Scalars['String']['output'];
  searchEmecCode: Scalars['String']['output'];
  searchStudentName: Scalars['String']['output'];
  searchValidationCode: Scalars['String']['output'];
  status: DocumentFinalAcademicTranscriptStatus;
};

export type DocumentFinalAcademicTranscriptCountOrderByAggregateInput = {
  documentBaseId?: InputMaybe<SortOrder>;
  parentDocumentId?: InputMaybe<SortOrder>;
  searchCPF?: InputMaybe<SortOrder>;
  searchCourse?: InputMaybe<SortOrder>;
  searchEmecCode?: InputMaybe<SortOrder>;
  searchStudentName?: InputMaybe<SortOrder>;
  searchValidationCode?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type DocumentFinalAcademicTranscriptCreateInput = {
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentFinalAcademicTranscriptInput;
  DocumentFinalAcademicTranscriptView?: InputMaybe<DocumentFinalAcademicTranscriptViewCreateNestedOneWithoutDocumentFinalAcademicTranscriptInput>;
  ParentDocument?: InputMaybe<DocumentAcademicDocumentationCreateNestedOneWithoutChildDocumentsInput>;
  searchCPF: Scalars['String']['input'];
  searchCourse: Scalars['String']['input'];
  searchEmecCode: Scalars['String']['input'];
  searchStudentName: Scalars['String']['input'];
  searchValidationCode: Scalars['String']['input'];
  status: DocumentFinalAcademicTranscriptStatus;
};

export type DocumentFinalAcademicTranscriptCreateManyInput = {
  documentBaseId: Scalars['String']['input'];
  parentDocumentId?: InputMaybe<Scalars['String']['input']>;
  searchCPF: Scalars['String']['input'];
  searchCourse: Scalars['String']['input'];
  searchEmecCode: Scalars['String']['input'];
  searchStudentName: Scalars['String']['input'];
  searchValidationCode: Scalars['String']['input'];
  status: DocumentFinalAcademicTranscriptStatus;
};

export type DocumentFinalAcademicTranscriptCreateManyParentDocumentInput = {
  documentBaseId: Scalars['String']['input'];
  searchCPF: Scalars['String']['input'];
  searchCourse: Scalars['String']['input'];
  searchEmecCode: Scalars['String']['input'];
  searchStudentName: Scalars['String']['input'];
  searchValidationCode: Scalars['String']['input'];
  status: DocumentFinalAcademicTranscriptStatus;
};

export type DocumentFinalAcademicTranscriptCreateManyParentDocumentInputEnvelope = {
  data: Array<DocumentFinalAcademicTranscriptCreateManyParentDocumentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentFinalAcademicTranscriptCreateNestedManyWithoutParentDocumentInput = {
  connect?: InputMaybe<Array<DocumentFinalAcademicTranscriptWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentFinalAcademicTranscriptCreateOrConnectWithoutParentDocumentInput>>;
  create?: InputMaybe<Array<DocumentFinalAcademicTranscriptCreateWithoutParentDocumentInput>>;
  createMany?: InputMaybe<DocumentFinalAcademicTranscriptCreateManyParentDocumentInputEnvelope>;
};

export type DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentBaseInput = {
  connect?: InputMaybe<DocumentFinalAcademicTranscriptWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentFinalAcademicTranscriptCreateOrConnectWithoutDocumentBaseInput>;
  create?: InputMaybe<DocumentFinalAcademicTranscriptCreateWithoutDocumentBaseInput>;
};

export type DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentFinalAcademicTranscriptViewInput = {
  connect?: InputMaybe<DocumentFinalAcademicTranscriptWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentFinalAcademicTranscriptCreateOrConnectWithoutDocumentFinalAcademicTranscriptViewInput>;
  create?: InputMaybe<DocumentFinalAcademicTranscriptCreateWithoutDocumentFinalAcademicTranscriptViewInput>;
};

export type DocumentFinalAcademicTranscriptCreateOrConnectWithoutDocumentBaseInput = {
  create: DocumentFinalAcademicTranscriptCreateWithoutDocumentBaseInput;
  where: DocumentFinalAcademicTranscriptWhereUniqueInput;
};

export type DocumentFinalAcademicTranscriptCreateOrConnectWithoutDocumentFinalAcademicTranscriptViewInput = {
  create: DocumentFinalAcademicTranscriptCreateWithoutDocumentFinalAcademicTranscriptViewInput;
  where: DocumentFinalAcademicTranscriptWhereUniqueInput;
};

export type DocumentFinalAcademicTranscriptCreateOrConnectWithoutParentDocumentInput = {
  create: DocumentFinalAcademicTranscriptCreateWithoutParentDocumentInput;
  where: DocumentFinalAcademicTranscriptWhereUniqueInput;
};

export type DocumentFinalAcademicTranscriptCreateWithoutDocumentBaseInput = {
  DocumentFinalAcademicTranscriptView?: InputMaybe<DocumentFinalAcademicTranscriptViewCreateNestedOneWithoutDocumentFinalAcademicTranscriptInput>;
  ParentDocument?: InputMaybe<DocumentAcademicDocumentationCreateNestedOneWithoutChildDocumentsInput>;
  searchCPF: Scalars['String']['input'];
  searchCourse: Scalars['String']['input'];
  searchEmecCode: Scalars['String']['input'];
  searchStudentName: Scalars['String']['input'];
  searchValidationCode: Scalars['String']['input'];
  status: DocumentFinalAcademicTranscriptStatus;
};

export type DocumentFinalAcademicTranscriptCreateWithoutDocumentFinalAcademicTranscriptViewInput = {
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentFinalAcademicTranscriptInput;
  ParentDocument?: InputMaybe<DocumentAcademicDocumentationCreateNestedOneWithoutChildDocumentsInput>;
  searchCPF: Scalars['String']['input'];
  searchCourse: Scalars['String']['input'];
  searchEmecCode: Scalars['String']['input'];
  searchStudentName: Scalars['String']['input'];
  searchValidationCode: Scalars['String']['input'];
  status: DocumentFinalAcademicTranscriptStatus;
};

export type DocumentFinalAcademicTranscriptCreateWithoutParentDocumentInput = {
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentFinalAcademicTranscriptInput;
  DocumentFinalAcademicTranscriptView?: InputMaybe<DocumentFinalAcademicTranscriptViewCreateNestedOneWithoutDocumentFinalAcademicTranscriptInput>;
  searchCPF: Scalars['String']['input'];
  searchCourse: Scalars['String']['input'];
  searchEmecCode: Scalars['String']['input'];
  searchStudentName: Scalars['String']['input'];
  searchValidationCode: Scalars['String']['input'];
  status: DocumentFinalAcademicTranscriptStatus;
};

export type DocumentFinalAcademicTranscriptListRelationFilter = {
  every?: InputMaybe<DocumentFinalAcademicTranscriptWhereInput>;
  none?: InputMaybe<DocumentFinalAcademicTranscriptWhereInput>;
  some?: InputMaybe<DocumentFinalAcademicTranscriptWhereInput>;
};

export type DocumentFinalAcademicTranscriptMaxOrderByAggregateInput = {
  documentBaseId?: InputMaybe<SortOrder>;
  parentDocumentId?: InputMaybe<SortOrder>;
  searchCPF?: InputMaybe<SortOrder>;
  searchCourse?: InputMaybe<SortOrder>;
  searchEmecCode?: InputMaybe<SortOrder>;
  searchStudentName?: InputMaybe<SortOrder>;
  searchValidationCode?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type DocumentFinalAcademicTranscriptMinOrderByAggregateInput = {
  documentBaseId?: InputMaybe<SortOrder>;
  parentDocumentId?: InputMaybe<SortOrder>;
  searchCPF?: InputMaybe<SortOrder>;
  searchCourse?: InputMaybe<SortOrder>;
  searchEmecCode?: InputMaybe<SortOrder>;
  searchStudentName?: InputMaybe<SortOrder>;
  searchValidationCode?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type DocumentFinalAcademicTranscriptNullableRelationFilter = {
  is?: InputMaybe<DocumentFinalAcademicTranscriptWhereInput>;
  isNot?: InputMaybe<DocumentFinalAcademicTranscriptWhereInput>;
};

export type DocumentFinalAcademicTranscriptOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DocumentFinalAcademicTranscriptOrderByWithAggregationInput = {
  _count?: InputMaybe<DocumentFinalAcademicTranscriptCountOrderByAggregateInput>;
  _max?: InputMaybe<DocumentFinalAcademicTranscriptMaxOrderByAggregateInput>;
  _min?: InputMaybe<DocumentFinalAcademicTranscriptMinOrderByAggregateInput>;
  documentBaseId?: InputMaybe<SortOrder>;
  parentDocumentId?: InputMaybe<SortOrder>;
  searchCPF?: InputMaybe<SortOrder>;
  searchCourse?: InputMaybe<SortOrder>;
  searchEmecCode?: InputMaybe<SortOrder>;
  searchStudentName?: InputMaybe<SortOrder>;
  searchValidationCode?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type DocumentFinalAcademicTranscriptOrderByWithRelationInput = {
  DocumentBase?: InputMaybe<DocumentBaseOrderByWithRelationInput>;
  DocumentFinalAcademicTranscriptView?: InputMaybe<DocumentFinalAcademicTranscriptViewOrderByWithRelationInput>;
  ParentDocument?: InputMaybe<DocumentAcademicDocumentationOrderByWithRelationInput>;
  documentBaseId?: InputMaybe<SortOrder>;
  parentDocumentId?: InputMaybe<SortOrder>;
  searchCPF?: InputMaybe<SortOrder>;
  searchCourse?: InputMaybe<SortOrder>;
  searchEmecCode?: InputMaybe<SortOrder>;
  searchStudentName?: InputMaybe<SortOrder>;
  searchValidationCode?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type DocumentFinalAcademicTranscriptRelationFilter = {
  is?: InputMaybe<DocumentFinalAcademicTranscriptWhereInput>;
  isNot?: InputMaybe<DocumentFinalAcademicTranscriptWhereInput>;
};

export enum DocumentFinalAcademicTranscriptScalarFieldEnum {
  DocumentBaseId = 'documentBaseId',
  ParentDocumentId = 'parentDocumentId',
  SearchCpf = 'searchCPF',
  SearchCourse = 'searchCourse',
  SearchEmecCode = 'searchEmecCode',
  SearchStudentName = 'searchStudentName',
  SearchValidationCode = 'searchValidationCode',
  Status = 'status'
}

export type DocumentFinalAcademicTranscriptScalarWhereInput = {
  AND?: InputMaybe<Array<DocumentFinalAcademicTranscriptScalarWhereInput>>;
  NOT?: InputMaybe<Array<DocumentFinalAcademicTranscriptScalarWhereInput>>;
  OR?: InputMaybe<Array<DocumentFinalAcademicTranscriptScalarWhereInput>>;
  documentBaseId?: InputMaybe<StringFilter>;
  parentDocumentId?: InputMaybe<StringNullableFilter>;
  searchCPF?: InputMaybe<StringFilter>;
  searchCourse?: InputMaybe<StringFilter>;
  searchEmecCode?: InputMaybe<StringFilter>;
  searchStudentName?: InputMaybe<StringFilter>;
  searchValidationCode?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumDocumentFinalAcademicTranscriptStatusFilter>;
};

export type DocumentFinalAcademicTranscriptScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DocumentFinalAcademicTranscriptScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DocumentFinalAcademicTranscriptScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DocumentFinalAcademicTranscriptScalarWhereWithAggregatesInput>>;
  documentBaseId?: InputMaybe<StringWithAggregatesFilter>;
  parentDocumentId?: InputMaybe<StringNullableWithAggregatesFilter>;
  searchCPF?: InputMaybe<StringWithAggregatesFilter>;
  searchCourse?: InputMaybe<StringWithAggregatesFilter>;
  searchEmecCode?: InputMaybe<StringWithAggregatesFilter>;
  searchStudentName?: InputMaybe<StringWithAggregatesFilter>;
  searchValidationCode?: InputMaybe<StringWithAggregatesFilter>;
  status?: InputMaybe<EnumDocumentFinalAcademicTranscriptStatusWithAggregatesFilter>;
};

export enum DocumentFinalAcademicTranscriptStatus {
  Approved = 'APPROVED',
  Invalid = 'INVALID',
  InSignature = 'IN_SIGNATURE',
  Issued = 'ISSUED',
  Revoked = 'REVOKED'
}

export type DocumentFinalAcademicTranscriptUpdateInput = {
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentFinalAcademicTranscriptNestedInput>;
  DocumentFinalAcademicTranscriptView?: InputMaybe<DocumentFinalAcademicTranscriptViewUpdateOneWithoutDocumentFinalAcademicTranscriptNestedInput>;
  ParentDocument?: InputMaybe<DocumentAcademicDocumentationUpdateOneWithoutChildDocumentsNestedInput>;
  searchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentFinalAcademicTranscriptStatusFieldUpdateOperationsInput>;
};

export type DocumentFinalAcademicTranscriptUpdateManyMutationInput = {
  searchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentFinalAcademicTranscriptStatusFieldUpdateOperationsInput>;
};

export type DocumentFinalAcademicTranscriptUpdateManyWithWhereWithoutParentDocumentInput = {
  data: DocumentFinalAcademicTranscriptUpdateManyMutationInput;
  where: DocumentFinalAcademicTranscriptScalarWhereInput;
};

export type DocumentFinalAcademicTranscriptUpdateManyWithoutParentDocumentNestedInput = {
  connect?: InputMaybe<Array<DocumentFinalAcademicTranscriptWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentFinalAcademicTranscriptCreateOrConnectWithoutParentDocumentInput>>;
  create?: InputMaybe<Array<DocumentFinalAcademicTranscriptCreateWithoutParentDocumentInput>>;
  createMany?: InputMaybe<DocumentFinalAcademicTranscriptCreateManyParentDocumentInputEnvelope>;
  delete?: InputMaybe<Array<DocumentFinalAcademicTranscriptWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentFinalAcademicTranscriptScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentFinalAcademicTranscriptWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentFinalAcademicTranscriptWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentFinalAcademicTranscriptUpdateWithWhereUniqueWithoutParentDocumentInput>>;
  updateMany?: InputMaybe<Array<DocumentFinalAcademicTranscriptUpdateManyWithWhereWithoutParentDocumentInput>>;
  upsert?: InputMaybe<Array<DocumentFinalAcademicTranscriptUpsertWithWhereUniqueWithoutParentDocumentInput>>;
};

export type DocumentFinalAcademicTranscriptUpdateOneRequiredWithoutDocumentFinalAcademicTranscriptViewNestedInput = {
  connect?: InputMaybe<DocumentFinalAcademicTranscriptWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentFinalAcademicTranscriptCreateOrConnectWithoutDocumentFinalAcademicTranscriptViewInput>;
  create?: InputMaybe<DocumentFinalAcademicTranscriptCreateWithoutDocumentFinalAcademicTranscriptViewInput>;
  update?: InputMaybe<DocumentFinalAcademicTranscriptUpdateToOneWithWhereWithoutDocumentFinalAcademicTranscriptViewInput>;
  upsert?: InputMaybe<DocumentFinalAcademicTranscriptUpsertWithoutDocumentFinalAcademicTranscriptViewInput>;
};

export type DocumentFinalAcademicTranscriptUpdateOneWithoutDocumentBaseNestedInput = {
  connect?: InputMaybe<DocumentFinalAcademicTranscriptWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentFinalAcademicTranscriptCreateOrConnectWithoutDocumentBaseInput>;
  create?: InputMaybe<DocumentFinalAcademicTranscriptCreateWithoutDocumentBaseInput>;
  delete?: InputMaybe<DocumentFinalAcademicTranscriptWhereInput>;
  disconnect?: InputMaybe<DocumentFinalAcademicTranscriptWhereInput>;
  update?: InputMaybe<DocumentFinalAcademicTranscriptUpdateToOneWithWhereWithoutDocumentBaseInput>;
  upsert?: InputMaybe<DocumentFinalAcademicTranscriptUpsertWithoutDocumentBaseInput>;
};

export type DocumentFinalAcademicTranscriptUpdateToOneWithWhereWithoutDocumentBaseInput = {
  data: DocumentFinalAcademicTranscriptUpdateWithoutDocumentBaseInput;
  where?: InputMaybe<DocumentFinalAcademicTranscriptWhereInput>;
};

export type DocumentFinalAcademicTranscriptUpdateToOneWithWhereWithoutDocumentFinalAcademicTranscriptViewInput = {
  data: DocumentFinalAcademicTranscriptUpdateWithoutDocumentFinalAcademicTranscriptViewInput;
  where?: InputMaybe<DocumentFinalAcademicTranscriptWhereInput>;
};

export type DocumentFinalAcademicTranscriptUpdateWithWhereUniqueWithoutParentDocumentInput = {
  data: DocumentFinalAcademicTranscriptUpdateWithoutParentDocumentInput;
  where: DocumentFinalAcademicTranscriptWhereUniqueInput;
};

export type DocumentFinalAcademicTranscriptUpdateWithoutDocumentBaseInput = {
  DocumentFinalAcademicTranscriptView?: InputMaybe<DocumentFinalAcademicTranscriptViewUpdateOneWithoutDocumentFinalAcademicTranscriptNestedInput>;
  ParentDocument?: InputMaybe<DocumentAcademicDocumentationUpdateOneWithoutChildDocumentsNestedInput>;
  searchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentFinalAcademicTranscriptStatusFieldUpdateOperationsInput>;
};

export type DocumentFinalAcademicTranscriptUpdateWithoutDocumentFinalAcademicTranscriptViewInput = {
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentFinalAcademicTranscriptNestedInput>;
  ParentDocument?: InputMaybe<DocumentAcademicDocumentationUpdateOneWithoutChildDocumentsNestedInput>;
  searchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentFinalAcademicTranscriptStatusFieldUpdateOperationsInput>;
};

export type DocumentFinalAcademicTranscriptUpdateWithoutParentDocumentInput = {
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentFinalAcademicTranscriptNestedInput>;
  DocumentFinalAcademicTranscriptView?: InputMaybe<DocumentFinalAcademicTranscriptViewUpdateOneWithoutDocumentFinalAcademicTranscriptNestedInput>;
  searchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentFinalAcademicTranscriptStatusFieldUpdateOperationsInput>;
};

export type DocumentFinalAcademicTranscriptUpsertWithWhereUniqueWithoutParentDocumentInput = {
  create: DocumentFinalAcademicTranscriptCreateWithoutParentDocumentInput;
  update: DocumentFinalAcademicTranscriptUpdateWithoutParentDocumentInput;
  where: DocumentFinalAcademicTranscriptWhereUniqueInput;
};

export type DocumentFinalAcademicTranscriptUpsertWithoutDocumentBaseInput = {
  create: DocumentFinalAcademicTranscriptCreateWithoutDocumentBaseInput;
  update: DocumentFinalAcademicTranscriptUpdateWithoutDocumentBaseInput;
  where?: InputMaybe<DocumentFinalAcademicTranscriptWhereInput>;
};

export type DocumentFinalAcademicTranscriptUpsertWithoutDocumentFinalAcademicTranscriptViewInput = {
  create: DocumentFinalAcademicTranscriptCreateWithoutDocumentFinalAcademicTranscriptViewInput;
  update: DocumentFinalAcademicTranscriptUpdateWithoutDocumentFinalAcademicTranscriptViewInput;
  where?: InputMaybe<DocumentFinalAcademicTranscriptWhereInput>;
};

export type DocumentFinalAcademicTranscriptView = {
  __typename?: 'DocumentFinalAcademicTranscriptView';
  DocumentFinalAcademicTranscript: DocumentFinalAcademicTranscript;
  documentBaseId: Scalars['String']['output'];
  normalizedSearchCPF: Scalars['String']['output'];
  normalizedSearchCourse: Scalars['String']['output'];
  normalizedSearchEmecCode: Scalars['String']['output'];
  normalizedSearchStudentName: Scalars['String']['output'];
};

export type DocumentFinalAcademicTranscriptViewCountOrderByAggregateInput = {
  documentBaseId?: InputMaybe<SortOrder>;
  normalizedSearchCPF?: InputMaybe<SortOrder>;
  normalizedSearchCourse?: InputMaybe<SortOrder>;
  normalizedSearchEmecCode?: InputMaybe<SortOrder>;
  normalizedSearchStudentName?: InputMaybe<SortOrder>;
};

export type DocumentFinalAcademicTranscriptViewCreateInput = {
  DocumentFinalAcademicTranscript: DocumentFinalAcademicTranscriptCreateNestedOneWithoutDocumentFinalAcademicTranscriptViewInput;
  normalizedSearchCPF: Scalars['String']['input'];
  normalizedSearchCourse: Scalars['String']['input'];
  normalizedSearchEmecCode: Scalars['String']['input'];
  normalizedSearchStudentName: Scalars['String']['input'];
};

export type DocumentFinalAcademicTranscriptViewCreateManyInput = {
  documentBaseId: Scalars['String']['input'];
  normalizedSearchCPF: Scalars['String']['input'];
  normalizedSearchCourse: Scalars['String']['input'];
  normalizedSearchEmecCode: Scalars['String']['input'];
  normalizedSearchStudentName: Scalars['String']['input'];
};

export type DocumentFinalAcademicTranscriptViewCreateNestedOneWithoutDocumentFinalAcademicTranscriptInput = {
  connect?: InputMaybe<DocumentFinalAcademicTranscriptViewWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentFinalAcademicTranscriptViewCreateOrConnectWithoutDocumentFinalAcademicTranscriptInput>;
  create?: InputMaybe<DocumentFinalAcademicTranscriptViewCreateWithoutDocumentFinalAcademicTranscriptInput>;
};

export type DocumentFinalAcademicTranscriptViewCreateOrConnectWithoutDocumentFinalAcademicTranscriptInput = {
  create: DocumentFinalAcademicTranscriptViewCreateWithoutDocumentFinalAcademicTranscriptInput;
  where: DocumentFinalAcademicTranscriptViewWhereUniqueInput;
};

export type DocumentFinalAcademicTranscriptViewCreateWithoutDocumentFinalAcademicTranscriptInput = {
  normalizedSearchCPF: Scalars['String']['input'];
  normalizedSearchCourse: Scalars['String']['input'];
  normalizedSearchEmecCode: Scalars['String']['input'];
  normalizedSearchStudentName: Scalars['String']['input'];
};

export type DocumentFinalAcademicTranscriptViewMaxOrderByAggregateInput = {
  documentBaseId?: InputMaybe<SortOrder>;
  normalizedSearchCPF?: InputMaybe<SortOrder>;
  normalizedSearchCourse?: InputMaybe<SortOrder>;
  normalizedSearchEmecCode?: InputMaybe<SortOrder>;
  normalizedSearchStudentName?: InputMaybe<SortOrder>;
};

export type DocumentFinalAcademicTranscriptViewMinOrderByAggregateInput = {
  documentBaseId?: InputMaybe<SortOrder>;
  normalizedSearchCPF?: InputMaybe<SortOrder>;
  normalizedSearchCourse?: InputMaybe<SortOrder>;
  normalizedSearchEmecCode?: InputMaybe<SortOrder>;
  normalizedSearchStudentName?: InputMaybe<SortOrder>;
};

export type DocumentFinalAcademicTranscriptViewNullableRelationFilter = {
  is?: InputMaybe<DocumentFinalAcademicTranscriptViewWhereInput>;
  isNot?: InputMaybe<DocumentFinalAcademicTranscriptViewWhereInput>;
};

export type DocumentFinalAcademicTranscriptViewOrderByWithAggregationInput = {
  _count?: InputMaybe<DocumentFinalAcademicTranscriptViewCountOrderByAggregateInput>;
  _max?: InputMaybe<DocumentFinalAcademicTranscriptViewMaxOrderByAggregateInput>;
  _min?: InputMaybe<DocumentFinalAcademicTranscriptViewMinOrderByAggregateInput>;
  documentBaseId?: InputMaybe<SortOrder>;
  normalizedSearchCPF?: InputMaybe<SortOrder>;
  normalizedSearchCourse?: InputMaybe<SortOrder>;
  normalizedSearchEmecCode?: InputMaybe<SortOrder>;
  normalizedSearchStudentName?: InputMaybe<SortOrder>;
};

export type DocumentFinalAcademicTranscriptViewOrderByWithRelationInput = {
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptOrderByWithRelationInput>;
  documentBaseId?: InputMaybe<SortOrder>;
  normalizedSearchCPF?: InputMaybe<SortOrder>;
  normalizedSearchCourse?: InputMaybe<SortOrder>;
  normalizedSearchEmecCode?: InputMaybe<SortOrder>;
  normalizedSearchStudentName?: InputMaybe<SortOrder>;
};

export enum DocumentFinalAcademicTranscriptViewScalarFieldEnum {
  DocumentBaseId = 'documentBaseId',
  NormalizedSearchCpf = 'normalizedSearchCPF',
  NormalizedSearchCourse = 'normalizedSearchCourse',
  NormalizedSearchEmecCode = 'normalizedSearchEmecCode',
  NormalizedSearchStudentName = 'normalizedSearchStudentName'
}

export type DocumentFinalAcademicTranscriptViewScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DocumentFinalAcademicTranscriptViewScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DocumentFinalAcademicTranscriptViewScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DocumentFinalAcademicTranscriptViewScalarWhereWithAggregatesInput>>;
  documentBaseId?: InputMaybe<StringWithAggregatesFilter>;
  normalizedSearchCPF?: InputMaybe<StringWithAggregatesFilter>;
  normalizedSearchCourse?: InputMaybe<StringWithAggregatesFilter>;
  normalizedSearchEmecCode?: InputMaybe<StringWithAggregatesFilter>;
  normalizedSearchStudentName?: InputMaybe<StringWithAggregatesFilter>;
};

export type DocumentFinalAcademicTranscriptViewUpdateInput = {
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptUpdateOneRequiredWithoutDocumentFinalAcademicTranscriptViewNestedInput>;
  normalizedSearchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalizedSearchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalizedSearchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalizedSearchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DocumentFinalAcademicTranscriptViewUpdateManyMutationInput = {
  normalizedSearchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalizedSearchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalizedSearchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalizedSearchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DocumentFinalAcademicTranscriptViewUpdateOneWithoutDocumentFinalAcademicTranscriptNestedInput = {
  connect?: InputMaybe<DocumentFinalAcademicTranscriptViewWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentFinalAcademicTranscriptViewCreateOrConnectWithoutDocumentFinalAcademicTranscriptInput>;
  create?: InputMaybe<DocumentFinalAcademicTranscriptViewCreateWithoutDocumentFinalAcademicTranscriptInput>;
  delete?: InputMaybe<DocumentFinalAcademicTranscriptViewWhereInput>;
  disconnect?: InputMaybe<DocumentFinalAcademicTranscriptViewWhereInput>;
  update?: InputMaybe<DocumentFinalAcademicTranscriptViewUpdateToOneWithWhereWithoutDocumentFinalAcademicTranscriptInput>;
  upsert?: InputMaybe<DocumentFinalAcademicTranscriptViewUpsertWithoutDocumentFinalAcademicTranscriptInput>;
};

export type DocumentFinalAcademicTranscriptViewUpdateToOneWithWhereWithoutDocumentFinalAcademicTranscriptInput = {
  data: DocumentFinalAcademicTranscriptViewUpdateWithoutDocumentFinalAcademicTranscriptInput;
  where?: InputMaybe<DocumentFinalAcademicTranscriptViewWhereInput>;
};

export type DocumentFinalAcademicTranscriptViewUpdateWithoutDocumentFinalAcademicTranscriptInput = {
  normalizedSearchCPF?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalizedSearchCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalizedSearchEmecCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  normalizedSearchStudentName?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DocumentFinalAcademicTranscriptViewUpsertWithoutDocumentFinalAcademicTranscriptInput = {
  create: DocumentFinalAcademicTranscriptViewCreateWithoutDocumentFinalAcademicTranscriptInput;
  update: DocumentFinalAcademicTranscriptViewUpdateWithoutDocumentFinalAcademicTranscriptInput;
  where?: InputMaybe<DocumentFinalAcademicTranscriptViewWhereInput>;
};

export type DocumentFinalAcademicTranscriptViewWhereInput = {
  AND?: InputMaybe<Array<DocumentFinalAcademicTranscriptViewWhereInput>>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptWhereInput>;
  NOT?: InputMaybe<Array<DocumentFinalAcademicTranscriptViewWhereInput>>;
  OR?: InputMaybe<Array<DocumentFinalAcademicTranscriptViewWhereInput>>;
  documentBaseId?: InputMaybe<StringFilter>;
  normalizedSearchCPF?: InputMaybe<StringFilter>;
  normalizedSearchCourse?: InputMaybe<StringFilter>;
  normalizedSearchEmecCode?: InputMaybe<StringFilter>;
  normalizedSearchStudentName?: InputMaybe<StringFilter>;
};

export type DocumentFinalAcademicTranscriptViewWhereUniqueInput = {
  AND?: InputMaybe<Array<DocumentFinalAcademicTranscriptViewWhereInput>>;
  DocumentFinalAcademicTranscript?: InputMaybe<DocumentFinalAcademicTranscriptWhereInput>;
  NOT?: InputMaybe<Array<DocumentFinalAcademicTranscriptViewWhereInput>>;
  OR?: InputMaybe<Array<DocumentFinalAcademicTranscriptViewWhereInput>>;
  documentBaseId?: InputMaybe<Scalars['String']['input']>;
  normalizedSearchCPF?: InputMaybe<StringFilter>;
  normalizedSearchCourse?: InputMaybe<StringFilter>;
  normalizedSearchEmecCode?: InputMaybe<StringFilter>;
  normalizedSearchStudentName?: InputMaybe<StringFilter>;
};

export type DocumentFinalAcademicTranscriptWhereInput = {
  AND?: InputMaybe<Array<DocumentFinalAcademicTranscriptWhereInput>>;
  DocumentBase?: InputMaybe<DocumentBaseWhereInput>;
  DocumentFinalAcademicTranscriptView?: InputMaybe<DocumentFinalAcademicTranscriptViewWhereInput>;
  NOT?: InputMaybe<Array<DocumentFinalAcademicTranscriptWhereInput>>;
  OR?: InputMaybe<Array<DocumentFinalAcademicTranscriptWhereInput>>;
  ParentDocument?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
  documentBaseId?: InputMaybe<StringFilter>;
  parentDocumentId?: InputMaybe<StringNullableFilter>;
  searchCPF?: InputMaybe<StringFilter>;
  searchCourse?: InputMaybe<StringFilter>;
  searchEmecCode?: InputMaybe<StringFilter>;
  searchStudentName?: InputMaybe<StringFilter>;
  searchValidationCode?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumDocumentFinalAcademicTranscriptStatusFilter>;
};

export type DocumentFinalAcademicTranscriptWhereUniqueInput = {
  AND?: InputMaybe<Array<DocumentFinalAcademicTranscriptWhereInput>>;
  DocumentBase?: InputMaybe<DocumentBaseWhereInput>;
  DocumentFinalAcademicTranscriptView?: InputMaybe<DocumentFinalAcademicTranscriptViewWhereInput>;
  NOT?: InputMaybe<Array<DocumentFinalAcademicTranscriptWhereInput>>;
  OR?: InputMaybe<Array<DocumentFinalAcademicTranscriptWhereInput>>;
  ParentDocument?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
  documentBaseId?: InputMaybe<Scalars['String']['input']>;
  parentDocumentId?: InputMaybe<StringNullableFilter>;
  searchCPF?: InputMaybe<StringFilter>;
  searchCourse?: InputMaybe<StringFilter>;
  searchEmecCode?: InputMaybe<StringFilter>;
  searchStudentName?: InputMaybe<StringFilter>;
  searchValidationCode?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumDocumentFinalAcademicTranscriptStatusFilter>;
};

export type DocumentRenotarization = {
  __typename?: 'DocumentRenotarization';
  DocumentBase: DocumentBase;
  Histories: Array<DocumentRenotarizationHistory>;
  archiveTimestampCertificateExpiration: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  documentBaseId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  signatureId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type DocumentRenotarizationHistoriesArgs = {
  cursor?: InputMaybe<DocumentRenotarizationHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentRenotarizationHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentRenotarizationHistoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentRenotarizationHistoryWhereInput>;
};

export type DocumentRenotarizationAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type DocumentRenotarizationCountOrderByAggregateInput = {
  archiveTimestampCertificateExpiration?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  documentBaseId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  signatureId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DocumentRenotarizationCreateInput = {
  DocumentBase: DocumentBaseCreateNestedOneWithoutRenotarizationsInput;
  Histories?: InputMaybe<DocumentRenotarizationHistoryCreateNestedManyWithoutDocumentRenotarizationInput>;
  archiveTimestampCertificateExpiration: Scalars['DateTime']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  signatureId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentRenotarizationCreateManyDocumentBaseInput = {
  archiveTimestampCertificateExpiration: Scalars['DateTime']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  signatureId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentRenotarizationCreateManyDocumentBaseInputEnvelope = {
  data: Array<DocumentRenotarizationCreateManyDocumentBaseInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentRenotarizationCreateManyInput = {
  archiveTimestampCertificateExpiration: Scalars['DateTime']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  documentBaseId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  signatureId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentRenotarizationCreateNestedManyWithoutDocumentBaseInput = {
  connect?: InputMaybe<Array<DocumentRenotarizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentRenotarizationCreateOrConnectWithoutDocumentBaseInput>>;
  create?: InputMaybe<Array<DocumentRenotarizationCreateWithoutDocumentBaseInput>>;
  createMany?: InputMaybe<DocumentRenotarizationCreateManyDocumentBaseInputEnvelope>;
};

export type DocumentRenotarizationCreateNestedOneWithoutHistoriesInput = {
  connect?: InputMaybe<DocumentRenotarizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentRenotarizationCreateOrConnectWithoutHistoriesInput>;
  create?: InputMaybe<DocumentRenotarizationCreateWithoutHistoriesInput>;
};

export type DocumentRenotarizationCreateOrConnectWithoutDocumentBaseInput = {
  create: DocumentRenotarizationCreateWithoutDocumentBaseInput;
  where: DocumentRenotarizationWhereUniqueInput;
};

export type DocumentRenotarizationCreateOrConnectWithoutHistoriesInput = {
  create: DocumentRenotarizationCreateWithoutHistoriesInput;
  where: DocumentRenotarizationWhereUniqueInput;
};

export type DocumentRenotarizationCreateWithoutDocumentBaseInput = {
  Histories?: InputMaybe<DocumentRenotarizationHistoryCreateNestedManyWithoutDocumentRenotarizationInput>;
  archiveTimestampCertificateExpiration: Scalars['DateTime']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  signatureId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentRenotarizationCreateWithoutHistoriesInput = {
  DocumentBase: DocumentBaseCreateNestedOneWithoutRenotarizationsInput;
  archiveTimestampCertificateExpiration: Scalars['DateTime']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  signatureId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentRenotarizationHistory = {
  __typename?: 'DocumentRenotarizationHistory';
  DocumentRenotarization: DocumentRenotarization;
  archiveTimestamp?: Maybe<Scalars['DateTime']['output']>;
  archiveTimestampAlgorithm: Scalars['String']['output'];
  archiveTimestampAuthority: Scalars['String']['output'];
  archiveTimestampCertificateExpiration: Scalars['DateTime']['output'];
  archiveTimestampSerial: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  documentRenotarizationId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  signatureId?: Maybe<Scalars['String']['output']>;
  type: DocumentRenotarizationStatus;
  userEmail?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type DocumentRenotarizationHistoryAvgOrderByAggregateInput = {
  documentRenotarizationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DocumentRenotarizationHistoryCountOrderByAggregateInput = {
  archiveTimestamp?: InputMaybe<SortOrder>;
  archiveTimestampAlgorithm?: InputMaybe<SortOrder>;
  archiveTimestampAuthority?: InputMaybe<SortOrder>;
  archiveTimestampCertificateExpiration?: InputMaybe<SortOrder>;
  archiveTimestampSerial?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  documentRenotarizationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  signatureId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  userEmail?: InputMaybe<SortOrder>;
  userName?: InputMaybe<SortOrder>;
};

export type DocumentRenotarizationHistoryCreateInput = {
  DocumentRenotarization: DocumentRenotarizationCreateNestedOneWithoutHistoriesInput;
  archiveTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  archiveTimestampAlgorithm?: InputMaybe<Scalars['String']['input']>;
  archiveTimestampAuthority?: InputMaybe<Scalars['String']['input']>;
  archiveTimestampCertificateExpiration: Scalars['DateTime']['input'];
  archiveTimestampSerial?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  signatureId?: InputMaybe<Scalars['String']['input']>;
  type: DocumentRenotarizationStatus;
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentRenotarizationHistoryCreateManyDocumentRenotarizationInput = {
  archiveTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  archiveTimestampAlgorithm?: InputMaybe<Scalars['String']['input']>;
  archiveTimestampAuthority?: InputMaybe<Scalars['String']['input']>;
  archiveTimestampCertificateExpiration: Scalars['DateTime']['input'];
  archiveTimestampSerial?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  signatureId?: InputMaybe<Scalars['String']['input']>;
  type: DocumentRenotarizationStatus;
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentRenotarizationHistoryCreateManyDocumentRenotarizationInputEnvelope = {
  data: Array<DocumentRenotarizationHistoryCreateManyDocumentRenotarizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentRenotarizationHistoryCreateManyInput = {
  archiveTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  archiveTimestampAlgorithm?: InputMaybe<Scalars['String']['input']>;
  archiveTimestampAuthority?: InputMaybe<Scalars['String']['input']>;
  archiveTimestampCertificateExpiration: Scalars['DateTime']['input'];
  archiveTimestampSerial?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  documentRenotarizationId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  signatureId?: InputMaybe<Scalars['String']['input']>;
  type: DocumentRenotarizationStatus;
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentRenotarizationHistoryCreateNestedManyWithoutDocumentRenotarizationInput = {
  connect?: InputMaybe<Array<DocumentRenotarizationHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentRenotarizationHistoryCreateOrConnectWithoutDocumentRenotarizationInput>>;
  create?: InputMaybe<Array<DocumentRenotarizationHistoryCreateWithoutDocumentRenotarizationInput>>;
  createMany?: InputMaybe<DocumentRenotarizationHistoryCreateManyDocumentRenotarizationInputEnvelope>;
};

export type DocumentRenotarizationHistoryCreateOrConnectWithoutDocumentRenotarizationInput = {
  create: DocumentRenotarizationHistoryCreateWithoutDocumentRenotarizationInput;
  where: DocumentRenotarizationHistoryWhereUniqueInput;
};

export type DocumentRenotarizationHistoryCreateWithoutDocumentRenotarizationInput = {
  archiveTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  archiveTimestampAlgorithm?: InputMaybe<Scalars['String']['input']>;
  archiveTimestampAuthority?: InputMaybe<Scalars['String']['input']>;
  archiveTimestampCertificateExpiration: Scalars['DateTime']['input'];
  archiveTimestampSerial?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  signatureId?: InputMaybe<Scalars['String']['input']>;
  type: DocumentRenotarizationStatus;
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentRenotarizationHistoryListRelationFilter = {
  every?: InputMaybe<DocumentRenotarizationHistoryWhereInput>;
  none?: InputMaybe<DocumentRenotarizationHistoryWhereInput>;
  some?: InputMaybe<DocumentRenotarizationHistoryWhereInput>;
};

export type DocumentRenotarizationHistoryMaxOrderByAggregateInput = {
  archiveTimestamp?: InputMaybe<SortOrder>;
  archiveTimestampAlgorithm?: InputMaybe<SortOrder>;
  archiveTimestampAuthority?: InputMaybe<SortOrder>;
  archiveTimestampCertificateExpiration?: InputMaybe<SortOrder>;
  archiveTimestampSerial?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  documentRenotarizationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  signatureId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  userEmail?: InputMaybe<SortOrder>;
  userName?: InputMaybe<SortOrder>;
};

export type DocumentRenotarizationHistoryMinOrderByAggregateInput = {
  archiveTimestamp?: InputMaybe<SortOrder>;
  archiveTimestampAlgorithm?: InputMaybe<SortOrder>;
  archiveTimestampAuthority?: InputMaybe<SortOrder>;
  archiveTimestampCertificateExpiration?: InputMaybe<SortOrder>;
  archiveTimestampSerial?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  documentRenotarizationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  signatureId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  userEmail?: InputMaybe<SortOrder>;
  userName?: InputMaybe<SortOrder>;
};

export type DocumentRenotarizationHistoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DocumentRenotarizationHistoryOrderByWithAggregationInput = {
  _avg?: InputMaybe<DocumentRenotarizationHistoryAvgOrderByAggregateInput>;
  _count?: InputMaybe<DocumentRenotarizationHistoryCountOrderByAggregateInput>;
  _max?: InputMaybe<DocumentRenotarizationHistoryMaxOrderByAggregateInput>;
  _min?: InputMaybe<DocumentRenotarizationHistoryMinOrderByAggregateInput>;
  _sum?: InputMaybe<DocumentRenotarizationHistorySumOrderByAggregateInput>;
  archiveTimestamp?: InputMaybe<SortOrder>;
  archiveTimestampAlgorithm?: InputMaybe<SortOrder>;
  archiveTimestampAuthority?: InputMaybe<SortOrder>;
  archiveTimestampCertificateExpiration?: InputMaybe<SortOrder>;
  archiveTimestampSerial?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  documentRenotarizationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  signatureId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  userEmail?: InputMaybe<SortOrder>;
  userName?: InputMaybe<SortOrder>;
};

export type DocumentRenotarizationHistoryOrderByWithRelationInput = {
  DocumentRenotarization?: InputMaybe<DocumentRenotarizationOrderByWithRelationInput>;
  archiveTimestamp?: InputMaybe<SortOrder>;
  archiveTimestampAlgorithm?: InputMaybe<SortOrder>;
  archiveTimestampAuthority?: InputMaybe<SortOrder>;
  archiveTimestampCertificateExpiration?: InputMaybe<SortOrder>;
  archiveTimestampSerial?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  documentRenotarizationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  signatureId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  userEmail?: InputMaybe<SortOrder>;
  userName?: InputMaybe<SortOrder>;
};

export enum DocumentRenotarizationHistoryScalarFieldEnum {
  ArchiveTimestamp = 'archiveTimestamp',
  ArchiveTimestampAlgorithm = 'archiveTimestampAlgorithm',
  ArchiveTimestampAuthority = 'archiveTimestampAuthority',
  ArchiveTimestampCertificateExpiration = 'archiveTimestampCertificateExpiration',
  ArchiveTimestampSerial = 'archiveTimestampSerial',
  CreatedAt = 'createdAt',
  DocumentRenotarizationId = 'documentRenotarizationId',
  Id = 'id',
  SignatureId = 'signatureId',
  Type = 'type',
  UserEmail = 'userEmail',
  UserName = 'userName'
}

export type DocumentRenotarizationHistoryScalarWhereInput = {
  AND?: InputMaybe<Array<DocumentRenotarizationHistoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<DocumentRenotarizationHistoryScalarWhereInput>>;
  OR?: InputMaybe<Array<DocumentRenotarizationHistoryScalarWhereInput>>;
  archiveTimestamp?: InputMaybe<DateTimeNullableFilter>;
  archiveTimestampAlgorithm?: InputMaybe<StringFilter>;
  archiveTimestampAuthority?: InputMaybe<StringFilter>;
  archiveTimestampCertificateExpiration?: InputMaybe<DateTimeFilter>;
  archiveTimestampSerial?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentRenotarizationId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  signatureId?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumDocumentRenotarizationStatusFilter>;
  userEmail?: InputMaybe<StringNullableFilter>;
  userName?: InputMaybe<StringNullableFilter>;
};

export type DocumentRenotarizationHistoryScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DocumentRenotarizationHistoryScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DocumentRenotarizationHistoryScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DocumentRenotarizationHistoryScalarWhereWithAggregatesInput>>;
  archiveTimestamp?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  archiveTimestampAlgorithm?: InputMaybe<StringWithAggregatesFilter>;
  archiveTimestampAuthority?: InputMaybe<StringWithAggregatesFilter>;
  archiveTimestampCertificateExpiration?: InputMaybe<DateTimeWithAggregatesFilter>;
  archiveTimestampSerial?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  documentRenotarizationId?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  signatureId?: InputMaybe<StringNullableWithAggregatesFilter>;
  type?: InputMaybe<EnumDocumentRenotarizationStatusWithAggregatesFilter>;
  userEmail?: InputMaybe<StringNullableWithAggregatesFilter>;
  userName?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type DocumentRenotarizationHistorySumOrderByAggregateInput = {
  documentRenotarizationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type DocumentRenotarizationHistoryUpdateInput = {
  DocumentRenotarization?: InputMaybe<DocumentRenotarizationUpdateOneRequiredWithoutHistoriesNestedInput>;
  archiveTimestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  archiveTimestampAlgorithm?: InputMaybe<StringFieldUpdateOperationsInput>;
  archiveTimestampAuthority?: InputMaybe<StringFieldUpdateOperationsInput>;
  archiveTimestampCertificateExpiration?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  archiveTimestampSerial?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  signatureId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentRenotarizationStatusFieldUpdateOperationsInput>;
  userEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DocumentRenotarizationHistoryUpdateManyMutationInput = {
  archiveTimestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  archiveTimestampAlgorithm?: InputMaybe<StringFieldUpdateOperationsInput>;
  archiveTimestampAuthority?: InputMaybe<StringFieldUpdateOperationsInput>;
  archiveTimestampCertificateExpiration?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  archiveTimestampSerial?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  signatureId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentRenotarizationStatusFieldUpdateOperationsInput>;
  userEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DocumentRenotarizationHistoryUpdateManyWithWhereWithoutDocumentRenotarizationInput = {
  data: DocumentRenotarizationHistoryUpdateManyMutationInput;
  where: DocumentRenotarizationHistoryScalarWhereInput;
};

export type DocumentRenotarizationHistoryUpdateManyWithoutDocumentRenotarizationNestedInput = {
  connect?: InputMaybe<Array<DocumentRenotarizationHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentRenotarizationHistoryCreateOrConnectWithoutDocumentRenotarizationInput>>;
  create?: InputMaybe<Array<DocumentRenotarizationHistoryCreateWithoutDocumentRenotarizationInput>>;
  createMany?: InputMaybe<DocumentRenotarizationHistoryCreateManyDocumentRenotarizationInputEnvelope>;
  delete?: InputMaybe<Array<DocumentRenotarizationHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentRenotarizationHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentRenotarizationHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentRenotarizationHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentRenotarizationHistoryUpdateWithWhereUniqueWithoutDocumentRenotarizationInput>>;
  updateMany?: InputMaybe<Array<DocumentRenotarizationHistoryUpdateManyWithWhereWithoutDocumentRenotarizationInput>>;
  upsert?: InputMaybe<Array<DocumentRenotarizationHistoryUpsertWithWhereUniqueWithoutDocumentRenotarizationInput>>;
};

export type DocumentRenotarizationHistoryUpdateWithWhereUniqueWithoutDocumentRenotarizationInput = {
  data: DocumentRenotarizationHistoryUpdateWithoutDocumentRenotarizationInput;
  where: DocumentRenotarizationHistoryWhereUniqueInput;
};

export type DocumentRenotarizationHistoryUpdateWithoutDocumentRenotarizationInput = {
  archiveTimestamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  archiveTimestampAlgorithm?: InputMaybe<StringFieldUpdateOperationsInput>;
  archiveTimestampAuthority?: InputMaybe<StringFieldUpdateOperationsInput>;
  archiveTimestampCertificateExpiration?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  archiveTimestampSerial?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  signatureId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumDocumentRenotarizationStatusFieldUpdateOperationsInput>;
  userEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type DocumentRenotarizationHistoryUpsertWithWhereUniqueWithoutDocumentRenotarizationInput = {
  create: DocumentRenotarizationHistoryCreateWithoutDocumentRenotarizationInput;
  update: DocumentRenotarizationHistoryUpdateWithoutDocumentRenotarizationInput;
  where: DocumentRenotarizationHistoryWhereUniqueInput;
};

export type DocumentRenotarizationHistoryWhereInput = {
  AND?: InputMaybe<Array<DocumentRenotarizationHistoryWhereInput>>;
  DocumentRenotarization?: InputMaybe<DocumentRenotarizationWhereInput>;
  NOT?: InputMaybe<Array<DocumentRenotarizationHistoryWhereInput>>;
  OR?: InputMaybe<Array<DocumentRenotarizationHistoryWhereInput>>;
  archiveTimestamp?: InputMaybe<DateTimeNullableFilter>;
  archiveTimestampAlgorithm?: InputMaybe<StringFilter>;
  archiveTimestampAuthority?: InputMaybe<StringFilter>;
  archiveTimestampCertificateExpiration?: InputMaybe<DateTimeFilter>;
  archiveTimestampSerial?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentRenotarizationId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  signatureId?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumDocumentRenotarizationStatusFilter>;
  userEmail?: InputMaybe<StringNullableFilter>;
  userName?: InputMaybe<StringNullableFilter>;
};

export type DocumentRenotarizationHistoryWhereUniqueInput = {
  AND?: InputMaybe<Array<DocumentRenotarizationHistoryWhereInput>>;
  DocumentRenotarization?: InputMaybe<DocumentRenotarizationWhereInput>;
  NOT?: InputMaybe<Array<DocumentRenotarizationHistoryWhereInput>>;
  OR?: InputMaybe<Array<DocumentRenotarizationHistoryWhereInput>>;
  archiveTimestamp?: InputMaybe<DateTimeNullableFilter>;
  archiveTimestampAlgorithm?: InputMaybe<StringFilter>;
  archiveTimestampAuthority?: InputMaybe<StringFilter>;
  archiveTimestampCertificateExpiration?: InputMaybe<DateTimeFilter>;
  archiveTimestampSerial?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentRenotarizationId?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  signatureId?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumDocumentRenotarizationStatusFilter>;
  userEmail?: InputMaybe<StringNullableFilter>;
  userName?: InputMaybe<StringNullableFilter>;
};

export type DocumentRenotarizationListRelationFilter = {
  every?: InputMaybe<DocumentRenotarizationWhereInput>;
  none?: InputMaybe<DocumentRenotarizationWhereInput>;
  some?: InputMaybe<DocumentRenotarizationWhereInput>;
};

export type DocumentRenotarizationMaxOrderByAggregateInput = {
  archiveTimestampCertificateExpiration?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  documentBaseId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  signatureId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DocumentRenotarizationMinOrderByAggregateInput = {
  archiveTimestampCertificateExpiration?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  documentBaseId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  signatureId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DocumentRenotarizationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DocumentRenotarizationOrderByWithAggregationInput = {
  _avg?: InputMaybe<DocumentRenotarizationAvgOrderByAggregateInput>;
  _count?: InputMaybe<DocumentRenotarizationCountOrderByAggregateInput>;
  _max?: InputMaybe<DocumentRenotarizationMaxOrderByAggregateInput>;
  _min?: InputMaybe<DocumentRenotarizationMinOrderByAggregateInput>;
  _sum?: InputMaybe<DocumentRenotarizationSumOrderByAggregateInput>;
  archiveTimestampCertificateExpiration?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  documentBaseId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  signatureId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DocumentRenotarizationOrderByWithRelationInput = {
  DocumentBase?: InputMaybe<DocumentBaseOrderByWithRelationInput>;
  Histories?: InputMaybe<DocumentRenotarizationHistoryOrderByRelationAggregateInput>;
  archiveTimestampCertificateExpiration?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  documentBaseId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  signatureId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type DocumentRenotarizationRelationFilter = {
  is?: InputMaybe<DocumentRenotarizationWhereInput>;
  isNot?: InputMaybe<DocumentRenotarizationWhereInput>;
};

export enum DocumentRenotarizationScalarFieldEnum {
  ArchiveTimestampCertificateExpiration = 'archiveTimestampCertificateExpiration',
  CreatedAt = 'createdAt',
  DocumentBaseId = 'documentBaseId',
  Id = 'id',
  SignatureId = 'signatureId',
  UpdatedAt = 'updatedAt'
}

export type DocumentRenotarizationScalarWhereInput = {
  AND?: InputMaybe<Array<DocumentRenotarizationScalarWhereInput>>;
  NOT?: InputMaybe<Array<DocumentRenotarizationScalarWhereInput>>;
  OR?: InputMaybe<Array<DocumentRenotarizationScalarWhereInput>>;
  archiveTimestampCertificateExpiration?: InputMaybe<DateTimeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentBaseId?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  signatureId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DocumentRenotarizationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DocumentRenotarizationScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DocumentRenotarizationScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DocumentRenotarizationScalarWhereWithAggregatesInput>>;
  archiveTimestampCertificateExpiration?: InputMaybe<DateTimeWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  documentBaseId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  signatureId?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export enum DocumentRenotarizationStatus {
  Pending = 'PENDING',
  Renotarized = 'RENOTARIZED'
}

export type DocumentRenotarizationSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type DocumentRenotarizationUpdateInput = {
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutRenotarizationsNestedInput>;
  Histories?: InputMaybe<DocumentRenotarizationHistoryUpdateManyWithoutDocumentRenotarizationNestedInput>;
  archiveTimestampCertificateExpiration?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  signatureId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentRenotarizationUpdateManyMutationInput = {
  archiveTimestampCertificateExpiration?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  signatureId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentRenotarizationUpdateManyWithWhereWithoutDocumentBaseInput = {
  data: DocumentRenotarizationUpdateManyMutationInput;
  where: DocumentRenotarizationScalarWhereInput;
};

export type DocumentRenotarizationUpdateManyWithoutDocumentBaseNestedInput = {
  connect?: InputMaybe<Array<DocumentRenotarizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentRenotarizationCreateOrConnectWithoutDocumentBaseInput>>;
  create?: InputMaybe<Array<DocumentRenotarizationCreateWithoutDocumentBaseInput>>;
  createMany?: InputMaybe<DocumentRenotarizationCreateManyDocumentBaseInputEnvelope>;
  delete?: InputMaybe<Array<DocumentRenotarizationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentRenotarizationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentRenotarizationWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentRenotarizationWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentRenotarizationUpdateWithWhereUniqueWithoutDocumentBaseInput>>;
  updateMany?: InputMaybe<Array<DocumentRenotarizationUpdateManyWithWhereWithoutDocumentBaseInput>>;
  upsert?: InputMaybe<Array<DocumentRenotarizationUpsertWithWhereUniqueWithoutDocumentBaseInput>>;
};

export type DocumentRenotarizationUpdateOneRequiredWithoutHistoriesNestedInput = {
  connect?: InputMaybe<DocumentRenotarizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentRenotarizationCreateOrConnectWithoutHistoriesInput>;
  create?: InputMaybe<DocumentRenotarizationCreateWithoutHistoriesInput>;
  update?: InputMaybe<DocumentRenotarizationUpdateToOneWithWhereWithoutHistoriesInput>;
  upsert?: InputMaybe<DocumentRenotarizationUpsertWithoutHistoriesInput>;
};

export type DocumentRenotarizationUpdateToOneWithWhereWithoutHistoriesInput = {
  data: DocumentRenotarizationUpdateWithoutHistoriesInput;
  where?: InputMaybe<DocumentRenotarizationWhereInput>;
};

export type DocumentRenotarizationUpdateWithWhereUniqueWithoutDocumentBaseInput = {
  data: DocumentRenotarizationUpdateWithoutDocumentBaseInput;
  where: DocumentRenotarizationWhereUniqueInput;
};

export type DocumentRenotarizationUpdateWithoutDocumentBaseInput = {
  Histories?: InputMaybe<DocumentRenotarizationHistoryUpdateManyWithoutDocumentRenotarizationNestedInput>;
  archiveTimestampCertificateExpiration?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  signatureId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentRenotarizationUpdateWithoutHistoriesInput = {
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutRenotarizationsNestedInput>;
  archiveTimestampCertificateExpiration?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  signatureId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DocumentRenotarizationUpsertWithWhereUniqueWithoutDocumentBaseInput = {
  create: DocumentRenotarizationCreateWithoutDocumentBaseInput;
  update: DocumentRenotarizationUpdateWithoutDocumentBaseInput;
  where: DocumentRenotarizationWhereUniqueInput;
};

export type DocumentRenotarizationUpsertWithoutHistoriesInput = {
  create: DocumentRenotarizationCreateWithoutHistoriesInput;
  update: DocumentRenotarizationUpdateWithoutHistoriesInput;
  where?: InputMaybe<DocumentRenotarizationWhereInput>;
};

export type DocumentRenotarizationWhereInput = {
  AND?: InputMaybe<Array<DocumentRenotarizationWhereInput>>;
  DocumentBase?: InputMaybe<DocumentBaseWhereInput>;
  Histories?: InputMaybe<DocumentRenotarizationHistoryListRelationFilter>;
  NOT?: InputMaybe<Array<DocumentRenotarizationWhereInput>>;
  OR?: InputMaybe<Array<DocumentRenotarizationWhereInput>>;
  archiveTimestampCertificateExpiration?: InputMaybe<DateTimeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentBaseId?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  signatureId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DocumentRenotarizationWhereUniqueInput = {
  AND?: InputMaybe<Array<DocumentRenotarizationWhereInput>>;
  DocumentBase?: InputMaybe<DocumentBaseWhereInput>;
  Histories?: InputMaybe<DocumentRenotarizationHistoryListRelationFilter>;
  NOT?: InputMaybe<Array<DocumentRenotarizationWhereInput>>;
  OR?: InputMaybe<Array<DocumentRenotarizationWhereInput>>;
  archiveTimestampCertificateExpiration?: InputMaybe<DateTimeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentBaseId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  signatureId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DocumentSchoolCurriculum = {
  __typename?: 'DocumentSchoolCurriculum';
  DocumentBase: DocumentBase;
  documentBaseId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  searchSchoolCurriculumCode: Scalars['String']['output'];
  searchSchoolCurriculumName: Scalars['String']['output'];
  searchSelectedCourse: Scalars['String']['output'];
  searchValidationCode: Scalars['String']['output'];
  status: DocumentSchoolCurriculumStatus;
};

export type DocumentSchoolCurriculumCountOrderByAggregateInput = {
  documentBaseId?: InputMaybe<SortOrder>;
  searchSchoolCurriculumCode?: InputMaybe<SortOrder>;
  searchSchoolCurriculumName?: InputMaybe<SortOrder>;
  searchSelectedCourse?: InputMaybe<SortOrder>;
  searchValidationCode?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type DocumentSchoolCurriculumCreateInput = {
  DocumentBase: DocumentBaseCreateNestedOneWithoutDocumentSchoolCurriculumInput;
  searchSchoolCurriculumCode: Scalars['String']['input'];
  searchSchoolCurriculumName: Scalars['String']['input'];
  searchSelectedCourse: Scalars['String']['input'];
  searchValidationCode: Scalars['String']['input'];
  status?: InputMaybe<DocumentSchoolCurriculumStatus>;
};

export type DocumentSchoolCurriculumCreateManyInput = {
  documentBaseId: Scalars['String']['input'];
  searchSchoolCurriculumCode: Scalars['String']['input'];
  searchSchoolCurriculumName: Scalars['String']['input'];
  searchSelectedCourse: Scalars['String']['input'];
  searchValidationCode: Scalars['String']['input'];
  status?: InputMaybe<DocumentSchoolCurriculumStatus>;
};

export type DocumentSchoolCurriculumCreateNestedOneWithoutDocumentBaseInput = {
  connect?: InputMaybe<DocumentSchoolCurriculumWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentSchoolCurriculumCreateOrConnectWithoutDocumentBaseInput>;
  create?: InputMaybe<DocumentSchoolCurriculumCreateWithoutDocumentBaseInput>;
};

export type DocumentSchoolCurriculumCreateOrConnectWithoutDocumentBaseInput = {
  create: DocumentSchoolCurriculumCreateWithoutDocumentBaseInput;
  where: DocumentSchoolCurriculumWhereUniqueInput;
};

export type DocumentSchoolCurriculumCreateWithoutDocumentBaseInput = {
  searchSchoolCurriculumCode: Scalars['String']['input'];
  searchSchoolCurriculumName: Scalars['String']['input'];
  searchSelectedCourse: Scalars['String']['input'];
  searchValidationCode: Scalars['String']['input'];
  status?: InputMaybe<DocumentSchoolCurriculumStatus>;
};

export type DocumentSchoolCurriculumMaxOrderByAggregateInput = {
  documentBaseId?: InputMaybe<SortOrder>;
  searchSchoolCurriculumCode?: InputMaybe<SortOrder>;
  searchSchoolCurriculumName?: InputMaybe<SortOrder>;
  searchSelectedCourse?: InputMaybe<SortOrder>;
  searchValidationCode?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type DocumentSchoolCurriculumMinOrderByAggregateInput = {
  documentBaseId?: InputMaybe<SortOrder>;
  searchSchoolCurriculumCode?: InputMaybe<SortOrder>;
  searchSchoolCurriculumName?: InputMaybe<SortOrder>;
  searchSelectedCourse?: InputMaybe<SortOrder>;
  searchValidationCode?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type DocumentSchoolCurriculumNullableRelationFilter = {
  is?: InputMaybe<DocumentSchoolCurriculumWhereInput>;
  isNot?: InputMaybe<DocumentSchoolCurriculumWhereInput>;
};

export type DocumentSchoolCurriculumOrderByWithAggregationInput = {
  _count?: InputMaybe<DocumentSchoolCurriculumCountOrderByAggregateInput>;
  _max?: InputMaybe<DocumentSchoolCurriculumMaxOrderByAggregateInput>;
  _min?: InputMaybe<DocumentSchoolCurriculumMinOrderByAggregateInput>;
  documentBaseId?: InputMaybe<SortOrder>;
  searchSchoolCurriculumCode?: InputMaybe<SortOrder>;
  searchSchoolCurriculumName?: InputMaybe<SortOrder>;
  searchSelectedCourse?: InputMaybe<SortOrder>;
  searchValidationCode?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type DocumentSchoolCurriculumOrderByWithRelationInput = {
  DocumentBase?: InputMaybe<DocumentBaseOrderByWithRelationInput>;
  documentBaseId?: InputMaybe<SortOrder>;
  searchSchoolCurriculumCode?: InputMaybe<SortOrder>;
  searchSchoolCurriculumName?: InputMaybe<SortOrder>;
  searchSelectedCourse?: InputMaybe<SortOrder>;
  searchValidationCode?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export enum DocumentSchoolCurriculumScalarFieldEnum {
  DocumentBaseId = 'documentBaseId',
  SearchSchoolCurriculumCode = 'searchSchoolCurriculumCode',
  SearchSchoolCurriculumName = 'searchSchoolCurriculumName',
  SearchSelectedCourse = 'searchSelectedCourse',
  SearchValidationCode = 'searchValidationCode',
  Status = 'status'
}

export type DocumentSchoolCurriculumScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DocumentSchoolCurriculumScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DocumentSchoolCurriculumScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DocumentSchoolCurriculumScalarWhereWithAggregatesInput>>;
  documentBaseId?: InputMaybe<StringWithAggregatesFilter>;
  searchSchoolCurriculumCode?: InputMaybe<StringWithAggregatesFilter>;
  searchSchoolCurriculumName?: InputMaybe<StringWithAggregatesFilter>;
  searchSelectedCourse?: InputMaybe<StringWithAggregatesFilter>;
  searchValidationCode?: InputMaybe<StringWithAggregatesFilter>;
  status?: InputMaybe<EnumDocumentSchoolCurriculumStatusWithAggregatesFilter>;
};

export enum DocumentSchoolCurriculumStatus {
  Draft = 'DRAFT',
  Invalid = 'INVALID',
  InCorrection = 'IN_CORRECTION',
  InSignature = 'IN_SIGNATURE',
  Issued = 'ISSUED',
  PendingReview = 'PENDING_REVIEW',
  Revoked = 'REVOKED',
  ValidationInValidation = 'VALIDATION_IN_VALIDATION'
}

export type DocumentSchoolCurriculumUpdateInput = {
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutDocumentSchoolCurriculumNestedInput>;
  searchSchoolCurriculumCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchSchoolCurriculumName?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchSelectedCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentSchoolCurriculumStatusFieldUpdateOperationsInput>;
};

export type DocumentSchoolCurriculumUpdateManyMutationInput = {
  searchSchoolCurriculumCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchSchoolCurriculumName?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchSelectedCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentSchoolCurriculumStatusFieldUpdateOperationsInput>;
};

export type DocumentSchoolCurriculumUpdateOneWithoutDocumentBaseNestedInput = {
  connect?: InputMaybe<DocumentSchoolCurriculumWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DocumentSchoolCurriculumCreateOrConnectWithoutDocumentBaseInput>;
  create?: InputMaybe<DocumentSchoolCurriculumCreateWithoutDocumentBaseInput>;
  delete?: InputMaybe<DocumentSchoolCurriculumWhereInput>;
  disconnect?: InputMaybe<DocumentSchoolCurriculumWhereInput>;
  update?: InputMaybe<DocumentSchoolCurriculumUpdateToOneWithWhereWithoutDocumentBaseInput>;
  upsert?: InputMaybe<DocumentSchoolCurriculumUpsertWithoutDocumentBaseInput>;
};

export type DocumentSchoolCurriculumUpdateToOneWithWhereWithoutDocumentBaseInput = {
  data: DocumentSchoolCurriculumUpdateWithoutDocumentBaseInput;
  where?: InputMaybe<DocumentSchoolCurriculumWhereInput>;
};

export type DocumentSchoolCurriculumUpdateWithoutDocumentBaseInput = {
  searchSchoolCurriculumCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchSchoolCurriculumName?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchSelectedCourse?: InputMaybe<StringFieldUpdateOperationsInput>;
  searchValidationCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumDocumentSchoolCurriculumStatusFieldUpdateOperationsInput>;
};

export type DocumentSchoolCurriculumUpsertWithoutDocumentBaseInput = {
  create: DocumentSchoolCurriculumCreateWithoutDocumentBaseInput;
  update: DocumentSchoolCurriculumUpdateWithoutDocumentBaseInput;
  where?: InputMaybe<DocumentSchoolCurriculumWhereInput>;
};

export type DocumentSchoolCurriculumWhereInput = {
  AND?: InputMaybe<Array<DocumentSchoolCurriculumWhereInput>>;
  DocumentBase?: InputMaybe<DocumentBaseWhereInput>;
  NOT?: InputMaybe<Array<DocumentSchoolCurriculumWhereInput>>;
  OR?: InputMaybe<Array<DocumentSchoolCurriculumWhereInput>>;
  documentBaseId?: InputMaybe<StringFilter>;
  searchSchoolCurriculumCode?: InputMaybe<StringFilter>;
  searchSchoolCurriculumName?: InputMaybe<StringFilter>;
  searchSelectedCourse?: InputMaybe<StringFilter>;
  searchValidationCode?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumDocumentSchoolCurriculumStatusFilter>;
};

export type DocumentSchoolCurriculumWhereUniqueInput = {
  AND?: InputMaybe<Array<DocumentSchoolCurriculumWhereInput>>;
  DocumentBase?: InputMaybe<DocumentBaseWhereInput>;
  NOT?: InputMaybe<Array<DocumentSchoolCurriculumWhereInput>>;
  OR?: InputMaybe<Array<DocumentSchoolCurriculumWhereInput>>;
  documentBaseId?: InputMaybe<Scalars['String']['input']>;
  searchSchoolCurriculumCode?: InputMaybe<StringFilter>;
  searchSchoolCurriculumName?: InputMaybe<StringFilter>;
  searchSelectedCourse?: InputMaybe<StringFilter>;
  searchValidationCode?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumDocumentSchoolCurriculumStatusFilter>;
};

export enum EducationLevelType {
  GenericCertificates = 'GENERIC_CERTIFICATES',
  PostGraduate = 'POST_GRADUATE',
  UnderGraduate = 'UNDER_GRADUATE'
}

export type EnabledInstitution = {
  __typename?: 'EnabledInstitution';
  Team?: Maybe<Team>;
  cnpj: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  educationLevelType: Array<EducationLevelType>;
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isMaintainer: Scalars['Boolean']['output'];
  /** "Não sistema federal" - Is true when the institution is not part of the federal system */
  isNSF: Scalars['Boolean']['output'];
  /** This name can be changed by the admin */
  placeholderName: Scalars['String']['output'];
  showCreateDiploma: Scalars['Boolean']['output'];
  showImportDiploma: Scalars['Boolean']['output'];
  syncWithLedgerDoc: Scalars['Boolean']['output'];
};

export type EnabledInstitutionAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type EnabledInstitutionCountOrderByAggregateInput = {
  cnpj?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  educationLevelType?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isMaintainer?: InputMaybe<SortOrder>;
  isNSF?: InputMaybe<SortOrder>;
  placeholderName?: InputMaybe<SortOrder>;
  showCreateDiploma?: InputMaybe<SortOrder>;
  showImportDiploma?: InputMaybe<SortOrder>;
  syncWithLedgerDoc?: InputMaybe<SortOrder>;
};

export type EnabledInstitutionCreateInput = {
  Team?: InputMaybe<TeamCreateNestedOneWithoutEnabledInstitutionInput>;
  cnpj: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevelType?: InputMaybe<Array<EducationLevelType>>;
  email: Scalars['String']['input'];
  isMaintainer?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  placeholderName?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnabledInstitutionCreateManyInput = {
  cnpj: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevelType?: InputMaybe<Array<EducationLevelType>>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isMaintainer?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  placeholderName?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnabledInstitutionCreateNestedOneWithoutTeamInput = {
  connect?: InputMaybe<EnabledInstitutionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EnabledInstitutionCreateOrConnectWithoutTeamInput>;
  create?: InputMaybe<EnabledInstitutionCreateWithoutTeamInput>;
};

export type EnabledInstitutionCreateOrConnectWithoutTeamInput = {
  create: EnabledInstitutionCreateWithoutTeamInput;
  where: EnabledInstitutionWhereUniqueInput;
};

export type EnabledInstitutionCreateWithoutTeamInput = {
  cnpj: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevelType?: InputMaybe<Array<EducationLevelType>>;
  email: Scalars['String']['input'];
  isMaintainer?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  placeholderName?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnabledInstitutionCreateeducationLevelTypeInput = {
  set: Array<EducationLevelType>;
};

export type EnabledInstitutionMaxOrderByAggregateInput = {
  cnpj?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isMaintainer?: InputMaybe<SortOrder>;
  isNSF?: InputMaybe<SortOrder>;
  placeholderName?: InputMaybe<SortOrder>;
  showCreateDiploma?: InputMaybe<SortOrder>;
  showImportDiploma?: InputMaybe<SortOrder>;
  syncWithLedgerDoc?: InputMaybe<SortOrder>;
};

export type EnabledInstitutionMinOrderByAggregateInput = {
  cnpj?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isMaintainer?: InputMaybe<SortOrder>;
  isNSF?: InputMaybe<SortOrder>;
  placeholderName?: InputMaybe<SortOrder>;
  showCreateDiploma?: InputMaybe<SortOrder>;
  showImportDiploma?: InputMaybe<SortOrder>;
  syncWithLedgerDoc?: InputMaybe<SortOrder>;
};

export type EnabledInstitutionNullableRelationFilter = {
  is?: InputMaybe<EnabledInstitutionWhereInput>;
  isNot?: InputMaybe<EnabledInstitutionWhereInput>;
};

export type EnabledInstitutionOrderByWithAggregationInput = {
  _avg?: InputMaybe<EnabledInstitutionAvgOrderByAggregateInput>;
  _count?: InputMaybe<EnabledInstitutionCountOrderByAggregateInput>;
  _max?: InputMaybe<EnabledInstitutionMaxOrderByAggregateInput>;
  _min?: InputMaybe<EnabledInstitutionMinOrderByAggregateInput>;
  _sum?: InputMaybe<EnabledInstitutionSumOrderByAggregateInput>;
  cnpj?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  educationLevelType?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isMaintainer?: InputMaybe<SortOrder>;
  isNSF?: InputMaybe<SortOrder>;
  placeholderName?: InputMaybe<SortOrder>;
  showCreateDiploma?: InputMaybe<SortOrder>;
  showImportDiploma?: InputMaybe<SortOrder>;
  syncWithLedgerDoc?: InputMaybe<SortOrder>;
};

export type EnabledInstitutionOrderByWithRelationInput = {
  Team?: InputMaybe<TeamOrderByWithRelationInput>;
  cnpj?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  educationLevelType?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isMaintainer?: InputMaybe<SortOrder>;
  isNSF?: InputMaybe<SortOrder>;
  placeholderName?: InputMaybe<SortOrder>;
  showCreateDiploma?: InputMaybe<SortOrder>;
  showImportDiploma?: InputMaybe<SortOrder>;
  syncWithLedgerDoc?: InputMaybe<SortOrder>;
};

export enum EnabledInstitutionScalarFieldEnum {
  Cnpj = 'cnpj',
  CreatedAt = 'createdAt',
  EducationLevelType = 'educationLevelType',
  Email = 'email',
  Id = 'id',
  IsMaintainer = 'isMaintainer',
  IsNsf = 'isNSF',
  PlaceholderName = 'placeholderName',
  ShowCreateDiploma = 'showCreateDiploma',
  ShowImportDiploma = 'showImportDiploma',
  SyncWithLedgerDoc = 'syncWithLedgerDoc'
}

export type EnabledInstitutionScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<EnabledInstitutionScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<EnabledInstitutionScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<EnabledInstitutionScalarWhereWithAggregatesInput>>;
  cnpj?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  educationLevelType?: InputMaybe<EnumEducationLevelTypeNullableListFilter>;
  email?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  isMaintainer?: InputMaybe<BoolWithAggregatesFilter>;
  isNSF?: InputMaybe<BoolWithAggregatesFilter>;
  placeholderName?: InputMaybe<StringWithAggregatesFilter>;
  showCreateDiploma?: InputMaybe<BoolWithAggregatesFilter>;
  showImportDiploma?: InputMaybe<BoolWithAggregatesFilter>;
  syncWithLedgerDoc?: InputMaybe<BoolWithAggregatesFilter>;
};

export type EnabledInstitutionSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type EnabledInstitutionUpdateInput = {
  Team?: InputMaybe<TeamUpdateOneWithoutEnabledInstitutionNestedInput>;
  cnpj?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  educationLevelType?: InputMaybe<Array<EducationLevelType>>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  isMaintainer?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isNSF?: InputMaybe<BoolFieldUpdateOperationsInput>;
  placeholderName?: InputMaybe<StringFieldUpdateOperationsInput>;
  showCreateDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showImportDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type EnabledInstitutionUpdateManyMutationInput = {
  cnpj?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  educationLevelType?: InputMaybe<Array<EducationLevelType>>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  isMaintainer?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isNSF?: InputMaybe<BoolFieldUpdateOperationsInput>;
  placeholderName?: InputMaybe<StringFieldUpdateOperationsInput>;
  showCreateDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showImportDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type EnabledInstitutionUpdateOneWithoutTeamNestedInput = {
  connect?: InputMaybe<EnabledInstitutionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EnabledInstitutionCreateOrConnectWithoutTeamInput>;
  create?: InputMaybe<EnabledInstitutionCreateWithoutTeamInput>;
  delete?: InputMaybe<EnabledInstitutionWhereInput>;
  disconnect?: InputMaybe<EnabledInstitutionWhereInput>;
  update?: InputMaybe<EnabledInstitutionUpdateToOneWithWhereWithoutTeamInput>;
  upsert?: InputMaybe<EnabledInstitutionUpsertWithoutTeamInput>;
};

export type EnabledInstitutionUpdateToOneWithWhereWithoutTeamInput = {
  data: EnabledInstitutionUpdateWithoutTeamInput;
  where?: InputMaybe<EnabledInstitutionWhereInput>;
};

export type EnabledInstitutionUpdateWithoutTeamInput = {
  cnpj?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  educationLevelType?: InputMaybe<Array<EducationLevelType>>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  isMaintainer?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isNSF?: InputMaybe<BoolFieldUpdateOperationsInput>;
  placeholderName?: InputMaybe<StringFieldUpdateOperationsInput>;
  showCreateDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showImportDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type EnabledInstitutionUpdateeducationLevelTypeInput = {
  push?: InputMaybe<Array<EducationLevelType>>;
  set?: InputMaybe<Array<EducationLevelType>>;
};

export type EnabledInstitutionUpsertWithoutTeamInput = {
  create: EnabledInstitutionCreateWithoutTeamInput;
  update: EnabledInstitutionUpdateWithoutTeamInput;
  where?: InputMaybe<EnabledInstitutionWhereInput>;
};

export type EnabledInstitutionWhereInput = {
  AND?: InputMaybe<Array<EnabledInstitutionWhereInput>>;
  NOT?: InputMaybe<Array<EnabledInstitutionWhereInput>>;
  OR?: InputMaybe<Array<EnabledInstitutionWhereInput>>;
  Team?: InputMaybe<TeamWhereInput>;
  cnpj?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  educationLevelType?: InputMaybe<EnumEducationLevelTypeNullableListFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  isMaintainer?: InputMaybe<BoolFilter>;
  isNSF?: InputMaybe<BoolFilter>;
  placeholderName?: InputMaybe<StringFilter>;
  showCreateDiploma?: InputMaybe<BoolFilter>;
  showImportDiploma?: InputMaybe<BoolFilter>;
  syncWithLedgerDoc?: InputMaybe<BoolFilter>;
};

export type EnabledInstitutionWhereUniqueInput = {
  AND?: InputMaybe<Array<EnabledInstitutionWhereInput>>;
  NOT?: InputMaybe<Array<EnabledInstitutionWhereInput>>;
  OR?: InputMaybe<Array<EnabledInstitutionWhereInput>>;
  Team?: InputMaybe<TeamWhereInput>;
  cnpj?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  educationLevelType?: InputMaybe<EnumEducationLevelTypeNullableListFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isMaintainer?: InputMaybe<BoolFilter>;
  isNSF?: InputMaybe<BoolFilter>;
  placeholderName?: InputMaybe<StringFilter>;
  showCreateDiploma?: InputMaybe<BoolFilter>;
  showImportDiploma?: InputMaybe<BoolFilter>;
  syncWithLedgerDoc?: InputMaybe<BoolFilter>;
};

export type EnumCertificateTypesFieldUpdateOperationsInput = {
  set?: InputMaybe<CertificateTypes>;
};

export type EnumCertificateTypesFilter = {
  equals?: InputMaybe<CertificateTypes>;
  in?: InputMaybe<Array<CertificateTypes>>;
  not?: InputMaybe<CertificateTypes>;
  notIn?: InputMaybe<Array<CertificateTypes>>;
};

export type EnumCertificateTypesWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumCertificateTypesFilter>;
  _min?: InputMaybe<NestedEnumCertificateTypesFilter>;
  equals?: InputMaybe<CertificateTypes>;
  in?: InputMaybe<Array<CertificateTypes>>;
  not?: InputMaybe<CertificateTypes>;
  notIn?: InputMaybe<Array<CertificateTypes>>;
};

export type EnumDocumentAcademicDocumentationCreationTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<DocumentAcademicDocumentationCreationType>;
};

export type EnumDocumentAcademicDocumentationCreationTypeFilter = {
  equals?: InputMaybe<DocumentAcademicDocumentationCreationType>;
  in?: InputMaybe<Array<DocumentAcademicDocumentationCreationType>>;
  not?: InputMaybe<DocumentAcademicDocumentationCreationType>;
  notIn?: InputMaybe<Array<DocumentAcademicDocumentationCreationType>>;
};

export type EnumDocumentAcademicDocumentationCreationTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDocumentAcademicDocumentationCreationTypeFilter>;
  _min?: InputMaybe<NestedEnumDocumentAcademicDocumentationCreationTypeFilter>;
  equals?: InputMaybe<DocumentAcademicDocumentationCreationType>;
  in?: InputMaybe<Array<DocumentAcademicDocumentationCreationType>>;
  not?: InputMaybe<DocumentAcademicDocumentationCreationType>;
  notIn?: InputMaybe<Array<DocumentAcademicDocumentationCreationType>>;
};

export type EnumDocumentAcademicDocumentationStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<DocumentAcademicDocumentationStatus>;
};

export type EnumDocumentAcademicDocumentationStatusFilter = {
  equals?: InputMaybe<DocumentAcademicDocumentationStatus>;
  in?: InputMaybe<Array<DocumentAcademicDocumentationStatus>>;
  not?: InputMaybe<DocumentAcademicDocumentationStatus>;
  notIn?: InputMaybe<Array<DocumentAcademicDocumentationStatus>>;
};

export type EnumDocumentAcademicDocumentationStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDocumentAcademicDocumentationStatusFilter>;
  _min?: InputMaybe<NestedEnumDocumentAcademicDocumentationStatusFilter>;
  equals?: InputMaybe<DocumentAcademicDocumentationStatus>;
  in?: InputMaybe<Array<DocumentAcademicDocumentationStatus>>;
  not?: InputMaybe<DocumentAcademicDocumentationStatus>;
  notIn?: InputMaybe<Array<DocumentAcademicDocumentationStatus>>;
};

export type EnumDocumentAcademicDocumentationTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<DocumentAcademicDocumentationType>;
};

export type EnumDocumentAcademicDocumentationTypeFilter = {
  equals?: InputMaybe<DocumentAcademicDocumentationType>;
  in?: InputMaybe<Array<DocumentAcademicDocumentationType>>;
  not?: InputMaybe<DocumentAcademicDocumentationType>;
  notIn?: InputMaybe<Array<DocumentAcademicDocumentationType>>;
};

export type EnumDocumentAcademicDocumentationTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDocumentAcademicDocumentationTypeFilter>;
  _min?: InputMaybe<NestedEnumDocumentAcademicDocumentationTypeFilter>;
  equals?: InputMaybe<DocumentAcademicDocumentationType>;
  in?: InputMaybe<Array<DocumentAcademicDocumentationType>>;
  not?: InputMaybe<DocumentAcademicDocumentationType>;
  notIn?: InputMaybe<Array<DocumentAcademicDocumentationType>>;
};

export type EnumDocumentAuditFileIssuerStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<DocumentAuditFileIssuerStatus>;
};

export type EnumDocumentAuditFileIssuerStatusFilter = {
  equals?: InputMaybe<DocumentAuditFileIssuerStatus>;
  in?: InputMaybe<Array<DocumentAuditFileIssuerStatus>>;
  not?: InputMaybe<DocumentAuditFileIssuerStatus>;
  notIn?: InputMaybe<Array<DocumentAuditFileIssuerStatus>>;
};

export type EnumDocumentAuditFileIssuerStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDocumentAuditFileIssuerStatusFilter>;
  _min?: InputMaybe<NestedEnumDocumentAuditFileIssuerStatusFilter>;
  equals?: InputMaybe<DocumentAuditFileIssuerStatus>;
  in?: InputMaybe<Array<DocumentAuditFileIssuerStatus>>;
  not?: InputMaybe<DocumentAuditFileIssuerStatus>;
  notIn?: InputMaybe<Array<DocumentAuditFileIssuerStatus>>;
};

export type EnumDocumentBaseTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<DocumentBaseType>;
};

export type EnumDocumentBaseTypeFilter = {
  equals?: InputMaybe<DocumentBaseType>;
  in?: InputMaybe<Array<DocumentBaseType>>;
  not?: InputMaybe<DocumentBaseType>;
  notIn?: InputMaybe<Array<DocumentBaseType>>;
};

export type EnumDocumentBaseTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDocumentBaseTypeFilter>;
  _min?: InputMaybe<NestedEnumDocumentBaseTypeFilter>;
  equals?: InputMaybe<DocumentBaseType>;
  in?: InputMaybe<Array<DocumentBaseType>>;
  not?: InputMaybe<DocumentBaseType>;
  notIn?: InputMaybe<Array<DocumentBaseType>>;
};

export type EnumDocumentCertificateSignatureHashHistoryTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<DocumentCertificateSignatureHashHistoryType>;
};

export type EnumDocumentCertificateSignatureHashHistoryTypeFilter = {
  equals?: InputMaybe<DocumentCertificateSignatureHashHistoryType>;
  in?: InputMaybe<Array<DocumentCertificateSignatureHashHistoryType>>;
  not?: InputMaybe<DocumentCertificateSignatureHashHistoryType>;
  notIn?: InputMaybe<Array<DocumentCertificateSignatureHashHistoryType>>;
};

export type EnumDocumentCertificateSignatureHashHistoryTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDocumentCertificateSignatureHashHistoryTypeFilter>;
  _min?: InputMaybe<NestedEnumDocumentCertificateSignatureHashHistoryTypeFilter>;
  equals?: InputMaybe<DocumentCertificateSignatureHashHistoryType>;
  in?: InputMaybe<Array<DocumentCertificateSignatureHashHistoryType>>;
  not?: InputMaybe<DocumentCertificateSignatureHashHistoryType>;
  notIn?: InputMaybe<Array<DocumentCertificateSignatureHashHistoryType>>;
};

export type EnumDocumentCertificateSignatureItemTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<DocumentCertificateSignatureItemType>;
};

export type EnumDocumentCertificateSignatureItemTypeFilter = {
  equals?: InputMaybe<DocumentCertificateSignatureItemType>;
  in?: InputMaybe<Array<DocumentCertificateSignatureItemType>>;
  not?: InputMaybe<DocumentCertificateSignatureItemType>;
  notIn?: InputMaybe<Array<DocumentCertificateSignatureItemType>>;
};

export type EnumDocumentCertificateSignatureItemTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDocumentCertificateSignatureItemTypeFilter>;
  _min?: InputMaybe<NestedEnumDocumentCertificateSignatureItemTypeFilter>;
  equals?: InputMaybe<DocumentCertificateSignatureItemType>;
  in?: InputMaybe<Array<DocumentCertificateSignatureItemType>>;
  not?: InputMaybe<DocumentCertificateSignatureItemType>;
  notIn?: InputMaybe<Array<DocumentCertificateSignatureItemType>>;
};

export type EnumDocumentCertificateStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<DocumentCertificateStatus>;
};

export type EnumDocumentCertificateStatusFilter = {
  equals?: InputMaybe<DocumentCertificateStatus>;
  in?: InputMaybe<Array<DocumentCertificateStatus>>;
  not?: InputMaybe<DocumentCertificateStatus>;
  notIn?: InputMaybe<Array<DocumentCertificateStatus>>;
};

export type EnumDocumentCertificateStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDocumentCertificateStatusFilter>;
  _min?: InputMaybe<NestedEnumDocumentCertificateStatusFilter>;
  equals?: InputMaybe<DocumentCertificateStatus>;
  in?: InputMaybe<Array<DocumentCertificateStatus>>;
  not?: InputMaybe<DocumentCertificateStatus>;
  notIn?: InputMaybe<Array<DocumentCertificateStatus>>;
};

export type EnumDocumentDegreeStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<DocumentDegreeStatus>;
};

export type EnumDocumentDegreeStatusFilter = {
  equals?: InputMaybe<DocumentDegreeStatus>;
  in?: InputMaybe<Array<DocumentDegreeStatus>>;
  not?: InputMaybe<DocumentDegreeStatus>;
  notIn?: InputMaybe<Array<DocumentDegreeStatus>>;
};

export type EnumDocumentDegreeStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDocumentDegreeStatusFilter>;
  _min?: InputMaybe<NestedEnumDocumentDegreeStatusFilter>;
  equals?: InputMaybe<DocumentDegreeStatus>;
  in?: InputMaybe<Array<DocumentDegreeStatus>>;
  not?: InputMaybe<DocumentDegreeStatus>;
  notIn?: InputMaybe<Array<DocumentDegreeStatus>>;
};

export type EnumDocumentFinalAcademicTranscriptStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<DocumentFinalAcademicTranscriptStatus>;
};

export type EnumDocumentFinalAcademicTranscriptStatusFilter = {
  equals?: InputMaybe<DocumentFinalAcademicTranscriptStatus>;
  in?: InputMaybe<Array<DocumentFinalAcademicTranscriptStatus>>;
  not?: InputMaybe<DocumentFinalAcademicTranscriptStatus>;
  notIn?: InputMaybe<Array<DocumentFinalAcademicTranscriptStatus>>;
};

export type EnumDocumentFinalAcademicTranscriptStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDocumentFinalAcademicTranscriptStatusFilter>;
  _min?: InputMaybe<NestedEnumDocumentFinalAcademicTranscriptStatusFilter>;
  equals?: InputMaybe<DocumentFinalAcademicTranscriptStatus>;
  in?: InputMaybe<Array<DocumentFinalAcademicTranscriptStatus>>;
  not?: InputMaybe<DocumentFinalAcademicTranscriptStatus>;
  notIn?: InputMaybe<Array<DocumentFinalAcademicTranscriptStatus>>;
};

export type EnumDocumentRenotarizationStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<DocumentRenotarizationStatus>;
};

export type EnumDocumentRenotarizationStatusFilter = {
  equals?: InputMaybe<DocumentRenotarizationStatus>;
  in?: InputMaybe<Array<DocumentRenotarizationStatus>>;
  not?: InputMaybe<DocumentRenotarizationStatus>;
  notIn?: InputMaybe<Array<DocumentRenotarizationStatus>>;
};

export type EnumDocumentRenotarizationStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDocumentRenotarizationStatusFilter>;
  _min?: InputMaybe<NestedEnumDocumentRenotarizationStatusFilter>;
  equals?: InputMaybe<DocumentRenotarizationStatus>;
  in?: InputMaybe<Array<DocumentRenotarizationStatus>>;
  not?: InputMaybe<DocumentRenotarizationStatus>;
  notIn?: InputMaybe<Array<DocumentRenotarizationStatus>>;
};

export type EnumDocumentSchoolCurriculumStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<DocumentSchoolCurriculumStatus>;
};

export type EnumDocumentSchoolCurriculumStatusFilter = {
  equals?: InputMaybe<DocumentSchoolCurriculumStatus>;
  in?: InputMaybe<Array<DocumentSchoolCurriculumStatus>>;
  not?: InputMaybe<DocumentSchoolCurriculumStatus>;
  notIn?: InputMaybe<Array<DocumentSchoolCurriculumStatus>>;
};

export type EnumDocumentSchoolCurriculumStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDocumentSchoolCurriculumStatusFilter>;
  _min?: InputMaybe<NestedEnumDocumentSchoolCurriculumStatusFilter>;
  equals?: InputMaybe<DocumentSchoolCurriculumStatus>;
  in?: InputMaybe<Array<DocumentSchoolCurriculumStatus>>;
  not?: InputMaybe<DocumentSchoolCurriculumStatus>;
  notIn?: InputMaybe<Array<DocumentSchoolCurriculumStatus>>;
};

export type EnumEducationLevelTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<EducationLevelType>;
};

export type EnumEducationLevelTypeFilter = {
  equals?: InputMaybe<EducationLevelType>;
  in?: InputMaybe<Array<EducationLevelType>>;
  not?: InputMaybe<EducationLevelType>;
  notIn?: InputMaybe<Array<EducationLevelType>>;
};

export type EnumEducationLevelTypeNullableListFilter = {
  equals?: InputMaybe<Array<EducationLevelType>>;
  has?: InputMaybe<EducationLevelType>;
  hasEvery?: InputMaybe<Array<EducationLevelType>>;
  hasSome?: InputMaybe<Array<EducationLevelType>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumEducationLevelTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumEducationLevelTypeFilter>;
  _min?: InputMaybe<NestedEnumEducationLevelTypeFilter>;
  equals?: InputMaybe<EducationLevelType>;
  in?: InputMaybe<Array<EducationLevelType>>;
  not?: InputMaybe<EducationLevelType>;
  notIn?: InputMaybe<Array<EducationLevelType>>;
};

export type EnumFinancialBillingCycleFieldUpdateOperationsInput = {
  set?: InputMaybe<FinancialBillingCycle>;
};

export type EnumFinancialBillingCycleFilter = {
  equals?: InputMaybe<FinancialBillingCycle>;
  in?: InputMaybe<Array<FinancialBillingCycle>>;
  not?: InputMaybe<FinancialBillingCycle>;
  notIn?: InputMaybe<Array<FinancialBillingCycle>>;
};

export type EnumFinancialBillingCycleNullableFilter = {
  equals?: InputMaybe<FinancialBillingCycle>;
  in?: InputMaybe<Array<FinancialBillingCycle>>;
  not?: InputMaybe<FinancialBillingCycle>;
  notIn?: InputMaybe<Array<FinancialBillingCycle>>;
};

export type EnumFinancialBillingCycleNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumFinancialBillingCycleNullableFilter>;
  _min?: InputMaybe<NestedEnumFinancialBillingCycleNullableFilter>;
  equals?: InputMaybe<FinancialBillingCycle>;
  in?: InputMaybe<Array<FinancialBillingCycle>>;
  not?: InputMaybe<FinancialBillingCycle>;
  notIn?: InputMaybe<Array<FinancialBillingCycle>>;
};

export type EnumFinancialBillingCycleWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumFinancialBillingCycleFilter>;
  _min?: InputMaybe<NestedEnumFinancialBillingCycleFilter>;
  equals?: InputMaybe<FinancialBillingCycle>;
  in?: InputMaybe<Array<FinancialBillingCycle>>;
  not?: InputMaybe<FinancialBillingCycle>;
  notIn?: InputMaybe<Array<FinancialBillingCycle>>;
};

export type EnumFinancialChargeableServiceFieldUpdateOperationsInput = {
  set?: InputMaybe<FinancialChargeableService>;
};

export type EnumFinancialChargeableServiceFilter = {
  equals?: InputMaybe<FinancialChargeableService>;
  in?: InputMaybe<Array<FinancialChargeableService>>;
  not?: InputMaybe<FinancialChargeableService>;
  notIn?: InputMaybe<Array<FinancialChargeableService>>;
};

export type EnumFinancialChargeableServiceWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumFinancialChargeableServiceFilter>;
  _min?: InputMaybe<NestedEnumFinancialChargeableServiceFilter>;
  equals?: InputMaybe<FinancialChargeableService>;
  in?: InputMaybe<Array<FinancialChargeableService>>;
  not?: InputMaybe<FinancialChargeableService>;
  notIn?: InputMaybe<Array<FinancialChargeableService>>;
};

export type EnumFinancialPlanFieldUpdateOperationsInput = {
  set?: InputMaybe<FinancialPlan>;
};

export type EnumFinancialPlanFilter = {
  equals?: InputMaybe<FinancialPlan>;
  in?: InputMaybe<Array<FinancialPlan>>;
  not?: InputMaybe<FinancialPlan>;
  notIn?: InputMaybe<Array<FinancialPlan>>;
};

export type EnumFinancialPlanWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumFinancialPlanFilter>;
  _min?: InputMaybe<NestedEnumFinancialPlanFilter>;
  equals?: InputMaybe<FinancialPlan>;
  in?: InputMaybe<Array<FinancialPlan>>;
  not?: InputMaybe<FinancialPlan>;
  notIn?: InputMaybe<Array<FinancialPlan>>;
};

export type EnumPaymentStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<PaymentStatus>;
};

export type EnumPaymentStatusFilter = {
  equals?: InputMaybe<PaymentStatus>;
  in?: InputMaybe<Array<PaymentStatus>>;
  not?: InputMaybe<PaymentStatus>;
  notIn?: InputMaybe<Array<PaymentStatus>>;
};

export type EnumPaymentStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPaymentStatusFilter>;
  _min?: InputMaybe<NestedEnumPaymentStatusFilter>;
  equals?: InputMaybe<PaymentStatus>;
  in?: InputMaybe<Array<PaymentStatus>>;
  not?: InputMaybe<PaymentStatus>;
  notIn?: InputMaybe<Array<PaymentStatus>>;
};

export type EnumSystemGlobalAlertTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<SystemGlobalAlertType>;
};

export type EnumSystemGlobalAlertTypeFilter = {
  equals?: InputMaybe<SystemGlobalAlertType>;
  in?: InputMaybe<Array<SystemGlobalAlertType>>;
  not?: InputMaybe<SystemGlobalAlertType>;
  notIn?: InputMaybe<Array<SystemGlobalAlertType>>;
};

export type EnumSystemGlobalAlertTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumSystemGlobalAlertTypeFilter>;
  _min?: InputMaybe<NestedEnumSystemGlobalAlertTypeFilter>;
  equals?: InputMaybe<SystemGlobalAlertType>;
  in?: InputMaybe<Array<SystemGlobalAlertType>>;
  not?: InputMaybe<SystemGlobalAlertType>;
  notIn?: InputMaybe<Array<SystemGlobalAlertType>>;
};

export type EnumTeamSpecificSignaturePolicyTypeNullableListFilter = {
  equals?: InputMaybe<Array<TeamSpecificSignaturePolicyType>>;
  has?: InputMaybe<TeamSpecificSignaturePolicyType>;
  hasEvery?: InputMaybe<Array<TeamSpecificSignaturePolicyType>>;
  hasSome?: InputMaybe<Array<TeamSpecificSignaturePolicyType>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnumVisualRepresentationCreationTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<VisualRepresentationCreationType>;
};

export type EnumVisualRepresentationCreationTypeFilter = {
  equals?: InputMaybe<VisualRepresentationCreationType>;
  in?: InputMaybe<Array<VisualRepresentationCreationType>>;
  not?: InputMaybe<VisualRepresentationCreationType>;
  notIn?: InputMaybe<Array<VisualRepresentationCreationType>>;
};

export type EnumVisualRepresentationCreationTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumVisualRepresentationCreationTypeFilter>;
  _min?: InputMaybe<NestedEnumVisualRepresentationCreationTypeFilter>;
  equals?: InputMaybe<VisualRepresentationCreationType>;
  in?: InputMaybe<Array<VisualRepresentationCreationType>>;
  not?: InputMaybe<VisualRepresentationCreationType>;
  notIn?: InputMaybe<Array<VisualRepresentationCreationType>>;
};

export enum Errors {
  /** Error while fast validating document */
  AcademicGenerationFastInvalid = 'ACADEMIC_GENERATION_FAST_INVALID',
  /** Error while reading form data for creating a academic documentation. Should show default message + option to read the error */
  AcademicGenerationUnexpected = 'ACADEMIC_GENERATION_UNEXPECTED',
  /** User does not have enough credits to generate a certificate with specified signature types */
  CertificateGenerationNoCredits = 'CERTIFICATE_GENERATION_NO_CREDITS',
  /** Error while fast validating degree before review */
  DegreeGenerationFastInvalid = 'DEGREE_GENERATION_FAST_INVALID',
  /** Error while validating degree at import */
  DegreeImportInvalid = 'DEGREE_IMPORT_INVALID',
  /** Institution flags do not enable this Digital Degree use case */
  InstitutionUseCaseDisabled = 'INSTITUTION_USE_CASE_DISABLED',
  /** User not activated yet */
  UserAwaitingActivation = 'USER_AWAITING_ACTIVATION',
  /** Error while validating user */
  UserNotAuthorizedForceLogout = 'USER_NOT_AUTHORIZED_FORCE_LOGOUT',
  /** User using more credits to generate a cheaper certificate */
  UsingMoreExpensiveCredits = 'USING_MORE_EXPENSIVE_CREDITS'
}

/** Endereço consultado. */
export type ExternalCepAddress = {
  __typename?: 'ExternalCepAddress';
  cep: Scalars['String']['output'];
  /** city */
  city?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** neighborhood */
  neighborhood?: Maybe<Scalars['String']['output']>;
  /** service */
  service?: Maybe<Scalars['String']['output']>;
  /** state */
  state?: Maybe<Scalars['String']['output']>;
  /** street */
  street?: Maybe<Scalars['String']['output']>;
};

/** Guarda os convites de assinatura externos */
export type ExternalSignatureInvite = {
  __typename?: 'ExternalSignatureInvite';
  DocumentBase: DocumentBase;
  callbackUrl?: Maybe<Scalars['String']['output']>;
  correlationId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  documentBaseInternalSeqId: Scalars['String']['output'];
  documentStudentName?: Maybe<Scalars['String']['output']>;
  /** CPF or CNPJ list ["24367828000140","27118210000135"] */
  enabledPersonIdList: Array<Scalars['String']['output']>;
  groupIndex: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  isSigned: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ExternalSignatureInviteAvgOrderByAggregateInput = {
  groupIndex?: InputMaybe<SortOrder>;
};

export type ExternalSignatureInviteCountOrderByAggregateInput = {
  callbackUrl?: InputMaybe<SortOrder>;
  correlationId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  documentBaseInternalSeqId?: InputMaybe<SortOrder>;
  enabledPersonIdList?: InputMaybe<SortOrder>;
  groupIndex?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isSigned?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ExternalSignatureInviteCreateInput = {
  DocumentBase: DocumentBaseCreateNestedOneWithoutExternalSignatureInviteInput;
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
  correlationId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  enabledPersonIdList?: InputMaybe<Array<Scalars['String']['input']>>;
  groupIndex: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isSigned?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ExternalSignatureInviteCreateManyDocumentBaseInput = {
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
  correlationId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  enabledPersonIdList?: InputMaybe<Array<Scalars['String']['input']>>;
  groupIndex: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isSigned?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ExternalSignatureInviteCreateManyDocumentBaseInputEnvelope = {
  data: Array<ExternalSignatureInviteCreateManyDocumentBaseInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExternalSignatureInviteCreateManyInput = {
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
  correlationId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  documentBaseInternalSeqId: Scalars['String']['input'];
  enabledPersonIdList?: InputMaybe<Array<Scalars['String']['input']>>;
  groupIndex: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isSigned?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ExternalSignatureInviteCreateNestedManyWithoutDocumentBaseInput = {
  connect?: InputMaybe<Array<ExternalSignatureInviteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalSignatureInviteCreateOrConnectWithoutDocumentBaseInput>>;
  create?: InputMaybe<Array<ExternalSignatureInviteCreateWithoutDocumentBaseInput>>;
  createMany?: InputMaybe<ExternalSignatureInviteCreateManyDocumentBaseInputEnvelope>;
};

export type ExternalSignatureInviteCreateOrConnectWithoutDocumentBaseInput = {
  create: ExternalSignatureInviteCreateWithoutDocumentBaseInput;
  where: ExternalSignatureInviteWhereUniqueInput;
};

export type ExternalSignatureInviteCreateWithoutDocumentBaseInput = {
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
  correlationId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  enabledPersonIdList?: InputMaybe<Array<Scalars['String']['input']>>;
  groupIndex: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  isSigned?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ExternalSignatureInviteCreateenabledPersonIdListInput = {
  set: Array<Scalars['String']['input']>;
};

export type ExternalSignatureInviteListRelationFilter = {
  every?: InputMaybe<ExternalSignatureInviteWhereInput>;
  none?: InputMaybe<ExternalSignatureInviteWhereInput>;
  some?: InputMaybe<ExternalSignatureInviteWhereInput>;
};

export type ExternalSignatureInviteMaxOrderByAggregateInput = {
  callbackUrl?: InputMaybe<SortOrder>;
  correlationId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  documentBaseInternalSeqId?: InputMaybe<SortOrder>;
  groupIndex?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isSigned?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ExternalSignatureInviteMinOrderByAggregateInput = {
  callbackUrl?: InputMaybe<SortOrder>;
  correlationId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  documentBaseInternalSeqId?: InputMaybe<SortOrder>;
  groupIndex?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isSigned?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ExternalSignatureInviteOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ExternalSignatureInviteOrderByWithAggregationInput = {
  _avg?: InputMaybe<ExternalSignatureInviteAvgOrderByAggregateInput>;
  _count?: InputMaybe<ExternalSignatureInviteCountOrderByAggregateInput>;
  _max?: InputMaybe<ExternalSignatureInviteMaxOrderByAggregateInput>;
  _min?: InputMaybe<ExternalSignatureInviteMinOrderByAggregateInput>;
  _sum?: InputMaybe<ExternalSignatureInviteSumOrderByAggregateInput>;
  callbackUrl?: InputMaybe<SortOrder>;
  correlationId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  documentBaseInternalSeqId?: InputMaybe<SortOrder>;
  enabledPersonIdList?: InputMaybe<SortOrder>;
  groupIndex?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isSigned?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ExternalSignatureInviteOrderByWithRelationInput = {
  DocumentBase?: InputMaybe<DocumentBaseOrderByWithRelationInput>;
  callbackUrl?: InputMaybe<SortOrder>;
  correlationId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  documentBaseInternalSeqId?: InputMaybe<SortOrder>;
  enabledPersonIdList?: InputMaybe<SortOrder>;
  groupIndex?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isSigned?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ExternalSignatureInviteScalarFieldEnum {
  CallbackUrl = 'callbackUrl',
  CorrelationId = 'correlationId',
  CreatedAt = 'createdAt',
  DocumentBaseInternalSeqId = 'documentBaseInternalSeqId',
  EnabledPersonIdList = 'enabledPersonIdList',
  GroupIndex = 'groupIndex',
  Id = 'id',
  IsSigned = 'isSigned',
  UpdatedAt = 'updatedAt'
}

export type ExternalSignatureInviteScalarWhereInput = {
  AND?: InputMaybe<Array<ExternalSignatureInviteScalarWhereInput>>;
  NOT?: InputMaybe<Array<ExternalSignatureInviteScalarWhereInput>>;
  OR?: InputMaybe<Array<ExternalSignatureInviteScalarWhereInput>>;
  callbackUrl?: InputMaybe<StringNullableFilter>;
  correlationId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentBaseInternalSeqId?: InputMaybe<StringFilter>;
  enabledPersonIdList?: InputMaybe<StringNullableListFilter>;
  groupIndex?: InputMaybe<IntFilter>;
  id?: InputMaybe<StringFilter>;
  isSigned?: InputMaybe<BoolFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ExternalSignatureInviteScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ExternalSignatureInviteScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ExternalSignatureInviteScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ExternalSignatureInviteScalarWhereWithAggregatesInput>>;
  callbackUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  correlationId?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  documentBaseInternalSeqId?: InputMaybe<StringWithAggregatesFilter>;
  enabledPersonIdList?: InputMaybe<StringNullableListFilter>;
  groupIndex?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isSigned?: InputMaybe<BoolWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type ExternalSignatureInviteSumOrderByAggregateInput = {
  groupIndex?: InputMaybe<SortOrder>;
};

export type ExternalSignatureInviteUpdateInput = {
  DocumentBase?: InputMaybe<DocumentBaseUpdateOneRequiredWithoutExternalSignatureInviteNestedInput>;
  callbackUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  correlationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  enabledPersonIdList?: InputMaybe<Array<Scalars['String']['input']>>;
  groupIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isSigned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ExternalSignatureInviteUpdateManyMutationInput = {
  callbackUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  correlationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  enabledPersonIdList?: InputMaybe<Array<Scalars['String']['input']>>;
  groupIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isSigned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ExternalSignatureInviteUpdateManyWithWhereWithoutDocumentBaseInput = {
  data: ExternalSignatureInviteUpdateManyMutationInput;
  where: ExternalSignatureInviteScalarWhereInput;
};

export type ExternalSignatureInviteUpdateManyWithoutDocumentBaseNestedInput = {
  connect?: InputMaybe<Array<ExternalSignatureInviteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ExternalSignatureInviteCreateOrConnectWithoutDocumentBaseInput>>;
  create?: InputMaybe<Array<ExternalSignatureInviteCreateWithoutDocumentBaseInput>>;
  createMany?: InputMaybe<ExternalSignatureInviteCreateManyDocumentBaseInputEnvelope>;
  delete?: InputMaybe<Array<ExternalSignatureInviteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ExternalSignatureInviteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ExternalSignatureInviteWhereUniqueInput>>;
  set?: InputMaybe<Array<ExternalSignatureInviteWhereUniqueInput>>;
  update?: InputMaybe<Array<ExternalSignatureInviteUpdateWithWhereUniqueWithoutDocumentBaseInput>>;
  updateMany?: InputMaybe<Array<ExternalSignatureInviteUpdateManyWithWhereWithoutDocumentBaseInput>>;
  upsert?: InputMaybe<Array<ExternalSignatureInviteUpsertWithWhereUniqueWithoutDocumentBaseInput>>;
};

export type ExternalSignatureInviteUpdateWithWhereUniqueWithoutDocumentBaseInput = {
  data: ExternalSignatureInviteUpdateWithoutDocumentBaseInput;
  where: ExternalSignatureInviteWhereUniqueInput;
};

export type ExternalSignatureInviteUpdateWithoutDocumentBaseInput = {
  callbackUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  correlationId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  enabledPersonIdList?: InputMaybe<Array<Scalars['String']['input']>>;
  groupIndex?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isSigned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ExternalSignatureInviteUpdateenabledPersonIdListInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ExternalSignatureInviteUpsertWithWhereUniqueWithoutDocumentBaseInput = {
  create: ExternalSignatureInviteCreateWithoutDocumentBaseInput;
  update: ExternalSignatureInviteUpdateWithoutDocumentBaseInput;
  where: ExternalSignatureInviteWhereUniqueInput;
};

export type ExternalSignatureInviteWhereInput = {
  AND?: InputMaybe<Array<ExternalSignatureInviteWhereInput>>;
  DocumentBase?: InputMaybe<DocumentBaseWhereInput>;
  NOT?: InputMaybe<Array<ExternalSignatureInviteWhereInput>>;
  OR?: InputMaybe<Array<ExternalSignatureInviteWhereInput>>;
  callbackUrl?: InputMaybe<StringNullableFilter>;
  correlationId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentBaseInternalSeqId?: InputMaybe<StringFilter>;
  enabledPersonIdList?: InputMaybe<StringNullableListFilter>;
  groupIndex?: InputMaybe<IntFilter>;
  id?: InputMaybe<StringFilter>;
  isSigned?: InputMaybe<BoolFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ExternalSignatureInviteWhereUniqueInput = {
  AND?: InputMaybe<Array<ExternalSignatureInviteWhereInput>>;
  DocumentBase?: InputMaybe<DocumentBaseWhereInput>;
  NOT?: InputMaybe<Array<ExternalSignatureInviteWhereInput>>;
  OR?: InputMaybe<Array<ExternalSignatureInviteWhereInput>>;
  callbackUrl?: InputMaybe<StringNullableFilter>;
  correlationId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  documentBaseInternalSeqId?: InputMaybe<StringFilter>;
  enabledPersonIdList?: InputMaybe<StringNullableListFilter>;
  groupIndex?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isSigned?: InputMaybe<BoolFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export enum FinancialBillingCycle {
  Monthly = 'MONTHLY',
  Yearly = 'YEARLY'
}

export type FinancialCharge = {
  __typename?: 'FinancialCharge';
  TeamWallet: FinancialTeamWallet;
  UserExecuted: CommonUser;
  createdAt: Scalars['DateTime']['output'];
  creditsDeducted: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  service: FinancialChargeableService;
  teamId: Scalars['Int']['output'];
  userExecutedId: Scalars['Int']['output'];
};

export type FinancialChargeAvgOrderByAggregateInput = {
  creditsDeducted?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  userExecutedId?: InputMaybe<SortOrder>;
};

export type FinancialChargeCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  creditsDeducted?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  service?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  userExecutedId?: InputMaybe<SortOrder>;
};

export type FinancialChargeCreateInput = {
  TeamWallet: FinancialTeamWalletCreateNestedOneWithoutChargesInput;
  UserExecuted: CommonUserCreateNestedOneWithoutChargesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsDeducted?: InputMaybe<Scalars['Int']['input']>;
  service: FinancialChargeableService;
};

export type FinancialChargeCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsDeducted?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  service: FinancialChargeableService;
  teamId: Scalars['Int']['input'];
  userExecutedId: Scalars['Int']['input'];
};

export type FinancialChargeCreateManyTeamWalletInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsDeducted?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  service: FinancialChargeableService;
  userExecutedId: Scalars['Int']['input'];
};

export type FinancialChargeCreateManyTeamWalletInputEnvelope = {
  data: Array<FinancialChargeCreateManyTeamWalletInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FinancialChargeCreateManyUserExecutedInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsDeducted?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  service: FinancialChargeableService;
  teamId: Scalars['Int']['input'];
};

export type FinancialChargeCreateManyUserExecutedInputEnvelope = {
  data: Array<FinancialChargeCreateManyUserExecutedInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FinancialChargeCreateNestedManyWithoutTeamWalletInput = {
  connect?: InputMaybe<Array<FinancialChargeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinancialChargeCreateOrConnectWithoutTeamWalletInput>>;
  create?: InputMaybe<Array<FinancialChargeCreateWithoutTeamWalletInput>>;
  createMany?: InputMaybe<FinancialChargeCreateManyTeamWalletInputEnvelope>;
};

export type FinancialChargeCreateNestedManyWithoutUserExecutedInput = {
  connect?: InputMaybe<Array<FinancialChargeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinancialChargeCreateOrConnectWithoutUserExecutedInput>>;
  create?: InputMaybe<Array<FinancialChargeCreateWithoutUserExecutedInput>>;
  createMany?: InputMaybe<FinancialChargeCreateManyUserExecutedInputEnvelope>;
};

export type FinancialChargeCreateOrConnectWithoutTeamWalletInput = {
  create: FinancialChargeCreateWithoutTeamWalletInput;
  where: FinancialChargeWhereUniqueInput;
};

export type FinancialChargeCreateOrConnectWithoutUserExecutedInput = {
  create: FinancialChargeCreateWithoutUserExecutedInput;
  where: FinancialChargeWhereUniqueInput;
};

export type FinancialChargeCreateWithoutTeamWalletInput = {
  UserExecuted: CommonUserCreateNestedOneWithoutChargesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsDeducted?: InputMaybe<Scalars['Int']['input']>;
  service: FinancialChargeableService;
};

export type FinancialChargeCreateWithoutUserExecutedInput = {
  TeamWallet: FinancialTeamWalletCreateNestedOneWithoutChargesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsDeducted?: InputMaybe<Scalars['Int']['input']>;
  service: FinancialChargeableService;
};

export type FinancialChargeListRelationFilter = {
  every?: InputMaybe<FinancialChargeWhereInput>;
  none?: InputMaybe<FinancialChargeWhereInput>;
  some?: InputMaybe<FinancialChargeWhereInput>;
};

export type FinancialChargeMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  creditsDeducted?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  service?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  userExecutedId?: InputMaybe<SortOrder>;
};

export type FinancialChargeMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  creditsDeducted?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  service?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  userExecutedId?: InputMaybe<SortOrder>;
};

export type FinancialChargeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FinancialChargeOrderByWithAggregationInput = {
  _avg?: InputMaybe<FinancialChargeAvgOrderByAggregateInput>;
  _count?: InputMaybe<FinancialChargeCountOrderByAggregateInput>;
  _max?: InputMaybe<FinancialChargeMaxOrderByAggregateInput>;
  _min?: InputMaybe<FinancialChargeMinOrderByAggregateInput>;
  _sum?: InputMaybe<FinancialChargeSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  creditsDeducted?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  service?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  userExecutedId?: InputMaybe<SortOrder>;
};

export type FinancialChargeOrderByWithRelationInput = {
  TeamWallet?: InputMaybe<FinancialTeamWalletOrderByWithRelationInput>;
  UserExecuted?: InputMaybe<CommonUserOrderByWithRelationInput>;
  createdAt?: InputMaybe<SortOrder>;
  creditsDeducted?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  service?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  userExecutedId?: InputMaybe<SortOrder>;
};

export enum FinancialChargeScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreditsDeducted = 'creditsDeducted',
  Id = 'id',
  Service = 'service',
  TeamId = 'teamId',
  UserExecutedId = 'userExecutedId'
}

export type FinancialChargeScalarWhereInput = {
  AND?: InputMaybe<Array<FinancialChargeScalarWhereInput>>;
  NOT?: InputMaybe<Array<FinancialChargeScalarWhereInput>>;
  OR?: InputMaybe<Array<FinancialChargeScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creditsDeducted?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  service?: InputMaybe<EnumFinancialChargeableServiceFilter>;
  teamId?: InputMaybe<IntFilter>;
  userExecutedId?: InputMaybe<IntFilter>;
};

export type FinancialChargeScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<FinancialChargeScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<FinancialChargeScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<FinancialChargeScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  creditsDeducted?: InputMaybe<IntWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  service?: InputMaybe<EnumFinancialChargeableServiceWithAggregatesFilter>;
  teamId?: InputMaybe<IntWithAggregatesFilter>;
  userExecutedId?: InputMaybe<IntWithAggregatesFilter>;
};

export type FinancialChargeSumOrderByAggregateInput = {
  creditsDeducted?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  userExecutedId?: InputMaybe<SortOrder>;
};

export type FinancialChargeUpdateInput = {
  TeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneRequiredWithoutChargesNestedInput>;
  UserExecuted?: InputMaybe<CommonUserUpdateOneRequiredWithoutChargesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsDeducted?: InputMaybe<IntFieldUpdateOperationsInput>;
  service?: InputMaybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
};

export type FinancialChargeUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsDeducted?: InputMaybe<IntFieldUpdateOperationsInput>;
  service?: InputMaybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
};

export type FinancialChargeUpdateManyWithWhereWithoutTeamWalletInput = {
  data: FinancialChargeUpdateManyMutationInput;
  where: FinancialChargeScalarWhereInput;
};

export type FinancialChargeUpdateManyWithWhereWithoutUserExecutedInput = {
  data: FinancialChargeUpdateManyMutationInput;
  where: FinancialChargeScalarWhereInput;
};

export type FinancialChargeUpdateManyWithoutTeamWalletNestedInput = {
  connect?: InputMaybe<Array<FinancialChargeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinancialChargeCreateOrConnectWithoutTeamWalletInput>>;
  create?: InputMaybe<Array<FinancialChargeCreateWithoutTeamWalletInput>>;
  createMany?: InputMaybe<FinancialChargeCreateManyTeamWalletInputEnvelope>;
  delete?: InputMaybe<Array<FinancialChargeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FinancialChargeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FinancialChargeWhereUniqueInput>>;
  set?: InputMaybe<Array<FinancialChargeWhereUniqueInput>>;
  update?: InputMaybe<Array<FinancialChargeUpdateWithWhereUniqueWithoutTeamWalletInput>>;
  updateMany?: InputMaybe<Array<FinancialChargeUpdateManyWithWhereWithoutTeamWalletInput>>;
  upsert?: InputMaybe<Array<FinancialChargeUpsertWithWhereUniqueWithoutTeamWalletInput>>;
};

export type FinancialChargeUpdateManyWithoutUserExecutedNestedInput = {
  connect?: InputMaybe<Array<FinancialChargeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinancialChargeCreateOrConnectWithoutUserExecutedInput>>;
  create?: InputMaybe<Array<FinancialChargeCreateWithoutUserExecutedInput>>;
  createMany?: InputMaybe<FinancialChargeCreateManyUserExecutedInputEnvelope>;
  delete?: InputMaybe<Array<FinancialChargeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FinancialChargeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FinancialChargeWhereUniqueInput>>;
  set?: InputMaybe<Array<FinancialChargeWhereUniqueInput>>;
  update?: InputMaybe<Array<FinancialChargeUpdateWithWhereUniqueWithoutUserExecutedInput>>;
  updateMany?: InputMaybe<Array<FinancialChargeUpdateManyWithWhereWithoutUserExecutedInput>>;
  upsert?: InputMaybe<Array<FinancialChargeUpsertWithWhereUniqueWithoutUserExecutedInput>>;
};

export type FinancialChargeUpdateWithWhereUniqueWithoutTeamWalletInput = {
  data: FinancialChargeUpdateWithoutTeamWalletInput;
  where: FinancialChargeWhereUniqueInput;
};

export type FinancialChargeUpdateWithWhereUniqueWithoutUserExecutedInput = {
  data: FinancialChargeUpdateWithoutUserExecutedInput;
  where: FinancialChargeWhereUniqueInput;
};

export type FinancialChargeUpdateWithoutTeamWalletInput = {
  UserExecuted?: InputMaybe<CommonUserUpdateOneRequiredWithoutChargesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsDeducted?: InputMaybe<IntFieldUpdateOperationsInput>;
  service?: InputMaybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
};

export type FinancialChargeUpdateWithoutUserExecutedInput = {
  TeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneRequiredWithoutChargesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsDeducted?: InputMaybe<IntFieldUpdateOperationsInput>;
  service?: InputMaybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
};

export type FinancialChargeUpsertWithWhereUniqueWithoutTeamWalletInput = {
  create: FinancialChargeCreateWithoutTeamWalletInput;
  update: FinancialChargeUpdateWithoutTeamWalletInput;
  where: FinancialChargeWhereUniqueInput;
};

export type FinancialChargeUpsertWithWhereUniqueWithoutUserExecutedInput = {
  create: FinancialChargeCreateWithoutUserExecutedInput;
  update: FinancialChargeUpdateWithoutUserExecutedInput;
  where: FinancialChargeWhereUniqueInput;
};

export type FinancialChargeWhereInput = {
  AND?: InputMaybe<Array<FinancialChargeWhereInput>>;
  NOT?: InputMaybe<Array<FinancialChargeWhereInput>>;
  OR?: InputMaybe<Array<FinancialChargeWhereInput>>;
  TeamWallet?: InputMaybe<FinancialTeamWalletWhereInput>;
  UserExecuted?: InputMaybe<CommonUserWhereInput>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creditsDeducted?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  service?: InputMaybe<EnumFinancialChargeableServiceFilter>;
  teamId?: InputMaybe<IntFilter>;
  userExecutedId?: InputMaybe<IntFilter>;
};

export type FinancialChargeWhereUniqueInput = {
  AND?: InputMaybe<Array<FinancialChargeWhereInput>>;
  NOT?: InputMaybe<Array<FinancialChargeWhereInput>>;
  OR?: InputMaybe<Array<FinancialChargeWhereInput>>;
  TeamWallet?: InputMaybe<FinancialTeamWalletWhereInput>;
  UserExecuted?: InputMaybe<CommonUserWhereInput>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creditsDeducted?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  service?: InputMaybe<EnumFinancialChargeableServiceFilter>;
  teamId?: InputMaybe<IntFilter>;
  userExecutedId?: InputMaybe<IntFilter>;
};

export enum FinancialChargeableService {
  GenerateCertificateRb = 'GENERATE_CERTIFICATE_RB',
  GenerateCertificateRtRa = 'GENERATE_CERTIFICATE_RT_RA',
  GenerateCertificateVisual = 'GENERATE_CERTIFICATE_VISUAL'
}

export type FinancialCreditCardSaved = {
  __typename?: 'FinancialCreditCardSaved';
  TeamWallet: FinancialTeamWallet;
  UserCreated: CommonUser;
  brand: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  number: Scalars['String']['output'];
  token: Scalars['String']['output'];
  userCreatedId: Scalars['Int']['output'];
  walletId: Scalars['Int']['output'];
};

export type FinancialCreditCardSavedAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  userCreatedId?: InputMaybe<SortOrder>;
  walletId?: InputMaybe<SortOrder>;
};

export type FinancialCreditCardSavedCountOrderByAggregateInput = {
  brand?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  number?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
  userCreatedId?: InputMaybe<SortOrder>;
  walletId?: InputMaybe<SortOrder>;
};

export type FinancialCreditCardSavedCreateInput = {
  TeamWallet: FinancialTeamWalletCreateNestedOneWithoutCreditCardSavedsInput;
  UserCreated: CommonUserCreateNestedOneWithoutCreditCardSavedsInput;
  brand: Scalars['String']['input'];
  number: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type FinancialCreditCardSavedCreateManyInput = {
  brand: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  number: Scalars['String']['input'];
  token: Scalars['String']['input'];
  userCreatedId: Scalars['Int']['input'];
  walletId: Scalars['Int']['input'];
};

export type FinancialCreditCardSavedCreateManyTeamWalletInput = {
  brand: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  number: Scalars['String']['input'];
  token: Scalars['String']['input'];
  userCreatedId: Scalars['Int']['input'];
};

export type FinancialCreditCardSavedCreateManyTeamWalletInputEnvelope = {
  data: Array<FinancialCreditCardSavedCreateManyTeamWalletInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FinancialCreditCardSavedCreateManyUserCreatedInput = {
  brand: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  number: Scalars['String']['input'];
  token: Scalars['String']['input'];
  walletId: Scalars['Int']['input'];
};

export type FinancialCreditCardSavedCreateManyUserCreatedInputEnvelope = {
  data: Array<FinancialCreditCardSavedCreateManyUserCreatedInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FinancialCreditCardSavedCreateNestedManyWithoutTeamWalletInput = {
  connect?: InputMaybe<Array<FinancialCreditCardSavedWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinancialCreditCardSavedCreateOrConnectWithoutTeamWalletInput>>;
  create?: InputMaybe<Array<FinancialCreditCardSavedCreateWithoutTeamWalletInput>>;
  createMany?: InputMaybe<FinancialCreditCardSavedCreateManyTeamWalletInputEnvelope>;
};

export type FinancialCreditCardSavedCreateNestedManyWithoutUserCreatedInput = {
  connect?: InputMaybe<Array<FinancialCreditCardSavedWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinancialCreditCardSavedCreateOrConnectWithoutUserCreatedInput>>;
  create?: InputMaybe<Array<FinancialCreditCardSavedCreateWithoutUserCreatedInput>>;
  createMany?: InputMaybe<FinancialCreditCardSavedCreateManyUserCreatedInputEnvelope>;
};

export type FinancialCreditCardSavedCreateOrConnectWithoutTeamWalletInput = {
  create: FinancialCreditCardSavedCreateWithoutTeamWalletInput;
  where: FinancialCreditCardSavedWhereUniqueInput;
};

export type FinancialCreditCardSavedCreateOrConnectWithoutUserCreatedInput = {
  create: FinancialCreditCardSavedCreateWithoutUserCreatedInput;
  where: FinancialCreditCardSavedWhereUniqueInput;
};

export type FinancialCreditCardSavedCreateWithoutTeamWalletInput = {
  UserCreated: CommonUserCreateNestedOneWithoutCreditCardSavedsInput;
  brand: Scalars['String']['input'];
  number: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type FinancialCreditCardSavedCreateWithoutUserCreatedInput = {
  TeamWallet: FinancialTeamWalletCreateNestedOneWithoutCreditCardSavedsInput;
  brand: Scalars['String']['input'];
  number: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type FinancialCreditCardSavedListRelationFilter = {
  every?: InputMaybe<FinancialCreditCardSavedWhereInput>;
  none?: InputMaybe<FinancialCreditCardSavedWhereInput>;
  some?: InputMaybe<FinancialCreditCardSavedWhereInput>;
};

export type FinancialCreditCardSavedMaxOrderByAggregateInput = {
  brand?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  number?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
  userCreatedId?: InputMaybe<SortOrder>;
  walletId?: InputMaybe<SortOrder>;
};

export type FinancialCreditCardSavedMinOrderByAggregateInput = {
  brand?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  number?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
  userCreatedId?: InputMaybe<SortOrder>;
  walletId?: InputMaybe<SortOrder>;
};

export type FinancialCreditCardSavedOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FinancialCreditCardSavedOrderByWithAggregationInput = {
  _avg?: InputMaybe<FinancialCreditCardSavedAvgOrderByAggregateInput>;
  _count?: InputMaybe<FinancialCreditCardSavedCountOrderByAggregateInput>;
  _max?: InputMaybe<FinancialCreditCardSavedMaxOrderByAggregateInput>;
  _min?: InputMaybe<FinancialCreditCardSavedMinOrderByAggregateInput>;
  _sum?: InputMaybe<FinancialCreditCardSavedSumOrderByAggregateInput>;
  brand?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  number?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
  userCreatedId?: InputMaybe<SortOrder>;
  walletId?: InputMaybe<SortOrder>;
};

export type FinancialCreditCardSavedOrderByWithRelationInput = {
  TeamWallet?: InputMaybe<FinancialTeamWalletOrderByWithRelationInput>;
  UserCreated?: InputMaybe<CommonUserOrderByWithRelationInput>;
  brand?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  number?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
  userCreatedId?: InputMaybe<SortOrder>;
  walletId?: InputMaybe<SortOrder>;
};

export enum FinancialCreditCardSavedScalarFieldEnum {
  Brand = 'brand',
  Id = 'id',
  Number = 'number',
  Token = 'token',
  UserCreatedId = 'userCreatedId',
  WalletId = 'walletId'
}

export type FinancialCreditCardSavedScalarWhereInput = {
  AND?: InputMaybe<Array<FinancialCreditCardSavedScalarWhereInput>>;
  NOT?: InputMaybe<Array<FinancialCreditCardSavedScalarWhereInput>>;
  OR?: InputMaybe<Array<FinancialCreditCardSavedScalarWhereInput>>;
  brand?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  number?: InputMaybe<StringFilter>;
  token?: InputMaybe<StringFilter>;
  userCreatedId?: InputMaybe<IntFilter>;
  walletId?: InputMaybe<IntFilter>;
};

export type FinancialCreditCardSavedScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<FinancialCreditCardSavedScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<FinancialCreditCardSavedScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<FinancialCreditCardSavedScalarWhereWithAggregatesInput>>;
  brand?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  number?: InputMaybe<StringWithAggregatesFilter>;
  token?: InputMaybe<StringWithAggregatesFilter>;
  userCreatedId?: InputMaybe<IntWithAggregatesFilter>;
  walletId?: InputMaybe<IntWithAggregatesFilter>;
};

export type FinancialCreditCardSavedSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  userCreatedId?: InputMaybe<SortOrder>;
  walletId?: InputMaybe<SortOrder>;
};

export type FinancialCreditCardSavedUpdateInput = {
  TeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneRequiredWithoutCreditCardSavedsNestedInput>;
  UserCreated?: InputMaybe<CommonUserUpdateOneRequiredWithoutCreditCardSavedsNestedInput>;
  brand?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FinancialCreditCardSavedUpdateManyMutationInput = {
  brand?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FinancialCreditCardSavedUpdateManyWithWhereWithoutTeamWalletInput = {
  data: FinancialCreditCardSavedUpdateManyMutationInput;
  where: FinancialCreditCardSavedScalarWhereInput;
};

export type FinancialCreditCardSavedUpdateManyWithWhereWithoutUserCreatedInput = {
  data: FinancialCreditCardSavedUpdateManyMutationInput;
  where: FinancialCreditCardSavedScalarWhereInput;
};

export type FinancialCreditCardSavedUpdateManyWithoutTeamWalletNestedInput = {
  connect?: InputMaybe<Array<FinancialCreditCardSavedWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinancialCreditCardSavedCreateOrConnectWithoutTeamWalletInput>>;
  create?: InputMaybe<Array<FinancialCreditCardSavedCreateWithoutTeamWalletInput>>;
  createMany?: InputMaybe<FinancialCreditCardSavedCreateManyTeamWalletInputEnvelope>;
  delete?: InputMaybe<Array<FinancialCreditCardSavedWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FinancialCreditCardSavedScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FinancialCreditCardSavedWhereUniqueInput>>;
  set?: InputMaybe<Array<FinancialCreditCardSavedWhereUniqueInput>>;
  update?: InputMaybe<Array<FinancialCreditCardSavedUpdateWithWhereUniqueWithoutTeamWalletInput>>;
  updateMany?: InputMaybe<Array<FinancialCreditCardSavedUpdateManyWithWhereWithoutTeamWalletInput>>;
  upsert?: InputMaybe<Array<FinancialCreditCardSavedUpsertWithWhereUniqueWithoutTeamWalletInput>>;
};

export type FinancialCreditCardSavedUpdateManyWithoutUserCreatedNestedInput = {
  connect?: InputMaybe<Array<FinancialCreditCardSavedWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinancialCreditCardSavedCreateOrConnectWithoutUserCreatedInput>>;
  create?: InputMaybe<Array<FinancialCreditCardSavedCreateWithoutUserCreatedInput>>;
  createMany?: InputMaybe<FinancialCreditCardSavedCreateManyUserCreatedInputEnvelope>;
  delete?: InputMaybe<Array<FinancialCreditCardSavedWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FinancialCreditCardSavedScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FinancialCreditCardSavedWhereUniqueInput>>;
  set?: InputMaybe<Array<FinancialCreditCardSavedWhereUniqueInput>>;
  update?: InputMaybe<Array<FinancialCreditCardSavedUpdateWithWhereUniqueWithoutUserCreatedInput>>;
  updateMany?: InputMaybe<Array<FinancialCreditCardSavedUpdateManyWithWhereWithoutUserCreatedInput>>;
  upsert?: InputMaybe<Array<FinancialCreditCardSavedUpsertWithWhereUniqueWithoutUserCreatedInput>>;
};

export type FinancialCreditCardSavedUpdateWithWhereUniqueWithoutTeamWalletInput = {
  data: FinancialCreditCardSavedUpdateWithoutTeamWalletInput;
  where: FinancialCreditCardSavedWhereUniqueInput;
};

export type FinancialCreditCardSavedUpdateWithWhereUniqueWithoutUserCreatedInput = {
  data: FinancialCreditCardSavedUpdateWithoutUserCreatedInput;
  where: FinancialCreditCardSavedWhereUniqueInput;
};

export type FinancialCreditCardSavedUpdateWithoutTeamWalletInput = {
  UserCreated?: InputMaybe<CommonUserUpdateOneRequiredWithoutCreditCardSavedsNestedInput>;
  brand?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FinancialCreditCardSavedUpdateWithoutUserCreatedInput = {
  TeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneRequiredWithoutCreditCardSavedsNestedInput>;
  brand?: InputMaybe<StringFieldUpdateOperationsInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FinancialCreditCardSavedUpsertWithWhereUniqueWithoutTeamWalletInput = {
  create: FinancialCreditCardSavedCreateWithoutTeamWalletInput;
  update: FinancialCreditCardSavedUpdateWithoutTeamWalletInput;
  where: FinancialCreditCardSavedWhereUniqueInput;
};

export type FinancialCreditCardSavedUpsertWithWhereUniqueWithoutUserCreatedInput = {
  create: FinancialCreditCardSavedCreateWithoutUserCreatedInput;
  update: FinancialCreditCardSavedUpdateWithoutUserCreatedInput;
  where: FinancialCreditCardSavedWhereUniqueInput;
};

export type FinancialCreditCardSavedWalletIdTokenCompoundUniqueInput = {
  token: Scalars['String']['input'];
  walletId: Scalars['Int']['input'];
};

export type FinancialCreditCardSavedWhereInput = {
  AND?: InputMaybe<Array<FinancialCreditCardSavedWhereInput>>;
  NOT?: InputMaybe<Array<FinancialCreditCardSavedWhereInput>>;
  OR?: InputMaybe<Array<FinancialCreditCardSavedWhereInput>>;
  TeamWallet?: InputMaybe<FinancialTeamWalletWhereInput>;
  UserCreated?: InputMaybe<CommonUserWhereInput>;
  brand?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  number?: InputMaybe<StringFilter>;
  token?: InputMaybe<StringFilter>;
  userCreatedId?: InputMaybe<IntFilter>;
  walletId?: InputMaybe<IntFilter>;
};

export type FinancialCreditCardSavedWhereUniqueInput = {
  AND?: InputMaybe<Array<FinancialCreditCardSavedWhereInput>>;
  NOT?: InputMaybe<Array<FinancialCreditCardSavedWhereInput>>;
  OR?: InputMaybe<Array<FinancialCreditCardSavedWhereInput>>;
  TeamWallet?: InputMaybe<FinancialTeamWalletWhereInput>;
  UserCreated?: InputMaybe<CommonUserWhereInput>;
  brand?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<StringFilter>;
  token?: InputMaybe<StringFilter>;
  userCreatedId?: InputMaybe<IntFilter>;
  walletId?: InputMaybe<IntFilter>;
  walletId_token?: InputMaybe<FinancialCreditCardSavedWalletIdTokenCompoundUniqueInput>;
};

/** Fallback costs for each service */
export type FinancialGeneralCostConfig = {
  __typename?: 'FinancialGeneralCostConfig';
  cost: Scalars['Decimal']['output'];
  id: Scalars['Int']['output'];
  service: FinancialChargeableService;
};

export type FinancialGeneralCostConfigAvgOrderByAggregateInput = {
  cost?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type FinancialGeneralCostConfigCountOrderByAggregateInput = {
  cost?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  service?: InputMaybe<SortOrder>;
};

export type FinancialGeneralCostConfigCreateInput = {
  cost: Scalars['Decimal']['input'];
  service: FinancialChargeableService;
};

export type FinancialGeneralCostConfigCreateManyInput = {
  cost: Scalars['Decimal']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  service: FinancialChargeableService;
};

export type FinancialGeneralCostConfigMaxOrderByAggregateInput = {
  cost?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  service?: InputMaybe<SortOrder>;
};

export type FinancialGeneralCostConfigMinOrderByAggregateInput = {
  cost?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  service?: InputMaybe<SortOrder>;
};

export type FinancialGeneralCostConfigOrderByWithAggregationInput = {
  _avg?: InputMaybe<FinancialGeneralCostConfigAvgOrderByAggregateInput>;
  _count?: InputMaybe<FinancialGeneralCostConfigCountOrderByAggregateInput>;
  _max?: InputMaybe<FinancialGeneralCostConfigMaxOrderByAggregateInput>;
  _min?: InputMaybe<FinancialGeneralCostConfigMinOrderByAggregateInput>;
  _sum?: InputMaybe<FinancialGeneralCostConfigSumOrderByAggregateInput>;
  cost?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  service?: InputMaybe<SortOrder>;
};

export type FinancialGeneralCostConfigOrderByWithRelationInput = {
  cost?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  service?: InputMaybe<SortOrder>;
};

export enum FinancialGeneralCostConfigScalarFieldEnum {
  Cost = 'cost',
  Id = 'id',
  Service = 'service'
}

export type FinancialGeneralCostConfigScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<FinancialGeneralCostConfigScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<FinancialGeneralCostConfigScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<FinancialGeneralCostConfigScalarWhereWithAggregatesInput>>;
  cost?: InputMaybe<DecimalWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  service?: InputMaybe<EnumFinancialChargeableServiceWithAggregatesFilter>;
};

export type FinancialGeneralCostConfigSumOrderByAggregateInput = {
  cost?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type FinancialGeneralCostConfigUpdateInput = {
  cost?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  service?: InputMaybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
};

export type FinancialGeneralCostConfigUpdateManyMutationInput = {
  cost?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  service?: InputMaybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
};

export type FinancialGeneralCostConfigWhereInput = {
  AND?: InputMaybe<Array<FinancialGeneralCostConfigWhereInput>>;
  NOT?: InputMaybe<Array<FinancialGeneralCostConfigWhereInput>>;
  OR?: InputMaybe<Array<FinancialGeneralCostConfigWhereInput>>;
  cost?: InputMaybe<DecimalFilter>;
  id?: InputMaybe<IntFilter>;
  service?: InputMaybe<EnumFinancialChargeableServiceFilter>;
};

export type FinancialGeneralCostConfigWhereUniqueInput = {
  AND?: InputMaybe<Array<FinancialGeneralCostConfigWhereInput>>;
  NOT?: InputMaybe<Array<FinancialGeneralCostConfigWhereInput>>;
  OR?: InputMaybe<Array<FinancialGeneralCostConfigWhereInput>>;
  cost?: InputMaybe<DecimalFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  service?: InputMaybe<FinancialChargeableService>;
};

/**
 * Store all payments (Purchases) executed by team
 * If its a purchase of a plan + credits, link with recharge and SubscriptionPayment
 */
export type FinancialPayment = {
  __typename?: 'FinancialPayment';
  Recharge?: Maybe<FinancialRecharge>;
  SubscriptionPayment?: Maybe<FinancialTeamWalletSubscriptionPayment>;
  TeamWallet: FinancialTeamWallet;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  walletId: Scalars['Int']['output'];
};

export type FinancialPaymentAvgOrderByAggregateInput = {
  walletId?: InputMaybe<SortOrder>;
};

export type FinancialPaymentCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  walletId?: InputMaybe<SortOrder>;
};

export type FinancialPaymentCreateInput = {
  Recharge?: InputMaybe<FinancialRechargeCreateNestedOneWithoutFinancialPaymentInput>;
  SubscriptionPayment?: InputMaybe<FinancialTeamWalletSubscriptionPaymentCreateNestedOneWithoutFinancialPaymentInput>;
  TeamWallet: FinancialTeamWalletCreateNestedOneWithoutPaymentsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialPaymentCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  walletId: Scalars['Int']['input'];
};

export type FinancialPaymentCreateManyTeamWalletInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialPaymentCreateManyTeamWalletInputEnvelope = {
  data: Array<FinancialPaymentCreateManyTeamWalletInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FinancialPaymentCreateNestedManyWithoutTeamWalletInput = {
  connect?: InputMaybe<Array<FinancialPaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinancialPaymentCreateOrConnectWithoutTeamWalletInput>>;
  create?: InputMaybe<Array<FinancialPaymentCreateWithoutTeamWalletInput>>;
  createMany?: InputMaybe<FinancialPaymentCreateManyTeamWalletInputEnvelope>;
};

export type FinancialPaymentCreateNestedOneWithoutRechargeInput = {
  connect?: InputMaybe<FinancialPaymentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FinancialPaymentCreateOrConnectWithoutRechargeInput>;
  create?: InputMaybe<FinancialPaymentCreateWithoutRechargeInput>;
};

export type FinancialPaymentCreateNestedOneWithoutSubscriptionPaymentInput = {
  connect?: InputMaybe<FinancialPaymentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FinancialPaymentCreateOrConnectWithoutSubscriptionPaymentInput>;
  create?: InputMaybe<FinancialPaymentCreateWithoutSubscriptionPaymentInput>;
};

export type FinancialPaymentCreateOrConnectWithoutRechargeInput = {
  create: FinancialPaymentCreateWithoutRechargeInput;
  where: FinancialPaymentWhereUniqueInput;
};

export type FinancialPaymentCreateOrConnectWithoutSubscriptionPaymentInput = {
  create: FinancialPaymentCreateWithoutSubscriptionPaymentInput;
  where: FinancialPaymentWhereUniqueInput;
};

export type FinancialPaymentCreateOrConnectWithoutTeamWalletInput = {
  create: FinancialPaymentCreateWithoutTeamWalletInput;
  where: FinancialPaymentWhereUniqueInput;
};

export type FinancialPaymentCreateWithoutRechargeInput = {
  SubscriptionPayment?: InputMaybe<FinancialTeamWalletSubscriptionPaymentCreateNestedOneWithoutFinancialPaymentInput>;
  TeamWallet: FinancialTeamWalletCreateNestedOneWithoutPaymentsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialPaymentCreateWithoutSubscriptionPaymentInput = {
  Recharge?: InputMaybe<FinancialRechargeCreateNestedOneWithoutFinancialPaymentInput>;
  TeamWallet: FinancialTeamWalletCreateNestedOneWithoutPaymentsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialPaymentCreateWithoutTeamWalletInput = {
  Recharge?: InputMaybe<FinancialRechargeCreateNestedOneWithoutFinancialPaymentInput>;
  SubscriptionPayment?: InputMaybe<FinancialTeamWalletSubscriptionPaymentCreateNestedOneWithoutFinancialPaymentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialPaymentListRelationFilter = {
  every?: InputMaybe<FinancialPaymentWhereInput>;
  none?: InputMaybe<FinancialPaymentWhereInput>;
  some?: InputMaybe<FinancialPaymentWhereInput>;
};

export type FinancialPaymentMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  walletId?: InputMaybe<SortOrder>;
};

export type FinancialPaymentMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  walletId?: InputMaybe<SortOrder>;
};

export type FinancialPaymentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FinancialPaymentOrderByWithAggregationInput = {
  _avg?: InputMaybe<FinancialPaymentAvgOrderByAggregateInput>;
  _count?: InputMaybe<FinancialPaymentCountOrderByAggregateInput>;
  _max?: InputMaybe<FinancialPaymentMaxOrderByAggregateInput>;
  _min?: InputMaybe<FinancialPaymentMinOrderByAggregateInput>;
  _sum?: InputMaybe<FinancialPaymentSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  walletId?: InputMaybe<SortOrder>;
};

export type FinancialPaymentOrderByWithRelationInput = {
  Recharge?: InputMaybe<FinancialRechargeOrderByWithRelationInput>;
  SubscriptionPayment?: InputMaybe<FinancialTeamWalletSubscriptionPaymentOrderByWithRelationInput>;
  TeamWallet?: InputMaybe<FinancialTeamWalletOrderByWithRelationInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  walletId?: InputMaybe<SortOrder>;
};

export type FinancialPaymentRelationFilter = {
  is?: InputMaybe<FinancialPaymentWhereInput>;
  isNot?: InputMaybe<FinancialPaymentWhereInput>;
};

export enum FinancialPaymentScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  WalletId = 'walletId'
}

export type FinancialPaymentScalarWhereInput = {
  AND?: InputMaybe<Array<FinancialPaymentScalarWhereInput>>;
  NOT?: InputMaybe<Array<FinancialPaymentScalarWhereInput>>;
  OR?: InputMaybe<Array<FinancialPaymentScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  walletId?: InputMaybe<IntFilter>;
};

export type FinancialPaymentScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<FinancialPaymentScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<FinancialPaymentScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<FinancialPaymentScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  walletId?: InputMaybe<IntWithAggregatesFilter>;
};

export type FinancialPaymentSumOrderByAggregateInput = {
  walletId?: InputMaybe<SortOrder>;
};

export type FinancialPaymentUpdateInput = {
  Recharge?: InputMaybe<FinancialRechargeUpdateOneWithoutFinancialPaymentNestedInput>;
  SubscriptionPayment?: InputMaybe<FinancialTeamWalletSubscriptionPaymentUpdateOneWithoutFinancialPaymentNestedInput>;
  TeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneRequiredWithoutPaymentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FinancialPaymentUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FinancialPaymentUpdateManyWithWhereWithoutTeamWalletInput = {
  data: FinancialPaymentUpdateManyMutationInput;
  where: FinancialPaymentScalarWhereInput;
};

export type FinancialPaymentUpdateManyWithoutTeamWalletNestedInput = {
  connect?: InputMaybe<Array<FinancialPaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinancialPaymentCreateOrConnectWithoutTeamWalletInput>>;
  create?: InputMaybe<Array<FinancialPaymentCreateWithoutTeamWalletInput>>;
  createMany?: InputMaybe<FinancialPaymentCreateManyTeamWalletInputEnvelope>;
  delete?: InputMaybe<Array<FinancialPaymentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FinancialPaymentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FinancialPaymentWhereUniqueInput>>;
  set?: InputMaybe<Array<FinancialPaymentWhereUniqueInput>>;
  update?: InputMaybe<Array<FinancialPaymentUpdateWithWhereUniqueWithoutTeamWalletInput>>;
  updateMany?: InputMaybe<Array<FinancialPaymentUpdateManyWithWhereWithoutTeamWalletInput>>;
  upsert?: InputMaybe<Array<FinancialPaymentUpsertWithWhereUniqueWithoutTeamWalletInput>>;
};

export type FinancialPaymentUpdateOneRequiredWithoutRechargeNestedInput = {
  connect?: InputMaybe<FinancialPaymentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FinancialPaymentCreateOrConnectWithoutRechargeInput>;
  create?: InputMaybe<FinancialPaymentCreateWithoutRechargeInput>;
  update?: InputMaybe<FinancialPaymentUpdateToOneWithWhereWithoutRechargeInput>;
  upsert?: InputMaybe<FinancialPaymentUpsertWithoutRechargeInput>;
};

export type FinancialPaymentUpdateOneRequiredWithoutSubscriptionPaymentNestedInput = {
  connect?: InputMaybe<FinancialPaymentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FinancialPaymentCreateOrConnectWithoutSubscriptionPaymentInput>;
  create?: InputMaybe<FinancialPaymentCreateWithoutSubscriptionPaymentInput>;
  update?: InputMaybe<FinancialPaymentUpdateToOneWithWhereWithoutSubscriptionPaymentInput>;
  upsert?: InputMaybe<FinancialPaymentUpsertWithoutSubscriptionPaymentInput>;
};

export type FinancialPaymentUpdateToOneWithWhereWithoutRechargeInput = {
  data: FinancialPaymentUpdateWithoutRechargeInput;
  where?: InputMaybe<FinancialPaymentWhereInput>;
};

export type FinancialPaymentUpdateToOneWithWhereWithoutSubscriptionPaymentInput = {
  data: FinancialPaymentUpdateWithoutSubscriptionPaymentInput;
  where?: InputMaybe<FinancialPaymentWhereInput>;
};

export type FinancialPaymentUpdateWithWhereUniqueWithoutTeamWalletInput = {
  data: FinancialPaymentUpdateWithoutTeamWalletInput;
  where: FinancialPaymentWhereUniqueInput;
};

export type FinancialPaymentUpdateWithoutRechargeInput = {
  SubscriptionPayment?: InputMaybe<FinancialTeamWalletSubscriptionPaymentUpdateOneWithoutFinancialPaymentNestedInput>;
  TeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneRequiredWithoutPaymentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FinancialPaymentUpdateWithoutSubscriptionPaymentInput = {
  Recharge?: InputMaybe<FinancialRechargeUpdateOneWithoutFinancialPaymentNestedInput>;
  TeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneRequiredWithoutPaymentsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FinancialPaymentUpdateWithoutTeamWalletInput = {
  Recharge?: InputMaybe<FinancialRechargeUpdateOneWithoutFinancialPaymentNestedInput>;
  SubscriptionPayment?: InputMaybe<FinancialTeamWalletSubscriptionPaymentUpdateOneWithoutFinancialPaymentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FinancialPaymentUpsertWithWhereUniqueWithoutTeamWalletInput = {
  create: FinancialPaymentCreateWithoutTeamWalletInput;
  update: FinancialPaymentUpdateWithoutTeamWalletInput;
  where: FinancialPaymentWhereUniqueInput;
};

export type FinancialPaymentUpsertWithoutRechargeInput = {
  create: FinancialPaymentCreateWithoutRechargeInput;
  update: FinancialPaymentUpdateWithoutRechargeInput;
  where?: InputMaybe<FinancialPaymentWhereInput>;
};

export type FinancialPaymentUpsertWithoutSubscriptionPaymentInput = {
  create: FinancialPaymentCreateWithoutSubscriptionPaymentInput;
  update: FinancialPaymentUpdateWithoutSubscriptionPaymentInput;
  where?: InputMaybe<FinancialPaymentWhereInput>;
};

export type FinancialPaymentWhereInput = {
  AND?: InputMaybe<Array<FinancialPaymentWhereInput>>;
  NOT?: InputMaybe<Array<FinancialPaymentWhereInput>>;
  OR?: InputMaybe<Array<FinancialPaymentWhereInput>>;
  Recharge?: InputMaybe<FinancialRechargeWhereInput>;
  SubscriptionPayment?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
  TeamWallet?: InputMaybe<FinancialTeamWalletWhereInput>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  walletId?: InputMaybe<IntFilter>;
};

export type FinancialPaymentWhereUniqueInput = {
  AND?: InputMaybe<Array<FinancialPaymentWhereInput>>;
  NOT?: InputMaybe<Array<FinancialPaymentWhereInput>>;
  OR?: InputMaybe<Array<FinancialPaymentWhereInput>>;
  Recharge?: InputMaybe<FinancialRechargeWhereInput>;
  SubscriptionPayment?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
  TeamWallet?: InputMaybe<FinancialTeamWalletWhereInput>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  walletId?: InputMaybe<IntFilter>;
};

export enum FinancialPlan {
  Business = 'BUSINESS',
  Detached = 'DETACHED',
  Enterprise = 'ENTERPRISE',
  Start = 'START',
  Trial = 'TRIAL'
}

export type FinancialRecharge = {
  __typename?: 'FinancialRecharge';
  FinancialPayment: FinancialPayment;
  UserExecuted: CommonUser;
  cost: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  creditsCount: Scalars['Int']['output'];
  creditsType: FinancialChargeableService;
  id: Scalars['Int']['output'];
  paymentId: Scalars['String']['output'];
  /** ![PrismaJson.AnyJson], thats for logging purposes */
  providerResponse?: Maybe<Scalars['Json']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userExecutedId: Scalars['Int']['output'];
};

export type FinancialRechargeAvgOrderByAggregateInput = {
  cost?: InputMaybe<SortOrder>;
  creditsCount?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  userExecutedId?: InputMaybe<SortOrder>;
};

export type FinancialRechargeCountOrderByAggregateInput = {
  cost?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  creditsCount?: InputMaybe<SortOrder>;
  creditsType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  providerResponse?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userExecutedId?: InputMaybe<SortOrder>;
};

export type FinancialRechargeCreateInput = {
  FinancialPayment: FinancialPaymentCreateNestedOneWithoutRechargeInput;
  UserExecuted: CommonUserCreateNestedOneWithoutRechargesInput;
  cost?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsCount: Scalars['Int']['input'];
  creditsType: FinancialChargeableService;
  providerResponse?: InputMaybe<Scalars['Json']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FinancialRechargeCreateManyInput = {
  cost?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsCount: Scalars['Int']['input'];
  creditsType: FinancialChargeableService;
  id?: InputMaybe<Scalars['Int']['input']>;
  paymentId: Scalars['String']['input'];
  providerResponse?: InputMaybe<Scalars['Json']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  userExecutedId: Scalars['Int']['input'];
};

export type FinancialRechargeCreateManyUserExecutedInput = {
  cost?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsCount: Scalars['Int']['input'];
  creditsType: FinancialChargeableService;
  id?: InputMaybe<Scalars['Int']['input']>;
  paymentId: Scalars['String']['input'];
  providerResponse?: InputMaybe<Scalars['Json']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FinancialRechargeCreateManyUserExecutedInputEnvelope = {
  data: Array<FinancialRechargeCreateManyUserExecutedInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FinancialRechargeCreateNestedManyWithoutUserExecutedInput = {
  connect?: InputMaybe<Array<FinancialRechargeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinancialRechargeCreateOrConnectWithoutUserExecutedInput>>;
  create?: InputMaybe<Array<FinancialRechargeCreateWithoutUserExecutedInput>>;
  createMany?: InputMaybe<FinancialRechargeCreateManyUserExecutedInputEnvelope>;
};

export type FinancialRechargeCreateNestedOneWithoutFinancialPaymentInput = {
  connect?: InputMaybe<FinancialRechargeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FinancialRechargeCreateOrConnectWithoutFinancialPaymentInput>;
  create?: InputMaybe<FinancialRechargeCreateWithoutFinancialPaymentInput>;
};

export type FinancialRechargeCreateOrConnectWithoutFinancialPaymentInput = {
  create: FinancialRechargeCreateWithoutFinancialPaymentInput;
  where: FinancialRechargeWhereUniqueInput;
};

export type FinancialRechargeCreateOrConnectWithoutUserExecutedInput = {
  create: FinancialRechargeCreateWithoutUserExecutedInput;
  where: FinancialRechargeWhereUniqueInput;
};

export type FinancialRechargeCreateWithoutFinancialPaymentInput = {
  UserExecuted: CommonUserCreateNestedOneWithoutRechargesInput;
  cost?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsCount: Scalars['Int']['input'];
  creditsType: FinancialChargeableService;
  providerResponse?: InputMaybe<Scalars['Json']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FinancialRechargeCreateWithoutUserExecutedInput = {
  FinancialPayment: FinancialPaymentCreateNestedOneWithoutRechargeInput;
  cost?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditsCount: Scalars['Int']['input'];
  creditsType: FinancialChargeableService;
  providerResponse?: InputMaybe<Scalars['Json']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FinancialRechargeListRelationFilter = {
  every?: InputMaybe<FinancialRechargeWhereInput>;
  none?: InputMaybe<FinancialRechargeWhereInput>;
  some?: InputMaybe<FinancialRechargeWhereInput>;
};

export type FinancialRechargeMaxOrderByAggregateInput = {
  cost?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  creditsCount?: InputMaybe<SortOrder>;
  creditsType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userExecutedId?: InputMaybe<SortOrder>;
};

export type FinancialRechargeMinOrderByAggregateInput = {
  cost?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  creditsCount?: InputMaybe<SortOrder>;
  creditsType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userExecutedId?: InputMaybe<SortOrder>;
};

export type FinancialRechargeNullableRelationFilter = {
  is?: InputMaybe<FinancialRechargeWhereInput>;
  isNot?: InputMaybe<FinancialRechargeWhereInput>;
};

export type FinancialRechargeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FinancialRechargeOrderByWithAggregationInput = {
  _avg?: InputMaybe<FinancialRechargeAvgOrderByAggregateInput>;
  _count?: InputMaybe<FinancialRechargeCountOrderByAggregateInput>;
  _max?: InputMaybe<FinancialRechargeMaxOrderByAggregateInput>;
  _min?: InputMaybe<FinancialRechargeMinOrderByAggregateInput>;
  _sum?: InputMaybe<FinancialRechargeSumOrderByAggregateInput>;
  cost?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  creditsCount?: InputMaybe<SortOrder>;
  creditsType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  providerResponse?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userExecutedId?: InputMaybe<SortOrder>;
};

export type FinancialRechargeOrderByWithRelationInput = {
  FinancialPayment?: InputMaybe<FinancialPaymentOrderByWithRelationInput>;
  UserExecuted?: InputMaybe<CommonUserOrderByWithRelationInput>;
  cost?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  creditsCount?: InputMaybe<SortOrder>;
  creditsType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  providerResponse?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userExecutedId?: InputMaybe<SortOrder>;
};

export enum FinancialRechargeScalarFieldEnum {
  Cost = 'cost',
  CreatedAt = 'createdAt',
  CreditsCount = 'creditsCount',
  CreditsType = 'creditsType',
  Id = 'id',
  PaymentId = 'paymentId',
  ProviderResponse = 'providerResponse',
  UpdatedAt = 'updatedAt',
  UserExecutedId = 'userExecutedId'
}

export type FinancialRechargeScalarWhereInput = {
  AND?: InputMaybe<Array<FinancialRechargeScalarWhereInput>>;
  NOT?: InputMaybe<Array<FinancialRechargeScalarWhereInput>>;
  OR?: InputMaybe<Array<FinancialRechargeScalarWhereInput>>;
  cost?: InputMaybe<DecimalFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creditsCount?: InputMaybe<IntFilter>;
  creditsType?: InputMaybe<EnumFinancialChargeableServiceFilter>;
  id?: InputMaybe<IntFilter>;
  paymentId?: InputMaybe<StringFilter>;
  providerResponse?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userExecutedId?: InputMaybe<IntFilter>;
};

export type FinancialRechargeScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<FinancialRechargeScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<FinancialRechargeScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<FinancialRechargeScalarWhereWithAggregatesInput>>;
  cost?: InputMaybe<DecimalWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  creditsCount?: InputMaybe<IntWithAggregatesFilter>;
  creditsType?: InputMaybe<EnumFinancialChargeableServiceWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  paymentId?: InputMaybe<StringWithAggregatesFilter>;
  providerResponse?: InputMaybe<JsonNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  userExecutedId?: InputMaybe<IntWithAggregatesFilter>;
};

export type FinancialRechargeSumOrderByAggregateInput = {
  cost?: InputMaybe<SortOrder>;
  creditsCount?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  userExecutedId?: InputMaybe<SortOrder>;
};

export type FinancialRechargeUpdateInput = {
  FinancialPayment?: InputMaybe<FinancialPaymentUpdateOneRequiredWithoutRechargeNestedInput>;
  UserExecuted?: InputMaybe<CommonUserUpdateOneRequiredWithoutRechargesNestedInput>;
  cost?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsType?: InputMaybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
  providerResponse?: InputMaybe<Scalars['Json']['input']>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type FinancialRechargeUpdateManyMutationInput = {
  cost?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsType?: InputMaybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
  providerResponse?: InputMaybe<Scalars['Json']['input']>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type FinancialRechargeUpdateManyWithWhereWithoutUserExecutedInput = {
  data: FinancialRechargeUpdateManyMutationInput;
  where: FinancialRechargeScalarWhereInput;
};

export type FinancialRechargeUpdateManyWithoutUserExecutedNestedInput = {
  connect?: InputMaybe<Array<FinancialRechargeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinancialRechargeCreateOrConnectWithoutUserExecutedInput>>;
  create?: InputMaybe<Array<FinancialRechargeCreateWithoutUserExecutedInput>>;
  createMany?: InputMaybe<FinancialRechargeCreateManyUserExecutedInputEnvelope>;
  delete?: InputMaybe<Array<FinancialRechargeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FinancialRechargeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FinancialRechargeWhereUniqueInput>>;
  set?: InputMaybe<Array<FinancialRechargeWhereUniqueInput>>;
  update?: InputMaybe<Array<FinancialRechargeUpdateWithWhereUniqueWithoutUserExecutedInput>>;
  updateMany?: InputMaybe<Array<FinancialRechargeUpdateManyWithWhereWithoutUserExecutedInput>>;
  upsert?: InputMaybe<Array<FinancialRechargeUpsertWithWhereUniqueWithoutUserExecutedInput>>;
};

export type FinancialRechargeUpdateOneWithoutFinancialPaymentNestedInput = {
  connect?: InputMaybe<FinancialRechargeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FinancialRechargeCreateOrConnectWithoutFinancialPaymentInput>;
  create?: InputMaybe<FinancialRechargeCreateWithoutFinancialPaymentInput>;
  delete?: InputMaybe<FinancialRechargeWhereInput>;
  disconnect?: InputMaybe<FinancialRechargeWhereInput>;
  update?: InputMaybe<FinancialRechargeUpdateToOneWithWhereWithoutFinancialPaymentInput>;
  upsert?: InputMaybe<FinancialRechargeUpsertWithoutFinancialPaymentInput>;
};

export type FinancialRechargeUpdateToOneWithWhereWithoutFinancialPaymentInput = {
  data: FinancialRechargeUpdateWithoutFinancialPaymentInput;
  where?: InputMaybe<FinancialRechargeWhereInput>;
};

export type FinancialRechargeUpdateWithWhereUniqueWithoutUserExecutedInput = {
  data: FinancialRechargeUpdateWithoutUserExecutedInput;
  where: FinancialRechargeWhereUniqueInput;
};

export type FinancialRechargeUpdateWithoutFinancialPaymentInput = {
  UserExecuted?: InputMaybe<CommonUserUpdateOneRequiredWithoutRechargesNestedInput>;
  cost?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsType?: InputMaybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
  providerResponse?: InputMaybe<Scalars['Json']['input']>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type FinancialRechargeUpdateWithoutUserExecutedInput = {
  FinancialPayment?: InputMaybe<FinancialPaymentUpdateOneRequiredWithoutRechargeNestedInput>;
  cost?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  creditsCount?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsType?: InputMaybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
  providerResponse?: InputMaybe<Scalars['Json']['input']>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type FinancialRechargeUpsertWithWhereUniqueWithoutUserExecutedInput = {
  create: FinancialRechargeCreateWithoutUserExecutedInput;
  update: FinancialRechargeUpdateWithoutUserExecutedInput;
  where: FinancialRechargeWhereUniqueInput;
};

export type FinancialRechargeUpsertWithoutFinancialPaymentInput = {
  create: FinancialRechargeCreateWithoutFinancialPaymentInput;
  update: FinancialRechargeUpdateWithoutFinancialPaymentInput;
  where?: InputMaybe<FinancialRechargeWhereInput>;
};

export type FinancialRechargeWhereInput = {
  AND?: InputMaybe<Array<FinancialRechargeWhereInput>>;
  FinancialPayment?: InputMaybe<FinancialPaymentWhereInput>;
  NOT?: InputMaybe<Array<FinancialRechargeWhereInput>>;
  OR?: InputMaybe<Array<FinancialRechargeWhereInput>>;
  UserExecuted?: InputMaybe<CommonUserWhereInput>;
  cost?: InputMaybe<DecimalFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creditsCount?: InputMaybe<IntFilter>;
  creditsType?: InputMaybe<EnumFinancialChargeableServiceFilter>;
  id?: InputMaybe<IntFilter>;
  paymentId?: InputMaybe<StringFilter>;
  providerResponse?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userExecutedId?: InputMaybe<IntFilter>;
};

export type FinancialRechargeWhereUniqueInput = {
  AND?: InputMaybe<Array<FinancialRechargeWhereInput>>;
  FinancialPayment?: InputMaybe<FinancialPaymentWhereInput>;
  NOT?: InputMaybe<Array<FinancialRechargeWhereInput>>;
  OR?: InputMaybe<Array<FinancialRechargeWhereInput>>;
  UserExecuted?: InputMaybe<CommonUserWhereInput>;
  cost?: InputMaybe<DecimalFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creditsCount?: InputMaybe<IntFilter>;
  creditsType?: InputMaybe<EnumFinancialChargeableServiceFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  providerResponse?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userExecutedId?: InputMaybe<IntFilter>;
};

export type FinancialTeamCostConfig = {
  __typename?: 'FinancialTeamCostConfig';
  TeamWallet: FinancialTeamWallet;
  cost: Scalars['Decimal']['output'];
  id: Scalars['Int']['output'];
  service: FinancialChargeableService;
  teamId: Scalars['Int']['output'];
};

export type FinancialTeamCostConfigAvgOrderByAggregateInput = {
  cost?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type FinancialTeamCostConfigCountOrderByAggregateInput = {
  cost?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  service?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type FinancialTeamCostConfigCreateInput = {
  TeamWallet: FinancialTeamWalletCreateNestedOneWithoutTeamCostConfigsInput;
  cost: Scalars['Decimal']['input'];
  service: FinancialChargeableService;
};

export type FinancialTeamCostConfigCreateManyInput = {
  cost: Scalars['Decimal']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  service: FinancialChargeableService;
  teamId: Scalars['Int']['input'];
};

export type FinancialTeamCostConfigCreateManyTeamWalletInput = {
  cost: Scalars['Decimal']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  service: FinancialChargeableService;
};

export type FinancialTeamCostConfigCreateManyTeamWalletInputEnvelope = {
  data: Array<FinancialTeamCostConfigCreateManyTeamWalletInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FinancialTeamCostConfigCreateNestedManyWithoutTeamWalletInput = {
  connect?: InputMaybe<Array<FinancialTeamCostConfigWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinancialTeamCostConfigCreateOrConnectWithoutTeamWalletInput>>;
  create?: InputMaybe<Array<FinancialTeamCostConfigCreateWithoutTeamWalletInput>>;
  createMany?: InputMaybe<FinancialTeamCostConfigCreateManyTeamWalletInputEnvelope>;
};

export type FinancialTeamCostConfigCreateOrConnectWithoutTeamWalletInput = {
  create: FinancialTeamCostConfigCreateWithoutTeamWalletInput;
  where: FinancialTeamCostConfigWhereUniqueInput;
};

export type FinancialTeamCostConfigCreateWithoutTeamWalletInput = {
  cost: Scalars['Decimal']['input'];
  service: FinancialChargeableService;
};

export type FinancialTeamCostConfigListRelationFilter = {
  every?: InputMaybe<FinancialTeamCostConfigWhereInput>;
  none?: InputMaybe<FinancialTeamCostConfigWhereInput>;
  some?: InputMaybe<FinancialTeamCostConfigWhereInput>;
};

export type FinancialTeamCostConfigMaxOrderByAggregateInput = {
  cost?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  service?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type FinancialTeamCostConfigMinOrderByAggregateInput = {
  cost?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  service?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type FinancialTeamCostConfigOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FinancialTeamCostConfigOrderByWithAggregationInput = {
  _avg?: InputMaybe<FinancialTeamCostConfigAvgOrderByAggregateInput>;
  _count?: InputMaybe<FinancialTeamCostConfigCountOrderByAggregateInput>;
  _max?: InputMaybe<FinancialTeamCostConfigMaxOrderByAggregateInput>;
  _min?: InputMaybe<FinancialTeamCostConfigMinOrderByAggregateInput>;
  _sum?: InputMaybe<FinancialTeamCostConfigSumOrderByAggregateInput>;
  cost?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  service?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type FinancialTeamCostConfigOrderByWithRelationInput = {
  TeamWallet?: InputMaybe<FinancialTeamWalletOrderByWithRelationInput>;
  cost?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  service?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export enum FinancialTeamCostConfigScalarFieldEnum {
  Cost = 'cost',
  Id = 'id',
  Service = 'service',
  TeamId = 'teamId'
}

export type FinancialTeamCostConfigScalarWhereInput = {
  AND?: InputMaybe<Array<FinancialTeamCostConfigScalarWhereInput>>;
  NOT?: InputMaybe<Array<FinancialTeamCostConfigScalarWhereInput>>;
  OR?: InputMaybe<Array<FinancialTeamCostConfigScalarWhereInput>>;
  cost?: InputMaybe<DecimalFilter>;
  id?: InputMaybe<IntFilter>;
  service?: InputMaybe<EnumFinancialChargeableServiceFilter>;
  teamId?: InputMaybe<IntFilter>;
};

export type FinancialTeamCostConfigScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<FinancialTeamCostConfigScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<FinancialTeamCostConfigScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<FinancialTeamCostConfigScalarWhereWithAggregatesInput>>;
  cost?: InputMaybe<DecimalWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  service?: InputMaybe<EnumFinancialChargeableServiceWithAggregatesFilter>;
  teamId?: InputMaybe<IntWithAggregatesFilter>;
};

export type FinancialTeamCostConfigSumOrderByAggregateInput = {
  cost?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type FinancialTeamCostConfigTeamIdServiceCompoundUniqueInput = {
  service: FinancialChargeableService;
  teamId: Scalars['Int']['input'];
};

export type FinancialTeamCostConfigUpdateInput = {
  TeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneRequiredWithoutTeamCostConfigsNestedInput>;
  cost?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  service?: InputMaybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
};

export type FinancialTeamCostConfigUpdateManyMutationInput = {
  cost?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  service?: InputMaybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
};

export type FinancialTeamCostConfigUpdateManyWithWhereWithoutTeamWalletInput = {
  data: FinancialTeamCostConfigUpdateManyMutationInput;
  where: FinancialTeamCostConfigScalarWhereInput;
};

export type FinancialTeamCostConfigUpdateManyWithoutTeamWalletNestedInput = {
  connect?: InputMaybe<Array<FinancialTeamCostConfigWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinancialTeamCostConfigCreateOrConnectWithoutTeamWalletInput>>;
  create?: InputMaybe<Array<FinancialTeamCostConfigCreateWithoutTeamWalletInput>>;
  createMany?: InputMaybe<FinancialTeamCostConfigCreateManyTeamWalletInputEnvelope>;
  delete?: InputMaybe<Array<FinancialTeamCostConfigWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FinancialTeamCostConfigScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FinancialTeamCostConfigWhereUniqueInput>>;
  set?: InputMaybe<Array<FinancialTeamCostConfigWhereUniqueInput>>;
  update?: InputMaybe<Array<FinancialTeamCostConfigUpdateWithWhereUniqueWithoutTeamWalletInput>>;
  updateMany?: InputMaybe<Array<FinancialTeamCostConfigUpdateManyWithWhereWithoutTeamWalletInput>>;
  upsert?: InputMaybe<Array<FinancialTeamCostConfigUpsertWithWhereUniqueWithoutTeamWalletInput>>;
};

export type FinancialTeamCostConfigUpdateWithWhereUniqueWithoutTeamWalletInput = {
  data: FinancialTeamCostConfigUpdateWithoutTeamWalletInput;
  where: FinancialTeamCostConfigWhereUniqueInput;
};

export type FinancialTeamCostConfigUpdateWithoutTeamWalletInput = {
  cost?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  service?: InputMaybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
};

export type FinancialTeamCostConfigUpsertWithWhereUniqueWithoutTeamWalletInput = {
  create: FinancialTeamCostConfigCreateWithoutTeamWalletInput;
  update: FinancialTeamCostConfigUpdateWithoutTeamWalletInput;
  where: FinancialTeamCostConfigWhereUniqueInput;
};

export type FinancialTeamCostConfigWhereInput = {
  AND?: InputMaybe<Array<FinancialTeamCostConfigWhereInput>>;
  NOT?: InputMaybe<Array<FinancialTeamCostConfigWhereInput>>;
  OR?: InputMaybe<Array<FinancialTeamCostConfigWhereInput>>;
  TeamWallet?: InputMaybe<FinancialTeamWalletWhereInput>;
  cost?: InputMaybe<DecimalFilter>;
  id?: InputMaybe<IntFilter>;
  service?: InputMaybe<EnumFinancialChargeableServiceFilter>;
  teamId?: InputMaybe<IntFilter>;
};

export type FinancialTeamCostConfigWhereUniqueInput = {
  AND?: InputMaybe<Array<FinancialTeamCostConfigWhereInput>>;
  NOT?: InputMaybe<Array<FinancialTeamCostConfigWhereInput>>;
  OR?: InputMaybe<Array<FinancialTeamCostConfigWhereInput>>;
  TeamWallet?: InputMaybe<FinancialTeamWalletWhereInput>;
  cost?: InputMaybe<DecimalFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  service?: InputMaybe<EnumFinancialChargeableServiceFilter>;
  teamId?: InputMaybe<IntFilter>;
  teamId_service?: InputMaybe<FinancialTeamCostConfigTeamIdServiceCompoundUniqueInput>;
};

/**
 * Must be deleted after payment.
 * It will help to pay after
 */
export type FinancialTeamSignupSelectedOptions = {
  __typename?: 'FinancialTeamSignupSelectedOptions';
  TeamWallet: FinancialTeamWallet;
  billingCycle: FinancialBillingCycle;
  financialTotal: Scalars['Int']['output'];
  plan: FinancialPlan;
  quantity: Scalars['Int']['output'];
  typeSign: FinancialChargeableService;
  walletId: Scalars['Int']['output'];
};

export type FinancialTeamSignupSelectedOptionsAvgOrderByAggregateInput = {
  financialTotal?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  walletId?: InputMaybe<SortOrder>;
};

export type FinancialTeamSignupSelectedOptionsCountOrderByAggregateInput = {
  billingCycle?: InputMaybe<SortOrder>;
  financialTotal?: InputMaybe<SortOrder>;
  plan?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  typeSign?: InputMaybe<SortOrder>;
  walletId?: InputMaybe<SortOrder>;
};

export type FinancialTeamSignupSelectedOptionsCreateInput = {
  TeamWallet: FinancialTeamWalletCreateNestedOneWithoutTeamSignupSelectedOptionsInput;
  billingCycle: FinancialBillingCycle;
  financialTotal: Scalars['Int']['input'];
  plan: FinancialPlan;
  quantity: Scalars['Int']['input'];
  typeSign: FinancialChargeableService;
};

export type FinancialTeamSignupSelectedOptionsCreateManyInput = {
  billingCycle: FinancialBillingCycle;
  financialTotal: Scalars['Int']['input'];
  plan: FinancialPlan;
  quantity: Scalars['Int']['input'];
  typeSign: FinancialChargeableService;
  walletId: Scalars['Int']['input'];
};

export type FinancialTeamSignupSelectedOptionsCreateManyTeamWalletInput = {
  billingCycle: FinancialBillingCycle;
  financialTotal: Scalars['Int']['input'];
  plan: FinancialPlan;
  quantity: Scalars['Int']['input'];
  typeSign: FinancialChargeableService;
};

export type FinancialTeamSignupSelectedOptionsCreateManyTeamWalletInputEnvelope = {
  data: Array<FinancialTeamSignupSelectedOptionsCreateManyTeamWalletInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FinancialTeamSignupSelectedOptionsCreateNestedManyWithoutTeamWalletInput = {
  connect?: InputMaybe<Array<FinancialTeamSignupSelectedOptionsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinancialTeamSignupSelectedOptionsCreateOrConnectWithoutTeamWalletInput>>;
  create?: InputMaybe<Array<FinancialTeamSignupSelectedOptionsCreateWithoutTeamWalletInput>>;
  createMany?: InputMaybe<FinancialTeamSignupSelectedOptionsCreateManyTeamWalletInputEnvelope>;
};

export type FinancialTeamSignupSelectedOptionsCreateOrConnectWithoutTeamWalletInput = {
  create: FinancialTeamSignupSelectedOptionsCreateWithoutTeamWalletInput;
  where: FinancialTeamSignupSelectedOptionsWhereUniqueInput;
};

export type FinancialTeamSignupSelectedOptionsCreateWithoutTeamWalletInput = {
  billingCycle: FinancialBillingCycle;
  financialTotal: Scalars['Int']['input'];
  plan: FinancialPlan;
  quantity: Scalars['Int']['input'];
  typeSign: FinancialChargeableService;
};

export type FinancialTeamSignupSelectedOptionsListRelationFilter = {
  every?: InputMaybe<FinancialTeamSignupSelectedOptionsWhereInput>;
  none?: InputMaybe<FinancialTeamSignupSelectedOptionsWhereInput>;
  some?: InputMaybe<FinancialTeamSignupSelectedOptionsWhereInput>;
};

export type FinancialTeamSignupSelectedOptionsMaxOrderByAggregateInput = {
  billingCycle?: InputMaybe<SortOrder>;
  financialTotal?: InputMaybe<SortOrder>;
  plan?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  typeSign?: InputMaybe<SortOrder>;
  walletId?: InputMaybe<SortOrder>;
};

export type FinancialTeamSignupSelectedOptionsMinOrderByAggregateInput = {
  billingCycle?: InputMaybe<SortOrder>;
  financialTotal?: InputMaybe<SortOrder>;
  plan?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  typeSign?: InputMaybe<SortOrder>;
  walletId?: InputMaybe<SortOrder>;
};

export type FinancialTeamSignupSelectedOptionsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FinancialTeamSignupSelectedOptionsOrderByWithAggregationInput = {
  _avg?: InputMaybe<FinancialTeamSignupSelectedOptionsAvgOrderByAggregateInput>;
  _count?: InputMaybe<FinancialTeamSignupSelectedOptionsCountOrderByAggregateInput>;
  _max?: InputMaybe<FinancialTeamSignupSelectedOptionsMaxOrderByAggregateInput>;
  _min?: InputMaybe<FinancialTeamSignupSelectedOptionsMinOrderByAggregateInput>;
  _sum?: InputMaybe<FinancialTeamSignupSelectedOptionsSumOrderByAggregateInput>;
  billingCycle?: InputMaybe<SortOrder>;
  financialTotal?: InputMaybe<SortOrder>;
  plan?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  typeSign?: InputMaybe<SortOrder>;
  walletId?: InputMaybe<SortOrder>;
};

export type FinancialTeamSignupSelectedOptionsOrderByWithRelationInput = {
  TeamWallet?: InputMaybe<FinancialTeamWalletOrderByWithRelationInput>;
  billingCycle?: InputMaybe<SortOrder>;
  financialTotal?: InputMaybe<SortOrder>;
  plan?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  typeSign?: InputMaybe<SortOrder>;
  walletId?: InputMaybe<SortOrder>;
};

export enum FinancialTeamSignupSelectedOptionsScalarFieldEnum {
  BillingCycle = 'billingCycle',
  FinancialTotal = 'financialTotal',
  Plan = 'plan',
  Quantity = 'quantity',
  TypeSign = 'typeSign',
  WalletId = 'walletId'
}

export type FinancialTeamSignupSelectedOptionsScalarWhereInput = {
  AND?: InputMaybe<Array<FinancialTeamSignupSelectedOptionsScalarWhereInput>>;
  NOT?: InputMaybe<Array<FinancialTeamSignupSelectedOptionsScalarWhereInput>>;
  OR?: InputMaybe<Array<FinancialTeamSignupSelectedOptionsScalarWhereInput>>;
  billingCycle?: InputMaybe<EnumFinancialBillingCycleFilter>;
  financialTotal?: InputMaybe<IntFilter>;
  plan?: InputMaybe<EnumFinancialPlanFilter>;
  quantity?: InputMaybe<IntFilter>;
  typeSign?: InputMaybe<EnumFinancialChargeableServiceFilter>;
  walletId?: InputMaybe<IntFilter>;
};

export type FinancialTeamSignupSelectedOptionsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<FinancialTeamSignupSelectedOptionsScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<FinancialTeamSignupSelectedOptionsScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<FinancialTeamSignupSelectedOptionsScalarWhereWithAggregatesInput>>;
  billingCycle?: InputMaybe<EnumFinancialBillingCycleWithAggregatesFilter>;
  financialTotal?: InputMaybe<IntWithAggregatesFilter>;
  plan?: InputMaybe<EnumFinancialPlanWithAggregatesFilter>;
  quantity?: InputMaybe<IntWithAggregatesFilter>;
  typeSign?: InputMaybe<EnumFinancialChargeableServiceWithAggregatesFilter>;
  walletId?: InputMaybe<IntWithAggregatesFilter>;
};

export type FinancialTeamSignupSelectedOptionsSumOrderByAggregateInput = {
  financialTotal?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  walletId?: InputMaybe<SortOrder>;
};

export type FinancialTeamSignupSelectedOptionsUpdateInput = {
  TeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneRequiredWithoutTeamSignupSelectedOptionsNestedInput>;
  billingCycle?: InputMaybe<EnumFinancialBillingCycleFieldUpdateOperationsInput>;
  financialTotal?: InputMaybe<IntFieldUpdateOperationsInput>;
  plan?: InputMaybe<EnumFinancialPlanFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  typeSign?: InputMaybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
};

export type FinancialTeamSignupSelectedOptionsUpdateManyMutationInput = {
  billingCycle?: InputMaybe<EnumFinancialBillingCycleFieldUpdateOperationsInput>;
  financialTotal?: InputMaybe<IntFieldUpdateOperationsInput>;
  plan?: InputMaybe<EnumFinancialPlanFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  typeSign?: InputMaybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
};

export type FinancialTeamSignupSelectedOptionsUpdateManyWithWhereWithoutTeamWalletInput = {
  data: FinancialTeamSignupSelectedOptionsUpdateManyMutationInput;
  where: FinancialTeamSignupSelectedOptionsScalarWhereInput;
};

export type FinancialTeamSignupSelectedOptionsUpdateManyWithoutTeamWalletNestedInput = {
  connect?: InputMaybe<Array<FinancialTeamSignupSelectedOptionsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinancialTeamSignupSelectedOptionsCreateOrConnectWithoutTeamWalletInput>>;
  create?: InputMaybe<Array<FinancialTeamSignupSelectedOptionsCreateWithoutTeamWalletInput>>;
  createMany?: InputMaybe<FinancialTeamSignupSelectedOptionsCreateManyTeamWalletInputEnvelope>;
  delete?: InputMaybe<Array<FinancialTeamSignupSelectedOptionsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FinancialTeamSignupSelectedOptionsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FinancialTeamSignupSelectedOptionsWhereUniqueInput>>;
  set?: InputMaybe<Array<FinancialTeamSignupSelectedOptionsWhereUniqueInput>>;
  update?: InputMaybe<Array<FinancialTeamSignupSelectedOptionsUpdateWithWhereUniqueWithoutTeamWalletInput>>;
  updateMany?: InputMaybe<Array<FinancialTeamSignupSelectedOptionsUpdateManyWithWhereWithoutTeamWalletInput>>;
  upsert?: InputMaybe<Array<FinancialTeamSignupSelectedOptionsUpsertWithWhereUniqueWithoutTeamWalletInput>>;
};

export type FinancialTeamSignupSelectedOptionsUpdateWithWhereUniqueWithoutTeamWalletInput = {
  data: FinancialTeamSignupSelectedOptionsUpdateWithoutTeamWalletInput;
  where: FinancialTeamSignupSelectedOptionsWhereUniqueInput;
};

export type FinancialTeamSignupSelectedOptionsUpdateWithoutTeamWalletInput = {
  billingCycle?: InputMaybe<EnumFinancialBillingCycleFieldUpdateOperationsInput>;
  financialTotal?: InputMaybe<IntFieldUpdateOperationsInput>;
  plan?: InputMaybe<EnumFinancialPlanFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  typeSign?: InputMaybe<EnumFinancialChargeableServiceFieldUpdateOperationsInput>;
};

export type FinancialTeamSignupSelectedOptionsUpsertWithWhereUniqueWithoutTeamWalletInput = {
  create: FinancialTeamSignupSelectedOptionsCreateWithoutTeamWalletInput;
  update: FinancialTeamSignupSelectedOptionsUpdateWithoutTeamWalletInput;
  where: FinancialTeamSignupSelectedOptionsWhereUniqueInput;
};

export type FinancialTeamSignupSelectedOptionsWhereInput = {
  AND?: InputMaybe<Array<FinancialTeamSignupSelectedOptionsWhereInput>>;
  NOT?: InputMaybe<Array<FinancialTeamSignupSelectedOptionsWhereInput>>;
  OR?: InputMaybe<Array<FinancialTeamSignupSelectedOptionsWhereInput>>;
  TeamWallet?: InputMaybe<FinancialTeamWalletWhereInput>;
  billingCycle?: InputMaybe<EnumFinancialBillingCycleFilter>;
  financialTotal?: InputMaybe<IntFilter>;
  plan?: InputMaybe<EnumFinancialPlanFilter>;
  quantity?: InputMaybe<IntFilter>;
  typeSign?: InputMaybe<EnumFinancialChargeableServiceFilter>;
  walletId?: InputMaybe<IntFilter>;
};

export type FinancialTeamSignupSelectedOptionsWhereUniqueInput = {
  AND?: InputMaybe<Array<FinancialTeamSignupSelectedOptionsWhereInput>>;
  NOT?: InputMaybe<Array<FinancialTeamSignupSelectedOptionsWhereInput>>;
  OR?: InputMaybe<Array<FinancialTeamSignupSelectedOptionsWhereInput>>;
  TeamWallet?: InputMaybe<FinancialTeamWalletWhereInput>;
  billingCycle?: InputMaybe<EnumFinancialBillingCycleFilter>;
  financialTotal?: InputMaybe<IntFilter>;
  plan?: InputMaybe<EnumFinancialPlanFilter>;
  quantity?: InputMaybe<IntFilter>;
  typeSign?: InputMaybe<EnumFinancialChargeableServiceFilter>;
  walletId?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Stores the current plan of the team and the amount of credits (of each type)
 * Must be created at financial choose after account creation
 * The "Trial" must be blocked if user has already a Wallet
 * More "powerful" credits can be used to generate less powerful certificates. Its because sometime users can choose a bigger plan because of other type of functionalities thats not because of the certificate signature type
 */
export type FinancialTeamWallet = {
  __typename?: 'FinancialTeamWallet';
  Charges: Array<FinancialCharge>;
  CreditCardSaveds: Array<FinancialCreditCardSaved>;
  Payments: Array<FinancialPayment>;
  SubscriptionActive?: Maybe<FinancialTeamWalletSubscription>;
  Subscriptions: Array<FinancialTeamWalletSubscription>;
  Team: Team;
  TeamCostConfigs: Array<FinancialTeamCostConfig>;
  TeamSignupSelectedOptions: Array<FinancialTeamSignupSelectedOptions>;
  /** For RB signed certificates (and visual) */
  creditsDetachedRb: Scalars['Int']['output'];
  /** For RT and RA signed certificates (and any other) */
  creditsDetachedRtRa: Scalars['Int']['output'];
  /**
   * -- Detached credits --
   * These credits needs to warn-popup-notify users when used to generate cheaper certificates
   * For visual signed certificates (and only visual)
   */
  creditsDetachedVisual: Scalars['Int']['output'];
  creditsPlanRb: Scalars['Int']['output'];
  creditsPlanRtRa: Scalars['Int']['output'];
  /**
   * -- Plan credits --
   * Are credits that are incremented in at plan payment
   * Different from the others, these credits will not warn-popup-notify users when used to generate cheaper certificates
   * Credits for visual signed certificates with watermark (and only visual)
   */
  creditsPlanTrial: Scalars['Int']['output'];
  creditsPlanVisual: Scalars['Int']['output'];
  financialProviderCustomerId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  teamId: Scalars['Int']['output'];
};


/**
 * Stores the current plan of the team and the amount of credits (of each type)
 * Must be created at financial choose after account creation
 * The "Trial" must be blocked if user has already a Wallet
 * More "powerful" credits can be used to generate less powerful certificates. Its because sometime users can choose a bigger plan because of other type of functionalities thats not because of the certificate signature type
 */
export type FinancialTeamWalletChargesArgs = {
  cursor?: InputMaybe<FinancialChargeWhereUniqueInput>;
  distinct?: InputMaybe<Array<FinancialChargeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FinancialChargeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FinancialChargeWhereInput>;
};


/**
 * Stores the current plan of the team and the amount of credits (of each type)
 * Must be created at financial choose after account creation
 * The "Trial" must be blocked if user has already a Wallet
 * More "powerful" credits can be used to generate less powerful certificates. Its because sometime users can choose a bigger plan because of other type of functionalities thats not because of the certificate signature type
 */
export type FinancialTeamWalletCreditCardSavedsArgs = {
  cursor?: InputMaybe<FinancialCreditCardSavedWhereUniqueInput>;
  distinct?: InputMaybe<Array<FinancialCreditCardSavedScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FinancialCreditCardSavedOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FinancialCreditCardSavedWhereInput>;
};


/**
 * Stores the current plan of the team and the amount of credits (of each type)
 * Must be created at financial choose after account creation
 * The "Trial" must be blocked if user has already a Wallet
 * More "powerful" credits can be used to generate less powerful certificates. Its because sometime users can choose a bigger plan because of other type of functionalities thats not because of the certificate signature type
 */
export type FinancialTeamWalletPaymentsArgs = {
  cursor?: InputMaybe<FinancialPaymentWhereUniqueInput>;
  distinct?: InputMaybe<Array<FinancialPaymentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FinancialPaymentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FinancialPaymentWhereInput>;
};


/**
 * Stores the current plan of the team and the amount of credits (of each type)
 * Must be created at financial choose after account creation
 * The "Trial" must be blocked if user has already a Wallet
 * More "powerful" credits can be used to generate less powerful certificates. Its because sometime users can choose a bigger plan because of other type of functionalities thats not because of the certificate signature type
 */
export type FinancialTeamWalletSubscriptionsArgs = {
  cursor?: InputMaybe<FinancialTeamWalletSubscriptionWhereUniqueInput>;
  distinct?: InputMaybe<Array<FinancialTeamWalletSubscriptionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FinancialTeamWalletSubscriptionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FinancialTeamWalletSubscriptionWhereInput>;
};


/**
 * Stores the current plan of the team and the amount of credits (of each type)
 * Must be created at financial choose after account creation
 * The "Trial" must be blocked if user has already a Wallet
 * More "powerful" credits can be used to generate less powerful certificates. Its because sometime users can choose a bigger plan because of other type of functionalities thats not because of the certificate signature type
 */
export type FinancialTeamWalletTeamCostConfigsArgs = {
  cursor?: InputMaybe<FinancialTeamCostConfigWhereUniqueInput>;
  distinct?: InputMaybe<Array<FinancialTeamCostConfigScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FinancialTeamCostConfigOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FinancialTeamCostConfigWhereInput>;
};


/**
 * Stores the current plan of the team and the amount of credits (of each type)
 * Must be created at financial choose after account creation
 * The "Trial" must be blocked if user has already a Wallet
 * More "powerful" credits can be used to generate less powerful certificates. Its because sometime users can choose a bigger plan because of other type of functionalities thats not because of the certificate signature type
 */
export type FinancialTeamWalletTeamSignupSelectedOptionsArgs = {
  cursor?: InputMaybe<FinancialTeamSignupSelectedOptionsWhereUniqueInput>;
  distinct?: InputMaybe<Array<FinancialTeamSignupSelectedOptionsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FinancialTeamSignupSelectedOptionsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FinancialTeamSignupSelectedOptionsWhereInput>;
};

export type FinancialTeamWalletAvgOrderByAggregateInput = {
  creditsDetachedRb?: InputMaybe<SortOrder>;
  creditsDetachedRtRa?: InputMaybe<SortOrder>;
  creditsDetachedVisual?: InputMaybe<SortOrder>;
  creditsPlanRb?: InputMaybe<SortOrder>;
  creditsPlanRtRa?: InputMaybe<SortOrder>;
  creditsPlanTrial?: InputMaybe<SortOrder>;
  creditsPlanVisual?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletCountOrderByAggregateInput = {
  creditsDetachedRb?: InputMaybe<SortOrder>;
  creditsDetachedRtRa?: InputMaybe<SortOrder>;
  creditsDetachedVisual?: InputMaybe<SortOrder>;
  creditsPlanRb?: InputMaybe<SortOrder>;
  creditsPlanRtRa?: InputMaybe<SortOrder>;
  creditsPlanTrial?: InputMaybe<SortOrder>;
  creditsPlanVisual?: InputMaybe<SortOrder>;
  financialProviderCustomerId?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletCreateInput = {
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutTeamWalletInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutTeamWalletInput>;
  Payments?: InputMaybe<FinancialPaymentCreateNestedManyWithoutTeamWalletInput>;
  Subscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutTeamWalletInput>;
  Team: TeamCreateNestedOneWithoutFinancialTeamWalletInput;
  TeamCostConfigs?: InputMaybe<FinancialTeamCostConfigCreateNestedManyWithoutTeamWalletInput>;
  TeamSignupSelectedOptions?: InputMaybe<FinancialTeamSignupSelectedOptionsCreateNestedManyWithoutTeamWalletInput>;
  creditsDetachedRb?: InputMaybe<Scalars['Int']['input']>;
  creditsDetachedRtRa?: InputMaybe<Scalars['Int']['input']>;
  creditsDetachedVisual?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanRb?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanRtRa?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanTrial?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanVisual?: InputMaybe<Scalars['Int']['input']>;
  financialProviderCustomerId?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialTeamWalletCreateManyInput = {
  creditsDetachedRb?: InputMaybe<Scalars['Int']['input']>;
  creditsDetachedRtRa?: InputMaybe<Scalars['Int']['input']>;
  creditsDetachedVisual?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanRb?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanRtRa?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanTrial?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanVisual?: InputMaybe<Scalars['Int']['input']>;
  financialProviderCustomerId?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type FinancialTeamWalletCreateNestedOneWithoutChargesInput = {
  connect?: InputMaybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FinancialTeamWalletCreateOrConnectWithoutChargesInput>;
  create?: InputMaybe<FinancialTeamWalletCreateWithoutChargesInput>;
};

export type FinancialTeamWalletCreateNestedOneWithoutCreditCardSavedsInput = {
  connect?: InputMaybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FinancialTeamWalletCreateOrConnectWithoutCreditCardSavedsInput>;
  create?: InputMaybe<FinancialTeamWalletCreateWithoutCreditCardSavedsInput>;
};

export type FinancialTeamWalletCreateNestedOneWithoutPaymentsInput = {
  connect?: InputMaybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FinancialTeamWalletCreateOrConnectWithoutPaymentsInput>;
  create?: InputMaybe<FinancialTeamWalletCreateWithoutPaymentsInput>;
};

export type FinancialTeamWalletCreateNestedOneWithoutSubscriptionsInput = {
  connect?: InputMaybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FinancialTeamWalletCreateOrConnectWithoutSubscriptionsInput>;
  create?: InputMaybe<FinancialTeamWalletCreateWithoutSubscriptionsInput>;
};

export type FinancialTeamWalletCreateNestedOneWithoutTeamCostConfigsInput = {
  connect?: InputMaybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FinancialTeamWalletCreateOrConnectWithoutTeamCostConfigsInput>;
  create?: InputMaybe<FinancialTeamWalletCreateWithoutTeamCostConfigsInput>;
};

export type FinancialTeamWalletCreateNestedOneWithoutTeamInput = {
  connect?: InputMaybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FinancialTeamWalletCreateOrConnectWithoutTeamInput>;
  create?: InputMaybe<FinancialTeamWalletCreateWithoutTeamInput>;
};

export type FinancialTeamWalletCreateNestedOneWithoutTeamSignupSelectedOptionsInput = {
  connect?: InputMaybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FinancialTeamWalletCreateOrConnectWithoutTeamSignupSelectedOptionsInput>;
  create?: InputMaybe<FinancialTeamWalletCreateWithoutTeamSignupSelectedOptionsInput>;
};

export type FinancialTeamWalletCreateOrConnectWithoutChargesInput = {
  create: FinancialTeamWalletCreateWithoutChargesInput;
  where: FinancialTeamWalletWhereUniqueInput;
};

export type FinancialTeamWalletCreateOrConnectWithoutCreditCardSavedsInput = {
  create: FinancialTeamWalletCreateWithoutCreditCardSavedsInput;
  where: FinancialTeamWalletWhereUniqueInput;
};

export type FinancialTeamWalletCreateOrConnectWithoutPaymentsInput = {
  create: FinancialTeamWalletCreateWithoutPaymentsInput;
  where: FinancialTeamWalletWhereUniqueInput;
};

export type FinancialTeamWalletCreateOrConnectWithoutSubscriptionsInput = {
  create: FinancialTeamWalletCreateWithoutSubscriptionsInput;
  where: FinancialTeamWalletWhereUniqueInput;
};

export type FinancialTeamWalletCreateOrConnectWithoutTeamCostConfigsInput = {
  create: FinancialTeamWalletCreateWithoutTeamCostConfigsInput;
  where: FinancialTeamWalletWhereUniqueInput;
};

export type FinancialTeamWalletCreateOrConnectWithoutTeamInput = {
  create: FinancialTeamWalletCreateWithoutTeamInput;
  where: FinancialTeamWalletWhereUniqueInput;
};

export type FinancialTeamWalletCreateOrConnectWithoutTeamSignupSelectedOptionsInput = {
  create: FinancialTeamWalletCreateWithoutTeamSignupSelectedOptionsInput;
  where: FinancialTeamWalletWhereUniqueInput;
};

export type FinancialTeamWalletCreateWithoutChargesInput = {
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutTeamWalletInput>;
  Payments?: InputMaybe<FinancialPaymentCreateNestedManyWithoutTeamWalletInput>;
  Subscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutTeamWalletInput>;
  Team: TeamCreateNestedOneWithoutFinancialTeamWalletInput;
  TeamCostConfigs?: InputMaybe<FinancialTeamCostConfigCreateNestedManyWithoutTeamWalletInput>;
  TeamSignupSelectedOptions?: InputMaybe<FinancialTeamSignupSelectedOptionsCreateNestedManyWithoutTeamWalletInput>;
  creditsDetachedRb?: InputMaybe<Scalars['Int']['input']>;
  creditsDetachedRtRa?: InputMaybe<Scalars['Int']['input']>;
  creditsDetachedVisual?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanRb?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanRtRa?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanTrial?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanVisual?: InputMaybe<Scalars['Int']['input']>;
  financialProviderCustomerId?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialTeamWalletCreateWithoutCreditCardSavedsInput = {
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutTeamWalletInput>;
  Payments?: InputMaybe<FinancialPaymentCreateNestedManyWithoutTeamWalletInput>;
  Subscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutTeamWalletInput>;
  Team: TeamCreateNestedOneWithoutFinancialTeamWalletInput;
  TeamCostConfigs?: InputMaybe<FinancialTeamCostConfigCreateNestedManyWithoutTeamWalletInput>;
  TeamSignupSelectedOptions?: InputMaybe<FinancialTeamSignupSelectedOptionsCreateNestedManyWithoutTeamWalletInput>;
  creditsDetachedRb?: InputMaybe<Scalars['Int']['input']>;
  creditsDetachedRtRa?: InputMaybe<Scalars['Int']['input']>;
  creditsDetachedVisual?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanRb?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanRtRa?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanTrial?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanVisual?: InputMaybe<Scalars['Int']['input']>;
  financialProviderCustomerId?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialTeamWalletCreateWithoutPaymentsInput = {
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutTeamWalletInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutTeamWalletInput>;
  Subscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutTeamWalletInput>;
  Team: TeamCreateNestedOneWithoutFinancialTeamWalletInput;
  TeamCostConfigs?: InputMaybe<FinancialTeamCostConfigCreateNestedManyWithoutTeamWalletInput>;
  TeamSignupSelectedOptions?: InputMaybe<FinancialTeamSignupSelectedOptionsCreateNestedManyWithoutTeamWalletInput>;
  creditsDetachedRb?: InputMaybe<Scalars['Int']['input']>;
  creditsDetachedRtRa?: InputMaybe<Scalars['Int']['input']>;
  creditsDetachedVisual?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanRb?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanRtRa?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanTrial?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanVisual?: InputMaybe<Scalars['Int']['input']>;
  financialProviderCustomerId?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialTeamWalletCreateWithoutSubscriptionsInput = {
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutTeamWalletInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutTeamWalletInput>;
  Payments?: InputMaybe<FinancialPaymentCreateNestedManyWithoutTeamWalletInput>;
  Team: TeamCreateNestedOneWithoutFinancialTeamWalletInput;
  TeamCostConfigs?: InputMaybe<FinancialTeamCostConfigCreateNestedManyWithoutTeamWalletInput>;
  TeamSignupSelectedOptions?: InputMaybe<FinancialTeamSignupSelectedOptionsCreateNestedManyWithoutTeamWalletInput>;
  creditsDetachedRb?: InputMaybe<Scalars['Int']['input']>;
  creditsDetachedRtRa?: InputMaybe<Scalars['Int']['input']>;
  creditsDetachedVisual?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanRb?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanRtRa?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanTrial?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanVisual?: InputMaybe<Scalars['Int']['input']>;
  financialProviderCustomerId?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialTeamWalletCreateWithoutTeamCostConfigsInput = {
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutTeamWalletInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutTeamWalletInput>;
  Payments?: InputMaybe<FinancialPaymentCreateNestedManyWithoutTeamWalletInput>;
  Subscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutTeamWalletInput>;
  Team: TeamCreateNestedOneWithoutFinancialTeamWalletInput;
  TeamSignupSelectedOptions?: InputMaybe<FinancialTeamSignupSelectedOptionsCreateNestedManyWithoutTeamWalletInput>;
  creditsDetachedRb?: InputMaybe<Scalars['Int']['input']>;
  creditsDetachedRtRa?: InputMaybe<Scalars['Int']['input']>;
  creditsDetachedVisual?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanRb?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanRtRa?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanTrial?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanVisual?: InputMaybe<Scalars['Int']['input']>;
  financialProviderCustomerId?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialTeamWalletCreateWithoutTeamInput = {
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutTeamWalletInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutTeamWalletInput>;
  Payments?: InputMaybe<FinancialPaymentCreateNestedManyWithoutTeamWalletInput>;
  Subscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutTeamWalletInput>;
  TeamCostConfigs?: InputMaybe<FinancialTeamCostConfigCreateNestedManyWithoutTeamWalletInput>;
  TeamSignupSelectedOptions?: InputMaybe<FinancialTeamSignupSelectedOptionsCreateNestedManyWithoutTeamWalletInput>;
  creditsDetachedRb?: InputMaybe<Scalars['Int']['input']>;
  creditsDetachedRtRa?: InputMaybe<Scalars['Int']['input']>;
  creditsDetachedVisual?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanRb?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanRtRa?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanTrial?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanVisual?: InputMaybe<Scalars['Int']['input']>;
  financialProviderCustomerId?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialTeamWalletCreateWithoutTeamSignupSelectedOptionsInput = {
  Charges?: InputMaybe<FinancialChargeCreateNestedManyWithoutTeamWalletInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedCreateNestedManyWithoutTeamWalletInput>;
  Payments?: InputMaybe<FinancialPaymentCreateNestedManyWithoutTeamWalletInput>;
  Subscriptions?: InputMaybe<FinancialTeamWalletSubscriptionCreateNestedManyWithoutTeamWalletInput>;
  Team: TeamCreateNestedOneWithoutFinancialTeamWalletInput;
  TeamCostConfigs?: InputMaybe<FinancialTeamCostConfigCreateNestedManyWithoutTeamWalletInput>;
  creditsDetachedRb?: InputMaybe<Scalars['Int']['input']>;
  creditsDetachedRtRa?: InputMaybe<Scalars['Int']['input']>;
  creditsDetachedVisual?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanRb?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanRtRa?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanTrial?: InputMaybe<Scalars['Int']['input']>;
  creditsPlanVisual?: InputMaybe<Scalars['Int']['input']>;
  financialProviderCustomerId?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialTeamWalletMaxOrderByAggregateInput = {
  creditsDetachedRb?: InputMaybe<SortOrder>;
  creditsDetachedRtRa?: InputMaybe<SortOrder>;
  creditsDetachedVisual?: InputMaybe<SortOrder>;
  creditsPlanRb?: InputMaybe<SortOrder>;
  creditsPlanRtRa?: InputMaybe<SortOrder>;
  creditsPlanTrial?: InputMaybe<SortOrder>;
  creditsPlanVisual?: InputMaybe<SortOrder>;
  financialProviderCustomerId?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletMinOrderByAggregateInput = {
  creditsDetachedRb?: InputMaybe<SortOrder>;
  creditsDetachedRtRa?: InputMaybe<SortOrder>;
  creditsDetachedVisual?: InputMaybe<SortOrder>;
  creditsPlanRb?: InputMaybe<SortOrder>;
  creditsPlanRtRa?: InputMaybe<SortOrder>;
  creditsPlanTrial?: InputMaybe<SortOrder>;
  creditsPlanVisual?: InputMaybe<SortOrder>;
  financialProviderCustomerId?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletNullableRelationFilter = {
  is?: InputMaybe<FinancialTeamWalletWhereInput>;
  isNot?: InputMaybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletOrderByWithAggregationInput = {
  _avg?: InputMaybe<FinancialTeamWalletAvgOrderByAggregateInput>;
  _count?: InputMaybe<FinancialTeamWalletCountOrderByAggregateInput>;
  _max?: InputMaybe<FinancialTeamWalletMaxOrderByAggregateInput>;
  _min?: InputMaybe<FinancialTeamWalletMinOrderByAggregateInput>;
  _sum?: InputMaybe<FinancialTeamWalletSumOrderByAggregateInput>;
  creditsDetachedRb?: InputMaybe<SortOrder>;
  creditsDetachedRtRa?: InputMaybe<SortOrder>;
  creditsDetachedVisual?: InputMaybe<SortOrder>;
  creditsPlanRb?: InputMaybe<SortOrder>;
  creditsPlanRtRa?: InputMaybe<SortOrder>;
  creditsPlanTrial?: InputMaybe<SortOrder>;
  creditsPlanVisual?: InputMaybe<SortOrder>;
  financialProviderCustomerId?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletOrderByWithRelationInput = {
  Charges?: InputMaybe<FinancialChargeOrderByRelationAggregateInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedOrderByRelationAggregateInput>;
  Payments?: InputMaybe<FinancialPaymentOrderByRelationAggregateInput>;
  Subscriptions?: InputMaybe<FinancialTeamWalletSubscriptionOrderByRelationAggregateInput>;
  Team?: InputMaybe<TeamOrderByWithRelationInput>;
  TeamCostConfigs?: InputMaybe<FinancialTeamCostConfigOrderByRelationAggregateInput>;
  TeamSignupSelectedOptions?: InputMaybe<FinancialTeamSignupSelectedOptionsOrderByRelationAggregateInput>;
  creditsDetachedRb?: InputMaybe<SortOrder>;
  creditsDetachedRtRa?: InputMaybe<SortOrder>;
  creditsDetachedVisual?: InputMaybe<SortOrder>;
  creditsPlanRb?: InputMaybe<SortOrder>;
  creditsPlanRtRa?: InputMaybe<SortOrder>;
  creditsPlanTrial?: InputMaybe<SortOrder>;
  creditsPlanVisual?: InputMaybe<SortOrder>;
  financialProviderCustomerId?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletPurchasePlanInput = {
  billingCycle: FinancialBillingCycle;
  creditCard?: InputMaybe<InputFinancialPurchaseCreditCard>;
  extraCredits: Scalars['Int']['input'];
  plan: FinancialPlan;
  savedCreditCard?: InputMaybe<InputFinancialPurchaseSavedCreditCard>;
  service: FinancialChargeableService;
};

export type FinancialTeamWalletRelationFilter = {
  is?: InputMaybe<FinancialTeamWalletWhereInput>;
  isNot?: InputMaybe<FinancialTeamWalletWhereInput>;
};

export enum FinancialTeamWalletScalarFieldEnum {
  CreditsDetachedRb = 'creditsDetachedRb',
  CreditsDetachedRtRa = 'creditsDetachedRtRa',
  CreditsDetachedVisual = 'creditsDetachedVisual',
  CreditsPlanRb = 'creditsPlanRb',
  CreditsPlanRtRa = 'creditsPlanRtRa',
  CreditsPlanTrial = 'creditsPlanTrial',
  CreditsPlanVisual = 'creditsPlanVisual',
  FinancialProviderCustomerId = 'financialProviderCustomerId',
  TeamId = 'teamId'
}

export type FinancialTeamWalletScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<FinancialTeamWalletScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<FinancialTeamWalletScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<FinancialTeamWalletScalarWhereWithAggregatesInput>>;
  creditsDetachedRb?: InputMaybe<IntWithAggregatesFilter>;
  creditsDetachedRtRa?: InputMaybe<IntWithAggregatesFilter>;
  creditsDetachedVisual?: InputMaybe<IntWithAggregatesFilter>;
  creditsPlanRb?: InputMaybe<IntWithAggregatesFilter>;
  creditsPlanRtRa?: InputMaybe<IntWithAggregatesFilter>;
  creditsPlanTrial?: InputMaybe<IntWithAggregatesFilter>;
  creditsPlanVisual?: InputMaybe<IntWithAggregatesFilter>;
  financialProviderCustomerId?: InputMaybe<StringNullableWithAggregatesFilter>;
  teamId?: InputMaybe<IntWithAggregatesFilter>;
};

/** Each wallet must have multiple subscriptions (If cancel and hire again) */
export type FinancialTeamWalletSubscription = {
  __typename?: 'FinancialTeamWalletSubscription';
  Payments: Array<FinancialTeamWalletSubscriptionPayment>;
  TeamWallet: FinancialTeamWallet;
  UserCreated: CommonUser;
  /**
   * Stores the date when the quota will be reset
   * Null if trial
   */
  annualCreditQuotaResetDate?: Maybe<Scalars['DateTime']['output']>;
  /** Null if trial */
  billingCycle?: Maybe<FinancialBillingCycle>;
  /** User has canceled the subscription */
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  /**
   * To show in frontend (Even if Pending payment was not created yet at Asaas (It will be created 40 days before the due date))
   * Null if trial
   */
  nextDueDate?: Maybe<Scalars['DateTime']['output']>;
  plan: FinancialPlan;
  planName?: Maybe<Scalars['String']['output']>;
  planUpdatedPrice: Scalars['Float']['output'];
  userCreatedId: Scalars['Int']['output'];
  walletId: Scalars['Int']['output'];
};


/** Each wallet must have multiple subscriptions (If cancel and hire again) */
export type FinancialTeamWalletSubscriptionPaymentsArgs = {
  cursor?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereUniqueInput>;
  distinct?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
};

export type FinancialTeamWalletSubscriptionAvgOrderByAggregateInput = {
  userCreatedId?: InputMaybe<SortOrder>;
  walletId?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionCountOrderByAggregateInput = {
  annualCreditQuotaResetDate?: InputMaybe<SortOrder>;
  billingCycle?: InputMaybe<SortOrder>;
  canceledAt?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  nextDueDate?: InputMaybe<SortOrder>;
  plan?: InputMaybe<SortOrder>;
  userCreatedId?: InputMaybe<SortOrder>;
  walletId?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionCreateInput = {
  Payments?: InputMaybe<FinancialTeamWalletSubscriptionPaymentCreateNestedManyWithoutSubscriptionInput>;
  TeamWallet: FinancialTeamWalletCreateNestedOneWithoutSubscriptionsInput;
  UserCreated: CommonUserCreateNestedOneWithoutCreatedSubscriptionsInput;
  annualCreditQuotaResetDate?: InputMaybe<Scalars['DateTime']['input']>;
  billingCycle?: InputMaybe<FinancialBillingCycle>;
  canceledAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  nextDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  plan: FinancialPlan;
};

export type FinancialTeamWalletSubscriptionCreateManyInput = {
  annualCreditQuotaResetDate?: InputMaybe<Scalars['DateTime']['input']>;
  billingCycle?: InputMaybe<FinancialBillingCycle>;
  canceledAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  nextDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  plan: FinancialPlan;
  userCreatedId: Scalars['Int']['input'];
  walletId: Scalars['Int']['input'];
};

export type FinancialTeamWalletSubscriptionCreateManyTeamWalletInput = {
  annualCreditQuotaResetDate?: InputMaybe<Scalars['DateTime']['input']>;
  billingCycle?: InputMaybe<FinancialBillingCycle>;
  canceledAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  nextDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  plan: FinancialPlan;
  userCreatedId: Scalars['Int']['input'];
};

export type FinancialTeamWalletSubscriptionCreateManyTeamWalletInputEnvelope = {
  data: Array<FinancialTeamWalletSubscriptionCreateManyTeamWalletInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FinancialTeamWalletSubscriptionCreateManyUserCreatedInput = {
  annualCreditQuotaResetDate?: InputMaybe<Scalars['DateTime']['input']>;
  billingCycle?: InputMaybe<FinancialBillingCycle>;
  canceledAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  nextDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  plan: FinancialPlan;
  walletId: Scalars['Int']['input'];
};

export type FinancialTeamWalletSubscriptionCreateManyUserCreatedInputEnvelope = {
  data: Array<FinancialTeamWalletSubscriptionCreateManyUserCreatedInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FinancialTeamWalletSubscriptionCreateNestedManyWithoutTeamWalletInput = {
  connect?: InputMaybe<Array<FinancialTeamWalletSubscriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinancialTeamWalletSubscriptionCreateOrConnectWithoutTeamWalletInput>>;
  create?: InputMaybe<Array<FinancialTeamWalletSubscriptionCreateWithoutTeamWalletInput>>;
  createMany?: InputMaybe<FinancialTeamWalletSubscriptionCreateManyTeamWalletInputEnvelope>;
};

export type FinancialTeamWalletSubscriptionCreateNestedManyWithoutUserCreatedInput = {
  connect?: InputMaybe<Array<FinancialTeamWalletSubscriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinancialTeamWalletSubscriptionCreateOrConnectWithoutUserCreatedInput>>;
  create?: InputMaybe<Array<FinancialTeamWalletSubscriptionCreateWithoutUserCreatedInput>>;
  createMany?: InputMaybe<FinancialTeamWalletSubscriptionCreateManyUserCreatedInputEnvelope>;
};

export type FinancialTeamWalletSubscriptionCreateNestedOneWithoutPaymentsInput = {
  connect?: InputMaybe<FinancialTeamWalletSubscriptionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FinancialTeamWalletSubscriptionCreateOrConnectWithoutPaymentsInput>;
  create?: InputMaybe<FinancialTeamWalletSubscriptionCreateWithoutPaymentsInput>;
};

export type FinancialTeamWalletSubscriptionCreateOrConnectWithoutPaymentsInput = {
  create: FinancialTeamWalletSubscriptionCreateWithoutPaymentsInput;
  where: FinancialTeamWalletSubscriptionWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionCreateOrConnectWithoutTeamWalletInput = {
  create: FinancialTeamWalletSubscriptionCreateWithoutTeamWalletInput;
  where: FinancialTeamWalletSubscriptionWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionCreateOrConnectWithoutUserCreatedInput = {
  create: FinancialTeamWalletSubscriptionCreateWithoutUserCreatedInput;
  where: FinancialTeamWalletSubscriptionWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionCreateWithoutPaymentsInput = {
  TeamWallet: FinancialTeamWalletCreateNestedOneWithoutSubscriptionsInput;
  UserCreated: CommonUserCreateNestedOneWithoutCreatedSubscriptionsInput;
  annualCreditQuotaResetDate?: InputMaybe<Scalars['DateTime']['input']>;
  billingCycle?: InputMaybe<FinancialBillingCycle>;
  canceledAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  nextDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  plan: FinancialPlan;
};

export type FinancialTeamWalletSubscriptionCreateWithoutTeamWalletInput = {
  Payments?: InputMaybe<FinancialTeamWalletSubscriptionPaymentCreateNestedManyWithoutSubscriptionInput>;
  UserCreated: CommonUserCreateNestedOneWithoutCreatedSubscriptionsInput;
  annualCreditQuotaResetDate?: InputMaybe<Scalars['DateTime']['input']>;
  billingCycle?: InputMaybe<FinancialBillingCycle>;
  canceledAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  nextDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  plan: FinancialPlan;
};

export type FinancialTeamWalletSubscriptionCreateWithoutUserCreatedInput = {
  Payments?: InputMaybe<FinancialTeamWalletSubscriptionPaymentCreateNestedManyWithoutSubscriptionInput>;
  TeamWallet: FinancialTeamWalletCreateNestedOneWithoutSubscriptionsInput;
  annualCreditQuotaResetDate?: InputMaybe<Scalars['DateTime']['input']>;
  billingCycle?: InputMaybe<FinancialBillingCycle>;
  canceledAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  nextDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  plan: FinancialPlan;
};

export type FinancialTeamWalletSubscriptionListRelationFilter = {
  every?: InputMaybe<FinancialTeamWalletSubscriptionWhereInput>;
  none?: InputMaybe<FinancialTeamWalletSubscriptionWhereInput>;
  some?: InputMaybe<FinancialTeamWalletSubscriptionWhereInput>;
};

export type FinancialTeamWalletSubscriptionMaxOrderByAggregateInput = {
  annualCreditQuotaResetDate?: InputMaybe<SortOrder>;
  billingCycle?: InputMaybe<SortOrder>;
  canceledAt?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  nextDueDate?: InputMaybe<SortOrder>;
  plan?: InputMaybe<SortOrder>;
  userCreatedId?: InputMaybe<SortOrder>;
  walletId?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionMinOrderByAggregateInput = {
  annualCreditQuotaResetDate?: InputMaybe<SortOrder>;
  billingCycle?: InputMaybe<SortOrder>;
  canceledAt?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  nextDueDate?: InputMaybe<SortOrder>;
  plan?: InputMaybe<SortOrder>;
  userCreatedId?: InputMaybe<SortOrder>;
  walletId?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionOrderByWithAggregationInput = {
  _avg?: InputMaybe<FinancialTeamWalletSubscriptionAvgOrderByAggregateInput>;
  _count?: InputMaybe<FinancialTeamWalletSubscriptionCountOrderByAggregateInput>;
  _max?: InputMaybe<FinancialTeamWalletSubscriptionMaxOrderByAggregateInput>;
  _min?: InputMaybe<FinancialTeamWalletSubscriptionMinOrderByAggregateInput>;
  _sum?: InputMaybe<FinancialTeamWalletSubscriptionSumOrderByAggregateInput>;
  annualCreditQuotaResetDate?: InputMaybe<SortOrder>;
  billingCycle?: InputMaybe<SortOrder>;
  canceledAt?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  nextDueDate?: InputMaybe<SortOrder>;
  plan?: InputMaybe<SortOrder>;
  userCreatedId?: InputMaybe<SortOrder>;
  walletId?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionOrderByWithRelationInput = {
  Payments?: InputMaybe<FinancialTeamWalletSubscriptionPaymentOrderByRelationAggregateInput>;
  TeamWallet?: InputMaybe<FinancialTeamWalletOrderByWithRelationInput>;
  UserCreated?: InputMaybe<CommonUserOrderByWithRelationInput>;
  annualCreditQuotaResetDate?: InputMaybe<SortOrder>;
  billingCycle?: InputMaybe<SortOrder>;
  canceledAt?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  nextDueDate?: InputMaybe<SortOrder>;
  plan?: InputMaybe<SortOrder>;
  userCreatedId?: InputMaybe<SortOrder>;
  walletId?: InputMaybe<SortOrder>;
};

/** Created on initial payment / Webhook payment created */
export type FinancialTeamWalletSubscriptionPayment = {
  __typename?: 'FinancialTeamWalletSubscriptionPayment';
  FinancialPayment: FinancialPayment;
  FinancialTeamWalletSubscriptionPaymentHistory: Array<FinancialTeamWalletSubscriptionPaymentHistory>;
  Subscription: FinancialTeamWalletSubscription;
  cost: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  dueDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  paymentId: Scalars['String']['output'];
  /**
   * Asaas payment id
   * In asaas we store externalReference when we create from backend
   * But sometimes, we create payment from webhook PAYMENT_CREATED
   * So we have to store it here to update status after PAYMENT_CONFIRMED | PAYMENT_OVERDUE
   */
  providerId?: Maybe<Scalars['String']['output']>;
  status: PaymentStatus;
  subscriptionId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** Created on initial payment / Webhook payment created */
export type FinancialTeamWalletSubscriptionPaymentFinancialTeamWalletSubscriptionPaymentHistoryArgs = {
  cursor?: InputMaybe<FinancialTeamWalletSubscriptionPaymentHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FinancialTeamWalletSubscriptionPaymentHistoryWhereInput>;
};

export type FinancialTeamWalletSubscriptionPaymentAvgOrderByAggregateInput = {
  cost?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentCountOrderByAggregateInput = {
  cost?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dueDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  providerId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subscriptionId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentCreateInput = {
  FinancialPayment: FinancialPaymentCreateNestedOneWithoutSubscriptionPaymentInput;
  FinancialTeamWalletSubscriptionPaymentHistory?: InputMaybe<FinancialTeamWalletSubscriptionPaymentHistoryCreateNestedManyWithoutPaymentInput>;
  Subscription: FinancialTeamWalletSubscriptionCreateNestedOneWithoutPaymentsInput;
  cost: Scalars['Decimal']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  status: PaymentStatus;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FinancialTeamWalletSubscriptionPaymentCreateManyInput = {
  cost: Scalars['Decimal']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  paymentId: Scalars['String']['input'];
  providerId?: InputMaybe<Scalars['String']['input']>;
  status: PaymentStatus;
  subscriptionId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FinancialTeamWalletSubscriptionPaymentCreateManySubscriptionInput = {
  cost: Scalars['Decimal']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  paymentId: Scalars['String']['input'];
  providerId?: InputMaybe<Scalars['String']['input']>;
  status: PaymentStatus;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FinancialTeamWalletSubscriptionPaymentCreateManySubscriptionInputEnvelope = {
  data: Array<FinancialTeamWalletSubscriptionPaymentCreateManySubscriptionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FinancialTeamWalletSubscriptionPaymentCreateNestedManyWithoutSubscriptionInput = {
  connect?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentCreateOrConnectWithoutSubscriptionInput>>;
  create?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentCreateWithoutSubscriptionInput>>;
  createMany?: InputMaybe<FinancialTeamWalletSubscriptionPaymentCreateManySubscriptionInputEnvelope>;
};

export type FinancialTeamWalletSubscriptionPaymentCreateNestedOneWithoutFinancialPaymentInput = {
  connect?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FinancialTeamWalletSubscriptionPaymentCreateOrConnectWithoutFinancialPaymentInput>;
  create?: InputMaybe<FinancialTeamWalletSubscriptionPaymentCreateWithoutFinancialPaymentInput>;
};

export type FinancialTeamWalletSubscriptionPaymentCreateNestedOneWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput = {
  connect?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FinancialTeamWalletSubscriptionPaymentCreateOrConnectWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput>;
  create?: InputMaybe<FinancialTeamWalletSubscriptionPaymentCreateWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput>;
};

export type FinancialTeamWalletSubscriptionPaymentCreateOrConnectWithoutFinancialPaymentInput = {
  create: FinancialTeamWalletSubscriptionPaymentCreateWithoutFinancialPaymentInput;
  where: FinancialTeamWalletSubscriptionPaymentWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionPaymentCreateOrConnectWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput = {
  create: FinancialTeamWalletSubscriptionPaymentCreateWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput;
  where: FinancialTeamWalletSubscriptionPaymentWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionPaymentCreateOrConnectWithoutSubscriptionInput = {
  create: FinancialTeamWalletSubscriptionPaymentCreateWithoutSubscriptionInput;
  where: FinancialTeamWalletSubscriptionPaymentWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionPaymentCreateWithoutFinancialPaymentInput = {
  FinancialTeamWalletSubscriptionPaymentHistory?: InputMaybe<FinancialTeamWalletSubscriptionPaymentHistoryCreateNestedManyWithoutPaymentInput>;
  Subscription: FinancialTeamWalletSubscriptionCreateNestedOneWithoutPaymentsInput;
  cost: Scalars['Decimal']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  status: PaymentStatus;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FinancialTeamWalletSubscriptionPaymentCreateWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput = {
  FinancialPayment: FinancialPaymentCreateNestedOneWithoutSubscriptionPaymentInput;
  Subscription: FinancialTeamWalletSubscriptionCreateNestedOneWithoutPaymentsInput;
  cost: Scalars['Decimal']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  status: PaymentStatus;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FinancialTeamWalletSubscriptionPaymentCreateWithoutSubscriptionInput = {
  FinancialPayment: FinancialPaymentCreateNestedOneWithoutSubscriptionPaymentInput;
  FinancialTeamWalletSubscriptionPaymentHistory?: InputMaybe<FinancialTeamWalletSubscriptionPaymentHistoryCreateNestedManyWithoutPaymentInput>;
  cost: Scalars['Decimal']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  status: PaymentStatus;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FinancialTeamWalletSubscriptionPaymentHistory = {
  __typename?: 'FinancialTeamWalletSubscriptionPaymentHistory';
  Payment: FinancialTeamWalletSubscriptionPayment;
  createdAt: Scalars['DateTime']['output'];
  /** ![PrismaJson.AnyJson], thats for logging purposes */
  data: Scalars['Json']['output'];
  id: Scalars['Int']['output'];
  paymentId: Scalars['String']['output'];
};

export type FinancialTeamWalletSubscriptionPaymentHistoryAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryCreateInput = {
  Payment: FinancialTeamWalletSubscriptionPaymentCreateNestedOneWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
};

export type FinancialTeamWalletSubscriptionPaymentHistoryCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  paymentId: Scalars['String']['input'];
};

export type FinancialTeamWalletSubscriptionPaymentHistoryCreateManyPaymentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryCreateManyPaymentInputEnvelope = {
  data: Array<FinancialTeamWalletSubscriptionPaymentHistoryCreateManyPaymentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryCreateNestedManyWithoutPaymentInput = {
  connect?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryCreateOrConnectWithoutPaymentInput>>;
  create?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryCreateWithoutPaymentInput>>;
  createMany?: InputMaybe<FinancialTeamWalletSubscriptionPaymentHistoryCreateManyPaymentInputEnvelope>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryCreateOrConnectWithoutPaymentInput = {
  create: FinancialTeamWalletSubscriptionPaymentHistoryCreateWithoutPaymentInput;
  where: FinancialTeamWalletSubscriptionPaymentHistoryWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryCreateWithoutPaymentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
};

export type FinancialTeamWalletSubscriptionPaymentHistoryListRelationFilter = {
  every?: InputMaybe<FinancialTeamWalletSubscriptionPaymentHistoryWhereInput>;
  none?: InputMaybe<FinancialTeamWalletSubscriptionPaymentHistoryWhereInput>;
  some?: InputMaybe<FinancialTeamWalletSubscriptionPaymentHistoryWhereInput>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryOrderByWithAggregationInput = {
  _avg?: InputMaybe<FinancialTeamWalletSubscriptionPaymentHistoryAvgOrderByAggregateInput>;
  _count?: InputMaybe<FinancialTeamWalletSubscriptionPaymentHistoryCountOrderByAggregateInput>;
  _max?: InputMaybe<FinancialTeamWalletSubscriptionPaymentHistoryMaxOrderByAggregateInput>;
  _min?: InputMaybe<FinancialTeamWalletSubscriptionPaymentHistoryMinOrderByAggregateInput>;
  _sum?: InputMaybe<FinancialTeamWalletSubscriptionPaymentHistorySumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryOrderByWithRelationInput = {
  Payment?: InputMaybe<FinancialTeamWalletSubscriptionPaymentOrderByWithRelationInput>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
};

export enum FinancialTeamWalletSubscriptionPaymentHistoryScalarFieldEnum {
  CreatedAt = 'createdAt',
  Data = 'data',
  Id = 'id',
  PaymentId = 'paymentId'
}

export type FinancialTeamWalletSubscriptionPaymentHistoryScalarWhereInput = {
  AND?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryScalarWhereInput>>;
  OR?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<IntFilter>;
  paymentId?: InputMaybe<StringFilter>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  data?: InputMaybe<JsonWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  paymentId?: InputMaybe<StringWithAggregatesFilter>;
};

export type FinancialTeamWalletSubscriptionPaymentHistorySumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryUpdateInput = {
  Payment?: InputMaybe<FinancialTeamWalletSubscriptionPaymentUpdateOneRequiredWithoutFinancialTeamWalletSubscriptionPaymentHistoryNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryUpdateManyWithWhereWithoutPaymentInput = {
  data: FinancialTeamWalletSubscriptionPaymentHistoryUpdateManyMutationInput;
  where: FinancialTeamWalletSubscriptionPaymentHistoryScalarWhereInput;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryUpdateManyWithoutPaymentNestedInput = {
  connect?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryCreateOrConnectWithoutPaymentInput>>;
  create?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryCreateWithoutPaymentInput>>;
  createMany?: InputMaybe<FinancialTeamWalletSubscriptionPaymentHistoryCreateManyPaymentInputEnvelope>;
  delete?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryUpdateWithWhereUniqueWithoutPaymentInput>>;
  updateMany?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryUpdateManyWithWhereWithoutPaymentInput>>;
  upsert?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryUpsertWithWhereUniqueWithoutPaymentInput>>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryUpdateWithWhereUniqueWithoutPaymentInput = {
  data: FinancialTeamWalletSubscriptionPaymentHistoryUpdateWithoutPaymentInput;
  where: FinancialTeamWalletSubscriptionPaymentHistoryWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryUpdateWithoutPaymentInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryUpsertWithWhereUniqueWithoutPaymentInput = {
  create: FinancialTeamWalletSubscriptionPaymentHistoryCreateWithoutPaymentInput;
  update: FinancialTeamWalletSubscriptionPaymentHistoryUpdateWithoutPaymentInput;
  where: FinancialTeamWalletSubscriptionPaymentHistoryWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryWhereInput = {
  AND?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryWhereInput>>;
  NOT?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryWhereInput>>;
  OR?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryWhereInput>>;
  Payment?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<IntFilter>;
  paymentId?: InputMaybe<StringFilter>;
};

export type FinancialTeamWalletSubscriptionPaymentHistoryWhereUniqueInput = {
  AND?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryWhereInput>>;
  NOT?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryWhereInput>>;
  OR?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentHistoryWhereInput>>;
  Payment?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  paymentId?: InputMaybe<StringFilter>;
};

export type FinancialTeamWalletSubscriptionPaymentListRelationFilter = {
  every?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
  none?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
  some?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
};

export type FinancialTeamWalletSubscriptionPaymentMaxOrderByAggregateInput = {
  cost?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dueDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  providerId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subscriptionId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentMinOrderByAggregateInput = {
  cost?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dueDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  providerId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subscriptionId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentNullableRelationFilter = {
  is?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
  isNot?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
};

export type FinancialTeamWalletSubscriptionPaymentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentOrderByWithAggregationInput = {
  _avg?: InputMaybe<FinancialTeamWalletSubscriptionPaymentAvgOrderByAggregateInput>;
  _count?: InputMaybe<FinancialTeamWalletSubscriptionPaymentCountOrderByAggregateInput>;
  _max?: InputMaybe<FinancialTeamWalletSubscriptionPaymentMaxOrderByAggregateInput>;
  _min?: InputMaybe<FinancialTeamWalletSubscriptionPaymentMinOrderByAggregateInput>;
  _sum?: InputMaybe<FinancialTeamWalletSubscriptionPaymentSumOrderByAggregateInput>;
  cost?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dueDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  providerId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subscriptionId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentOrderByWithRelationInput = {
  FinancialPayment?: InputMaybe<FinancialPaymentOrderByWithRelationInput>;
  FinancialTeamWalletSubscriptionPaymentHistory?: InputMaybe<FinancialTeamWalletSubscriptionPaymentHistoryOrderByRelationAggregateInput>;
  Subscription?: InputMaybe<FinancialTeamWalletSubscriptionOrderByWithRelationInput>;
  cost?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dueDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  providerId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  subscriptionId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentRelationFilter = {
  is?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
  isNot?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
};

export enum FinancialTeamWalletSubscriptionPaymentScalarFieldEnum {
  Cost = 'cost',
  CreatedAt = 'createdAt',
  DueDate = 'dueDate',
  Id = 'id',
  PaymentId = 'paymentId',
  ProviderId = 'providerId',
  Status = 'status',
  SubscriptionId = 'subscriptionId',
  UpdatedAt = 'updatedAt'
}

export type FinancialTeamWalletSubscriptionPaymentScalarWhereInput = {
  AND?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentScalarWhereInput>>;
  NOT?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentScalarWhereInput>>;
  OR?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentScalarWhereInput>>;
  cost?: InputMaybe<DecimalFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dueDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  paymentId?: InputMaybe<StringFilter>;
  providerId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumPaymentStatusFilter>;
  subscriptionId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type FinancialTeamWalletSubscriptionPaymentScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentScalarWhereWithAggregatesInput>>;
  cost?: InputMaybe<DecimalWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  dueDate?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  paymentId?: InputMaybe<StringWithAggregatesFilter>;
  providerId?: InputMaybe<StringNullableWithAggregatesFilter>;
  status?: InputMaybe<EnumPaymentStatusWithAggregatesFilter>;
  subscriptionId?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type FinancialTeamWalletSubscriptionPaymentSumOrderByAggregateInput = {
  cost?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionPaymentUpdateInput = {
  FinancialPayment?: InputMaybe<FinancialPaymentUpdateOneRequiredWithoutSubscriptionPaymentNestedInput>;
  FinancialTeamWalletSubscriptionPaymentHistory?: InputMaybe<FinancialTeamWalletSubscriptionPaymentHistoryUpdateManyWithoutPaymentNestedInput>;
  Subscription?: InputMaybe<FinancialTeamWalletSubscriptionUpdateOneRequiredWithoutPaymentsNestedInput>;
  cost?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dueDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPaymentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletSubscriptionPaymentUpdateManyMutationInput = {
  cost?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dueDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPaymentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletSubscriptionPaymentUpdateManyWithWhereWithoutSubscriptionInput = {
  data: FinancialTeamWalletSubscriptionPaymentUpdateManyMutationInput;
  where: FinancialTeamWalletSubscriptionPaymentScalarWhereInput;
};

export type FinancialTeamWalletSubscriptionPaymentUpdateManyWithoutSubscriptionNestedInput = {
  connect?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentCreateOrConnectWithoutSubscriptionInput>>;
  create?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentCreateWithoutSubscriptionInput>>;
  createMany?: InputMaybe<FinancialTeamWalletSubscriptionPaymentCreateManySubscriptionInputEnvelope>;
  delete?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentWhereUniqueInput>>;
  set?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentWhereUniqueInput>>;
  update?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentUpdateWithWhereUniqueWithoutSubscriptionInput>>;
  updateMany?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentUpdateManyWithWhereWithoutSubscriptionInput>>;
  upsert?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentUpsertWithWhereUniqueWithoutSubscriptionInput>>;
};

export type FinancialTeamWalletSubscriptionPaymentUpdateOneRequiredWithoutFinancialTeamWalletSubscriptionPaymentHistoryNestedInput = {
  connect?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FinancialTeamWalletSubscriptionPaymentCreateOrConnectWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput>;
  create?: InputMaybe<FinancialTeamWalletSubscriptionPaymentCreateWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput>;
  update?: InputMaybe<FinancialTeamWalletSubscriptionPaymentUpdateToOneWithWhereWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput>;
  upsert?: InputMaybe<FinancialTeamWalletSubscriptionPaymentUpsertWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput>;
};

export type FinancialTeamWalletSubscriptionPaymentUpdateOneWithoutFinancialPaymentNestedInput = {
  connect?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FinancialTeamWalletSubscriptionPaymentCreateOrConnectWithoutFinancialPaymentInput>;
  create?: InputMaybe<FinancialTeamWalletSubscriptionPaymentCreateWithoutFinancialPaymentInput>;
  delete?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
  disconnect?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
  update?: InputMaybe<FinancialTeamWalletSubscriptionPaymentUpdateToOneWithWhereWithoutFinancialPaymentInput>;
  upsert?: InputMaybe<FinancialTeamWalletSubscriptionPaymentUpsertWithoutFinancialPaymentInput>;
};

export type FinancialTeamWalletSubscriptionPaymentUpdateToOneWithWhereWithoutFinancialPaymentInput = {
  data: FinancialTeamWalletSubscriptionPaymentUpdateWithoutFinancialPaymentInput;
  where?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
};

export type FinancialTeamWalletSubscriptionPaymentUpdateToOneWithWhereWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput = {
  data: FinancialTeamWalletSubscriptionPaymentUpdateWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput;
  where?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
};

export type FinancialTeamWalletSubscriptionPaymentUpdateWithWhereUniqueWithoutSubscriptionInput = {
  data: FinancialTeamWalletSubscriptionPaymentUpdateWithoutSubscriptionInput;
  where: FinancialTeamWalletSubscriptionPaymentWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionPaymentUpdateWithoutFinancialPaymentInput = {
  FinancialTeamWalletSubscriptionPaymentHistory?: InputMaybe<FinancialTeamWalletSubscriptionPaymentHistoryUpdateManyWithoutPaymentNestedInput>;
  Subscription?: InputMaybe<FinancialTeamWalletSubscriptionUpdateOneRequiredWithoutPaymentsNestedInput>;
  cost?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dueDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPaymentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletSubscriptionPaymentUpdateWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput = {
  FinancialPayment?: InputMaybe<FinancialPaymentUpdateOneRequiredWithoutSubscriptionPaymentNestedInput>;
  Subscription?: InputMaybe<FinancialTeamWalletSubscriptionUpdateOneRequiredWithoutPaymentsNestedInput>;
  cost?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dueDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPaymentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletSubscriptionPaymentUpdateWithoutSubscriptionInput = {
  FinancialPayment?: InputMaybe<FinancialPaymentUpdateOneRequiredWithoutSubscriptionPaymentNestedInput>;
  FinancialTeamWalletSubscriptionPaymentHistory?: InputMaybe<FinancialTeamWalletSubscriptionPaymentHistoryUpdateManyWithoutPaymentNestedInput>;
  cost?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dueDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  providerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPaymentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletSubscriptionPaymentUpsertWithWhereUniqueWithoutSubscriptionInput = {
  create: FinancialTeamWalletSubscriptionPaymentCreateWithoutSubscriptionInput;
  update: FinancialTeamWalletSubscriptionPaymentUpdateWithoutSubscriptionInput;
  where: FinancialTeamWalletSubscriptionPaymentWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionPaymentUpsertWithoutFinancialPaymentInput = {
  create: FinancialTeamWalletSubscriptionPaymentCreateWithoutFinancialPaymentInput;
  update: FinancialTeamWalletSubscriptionPaymentUpdateWithoutFinancialPaymentInput;
  where?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
};

export type FinancialTeamWalletSubscriptionPaymentUpsertWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput = {
  create: FinancialTeamWalletSubscriptionPaymentCreateWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput;
  update: FinancialTeamWalletSubscriptionPaymentUpdateWithoutFinancialTeamWalletSubscriptionPaymentHistoryInput;
  where?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
};

export type FinancialTeamWalletSubscriptionPaymentWhereInput = {
  AND?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentWhereInput>>;
  FinancialPayment?: InputMaybe<FinancialPaymentWhereInput>;
  FinancialTeamWalletSubscriptionPaymentHistory?: InputMaybe<FinancialTeamWalletSubscriptionPaymentHistoryListRelationFilter>;
  NOT?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentWhereInput>>;
  OR?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentWhereInput>>;
  Subscription?: InputMaybe<FinancialTeamWalletSubscriptionWhereInput>;
  cost?: InputMaybe<DecimalFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dueDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  paymentId?: InputMaybe<StringFilter>;
  providerId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumPaymentStatusFilter>;
  subscriptionId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type FinancialTeamWalletSubscriptionPaymentWhereUniqueInput = {
  AND?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentWhereInput>>;
  FinancialPayment?: InputMaybe<FinancialPaymentWhereInput>;
  FinancialTeamWalletSubscriptionPaymentHistory?: InputMaybe<FinancialTeamWalletSubscriptionPaymentHistoryListRelationFilter>;
  NOT?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentWhereInput>>;
  OR?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentWhereInput>>;
  Subscription?: InputMaybe<FinancialTeamWalletSubscriptionWhereInput>;
  cost?: InputMaybe<DecimalFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dueDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumPaymentStatusFilter>;
  subscriptionId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type FinancialTeamWalletSubscriptionRelationFilter = {
  is?: InputMaybe<FinancialTeamWalletSubscriptionWhereInput>;
  isNot?: InputMaybe<FinancialTeamWalletSubscriptionWhereInput>;
};

export enum FinancialTeamWalletSubscriptionScalarFieldEnum {
  AnnualCreditQuotaResetDate = 'annualCreditQuotaResetDate',
  BillingCycle = 'billingCycle',
  CanceledAt = 'canceledAt',
  CreatedAt = 'createdAt',
  Id = 'id',
  NextDueDate = 'nextDueDate',
  Plan = 'plan',
  UserCreatedId = 'userCreatedId',
  WalletId = 'walletId'
}

export type FinancialTeamWalletSubscriptionScalarWhereInput = {
  AND?: InputMaybe<Array<FinancialTeamWalletSubscriptionScalarWhereInput>>;
  NOT?: InputMaybe<Array<FinancialTeamWalletSubscriptionScalarWhereInput>>;
  OR?: InputMaybe<Array<FinancialTeamWalletSubscriptionScalarWhereInput>>;
  annualCreditQuotaResetDate?: InputMaybe<DateTimeNullableFilter>;
  billingCycle?: InputMaybe<EnumFinancialBillingCycleNullableFilter>;
  canceledAt?: InputMaybe<DateTimeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  nextDueDate?: InputMaybe<DateTimeNullableFilter>;
  plan?: InputMaybe<EnumFinancialPlanFilter>;
  userCreatedId?: InputMaybe<IntFilter>;
  walletId?: InputMaybe<IntFilter>;
};

export type FinancialTeamWalletSubscriptionScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<FinancialTeamWalletSubscriptionScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<FinancialTeamWalletSubscriptionScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<FinancialTeamWalletSubscriptionScalarWhereWithAggregatesInput>>;
  annualCreditQuotaResetDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  billingCycle?: InputMaybe<EnumFinancialBillingCycleNullableWithAggregatesFilter>;
  canceledAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  nextDueDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  plan?: InputMaybe<EnumFinancialPlanWithAggregatesFilter>;
  userCreatedId?: InputMaybe<IntWithAggregatesFilter>;
  walletId?: InputMaybe<IntWithAggregatesFilter>;
};

export type FinancialTeamWalletSubscriptionSumOrderByAggregateInput = {
  userCreatedId?: InputMaybe<SortOrder>;
  walletId?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletSubscriptionUpdateInput = {
  Payments?: InputMaybe<FinancialTeamWalletSubscriptionPaymentUpdateManyWithoutSubscriptionNestedInput>;
  TeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneRequiredWithoutSubscriptionsNestedInput>;
  UserCreated?: InputMaybe<CommonUserUpdateOneRequiredWithoutCreatedSubscriptionsNestedInput>;
  annualCreditQuotaResetDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingCycle?: InputMaybe<NullableEnumFinancialBillingCycleFieldUpdateOperationsInput>;
  canceledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  nextDueDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  plan?: InputMaybe<EnumFinancialPlanFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletSubscriptionUpdateManyMutationInput = {
  annualCreditQuotaResetDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingCycle?: InputMaybe<NullableEnumFinancialBillingCycleFieldUpdateOperationsInput>;
  canceledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  nextDueDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  plan?: InputMaybe<EnumFinancialPlanFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletSubscriptionUpdateManyWithWhereWithoutTeamWalletInput = {
  data: FinancialTeamWalletSubscriptionUpdateManyMutationInput;
  where: FinancialTeamWalletSubscriptionScalarWhereInput;
};

export type FinancialTeamWalletSubscriptionUpdateManyWithWhereWithoutUserCreatedInput = {
  data: FinancialTeamWalletSubscriptionUpdateManyMutationInput;
  where: FinancialTeamWalletSubscriptionScalarWhereInput;
};

export type FinancialTeamWalletSubscriptionUpdateManyWithoutTeamWalletNestedInput = {
  connect?: InputMaybe<Array<FinancialTeamWalletSubscriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinancialTeamWalletSubscriptionCreateOrConnectWithoutTeamWalletInput>>;
  create?: InputMaybe<Array<FinancialTeamWalletSubscriptionCreateWithoutTeamWalletInput>>;
  createMany?: InputMaybe<FinancialTeamWalletSubscriptionCreateManyTeamWalletInputEnvelope>;
  delete?: InputMaybe<Array<FinancialTeamWalletSubscriptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FinancialTeamWalletSubscriptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FinancialTeamWalletSubscriptionWhereUniqueInput>>;
  set?: InputMaybe<Array<FinancialTeamWalletSubscriptionWhereUniqueInput>>;
  update?: InputMaybe<Array<FinancialTeamWalletSubscriptionUpdateWithWhereUniqueWithoutTeamWalletInput>>;
  updateMany?: InputMaybe<Array<FinancialTeamWalletSubscriptionUpdateManyWithWhereWithoutTeamWalletInput>>;
  upsert?: InputMaybe<Array<FinancialTeamWalletSubscriptionUpsertWithWhereUniqueWithoutTeamWalletInput>>;
};

export type FinancialTeamWalletSubscriptionUpdateManyWithoutUserCreatedNestedInput = {
  connect?: InputMaybe<Array<FinancialTeamWalletSubscriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinancialTeamWalletSubscriptionCreateOrConnectWithoutUserCreatedInput>>;
  create?: InputMaybe<Array<FinancialTeamWalletSubscriptionCreateWithoutUserCreatedInput>>;
  createMany?: InputMaybe<FinancialTeamWalletSubscriptionCreateManyUserCreatedInputEnvelope>;
  delete?: InputMaybe<Array<FinancialTeamWalletSubscriptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FinancialTeamWalletSubscriptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FinancialTeamWalletSubscriptionWhereUniqueInput>>;
  set?: InputMaybe<Array<FinancialTeamWalletSubscriptionWhereUniqueInput>>;
  update?: InputMaybe<Array<FinancialTeamWalletSubscriptionUpdateWithWhereUniqueWithoutUserCreatedInput>>;
  updateMany?: InputMaybe<Array<FinancialTeamWalletSubscriptionUpdateManyWithWhereWithoutUserCreatedInput>>;
  upsert?: InputMaybe<Array<FinancialTeamWalletSubscriptionUpsertWithWhereUniqueWithoutUserCreatedInput>>;
};

export type FinancialTeamWalletSubscriptionUpdateOneRequiredWithoutPaymentsNestedInput = {
  connect?: InputMaybe<FinancialTeamWalletSubscriptionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FinancialTeamWalletSubscriptionCreateOrConnectWithoutPaymentsInput>;
  create?: InputMaybe<FinancialTeamWalletSubscriptionCreateWithoutPaymentsInput>;
  update?: InputMaybe<FinancialTeamWalletSubscriptionUpdateToOneWithWhereWithoutPaymentsInput>;
  upsert?: InputMaybe<FinancialTeamWalletSubscriptionUpsertWithoutPaymentsInput>;
};

export type FinancialTeamWalletSubscriptionUpdateToOneWithWhereWithoutPaymentsInput = {
  data: FinancialTeamWalletSubscriptionUpdateWithoutPaymentsInput;
  where?: InputMaybe<FinancialTeamWalletSubscriptionWhereInput>;
};

export type FinancialTeamWalletSubscriptionUpdateWithWhereUniqueWithoutTeamWalletInput = {
  data: FinancialTeamWalletSubscriptionUpdateWithoutTeamWalletInput;
  where: FinancialTeamWalletSubscriptionWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionUpdateWithWhereUniqueWithoutUserCreatedInput = {
  data: FinancialTeamWalletSubscriptionUpdateWithoutUserCreatedInput;
  where: FinancialTeamWalletSubscriptionWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionUpdateWithoutPaymentsInput = {
  TeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneRequiredWithoutSubscriptionsNestedInput>;
  UserCreated?: InputMaybe<CommonUserUpdateOneRequiredWithoutCreatedSubscriptionsNestedInput>;
  annualCreditQuotaResetDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingCycle?: InputMaybe<NullableEnumFinancialBillingCycleFieldUpdateOperationsInput>;
  canceledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  nextDueDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  plan?: InputMaybe<EnumFinancialPlanFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletSubscriptionUpdateWithoutTeamWalletInput = {
  Payments?: InputMaybe<FinancialTeamWalletSubscriptionPaymentUpdateManyWithoutSubscriptionNestedInput>;
  UserCreated?: InputMaybe<CommonUserUpdateOneRequiredWithoutCreatedSubscriptionsNestedInput>;
  annualCreditQuotaResetDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingCycle?: InputMaybe<NullableEnumFinancialBillingCycleFieldUpdateOperationsInput>;
  canceledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  nextDueDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  plan?: InputMaybe<EnumFinancialPlanFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletSubscriptionUpdateWithoutUserCreatedInput = {
  Payments?: InputMaybe<FinancialTeamWalletSubscriptionPaymentUpdateManyWithoutSubscriptionNestedInput>;
  TeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneRequiredWithoutSubscriptionsNestedInput>;
  annualCreditQuotaResetDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  billingCycle?: InputMaybe<NullableEnumFinancialBillingCycleFieldUpdateOperationsInput>;
  canceledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  nextDueDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  plan?: InputMaybe<EnumFinancialPlanFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletSubscriptionUpsertWithWhereUniqueWithoutTeamWalletInput = {
  create: FinancialTeamWalletSubscriptionCreateWithoutTeamWalletInput;
  update: FinancialTeamWalletSubscriptionUpdateWithoutTeamWalletInput;
  where: FinancialTeamWalletSubscriptionWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionUpsertWithWhereUniqueWithoutUserCreatedInput = {
  create: FinancialTeamWalletSubscriptionCreateWithoutUserCreatedInput;
  update: FinancialTeamWalletSubscriptionUpdateWithoutUserCreatedInput;
  where: FinancialTeamWalletSubscriptionWhereUniqueInput;
};

export type FinancialTeamWalletSubscriptionUpsertWithoutPaymentsInput = {
  create: FinancialTeamWalletSubscriptionCreateWithoutPaymentsInput;
  update: FinancialTeamWalletSubscriptionUpdateWithoutPaymentsInput;
  where?: InputMaybe<FinancialTeamWalletSubscriptionWhereInput>;
};

export type FinancialTeamWalletSubscriptionWhereInput = {
  AND?: InputMaybe<Array<FinancialTeamWalletSubscriptionWhereInput>>;
  NOT?: InputMaybe<Array<FinancialTeamWalletSubscriptionWhereInput>>;
  OR?: InputMaybe<Array<FinancialTeamWalletSubscriptionWhereInput>>;
  Payments?: InputMaybe<FinancialTeamWalletSubscriptionPaymentListRelationFilter>;
  TeamWallet?: InputMaybe<FinancialTeamWalletWhereInput>;
  UserCreated?: InputMaybe<CommonUserWhereInput>;
  annualCreditQuotaResetDate?: InputMaybe<DateTimeNullableFilter>;
  billingCycle?: InputMaybe<EnumFinancialBillingCycleNullableFilter>;
  canceledAt?: InputMaybe<DateTimeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  nextDueDate?: InputMaybe<DateTimeNullableFilter>;
  plan?: InputMaybe<EnumFinancialPlanFilter>;
  userCreatedId?: InputMaybe<IntFilter>;
  walletId?: InputMaybe<IntFilter>;
};

export type FinancialTeamWalletSubscriptionWhereUniqueInput = {
  AND?: InputMaybe<Array<FinancialTeamWalletSubscriptionWhereInput>>;
  NOT?: InputMaybe<Array<FinancialTeamWalletSubscriptionWhereInput>>;
  OR?: InputMaybe<Array<FinancialTeamWalletSubscriptionWhereInput>>;
  Payments?: InputMaybe<FinancialTeamWalletSubscriptionPaymentListRelationFilter>;
  TeamWallet?: InputMaybe<FinancialTeamWalletWhereInput>;
  UserCreated?: InputMaybe<CommonUserWhereInput>;
  annualCreditQuotaResetDate?: InputMaybe<DateTimeNullableFilter>;
  billingCycle?: InputMaybe<EnumFinancialBillingCycleNullableFilter>;
  canceledAt?: InputMaybe<DateTimeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  nextDueDate?: InputMaybe<DateTimeNullableFilter>;
  plan?: InputMaybe<EnumFinancialPlanFilter>;
  userCreatedId?: InputMaybe<IntFilter>;
  walletId?: InputMaybe<IntFilter>;
};

export type FinancialTeamWalletSumOrderByAggregateInput = {
  creditsDetachedRb?: InputMaybe<SortOrder>;
  creditsDetachedRtRa?: InputMaybe<SortOrder>;
  creditsDetachedVisual?: InputMaybe<SortOrder>;
  creditsPlanRb?: InputMaybe<SortOrder>;
  creditsPlanRtRa?: InputMaybe<SortOrder>;
  creditsPlanTrial?: InputMaybe<SortOrder>;
  creditsPlanVisual?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type FinancialTeamWalletUpdateInput = {
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutTeamWalletNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutTeamWalletNestedInput>;
  Payments?: InputMaybe<FinancialPaymentUpdateManyWithoutTeamWalletNestedInput>;
  Subscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutTeamWalletNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutFinancialTeamWalletNestedInput>;
  TeamCostConfigs?: InputMaybe<FinancialTeamCostConfigUpdateManyWithoutTeamWalletNestedInput>;
  TeamSignupSelectedOptions?: InputMaybe<FinancialTeamSignupSelectedOptionsUpdateManyWithoutTeamWalletNestedInput>;
  creditsDetachedRb?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsDetachedRtRa?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsDetachedVisual?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanRb?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanRtRa?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanTrial?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanVisual?: InputMaybe<IntFieldUpdateOperationsInput>;
  financialProviderCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletUpdateManyMutationInput = {
  creditsDetachedRb?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsDetachedRtRa?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsDetachedVisual?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanRb?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanRtRa?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanTrial?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanVisual?: InputMaybe<IntFieldUpdateOperationsInput>;
  financialProviderCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletUpdateOneRequiredWithoutChargesNestedInput = {
  connect?: InputMaybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FinancialTeamWalletCreateOrConnectWithoutChargesInput>;
  create?: InputMaybe<FinancialTeamWalletCreateWithoutChargesInput>;
  update?: InputMaybe<FinancialTeamWalletUpdateToOneWithWhereWithoutChargesInput>;
  upsert?: InputMaybe<FinancialTeamWalletUpsertWithoutChargesInput>;
};

export type FinancialTeamWalletUpdateOneRequiredWithoutCreditCardSavedsNestedInput = {
  connect?: InputMaybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FinancialTeamWalletCreateOrConnectWithoutCreditCardSavedsInput>;
  create?: InputMaybe<FinancialTeamWalletCreateWithoutCreditCardSavedsInput>;
  update?: InputMaybe<FinancialTeamWalletUpdateToOneWithWhereWithoutCreditCardSavedsInput>;
  upsert?: InputMaybe<FinancialTeamWalletUpsertWithoutCreditCardSavedsInput>;
};

export type FinancialTeamWalletUpdateOneRequiredWithoutPaymentsNestedInput = {
  connect?: InputMaybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FinancialTeamWalletCreateOrConnectWithoutPaymentsInput>;
  create?: InputMaybe<FinancialTeamWalletCreateWithoutPaymentsInput>;
  update?: InputMaybe<FinancialTeamWalletUpdateToOneWithWhereWithoutPaymentsInput>;
  upsert?: InputMaybe<FinancialTeamWalletUpsertWithoutPaymentsInput>;
};

export type FinancialTeamWalletUpdateOneRequiredWithoutSubscriptionsNestedInput = {
  connect?: InputMaybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FinancialTeamWalletCreateOrConnectWithoutSubscriptionsInput>;
  create?: InputMaybe<FinancialTeamWalletCreateWithoutSubscriptionsInput>;
  update?: InputMaybe<FinancialTeamWalletUpdateToOneWithWhereWithoutSubscriptionsInput>;
  upsert?: InputMaybe<FinancialTeamWalletUpsertWithoutSubscriptionsInput>;
};

export type FinancialTeamWalletUpdateOneRequiredWithoutTeamCostConfigsNestedInput = {
  connect?: InputMaybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FinancialTeamWalletCreateOrConnectWithoutTeamCostConfigsInput>;
  create?: InputMaybe<FinancialTeamWalletCreateWithoutTeamCostConfigsInput>;
  update?: InputMaybe<FinancialTeamWalletUpdateToOneWithWhereWithoutTeamCostConfigsInput>;
  upsert?: InputMaybe<FinancialTeamWalletUpsertWithoutTeamCostConfigsInput>;
};

export type FinancialTeamWalletUpdateOneRequiredWithoutTeamSignupSelectedOptionsNestedInput = {
  connect?: InputMaybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FinancialTeamWalletCreateOrConnectWithoutTeamSignupSelectedOptionsInput>;
  create?: InputMaybe<FinancialTeamWalletCreateWithoutTeamSignupSelectedOptionsInput>;
  update?: InputMaybe<FinancialTeamWalletUpdateToOneWithWhereWithoutTeamSignupSelectedOptionsInput>;
  upsert?: InputMaybe<FinancialTeamWalletUpsertWithoutTeamSignupSelectedOptionsInput>;
};

export type FinancialTeamWalletUpdateOneWithoutTeamNestedInput = {
  connect?: InputMaybe<FinancialTeamWalletWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FinancialTeamWalletCreateOrConnectWithoutTeamInput>;
  create?: InputMaybe<FinancialTeamWalletCreateWithoutTeamInput>;
  delete?: InputMaybe<FinancialTeamWalletWhereInput>;
  disconnect?: InputMaybe<FinancialTeamWalletWhereInput>;
  update?: InputMaybe<FinancialTeamWalletUpdateToOneWithWhereWithoutTeamInput>;
  upsert?: InputMaybe<FinancialTeamWalletUpsertWithoutTeamInput>;
};

export type FinancialTeamWalletUpdateToOneWithWhereWithoutChargesInput = {
  data: FinancialTeamWalletUpdateWithoutChargesInput;
  where?: InputMaybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletUpdateToOneWithWhereWithoutCreditCardSavedsInput = {
  data: FinancialTeamWalletUpdateWithoutCreditCardSavedsInput;
  where?: InputMaybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletUpdateToOneWithWhereWithoutPaymentsInput = {
  data: FinancialTeamWalletUpdateWithoutPaymentsInput;
  where?: InputMaybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletUpdateToOneWithWhereWithoutSubscriptionsInput = {
  data: FinancialTeamWalletUpdateWithoutSubscriptionsInput;
  where?: InputMaybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletUpdateToOneWithWhereWithoutTeamCostConfigsInput = {
  data: FinancialTeamWalletUpdateWithoutTeamCostConfigsInput;
  where?: InputMaybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletUpdateToOneWithWhereWithoutTeamInput = {
  data: FinancialTeamWalletUpdateWithoutTeamInput;
  where?: InputMaybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletUpdateToOneWithWhereWithoutTeamSignupSelectedOptionsInput = {
  data: FinancialTeamWalletUpdateWithoutTeamSignupSelectedOptionsInput;
  where?: InputMaybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletUpdateWithoutChargesInput = {
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutTeamWalletNestedInput>;
  Payments?: InputMaybe<FinancialPaymentUpdateManyWithoutTeamWalletNestedInput>;
  Subscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutTeamWalletNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutFinancialTeamWalletNestedInput>;
  TeamCostConfigs?: InputMaybe<FinancialTeamCostConfigUpdateManyWithoutTeamWalletNestedInput>;
  TeamSignupSelectedOptions?: InputMaybe<FinancialTeamSignupSelectedOptionsUpdateManyWithoutTeamWalletNestedInput>;
  creditsDetachedRb?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsDetachedRtRa?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsDetachedVisual?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanRb?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanRtRa?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanTrial?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanVisual?: InputMaybe<IntFieldUpdateOperationsInput>;
  financialProviderCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletUpdateWithoutCreditCardSavedsInput = {
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutTeamWalletNestedInput>;
  Payments?: InputMaybe<FinancialPaymentUpdateManyWithoutTeamWalletNestedInput>;
  Subscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutTeamWalletNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutFinancialTeamWalletNestedInput>;
  TeamCostConfigs?: InputMaybe<FinancialTeamCostConfigUpdateManyWithoutTeamWalletNestedInput>;
  TeamSignupSelectedOptions?: InputMaybe<FinancialTeamSignupSelectedOptionsUpdateManyWithoutTeamWalletNestedInput>;
  creditsDetachedRb?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsDetachedRtRa?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsDetachedVisual?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanRb?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanRtRa?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanTrial?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanVisual?: InputMaybe<IntFieldUpdateOperationsInput>;
  financialProviderCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletUpdateWithoutPaymentsInput = {
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutTeamWalletNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutTeamWalletNestedInput>;
  Subscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutTeamWalletNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutFinancialTeamWalletNestedInput>;
  TeamCostConfigs?: InputMaybe<FinancialTeamCostConfigUpdateManyWithoutTeamWalletNestedInput>;
  TeamSignupSelectedOptions?: InputMaybe<FinancialTeamSignupSelectedOptionsUpdateManyWithoutTeamWalletNestedInput>;
  creditsDetachedRb?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsDetachedRtRa?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsDetachedVisual?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanRb?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanRtRa?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanTrial?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanVisual?: InputMaybe<IntFieldUpdateOperationsInput>;
  financialProviderCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletUpdateWithoutSubscriptionsInput = {
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutTeamWalletNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutTeamWalletNestedInput>;
  Payments?: InputMaybe<FinancialPaymentUpdateManyWithoutTeamWalletNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutFinancialTeamWalletNestedInput>;
  TeamCostConfigs?: InputMaybe<FinancialTeamCostConfigUpdateManyWithoutTeamWalletNestedInput>;
  TeamSignupSelectedOptions?: InputMaybe<FinancialTeamSignupSelectedOptionsUpdateManyWithoutTeamWalletNestedInput>;
  creditsDetachedRb?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsDetachedRtRa?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsDetachedVisual?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanRb?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanRtRa?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanTrial?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanVisual?: InputMaybe<IntFieldUpdateOperationsInput>;
  financialProviderCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletUpdateWithoutTeamCostConfigsInput = {
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutTeamWalletNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutTeamWalletNestedInput>;
  Payments?: InputMaybe<FinancialPaymentUpdateManyWithoutTeamWalletNestedInput>;
  Subscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutTeamWalletNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutFinancialTeamWalletNestedInput>;
  TeamSignupSelectedOptions?: InputMaybe<FinancialTeamSignupSelectedOptionsUpdateManyWithoutTeamWalletNestedInput>;
  creditsDetachedRb?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsDetachedRtRa?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsDetachedVisual?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanRb?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanRtRa?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanTrial?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanVisual?: InputMaybe<IntFieldUpdateOperationsInput>;
  financialProviderCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletUpdateWithoutTeamInput = {
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutTeamWalletNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutTeamWalletNestedInput>;
  Payments?: InputMaybe<FinancialPaymentUpdateManyWithoutTeamWalletNestedInput>;
  Subscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutTeamWalletNestedInput>;
  TeamCostConfigs?: InputMaybe<FinancialTeamCostConfigUpdateManyWithoutTeamWalletNestedInput>;
  TeamSignupSelectedOptions?: InputMaybe<FinancialTeamSignupSelectedOptionsUpdateManyWithoutTeamWalletNestedInput>;
  creditsDetachedRb?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsDetachedRtRa?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsDetachedVisual?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanRb?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanRtRa?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanTrial?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanVisual?: InputMaybe<IntFieldUpdateOperationsInput>;
  financialProviderCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletUpdateWithoutTeamSignupSelectedOptionsInput = {
  Charges?: InputMaybe<FinancialChargeUpdateManyWithoutTeamWalletNestedInput>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedUpdateManyWithoutTeamWalletNestedInput>;
  Payments?: InputMaybe<FinancialPaymentUpdateManyWithoutTeamWalletNestedInput>;
  Subscriptions?: InputMaybe<FinancialTeamWalletSubscriptionUpdateManyWithoutTeamWalletNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutFinancialTeamWalletNestedInput>;
  TeamCostConfigs?: InputMaybe<FinancialTeamCostConfigUpdateManyWithoutTeamWalletNestedInput>;
  creditsDetachedRb?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsDetachedRtRa?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsDetachedVisual?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanRb?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanRtRa?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanTrial?: InputMaybe<IntFieldUpdateOperationsInput>;
  creditsPlanVisual?: InputMaybe<IntFieldUpdateOperationsInput>;
  financialProviderCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type FinancialTeamWalletUpsertWithoutChargesInput = {
  create: FinancialTeamWalletCreateWithoutChargesInput;
  update: FinancialTeamWalletUpdateWithoutChargesInput;
  where?: InputMaybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletUpsertWithoutCreditCardSavedsInput = {
  create: FinancialTeamWalletCreateWithoutCreditCardSavedsInput;
  update: FinancialTeamWalletUpdateWithoutCreditCardSavedsInput;
  where?: InputMaybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletUpsertWithoutPaymentsInput = {
  create: FinancialTeamWalletCreateWithoutPaymentsInput;
  update: FinancialTeamWalletUpdateWithoutPaymentsInput;
  where?: InputMaybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletUpsertWithoutSubscriptionsInput = {
  create: FinancialTeamWalletCreateWithoutSubscriptionsInput;
  update: FinancialTeamWalletUpdateWithoutSubscriptionsInput;
  where?: InputMaybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletUpsertWithoutTeamCostConfigsInput = {
  create: FinancialTeamWalletCreateWithoutTeamCostConfigsInput;
  update: FinancialTeamWalletUpdateWithoutTeamCostConfigsInput;
  where?: InputMaybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletUpsertWithoutTeamInput = {
  create: FinancialTeamWalletCreateWithoutTeamInput;
  update: FinancialTeamWalletUpdateWithoutTeamInput;
  where?: InputMaybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletUpsertWithoutTeamSignupSelectedOptionsInput = {
  create: FinancialTeamWalletCreateWithoutTeamSignupSelectedOptionsInput;
  update: FinancialTeamWalletUpdateWithoutTeamSignupSelectedOptionsInput;
  where?: InputMaybe<FinancialTeamWalletWhereInput>;
};

export type FinancialTeamWalletWhereInput = {
  AND?: InputMaybe<Array<FinancialTeamWalletWhereInput>>;
  Charges?: InputMaybe<FinancialChargeListRelationFilter>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedListRelationFilter>;
  NOT?: InputMaybe<Array<FinancialTeamWalletWhereInput>>;
  OR?: InputMaybe<Array<FinancialTeamWalletWhereInput>>;
  Payments?: InputMaybe<FinancialPaymentListRelationFilter>;
  Subscriptions?: InputMaybe<FinancialTeamWalletSubscriptionListRelationFilter>;
  Team?: InputMaybe<TeamWhereInput>;
  TeamCostConfigs?: InputMaybe<FinancialTeamCostConfigListRelationFilter>;
  TeamSignupSelectedOptions?: InputMaybe<FinancialTeamSignupSelectedOptionsListRelationFilter>;
  creditsDetachedRb?: InputMaybe<IntFilter>;
  creditsDetachedRtRa?: InputMaybe<IntFilter>;
  creditsDetachedVisual?: InputMaybe<IntFilter>;
  creditsPlanRb?: InputMaybe<IntFilter>;
  creditsPlanRtRa?: InputMaybe<IntFilter>;
  creditsPlanTrial?: InputMaybe<IntFilter>;
  creditsPlanVisual?: InputMaybe<IntFilter>;
  financialProviderCustomerId?: InputMaybe<StringNullableFilter>;
  teamId?: InputMaybe<IntFilter>;
};

export type FinancialTeamWalletWhereUniqueInput = {
  AND?: InputMaybe<Array<FinancialTeamWalletWhereInput>>;
  Charges?: InputMaybe<FinancialChargeListRelationFilter>;
  CreditCardSaveds?: InputMaybe<FinancialCreditCardSavedListRelationFilter>;
  NOT?: InputMaybe<Array<FinancialTeamWalletWhereInput>>;
  OR?: InputMaybe<Array<FinancialTeamWalletWhereInput>>;
  Payments?: InputMaybe<FinancialPaymentListRelationFilter>;
  Subscriptions?: InputMaybe<FinancialTeamWalletSubscriptionListRelationFilter>;
  Team?: InputMaybe<TeamWhereInput>;
  TeamCostConfigs?: InputMaybe<FinancialTeamCostConfigListRelationFilter>;
  TeamSignupSelectedOptions?: InputMaybe<FinancialTeamSignupSelectedOptionsListRelationFilter>;
  creditsDetachedRb?: InputMaybe<IntFilter>;
  creditsDetachedRtRa?: InputMaybe<IntFilter>;
  creditsDetachedVisual?: InputMaybe<IntFilter>;
  creditsPlanRb?: InputMaybe<IntFilter>;
  creditsPlanRtRa?: InputMaybe<IntFilter>;
  creditsPlanTrial?: InputMaybe<IntFilter>;
  creditsPlanVisual?: InputMaybe<IntFilter>;
  financialProviderCustomerId?: InputMaybe<StringNullableFilter>;
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type FindPublicViewDegreeDomainPathObject = {
  __typename?: 'FindPublicViewDegreeDomainPathObject';
  foundTeam: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  publicViewDegreeDomainPath?: Maybe<Scalars['String']['output']>;
};

export type FloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']['input']>;
  divide?: InputMaybe<Scalars['Float']['input']>;
  increment?: InputMaybe<Scalars['Float']['input']>;
  multiply?: InputMaybe<Scalars['Float']['input']>;
  set?: InputMaybe<Scalars['Float']['input']>;
};

export type FloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FloatWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedFloatFilter>;
  _min?: InputMaybe<NestedFloatFilter>;
  _sum?: InputMaybe<NestedFloatFilter>;
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FuzzySearch = {
  keys: Array<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type GeneratedCertificateData = {
  __typename?: 'GeneratedCertificateData';
  bulkCertificateRecordId: Scalars['String']['output'];
  certificateId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  institutionId: Scalars['Int']['output'];
  totalCertificates: Scalars['Int']['output'];
  totalIssued: Scalars['Int']['output'];
};

export type GroupEmails = {
  /** If one item was undefined, it will be considered e-CNPJ */
  emails: Array<InputMaybe<Scalars['String']['input']>>;
};

export type InitializeResponseInput = {
  dataToSign: Scalars['String']['input'];
  lastSignatureIsoString: Scalars['String']['input'];
  signingTime: Scalars['String']['input'];
};

export type InputFinancialPurchaseCreditCard = {
  fields: InputFinancialPurchaseCreditCardFields;
  save: Scalars['Boolean']['input'];
};

export type InputFinancialPurchaseCreditCardFields = {
  addressComplement: Scalars['String']['input'];
  addressNumber: Scalars['String']['input'];
  adressCep: Scalars['String']['input'];
  cpfCnpj: Scalars['String']['input'];
  cvc: Scalars['String']['input'];
  email: Scalars['String']['input'];
  expiry: Scalars['String']['input'];
  name: Scalars['String']['input'];
  number: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type InputFinancialPurchaseSavedCreditCard = {
  idCard: Scalars['Int']['input'];
};

export enum InstitutionActionMethod {
  Activate = 'ACTIVATE',
  Inactivate = 'INACTIVATE'
}

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedIntNullableFilter>;
  _min?: InputMaybe<NestedIntNullableFilter>;
  _sum?: InputMaybe<NestedIntNullableFilter>;
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedIntFilter>;
  _min?: InputMaybe<NestedIntFilter>;
  _sum?: InputMaybe<NestedIntFilter>;
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type InviteGroups = {
  groups: Array<GroupEmails>;
  id: Scalars['String']['input'];
};

export type JsonFilter = {
  array_contains?: InputMaybe<Scalars['Json']['input']>;
  array_ends_with?: InputMaybe<Scalars['Json']['input']>;
  array_starts_with?: InputMaybe<Scalars['Json']['input']>;
  equals?: InputMaybe<Scalars['Json']['input']>;
  gt?: InputMaybe<Scalars['Json']['input']>;
  gte?: InputMaybe<Scalars['Json']['input']>;
  lt?: InputMaybe<Scalars['Json']['input']>;
  lte?: InputMaybe<Scalars['Json']['input']>;
  not?: InputMaybe<Scalars['Json']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum JsonNullValueFilter {
  AnyNull = 'AnyNull',
  DbNull = 'DbNull',
  JsonNull = 'JsonNull'
}

export enum JsonNullValueInput {
  JsonNull = 'JsonNull'
}

export type JsonNullableFilter = {
  array_contains?: InputMaybe<Scalars['Json']['input']>;
  array_ends_with?: InputMaybe<Scalars['Json']['input']>;
  array_starts_with?: InputMaybe<Scalars['Json']['input']>;
  equals?: InputMaybe<Scalars['Json']['input']>;
  gt?: InputMaybe<Scalars['Json']['input']>;
  gte?: InputMaybe<Scalars['Json']['input']>;
  lt?: InputMaybe<Scalars['Json']['input']>;
  lte?: InputMaybe<Scalars['Json']['input']>;
  not?: InputMaybe<Scalars['Json']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type JsonNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedJsonNullableFilter>;
  _min?: InputMaybe<NestedJsonNullableFilter>;
  array_contains?: InputMaybe<Scalars['Json']['input']>;
  array_ends_with?: InputMaybe<Scalars['Json']['input']>;
  array_starts_with?: InputMaybe<Scalars['Json']['input']>;
  equals?: InputMaybe<Scalars['Json']['input']>;
  gt?: InputMaybe<Scalars['Json']['input']>;
  gte?: InputMaybe<Scalars['Json']['input']>;
  lt?: InputMaybe<Scalars['Json']['input']>;
  lte?: InputMaybe<Scalars['Json']['input']>;
  not?: InputMaybe<Scalars['Json']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type JsonWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedJsonFilter>;
  _min?: InputMaybe<NestedJsonFilter>;
  array_contains?: InputMaybe<Scalars['Json']['input']>;
  array_ends_with?: InputMaybe<Scalars['Json']['input']>;
  array_starts_with?: InputMaybe<Scalars['Json']['input']>;
  equals?: InputMaybe<Scalars['Json']['input']>;
  gt?: InputMaybe<Scalars['Json']['input']>;
  gte?: InputMaybe<Scalars['Json']['input']>;
  lt?: InputMaybe<Scalars['Json']['input']>;
  lte?: InputMaybe<Scalars['Json']['input']>;
  not?: InputMaybe<Scalars['Json']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type KeyValue = {
  __typename?: 'KeyValue';
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type Maintainer = {
  __typename?: 'Maintainer';
  MainTeam: Team;
  MaintainerAdmin: Array<MaintainerAdmin>;
  Teams: Array<Team>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  mainTeamId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type MaintainerMaintainerAdminArgs = {
  cursor?: InputMaybe<MaintainerAdminWhereUniqueInput>;
  distinct?: InputMaybe<Array<MaintainerAdminScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MaintainerAdminOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MaintainerAdminWhereInput>;
};


export type MaintainerTeamsArgs = {
  cursor?: InputMaybe<TeamWhereUniqueInput>;
  distinct?: InputMaybe<Array<TeamScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TeamOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeamWhereInput>;
};

export type MaintainerAdmin = {
  __typename?: 'MaintainerAdmin';
  Maintainer: Maintainer;
  User: CommonUser;
  commonUserId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  maintainerId: Scalars['Int']['output'];
};

export type MaintainerAdminAvgOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  maintainerId?: InputMaybe<SortOrder>;
};

export type MaintainerAdminCountOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  maintainerId?: InputMaybe<SortOrder>;
};

export type MaintainerAdminCreateInput = {
  Maintainer: MaintainerCreateNestedOneWithoutMaintainerAdminInput;
  User: CommonUserCreateNestedOneWithoutMaintainerAdminInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MaintainerAdminCreateManyInput = {
  commonUserId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  maintainerId: Scalars['Int']['input'];
};

export type MaintainerAdminCreateManyMaintainerInput = {
  commonUserId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MaintainerAdminCreateManyMaintainerInputEnvelope = {
  data: Array<MaintainerAdminCreateManyMaintainerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MaintainerAdminCreateNestedManyWithoutMaintainerInput = {
  connect?: InputMaybe<Array<MaintainerAdminWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaintainerAdminCreateOrConnectWithoutMaintainerInput>>;
  create?: InputMaybe<Array<MaintainerAdminCreateWithoutMaintainerInput>>;
  createMany?: InputMaybe<MaintainerAdminCreateManyMaintainerInputEnvelope>;
};

export type MaintainerAdminCreateNestedOneWithoutUserInput = {
  connect?: InputMaybe<MaintainerAdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MaintainerAdminCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<MaintainerAdminCreateWithoutUserInput>;
};

export type MaintainerAdminCreateOrConnectWithoutMaintainerInput = {
  create: MaintainerAdminCreateWithoutMaintainerInput;
  where: MaintainerAdminWhereUniqueInput;
};

export type MaintainerAdminCreateOrConnectWithoutUserInput = {
  create: MaintainerAdminCreateWithoutUserInput;
  where: MaintainerAdminWhereUniqueInput;
};

export type MaintainerAdminCreateWithoutMaintainerInput = {
  User: CommonUserCreateNestedOneWithoutMaintainerAdminInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MaintainerAdminCreateWithoutUserInput = {
  Maintainer: MaintainerCreateNestedOneWithoutMaintainerAdminInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MaintainerAdminListRelationFilter = {
  every?: InputMaybe<MaintainerAdminWhereInput>;
  none?: InputMaybe<MaintainerAdminWhereInput>;
  some?: InputMaybe<MaintainerAdminWhereInput>;
};

export type MaintainerAdminMaxOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  maintainerId?: InputMaybe<SortOrder>;
};

export type MaintainerAdminMinOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  maintainerId?: InputMaybe<SortOrder>;
};

export type MaintainerAdminNullableRelationFilter = {
  is?: InputMaybe<MaintainerAdminWhereInput>;
  isNot?: InputMaybe<MaintainerAdminWhereInput>;
};

export type MaintainerAdminOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MaintainerAdminOrderByWithAggregationInput = {
  _avg?: InputMaybe<MaintainerAdminAvgOrderByAggregateInput>;
  _count?: InputMaybe<MaintainerAdminCountOrderByAggregateInput>;
  _max?: InputMaybe<MaintainerAdminMaxOrderByAggregateInput>;
  _min?: InputMaybe<MaintainerAdminMinOrderByAggregateInput>;
  _sum?: InputMaybe<MaintainerAdminSumOrderByAggregateInput>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  maintainerId?: InputMaybe<SortOrder>;
};

export type MaintainerAdminOrderByWithRelationInput = {
  Maintainer?: InputMaybe<MaintainerOrderByWithRelationInput>;
  User?: InputMaybe<CommonUserOrderByWithRelationInput>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  maintainerId?: InputMaybe<SortOrder>;
};

export enum MaintainerAdminScalarFieldEnum {
  CommonUserId = 'commonUserId',
  CreatedAt = 'createdAt',
  MaintainerId = 'maintainerId'
}

export type MaintainerAdminScalarWhereInput = {
  AND?: InputMaybe<Array<MaintainerAdminScalarWhereInput>>;
  NOT?: InputMaybe<Array<MaintainerAdminScalarWhereInput>>;
  OR?: InputMaybe<Array<MaintainerAdminScalarWhereInput>>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  maintainerId?: InputMaybe<IntFilter>;
};

export type MaintainerAdminScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<MaintainerAdminScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<MaintainerAdminScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<MaintainerAdminScalarWhereWithAggregatesInput>>;
  commonUserId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  maintainerId?: InputMaybe<IntWithAggregatesFilter>;
};

export type MaintainerAdminSumOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  maintainerId?: InputMaybe<SortOrder>;
};

export type MaintainerAdminUpdateInput = {
  Maintainer?: InputMaybe<MaintainerUpdateOneRequiredWithoutMaintainerAdminNestedInput>;
  User?: InputMaybe<CommonUserUpdateOneRequiredWithoutMaintainerAdminNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MaintainerAdminUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MaintainerAdminUpdateManyWithWhereWithoutMaintainerInput = {
  data: MaintainerAdminUpdateManyMutationInput;
  where: MaintainerAdminScalarWhereInput;
};

export type MaintainerAdminUpdateManyWithoutMaintainerNestedInput = {
  connect?: InputMaybe<Array<MaintainerAdminWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaintainerAdminCreateOrConnectWithoutMaintainerInput>>;
  create?: InputMaybe<Array<MaintainerAdminCreateWithoutMaintainerInput>>;
  createMany?: InputMaybe<MaintainerAdminCreateManyMaintainerInputEnvelope>;
  delete?: InputMaybe<Array<MaintainerAdminWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MaintainerAdminScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MaintainerAdminWhereUniqueInput>>;
  set?: InputMaybe<Array<MaintainerAdminWhereUniqueInput>>;
  update?: InputMaybe<Array<MaintainerAdminUpdateWithWhereUniqueWithoutMaintainerInput>>;
  updateMany?: InputMaybe<Array<MaintainerAdminUpdateManyWithWhereWithoutMaintainerInput>>;
  upsert?: InputMaybe<Array<MaintainerAdminUpsertWithWhereUniqueWithoutMaintainerInput>>;
};

export type MaintainerAdminUpdateOneWithoutUserNestedInput = {
  connect?: InputMaybe<MaintainerAdminWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MaintainerAdminCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<MaintainerAdminCreateWithoutUserInput>;
  delete?: InputMaybe<MaintainerAdminWhereInput>;
  disconnect?: InputMaybe<MaintainerAdminWhereInput>;
  update?: InputMaybe<MaintainerAdminUpdateToOneWithWhereWithoutUserInput>;
  upsert?: InputMaybe<MaintainerAdminUpsertWithoutUserInput>;
};

export type MaintainerAdminUpdateToOneWithWhereWithoutUserInput = {
  data: MaintainerAdminUpdateWithoutUserInput;
  where?: InputMaybe<MaintainerAdminWhereInput>;
};

export type MaintainerAdminUpdateWithWhereUniqueWithoutMaintainerInput = {
  data: MaintainerAdminUpdateWithoutMaintainerInput;
  where: MaintainerAdminWhereUniqueInput;
};

export type MaintainerAdminUpdateWithoutMaintainerInput = {
  User?: InputMaybe<CommonUserUpdateOneRequiredWithoutMaintainerAdminNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MaintainerAdminUpdateWithoutUserInput = {
  Maintainer?: InputMaybe<MaintainerUpdateOneRequiredWithoutMaintainerAdminNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MaintainerAdminUpsertWithWhereUniqueWithoutMaintainerInput = {
  create: MaintainerAdminCreateWithoutMaintainerInput;
  update: MaintainerAdminUpdateWithoutMaintainerInput;
  where: MaintainerAdminWhereUniqueInput;
};

export type MaintainerAdminUpsertWithoutUserInput = {
  create: MaintainerAdminCreateWithoutUserInput;
  update: MaintainerAdminUpdateWithoutUserInput;
  where?: InputMaybe<MaintainerAdminWhereInput>;
};

export type MaintainerAdminWhereInput = {
  AND?: InputMaybe<Array<MaintainerAdminWhereInput>>;
  Maintainer?: InputMaybe<MaintainerWhereInput>;
  NOT?: InputMaybe<Array<MaintainerAdminWhereInput>>;
  OR?: InputMaybe<Array<MaintainerAdminWhereInput>>;
  User?: InputMaybe<CommonUserWhereInput>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  maintainerId?: InputMaybe<IntFilter>;
};

export type MaintainerAdminWhereUniqueInput = {
  AND?: InputMaybe<Array<MaintainerAdminWhereInput>>;
  Maintainer?: InputMaybe<MaintainerWhereInput>;
  NOT?: InputMaybe<Array<MaintainerAdminWhereInput>>;
  OR?: InputMaybe<Array<MaintainerAdminWhereInput>>;
  User?: InputMaybe<CommonUserWhereInput>;
  commonUserId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<DateTimeFilter>;
  maintainerId?: InputMaybe<IntFilter>;
};

export type MaintainerAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  mainTeamId?: InputMaybe<SortOrder>;
};

export type MaintainerCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mainTeamId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type MaintainerCreateInput = {
  MainTeam: TeamCreateNestedOneWithoutMainTeamOfMaintainerInput;
  MaintainerAdmin?: InputMaybe<MaintainerAdminCreateNestedManyWithoutMaintainerInput>;
  Teams?: InputMaybe<TeamCreateNestedManyWithoutMaintainerInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MaintainerCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  mainTeamId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MaintainerCreateNestedOneWithoutMainTeamInput = {
  connect?: InputMaybe<MaintainerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MaintainerCreateOrConnectWithoutMainTeamInput>;
  create?: InputMaybe<MaintainerCreateWithoutMainTeamInput>;
};

export type MaintainerCreateNestedOneWithoutMaintainerAdminInput = {
  connect?: InputMaybe<MaintainerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MaintainerCreateOrConnectWithoutMaintainerAdminInput>;
  create?: InputMaybe<MaintainerCreateWithoutMaintainerAdminInput>;
};

export type MaintainerCreateNestedOneWithoutTeamsInput = {
  connect?: InputMaybe<MaintainerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MaintainerCreateOrConnectWithoutTeamsInput>;
  create?: InputMaybe<MaintainerCreateWithoutTeamsInput>;
};

export type MaintainerCreateOrConnectWithoutMainTeamInput = {
  create: MaintainerCreateWithoutMainTeamInput;
  where: MaintainerWhereUniqueInput;
};

export type MaintainerCreateOrConnectWithoutMaintainerAdminInput = {
  create: MaintainerCreateWithoutMaintainerAdminInput;
  where: MaintainerWhereUniqueInput;
};

export type MaintainerCreateOrConnectWithoutTeamsInput = {
  create: MaintainerCreateWithoutTeamsInput;
  where: MaintainerWhereUniqueInput;
};

export type MaintainerCreateWithoutMainTeamInput = {
  MaintainerAdmin?: InputMaybe<MaintainerAdminCreateNestedManyWithoutMaintainerInput>;
  Teams?: InputMaybe<TeamCreateNestedManyWithoutMaintainerInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MaintainerCreateWithoutMaintainerAdminInput = {
  MainTeam: TeamCreateNestedOneWithoutMainTeamOfMaintainerInput;
  Teams?: InputMaybe<TeamCreateNestedManyWithoutMaintainerInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MaintainerCreateWithoutTeamsInput = {
  MainTeam: TeamCreateNestedOneWithoutMainTeamOfMaintainerInput;
  MaintainerAdmin?: InputMaybe<MaintainerAdminCreateNestedManyWithoutMaintainerInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MaintainerMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mainTeamId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type MaintainerMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mainTeamId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type MaintainerNullableRelationFilter = {
  is?: InputMaybe<MaintainerWhereInput>;
  isNot?: InputMaybe<MaintainerWhereInput>;
};

export type MaintainerOrderByWithAggregationInput = {
  _avg?: InputMaybe<MaintainerAvgOrderByAggregateInput>;
  _count?: InputMaybe<MaintainerCountOrderByAggregateInput>;
  _max?: InputMaybe<MaintainerMaxOrderByAggregateInput>;
  _min?: InputMaybe<MaintainerMinOrderByAggregateInput>;
  _sum?: InputMaybe<MaintainerSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mainTeamId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type MaintainerOrderByWithRelationInput = {
  MainTeam?: InputMaybe<TeamOrderByWithRelationInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminOrderByRelationAggregateInput>;
  Teams?: InputMaybe<TeamOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mainTeamId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type MaintainerRelationFilter = {
  is?: InputMaybe<MaintainerWhereInput>;
  isNot?: InputMaybe<MaintainerWhereInput>;
};

export enum MaintainerScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  MainTeamId = 'mainTeamId',
  UpdatedAt = 'updatedAt'
}

export type MaintainerScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<MaintainerScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<MaintainerScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<MaintainerScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  mainTeamId?: InputMaybe<IntWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type MaintainerSpace = {
  __typename?: 'MaintainerSpace';
  id: Scalars['Int']['output'];
  storage: Scalars['Int']['output'];
  usage: Scalars['Int']['output'];
};

export type MaintainerSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  mainTeamId?: InputMaybe<SortOrder>;
};

export type MaintainerUpdateInput = {
  MainTeam?: InputMaybe<TeamUpdateOneRequiredWithoutMainTeamOfMaintainerNestedInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminUpdateManyWithoutMaintainerNestedInput>;
  Teams?: InputMaybe<TeamUpdateManyWithoutMaintainerNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type MaintainerUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type MaintainerUpdateOneRequiredWithoutMaintainerAdminNestedInput = {
  connect?: InputMaybe<MaintainerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MaintainerCreateOrConnectWithoutMaintainerAdminInput>;
  create?: InputMaybe<MaintainerCreateWithoutMaintainerAdminInput>;
  update?: InputMaybe<MaintainerUpdateToOneWithWhereWithoutMaintainerAdminInput>;
  upsert?: InputMaybe<MaintainerUpsertWithoutMaintainerAdminInput>;
};

export type MaintainerUpdateOneWithoutMainTeamNestedInput = {
  connect?: InputMaybe<MaintainerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MaintainerCreateOrConnectWithoutMainTeamInput>;
  create?: InputMaybe<MaintainerCreateWithoutMainTeamInput>;
  delete?: InputMaybe<MaintainerWhereInput>;
  disconnect?: InputMaybe<MaintainerWhereInput>;
  update?: InputMaybe<MaintainerUpdateToOneWithWhereWithoutMainTeamInput>;
  upsert?: InputMaybe<MaintainerUpsertWithoutMainTeamInput>;
};

export type MaintainerUpdateOneWithoutTeamsNestedInput = {
  connect?: InputMaybe<MaintainerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MaintainerCreateOrConnectWithoutTeamsInput>;
  create?: InputMaybe<MaintainerCreateWithoutTeamsInput>;
  delete?: InputMaybe<MaintainerWhereInput>;
  disconnect?: InputMaybe<MaintainerWhereInput>;
  update?: InputMaybe<MaintainerUpdateToOneWithWhereWithoutTeamsInput>;
  upsert?: InputMaybe<MaintainerUpsertWithoutTeamsInput>;
};

export type MaintainerUpdateToOneWithWhereWithoutMainTeamInput = {
  data: MaintainerUpdateWithoutMainTeamInput;
  where?: InputMaybe<MaintainerWhereInput>;
};

export type MaintainerUpdateToOneWithWhereWithoutMaintainerAdminInput = {
  data: MaintainerUpdateWithoutMaintainerAdminInput;
  where?: InputMaybe<MaintainerWhereInput>;
};

export type MaintainerUpdateToOneWithWhereWithoutTeamsInput = {
  data: MaintainerUpdateWithoutTeamsInput;
  where?: InputMaybe<MaintainerWhereInput>;
};

export type MaintainerUpdateWithoutMainTeamInput = {
  MaintainerAdmin?: InputMaybe<MaintainerAdminUpdateManyWithoutMaintainerNestedInput>;
  Teams?: InputMaybe<TeamUpdateManyWithoutMaintainerNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type MaintainerUpdateWithoutMaintainerAdminInput = {
  MainTeam?: InputMaybe<TeamUpdateOneRequiredWithoutMainTeamOfMaintainerNestedInput>;
  Teams?: InputMaybe<TeamUpdateManyWithoutMaintainerNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type MaintainerUpdateWithoutTeamsInput = {
  MainTeam?: InputMaybe<TeamUpdateOneRequiredWithoutMainTeamOfMaintainerNestedInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminUpdateManyWithoutMaintainerNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type MaintainerUpsertWithoutMainTeamInput = {
  create: MaintainerCreateWithoutMainTeamInput;
  update: MaintainerUpdateWithoutMainTeamInput;
  where?: InputMaybe<MaintainerWhereInput>;
};

export type MaintainerUpsertWithoutMaintainerAdminInput = {
  create: MaintainerCreateWithoutMaintainerAdminInput;
  update: MaintainerUpdateWithoutMaintainerAdminInput;
  where?: InputMaybe<MaintainerWhereInput>;
};

export type MaintainerUpsertWithoutTeamsInput = {
  create: MaintainerCreateWithoutTeamsInput;
  update: MaintainerUpdateWithoutTeamsInput;
  where?: InputMaybe<MaintainerWhereInput>;
};

export type MaintainerWhereInput = {
  AND?: InputMaybe<Array<MaintainerWhereInput>>;
  MainTeam?: InputMaybe<TeamWhereInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminListRelationFilter>;
  NOT?: InputMaybe<Array<MaintainerWhereInput>>;
  OR?: InputMaybe<Array<MaintainerWhereInput>>;
  Teams?: InputMaybe<TeamListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  mainTeamId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MaintainerWhereUniqueInput = {
  AND?: InputMaybe<Array<MaintainerWhereInput>>;
  MainTeam?: InputMaybe<TeamWhereInput>;
  MaintainerAdmin?: InputMaybe<MaintainerAdminListRelationFilter>;
  NOT?: InputMaybe<Array<MaintainerWhereInput>>;
  OR?: InputMaybe<Array<MaintainerWhereInput>>;
  Teams?: InputMaybe<TeamListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  mainTeamId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addOneTeamMember: TeamMember;
  buildOneDegreeVisualRepresentation?: Maybe<DocumentDegree>;
  /**
   * Essa mutation deve produzir o login em 3 fluxos possíveis:
   *
   * 1. Login via LedgerSign, fornecendo o token recebido no LedgerSign
   * 2. Login através da funcionalidade "Login como", fornecendo o email no lugar do token
   * 3. Login através de devs em desenvolvimento, fornecendo o email no lugar do token
   */
  codeAuthLoginLedgerSign: CommonUser;
  codeAuthRefreshTokens: CommonUser;
  codeDevCallGarbageCollectorGc: Scalars['Boolean']['output'];
  codeDevGenerateMemoryOutput: Scalars['Json']['output'];
  /**
   *
   * Recria o XML para re-assinatura do documento.
   * 1. Faz o build do XML
   * 2. Deleta as assinaturas "realizadas"
   *
   */
  codeDevRebuildXml: Scalars['Boolean']['output'];
  codeDevSetFullPermissions: Scalars['String']['output'];
  codeDevUseTemporaryMemory: Scalars['Json']['output'];
  /** Atualiza tamanhos de documentos e espaço usado por time. Só contar para o espaço documentos não deletados. */
  codeMigrateDocumentSizes: Scalars['Json']['output'];
  codeServiceSendMessageToSlack: Scalars['String']['output'];
  /** Conclui o cadastro de uma assinatura pelo celular */
  completeOneTemporarySignatureImage: SignSignatureImage;
  /** Correção de arquivo de fiscalização e envio para revisão */
  correctOneDocumentAuditFileIssuer: DocumentAuditFileIssuer;
  createApiKey: Scalars['String']['output'];
  createBulkDocumentCertificate: BulkCertificateRecord;
  createOneCertificateCourse: CertificateCourse;
  createOneCertificateCourseLevel: CertificateCourseLevel;
  createOneCertificateCurriculum: CertificateCurriculum;
  createOneCertificateDiscipline: CertificateDiscipline;
  createOneCertificateEvent: CertificateEvent;
  createOneCertificateTeacher: CertificateTeacher;
  createOneCertificateTemplate: CertificateTemplate;
  createOneCertificateTemplatePreset: CertificateTemplatePreset;
  createOneDegree: DocumentDegree;
  /** Cria o rascunho de um Diploma Digital a partir de uma documentação acadêmica emitida da própria IES */
  createOneDegreeFromAcademicDocumentation: DocumentDegree;
  /** Finalização da documentação acadêmica e envio para revisão */
  createOneDocumentAcademicDocumentation: DocumentAcademicDocumentation;
  createOneDocumentAcademicDocumentationFromRevokedDocument: DocumentAcademicDocumentation;
  /** Finalização do arquivo de fiscalização e envio para revisão */
  createOneDocumentAuditFileIssuer: DocumentAuditFileIssuer;
  createOneDocumentCertificate: DocumentCertificate;
  createOneDocumentCertificatePreview: Scalars['String']['output'];
  createOneDocumentFinalAcademicTranscript: DocumentFinalAcademicTranscript;
  /** Finalização do curriculo escolar e envio para revisão */
  createOneDocumentSchoolCurriculum: DocumentSchoolCurriculum;
  createOneEnabledInstitution: EnabledInstitution;
  createOneFinancialRecharge: FinancialRecharge;
  createOneMaintainerAdmin: MaintainerAdmin;
  createOneMaintainerTeam: Team;
  createOnePerson: Person;
  createOneReusableFormDataCurriculum: ReusableFormDataCurriculum;
  createOneSignSignatureImage: SignSignatureImage;
  createOneSystemGlobalAlert: SystemGlobalAlert;
  createOneTeamContract: TeamContract;
  defineOneSignSignatureImageAsPrimary?: Maybe<SignSignatureImage>;
  defineSigners: Array<DocumentBaseSignatureInviteGroup>;
  deleteOneApiKey?: Maybe<ApiKey>;
  deleteOneCertificateBase?: Maybe<CertificateBase>;
  deleteOneCertificateTemplate?: Maybe<CertificateTemplate>;
  deleteOneCertificateTemplatePreset?: Maybe<CertificateTemplatePreset>;
  deleteOneDegreeVisualRepresentation?: Maybe<DocumentDegree>;
  deleteOneDocumentBase?: Maybe<DocumentBase>;
  deleteOneDocumentBaseDefaultSignatureInviteConfiguration: DocumentBaseDefaultSignatureInviteConfiguration;
  deleteOneFinancialCreditCardSaved?: Maybe<FinancialCreditCardSaved>;
  deleteOneMaintainerAdmin?: Maybe<MaintainerAdmin>;
  deleteOneMaintainerTeam?: Maybe<Team>;
  deleteOnePerson?: Maybe<Person>;
  deleteOneReusableFormData?: Maybe<ReusableFormData>;
  deleteOneReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculum>;
  deleteOneSignSignatureImage?: Maybe<SignSignatureImage>;
  deleteOneSystemGlobalAlert?: Maybe<SystemGlobalAlert>;
  deleteOneTeamContract?: Maybe<TeamContract>;
  deleteOneTeamDocumentTypeSpecificSignaturePolicyConfig: TeamDocumentTypeSpecificSignaturePolicyConfig;
  deleteOneTeamMember?: Maybe<TeamMember>;
  dismissSystemGlobalAlert: Scalars['Boolean']['output'];
  duplicateOneCertificateTemplate: CertificateTemplate;
  finalizeOneCertificateSignature: DocumentCertificateSignatureItemPossibleSignerInviteSignature;
  finalizeOneSignature: DocumentBaseSignatureInviteSignature;
  finalizeOneSignatureExternalSignatureInvite: ExternalSignatureInvite;
  financialTeamWalletActivateTrial: FinancialTeamWallet;
  financialTeamWalletPurchasePlan: PurchasedPlanWithOldPlan;
  financialTeamWalletSubscriptionCancelPlan: FinancialTeamWalletSubscription;
  /** Usado durante os testes. Dispara a rodada de renotarização do cron restrita ao documento e retorna o id do job */
  forceDocumentRenotarization: Scalars['String']['output'];
  /** Usado durante os testes. Move a expiração do carimbo de tempo para dentro da janela de renotarização */
  forceDocumentRenotarizationWindow: Scalars['Int']['output'];
  /** Usado durante os testes já que não é possível assinar */
  forceGenerateDocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentation>;
  /** Usado durante os testes já que não é possível assinar */
  forceGenerateDocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculum>;
  /** Usado durante os testes já que não é possível assinar */
  forceSignDegree?: Maybe<DocumentDegree>;
  /** Ops/Admin: re-envia para a fila de webhook todas as assinaturas externas concluídas (isSigned=true) dos documentos informados. */
  opsResendExternalSignatureWebhooks: Scalars['Json']['output'];
  patchOneDegree: Scalars['DateTime']['output'];
  patchOneDocumentAcademicDocumentation: Scalars['DateTime']['output'];
  patchOneDocumentSchoolCurriculum: Scalars['DateTime']['output'];
  payOverduePayments: FinancialTeamWalletSubscription;
  /** Finalização da documentação acadêmica e envio para revisão */
  recreateOneAcademicDocumentationXml: DocumentAcademicDocumentation;
  renotarizeDocument: DocumentBase;
  replaceOneDegreeVisualRepresentation?: Maybe<DocumentDegree>;
  resendOneTeamMemberEmail: TeamMember;
  /** Reenvia para validação um Diploma Digital que ficou como "impossível validar", zerando as tentativas */
  revalidateOneDegree?: Maybe<DocumentDegree>;
  revalidateOneDocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentation>;
  /** Revisão do Diploma Digital. Se possuir razão da reprovação, então está sendo reprovado. */
  reviewOneDegree?: Maybe<DocumentDegree>;
  reviewOneDocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentation>;
  /** Revisão do arquivo de fiscalização. Se possuir razão da reprovação, então está sendo reprovado. */
  reviewOneDocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuer>;
  /** Revisão do curriculo escolar. Se possuir razão da reprovação, então está sendo reprovado. */
  reviewOneDocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculum>;
  revokeOneDocumentBase?: Maybe<DocumentBase>;
  saveOneCommonUserConfig: CommonUserConfig;
  /** Cria o rascunho de uma documentação acadêmica */
  saveOneDocumentAcademicDocumentation: DocumentAcademicDocumentation;
  /** Cria o rascunho de um curriculo escolar */
  saveOneDocumentSchoolCurriculum: DocumentSchoolCurriculum;
  saveOneReusableFormData: ReusableFormData;
  sendActivity: Scalars['String']['output'];
  /** Finalização do rascunho do Diploma Digital: gera o XML e envia para revisão */
  sendOneDegreeToReview?: Maybe<DocumentDegree>;
  signOnlyVisualOneSignature: DocumentCertificateSignatureItemPossibleSignerInviteSignature;
  /** Usado durante os testes já que o validador não roda no ambiente local */
  simulateDegreeValidationResponse?: Maybe<DocumentDegree>;
  singBulkCertificateVisualRepresentation: CustomReturnType;
  startOneCertificateSignature: StartSignature;
  startOneSignature: StartSignature;
  startOneSignatureExternalSignatureInvite: StartSignature;
  updateOneAcademicDocumentationSentToRegistrarStatus?: Maybe<DocumentAcademicDocumentation>;
  updateOneCertificateCourse?: Maybe<CertificateCourse>;
  updateOneCertificateCourseLevel?: Maybe<CertificateCourseLevel>;
  updateOneCertificateCurriculum?: Maybe<CertificateCurriculum>;
  updateOneCertificateDiscipline?: Maybe<CertificateDiscipline>;
  updateOneCertificateEvent?: Maybe<CertificateEvent>;
  updateOneCertificateTeacher?: Maybe<CertificateTeacher>;
  updateOneCertificateTemplate?: Maybe<CertificateTemplate>;
  updateOneCertificateTemplatePreset?: Maybe<CertificateTemplatePreset>;
  /** Marca ou desmarca o Diploma Digital como entregue ao diplomado. Não altera o status do documento. */
  updateOneDegreeSentToGraduateStatus?: Maybe<DocumentDegree>;
  updateOneDegreeVisualRepresentation?: Maybe<DocumentDegree>;
  updateOnePerson?: Maybe<Person>;
  updateOneReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculum>;
  updateOneSystemGlobalAlert?: Maybe<SystemGlobalAlert>;
  updateOneTeam?: Maybe<Team>;
  updateOneTeamContract?: Maybe<TeamContract>;
  /** Se certificateTemplateId for nulo, remove o modelo padrão */
  updateOneTeamDefaultDegreeCertificateTemplate?: Maybe<Team>;
  updateOneTeamMember?: Maybe<TeamMember>;
  updateTeamActivationStatus: Team;
  updateTeamConfigAddDocumentSignerNode?: Maybe<Team>;
  upsertDocumentBaseDefaultSignatureInviteConfiguration: DocumentBaseDefaultSignatureInviteConfiguration;
  /** Cria uma assinatura temporária ou usa uma existente para poder finalizar o cadastro pelo celular */
  upsertOneTemporarySignatureImage: SignSignatureImage;
  upsertTeamDocumentTypeSpecificSignaturePolicyConfig: TeamDocumentTypeSpecificSignaturePolicyConfig;
  validateOnePdfa: Scalars['Boolean']['output'];
};


export type MutationAddOneTeamMemberArgs = {
  email: Scalars['String']['input'];
  permissions: Array<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBuildOneDegreeVisualRepresentationArgs = {
  degreeId: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
  variables: Scalars['Json']['input'];
};


export type MutationCodeAuthLoginLedgerSignArgs = {
  subservice: SubService;
  token: Scalars['String']['input'];
};


export type MutationCodeAuthRefreshTokensArgs = {
  token: Scalars['String']['input'];
};


export type MutationCodeDevRebuildXmlArgs = {
  documentIds: Array<Scalars['String']['input']>;
};


export type MutationCodeDevUseTemporaryMemoryArgs = {
  sizeInMB: Scalars['Int']['input'];
};


export type MutationCodeServiceSendMessageToSlackArgs = {
  message: Scalars['String']['input'];
};


export type MutationCompleteOneTemporarySignatureImageArgs = {
  completeData: CompleteSignatureImage;
};


export type MutationCorrectOneDocumentAuditFileIssuerArgs = {
  degreeCount: Scalars['Int']['input'];
  documentBaseId: Scalars['String']['input'];
  endDate: Scalars['Date']['input'];
  excludeRevoked: Scalars['Boolean']['input'];
  startDate: Scalars['Date']['input'];
};


export type MutationCreateApiKeyArgs = {
  description: Scalars['String']['input'];
};


export type MutationCreateBulkDocumentCertificateArgs = {
  bulkCertificateRecordName?: InputMaybe<Scalars['String']['input']>;
  curriculumId?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  ignoreUsingExpensiveCreditsError?: InputMaybe<Scalars['Boolean']['input']>;
  importedRecords: Scalars['Json']['input'];
  templateId: Scalars['String']['input'];
  variables: Scalars['Json']['input'];
};


export type MutationCreateOneCertificateCourseArgs = {
  areaKnowledge: Scalars['String']['input'];
  courseLevelId?: InputMaybe<Scalars['String']['input']>;
  metaData: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreateOneCertificateCourseLevelArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateOneCertificateCurriculumArgs = {
  amountOfHours?: InputMaybe<Scalars['Int']['input']>;
  certificateCourseId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  selectedDisciplines: Array<CirriculumSelectedDiscipline>;
};


export type MutationCreateOneCertificateDisciplineArgs = {
  name: Scalars['String']['input'];
  viewOnDegree: Scalars['Boolean']['input'];
};


export type MutationCreateOneCertificateEventArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateOneCertificateTeacherArgs = {
  name: Scalars['String']['input'];
  titration: Scalars['String']['input'];
};


export type MutationCreateOneCertificateTemplateArgs = {
  data: Scalars['Json']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreateOneCertificateTemplatePresetArgs = {
  data: CertificateTemplatePresetCreateInput;
};


export type MutationCreateOneDegreeArgs = {
  degreeAcademicDocumentationId?: InputMaybe<Scalars['String']['input']>;
  visualRepresentation?: InputMaybe<Scalars['Upload']['input']>;
  xml: Scalars['Upload']['input'];
};


export type MutationCreateOneDegreeFromAcademicDocumentationArgs = {
  academicDocumentationId: Scalars['String']['input'];
};


export type MutationCreateOneDocumentAcademicDocumentationArgs = {
  draftId: Scalars['String']['input'];
};


export type MutationCreateOneDocumentAcademicDocumentationFromRevokedDocumentArgs = {
  documentId: Scalars['String']['input'];
};


export type MutationCreateOneDocumentAuditFileIssuerArgs = {
  degreeCount: Scalars['Int']['input'];
  endDate: Scalars['Date']['input'];
  excludeRevoked: Scalars['Boolean']['input'];
  startDate: Scalars['Date']['input'];
  version: Scalars['String']['input'];
};


export type MutationCreateOneDocumentCertificateArgs = {
  curriculumDisciplinesVariables: Array<CurriculumDisciplineVariable>;
  curriculumId?: InputMaybe<Scalars['String']['input']>;
  degreeId?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  ignoreUsingExpensiveCreditsError?: InputMaybe<Scalars['Boolean']['input']>;
  personId?: InputMaybe<Scalars['String']['input']>;
  studentCPF: Scalars['String']['input'];
  studentEmail: Scalars['String']['input'];
  studentName: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
  variables: Scalars['Json']['input'];
};


export type MutationCreateOneDocumentCertificatePreviewArgs = {
  curriculumDisciplinesVariables: Array<CurriculumDisciplineVariable>;
  curriculumId?: InputMaybe<Scalars['String']['input']>;
  degreeId?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  personId?: InputMaybe<Scalars['String']['input']>;
  studentCPF: Scalars['String']['input'];
  studentEmail: Scalars['String']['input'];
  studentName: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
  variables: Scalars['Json']['input'];
};


export type MutationCreateOneDocumentFinalAcademicTranscriptArgs = {
  baseAcademicId: Scalars['String']['input'];
};


export type MutationCreateOneDocumentSchoolCurriculumArgs = {
  id: Scalars['String']['input'];
};


export type MutationCreateOneEnabledInstitutionArgs = {
  data: CreateOneEnabledInstitutionInput;
};


export type MutationCreateOneFinancialRechargeArgs = {
  data: CreateOneFinancialRechargeInput;
};


export type MutationCreateOneMaintainerAdminArgs = {
  email: Scalars['String']['input'];
};


export type MutationCreateOneMaintainerTeamArgs = {
  CNPJ: Scalars['String']['input'];
  educationLevelType: Array<EducationLevelType>;
  placeholderName: Scalars['String']['input'];
};


export type MutationCreateOnePersonArgs = {
  address?: InputMaybe<AddressInput>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identityDocument?: InputMaybe<Scalars['String']['input']>;
  isForeign: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  passport?: InputMaybe<Scalars['String']['input']>;
  phones: Array<Scalars['String']['input']>;
  receivesCertificateEmail: Scalars['Boolean']['input'];
  receivesCertificateWhatsapp: Scalars['Boolean']['input'];
};


export type MutationCreateOneReusableFormDataCurriculumArgs = {
  data: ReusableFormDataCurriculumCreateInputCustom;
};


export type MutationCreateOneSignSignatureImageArgs = {
  data: CreateOneSignSignatureImageData;
};


export type MutationCreateOneSystemGlobalAlertArgs = {
  data: SystemGlobalAlertCreateInput;
};


export type MutationCreateOneTeamContractArgs = {
  data: TeamContractCreateInput;
};


export type MutationDefineOneSignSignatureImageAsPrimaryArgs = {
  where: SignSignatureImageWhereUniqueInput;
};


export type MutationDefineSignersArgs = {
  addSignersNode?: InputMaybe<Scalars['Boolean']['input']>;
  data: InviteGroups;
  saveDefault?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeleteOneApiKeyArgs = {
  apiKeyId: Scalars['Int']['input'];
};


export type MutationDeleteOneCertificateBaseArgs = {
  certificateId: Scalars['String']['input'];
};


export type MutationDeleteOneCertificateTemplateArgs = {
  where: CertificateTemplateWhereUniqueInput;
};


export type MutationDeleteOneCertificateTemplatePresetArgs = {
  where: CertificateTemplatePresetWhereUniqueInput;
};


export type MutationDeleteOneDegreeVisualRepresentationArgs = {
  degreeId: Scalars['String']['input'];
};


export type MutationDeleteOneDocumentBaseArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteOneDocumentBaseDefaultSignatureInviteConfigurationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteOneFinancialCreditCardSavedArgs = {
  where: FinancialCreditCardSavedWhereUniqueInput;
};


export type MutationDeleteOneMaintainerAdminArgs = {
  where: MaintainerAdminWhereUniqueInput;
};


export type MutationDeleteOneMaintainerTeamArgs = {
  where: TeamWhereUniqueInput;
};


export type MutationDeleteOnePersonArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteOneReusableFormDataArgs = {
  where: ReusableFormDataWhereUniqueInput;
};


export type MutationDeleteOneReusableFormDataCurriculumArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteOneSignSignatureImageArgs = {
  where: SignSignatureImageWhereUniqueInput;
};


export type MutationDeleteOneSystemGlobalAlertArgs = {
  where: SystemGlobalAlertWhereUniqueInput;
};


export type MutationDeleteOneTeamContractArgs = {
  where: TeamContractWhereUniqueInput;
};


export type MutationDeleteOneTeamDocumentTypeSpecificSignaturePolicyConfigArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteOneTeamMemberArgs = {
  where: TeamMemberWhereUniqueInput;
};


export type MutationDismissSystemGlobalAlertArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDuplicateOneCertificateTemplateArgs = {
  templateId: Scalars['String']['input'];
};


export type MutationFinalizeOneCertificateSignatureArgs = {
  certificate: Scalars['String']['input'];
  initialize: InitializeResponseInput;
  inviteId: Scalars['String']['input'];
  signatureImageId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationFinalizeOneSignatureArgs = {
  certificate: Scalars['String']['input'];
  initialize: InitializeResponseInput;
  inviteId: Scalars['Int']['input'];
};


export type MutationFinalizeOneSignatureExternalSignatureInviteArgs = {
  certificate: Scalars['String']['input'];
  initialize: InitializeResponseInput;
  inviteId: Scalars['String']['input'];
};


export type MutationFinancialTeamWalletPurchasePlanArgs = {
  data: FinancialTeamWalletPurchasePlanInput;
};


export type MutationForceDocumentRenotarizationArgs = {
  documentId: Scalars['String']['input'];
};


export type MutationForceDocumentRenotarizationWindowArgs = {
  documentId: Scalars['String']['input'];
};


export type MutationForceGenerateDocumentAcademicDocumentationArgs = {
  docId: Scalars['String']['input'];
};


export type MutationForceGenerateDocumentSchoolCurriculumArgs = {
  docId: Scalars['String']['input'];
};


export type MutationForceSignDegreeArgs = {
  degreeId: Scalars['String']['input'];
};


export type MutationOpsResendExternalSignatureWebhooksArgs = {
  documentIds: Array<Scalars['String']['input']>;
};


export type MutationPatchOneDegreeArgs = {
  changes: Array<DocumentChange>;
  id: Scalars['String']['input'];
};


export type MutationPatchOneDocumentAcademicDocumentationArgs = {
  changes: Array<DocumentChange>;
  id: Scalars['String']['input'];
};


export type MutationPatchOneDocumentSchoolCurriculumArgs = {
  changes: Array<DocumentChange>;
  id: Scalars['String']['input'];
};


export type MutationPayOverduePaymentsArgs = {
  data: PlanPayOverduePaymentsInput;
};


export type MutationRecreateOneAcademicDocumentationXmlArgs = {
  documentId: Scalars['String']['input'];
  status: DocumentAcademicDocumentationStatus;
};


export type MutationRenotarizeDocumentArgs = {
  documentId: Scalars['String']['input'];
  signatureId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReplaceOneDegreeVisualRepresentationArgs = {
  degreeId: Scalars['String']['input'];
  visualRepresentation: Scalars['Upload']['input'];
};


export type MutationResendOneTeamMemberEmailArgs = {
  memberId: Scalars['Int']['input'];
};


export type MutationRevalidateOneDegreeArgs = {
  degreeId: Scalars['String']['input'];
};


export type MutationRevalidateOneDocumentAcademicDocumentationArgs = {
  documentId: Scalars['String']['input'];
};


export type MutationReviewOneDegreeArgs = {
  degreeId: Scalars['String']['input'];
  reproveReason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReviewOneDocumentAcademicDocumentationArgs = {
  academicDocumentationId: Scalars['String']['input'];
  reproveReason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReviewOneDocumentAuditFileIssuerArgs = {
  documentBaseId: Scalars['String']['input'];
  reproveReason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationReviewOneDocumentSchoolCurriculumArgs = {
  reproveReason?: InputMaybe<Scalars['String']['input']>;
  schoolCurriculumId: Scalars['String']['input'];
};


export type MutationRevokeOneDocumentBaseArgs = {
  id: Scalars['String']['input'];
  revokeReason: Scalars['String']['input'];
};


export type MutationSaveOneCommonUserConfigArgs = {
  data: SaveOneCommonUserConfigInputData;
};


export type MutationSaveOneDocumentAcademicDocumentationArgs = {
  data: Scalars['Json']['input'];
  type?: InputMaybe<DocumentAcademicDocumentationType>;
  version: Scalars['String']['input'];
};


export type MutationSaveOneDocumentSchoolCurriculumArgs = {
  data: Scalars['Json']['input'];
  version: Scalars['String']['input'];
};


export type MutationSaveOneReusableFormDataArgs = {
  data: Scalars['Json']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
};


export type MutationSendActivityArgs = {
  input: WatchDocumentInput;
};


export type MutationSendOneDegreeToReviewArgs = {
  degreeId: Scalars['String']['input'];
};


export type MutationSignOnlyVisualOneSignatureArgs = {
  inviteId: Scalars['String']['input'];
  signatureImageId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSimulateDegreeValidationResponseArgs = {
  degreeId: Scalars['String']['input'];
  status: DegreeValidationVerdict;
};


export type MutationSingBulkCertificateVisualRepresentationArgs = {
  bulkId: Scalars['String']['input'];
  certificateList: Array<Scalars['String']['input']>;
  signatureImageId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationStartOneCertificateSignatureArgs = {
  certificate: Scalars['String']['input'];
  inviteId: Scalars['String']['input'];
  signatureImageId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationStartOneSignatureArgs = {
  certificate: Scalars['String']['input'];
  inviteId: Scalars['Int']['input'];
};


export type MutationStartOneSignatureExternalSignatureInviteArgs = {
  certificate: Scalars['String']['input'];
  inviteId: Scalars['String']['input'];
};


export type MutationUpdateOneAcademicDocumentationSentToRegistrarStatusArgs = {
  id: Scalars['String']['input'];
  isSentToRegistrar: Scalars['Boolean']['input'];
};


export type MutationUpdateOneCertificateCourseArgs = {
  areaKnowledge: Scalars['String']['input'];
  certificateId: Scalars['String']['input'];
  courseLevelId?: InputMaybe<Scalars['String']['input']>;
  metaData: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationUpdateOneCertificateCourseLevelArgs = {
  certificateBaseId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateOneCertificateCurriculumArgs = {
  amountOfHours?: InputMaybe<Scalars['Int']['input']>;
  certificateCourseId: Scalars['String']['input'];
  certificateId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  selectedDisciplines: Array<CirriculumSelectedDiscipline>;
};


export type MutationUpdateOneCertificateDisciplineArgs = {
  certificateId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  viewOnDegree: Scalars['Boolean']['input'];
};


export type MutationUpdateOneCertificateEventArgs = {
  certificateId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateOneCertificateTeacherArgs = {
  certificateId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  titration: Scalars['String']['input'];
};


export type MutationUpdateOneCertificateTemplateArgs = {
  data: CertificateTemplateUpdateInput;
  where: CertificateTemplateWhereUniqueInput;
};


export type MutationUpdateOneCertificateTemplatePresetArgs = {
  data: CertificateTemplatePresetUpdateInput;
  where: CertificateTemplatePresetWhereUniqueInput;
};


export type MutationUpdateOneDegreeSentToGraduateStatusArgs = {
  degreeId: Scalars['String']['input'];
  isSentToGraduate: Scalars['Boolean']['input'];
};


export type MutationUpdateOneDegreeVisualRepresentationArgs = {
  degreeId: Scalars['String']['input'];
  visualRepresentation: Scalars['Upload']['input'];
};


export type MutationUpdateOnePersonArgs = {
  address?: InputMaybe<AddressInput>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identityDocument?: InputMaybe<Scalars['String']['input']>;
  isForeign: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  passport?: InputMaybe<Scalars['String']['input']>;
  phones: Array<Scalars['String']['input']>;
  receivesCertificateEmail: Scalars['Boolean']['input'];
  receivesCertificateWhatsapp: Scalars['Boolean']['input'];
};


export type MutationUpdateOneReusableFormDataCurriculumArgs = {
  data: ReusableFormDataCurriculumCreateInputCustom;
  where: ReusableFormDataCurriculumWhereUniqueInput;
};


export type MutationUpdateOneSystemGlobalAlertArgs = {
  data: SystemGlobalAlertUpdateInput;
  where: SystemGlobalAlertWhereUniqueInput;
};


export type MutationUpdateOneTeamArgs = {
  data: UpdateOneTeamData;
};


export type MutationUpdateOneTeamContractArgs = {
  data: TeamContractUpdateInput;
  where: TeamContractWhereUniqueInput;
};


export type MutationUpdateOneTeamDefaultDegreeCertificateTemplateArgs = {
  certificateTemplateId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateOneTeamMemberArgs = {
  cpfOrCnpj?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
  role?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateTeamActivationStatusArgs = {
  data: UpdateTeamActivationStatusArgs;
};


export type MutationUpdateTeamConfigAddDocumentSignerNodeArgs = {
  addSigners: Scalars['Boolean']['input'];
};


export type MutationUpsertDocumentBaseDefaultSignatureInviteConfigurationArgs = {
  data: UpsertDocumentBaseDefaultSignatureInviteConfigurationInput;
};


export type MutationUpsertOneTemporarySignatureImageArgs = {
  description: Scalars['String']['input'];
};


export type MutationUpsertTeamDocumentTypeSpecificSignaturePolicyConfigArgs = {
  data: UpsertTeamDocumentTypeSpecificSignaturePolicyConfigInput;
};


export type MutationValidateOnePdfaArgs = {
  base64: Scalars['String']['input'];
};

export type NestedBigIntFilter = {
  equals?: InputMaybe<Scalars['BigInt']['input']>;
  gt?: InputMaybe<Scalars['BigInt']['input']>;
  gte?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lt?: InputMaybe<Scalars['BigInt']['input']>;
  lte?: InputMaybe<Scalars['BigInt']['input']>;
  not?: InputMaybe<NestedBigIntFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type NestedBigIntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedBigIntFilter>;
  _min?: InputMaybe<NestedBigIntFilter>;
  _sum?: InputMaybe<NestedBigIntFilter>;
  equals?: InputMaybe<Scalars['BigInt']['input']>;
  gt?: InputMaybe<Scalars['BigInt']['input']>;
  gte?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lt?: InputMaybe<Scalars['BigInt']['input']>;
  lte?: InputMaybe<Scalars['BigInt']['input']>;
  not?: InputMaybe<NestedBigIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type NestedBoolNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedBoolNullableFilter>;
  _min?: InputMaybe<NestedBoolNullableFilter>;
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolNullableWithAggregatesFilter>;
};

export type NestedBoolWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedBoolFilter>;
  _min?: InputMaybe<NestedBoolFilter>;
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDateTimeNullableFilter>;
  _min?: InputMaybe<NestedDateTimeNullableFilter>;
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type NestedDecimalWithAggregatesFilter = {
  _avg?: InputMaybe<NestedDecimalFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDecimalFilter>;
  _min?: InputMaybe<NestedDecimalFilter>;
  _sum?: InputMaybe<NestedDecimalFilter>;
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type NestedEnumCertificateTypesFilter = {
  equals?: InputMaybe<CertificateTypes>;
  in?: InputMaybe<Array<CertificateTypes>>;
  not?: InputMaybe<CertificateTypes>;
  notIn?: InputMaybe<Array<CertificateTypes>>;
};

export type NestedEnumCertificateTypesWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumCertificateTypesFilter>;
  _min?: InputMaybe<NestedEnumCertificateTypesFilter>;
  equals?: InputMaybe<CertificateTypes>;
  in?: InputMaybe<Array<CertificateTypes>>;
  not?: InputMaybe<CertificateTypes>;
  notIn?: InputMaybe<Array<CertificateTypes>>;
};

export type NestedEnumDocumentAcademicDocumentationCreationTypeFilter = {
  equals?: InputMaybe<DocumentAcademicDocumentationCreationType>;
  in?: InputMaybe<Array<DocumentAcademicDocumentationCreationType>>;
  not?: InputMaybe<DocumentAcademicDocumentationCreationType>;
  notIn?: InputMaybe<Array<DocumentAcademicDocumentationCreationType>>;
};

export type NestedEnumDocumentAcademicDocumentationCreationTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDocumentAcademicDocumentationCreationTypeFilter>;
  _min?: InputMaybe<NestedEnumDocumentAcademicDocumentationCreationTypeFilter>;
  equals?: InputMaybe<DocumentAcademicDocumentationCreationType>;
  in?: InputMaybe<Array<DocumentAcademicDocumentationCreationType>>;
  not?: InputMaybe<DocumentAcademicDocumentationCreationType>;
  notIn?: InputMaybe<Array<DocumentAcademicDocumentationCreationType>>;
};

export type NestedEnumDocumentAcademicDocumentationStatusFilter = {
  equals?: InputMaybe<DocumentAcademicDocumentationStatus>;
  in?: InputMaybe<Array<DocumentAcademicDocumentationStatus>>;
  not?: InputMaybe<DocumentAcademicDocumentationStatus>;
  notIn?: InputMaybe<Array<DocumentAcademicDocumentationStatus>>;
};

export type NestedEnumDocumentAcademicDocumentationStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDocumentAcademicDocumentationStatusFilter>;
  _min?: InputMaybe<NestedEnumDocumentAcademicDocumentationStatusFilter>;
  equals?: InputMaybe<DocumentAcademicDocumentationStatus>;
  in?: InputMaybe<Array<DocumentAcademicDocumentationStatus>>;
  not?: InputMaybe<DocumentAcademicDocumentationStatus>;
  notIn?: InputMaybe<Array<DocumentAcademicDocumentationStatus>>;
};

export type NestedEnumDocumentAcademicDocumentationTypeFilter = {
  equals?: InputMaybe<DocumentAcademicDocumentationType>;
  in?: InputMaybe<Array<DocumentAcademicDocumentationType>>;
  not?: InputMaybe<DocumentAcademicDocumentationType>;
  notIn?: InputMaybe<Array<DocumentAcademicDocumentationType>>;
};

export type NestedEnumDocumentAcademicDocumentationTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDocumentAcademicDocumentationTypeFilter>;
  _min?: InputMaybe<NestedEnumDocumentAcademicDocumentationTypeFilter>;
  equals?: InputMaybe<DocumentAcademicDocumentationType>;
  in?: InputMaybe<Array<DocumentAcademicDocumentationType>>;
  not?: InputMaybe<DocumentAcademicDocumentationType>;
  notIn?: InputMaybe<Array<DocumentAcademicDocumentationType>>;
};

export type NestedEnumDocumentAuditFileIssuerStatusFilter = {
  equals?: InputMaybe<DocumentAuditFileIssuerStatus>;
  in?: InputMaybe<Array<DocumentAuditFileIssuerStatus>>;
  not?: InputMaybe<DocumentAuditFileIssuerStatus>;
  notIn?: InputMaybe<Array<DocumentAuditFileIssuerStatus>>;
};

export type NestedEnumDocumentAuditFileIssuerStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDocumentAuditFileIssuerStatusFilter>;
  _min?: InputMaybe<NestedEnumDocumentAuditFileIssuerStatusFilter>;
  equals?: InputMaybe<DocumentAuditFileIssuerStatus>;
  in?: InputMaybe<Array<DocumentAuditFileIssuerStatus>>;
  not?: InputMaybe<DocumentAuditFileIssuerStatus>;
  notIn?: InputMaybe<Array<DocumentAuditFileIssuerStatus>>;
};

export type NestedEnumDocumentBaseTypeFilter = {
  equals?: InputMaybe<DocumentBaseType>;
  in?: InputMaybe<Array<DocumentBaseType>>;
  not?: InputMaybe<DocumentBaseType>;
  notIn?: InputMaybe<Array<DocumentBaseType>>;
};

export type NestedEnumDocumentBaseTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDocumentBaseTypeFilter>;
  _min?: InputMaybe<NestedEnumDocumentBaseTypeFilter>;
  equals?: InputMaybe<DocumentBaseType>;
  in?: InputMaybe<Array<DocumentBaseType>>;
  not?: InputMaybe<DocumentBaseType>;
  notIn?: InputMaybe<Array<DocumentBaseType>>;
};

export type NestedEnumDocumentCertificateSignatureHashHistoryTypeFilter = {
  equals?: InputMaybe<DocumentCertificateSignatureHashHistoryType>;
  in?: InputMaybe<Array<DocumentCertificateSignatureHashHistoryType>>;
  not?: InputMaybe<DocumentCertificateSignatureHashHistoryType>;
  notIn?: InputMaybe<Array<DocumentCertificateSignatureHashHistoryType>>;
};

export type NestedEnumDocumentCertificateSignatureHashHistoryTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDocumentCertificateSignatureHashHistoryTypeFilter>;
  _min?: InputMaybe<NestedEnumDocumentCertificateSignatureHashHistoryTypeFilter>;
  equals?: InputMaybe<DocumentCertificateSignatureHashHistoryType>;
  in?: InputMaybe<Array<DocumentCertificateSignatureHashHistoryType>>;
  not?: InputMaybe<DocumentCertificateSignatureHashHistoryType>;
  notIn?: InputMaybe<Array<DocumentCertificateSignatureHashHistoryType>>;
};

export type NestedEnumDocumentCertificateSignatureItemTypeFilter = {
  equals?: InputMaybe<DocumentCertificateSignatureItemType>;
  in?: InputMaybe<Array<DocumentCertificateSignatureItemType>>;
  not?: InputMaybe<DocumentCertificateSignatureItemType>;
  notIn?: InputMaybe<Array<DocumentCertificateSignatureItemType>>;
};

export type NestedEnumDocumentCertificateSignatureItemTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDocumentCertificateSignatureItemTypeFilter>;
  _min?: InputMaybe<NestedEnumDocumentCertificateSignatureItemTypeFilter>;
  equals?: InputMaybe<DocumentCertificateSignatureItemType>;
  in?: InputMaybe<Array<DocumentCertificateSignatureItemType>>;
  not?: InputMaybe<DocumentCertificateSignatureItemType>;
  notIn?: InputMaybe<Array<DocumentCertificateSignatureItemType>>;
};

export type NestedEnumDocumentCertificateStatusFilter = {
  equals?: InputMaybe<DocumentCertificateStatus>;
  in?: InputMaybe<Array<DocumentCertificateStatus>>;
  not?: InputMaybe<DocumentCertificateStatus>;
  notIn?: InputMaybe<Array<DocumentCertificateStatus>>;
};

export type NestedEnumDocumentCertificateStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDocumentCertificateStatusFilter>;
  _min?: InputMaybe<NestedEnumDocumentCertificateStatusFilter>;
  equals?: InputMaybe<DocumentCertificateStatus>;
  in?: InputMaybe<Array<DocumentCertificateStatus>>;
  not?: InputMaybe<DocumentCertificateStatus>;
  notIn?: InputMaybe<Array<DocumentCertificateStatus>>;
};

export type NestedEnumDocumentDegreeStatusFilter = {
  equals?: InputMaybe<DocumentDegreeStatus>;
  in?: InputMaybe<Array<DocumentDegreeStatus>>;
  not?: InputMaybe<DocumentDegreeStatus>;
  notIn?: InputMaybe<Array<DocumentDegreeStatus>>;
};

export type NestedEnumDocumentDegreeStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDocumentDegreeStatusFilter>;
  _min?: InputMaybe<NestedEnumDocumentDegreeStatusFilter>;
  equals?: InputMaybe<DocumentDegreeStatus>;
  in?: InputMaybe<Array<DocumentDegreeStatus>>;
  not?: InputMaybe<DocumentDegreeStatus>;
  notIn?: InputMaybe<Array<DocumentDegreeStatus>>;
};

export type NestedEnumDocumentFinalAcademicTranscriptStatusFilter = {
  equals?: InputMaybe<DocumentFinalAcademicTranscriptStatus>;
  in?: InputMaybe<Array<DocumentFinalAcademicTranscriptStatus>>;
  not?: InputMaybe<DocumentFinalAcademicTranscriptStatus>;
  notIn?: InputMaybe<Array<DocumentFinalAcademicTranscriptStatus>>;
};

export type NestedEnumDocumentFinalAcademicTranscriptStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDocumentFinalAcademicTranscriptStatusFilter>;
  _min?: InputMaybe<NestedEnumDocumentFinalAcademicTranscriptStatusFilter>;
  equals?: InputMaybe<DocumentFinalAcademicTranscriptStatus>;
  in?: InputMaybe<Array<DocumentFinalAcademicTranscriptStatus>>;
  not?: InputMaybe<DocumentFinalAcademicTranscriptStatus>;
  notIn?: InputMaybe<Array<DocumentFinalAcademicTranscriptStatus>>;
};

export type NestedEnumDocumentRenotarizationStatusFilter = {
  equals?: InputMaybe<DocumentRenotarizationStatus>;
  in?: InputMaybe<Array<DocumentRenotarizationStatus>>;
  not?: InputMaybe<DocumentRenotarizationStatus>;
  notIn?: InputMaybe<Array<DocumentRenotarizationStatus>>;
};

export type NestedEnumDocumentRenotarizationStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDocumentRenotarizationStatusFilter>;
  _min?: InputMaybe<NestedEnumDocumentRenotarizationStatusFilter>;
  equals?: InputMaybe<DocumentRenotarizationStatus>;
  in?: InputMaybe<Array<DocumentRenotarizationStatus>>;
  not?: InputMaybe<DocumentRenotarizationStatus>;
  notIn?: InputMaybe<Array<DocumentRenotarizationStatus>>;
};

export type NestedEnumDocumentSchoolCurriculumStatusFilter = {
  equals?: InputMaybe<DocumentSchoolCurriculumStatus>;
  in?: InputMaybe<Array<DocumentSchoolCurriculumStatus>>;
  not?: InputMaybe<DocumentSchoolCurriculumStatus>;
  notIn?: InputMaybe<Array<DocumentSchoolCurriculumStatus>>;
};

export type NestedEnumDocumentSchoolCurriculumStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDocumentSchoolCurriculumStatusFilter>;
  _min?: InputMaybe<NestedEnumDocumentSchoolCurriculumStatusFilter>;
  equals?: InputMaybe<DocumentSchoolCurriculumStatus>;
  in?: InputMaybe<Array<DocumentSchoolCurriculumStatus>>;
  not?: InputMaybe<DocumentSchoolCurriculumStatus>;
  notIn?: InputMaybe<Array<DocumentSchoolCurriculumStatus>>;
};

export type NestedEnumEducationLevelTypeFilter = {
  equals?: InputMaybe<EducationLevelType>;
  in?: InputMaybe<Array<EducationLevelType>>;
  not?: InputMaybe<EducationLevelType>;
  notIn?: InputMaybe<Array<EducationLevelType>>;
};

export type NestedEnumEducationLevelTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumEducationLevelTypeFilter>;
  _min?: InputMaybe<NestedEnumEducationLevelTypeFilter>;
  equals?: InputMaybe<EducationLevelType>;
  in?: InputMaybe<Array<EducationLevelType>>;
  not?: InputMaybe<EducationLevelType>;
  notIn?: InputMaybe<Array<EducationLevelType>>;
};

export type NestedEnumFinancialBillingCycleFilter = {
  equals?: InputMaybe<FinancialBillingCycle>;
  in?: InputMaybe<Array<FinancialBillingCycle>>;
  not?: InputMaybe<FinancialBillingCycle>;
  notIn?: InputMaybe<Array<FinancialBillingCycle>>;
};

export type NestedEnumFinancialBillingCycleNullableFilter = {
  equals?: InputMaybe<FinancialBillingCycle>;
  in?: InputMaybe<Array<FinancialBillingCycle>>;
  not?: InputMaybe<FinancialBillingCycle>;
  notIn?: InputMaybe<Array<FinancialBillingCycle>>;
};

export type NestedEnumFinancialBillingCycleNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumFinancialBillingCycleNullableFilter>;
  _min?: InputMaybe<NestedEnumFinancialBillingCycleNullableFilter>;
  equals?: InputMaybe<FinancialBillingCycle>;
  in?: InputMaybe<Array<FinancialBillingCycle>>;
  not?: InputMaybe<FinancialBillingCycle>;
  notIn?: InputMaybe<Array<FinancialBillingCycle>>;
};

export type NestedEnumFinancialBillingCycleWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumFinancialBillingCycleFilter>;
  _min?: InputMaybe<NestedEnumFinancialBillingCycleFilter>;
  equals?: InputMaybe<FinancialBillingCycle>;
  in?: InputMaybe<Array<FinancialBillingCycle>>;
  not?: InputMaybe<FinancialBillingCycle>;
  notIn?: InputMaybe<Array<FinancialBillingCycle>>;
};

export type NestedEnumFinancialChargeableServiceFilter = {
  equals?: InputMaybe<FinancialChargeableService>;
  in?: InputMaybe<Array<FinancialChargeableService>>;
  not?: InputMaybe<FinancialChargeableService>;
  notIn?: InputMaybe<Array<FinancialChargeableService>>;
};

export type NestedEnumFinancialChargeableServiceWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumFinancialChargeableServiceFilter>;
  _min?: InputMaybe<NestedEnumFinancialChargeableServiceFilter>;
  equals?: InputMaybe<FinancialChargeableService>;
  in?: InputMaybe<Array<FinancialChargeableService>>;
  not?: InputMaybe<FinancialChargeableService>;
  notIn?: InputMaybe<Array<FinancialChargeableService>>;
};

export type NestedEnumFinancialPlanFilter = {
  equals?: InputMaybe<FinancialPlan>;
  in?: InputMaybe<Array<FinancialPlan>>;
  not?: InputMaybe<FinancialPlan>;
  notIn?: InputMaybe<Array<FinancialPlan>>;
};

export type NestedEnumFinancialPlanWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumFinancialPlanFilter>;
  _min?: InputMaybe<NestedEnumFinancialPlanFilter>;
  equals?: InputMaybe<FinancialPlan>;
  in?: InputMaybe<Array<FinancialPlan>>;
  not?: InputMaybe<FinancialPlan>;
  notIn?: InputMaybe<Array<FinancialPlan>>;
};

export type NestedEnumPaymentStatusFilter = {
  equals?: InputMaybe<PaymentStatus>;
  in?: InputMaybe<Array<PaymentStatus>>;
  not?: InputMaybe<PaymentStatus>;
  notIn?: InputMaybe<Array<PaymentStatus>>;
};

export type NestedEnumPaymentStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPaymentStatusFilter>;
  _min?: InputMaybe<NestedEnumPaymentStatusFilter>;
  equals?: InputMaybe<PaymentStatus>;
  in?: InputMaybe<Array<PaymentStatus>>;
  not?: InputMaybe<PaymentStatus>;
  notIn?: InputMaybe<Array<PaymentStatus>>;
};

export type NestedEnumSystemGlobalAlertTypeFilter = {
  equals?: InputMaybe<SystemGlobalAlertType>;
  in?: InputMaybe<Array<SystemGlobalAlertType>>;
  not?: InputMaybe<SystemGlobalAlertType>;
  notIn?: InputMaybe<Array<SystemGlobalAlertType>>;
};

export type NestedEnumSystemGlobalAlertTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumSystemGlobalAlertTypeFilter>;
  _min?: InputMaybe<NestedEnumSystemGlobalAlertTypeFilter>;
  equals?: InputMaybe<SystemGlobalAlertType>;
  in?: InputMaybe<Array<SystemGlobalAlertType>>;
  not?: InputMaybe<SystemGlobalAlertType>;
  notIn?: InputMaybe<Array<SystemGlobalAlertType>>;
};

export type NestedEnumVisualRepresentationCreationTypeFilter = {
  equals?: InputMaybe<VisualRepresentationCreationType>;
  in?: InputMaybe<Array<VisualRepresentationCreationType>>;
  not?: InputMaybe<VisualRepresentationCreationType>;
  notIn?: InputMaybe<Array<VisualRepresentationCreationType>>;
};

export type NestedEnumVisualRepresentationCreationTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumVisualRepresentationCreationTypeFilter>;
  _min?: InputMaybe<NestedEnumVisualRepresentationCreationTypeFilter>;
  equals?: InputMaybe<VisualRepresentationCreationType>;
  in?: InputMaybe<Array<VisualRepresentationCreationType>>;
  not?: InputMaybe<VisualRepresentationCreationType>;
  notIn?: InputMaybe<Array<VisualRepresentationCreationType>>;
};

export type NestedFloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedFloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedFloatWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedFloatFilter>;
  _min?: InputMaybe<NestedFloatFilter>;
  _sum?: InputMaybe<NestedFloatFilter>;
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedIntNullableFilter>;
  _min?: InputMaybe<NestedIntNullableFilter>;
  _sum?: InputMaybe<NestedIntNullableFilter>;
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedIntFilter>;
  _min?: InputMaybe<NestedIntFilter>;
  _sum?: InputMaybe<NestedIntFilter>;
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedJsonFilter = {
  array_contains?: InputMaybe<Scalars['Json']['input']>;
  array_ends_with?: InputMaybe<Scalars['Json']['input']>;
  array_starts_with?: InputMaybe<Scalars['Json']['input']>;
  equals?: InputMaybe<Scalars['Json']['input']>;
  gt?: InputMaybe<Scalars['Json']['input']>;
  gte?: InputMaybe<Scalars['Json']['input']>;
  lt?: InputMaybe<Scalars['Json']['input']>;
  lte?: InputMaybe<Scalars['Json']['input']>;
  not?: InputMaybe<Scalars['Json']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type NestedJsonNullableFilter = {
  array_contains?: InputMaybe<Scalars['Json']['input']>;
  array_ends_with?: InputMaybe<Scalars['Json']['input']>;
  array_starts_with?: InputMaybe<Scalars['Json']['input']>;
  equals?: InputMaybe<Scalars['Json']['input']>;
  gt?: InputMaybe<Scalars['Json']['input']>;
  gte?: InputMaybe<Scalars['Json']['input']>;
  lt?: InputMaybe<Scalars['Json']['input']>;
  lte?: InputMaybe<Scalars['Json']['input']>;
  not?: InputMaybe<Scalars['Json']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NullableBoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NullableEnumFinancialBillingCycleFieldUpdateOperationsInput = {
  set?: InputMaybe<FinancialBillingCycle>;
};

export type NullableIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export enum NullableJsonNullValueInput {
  DbNull = 'DbNull',
  JsonNull = 'JsonNull'
}

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export enum NullsOrder {
  First = 'first',
  Last = 'last'
}

export enum PaymentStatus {
  Canceled = 'CANCELED',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Pending = 'PENDING'
}

export type Permission = {
  __typename?: 'Permission';
  TeamMemberPermissions: Array<TeamMemberPermission>;
  /** CREATE_UPDATE_DOCUMENT, UPDATE_OWN_DOCUMENT, UPDATE_ANY_DOCUMENT, REVIEW_DOCUMENT, INVITE_SIGNERS, SIGN_DOCUMENT, MANAGE_REUSABLE_IES, MANAGE_REUSABLE_ANY, MANAGE_USERS, REVOKE_DOCUMENT, DEGREE_IMPORT */
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type PermissionTeamMemberPermissionsArgs = {
  cursor?: InputMaybe<TeamMemberPermissionWhereUniqueInput>;
  distinct?: InputMaybe<Array<TeamMemberPermissionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TeamMemberPermissionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeamMemberPermissionWhereInput>;
};

export type PermissionAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type PermissionCountOrderByAggregateInput = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PermissionCreateInput = {
  TeamMemberPermissions?: InputMaybe<TeamMemberPermissionCreateNestedManyWithoutPermissionInput>;
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PermissionCreateManyInput = {
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PermissionCreateNestedOneWithoutTeamMemberPermissionsInput = {
  connect?: InputMaybe<PermissionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PermissionCreateOrConnectWithoutTeamMemberPermissionsInput>;
  create?: InputMaybe<PermissionCreateWithoutTeamMemberPermissionsInput>;
};

export type PermissionCreateOrConnectWithoutTeamMemberPermissionsInput = {
  create: PermissionCreateWithoutTeamMemberPermissionsInput;
  where: PermissionWhereUniqueInput;
};

export type PermissionCreateWithoutTeamMemberPermissionsInput = {
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PermissionMaxOrderByAggregateInput = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PermissionMinOrderByAggregateInput = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PermissionOrderByWithAggregationInput = {
  _avg?: InputMaybe<PermissionAvgOrderByAggregateInput>;
  _count?: InputMaybe<PermissionCountOrderByAggregateInput>;
  _max?: InputMaybe<PermissionMaxOrderByAggregateInput>;
  _min?: InputMaybe<PermissionMinOrderByAggregateInput>;
  _sum?: InputMaybe<PermissionSumOrderByAggregateInput>;
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PermissionOrderByWithRelationInput = {
  TeamMemberPermissions?: InputMaybe<TeamMemberPermissionOrderByRelationAggregateInput>;
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PermissionRelationFilter = {
  is?: InputMaybe<PermissionWhereInput>;
  isNot?: InputMaybe<PermissionWhereInput>;
};

export enum PermissionScalarFieldEnum {
  Code = 'code',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type PermissionScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<PermissionScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<PermissionScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<PermissionScalarWhereWithAggregatesInput>>;
  code?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type PermissionSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type PermissionUpdateInput = {
  TeamMemberPermissions?: InputMaybe<TeamMemberPermissionUpdateManyWithoutPermissionNestedInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PermissionUpdateManyMutationInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PermissionUpdateOneRequiredWithoutTeamMemberPermissionsNestedInput = {
  connect?: InputMaybe<PermissionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PermissionCreateOrConnectWithoutTeamMemberPermissionsInput>;
  create?: InputMaybe<PermissionCreateWithoutTeamMemberPermissionsInput>;
  update?: InputMaybe<PermissionUpdateToOneWithWhereWithoutTeamMemberPermissionsInput>;
  upsert?: InputMaybe<PermissionUpsertWithoutTeamMemberPermissionsInput>;
};

export type PermissionUpdateToOneWithWhereWithoutTeamMemberPermissionsInput = {
  data: PermissionUpdateWithoutTeamMemberPermissionsInput;
  where?: InputMaybe<PermissionWhereInput>;
};

export type PermissionUpdateWithoutTeamMemberPermissionsInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type PermissionUpsertWithoutTeamMemberPermissionsInput = {
  create: PermissionCreateWithoutTeamMemberPermissionsInput;
  update: PermissionUpdateWithoutTeamMemberPermissionsInput;
  where?: InputMaybe<PermissionWhereInput>;
};

export type PermissionWhereInput = {
  AND?: InputMaybe<Array<PermissionWhereInput>>;
  NOT?: InputMaybe<Array<PermissionWhereInput>>;
  OR?: InputMaybe<Array<PermissionWhereInput>>;
  TeamMemberPermissions?: InputMaybe<TeamMemberPermissionListRelationFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type PermissionWhereUniqueInput = {
  AND?: InputMaybe<Array<PermissionWhereInput>>;
  NOT?: InputMaybe<Array<PermissionWhereInput>>;
  OR?: InputMaybe<Array<PermissionWhereInput>>;
  TeamMemberPermissions?: InputMaybe<TeamMemberPermissionListRelationFilter>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type Person = {
  __typename?: 'Person';
  Address?: Maybe<Address>;
  DocumentCertificate: Array<DocumentCertificate>;
  Phones: Array<Telephone>;
  Team: Team;
  birthDate?: Maybe<Scalars['String']['output']>;
  cpf?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  educationLevel: EducationLevelType;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identityDocument?: Maybe<Scalars['String']['output']>;
  isForeign: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  passport?: Maybe<Scalars['String']['output']>;
  receivesCertificateEmail: Scalars['Boolean']['output'];
  receivesCertificateWhatsapp: Scalars['Boolean']['output'];
  teamId: Scalars['Int']['output'];
};


export type PersonDocumentCertificateArgs = {
  cursor?: InputMaybe<DocumentCertificateWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentCertificateScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentCertificateOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentCertificateWhereInput>;
};


export type PersonPhonesArgs = {
  cursor?: InputMaybe<TelephoneWhereUniqueInput>;
  distinct?: InputMaybe<Array<TelephoneScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TelephoneOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TelephoneWhereInput>;
};

export type PersonAvgOrderByAggregateInput = {
  teamId?: InputMaybe<SortOrder>;
};

export type PersonCountOrderByAggregateInput = {
  birthDate?: InputMaybe<SortOrder>;
  cpf?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  educationLevel?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identityDocument?: InputMaybe<SortOrder>;
  isForeign?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  passport?: InputMaybe<SortOrder>;
  receivesCertificateEmail?: InputMaybe<SortOrder>;
  receivesCertificateWhatsapp?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type PersonCpfTeamIdCompoundUniqueInput = {
  cpf: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type PersonCreateInput = {
  Address?: InputMaybe<AddressCreateNestedOneWithoutPersonInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedManyWithoutPersonInput>;
  Phones?: InputMaybe<TelephoneCreateNestedManyWithoutPersonInput>;
  Team: TeamCreateNestedOneWithoutPersonInput;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identityDocument?: InputMaybe<Scalars['String']['input']>;
  isForeign?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  passport?: InputMaybe<Scalars['String']['input']>;
  receivesCertificateEmail?: InputMaybe<Scalars['Boolean']['input']>;
  receivesCertificateWhatsapp?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonCreateManyInput = {
  birthDate?: InputMaybe<Scalars['String']['input']>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identityDocument?: InputMaybe<Scalars['String']['input']>;
  isForeign?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  passport?: InputMaybe<Scalars['String']['input']>;
  receivesCertificateEmail?: InputMaybe<Scalars['Boolean']['input']>;
  receivesCertificateWhatsapp?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['Int']['input'];
};

export type PersonCreateManyTeamInput = {
  birthDate?: InputMaybe<Scalars['String']['input']>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identityDocument?: InputMaybe<Scalars['String']['input']>;
  isForeign?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  passport?: InputMaybe<Scalars['String']['input']>;
  receivesCertificateEmail?: InputMaybe<Scalars['Boolean']['input']>;
  receivesCertificateWhatsapp?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonCreateManyTeamInputEnvelope = {
  data: Array<PersonCreateManyTeamInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonCreateNestedManyWithoutTeamInput = {
  connect?: InputMaybe<Array<PersonWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PersonCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<PersonCreateWithoutTeamInput>>;
  createMany?: InputMaybe<PersonCreateManyTeamInputEnvelope>;
};

export type PersonCreateNestedOneWithoutAddressInput = {
  connect?: InputMaybe<PersonWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PersonCreateOrConnectWithoutAddressInput>;
  create?: InputMaybe<PersonCreateWithoutAddressInput>;
};

export type PersonCreateNestedOneWithoutDocumentCertificateInput = {
  connect?: InputMaybe<PersonWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PersonCreateOrConnectWithoutDocumentCertificateInput>;
  create?: InputMaybe<PersonCreateWithoutDocumentCertificateInput>;
};

export type PersonCreateNestedOneWithoutPhonesInput = {
  connect?: InputMaybe<PersonWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PersonCreateOrConnectWithoutPhonesInput>;
  create?: InputMaybe<PersonCreateWithoutPhonesInput>;
};

export type PersonCreateOrConnectWithoutAddressInput = {
  create: PersonCreateWithoutAddressInput;
  where: PersonWhereUniqueInput;
};

export type PersonCreateOrConnectWithoutDocumentCertificateInput = {
  create: PersonCreateWithoutDocumentCertificateInput;
  where: PersonWhereUniqueInput;
};

export type PersonCreateOrConnectWithoutPhonesInput = {
  create: PersonCreateWithoutPhonesInput;
  where: PersonWhereUniqueInput;
};

export type PersonCreateOrConnectWithoutTeamInput = {
  create: PersonCreateWithoutTeamInput;
  where: PersonWhereUniqueInput;
};

export type PersonCreateWithoutAddressInput = {
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedManyWithoutPersonInput>;
  Phones?: InputMaybe<TelephoneCreateNestedManyWithoutPersonInput>;
  Team: TeamCreateNestedOneWithoutPersonInput;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identityDocument?: InputMaybe<Scalars['String']['input']>;
  isForeign?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  passport?: InputMaybe<Scalars['String']['input']>;
  receivesCertificateEmail?: InputMaybe<Scalars['Boolean']['input']>;
  receivesCertificateWhatsapp?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonCreateWithoutDocumentCertificateInput = {
  Address?: InputMaybe<AddressCreateNestedOneWithoutPersonInput>;
  Phones?: InputMaybe<TelephoneCreateNestedManyWithoutPersonInput>;
  Team: TeamCreateNestedOneWithoutPersonInput;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identityDocument?: InputMaybe<Scalars['String']['input']>;
  isForeign?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  passport?: InputMaybe<Scalars['String']['input']>;
  receivesCertificateEmail?: InputMaybe<Scalars['Boolean']['input']>;
  receivesCertificateWhatsapp?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonCreateWithoutPhonesInput = {
  Address?: InputMaybe<AddressCreateNestedOneWithoutPersonInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedManyWithoutPersonInput>;
  Team: TeamCreateNestedOneWithoutPersonInput;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identityDocument?: InputMaybe<Scalars['String']['input']>;
  isForeign?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  passport?: InputMaybe<Scalars['String']['input']>;
  receivesCertificateEmail?: InputMaybe<Scalars['Boolean']['input']>;
  receivesCertificateWhatsapp?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonCreateWithoutTeamInput = {
  Address?: InputMaybe<AddressCreateNestedOneWithoutPersonInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedManyWithoutPersonInput>;
  Phones?: InputMaybe<TelephoneCreateNestedManyWithoutPersonInput>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevel?: InputMaybe<EducationLevelType>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identityDocument?: InputMaybe<Scalars['String']['input']>;
  isForeign?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  passport?: InputMaybe<Scalars['String']['input']>;
  receivesCertificateEmail?: InputMaybe<Scalars['Boolean']['input']>;
  receivesCertificateWhatsapp?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonListRelationFilter = {
  every?: InputMaybe<PersonWhereInput>;
  none?: InputMaybe<PersonWhereInput>;
  some?: InputMaybe<PersonWhereInput>;
};

export type PersonMaxOrderByAggregateInput = {
  birthDate?: InputMaybe<SortOrder>;
  cpf?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  educationLevel?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identityDocument?: InputMaybe<SortOrder>;
  isForeign?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  passport?: InputMaybe<SortOrder>;
  receivesCertificateEmail?: InputMaybe<SortOrder>;
  receivesCertificateWhatsapp?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type PersonMinOrderByAggregateInput = {
  birthDate?: InputMaybe<SortOrder>;
  cpf?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  educationLevel?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identityDocument?: InputMaybe<SortOrder>;
  isForeign?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  passport?: InputMaybe<SortOrder>;
  receivesCertificateEmail?: InputMaybe<SortOrder>;
  receivesCertificateWhatsapp?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type PersonOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PersonOrderByWithAggregationInput = {
  _avg?: InputMaybe<PersonAvgOrderByAggregateInput>;
  _count?: InputMaybe<PersonCountOrderByAggregateInput>;
  _max?: InputMaybe<PersonMaxOrderByAggregateInput>;
  _min?: InputMaybe<PersonMinOrderByAggregateInput>;
  _sum?: InputMaybe<PersonSumOrderByAggregateInput>;
  birthDate?: InputMaybe<SortOrder>;
  cpf?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  educationLevel?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identityDocument?: InputMaybe<SortOrder>;
  isForeign?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  passport?: InputMaybe<SortOrder>;
  receivesCertificateEmail?: InputMaybe<SortOrder>;
  receivesCertificateWhatsapp?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type PersonOrderByWithRelationInput = {
  Address?: InputMaybe<AddressOrderByWithRelationInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateOrderByRelationAggregateInput>;
  Phones?: InputMaybe<TelephoneOrderByRelationAggregateInput>;
  Team?: InputMaybe<TeamOrderByWithRelationInput>;
  birthDate?: InputMaybe<SortOrder>;
  cpf?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  educationLevel?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identityDocument?: InputMaybe<SortOrder>;
  isForeign?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  passport?: InputMaybe<SortOrder>;
  receivesCertificateEmail?: InputMaybe<SortOrder>;
  receivesCertificateWhatsapp?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type PersonPassportTeamIdCompoundUniqueInput = {
  passport: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type PersonRelationFilter = {
  is?: InputMaybe<PersonWhereInput>;
  isNot?: InputMaybe<PersonWhereInput>;
};

export enum PersonScalarFieldEnum {
  BirthDate = 'birthDate',
  Cpf = 'cpf',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  EducationLevel = 'educationLevel',
  Email = 'email',
  Id = 'id',
  IdentityDocument = 'identityDocument',
  IsForeign = 'isForeign',
  Name = 'name',
  Passport = 'passport',
  ReceivesCertificateEmail = 'receivesCertificateEmail',
  ReceivesCertificateWhatsapp = 'receivesCertificateWhatsapp',
  TeamId = 'teamId'
}

export type PersonScalarWhereInput = {
  AND?: InputMaybe<Array<PersonScalarWhereInput>>;
  NOT?: InputMaybe<Array<PersonScalarWhereInput>>;
  OR?: InputMaybe<Array<PersonScalarWhereInput>>;
  birthDate?: InputMaybe<StringNullableFilter>;
  cpf?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFilter>;
  email?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  identityDocument?: InputMaybe<StringNullableFilter>;
  isForeign?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  passport?: InputMaybe<StringNullableFilter>;
  receivesCertificateEmail?: InputMaybe<BoolFilter>;
  receivesCertificateWhatsapp?: InputMaybe<BoolFilter>;
  teamId?: InputMaybe<IntFilter>;
};

export type PersonScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<PersonScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<PersonScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<PersonScalarWhereWithAggregatesInput>>;
  birthDate?: InputMaybe<StringNullableWithAggregatesFilter>;
  cpf?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeWithAggregatesFilter>;
  email?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  identityDocument?: InputMaybe<StringNullableWithAggregatesFilter>;
  isForeign?: InputMaybe<BoolWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  passport?: InputMaybe<StringNullableWithAggregatesFilter>;
  receivesCertificateEmail?: InputMaybe<BoolWithAggregatesFilter>;
  receivesCertificateWhatsapp?: InputMaybe<BoolWithAggregatesFilter>;
  teamId?: InputMaybe<IntWithAggregatesFilter>;
};

export type PersonSumOrderByAggregateInput = {
  teamId?: InputMaybe<SortOrder>;
};

export type PersonUpdateInput = {
  Address?: InputMaybe<AddressUpdateOneWithoutPersonNestedInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateManyWithoutPersonNestedInput>;
  Phones?: InputMaybe<TelephoneUpdateManyWithoutPersonNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutPersonNestedInput>;
  birthDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identityDocument?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isForeign?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  passport?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivesCertificateEmail?: InputMaybe<BoolFieldUpdateOperationsInput>;
  receivesCertificateWhatsapp?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type PersonUpdateManyMutationInput = {
  birthDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identityDocument?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isForeign?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  passport?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivesCertificateEmail?: InputMaybe<BoolFieldUpdateOperationsInput>;
  receivesCertificateWhatsapp?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type PersonUpdateManyWithWhereWithoutTeamInput = {
  data: PersonUpdateManyMutationInput;
  where: PersonScalarWhereInput;
};

export type PersonUpdateManyWithoutTeamNestedInput = {
  connect?: InputMaybe<Array<PersonWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PersonCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<PersonCreateWithoutTeamInput>>;
  createMany?: InputMaybe<PersonCreateManyTeamInputEnvelope>;
  delete?: InputMaybe<Array<PersonWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PersonScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PersonWhereUniqueInput>>;
  set?: InputMaybe<Array<PersonWhereUniqueInput>>;
  update?: InputMaybe<Array<PersonUpdateWithWhereUniqueWithoutTeamInput>>;
  updateMany?: InputMaybe<Array<PersonUpdateManyWithWhereWithoutTeamInput>>;
  upsert?: InputMaybe<Array<PersonUpsertWithWhereUniqueWithoutTeamInput>>;
};

export type PersonUpdateOneRequiredWithoutAddressNestedInput = {
  connect?: InputMaybe<PersonWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PersonCreateOrConnectWithoutAddressInput>;
  create?: InputMaybe<PersonCreateWithoutAddressInput>;
  update?: InputMaybe<PersonUpdateToOneWithWhereWithoutAddressInput>;
  upsert?: InputMaybe<PersonUpsertWithoutAddressInput>;
};

export type PersonUpdateOneRequiredWithoutDocumentCertificateNestedInput = {
  connect?: InputMaybe<PersonWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PersonCreateOrConnectWithoutDocumentCertificateInput>;
  create?: InputMaybe<PersonCreateWithoutDocumentCertificateInput>;
  update?: InputMaybe<PersonUpdateToOneWithWhereWithoutDocumentCertificateInput>;
  upsert?: InputMaybe<PersonUpsertWithoutDocumentCertificateInput>;
};

export type PersonUpdateOneRequiredWithoutPhonesNestedInput = {
  connect?: InputMaybe<PersonWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PersonCreateOrConnectWithoutPhonesInput>;
  create?: InputMaybe<PersonCreateWithoutPhonesInput>;
  update?: InputMaybe<PersonUpdateToOneWithWhereWithoutPhonesInput>;
  upsert?: InputMaybe<PersonUpsertWithoutPhonesInput>;
};

export type PersonUpdateToOneWithWhereWithoutAddressInput = {
  data: PersonUpdateWithoutAddressInput;
  where?: InputMaybe<PersonWhereInput>;
};

export type PersonUpdateToOneWithWhereWithoutDocumentCertificateInput = {
  data: PersonUpdateWithoutDocumentCertificateInput;
  where?: InputMaybe<PersonWhereInput>;
};

export type PersonUpdateToOneWithWhereWithoutPhonesInput = {
  data: PersonUpdateWithoutPhonesInput;
  where?: InputMaybe<PersonWhereInput>;
};

export type PersonUpdateWithWhereUniqueWithoutTeamInput = {
  data: PersonUpdateWithoutTeamInput;
  where: PersonWhereUniqueInput;
};

export type PersonUpdateWithoutAddressInput = {
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateManyWithoutPersonNestedInput>;
  Phones?: InputMaybe<TelephoneUpdateManyWithoutPersonNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutPersonNestedInput>;
  birthDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identityDocument?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isForeign?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  passport?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivesCertificateEmail?: InputMaybe<BoolFieldUpdateOperationsInput>;
  receivesCertificateWhatsapp?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type PersonUpdateWithoutDocumentCertificateInput = {
  Address?: InputMaybe<AddressUpdateOneWithoutPersonNestedInput>;
  Phones?: InputMaybe<TelephoneUpdateManyWithoutPersonNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutPersonNestedInput>;
  birthDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identityDocument?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isForeign?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  passport?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivesCertificateEmail?: InputMaybe<BoolFieldUpdateOperationsInput>;
  receivesCertificateWhatsapp?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type PersonUpdateWithoutPhonesInput = {
  Address?: InputMaybe<AddressUpdateOneWithoutPersonNestedInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateManyWithoutPersonNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutPersonNestedInput>;
  birthDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identityDocument?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isForeign?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  passport?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivesCertificateEmail?: InputMaybe<BoolFieldUpdateOperationsInput>;
  receivesCertificateWhatsapp?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type PersonUpdateWithoutTeamInput = {
  Address?: InputMaybe<AddressUpdateOneWithoutPersonNestedInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateManyWithoutPersonNestedInput>;
  Phones?: InputMaybe<TelephoneUpdateManyWithoutPersonNestedInput>;
  birthDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cpf?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identityDocument?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isForeign?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  passport?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivesCertificateEmail?: InputMaybe<BoolFieldUpdateOperationsInput>;
  receivesCertificateWhatsapp?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type PersonUpsertWithWhereUniqueWithoutTeamInput = {
  create: PersonCreateWithoutTeamInput;
  update: PersonUpdateWithoutTeamInput;
  where: PersonWhereUniqueInput;
};

export type PersonUpsertWithoutAddressInput = {
  create: PersonCreateWithoutAddressInput;
  update: PersonUpdateWithoutAddressInput;
  where?: InputMaybe<PersonWhereInput>;
};

export type PersonUpsertWithoutDocumentCertificateInput = {
  create: PersonCreateWithoutDocumentCertificateInput;
  update: PersonUpdateWithoutDocumentCertificateInput;
  where?: InputMaybe<PersonWhereInput>;
};

export type PersonUpsertWithoutPhonesInput = {
  create: PersonCreateWithoutPhonesInput;
  update: PersonUpdateWithoutPhonesInput;
  where?: InputMaybe<PersonWhereInput>;
};

export type PersonWhereInput = {
  AND?: InputMaybe<Array<PersonWhereInput>>;
  Address?: InputMaybe<AddressWhereInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateListRelationFilter>;
  NOT?: InputMaybe<Array<PersonWhereInput>>;
  OR?: InputMaybe<Array<PersonWhereInput>>;
  Phones?: InputMaybe<TelephoneListRelationFilter>;
  Team?: InputMaybe<TeamWhereInput>;
  birthDate?: InputMaybe<StringNullableFilter>;
  cpf?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFilter>;
  email?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  identityDocument?: InputMaybe<StringNullableFilter>;
  isForeign?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  passport?: InputMaybe<StringNullableFilter>;
  receivesCertificateEmail?: InputMaybe<BoolFilter>;
  receivesCertificateWhatsapp?: InputMaybe<BoolFilter>;
  teamId?: InputMaybe<IntFilter>;
};

export type PersonWhereUniqueInput = {
  AND?: InputMaybe<Array<PersonWhereInput>>;
  Address?: InputMaybe<AddressWhereInput>;
  DocumentCertificate?: InputMaybe<DocumentCertificateListRelationFilter>;
  NOT?: InputMaybe<Array<PersonWhereInput>>;
  OR?: InputMaybe<Array<PersonWhereInput>>;
  Phones?: InputMaybe<TelephoneListRelationFilter>;
  Team?: InputMaybe<TeamWhereInput>;
  birthDate?: InputMaybe<StringNullableFilter>;
  cpf?: InputMaybe<StringNullableFilter>;
  cpf_teamId?: InputMaybe<PersonCpfTeamIdCompoundUniqueInput>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  educationLevel?: InputMaybe<EnumEducationLevelTypeFilter>;
  email?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  identityDocument?: InputMaybe<StringNullableFilter>;
  isForeign?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  passport?: InputMaybe<StringNullableFilter>;
  passport_teamId?: InputMaybe<PersonPassportTeamIdCompoundUniqueInput>;
  receivesCertificateEmail?: InputMaybe<BoolFilter>;
  receivesCertificateWhatsapp?: InputMaybe<BoolFilter>;
  teamId?: InputMaybe<IntFilter>;
};

/** A financial plan with values */
export type PlanAndConditions = {
  __typename?: 'PlanAndConditions';
  disabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  includedCertificates: Scalars['Int']['output'];
  monthlyPricing: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  plan: FinancialPlan;
  yearlyPricing: Scalars['Float']['output'];
};

export type PlanPayOverduePaymentsInput = {
  creditCard?: InputMaybe<InputFinancialPurchaseCreditCard>;
  savedCreditCard?: InputMaybe<InputFinancialPurchaseSavedCreditCard>;
};

/** Quantidade rápida pra definir a quantidade de itens pra comprar na recarga */
export type Preset = {
  __typename?: 'Preset';
  count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type PublicView = {
  __typename?: 'PublicView';
  dataKeyValues: Array<KeyValue>;
  /** Diploma Digital, ... */
  documentTypeName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Se o documento é valido ou revogado */
  isValid: Scalars['Boolean']['output'];
  /** Se a visualização do documento estiver habilitada para este tipo de documento */
  isVisualRepresentationEnabled: Scalars['Boolean']['output'];
  securityCode: Scalars['String']['output'];
  validationDatetime: Scalars['String']['output'];
};

export type PurchasedPlanWithOldPlan = {
  __typename?: 'PurchasedPlanWithOldPlan';
  Wallet: FinancialTeamWallet;
  id: Scalars['Int']['output'];
  /** Verdadeiro se primeiro plano da conta. Usado para redirecionar usuário para onboarding ou não. */
  isFirstPlan: Scalars['Boolean']['output'];
};

export type Query = {
  __typename?: 'Query';
  codeDevGetHeapStatistics: Scalars['Json']['output'];
  codeDevGetMemoryUsage?: Maybe<Scalars['Json']['output']>;
  codeDevGetS3KeySize?: Maybe<Scalars['Json']['output']>;
  codeDevOnlineUsers: Scalars['Json']['output'];
  codeDevTest?: Maybe<Scalars['Json']['output']>;
  countApiKey: Scalars['Int']['output'];
  countBulkCertificateRecord: Scalars['Int']['output'];
  countCertificateCourse: Scalars['Int']['output'];
  countCertificateCourseLevel: Scalars['Int']['output'];
  countCertificateCurriculum: Scalars['Int']['output'];
  countCertificateDiscipline: Scalars['Int']['output'];
  countCertificateEvent: Scalars['Int']['output'];
  countCertificateTeacher: Scalars['Int']['output'];
  countCertificateTemplate: Scalars['Int']['output'];
  countCertificateTemplatePreset: Scalars['Int']['output'];
  countCommonUser: Scalars['Int']['output'];
  countDegree: Scalars['Int']['output'];
  countDocumentAcademicDocumentation: Scalars['Int']['output'];
  countDocumentAuditFileIssuer: Scalars['Int']['output'];
  /** Contar os tipos de documento. OBS: Use apenas um type na consulta, pois essa query retorna um INT. */
  countDocumentBaseByType?: Maybe<Scalars['Int']['output']>;
  countDocumentBaseDefaultSignatureInviteConfiguration: Scalars['Int']['output'];
  countDocumentBaseSignatureInvite: Scalars['Int']['output'];
  countDocumentCertificate: Scalars['Int']['output'];
  countDocumentCertificateSignatureItem: Scalars['Int']['output'];
  countDocumentFinalAcademicTranscript: Scalars['Int']['output'];
  countDocumentRenotarization: Scalars['Int']['output'];
  countDocumentSchoolCurriculum: Scalars['Int']['output'];
  countEnabledInstitution: Scalars['Int']['output'];
  countFinancialCharge: Scalars['Int']['output'];
  countFinancialCreditCardSaved: Scalars['Int']['output'];
  countFinancialPayment: Scalars['Int']['output'];
  countFinancialRecharge: Scalars['Int']['output'];
  countFinancialTeamWalletSubscriptionPayment: Scalars['Int']['output'];
  countMaintainerAdmin: Scalars['Int']['output'];
  countPermission: Scalars['Int']['output'];
  countPerson: Scalars['Int']['output'];
  countReusableFormData: Scalars['Int']['output'];
  countReusableFormDataCurriculum: Scalars['Int']['output'];
  countSignSignatureImage: Scalars['Int']['output'];
  countSystemAuditLog: Scalars['Int']['output'];
  countSystemGlobalAlert: Scalars['Int']['output'];
  countTeam: Scalars['Int']['output'];
  countTeamContract: Scalars['Int']['output'];
  countTeamDocumentTypeSpecificSignaturePolicyConfig: Scalars['Int']['output'];
  countTeamMaintained: Scalars['Int']['output'];
  countTeamMember: Scalars['Int']['output'];
  countTotalIssuedDocuments: Scalars['Int']['output'];
  findAllCountDocumentRenotarization: FindAllCountDocumentRenotarizationObject;
  findFirstDocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentation>;
  findFirstDocumentBaseSignatureInvite?: Maybe<DocumentBaseSignatureInvite>;
  findFirstDocumentDegree?: Maybe<DocumentDegree>;
  findFirstPermission?: Maybe<Permission>;
  findFirstReusableFormData?: Maybe<ReusableFormData>;
  findFirstTeamMember?: Maybe<TeamMember>;
  findManyApiKey: Array<ApiKey>;
  findManyBulkCertificateRecord: Array<BulkCertificateRecord>;
  findManyCertificateCourse: Array<CertificateCourse>;
  findManyCertificateCourseLevel: Array<CertificateCourseLevel>;
  findManyCertificateCurriculum: Array<CertificateCurriculum>;
  findManyCertificateDiscipline: Array<CertificateDiscipline>;
  findManyCertificateEvent: Array<CertificateEvent>;
  findManyCertificateTeacher: Array<CertificateTeacher>;
  findManyCertificateTemplate: Array<CertificateTemplate>;
  findManyCertificateTemplatePreset: Array<CertificateTemplatePreset>;
  findManyCertificatesByBatchId: Array<DocumentCertificate>;
  findManyCommonUser: Array<CommonUser>;
  findManyDegree: Array<DocumentDegree>;
  findManyDocumentAcademicDocumentation: Array<DocumentAcademicDocumentation>;
  findManyDocumentAuditFileIssuer: Array<DocumentAuditFileIssuer>;
  findManyDocumentBaseDefaultSignatureInviteConfiguration: Array<DocumentBaseDefaultSignatureInviteConfiguration>;
  findManyDocumentBaseSignatureInvite: Array<DocumentBaseSignatureInvite>;
  findManyDocumentCertificate: Array<DocumentCertificate>;
  findManyDocumentCertificateSignatureItem: Array<DocumentCertificateSignatureItem>;
  findManyDocumentFinalAcademicTranscript: Array<DocumentFinalAcademicTranscript>;
  findManyDocumentRenotarization: Array<DocumentRenotarization>;
  findManyDocumentSchoolCurriculum: Array<DocumentSchoolCurriculum>;
  findManyEnabledInstitution: Array<EnabledInstitution>;
  findManyFinancialCharge: Array<FinancialCharge>;
  findManyFinancialCreditCardSaved: Array<FinancialCreditCardSaved>;
  findManyFinancialPayment: Array<FinancialPayment>;
  findManyFinancialPlan: Array<PlanAndConditions>;
  findManyFinancialRecharge: Array<FinancialRecharge>;
  findManyFinancialTeamWalletSubscriptionPayment: Array<FinancialTeamWalletSubscriptionPayment>;
  findManyMaintainerAdmin: Array<MaintainerAdmin>;
  findManyMaintainerAdministered: Array<EnabledInstitution>;
  findManyPermission: Array<Permission>;
  findManyPerson: Array<Person>;
  findManyReusableFormData: Array<ReusableFormData>;
  findManyReusableFormDataCurriculum: Array<ReusableFormDataCurriculum>;
  findManySignSignatureImage: Array<SignSignatureImage>;
  findManySignableDocumentBaseSignatureInvite: SignableInviteItemsAndCount;
  findManySystemAuditLog: Array<SystemAuditLog>;
  findManySystemGlobalAlert: Array<SystemGlobalAlert>;
  findManyTeam: Array<Team>;
  findManyTeamContract: Array<TeamContract>;
  findManyTeamDocumentTypeSpecificSignaturePolicyConfig: Array<TeamDocumentTypeSpecificSignaturePolicyConfig>;
  findManyTeamMaintained: Array<Team>;
  findManyTeamMember: Array<TeamMember>;
  findOneExternalCepAddress: ExternalCepAddress;
  findPublicViewDegreeDomainPath?: Maybe<FindPublicViewDegreeDomainPathObject>;
  findUniqueBulkCertificateRecord?: Maybe<BulkCertificateRecord>;
  findUniqueCertificateCourse?: Maybe<CertificateCourse>;
  findUniqueCertificateCourseLevel?: Maybe<CertificateCourseLevel>;
  findUniqueCertificateCurriculum?: Maybe<CertificateCurriculum>;
  findUniqueCertificateDiscipline?: Maybe<CertificateDiscipline>;
  findUniqueCertificateEvent?: Maybe<CertificateEvent>;
  findUniqueCertificateTeacher?: Maybe<CertificateTeacher>;
  findUniqueCertificateTemplate?: Maybe<CertificateTemplate>;
  findUniqueCertificateTemplatePreset?: Maybe<CertificateTemplatePreset>;
  findUniqueDegreeToSeeBySecurityCode?: Maybe<DocumentDegree>;
  findUniqueDocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentation>;
  findUniqueDocumentAuditFileIssuer?: Maybe<DocumentAuditFileIssuer>;
  findUniqueDocumentBaseDefaultSignatureInviteConfiguration?: Maybe<DocumentBaseDefaultSignatureInviteConfiguration>;
  findUniqueDocumentBaseSignatureInvite?: Maybe<DocumentBaseSignatureInvite>;
  findUniqueDocumentCertificate?: Maybe<DocumentCertificate>;
  findUniqueDocumentCertificateSignatureItem?: Maybe<DocumentCertificateSignatureItem>;
  findUniqueDocumentDegree?: Maybe<DocumentDegree>;
  findUniqueDocumentFinalAcademicTranscript?: Maybe<DocumentFinalAcademicTranscript>;
  findUniqueDocumentSchoolCurriculum?: Maybe<DocumentSchoolCurriculum>;
  findUniqueExternalSignatureInvite?: Maybe<ExternalSignatureInvite>;
  findUniquePermission?: Maybe<Permission>;
  findUniquePerson?: Maybe<Person>;
  findUniqueReusableFormDataCurriculum?: Maybe<ReusableFormDataCurriculum>;
  findUniqueSignSignatureImage?: Maybe<SignSignatureImage>;
  findUniqueTeam?: Maybe<Team>;
  findUniqueTeamAndPublicDocumentBaseTypeByPublicUrl?: Maybe<TeamAndPublicDocumentBaseType>;
  findUniqueTeamContract?: Maybe<TeamContract>;
  findUniqueTeamDocumentTypeSpecificSignaturePolicyConfig?: Maybe<TeamDocumentTypeSpecificSignaturePolicyConfig>;
  findUniqueToSeePublicDocument?: Maybe<PublicView>;
  /** Retorna o base64 do PDF do certificado */
  generateSampleCertificatePdfBase64: Scalars['String']['output'];
  getFinancialRechargePlans: RechargeOptions;
  getMineTeam?: Maybe<Team>;
  getMineTeamCount: Scalars['Int']['output'];
  globalHealth: Scalars['String']['output'];
  me?: Maybe<CommonUser>;
  /** Ops/Admin: exporta uso de espaço (MB) por DocumentBaseType, agrupando vivos e deletados, incluindo representação visual de diplomas. itemsCount = DocumentBase + DocumentDegree (igual spaceUsageCheckTeam). */
  opsExportTeamSpaceUsageByDocumentType: Scalars['Json']['output'];
  /** Usado durante os testes. Null quando o documento não pode ter a renotarização forçada */
  renotarizationForceStage?: Maybe<RenotarizationForceStage>;
  summaryFinancialCharge: SumCount;
  validateOneDocumentCertificate: ValidateOneDocumentCertificateObject;
};


export type QueryCodeDevGetS3KeySizeArgs = {
  key: Scalars['String']['input'];
};


export type QueryCountApiKeyArgs = {
  cursor?: InputMaybe<ApiKeyWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApiKeyScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApiKeyOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ApiKeyWhereInput>;
};


export type QueryCountBulkCertificateRecordArgs = {
  cursor?: InputMaybe<BulkCertificateRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<BulkCertificateRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BulkCertificateRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BulkCertificateRecordWhereInput>;
};


export type QueryCountCertificateCourseArgs = {
  cursor?: InputMaybe<CertificateCourseWhereUniqueInput>;
  distinct?: InputMaybe<Array<CertificateCourseScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CertificateCourseOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CertificateCourseWhereInput>;
};


export type QueryCountCertificateCourseLevelArgs = {
  cursor?: InputMaybe<CertificateCourseLevelWhereUniqueInput>;
  distinct?: InputMaybe<Array<CertificateCourseLevelScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CertificateCourseLevelOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CertificateCourseLevelWhereInput>;
};


export type QueryCountCertificateCurriculumArgs = {
  cursor?: InputMaybe<CertificateCurriculumWhereUniqueInput>;
  distinct?: InputMaybe<Array<CertificateCurriculumScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CertificateCurriculumOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CertificateCurriculumWhereInput>;
};


export type QueryCountCertificateDisciplineArgs = {
  cursor?: InputMaybe<CertificateDisciplineWhereUniqueInput>;
  distinct?: InputMaybe<Array<CertificateDisciplineScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CertificateDisciplineOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CertificateDisciplineWhereInput>;
};


export type QueryCountCertificateEventArgs = {
  cursor?: InputMaybe<CertificateEventWhereUniqueInput>;
  distinct?: InputMaybe<Array<CertificateEventScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CertificateEventOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CertificateEventWhereInput>;
};


export type QueryCountCertificateTeacherArgs = {
  cursor?: InputMaybe<CertificateTeacherWhereUniqueInput>;
  distinct?: InputMaybe<Array<CertificateTeacherScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CertificateTeacherOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CertificateTeacherWhereInput>;
};


export type QueryCountCertificateTemplateArgs = {
  cursor?: InputMaybe<CertificateTemplateWhereUniqueInput>;
  distinct?: InputMaybe<Array<CertificateTemplateScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CertificateTemplateOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CertificateTemplateWhereInput>;
};


export type QueryCountCertificateTemplatePresetArgs = {
  cursor?: InputMaybe<CertificateTemplatePresetWhereUniqueInput>;
  distinct?: InputMaybe<Array<CertificateTemplatePresetScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CertificateTemplatePresetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CertificateTemplatePresetWhereInput>;
};


export type QueryCountCommonUserArgs = {
  cursor?: InputMaybe<CommonUserWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommonUserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommonUserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommonUserWhereInput>;
};


export type QueryCountDegreeArgs = {
  cursor?: InputMaybe<DocumentDegreeWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentDegreeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentDegreeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentDegreeWhereInput>;
};


export type QueryCountDocumentAcademicDocumentationArgs = {
  cursor?: InputMaybe<DocumentAcademicDocumentationWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentAcademicDocumentationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentAcademicDocumentationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
};


export type QueryCountDocumentAuditFileIssuerArgs = {
  cursor?: InputMaybe<DocumentAuditFileIssuerWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentAuditFileIssuerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentAuditFileIssuerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentAuditFileIssuerWhereInput>;
};


export type QueryCountDocumentBaseByTypeArgs = {
  where: DocumentBaseWhereInput;
};


export type QueryCountDocumentBaseDefaultSignatureInviteConfigurationArgs = {
  cursor?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>;
};


export type QueryCountDocumentBaseSignatureInviteArgs = {
  cursor?: InputMaybe<DocumentBaseSignatureInviteWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentBaseSignatureInviteScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentBaseSignatureInviteOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentBaseSignatureInviteWhereInput>;
};


export type QueryCountDocumentCertificateArgs = {
  cursor?: InputMaybe<DocumentCertificateWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentCertificateScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentCertificateOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentCertificateWhereInput>;
};


export type QueryCountDocumentCertificateSignatureItemArgs = {
  cursor?: InputMaybe<DocumentCertificateSignatureItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentCertificateSignatureItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentCertificateSignatureItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentCertificateSignatureItemWhereInput>;
};


export type QueryCountDocumentFinalAcademicTranscriptArgs = {
  cursor?: InputMaybe<DocumentFinalAcademicTranscriptWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentFinalAcademicTranscriptScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentFinalAcademicTranscriptOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentFinalAcademicTranscriptWhereInput>;
};


export type QueryCountDocumentRenotarizationArgs = {
  cursor?: InputMaybe<DocumentRenotarizationWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentRenotarizationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentRenotarizationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentRenotarizationWhereInput>;
};


export type QueryCountDocumentSchoolCurriculumArgs = {
  cursor?: InputMaybe<DocumentSchoolCurriculumWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentSchoolCurriculumScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentSchoolCurriculumOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentSchoolCurriculumWhereInput>;
};


export type QueryCountEnabledInstitutionArgs = {
  cursor?: InputMaybe<EnabledInstitutionWhereUniqueInput>;
  distinct?: InputMaybe<Array<EnabledInstitutionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<EnabledInstitutionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EnabledInstitutionWhereInput>;
};


export type QueryCountFinancialChargeArgs = {
  cursor?: InputMaybe<FinancialChargeWhereUniqueInput>;
  distinct?: InputMaybe<Array<FinancialChargeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FinancialChargeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FinancialChargeWhereInput>;
};


export type QueryCountFinancialCreditCardSavedArgs = {
  cursor?: InputMaybe<FinancialCreditCardSavedWhereUniqueInput>;
  distinct?: InputMaybe<Array<FinancialCreditCardSavedScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FinancialCreditCardSavedOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FinancialCreditCardSavedWhereInput>;
};


export type QueryCountFinancialPaymentArgs = {
  cursor?: InputMaybe<FinancialPaymentWhereUniqueInput>;
  distinct?: InputMaybe<Array<FinancialPaymentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FinancialPaymentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FinancialPaymentWhereInput>;
};


export type QueryCountFinancialRechargeArgs = {
  cursor?: InputMaybe<FinancialRechargeWhereUniqueInput>;
  distinct?: InputMaybe<Array<FinancialRechargeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FinancialRechargeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FinancialRechargeWhereInput>;
};


export type QueryCountFinancialTeamWalletSubscriptionPaymentArgs = {
  cursor?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereUniqueInput>;
  distinct?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
};


export type QueryCountMaintainerAdminArgs = {
  cursor?: InputMaybe<MaintainerAdminWhereUniqueInput>;
  distinct?: InputMaybe<Array<MaintainerAdminScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MaintainerAdminOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MaintainerAdminWhereInput>;
};


export type QueryCountPermissionArgs = {
  cursor?: InputMaybe<PermissionWhereUniqueInput>;
  distinct?: InputMaybe<Array<PermissionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PermissionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PermissionWhereInput>;
};


export type QueryCountPersonArgs = {
  cursor?: InputMaybe<PersonWhereUniqueInput>;
  distinct?: InputMaybe<Array<PersonScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PersonOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PersonWhereInput>;
};


export type QueryCountReusableFormDataArgs = {
  cursor?: InputMaybe<ReusableFormDataWhereUniqueInput>;
  distinct?: InputMaybe<Array<ReusableFormDataScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ReusableFormDataOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReusableFormDataWhereInputCustom>;
};


export type QueryCountReusableFormDataCurriculumArgs = {
  cursor?: InputMaybe<ReusableFormDataCurriculumWhereUniqueInput>;
  distinct?: InputMaybe<Array<ReusableFormDataCurriculumScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ReusableFormDataCurriculumOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReusableFormDataCurriculumWhereInput>;
};


export type QueryCountSignSignatureImageArgs = {
  cursor?: InputMaybe<SignSignatureImageWhereUniqueInput>;
  distinct?: InputMaybe<Array<SignSignatureImageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SignSignatureImageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SignSignatureImageWhereInput>;
};


export type QueryCountSystemAuditLogArgs = {
  cursor?: InputMaybe<SystemAuditLogWhereUniqueInput>;
  distinct?: InputMaybe<Array<SystemAuditLogScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SystemAuditLogOrderByWithRelationInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SystemAuditLogWhereInput>;
};


export type QueryCountSystemGlobalAlertArgs = {
  cursor?: InputMaybe<SystemGlobalAlertWhereUniqueInput>;
  distinct?: InputMaybe<Array<SystemGlobalAlertScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SystemGlobalAlertOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SystemGlobalAlertWhereInput>;
};


export type QueryCountTeamArgs = {
  cursor?: InputMaybe<TeamWhereUniqueInput>;
  distinct?: InputMaybe<Array<TeamScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TeamOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeamWhereInput>;
};


export type QueryCountTeamContractArgs = {
  cursor?: InputMaybe<TeamContractWhereUniqueInput>;
  distinct?: InputMaybe<Array<TeamContractScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TeamContractOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeamContractWhereInput>;
};


export type QueryCountTeamDocumentTypeSpecificSignaturePolicyConfigArgs = {
  cursor?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigWhereUniqueInput>;
  distinct?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigWhereInput>;
};


export type QueryCountTeamMaintainedArgs = {
  cursor?: InputMaybe<TeamWhereUniqueInput>;
  distinct?: InputMaybe<Array<TeamScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TeamOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeamWhereInput>;
};


export type QueryCountTeamMemberArgs = {
  cursor?: InputMaybe<TeamMemberWhereUniqueInput>;
  distinct?: InputMaybe<Array<TeamMemberScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TeamMemberOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeamMemberWhereInput>;
};


export type QueryFindAllCountDocumentRenotarizationArgs = {
  documentBaseType: DocumentBaseType;
};


export type QueryFindFirstDocumentAcademicDocumentationArgs = {
  cursor?: InputMaybe<DocumentAcademicDocumentationWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentAcademicDocumentationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentAcademicDocumentationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
};


export type QueryFindFirstDocumentBaseSignatureInviteArgs = {
  cursor?: InputMaybe<DocumentBaseSignatureInviteWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentBaseSignatureInviteScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentBaseSignatureInviteOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentBaseSignatureInviteWhereInput>;
};


export type QueryFindFirstDocumentDegreeArgs = {
  cursor?: InputMaybe<DocumentDegreeWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentDegreeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentDegreeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentDegreeWhereInput>;
};


export type QueryFindFirstPermissionArgs = {
  cursor?: InputMaybe<PermissionWhereUniqueInput>;
  distinct?: InputMaybe<Array<PermissionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PermissionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PermissionWhereInput>;
};


export type QueryFindFirstReusableFormDataArgs = {
  cursor?: InputMaybe<ReusableFormDataWhereUniqueInput>;
  distinct?: InputMaybe<Array<ReusableFormDataScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ReusableFormDataOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReusableFormDataWhereInput>;
};


export type QueryFindFirstTeamMemberArgs = {
  cursor?: InputMaybe<TeamMemberWhereUniqueInput>;
  distinct?: InputMaybe<Array<TeamMemberScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TeamMemberOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeamMemberWhereInput>;
};


export type QueryFindManyApiKeyArgs = {
  cursor?: InputMaybe<ApiKeyWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApiKeyScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApiKeyOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ApiKeyWhereInput>;
};


export type QueryFindManyBulkCertificateRecordArgs = {
  cursor?: InputMaybe<BulkCertificateRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<BulkCertificateRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BulkCertificateRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BulkCertificateRecordWhereInput>;
};


export type QueryFindManyCertificateCourseArgs = {
  cursor?: InputMaybe<CertificateCourseWhereUniqueInput>;
  distinct?: InputMaybe<Array<CertificateCourseScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CertificateCourseOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CertificateCourseWhereInput>;
};


export type QueryFindManyCertificateCourseLevelArgs = {
  cursor?: InputMaybe<CertificateCourseLevelWhereUniqueInput>;
  distinct?: InputMaybe<Array<CertificateCourseLevelScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CertificateCourseLevelOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CertificateCourseLevelWhereInput>;
};


export type QueryFindManyCertificateCurriculumArgs = {
  cursor?: InputMaybe<CertificateCurriculumWhereUniqueInput>;
  distinct?: InputMaybe<Array<CertificateCurriculumScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CertificateCurriculumOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CertificateCurriculumWhereInput>;
};


export type QueryFindManyCertificateDisciplineArgs = {
  cursor?: InputMaybe<CertificateDisciplineWhereUniqueInput>;
  distinct?: InputMaybe<Array<CertificateDisciplineScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CertificateDisciplineOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CertificateDisciplineWhereInput>;
};


export type QueryFindManyCertificateEventArgs = {
  cursor?: InputMaybe<CertificateEventWhereUniqueInput>;
  distinct?: InputMaybe<Array<CertificateEventScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CertificateEventOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CertificateEventWhereInput>;
};


export type QueryFindManyCertificateTeacherArgs = {
  cursor?: InputMaybe<CertificateTeacherWhereUniqueInput>;
  distinct?: InputMaybe<Array<CertificateTeacherScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CertificateTeacherOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CertificateTeacherWhereInput>;
};


export type QueryFindManyCertificateTemplateArgs = {
  cursor?: InputMaybe<CertificateTemplateWhereUniqueInput>;
  distinct?: InputMaybe<Array<CertificateTemplateScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CertificateTemplateOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CertificateTemplateWhereInput>;
};


export type QueryFindManyCertificateTemplatePresetArgs = {
  cursor?: InputMaybe<CertificateTemplatePresetWhereUniqueInput>;
  distinct?: InputMaybe<Array<CertificateTemplatePresetScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CertificateTemplatePresetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CertificateTemplatePresetWhereInput>;
};


export type QueryFindManyCertificatesByBatchIdArgs = {
  batchId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindManyCommonUserArgs = {
  cursor?: InputMaybe<CommonUserWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommonUserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommonUserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommonUserWhereInput>;
};


export type QueryFindManyDegreeArgs = {
  cursor?: InputMaybe<DocumentDegreeWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentDegreeScalarFieldEnum>>;
  isAdminView?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<DocumentDegreeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentDegreeWhereInput>;
};


export type QueryFindManyDocumentAcademicDocumentationArgs = {
  cursor?: InputMaybe<DocumentAcademicDocumentationWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentAcademicDocumentationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentAcademicDocumentationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
};


export type QueryFindManyDocumentAuditFileIssuerArgs = {
  cursor?: InputMaybe<DocumentAuditFileIssuerWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentAuditFileIssuerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentAuditFileIssuerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentAuditFileIssuerWhereInput>;
};


export type QueryFindManyDocumentBaseDefaultSignatureInviteConfigurationArgs = {
  cursor?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>;
};


export type QueryFindManyDocumentBaseSignatureInviteArgs = {
  cursor?: InputMaybe<DocumentBaseSignatureInviteWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentBaseSignatureInviteScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentBaseSignatureInviteOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentBaseSignatureInviteWhereInput>;
};


export type QueryFindManyDocumentCertificateArgs = {
  cursor?: InputMaybe<DocumentCertificateWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentCertificateScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentCertificateOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentCertificateWhereInput>;
};


export type QueryFindManyDocumentCertificateSignatureItemArgs = {
  cursor?: InputMaybe<DocumentCertificateSignatureItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentCertificateSignatureItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentCertificateSignatureItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentCertificateSignatureItemWhereInput>;
};


export type QueryFindManyDocumentFinalAcademicTranscriptArgs = {
  cursor?: InputMaybe<DocumentFinalAcademicTranscriptWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentFinalAcademicTranscriptScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentFinalAcademicTranscriptOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentFinalAcademicTranscriptWhereInput>;
};


export type QueryFindManyDocumentRenotarizationArgs = {
  cursor?: InputMaybe<DocumentRenotarizationWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentRenotarizationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentRenotarizationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentRenotarizationWhereInput>;
};


export type QueryFindManyDocumentSchoolCurriculumArgs = {
  cursor?: InputMaybe<DocumentSchoolCurriculumWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentSchoolCurriculumScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentSchoolCurriculumOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentSchoolCurriculumWhereInput>;
};


export type QueryFindManyEnabledInstitutionArgs = {
  cursor?: InputMaybe<EnabledInstitutionWhereUniqueInput>;
  distinct?: InputMaybe<Array<EnabledInstitutionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<EnabledInstitutionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EnabledInstitutionWhereInput>;
};


export type QueryFindManyFinancialChargeArgs = {
  cursor?: InputMaybe<FinancialChargeWhereUniqueInput>;
  distinct?: InputMaybe<Array<FinancialChargeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FinancialChargeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FinancialChargeWhereInput>;
};


export type QueryFindManyFinancialCreditCardSavedArgs = {
  cursor?: InputMaybe<FinancialCreditCardSavedWhereUniqueInput>;
  distinct?: InputMaybe<Array<FinancialCreditCardSavedScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FinancialCreditCardSavedOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FinancialCreditCardSavedWhereInput>;
};


export type QueryFindManyFinancialPaymentArgs = {
  cursor?: InputMaybe<FinancialPaymentWhereUniqueInput>;
  distinct?: InputMaybe<Array<FinancialPaymentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FinancialPaymentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FinancialPaymentWhereInput>;
};


export type QueryFindManyFinancialRechargeArgs = {
  cursor?: InputMaybe<FinancialRechargeWhereUniqueInput>;
  distinct?: InputMaybe<Array<FinancialRechargeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FinancialRechargeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FinancialRechargeWhereInput>;
};


export type QueryFindManyFinancialTeamWalletSubscriptionPaymentArgs = {
  cursor?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereUniqueInput>;
  distinct?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
};


export type QueryFindManyMaintainerAdminArgs = {
  cursor?: InputMaybe<MaintainerAdminWhereUniqueInput>;
  distinct?: InputMaybe<Array<MaintainerAdminScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MaintainerAdminOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MaintainerAdminWhereInput>;
};


export type QueryFindManyMaintainerAdministeredArgs = {
  maintainerTeamId: Scalars['String']['input'];
};


export type QueryFindManyPermissionArgs = {
  cursor?: InputMaybe<PermissionWhereUniqueInput>;
  distinct?: InputMaybe<Array<PermissionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PermissionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PermissionWhereInput>;
};


export type QueryFindManyPersonArgs = {
  cursor?: InputMaybe<PersonWhereUniqueInput>;
  distinct?: InputMaybe<Array<PersonScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PersonOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PersonWhereInput>;
};


export type QueryFindManyReusableFormDataArgs = {
  cursor?: InputMaybe<ReusableFormDataWhereUniqueInput>;
  distinct?: InputMaybe<Array<ReusableFormDataScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ReusableFormDataOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReusableFormDataWhereInputCustom>;
};


export type QueryFindManyReusableFormDataCurriculumArgs = {
  cursor?: InputMaybe<ReusableFormDataCurriculumWhereUniqueInput>;
  distinct?: InputMaybe<Array<ReusableFormDataCurriculumScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ReusableFormDataCurriculumOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReusableFormDataCurriculumWhereInput>;
};


export type QueryFindManySignSignatureImageArgs = {
  cursor?: InputMaybe<SignSignatureImageWhereUniqueInput>;
  distinct?: InputMaybe<Array<SignSignatureImageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SignSignatureImageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SignSignatureImageWhereInput>;
};


export type QueryFindManySignableDocumentBaseSignatureInviteArgs = {
  cursor?: InputMaybe<DocumentBaseSignatureInviteWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentBaseSignatureInviteScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentBaseSignatureInviteOrderByWithRelationInput>>;
  personId: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentBaseSignatureInviteWhereInput>;
};


export type QueryFindManySystemAuditLogArgs = {
  cursor?: InputMaybe<SystemAuditLogWhereUniqueInput>;
  distinct?: InputMaybe<Array<SystemAuditLogScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SystemAuditLogOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SystemAuditLogWhereInput>;
};


export type QueryFindManySystemGlobalAlertArgs = {
  cursor?: InputMaybe<SystemGlobalAlertWhereUniqueInput>;
  distinct?: InputMaybe<Array<SystemGlobalAlertScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SystemGlobalAlertOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SystemGlobalAlertWhereInput>;
};


export type QueryFindManyTeamArgs = {
  cursor?: InputMaybe<TeamWhereUniqueInput>;
  distinct?: InputMaybe<Array<TeamScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TeamOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeamWhereInput>;
};


export type QueryFindManyTeamContractArgs = {
  cursor?: InputMaybe<TeamContractWhereUniqueInput>;
  distinct?: InputMaybe<Array<TeamContractScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TeamContractOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeamContractWhereInput>;
};


export type QueryFindManyTeamDocumentTypeSpecificSignaturePolicyConfigArgs = {
  cursor?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigWhereUniqueInput>;
  distinct?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigWhereInput>;
};


export type QueryFindManyTeamMaintainedArgs = {
  cursor?: InputMaybe<TeamWhereUniqueInput>;
  distinct?: InputMaybe<Array<TeamScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TeamOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeamWhereInput>;
};


export type QueryFindManyTeamMemberArgs = {
  cursor?: InputMaybe<TeamMemberWhereUniqueInput>;
  distinct?: InputMaybe<Array<TeamMemberScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TeamMemberOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeamMemberWhereInput>;
};


export type QueryFindOneExternalCepAddressArgs = {
  cep: Scalars['String']['input'];
};


export type QueryFindPublicViewDegreeDomainPathArgs = {
  searchValidationCode: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};


export type QueryFindUniqueBulkCertificateRecordArgs = {
  where: BulkCertificateRecordWhereUniqueInput;
};


export type QueryFindUniqueCertificateCourseArgs = {
  where: CertificateCourseWhereUniqueInput;
};


export type QueryFindUniqueCertificateCourseLevelArgs = {
  where: CertificateCourseLevelWhereUniqueInput;
};


export type QueryFindUniqueCertificateCurriculumArgs = {
  where: CertificateCurriculumWhereUniqueInput;
};


export type QueryFindUniqueCertificateDisciplineArgs = {
  where: CertificateDisciplineWhereUniqueInput;
};


export type QueryFindUniqueCertificateEventArgs = {
  where: CertificateEventWhereUniqueInput;
};


export type QueryFindUniqueCertificateTeacherArgs = {
  where: CertificateTeacherWhereUniqueInput;
};


export type QueryFindUniqueCertificateTemplateArgs = {
  where: CertificateTemplateWhereUniqueInput;
};


export type QueryFindUniqueCertificateTemplatePresetArgs = {
  where: CertificateTemplatePresetWhereUniqueInput;
};


export type QueryFindUniqueDegreeToSeeBySecurityCodeArgs = {
  domain: Scalars['String']['input'];
  recaptchaResponse: Scalars['String']['input'];
  securityCode: Scalars['String']['input'];
};


export type QueryFindUniqueDocumentAcademicDocumentationArgs = {
  where: DocumentAcademicDocumentationWhereUniqueInput;
};


export type QueryFindUniqueDocumentAuditFileIssuerArgs = {
  where: DocumentAuditFileIssuerWhereUniqueInput;
};


export type QueryFindUniqueDocumentBaseDefaultSignatureInviteConfigurationArgs = {
  where: DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput;
};


export type QueryFindUniqueDocumentBaseSignatureInviteArgs = {
  where: DocumentBaseSignatureInviteWhereUniqueInput;
};


export type QueryFindUniqueDocumentCertificateArgs = {
  where: DocumentCertificateWhereUniqueInput;
};


export type QueryFindUniqueDocumentCertificateSignatureItemArgs = {
  where: DocumentCertificateSignatureItemWhereUniqueInput;
};


export type QueryFindUniqueDocumentDegreeArgs = {
  where: DocumentDegreeWhereUniqueInput;
};


export type QueryFindUniqueDocumentFinalAcademicTranscriptArgs = {
  where: DocumentFinalAcademicTranscriptWhereUniqueInput;
};


export type QueryFindUniqueDocumentSchoolCurriculumArgs = {
  where: DocumentSchoolCurriculumWhereUniqueInput;
};


export type QueryFindUniqueExternalSignatureInviteArgs = {
  where: ExternalSignatureInviteWhereUniqueInput;
};


export type QueryFindUniquePermissionArgs = {
  where: PermissionWhereUniqueInput;
};


export type QueryFindUniquePersonArgs = {
  where: PersonWhereUniqueInput;
};


export type QueryFindUniqueReusableFormDataCurriculumArgs = {
  where: ReusableFormDataCurriculumWhereUniqueInput;
};


export type QueryFindUniqueSignSignatureImageArgs = {
  where: SignSignatureImageWhereUniqueInput;
};


export type QueryFindUniqueTeamArgs = {
  where: TeamWhereUniqueInput;
};


export type QueryFindUniqueTeamContractArgs = {
  where: TeamContractWhereUniqueInput;
};


export type QueryFindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigArgs = {
  where: TeamDocumentTypeSpecificSignaturePolicyConfigWhereUniqueInput;
};


export type QueryFindUniqueToSeePublicDocumentArgs = {
  recaptchaResponse: Scalars['String']['input'];
};


export type QueryGenerateSampleCertificatePdfBase64Args = {
  template: Scalars['Json']['input'];
};


export type QueryGetMineTeamArgs = {
  cursor?: InputMaybe<TeamWhereUniqueInput>;
  distinct?: InputMaybe<Array<TeamScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TeamOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeamWhereInput>;
};


export type QueryGetMineTeamCountArgs = {
  cursor?: InputMaybe<TeamWhereUniqueInput>;
  distinct?: InputMaybe<Array<TeamScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TeamOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeamWhereInput>;
};


export type QueryOpsExportTeamSpaceUsageByDocumentTypeArgs = {
  teamIds: Array<Scalars['Int']['input']>;
};


export type QueryRenotarizationForceStageArgs = {
  documentId: Scalars['String']['input'];
};


export type QuerySummaryFinancialChargeArgs = {
  cursor?: InputMaybe<FinancialChargeWhereUniqueInput>;
  distinct?: InputMaybe<Array<FinancialChargeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FinancialChargeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FinancialChargeWhereInput>;
};


export type QueryValidateOneDocumentCertificateArgs = {
  docId?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  recaptchaResponse: Scalars['String']['input'];
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type RechargeOptions = {
  __typename?: 'RechargeOptions';
  discounts: Array<Discount>;
  presets: Array<Preset>;
  servicesPrices: Array<ServicePrice>;
};

export enum RenotarizationForceStage {
  InWindow = 'IN_WINDOW',
  OutOfWindow = 'OUT_OF_WINDOW'
}

/** Store Issuer/Course data to late user */
export type ReusableFormData = {
  __typename?: 'ReusableFormData';
  DisciplineLinks: Array<ReusableFormDataCurriculumDisciplineLink>;
  ReusableFormDataCurriculum: Array<ReusableFormDataCurriculum>;
  Team: Team;
  UserOwner: CommonUser;
  commonUserId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** ![PrismaJson.AnyJson] */
  data: Scalars['Json']['output'];
  id: Scalars['Int']['output'];
  teamId: Scalars['Int']['output'];
  /** issuer, course, discipline, teacher */
  type: Scalars['String']['output'];
};


/** Store Issuer/Course data to late user */
export type ReusableFormDataDisciplineLinksArgs = {
  cursor?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput>;
  distinct?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkWhereInput>;
};


/** Store Issuer/Course data to late user */
export type ReusableFormDataReusableFormDataCurriculumArgs = {
  cursor?: InputMaybe<ReusableFormDataCurriculumWhereUniqueInput>;
  distinct?: InputMaybe<Array<ReusableFormDataCurriculumScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ReusableFormDataCurriculumOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReusableFormDataCurriculumWhereInput>;
};

export type ReusableFormDataAvgOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type ReusableFormDataCountOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type ReusableFormDataCreateInput = {
  DisciplineLinks?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkCreateNestedManyWithoutDisciplineInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutCourseInput>;
  Team: TeamCreateNestedOneWithoutReusableFormDataInput;
  UserOwner: CommonUserCreateNestedOneWithoutReusableFormDatasInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  type: Scalars['String']['input'];
};

export type ReusableFormDataCreateManyInput = {
  commonUserId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type ReusableFormDataCreateManyTeamInput = {
  commonUserId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
};

export type ReusableFormDataCreateManyTeamInputEnvelope = {
  data: Array<ReusableFormDataCreateManyTeamInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReusableFormDataCreateManyUserOwnerInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type ReusableFormDataCreateManyUserOwnerInputEnvelope = {
  data: Array<ReusableFormDataCreateManyUserOwnerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReusableFormDataCreateNestedManyWithoutTeamInput = {
  connect?: InputMaybe<Array<ReusableFormDataWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReusableFormDataCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<ReusableFormDataCreateWithoutTeamInput>>;
  createMany?: InputMaybe<ReusableFormDataCreateManyTeamInputEnvelope>;
};

export type ReusableFormDataCreateNestedManyWithoutUserOwnerInput = {
  connect?: InputMaybe<Array<ReusableFormDataWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReusableFormDataCreateOrConnectWithoutUserOwnerInput>>;
  create?: InputMaybe<Array<ReusableFormDataCreateWithoutUserOwnerInput>>;
  createMany?: InputMaybe<ReusableFormDataCreateManyUserOwnerInputEnvelope>;
};

export type ReusableFormDataCreateNestedOneWithoutDisciplineLinksInput = {
  connect?: InputMaybe<ReusableFormDataWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ReusableFormDataCreateOrConnectWithoutDisciplineLinksInput>;
  create?: InputMaybe<ReusableFormDataCreateWithoutDisciplineLinksInput>;
};

export type ReusableFormDataCreateNestedOneWithoutReusableFormDataCurriculumInput = {
  connect?: InputMaybe<ReusableFormDataWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ReusableFormDataCreateOrConnectWithoutReusableFormDataCurriculumInput>;
  create?: InputMaybe<ReusableFormDataCreateWithoutReusableFormDataCurriculumInput>;
};

export type ReusableFormDataCreateOrConnectWithoutDisciplineLinksInput = {
  create: ReusableFormDataCreateWithoutDisciplineLinksInput;
  where: ReusableFormDataWhereUniqueInput;
};

export type ReusableFormDataCreateOrConnectWithoutReusableFormDataCurriculumInput = {
  create: ReusableFormDataCreateWithoutReusableFormDataCurriculumInput;
  where: ReusableFormDataWhereUniqueInput;
};

export type ReusableFormDataCreateOrConnectWithoutTeamInput = {
  create: ReusableFormDataCreateWithoutTeamInput;
  where: ReusableFormDataWhereUniqueInput;
};

export type ReusableFormDataCreateOrConnectWithoutUserOwnerInput = {
  create: ReusableFormDataCreateWithoutUserOwnerInput;
  where: ReusableFormDataWhereUniqueInput;
};

export type ReusableFormDataCreateWithoutDisciplineLinksInput = {
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutCourseInput>;
  Team: TeamCreateNestedOneWithoutReusableFormDataInput;
  UserOwner: CommonUserCreateNestedOneWithoutReusableFormDatasInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  type: Scalars['String']['input'];
};

export type ReusableFormDataCreateWithoutReusableFormDataCurriculumInput = {
  DisciplineLinks?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkCreateNestedManyWithoutDisciplineInput>;
  Team: TeamCreateNestedOneWithoutReusableFormDataInput;
  UserOwner: CommonUserCreateNestedOneWithoutReusableFormDatasInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  type: Scalars['String']['input'];
};

export type ReusableFormDataCreateWithoutTeamInput = {
  DisciplineLinks?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkCreateNestedManyWithoutDisciplineInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutCourseInput>;
  UserOwner: CommonUserCreateNestedOneWithoutReusableFormDatasInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  type: Scalars['String']['input'];
};

export type ReusableFormDataCreateWithoutUserOwnerInput = {
  DisciplineLinks?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkCreateNestedManyWithoutDisciplineInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutCourseInput>;
  Team: TeamCreateNestedOneWithoutReusableFormDataInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  type: Scalars['String']['input'];
};

/**
 * Store a Array<ReusableFormData<discipline>> to import
 * Created a new model to store references to ReusableFormData, instead of a raw JSON
 */
export type ReusableFormDataCurriculum = {
  __typename?: 'ReusableFormDataCurriculum';
  Course: ReusableFormData;
  DisciplineLinks: Array<ReusableFormDataCurriculumDisciplineLink>;
  Team: Team;
  UserOwner: CommonUser;
  commonUserId: Scalars['Int']['output'];
  courseId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  teamId: Scalars['Int']['output'];
};


/**
 * Store a Array<ReusableFormData<discipline>> to import
 * Created a new model to store references to ReusableFormData, instead of a raw JSON
 */
export type ReusableFormDataCurriculumDisciplineLinksArgs = {
  cursor?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput>;
  distinct?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkWhereInput>;
};

export type ReusableFormDataCurriculumAvgOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  courseId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type ReusableFormDataCurriculumCountOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  courseId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type ReusableFormDataCurriculumCreateInput = {
  Course: ReusableFormDataCreateNestedOneWithoutReusableFormDataCurriculumInput;
  DisciplineLinks?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkCreateNestedManyWithoutCurriculumInput>;
  Team: TeamCreateNestedOneWithoutReusableFormDataCurriculumInput;
  UserOwner: CommonUserCreateNestedOneWithoutReusableFormDataCurriculumListInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
};

export type ReusableFormDataCurriculumCreateInputCustom = {
  courseId: Scalars['Int']['input'];
  disciplines: Array<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type ReusableFormDataCurriculumCreateManyCourseInput = {
  commonUserId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type ReusableFormDataCurriculumCreateManyCourseInputEnvelope = {
  data: Array<ReusableFormDataCurriculumCreateManyCourseInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReusableFormDataCurriculumCreateManyInput = {
  commonUserId: Scalars['Int']['input'];
  courseId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type ReusableFormDataCurriculumCreateManyTeamInput = {
  commonUserId: Scalars['Int']['input'];
  courseId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type ReusableFormDataCurriculumCreateManyTeamInputEnvelope = {
  data: Array<ReusableFormDataCurriculumCreateManyTeamInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReusableFormDataCurriculumCreateManyUserOwnerInput = {
  courseId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};

export type ReusableFormDataCurriculumCreateManyUserOwnerInputEnvelope = {
  data: Array<ReusableFormDataCurriculumCreateManyUserOwnerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReusableFormDataCurriculumCreateNestedManyWithoutCourseInput = {
  connect?: InputMaybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReusableFormDataCurriculumCreateOrConnectWithoutCourseInput>>;
  create?: InputMaybe<Array<ReusableFormDataCurriculumCreateWithoutCourseInput>>;
  createMany?: InputMaybe<ReusableFormDataCurriculumCreateManyCourseInputEnvelope>;
};

export type ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput = {
  connect?: InputMaybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReusableFormDataCurriculumCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<ReusableFormDataCurriculumCreateWithoutTeamInput>>;
  createMany?: InputMaybe<ReusableFormDataCurriculumCreateManyTeamInputEnvelope>;
};

export type ReusableFormDataCurriculumCreateNestedManyWithoutUserOwnerInput = {
  connect?: InputMaybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReusableFormDataCurriculumCreateOrConnectWithoutUserOwnerInput>>;
  create?: InputMaybe<Array<ReusableFormDataCurriculumCreateWithoutUserOwnerInput>>;
  createMany?: InputMaybe<ReusableFormDataCurriculumCreateManyUserOwnerInputEnvelope>;
};

export type ReusableFormDataCurriculumCreateNestedOneWithoutDisciplineLinksInput = {
  connect?: InputMaybe<ReusableFormDataCurriculumWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ReusableFormDataCurriculumCreateOrConnectWithoutDisciplineLinksInput>;
  create?: InputMaybe<ReusableFormDataCurriculumCreateWithoutDisciplineLinksInput>;
};

export type ReusableFormDataCurriculumCreateOrConnectWithoutCourseInput = {
  create: ReusableFormDataCurriculumCreateWithoutCourseInput;
  where: ReusableFormDataCurriculumWhereUniqueInput;
};

export type ReusableFormDataCurriculumCreateOrConnectWithoutDisciplineLinksInput = {
  create: ReusableFormDataCurriculumCreateWithoutDisciplineLinksInput;
  where: ReusableFormDataCurriculumWhereUniqueInput;
};

export type ReusableFormDataCurriculumCreateOrConnectWithoutTeamInput = {
  create: ReusableFormDataCurriculumCreateWithoutTeamInput;
  where: ReusableFormDataCurriculumWhereUniqueInput;
};

export type ReusableFormDataCurriculumCreateOrConnectWithoutUserOwnerInput = {
  create: ReusableFormDataCurriculumCreateWithoutUserOwnerInput;
  where: ReusableFormDataCurriculumWhereUniqueInput;
};

export type ReusableFormDataCurriculumCreateWithoutCourseInput = {
  DisciplineLinks?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkCreateNestedManyWithoutCurriculumInput>;
  Team: TeamCreateNestedOneWithoutReusableFormDataCurriculumInput;
  UserOwner: CommonUserCreateNestedOneWithoutReusableFormDataCurriculumListInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
};

export type ReusableFormDataCurriculumCreateWithoutDisciplineLinksInput = {
  Course: ReusableFormDataCreateNestedOneWithoutReusableFormDataCurriculumInput;
  Team: TeamCreateNestedOneWithoutReusableFormDataCurriculumInput;
  UserOwner: CommonUserCreateNestedOneWithoutReusableFormDataCurriculumListInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
};

export type ReusableFormDataCurriculumCreateWithoutTeamInput = {
  Course: ReusableFormDataCreateNestedOneWithoutReusableFormDataCurriculumInput;
  DisciplineLinks?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkCreateNestedManyWithoutCurriculumInput>;
  UserOwner: CommonUserCreateNestedOneWithoutReusableFormDataCurriculumListInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
};

export type ReusableFormDataCurriculumCreateWithoutUserOwnerInput = {
  Course: ReusableFormDataCreateNestedOneWithoutReusableFormDataCurriculumInput;
  DisciplineLinks?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkCreateNestedManyWithoutCurriculumInput>;
  Team: TeamCreateNestedOneWithoutReusableFormDataCurriculumInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
};

export type ReusableFormDataCurriculumDisciplineLink = {
  __typename?: 'ReusableFormDataCurriculumDisciplineLink';
  Curriculum: ReusableFormDataCurriculum;
  Discipline: ReusableFormData;
  id: Scalars['Int']['output'];
  reusableFormDataCurriculumId: Scalars['Int']['output'];
  reusableFormDataDisciplineId: Scalars['Int']['output'];
};

export type ReusableFormDataCurriculumDisciplineLinkAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  reusableFormDataCurriculumId?: InputMaybe<SortOrder>;
  reusableFormDataDisciplineId?: InputMaybe<SortOrder>;
};

export type ReusableFormDataCurriculumDisciplineLinkCountOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  reusableFormDataCurriculumId?: InputMaybe<SortOrder>;
  reusableFormDataDisciplineId?: InputMaybe<SortOrder>;
};

export type ReusableFormDataCurriculumDisciplineLinkCreateInput = {
  Curriculum: ReusableFormDataCurriculumCreateNestedOneWithoutDisciplineLinksInput;
  Discipline: ReusableFormDataCreateNestedOneWithoutDisciplineLinksInput;
};

export type ReusableFormDataCurriculumDisciplineLinkCreateManyCurriculumInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  reusableFormDataDisciplineId: Scalars['Int']['input'];
};

export type ReusableFormDataCurriculumDisciplineLinkCreateManyCurriculumInputEnvelope = {
  data: Array<ReusableFormDataCurriculumDisciplineLinkCreateManyCurriculumInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReusableFormDataCurriculumDisciplineLinkCreateManyDisciplineInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  reusableFormDataCurriculumId: Scalars['Int']['input'];
};

export type ReusableFormDataCurriculumDisciplineLinkCreateManyDisciplineInputEnvelope = {
  data: Array<ReusableFormDataCurriculumDisciplineLinkCreateManyDisciplineInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReusableFormDataCurriculumDisciplineLinkCreateManyInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  reusableFormDataCurriculumId: Scalars['Int']['input'];
  reusableFormDataDisciplineId: Scalars['Int']['input'];
};

export type ReusableFormDataCurriculumDisciplineLinkCreateNestedManyWithoutCurriculumInput = {
  connect?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkCreateOrConnectWithoutCurriculumInput>>;
  create?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkCreateWithoutCurriculumInput>>;
  createMany?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkCreateManyCurriculumInputEnvelope>;
};

export type ReusableFormDataCurriculumDisciplineLinkCreateNestedManyWithoutDisciplineInput = {
  connect?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkCreateOrConnectWithoutDisciplineInput>>;
  create?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkCreateWithoutDisciplineInput>>;
  createMany?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkCreateManyDisciplineInputEnvelope>;
};

export type ReusableFormDataCurriculumDisciplineLinkCreateOrConnectWithoutCurriculumInput = {
  create: ReusableFormDataCurriculumDisciplineLinkCreateWithoutCurriculumInput;
  where: ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput;
};

export type ReusableFormDataCurriculumDisciplineLinkCreateOrConnectWithoutDisciplineInput = {
  create: ReusableFormDataCurriculumDisciplineLinkCreateWithoutDisciplineInput;
  where: ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput;
};

export type ReusableFormDataCurriculumDisciplineLinkCreateWithoutCurriculumInput = {
  Discipline: ReusableFormDataCreateNestedOneWithoutDisciplineLinksInput;
};

export type ReusableFormDataCurriculumDisciplineLinkCreateWithoutDisciplineInput = {
  Curriculum: ReusableFormDataCurriculumCreateNestedOneWithoutDisciplineLinksInput;
};

export type ReusableFormDataCurriculumDisciplineLinkListRelationFilter = {
  every?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkWhereInput>;
  none?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkWhereInput>;
  some?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkWhereInput>;
};

export type ReusableFormDataCurriculumDisciplineLinkMaxOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  reusableFormDataCurriculumId?: InputMaybe<SortOrder>;
  reusableFormDataDisciplineId?: InputMaybe<SortOrder>;
};

export type ReusableFormDataCurriculumDisciplineLinkMinOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  reusableFormDataCurriculumId?: InputMaybe<SortOrder>;
  reusableFormDataDisciplineId?: InputMaybe<SortOrder>;
};

export type ReusableFormDataCurriculumDisciplineLinkOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ReusableFormDataCurriculumDisciplineLinkOrderByWithAggregationInput = {
  _avg?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkAvgOrderByAggregateInput>;
  _count?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkCountOrderByAggregateInput>;
  _max?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkMaxOrderByAggregateInput>;
  _min?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkMinOrderByAggregateInput>;
  _sum?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkSumOrderByAggregateInput>;
  id?: InputMaybe<SortOrder>;
  reusableFormDataCurriculumId?: InputMaybe<SortOrder>;
  reusableFormDataDisciplineId?: InputMaybe<SortOrder>;
};

export type ReusableFormDataCurriculumDisciplineLinkOrderByWithRelationInput = {
  Curriculum?: InputMaybe<ReusableFormDataCurriculumOrderByWithRelationInput>;
  Discipline?: InputMaybe<ReusableFormDataOrderByWithRelationInput>;
  id?: InputMaybe<SortOrder>;
  reusableFormDataCurriculumId?: InputMaybe<SortOrder>;
  reusableFormDataDisciplineId?: InputMaybe<SortOrder>;
};

export enum ReusableFormDataCurriculumDisciplineLinkScalarFieldEnum {
  Id = 'id',
  ReusableFormDataCurriculumId = 'reusableFormDataCurriculumId',
  ReusableFormDataDisciplineId = 'reusableFormDataDisciplineId'
}

export type ReusableFormDataCurriculumDisciplineLinkScalarWhereInput = {
  AND?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkScalarWhereInput>>;
  NOT?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkScalarWhereInput>>;
  OR?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkScalarWhereInput>>;
  id?: InputMaybe<IntFilter>;
  reusableFormDataCurriculumId?: InputMaybe<IntFilter>;
  reusableFormDataDisciplineId?: InputMaybe<IntFilter>;
};

export type ReusableFormDataCurriculumDisciplineLinkScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkScalarWhereWithAggregatesInput>>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  reusableFormDataCurriculumId?: InputMaybe<IntWithAggregatesFilter>;
  reusableFormDataDisciplineId?: InputMaybe<IntWithAggregatesFilter>;
};

export type ReusableFormDataCurriculumDisciplineLinkSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  reusableFormDataCurriculumId?: InputMaybe<SortOrder>;
  reusableFormDataDisciplineId?: InputMaybe<SortOrder>;
};

export type ReusableFormDataCurriculumDisciplineLinkUpdateInput = {
  Curriculum?: InputMaybe<ReusableFormDataCurriculumUpdateOneRequiredWithoutDisciplineLinksNestedInput>;
  Discipline?: InputMaybe<ReusableFormDataUpdateOneRequiredWithoutDisciplineLinksNestedInput>;
};

export type ReusableFormDataCurriculumDisciplineLinkUpdateManyMutationInput = {
  _?: InputMaybe<Scalars['NEVER']['input']>;
};

export type ReusableFormDataCurriculumDisciplineLinkUpdateManyWithWhereWithoutCurriculumInput = {
  data: ReusableFormDataCurriculumDisciplineLinkUpdateManyMutationInput;
  where: ReusableFormDataCurriculumDisciplineLinkScalarWhereInput;
};

export type ReusableFormDataCurriculumDisciplineLinkUpdateManyWithWhereWithoutDisciplineInput = {
  data: ReusableFormDataCurriculumDisciplineLinkUpdateManyMutationInput;
  where: ReusableFormDataCurriculumDisciplineLinkScalarWhereInput;
};

export type ReusableFormDataCurriculumDisciplineLinkUpdateManyWithoutCurriculumNestedInput = {
  connect?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkCreateOrConnectWithoutCurriculumInput>>;
  create?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkCreateWithoutCurriculumInput>>;
  createMany?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkCreateManyCurriculumInputEnvelope>;
  delete?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput>>;
  set?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput>>;
  update?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkUpdateWithWhereUniqueWithoutCurriculumInput>>;
  updateMany?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkUpdateManyWithWhereWithoutCurriculumInput>>;
  upsert?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkUpsertWithWhereUniqueWithoutCurriculumInput>>;
};

export type ReusableFormDataCurriculumDisciplineLinkUpdateManyWithoutDisciplineNestedInput = {
  connect?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkCreateOrConnectWithoutDisciplineInput>>;
  create?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkCreateWithoutDisciplineInput>>;
  createMany?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkCreateManyDisciplineInputEnvelope>;
  delete?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput>>;
  set?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput>>;
  update?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkUpdateWithWhereUniqueWithoutDisciplineInput>>;
  updateMany?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkUpdateManyWithWhereWithoutDisciplineInput>>;
  upsert?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkUpsertWithWhereUniqueWithoutDisciplineInput>>;
};

export type ReusableFormDataCurriculumDisciplineLinkUpdateWithWhereUniqueWithoutCurriculumInput = {
  data: ReusableFormDataCurriculumDisciplineLinkUpdateWithoutCurriculumInput;
  where: ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput;
};

export type ReusableFormDataCurriculumDisciplineLinkUpdateWithWhereUniqueWithoutDisciplineInput = {
  data: ReusableFormDataCurriculumDisciplineLinkUpdateWithoutDisciplineInput;
  where: ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput;
};

export type ReusableFormDataCurriculumDisciplineLinkUpdateWithoutCurriculumInput = {
  Discipline?: InputMaybe<ReusableFormDataUpdateOneRequiredWithoutDisciplineLinksNestedInput>;
};

export type ReusableFormDataCurriculumDisciplineLinkUpdateWithoutDisciplineInput = {
  Curriculum?: InputMaybe<ReusableFormDataCurriculumUpdateOneRequiredWithoutDisciplineLinksNestedInput>;
};

export type ReusableFormDataCurriculumDisciplineLinkUpsertWithWhereUniqueWithoutCurriculumInput = {
  create: ReusableFormDataCurriculumDisciplineLinkCreateWithoutCurriculumInput;
  update: ReusableFormDataCurriculumDisciplineLinkUpdateWithoutCurriculumInput;
  where: ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput;
};

export type ReusableFormDataCurriculumDisciplineLinkUpsertWithWhereUniqueWithoutDisciplineInput = {
  create: ReusableFormDataCurriculumDisciplineLinkCreateWithoutDisciplineInput;
  update: ReusableFormDataCurriculumDisciplineLinkUpdateWithoutDisciplineInput;
  where: ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput;
};

export type ReusableFormDataCurriculumDisciplineLinkWhereInput = {
  AND?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereInput>>;
  Curriculum?: InputMaybe<ReusableFormDataCurriculumWhereInput>;
  Discipline?: InputMaybe<ReusableFormDataWhereInput>;
  NOT?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereInput>>;
  OR?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereInput>>;
  id?: InputMaybe<IntFilter>;
  reusableFormDataCurriculumId?: InputMaybe<IntFilter>;
  reusableFormDataDisciplineId?: InputMaybe<IntFilter>;
};

export type ReusableFormDataCurriculumDisciplineLinkWhereUniqueInput = {
  AND?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereInput>>;
  Curriculum?: InputMaybe<ReusableFormDataCurriculumWhereInput>;
  Discipline?: InputMaybe<ReusableFormDataWhereInput>;
  NOT?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereInput>>;
  OR?: InputMaybe<Array<ReusableFormDataCurriculumDisciplineLinkWhereInput>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  reusableFormDataCurriculumId?: InputMaybe<IntFilter>;
  reusableFormDataDisciplineId?: InputMaybe<IntFilter>;
};

export type ReusableFormDataCurriculumListRelationFilter = {
  every?: InputMaybe<ReusableFormDataCurriculumWhereInput>;
  none?: InputMaybe<ReusableFormDataCurriculumWhereInput>;
  some?: InputMaybe<ReusableFormDataCurriculumWhereInput>;
};

export type ReusableFormDataCurriculumMaxOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  courseId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type ReusableFormDataCurriculumMinOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  courseId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type ReusableFormDataCurriculumOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ReusableFormDataCurriculumOrderByWithAggregationInput = {
  _avg?: InputMaybe<ReusableFormDataCurriculumAvgOrderByAggregateInput>;
  _count?: InputMaybe<ReusableFormDataCurriculumCountOrderByAggregateInput>;
  _max?: InputMaybe<ReusableFormDataCurriculumMaxOrderByAggregateInput>;
  _min?: InputMaybe<ReusableFormDataCurriculumMinOrderByAggregateInput>;
  _sum?: InputMaybe<ReusableFormDataCurriculumSumOrderByAggregateInput>;
  commonUserId?: InputMaybe<SortOrder>;
  courseId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type ReusableFormDataCurriculumOrderByWithRelationInput = {
  Course?: InputMaybe<ReusableFormDataOrderByWithRelationInput>;
  DisciplineLinks?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkOrderByRelationAggregateInput>;
  Team?: InputMaybe<TeamOrderByWithRelationInput>;
  UserOwner?: InputMaybe<CommonUserOrderByWithRelationInput>;
  commonUserId?: InputMaybe<SortOrder>;
  courseId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type ReusableFormDataCurriculumRelationFilter = {
  is?: InputMaybe<ReusableFormDataCurriculumWhereInput>;
  isNot?: InputMaybe<ReusableFormDataCurriculumWhereInput>;
};

export enum ReusableFormDataCurriculumScalarFieldEnum {
  CommonUserId = 'commonUserId',
  CourseId = 'courseId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  TeamId = 'teamId'
}

export type ReusableFormDataCurriculumScalarWhereInput = {
  AND?: InputMaybe<Array<ReusableFormDataCurriculumScalarWhereInput>>;
  NOT?: InputMaybe<Array<ReusableFormDataCurriculumScalarWhereInput>>;
  OR?: InputMaybe<Array<ReusableFormDataCurriculumScalarWhereInput>>;
  commonUserId?: InputMaybe<IntFilter>;
  courseId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<IntFilter>;
};

export type ReusableFormDataCurriculumScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ReusableFormDataCurriculumScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ReusableFormDataCurriculumScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ReusableFormDataCurriculumScalarWhereWithAggregatesInput>>;
  commonUserId?: InputMaybe<IntWithAggregatesFilter>;
  courseId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  teamId?: InputMaybe<IntWithAggregatesFilter>;
};

export type ReusableFormDataCurriculumSumOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  courseId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type ReusableFormDataCurriculumUpdateInput = {
  Course?: InputMaybe<ReusableFormDataUpdateOneRequiredWithoutReusableFormDataCurriculumNestedInput>;
  DisciplineLinks?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkUpdateManyWithoutCurriculumNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutReusableFormDataCurriculumNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutReusableFormDataCurriculumListNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ReusableFormDataCurriculumUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ReusableFormDataCurriculumUpdateManyWithWhereWithoutCourseInput = {
  data: ReusableFormDataCurriculumUpdateManyMutationInput;
  where: ReusableFormDataCurriculumScalarWhereInput;
};

export type ReusableFormDataCurriculumUpdateManyWithWhereWithoutTeamInput = {
  data: ReusableFormDataCurriculumUpdateManyMutationInput;
  where: ReusableFormDataCurriculumScalarWhereInput;
};

export type ReusableFormDataCurriculumUpdateManyWithWhereWithoutUserOwnerInput = {
  data: ReusableFormDataCurriculumUpdateManyMutationInput;
  where: ReusableFormDataCurriculumScalarWhereInput;
};

export type ReusableFormDataCurriculumUpdateManyWithoutCourseNestedInput = {
  connect?: InputMaybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReusableFormDataCurriculumCreateOrConnectWithoutCourseInput>>;
  create?: InputMaybe<Array<ReusableFormDataCurriculumCreateWithoutCourseInput>>;
  createMany?: InputMaybe<ReusableFormDataCurriculumCreateManyCourseInputEnvelope>;
  delete?: InputMaybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ReusableFormDataCurriculumScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  set?: InputMaybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  update?: InputMaybe<Array<ReusableFormDataCurriculumUpdateWithWhereUniqueWithoutCourseInput>>;
  updateMany?: InputMaybe<Array<ReusableFormDataCurriculumUpdateManyWithWhereWithoutCourseInput>>;
  upsert?: InputMaybe<Array<ReusableFormDataCurriculumUpsertWithWhereUniqueWithoutCourseInput>>;
};

export type ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput = {
  connect?: InputMaybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReusableFormDataCurriculumCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<ReusableFormDataCurriculumCreateWithoutTeamInput>>;
  createMany?: InputMaybe<ReusableFormDataCurriculumCreateManyTeamInputEnvelope>;
  delete?: InputMaybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ReusableFormDataCurriculumScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  set?: InputMaybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  update?: InputMaybe<Array<ReusableFormDataCurriculumUpdateWithWhereUniqueWithoutTeamInput>>;
  updateMany?: InputMaybe<Array<ReusableFormDataCurriculumUpdateManyWithWhereWithoutTeamInput>>;
  upsert?: InputMaybe<Array<ReusableFormDataCurriculumUpsertWithWhereUniqueWithoutTeamInput>>;
};

export type ReusableFormDataCurriculumUpdateManyWithoutUserOwnerNestedInput = {
  connect?: InputMaybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReusableFormDataCurriculumCreateOrConnectWithoutUserOwnerInput>>;
  create?: InputMaybe<Array<ReusableFormDataCurriculumCreateWithoutUserOwnerInput>>;
  createMany?: InputMaybe<ReusableFormDataCurriculumCreateManyUserOwnerInputEnvelope>;
  delete?: InputMaybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ReusableFormDataCurriculumScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  set?: InputMaybe<Array<ReusableFormDataCurriculumWhereUniqueInput>>;
  update?: InputMaybe<Array<ReusableFormDataCurriculumUpdateWithWhereUniqueWithoutUserOwnerInput>>;
  updateMany?: InputMaybe<Array<ReusableFormDataCurriculumUpdateManyWithWhereWithoutUserOwnerInput>>;
  upsert?: InputMaybe<Array<ReusableFormDataCurriculumUpsertWithWhereUniqueWithoutUserOwnerInput>>;
};

export type ReusableFormDataCurriculumUpdateOneRequiredWithoutDisciplineLinksNestedInput = {
  connect?: InputMaybe<ReusableFormDataCurriculumWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ReusableFormDataCurriculumCreateOrConnectWithoutDisciplineLinksInput>;
  create?: InputMaybe<ReusableFormDataCurriculumCreateWithoutDisciplineLinksInput>;
  update?: InputMaybe<ReusableFormDataCurriculumUpdateToOneWithWhereWithoutDisciplineLinksInput>;
  upsert?: InputMaybe<ReusableFormDataCurriculumUpsertWithoutDisciplineLinksInput>;
};

export type ReusableFormDataCurriculumUpdateToOneWithWhereWithoutDisciplineLinksInput = {
  data: ReusableFormDataCurriculumUpdateWithoutDisciplineLinksInput;
  where?: InputMaybe<ReusableFormDataCurriculumWhereInput>;
};

export type ReusableFormDataCurriculumUpdateWithWhereUniqueWithoutCourseInput = {
  data: ReusableFormDataCurriculumUpdateWithoutCourseInput;
  where: ReusableFormDataCurriculumWhereUniqueInput;
};

export type ReusableFormDataCurriculumUpdateWithWhereUniqueWithoutTeamInput = {
  data: ReusableFormDataCurriculumUpdateWithoutTeamInput;
  where: ReusableFormDataCurriculumWhereUniqueInput;
};

export type ReusableFormDataCurriculumUpdateWithWhereUniqueWithoutUserOwnerInput = {
  data: ReusableFormDataCurriculumUpdateWithoutUserOwnerInput;
  where: ReusableFormDataCurriculumWhereUniqueInput;
};

export type ReusableFormDataCurriculumUpdateWithoutCourseInput = {
  DisciplineLinks?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkUpdateManyWithoutCurriculumNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutReusableFormDataCurriculumNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutReusableFormDataCurriculumListNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ReusableFormDataCurriculumUpdateWithoutDisciplineLinksInput = {
  Course?: InputMaybe<ReusableFormDataUpdateOneRequiredWithoutReusableFormDataCurriculumNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutReusableFormDataCurriculumNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutReusableFormDataCurriculumListNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ReusableFormDataCurriculumUpdateWithoutTeamInput = {
  Course?: InputMaybe<ReusableFormDataUpdateOneRequiredWithoutReusableFormDataCurriculumNestedInput>;
  DisciplineLinks?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkUpdateManyWithoutCurriculumNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutReusableFormDataCurriculumListNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ReusableFormDataCurriculumUpdateWithoutUserOwnerInput = {
  Course?: InputMaybe<ReusableFormDataUpdateOneRequiredWithoutReusableFormDataCurriculumNestedInput>;
  DisciplineLinks?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkUpdateManyWithoutCurriculumNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutReusableFormDataCurriculumNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ReusableFormDataCurriculumUpsertWithWhereUniqueWithoutCourseInput = {
  create: ReusableFormDataCurriculumCreateWithoutCourseInput;
  update: ReusableFormDataCurriculumUpdateWithoutCourseInput;
  where: ReusableFormDataCurriculumWhereUniqueInput;
};

export type ReusableFormDataCurriculumUpsertWithWhereUniqueWithoutTeamInput = {
  create: ReusableFormDataCurriculumCreateWithoutTeamInput;
  update: ReusableFormDataCurriculumUpdateWithoutTeamInput;
  where: ReusableFormDataCurriculumWhereUniqueInput;
};

export type ReusableFormDataCurriculumUpsertWithWhereUniqueWithoutUserOwnerInput = {
  create: ReusableFormDataCurriculumCreateWithoutUserOwnerInput;
  update: ReusableFormDataCurriculumUpdateWithoutUserOwnerInput;
  where: ReusableFormDataCurriculumWhereUniqueInput;
};

export type ReusableFormDataCurriculumUpsertWithoutDisciplineLinksInput = {
  create: ReusableFormDataCurriculumCreateWithoutDisciplineLinksInput;
  update: ReusableFormDataCurriculumUpdateWithoutDisciplineLinksInput;
  where?: InputMaybe<ReusableFormDataCurriculumWhereInput>;
};

export type ReusableFormDataCurriculumWhereInput = {
  AND?: InputMaybe<Array<ReusableFormDataCurriculumWhereInput>>;
  Course?: InputMaybe<ReusableFormDataWhereInput>;
  DisciplineLinks?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkListRelationFilter>;
  NOT?: InputMaybe<Array<ReusableFormDataCurriculumWhereInput>>;
  OR?: InputMaybe<Array<ReusableFormDataCurriculumWhereInput>>;
  Team?: InputMaybe<TeamWhereInput>;
  UserOwner?: InputMaybe<CommonUserWhereInput>;
  commonUserId?: InputMaybe<IntFilter>;
  courseId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<IntFilter>;
};

export type ReusableFormDataCurriculumWhereUniqueInput = {
  AND?: InputMaybe<Array<ReusableFormDataCurriculumWhereInput>>;
  Course?: InputMaybe<ReusableFormDataWhereInput>;
  DisciplineLinks?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkListRelationFilter>;
  NOT?: InputMaybe<Array<ReusableFormDataCurriculumWhereInput>>;
  OR?: InputMaybe<Array<ReusableFormDataCurriculumWhereInput>>;
  Team?: InputMaybe<TeamWhereInput>;
  UserOwner?: InputMaybe<CommonUserWhereInput>;
  commonUserId?: InputMaybe<IntFilter>;
  courseId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<IntFilter>;
};

export type ReusableFormDataListRelationFilter = {
  every?: InputMaybe<ReusableFormDataWhereInput>;
  none?: InputMaybe<ReusableFormDataWhereInput>;
  some?: InputMaybe<ReusableFormDataWhereInput>;
};

export type ReusableFormDataMaxOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type ReusableFormDataMinOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type ReusableFormDataOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ReusableFormDataOrderByWithAggregationInput = {
  _avg?: InputMaybe<ReusableFormDataAvgOrderByAggregateInput>;
  _count?: InputMaybe<ReusableFormDataCountOrderByAggregateInput>;
  _max?: InputMaybe<ReusableFormDataMaxOrderByAggregateInput>;
  _min?: InputMaybe<ReusableFormDataMinOrderByAggregateInput>;
  _sum?: InputMaybe<ReusableFormDataSumOrderByAggregateInput>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type ReusableFormDataOrderByWithRelationInput = {
  DisciplineLinks?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkOrderByRelationAggregateInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumOrderByRelationAggregateInput>;
  Team?: InputMaybe<TeamOrderByWithRelationInput>;
  UserOwner?: InputMaybe<CommonUserOrderByWithRelationInput>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type ReusableFormDataRelationFilter = {
  is?: InputMaybe<ReusableFormDataWhereInput>;
  isNot?: InputMaybe<ReusableFormDataWhereInput>;
};

export enum ReusableFormDataScalarFieldEnum {
  CommonUserId = 'commonUserId',
  CreatedAt = 'createdAt',
  Data = 'data',
  Id = 'id',
  TeamId = 'teamId',
  Type = 'type'
}

export type ReusableFormDataScalarWhereInput = {
  AND?: InputMaybe<Array<ReusableFormDataScalarWhereInput>>;
  NOT?: InputMaybe<Array<ReusableFormDataScalarWhereInput>>;
  OR?: InputMaybe<Array<ReusableFormDataScalarWhereInput>>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<IntFilter>;
  teamId?: InputMaybe<IntFilter>;
  type?: InputMaybe<StringFilter>;
};

export type ReusableFormDataScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ReusableFormDataScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ReusableFormDataScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ReusableFormDataScalarWhereWithAggregatesInput>>;
  commonUserId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  data?: InputMaybe<JsonWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  teamId?: InputMaybe<IntWithAggregatesFilter>;
  type?: InputMaybe<StringWithAggregatesFilter>;
};

export type ReusableFormDataSumOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type ReusableFormDataUpdateInput = {
  DisciplineLinks?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkUpdateManyWithoutDisciplineNestedInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutCourseNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutReusableFormDataNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutReusableFormDatasNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ReusableFormDataUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ReusableFormDataUpdateManyWithWhereWithoutTeamInput = {
  data: ReusableFormDataUpdateManyMutationInput;
  where: ReusableFormDataScalarWhereInput;
};

export type ReusableFormDataUpdateManyWithWhereWithoutUserOwnerInput = {
  data: ReusableFormDataUpdateManyMutationInput;
  where: ReusableFormDataScalarWhereInput;
};

export type ReusableFormDataUpdateManyWithoutTeamNestedInput = {
  connect?: InputMaybe<Array<ReusableFormDataWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReusableFormDataCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<ReusableFormDataCreateWithoutTeamInput>>;
  createMany?: InputMaybe<ReusableFormDataCreateManyTeamInputEnvelope>;
  delete?: InputMaybe<Array<ReusableFormDataWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ReusableFormDataScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ReusableFormDataWhereUniqueInput>>;
  set?: InputMaybe<Array<ReusableFormDataWhereUniqueInput>>;
  update?: InputMaybe<Array<ReusableFormDataUpdateWithWhereUniqueWithoutTeamInput>>;
  updateMany?: InputMaybe<Array<ReusableFormDataUpdateManyWithWhereWithoutTeamInput>>;
  upsert?: InputMaybe<Array<ReusableFormDataUpsertWithWhereUniqueWithoutTeamInput>>;
};

export type ReusableFormDataUpdateManyWithoutUserOwnerNestedInput = {
  connect?: InputMaybe<Array<ReusableFormDataWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReusableFormDataCreateOrConnectWithoutUserOwnerInput>>;
  create?: InputMaybe<Array<ReusableFormDataCreateWithoutUserOwnerInput>>;
  createMany?: InputMaybe<ReusableFormDataCreateManyUserOwnerInputEnvelope>;
  delete?: InputMaybe<Array<ReusableFormDataWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ReusableFormDataScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ReusableFormDataWhereUniqueInput>>;
  set?: InputMaybe<Array<ReusableFormDataWhereUniqueInput>>;
  update?: InputMaybe<Array<ReusableFormDataUpdateWithWhereUniqueWithoutUserOwnerInput>>;
  updateMany?: InputMaybe<Array<ReusableFormDataUpdateManyWithWhereWithoutUserOwnerInput>>;
  upsert?: InputMaybe<Array<ReusableFormDataUpsertWithWhereUniqueWithoutUserOwnerInput>>;
};

export type ReusableFormDataUpdateOneRequiredWithoutDisciplineLinksNestedInput = {
  connect?: InputMaybe<ReusableFormDataWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ReusableFormDataCreateOrConnectWithoutDisciplineLinksInput>;
  create?: InputMaybe<ReusableFormDataCreateWithoutDisciplineLinksInput>;
  update?: InputMaybe<ReusableFormDataUpdateToOneWithWhereWithoutDisciplineLinksInput>;
  upsert?: InputMaybe<ReusableFormDataUpsertWithoutDisciplineLinksInput>;
};

export type ReusableFormDataUpdateOneRequiredWithoutReusableFormDataCurriculumNestedInput = {
  connect?: InputMaybe<ReusableFormDataWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ReusableFormDataCreateOrConnectWithoutReusableFormDataCurriculumInput>;
  create?: InputMaybe<ReusableFormDataCreateWithoutReusableFormDataCurriculumInput>;
  update?: InputMaybe<ReusableFormDataUpdateToOneWithWhereWithoutReusableFormDataCurriculumInput>;
  upsert?: InputMaybe<ReusableFormDataUpsertWithoutReusableFormDataCurriculumInput>;
};

export type ReusableFormDataUpdateToOneWithWhereWithoutDisciplineLinksInput = {
  data: ReusableFormDataUpdateWithoutDisciplineLinksInput;
  where?: InputMaybe<ReusableFormDataWhereInput>;
};

export type ReusableFormDataUpdateToOneWithWhereWithoutReusableFormDataCurriculumInput = {
  data: ReusableFormDataUpdateWithoutReusableFormDataCurriculumInput;
  where?: InputMaybe<ReusableFormDataWhereInput>;
};

export type ReusableFormDataUpdateWithWhereUniqueWithoutTeamInput = {
  data: ReusableFormDataUpdateWithoutTeamInput;
  where: ReusableFormDataWhereUniqueInput;
};

export type ReusableFormDataUpdateWithWhereUniqueWithoutUserOwnerInput = {
  data: ReusableFormDataUpdateWithoutUserOwnerInput;
  where: ReusableFormDataWhereUniqueInput;
};

export type ReusableFormDataUpdateWithoutDisciplineLinksInput = {
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutCourseNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutReusableFormDataNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutReusableFormDatasNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ReusableFormDataUpdateWithoutReusableFormDataCurriculumInput = {
  DisciplineLinks?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkUpdateManyWithoutDisciplineNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutReusableFormDataNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutReusableFormDatasNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ReusableFormDataUpdateWithoutTeamInput = {
  DisciplineLinks?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkUpdateManyWithoutDisciplineNestedInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutCourseNestedInput>;
  UserOwner?: InputMaybe<CommonUserUpdateOneRequiredWithoutReusableFormDatasNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ReusableFormDataUpdateWithoutUserOwnerInput = {
  DisciplineLinks?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkUpdateManyWithoutDisciplineNestedInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutCourseNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutReusableFormDataNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ReusableFormDataUpsertWithWhereUniqueWithoutTeamInput = {
  create: ReusableFormDataCreateWithoutTeamInput;
  update: ReusableFormDataUpdateWithoutTeamInput;
  where: ReusableFormDataWhereUniqueInput;
};

export type ReusableFormDataUpsertWithWhereUniqueWithoutUserOwnerInput = {
  create: ReusableFormDataCreateWithoutUserOwnerInput;
  update: ReusableFormDataUpdateWithoutUserOwnerInput;
  where: ReusableFormDataWhereUniqueInput;
};

export type ReusableFormDataUpsertWithoutDisciplineLinksInput = {
  create: ReusableFormDataCreateWithoutDisciplineLinksInput;
  update: ReusableFormDataUpdateWithoutDisciplineLinksInput;
  where?: InputMaybe<ReusableFormDataWhereInput>;
};

export type ReusableFormDataUpsertWithoutReusableFormDataCurriculumInput = {
  create: ReusableFormDataCreateWithoutReusableFormDataCurriculumInput;
  update: ReusableFormDataUpdateWithoutReusableFormDataCurriculumInput;
  where?: InputMaybe<ReusableFormDataWhereInput>;
};

export type ReusableFormDataWhereInput = {
  AND?: InputMaybe<Array<ReusableFormDataWhereInput>>;
  DisciplineLinks?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkListRelationFilter>;
  NOT?: InputMaybe<Array<ReusableFormDataWhereInput>>;
  OR?: InputMaybe<Array<ReusableFormDataWhereInput>>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumListRelationFilter>;
  Team?: InputMaybe<TeamWhereInput>;
  UserOwner?: InputMaybe<CommonUserWhereInput>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<IntFilter>;
  teamId?: InputMaybe<IntFilter>;
  type?: InputMaybe<StringFilter>;
};

export type ReusableFormDataWhereInputCustom = {
  AND?: InputMaybe<Array<ReusableFormDataWhereInput>>;
  DisciplineLinks?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkListRelationFilter>;
  NOT?: InputMaybe<Array<ReusableFormDataWhereInput>>;
  OR?: InputMaybe<Array<ReusableFormDataWhereInput>>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumListRelationFilter>;
  Team?: InputMaybe<TeamWhereInput>;
  UserOwner?: InputMaybe<CommonUserWhereInput>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  fuzzySearch?: InputMaybe<FuzzySearch>;
  id?: InputMaybe<IntFilter>;
  teamId?: InputMaybe<IntFilter>;
  type?: InputMaybe<StringFilter>;
};

export type ReusableFormDataWhereUniqueInput = {
  AND?: InputMaybe<Array<ReusableFormDataWhereInput>>;
  DisciplineLinks?: InputMaybe<ReusableFormDataCurriculumDisciplineLinkListRelationFilter>;
  NOT?: InputMaybe<Array<ReusableFormDataWhereInput>>;
  OR?: InputMaybe<Array<ReusableFormDataWhereInput>>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumListRelationFilter>;
  Team?: InputMaybe<TeamWhereInput>;
  UserOwner?: InputMaybe<CommonUserWhereInput>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  teamId?: InputMaybe<IntFilter>;
  type?: InputMaybe<StringFilter>;
};

export type SaveOneCommonUserConfigInputData = {
  key: CommonUserConfigKeys;
  value: Scalars['Json']['input'];
};

/** Servuço e seu preço */
export type ServicePrice = {
  __typename?: 'ServicePrice';
  id: Scalars['String']['output'];
  service: FinancialChargeableService;
  unitPrice: Scalars['Float']['output'];
};

export type SignSignatureImage = {
  __typename?: 'SignSignatureImage';
  UserCreated: CommonUser;
  UserUsingAsPrimary?: Maybe<CommonUser>;
  base64Image: Scalars['String']['output'];
  commonUserId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  percentageBelowTheLine: Scalars['Float']['output'];
};

export type SignSignatureImageAvgOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  percentageBelowTheLine?: InputMaybe<SortOrder>;
};

export type SignSignatureImageCountOrderByAggregateInput = {
  base64Image?: InputMaybe<SortOrder>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  percentageBelowTheLine?: InputMaybe<SortOrder>;
};

export type SignSignatureImageCreateInput = {
  UserCreated: CommonUserCreateNestedOneWithoutCreatedSignatureImagesInput;
  UserUsingAsPrimary?: InputMaybe<CommonUserCreateNestedOneWithoutDefaultImageInput>;
  base64Image: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  percentageBelowTheLine?: InputMaybe<Scalars['Float']['input']>;
};

export type SignSignatureImageCreateManyInput = {
  base64Image: Scalars['String']['input'];
  commonUserId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  percentageBelowTheLine?: InputMaybe<Scalars['Float']['input']>;
};

export type SignSignatureImageCreateManyUserCreatedInput = {
  base64Image: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  percentageBelowTheLine?: InputMaybe<Scalars['Float']['input']>;
};

export type SignSignatureImageCreateManyUserCreatedInputEnvelope = {
  data: Array<SignSignatureImageCreateManyUserCreatedInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SignSignatureImageCreateNestedManyWithoutUserCreatedInput = {
  connect?: InputMaybe<Array<SignSignatureImageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SignSignatureImageCreateOrConnectWithoutUserCreatedInput>>;
  create?: InputMaybe<Array<SignSignatureImageCreateWithoutUserCreatedInput>>;
  createMany?: InputMaybe<SignSignatureImageCreateManyUserCreatedInputEnvelope>;
};

export type SignSignatureImageCreateNestedOneWithoutUserUsingAsPrimaryInput = {
  connect?: InputMaybe<SignSignatureImageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SignSignatureImageCreateOrConnectWithoutUserUsingAsPrimaryInput>;
  create?: InputMaybe<SignSignatureImageCreateWithoutUserUsingAsPrimaryInput>;
};

export type SignSignatureImageCreateOrConnectWithoutUserCreatedInput = {
  create: SignSignatureImageCreateWithoutUserCreatedInput;
  where: SignSignatureImageWhereUniqueInput;
};

export type SignSignatureImageCreateOrConnectWithoutUserUsingAsPrimaryInput = {
  create: SignSignatureImageCreateWithoutUserUsingAsPrimaryInput;
  where: SignSignatureImageWhereUniqueInput;
};

export type SignSignatureImageCreateWithoutUserCreatedInput = {
  UserUsingAsPrimary?: InputMaybe<CommonUserCreateNestedOneWithoutDefaultImageInput>;
  base64Image: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  percentageBelowTheLine?: InputMaybe<Scalars['Float']['input']>;
};

export type SignSignatureImageCreateWithoutUserUsingAsPrimaryInput = {
  UserCreated: CommonUserCreateNestedOneWithoutCreatedSignatureImagesInput;
  base64Image: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  percentageBelowTheLine?: InputMaybe<Scalars['Float']['input']>;
};

export type SignSignatureImageListRelationFilter = {
  every?: InputMaybe<SignSignatureImageWhereInput>;
  none?: InputMaybe<SignSignatureImageWhereInput>;
  some?: InputMaybe<SignSignatureImageWhereInput>;
};

export type SignSignatureImageMaxOrderByAggregateInput = {
  base64Image?: InputMaybe<SortOrder>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  percentageBelowTheLine?: InputMaybe<SortOrder>;
};

export type SignSignatureImageMinOrderByAggregateInput = {
  base64Image?: InputMaybe<SortOrder>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  percentageBelowTheLine?: InputMaybe<SortOrder>;
};

export type SignSignatureImageNullableRelationFilter = {
  is?: InputMaybe<SignSignatureImageWhereInput>;
  isNot?: InputMaybe<SignSignatureImageWhereInput>;
};

export type SignSignatureImageOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SignSignatureImageOrderByWithAggregationInput = {
  _avg?: InputMaybe<SignSignatureImageAvgOrderByAggregateInput>;
  _count?: InputMaybe<SignSignatureImageCountOrderByAggregateInput>;
  _max?: InputMaybe<SignSignatureImageMaxOrderByAggregateInput>;
  _min?: InputMaybe<SignSignatureImageMinOrderByAggregateInput>;
  _sum?: InputMaybe<SignSignatureImageSumOrderByAggregateInput>;
  base64Image?: InputMaybe<SortOrder>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  percentageBelowTheLine?: InputMaybe<SortOrder>;
};

export type SignSignatureImageOrderByWithRelationInput = {
  UserCreated?: InputMaybe<CommonUserOrderByWithRelationInput>;
  UserUsingAsPrimary?: InputMaybe<CommonUserOrderByWithRelationInput>;
  base64Image?: InputMaybe<SortOrder>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  percentageBelowTheLine?: InputMaybe<SortOrder>;
};

export enum SignSignatureImageScalarFieldEnum {
  Base64Image = 'base64Image',
  CommonUserId = 'commonUserId',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  PercentageBelowTheLine = 'percentageBelowTheLine'
}

export type SignSignatureImageScalarWhereInput = {
  AND?: InputMaybe<Array<SignSignatureImageScalarWhereInput>>;
  NOT?: InputMaybe<Array<SignSignatureImageScalarWhereInput>>;
  OR?: InputMaybe<Array<SignSignatureImageScalarWhereInput>>;
  base64Image?: InputMaybe<StringFilter>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  percentageBelowTheLine?: InputMaybe<FloatFilter>;
};

export type SignSignatureImageScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<SignSignatureImageScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<SignSignatureImageScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<SignSignatureImageScalarWhereWithAggregatesInput>>;
  base64Image?: InputMaybe<StringWithAggregatesFilter>;
  commonUserId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  percentageBelowTheLine?: InputMaybe<FloatWithAggregatesFilter>;
};

export type SignSignatureImageSumOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  percentageBelowTheLine?: InputMaybe<SortOrder>;
};

export type SignSignatureImageUpdateInput = {
  UserCreated?: InputMaybe<CommonUserUpdateOneRequiredWithoutCreatedSignatureImagesNestedInput>;
  UserUsingAsPrimary?: InputMaybe<CommonUserUpdateOneWithoutDefaultImageNestedInput>;
  base64Image?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  percentageBelowTheLine?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type SignSignatureImageUpdateManyMutationInput = {
  base64Image?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  percentageBelowTheLine?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type SignSignatureImageUpdateManyWithWhereWithoutUserCreatedInput = {
  data: SignSignatureImageUpdateManyMutationInput;
  where: SignSignatureImageScalarWhereInput;
};

export type SignSignatureImageUpdateManyWithoutUserCreatedNestedInput = {
  connect?: InputMaybe<Array<SignSignatureImageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SignSignatureImageCreateOrConnectWithoutUserCreatedInput>>;
  create?: InputMaybe<Array<SignSignatureImageCreateWithoutUserCreatedInput>>;
  createMany?: InputMaybe<SignSignatureImageCreateManyUserCreatedInputEnvelope>;
  delete?: InputMaybe<Array<SignSignatureImageWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SignSignatureImageScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SignSignatureImageWhereUniqueInput>>;
  set?: InputMaybe<Array<SignSignatureImageWhereUniqueInput>>;
  update?: InputMaybe<Array<SignSignatureImageUpdateWithWhereUniqueWithoutUserCreatedInput>>;
  updateMany?: InputMaybe<Array<SignSignatureImageUpdateManyWithWhereWithoutUserCreatedInput>>;
  upsert?: InputMaybe<Array<SignSignatureImageUpsertWithWhereUniqueWithoutUserCreatedInput>>;
};

export type SignSignatureImageUpdateOneWithoutUserUsingAsPrimaryNestedInput = {
  connect?: InputMaybe<SignSignatureImageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SignSignatureImageCreateOrConnectWithoutUserUsingAsPrimaryInput>;
  create?: InputMaybe<SignSignatureImageCreateWithoutUserUsingAsPrimaryInput>;
  delete?: InputMaybe<SignSignatureImageWhereInput>;
  disconnect?: InputMaybe<SignSignatureImageWhereInput>;
  update?: InputMaybe<SignSignatureImageUpdateToOneWithWhereWithoutUserUsingAsPrimaryInput>;
  upsert?: InputMaybe<SignSignatureImageUpsertWithoutUserUsingAsPrimaryInput>;
};

export type SignSignatureImageUpdateToOneWithWhereWithoutUserUsingAsPrimaryInput = {
  data: SignSignatureImageUpdateWithoutUserUsingAsPrimaryInput;
  where?: InputMaybe<SignSignatureImageWhereInput>;
};

export type SignSignatureImageUpdateWithWhereUniqueWithoutUserCreatedInput = {
  data: SignSignatureImageUpdateWithoutUserCreatedInput;
  where: SignSignatureImageWhereUniqueInput;
};

export type SignSignatureImageUpdateWithoutUserCreatedInput = {
  UserUsingAsPrimary?: InputMaybe<CommonUserUpdateOneWithoutDefaultImageNestedInput>;
  base64Image?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  percentageBelowTheLine?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type SignSignatureImageUpdateWithoutUserUsingAsPrimaryInput = {
  UserCreated?: InputMaybe<CommonUserUpdateOneRequiredWithoutCreatedSignatureImagesNestedInput>;
  base64Image?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  percentageBelowTheLine?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type SignSignatureImageUpsertWithWhereUniqueWithoutUserCreatedInput = {
  create: SignSignatureImageCreateWithoutUserCreatedInput;
  update: SignSignatureImageUpdateWithoutUserCreatedInput;
  where: SignSignatureImageWhereUniqueInput;
};

export type SignSignatureImageUpsertWithoutUserUsingAsPrimaryInput = {
  create: SignSignatureImageCreateWithoutUserUsingAsPrimaryInput;
  update: SignSignatureImageUpdateWithoutUserUsingAsPrimaryInput;
  where?: InputMaybe<SignSignatureImageWhereInput>;
};

export type SignSignatureImageWhereInput = {
  AND?: InputMaybe<Array<SignSignatureImageWhereInput>>;
  NOT?: InputMaybe<Array<SignSignatureImageWhereInput>>;
  OR?: InputMaybe<Array<SignSignatureImageWhereInput>>;
  UserCreated?: InputMaybe<CommonUserWhereInput>;
  UserUsingAsPrimary?: InputMaybe<CommonUserWhereInput>;
  base64Image?: InputMaybe<StringFilter>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  percentageBelowTheLine?: InputMaybe<FloatFilter>;
};

export type SignSignatureImageWhereUniqueInput = {
  AND?: InputMaybe<Array<SignSignatureImageWhereInput>>;
  NOT?: InputMaybe<Array<SignSignatureImageWhereInput>>;
  OR?: InputMaybe<Array<SignSignatureImageWhereInput>>;
  UserCreated?: InputMaybe<CommonUserWhereInput>;
  UserUsingAsPrimary?: InputMaybe<CommonUserWhereInput>;
  base64Image?: InputMaybe<StringFilter>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  percentageBelowTheLine?: InputMaybe<FloatFilter>;
};

export type SignableInviteItemsAndCount = {
  __typename?: 'SignableInviteItemsAndCount';
  count: Scalars['Int']['output'];
  items: Array<DocumentBaseSignatureInvite>;
};

export enum SignatureType {
  Cnpj = 'CNPJ',
  Cpf_0OrMore = 'CPF_0_OR_MORE',
  Cpf_1OrMore = 'CPF_1_OR_MORE'
}

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type StartSignature = {
  __typename?: 'StartSignature';
  dataToSign: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastSignatureIsoString: Scalars['String']['output'];
  signingTime: Scalars['String']['output'];
};

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['String']['input']>>;
  has?: InputMaybe<Scalars['String']['input']>;
  hasEvery?: InputMaybe<Array<Scalars['String']['input']>>;
  hasSome?: InputMaybe<Array<Scalars['String']['input']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export enum SubService {
  Certificates = 'CERTIFICATES',
  UnderGraduateAndPostGraduate = 'UNDER_GRADUATE_AND_POST_GRADUATE'
}

export type Subscription = {
  __typename?: 'Subscription';
  findFirstDocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentation>;
  findUniqueDocumentAcademicDocumentation?: Maybe<DocumentAcademicDocumentation>;
  findUniqueSignSignatureImage?: Maybe<SignSignatureImage>;
  /** Notificar quando um novo certificado for gerado. */
  generatedCertificate: GeneratedCertificateData;
  /** Notificar usuário em caso de mudança num template */
  watchCertificateTemplateData: WatchCertificateTemplateData;
  /** Notificações do usuário */
  watchDocumentFocus: Array<WatchDocumentFocus>;
  /** Notificações do usuário */
  watchDocumentPatches: WatchDocumentPatch;
  /** Notificações do usuário */
  watchDocumentStatus: Scalars['String']['output'];
  /** Créditos do time */
  watchFinancialTeamWallet: FinancialTeamWallet;
  /** Notificar quando um novo certificado for assinado. */
  watchSignBulkCertificate: WatchSignBulkCertificate;
  /** Enviar uma notificação quando uma assinatura do certificado em lote for validada. */
  watchSignValidationBulkCertificate: WatchSignValidationBulkCertificate;
  /** Enviar uma notificação quando uma assinatura de um certificado for validada. */
  watchSingleCertificateSignValidationEvent: WatchSingleCertificateSignValidationEvent;
  /** Créditos do time */
  watchTeamSpaceUsage?: Maybe<Team>;
};


export type SubscriptionFindFirstDocumentAcademicDocumentationArgs = {
  cursor?: InputMaybe<DocumentAcademicDocumentationWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentAcademicDocumentationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentAcademicDocumentationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
};


export type SubscriptionFindUniqueDocumentAcademicDocumentationArgs = {
  where: DocumentAcademicDocumentationWhereUniqueInput;
};


export type SubscriptionFindUniqueSignSignatureImageArgs = {
  where: SignSignatureImageWhereUniqueInput;
};


export type SubscriptionGeneratedCertificateArgs = {
  bulkCertificateRecordId: Scalars['String']['input'];
  institutionId: Scalars['Int']['input'];
};


export type SubscriptionWatchCertificateTemplateDataArgs = {
  teamId: Scalars['Int']['input'];
  templateId: Scalars['String']['input'];
};


export type SubscriptionWatchDocumentFocusArgs = {
  documentId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};


export type SubscriptionWatchDocumentPatchesArgs = {
  documentId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};


export type SubscriptionWatchDocumentStatusArgs = {
  documentId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
};


export type SubscriptionWatchSignBulkCertificateArgs = {
  bulkId: Scalars['String']['input'];
};


export type SubscriptionWatchSignValidationBulkCertificateArgs = {
  bulkId: Scalars['String']['input'];
};


export type SubscriptionWatchSingleCertificateSignValidationEventArgs = {
  inviteId: Scalars['String']['input'];
};

export type SumCount = {
  __typename?: 'SumCount';
  count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  sum: Scalars['Float']['output'];
};

/** Responsável por guardar ações do sistema. Como deleção de itens... */
export type SystemAuditLog = {
  __typename?: 'SystemAuditLog';
  Team?: Maybe<Team>;
  User?: Maybe<CommonUser>;
  /**
   * https://docs.bemi.io/postgresql/destination-database Records values after the change. Used in create / update
   * ![PrismaJson.AnyJson]
   */
  after?: Maybe<Scalars['Json']['output']>;
  /** ![PrismaJson.AnyJson] */
  args?: Maybe<Scalars['Json']['output']>;
  commonUserId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** ![PrismaJson.AnyJson] */
  extraContext?: Maybe<Scalars['Json']['output']>;
  id: Scalars['String']['output'];
  moduleTranslated: Scalars['String']['output'];
  /** create, update, delete, deleteMany */
  operation: Scalars['String']['output'];
  operationTranslated: Scalars['String']['output'];
  primaryKey?: Maybe<Scalars['String']['output']>;
  /** CommonUser, ... */
  table: Scalars['String']['output'];
  teamId?: Maybe<Scalars['Int']['output']>;
  translatedAfter: Array<KeyValue>;
};

export type SystemAuditLogAvgOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type SystemAuditLogCountOrderByAggregateInput = {
  after?: InputMaybe<SortOrder>;
  args?: InputMaybe<SortOrder>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  extraContext?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  operation?: InputMaybe<SortOrder>;
  primaryKey?: InputMaybe<SortOrder>;
  table?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type SystemAuditLogCreateInput = {
  Team?: InputMaybe<TeamCreateNestedOneWithoutSystemAuditLogsInput>;
  User?: InputMaybe<CommonUserCreateNestedOneWithoutSystemAuditLogsInput>;
  after?: InputMaybe<Scalars['Json']['input']>;
  args?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  extraContext?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  operation: Scalars['String']['input'];
  primaryKey?: InputMaybe<Scalars['String']['input']>;
  table: Scalars['String']['input'];
};

export type SystemAuditLogCreateManyInput = {
  after?: InputMaybe<Scalars['Json']['input']>;
  args?: InputMaybe<Scalars['Json']['input']>;
  commonUserId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  extraContext?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  operation: Scalars['String']['input'];
  primaryKey?: InputMaybe<Scalars['String']['input']>;
  table: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type SystemAuditLogCreateManyTeamInput = {
  after?: InputMaybe<Scalars['Json']['input']>;
  args?: InputMaybe<Scalars['Json']['input']>;
  commonUserId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  extraContext?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  operation: Scalars['String']['input'];
  primaryKey?: InputMaybe<Scalars['String']['input']>;
  table: Scalars['String']['input'];
};

export type SystemAuditLogCreateManyTeamInputEnvelope = {
  data: Array<SystemAuditLogCreateManyTeamInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SystemAuditLogCreateManyUserInput = {
  after?: InputMaybe<Scalars['Json']['input']>;
  args?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  extraContext?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  operation: Scalars['String']['input'];
  primaryKey?: InputMaybe<Scalars['String']['input']>;
  table: Scalars['String']['input'];
  teamId?: InputMaybe<Scalars['Int']['input']>;
};

export type SystemAuditLogCreateManyUserInputEnvelope = {
  data: Array<SystemAuditLogCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SystemAuditLogCreateNestedManyWithoutTeamInput = {
  connect?: InputMaybe<Array<SystemAuditLogWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SystemAuditLogCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<SystemAuditLogCreateWithoutTeamInput>>;
  createMany?: InputMaybe<SystemAuditLogCreateManyTeamInputEnvelope>;
};

export type SystemAuditLogCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<SystemAuditLogWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SystemAuditLogCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<SystemAuditLogCreateWithoutUserInput>>;
  createMany?: InputMaybe<SystemAuditLogCreateManyUserInputEnvelope>;
};

export type SystemAuditLogCreateOrConnectWithoutTeamInput = {
  create: SystemAuditLogCreateWithoutTeamInput;
  where: SystemAuditLogWhereUniqueInput;
};

export type SystemAuditLogCreateOrConnectWithoutUserInput = {
  create: SystemAuditLogCreateWithoutUserInput;
  where: SystemAuditLogWhereUniqueInput;
};

export type SystemAuditLogCreateWithoutTeamInput = {
  User?: InputMaybe<CommonUserCreateNestedOneWithoutSystemAuditLogsInput>;
  after?: InputMaybe<Scalars['Json']['input']>;
  args?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  extraContext?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  operation: Scalars['String']['input'];
  primaryKey?: InputMaybe<Scalars['String']['input']>;
  table: Scalars['String']['input'];
};

export type SystemAuditLogCreateWithoutUserInput = {
  Team?: InputMaybe<TeamCreateNestedOneWithoutSystemAuditLogsInput>;
  after?: InputMaybe<Scalars['Json']['input']>;
  args?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  extraContext?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  operation: Scalars['String']['input'];
  primaryKey?: InputMaybe<Scalars['String']['input']>;
  table: Scalars['String']['input'];
};

export type SystemAuditLogListRelationFilter = {
  every?: InputMaybe<SystemAuditLogWhereInput>;
  none?: InputMaybe<SystemAuditLogWhereInput>;
  some?: InputMaybe<SystemAuditLogWhereInput>;
};

export type SystemAuditLogMaxOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  operation?: InputMaybe<SortOrder>;
  primaryKey?: InputMaybe<SortOrder>;
  table?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type SystemAuditLogMinOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  operation?: InputMaybe<SortOrder>;
  primaryKey?: InputMaybe<SortOrder>;
  table?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type SystemAuditLogOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SystemAuditLogOrderByWithAggregationInput = {
  _avg?: InputMaybe<SystemAuditLogAvgOrderByAggregateInput>;
  _count?: InputMaybe<SystemAuditLogCountOrderByAggregateInput>;
  _max?: InputMaybe<SystemAuditLogMaxOrderByAggregateInput>;
  _min?: InputMaybe<SystemAuditLogMinOrderByAggregateInput>;
  _sum?: InputMaybe<SystemAuditLogSumOrderByAggregateInput>;
  after?: InputMaybe<SortOrder>;
  args?: InputMaybe<SortOrder>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  extraContext?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  operation?: InputMaybe<SortOrder>;
  primaryKey?: InputMaybe<SortOrder>;
  table?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type SystemAuditLogOrderByWithRelationInput = {
  Team?: InputMaybe<TeamOrderByWithRelationInput>;
  User?: InputMaybe<CommonUserOrderByWithRelationInput>;
  after?: InputMaybe<SortOrder>;
  args?: InputMaybe<SortOrder>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  extraContext?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  operation?: InputMaybe<SortOrder>;
  primaryKey?: InputMaybe<SortOrder>;
  table?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export enum SystemAuditLogScalarFieldEnum {
  After = 'after',
  Args = 'args',
  CommonUserId = 'commonUserId',
  CreatedAt = 'createdAt',
  ExtraContext = 'extraContext',
  Id = 'id',
  Operation = 'operation',
  PrimaryKey = 'primaryKey',
  Table = 'table',
  TeamId = 'teamId'
}

export type SystemAuditLogScalarWhereInput = {
  AND?: InputMaybe<Array<SystemAuditLogScalarWhereInput>>;
  NOT?: InputMaybe<Array<SystemAuditLogScalarWhereInput>>;
  OR?: InputMaybe<Array<SystemAuditLogScalarWhereInput>>;
  after?: InputMaybe<JsonNullableFilter>;
  args?: InputMaybe<JsonNullableFilter>;
  commonUserId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  extraContext?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<StringFilter>;
  operation?: InputMaybe<StringFilter>;
  primaryKey?: InputMaybe<StringNullableFilter>;
  table?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<IntNullableFilter>;
};

export type SystemAuditLogScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<SystemAuditLogScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<SystemAuditLogScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<SystemAuditLogScalarWhereWithAggregatesInput>>;
  after?: InputMaybe<JsonNullableWithAggregatesFilter>;
  args?: InputMaybe<JsonNullableWithAggregatesFilter>;
  commonUserId?: InputMaybe<IntNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  extraContext?: InputMaybe<JsonNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  operation?: InputMaybe<StringWithAggregatesFilter>;
  primaryKey?: InputMaybe<StringNullableWithAggregatesFilter>;
  table?: InputMaybe<StringWithAggregatesFilter>;
  teamId?: InputMaybe<IntNullableWithAggregatesFilter>;
};

export type SystemAuditLogSumOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type SystemAuditLogUpdateInput = {
  Team?: InputMaybe<TeamUpdateOneWithoutSystemAuditLogsNestedInput>;
  User?: InputMaybe<CommonUserUpdateOneWithoutSystemAuditLogsNestedInput>;
  after?: InputMaybe<Scalars['Json']['input']>;
  args?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  extraContext?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  operation?: InputMaybe<StringFieldUpdateOperationsInput>;
  primaryKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  table?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SystemAuditLogUpdateManyMutationInput = {
  after?: InputMaybe<Scalars['Json']['input']>;
  args?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  extraContext?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  operation?: InputMaybe<StringFieldUpdateOperationsInput>;
  primaryKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  table?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SystemAuditLogUpdateManyWithWhereWithoutTeamInput = {
  data: SystemAuditLogUpdateManyMutationInput;
  where: SystemAuditLogScalarWhereInput;
};

export type SystemAuditLogUpdateManyWithWhereWithoutUserInput = {
  data: SystemAuditLogUpdateManyMutationInput;
  where: SystemAuditLogScalarWhereInput;
};

export type SystemAuditLogUpdateManyWithoutTeamNestedInput = {
  connect?: InputMaybe<Array<SystemAuditLogWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SystemAuditLogCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<SystemAuditLogCreateWithoutTeamInput>>;
  createMany?: InputMaybe<SystemAuditLogCreateManyTeamInputEnvelope>;
  delete?: InputMaybe<Array<SystemAuditLogWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SystemAuditLogScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SystemAuditLogWhereUniqueInput>>;
  set?: InputMaybe<Array<SystemAuditLogWhereUniqueInput>>;
  update?: InputMaybe<Array<SystemAuditLogUpdateWithWhereUniqueWithoutTeamInput>>;
  updateMany?: InputMaybe<Array<SystemAuditLogUpdateManyWithWhereWithoutTeamInput>>;
  upsert?: InputMaybe<Array<SystemAuditLogUpsertWithWhereUniqueWithoutTeamInput>>;
};

export type SystemAuditLogUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<SystemAuditLogWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SystemAuditLogCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<SystemAuditLogCreateWithoutUserInput>>;
  createMany?: InputMaybe<SystemAuditLogCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<SystemAuditLogWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SystemAuditLogScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SystemAuditLogWhereUniqueInput>>;
  set?: InputMaybe<Array<SystemAuditLogWhereUniqueInput>>;
  update?: InputMaybe<Array<SystemAuditLogUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<SystemAuditLogUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<SystemAuditLogUpsertWithWhereUniqueWithoutUserInput>>;
};

export type SystemAuditLogUpdateWithWhereUniqueWithoutTeamInput = {
  data: SystemAuditLogUpdateWithoutTeamInput;
  where: SystemAuditLogWhereUniqueInput;
};

export type SystemAuditLogUpdateWithWhereUniqueWithoutUserInput = {
  data: SystemAuditLogUpdateWithoutUserInput;
  where: SystemAuditLogWhereUniqueInput;
};

export type SystemAuditLogUpdateWithoutTeamInput = {
  User?: InputMaybe<CommonUserUpdateOneWithoutSystemAuditLogsNestedInput>;
  after?: InputMaybe<Scalars['Json']['input']>;
  args?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  extraContext?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  operation?: InputMaybe<StringFieldUpdateOperationsInput>;
  primaryKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  table?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SystemAuditLogUpdateWithoutUserInput = {
  Team?: InputMaybe<TeamUpdateOneWithoutSystemAuditLogsNestedInput>;
  after?: InputMaybe<Scalars['Json']['input']>;
  args?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  extraContext?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  operation?: InputMaybe<StringFieldUpdateOperationsInput>;
  primaryKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  table?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SystemAuditLogUpsertWithWhereUniqueWithoutTeamInput = {
  create: SystemAuditLogCreateWithoutTeamInput;
  update: SystemAuditLogUpdateWithoutTeamInput;
  where: SystemAuditLogWhereUniqueInput;
};

export type SystemAuditLogUpsertWithWhereUniqueWithoutUserInput = {
  create: SystemAuditLogCreateWithoutUserInput;
  update: SystemAuditLogUpdateWithoutUserInput;
  where: SystemAuditLogWhereUniqueInput;
};

export type SystemAuditLogWhereInput = {
  AND?: InputMaybe<Array<SystemAuditLogWhereInput>>;
  NOT?: InputMaybe<Array<SystemAuditLogWhereInput>>;
  OR?: InputMaybe<Array<SystemAuditLogWhereInput>>;
  Team?: InputMaybe<TeamWhereInput>;
  User?: InputMaybe<CommonUserWhereInput>;
  after?: InputMaybe<JsonNullableFilter>;
  args?: InputMaybe<JsonNullableFilter>;
  commonUserId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  extraContext?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<StringFilter>;
  operation?: InputMaybe<StringFilter>;
  primaryKey?: InputMaybe<StringNullableFilter>;
  table?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<IntNullableFilter>;
};

export type SystemAuditLogWhereUniqueInput = {
  AND?: InputMaybe<Array<SystemAuditLogWhereInput>>;
  NOT?: InputMaybe<Array<SystemAuditLogWhereInput>>;
  OR?: InputMaybe<Array<SystemAuditLogWhereInput>>;
  Team?: InputMaybe<TeamWhereInput>;
  User?: InputMaybe<CommonUserWhereInput>;
  after?: InputMaybe<JsonNullableFilter>;
  args?: InputMaybe<JsonNullableFilter>;
  commonUserId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  extraContext?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  operation?: InputMaybe<StringFilter>;
  primaryKey?: InputMaybe<StringNullableFilter>;
  table?: InputMaybe<StringFilter>;
  teamId?: InputMaybe<IntNullableFilter>;
};

/** Version of Sign Assistant, ... */
export type SystemGlobalAlert = {
  __typename?: 'SystemGlobalAlert';
  SystemGlobalAlertUserDismisses: Array<SystemGlobalAlertUserDismiss>;
  actionTitle?: Maybe<Scalars['String']['output']>;
  actionUrl?: Maybe<Scalars['String']['output']>;
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  dismissonsCount: Scalars['Int']['output'];
  forcedActionUrl?: Maybe<Scalars['String']['output']>;
  forcedDescription: Scalars['String']['output'];
  forcedTitle: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  myDismissonsCount: Scalars['Int']['output'];
  targetEducationLevels: Array<EducationLevelType>;
  /** SIGN_ASSISTANT_VERSION / Message */
  type: SystemGlobalAlertType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 1.1.3 / "Novidades no Portal da Emissora" / "Sistema indisponível" / Title */
  value: Scalars['String']['output'];
};


/** Version of Sign Assistant, ... */
export type SystemGlobalAlertSystemGlobalAlertUserDismissesArgs = {
  cursor?: InputMaybe<SystemGlobalAlertUserDismissWhereUniqueInput>;
  distinct?: InputMaybe<Array<SystemGlobalAlertUserDismissScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SystemGlobalAlertUserDismissOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SystemGlobalAlertUserDismissWhereInput>;
};

export type SystemGlobalAlertAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type SystemGlobalAlertCountOrderByAggregateInput = {
  actionTitle?: InputMaybe<SortOrder>;
  actionUrl?: InputMaybe<SortOrder>;
  active?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  targetEducationLevels?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type SystemGlobalAlertCreateInput = {
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissCreateNestedManyWithoutSystemGlobalAlertInput>;
  actionTitle?: InputMaybe<Scalars['String']['input']>;
  actionUrl?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  targetEducationLevels?: InputMaybe<Array<EducationLevelType>>;
  type?: InputMaybe<SystemGlobalAlertType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  value: Scalars['String']['input'];
};

export type SystemGlobalAlertCreateManyInput = {
  actionTitle?: InputMaybe<Scalars['String']['input']>;
  actionUrl?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  targetEducationLevels?: InputMaybe<Array<EducationLevelType>>;
  type?: InputMaybe<SystemGlobalAlertType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  value: Scalars['String']['input'];
};

export type SystemGlobalAlertCreateNestedOneWithoutSystemGlobalAlertUserDismissesInput = {
  connect?: InputMaybe<SystemGlobalAlertWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SystemGlobalAlertCreateOrConnectWithoutSystemGlobalAlertUserDismissesInput>;
  create?: InputMaybe<SystemGlobalAlertCreateWithoutSystemGlobalAlertUserDismissesInput>;
};

export type SystemGlobalAlertCreateOrConnectWithoutSystemGlobalAlertUserDismissesInput = {
  create: SystemGlobalAlertCreateWithoutSystemGlobalAlertUserDismissesInput;
  where: SystemGlobalAlertWhereUniqueInput;
};

export type SystemGlobalAlertCreateWithoutSystemGlobalAlertUserDismissesInput = {
  actionTitle?: InputMaybe<Scalars['String']['input']>;
  actionUrl?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  targetEducationLevels?: InputMaybe<Array<EducationLevelType>>;
  type?: InputMaybe<SystemGlobalAlertType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  value: Scalars['String']['input'];
};

export type SystemGlobalAlertCreatetargetEducationLevelsInput = {
  set: Array<EducationLevelType>;
};

export type SystemGlobalAlertMaxOrderByAggregateInput = {
  actionTitle?: InputMaybe<SortOrder>;
  actionUrl?: InputMaybe<SortOrder>;
  active?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type SystemGlobalAlertMinOrderByAggregateInput = {
  actionTitle?: InputMaybe<SortOrder>;
  actionUrl?: InputMaybe<SortOrder>;
  active?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type SystemGlobalAlertOrderByWithAggregationInput = {
  _avg?: InputMaybe<SystemGlobalAlertAvgOrderByAggregateInput>;
  _count?: InputMaybe<SystemGlobalAlertCountOrderByAggregateInput>;
  _max?: InputMaybe<SystemGlobalAlertMaxOrderByAggregateInput>;
  _min?: InputMaybe<SystemGlobalAlertMinOrderByAggregateInput>;
  _sum?: InputMaybe<SystemGlobalAlertSumOrderByAggregateInput>;
  actionTitle?: InputMaybe<SortOrder>;
  actionUrl?: InputMaybe<SortOrder>;
  active?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  targetEducationLevels?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type SystemGlobalAlertOrderByWithRelationInput = {
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissOrderByRelationAggregateInput>;
  actionTitle?: InputMaybe<SortOrder>;
  actionUrl?: InputMaybe<SortOrder>;
  active?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  targetEducationLevels?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export type SystemGlobalAlertRelationFilter = {
  is?: InputMaybe<SystemGlobalAlertWhereInput>;
  isNot?: InputMaybe<SystemGlobalAlertWhereInput>;
};

export enum SystemGlobalAlertScalarFieldEnum {
  ActionTitle = 'actionTitle',
  ActionUrl = 'actionUrl',
  Active = 'active',
  CreatedAt = 'createdAt',
  Id = 'id',
  Message = 'message',
  TargetEducationLevels = 'targetEducationLevels',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  Value = 'value'
}

export type SystemGlobalAlertScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<SystemGlobalAlertScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<SystemGlobalAlertScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<SystemGlobalAlertScalarWhereWithAggregatesInput>>;
  actionTitle?: InputMaybe<StringNullableWithAggregatesFilter>;
  actionUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  active?: InputMaybe<BoolWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  message?: InputMaybe<StringNullableWithAggregatesFilter>;
  targetEducationLevels?: InputMaybe<EnumEducationLevelTypeNullableListFilter>;
  type?: InputMaybe<EnumSystemGlobalAlertTypeWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  value?: InputMaybe<StringWithAggregatesFilter>;
};

export type SystemGlobalAlertSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export enum SystemGlobalAlertType {
  MessagePopup = 'MESSAGE_POPUP',
  MessageToast = 'MESSAGE_TOAST',
  SignAssistantVersion = 'SIGN_ASSISTANT_VERSION'
}

export type SystemGlobalAlertUpdateInput = {
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissUpdateManyWithoutSystemGlobalAlertNestedInput>;
  actionTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  actionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetEducationLevels?: InputMaybe<Array<EducationLevelType>>;
  type?: InputMaybe<EnumSystemGlobalAlertTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SystemGlobalAlertUpdateManyMutationInput = {
  actionTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  actionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetEducationLevels?: InputMaybe<Array<EducationLevelType>>;
  type?: InputMaybe<EnumSystemGlobalAlertTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SystemGlobalAlertUpdateOneRequiredWithoutSystemGlobalAlertUserDismissesNestedInput = {
  connect?: InputMaybe<SystemGlobalAlertWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SystemGlobalAlertCreateOrConnectWithoutSystemGlobalAlertUserDismissesInput>;
  create?: InputMaybe<SystemGlobalAlertCreateWithoutSystemGlobalAlertUserDismissesInput>;
  update?: InputMaybe<SystemGlobalAlertUpdateToOneWithWhereWithoutSystemGlobalAlertUserDismissesInput>;
  upsert?: InputMaybe<SystemGlobalAlertUpsertWithoutSystemGlobalAlertUserDismissesInput>;
};

export type SystemGlobalAlertUpdateToOneWithWhereWithoutSystemGlobalAlertUserDismissesInput = {
  data: SystemGlobalAlertUpdateWithoutSystemGlobalAlertUserDismissesInput;
  where?: InputMaybe<SystemGlobalAlertWhereInput>;
};

export type SystemGlobalAlertUpdateWithoutSystemGlobalAlertUserDismissesInput = {
  actionTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  actionUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetEducationLevels?: InputMaybe<Array<EducationLevelType>>;
  type?: InputMaybe<EnumSystemGlobalAlertTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SystemGlobalAlertUpdatetargetEducationLevelsInput = {
  push?: InputMaybe<Array<EducationLevelType>>;
  set?: InputMaybe<Array<EducationLevelType>>;
};

export type SystemGlobalAlertUpsertWithoutSystemGlobalAlertUserDismissesInput = {
  create: SystemGlobalAlertCreateWithoutSystemGlobalAlertUserDismissesInput;
  update: SystemGlobalAlertUpdateWithoutSystemGlobalAlertUserDismissesInput;
  where?: InputMaybe<SystemGlobalAlertWhereInput>;
};

export type SystemGlobalAlertUserDismiss = {
  __typename?: 'SystemGlobalAlertUserDismiss';
  CommonUser: CommonUser;
  SystemGlobalAlert: SystemGlobalAlert;
  commonUserId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  systemGlobalAlertId: Scalars['Int']['output'];
};

export type SystemGlobalAlertUserDismissAvgOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  systemGlobalAlertId?: InputMaybe<SortOrder>;
};

export type SystemGlobalAlertUserDismissCommonUserIdSystemGlobalAlertIdCompoundUniqueInput = {
  commonUserId: Scalars['Int']['input'];
  systemGlobalAlertId: Scalars['Int']['input'];
};

export type SystemGlobalAlertUserDismissCountOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  systemGlobalAlertId?: InputMaybe<SortOrder>;
};

export type SystemGlobalAlertUserDismissCreateInput = {
  CommonUser: CommonUserCreateNestedOneWithoutSystemGlobalAlertUserDismissesInput;
  SystemGlobalAlert: SystemGlobalAlertCreateNestedOneWithoutSystemGlobalAlertUserDismissesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SystemGlobalAlertUserDismissCreateManyCommonUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  systemGlobalAlertId: Scalars['Int']['input'];
};

export type SystemGlobalAlertUserDismissCreateManyCommonUserInputEnvelope = {
  data: Array<SystemGlobalAlertUserDismissCreateManyCommonUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SystemGlobalAlertUserDismissCreateManyInput = {
  commonUserId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  systemGlobalAlertId: Scalars['Int']['input'];
};

export type SystemGlobalAlertUserDismissCreateManySystemGlobalAlertInput = {
  commonUserId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SystemGlobalAlertUserDismissCreateManySystemGlobalAlertInputEnvelope = {
  data: Array<SystemGlobalAlertUserDismissCreateManySystemGlobalAlertInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SystemGlobalAlertUserDismissCreateNestedManyWithoutCommonUserInput = {
  connect?: InputMaybe<Array<SystemGlobalAlertUserDismissWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SystemGlobalAlertUserDismissCreateOrConnectWithoutCommonUserInput>>;
  create?: InputMaybe<Array<SystemGlobalAlertUserDismissCreateWithoutCommonUserInput>>;
  createMany?: InputMaybe<SystemGlobalAlertUserDismissCreateManyCommonUserInputEnvelope>;
};

export type SystemGlobalAlertUserDismissCreateNestedManyWithoutSystemGlobalAlertInput = {
  connect?: InputMaybe<Array<SystemGlobalAlertUserDismissWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SystemGlobalAlertUserDismissCreateOrConnectWithoutSystemGlobalAlertInput>>;
  create?: InputMaybe<Array<SystemGlobalAlertUserDismissCreateWithoutSystemGlobalAlertInput>>;
  createMany?: InputMaybe<SystemGlobalAlertUserDismissCreateManySystemGlobalAlertInputEnvelope>;
};

export type SystemGlobalAlertUserDismissCreateOrConnectWithoutCommonUserInput = {
  create: SystemGlobalAlertUserDismissCreateWithoutCommonUserInput;
  where: SystemGlobalAlertUserDismissWhereUniqueInput;
};

export type SystemGlobalAlertUserDismissCreateOrConnectWithoutSystemGlobalAlertInput = {
  create: SystemGlobalAlertUserDismissCreateWithoutSystemGlobalAlertInput;
  where: SystemGlobalAlertUserDismissWhereUniqueInput;
};

export type SystemGlobalAlertUserDismissCreateWithoutCommonUserInput = {
  SystemGlobalAlert: SystemGlobalAlertCreateNestedOneWithoutSystemGlobalAlertUserDismissesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SystemGlobalAlertUserDismissCreateWithoutSystemGlobalAlertInput = {
  CommonUser: CommonUserCreateNestedOneWithoutSystemGlobalAlertUserDismissesInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SystemGlobalAlertUserDismissListRelationFilter = {
  every?: InputMaybe<SystemGlobalAlertUserDismissWhereInput>;
  none?: InputMaybe<SystemGlobalAlertUserDismissWhereInput>;
  some?: InputMaybe<SystemGlobalAlertUserDismissWhereInput>;
};

export type SystemGlobalAlertUserDismissMaxOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  systemGlobalAlertId?: InputMaybe<SortOrder>;
};

export type SystemGlobalAlertUserDismissMinOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  systemGlobalAlertId?: InputMaybe<SortOrder>;
};

export type SystemGlobalAlertUserDismissOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SystemGlobalAlertUserDismissOrderByWithAggregationInput = {
  _avg?: InputMaybe<SystemGlobalAlertUserDismissAvgOrderByAggregateInput>;
  _count?: InputMaybe<SystemGlobalAlertUserDismissCountOrderByAggregateInput>;
  _max?: InputMaybe<SystemGlobalAlertUserDismissMaxOrderByAggregateInput>;
  _min?: InputMaybe<SystemGlobalAlertUserDismissMinOrderByAggregateInput>;
  _sum?: InputMaybe<SystemGlobalAlertUserDismissSumOrderByAggregateInput>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  systemGlobalAlertId?: InputMaybe<SortOrder>;
};

export type SystemGlobalAlertUserDismissOrderByWithRelationInput = {
  CommonUser?: InputMaybe<CommonUserOrderByWithRelationInput>;
  SystemGlobalAlert?: InputMaybe<SystemGlobalAlertOrderByWithRelationInput>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  systemGlobalAlertId?: InputMaybe<SortOrder>;
};

export enum SystemGlobalAlertUserDismissScalarFieldEnum {
  CommonUserId = 'commonUserId',
  CreatedAt = 'createdAt',
  SystemGlobalAlertId = 'systemGlobalAlertId'
}

export type SystemGlobalAlertUserDismissScalarWhereInput = {
  AND?: InputMaybe<Array<SystemGlobalAlertUserDismissScalarWhereInput>>;
  NOT?: InputMaybe<Array<SystemGlobalAlertUserDismissScalarWhereInput>>;
  OR?: InputMaybe<Array<SystemGlobalAlertUserDismissScalarWhereInput>>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  systemGlobalAlertId?: InputMaybe<IntFilter>;
};

export type SystemGlobalAlertUserDismissScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<SystemGlobalAlertUserDismissScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<SystemGlobalAlertUserDismissScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<SystemGlobalAlertUserDismissScalarWhereWithAggregatesInput>>;
  commonUserId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  systemGlobalAlertId?: InputMaybe<IntWithAggregatesFilter>;
};

export type SystemGlobalAlertUserDismissSumOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  systemGlobalAlertId?: InputMaybe<SortOrder>;
};

export type SystemGlobalAlertUserDismissUpdateInput = {
  CommonUser?: InputMaybe<CommonUserUpdateOneRequiredWithoutSystemGlobalAlertUserDismissesNestedInput>;
  SystemGlobalAlert?: InputMaybe<SystemGlobalAlertUpdateOneRequiredWithoutSystemGlobalAlertUserDismissesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SystemGlobalAlertUserDismissUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SystemGlobalAlertUserDismissUpdateManyWithWhereWithoutCommonUserInput = {
  data: SystemGlobalAlertUserDismissUpdateManyMutationInput;
  where: SystemGlobalAlertUserDismissScalarWhereInput;
};

export type SystemGlobalAlertUserDismissUpdateManyWithWhereWithoutSystemGlobalAlertInput = {
  data: SystemGlobalAlertUserDismissUpdateManyMutationInput;
  where: SystemGlobalAlertUserDismissScalarWhereInput;
};

export type SystemGlobalAlertUserDismissUpdateManyWithoutCommonUserNestedInput = {
  connect?: InputMaybe<Array<SystemGlobalAlertUserDismissWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SystemGlobalAlertUserDismissCreateOrConnectWithoutCommonUserInput>>;
  create?: InputMaybe<Array<SystemGlobalAlertUserDismissCreateWithoutCommonUserInput>>;
  createMany?: InputMaybe<SystemGlobalAlertUserDismissCreateManyCommonUserInputEnvelope>;
  delete?: InputMaybe<Array<SystemGlobalAlertUserDismissWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SystemGlobalAlertUserDismissScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SystemGlobalAlertUserDismissWhereUniqueInput>>;
  set?: InputMaybe<Array<SystemGlobalAlertUserDismissWhereUniqueInput>>;
  update?: InputMaybe<Array<SystemGlobalAlertUserDismissUpdateWithWhereUniqueWithoutCommonUserInput>>;
  updateMany?: InputMaybe<Array<SystemGlobalAlertUserDismissUpdateManyWithWhereWithoutCommonUserInput>>;
  upsert?: InputMaybe<Array<SystemGlobalAlertUserDismissUpsertWithWhereUniqueWithoutCommonUserInput>>;
};

export type SystemGlobalAlertUserDismissUpdateManyWithoutSystemGlobalAlertNestedInput = {
  connect?: InputMaybe<Array<SystemGlobalAlertUserDismissWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SystemGlobalAlertUserDismissCreateOrConnectWithoutSystemGlobalAlertInput>>;
  create?: InputMaybe<Array<SystemGlobalAlertUserDismissCreateWithoutSystemGlobalAlertInput>>;
  createMany?: InputMaybe<SystemGlobalAlertUserDismissCreateManySystemGlobalAlertInputEnvelope>;
  delete?: InputMaybe<Array<SystemGlobalAlertUserDismissWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SystemGlobalAlertUserDismissScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SystemGlobalAlertUserDismissWhereUniqueInput>>;
  set?: InputMaybe<Array<SystemGlobalAlertUserDismissWhereUniqueInput>>;
  update?: InputMaybe<Array<SystemGlobalAlertUserDismissUpdateWithWhereUniqueWithoutSystemGlobalAlertInput>>;
  updateMany?: InputMaybe<Array<SystemGlobalAlertUserDismissUpdateManyWithWhereWithoutSystemGlobalAlertInput>>;
  upsert?: InputMaybe<Array<SystemGlobalAlertUserDismissUpsertWithWhereUniqueWithoutSystemGlobalAlertInput>>;
};

export type SystemGlobalAlertUserDismissUpdateWithWhereUniqueWithoutCommonUserInput = {
  data: SystemGlobalAlertUserDismissUpdateWithoutCommonUserInput;
  where: SystemGlobalAlertUserDismissWhereUniqueInput;
};

export type SystemGlobalAlertUserDismissUpdateWithWhereUniqueWithoutSystemGlobalAlertInput = {
  data: SystemGlobalAlertUserDismissUpdateWithoutSystemGlobalAlertInput;
  where: SystemGlobalAlertUserDismissWhereUniqueInput;
};

export type SystemGlobalAlertUserDismissUpdateWithoutCommonUserInput = {
  SystemGlobalAlert?: InputMaybe<SystemGlobalAlertUpdateOneRequiredWithoutSystemGlobalAlertUserDismissesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SystemGlobalAlertUserDismissUpdateWithoutSystemGlobalAlertInput = {
  CommonUser?: InputMaybe<CommonUserUpdateOneRequiredWithoutSystemGlobalAlertUserDismissesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SystemGlobalAlertUserDismissUpsertWithWhereUniqueWithoutCommonUserInput = {
  create: SystemGlobalAlertUserDismissCreateWithoutCommonUserInput;
  update: SystemGlobalAlertUserDismissUpdateWithoutCommonUserInput;
  where: SystemGlobalAlertUserDismissWhereUniqueInput;
};

export type SystemGlobalAlertUserDismissUpsertWithWhereUniqueWithoutSystemGlobalAlertInput = {
  create: SystemGlobalAlertUserDismissCreateWithoutSystemGlobalAlertInput;
  update: SystemGlobalAlertUserDismissUpdateWithoutSystemGlobalAlertInput;
  where: SystemGlobalAlertUserDismissWhereUniqueInput;
};

export type SystemGlobalAlertUserDismissWhereInput = {
  AND?: InputMaybe<Array<SystemGlobalAlertUserDismissWhereInput>>;
  CommonUser?: InputMaybe<CommonUserWhereInput>;
  NOT?: InputMaybe<Array<SystemGlobalAlertUserDismissWhereInput>>;
  OR?: InputMaybe<Array<SystemGlobalAlertUserDismissWhereInput>>;
  SystemGlobalAlert?: InputMaybe<SystemGlobalAlertWhereInput>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  systemGlobalAlertId?: InputMaybe<IntFilter>;
};

export type SystemGlobalAlertUserDismissWhereUniqueInput = {
  AND?: InputMaybe<Array<SystemGlobalAlertUserDismissWhereInput>>;
  CommonUser?: InputMaybe<CommonUserWhereInput>;
  NOT?: InputMaybe<Array<SystemGlobalAlertUserDismissWhereInput>>;
  OR?: InputMaybe<Array<SystemGlobalAlertUserDismissWhereInput>>;
  SystemGlobalAlert?: InputMaybe<SystemGlobalAlertWhereInput>;
  commonUserId?: InputMaybe<IntFilter>;
  commonUserId_systemGlobalAlertId?: InputMaybe<SystemGlobalAlertUserDismissCommonUserIdSystemGlobalAlertIdCompoundUniqueInput>;
  createdAt?: InputMaybe<DateTimeFilter>;
  systemGlobalAlertId?: InputMaybe<IntFilter>;
};

export type SystemGlobalAlertWhereInput = {
  AND?: InputMaybe<Array<SystemGlobalAlertWhereInput>>;
  NOT?: InputMaybe<Array<SystemGlobalAlertWhereInput>>;
  OR?: InputMaybe<Array<SystemGlobalAlertWhereInput>>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissListRelationFilter>;
  actionTitle?: InputMaybe<StringNullableFilter>;
  actionUrl?: InputMaybe<StringNullableFilter>;
  active?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  message?: InputMaybe<StringNullableFilter>;
  targetEducationLevels?: InputMaybe<EnumEducationLevelTypeNullableListFilter>;
  type?: InputMaybe<EnumSystemGlobalAlertTypeFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  value?: InputMaybe<StringFilter>;
};

export type SystemGlobalAlertWhereUniqueInput = {
  AND?: InputMaybe<Array<SystemGlobalAlertWhereInput>>;
  NOT?: InputMaybe<Array<SystemGlobalAlertWhereInput>>;
  OR?: InputMaybe<Array<SystemGlobalAlertWhereInput>>;
  SystemGlobalAlertUserDismisses?: InputMaybe<SystemGlobalAlertUserDismissListRelationFilter>;
  actionTitle?: InputMaybe<StringNullableFilter>;
  actionUrl?: InputMaybe<StringNullableFilter>;
  active?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<StringNullableFilter>;
  targetEducationLevels?: InputMaybe<EnumEducationLevelTypeNullableListFilter>;
  type?: InputMaybe<EnumSystemGlobalAlertTypeFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  value?: InputMaybe<StringFilter>;
};

/** Deprecated */
export type SystemLog = {
  __typename?: 'SystemLog';
  User?: Maybe<CommonUser>;
  commonUserId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** ![PrismaJson.AnyJson] */
  data?: Maybe<Scalars['Json']['output']>;
  id: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SystemLogAvgOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type SystemLogCountOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SystemLogCreateInput = {
  User?: InputMaybe<CommonUserCreateNestedOneWithoutSystemLogInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data?: InputMaybe<Scalars['Json']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SystemLogCreateManyInput = {
  commonUserId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SystemLogCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SystemLogCreateManyUserInputEnvelope = {
  data: Array<SystemLogCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SystemLogCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<SystemLogWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SystemLogCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<SystemLogCreateWithoutUserInput>>;
  createMany?: InputMaybe<SystemLogCreateManyUserInputEnvelope>;
};

export type SystemLogCreateOrConnectWithoutUserInput = {
  create: SystemLogCreateWithoutUserInput;
  where: SystemLogWhereUniqueInput;
};

export type SystemLogCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data?: InputMaybe<Scalars['Json']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SystemLogListRelationFilter = {
  every?: InputMaybe<SystemLogWhereInput>;
  none?: InputMaybe<SystemLogWhereInput>;
  some?: InputMaybe<SystemLogWhereInput>;
};

export type SystemLogMaxOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SystemLogMinOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SystemLogOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SystemLogOrderByWithAggregationInput = {
  _avg?: InputMaybe<SystemLogAvgOrderByAggregateInput>;
  _count?: InputMaybe<SystemLogCountOrderByAggregateInput>;
  _max?: InputMaybe<SystemLogMaxOrderByAggregateInput>;
  _min?: InputMaybe<SystemLogMinOrderByAggregateInput>;
  _sum?: InputMaybe<SystemLogSumOrderByAggregateInput>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type SystemLogOrderByWithRelationInput = {
  User?: InputMaybe<CommonUserOrderByWithRelationInput>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum SystemLogScalarFieldEnum {
  CommonUserId = 'commonUserId',
  CreatedAt = 'createdAt',
  Data = 'data',
  Id = 'id',
  Message = 'message',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type SystemLogScalarWhereInput = {
  AND?: InputMaybe<Array<SystemLogScalarWhereInput>>;
  NOT?: InputMaybe<Array<SystemLogScalarWhereInput>>;
  OR?: InputMaybe<Array<SystemLogScalarWhereInput>>;
  commonUserId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  message?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type SystemLogScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<SystemLogScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<SystemLogScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<SystemLogScalarWhereWithAggregatesInput>>;
  commonUserId?: InputMaybe<IntNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  data?: InputMaybe<JsonNullableWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  message?: InputMaybe<StringNullableWithAggregatesFilter>;
  type?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type SystemLogSumOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type SystemLogUpdateInput = {
  User?: InputMaybe<CommonUserUpdateOneWithoutSystemLogNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type SystemLogUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type SystemLogUpdateManyWithWhereWithoutUserInput = {
  data: SystemLogUpdateManyMutationInput;
  where: SystemLogScalarWhereInput;
};

export type SystemLogUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<SystemLogWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SystemLogCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<SystemLogCreateWithoutUserInput>>;
  createMany?: InputMaybe<SystemLogCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<SystemLogWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SystemLogScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SystemLogWhereUniqueInput>>;
  set?: InputMaybe<Array<SystemLogWhereUniqueInput>>;
  update?: InputMaybe<Array<SystemLogUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<SystemLogUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<SystemLogUpsertWithWhereUniqueWithoutUserInput>>;
};

export type SystemLogUpdateWithWhereUniqueWithoutUserInput = {
  data: SystemLogUpdateWithoutUserInput;
  where: SystemLogWhereUniqueInput;
};

export type SystemLogUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type SystemLogUpsertWithWhereUniqueWithoutUserInput = {
  create: SystemLogCreateWithoutUserInput;
  update: SystemLogUpdateWithoutUserInput;
  where: SystemLogWhereUniqueInput;
};

export type SystemLogWhereInput = {
  AND?: InputMaybe<Array<SystemLogWhereInput>>;
  NOT?: InputMaybe<Array<SystemLogWhereInput>>;
  OR?: InputMaybe<Array<SystemLogWhereInput>>;
  User?: InputMaybe<CommonUserWhereInput>;
  commonUserId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  message?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type SystemLogWhereUniqueInput = {
  AND?: InputMaybe<Array<SystemLogWhereInput>>;
  NOT?: InputMaybe<Array<SystemLogWhereInput>>;
  OR?: InputMaybe<Array<SystemLogWhereInput>>;
  User?: InputMaybe<CommonUserWhereInput>;
  commonUserId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

/** Institution */
export type Team = {
  __typename?: 'Team';
  ApiKey: Array<ApiKey>;
  BulkCertificateRecord: Array<BulkCertificateRecord>;
  CertificateBase: Array<CertificateBase>;
  CertificateTemplates: Array<CertificateTemplate>;
  DefaultDegreeCertificateTemplate?: Maybe<CertificateTemplate>;
  DefaultSignatureInviteConfigurations: Array<DocumentBaseDefaultSignatureInviteConfiguration>;
  Documents: Array<DocumentBase>;
  EnabledInstitution?: Maybe<EnabledInstitution>;
  /** Must be created at first purchase (When its created, cannot choose "Trial" plan again) */
  FinancialTeamWallet?: Maybe<FinancialTeamWallet>;
  MainTeamOfMaintainer?: Maybe<Maintainer>;
  Maintainer?: Maybe<Maintainer>;
  Owner: CommonUser;
  Person: Array<Person>;
  ReusableFormData: Array<ReusableFormData>;
  ReusableFormDataCurriculum: Array<ReusableFormDataCurriculum>;
  SystemAuditLogs: Array<SystemAuditLog>;
  TeamContracts: Array<TeamContract>;
  TeamDocumentTypeSpecificSignaturePolicyConfig: Array<TeamDocumentTypeSpecificSignaturePolicyConfig>;
  TeamEducationLevel: Array<TeamEducationLevel>;
  TeamMember: Array<TeamMember>;
  /** CNPJ from LedgerSign company of the user */
  cnpj?: Maybe<Scalars['String']['output']>;
  commonUserId: Scalars['Int']['output'];
  /** Salva se ao enviar convite, o documento deve ou não incluir o signerNode */
  configAddDocumentSignerNode: Scalars['Boolean']['output'];
  /**
   * contract's link
   * @deprecated due to the new contracts table (TeamContract)
   */
  contract: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deactivationReason?: Maybe<Scalars['String']['output']>;
  defaultDegreeCertificateTemplateId?: Maybe<Scalars['String']['output']>;
  enabledInstitutionId?: Maybe<Scalars['Int']['output']>;
  externalSignatureWebhookURL?: Maybe<Scalars['String']['output']>;
  faviconBase64?: Maybe<Scalars['String']['output']>;
  financialShouldCharge: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  isNSF: Scalars['Boolean']['output'];
  issuedCount: Scalars['Int']['output'];
  issuerData?: Maybe<Scalars['Json']['output']>;
  /** Nome da instituição criado em String pra manter a tipagem do front enquanto só usamos o nome */
  issuerName?: Maybe<Scalars['String']['output']>;
  lastActivityAt: Scalars['DateTime']['output'];
  logoBase64?: Maybe<Scalars['String']['output']>;
  maintainerId?: Maybe<Scalars['Int']['output']>;
  /** Espaço utilizado pela instituição */
  maintainerSpace?: Maybe<MaintainerSpace>;
  memberCount: Scalars['Int']['output'];
  observations: Scalars['String']['output'];
  /** This name can be changed by the admin */
  placeholderName: Scalars['String']['output'];
  /** Domínio da instituição caso utilizem o visualizador de diplomas */
  publicViewDegreeDomainPath?: Maybe<Scalars['String']['output']>;
  publicViewFinalAcademicTranscriptDomainPath?: Maybe<Scalars['String']['output']>;
  publicViewInstitutionName?: Maybe<Scalars['String']['output']>;
  /** Cor primária da instituição caso utilizem o visualizador de diplomas */
  publicViewPrimaryColor?: Maybe<Scalars['String']['output']>;
  publicViewSchoolCurriculumDomainPath?: Maybe<Scalars['String']['output']>;
  /** Cor secundária da instituição caso utilizem o visualizador de diplomas */
  publicViewSecondaryColor?: Maybe<Scalars['String']['output']>;
  showCreateDiploma: Scalars['Boolean']['output'];
  showImportDiploma: Scalars['Boolean']['output'];
  spaceUsage: Scalars['BigInt']['output'];
  storage: Scalars['Int']['output'];
  syncWithLedgerDoc: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  validateCertificateURL?: Maybe<Scalars['String']['output']>;
};


/** Institution */
export type TeamApiKeyArgs = {
  cursor?: InputMaybe<ApiKeyWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApiKeyScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApiKeyOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ApiKeyWhereInput>;
};


/** Institution */
export type TeamBulkCertificateRecordArgs = {
  cursor?: InputMaybe<BulkCertificateRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<BulkCertificateRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BulkCertificateRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BulkCertificateRecordWhereInput>;
};


/** Institution */
export type TeamCertificateBaseArgs = {
  cursor?: InputMaybe<CertificateBaseWhereUniqueInput>;
  distinct?: InputMaybe<Array<CertificateBaseScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CertificateBaseOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CertificateBaseWhereInput>;
};


/** Institution */
export type TeamCertificateTemplatesArgs = {
  cursor?: InputMaybe<CertificateTemplateWhereUniqueInput>;
  distinct?: InputMaybe<Array<CertificateTemplateScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CertificateTemplateOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CertificateTemplateWhereInput>;
};


/** Institution */
export type TeamDefaultSignatureInviteConfigurationsArgs = {
  cursor?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>;
};


/** Institution */
export type TeamDocumentsArgs = {
  cursor?: InputMaybe<DocumentBaseWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentBaseScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentBaseOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentBaseWhereInput>;
};


/** Institution */
export type TeamPersonArgs = {
  cursor?: InputMaybe<PersonWhereUniqueInput>;
  distinct?: InputMaybe<Array<PersonScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PersonOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PersonWhereInput>;
};


/** Institution */
export type TeamReusableFormDataArgs = {
  cursor?: InputMaybe<ReusableFormDataWhereUniqueInput>;
  distinct?: InputMaybe<Array<ReusableFormDataScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ReusableFormDataOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReusableFormDataWhereInput>;
};


/** Institution */
export type TeamReusableFormDataCurriculumArgs = {
  cursor?: InputMaybe<ReusableFormDataCurriculumWhereUniqueInput>;
  distinct?: InputMaybe<Array<ReusableFormDataCurriculumScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ReusableFormDataCurriculumOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReusableFormDataCurriculumWhereInput>;
};


/** Institution */
export type TeamSystemAuditLogsArgs = {
  cursor?: InputMaybe<SystemAuditLogWhereUniqueInput>;
  distinct?: InputMaybe<Array<SystemAuditLogScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SystemAuditLogOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SystemAuditLogWhereInput>;
};


/** Institution */
export type TeamTeamContractsArgs = {
  cursor?: InputMaybe<TeamContractWhereUniqueInput>;
  distinct?: InputMaybe<Array<TeamContractScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TeamContractOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeamContractWhereInput>;
};


/** Institution */
export type TeamTeamDocumentTypeSpecificSignaturePolicyConfigArgs = {
  cursor?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigWhereUniqueInput>;
  distinct?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigWhereInput>;
};


/** Institution */
export type TeamTeamEducationLevelArgs = {
  cursor?: InputMaybe<TeamEducationLevelWhereUniqueInput>;
  distinct?: InputMaybe<Array<TeamEducationLevelScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TeamEducationLevelOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeamEducationLevelWhereInput>;
};


/** Institution */
export type TeamTeamMemberArgs = {
  cursor?: InputMaybe<TeamMemberWhereUniqueInput>;
  distinct?: InputMaybe<Array<TeamMemberScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TeamMemberOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeamMemberWhereInput>;
};

export type TeamAndPublicDocumentBaseType = {
  __typename?: 'TeamAndPublicDocumentBaseType';
  documentSeeType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  team: Team;
  url: Scalars['String']['output'];
};

export type TeamAvgOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  enabledInstitutionId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  maintainerId?: InputMaybe<SortOrder>;
  spaceUsage?: InputMaybe<SortOrder>;
  storage?: InputMaybe<SortOrder>;
};

export type TeamContract = {
  __typename?: 'TeamContract';
  Team: Team;
  contractUrl: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  endOfContract: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  observations: Scalars['String']['output'];
  startOfContract: Scalars['DateTime']['output'];
  /** When defined, needs to update the team storage in Gb */
  storageInGb: Scalars['Int']['output'];
  teamId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TeamContractAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  storageInGb?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type TeamContractCountOrderByAggregateInput = {
  contractUrl?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endOfContract?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  observations?: InputMaybe<SortOrder>;
  startOfContract?: InputMaybe<SortOrder>;
  storageInGb?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TeamContractCreateInput = {
  Team: TeamCreateNestedOneWithoutTeamContractsInput;
  contractUrl: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endOfContract: Scalars['DateTime']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  startOfContract: Scalars['DateTime']['input'];
  storageInGb?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeamContractCreateManyInput = {
  contractUrl: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endOfContract: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  startOfContract: Scalars['DateTime']['input'];
  storageInGb?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeamContractCreateManyTeamInput = {
  contractUrl: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endOfContract: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  startOfContract: Scalars['DateTime']['input'];
  storageInGb?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeamContractCreateManyTeamInputEnvelope = {
  data: Array<TeamContractCreateManyTeamInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TeamContractCreateNestedManyWithoutTeamInput = {
  connect?: InputMaybe<Array<TeamContractWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TeamContractCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<TeamContractCreateWithoutTeamInput>>;
  createMany?: InputMaybe<TeamContractCreateManyTeamInputEnvelope>;
};

export type TeamContractCreateOrConnectWithoutTeamInput = {
  create: TeamContractCreateWithoutTeamInput;
  where: TeamContractWhereUniqueInput;
};

export type TeamContractCreateWithoutTeamInput = {
  contractUrl: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endOfContract: Scalars['DateTime']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  startOfContract: Scalars['DateTime']['input'];
  storageInGb?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeamContractListRelationFilter = {
  every?: InputMaybe<TeamContractWhereInput>;
  none?: InputMaybe<TeamContractWhereInput>;
  some?: InputMaybe<TeamContractWhereInput>;
};

export type TeamContractMaxOrderByAggregateInput = {
  contractUrl?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endOfContract?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  observations?: InputMaybe<SortOrder>;
  startOfContract?: InputMaybe<SortOrder>;
  storageInGb?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TeamContractMinOrderByAggregateInput = {
  contractUrl?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endOfContract?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  observations?: InputMaybe<SortOrder>;
  startOfContract?: InputMaybe<SortOrder>;
  storageInGb?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TeamContractOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TeamContractOrderByWithAggregationInput = {
  _avg?: InputMaybe<TeamContractAvgOrderByAggregateInput>;
  _count?: InputMaybe<TeamContractCountOrderByAggregateInput>;
  _max?: InputMaybe<TeamContractMaxOrderByAggregateInput>;
  _min?: InputMaybe<TeamContractMinOrderByAggregateInput>;
  _sum?: InputMaybe<TeamContractSumOrderByAggregateInput>;
  contractUrl?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endOfContract?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  observations?: InputMaybe<SortOrder>;
  startOfContract?: InputMaybe<SortOrder>;
  storageInGb?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TeamContractOrderByWithRelationInput = {
  Team?: InputMaybe<TeamOrderByWithRelationInput>;
  contractUrl?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endOfContract?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  observations?: InputMaybe<SortOrder>;
  startOfContract?: InputMaybe<SortOrder>;
  storageInGb?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum TeamContractScalarFieldEnum {
  ContractUrl = 'contractUrl',
  CreatedAt = 'createdAt',
  EndOfContract = 'endOfContract',
  Id = 'id',
  IsActive = 'isActive',
  Observations = 'observations',
  StartOfContract = 'startOfContract',
  StorageInGb = 'storageInGb',
  TeamId = 'teamId',
  UpdatedAt = 'updatedAt'
}

export type TeamContractScalarWhereInput = {
  AND?: InputMaybe<Array<TeamContractScalarWhereInput>>;
  NOT?: InputMaybe<Array<TeamContractScalarWhereInput>>;
  OR?: InputMaybe<Array<TeamContractScalarWhereInput>>;
  contractUrl?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  endOfContract?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  isActive?: InputMaybe<BoolNullableFilter>;
  observations?: InputMaybe<StringFilter>;
  startOfContract?: InputMaybe<DateTimeFilter>;
  storageInGb?: InputMaybe<IntFilter>;
  teamId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type TeamContractScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<TeamContractScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<TeamContractScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<TeamContractScalarWhereWithAggregatesInput>>;
  contractUrl?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  endOfContract?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  isActive?: InputMaybe<BoolNullableWithAggregatesFilter>;
  observations?: InputMaybe<StringWithAggregatesFilter>;
  startOfContract?: InputMaybe<DateTimeWithAggregatesFilter>;
  storageInGb?: InputMaybe<IntWithAggregatesFilter>;
  teamId?: InputMaybe<IntWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type TeamContractSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  storageInGb?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type TeamContractUnique_Active_Team_ContractCompoundUniqueInput = {
  isActive: Scalars['Boolean']['input'];
  teamId: Scalars['Int']['input'];
};

export type TeamContractUpdateInput = {
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutTeamContractsNestedInput>;
  contractUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endOfContract?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  observations?: InputMaybe<StringFieldUpdateOperationsInput>;
  startOfContract?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  storageInGb?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamContractUpdateManyMutationInput = {
  contractUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endOfContract?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  observations?: InputMaybe<StringFieldUpdateOperationsInput>;
  startOfContract?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  storageInGb?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamContractUpdateManyWithWhereWithoutTeamInput = {
  data: TeamContractUpdateManyMutationInput;
  where: TeamContractScalarWhereInput;
};

export type TeamContractUpdateManyWithoutTeamNestedInput = {
  connect?: InputMaybe<Array<TeamContractWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TeamContractCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<TeamContractCreateWithoutTeamInput>>;
  createMany?: InputMaybe<TeamContractCreateManyTeamInputEnvelope>;
  delete?: InputMaybe<Array<TeamContractWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TeamContractScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TeamContractWhereUniqueInput>>;
  set?: InputMaybe<Array<TeamContractWhereUniqueInput>>;
  update?: InputMaybe<Array<TeamContractUpdateWithWhereUniqueWithoutTeamInput>>;
  updateMany?: InputMaybe<Array<TeamContractUpdateManyWithWhereWithoutTeamInput>>;
  upsert?: InputMaybe<Array<TeamContractUpsertWithWhereUniqueWithoutTeamInput>>;
};

export type TeamContractUpdateWithWhereUniqueWithoutTeamInput = {
  data: TeamContractUpdateWithoutTeamInput;
  where: TeamContractWhereUniqueInput;
};

export type TeamContractUpdateWithoutTeamInput = {
  contractUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endOfContract?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  observations?: InputMaybe<StringFieldUpdateOperationsInput>;
  startOfContract?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  storageInGb?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamContractUpsertWithWhereUniqueWithoutTeamInput = {
  create: TeamContractCreateWithoutTeamInput;
  update: TeamContractUpdateWithoutTeamInput;
  where: TeamContractWhereUniqueInput;
};

export type TeamContractWhereInput = {
  AND?: InputMaybe<Array<TeamContractWhereInput>>;
  NOT?: InputMaybe<Array<TeamContractWhereInput>>;
  OR?: InputMaybe<Array<TeamContractWhereInput>>;
  Team?: InputMaybe<TeamWhereInput>;
  contractUrl?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  endOfContract?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  isActive?: InputMaybe<BoolNullableFilter>;
  observations?: InputMaybe<StringFilter>;
  startOfContract?: InputMaybe<DateTimeFilter>;
  storageInGb?: InputMaybe<IntFilter>;
  teamId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type TeamContractWhereUniqueInput = {
  AND?: InputMaybe<Array<TeamContractWhereInput>>;
  NOT?: InputMaybe<Array<TeamContractWhereInput>>;
  OR?: InputMaybe<Array<TeamContractWhereInput>>;
  Team?: InputMaybe<TeamWhereInput>;
  contractUrl?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  endOfContract?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<BoolNullableFilter>;
  observations?: InputMaybe<StringFilter>;
  startOfContract?: InputMaybe<DateTimeFilter>;
  storageInGb?: InputMaybe<IntFilter>;
  teamId?: InputMaybe<IntFilter>;
  unique_active_team_contract?: InputMaybe<TeamContractUnique_Active_Team_ContractCompoundUniqueInput>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type TeamCountOrderByAggregateInput = {
  cnpj?: InputMaybe<SortOrder>;
  commonUserId?: InputMaybe<SortOrder>;
  configAddDocumentSignerNode?: InputMaybe<SortOrder>;
  contract?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deactivationReason?: InputMaybe<SortOrder>;
  defaultDegreeCertificateTemplateId?: InputMaybe<SortOrder>;
  enabledInstitutionId?: InputMaybe<SortOrder>;
  externalSignatureWebhookURL?: InputMaybe<SortOrder>;
  faviconBase64?: InputMaybe<SortOrder>;
  financialShouldCharge?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  isNSF?: InputMaybe<SortOrder>;
  lastActivityAt?: InputMaybe<SortOrder>;
  logoBase64?: InputMaybe<SortOrder>;
  maintainerId?: InputMaybe<SortOrder>;
  observations?: InputMaybe<SortOrder>;
  placeholderName?: InputMaybe<SortOrder>;
  publicViewDegreeDomainPath?: InputMaybe<SortOrder>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<SortOrder>;
  publicViewInstitutionName?: InputMaybe<SortOrder>;
  publicViewPrimaryColor?: InputMaybe<SortOrder>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<SortOrder>;
  publicViewSecondaryColor?: InputMaybe<SortOrder>;
  showCreateDiploma?: InputMaybe<SortOrder>;
  showImportDiploma?: InputMaybe<SortOrder>;
  spaceUsage?: InputMaybe<SortOrder>;
  storage?: InputMaybe<SortOrder>;
  syncWithLedgerDoc?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  validateCertificateURL?: InputMaybe<SortOrder>;
};

export type TeamCreateInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateCreateNestedOneWithoutTeamUsingAsPrimaryInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: InputMaybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: InputMaybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: InputMaybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamContracts?: InputMaybe<TeamContractCreateNestedManyWithoutTeamInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  configAddDocumentSignerNode?: InputMaybe<Scalars['Boolean']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationReason?: InputMaybe<Scalars['String']['input']>;
  externalSignatureWebhookURL?: InputMaybe<Scalars['String']['input']>;
  faviconBase64?: InputMaybe<Scalars['String']['input']>;
  financialShouldCharge?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  logoBase64?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  placeholderName?: InputMaybe<Scalars['String']['input']>;
  publicViewDegreeDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewInstitutionName?: InputMaybe<Scalars['String']['input']>;
  publicViewPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  spaceUsage?: InputMaybe<Scalars['BigInt']['input']>;
  storage?: InputMaybe<Scalars['Int']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validateCertificateURL?: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreateManyInput = {
  cnpj?: InputMaybe<Scalars['String']['input']>;
  commonUserId: Scalars['Int']['input'];
  configAddDocumentSignerNode?: InputMaybe<Scalars['Boolean']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationReason?: InputMaybe<Scalars['String']['input']>;
  defaultDegreeCertificateTemplateId?: InputMaybe<Scalars['String']['input']>;
  enabledInstitutionId?: InputMaybe<Scalars['Int']['input']>;
  externalSignatureWebhookURL?: InputMaybe<Scalars['String']['input']>;
  faviconBase64?: InputMaybe<Scalars['String']['input']>;
  financialShouldCharge?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  logoBase64?: InputMaybe<Scalars['String']['input']>;
  maintainerId?: InputMaybe<Scalars['Int']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  placeholderName?: InputMaybe<Scalars['String']['input']>;
  publicViewDegreeDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewInstitutionName?: InputMaybe<Scalars['String']['input']>;
  publicViewPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  spaceUsage?: InputMaybe<Scalars['BigInt']['input']>;
  storage?: InputMaybe<Scalars['Int']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validateCertificateURL?: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreateManyMaintainerInput = {
  cnpj?: InputMaybe<Scalars['String']['input']>;
  commonUserId: Scalars['Int']['input'];
  configAddDocumentSignerNode?: InputMaybe<Scalars['Boolean']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationReason?: InputMaybe<Scalars['String']['input']>;
  defaultDegreeCertificateTemplateId?: InputMaybe<Scalars['String']['input']>;
  enabledInstitutionId?: InputMaybe<Scalars['Int']['input']>;
  externalSignatureWebhookURL?: InputMaybe<Scalars['String']['input']>;
  faviconBase64?: InputMaybe<Scalars['String']['input']>;
  financialShouldCharge?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  logoBase64?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  placeholderName?: InputMaybe<Scalars['String']['input']>;
  publicViewDegreeDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewInstitutionName?: InputMaybe<Scalars['String']['input']>;
  publicViewPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  spaceUsage?: InputMaybe<Scalars['BigInt']['input']>;
  storage?: InputMaybe<Scalars['Int']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validateCertificateURL?: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreateManyMaintainerInputEnvelope = {
  data: Array<TeamCreateManyMaintainerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TeamCreateManyOwnerInput = {
  cnpj?: InputMaybe<Scalars['String']['input']>;
  configAddDocumentSignerNode?: InputMaybe<Scalars['Boolean']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationReason?: InputMaybe<Scalars['String']['input']>;
  defaultDegreeCertificateTemplateId?: InputMaybe<Scalars['String']['input']>;
  enabledInstitutionId?: InputMaybe<Scalars['Int']['input']>;
  externalSignatureWebhookURL?: InputMaybe<Scalars['String']['input']>;
  faviconBase64?: InputMaybe<Scalars['String']['input']>;
  financialShouldCharge?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  logoBase64?: InputMaybe<Scalars['String']['input']>;
  maintainerId?: InputMaybe<Scalars['Int']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  placeholderName?: InputMaybe<Scalars['String']['input']>;
  publicViewDegreeDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewInstitutionName?: InputMaybe<Scalars['String']['input']>;
  publicViewPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  spaceUsage?: InputMaybe<Scalars['BigInt']['input']>;
  storage?: InputMaybe<Scalars['Int']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validateCertificateURL?: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreateManyOwnerInputEnvelope = {
  data: Array<TeamCreateManyOwnerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TeamCreateNestedManyWithoutMaintainerInput = {
  connect?: InputMaybe<Array<TeamWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TeamCreateOrConnectWithoutMaintainerInput>>;
  create?: InputMaybe<Array<TeamCreateWithoutMaintainerInput>>;
  createMany?: InputMaybe<TeamCreateManyMaintainerInputEnvelope>;
};

export type TeamCreateNestedManyWithoutOwnerInput = {
  connect?: InputMaybe<Array<TeamWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TeamCreateOrConnectWithoutOwnerInput>>;
  create?: InputMaybe<Array<TeamCreateWithoutOwnerInput>>;
  createMany?: InputMaybe<TeamCreateManyOwnerInputEnvelope>;
};

export type TeamCreateNestedOneWithoutApiKeyInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutApiKeyInput>;
  create?: InputMaybe<TeamCreateWithoutApiKeyInput>;
};

export type TeamCreateNestedOneWithoutBulkCertificateRecordInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutBulkCertificateRecordInput>;
  create?: InputMaybe<TeamCreateWithoutBulkCertificateRecordInput>;
};

export type TeamCreateNestedOneWithoutCertificateBaseInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutCertificateBaseInput>;
  create?: InputMaybe<TeamCreateWithoutCertificateBaseInput>;
};

export type TeamCreateNestedOneWithoutCertificateTemplatesInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutCertificateTemplatesInput>;
  create?: InputMaybe<TeamCreateWithoutCertificateTemplatesInput>;
};

export type TeamCreateNestedOneWithoutDefaultDegreeCertificateTemplateInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutDefaultDegreeCertificateTemplateInput>;
  create?: InputMaybe<TeamCreateWithoutDefaultDegreeCertificateTemplateInput>;
};

export type TeamCreateNestedOneWithoutDefaultSignatureInviteConfigurationsInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutDefaultSignatureInviteConfigurationsInput>;
  create?: InputMaybe<TeamCreateWithoutDefaultSignatureInviteConfigurationsInput>;
};

export type TeamCreateNestedOneWithoutDocumentsInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutDocumentsInput>;
  create?: InputMaybe<TeamCreateWithoutDocumentsInput>;
};

export type TeamCreateNestedOneWithoutEnabledInstitutionInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutEnabledInstitutionInput>;
  create?: InputMaybe<TeamCreateWithoutEnabledInstitutionInput>;
};

export type TeamCreateNestedOneWithoutFinancialTeamWalletInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutFinancialTeamWalletInput>;
  create?: InputMaybe<TeamCreateWithoutFinancialTeamWalletInput>;
};

export type TeamCreateNestedOneWithoutMainTeamOfMaintainerInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutMainTeamOfMaintainerInput>;
  create?: InputMaybe<TeamCreateWithoutMainTeamOfMaintainerInput>;
};

export type TeamCreateNestedOneWithoutPersonInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutPersonInput>;
  create?: InputMaybe<TeamCreateWithoutPersonInput>;
};

export type TeamCreateNestedOneWithoutReusableFormDataCurriculumInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutReusableFormDataCurriculumInput>;
  create?: InputMaybe<TeamCreateWithoutReusableFormDataCurriculumInput>;
};

export type TeamCreateNestedOneWithoutReusableFormDataInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutReusableFormDataInput>;
  create?: InputMaybe<TeamCreateWithoutReusableFormDataInput>;
};

export type TeamCreateNestedOneWithoutSystemAuditLogsInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutSystemAuditLogsInput>;
  create?: InputMaybe<TeamCreateWithoutSystemAuditLogsInput>;
};

export type TeamCreateNestedOneWithoutTeamContractsInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutTeamContractsInput>;
  create?: InputMaybe<TeamCreateWithoutTeamContractsInput>;
};

export type TeamCreateNestedOneWithoutTeamDocumentTypeSpecificSignaturePolicyConfigInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutTeamDocumentTypeSpecificSignaturePolicyConfigInput>;
  create?: InputMaybe<TeamCreateWithoutTeamDocumentTypeSpecificSignaturePolicyConfigInput>;
};

export type TeamCreateNestedOneWithoutTeamEducationLevelInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutTeamEducationLevelInput>;
  create?: InputMaybe<TeamCreateWithoutTeamEducationLevelInput>;
};

export type TeamCreateNestedOneWithoutTeamMemberInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutTeamMemberInput>;
  create?: InputMaybe<TeamCreateWithoutTeamMemberInput>;
};

export type TeamCreateOrConnectWithoutApiKeyInput = {
  create: TeamCreateWithoutApiKeyInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutBulkCertificateRecordInput = {
  create: TeamCreateWithoutBulkCertificateRecordInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutCertificateBaseInput = {
  create: TeamCreateWithoutCertificateBaseInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutCertificateTemplatesInput = {
  create: TeamCreateWithoutCertificateTemplatesInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutDefaultDegreeCertificateTemplateInput = {
  create: TeamCreateWithoutDefaultDegreeCertificateTemplateInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutDefaultSignatureInviteConfigurationsInput = {
  create: TeamCreateWithoutDefaultSignatureInviteConfigurationsInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutDocumentsInput = {
  create: TeamCreateWithoutDocumentsInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutEnabledInstitutionInput = {
  create: TeamCreateWithoutEnabledInstitutionInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutFinancialTeamWalletInput = {
  create: TeamCreateWithoutFinancialTeamWalletInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutMainTeamOfMaintainerInput = {
  create: TeamCreateWithoutMainTeamOfMaintainerInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutMaintainerInput = {
  create: TeamCreateWithoutMaintainerInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutOwnerInput = {
  create: TeamCreateWithoutOwnerInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutPersonInput = {
  create: TeamCreateWithoutPersonInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutReusableFormDataCurriculumInput = {
  create: TeamCreateWithoutReusableFormDataCurriculumInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutReusableFormDataInput = {
  create: TeamCreateWithoutReusableFormDataInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutSystemAuditLogsInput = {
  create: TeamCreateWithoutSystemAuditLogsInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutTeamContractsInput = {
  create: TeamCreateWithoutTeamContractsInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutTeamDocumentTypeSpecificSignaturePolicyConfigInput = {
  create: TeamCreateWithoutTeamDocumentTypeSpecificSignaturePolicyConfigInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutTeamEducationLevelInput = {
  create: TeamCreateWithoutTeamEducationLevelInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateOrConnectWithoutTeamMemberInput = {
  create: TeamCreateWithoutTeamMemberInput;
  where: TeamWhereUniqueInput;
};

export type TeamCreateWithoutApiKeyInput = {
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateCreateNestedOneWithoutTeamUsingAsPrimaryInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: InputMaybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: InputMaybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: InputMaybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamContracts?: InputMaybe<TeamContractCreateNestedManyWithoutTeamInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  configAddDocumentSignerNode?: InputMaybe<Scalars['Boolean']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationReason?: InputMaybe<Scalars['String']['input']>;
  externalSignatureWebhookURL?: InputMaybe<Scalars['String']['input']>;
  faviconBase64?: InputMaybe<Scalars['String']['input']>;
  financialShouldCharge?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  logoBase64?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  placeholderName?: InputMaybe<Scalars['String']['input']>;
  publicViewDegreeDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewInstitutionName?: InputMaybe<Scalars['String']['input']>;
  publicViewPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  spaceUsage?: InputMaybe<Scalars['BigInt']['input']>;
  storage?: InputMaybe<Scalars['Int']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validateCertificateURL?: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreateWithoutBulkCertificateRecordInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateCreateNestedOneWithoutTeamUsingAsPrimaryInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: InputMaybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: InputMaybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: InputMaybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamContracts?: InputMaybe<TeamContractCreateNestedManyWithoutTeamInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  configAddDocumentSignerNode?: InputMaybe<Scalars['Boolean']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationReason?: InputMaybe<Scalars['String']['input']>;
  externalSignatureWebhookURL?: InputMaybe<Scalars['String']['input']>;
  faviconBase64?: InputMaybe<Scalars['String']['input']>;
  financialShouldCharge?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  logoBase64?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  placeholderName?: InputMaybe<Scalars['String']['input']>;
  publicViewDegreeDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewInstitutionName?: InputMaybe<Scalars['String']['input']>;
  publicViewPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  spaceUsage?: InputMaybe<Scalars['BigInt']['input']>;
  storage?: InputMaybe<Scalars['Int']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validateCertificateURL?: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreateWithoutCertificateBaseInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateCreateNestedOneWithoutTeamUsingAsPrimaryInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: InputMaybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: InputMaybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: InputMaybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamContracts?: InputMaybe<TeamContractCreateNestedManyWithoutTeamInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  configAddDocumentSignerNode?: InputMaybe<Scalars['Boolean']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationReason?: InputMaybe<Scalars['String']['input']>;
  externalSignatureWebhookURL?: InputMaybe<Scalars['String']['input']>;
  faviconBase64?: InputMaybe<Scalars['String']['input']>;
  financialShouldCharge?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  logoBase64?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  placeholderName?: InputMaybe<Scalars['String']['input']>;
  publicViewDegreeDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewInstitutionName?: InputMaybe<Scalars['String']['input']>;
  publicViewPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  spaceUsage?: InputMaybe<Scalars['BigInt']['input']>;
  storage?: InputMaybe<Scalars['Int']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validateCertificateURL?: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreateWithoutCertificateTemplatesInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateCreateNestedOneWithoutTeamUsingAsPrimaryInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: InputMaybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: InputMaybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: InputMaybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamContracts?: InputMaybe<TeamContractCreateNestedManyWithoutTeamInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  configAddDocumentSignerNode?: InputMaybe<Scalars['Boolean']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationReason?: InputMaybe<Scalars['String']['input']>;
  externalSignatureWebhookURL?: InputMaybe<Scalars['String']['input']>;
  faviconBase64?: InputMaybe<Scalars['String']['input']>;
  financialShouldCharge?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  logoBase64?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  placeholderName?: InputMaybe<Scalars['String']['input']>;
  publicViewDegreeDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewInstitutionName?: InputMaybe<Scalars['String']['input']>;
  publicViewPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  spaceUsage?: InputMaybe<Scalars['BigInt']['input']>;
  storage?: InputMaybe<Scalars['Int']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validateCertificateURL?: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreateWithoutDefaultDegreeCertificateTemplateInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: InputMaybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: InputMaybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: InputMaybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamContracts?: InputMaybe<TeamContractCreateNestedManyWithoutTeamInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  configAddDocumentSignerNode?: InputMaybe<Scalars['Boolean']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationReason?: InputMaybe<Scalars['String']['input']>;
  externalSignatureWebhookURL?: InputMaybe<Scalars['String']['input']>;
  faviconBase64?: InputMaybe<Scalars['String']['input']>;
  financialShouldCharge?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  logoBase64?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  placeholderName?: InputMaybe<Scalars['String']['input']>;
  publicViewDegreeDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewInstitutionName?: InputMaybe<Scalars['String']['input']>;
  publicViewPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  spaceUsage?: InputMaybe<Scalars['BigInt']['input']>;
  storage?: InputMaybe<Scalars['Int']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validateCertificateURL?: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreateWithoutDefaultSignatureInviteConfigurationsInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateCreateNestedOneWithoutTeamUsingAsPrimaryInput>;
  Documents?: InputMaybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: InputMaybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: InputMaybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamContracts?: InputMaybe<TeamContractCreateNestedManyWithoutTeamInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  configAddDocumentSignerNode?: InputMaybe<Scalars['Boolean']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationReason?: InputMaybe<Scalars['String']['input']>;
  externalSignatureWebhookURL?: InputMaybe<Scalars['String']['input']>;
  faviconBase64?: InputMaybe<Scalars['String']['input']>;
  financialShouldCharge?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  logoBase64?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  placeholderName?: InputMaybe<Scalars['String']['input']>;
  publicViewDegreeDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewInstitutionName?: InputMaybe<Scalars['String']['input']>;
  publicViewPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  spaceUsage?: InputMaybe<Scalars['BigInt']['input']>;
  storage?: InputMaybe<Scalars['Int']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validateCertificateURL?: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreateWithoutDocumentsInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateCreateNestedOneWithoutTeamUsingAsPrimaryInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: InputMaybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: InputMaybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamContracts?: InputMaybe<TeamContractCreateNestedManyWithoutTeamInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  configAddDocumentSignerNode?: InputMaybe<Scalars['Boolean']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationReason?: InputMaybe<Scalars['String']['input']>;
  externalSignatureWebhookURL?: InputMaybe<Scalars['String']['input']>;
  faviconBase64?: InputMaybe<Scalars['String']['input']>;
  financialShouldCharge?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  logoBase64?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  placeholderName?: InputMaybe<Scalars['String']['input']>;
  publicViewDegreeDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewInstitutionName?: InputMaybe<Scalars['String']['input']>;
  publicViewPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  spaceUsage?: InputMaybe<Scalars['BigInt']['input']>;
  storage?: InputMaybe<Scalars['Int']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validateCertificateURL?: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreateWithoutEnabledInstitutionInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateCreateNestedOneWithoutTeamUsingAsPrimaryInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: InputMaybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: InputMaybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: InputMaybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamContracts?: InputMaybe<TeamContractCreateNestedManyWithoutTeamInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  configAddDocumentSignerNode?: InputMaybe<Scalars['Boolean']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationReason?: InputMaybe<Scalars['String']['input']>;
  externalSignatureWebhookURL?: InputMaybe<Scalars['String']['input']>;
  faviconBase64?: InputMaybe<Scalars['String']['input']>;
  financialShouldCharge?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  logoBase64?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  placeholderName?: InputMaybe<Scalars['String']['input']>;
  publicViewDegreeDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewInstitutionName?: InputMaybe<Scalars['String']['input']>;
  publicViewPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  spaceUsage?: InputMaybe<Scalars['BigInt']['input']>;
  storage?: InputMaybe<Scalars['Int']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validateCertificateURL?: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreateWithoutFinancialTeamWalletInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateCreateNestedOneWithoutTeamUsingAsPrimaryInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: InputMaybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: InputMaybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: InputMaybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamContracts?: InputMaybe<TeamContractCreateNestedManyWithoutTeamInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  configAddDocumentSignerNode?: InputMaybe<Scalars['Boolean']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationReason?: InputMaybe<Scalars['String']['input']>;
  externalSignatureWebhookURL?: InputMaybe<Scalars['String']['input']>;
  faviconBase64?: InputMaybe<Scalars['String']['input']>;
  financialShouldCharge?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  logoBase64?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  placeholderName?: InputMaybe<Scalars['String']['input']>;
  publicViewDegreeDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewInstitutionName?: InputMaybe<Scalars['String']['input']>;
  publicViewPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  spaceUsage?: InputMaybe<Scalars['BigInt']['input']>;
  storage?: InputMaybe<Scalars['Int']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validateCertificateURL?: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreateWithoutMainTeamOfMaintainerInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateCreateNestedOneWithoutTeamUsingAsPrimaryInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: InputMaybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  Maintainer?: InputMaybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: InputMaybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamContracts?: InputMaybe<TeamContractCreateNestedManyWithoutTeamInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  configAddDocumentSignerNode?: InputMaybe<Scalars['Boolean']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationReason?: InputMaybe<Scalars['String']['input']>;
  externalSignatureWebhookURL?: InputMaybe<Scalars['String']['input']>;
  faviconBase64?: InputMaybe<Scalars['String']['input']>;
  financialShouldCharge?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  logoBase64?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  placeholderName?: InputMaybe<Scalars['String']['input']>;
  publicViewDegreeDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewInstitutionName?: InputMaybe<Scalars['String']['input']>;
  publicViewPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  spaceUsage?: InputMaybe<Scalars['BigInt']['input']>;
  storage?: InputMaybe<Scalars['Int']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validateCertificateURL?: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreateWithoutMaintainerInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateCreateNestedOneWithoutTeamUsingAsPrimaryInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: InputMaybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: InputMaybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamContracts?: InputMaybe<TeamContractCreateNestedManyWithoutTeamInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  configAddDocumentSignerNode?: InputMaybe<Scalars['Boolean']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationReason?: InputMaybe<Scalars['String']['input']>;
  externalSignatureWebhookURL?: InputMaybe<Scalars['String']['input']>;
  faviconBase64?: InputMaybe<Scalars['String']['input']>;
  financialShouldCharge?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  logoBase64?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  placeholderName?: InputMaybe<Scalars['String']['input']>;
  publicViewDegreeDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewInstitutionName?: InputMaybe<Scalars['String']['input']>;
  publicViewPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  spaceUsage?: InputMaybe<Scalars['BigInt']['input']>;
  storage?: InputMaybe<Scalars['Int']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validateCertificateURL?: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreateWithoutOwnerInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateCreateNestedOneWithoutTeamUsingAsPrimaryInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: InputMaybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: InputMaybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Person?: InputMaybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamContracts?: InputMaybe<TeamContractCreateNestedManyWithoutTeamInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  configAddDocumentSignerNode?: InputMaybe<Scalars['Boolean']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationReason?: InputMaybe<Scalars['String']['input']>;
  externalSignatureWebhookURL?: InputMaybe<Scalars['String']['input']>;
  faviconBase64?: InputMaybe<Scalars['String']['input']>;
  financialShouldCharge?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  logoBase64?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  placeholderName?: InputMaybe<Scalars['String']['input']>;
  publicViewDegreeDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewInstitutionName?: InputMaybe<Scalars['String']['input']>;
  publicViewPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  spaceUsage?: InputMaybe<Scalars['BigInt']['input']>;
  storage?: InputMaybe<Scalars['Int']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validateCertificateURL?: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreateWithoutPersonInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateCreateNestedOneWithoutTeamUsingAsPrimaryInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: InputMaybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: InputMaybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  ReusableFormData?: InputMaybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamContracts?: InputMaybe<TeamContractCreateNestedManyWithoutTeamInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  configAddDocumentSignerNode?: InputMaybe<Scalars['Boolean']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationReason?: InputMaybe<Scalars['String']['input']>;
  externalSignatureWebhookURL?: InputMaybe<Scalars['String']['input']>;
  faviconBase64?: InputMaybe<Scalars['String']['input']>;
  financialShouldCharge?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  logoBase64?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  placeholderName?: InputMaybe<Scalars['String']['input']>;
  publicViewDegreeDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewInstitutionName?: InputMaybe<Scalars['String']['input']>;
  publicViewPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  spaceUsage?: InputMaybe<Scalars['BigInt']['input']>;
  storage?: InputMaybe<Scalars['Int']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validateCertificateURL?: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreateWithoutReusableFormDataCurriculumInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateCreateNestedOneWithoutTeamUsingAsPrimaryInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: InputMaybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: InputMaybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: InputMaybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamContracts?: InputMaybe<TeamContractCreateNestedManyWithoutTeamInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  configAddDocumentSignerNode?: InputMaybe<Scalars['Boolean']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationReason?: InputMaybe<Scalars['String']['input']>;
  externalSignatureWebhookURL?: InputMaybe<Scalars['String']['input']>;
  faviconBase64?: InputMaybe<Scalars['String']['input']>;
  financialShouldCharge?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  logoBase64?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  placeholderName?: InputMaybe<Scalars['String']['input']>;
  publicViewDegreeDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewInstitutionName?: InputMaybe<Scalars['String']['input']>;
  publicViewPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  spaceUsage?: InputMaybe<Scalars['BigInt']['input']>;
  storage?: InputMaybe<Scalars['Int']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validateCertificateURL?: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreateWithoutReusableFormDataInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateCreateNestedOneWithoutTeamUsingAsPrimaryInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: InputMaybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: InputMaybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: InputMaybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamContracts?: InputMaybe<TeamContractCreateNestedManyWithoutTeamInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  configAddDocumentSignerNode?: InputMaybe<Scalars['Boolean']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationReason?: InputMaybe<Scalars['String']['input']>;
  externalSignatureWebhookURL?: InputMaybe<Scalars['String']['input']>;
  faviconBase64?: InputMaybe<Scalars['String']['input']>;
  financialShouldCharge?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  logoBase64?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  placeholderName?: InputMaybe<Scalars['String']['input']>;
  publicViewDegreeDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewInstitutionName?: InputMaybe<Scalars['String']['input']>;
  publicViewPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  spaceUsage?: InputMaybe<Scalars['BigInt']['input']>;
  storage?: InputMaybe<Scalars['Int']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validateCertificateURL?: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreateWithoutSystemAuditLogsInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateCreateNestedOneWithoutTeamUsingAsPrimaryInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: InputMaybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: InputMaybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: InputMaybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  TeamContracts?: InputMaybe<TeamContractCreateNestedManyWithoutTeamInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  configAddDocumentSignerNode?: InputMaybe<Scalars['Boolean']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationReason?: InputMaybe<Scalars['String']['input']>;
  externalSignatureWebhookURL?: InputMaybe<Scalars['String']['input']>;
  faviconBase64?: InputMaybe<Scalars['String']['input']>;
  financialShouldCharge?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  logoBase64?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  placeholderName?: InputMaybe<Scalars['String']['input']>;
  publicViewDegreeDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewInstitutionName?: InputMaybe<Scalars['String']['input']>;
  publicViewPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  spaceUsage?: InputMaybe<Scalars['BigInt']['input']>;
  storage?: InputMaybe<Scalars['Int']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validateCertificateURL?: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreateWithoutTeamContractsInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateCreateNestedOneWithoutTeamUsingAsPrimaryInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: InputMaybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: InputMaybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: InputMaybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  configAddDocumentSignerNode?: InputMaybe<Scalars['Boolean']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationReason?: InputMaybe<Scalars['String']['input']>;
  externalSignatureWebhookURL?: InputMaybe<Scalars['String']['input']>;
  faviconBase64?: InputMaybe<Scalars['String']['input']>;
  financialShouldCharge?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  logoBase64?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  placeholderName?: InputMaybe<Scalars['String']['input']>;
  publicViewDegreeDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewInstitutionName?: InputMaybe<Scalars['String']['input']>;
  publicViewPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  spaceUsage?: InputMaybe<Scalars['BigInt']['input']>;
  storage?: InputMaybe<Scalars['Int']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validateCertificateURL?: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreateWithoutTeamDocumentTypeSpecificSignaturePolicyConfigInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateCreateNestedOneWithoutTeamUsingAsPrimaryInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: InputMaybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: InputMaybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: InputMaybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamContracts?: InputMaybe<TeamContractCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  configAddDocumentSignerNode?: InputMaybe<Scalars['Boolean']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationReason?: InputMaybe<Scalars['String']['input']>;
  externalSignatureWebhookURL?: InputMaybe<Scalars['String']['input']>;
  faviconBase64?: InputMaybe<Scalars['String']['input']>;
  financialShouldCharge?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  logoBase64?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  placeholderName?: InputMaybe<Scalars['String']['input']>;
  publicViewDegreeDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewInstitutionName?: InputMaybe<Scalars['String']['input']>;
  publicViewPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  spaceUsage?: InputMaybe<Scalars['BigInt']['input']>;
  storage?: InputMaybe<Scalars['Int']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validateCertificateURL?: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreateWithoutTeamEducationLevelInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateCreateNestedOneWithoutTeamUsingAsPrimaryInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: InputMaybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: InputMaybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: InputMaybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamContracts?: InputMaybe<TeamContractCreateNestedManyWithoutTeamInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigCreateNestedManyWithoutTeamInput>;
  TeamMember?: InputMaybe<TeamMemberCreateNestedManyWithoutTeamInput>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  configAddDocumentSignerNode?: InputMaybe<Scalars['Boolean']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationReason?: InputMaybe<Scalars['String']['input']>;
  externalSignatureWebhookURL?: InputMaybe<Scalars['String']['input']>;
  faviconBase64?: InputMaybe<Scalars['String']['input']>;
  financialShouldCharge?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  logoBase64?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  placeholderName?: InputMaybe<Scalars['String']['input']>;
  publicViewDegreeDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewInstitutionName?: InputMaybe<Scalars['String']['input']>;
  publicViewPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  spaceUsage?: InputMaybe<Scalars['BigInt']['input']>;
  storage?: InputMaybe<Scalars['Int']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validateCertificateURL?: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreateWithoutTeamMemberInput = {
  ApiKey?: InputMaybe<ApiKeyCreateNestedManyWithoutTeamInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordCreateNestedManyWithoutTeamInput>;
  CertificateBase?: InputMaybe<CertificateBaseCreateNestedManyWithoutTeamInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateCreateNestedManyWithoutTeamInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateCreateNestedOneWithoutTeamUsingAsPrimaryInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationCreateNestedManyWithoutTeamInput>;
  Documents?: InputMaybe<DocumentBaseCreateNestedManyWithoutTeamInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionCreateNestedOneWithoutTeamInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletCreateNestedOneWithoutTeamInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerCreateNestedOneWithoutMainTeamInput>;
  Maintainer?: InputMaybe<MaintainerCreateNestedOneWithoutTeamsInput>;
  Owner: CommonUserCreateNestedOneWithoutTeamsCreatedInput;
  Person?: InputMaybe<PersonCreateNestedManyWithoutTeamInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataCreateNestedManyWithoutTeamInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumCreateNestedManyWithoutTeamInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogCreateNestedManyWithoutTeamInput>;
  TeamContracts?: InputMaybe<TeamContractCreateNestedManyWithoutTeamInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigCreateNestedManyWithoutTeamInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelCreateNestedManyWithoutTeamInput>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  configAddDocumentSignerNode?: InputMaybe<Scalars['Boolean']['input']>;
  contract?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deactivationReason?: InputMaybe<Scalars['String']['input']>;
  externalSignatureWebhookURL?: InputMaybe<Scalars['String']['input']>;
  faviconBase64?: InputMaybe<Scalars['String']['input']>;
  financialShouldCharge?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  lastActivityAt?: InputMaybe<Scalars['DateTime']['input']>;
  logoBase64?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  placeholderName?: InputMaybe<Scalars['String']['input']>;
  publicViewDegreeDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewInstitutionName?: InputMaybe<Scalars['String']['input']>;
  publicViewPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  spaceUsage?: InputMaybe<Scalars['BigInt']['input']>;
  storage?: InputMaybe<Scalars['Int']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  validateCertificateURL?: InputMaybe<Scalars['String']['input']>;
};

export type TeamDocumentTypeSpecificSignaturePolicyConfig = {
  __typename?: 'TeamDocumentTypeSpecificSignaturePolicyConfig';
  Team: Team;
  documentType: DocumentBaseType;
  /** Policies for each signature group */
  groupPolicies: Array<TeamSpecificSignaturePolicyType>;
  id: Scalars['Int']['output'];
  teamId: Scalars['Int']['output'];
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigCountOrderByAggregateInput = {
  documentType?: InputMaybe<SortOrder>;
  groupPolicies?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigCreateInput = {
  Team: TeamCreateNestedOneWithoutTeamDocumentTypeSpecificSignaturePolicyConfigInput;
  documentType: DocumentBaseType;
  groupPolicies?: InputMaybe<Array<TeamSpecificSignaturePolicyType>>;
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigCreateManyInput = {
  documentType: DocumentBaseType;
  groupPolicies?: InputMaybe<Array<TeamSpecificSignaturePolicyType>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigCreateManyTeamInput = {
  documentType: DocumentBaseType;
  groupPolicies?: InputMaybe<Array<TeamSpecificSignaturePolicyType>>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigCreateManyTeamInputEnvelope = {
  data: Array<TeamDocumentTypeSpecificSignaturePolicyConfigCreateManyTeamInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigCreateNestedManyWithoutTeamInput = {
  connect?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigCreateWithoutTeamInput>>;
  createMany?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigCreateManyTeamInputEnvelope>;
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigCreateOrConnectWithoutTeamInput = {
  create: TeamDocumentTypeSpecificSignaturePolicyConfigCreateWithoutTeamInput;
  where: TeamDocumentTypeSpecificSignaturePolicyConfigWhereUniqueInput;
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigCreateWithoutTeamInput = {
  documentType: DocumentBaseType;
  groupPolicies?: InputMaybe<Array<TeamSpecificSignaturePolicyType>>;
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigCreategroupPoliciesInput = {
  set: Array<TeamSpecificSignaturePolicyType>;
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigListRelationFilter = {
  every?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigWhereInput>;
  none?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigWhereInput>;
  some?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigWhereInput>;
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigMaxOrderByAggregateInput = {
  documentType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigMinOrderByAggregateInput = {
  documentType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigOrderByWithAggregationInput = {
  _avg?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigAvgOrderByAggregateInput>;
  _count?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigCountOrderByAggregateInput>;
  _max?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigMaxOrderByAggregateInput>;
  _min?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigMinOrderByAggregateInput>;
  _sum?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigSumOrderByAggregateInput>;
  documentType?: InputMaybe<SortOrder>;
  groupPolicies?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigOrderByWithRelationInput = {
  Team?: InputMaybe<TeamOrderByWithRelationInput>;
  documentType?: InputMaybe<SortOrder>;
  groupPolicies?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export enum TeamDocumentTypeSpecificSignaturePolicyConfigScalarFieldEnum {
  DocumentType = 'documentType',
  GroupPolicies = 'groupPolicies',
  Id = 'id',
  TeamId = 'teamId'
}

export type TeamDocumentTypeSpecificSignaturePolicyConfigScalarWhereInput = {
  AND?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigScalarWhereInput>>;
  NOT?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigScalarWhereInput>>;
  OR?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigScalarWhereInput>>;
  documentType?: InputMaybe<EnumDocumentBaseTypeFilter>;
  groupPolicies?: InputMaybe<EnumTeamSpecificSignaturePolicyTypeNullableListFilter>;
  id?: InputMaybe<IntFilter>;
  teamId?: InputMaybe<IntFilter>;
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigScalarWhereWithAggregatesInput>>;
  documentType?: InputMaybe<EnumDocumentBaseTypeWithAggregatesFilter>;
  groupPolicies?: InputMaybe<EnumTeamSpecificSignaturePolicyTypeNullableListFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  teamId?: InputMaybe<IntWithAggregatesFilter>;
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigTeamIdDocumentTypeCompoundUniqueInput = {
  documentType: DocumentBaseType;
  teamId: Scalars['Int']['input'];
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigUpdateInput = {
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutTeamDocumentTypeSpecificSignaturePolicyConfigNestedInput>;
  documentType?: InputMaybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  groupPolicies?: InputMaybe<Array<TeamSpecificSignaturePolicyType>>;
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigUpdateManyMutationInput = {
  documentType?: InputMaybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  groupPolicies?: InputMaybe<Array<TeamSpecificSignaturePolicyType>>;
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigUpdateManyWithWhereWithoutTeamInput = {
  data: TeamDocumentTypeSpecificSignaturePolicyConfigUpdateManyMutationInput;
  where: TeamDocumentTypeSpecificSignaturePolicyConfigScalarWhereInput;
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigUpdateManyWithoutTeamNestedInput = {
  connect?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigCreateWithoutTeamInput>>;
  createMany?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigCreateManyTeamInputEnvelope>;
  delete?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigWhereUniqueInput>>;
  set?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigWhereUniqueInput>>;
  update?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigUpdateWithWhereUniqueWithoutTeamInput>>;
  updateMany?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigUpdateManyWithWhereWithoutTeamInput>>;
  upsert?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigUpsertWithWhereUniqueWithoutTeamInput>>;
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigUpdateWithWhereUniqueWithoutTeamInput = {
  data: TeamDocumentTypeSpecificSignaturePolicyConfigUpdateWithoutTeamInput;
  where: TeamDocumentTypeSpecificSignaturePolicyConfigWhereUniqueInput;
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigUpdateWithoutTeamInput = {
  documentType?: InputMaybe<EnumDocumentBaseTypeFieldUpdateOperationsInput>;
  groupPolicies?: InputMaybe<Array<TeamSpecificSignaturePolicyType>>;
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigUpdategroupPoliciesInput = {
  push?: InputMaybe<Array<TeamSpecificSignaturePolicyType>>;
  set?: InputMaybe<Array<TeamSpecificSignaturePolicyType>>;
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigUpsertWithWhereUniqueWithoutTeamInput = {
  create: TeamDocumentTypeSpecificSignaturePolicyConfigCreateWithoutTeamInput;
  update: TeamDocumentTypeSpecificSignaturePolicyConfigUpdateWithoutTeamInput;
  where: TeamDocumentTypeSpecificSignaturePolicyConfigWhereUniqueInput;
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigWhereInput = {
  AND?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigWhereInput>>;
  NOT?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigWhereInput>>;
  OR?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigWhereInput>>;
  Team?: InputMaybe<TeamWhereInput>;
  documentType?: InputMaybe<EnumDocumentBaseTypeFilter>;
  groupPolicies?: InputMaybe<EnumTeamSpecificSignaturePolicyTypeNullableListFilter>;
  id?: InputMaybe<IntFilter>;
  teamId?: InputMaybe<IntFilter>;
};

export type TeamDocumentTypeSpecificSignaturePolicyConfigWhereUniqueInput = {
  AND?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigWhereInput>>;
  NOT?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigWhereInput>>;
  OR?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigWhereInput>>;
  Team?: InputMaybe<TeamWhereInput>;
  documentType?: InputMaybe<EnumDocumentBaseTypeFilter>;
  groupPolicies?: InputMaybe<EnumTeamSpecificSignaturePolicyTypeNullableListFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  teamId?: InputMaybe<IntFilter>;
  teamId_documentType?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigTeamIdDocumentTypeCompoundUniqueInput>;
};

export type TeamEducationLevel = {
  __typename?: 'TeamEducationLevel';
  DocumentCertificate: Array<DocumentCertificate>;
  createdAt: Scalars['DateTime']['output'];
  educationLevelType: EducationLevelType;
  id: Scalars['Int']['output'];
  team: Team;
  teamId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type TeamEducationLevelDocumentCertificateArgs = {
  cursor?: InputMaybe<DocumentCertificateWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentCertificateScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentCertificateOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentCertificateWhereInput>;
};

export type TeamEducationLevelAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type TeamEducationLevelCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  educationLevelType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TeamEducationLevelCreateInput = {
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedManyWithoutTeamEducationLevelInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevelType?: InputMaybe<EducationLevelType>;
  team: TeamCreateNestedOneWithoutTeamEducationLevelInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeamEducationLevelCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevelType?: InputMaybe<EducationLevelType>;
  id?: InputMaybe<Scalars['Int']['input']>;
  teamId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeamEducationLevelCreateManyTeamInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevelType?: InputMaybe<EducationLevelType>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeamEducationLevelCreateManyTeamInputEnvelope = {
  data: Array<TeamEducationLevelCreateManyTeamInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TeamEducationLevelCreateNestedManyWithoutTeamInput = {
  connect?: InputMaybe<Array<TeamEducationLevelWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TeamEducationLevelCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<TeamEducationLevelCreateWithoutTeamInput>>;
  createMany?: InputMaybe<TeamEducationLevelCreateManyTeamInputEnvelope>;
};

export type TeamEducationLevelCreateNestedOneWithoutDocumentCertificateInput = {
  connect?: InputMaybe<TeamEducationLevelWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamEducationLevelCreateOrConnectWithoutDocumentCertificateInput>;
  create?: InputMaybe<TeamEducationLevelCreateWithoutDocumentCertificateInput>;
};

export type TeamEducationLevelCreateOrConnectWithoutDocumentCertificateInput = {
  create: TeamEducationLevelCreateWithoutDocumentCertificateInput;
  where: TeamEducationLevelWhereUniqueInput;
};

export type TeamEducationLevelCreateOrConnectWithoutTeamInput = {
  create: TeamEducationLevelCreateWithoutTeamInput;
  where: TeamEducationLevelWhereUniqueInput;
};

export type TeamEducationLevelCreateWithoutDocumentCertificateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevelType?: InputMaybe<EducationLevelType>;
  team: TeamCreateNestedOneWithoutTeamEducationLevelInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeamEducationLevelCreateWithoutTeamInput = {
  DocumentCertificate?: InputMaybe<DocumentCertificateCreateNestedManyWithoutTeamEducationLevelInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  educationLevelType?: InputMaybe<EducationLevelType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeamEducationLevelListRelationFilter = {
  every?: InputMaybe<TeamEducationLevelWhereInput>;
  none?: InputMaybe<TeamEducationLevelWhereInput>;
  some?: InputMaybe<TeamEducationLevelWhereInput>;
};

export type TeamEducationLevelMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  educationLevelType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TeamEducationLevelMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  educationLevelType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TeamEducationLevelOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TeamEducationLevelOrderByWithAggregationInput = {
  _avg?: InputMaybe<TeamEducationLevelAvgOrderByAggregateInput>;
  _count?: InputMaybe<TeamEducationLevelCountOrderByAggregateInput>;
  _max?: InputMaybe<TeamEducationLevelMaxOrderByAggregateInput>;
  _min?: InputMaybe<TeamEducationLevelMinOrderByAggregateInput>;
  _sum?: InputMaybe<TeamEducationLevelSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  educationLevelType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TeamEducationLevelOrderByWithRelationInput = {
  DocumentCertificate?: InputMaybe<DocumentCertificateOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  educationLevelType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  team?: InputMaybe<TeamOrderByWithRelationInput>;
  teamId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TeamEducationLevelRelationFilter = {
  is?: InputMaybe<TeamEducationLevelWhereInput>;
  isNot?: InputMaybe<TeamEducationLevelWhereInput>;
};

export enum TeamEducationLevelScalarFieldEnum {
  CreatedAt = 'createdAt',
  EducationLevelType = 'educationLevelType',
  Id = 'id',
  TeamId = 'teamId',
  UpdatedAt = 'updatedAt'
}

export type TeamEducationLevelScalarWhereInput = {
  AND?: InputMaybe<Array<TeamEducationLevelScalarWhereInput>>;
  NOT?: InputMaybe<Array<TeamEducationLevelScalarWhereInput>>;
  OR?: InputMaybe<Array<TeamEducationLevelScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  educationLevelType?: InputMaybe<EnumEducationLevelTypeFilter>;
  id?: InputMaybe<IntFilter>;
  teamId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type TeamEducationLevelScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<TeamEducationLevelScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<TeamEducationLevelScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<TeamEducationLevelScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  educationLevelType?: InputMaybe<EnumEducationLevelTypeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  teamId?: InputMaybe<IntWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type TeamEducationLevelSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type TeamEducationLevelTeamIdEducationLevelTypeCompoundUniqueInput = {
  educationLevelType: EducationLevelType;
  teamId: Scalars['Int']['input'];
};

export type TeamEducationLevelUpdateInput = {
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateManyWithoutTeamEducationLevelNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  educationLevelType?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  team?: InputMaybe<TeamUpdateOneRequiredWithoutTeamEducationLevelNestedInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamEducationLevelUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  educationLevelType?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamEducationLevelUpdateManyWithWhereWithoutTeamInput = {
  data: TeamEducationLevelUpdateManyMutationInput;
  where: TeamEducationLevelScalarWhereInput;
};

export type TeamEducationLevelUpdateManyWithoutTeamNestedInput = {
  connect?: InputMaybe<Array<TeamEducationLevelWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TeamEducationLevelCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<TeamEducationLevelCreateWithoutTeamInput>>;
  createMany?: InputMaybe<TeamEducationLevelCreateManyTeamInputEnvelope>;
  delete?: InputMaybe<Array<TeamEducationLevelWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TeamEducationLevelScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TeamEducationLevelWhereUniqueInput>>;
  set?: InputMaybe<Array<TeamEducationLevelWhereUniqueInput>>;
  update?: InputMaybe<Array<TeamEducationLevelUpdateWithWhereUniqueWithoutTeamInput>>;
  updateMany?: InputMaybe<Array<TeamEducationLevelUpdateManyWithWhereWithoutTeamInput>>;
  upsert?: InputMaybe<Array<TeamEducationLevelUpsertWithWhereUniqueWithoutTeamInput>>;
};

export type TeamEducationLevelUpdateOneRequiredWithoutDocumentCertificateNestedInput = {
  connect?: InputMaybe<TeamEducationLevelWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamEducationLevelCreateOrConnectWithoutDocumentCertificateInput>;
  create?: InputMaybe<TeamEducationLevelCreateWithoutDocumentCertificateInput>;
  update?: InputMaybe<TeamEducationLevelUpdateToOneWithWhereWithoutDocumentCertificateInput>;
  upsert?: InputMaybe<TeamEducationLevelUpsertWithoutDocumentCertificateInput>;
};

export type TeamEducationLevelUpdateToOneWithWhereWithoutDocumentCertificateInput = {
  data: TeamEducationLevelUpdateWithoutDocumentCertificateInput;
  where?: InputMaybe<TeamEducationLevelWhereInput>;
};

export type TeamEducationLevelUpdateWithWhereUniqueWithoutTeamInput = {
  data: TeamEducationLevelUpdateWithoutTeamInput;
  where: TeamEducationLevelWhereUniqueInput;
};

export type TeamEducationLevelUpdateWithoutDocumentCertificateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  educationLevelType?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  team?: InputMaybe<TeamUpdateOneRequiredWithoutTeamEducationLevelNestedInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamEducationLevelUpdateWithoutTeamInput = {
  DocumentCertificate?: InputMaybe<DocumentCertificateUpdateManyWithoutTeamEducationLevelNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  educationLevelType?: InputMaybe<EnumEducationLevelTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamEducationLevelUpsertWithWhereUniqueWithoutTeamInput = {
  create: TeamEducationLevelCreateWithoutTeamInput;
  update: TeamEducationLevelUpdateWithoutTeamInput;
  where: TeamEducationLevelWhereUniqueInput;
};

export type TeamEducationLevelUpsertWithoutDocumentCertificateInput = {
  create: TeamEducationLevelCreateWithoutDocumentCertificateInput;
  update: TeamEducationLevelUpdateWithoutDocumentCertificateInput;
  where?: InputMaybe<TeamEducationLevelWhereInput>;
};

export type TeamEducationLevelWhereInput = {
  AND?: InputMaybe<Array<TeamEducationLevelWhereInput>>;
  DocumentCertificate?: InputMaybe<DocumentCertificateListRelationFilter>;
  NOT?: InputMaybe<Array<TeamEducationLevelWhereInput>>;
  OR?: InputMaybe<Array<TeamEducationLevelWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  educationLevelType?: InputMaybe<EnumEducationLevelTypeFilter>;
  id?: InputMaybe<IntFilter>;
  team?: InputMaybe<TeamWhereInput>;
  teamId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type TeamEducationLevelWhereUniqueInput = {
  AND?: InputMaybe<Array<TeamEducationLevelWhereInput>>;
  DocumentCertificate?: InputMaybe<DocumentCertificateListRelationFilter>;
  NOT?: InputMaybe<Array<TeamEducationLevelWhereInput>>;
  OR?: InputMaybe<Array<TeamEducationLevelWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  educationLevelType?: InputMaybe<EnumEducationLevelTypeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  team?: InputMaybe<TeamWhereInput>;
  teamId?: InputMaybe<IntFilter>;
  teamId_educationLevelType?: InputMaybe<TeamEducationLevelTeamIdEducationLevelTypeCompoundUniqueInput>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type TeamListRelationFilter = {
  every?: InputMaybe<TeamWhereInput>;
  none?: InputMaybe<TeamWhereInput>;
  some?: InputMaybe<TeamWhereInput>;
};

export type TeamMaxOrderByAggregateInput = {
  cnpj?: InputMaybe<SortOrder>;
  commonUserId?: InputMaybe<SortOrder>;
  configAddDocumentSignerNode?: InputMaybe<SortOrder>;
  contract?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deactivationReason?: InputMaybe<SortOrder>;
  defaultDegreeCertificateTemplateId?: InputMaybe<SortOrder>;
  enabledInstitutionId?: InputMaybe<SortOrder>;
  externalSignatureWebhookURL?: InputMaybe<SortOrder>;
  faviconBase64?: InputMaybe<SortOrder>;
  financialShouldCharge?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  isNSF?: InputMaybe<SortOrder>;
  lastActivityAt?: InputMaybe<SortOrder>;
  logoBase64?: InputMaybe<SortOrder>;
  maintainerId?: InputMaybe<SortOrder>;
  observations?: InputMaybe<SortOrder>;
  placeholderName?: InputMaybe<SortOrder>;
  publicViewDegreeDomainPath?: InputMaybe<SortOrder>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<SortOrder>;
  publicViewInstitutionName?: InputMaybe<SortOrder>;
  publicViewPrimaryColor?: InputMaybe<SortOrder>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<SortOrder>;
  publicViewSecondaryColor?: InputMaybe<SortOrder>;
  showCreateDiploma?: InputMaybe<SortOrder>;
  showImportDiploma?: InputMaybe<SortOrder>;
  spaceUsage?: InputMaybe<SortOrder>;
  storage?: InputMaybe<SortOrder>;
  syncWithLedgerDoc?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  validateCertificateURL?: InputMaybe<SortOrder>;
};

/** CPF cant be externally linked to user, so this table is necessary */
export type TeamMember = {
  __typename?: 'TeamMember';
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems: Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItem>;
  DocumentCertificateSignatureItemPossibleSignerInvites: Array<DocumentCertificateSignatureItemPossibleSignerInvite>;
  Invites: Array<DocumentBaseSignatureInvite>;
  Team: Team;
  TeamMemberPermissions: Array<TeamMemberPermission>;
  User: CommonUser;
  commonUserId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  role?: Maybe<Scalars['String']['output']>;
  teamId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** CPF cant be externally linked to user, so this table is necessary */
export type TeamMemberDocumentBaseDefaultSignatureInviteConfigurationGroupItemsArgs = {
  cursor?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationGroupItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemWhereInput>;
};


/** CPF cant be externally linked to user, so this table is necessary */
export type TeamMemberDocumentCertificateSignatureItemPossibleSignerInvitesArgs = {
  cursor?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentCertificateSignatureItemPossibleSignerInviteOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteWhereInput>;
};


/** CPF cant be externally linked to user, so this table is necessary */
export type TeamMemberInvitesArgs = {
  cursor?: InputMaybe<DocumentBaseSignatureInviteWhereUniqueInput>;
  distinct?: InputMaybe<Array<DocumentBaseSignatureInviteScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DocumentBaseSignatureInviteOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentBaseSignatureInviteWhereInput>;
};


/** CPF cant be externally linked to user, so this table is necessary */
export type TeamMemberTeamMemberPermissionsArgs = {
  cursor?: InputMaybe<TeamMemberPermissionWhereUniqueInput>;
  distinct?: InputMaybe<Array<TeamMemberPermissionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TeamMemberPermissionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeamMemberPermissionWhereInput>;
};

export type TeamMemberAvgOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type TeamMemberCountOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TeamMemberCreateInput = {
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateNestedManyWithoutTeamMemberInput>;
  DocumentCertificateSignatureItemPossibleSignerInvites?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateNestedManyWithoutTeamMemberInput>;
  Invites?: InputMaybe<DocumentBaseSignatureInviteCreateNestedManyWithoutTeamMemberInput>;
  Team: TeamCreateNestedOneWithoutTeamMemberInput;
  TeamMemberPermissions?: InputMaybe<TeamMemberPermissionCreateNestedManyWithoutTeamMemberInput>;
  User: CommonUserCreateNestedOneWithoutTeamMemberInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeamMemberCreateManyInput = {
  commonUserId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeamMemberCreateManyTeamInput = {
  commonUserId: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeamMemberCreateManyTeamInputEnvelope = {
  data: Array<TeamMemberCreateManyTeamInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TeamMemberCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeamMemberCreateManyUserInputEnvelope = {
  data: Array<TeamMemberCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TeamMemberCreateNestedManyWithoutTeamInput = {
  connect?: InputMaybe<Array<TeamMemberWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TeamMemberCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<TeamMemberCreateWithoutTeamInput>>;
  createMany?: InputMaybe<TeamMemberCreateManyTeamInputEnvelope>;
};

export type TeamMemberCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<TeamMemberWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TeamMemberCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<TeamMemberCreateWithoutUserInput>>;
  createMany?: InputMaybe<TeamMemberCreateManyUserInputEnvelope>;
};

export type TeamMemberCreateNestedOneWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput = {
  connect?: InputMaybe<TeamMemberWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamMemberCreateOrConnectWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput>;
  create?: InputMaybe<TeamMemberCreateWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput>;
};

export type TeamMemberCreateNestedOneWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput = {
  connect?: InputMaybe<TeamMemberWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamMemberCreateOrConnectWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput>;
  create?: InputMaybe<TeamMemberCreateWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput>;
};

export type TeamMemberCreateNestedOneWithoutInvitesInput = {
  connect?: InputMaybe<TeamMemberWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamMemberCreateOrConnectWithoutInvitesInput>;
  create?: InputMaybe<TeamMemberCreateWithoutInvitesInput>;
};

export type TeamMemberCreateNestedOneWithoutTeamMemberPermissionsInput = {
  connect?: InputMaybe<TeamMemberWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamMemberCreateOrConnectWithoutTeamMemberPermissionsInput>;
  create?: InputMaybe<TeamMemberCreateWithoutTeamMemberPermissionsInput>;
};

export type TeamMemberCreateOrConnectWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput = {
  create: TeamMemberCreateWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput;
  where: TeamMemberWhereUniqueInput;
};

export type TeamMemberCreateOrConnectWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput = {
  create: TeamMemberCreateWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput;
  where: TeamMemberWhereUniqueInput;
};

export type TeamMemberCreateOrConnectWithoutInvitesInput = {
  create: TeamMemberCreateWithoutInvitesInput;
  where: TeamMemberWhereUniqueInput;
};

export type TeamMemberCreateOrConnectWithoutTeamInput = {
  create: TeamMemberCreateWithoutTeamInput;
  where: TeamMemberWhereUniqueInput;
};

export type TeamMemberCreateOrConnectWithoutTeamMemberPermissionsInput = {
  create: TeamMemberCreateWithoutTeamMemberPermissionsInput;
  where: TeamMemberWhereUniqueInput;
};

export type TeamMemberCreateOrConnectWithoutUserInput = {
  create: TeamMemberCreateWithoutUserInput;
  where: TeamMemberWhereUniqueInput;
};

export type TeamMemberCreateWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput = {
  DocumentCertificateSignatureItemPossibleSignerInvites?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateNestedManyWithoutTeamMemberInput>;
  Invites?: InputMaybe<DocumentBaseSignatureInviteCreateNestedManyWithoutTeamMemberInput>;
  Team: TeamCreateNestedOneWithoutTeamMemberInput;
  TeamMemberPermissions?: InputMaybe<TeamMemberPermissionCreateNestedManyWithoutTeamMemberInput>;
  User: CommonUserCreateNestedOneWithoutTeamMemberInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeamMemberCreateWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput = {
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateNestedManyWithoutTeamMemberInput>;
  Invites?: InputMaybe<DocumentBaseSignatureInviteCreateNestedManyWithoutTeamMemberInput>;
  Team: TeamCreateNestedOneWithoutTeamMemberInput;
  TeamMemberPermissions?: InputMaybe<TeamMemberPermissionCreateNestedManyWithoutTeamMemberInput>;
  User: CommonUserCreateNestedOneWithoutTeamMemberInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeamMemberCreateWithoutInvitesInput = {
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateNestedManyWithoutTeamMemberInput>;
  DocumentCertificateSignatureItemPossibleSignerInvites?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateNestedManyWithoutTeamMemberInput>;
  Team: TeamCreateNestedOneWithoutTeamMemberInput;
  TeamMemberPermissions?: InputMaybe<TeamMemberPermissionCreateNestedManyWithoutTeamMemberInput>;
  User: CommonUserCreateNestedOneWithoutTeamMemberInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeamMemberCreateWithoutTeamInput = {
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateNestedManyWithoutTeamMemberInput>;
  DocumentCertificateSignatureItemPossibleSignerInvites?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateNestedManyWithoutTeamMemberInput>;
  Invites?: InputMaybe<DocumentBaseSignatureInviteCreateNestedManyWithoutTeamMemberInput>;
  TeamMemberPermissions?: InputMaybe<TeamMemberPermissionCreateNestedManyWithoutTeamMemberInput>;
  User: CommonUserCreateNestedOneWithoutTeamMemberInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeamMemberCreateWithoutTeamMemberPermissionsInput = {
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateNestedManyWithoutTeamMemberInput>;
  DocumentCertificateSignatureItemPossibleSignerInvites?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateNestedManyWithoutTeamMemberInput>;
  Invites?: InputMaybe<DocumentBaseSignatureInviteCreateNestedManyWithoutTeamMemberInput>;
  Team: TeamCreateNestedOneWithoutTeamMemberInput;
  User: CommonUserCreateNestedOneWithoutTeamMemberInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeamMemberCreateWithoutUserInput = {
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemCreateNestedManyWithoutTeamMemberInput>;
  DocumentCertificateSignatureItemPossibleSignerInvites?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteCreateNestedManyWithoutTeamMemberInput>;
  Invites?: InputMaybe<DocumentBaseSignatureInviteCreateNestedManyWithoutTeamMemberInput>;
  Team: TeamCreateNestedOneWithoutTeamMemberInput;
  TeamMemberPermissions?: InputMaybe<TeamMemberPermissionCreateNestedManyWithoutTeamMemberInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeamMemberListRelationFilter = {
  every?: InputMaybe<TeamMemberWhereInput>;
  none?: InputMaybe<TeamMemberWhereInput>;
  some?: InputMaybe<TeamMemberWhereInput>;
};

export type TeamMemberMaxOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TeamMemberMinOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TeamMemberNullableRelationFilter = {
  is?: InputMaybe<TeamMemberWhereInput>;
  isNot?: InputMaybe<TeamMemberWhereInput>;
};

export type TeamMemberOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TeamMemberOrderByWithAggregationInput = {
  _avg?: InputMaybe<TeamMemberAvgOrderByAggregateInput>;
  _count?: InputMaybe<TeamMemberCountOrderByAggregateInput>;
  _max?: InputMaybe<TeamMemberMaxOrderByAggregateInput>;
  _min?: InputMaybe<TeamMemberMinOrderByAggregateInput>;
  _sum?: InputMaybe<TeamMemberSumOrderByAggregateInput>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TeamMemberOrderByWithRelationInput = {
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemOrderByRelationAggregateInput>;
  DocumentCertificateSignatureItemPossibleSignerInvites?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteOrderByRelationAggregateInput>;
  Invites?: InputMaybe<DocumentBaseSignatureInviteOrderByRelationAggregateInput>;
  Team?: InputMaybe<TeamOrderByWithRelationInput>;
  TeamMemberPermissions?: InputMaybe<TeamMemberPermissionOrderByRelationAggregateInput>;
  User?: InputMaybe<CommonUserOrderByWithRelationInput>;
  commonUserId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TeamMemberPermission = {
  __typename?: 'TeamMemberPermission';
  Permission: Permission;
  TeamMember: TeamMember;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  permissionCode: Scalars['String']['output'];
  teamMemberId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TeamMemberPermissionAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
};

export type TeamMemberPermissionCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  permissionCode?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TeamMemberPermissionCreateInput = {
  Permission: PermissionCreateNestedOneWithoutTeamMemberPermissionsInput;
  TeamMember: TeamMemberCreateNestedOneWithoutTeamMemberPermissionsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeamMemberPermissionCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  permissionCode: Scalars['String']['input'];
  teamMemberId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeamMemberPermissionCreateManyPermissionInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  teamMemberId: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeamMemberPermissionCreateManyPermissionInputEnvelope = {
  data: Array<TeamMemberPermissionCreateManyPermissionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TeamMemberPermissionCreateManyTeamMemberInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  permissionCode: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeamMemberPermissionCreateManyTeamMemberInputEnvelope = {
  data: Array<TeamMemberPermissionCreateManyTeamMemberInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TeamMemberPermissionCreateNestedManyWithoutPermissionInput = {
  connect?: InputMaybe<Array<TeamMemberPermissionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TeamMemberPermissionCreateOrConnectWithoutPermissionInput>>;
  create?: InputMaybe<Array<TeamMemberPermissionCreateWithoutPermissionInput>>;
  createMany?: InputMaybe<TeamMemberPermissionCreateManyPermissionInputEnvelope>;
};

export type TeamMemberPermissionCreateNestedManyWithoutTeamMemberInput = {
  connect?: InputMaybe<Array<TeamMemberPermissionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TeamMemberPermissionCreateOrConnectWithoutTeamMemberInput>>;
  create?: InputMaybe<Array<TeamMemberPermissionCreateWithoutTeamMemberInput>>;
  createMany?: InputMaybe<TeamMemberPermissionCreateManyTeamMemberInputEnvelope>;
};

export type TeamMemberPermissionCreateOrConnectWithoutPermissionInput = {
  create: TeamMemberPermissionCreateWithoutPermissionInput;
  where: TeamMemberPermissionWhereUniqueInput;
};

export type TeamMemberPermissionCreateOrConnectWithoutTeamMemberInput = {
  create: TeamMemberPermissionCreateWithoutTeamMemberInput;
  where: TeamMemberPermissionWhereUniqueInput;
};

export type TeamMemberPermissionCreateWithoutPermissionInput = {
  TeamMember: TeamMemberCreateNestedOneWithoutTeamMemberPermissionsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeamMemberPermissionCreateWithoutTeamMemberInput = {
  Permission: PermissionCreateNestedOneWithoutTeamMemberPermissionsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TeamMemberPermissionListRelationFilter = {
  every?: InputMaybe<TeamMemberPermissionWhereInput>;
  none?: InputMaybe<TeamMemberPermissionWhereInput>;
  some?: InputMaybe<TeamMemberPermissionWhereInput>;
};

export type TeamMemberPermissionMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  permissionCode?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TeamMemberPermissionMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  permissionCode?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TeamMemberPermissionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TeamMemberPermissionOrderByWithAggregationInput = {
  _avg?: InputMaybe<TeamMemberPermissionAvgOrderByAggregateInput>;
  _count?: InputMaybe<TeamMemberPermissionCountOrderByAggregateInput>;
  _max?: InputMaybe<TeamMemberPermissionMaxOrderByAggregateInput>;
  _min?: InputMaybe<TeamMemberPermissionMinOrderByAggregateInput>;
  _sum?: InputMaybe<TeamMemberPermissionSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  permissionCode?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TeamMemberPermissionOrderByWithRelationInput = {
  Permission?: InputMaybe<PermissionOrderByWithRelationInput>;
  TeamMember?: InputMaybe<TeamMemberOrderByWithRelationInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  permissionCode?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum TeamMemberPermissionScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  PermissionCode = 'permissionCode',
  TeamMemberId = 'teamMemberId',
  UpdatedAt = 'updatedAt'
}

export type TeamMemberPermissionScalarWhereInput = {
  AND?: InputMaybe<Array<TeamMemberPermissionScalarWhereInput>>;
  NOT?: InputMaybe<Array<TeamMemberPermissionScalarWhereInput>>;
  OR?: InputMaybe<Array<TeamMemberPermissionScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  permissionCode?: InputMaybe<StringFilter>;
  teamMemberId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type TeamMemberPermissionScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<TeamMemberPermissionScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<TeamMemberPermissionScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<TeamMemberPermissionScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  permissionCode?: InputMaybe<StringWithAggregatesFilter>;
  teamMemberId?: InputMaybe<IntWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type TeamMemberPermissionSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  teamMemberId?: InputMaybe<SortOrder>;
};

export type TeamMemberPermissionUpdateInput = {
  Permission?: InputMaybe<PermissionUpdateOneRequiredWithoutTeamMemberPermissionsNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateOneRequiredWithoutTeamMemberPermissionsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamMemberPermissionUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamMemberPermissionUpdateManyWithWhereWithoutPermissionInput = {
  data: TeamMemberPermissionUpdateManyMutationInput;
  where: TeamMemberPermissionScalarWhereInput;
};

export type TeamMemberPermissionUpdateManyWithWhereWithoutTeamMemberInput = {
  data: TeamMemberPermissionUpdateManyMutationInput;
  where: TeamMemberPermissionScalarWhereInput;
};

export type TeamMemberPermissionUpdateManyWithoutPermissionNestedInput = {
  connect?: InputMaybe<Array<TeamMemberPermissionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TeamMemberPermissionCreateOrConnectWithoutPermissionInput>>;
  create?: InputMaybe<Array<TeamMemberPermissionCreateWithoutPermissionInput>>;
  createMany?: InputMaybe<TeamMemberPermissionCreateManyPermissionInputEnvelope>;
  delete?: InputMaybe<Array<TeamMemberPermissionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TeamMemberPermissionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TeamMemberPermissionWhereUniqueInput>>;
  set?: InputMaybe<Array<TeamMemberPermissionWhereUniqueInput>>;
  update?: InputMaybe<Array<TeamMemberPermissionUpdateWithWhereUniqueWithoutPermissionInput>>;
  updateMany?: InputMaybe<Array<TeamMemberPermissionUpdateManyWithWhereWithoutPermissionInput>>;
  upsert?: InputMaybe<Array<TeamMemberPermissionUpsertWithWhereUniqueWithoutPermissionInput>>;
};

export type TeamMemberPermissionUpdateManyWithoutTeamMemberNestedInput = {
  connect?: InputMaybe<Array<TeamMemberPermissionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TeamMemberPermissionCreateOrConnectWithoutTeamMemberInput>>;
  create?: InputMaybe<Array<TeamMemberPermissionCreateWithoutTeamMemberInput>>;
  createMany?: InputMaybe<TeamMemberPermissionCreateManyTeamMemberInputEnvelope>;
  delete?: InputMaybe<Array<TeamMemberPermissionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TeamMemberPermissionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TeamMemberPermissionWhereUniqueInput>>;
  set?: InputMaybe<Array<TeamMemberPermissionWhereUniqueInput>>;
  update?: InputMaybe<Array<TeamMemberPermissionUpdateWithWhereUniqueWithoutTeamMemberInput>>;
  updateMany?: InputMaybe<Array<TeamMemberPermissionUpdateManyWithWhereWithoutTeamMemberInput>>;
  upsert?: InputMaybe<Array<TeamMemberPermissionUpsertWithWhereUniqueWithoutTeamMemberInput>>;
};

export type TeamMemberPermissionUpdateWithWhereUniqueWithoutPermissionInput = {
  data: TeamMemberPermissionUpdateWithoutPermissionInput;
  where: TeamMemberPermissionWhereUniqueInput;
};

export type TeamMemberPermissionUpdateWithWhereUniqueWithoutTeamMemberInput = {
  data: TeamMemberPermissionUpdateWithoutTeamMemberInput;
  where: TeamMemberPermissionWhereUniqueInput;
};

export type TeamMemberPermissionUpdateWithoutPermissionInput = {
  TeamMember?: InputMaybe<TeamMemberUpdateOneRequiredWithoutTeamMemberPermissionsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamMemberPermissionUpdateWithoutTeamMemberInput = {
  Permission?: InputMaybe<PermissionUpdateOneRequiredWithoutTeamMemberPermissionsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamMemberPermissionUpsertWithWhereUniqueWithoutPermissionInput = {
  create: TeamMemberPermissionCreateWithoutPermissionInput;
  update: TeamMemberPermissionUpdateWithoutPermissionInput;
  where: TeamMemberPermissionWhereUniqueInput;
};

export type TeamMemberPermissionUpsertWithWhereUniqueWithoutTeamMemberInput = {
  create: TeamMemberPermissionCreateWithoutTeamMemberInput;
  update: TeamMemberPermissionUpdateWithoutTeamMemberInput;
  where: TeamMemberPermissionWhereUniqueInput;
};

export type TeamMemberPermissionWhereInput = {
  AND?: InputMaybe<Array<TeamMemberPermissionWhereInput>>;
  NOT?: InputMaybe<Array<TeamMemberPermissionWhereInput>>;
  OR?: InputMaybe<Array<TeamMemberPermissionWhereInput>>;
  Permission?: InputMaybe<PermissionWhereInput>;
  TeamMember?: InputMaybe<TeamMemberWhereInput>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  permissionCode?: InputMaybe<StringFilter>;
  teamMemberId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type TeamMemberPermissionWhereUniqueInput = {
  AND?: InputMaybe<Array<TeamMemberPermissionWhereInput>>;
  NOT?: InputMaybe<Array<TeamMemberPermissionWhereInput>>;
  OR?: InputMaybe<Array<TeamMemberPermissionWhereInput>>;
  Permission?: InputMaybe<PermissionWhereInput>;
  TeamMember?: InputMaybe<TeamMemberWhereInput>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  permissionCode?: InputMaybe<StringFilter>;
  teamMemberId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type TeamMemberRelationFilter = {
  is?: InputMaybe<TeamMemberWhereInput>;
  isNot?: InputMaybe<TeamMemberWhereInput>;
};

export enum TeamMemberScalarFieldEnum {
  CommonUserId = 'commonUserId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Role = 'role',
  TeamId = 'teamId',
  UpdatedAt = 'updatedAt'
}

export type TeamMemberScalarWhereInput = {
  AND?: InputMaybe<Array<TeamMemberScalarWhereInput>>;
  NOT?: InputMaybe<Array<TeamMemberScalarWhereInput>>;
  OR?: InputMaybe<Array<TeamMemberScalarWhereInput>>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  role?: InputMaybe<StringNullableFilter>;
  teamId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type TeamMemberScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<TeamMemberScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<TeamMemberScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<TeamMemberScalarWhereWithAggregatesInput>>;
  commonUserId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  role?: InputMaybe<StringNullableWithAggregatesFilter>;
  teamId?: InputMaybe<IntWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type TeamMemberSumOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  teamId?: InputMaybe<SortOrder>;
};

export type TeamMemberTeamIdCommonUserIdCompoundUniqueInput = {
  commonUserId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
};

export type TeamMemberUpdateInput = {
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithoutTeamMemberNestedInput>;
  DocumentCertificateSignatureItemPossibleSignerInvites?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithoutTeamMemberNestedInput>;
  Invites?: InputMaybe<DocumentBaseSignatureInviteUpdateManyWithoutTeamMemberNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutTeamMemberNestedInput>;
  TeamMemberPermissions?: InputMaybe<TeamMemberPermissionUpdateManyWithoutTeamMemberNestedInput>;
  User?: InputMaybe<CommonUserUpdateOneRequiredWithoutTeamMemberNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  role?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamMemberUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  role?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamMemberUpdateManyWithWhereWithoutTeamInput = {
  data: TeamMemberUpdateManyMutationInput;
  where: TeamMemberScalarWhereInput;
};

export type TeamMemberUpdateManyWithWhereWithoutUserInput = {
  data: TeamMemberUpdateManyMutationInput;
  where: TeamMemberScalarWhereInput;
};

export type TeamMemberUpdateManyWithoutTeamNestedInput = {
  connect?: InputMaybe<Array<TeamMemberWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TeamMemberCreateOrConnectWithoutTeamInput>>;
  create?: InputMaybe<Array<TeamMemberCreateWithoutTeamInput>>;
  createMany?: InputMaybe<TeamMemberCreateManyTeamInputEnvelope>;
  delete?: InputMaybe<Array<TeamMemberWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TeamMemberScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TeamMemberWhereUniqueInput>>;
  set?: InputMaybe<Array<TeamMemberWhereUniqueInput>>;
  update?: InputMaybe<Array<TeamMemberUpdateWithWhereUniqueWithoutTeamInput>>;
  updateMany?: InputMaybe<Array<TeamMemberUpdateManyWithWhereWithoutTeamInput>>;
  upsert?: InputMaybe<Array<TeamMemberUpsertWithWhereUniqueWithoutTeamInput>>;
};

export type TeamMemberUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<TeamMemberWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TeamMemberCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<TeamMemberCreateWithoutUserInput>>;
  createMany?: InputMaybe<TeamMemberCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<TeamMemberWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TeamMemberScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TeamMemberWhereUniqueInput>>;
  set?: InputMaybe<Array<TeamMemberWhereUniqueInput>>;
  update?: InputMaybe<Array<TeamMemberUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<TeamMemberUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<TeamMemberUpsertWithWhereUniqueWithoutUserInput>>;
};

export type TeamMemberUpdateOneRequiredWithoutDocumentCertificateSignatureItemPossibleSignerInvitesNestedInput = {
  connect?: InputMaybe<TeamMemberWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamMemberCreateOrConnectWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput>;
  create?: InputMaybe<TeamMemberCreateWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput>;
  update?: InputMaybe<TeamMemberUpdateToOneWithWhereWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput>;
  upsert?: InputMaybe<TeamMemberUpsertWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput>;
};

export type TeamMemberUpdateOneRequiredWithoutTeamMemberPermissionsNestedInput = {
  connect?: InputMaybe<TeamMemberWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamMemberCreateOrConnectWithoutTeamMemberPermissionsInput>;
  create?: InputMaybe<TeamMemberCreateWithoutTeamMemberPermissionsInput>;
  update?: InputMaybe<TeamMemberUpdateToOneWithWhereWithoutTeamMemberPermissionsInput>;
  upsert?: InputMaybe<TeamMemberUpsertWithoutTeamMemberPermissionsInput>;
};

export type TeamMemberUpdateOneWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsNestedInput = {
  connect?: InputMaybe<TeamMemberWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamMemberCreateOrConnectWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput>;
  create?: InputMaybe<TeamMemberCreateWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput>;
  delete?: InputMaybe<TeamMemberWhereInput>;
  disconnect?: InputMaybe<TeamMemberWhereInput>;
  update?: InputMaybe<TeamMemberUpdateToOneWithWhereWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput>;
  upsert?: InputMaybe<TeamMemberUpsertWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput>;
};

export type TeamMemberUpdateOneWithoutInvitesNestedInput = {
  connect?: InputMaybe<TeamMemberWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamMemberCreateOrConnectWithoutInvitesInput>;
  create?: InputMaybe<TeamMemberCreateWithoutInvitesInput>;
  delete?: InputMaybe<TeamMemberWhereInput>;
  disconnect?: InputMaybe<TeamMemberWhereInput>;
  update?: InputMaybe<TeamMemberUpdateToOneWithWhereWithoutInvitesInput>;
  upsert?: InputMaybe<TeamMemberUpsertWithoutInvitesInput>;
};

export type TeamMemberUpdateToOneWithWhereWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput = {
  data: TeamMemberUpdateWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput;
  where?: InputMaybe<TeamMemberWhereInput>;
};

export type TeamMemberUpdateToOneWithWhereWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput = {
  data: TeamMemberUpdateWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput;
  where?: InputMaybe<TeamMemberWhereInput>;
};

export type TeamMemberUpdateToOneWithWhereWithoutInvitesInput = {
  data: TeamMemberUpdateWithoutInvitesInput;
  where?: InputMaybe<TeamMemberWhereInput>;
};

export type TeamMemberUpdateToOneWithWhereWithoutTeamMemberPermissionsInput = {
  data: TeamMemberUpdateWithoutTeamMemberPermissionsInput;
  where?: InputMaybe<TeamMemberWhereInput>;
};

export type TeamMemberUpdateWithWhereUniqueWithoutTeamInput = {
  data: TeamMemberUpdateWithoutTeamInput;
  where: TeamMemberWhereUniqueInput;
};

export type TeamMemberUpdateWithWhereUniqueWithoutUserInput = {
  data: TeamMemberUpdateWithoutUserInput;
  where: TeamMemberWhereUniqueInput;
};

export type TeamMemberUpdateWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput = {
  DocumentCertificateSignatureItemPossibleSignerInvites?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithoutTeamMemberNestedInput>;
  Invites?: InputMaybe<DocumentBaseSignatureInviteUpdateManyWithoutTeamMemberNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutTeamMemberNestedInput>;
  TeamMemberPermissions?: InputMaybe<TeamMemberPermissionUpdateManyWithoutTeamMemberNestedInput>;
  User?: InputMaybe<CommonUserUpdateOneRequiredWithoutTeamMemberNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  role?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamMemberUpdateWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput = {
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithoutTeamMemberNestedInput>;
  Invites?: InputMaybe<DocumentBaseSignatureInviteUpdateManyWithoutTeamMemberNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutTeamMemberNestedInput>;
  TeamMemberPermissions?: InputMaybe<TeamMemberPermissionUpdateManyWithoutTeamMemberNestedInput>;
  User?: InputMaybe<CommonUserUpdateOneRequiredWithoutTeamMemberNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  role?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamMemberUpdateWithoutInvitesInput = {
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithoutTeamMemberNestedInput>;
  DocumentCertificateSignatureItemPossibleSignerInvites?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithoutTeamMemberNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutTeamMemberNestedInput>;
  TeamMemberPermissions?: InputMaybe<TeamMemberPermissionUpdateManyWithoutTeamMemberNestedInput>;
  User?: InputMaybe<CommonUserUpdateOneRequiredWithoutTeamMemberNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  role?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamMemberUpdateWithoutTeamInput = {
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithoutTeamMemberNestedInput>;
  DocumentCertificateSignatureItemPossibleSignerInvites?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithoutTeamMemberNestedInput>;
  Invites?: InputMaybe<DocumentBaseSignatureInviteUpdateManyWithoutTeamMemberNestedInput>;
  TeamMemberPermissions?: InputMaybe<TeamMemberPermissionUpdateManyWithoutTeamMemberNestedInput>;
  User?: InputMaybe<CommonUserUpdateOneRequiredWithoutTeamMemberNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  role?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamMemberUpdateWithoutTeamMemberPermissionsInput = {
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithoutTeamMemberNestedInput>;
  DocumentCertificateSignatureItemPossibleSignerInvites?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithoutTeamMemberNestedInput>;
  Invites?: InputMaybe<DocumentBaseSignatureInviteUpdateManyWithoutTeamMemberNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutTeamMemberNestedInput>;
  User?: InputMaybe<CommonUserUpdateOneRequiredWithoutTeamMemberNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  role?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamMemberUpdateWithoutUserInput = {
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemUpdateManyWithoutTeamMemberNestedInput>;
  DocumentCertificateSignatureItemPossibleSignerInvites?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteUpdateManyWithoutTeamMemberNestedInput>;
  Invites?: InputMaybe<DocumentBaseSignatureInviteUpdateManyWithoutTeamMemberNestedInput>;
  Team?: InputMaybe<TeamUpdateOneRequiredWithoutTeamMemberNestedInput>;
  TeamMemberPermissions?: InputMaybe<TeamMemberPermissionUpdateManyWithoutTeamMemberNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  role?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type TeamMemberUpsertWithWhereUniqueWithoutTeamInput = {
  create: TeamMemberCreateWithoutTeamInput;
  update: TeamMemberUpdateWithoutTeamInput;
  where: TeamMemberWhereUniqueInput;
};

export type TeamMemberUpsertWithWhereUniqueWithoutUserInput = {
  create: TeamMemberCreateWithoutUserInput;
  update: TeamMemberUpdateWithoutUserInput;
  where: TeamMemberWhereUniqueInput;
};

export type TeamMemberUpsertWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput = {
  create: TeamMemberCreateWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput;
  update: TeamMemberUpdateWithoutDocumentBaseDefaultSignatureInviteConfigurationGroupItemsInput;
  where?: InputMaybe<TeamMemberWhereInput>;
};

export type TeamMemberUpsertWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput = {
  create: TeamMemberCreateWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput;
  update: TeamMemberUpdateWithoutDocumentCertificateSignatureItemPossibleSignerInvitesInput;
  where?: InputMaybe<TeamMemberWhereInput>;
};

export type TeamMemberUpsertWithoutInvitesInput = {
  create: TeamMemberCreateWithoutInvitesInput;
  update: TeamMemberUpdateWithoutInvitesInput;
  where?: InputMaybe<TeamMemberWhereInput>;
};

export type TeamMemberUpsertWithoutTeamMemberPermissionsInput = {
  create: TeamMemberCreateWithoutTeamMemberPermissionsInput;
  update: TeamMemberUpdateWithoutTeamMemberPermissionsInput;
  where?: InputMaybe<TeamMemberWhereInput>;
};

export type TeamMemberWhereInput = {
  AND?: InputMaybe<Array<TeamMemberWhereInput>>;
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemListRelationFilter>;
  DocumentCertificateSignatureItemPossibleSignerInvites?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteListRelationFilter>;
  Invites?: InputMaybe<DocumentBaseSignatureInviteListRelationFilter>;
  NOT?: InputMaybe<Array<TeamMemberWhereInput>>;
  OR?: InputMaybe<Array<TeamMemberWhereInput>>;
  Team?: InputMaybe<TeamWhereInput>;
  TeamMemberPermissions?: InputMaybe<TeamMemberPermissionListRelationFilter>;
  User?: InputMaybe<CommonUserWhereInput>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  role?: InputMaybe<StringNullableFilter>;
  teamId?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type TeamMemberWhereUniqueInput = {
  AND?: InputMaybe<Array<TeamMemberWhereInput>>;
  DocumentBaseDefaultSignatureInviteConfigurationGroupItems?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationGroupItemListRelationFilter>;
  DocumentCertificateSignatureItemPossibleSignerInvites?: InputMaybe<DocumentCertificateSignatureItemPossibleSignerInviteListRelationFilter>;
  Invites?: InputMaybe<DocumentBaseSignatureInviteListRelationFilter>;
  NOT?: InputMaybe<Array<TeamMemberWhereInput>>;
  OR?: InputMaybe<Array<TeamMemberWhereInput>>;
  Team?: InputMaybe<TeamWhereInput>;
  TeamMemberPermissions?: InputMaybe<TeamMemberPermissionListRelationFilter>;
  User?: InputMaybe<CommonUserWhereInput>;
  commonUserId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<StringNullableFilter>;
  teamId?: InputMaybe<IntFilter>;
  teamId_commonUserId?: InputMaybe<TeamMemberTeamIdCommonUserIdCompoundUniqueInput>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type TeamMinOrderByAggregateInput = {
  cnpj?: InputMaybe<SortOrder>;
  commonUserId?: InputMaybe<SortOrder>;
  configAddDocumentSignerNode?: InputMaybe<SortOrder>;
  contract?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deactivationReason?: InputMaybe<SortOrder>;
  defaultDegreeCertificateTemplateId?: InputMaybe<SortOrder>;
  enabledInstitutionId?: InputMaybe<SortOrder>;
  externalSignatureWebhookURL?: InputMaybe<SortOrder>;
  faviconBase64?: InputMaybe<SortOrder>;
  financialShouldCharge?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  isNSF?: InputMaybe<SortOrder>;
  lastActivityAt?: InputMaybe<SortOrder>;
  logoBase64?: InputMaybe<SortOrder>;
  maintainerId?: InputMaybe<SortOrder>;
  observations?: InputMaybe<SortOrder>;
  placeholderName?: InputMaybe<SortOrder>;
  publicViewDegreeDomainPath?: InputMaybe<SortOrder>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<SortOrder>;
  publicViewInstitutionName?: InputMaybe<SortOrder>;
  publicViewPrimaryColor?: InputMaybe<SortOrder>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<SortOrder>;
  publicViewSecondaryColor?: InputMaybe<SortOrder>;
  showCreateDiploma?: InputMaybe<SortOrder>;
  showImportDiploma?: InputMaybe<SortOrder>;
  spaceUsage?: InputMaybe<SortOrder>;
  storage?: InputMaybe<SortOrder>;
  syncWithLedgerDoc?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  validateCertificateURL?: InputMaybe<SortOrder>;
};

export type TeamNullableRelationFilter = {
  is?: InputMaybe<TeamWhereInput>;
  isNot?: InputMaybe<TeamWhereInput>;
};

export type TeamOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TeamOrderByWithAggregationInput = {
  _avg?: InputMaybe<TeamAvgOrderByAggregateInput>;
  _count?: InputMaybe<TeamCountOrderByAggregateInput>;
  _max?: InputMaybe<TeamMaxOrderByAggregateInput>;
  _min?: InputMaybe<TeamMinOrderByAggregateInput>;
  _sum?: InputMaybe<TeamSumOrderByAggregateInput>;
  cnpj?: InputMaybe<SortOrder>;
  commonUserId?: InputMaybe<SortOrder>;
  configAddDocumentSignerNode?: InputMaybe<SortOrder>;
  contract?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deactivationReason?: InputMaybe<SortOrder>;
  defaultDegreeCertificateTemplateId?: InputMaybe<SortOrder>;
  enabledInstitutionId?: InputMaybe<SortOrder>;
  externalSignatureWebhookURL?: InputMaybe<SortOrder>;
  faviconBase64?: InputMaybe<SortOrder>;
  financialShouldCharge?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  isNSF?: InputMaybe<SortOrder>;
  lastActivityAt?: InputMaybe<SortOrder>;
  logoBase64?: InputMaybe<SortOrder>;
  maintainerId?: InputMaybe<SortOrder>;
  observations?: InputMaybe<SortOrder>;
  placeholderName?: InputMaybe<SortOrder>;
  publicViewDegreeDomainPath?: InputMaybe<SortOrder>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<SortOrder>;
  publicViewInstitutionName?: InputMaybe<SortOrder>;
  publicViewPrimaryColor?: InputMaybe<SortOrder>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<SortOrder>;
  publicViewSecondaryColor?: InputMaybe<SortOrder>;
  showCreateDiploma?: InputMaybe<SortOrder>;
  showImportDiploma?: InputMaybe<SortOrder>;
  spaceUsage?: InputMaybe<SortOrder>;
  storage?: InputMaybe<SortOrder>;
  syncWithLedgerDoc?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  validateCertificateURL?: InputMaybe<SortOrder>;
};

export type TeamOrderByWithRelationInput = {
  ApiKey?: InputMaybe<ApiKeyOrderByRelationAggregateInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordOrderByRelationAggregateInput>;
  CertificateBase?: InputMaybe<CertificateBaseOrderByRelationAggregateInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateOrderByRelationAggregateInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateOrderByWithRelationInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationOrderByRelationAggregateInput>;
  Documents?: InputMaybe<DocumentBaseOrderByRelationAggregateInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionOrderByWithRelationInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletOrderByWithRelationInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerOrderByWithRelationInput>;
  Maintainer?: InputMaybe<MaintainerOrderByWithRelationInput>;
  Owner?: InputMaybe<CommonUserOrderByWithRelationInput>;
  Person?: InputMaybe<PersonOrderByRelationAggregateInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataOrderByRelationAggregateInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumOrderByRelationAggregateInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogOrderByRelationAggregateInput>;
  TeamContracts?: InputMaybe<TeamContractOrderByRelationAggregateInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigOrderByRelationAggregateInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelOrderByRelationAggregateInput>;
  TeamMember?: InputMaybe<TeamMemberOrderByRelationAggregateInput>;
  cnpj?: InputMaybe<SortOrder>;
  commonUserId?: InputMaybe<SortOrder>;
  configAddDocumentSignerNode?: InputMaybe<SortOrder>;
  contract?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  deactivationReason?: InputMaybe<SortOrder>;
  defaultDegreeCertificateTemplateId?: InputMaybe<SortOrder>;
  enabledInstitutionId?: InputMaybe<SortOrder>;
  externalSignatureWebhookURL?: InputMaybe<SortOrder>;
  faviconBase64?: InputMaybe<SortOrder>;
  financialShouldCharge?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  isNSF?: InputMaybe<SortOrder>;
  lastActivityAt?: InputMaybe<SortOrder>;
  logoBase64?: InputMaybe<SortOrder>;
  maintainerId?: InputMaybe<SortOrder>;
  observations?: InputMaybe<SortOrder>;
  placeholderName?: InputMaybe<SortOrder>;
  publicViewDegreeDomainPath?: InputMaybe<SortOrder>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<SortOrder>;
  publicViewInstitutionName?: InputMaybe<SortOrder>;
  publicViewPrimaryColor?: InputMaybe<SortOrder>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<SortOrder>;
  publicViewSecondaryColor?: InputMaybe<SortOrder>;
  showCreateDiploma?: InputMaybe<SortOrder>;
  showImportDiploma?: InputMaybe<SortOrder>;
  spaceUsage?: InputMaybe<SortOrder>;
  storage?: InputMaybe<SortOrder>;
  syncWithLedgerDoc?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  validateCertificateURL?: InputMaybe<SortOrder>;
};

export type TeamRelationFilter = {
  is?: InputMaybe<TeamWhereInput>;
  isNot?: InputMaybe<TeamWhereInput>;
};

export enum TeamScalarFieldEnum {
  Cnpj = 'cnpj',
  CommonUserId = 'commonUserId',
  ConfigAddDocumentSignerNode = 'configAddDocumentSignerNode',
  Contract = 'contract',
  CreatedAt = 'createdAt',
  DeactivationReason = 'deactivationReason',
  DefaultDegreeCertificateTemplateId = 'defaultDegreeCertificateTemplateId',
  EnabledInstitutionId = 'enabledInstitutionId',
  ExternalSignatureWebhookUrl = 'externalSignatureWebhookURL',
  FaviconBase64 = 'faviconBase64',
  FinancialShouldCharge = 'financialShouldCharge',
  Id = 'id',
  IsActive = 'isActive',
  IsNsf = 'isNSF',
  LastActivityAt = 'lastActivityAt',
  LogoBase64 = 'logoBase64',
  MaintainerId = 'maintainerId',
  Observations = 'observations',
  PlaceholderName = 'placeholderName',
  PublicViewDegreeDomainPath = 'publicViewDegreeDomainPath',
  PublicViewFinalAcademicTranscriptDomainPath = 'publicViewFinalAcademicTranscriptDomainPath',
  PublicViewInstitutionName = 'publicViewInstitutionName',
  PublicViewPrimaryColor = 'publicViewPrimaryColor',
  PublicViewSchoolCurriculumDomainPath = 'publicViewSchoolCurriculumDomainPath',
  PublicViewSecondaryColor = 'publicViewSecondaryColor',
  ShowCreateDiploma = 'showCreateDiploma',
  ShowImportDiploma = 'showImportDiploma',
  SpaceUsage = 'spaceUsage',
  Storage = 'storage',
  SyncWithLedgerDoc = 'syncWithLedgerDoc',
  UpdatedAt = 'updatedAt',
  ValidateCertificateUrl = 'validateCertificateURL'
}

export type TeamScalarWhereInput = {
  AND?: InputMaybe<Array<TeamScalarWhereInput>>;
  NOT?: InputMaybe<Array<TeamScalarWhereInput>>;
  OR?: InputMaybe<Array<TeamScalarWhereInput>>;
  cnpj?: InputMaybe<StringNullableFilter>;
  commonUserId?: InputMaybe<IntFilter>;
  configAddDocumentSignerNode?: InputMaybe<BoolFilter>;
  contract?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deactivationReason?: InputMaybe<StringNullableFilter>;
  defaultDegreeCertificateTemplateId?: InputMaybe<StringNullableFilter>;
  enabledInstitutionId?: InputMaybe<IntNullableFilter>;
  externalSignatureWebhookURL?: InputMaybe<StringNullableFilter>;
  faviconBase64?: InputMaybe<StringNullableFilter>;
  financialShouldCharge?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  isActive?: InputMaybe<BoolFilter>;
  isNSF?: InputMaybe<BoolFilter>;
  lastActivityAt?: InputMaybe<DateTimeFilter>;
  logoBase64?: InputMaybe<StringNullableFilter>;
  maintainerId?: InputMaybe<IntNullableFilter>;
  observations?: InputMaybe<StringFilter>;
  placeholderName?: InputMaybe<StringFilter>;
  publicViewDegreeDomainPath?: InputMaybe<StringNullableFilter>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<StringNullableFilter>;
  publicViewInstitutionName?: InputMaybe<StringNullableFilter>;
  publicViewPrimaryColor?: InputMaybe<StringNullableFilter>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<StringNullableFilter>;
  publicViewSecondaryColor?: InputMaybe<StringNullableFilter>;
  showCreateDiploma?: InputMaybe<BoolFilter>;
  showImportDiploma?: InputMaybe<BoolFilter>;
  spaceUsage?: InputMaybe<BigIntFilter>;
  storage?: InputMaybe<IntFilter>;
  syncWithLedgerDoc?: InputMaybe<BoolFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  validateCertificateURL?: InputMaybe<StringNullableFilter>;
};

export type TeamScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<TeamScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<TeamScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<TeamScalarWhereWithAggregatesInput>>;
  cnpj?: InputMaybe<StringNullableWithAggregatesFilter>;
  commonUserId?: InputMaybe<IntWithAggregatesFilter>;
  configAddDocumentSignerNode?: InputMaybe<BoolWithAggregatesFilter>;
  contract?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  deactivationReason?: InputMaybe<StringNullableWithAggregatesFilter>;
  defaultDegreeCertificateTemplateId?: InputMaybe<StringNullableWithAggregatesFilter>;
  enabledInstitutionId?: InputMaybe<IntNullableWithAggregatesFilter>;
  externalSignatureWebhookURL?: InputMaybe<StringNullableWithAggregatesFilter>;
  faviconBase64?: InputMaybe<StringNullableWithAggregatesFilter>;
  financialShouldCharge?: InputMaybe<BoolWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  isActive?: InputMaybe<BoolWithAggregatesFilter>;
  isNSF?: InputMaybe<BoolWithAggregatesFilter>;
  lastActivityAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  logoBase64?: InputMaybe<StringNullableWithAggregatesFilter>;
  maintainerId?: InputMaybe<IntNullableWithAggregatesFilter>;
  observations?: InputMaybe<StringWithAggregatesFilter>;
  placeholderName?: InputMaybe<StringWithAggregatesFilter>;
  publicViewDegreeDomainPath?: InputMaybe<StringNullableWithAggregatesFilter>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<StringNullableWithAggregatesFilter>;
  publicViewInstitutionName?: InputMaybe<StringNullableWithAggregatesFilter>;
  publicViewPrimaryColor?: InputMaybe<StringNullableWithAggregatesFilter>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<StringNullableWithAggregatesFilter>;
  publicViewSecondaryColor?: InputMaybe<StringNullableWithAggregatesFilter>;
  showCreateDiploma?: InputMaybe<BoolWithAggregatesFilter>;
  showImportDiploma?: InputMaybe<BoolWithAggregatesFilter>;
  spaceUsage?: InputMaybe<BigIntWithAggregatesFilter>;
  storage?: InputMaybe<IntWithAggregatesFilter>;
  syncWithLedgerDoc?: InputMaybe<BoolWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  validateCertificateURL?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export enum TeamSpecificSignaturePolicyType {
  Ra = 'RA',
  Rb = 'RB',
  Rc = 'RC',
  Rt = 'RT'
}

export type TeamSumOrderByAggregateInput = {
  commonUserId?: InputMaybe<SortOrder>;
  enabledInstitutionId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  maintainerId?: InputMaybe<SortOrder>;
  spaceUsage?: InputMaybe<SortOrder>;
  storage?: InputMaybe<SortOrder>;
};

export type TeamUpdateInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateUpdateOneWithoutTeamUsingAsPrimaryNestedInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: InputMaybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: InputMaybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: InputMaybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: InputMaybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamContracts?: InputMaybe<TeamContractUpdateManyWithoutTeamNestedInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contract?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isNSF?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  observations?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeholderName?: InputMaybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  showCreateDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showImportDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spaceUsage?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  storage?: InputMaybe<IntFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateManyMutationInput = {
  cnpj?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contract?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isNSF?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  observations?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeholderName?: InputMaybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  showCreateDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showImportDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spaceUsage?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  storage?: InputMaybe<IntFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateManyWithWhereWithoutMaintainerInput = {
  data: TeamUpdateManyMutationInput;
  where: TeamScalarWhereInput;
};

export type TeamUpdateManyWithWhereWithoutOwnerInput = {
  data: TeamUpdateManyMutationInput;
  where: TeamScalarWhereInput;
};

export type TeamUpdateManyWithoutMaintainerNestedInput = {
  connect?: InputMaybe<Array<TeamWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TeamCreateOrConnectWithoutMaintainerInput>>;
  create?: InputMaybe<Array<TeamCreateWithoutMaintainerInput>>;
  createMany?: InputMaybe<TeamCreateManyMaintainerInputEnvelope>;
  delete?: InputMaybe<Array<TeamWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TeamScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TeamWhereUniqueInput>>;
  set?: InputMaybe<Array<TeamWhereUniqueInput>>;
  update?: InputMaybe<Array<TeamUpdateWithWhereUniqueWithoutMaintainerInput>>;
  updateMany?: InputMaybe<Array<TeamUpdateManyWithWhereWithoutMaintainerInput>>;
  upsert?: InputMaybe<Array<TeamUpsertWithWhereUniqueWithoutMaintainerInput>>;
};

export type TeamUpdateManyWithoutOwnerNestedInput = {
  connect?: InputMaybe<Array<TeamWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TeamCreateOrConnectWithoutOwnerInput>>;
  create?: InputMaybe<Array<TeamCreateWithoutOwnerInput>>;
  createMany?: InputMaybe<TeamCreateManyOwnerInputEnvelope>;
  delete?: InputMaybe<Array<TeamWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TeamScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TeamWhereUniqueInput>>;
  set?: InputMaybe<Array<TeamWhereUniqueInput>>;
  update?: InputMaybe<Array<TeamUpdateWithWhereUniqueWithoutOwnerInput>>;
  updateMany?: InputMaybe<Array<TeamUpdateManyWithWhereWithoutOwnerInput>>;
  upsert?: InputMaybe<Array<TeamUpsertWithWhereUniqueWithoutOwnerInput>>;
};

export type TeamUpdateOneRequiredWithoutApiKeyNestedInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutApiKeyInput>;
  create?: InputMaybe<TeamCreateWithoutApiKeyInput>;
  update?: InputMaybe<TeamUpdateToOneWithWhereWithoutApiKeyInput>;
  upsert?: InputMaybe<TeamUpsertWithoutApiKeyInput>;
};

export type TeamUpdateOneRequiredWithoutBulkCertificateRecordNestedInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutBulkCertificateRecordInput>;
  create?: InputMaybe<TeamCreateWithoutBulkCertificateRecordInput>;
  update?: InputMaybe<TeamUpdateToOneWithWhereWithoutBulkCertificateRecordInput>;
  upsert?: InputMaybe<TeamUpsertWithoutBulkCertificateRecordInput>;
};

export type TeamUpdateOneRequiredWithoutCertificateBaseNestedInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutCertificateBaseInput>;
  create?: InputMaybe<TeamCreateWithoutCertificateBaseInput>;
  update?: InputMaybe<TeamUpdateToOneWithWhereWithoutCertificateBaseInput>;
  upsert?: InputMaybe<TeamUpsertWithoutCertificateBaseInput>;
};

export type TeamUpdateOneRequiredWithoutCertificateTemplatesNestedInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutCertificateTemplatesInput>;
  create?: InputMaybe<TeamCreateWithoutCertificateTemplatesInput>;
  update?: InputMaybe<TeamUpdateToOneWithWhereWithoutCertificateTemplatesInput>;
  upsert?: InputMaybe<TeamUpsertWithoutCertificateTemplatesInput>;
};

export type TeamUpdateOneRequiredWithoutDefaultSignatureInviteConfigurationsNestedInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutDefaultSignatureInviteConfigurationsInput>;
  create?: InputMaybe<TeamCreateWithoutDefaultSignatureInviteConfigurationsInput>;
  update?: InputMaybe<TeamUpdateToOneWithWhereWithoutDefaultSignatureInviteConfigurationsInput>;
  upsert?: InputMaybe<TeamUpsertWithoutDefaultSignatureInviteConfigurationsInput>;
};

export type TeamUpdateOneRequiredWithoutDocumentsNestedInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutDocumentsInput>;
  create?: InputMaybe<TeamCreateWithoutDocumentsInput>;
  update?: InputMaybe<TeamUpdateToOneWithWhereWithoutDocumentsInput>;
  upsert?: InputMaybe<TeamUpsertWithoutDocumentsInput>;
};

export type TeamUpdateOneRequiredWithoutFinancialTeamWalletNestedInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutFinancialTeamWalletInput>;
  create?: InputMaybe<TeamCreateWithoutFinancialTeamWalletInput>;
  update?: InputMaybe<TeamUpdateToOneWithWhereWithoutFinancialTeamWalletInput>;
  upsert?: InputMaybe<TeamUpsertWithoutFinancialTeamWalletInput>;
};

export type TeamUpdateOneRequiredWithoutMainTeamOfMaintainerNestedInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutMainTeamOfMaintainerInput>;
  create?: InputMaybe<TeamCreateWithoutMainTeamOfMaintainerInput>;
  update?: InputMaybe<TeamUpdateToOneWithWhereWithoutMainTeamOfMaintainerInput>;
  upsert?: InputMaybe<TeamUpsertWithoutMainTeamOfMaintainerInput>;
};

export type TeamUpdateOneRequiredWithoutPersonNestedInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutPersonInput>;
  create?: InputMaybe<TeamCreateWithoutPersonInput>;
  update?: InputMaybe<TeamUpdateToOneWithWhereWithoutPersonInput>;
  upsert?: InputMaybe<TeamUpsertWithoutPersonInput>;
};

export type TeamUpdateOneRequiredWithoutReusableFormDataCurriculumNestedInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutReusableFormDataCurriculumInput>;
  create?: InputMaybe<TeamCreateWithoutReusableFormDataCurriculumInput>;
  update?: InputMaybe<TeamUpdateToOneWithWhereWithoutReusableFormDataCurriculumInput>;
  upsert?: InputMaybe<TeamUpsertWithoutReusableFormDataCurriculumInput>;
};

export type TeamUpdateOneRequiredWithoutReusableFormDataNestedInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutReusableFormDataInput>;
  create?: InputMaybe<TeamCreateWithoutReusableFormDataInput>;
  update?: InputMaybe<TeamUpdateToOneWithWhereWithoutReusableFormDataInput>;
  upsert?: InputMaybe<TeamUpsertWithoutReusableFormDataInput>;
};

export type TeamUpdateOneRequiredWithoutTeamContractsNestedInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutTeamContractsInput>;
  create?: InputMaybe<TeamCreateWithoutTeamContractsInput>;
  update?: InputMaybe<TeamUpdateToOneWithWhereWithoutTeamContractsInput>;
  upsert?: InputMaybe<TeamUpsertWithoutTeamContractsInput>;
};

export type TeamUpdateOneRequiredWithoutTeamDocumentTypeSpecificSignaturePolicyConfigNestedInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutTeamDocumentTypeSpecificSignaturePolicyConfigInput>;
  create?: InputMaybe<TeamCreateWithoutTeamDocumentTypeSpecificSignaturePolicyConfigInput>;
  update?: InputMaybe<TeamUpdateToOneWithWhereWithoutTeamDocumentTypeSpecificSignaturePolicyConfigInput>;
  upsert?: InputMaybe<TeamUpsertWithoutTeamDocumentTypeSpecificSignaturePolicyConfigInput>;
};

export type TeamUpdateOneRequiredWithoutTeamEducationLevelNestedInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutTeamEducationLevelInput>;
  create?: InputMaybe<TeamCreateWithoutTeamEducationLevelInput>;
  update?: InputMaybe<TeamUpdateToOneWithWhereWithoutTeamEducationLevelInput>;
  upsert?: InputMaybe<TeamUpsertWithoutTeamEducationLevelInput>;
};

export type TeamUpdateOneRequiredWithoutTeamMemberNestedInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutTeamMemberInput>;
  create?: InputMaybe<TeamCreateWithoutTeamMemberInput>;
  update?: InputMaybe<TeamUpdateToOneWithWhereWithoutTeamMemberInput>;
  upsert?: InputMaybe<TeamUpsertWithoutTeamMemberInput>;
};

export type TeamUpdateOneWithoutDefaultDegreeCertificateTemplateNestedInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutDefaultDegreeCertificateTemplateInput>;
  create?: InputMaybe<TeamCreateWithoutDefaultDegreeCertificateTemplateInput>;
  delete?: InputMaybe<TeamWhereInput>;
  disconnect?: InputMaybe<TeamWhereInput>;
  update?: InputMaybe<TeamUpdateToOneWithWhereWithoutDefaultDegreeCertificateTemplateInput>;
  upsert?: InputMaybe<TeamUpsertWithoutDefaultDegreeCertificateTemplateInput>;
};

export type TeamUpdateOneWithoutEnabledInstitutionNestedInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutEnabledInstitutionInput>;
  create?: InputMaybe<TeamCreateWithoutEnabledInstitutionInput>;
  delete?: InputMaybe<TeamWhereInput>;
  disconnect?: InputMaybe<TeamWhereInput>;
  update?: InputMaybe<TeamUpdateToOneWithWhereWithoutEnabledInstitutionInput>;
  upsert?: InputMaybe<TeamUpsertWithoutEnabledInstitutionInput>;
};

export type TeamUpdateOneWithoutSystemAuditLogsNestedInput = {
  connect?: InputMaybe<TeamWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TeamCreateOrConnectWithoutSystemAuditLogsInput>;
  create?: InputMaybe<TeamCreateWithoutSystemAuditLogsInput>;
  delete?: InputMaybe<TeamWhereInput>;
  disconnect?: InputMaybe<TeamWhereInput>;
  update?: InputMaybe<TeamUpdateToOneWithWhereWithoutSystemAuditLogsInput>;
  upsert?: InputMaybe<TeamUpsertWithoutSystemAuditLogsInput>;
};

export type TeamUpdateToOneWithWhereWithoutApiKeyInput = {
  data: TeamUpdateWithoutApiKeyInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutBulkCertificateRecordInput = {
  data: TeamUpdateWithoutBulkCertificateRecordInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutCertificateBaseInput = {
  data: TeamUpdateWithoutCertificateBaseInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutCertificateTemplatesInput = {
  data: TeamUpdateWithoutCertificateTemplatesInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutDefaultDegreeCertificateTemplateInput = {
  data: TeamUpdateWithoutDefaultDegreeCertificateTemplateInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutDefaultSignatureInviteConfigurationsInput = {
  data: TeamUpdateWithoutDefaultSignatureInviteConfigurationsInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutDocumentsInput = {
  data: TeamUpdateWithoutDocumentsInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutEnabledInstitutionInput = {
  data: TeamUpdateWithoutEnabledInstitutionInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutFinancialTeamWalletInput = {
  data: TeamUpdateWithoutFinancialTeamWalletInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutMainTeamOfMaintainerInput = {
  data: TeamUpdateWithoutMainTeamOfMaintainerInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutPersonInput = {
  data: TeamUpdateWithoutPersonInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutReusableFormDataCurriculumInput = {
  data: TeamUpdateWithoutReusableFormDataCurriculumInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutReusableFormDataInput = {
  data: TeamUpdateWithoutReusableFormDataInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutSystemAuditLogsInput = {
  data: TeamUpdateWithoutSystemAuditLogsInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutTeamContractsInput = {
  data: TeamUpdateWithoutTeamContractsInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutTeamDocumentTypeSpecificSignaturePolicyConfigInput = {
  data: TeamUpdateWithoutTeamDocumentTypeSpecificSignaturePolicyConfigInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutTeamEducationLevelInput = {
  data: TeamUpdateWithoutTeamEducationLevelInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpdateToOneWithWhereWithoutTeamMemberInput = {
  data: TeamUpdateWithoutTeamMemberInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpdateWithWhereUniqueWithoutMaintainerInput = {
  data: TeamUpdateWithoutMaintainerInput;
  where: TeamWhereUniqueInput;
};

export type TeamUpdateWithWhereUniqueWithoutOwnerInput = {
  data: TeamUpdateWithoutOwnerInput;
  where: TeamWhereUniqueInput;
};

export type TeamUpdateWithoutApiKeyInput = {
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateUpdateOneWithoutTeamUsingAsPrimaryNestedInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: InputMaybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: InputMaybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: InputMaybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: InputMaybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamContracts?: InputMaybe<TeamContractUpdateManyWithoutTeamNestedInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contract?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isNSF?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  observations?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeholderName?: InputMaybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  showCreateDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showImportDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spaceUsage?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  storage?: InputMaybe<IntFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutBulkCertificateRecordInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateUpdateOneWithoutTeamUsingAsPrimaryNestedInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: InputMaybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: InputMaybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: InputMaybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: InputMaybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamContracts?: InputMaybe<TeamContractUpdateManyWithoutTeamNestedInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contract?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isNSF?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  observations?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeholderName?: InputMaybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  showCreateDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showImportDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spaceUsage?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  storage?: InputMaybe<IntFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutCertificateBaseInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateUpdateOneWithoutTeamUsingAsPrimaryNestedInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: InputMaybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: InputMaybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: InputMaybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: InputMaybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamContracts?: InputMaybe<TeamContractUpdateManyWithoutTeamNestedInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contract?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isNSF?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  observations?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeholderName?: InputMaybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  showCreateDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showImportDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spaceUsage?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  storage?: InputMaybe<IntFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutCertificateTemplatesInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateUpdateOneWithoutTeamUsingAsPrimaryNestedInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: InputMaybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: InputMaybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: InputMaybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: InputMaybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamContracts?: InputMaybe<TeamContractUpdateManyWithoutTeamNestedInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contract?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isNSF?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  observations?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeholderName?: InputMaybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  showCreateDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showImportDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spaceUsage?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  storage?: InputMaybe<IntFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutDefaultDegreeCertificateTemplateInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: InputMaybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: InputMaybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: InputMaybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: InputMaybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamContracts?: InputMaybe<TeamContractUpdateManyWithoutTeamNestedInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contract?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isNSF?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  observations?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeholderName?: InputMaybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  showCreateDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showImportDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spaceUsage?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  storage?: InputMaybe<IntFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutDefaultSignatureInviteConfigurationsInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateUpdateOneWithoutTeamUsingAsPrimaryNestedInput>;
  Documents?: InputMaybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: InputMaybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: InputMaybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: InputMaybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamContracts?: InputMaybe<TeamContractUpdateManyWithoutTeamNestedInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contract?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isNSF?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  observations?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeholderName?: InputMaybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  showCreateDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showImportDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spaceUsage?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  storage?: InputMaybe<IntFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutDocumentsInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateUpdateOneWithoutTeamUsingAsPrimaryNestedInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: InputMaybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: InputMaybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: InputMaybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamContracts?: InputMaybe<TeamContractUpdateManyWithoutTeamNestedInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contract?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isNSF?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  observations?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeholderName?: InputMaybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  showCreateDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showImportDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spaceUsage?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  storage?: InputMaybe<IntFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutEnabledInstitutionInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateUpdateOneWithoutTeamUsingAsPrimaryNestedInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: InputMaybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: InputMaybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: InputMaybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: InputMaybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamContracts?: InputMaybe<TeamContractUpdateManyWithoutTeamNestedInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contract?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isNSF?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  observations?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeholderName?: InputMaybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  showCreateDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showImportDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spaceUsage?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  storage?: InputMaybe<IntFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutFinancialTeamWalletInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateUpdateOneWithoutTeamUsingAsPrimaryNestedInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: InputMaybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: InputMaybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: InputMaybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: InputMaybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamContracts?: InputMaybe<TeamContractUpdateManyWithoutTeamNestedInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contract?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isNSF?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  observations?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeholderName?: InputMaybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  showCreateDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showImportDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spaceUsage?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  storage?: InputMaybe<IntFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutMainTeamOfMaintainerInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateUpdateOneWithoutTeamUsingAsPrimaryNestedInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: InputMaybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  Maintainer?: InputMaybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: InputMaybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: InputMaybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamContracts?: InputMaybe<TeamContractUpdateManyWithoutTeamNestedInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contract?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isNSF?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  observations?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeholderName?: InputMaybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  showCreateDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showImportDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spaceUsage?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  storage?: InputMaybe<IntFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutMaintainerInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateUpdateOneWithoutTeamUsingAsPrimaryNestedInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: InputMaybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Owner?: InputMaybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: InputMaybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamContracts?: InputMaybe<TeamContractUpdateManyWithoutTeamNestedInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contract?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isNSF?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  observations?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeholderName?: InputMaybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  showCreateDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showImportDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spaceUsage?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  storage?: InputMaybe<IntFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutOwnerInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateUpdateOneWithoutTeamUsingAsPrimaryNestedInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: InputMaybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: InputMaybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Person?: InputMaybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamContracts?: InputMaybe<TeamContractUpdateManyWithoutTeamNestedInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contract?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isNSF?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  observations?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeholderName?: InputMaybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  showCreateDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showImportDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spaceUsage?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  storage?: InputMaybe<IntFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutPersonInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateUpdateOneWithoutTeamUsingAsPrimaryNestedInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: InputMaybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: InputMaybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: InputMaybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamContracts?: InputMaybe<TeamContractUpdateManyWithoutTeamNestedInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contract?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isNSF?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  observations?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeholderName?: InputMaybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  showCreateDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showImportDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spaceUsage?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  storage?: InputMaybe<IntFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutReusableFormDataCurriculumInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateUpdateOneWithoutTeamUsingAsPrimaryNestedInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: InputMaybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: InputMaybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: InputMaybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: InputMaybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamContracts?: InputMaybe<TeamContractUpdateManyWithoutTeamNestedInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contract?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isNSF?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  observations?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeholderName?: InputMaybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  showCreateDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showImportDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spaceUsage?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  storage?: InputMaybe<IntFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutReusableFormDataInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateUpdateOneWithoutTeamUsingAsPrimaryNestedInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: InputMaybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: InputMaybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: InputMaybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: InputMaybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamContracts?: InputMaybe<TeamContractUpdateManyWithoutTeamNestedInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contract?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isNSF?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  observations?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeholderName?: InputMaybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  showCreateDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showImportDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spaceUsage?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  storage?: InputMaybe<IntFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutSystemAuditLogsInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateUpdateOneWithoutTeamUsingAsPrimaryNestedInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: InputMaybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: InputMaybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: InputMaybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: InputMaybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  TeamContracts?: InputMaybe<TeamContractUpdateManyWithoutTeamNestedInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contract?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isNSF?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  observations?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeholderName?: InputMaybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  showCreateDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showImportDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spaceUsage?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  storage?: InputMaybe<IntFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutTeamContractsInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateUpdateOneWithoutTeamUsingAsPrimaryNestedInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: InputMaybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: InputMaybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: InputMaybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: InputMaybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contract?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isNSF?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  observations?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeholderName?: InputMaybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  showCreateDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showImportDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spaceUsage?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  storage?: InputMaybe<IntFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutTeamDocumentTypeSpecificSignaturePolicyConfigInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateUpdateOneWithoutTeamUsingAsPrimaryNestedInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: InputMaybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: InputMaybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: InputMaybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: InputMaybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamContracts?: InputMaybe<TeamContractUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contract?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isNSF?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  observations?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeholderName?: InputMaybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  showCreateDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showImportDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spaceUsage?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  storage?: InputMaybe<IntFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutTeamEducationLevelInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateUpdateOneWithoutTeamUsingAsPrimaryNestedInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: InputMaybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: InputMaybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: InputMaybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: InputMaybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamContracts?: InputMaybe<TeamContractUpdateManyWithoutTeamNestedInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigUpdateManyWithoutTeamNestedInput>;
  TeamMember?: InputMaybe<TeamMemberUpdateManyWithoutTeamNestedInput>;
  cnpj?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contract?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isNSF?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  observations?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeholderName?: InputMaybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  showCreateDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showImportDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spaceUsage?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  storage?: InputMaybe<IntFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpdateWithoutTeamMemberInput = {
  ApiKey?: InputMaybe<ApiKeyUpdateManyWithoutTeamNestedInput>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordUpdateManyWithoutTeamNestedInput>;
  CertificateBase?: InputMaybe<CertificateBaseUpdateManyWithoutTeamNestedInput>;
  CertificateTemplates?: InputMaybe<CertificateTemplateUpdateManyWithoutTeamNestedInput>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateUpdateOneWithoutTeamUsingAsPrimaryNestedInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationUpdateManyWithoutTeamNestedInput>;
  Documents?: InputMaybe<DocumentBaseUpdateManyWithoutTeamNestedInput>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionUpdateOneWithoutTeamNestedInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletUpdateOneWithoutTeamNestedInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerUpdateOneWithoutMainTeamNestedInput>;
  Maintainer?: InputMaybe<MaintainerUpdateOneWithoutTeamsNestedInput>;
  Owner?: InputMaybe<CommonUserUpdateOneRequiredWithoutTeamsCreatedNestedInput>;
  Person?: InputMaybe<PersonUpdateManyWithoutTeamNestedInput>;
  ReusableFormData?: InputMaybe<ReusableFormDataUpdateManyWithoutTeamNestedInput>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumUpdateManyWithoutTeamNestedInput>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogUpdateManyWithoutTeamNestedInput>;
  TeamContracts?: InputMaybe<TeamContractUpdateManyWithoutTeamNestedInput>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigUpdateManyWithoutTeamNestedInput>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelUpdateManyWithoutTeamNestedInput>;
  cnpj?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  configAddDocumentSignerNode?: InputMaybe<BoolFieldUpdateOperationsInput>;
  contract?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deactivationReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalSignatureWebhookURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  faviconBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  financialShouldCharge?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isNSF?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastActivityAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  logoBase64?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  observations?: InputMaybe<StringFieldUpdateOperationsInput>;
  placeholderName?: InputMaybe<StringFieldUpdateOperationsInput>;
  publicViewDegreeDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewInstitutionName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewPrimaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicViewSecondaryColor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  showCreateDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showImportDiploma?: InputMaybe<BoolFieldUpdateOperationsInput>;
  spaceUsage?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  storage?: InputMaybe<IntFieldUpdateOperationsInput>;
  syncWithLedgerDoc?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  validateCertificateURL?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type TeamUpsertWithWhereUniqueWithoutMaintainerInput = {
  create: TeamCreateWithoutMaintainerInput;
  update: TeamUpdateWithoutMaintainerInput;
  where: TeamWhereUniqueInput;
};

export type TeamUpsertWithWhereUniqueWithoutOwnerInput = {
  create: TeamCreateWithoutOwnerInput;
  update: TeamUpdateWithoutOwnerInput;
  where: TeamWhereUniqueInput;
};

export type TeamUpsertWithoutApiKeyInput = {
  create: TeamCreateWithoutApiKeyInput;
  update: TeamUpdateWithoutApiKeyInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpsertWithoutBulkCertificateRecordInput = {
  create: TeamCreateWithoutBulkCertificateRecordInput;
  update: TeamUpdateWithoutBulkCertificateRecordInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpsertWithoutCertificateBaseInput = {
  create: TeamCreateWithoutCertificateBaseInput;
  update: TeamUpdateWithoutCertificateBaseInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpsertWithoutCertificateTemplatesInput = {
  create: TeamCreateWithoutCertificateTemplatesInput;
  update: TeamUpdateWithoutCertificateTemplatesInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpsertWithoutDefaultDegreeCertificateTemplateInput = {
  create: TeamCreateWithoutDefaultDegreeCertificateTemplateInput;
  update: TeamUpdateWithoutDefaultDegreeCertificateTemplateInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpsertWithoutDefaultSignatureInviteConfigurationsInput = {
  create: TeamCreateWithoutDefaultSignatureInviteConfigurationsInput;
  update: TeamUpdateWithoutDefaultSignatureInviteConfigurationsInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpsertWithoutDocumentsInput = {
  create: TeamCreateWithoutDocumentsInput;
  update: TeamUpdateWithoutDocumentsInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpsertWithoutEnabledInstitutionInput = {
  create: TeamCreateWithoutEnabledInstitutionInput;
  update: TeamUpdateWithoutEnabledInstitutionInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpsertWithoutFinancialTeamWalletInput = {
  create: TeamCreateWithoutFinancialTeamWalletInput;
  update: TeamUpdateWithoutFinancialTeamWalletInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpsertWithoutMainTeamOfMaintainerInput = {
  create: TeamCreateWithoutMainTeamOfMaintainerInput;
  update: TeamUpdateWithoutMainTeamOfMaintainerInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpsertWithoutPersonInput = {
  create: TeamCreateWithoutPersonInput;
  update: TeamUpdateWithoutPersonInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpsertWithoutReusableFormDataCurriculumInput = {
  create: TeamCreateWithoutReusableFormDataCurriculumInput;
  update: TeamUpdateWithoutReusableFormDataCurriculumInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpsertWithoutReusableFormDataInput = {
  create: TeamCreateWithoutReusableFormDataInput;
  update: TeamUpdateWithoutReusableFormDataInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpsertWithoutSystemAuditLogsInput = {
  create: TeamCreateWithoutSystemAuditLogsInput;
  update: TeamUpdateWithoutSystemAuditLogsInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpsertWithoutTeamContractsInput = {
  create: TeamCreateWithoutTeamContractsInput;
  update: TeamUpdateWithoutTeamContractsInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpsertWithoutTeamDocumentTypeSpecificSignaturePolicyConfigInput = {
  create: TeamCreateWithoutTeamDocumentTypeSpecificSignaturePolicyConfigInput;
  update: TeamUpdateWithoutTeamDocumentTypeSpecificSignaturePolicyConfigInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpsertWithoutTeamEducationLevelInput = {
  create: TeamCreateWithoutTeamEducationLevelInput;
  update: TeamUpdateWithoutTeamEducationLevelInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamUpsertWithoutTeamMemberInput = {
  create: TeamCreateWithoutTeamMemberInput;
  update: TeamUpdateWithoutTeamMemberInput;
  where?: InputMaybe<TeamWhereInput>;
};

export type TeamWhereInput = {
  AND?: InputMaybe<Array<TeamWhereInput>>;
  ApiKey?: InputMaybe<ApiKeyListRelationFilter>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordListRelationFilter>;
  CertificateBase?: InputMaybe<CertificateBaseListRelationFilter>;
  CertificateTemplates?: InputMaybe<CertificateTemplateListRelationFilter>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateWhereInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationListRelationFilter>;
  Documents?: InputMaybe<DocumentBaseListRelationFilter>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionWhereInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletWhereInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerWhereInput>;
  Maintainer?: InputMaybe<MaintainerWhereInput>;
  NOT?: InputMaybe<Array<TeamWhereInput>>;
  OR?: InputMaybe<Array<TeamWhereInput>>;
  Owner?: InputMaybe<CommonUserWhereInput>;
  Person?: InputMaybe<PersonListRelationFilter>;
  ReusableFormData?: InputMaybe<ReusableFormDataListRelationFilter>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumListRelationFilter>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogListRelationFilter>;
  TeamContracts?: InputMaybe<TeamContractListRelationFilter>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigListRelationFilter>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelListRelationFilter>;
  TeamMember?: InputMaybe<TeamMemberListRelationFilter>;
  cnpj?: InputMaybe<StringNullableFilter>;
  commonUserId?: InputMaybe<IntFilter>;
  configAddDocumentSignerNode?: InputMaybe<BoolFilter>;
  contract?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deactivationReason?: InputMaybe<StringNullableFilter>;
  defaultDegreeCertificateTemplateId?: InputMaybe<StringNullableFilter>;
  enabledInstitutionId?: InputMaybe<IntNullableFilter>;
  externalSignatureWebhookURL?: InputMaybe<StringNullableFilter>;
  faviconBase64?: InputMaybe<StringNullableFilter>;
  financialShouldCharge?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  isActive?: InputMaybe<BoolFilter>;
  isNSF?: InputMaybe<BoolFilter>;
  lastActivityAt?: InputMaybe<DateTimeFilter>;
  logoBase64?: InputMaybe<StringNullableFilter>;
  maintainerId?: InputMaybe<IntNullableFilter>;
  observations?: InputMaybe<StringFilter>;
  placeholderName?: InputMaybe<StringFilter>;
  publicViewDegreeDomainPath?: InputMaybe<StringNullableFilter>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<StringNullableFilter>;
  publicViewInstitutionName?: InputMaybe<StringNullableFilter>;
  publicViewPrimaryColor?: InputMaybe<StringNullableFilter>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<StringNullableFilter>;
  publicViewSecondaryColor?: InputMaybe<StringNullableFilter>;
  showCreateDiploma?: InputMaybe<BoolFilter>;
  showImportDiploma?: InputMaybe<BoolFilter>;
  spaceUsage?: InputMaybe<BigIntFilter>;
  storage?: InputMaybe<IntFilter>;
  syncWithLedgerDoc?: InputMaybe<BoolFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  validateCertificateURL?: InputMaybe<StringNullableFilter>;
};

export type TeamWhereUniqueInput = {
  AND?: InputMaybe<Array<TeamWhereInput>>;
  ApiKey?: InputMaybe<ApiKeyListRelationFilter>;
  BulkCertificateRecord?: InputMaybe<BulkCertificateRecordListRelationFilter>;
  CertificateBase?: InputMaybe<CertificateBaseListRelationFilter>;
  CertificateTemplates?: InputMaybe<CertificateTemplateListRelationFilter>;
  DefaultDegreeCertificateTemplate?: InputMaybe<CertificateTemplateWhereInput>;
  DefaultSignatureInviteConfigurations?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationListRelationFilter>;
  Documents?: InputMaybe<DocumentBaseListRelationFilter>;
  EnabledInstitution?: InputMaybe<EnabledInstitutionWhereInput>;
  FinancialTeamWallet?: InputMaybe<FinancialTeamWalletWhereInput>;
  MainTeamOfMaintainer?: InputMaybe<MaintainerWhereInput>;
  Maintainer?: InputMaybe<MaintainerWhereInput>;
  NOT?: InputMaybe<Array<TeamWhereInput>>;
  OR?: InputMaybe<Array<TeamWhereInput>>;
  Owner?: InputMaybe<CommonUserWhereInput>;
  Person?: InputMaybe<PersonListRelationFilter>;
  ReusableFormData?: InputMaybe<ReusableFormDataListRelationFilter>;
  ReusableFormDataCurriculum?: InputMaybe<ReusableFormDataCurriculumListRelationFilter>;
  SystemAuditLogs?: InputMaybe<SystemAuditLogListRelationFilter>;
  TeamContracts?: InputMaybe<TeamContractListRelationFilter>;
  TeamDocumentTypeSpecificSignaturePolicyConfig?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigListRelationFilter>;
  TeamEducationLevel?: InputMaybe<TeamEducationLevelListRelationFilter>;
  TeamMember?: InputMaybe<TeamMemberListRelationFilter>;
  cnpj?: InputMaybe<StringNullableFilter>;
  commonUserId?: InputMaybe<IntFilter>;
  configAddDocumentSignerNode?: InputMaybe<BoolFilter>;
  contract?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deactivationReason?: InputMaybe<StringNullableFilter>;
  defaultDegreeCertificateTemplateId?: InputMaybe<Scalars['String']['input']>;
  enabledInstitutionId?: InputMaybe<Scalars['Int']['input']>;
  externalSignatureWebhookURL?: InputMaybe<StringNullableFilter>;
  faviconBase64?: InputMaybe<StringNullableFilter>;
  financialShouldCharge?: InputMaybe<BoolFilter>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<BoolFilter>;
  isNSF?: InputMaybe<BoolFilter>;
  lastActivityAt?: InputMaybe<DateTimeFilter>;
  logoBase64?: InputMaybe<StringNullableFilter>;
  maintainerId?: InputMaybe<IntNullableFilter>;
  observations?: InputMaybe<StringFilter>;
  placeholderName?: InputMaybe<StringFilter>;
  publicViewDegreeDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewInstitutionName?: InputMaybe<StringNullableFilter>;
  publicViewPrimaryColor?: InputMaybe<StringNullableFilter>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewSecondaryColor?: InputMaybe<StringNullableFilter>;
  showCreateDiploma?: InputMaybe<BoolFilter>;
  showImportDiploma?: InputMaybe<BoolFilter>;
  spaceUsage?: InputMaybe<BigIntFilter>;
  storage?: InputMaybe<IntFilter>;
  syncWithLedgerDoc?: InputMaybe<BoolFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  validateCertificateURL?: InputMaybe<StringNullableFilter>;
};

export type Telephone = {
  __typename?: 'Telephone';
  Person: Person;
  id: Scalars['Int']['output'];
  number: Scalars['String']['output'];
  personId: Scalars['String']['output'];
};

export type TelephoneAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type TelephoneCountOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  number?: InputMaybe<SortOrder>;
  personId?: InputMaybe<SortOrder>;
};

export type TelephoneCreateInput = {
  Person: PersonCreateNestedOneWithoutPhonesInput;
  number: Scalars['String']['input'];
};

export type TelephoneCreateManyInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  number: Scalars['String']['input'];
  personId: Scalars['String']['input'];
};

export type TelephoneCreateManyPersonInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  number: Scalars['String']['input'];
};

export type TelephoneCreateManyPersonInputEnvelope = {
  data: Array<TelephoneCreateManyPersonInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TelephoneCreateNestedManyWithoutPersonInput = {
  connect?: InputMaybe<Array<TelephoneWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TelephoneCreateOrConnectWithoutPersonInput>>;
  create?: InputMaybe<Array<TelephoneCreateWithoutPersonInput>>;
  createMany?: InputMaybe<TelephoneCreateManyPersonInputEnvelope>;
};

export type TelephoneCreateOrConnectWithoutPersonInput = {
  create: TelephoneCreateWithoutPersonInput;
  where: TelephoneWhereUniqueInput;
};

export type TelephoneCreateWithoutPersonInput = {
  number: Scalars['String']['input'];
};

export type TelephoneListRelationFilter = {
  every?: InputMaybe<TelephoneWhereInput>;
  none?: InputMaybe<TelephoneWhereInput>;
  some?: InputMaybe<TelephoneWhereInput>;
};

export type TelephoneMaxOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  number?: InputMaybe<SortOrder>;
  personId?: InputMaybe<SortOrder>;
};

export type TelephoneMinOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  number?: InputMaybe<SortOrder>;
  personId?: InputMaybe<SortOrder>;
};

export type TelephoneOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TelephoneOrderByWithAggregationInput = {
  _avg?: InputMaybe<TelephoneAvgOrderByAggregateInput>;
  _count?: InputMaybe<TelephoneCountOrderByAggregateInput>;
  _max?: InputMaybe<TelephoneMaxOrderByAggregateInput>;
  _min?: InputMaybe<TelephoneMinOrderByAggregateInput>;
  _sum?: InputMaybe<TelephoneSumOrderByAggregateInput>;
  id?: InputMaybe<SortOrder>;
  number?: InputMaybe<SortOrder>;
  personId?: InputMaybe<SortOrder>;
};

export type TelephoneOrderByWithRelationInput = {
  Person?: InputMaybe<PersonOrderByWithRelationInput>;
  id?: InputMaybe<SortOrder>;
  number?: InputMaybe<SortOrder>;
  personId?: InputMaybe<SortOrder>;
};

export enum TelephoneScalarFieldEnum {
  Id = 'id',
  Number = 'number',
  PersonId = 'personId'
}

export type TelephoneScalarWhereInput = {
  AND?: InputMaybe<Array<TelephoneScalarWhereInput>>;
  NOT?: InputMaybe<Array<TelephoneScalarWhereInput>>;
  OR?: InputMaybe<Array<TelephoneScalarWhereInput>>;
  id?: InputMaybe<IntFilter>;
  number?: InputMaybe<StringFilter>;
  personId?: InputMaybe<StringFilter>;
};

export type TelephoneScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<TelephoneScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<TelephoneScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<TelephoneScalarWhereWithAggregatesInput>>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  number?: InputMaybe<StringWithAggregatesFilter>;
  personId?: InputMaybe<StringWithAggregatesFilter>;
};

export type TelephoneSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type TelephoneUpdateInput = {
  Person?: InputMaybe<PersonUpdateOneRequiredWithoutPhonesNestedInput>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TelephoneUpdateManyMutationInput = {
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TelephoneUpdateManyWithWhereWithoutPersonInput = {
  data: TelephoneUpdateManyMutationInput;
  where: TelephoneScalarWhereInput;
};

export type TelephoneUpdateManyWithoutPersonNestedInput = {
  connect?: InputMaybe<Array<TelephoneWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TelephoneCreateOrConnectWithoutPersonInput>>;
  create?: InputMaybe<Array<TelephoneCreateWithoutPersonInput>>;
  createMany?: InputMaybe<TelephoneCreateManyPersonInputEnvelope>;
  delete?: InputMaybe<Array<TelephoneWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TelephoneScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TelephoneWhereUniqueInput>>;
  set?: InputMaybe<Array<TelephoneWhereUniqueInput>>;
  update?: InputMaybe<Array<TelephoneUpdateWithWhereUniqueWithoutPersonInput>>;
  updateMany?: InputMaybe<Array<TelephoneUpdateManyWithWhereWithoutPersonInput>>;
  upsert?: InputMaybe<Array<TelephoneUpsertWithWhereUniqueWithoutPersonInput>>;
};

export type TelephoneUpdateWithWhereUniqueWithoutPersonInput = {
  data: TelephoneUpdateWithoutPersonInput;
  where: TelephoneWhereUniqueInput;
};

export type TelephoneUpdateWithoutPersonInput = {
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TelephoneUpsertWithWhereUniqueWithoutPersonInput = {
  create: TelephoneCreateWithoutPersonInput;
  update: TelephoneUpdateWithoutPersonInput;
  where: TelephoneWhereUniqueInput;
};

export type TelephoneWhereInput = {
  AND?: InputMaybe<Array<TelephoneWhereInput>>;
  NOT?: InputMaybe<Array<TelephoneWhereInput>>;
  OR?: InputMaybe<Array<TelephoneWhereInput>>;
  Person?: InputMaybe<PersonWhereInput>;
  id?: InputMaybe<IntFilter>;
  number?: InputMaybe<StringFilter>;
  personId?: InputMaybe<StringFilter>;
};

export type TelephoneWhereUniqueInput = {
  AND?: InputMaybe<Array<TelephoneWhereInput>>;
  NOT?: InputMaybe<Array<TelephoneWhereInput>>;
  OR?: InputMaybe<Array<TelephoneWhereInput>>;
  Person?: InputMaybe<PersonWhereInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<StringFilter>;
  personId?: InputMaybe<StringFilter>;
};

export enum TransactionIsolationLevel {
  ReadCommitted = 'ReadCommitted',
  ReadUncommitted = 'ReadUncommitted',
  RepeatableRead = 'RepeatableRead',
  Serializable = 'Serializable'
}

export type UpdateOneTeamData = {
  /** Contract URL */
  contract?: InputMaybe<Scalars['String']['input']>;
  educationLevelTypes?: InputMaybe<Array<EducationLevelType>>;
  externalSignatureWebhookURL?: InputMaybe<Scalars['String']['input']>;
  faviconBase64?: InputMaybe<Scalars['String']['input']>;
  isMaintainer?: InputMaybe<Scalars['Boolean']['input']>;
  isNSF?: InputMaybe<Scalars['Boolean']['input']>;
  logoBase64?: InputMaybe<Scalars['String']['input']>;
  observations?: InputMaybe<Scalars['String']['input']>;
  publicCertificateAutenticateURL?: InputMaybe<Scalars['String']['input']>;
  publicViewDegreeDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewFinalAcademicTranscriptDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewInstitutionName?: InputMaybe<Scalars['String']['input']>;
  publicViewPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  publicViewSchoolCurriculumDomainPath?: InputMaybe<Scalars['String']['input']>;
  publicViewSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  showCreateDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  showImportDiploma?: InputMaybe<Scalars['Boolean']['input']>;
  syncWithLedgerDoc?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['Int']['input'];
};

export type UpsertDocumentBaseDefaultSignatureInviteConfigurationInput = {
  /** Adiciona o nó assinantes com todos os convidados assinantes eCPF. Apenas considerado se for documentação acadêmica. */
  addSignersNode?: InputMaybe<Scalars['Boolean']['input']>;
  groups: Array<GroupEmails>;
  type: DocumentBaseType;
};

export type UpsertTeamDocumentTypeSpecificSignaturePolicyConfigInput = {
  documentBaseType: DocumentBaseType;
  teamId: Scalars['Int']['input'];
  types: Array<TeamSpecificSignaturePolicyType>;
};

export type ValidationResult = {
  __typename?: 'ValidationResult';
  id: Scalars['String']['output'];
  isValid: Scalars['Boolean']['output'];
};

export enum VisualRepresentationCreationType {
  CreatedInPortal = 'CREATED_IN_PORTAL',
  Imported = 'IMPORTED'
}

export type WatchCertificateTemplateData = {
  __typename?: 'WatchCertificateTemplateData';
  data?: Maybe<Scalars['Json']['output']>;
  id: Scalars['String']['output'];
};

export type WatchDocumentFocus = {
  __typename?: 'WatchDocumentFocus';
  fieldPath: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  user: WatchDocumentObjectUser;
};

export type WatchDocumentInput = {
  documentId: Scalars['String']['input'];
  fieldPath: Scalars['String']['input'];
};

export type WatchDocumentObjectUser = {
  __typename?: 'WatchDocumentObjectUser';
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
};

export type WatchDocumentPatch = {
  __typename?: 'WatchDocumentPatch';
  changes: Array<WatchDocumentPatchesChanges>;
  id: Scalars['String']['output'];
};

export type WatchDocumentPatchesChanges = {
  __typename?: 'WatchDocumentPatchesChanges';
  id: Scalars['String']['output'];
  propertyPath: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['Json']['output']>;
};

export type WatchSignBulkCertificate = {
  __typename?: 'WatchSignBulkCertificate';
  documentsCompleted: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalInviteForSign: Scalars['Int']['output'];
};

export type WatchSignValidationBulkCertificate = {
  __typename?: 'WatchSignValidationBulkCertificate';
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type WatchSingleCertificateSignValidationEvent = {
  __typename?: 'WatchSingleCertificateSignValidationEvent';
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type FindAllCountDocumentRenotarizationObject = {
  __typename?: 'findAllCountDocumentRenotarizationObject';
  expired: Scalars['Int']['output'];
  expiresIn90Days: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  pending: Scalars['Int']['output'];
  renotarized: Scalars['Int']['output'];
  totalDocumentsWithRA: Scalars['Int']['output'];
  totalRASignatures: Scalars['Int']['output'];
};

export type UpdateTeamActivationStatusArgs = {
  method: InstitutionActionMethod;
  reason?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Int']['input'];
};

export type ValidateOneDocumentCertificateObject = {
  __typename?: 'validateOneDocumentCertificateObject';
  certificate: DocumentCertificateHashHistory;
  id: Scalars['String']['output'];
  validationResult: ValidationResult;
};

export type DocumentAcademicDocumentationFieldsFragment = { __typename?: 'DocumentAcademicDocumentation', id: string, documentBaseId: string, type: DocumentAcademicDocumentationType, status: DocumentAcademicDocumentationStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any, updatedAt?: any | null, creationType: DocumentAcademicDocumentationCreationType, data: any, filePath?: string | null, fileSize: number, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> }, ChildDocuments: Array<{ __typename?: 'DocumentFinalAcademicTranscript', id: string, documentBaseId: string, status: DocumentFinalAcademicTranscriptStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any } }>, LinkedDegreeList: Array<{ __typename?: 'DocumentDegree', id: string, documentBaseId: string, status: DocumentDegreeStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, deletedAt?: any | null } }> };

export type DocumentBaseSignatureInviteFieldsFragment = { __typename?: 'DocumentBaseSignatureInvite', id: number, createdAt: any, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }>, TeamMember?: { __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number, cpf?: string | null } } | null, Group: { __typename?: 'DocumentBaseSignatureInviteGroup', id: number, order: number, DocumentBase: { __typename?: 'DocumentBase', id: string, internalSeqId: string, version: string, type: DocumentBaseType, createdAt: any, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, DocumentAcademicDocumentation?: { __typename?: 'DocumentAcademicDocumentation', id: string, searchStudentName: string, searchCourse: string, searchCPF: string, searchEmecCode: string } | null, DocumentDegree?: { __typename?: 'DocumentDegree', id: string, searchStudentName: string, searchCourse: string, searchCPF: string, searchEmecCode: string } | null, DocumentFinalAcademicTranscript?: { __typename?: 'DocumentFinalAcademicTranscript', id: string, searchStudentName: string, searchCourse: string, searchCPF: string, searchEmecCode: string } | null, DocumentAuditFileIssuer?: { __typename?: 'DocumentAuditFileIssuer', id: string, searchAuditStartDate: string, searchAuditEndDate: string } | null } } };

export type DocumentBaseSignatureInviteGroupFieldsFragment = { __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> };

export type DocumentBaseFieldsFragment = { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any, updatedAt?: any | null, creationType: DocumentAcademicDocumentationCreationType, data: any, filePath?: string | null, fileSize: number, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> };

export type DocumentDegreeFieldsFragment = { __typename?: 'DocumentDegree', id: string, documentBaseId: string, searchStudentName: string, searchCPF: string, searchCourse: string, searchEmecCode: string, status: DocumentDegreeStatus, searchValidationCode?: string | null, searchIssueDate?: any | null, searchRegistrationDate?: any | null, visualRepresentationCreationType: VisualRepresentationCreationType, visualRepresentationFileSize: number, isSentToGraduate: boolean, DocumentBase: { __typename?: 'DocumentBase', id: string, internalSeqId: string, creationType: DocumentAcademicDocumentationCreationType, fileSize: number, hasFile: boolean, createdAt: any, deletedAt?: any | null } };

export type DocumentDegreeUniqueFieldsFragment = { __typename?: 'DocumentDegree', id: string, documentBaseId: string, visualRepresentationPath?: string | null, visualRepresentationFileSize: number, searchStudentName: string, searchCPF: string, searchCourse: string, searchValidationCode?: string | null, status: DocumentDegreeStatus, ParentAcademicDocumentation?: { __typename?: 'DocumentAcademicDocumentation', id: string, DocumentBase: { __typename?: 'DocumentBase', id: string, internalSeqId: string } } | null, DocumentBase: { __typename?: 'DocumentBase', filePath?: string | null, type: DocumentBaseType, id: string, internalSeqId: string, version: string, createdAt: any, updatedAt?: any | null, creationType: DocumentAcademicDocumentationCreationType, data: any, fileSize: number, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> } };

export type PersonFieldsFragment = { __typename?: 'Person', id: string, name: string, receivesCertificateEmail: boolean, receivesCertificateWhatsapp: boolean, cpf?: string | null, birthDate?: string | null, identityDocument?: string | null, email?: string | null, isForeign: boolean, passport?: string | null, Phones: Array<{ __typename?: 'Telephone', id: number, number: string }>, Address?: { __typename?: 'Address', id: number, city?: string | null, complement?: string | null, neighborhood?: string | null, postalCode?: string | null, state?: string | null, street?: string | null } | null };

export type DocumentSchoolCurriculumFieldsFragment = { __typename?: 'DocumentSchoolCurriculum', id: string, searchSchoolCurriculumName: string, searchSchoolCurriculumCode: string, documentBaseId: string, status: DocumentSchoolCurriculumStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any, updatedAt?: any | null, creationType: DocumentAcademicDocumentationCreationType, data: any, filePath?: string | null, fileSize: number, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> } };

export type SystemGlobalAlertFieldsFragment = { __typename?: 'SystemGlobalAlert', id: number, type: SystemGlobalAlertType, value: string, actionUrl?: string | null, actionTitle?: string | null, message?: string | null, forcedTitle: string, forcedDescription: string, forcedActionUrl?: string | null, myDismissonsCount: number, targetEducationLevels: Array<EducationLevelType> };

export type TeamFieldsFragment = { __typename?: 'Team', id: number, isNSF: boolean, showImportDiploma: boolean, showCreateDiploma: boolean, cnpj?: string | null, createdAt: any, TeamMember: Array<{ __typename?: 'TeamMember', id: number, role?: string | null, User: { __typename?: 'CommonUser', id: number, name?: string | null, cpf?: string | null, email: string, createdAt: any } }>, TeamEducationLevel: Array<{ __typename?: 'TeamEducationLevel', id: number, educationLevelType: EducationLevelType }> };

export type TeamMemberFieldsFragment = { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> };

export type TeamIdNamesActiveFieldsFragment = { __typename?: 'Team', id: number, isActive: boolean, issuerName?: string | null, placeholderName: string };

export type UserFieldsFragment = { __typename?: 'CommonUser', id: number, email: string, createdAt: any, institutionCnpj?: string | null, name?: string | null, cpf?: string | null, photo?: string | null, permissions: Array<string>, teamId?: number | null, computedResolvedAt: string, loggedAs?: boolean | null, defaultSignatureImageId?: string | null, UserConfigs: Array<{ __typename?: 'CommonUserConfig', id: string, key: string, value: any }>, TeamMember: Array<{ __typename?: 'TeamMember', id: number, Team: { __typename?: 'Team', id: number, isActive: boolean, issuerName?: string | null, placeholderName: string } }>, Team: { __typename?: 'Team', id: number, financialShouldCharge: boolean, isNSF: boolean, showImportDiploma: boolean, showCreateDiploma: boolean, issuerData?: any | null, configAddDocumentSignerNode: boolean, publicViewDegreeDomainPath?: string | null, publicViewFinalAcademicTranscriptDomainPath?: string | null, publicViewSchoolCurriculumDomainPath?: string | null, externalSignatureWebhookURL?: string | null, placeholderName: string, spaceUsage: number, storage: number, FinancialTeamWallet?: { __typename?: 'FinancialTeamWallet', id: number, creditsPlanVisual: number, creditsPlanTrial: number, creditsPlanRb: number, creditsPlanRtRa: number, creditsDetachedVisual: number, creditsDetachedRb: number, creditsDetachedRtRa: number, teamId: number, SubscriptionActive?: { __typename?: 'FinancialTeamWalletSubscription', id: string, plan: FinancialPlan, billingCycle?: FinancialBillingCycle | null, planName?: string | null, canceledAt?: any | null, nextDueDate?: any | null, annualCreditQuotaResetDate?: any | null, createdAt: any, planUpdatedPrice: number } | null } | null, TeamEducationLevel: Array<{ __typename?: 'TeamEducationLevel', id: number, educationLevelType: EducationLevelType }>, maintainerSpace?: { __typename?: 'MaintainerSpace', id: number, usage: number, storage: number } | null }, UserAlerts: Array<{ __typename?: 'SystemGlobalAlert', id: number, type: SystemGlobalAlertType, value: string, actionUrl?: string | null, actionTitle?: string | null, message?: string | null, forcedTitle: string, forcedDescription: string, forcedActionUrl?: string | null, myDismissonsCount: number, targetEducationLevels: Array<EducationLevelType> }>, MaintainerAdmin?: { __typename?: 'MaintainerAdmin', id: string, Maintainer: { __typename?: 'Maintainer', id: number, Teams: Array<{ __typename?: 'Team', id: number, isActive: boolean, issuerName?: string | null, placeholderName: string }> } } | null };

export type AddOneTeamMemberMutationVariables = Exact<{
  email: Scalars['String']['input'];
  permissions: Array<Scalars['String']['input']> | Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddOneTeamMemberMutation = { addOneTeamMember: { __typename?: 'TeamMember', id: number } };

export type BuildOneDegreeVisualRepresentationMutationVariables = Exact<{
  degreeId: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
  variables: Scalars['Json']['input'];
}>;


export type BuildOneDegreeVisualRepresentationMutation = { buildOneDegreeVisualRepresentation?: { __typename?: 'DocumentDegree', id: string, documentBaseId: string, visualRepresentationPath?: string | null } | null };

export type CodeAuthLoginLedgerSignMutationVariables = Exact<{
  token: Scalars['String']['input'];
  subservice: SubService;
}>;


export type CodeAuthLoginLedgerSignMutation = { codeAuthLoginLedgerSign: { __typename?: 'CommonUser', id: number, email: string, createdAt: any, institutionCnpj?: string | null, name?: string | null, cpf?: string | null, photo?: string | null, permissions: Array<string>, teamId?: number | null, computedResolvedAt: string, loggedAs?: boolean | null, defaultSignatureImageId?: string | null, UserConfigs: Array<{ __typename?: 'CommonUserConfig', id: string, key: string, value: any }>, TeamMember: Array<{ __typename?: 'TeamMember', id: number, Team: { __typename?: 'Team', id: number, isActive: boolean, issuerName?: string | null, placeholderName: string } }>, Team: { __typename?: 'Team', id: number, financialShouldCharge: boolean, isNSF: boolean, showImportDiploma: boolean, showCreateDiploma: boolean, issuerData?: any | null, configAddDocumentSignerNode: boolean, publicViewDegreeDomainPath?: string | null, publicViewFinalAcademicTranscriptDomainPath?: string | null, publicViewSchoolCurriculumDomainPath?: string | null, externalSignatureWebhookURL?: string | null, placeholderName: string, spaceUsage: number, storage: number, FinancialTeamWallet?: { __typename?: 'FinancialTeamWallet', id: number, creditsPlanVisual: number, creditsPlanTrial: number, creditsPlanRb: number, creditsPlanRtRa: number, creditsDetachedVisual: number, creditsDetachedRb: number, creditsDetachedRtRa: number, teamId: number, SubscriptionActive?: { __typename?: 'FinancialTeamWalletSubscription', id: string, plan: FinancialPlan, billingCycle?: FinancialBillingCycle | null, planName?: string | null, canceledAt?: any | null, nextDueDate?: any | null, annualCreditQuotaResetDate?: any | null, createdAt: any, planUpdatedPrice: number } | null } | null, TeamEducationLevel: Array<{ __typename?: 'TeamEducationLevel', id: number, educationLevelType: EducationLevelType }>, maintainerSpace?: { __typename?: 'MaintainerSpace', id: number, usage: number, storage: number } | null }, UserAlerts: Array<{ __typename?: 'SystemGlobalAlert', id: number, type: SystemGlobalAlertType, value: string, actionUrl?: string | null, actionTitle?: string | null, message?: string | null, forcedTitle: string, forcedDescription: string, forcedActionUrl?: string | null, myDismissonsCount: number, targetEducationLevels: Array<EducationLevelType> }>, MaintainerAdmin?: { __typename?: 'MaintainerAdmin', id: string, Maintainer: { __typename?: 'Maintainer', id: number, Teams: Array<{ __typename?: 'Team', id: number, isActive: boolean, issuerName?: string | null, placeholderName: string }> } } | null } };

export type CodeAuthRefreshTokensMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type CodeAuthRefreshTokensMutation = { codeAuthRefreshTokens: { __typename?: 'CommonUser', id: number } };

export type CodeServiceSendMessageToSlackMutationVariables = Exact<{
  message: Scalars['String']['input'];
}>;


export type CodeServiceSendMessageToSlackMutation = { codeServiceSendMessageToSlack: string };

export type CompleteOneTemporarySignatureImageMutationVariables = Exact<{
  completeData: CompleteSignatureImage;
}>;


export type CompleteOneTemporarySignatureImageMutation = { completeOneTemporarySignatureImage: { __typename?: 'SignSignatureImage', id: string } };

export type CorrectOneDocumentAuditFileIssuerMutationVariables = Exact<{
  degreeCount: Scalars['Int']['input'];
  documentBaseId: Scalars['String']['input'];
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
  excludeRevoked: Scalars['Boolean']['input'];
}>;


export type CorrectOneDocumentAuditFileIssuerMutation = { correctOneDocumentAuditFileIssuer: { __typename?: 'DocumentAuditFileIssuer', id: string, documentBaseId: string } };

export type CreateApiKeyMutationVariables = Exact<{
  description: Scalars['String']['input'];
}>;


export type CreateApiKeyMutation = { createApiKey: string };

export type CreateBulkDocumentCertificateMutationVariables = Exact<{
  curriculumId?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
  variables: Scalars['Json']['input'];
  importedRecords: Scalars['Json']['input'];
  bulkCertificateRecordName: Scalars['String']['input'];
  eventId?: InputMaybe<Scalars['String']['input']>;
  ignoreUsingExpensiveCreditsError?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateBulkDocumentCertificateMutation = { createBulkDocumentCertificate: { __typename?: 'BulkCertificateRecord', id: string, createdAt: any, totalCertificates: number } };

export type CreateOneDocumentAcademicDocumentationMutationVariables = Exact<{
  draftId: Scalars['String']['input'];
}>;


export type CreateOneDocumentAcademicDocumentationMutation = { createOneDocumentAcademicDocumentation: { __typename?: 'DocumentAcademicDocumentation', id: string, documentBaseId: string, type: DocumentAcademicDocumentationType, status: DocumentAcademicDocumentationStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any, updatedAt?: any | null, creationType: DocumentAcademicDocumentationCreationType, data: any, filePath?: string | null, fileSize: number, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> }, ChildDocuments: Array<{ __typename?: 'DocumentFinalAcademicTranscript', id: string, documentBaseId: string, status: DocumentFinalAcademicTranscriptStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any } }>, LinkedDegreeList: Array<{ __typename?: 'DocumentDegree', id: string, documentBaseId: string, status: DocumentDegreeStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, deletedAt?: any | null } }> } };

export type CreateOneDocumentAcademicDocumentationFromRevokedDocumentMutationVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type CreateOneDocumentAcademicDocumentationFromRevokedDocumentMutation = { createOneDocumentAcademicDocumentationFromRevokedDocument: { __typename?: 'DocumentAcademicDocumentation', id: string, DocumentBase: { __typename?: 'DocumentBase', id: string, internalSeqId: string, type: DocumentBaseType } } };

export type CreateOneCertificateCourseMutationVariables = Exact<{
  areaKnowledge: Scalars['String']['input'];
  metaData: Array<Scalars['String']['input']> | Scalars['String']['input'];
  name: Scalars['String']['input'];
  courseLevelId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateOneCertificateCourseMutation = { createOneCertificateCourse: { __typename?: 'CertificateCourse', id: string, certificateBaseId: string, name: string, areaKnowledge: string, metaData: Array<string> } };

export type CreateOneCertificateCourseLevelMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateOneCertificateCourseLevelMutation = { createOneCertificateCourseLevel: { __typename?: 'CertificateCourseLevel', id: string, certificateBaseId: string, name: string } };

export type CreateOneCertificateCurriculumMutationVariables = Exact<{
  amountOfHours?: InputMaybe<Scalars['Int']['input']>;
  certificateCourseId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  selectedDisciplines: Array<CirriculumSelectedDiscipline> | CirriculumSelectedDiscipline;
}>;


export type CreateOneCertificateCurriculumMutation = { createOneCertificateCurriculum: { __typename?: 'CertificateCurriculum', id: string, certificateBaseId: string, name: string, amountOfHours?: number | null } };

export type CreateOneCertificateDisciplineMutationVariables = Exact<{
  name: Scalars['String']['input'];
  viewOnDegree: Scalars['Boolean']['input'];
}>;


export type CreateOneCertificateDisciplineMutation = { createOneCertificateDiscipline: { __typename?: 'CertificateDiscipline', id: string, certificateBaseId: string, name: string, viewOnDegree: boolean } };

export type CreateOneCertificateEventMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateOneCertificateEventMutation = { createOneCertificateEvent: { __typename?: 'CertificateEvent', id: string, certificateBaseId: string, name: string } };

export type CreateOneCertificateTeacherMutationVariables = Exact<{
  name: Scalars['String']['input'];
  titration: Scalars['String']['input'];
}>;


export type CreateOneCertificateTeacherMutation = { createOneCertificateTeacher: { __typename?: 'CertificateTeacher', id: string, certificateBaseId: string, name: string, titration: string } };

export type CreateOneCertificateTemplateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  data: Scalars['Json']['input'];
}>;


export type CreateOneCertificateTemplateMutation = { createOneCertificateTemplate: { __typename?: 'CertificateTemplate', id: string } };

export type CreateOneDegreeMutationVariables = Exact<{
  degreeDocumentAcademicDocumentationId?: InputMaybe<Scalars['String']['input']>;
  visualRepresentation?: InputMaybe<Scalars['Upload']['input']>;
  xml: Scalars['Upload']['input'];
}>;


export type CreateOneDegreeMutation = { createOneDegree: { __typename?: 'DocumentDegree', id: string, documentBaseId: string, searchCPF: string, searchCourse: string, DocumentBase: { __typename?: 'DocumentBase', id: string, filePath?: string | null } } };

export type CreateOneDegreeFromAcademicDocumentationMutationVariables = Exact<{
  academicDocumentationId: Scalars['String']['input'];
}>;


export type CreateOneDegreeFromAcademicDocumentationMutation = { createOneDegreeFromAcademicDocumentation: { __typename?: 'DocumentDegree', id: string, documentBaseId: string, visualRepresentationPath?: string | null, visualRepresentationFileSize: number, searchStudentName: string, searchCPF: string, searchCourse: string, searchValidationCode?: string | null, status: DocumentDegreeStatus, ParentAcademicDocumentation?: { __typename?: 'DocumentAcademicDocumentation', id: string, DocumentBase: { __typename?: 'DocumentBase', id: string, internalSeqId: string } } | null, DocumentBase: { __typename?: 'DocumentBase', filePath?: string | null, type: DocumentBaseType, id: string, internalSeqId: string, version: string, createdAt: any, updatedAt?: any | null, creationType: DocumentAcademicDocumentationCreationType, data: any, fileSize: number, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> } } };

export type CreateOneDocumentAuditFileIssuerMutationVariables = Exact<{
  degreeCount: Scalars['Int']['input'];
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
  version: Scalars['String']['input'];
  excludeRevoked: Scalars['Boolean']['input'];
}>;


export type CreateOneDocumentAuditFileIssuerMutation = { createOneDocumentAuditFileIssuer: { __typename?: 'DocumentAuditFileIssuer', id: string, documentBaseId: string } };

export type CreateOneDocumentCertificateMutationVariables = Exact<{
  curriculumId?: InputMaybe<Scalars['String']['input']>;
  studentCpf: Scalars['String']['input'];
  studentName: Scalars['String']['input'];
  studentEmail: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
  variables: Scalars['Json']['input'];
  curriculumDisciplinesVariables: Array<CurriculumDisciplineVariable> | CurriculumDisciplineVariable;
  eventId?: InputMaybe<Scalars['String']['input']>;
  ignoreUsingExpensiveCreditsError?: InputMaybe<Scalars['Boolean']['input']>;
  personId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateOneDocumentCertificateMutation = { createOneDocumentCertificate: { __typename?: 'DocumentCertificate', id: string, documentBaseId: string, DocumentCertificateSignatureItems: Array<{ __typename?: 'DocumentCertificateSignatureItem', id: string, type: DocumentCertificateSignatureItemType, PossibleSigners: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInvite', id: number, TeamMember: { __typename?: 'TeamMember', id: number, commonUserId: number } }> }> } };

export type CreateOneDocumentCertificatePreviewMutationVariables = Exact<{
  curriculumId?: InputMaybe<Scalars['String']['input']>;
  studentCpf: Scalars['String']['input'];
  studentName: Scalars['String']['input'];
  studentEmail: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
  variables: Scalars['Json']['input'];
  curriculumDisciplinesVariables: Array<CurriculumDisciplineVariable> | CurriculumDisciplineVariable;
  eventId?: InputMaybe<Scalars['String']['input']>;
  degreeId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateOneDocumentCertificatePreviewMutation = { createOneDocumentCertificatePreview: string };

export type CreateOneDocumentSchoolCurriculumMutationVariables = Exact<{
  createOneDocumentSchoolCurriculumId: Scalars['String']['input'];
}>;


export type CreateOneDocumentSchoolCurriculumMutation = { createOneDocumentSchoolCurriculum: { __typename?: 'DocumentSchoolCurriculum', id: string, searchSchoolCurriculumName: string, searchSchoolCurriculumCode: string, documentBaseId: string, status: DocumentSchoolCurriculumStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any, updatedAt?: any | null, creationType: DocumentAcademicDocumentationCreationType, data: any, filePath?: string | null, fileSize: number, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> } } };

export type CreateOneEnabledInstitutionMutationVariables = Exact<{
  data: CreateOneEnabledInstitutionInput;
}>;


export type CreateOneEnabledInstitutionMutation = { createOneEnabledInstitution: { __typename?: 'EnabledInstitution', id: number, email: string, cnpj: string, educationLevelType: Array<EducationLevelType>, isMaintainer: boolean } };

export type CreateOneDocumentFinalAcademicTranscriptMutationVariables = Exact<{
  baseAcademicId: Scalars['String']['input'];
}>;


export type CreateOneDocumentFinalAcademicTranscriptMutation = { createOneDocumentFinalAcademicTranscript: { __typename?: 'DocumentFinalAcademicTranscript', id: string, DocumentBase: { __typename?: 'DocumentBase', id: string, internalSeqId: string, version: string } } };

export type CreateOneFinancialRechargeMutationVariables = Exact<{
  data: CreateOneFinancialRechargeInput;
}>;


export type CreateOneFinancialRechargeMutation = { createOneFinancialRecharge: { __typename?: 'FinancialRecharge', id: number } };

export type CreateOneMaintainerAdminMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type CreateOneMaintainerAdminMutation = { createOneMaintainerAdmin: { __typename?: 'MaintainerAdmin', id: string, maintainerId: number } };

export type CreateOnePersonMutationVariables = Exact<{
  isForeign: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  receivesCertificateEmail: Scalars['Boolean']['input'];
  receivesCertificateWhatsapp: Scalars['Boolean']['input'];
  phones: Array<Scalars['String']['input']> | Scalars['String']['input'];
  cpf?: InputMaybe<Scalars['String']['input']>;
  passport?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  identityDocument?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<AddressInput>;
}>;


export type CreateOnePersonMutation = { createOnePerson: { __typename?: 'Person', id: string, name: string, createdAt: any } };

export type CreateOneReusableFormDataCurriculumMutationVariables = Exact<{
  data: ReusableFormDataCurriculumCreateInputCustom;
}>;


export type CreateOneReusableFormDataCurriculumMutation = { createOneReusableFormDataCurriculum: { __typename?: 'ReusableFormDataCurriculum', id: number } };

export type CreateOneSignSignatureImageMutationVariables = Exact<{
  data: CreateOneSignSignatureImageData;
}>;


export type CreateOneSignSignatureImageMutation = { createOneSignSignatureImage: { __typename?: 'SignSignatureImage', id: string } };

export type CreateOneSystemGlobalAlertMutationVariables = Exact<{
  data: SystemGlobalAlertCreateInput;
}>;


export type CreateOneSystemGlobalAlertMutation = { createOneSystemGlobalAlert: { __typename?: 'SystemGlobalAlert', id: number } };

export type CreateOneTeamContractMutationVariables = Exact<{
  data: TeamContractCreateInput;
}>;


export type CreateOneTeamContractMutation = { createOneTeamContract: { __typename?: 'TeamContract', id: number, contractUrl: string, isActive?: boolean | null, startOfContract: any, endOfContract: any, createdAt: any, teamId: number, observations: string, storageInGb: number } };

export type DefineOneSignSignatureImageAsPrimaryMutationVariables = Exact<{
  where: SignSignatureImageWhereUniqueInput;
}>;


export type DefineOneSignSignatureImageAsPrimaryMutation = { defineOneSignSignatureImageAsPrimary?: { __typename?: 'SignSignatureImage', id: string } | null };

export type DefineSignersMutationVariables = Exact<{
  data: InviteGroups;
  addSignersNode?: InputMaybe<Scalars['Boolean']['input']>;
  saveDefault?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DefineSignersMutation = { defineSigners: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', id: number }> };

export type DeleteOneApiKeyMutationVariables = Exact<{
  apiKeyId: Scalars['Int']['input'];
}>;


export type DeleteOneApiKeyMutation = { deleteOneApiKey?: { __typename?: 'ApiKey', id: number } | null };

export type DeleteOneCertificateBaseMutationVariables = Exact<{
  certificateId: Scalars['String']['input'];
}>;


export type DeleteOneCertificateBaseMutation = { deleteOneCertificateBase?: { __typename?: 'CertificateBase', id: string } | null };

export type DeleteOneCertificateTemplateMutationVariables = Exact<{
  where: CertificateTemplateWhereUniqueInput;
}>;


export type DeleteOneCertificateTemplateMutation = { deleteOneCertificateTemplate?: { __typename?: 'CertificateTemplate', id: string } | null };

export type DeleteOneDegreeVisualRepresentationMutationVariables = Exact<{
  degreeId: Scalars['String']['input'];
}>;


export type DeleteOneDegreeVisualRepresentationMutation = { deleteOneDegreeVisualRepresentation?: { __typename?: 'DocumentDegree', id: string, documentBaseId: string, visualRepresentationPath?: string | null } | null };

export type DeleteOneDocumentBaseMutationVariables = Exact<{
  deleteOneDocumentBaseId: Scalars['String']['input'];
}>;


export type DeleteOneDocumentBaseMutation = { deleteOneDocumentBase?: { __typename?: 'DocumentBase', id: string, internalSeqId: string, type: DocumentBaseType } | null };

export type DeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutation = { deleteOneDocumentBaseDefaultSignatureInviteConfiguration: { __typename?: 'DocumentBaseDefaultSignatureInviteConfiguration', id: number } };

export type DeleteOneFinancialCreditCardSavedMutationVariables = Exact<{
  where: FinancialCreditCardSavedWhereUniqueInput;
}>;


export type DeleteOneFinancialCreditCardSavedMutation = { deleteOneFinancialCreditCardSaved?: { __typename?: 'FinancialCreditCardSaved', id: number } | null };

export type DeleteOneMaintainerAdminMutationVariables = Exact<{
  where: MaintainerAdminWhereUniqueInput;
}>;


export type DeleteOneMaintainerAdminMutation = { deleteOneMaintainerAdmin?: { __typename?: 'MaintainerAdmin', id: string, commonUserId: number } | null };

export type DeleteOneMaintainerTeamMutationVariables = Exact<{
  where: TeamWhereUniqueInput;
}>;


export type DeleteOneMaintainerTeamMutation = { deleteOneMaintainerTeam?: { __typename?: 'Team', id: number } | null };

export type DeleteOneReusableFormDataMutationVariables = Exact<{
  where: ReusableFormDataWhereUniqueInput;
}>;


export type DeleteOneReusableFormDataMutation = { deleteOneReusableFormData?: { __typename?: 'ReusableFormData', id: number } | null };

export type DeleteOnePersonMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteOnePersonMutation = { deleteOnePerson?: { __typename?: 'Person', id: string } | null };

export type DeleteOneReusableFormDataCurriculumMutationVariables = Exact<{
  deleteOneReusableFormDataCurriculumId: Scalars['Int']['input'];
}>;


export type DeleteOneReusableFormDataCurriculumMutation = { deleteOneReusableFormDataCurriculum?: { __typename?: 'ReusableFormDataCurriculum', id: number } | null };

export type DeleteOneSignSignatureImageMutationVariables = Exact<{
  where: SignSignatureImageWhereUniqueInput;
}>;


export type DeleteOneSignSignatureImageMutation = { deleteOneSignSignatureImage?: { __typename?: 'SignSignatureImage', id: string } | null };

export type DeleteOneSystemGlobalAlertMutationVariables = Exact<{
  where: SystemGlobalAlertWhereUniqueInput;
}>;


export type DeleteOneSystemGlobalAlertMutation = { deleteOneSystemGlobalAlert?: { __typename?: 'SystemGlobalAlert', id: number } | null };

export type DeleteOneTeamContractMutationVariables = Exact<{
  where: TeamContractWhereUniqueInput;
}>;


export type DeleteOneTeamContractMutation = { deleteOneTeamContract?: { __typename?: 'TeamContract', id: number } | null };

export type DeleteOneTeamDocumentTypeSpecificSignaturePolicyConfigMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteOneTeamDocumentTypeSpecificSignaturePolicyConfigMutation = { deleteOneTeamDocumentTypeSpecificSignaturePolicyConfig: { __typename?: 'TeamDocumentTypeSpecificSignaturePolicyConfig', id: number } };

export type DeleteOneTeamMemberMutationVariables = Exact<{
  where: TeamMemberWhereUniqueInput;
}>;


export type DeleteOneTeamMemberMutation = { deleteOneTeamMember?: { __typename?: 'TeamMember', id: number } | null };

export type DismissSystemGlobalAlertMutationVariables = Exact<{
  dismissSystemGlobalAlertId: Scalars['Int']['input'];
}>;


export type DismissSystemGlobalAlertMutation = { dismissSystemGlobalAlert: boolean };

export type DuplicateOneCertificateTemplateMutationVariables = Exact<{
  templateId: Scalars['String']['input'];
}>;


export type DuplicateOneCertificateTemplateMutation = { duplicateOneCertificateTemplate: { __typename?: 'CertificateTemplate', id: string } };

export type FinalizeOneCertificateSignatureMutationVariables = Exact<{
  certificate: Scalars['String']['input'];
  initialize: InitializeResponseInput;
  inviteId: Scalars['String']['input'];
  signatureImageId?: InputMaybe<Scalars['String']['input']>;
}>;


export type FinalizeOneCertificateSignatureMutation = { finalizeOneCertificateSignature: { __typename?: 'DocumentCertificateSignatureItemPossibleSignerInviteSignature', id: number } };

export type FinalizeOneSignatureMutationVariables = Exact<{
  certificate: Scalars['String']['input'];
  initialize: InitializeResponseInput;
  inviteId: Scalars['Int']['input'];
}>;


export type FinalizeOneSignatureMutation = { finalizeOneSignature: { __typename?: 'DocumentBaseSignatureInviteSignature', id: number } };

export type FinalizeOneSignatureExternalSignatureInviteMutationVariables = Exact<{
  certificate: Scalars['String']['input'];
  initialize: InitializeResponseInput;
  inviteId: Scalars['String']['input'];
}>;


export type FinalizeOneSignatureExternalSignatureInviteMutation = { finalizeOneSignature: { __typename?: 'ExternalSignatureInvite', id: string } };

export type FinancialTeamWalletActivateTrialMutationVariables = Exact<{ [key: string]: never; }>;


export type FinancialTeamWalletActivateTrialMutation = { financialTeamWalletActivateTrial: { __typename?: 'FinancialTeamWallet', id: number, teamId: number, creditsPlanTrial: number, SubscriptionActive?: { __typename?: 'FinancialTeamWalletSubscription', id: string, plan: FinancialPlan } | null } };

export type FinancialTeamWalletPurchasePlanMutationVariables = Exact<{
  data: FinancialTeamWalletPurchasePlanInput;
}>;


export type FinancialTeamWalletPurchasePlanMutation = { financialTeamWalletPurchasePlan: { __typename?: 'PurchasedPlanWithOldPlan', id: number, isFirstPlan: boolean, Wallet: { __typename?: 'FinancialTeamWallet', id: number, teamId: number } } };

export type FinancialTeamWalletSubscriptionCancelPlanMutationVariables = Exact<{ [key: string]: never; }>;


export type FinancialTeamWalletSubscriptionCancelPlanMutation = { financialTeamWalletSubscriptionCancelPlan: { __typename?: 'FinancialTeamWalletSubscription', id: string } };

export type SignSignatureImageFieldsFragment = { __typename?: 'SignSignatureImage', id: string, base64Image: string, createdAt: any, description: string, percentageBelowTheLine: number, UserUsingAsPrimary?: { __typename?: 'CommonUser', id: number } | null };

export type FindManySignSignatureImageQueryVariables = Exact<{
  where?: InputMaybe<SignSignatureImageWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SignSignatureImageOrderByWithRelationInput> | SignSignatureImageOrderByWithRelationInput>;
}>;


export type FindManySignSignatureImageQuery = { countSignSignatureImage: number, findManySignSignatureImage: Array<{ __typename?: 'SignSignatureImage', id: string, base64Image: string, createdAt: any, description: string, percentageBelowTheLine: number, UserUsingAsPrimary?: { __typename?: 'CommonUser', id: number } | null }> };

export type ForceDocumentRenotarizationMutationVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type ForceDocumentRenotarizationMutation = { forceDocumentRenotarization: string };

export type ForceDocumentRenotarizationWindowMutationVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type ForceDocumentRenotarizationWindowMutation = { forceDocumentRenotarizationWindow: number };

export type ForceSignDegreeMutationVariables = Exact<{
  degreeId: Scalars['String']['input'];
}>;


export type ForceSignDegreeMutation = { forceSignDegree?: { __typename?: 'DocumentDegree', id: string, documentBaseId: string } | null };

export type PatchOneDocumentAcademicDocumentationMutationVariables = Exact<{
  changes: Array<DocumentChange> | DocumentChange;
  patchOneDocumentAcademicDocumentationId: Scalars['String']['input'];
}>;


export type PatchOneDocumentAcademicDocumentationMutation = { patchOneDocumentAcademicDocumentation: any };

export type PatchOneDegreeMutationVariables = Exact<{
  changes: Array<DocumentChange> | DocumentChange;
  patchOneDegreeId: Scalars['String']['input'];
}>;


export type PatchOneDegreeMutation = { patchOneDegree: any };

export type PatchOneDocumentSchoolCurriculumMutationVariables = Exact<{
  changes: Array<DocumentChange> | DocumentChange;
  patchOneDocumentSchoolCurriculumId: Scalars['String']['input'];
}>;


export type PatchOneDocumentSchoolCurriculumMutation = { patchOneDocumentSchoolCurriculum: any };

export type PayOverduePaymentsMutationVariables = Exact<{
  data: PlanPayOverduePaymentsInput;
}>;


export type PayOverduePaymentsMutation = { payOverduePayments: { __typename?: 'FinancialTeamWalletSubscription', id: string } };

export type RenotarizeDocumentMutationVariables = Exact<{
  documentId: Scalars['String']['input'];
  signatureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RenotarizeDocumentMutation = { renotarizeDocument: { __typename?: 'DocumentBase', id: string, internalSeqId: string, fileSize: number } };

export type ReplaceOneDegreeVisualRepresentationMutationVariables = Exact<{
  degreeId: Scalars['String']['input'];
  visualRepresentation: Scalars['Upload']['input'];
}>;


export type ReplaceOneDegreeVisualRepresentationMutation = { replaceOneDegreeVisualRepresentation?: { __typename?: 'DocumentDegree', id: string, documentBaseId: string, visualRepresentationPath?: string | null } | null };

export type ResendOneTeamMemberEmailMutationVariables = Exact<{
  memberId: Scalars['Int']['input'];
}>;


export type ResendOneTeamMemberEmailMutation = { resendOneTeamMemberEmail: { __typename?: 'TeamMember', id: number } };

export type RevalidateOneDocumentAcademicDocumentationMutationVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type RevalidateOneDocumentAcademicDocumentationMutation = { revalidateOneDocumentAcademicDocumentation?: { __typename?: 'DocumentAcademicDocumentation', id: string, documentBaseId: string } | null };

export type RevalidateOneDegreeMutationVariables = Exact<{
  degreeId: Scalars['String']['input'];
}>;


export type RevalidateOneDegreeMutation = { revalidateOneDegree?: { __typename?: 'DocumentDegree', id: string, documentBaseId: string } | null };

export type ReviewOneDocumentAcademicDocumentationMutationVariables = Exact<{
  academicDocumentationId: Scalars['String']['input'];
  reproveReason?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReviewOneDocumentAcademicDocumentationMutation = { reviewOneDocumentAcademicDocumentation?: { __typename?: 'DocumentAcademicDocumentation', id: string, documentBaseId: string, status: DocumentAcademicDocumentationStatus } | null };

export type ReviewOneDegreeMutationVariables = Exact<{
  degreeId: Scalars['String']['input'];
  reproveReason?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReviewOneDegreeMutation = { reviewOneDegree?: { __typename?: 'DocumentDegree', id: string, documentBaseId: string, visualRepresentationPath?: string | null, visualRepresentationFileSize: number, searchStudentName: string, searchCPF: string, searchCourse: string, searchValidationCode?: string | null, status: DocumentDegreeStatus, ParentAcademicDocumentation?: { __typename?: 'DocumentAcademicDocumentation', id: string, DocumentBase: { __typename?: 'DocumentBase', id: string, internalSeqId: string } } | null, DocumentBase: { __typename?: 'DocumentBase', filePath?: string | null, type: DocumentBaseType, id: string, internalSeqId: string, version: string, createdAt: any, updatedAt?: any | null, creationType: DocumentAcademicDocumentationCreationType, data: any, fileSize: number, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> } } | null };

export type ReviewOneDocumentAuditFileIssuerMutationVariables = Exact<{
  documentBaseId: Scalars['String']['input'];
  reproveReason?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReviewOneDocumentAuditFileIssuerMutation = { reviewOneDocumentAuditFileIssuer?: { __typename?: 'DocumentAuditFileIssuer', id: string, documentBaseId: string, DocumentBase: { __typename?: 'DocumentBase', id: string, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number }> }> } } | null };

export type ReviewOneDocumentSchoolCurriculumMutationVariables = Exact<{
  schoolCurriculumId: Scalars['String']['input'];
  reproveReason?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReviewOneDocumentSchoolCurriculumMutation = { reviewOneDocumentSchoolCurriculum?: { __typename?: 'DocumentSchoolCurriculum', id: string, documentBaseId: string, DocumentBase: { __typename?: 'DocumentBase', id: string, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number }> }> } } | null };

export type RevokeOneDocumentBaseMutationVariables = Exact<{
  id: Scalars['String']['input'];
  revokeReason: Scalars['String']['input'];
}>;


export type RevokeOneDocumentBaseMutation = { revokeOneDocumentBase?: { __typename?: 'DocumentBase', id: string, internalSeqId: string, type: DocumentBaseType } | null };

export type SaveOneDocumentAcademicDocumentationMutationVariables = Exact<{
  data: Scalars['Json']['input'];
  type?: InputMaybe<DocumentAcademicDocumentationType>;
  version: Scalars['String']['input'];
}>;


export type SaveOneDocumentAcademicDocumentationMutation = { saveOneDocumentAcademicDocumentation: { __typename?: 'DocumentAcademicDocumentation', id: string, documentBaseId: string, type: DocumentAcademicDocumentationType, status: DocumentAcademicDocumentationStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any, updatedAt?: any | null, creationType: DocumentAcademicDocumentationCreationType, data: any, filePath?: string | null, fileSize: number, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> }, ChildDocuments: Array<{ __typename?: 'DocumentFinalAcademicTranscript', id: string, documentBaseId: string, status: DocumentFinalAcademicTranscriptStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any } }>, LinkedDegreeList: Array<{ __typename?: 'DocumentDegree', id: string, documentBaseId: string, status: DocumentDegreeStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, deletedAt?: any | null } }> } };

export type SaveOneCommonUserConfigMutationVariables = Exact<{
  data: SaveOneCommonUserConfigInputData;
}>;


export type SaveOneCommonUserConfigMutation = { saveOneCommonUserConfig: { __typename?: 'CommonUserConfig', id: string, key: string } };

export type SaveOneReusableFormDataMutationVariables = Exact<{
  data: Scalars['Json']['input'];
  type: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SaveOneReusableFormDataMutation = { saveOneReusableFormData: { __typename?: 'ReusableFormData', id: number, data: any } };

export type SaveOneDocumentSchoolCurriculumMutationVariables = Exact<{
  data: Scalars['Json']['input'];
  version: Scalars['String']['input'];
}>;


export type SaveOneDocumentSchoolCurriculumMutation = { saveOneDocumentSchoolCurriculum: { __typename?: 'DocumentSchoolCurriculum', id: string, searchSchoolCurriculumName: string, searchSchoolCurriculumCode: string, documentBaseId: string, status: DocumentSchoolCurriculumStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any, updatedAt?: any | null, creationType: DocumentAcademicDocumentationCreationType, data: any, filePath?: string | null, fileSize: number, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> } } };

export type SendActivityMutationVariables = Exact<{
  input: WatchDocumentInput;
}>;


export type SendActivityMutation = { sendActivity: string };

export type SendOneDegreeToReviewMutationVariables = Exact<{
  degreeId: Scalars['String']['input'];
}>;


export type SendOneDegreeToReviewMutation = { sendOneDegreeToReview?: { __typename?: 'DocumentDegree', id: string, documentBaseId: string, visualRepresentationPath?: string | null, visualRepresentationFileSize: number, searchStudentName: string, searchCPF: string, searchCourse: string, searchValidationCode?: string | null, status: DocumentDegreeStatus, ParentAcademicDocumentation?: { __typename?: 'DocumentAcademicDocumentation', id: string, DocumentBase: { __typename?: 'DocumentBase', id: string, internalSeqId: string } } | null, DocumentBase: { __typename?: 'DocumentBase', filePath?: string | null, type: DocumentBaseType, id: string, internalSeqId: string, version: string, createdAt: any, updatedAt?: any | null, creationType: DocumentAcademicDocumentationCreationType, data: any, fileSize: number, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> } } | null };

export type SignOnlyVisualOneSignatureMutationVariables = Exact<{
  inviteId: Scalars['String']['input'];
  signatureImageId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SignOnlyVisualOneSignatureMutation = { signOnlyVisualOneSignature: { __typename?: 'DocumentCertificateSignatureItemPossibleSignerInviteSignature', id: number } };

export type SimulateDegreeValidationResponseMutationVariables = Exact<{
  degreeId: Scalars['String']['input'];
  status: DegreeValidationVerdict;
}>;


export type SimulateDegreeValidationResponseMutation = { simulateDegreeValidationResponse?: { __typename?: 'DocumentDegree', id: string, documentBaseId: string } | null };

export type SingBulkCertificateVisualRepresentationMutationVariables = Exact<{
  certificateList: Array<Scalars['String']['input']> | Scalars['String']['input'];
  signatureImageId?: InputMaybe<Scalars['String']['input']>;
  bulkId: Scalars['String']['input'];
}>;


export type SingBulkCertificateVisualRepresentationMutation = { singBulkCertificateVisualRepresentation: { __typename?: 'CustomReturnType', id: string, success: boolean, total: number } };

export type StartOneCertificateSignatureMutationVariables = Exact<{
  certificate: Scalars['String']['input'];
  inviteId: Scalars['String']['input'];
  signatureImageId?: InputMaybe<Scalars['String']['input']>;
}>;


export type StartOneCertificateSignatureMutation = { startOneCertificateSignature: { __typename?: 'StartSignature', id: string, signingTime: string, dataToSign: string, lastSignatureIsoString: string } };

export type UpdateOneCertificateCourseMutationVariables = Exact<{
  areaKnowledge: Scalars['String']['input'];
  certificateId: Scalars['String']['input'];
  metaData: Array<Scalars['String']['input']> | Scalars['String']['input'];
  name: Scalars['String']['input'];
  courseLevelId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOneCertificateCourseMutation = { updateOneCertificateCourse?: { __typename?: 'CertificateCourse', id: string, areaKnowledge: string, certificateBaseId: string, name: string, metaData: Array<string> } | null };

export type UpdateOneCertificateCourseLevelMutationVariables = Exact<{
  certificateBaseId: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateOneCertificateCourseLevelMutation = { updateOneCertificateCourseLevel?: { __typename?: 'CertificateCourseLevel', id: string, certificateBaseId: string } | null };

export type UpdateOneCertificateCurriculumMutationVariables = Exact<{
  amountOfHours?: InputMaybe<Scalars['Int']['input']>;
  certificateCourseId: Scalars['String']['input'];
  certificateId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  selectedDisciplines: Array<CirriculumSelectedDiscipline> | CirriculumSelectedDiscipline;
}>;


export type UpdateOneCertificateCurriculumMutation = { updateOneCertificateCurriculum?: { __typename?: 'CertificateCurriculum', id: string, certificateBaseId: string, name: string, amountOfHours?: number | null } | null };

export type UpdateOneCertificateDisciplineMutationVariables = Exact<{
  certificateId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  viewOnDegree: Scalars['Boolean']['input'];
}>;


export type UpdateOneCertificateDisciplineMutation = { updateOneCertificateDiscipline?: { __typename?: 'CertificateDiscipline', id: string, certificateBaseId: string, name: string, viewOnDegree: boolean } | null };

export type UpdateOneCertificateEventMutationVariables = Exact<{
  certificateId: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateOneCertificateEventMutation = { updateOneCertificateEvent?: { __typename?: 'CertificateEvent', id: string, certificateBaseId: string, name: string } | null };

export type UpdateOneCertificateTeacherMutationVariables = Exact<{
  name: Scalars['String']['input'];
  titration: Scalars['String']['input'];
  certificateId: Scalars['String']['input'];
}>;


export type UpdateOneCertificateTeacherMutation = { updateOneCertificateTeacher?: { __typename?: 'CertificateTeacher', id: string, certificateBaseId: string, name: string, titration: string } | null };

export type UpdateOneCertificateTemplateMutationVariables = Exact<{
  data: CertificateTemplateUpdateInput;
  where: CertificateTemplateWhereUniqueInput;
}>;


export type UpdateOneCertificateTemplateMutation = { updateOneCertificateTemplate?: { __typename?: 'CertificateTemplate', id: string } | null };

export type UpdateOneDegreeSentToGraduateStatusMutationVariables = Exact<{
  degreeId: Scalars['String']['input'];
  isSentToGraduate: Scalars['Boolean']['input'];
}>;


export type UpdateOneDegreeSentToGraduateStatusMutation = { updateOneDegreeSentToGraduateStatus?: { __typename?: 'DocumentDegree', id: string, documentBaseId: string, isSentToGraduate: boolean, status: DocumentDegreeStatus } | null };

export type UpdateOnePersonMutationVariables = Exact<{
  isForeign: Scalars['Boolean']['input'];
  phones: Array<Scalars['String']['input']> | Scalars['String']['input'];
  receivesCertificateEmail: Scalars['Boolean']['input'];
  receivesCertificateWhatsapp: Scalars['Boolean']['input'];
  address?: InputMaybe<AddressInput>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identityDocument?: InputMaybe<Scalars['String']['input']>;
  passport?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
}>;


export type UpdateOnePersonMutation = { updateOnePerson?: { __typename?: 'Person', id: string, name: string } | null };

export type UpdateOneReusableFormDataCurriculumMutationVariables = Exact<{
  data: ReusableFormDataCurriculumCreateInputCustom;
  where: ReusableFormDataCurriculumWhereUniqueInput;
}>;


export type UpdateOneReusableFormDataCurriculumMutation = { updateOneReusableFormDataCurriculum?: { __typename?: 'ReusableFormDataCurriculum', id: number } | null };

export type UpdateOneSystemGlobalAlertMutationVariables = Exact<{
  data: SystemGlobalAlertUpdateInput;
  where: SystemGlobalAlertWhereUniqueInput;
}>;


export type UpdateOneSystemGlobalAlertMutation = { updateOneSystemGlobalAlert?: { __typename?: 'SystemGlobalAlert', id: number } | null };

export type UpdateOneTeamMutationVariables = Exact<{
  data: UpdateOneTeamData;
}>;


export type UpdateOneTeamMutation = { updateOneTeam?: { __typename?: 'Team', cnpj?: string | null, id: number, TeamEducationLevel: Array<{ __typename?: 'TeamEducationLevel', id: number, educationLevelType: EducationLevelType }> } | null };

export type UpdateOneTeamContractMutationVariables = Exact<{
  data: TeamContractUpdateInput;
  where: TeamContractWhereUniqueInput;
}>;


export type UpdateOneTeamContractMutation = { updateOneTeamContract?: { __typename?: 'TeamContract', id: number, contractUrl: string, isActive?: boolean | null, startOfContract: any, endOfContract: any, updatedAt?: any | null, teamId: number, observations: string, storageInGb: number } | null };

export type UpdateOneTeamDefaultDegreeCertificateTemplateMutationVariables = Exact<{
  certificateTemplateId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOneTeamDefaultDegreeCertificateTemplateMutation = { updateOneTeamDefaultDegreeCertificateTemplate?: { __typename?: 'Team', id: number, DefaultDegreeCertificateTemplate?: { __typename?: 'CertificateTemplate', id: string, name: string } | null } | null };

export type UpdateOneTeamMemberMutationVariables = Exact<{
  updateOneTeamMemberId: Scalars['Int']['input'];
  permissions?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOneTeamMemberMutation = { updateOneTeamMember?: { __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number } } | null };

export type UpdateOneAcademicDocumentationSentToRegistrarStatusMutationVariables = Exact<{
  updateSentToRegistrarStatusId: Scalars['String']['input'];
  isSentToRegistrar: Scalars['Boolean']['input'];
}>;


export type UpdateOneAcademicDocumentationSentToRegistrarStatusMutation = { updateOneAcademicDocumentationSentToRegistrarStatus?: { __typename?: 'DocumentAcademicDocumentation', id: string, documentBaseId: string, isSentToRegistrar: boolean } | null };

export type UpdateTeamActivationStatusMutationVariables = Exact<{
  data: UpdateTeamActivationStatusArgs;
}>;


export type UpdateTeamActivationStatusMutation = { updateTeamActivationStatus: { __typename?: 'Team', id: number, isActive: boolean } };

export type UpdateTeamConfigAddDocumentSignerNodeMutationVariables = Exact<{
  addSigners: Scalars['Boolean']['input'];
}>;


export type UpdateTeamConfigAddDocumentSignerNodeMutation = { updateTeamConfigAddDocumentSignerNode?: { __typename?: 'Team', id: number } | null };

export type UpsertDocumentBaseDefaultSignatureInviteConfigurationMutationVariables = Exact<{
  data: UpsertDocumentBaseDefaultSignatureInviteConfigurationInput;
}>;


export type UpsertDocumentBaseDefaultSignatureInviteConfigurationMutation = { upsertDocumentBaseDefaultSignatureInviteConfiguration: { __typename?: 'DocumentBaseDefaultSignatureInviteConfiguration', id: number } };

export type UpsertOneTemporarySignatureImageMutationVariables = Exact<{
  description: Scalars['String']['input'];
}>;


export type UpsertOneTemporarySignatureImageMutation = { upsertOneTemporarySignatureImage: { __typename?: 'SignSignatureImage', id: string, base64Image: string, description: string, percentageBelowTheLine: number, createdAt: any } };

export type UpsertTeamDocumentTypeSpecificSignaturePolicyConfigMutationVariables = Exact<{
  data: UpsertTeamDocumentTypeSpecificSignaturePolicyConfigInput;
}>;


export type UpsertTeamDocumentTypeSpecificSignaturePolicyConfigMutation = { upsertTeamDocumentTypeSpecificSignaturePolicyConfig: { __typename?: 'TeamDocumentTypeSpecificSignaturePolicyConfig', id: number, teamId: number, documentType: DocumentBaseType, groupPolicies: Array<TeamSpecificSignaturePolicyType> } };

export type ValidateOnePdfaMutationVariables = Exact<{
  base64: Scalars['String']['input'];
}>;


export type ValidateOnePdfaMutation = { validateOnePdfa: boolean };

export type CountDocumentAcademicDocumentationQueryVariables = Exact<{
  where?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
}>;


export type CountDocumentAcademicDocumentationQuery = { count: number };

export type CountDocumentAuditFileIssuerQueryVariables = Exact<{
  where?: InputMaybe<DocumentAuditFileIssuerWhereInput>;
}>;


export type CountDocumentAuditFileIssuerQuery = { count: number };

export type CountDocumentBaseByTypeQueryVariables = Exact<{
  where: DocumentBaseWhereInput;
}>;


export type CountDocumentBaseByTypeQuery = { count?: number | null };

export type CountDocumentCertificateQueryVariables = Exact<{
  where?: InputMaybe<DocumentCertificateWhereInput>;
}>;


export type CountDocumentCertificateQuery = { count: number };

export type CountDocumentDegreeQueryVariables = Exact<{
  where?: InputMaybe<DocumentDegreeWhereInput>;
}>;


export type CountDocumentDegreeQuery = { count: number };

export type CountDocumentFinalAcademicTranscriptQueryVariables = Exact<{
  where?: InputMaybe<DocumentFinalAcademicTranscriptWhereInput>;
}>;


export type CountDocumentFinalAcademicTranscriptQuery = { count: number };

export type CountDocumentRenotarizationQueryVariables = Exact<{
  where?: InputMaybe<DocumentRenotarizationWhereInput>;
}>;


export type CountDocumentRenotarizationQuery = { count: number };

export type CountDocumentSchoolCurriculumQueryVariables = Exact<{
  where?: InputMaybe<DocumentSchoolCurriculumWhereInput>;
}>;


export type CountDocumentSchoolCurriculumQuery = { count: number };

export type CreateOneMaintainerTeamMutationVariables = Exact<{
  cnpj: Scalars['String']['input'];
  educationLevelType: Array<EducationLevelType> | EducationLevelType;
  placeholderName: Scalars['String']['input'];
}>;


export type CreateOneMaintainerTeamMutation = { createOneMaintainerTeam: { __typename?: 'Team', id: number, cnpj?: string | null } };

export type FindAllCountDocumentRenotarizationQueryVariables = Exact<{
  documentBaseType: DocumentBaseType;
}>;


export type FindAllCountDocumentRenotarizationQuery = { findAllCountDocumentRenotarization: { __typename?: 'findAllCountDocumentRenotarizationObject', id: string, totalDocumentsWithRA: number, totalRASignatures: number, pending: number, expiresIn90Days: number, expired: number, renotarized: number } };

export type FindFirstDocumentAcademicDocumentationQueryVariables = Exact<{
  where: DocumentAcademicDocumentationWhereInput;
}>;


export type FindFirstDocumentAcademicDocumentationQuery = { findFirstDocumentAcademicDocumentation?: { __typename?: 'DocumentAcademicDocumentation', id: string, documentBaseId: string, type: DocumentAcademicDocumentationType, status: DocumentAcademicDocumentationStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any, updatedAt?: any | null, creationType: DocumentAcademicDocumentationCreationType, data: any, filePath?: string | null, fileSize: number, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> }, ChildDocuments: Array<{ __typename?: 'DocumentFinalAcademicTranscript', id: string, documentBaseId: string, status: DocumentFinalAcademicTranscriptStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any } }>, LinkedDegreeList: Array<{ __typename?: 'DocumentDegree', id: string, documentBaseId: string, status: DocumentDegreeStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, deletedAt?: any | null } }> } | null };

export type FindFirstDocumentBaseSignatureInviteQueryVariables = Exact<{
  where?: InputMaybe<DocumentBaseSignatureInviteWhereInput>;
}>;


export type FindFirstDocumentBaseSignatureInviteQuery = { findFirstDocumentBaseSignatureInvite?: { __typename?: 'DocumentBaseSignatureInvite', id: number, createdAt: any, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }>, TeamMember?: { __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number, cpf?: string | null } } | null, Group: { __typename?: 'DocumentBaseSignatureInviteGroup', id: number, order: number, DocumentBase: { __typename?: 'DocumentBase', id: string, internalSeqId: string, version: string, type: DocumentBaseType, createdAt: any, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, DocumentAcademicDocumentation?: { __typename?: 'DocumentAcademicDocumentation', id: string, searchStudentName: string, searchCourse: string, searchCPF: string, searchEmecCode: string } | null, DocumentDegree?: { __typename?: 'DocumentDegree', id: string, searchStudentName: string, searchCourse: string, searchCPF: string, searchEmecCode: string } | null, DocumentFinalAcademicTranscript?: { __typename?: 'DocumentFinalAcademicTranscript', id: string, searchStudentName: string, searchCourse: string, searchCPF: string, searchEmecCode: string } | null, DocumentAuditFileIssuer?: { __typename?: 'DocumentAuditFileIssuer', id: string, searchAuditStartDate: string, searchAuditEndDate: string } | null } } } | null };

export type FindFirstDocumentDegreeQueryVariables = Exact<{
  where: DocumentDegreeWhereInput;
}>;


export type FindFirstDocumentDegreeQuery = { findFirstDocumentDegree?: { __typename?: 'DocumentDegree', id: string, documentBaseId: string, visualRepresentationPath?: string | null, visualRepresentationFileSize: number, searchStudentName: string, searchCPF: string, searchCourse: string, searchValidationCode?: string | null, status: DocumentDegreeStatus, ParentAcademicDocumentation?: { __typename?: 'DocumentAcademicDocumentation', id: string, DocumentBase: { __typename?: 'DocumentBase', id: string, internalSeqId: string } } | null, DocumentBase: { __typename?: 'DocumentBase', filePath?: string | null, type: DocumentBaseType, id: string, internalSeqId: string, version: string, createdAt: any, updatedAt?: any | null, creationType: DocumentAcademicDocumentationCreationType, data: any, fileSize: number, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> } } | null };

export type FindFirstReusableFormDataQueryVariables = Exact<{
  where?: InputMaybe<ReusableFormDataWhereInput>;
}>;


export type FindFirstReusableFormDataQuery = { findFirstReusableFormData?: { __typename?: 'ReusableFormData', id: number, createdAt: any, data: any, type: string } | null };

export type FindFirstTeamMemberQueryVariables = Exact<{
  where?: InputMaybe<TeamMemberWhereInput>;
}>;


export type FindFirstTeamMemberQuery = { findFirstTeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null };

export type DocumentAcademicDocumentationTableFieldsFragment = { __typename?: 'DocumentAcademicDocumentation', id: string, documentBaseId: string, status: DocumentAcademicDocumentationStatus, type: DocumentAcademicDocumentationType, searchStudentName: string, searchCPF: string, searchCourse: string, searchEmecCode: string, isSentToRegistrar: boolean, DocumentBase: { __typename?: 'DocumentBase', id: string, internalSeqId: string, creationType: DocumentAcademicDocumentationCreationType, version: string, hasFile: boolean, createdAt: any, deletedAt?: any | null } };

export type FindManyDocumentAcademicDocumentationQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentAcademicDocumentationOrderByWithRelationInput> | DocumentAcademicDocumentationOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
}>;


export type FindManyDocumentAcademicDocumentationQuery = { count: number, findManyDocumentAcademicDocumentation: Array<{ __typename?: 'DocumentAcademicDocumentation', id: string, documentBaseId: string, status: DocumentAcademicDocumentationStatus, type: DocumentAcademicDocumentationType, searchStudentName: string, searchCPF: string, searchCourse: string, searchEmecCode: string, isSentToRegistrar: boolean, DocumentBase: { __typename?: 'DocumentBase', id: string, internalSeqId: string, creationType: DocumentAcademicDocumentationCreationType, version: string, hasFile: boolean, createdAt: any, deletedAt?: any | null } }> };

export type FindManyDocumentBaseSignatureInviteQueryVariables = Exact<{
  where?: InputMaybe<DocumentBaseSignatureInviteWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentBaseSignatureInviteOrderByWithRelationInput> | DocumentBaseSignatureInviteOrderByWithRelationInput>;
}>;


export type FindManyDocumentBaseSignatureInviteQuery = { count: number, findManyDocumentBaseSignatureInvite: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, createdAt: any, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }>, TeamMember?: { __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number, cpf?: string | null } } | null, Group: { __typename?: 'DocumentBaseSignatureInviteGroup', id: number, order: number, DocumentBase: { __typename?: 'DocumentBase', id: string, internalSeqId: string, version: string, type: DocumentBaseType, createdAt: any, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, DocumentAcademicDocumentation?: { __typename?: 'DocumentAcademicDocumentation', id: string, searchStudentName: string, searchCourse: string, searchCPF: string, searchEmecCode: string } | null, DocumentDegree?: { __typename?: 'DocumentDegree', id: string, searchStudentName: string, searchCourse: string, searchCPF: string, searchEmecCode: string } | null, DocumentFinalAcademicTranscript?: { __typename?: 'DocumentFinalAcademicTranscript', id: string, searchStudentName: string, searchCourse: string, searchCPF: string, searchEmecCode: string } | null, DocumentAuditFileIssuer?: { __typename?: 'DocumentAuditFileIssuer', id: string, searchAuditStartDate: string, searchAuditEndDate: string } | null } } }> };

export type FindManyApiKeyQueryVariables = Exact<{
  where?: InputMaybe<ApiKeyWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApiKeyOrderByWithRelationInput> | ApiKeyOrderByWithRelationInput>;
}>;


export type FindManyApiKeyQuery = { count: number, findManyApiKey: Array<{ __typename?: 'ApiKey', id: number, description: string, createdAt: any }> };

export type FindManyBulkCertificateRecordQueryVariables = Exact<{
  where?: InputMaybe<BulkCertificateRecordWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BulkCertificateRecordOrderByWithRelationInput> | BulkCertificateRecordOrderByWithRelationInput>;
}>;


export type FindManyBulkCertificateRecordQuery = { count: number, findManyBulkCertificateRecord: Array<{ __typename?: 'BulkCertificateRecord', id: string, bulkCertificateRecordName: string, totalCertificates: number, createdAt: any }> };

export type CertificateCourseFieldsFragment = { __typename?: 'CertificateCourse', id: string, certificateBaseId: string, name: string, areaKnowledge: string, metaData: Array<string>, CertificateBase: { __typename?: 'CertificateBase', id: string, createdAt: any }, CourseLevel?: { __typename?: 'CertificateCourseLevel', id: string, certificateBaseId: string, name: string } | null };

export type FindManyCertificateCourseQueryVariables = Exact<{
  where?: InputMaybe<CertificateCourseWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CertificateCourseOrderByWithRelationInput> | CertificateCourseOrderByWithRelationInput>;
}>;


export type FindManyCertificateCourseQuery = { count: number, findManyCertificateCourse: Array<{ __typename?: 'CertificateCourse', id: string, certificateBaseId: string, name: string, areaKnowledge: string, metaData: Array<string>, CertificateBase: { __typename?: 'CertificateBase', id: string, createdAt: any }, CourseLevel?: { __typename?: 'CertificateCourseLevel', id: string, certificateBaseId: string, name: string } | null }> };

export type CertificateCourseLevelFieldsFragment = { __typename?: 'CertificateCourseLevel', id: string, certificateBaseId: string, name: string, CertificateBase: { __typename?: 'CertificateBase', id: string, createdAt: any } };

export type FindManyCertificateCourseLevelQueryVariables = Exact<{
  where?: InputMaybe<CertificateCourseLevelWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CertificateCourseLevelOrderByWithRelationInput> | CertificateCourseLevelOrderByWithRelationInput>;
}>;


export type FindManyCertificateCourseLevelQuery = { count: number, findManyCertificateCourseLevel: Array<{ __typename?: 'CertificateCourseLevel', id: string, certificateBaseId: string, name: string, CertificateBase: { __typename?: 'CertificateBase', id: string, createdAt: any } }> };

export type CertificateCurriculumFieldsFragment = { __typename?: 'CertificateCurriculum', id: string, certificateBaseId: string, name: string, amountOfHours?: number | null, CertificateBase: { __typename?: 'CertificateBase', id: string, createdAt: any }, CertificateCurriculumSelectedDisciplines: Array<{ __typename?: 'CertificateCurriculumSelectedDiscipline', id: number, SelectedDiscipline: { __typename?: 'CertificateDiscipline', id: string, name: string, certificateBaseId: string } }> };

export type FindManyCertificateCurriculumQueryVariables = Exact<{
  where?: InputMaybe<CertificateCurriculumWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CertificateCurriculumOrderByWithRelationInput> | CertificateCurriculumOrderByWithRelationInput>;
}>;


export type FindManyCertificateCurriculumQuery = { count: number, findManyCertificateCurriculum: Array<{ __typename?: 'CertificateCurriculum', id: string, certificateBaseId: string, name: string, amountOfHours?: number | null, CertificateBase: { __typename?: 'CertificateBase', id: string, createdAt: any }, CertificateCurriculumSelectedDisciplines: Array<{ __typename?: 'CertificateCurriculumSelectedDiscipline', id: number, SelectedDiscipline: { __typename?: 'CertificateDiscipline', id: string, name: string, certificateBaseId: string } }> }> };

export type FindManyCertificateDisciplineQueryVariables = Exact<{
  where?: InputMaybe<CertificateDisciplineWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CertificateDisciplineOrderByWithRelationInput> | CertificateDisciplineOrderByWithRelationInput>;
}>;


export type FindManyCertificateDisciplineQuery = { count: number, findManyCertificateDiscipline: Array<{ __typename?: 'CertificateDiscipline', id: string, certificateBaseId: string, name: string, viewOnDegree: boolean, CertificateBase: { __typename?: 'CertificateBase', id: string, createdAt: any } }> };

export type CertificateEventFieldsFragment = { __typename?: 'CertificateEvent', id: string, certificateBaseId: string, name: string, CertificateBase: { __typename?: 'CertificateBase', id: string, createdAt: any } };

export type FindManyCertificateEventQueryVariables = Exact<{
  where?: InputMaybe<CertificateEventWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CertificateEventOrderByWithRelationInput> | CertificateEventOrderByWithRelationInput>;
}>;


export type FindManyCertificateEventQuery = { count: number, findManyCertificateEvent: Array<{ __typename?: 'CertificateEvent', id: string, certificateBaseId: string, name: string, CertificateBase: { __typename?: 'CertificateBase', id: string, createdAt: any } }> };

export type FindManyCertificateTeacherQueryVariables = Exact<{
  where?: InputMaybe<CertificateTeacherWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CertificateTeacherOrderByWithRelationInput> | CertificateTeacherOrderByWithRelationInput>;
}>;


export type FindManyCertificateTeacherQuery = { count: number, findManyCertificateTeacher: Array<{ __typename?: 'CertificateTeacher', id: string, certificateBaseId: string, name: string, titration: string, CertificateBase: { __typename?: 'CertificateBase', id: string, createdAt: any } }> };

export type CertificateTemplateManyFieldsFragment = { __typename?: 'CertificateTemplate', id: string, name: string, description?: string | null, createdAt: any, commonUserId: number, TeamUsingAsPrimary?: { __typename?: 'Team', id: number } | null };

export type FindManyCertificateTemplateQueryVariables = Exact<{
  where?: InputMaybe<CertificateTemplateWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CertificateTemplateOrderByWithRelationInput> | CertificateTemplateOrderByWithRelationInput>;
}>;


export type FindManyCertificateTemplateQuery = { count: number, items: Array<{ __typename?: 'CertificateTemplate', id: string, name: string, description?: string | null, createdAt: any, commonUserId: number, TeamUsingAsPrimary?: { __typename?: 'Team', id: number } | null }> };

export type FindManyCertificateTemplatePresetQueryVariables = Exact<{
  where?: InputMaybe<CertificateTemplatePresetWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CertificateTemplatePresetOrderByWithRelationInput> | CertificateTemplatePresetOrderByWithRelationInput>;
}>;


export type FindManyCertificateTemplatePresetQuery = { count: number, findManyCertificateTemplatePreset: Array<{ __typename?: 'CertificateTemplatePreset', name: string, imageUrl: string, id: string, createdAt: any }> };

export type FindManyCertificatesByBatchIdQueryVariables = Exact<{
  batchId?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindManyCertificatesByBatchIdQuery = { findManyCertificatesByBatchId: Array<{ __typename?: 'DocumentCertificate', id: string, documentBaseId: string, documentCertificateName: string, documentCertificateCPF: string, status: DocumentCertificateStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, createdAt: any, filePath?: string | null }, DocumentCertificateSignatureItems: Array<{ __typename?: 'DocumentCertificateSignatureItem', id: string, predefinedImageBase64?: string | null, type: DocumentCertificateSignatureItemType, DocumentCertificate: { __typename?: 'DocumentCertificate', id: string, documentBaseId: string, uuid: string, documentCertificateCPF: string, documentCertificateName: string, certificateTemplateId?: string | null, status: DocumentCertificateStatus, hasOnlyPredefinedVisualSignature: boolean, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any, updatedAt?: any | null, creationType: DocumentAcademicDocumentationCreationType, data: any, filePath?: string | null, fileSize: number, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> }, DocumentCertificateSignatureItems: Array<{ __typename?: 'DocumentCertificateSignatureItem', id: string, type: DocumentCertificateSignatureItemType, predefinedImageBase64?: string | null, createdAt: any, PossibleSigners: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInvite', id: number, TeamMember: { __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number, cpf?: string | null, name?: string | null, email: string } }, DocumentCertificateSignatureItemPossibleSignerInviteSignature: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInviteSignature', id: number, success: boolean, createdAt: any }> }> }>, Person: { __typename?: 'Person', id: string, name: string, cpf?: string | null, email?: string | null }, Curriculum?: { __typename?: 'CertificateCurriculum', id: string, name: string, CertificateCourse: { __typename?: 'CertificateCourse', id: string, name: string } } | null, BulkCertificateRecord?: { __typename?: 'BulkCertificateRecord', id: string, status: DocumentCertificateStatus, bulkCertificateRecordName: string } | null, DocumentCertificateHashHistory: Array<{ __typename?: 'DocumentCertificateHashHistory', id: string, hash: string }>, TeamEducationLevel: { __typename?: 'TeamEducationLevel', id: number, educationLevelType: EducationLevelType } }, PossibleSigners: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInvite', id: number, TeamMember: { __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }, DocumentCertificateSignatureItemPossibleSignerInviteSignature: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInviteSignature', id: number, success: boolean, createdAt: any }> }> }> }> };

export type FindManyCommonUserQueryVariables = Exact<{
  where?: InputMaybe<CommonUserWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommonUserOrderByWithRelationInput> | CommonUserOrderByWithRelationInput>;
}>;


export type FindManyCommonUserQuery = { findManyCommonUser: Array<{ __typename?: 'CommonUser', name?: string | null, id: number, email: string, photo?: string | null, Team: { __typename?: 'Team', id: number, issuerName?: string | null, placeholderName: string } }> };

export type FindManyDegreeQueryVariables = Exact<{
  where?: InputMaybe<DocumentDegreeWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentDegreeOrderByWithRelationInput> | DocumentDegreeOrderByWithRelationInput>;
  isAdminView?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FindManyDegreeQuery = { count: number, findManyDegree: Array<{ __typename?: 'DocumentDegree', id: string, documentBaseId: string, searchStudentName: string, searchCPF: string, searchCourse: string, searchEmecCode: string, status: DocumentDegreeStatus, searchValidationCode?: string | null, searchIssueDate?: any | null, searchRegistrationDate?: any | null, visualRepresentationCreationType: VisualRepresentationCreationType, visualRepresentationFileSize: number, isSentToGraduate: boolean, DocumentBase: { __typename?: 'DocumentBase', id: string, internalSeqId: string, creationType: DocumentAcademicDocumentationCreationType, fileSize: number, hasFile: boolean, createdAt: any, deletedAt?: any | null } }> };

export type FindManyDocumentAuditFileIssuerQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentAuditFileIssuerWhereInput>;
  orderBy?: InputMaybe<Array<DocumentAuditFileIssuerOrderByWithRelationInput> | DocumentAuditFileIssuerOrderByWithRelationInput>;
}>;


export type FindManyDocumentAuditFileIssuerQuery = { count: number, findManyDocumentAuditFileIssuer: Array<{ __typename?: 'DocumentAuditFileIssuer', id: string, documentBaseId: string, searchAuditStartDate: string, searchAuditEndDate: string, status: DocumentAuditFileIssuerStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, filePath?: string | null, createdAt: any, deletedAt?: any | null } }> };

export type FindManyDocumentBaseDefaultSignatureInviteConfigurationQueryVariables = Exact<{
  where?: InputMaybe<DocumentBaseDefaultSignatureInviteConfigurationWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentBaseDefaultSignatureInviteConfigurationOrderByWithRelationInput> | DocumentBaseDefaultSignatureInviteConfigurationOrderByWithRelationInput>;
}>;


export type FindManyDocumentBaseDefaultSignatureInviteConfigurationQuery = { countDocumentBaseDefaultSignatureInviteConfiguration: number, findManyDocumentBaseDefaultSignatureInviteConfiguration: Array<{ __typename?: 'DocumentBaseDefaultSignatureInviteConfiguration', id: number, type: DocumentBaseType, createdAt: any, updatedAt?: any | null, Groups: Array<{ __typename?: 'DocumentBaseDefaultSignatureInviteConfigurationGroup', id: number, Items: Array<{ __typename?: 'DocumentBaseDefaultSignatureInviteConfigurationGroupItem', id: number, teamMemberId?: number | null, TeamMember?: { __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string } } | null }> }> }> };

export type FindManyDocumentCertificateQueryVariables = Exact<{
  where?: InputMaybe<DocumentCertificateWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentCertificateOrderByWithRelationInput> | DocumentCertificateOrderByWithRelationInput>;
}>;


export type FindManyDocumentCertificateQuery = { count: number, findManyDocumentCertificate: Array<{ __typename?: 'DocumentCertificate', id: string, documentBaseId: string, documentCertificateName: string, documentCertificateCPF: string, status: DocumentCertificateStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, createdAt: any, hasFile: boolean, deletedAt?: any | null }, DocumentCertificateSignatureItems: Array<{ __typename?: 'DocumentCertificateSignatureItem', id: string, predefinedImageBase64?: string | null, type: DocumentCertificateSignatureItemType, DocumentCertificate: { __typename?: 'DocumentCertificate', id: string, documentBaseId: string, uuid: string, documentCertificateCPF: string, documentCertificateName: string, certificateTemplateId?: string | null, status: DocumentCertificateStatus, hasOnlyPredefinedVisualSignature: boolean, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any, updatedAt?: any | null, creationType: DocumentAcademicDocumentationCreationType, data: any, filePath?: string | null, fileSize: number, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> }, DocumentCertificateSignatureItems: Array<{ __typename?: 'DocumentCertificateSignatureItem', id: string, type: DocumentCertificateSignatureItemType, predefinedImageBase64?: string | null, createdAt: any, PossibleSigners: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInvite', id: number, TeamMember: { __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number, cpf?: string | null, name?: string | null, email: string } }, DocumentCertificateSignatureItemPossibleSignerInviteSignature: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInviteSignature', id: number, success: boolean, createdAt: any }> }> }>, Person: { __typename?: 'Person', id: string, name: string, cpf?: string | null, email?: string | null }, Curriculum?: { __typename?: 'CertificateCurriculum', id: string, name: string, CertificateCourse: { __typename?: 'CertificateCourse', id: string, name: string } } | null, BulkCertificateRecord?: { __typename?: 'BulkCertificateRecord', id: string, status: DocumentCertificateStatus, bulkCertificateRecordName: string } | null, DocumentCertificateHashHistory: Array<{ __typename?: 'DocumentCertificateHashHistory', id: string, hash: string }>, TeamEducationLevel: { __typename?: 'TeamEducationLevel', id: number, educationLevelType: EducationLevelType } }, PossibleSigners: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInvite', id: number, TeamMember: { __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }, DocumentCertificateSignatureItemPossibleSignerInviteSignature: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInviteSignature', id: number, success: boolean, createdAt: any }> }> }> }> };

export type FindManyDocumentCertificateSignatureItemQueryVariables = Exact<{
  where?: InputMaybe<DocumentCertificateSignatureItemWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentCertificateSignatureItemOrderByWithRelationInput> | DocumentCertificateSignatureItemOrderByWithRelationInput>;
}>;


export type FindManyDocumentCertificateSignatureItemQuery = { countDocumentCertificateSignatureItem: number, findManyDocumentCertificateSignatureItem: Array<{ __typename?: 'DocumentCertificateSignatureItem', id: string, predefinedImageBase64?: string | null, type: DocumentCertificateSignatureItemType, createdAt: any, DocumentCertificate: { __typename?: 'DocumentCertificate', id: string, documentCertificateName: string, documentCertificateCPF: string, DocumentBase: { __typename?: 'DocumentBase', id: string, internalSeqId: string }, DocumentCertificateSignatureItems: Array<{ __typename?: 'DocumentCertificateSignatureItem', id: string, predefinedImageBase64?: string | null, type: DocumentCertificateSignatureItemType, createdAt: any, PossibleSigners: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInvite', id: number, TeamMember: { __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string } }, DocumentCertificateSignatureItemPossibleSignerInviteSignature: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInviteSignature', id: number, success: boolean, createdAt: any }> }> }> }, PossibleSigners: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInvite', id: number, TeamMember: { __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string } }, DocumentCertificateSignatureItemPossibleSignerInviteSignature: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInviteSignature', id: number, success: boolean, createdAt: any }> }> }> };

export type FindManyDocumentFinalAcademicTranscriptQueryVariables = Exact<{
  where?: InputMaybe<DocumentFinalAcademicTranscriptWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentFinalAcademicTranscriptOrderByWithRelationInput> | DocumentFinalAcademicTranscriptOrderByWithRelationInput>;
}>;


export type FindManyDocumentFinalAcademicTranscriptQuery = { count: number, findManyDocumentFinalAcademicTranscript: Array<{ __typename?: 'DocumentFinalAcademicTranscript', id: string, documentBaseId: string, status: DocumentFinalAcademicTranscriptStatus, searchStudentName: string, searchCourse: string, searchCPF: string, searchEmecCode: string, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, createdAt: any, deletedAt?: any | null } }> };

export type DocumentRenotarizationHistoryTableFieldsFragment = { __typename?: 'DocumentRenotarizationHistory', id: number, type: DocumentRenotarizationStatus, signatureId?: string | null, userName?: string | null, userEmail?: string | null, archiveTimestamp?: any | null, archiveTimestampCertificateExpiration: any, archiveTimestampAuthority: string, archiveTimestampAlgorithm: string, archiveTimestampSerial: string, createdAt: any };

export type DocumentRenotarizationTableFieldsFragment = { __typename?: 'DocumentRenotarization', id: string, documentBaseId: string, archiveTimestampCertificateExpiration: any, createdAt: any, updatedAt: any, signatureId?: string | null, Histories: Array<{ __typename?: 'DocumentRenotarizationHistory', id: number, type: DocumentRenotarizationStatus, signatureId?: string | null, userName?: string | null, userEmail?: string | null, archiveTimestamp?: any | null, archiveTimestampCertificateExpiration: any, archiveTimestampAuthority: string, archiveTimestampAlgorithm: string, archiveTimestampSerial: string, createdAt: any }>, DocumentBase: { __typename?: 'DocumentBase', id: string, internalSeqId: string, createdAt: any, type: DocumentBaseType, version: string, deletedAt?: any | null, data: any, Team: { __typename?: 'Team', id: number, placeholderName: string, issuerName?: string | null, EnabledInstitution?: { __typename?: 'EnabledInstitution', id: number, placeholderName: string } | null }, Renotarizations: Array<{ __typename?: 'DocumentRenotarization', id: string, archiveTimestampCertificateExpiration: any, createdAt: any }>, DocumentAcademicDocumentation?: { __typename?: 'DocumentAcademicDocumentation', id: string, searchStudentName: string } | null, DocumentFinalAcademicTranscript?: { __typename?: 'DocumentFinalAcademicTranscript', id: string, searchStudentName: string } | null, DocumentDegree?: { __typename?: 'DocumentDegree', id: string, searchStudentName: string } | null, DocumentCertificate?: { __typename?: 'DocumentCertificate', id: string, documentCertificateName: string } | null, DocumentSchoolCurriculum?: { __typename?: 'DocumentSchoolCurriculum', id: string, searchSchoolCurriculumName: string } | null } };

export type FindManyDocumentRenotarizationQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentRenotarizationOrderByWithRelationInput> | DocumentRenotarizationOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentRenotarizationWhereInput>;
}>;


export type FindManyDocumentRenotarizationQuery = { count: number, findManyDocumentRenotarization: Array<{ __typename?: 'DocumentRenotarization', id: string, documentBaseId: string, archiveTimestampCertificateExpiration: any, createdAt: any, updatedAt: any, signatureId?: string | null, Histories: Array<{ __typename?: 'DocumentRenotarizationHistory', id: number, type: DocumentRenotarizationStatus, signatureId?: string | null, userName?: string | null, userEmail?: string | null, archiveTimestamp?: any | null, archiveTimestampCertificateExpiration: any, archiveTimestampAuthority: string, archiveTimestampAlgorithm: string, archiveTimestampSerial: string, createdAt: any }>, DocumentBase: { __typename?: 'DocumentBase', id: string, internalSeqId: string, createdAt: any, type: DocumentBaseType, version: string, deletedAt?: any | null, data: any, Team: { __typename?: 'Team', id: number, placeholderName: string, issuerName?: string | null, EnabledInstitution?: { __typename?: 'EnabledInstitution', id: number, placeholderName: string } | null }, Renotarizations: Array<{ __typename?: 'DocumentRenotarization', id: string, archiveTimestampCertificateExpiration: any, createdAt: any }>, DocumentAcademicDocumentation?: { __typename?: 'DocumentAcademicDocumentation', id: string, searchStudentName: string } | null, DocumentFinalAcademicTranscript?: { __typename?: 'DocumentFinalAcademicTranscript', id: string, searchStudentName: string } | null, DocumentDegree?: { __typename?: 'DocumentDegree', id: string, searchStudentName: string } | null, DocumentCertificate?: { __typename?: 'DocumentCertificate', id: string, documentCertificateName: string } | null, DocumentSchoolCurriculum?: { __typename?: 'DocumentSchoolCurriculum', id: string, searchSchoolCurriculumName: string } | null } }> };

export type FindManyDocumentRenotarizationForSelectionQueryVariables = Exact<{
  where?: InputMaybe<DocumentRenotarizationWhereInput>;
  orderBy?: InputMaybe<Array<DocumentRenotarizationOrderByWithRelationInput> | DocumentRenotarizationOrderByWithRelationInput>;
}>;


export type FindManyDocumentRenotarizationForSelectionQuery = { findManyDocumentRenotarization: Array<{ __typename?: 'DocumentRenotarization', id: string, documentBaseId: string, signatureId?: string | null, createdAt: any, Histories: Array<{ __typename?: 'DocumentRenotarizationHistory', id: number, type: DocumentRenotarizationStatus, userName?: string | null }>, DocumentBase: { __typename?: 'DocumentBase', id: string, internalSeqId: string } }> };

export type FindManyDocumentSchoolCurriculumQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<DocumentSchoolCurriculumOrderByWithRelationInput> | DocumentSchoolCurriculumOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DocumentSchoolCurriculumWhereInput>;
}>;


export type FindManyDocumentSchoolCurriculumQuery = { count: number, findManyDocumentSchoolCurriculum: Array<{ __typename?: 'DocumentSchoolCurriculum', id: string, documentBaseId: string, searchSchoolCurriculumName: string, searchSchoolCurriculumCode: string, searchSelectedCourse: string, status: DocumentSchoolCurriculumStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, createdAt: any, deletedAt?: any | null, hasFile: boolean } }> };

export type EnabledInstitutionFieldsFragment = { __typename?: 'EnabledInstitution', id: number, cnpj: string, email: string, isMaintainer: boolean, placeholderName: string, Team?: { __typename?: 'Team', id: number, placeholderName: string, contract: string, observations: string, syncWithLedgerDoc: boolean, isNSF: boolean, showImportDiploma: boolean, showCreateDiploma: boolean, lastActivityAt: any, issuedCount: number, logoBase64?: string | null, faviconBase64?: string | null, publicViewDegreeDomainPath?: string | null, publicViewFinalAcademicTranscriptDomainPath?: string | null, publicViewSchoolCurriculumDomainPath?: string | null, publicViewInstitutionName?: string | null, publicViewPrimaryColor?: string | null, publicViewSecondaryColor?: string | null, externalSignatureWebhookURL?: string | null, validateCertificateURL?: string | null, isActive: boolean, deactivationReason?: string | null, issuerData?: any | null, issuerName?: string | null, spaceUsage: number, storage: number, TeamEducationLevel: Array<{ __typename?: 'TeamEducationLevel', id: number, educationLevelType: EducationLevelType }>, Maintainer?: { __typename?: 'Maintainer', id: number, MainTeam: { __typename?: 'Team', id: number, issuerName?: string | null, placeholderName: string }, Teams: Array<{ __typename?: 'Team', id: number }> } | null, TeamContracts: Array<{ __typename?: 'TeamContract', id: number, contractUrl: string, startOfContract: any, endOfContract: any, isActive?: boolean | null }>, maintainerSpace?: { __typename?: 'MaintainerSpace', id: number, usage: number, storage: number } | null } | null };

export type FindManyEnabledInstitutionQueryVariables = Exact<{
  where?: InputMaybe<EnabledInstitutionWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EnabledInstitutionOrderByWithRelationInput> | EnabledInstitutionOrderByWithRelationInput>;
}>;


export type FindManyEnabledInstitutionQuery = { count: number, totalIssuedDocuments: number, findManyEnabledInstitution: Array<{ __typename?: 'EnabledInstitution', id: number, cnpj: string, email: string, isMaintainer: boolean, placeholderName: string, Team?: { __typename?: 'Team', id: number, placeholderName: string, contract: string, observations: string, syncWithLedgerDoc: boolean, isNSF: boolean, showImportDiploma: boolean, showCreateDiploma: boolean, lastActivityAt: any, issuedCount: number, logoBase64?: string | null, faviconBase64?: string | null, publicViewDegreeDomainPath?: string | null, publicViewFinalAcademicTranscriptDomainPath?: string | null, publicViewSchoolCurriculumDomainPath?: string | null, publicViewInstitutionName?: string | null, publicViewPrimaryColor?: string | null, publicViewSecondaryColor?: string | null, externalSignatureWebhookURL?: string | null, validateCertificateURL?: string | null, isActive: boolean, deactivationReason?: string | null, issuerData?: any | null, issuerName?: string | null, spaceUsage: number, storage: number, TeamEducationLevel: Array<{ __typename?: 'TeamEducationLevel', id: number, educationLevelType: EducationLevelType }>, Maintainer?: { __typename?: 'Maintainer', id: number, MainTeam: { __typename?: 'Team', id: number, issuerName?: string | null, placeholderName: string }, Teams: Array<{ __typename?: 'Team', id: number }> } | null, TeamContracts: Array<{ __typename?: 'TeamContract', id: number, contractUrl: string, startOfContract: any, endOfContract: any, isActive?: boolean | null }>, maintainerSpace?: { __typename?: 'MaintainerSpace', id: number, usage: number, storage: number } | null } | null }> };

export type FindManyFinancialChargeQueryVariables = Exact<{
  where?: InputMaybe<FinancialChargeWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FinancialChargeOrderByWithRelationInput> | FinancialChargeOrderByWithRelationInput>;
}>;


export type FindManyFinancialChargeQuery = { count: number, findManyFinancialCharge: Array<{ __typename?: 'FinancialCharge', id: number, service: FinancialChargeableService, createdAt: any, creditsDeducted: number, UserExecuted: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, photo?: string | null } }> };

export type FindManyFinancialCreditCardSavedQueryVariables = Exact<{ [key: string]: never; }>;


export type FindManyFinancialCreditCardSavedQuery = { findManyFinancialCreditCardSaved: Array<{ __typename?: 'FinancialCreditCardSaved', id: number, token: string, number: string, brand: string }> };

export type PlanAndConditionsFieldsFragment = { __typename?: 'PlanAndConditions', id: number, includedCertificates: number, name: string, monthlyPricing: number, yearlyPricing: number, plan: FinancialPlan, disabled: boolean };

export type FindManyFinancialPlanQueryVariables = Exact<{ [key: string]: never; }>;


export type FindManyFinancialPlanQuery = { findManyFinancialPlan: Array<{ __typename?: 'PlanAndConditions', id: number, includedCertificates: number, name: string, monthlyPricing: number, yearlyPricing: number, plan: FinancialPlan, disabled: boolean }> };

export type FindManyFinancialPaymentQueryVariables = Exact<{
  where?: InputMaybe<FinancialPaymentWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FinancialPaymentOrderByWithRelationInput> | FinancialPaymentOrderByWithRelationInput>;
}>;


export type FindManyFinancialPaymentQuery = { count: number, items: Array<{ __typename?: 'FinancialPayment', id: string, createdAt: any, Recharge?: { __typename?: 'FinancialRecharge', id: number, createdAt: any, cost: any, creditsCount: number, creditsType: FinancialChargeableService, UserExecuted: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, photo?: string | null } } | null, SubscriptionPayment?: { __typename?: 'FinancialTeamWalletSubscriptionPayment', dueDate: any, cost: any, id: string, createdAt: any, Subscription: { __typename?: 'FinancialTeamWalletSubscription', id: string, plan: FinancialPlan, planName?: string | null } } | null }> };

export type FinancialTeamWalletSubscriptionPaymentFieldsFragment = { __typename?: 'FinancialTeamWalletSubscriptionPayment', id: string, dueDate: any, cost: any, createdAt: any, status: PaymentStatus };

export type FindManyFinancialTeamWalletSubscriptionPaymentQueryVariables = Exact<{
  where?: InputMaybe<FinancialTeamWalletSubscriptionPaymentWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FinancialTeamWalletSubscriptionPaymentOrderByWithRelationInput> | FinancialTeamWalletSubscriptionPaymentOrderByWithRelationInput>;
}>;


export type FindManyFinancialTeamWalletSubscriptionPaymentQuery = { count: number, items: Array<{ __typename?: 'FinancialTeamWalletSubscriptionPayment', id: string, dueDate: any, cost: any, createdAt: any, status: PaymentStatus }> };

export type FindManyMaintainerAdminQueryVariables = Exact<{
  where?: InputMaybe<MaintainerAdminWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MaintainerAdminOrderByWithRelationInput> | MaintainerAdminOrderByWithRelationInput>;
}>;


export type FindManyMaintainerAdminQuery = { countMaintainerAdmin: number, findManyMaintainerAdmin: Array<{ __typename?: 'MaintainerAdmin', id: string, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, idLedgerSign?: number | null, name?: string | null, cpf?: string | null } }> };

export type FindManyMaintainerAdministeredQueryVariables = Exact<{
  maintainerTeamId: Scalars['String']['input'];
}>;


export type FindManyMaintainerAdministeredQuery = { findManyMaintainerAdministered: Array<{ __typename?: 'EnabledInstitution', id: number, cnpj: string, email: string, isMaintainer: boolean, placeholderName: string, Team?: { __typename?: 'Team', id: number, placeholderName: string, contract: string, observations: string, syncWithLedgerDoc: boolean, isNSF: boolean, showImportDiploma: boolean, showCreateDiploma: boolean, lastActivityAt: any, issuedCount: number, logoBase64?: string | null, faviconBase64?: string | null, publicViewDegreeDomainPath?: string | null, publicViewFinalAcademicTranscriptDomainPath?: string | null, publicViewSchoolCurriculumDomainPath?: string | null, publicViewInstitutionName?: string | null, publicViewPrimaryColor?: string | null, publicViewSecondaryColor?: string | null, externalSignatureWebhookURL?: string | null, validateCertificateURL?: string | null, isActive: boolean, deactivationReason?: string | null, issuerData?: any | null, issuerName?: string | null, spaceUsage: number, storage: number, TeamEducationLevel: Array<{ __typename?: 'TeamEducationLevel', id: number, educationLevelType: EducationLevelType }>, Maintainer?: { __typename?: 'Maintainer', id: number, MainTeam: { __typename?: 'Team', id: number, issuerName?: string | null, placeholderName: string }, Teams: Array<{ __typename?: 'Team', id: number }> } | null, TeamContracts: Array<{ __typename?: 'TeamContract', id: number, contractUrl: string, startOfContract: any, endOfContract: any, isActive?: boolean | null }>, maintainerSpace?: { __typename?: 'MaintainerSpace', id: number, usage: number, storage: number } | null } | null }> };

export type FindManyPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type FindManyPermissionQuery = { findManyPermission: Array<{ __typename?: 'Permission', id: number, code: string, title: string, description: string }> };

export type FindManyPersonQueryVariables = Exact<{
  cursor?: InputMaybe<PersonWhereUniqueInput>;
  distinct?: InputMaybe<Array<PersonScalarFieldEnum> | PersonScalarFieldEnum>;
  orderBy?: InputMaybe<Array<PersonOrderByWithRelationInput> | PersonOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PersonWhereInput>;
}>;


export type FindManyPersonQuery = { count: number, findManyPerson: Array<{ __typename?: 'Person', id: string, cpf?: string | null, passport?: string | null, name: string, birthDate?: string | null, email?: string | null, createdAt: any }> };

export type FindManyReusableFormDataQueryVariables = Exact<{
  where?: InputMaybe<ReusableFormDataWhereInputCustom>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReusableFormDataOrderByWithRelationInput> | ReusableFormDataOrderByWithRelationInput>;
}>;


export type FindManyReusableFormDataQuery = { count: number, findManyReusableFormData: Array<{ __typename?: 'ReusableFormData', id: number, data: any, createdAt: any }> };

export type ReusableFormDataCurriculumFieldsFragment = { __typename?: 'ReusableFormDataCurriculum', id: number, name: string, createdAt: any, Course: { __typename?: 'ReusableFormData', id: number, data: any } };

export type FindManyReusableFormDataCurriculumQueryVariables = Exact<{
  where?: InputMaybe<ReusableFormDataCurriculumWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReusableFormDataCurriculumOrderByWithRelationInput> | ReusableFormDataCurriculumOrderByWithRelationInput>;
}>;


export type FindManyReusableFormDataCurriculumQuery = { count: number, items: Array<{ __typename?: 'ReusableFormDataCurriculum', id: number, name: string, createdAt: any, Course: { __typename?: 'ReusableFormData', id: number, data: any } }> };

export type FindManySignableDocumentBaseSignatureInviteQueryVariables = Exact<{
  where?: InputMaybe<DocumentBaseSignatureInviteWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DocumentBaseSignatureInviteOrderByWithRelationInput> | DocumentBaseSignatureInviteOrderByWithRelationInput>;
  personId: Scalars['String']['input'];
}>;


export type FindManySignableDocumentBaseSignatureInviteQuery = { findManySignableDocumentBaseSignatureInvite: { __typename?: 'SignableInviteItemsAndCount', count: number, items: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, createdAt: any, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }>, TeamMember?: { __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number, cpf?: string | null } } | null, Group: { __typename?: 'DocumentBaseSignatureInviteGroup', id: number, order: number, DocumentBase: { __typename?: 'DocumentBase', id: string, internalSeqId: string, version: string, type: DocumentBaseType, createdAt: any, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, DocumentAcademicDocumentation?: { __typename?: 'DocumentAcademicDocumentation', id: string, searchStudentName: string, searchCourse: string, searchCPF: string, searchEmecCode: string } | null, DocumentDegree?: { __typename?: 'DocumentDegree', id: string, searchStudentName: string, searchCourse: string, searchCPF: string, searchEmecCode: string } | null, DocumentFinalAcademicTranscript?: { __typename?: 'DocumentFinalAcademicTranscript', id: string, searchStudentName: string, searchCourse: string, searchCPF: string, searchEmecCode: string } | null, DocumentAuditFileIssuer?: { __typename?: 'DocumentAuditFileIssuer', id: string, searchAuditStartDate: string, searchAuditEndDate: string } | null } } }> } };

export type SystemGlobalAlertManyFieldsFragment = { __typename?: 'SystemGlobalAlert', actionTitle?: string | null, actionUrl?: string | null, active: boolean, createdAt: any, forcedDescription: string, forcedTitle: string, id: number, message?: string | null, type: SystemGlobalAlertType, updatedAt?: any | null, value: string, dismissonsCount: number, targetEducationLevels: Array<EducationLevelType> };

export type FindManySystemGlobalAlertQueryVariables = Exact<{
  where?: InputMaybe<SystemGlobalAlertWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SystemGlobalAlertOrderByWithRelationInput> | SystemGlobalAlertOrderByWithRelationInput>;
}>;


export type FindManySystemGlobalAlertQuery = { count: number, findManySystemGlobalAlert: Array<{ __typename?: 'SystemGlobalAlert', actionTitle?: string | null, actionUrl?: string | null, active: boolean, createdAt: any, forcedDescription: string, forcedTitle: string, id: number, message?: string | null, type: SystemGlobalAlertType, updatedAt?: any | null, value: string, dismissonsCount: number, targetEducationLevels: Array<EducationLevelType> }> };

export type TeamManyFieldsFragment = { __typename?: 'Team', id: number, issuedCount: number, placeholderName: string, validateCertificateURL?: string | null, cnpj?: string | null, lastActivityAt: any, isActive: boolean, deactivationReason?: string | null, spaceUsage: number, storage: number, Owner: { __typename?: 'CommonUser', id: number, name?: string | null, email: string }, maintainerSpace?: { __typename?: 'MaintainerSpace', id: number, usage: number, storage: number } | null };

export type FindManyTeamQueryVariables = Exact<{
  where?: InputMaybe<TeamWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TeamOrderByWithRelationInput> | TeamOrderByWithRelationInput>;
}>;


export type FindManyTeamQuery = { count: number, totalIssuedDocuments: number, items: Array<{ __typename?: 'Team', id: number, issuedCount: number, placeholderName: string, validateCertificateURL?: string | null, cnpj?: string | null, lastActivityAt: any, isActive: boolean, deactivationReason?: string | null, spaceUsage: number, storage: number, Owner: { __typename?: 'CommonUser', id: number, name?: string | null, email: string }, maintainerSpace?: { __typename?: 'MaintainerSpace', id: number, usage: number, storage: number } | null }> };

export type TeamContractManyFieldsFragment = { __typename?: 'TeamContract', id: number, contractUrl: string, isActive?: boolean | null, startOfContract: any, endOfContract: any, createdAt: any, updatedAt?: any | null, teamId: number, observations: string, storageInGb: number };

export type FindManyTeamContractQueryVariables = Exact<{
  where?: InputMaybe<TeamContractWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TeamContractOrderByWithRelationInput> | TeamContractOrderByWithRelationInput>;
}>;


export type FindManyTeamContractQuery = { count: number, findManyTeamContract: Array<{ __typename?: 'TeamContract', id: number, contractUrl: string, isActive?: boolean | null, startOfContract: any, endOfContract: any, createdAt: any, updatedAt?: any | null, teamId: number, observations: string, storageInGb: number }> };

export type TeamDocumentTypeSpecificSignaturePolicyConfigManyFieldsFragment = { __typename?: 'TeamDocumentTypeSpecificSignaturePolicyConfig', id: number, teamId: number, documentType: DocumentBaseType, groupPolicies: Array<TeamSpecificSignaturePolicyType> };

export type FindManyTeamDocumentTypeSpecificSignaturePolicyConfigQueryVariables = Exact<{
  where?: InputMaybe<TeamDocumentTypeSpecificSignaturePolicyConfigWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TeamDocumentTypeSpecificSignaturePolicyConfigOrderByWithRelationInput> | TeamDocumentTypeSpecificSignaturePolicyConfigOrderByWithRelationInput>;
}>;


export type FindManyTeamDocumentTypeSpecificSignaturePolicyConfigQuery = { count: number, findManyTeamDocumentTypeSpecificSignaturePolicyConfig: Array<{ __typename?: 'TeamDocumentTypeSpecificSignaturePolicyConfig', id: number, teamId: number, documentType: DocumentBaseType, groupPolicies: Array<TeamSpecificSignaturePolicyType> }> };

export type FindManyTeamMaintainedQueryVariables = Exact<{
  where?: InputMaybe<TeamWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TeamOrderByWithRelationInput> | TeamOrderByWithRelationInput>;
}>;


export type FindManyTeamMaintainedQuery = { countTeamMaintained: number, findManyTeamMaintained: Array<{ __typename?: 'Team', id: number, issuerName?: string | null, placeholderName: string, cnpj?: string | null, createdAt: any, MainTeamOfMaintainer?: { __typename?: 'Maintainer', id: number, mainTeamId: number } | null, Owner: { __typename?: 'CommonUser', id: number, name?: string | null } }> };

export type FindManyTeamMemberQueryVariables = Exact<{
  where?: InputMaybe<TeamMemberWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TeamMemberOrderByWithRelationInput> | TeamMemberOrderByWithRelationInput>;
}>;


export type FindManyTeamMemberQuery = { count: number, findManyTeamMember: Array<{ __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> }> };

export type SystemAuditLogFieldsFragment = { __typename?: 'SystemAuditLog', id: string, table: string, operation: string, teamId?: number | null, operationTranslated: string, moduleTranslated: string, createdAt: any, after?: any | null, args?: any | null, extraContext?: any | null, primaryKey?: string | null, User?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null, translatedAfter: Array<{ __typename?: 'KeyValue', id: string, key: string, value?: string | null }> };

export type FindManySystemAuditLogQueryVariables = Exact<{
  where?: InputMaybe<SystemAuditLogWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SystemAuditLogOrderByWithRelationInput> | SystemAuditLogOrderByWithRelationInput>;
}>;


export type FindManySystemAuditLogQuery = { countSystemAuditLog: number, findManySystemAuditLog: Array<{ __typename?: 'SystemAuditLog', id: string, table: string, operation: string, teamId?: number | null, operationTranslated: string, moduleTranslated: string, createdAt: any, after?: any | null, args?: any | null, extraContext?: any | null, primaryKey?: string | null, User?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null, translatedAfter: Array<{ __typename?: 'KeyValue', id: string, key: string, value?: string | null }> }> };

export type FindOneExternalCepAddressQueryVariables = Exact<{
  cep: Scalars['String']['input'];
}>;


export type FindOneExternalCepAddressQuery = { findOneExternalCepAddress: { __typename?: 'ExternalCepAddress', id: string, street?: string | null, state?: string | null, service?: string | null, neighborhood?: string | null, city?: string | null, cep: string } };

export type FindPublicViewDegreeDomainPathQueryVariables = Exact<{
  searchValidationCode: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
}>;


export type FindPublicViewDegreeDomainPathQuery = { findPublicViewDegreeDomainPath?: { __typename?: 'FindPublicViewDegreeDomainPathObject', id: string, foundTeam: boolean, publicViewDegreeDomainPath?: string | null } | null };

export type FindUniqueBulkCertificateRecordQueryVariables = Exact<{
  where: BulkCertificateRecordWhereUniqueInput;
  countInSignaturesDocumentCertificatesWhere?: InputMaybe<DocumentCertificateWhereInput>;
}>;


export type FindUniqueBulkCertificateRecordQuery = { findUniqueBulkCertificateRecord?: { __typename?: 'BulkCertificateRecord', id: string, createdAt: any, bulkCertificateRecordName: string, totalCertificates: number, status: DocumentCertificateStatus, countDocumentCertificates: number, countDocumentCertificatesStatusInSignature: number } | null };

export type TeamAndPublicDocumentBaseTypeFieldsFragment = { __typename?: 'TeamAndPublicDocumentBaseType', id: number, documentSeeType: string, url: string, team: { __typename?: 'Team', id: number, publicViewDegreeDomainPath?: string | null, publicViewFinalAcademicTranscriptDomainPath?: string | null, publicViewSchoolCurriculumDomainPath?: string | null, publicViewInstitutionName?: string | null, publicViewPrimaryColor?: string | null, publicViewSecondaryColor?: string | null, externalSignatureWebhookURL?: string | null, logoBase64?: string | null, faviconBase64?: string | null } };

export type FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery = { findUniqueTeamAndPublicDocumentBaseTypeByPublicUrl?: { __typename?: 'TeamAndPublicDocumentBaseType', id: number, documentSeeType: string, url: string, team: { __typename?: 'Team', id: number, publicViewDegreeDomainPath?: string | null, publicViewFinalAcademicTranscriptDomainPath?: string | null, publicViewSchoolCurriculumDomainPath?: string | null, publicViewInstitutionName?: string | null, publicViewPrimaryColor?: string | null, publicViewSecondaryColor?: string | null, externalSignatureWebhookURL?: string | null, logoBase64?: string | null, faviconBase64?: string | null } } | null };

export type FindUniqueCertificateCourseQueryVariables = Exact<{
  where: CertificateCourseWhereUniqueInput;
}>;


export type FindUniqueCertificateCourseQuery = { findUniqueCertificateCourse?: { __typename?: 'CertificateCourse', id: string, certificateBaseId: string, name: string, areaKnowledge: string, metaData: Array<string>, CertificateBase: { __typename?: 'CertificateBase', id: string, createdAt: any }, CourseLevel?: { __typename?: 'CertificateCourseLevel', id: string, certificateBaseId: string, name: string } | null } | null };

export type FindUniqueCertificateCourseLevelQueryVariables = Exact<{
  where: CertificateCourseLevelWhereUniqueInput;
}>;


export type FindUniqueCertificateCourseLevelQuery = { findUniqueCertificateCourseLevel?: { __typename?: 'CertificateCourseLevel', id: string, name: string, certificateBaseId: string, CertificateBase: { __typename?: 'CertificateBase', id: string, createdAt: any } } | null };

export type SelectedDisciplineFieldsFragment = { __typename?: 'CertificateCurriculumSelectedDiscipline', id: number, amountOfHours?: number | null, SelectedDiscipline: { __typename?: 'CertificateDiscipline', id: string, certificateBaseId: string, name: string }, SelectedTeacher?: { __typename?: 'CertificateTeacher', id: string, certificateBaseId: string, name: string } | null };

export type FindUniqueCertificateCurriculumQueryVariables = Exact<{
  where: CertificateCurriculumWhereUniqueInput;
}>;


export type FindUniqueCertificateCurriculumQuery = { findUniqueCertificateCurriculum?: { __typename?: 'CertificateCurriculum', id: string, name: string, amountOfHours?: number | null, CertificateCourse: { __typename?: 'CertificateCourse', id: string, certificateBaseId: string, name: string }, CertificateCurriculumSelectedDisciplines: Array<{ __typename?: 'CertificateCurriculumSelectedDiscipline', id: number, amountOfHours?: number | null, SelectedDiscipline: { __typename?: 'CertificateDiscipline', id: string, certificateBaseId: string, name: string }, SelectedTeacher?: { __typename?: 'CertificateTeacher', id: string, certificateBaseId: string, name: string } | null }> } | null };

export type FindUniqueCertificateDisciplineQueryVariables = Exact<{
  where: CertificateDisciplineWhereUniqueInput;
}>;


export type FindUniqueCertificateDisciplineQuery = { findUniqueCertificateDiscipline?: { __typename?: 'CertificateDiscipline', id: string, certificateBaseId: string, name: string, viewOnDegree: boolean } | null };

export type FindUniqueCertificateEventQueryVariables = Exact<{
  where: CertificateEventWhereUniqueInput;
}>;


export type FindUniqueCertificateEventQuery = { findUniqueCertificateEvent?: { __typename?: 'CertificateEvent', id: string, certificateBaseId: string, name: string, CertificateBase: { __typename?: 'CertificateBase', id: string, createdAt: any } } | null };

export type FindUniqueCertificateTeacherQueryVariables = Exact<{
  where: CertificateTeacherWhereUniqueInput;
}>;


export type FindUniqueCertificateTeacherQuery = { findUniqueCertificateTeacher?: { __typename?: 'CertificateTeacher', id: string, certificateBaseId: string, name: string, titration: string, CertificateBase: { __typename?: 'CertificateBase', id: string, createdAt: any } } | null };

export type CertificateTemplateFieldsFragment = { __typename?: 'CertificateTemplate', id: string, name: string, description?: string | null, createdAt: any, data: any };

export type FindUniqueCertificateTemplateQueryVariables = Exact<{
  where: CertificateTemplateWhereUniqueInput;
}>;


export type FindUniqueCertificateTemplateQuery = { findUniqueCertificateTemplate?: { __typename?: 'CertificateTemplate', id: string, name: string, description?: string | null, createdAt: any, data: any } | null };

export type FindUniqueCertificateTemplatePresetQueryVariables = Exact<{
  where: CertificateTemplatePresetWhereUniqueInput;
}>;


export type FindUniqueCertificateTemplatePresetQuery = { findUniqueCertificateTemplatePreset?: { __typename?: 'CertificateTemplatePreset', id: string, data: any } | null };

export type FindUniqueDocumentDegreeQueryVariables = Exact<{
  where: DocumentDegreeWhereUniqueInput;
}>;


export type FindUniqueDocumentDegreeQuery = { findUniqueDocumentDegree?: { __typename?: 'DocumentDegree', id: string, documentBaseId: string, visualRepresentationPath?: string | null, visualRepresentationFileSize: number, searchStudentName: string, searchCPF: string, searchCourse: string, searchValidationCode?: string | null, status: DocumentDegreeStatus, ParentAcademicDocumentation?: { __typename?: 'DocumentAcademicDocumentation', id: string, DocumentBase: { __typename?: 'DocumentBase', id: string, internalSeqId: string } } | null, DocumentBase: { __typename?: 'DocumentBase', filePath?: string | null, type: DocumentBaseType, id: string, internalSeqId: string, version: string, createdAt: any, updatedAt?: any | null, creationType: DocumentAcademicDocumentationCreationType, data: any, fileSize: number, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> } } | null };

export type DegreeViewDegreeFragment = { __typename?: 'DocumentDegree', id: string, documentBaseId: string, searchCourse: string, searchCPF: string, searchEmecCode: string, searchStudentName: string, searchValidationCode?: string | null, status: DocumentDegreeStatus, visualRepresentationPath?: string | null, DocumentBase: { __typename?: 'DocumentBase', id: string, createdAt: any, Team: { __typename?: 'Team', id: number, publicViewDegreeDomainPath?: string | null, publicViewFinalAcademicTranscriptDomainPath?: string | null, publicViewSchoolCurriculumDomainPath?: string | null, externalSignatureWebhookURL?: string | null, publicViewInstitutionName?: string | null, publicViewPrimaryColor?: string | null, publicViewSecondaryColor?: string | null } } };

export type FindUniqueDegreeToSeeBySecurityCodeQueryVariables = Exact<{
  domain: Scalars['String']['input'];
  recaptchaResponse: Scalars['String']['input'];
  securityCode: Scalars['String']['input'];
}>;


export type FindUniqueDegreeToSeeBySecurityCodeQuery = { findUniqueDegreeToSeeBySecurityCode?: { __typename?: 'DocumentDegree', id: string, documentBaseId: string, searchCourse: string, searchCPF: string, searchEmecCode: string, searchStudentName: string, searchValidationCode?: string | null, status: DocumentDegreeStatus, visualRepresentationPath?: string | null, DocumentBase: { __typename?: 'DocumentBase', id: string, createdAt: any, Team: { __typename?: 'Team', id: number, publicViewDegreeDomainPath?: string | null, publicViewFinalAcademicTranscriptDomainPath?: string | null, publicViewSchoolCurriculumDomainPath?: string | null, externalSignatureWebhookURL?: string | null, publicViewInstitutionName?: string | null, publicViewPrimaryColor?: string | null, publicViewSecondaryColor?: string | null } } } | null };

export type FindUniqueDocumentAcademicDocumentationQueryVariables = Exact<{
  where: DocumentAcademicDocumentationWhereUniqueInput;
}>;


export type FindUniqueDocumentAcademicDocumentationQuery = { findUnique?: { __typename?: 'DocumentAcademicDocumentation', id: string, documentBaseId: string, type: DocumentAcademicDocumentationType, status: DocumentAcademicDocumentationStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any, updatedAt?: any | null, creationType: DocumentAcademicDocumentationCreationType, data: any, filePath?: string | null, fileSize: number, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> }, ChildDocuments: Array<{ __typename?: 'DocumentFinalAcademicTranscript', id: string, documentBaseId: string, status: DocumentFinalAcademicTranscriptStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any } }>, LinkedDegreeList: Array<{ __typename?: 'DocumentDegree', id: string, documentBaseId: string, status: DocumentDegreeStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, deletedAt?: any | null } }> } | null };

export type DocumentAuditFileIssuerFieldsFragment = { __typename?: 'DocumentAuditFileIssuer', id: string, documentBaseId: string, searchAuditStartDate: string, searchAuditEndDate: string, status: DocumentAuditFileIssuerStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any, updatedAt?: any | null, creationType: DocumentAcademicDocumentationCreationType, data: any, filePath?: string | null, fileSize: number, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> } };

export type FindUniqueDocumentAuditFileIssuerQueryVariables = Exact<{
  where: DocumentAuditFileIssuerWhereUniqueInput;
}>;


export type FindUniqueDocumentAuditFileIssuerQuery = { findUnique?: { __typename?: 'DocumentAuditFileIssuer', id: string, documentBaseId: string, searchAuditStartDate: string, searchAuditEndDate: string, status: DocumentAuditFileIssuerStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any, updatedAt?: any | null, creationType: DocumentAcademicDocumentationCreationType, data: any, filePath?: string | null, fileSize: number, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> } } | null };

export type FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQueryVariables = Exact<{
  where: DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput;
}>;


export type FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQuery = { findUniqueDocumentBaseDefaultSignatureInviteConfiguration?: { __typename?: 'DocumentBaseDefaultSignatureInviteConfiguration', id: number, type: DocumentBaseType, createdAt: any, updatedAt?: any | null, addSignersNode: boolean, signatureConfig: Array<SignatureType>, Groups: Array<{ __typename?: 'DocumentBaseDefaultSignatureInviteConfigurationGroup', id: number, Items: Array<{ __typename?: 'DocumentBaseDefaultSignatureInviteConfigurationGroupItem', id: number, teamMemberId?: number | null, TeamMember?: { __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string } } | null }> }> } | null };

export type FindUniqueDocumentBaseSignatureInviteQueryVariables = Exact<{
  where: DocumentBaseSignatureInviteWhereUniqueInput;
}>;


export type FindUniqueDocumentBaseSignatureInviteQuery = { findUniqueDocumentBaseSignatureInvite?: { __typename?: 'DocumentBaseSignatureInvite', id: number, createdAt: any, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }>, TeamMember?: { __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number, cpf?: string | null } } | null, Group: { __typename?: 'DocumentBaseSignatureInviteGroup', id: number, order: number, DocumentBase: { __typename?: 'DocumentBase', id: string, internalSeqId: string, version: string, type: DocumentBaseType, createdAt: any, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, DocumentAcademicDocumentation?: { __typename?: 'DocumentAcademicDocumentation', id: string, searchStudentName: string, searchCourse: string, searchCPF: string, searchEmecCode: string } | null, DocumentDegree?: { __typename?: 'DocumentDegree', id: string, searchStudentName: string, searchCourse: string, searchCPF: string, searchEmecCode: string } | null, DocumentFinalAcademicTranscript?: { __typename?: 'DocumentFinalAcademicTranscript', id: string, searchStudentName: string, searchCourse: string, searchCPF: string, searchEmecCode: string } | null, DocumentAuditFileIssuer?: { __typename?: 'DocumentAuditFileIssuer', id: string, searchAuditStartDate: string, searchAuditEndDate: string } | null } } } | null };

export type DocumentCertificateSignatureItemBaseFieldsFragment = { __typename?: 'DocumentCertificateSignatureItem', id: string, predefinedImageBase64?: string | null, type: DocumentCertificateSignatureItemType, createdAt: any, PossibleSigners: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInvite', id: number, TeamMember: { __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string } }, DocumentCertificateSignatureItemPossibleSignerInviteSignature: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInviteSignature', id: number, success: boolean, createdAt: any }> }> };

export type DocumentCertificateFieldsFragment = { __typename?: 'DocumentCertificate', id: string, documentBaseId: string, uuid: string, documentCertificateCPF: string, documentCertificateName: string, certificateTemplateId?: string | null, status: DocumentCertificateStatus, hasOnlyPredefinedVisualSignature: boolean, Person: { __typename?: 'Person', id: string, name: string, cpf?: string | null, email?: string | null }, Curriculum?: { __typename?: 'CertificateCurriculum', id: string, name: string, CertificateCourse: { __typename?: 'CertificateCourse', id: string, name: string } } | null, BulkCertificateRecord?: { __typename?: 'BulkCertificateRecord', id: string, status: DocumentCertificateStatus, bulkCertificateRecordName: string } | null, DocumentCertificateSignatureItems: Array<{ __typename?: 'DocumentCertificateSignatureItem', id: string, predefinedImageBase64?: string | null, type: DocumentCertificateSignatureItemType, createdAt: any, PossibleSigners: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInvite', id: number, TeamMember: { __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string } }, DocumentCertificateSignatureItemPossibleSignerInviteSignature: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInviteSignature', id: number, success: boolean, createdAt: any }> }> }>, DocumentCertificateHashHistory: Array<{ __typename?: 'DocumentCertificateHashHistory', id: string, hash: string }>, TeamEducationLevel: { __typename?: 'TeamEducationLevel', id: number, educationLevelType: EducationLevelType }, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any, updatedAt?: any | null, creationType: DocumentAcademicDocumentationCreationType, data: any, filePath?: string | null, fileSize: number, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> } };

export type FindUniqueDocumentCertificateQueryVariables = Exact<{
  where: DocumentCertificateWhereUniqueInput;
}>;


export type FindUniqueDocumentCertificateQuery = { findUniqueDocumentCertificate?: { __typename?: 'DocumentCertificate', id: string, documentBaseId: string, uuid: string, documentCertificateCPF: string, documentCertificateName: string, certificateTemplateId?: string | null, status: DocumentCertificateStatus, hasOnlyPredefinedVisualSignature: boolean, Person: { __typename?: 'Person', id: string, name: string, cpf?: string | null, email?: string | null }, Curriculum?: { __typename?: 'CertificateCurriculum', id: string, name: string, CertificateCourse: { __typename?: 'CertificateCourse', id: string, name: string } } | null, BulkCertificateRecord?: { __typename?: 'BulkCertificateRecord', id: string, status: DocumentCertificateStatus, bulkCertificateRecordName: string } | null, DocumentCertificateSignatureItems: Array<{ __typename?: 'DocumentCertificateSignatureItem', id: string, predefinedImageBase64?: string | null, type: DocumentCertificateSignatureItemType, createdAt: any, PossibleSigners: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInvite', id: number, TeamMember: { __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string } }, DocumentCertificateSignatureItemPossibleSignerInviteSignature: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInviteSignature', id: number, success: boolean, createdAt: any }> }> }>, DocumentCertificateHashHistory: Array<{ __typename?: 'DocumentCertificateHashHistory', id: string, hash: string }>, TeamEducationLevel: { __typename?: 'TeamEducationLevel', id: number, educationLevelType: EducationLevelType }, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any, updatedAt?: any | null, creationType: DocumentAcademicDocumentationCreationType, data: any, filePath?: string | null, fileSize: number, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> } } | null };

export type DocumentCertificateSignatureItemFieldsFragment = { __typename?: 'DocumentCertificateSignatureItem', id: string, predefinedImageBase64?: string | null, type: DocumentCertificateSignatureItemType, DocumentCertificate: { __typename?: 'DocumentCertificate', id: string, documentBaseId: string, uuid: string, documentCertificateCPF: string, documentCertificateName: string, certificateTemplateId?: string | null, status: DocumentCertificateStatus, hasOnlyPredefinedVisualSignature: boolean, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any, updatedAt?: any | null, creationType: DocumentAcademicDocumentationCreationType, data: any, filePath?: string | null, fileSize: number, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> }, DocumentCertificateSignatureItems: Array<{ __typename?: 'DocumentCertificateSignatureItem', id: string, type: DocumentCertificateSignatureItemType, predefinedImageBase64?: string | null, createdAt: any, PossibleSigners: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInvite', id: number, TeamMember: { __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number, cpf?: string | null, name?: string | null, email: string } }, DocumentCertificateSignatureItemPossibleSignerInviteSignature: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInviteSignature', id: number, success: boolean, createdAt: any }> }> }>, Person: { __typename?: 'Person', id: string, name: string, cpf?: string | null, email?: string | null }, Curriculum?: { __typename?: 'CertificateCurriculum', id: string, name: string, CertificateCourse: { __typename?: 'CertificateCourse', id: string, name: string } } | null, BulkCertificateRecord?: { __typename?: 'BulkCertificateRecord', id: string, status: DocumentCertificateStatus, bulkCertificateRecordName: string } | null, DocumentCertificateHashHistory: Array<{ __typename?: 'DocumentCertificateHashHistory', id: string, hash: string }>, TeamEducationLevel: { __typename?: 'TeamEducationLevel', id: number, educationLevelType: EducationLevelType } }, PossibleSigners: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInvite', id: number, TeamMember: { __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }, DocumentCertificateSignatureItemPossibleSignerInviteSignature: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInviteSignature', id: number, success: boolean, createdAt: any }> }> };

export type FindUniqueDocumentCertificateSignatureItemQueryVariables = Exact<{
  where: DocumentCertificateSignatureItemWhereUniqueInput;
}>;


export type FindUniqueDocumentCertificateSignatureItemQuery = { findUniqueDocumentCertificateSignatureItem?: { __typename?: 'DocumentCertificateSignatureItem', id: string, predefinedImageBase64?: string | null, type: DocumentCertificateSignatureItemType, DocumentCertificate: { __typename?: 'DocumentCertificate', id: string, documentBaseId: string, uuid: string, documentCertificateCPF: string, documentCertificateName: string, certificateTemplateId?: string | null, status: DocumentCertificateStatus, hasOnlyPredefinedVisualSignature: boolean, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any, updatedAt?: any | null, creationType: DocumentAcademicDocumentationCreationType, data: any, filePath?: string | null, fileSize: number, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> }, DocumentCertificateSignatureItems: Array<{ __typename?: 'DocumentCertificateSignatureItem', id: string, type: DocumentCertificateSignatureItemType, predefinedImageBase64?: string | null, createdAt: any, PossibleSigners: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInvite', id: number, TeamMember: { __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number, cpf?: string | null, name?: string | null, email: string } }, DocumentCertificateSignatureItemPossibleSignerInviteSignature: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInviteSignature', id: number, success: boolean, createdAt: any }> }> }>, Person: { __typename?: 'Person', id: string, name: string, cpf?: string | null, email?: string | null }, Curriculum?: { __typename?: 'CertificateCurriculum', id: string, name: string, CertificateCourse: { __typename?: 'CertificateCourse', id: string, name: string } } | null, BulkCertificateRecord?: { __typename?: 'BulkCertificateRecord', id: string, status: DocumentCertificateStatus, bulkCertificateRecordName: string } | null, DocumentCertificateHashHistory: Array<{ __typename?: 'DocumentCertificateHashHistory', id: string, hash: string }>, TeamEducationLevel: { __typename?: 'TeamEducationLevel', id: number, educationLevelType: EducationLevelType } }, PossibleSigners: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInvite', id: number, TeamMember: { __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }, DocumentCertificateSignatureItemPossibleSignerInviteSignature: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInviteSignature', id: number, success: boolean, createdAt: any }> }> } | null };

export type DocumentFinalAcademicTranscriptFieldsFragment = { __typename?: 'DocumentFinalAcademicTranscript', id: string, documentBaseId: string, status: DocumentFinalAcademicTranscriptStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any, updatedAt?: any | null, creationType: DocumentAcademicDocumentationCreationType, data: any, filePath?: string | null, fileSize: number, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> } };

export type FindUniqueDocumentFinalAcademicTranscriptQueryVariables = Exact<{
  where: DocumentFinalAcademicTranscriptWhereUniqueInput;
}>;


export type FindUniqueDocumentFinalAcademicTranscriptQuery = { findUnique?: { __typename?: 'DocumentFinalAcademicTranscript', id: string, documentBaseId: string, status: DocumentFinalAcademicTranscriptStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any, updatedAt?: any | null, creationType: DocumentAcademicDocumentationCreationType, data: any, filePath?: string | null, fileSize: number, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> } } | null };

export type FindUniqueDocumentSchoolCurriculumQueryVariables = Exact<{
  where: DocumentSchoolCurriculumWhereUniqueInput;
}>;


export type FindUniqueDocumentSchoolCurriculumQuery = { findUniqueDocumentSchoolCurriculum?: { __typename?: 'DocumentSchoolCurriculum', id: string, searchSchoolCurriculumName: string, searchSchoolCurriculumCode: string, documentBaseId: string, status: DocumentSchoolCurriculumStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any, updatedAt?: any | null, creationType: DocumentAcademicDocumentationCreationType, data: any, filePath?: string | null, fileSize: number, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> } } | null };

export type ExternalSignatureInviteFieldsFragment = { __typename?: 'ExternalSignatureInvite', id: string, isSigned: boolean, callbackUrl?: string | null, createdAt: any, documentBaseInternalSeqId: string, groupIndex: number, documentStudentName?: string | null, enabledPersonIdList: Array<string>, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, ExternalSignatureInvite: Array<{ __typename?: 'ExternalSignatureInvite', id: string, groupIndex: number, isSigned: boolean }> } };

export type FindUniqueExternalSignatureInviteQueryVariables = Exact<{
  where: ExternalSignatureInviteWhereUniqueInput;
}>;


export type FindUniqueExternalSignatureInviteQuery = { findUniqueExternalSignatureInvite?: { __typename?: 'ExternalSignatureInvite', id: string, isSigned: boolean, callbackUrl?: string | null, createdAt: any, documentBaseInternalSeqId: string, groupIndex: number, documentStudentName?: string | null, enabledPersonIdList: Array<string>, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, ExternalSignatureInvite: Array<{ __typename?: 'ExternalSignatureInvite', id: string, groupIndex: number, isSigned: boolean }> } } | null };

export type FindUniquePersonQueryVariables = Exact<{
  where: PersonWhereUniqueInput;
}>;


export type FindUniquePersonQuery = { findUniquePerson?: { __typename?: 'Person', id: string, name: string, receivesCertificateEmail: boolean, receivesCertificateWhatsapp: boolean, cpf?: string | null, birthDate?: string | null, identityDocument?: string | null, email?: string | null, isForeign: boolean, passport?: string | null, Phones: Array<{ __typename?: 'Telephone', id: number, number: string }>, Address?: { __typename?: 'Address', id: number, city?: string | null, complement?: string | null, neighborhood?: string | null, postalCode?: string | null, state?: string | null, street?: string | null } | null } | null };

export type ReusableFormDataCurriculumUniqueFieldsFragment = { __typename?: 'ReusableFormDataCurriculum', id: number, name: string, Course: { __typename?: 'ReusableFormData', id: number, data: any }, DisciplineLinks: Array<{ __typename?: 'ReusableFormDataCurriculumDisciplineLink', id: number, Discipline: { __typename?: 'ReusableFormData', id: number, data: any } }> };

export type FindUniqueReusableFormDataCurriculumQueryVariables = Exact<{
  where: ReusableFormDataCurriculumWhereUniqueInput;
}>;


export type FindUniqueReusableFormDataCurriculumQuery = { findUniqueReusableFormDataCurriculum?: { __typename?: 'ReusableFormDataCurriculum', id: number, name: string, Course: { __typename?: 'ReusableFormData', id: number, data: any }, DisciplineLinks: Array<{ __typename?: 'ReusableFormDataCurriculumDisciplineLink', id: number, Discipline: { __typename?: 'ReusableFormData', id: number, data: any } }> } | null };

export type SignSignatureImageUniqueFieldsFragment = { __typename?: 'SignSignatureImage', id: string, base64Image: string, description: string, percentageBelowTheLine: number, createdAt: any };

export type FindUniqueSignSignatureImageQueryVariables = Exact<{
  where: SignSignatureImageWhereUniqueInput;
}>;


export type FindUniqueSignSignatureImageQuery = { findUniqueSignSignatureImage?: { __typename?: 'SignSignatureImage', id: string, base64Image: string, description: string, percentageBelowTheLine: number, createdAt: any } | null };

export type UniqueTeamFieldsFragment = { __typename?: 'Team', id: number, publicViewInstitutionName?: string | null, memberCount: number, TeamMember: Array<{ __typename?: 'TeamMember', id: number, role?: string | null, User: { __typename?: 'CommonUser', id: number, lastActivityAt: any, name?: string | null, email: string, cpf?: string | null, createdAt: any } }>, TeamEducationLevel: Array<{ __typename?: 'TeamEducationLevel', id: number, educationLevelType: EducationLevelType, teamId: number }> };

export type FindUniqueTeamQueryVariables = Exact<{
  where: TeamWhereUniqueInput;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TeamMemberOrderByWithRelationInput> | TeamMemberOrderByWithRelationInput>;
  teamMemberWhere?: InputMaybe<TeamMemberWhereInput>;
}>;


export type FindUniqueTeamQuery = { findUniqueTeam?: { __typename?: 'Team', id: number, publicViewInstitutionName?: string | null, memberCount: number, TeamMember: Array<{ __typename?: 'TeamMember', id: number, role?: string | null, User: { __typename?: 'CommonUser', id: number, lastActivityAt: any, name?: string | null, email: string, cpf?: string | null, createdAt: any } }>, TeamEducationLevel: Array<{ __typename?: 'TeamEducationLevel', id: number, educationLevelType: EducationLevelType, teamId: number }> } | null };

export type FindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigQueryVariables = Exact<{
  where: TeamDocumentTypeSpecificSignaturePolicyConfigWhereUniqueInput;
}>;


export type FindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigQuery = { findUniqueTeamDocumentTypeSpecificSignaturePolicyConfig?: { __typename?: 'TeamDocumentTypeSpecificSignaturePolicyConfig', id: number, teamId: number, documentType: DocumentBaseType, groupPolicies: Array<TeamSpecificSignaturePolicyType> } | null };

export type FindUniqueTeamForUsagePanelQueryVariables = Exact<{
  where: TeamWhereUniqueInput;
}>;


export type FindUniqueTeamForUsagePanelQuery = { findUniqueTeam?: { __typename?: 'Team', id: number, spaceUsage: number, storage: number, issuerName?: string | null, publicViewInstitutionName?: string | null, EnabledInstitution?: { __typename?: 'EnabledInstitution', id: number, placeholderName: string } | null, maintainerSpace?: { __typename?: 'MaintainerSpace', id: number, usage: number, storage: number } | null } | null };

export type PublicViewFieldsFragment = { __typename?: 'PublicView', id: string, documentTypeName: string, isValid: boolean, isVisualRepresentationEnabled: boolean, securityCode: string, validationDatetime: string, dataKeyValues: Array<{ __typename?: 'KeyValue', id: string, key: string, value?: string | null }> };

export type FindUniqueToSeePublicDocumentQueryVariables = Exact<{
  recaptchaResponse: Scalars['String']['input'];
}>;


export type FindUniqueToSeePublicDocumentQuery = { findUniqueToSeePublicDocument?: { __typename?: 'PublicView', id: string, documentTypeName: string, isValid: boolean, isVisualRepresentationEnabled: boolean, securityCode: string, validationDatetime: string, dataKeyValues: Array<{ __typename?: 'KeyValue', id: string, key: string, value?: string | null }> } | null };

export type ForceGenerateDocumentAcademicDocumentationMutationVariables = Exact<{
  docId: Scalars['String']['input'];
}>;


export type ForceGenerateDocumentAcademicDocumentationMutation = { forceGenerateDocumentAcademicDocumentation?: { __typename?: 'DocumentAcademicDocumentation', id: string, documentBaseId: string } | null };

export type ForceGenerateDocumentSchoolCurriculumMutationVariables = Exact<{
  docId: Scalars['String']['input'];
}>;


export type ForceGenerateDocumentSchoolCurriculumMutation = { forceGenerateDocumentSchoolCurriculum?: { __typename?: 'DocumentSchoolCurriculum', id: string, documentBaseId: string } | null };

export type GenerateSampleCertificatePdfBase64QueryVariables = Exact<{
  template: Scalars['Json']['input'];
}>;


export type GenerateSampleCertificatePdfBase64Query = { generateSampleCertificatePdfBase64: string };

export type GetDocumentJsonQueryVariables = Exact<{
  where?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
}>;


export type GetDocumentJsonQuery = { findFirstDocumentAcademicDocumentation?: { __typename?: 'DocumentAcademicDocumentation', id: string, documentBaseId: string, DocumentBase: { __typename?: 'DocumentBase', id: string, dataWithIesAndFiles: any } } | null };

export type GetDocumentJsonSchoolCurriculumQueryVariables = Exact<{
  where: DocumentSchoolCurriculumWhereUniqueInput;
}>;


export type GetDocumentJsonSchoolCurriculumQuery = { findUniqueDocumentSchoolCurriculum?: { __typename?: 'DocumentSchoolCurriculum', id: string, searchSchoolCurriculumName: string, searchSchoolCurriculumCode: string, documentBaseId: string, status: DocumentSchoolCurriculumStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any, updatedAt?: any | null, creationType: DocumentAcademicDocumentationCreationType, data: any, filePath?: string | null, fileSize: number, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> } } | null };

export type GetDocumentVariableJsonQueryVariables = Exact<{
  removeFiles?: InputMaybe<Scalars['Boolean']['input']>;
  coverWithMetaAndData?: InputMaybe<Scalars['Boolean']['input']>;
  clean?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DocumentAcademicDocumentationWhereInput>;
}>;


export type GetDocumentVariableJsonQuery = { findFirstDocumentAcademicDocumentation?: { __typename?: 'DocumentAcademicDocumentation', id: string, DocumentBase: { __typename?: 'DocumentBase', id: string, internalSeqId: string, filePath?: string | null, variableJson: any } } | null };

export type GetFinancialRechargeDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFinancialRechargeDataQuery = { getFinancialRechargePlans: { __typename?: 'RechargeOptions', discounts: Array<{ __typename?: 'Discount', id: number, count: number, valueInPercent: number }>, presets: Array<{ __typename?: 'Preset', id: number, count: number }>, servicesPrices: Array<{ __typename?: 'ServicePrice', id: string, service: FinancialChargeableService, unitPrice: number }> }, findManyFinancialCreditCardSaved: Array<{ __typename?: 'FinancialCreditCardSaved', id: number, token: string, number: string, brand: string }> };

export type RechargeOptionsFieldsFragment = { __typename?: 'RechargeOptions', discounts: Array<{ __typename?: 'Discount', id: number, count: number, valueInPercent: number }>, presets: Array<{ __typename?: 'Preset', id: number, count: number }>, servicesPrices: Array<{ __typename?: 'ServicePrice', id: string, service: FinancialChargeableService, unitPrice: number }> };

export type GetFinancialRechargePlansQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFinancialRechargePlansQuery = { getFinancialRechargePlans: { __typename?: 'RechargeOptions', discounts: Array<{ __typename?: 'Discount', id: number, count: number, valueInPercent: number }>, presets: Array<{ __typename?: 'Preset', id: number, count: number }>, servicesPrices: Array<{ __typename?: 'ServicePrice', id: string, service: FinancialChargeableService, unitPrice: number }> } };

export type GetMineTeamQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<TeamOrderByWithRelationInput> | TeamOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeamWhereInput>;
}>;


export type GetMineTeamQuery = { count: number, getMineTeam?: { __typename?: 'Team', id: number, createdAt: any, updatedAt?: any | null, TeamMember: Array<{ __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> }>, Documents: Array<{ __typename?: 'DocumentBase', id: string, type: DocumentBaseType }> } | null };

export type GetPrimaryDegreeCertificateTemplateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPrimaryDegreeCertificateTemplateQuery = { getMineTeam?: { __typename?: 'Team', id: number, DefaultDegreeCertificateTemplate?: { __typename?: 'CertificateTemplate', id: string, name: string } | null } | null };

export type GetTeamConfigsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<TeamOrderByWithRelationInput> | TeamOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TeamWhereInput>;
}>;


export type GetTeamConfigsQuery = { getMineTeam?: { __typename?: 'Team', id: number, configAddDocumentSignerNode: boolean } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { me?: { __typename?: 'CommonUser', id: number, email: string, createdAt: any, institutionCnpj?: string | null, name?: string | null, cpf?: string | null, photo?: string | null, permissions: Array<string>, teamId?: number | null, computedResolvedAt: string, loggedAs?: boolean | null, defaultSignatureImageId?: string | null, UserConfigs: Array<{ __typename?: 'CommonUserConfig', id: string, key: string, value: any }>, TeamMember: Array<{ __typename?: 'TeamMember', id: number, Team: { __typename?: 'Team', id: number, isActive: boolean, issuerName?: string | null, placeholderName: string } }>, Team: { __typename?: 'Team', id: number, financialShouldCharge: boolean, isNSF: boolean, showImportDiploma: boolean, showCreateDiploma: boolean, issuerData?: any | null, configAddDocumentSignerNode: boolean, publicViewDegreeDomainPath?: string | null, publicViewFinalAcademicTranscriptDomainPath?: string | null, publicViewSchoolCurriculumDomainPath?: string | null, externalSignatureWebhookURL?: string | null, placeholderName: string, spaceUsage: number, storage: number, FinancialTeamWallet?: { __typename?: 'FinancialTeamWallet', id: number, creditsPlanVisual: number, creditsPlanTrial: number, creditsPlanRb: number, creditsPlanRtRa: number, creditsDetachedVisual: number, creditsDetachedRb: number, creditsDetachedRtRa: number, teamId: number, SubscriptionActive?: { __typename?: 'FinancialTeamWalletSubscription', id: string, plan: FinancialPlan, billingCycle?: FinancialBillingCycle | null, planName?: string | null, canceledAt?: any | null, nextDueDate?: any | null, annualCreditQuotaResetDate?: any | null, createdAt: any, planUpdatedPrice: number } | null } | null, TeamEducationLevel: Array<{ __typename?: 'TeamEducationLevel', id: number, educationLevelType: EducationLevelType }>, maintainerSpace?: { __typename?: 'MaintainerSpace', id: number, usage: number, storage: number } | null }, UserAlerts: Array<{ __typename?: 'SystemGlobalAlert', id: number, type: SystemGlobalAlertType, value: string, actionUrl?: string | null, actionTitle?: string | null, message?: string | null, forcedTitle: string, forcedDescription: string, forcedActionUrl?: string | null, myDismissonsCount: number, targetEducationLevels: Array<EducationLevelType> }>, MaintainerAdmin?: { __typename?: 'MaintainerAdmin', id: string, Maintainer: { __typename?: 'Maintainer', id: number, Teams: Array<{ __typename?: 'Team', id: number, isActive: boolean, issuerName?: string | null, placeholderName: string }> } } | null } | null };

export type RenotarizationForceStageQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type RenotarizationForceStageQuery = { renotarizationForceStage?: RenotarizationForceStage | null };

export type SpaceFieldsFragment = { __typename?: 'Team', id: number, spaceUsage: number, storage: number, maintainerSpace?: { __typename?: 'MaintainerSpace', id: number, usage: number, storage: number } | null };

export type StartOneSignatureMutationVariables = Exact<{
  inviteId: Scalars['Int']['input'];
  certificate: Scalars['String']['input'];
}>;


export type StartOneSignatureMutation = { startOneSignature: { __typename?: 'StartSignature', id: string, dataToSign: string, signingTime: string, lastSignatureIsoString: string } };

export type StartOneSignatureExternalSignatureInviteMutationVariables = Exact<{
  inviteId: Scalars['String']['input'];
  certificate: Scalars['String']['input'];
}>;


export type StartOneSignatureExternalSignatureInviteMutation = { startOneSignature: { __typename?: 'StartSignature', id: string, dataToSign: string, signingTime: string, lastSignatureIsoString: string } };

export type SummaryFinancialChargeQueryVariables = Exact<{
  where?: InputMaybe<FinancialChargeWhereInput>;
}>;


export type SummaryFinancialChargeQuery = { summaryFinancialCharge: { __typename?: 'SumCount', id: number, sum: number, count: number } };

export type UpdateOneDegreeVisualRepresentationMutationVariables = Exact<{
  degreeId: Scalars['String']['input'];
  visualRepresentation: Scalars['Upload']['input'];
}>;


export type UpdateOneDegreeVisualRepresentationMutation = { updateOneDegreeVisualRepresentation?: { __typename?: 'DocumentDegree', id: string, documentBaseId: string } | null };

export type DocumentCertificateValidateFieldsFragment = { __typename?: 'DocumentCertificateHashHistory', id: string, hash: string, documentBaseId: string, createdAt: any, DocumentCertificate: { __typename?: 'DocumentCertificate', id: string, uuid: string, documentBaseId: string, documentCertificateCPF: string, documentCertificateName: string, status: DocumentCertificateStatus, MetadataList: Array<{ __typename?: 'DocumentCertificateMetadata', id: number, key: string, value: string }>, DocumentBase: { __typename?: 'DocumentBase', id: string, createdAt: any, updatedAt?: any | null, Team: { __typename?: 'Team', id: number, publicViewInstitutionName?: string | null }, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, data?: any | null, status?: string | null }> }, DocumentCertificateSignatureItems: Array<{ __typename?: 'DocumentCertificateSignatureItem', id: string, createdAt: any, PossibleSigners: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInvite', id: number, DocumentCertificateSignatureItemPossibleSignerInviteSignature: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInviteSignature', id: number, success: boolean, createdAt: any }>, TeamMember: { __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number, name?: string | null } } }> }> } };

export type ValidateOneDocumentCertificateQueryVariables = Exact<{
  file?: InputMaybe<Scalars['Upload']['input']>;
  docId?: InputMaybe<Scalars['String']['input']>;
  recaptchaResponse: Scalars['String']['input'];
}>;


export type ValidateOneDocumentCertificateQuery = { validateOneDocumentCertificate: { __typename?: 'validateOneDocumentCertificateObject', id: string, certificate: { __typename?: 'DocumentCertificateHashHistory', id: string, hash: string, documentBaseId: string, createdAt: any, DocumentCertificate: { __typename?: 'DocumentCertificate', id: string, uuid: string, documentBaseId: string, documentCertificateCPF: string, documentCertificateName: string, status: DocumentCertificateStatus, MetadataList: Array<{ __typename?: 'DocumentCertificateMetadata', id: number, key: string, value: string }>, DocumentBase: { __typename?: 'DocumentBase', id: string, createdAt: any, updatedAt?: any | null, Team: { __typename?: 'Team', id: number, publicViewInstitutionName?: string | null }, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, data?: any | null, status?: string | null }> }, DocumentCertificateSignatureItems: Array<{ __typename?: 'DocumentCertificateSignatureItem', id: string, createdAt: any, PossibleSigners: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInvite', id: number, DocumentCertificateSignatureItemPossibleSignerInviteSignature: Array<{ __typename?: 'DocumentCertificateSignatureItemPossibleSignerInviteSignature', id: number, success: boolean, createdAt: any }>, TeamMember: { __typename?: 'TeamMember', id: number, User: { __typename?: 'CommonUser', id: number, name?: string | null } } }> }> } }, validationResult: { __typename?: 'ValidationResult', id: string, isValid: boolean } } };

export type WatchFindFirstDocumentAcademicDocumentationSubscriptionVariables = Exact<{
  where: DocumentAcademicDocumentationWhereInput;
}>;


export type WatchFindFirstDocumentAcademicDocumentationSubscription = { findFirstDocumentAcademicDocumentation?: { __typename?: 'DocumentAcademicDocumentation', id: string, documentBaseId: string, type: DocumentAcademicDocumentationType, status: DocumentAcademicDocumentationStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, type: DocumentBaseType, internalSeqId: string, version: string, createdAt: any, creationType: DocumentAcademicDocumentationCreationType, data: any, filePath?: string | null, signatureConfig: Array<SignatureType>, UserOwner: { __typename?: 'CommonUser', id: number, email: string }, DocumentBaseSignatureInviteGroups: Array<{ __typename?: 'DocumentBaseSignatureInviteGroup', order: number, id: number, Invites: Array<{ __typename?: 'DocumentBaseSignatureInvite', id: number, TeamMember?: { __typename?: 'TeamMember', id: number, role?: string | null, createdAt: any, User: { __typename?: 'CommonUser', id: number, email: string, cpf?: string | null, name?: string | null, photo?: string | null }, TeamMemberPermissions: Array<{ __typename?: 'TeamMemberPermission', id: number, Permission: { __typename?: 'Permission', id: number, code: string } }> } | null, Signatures: Array<{ __typename?: 'DocumentBaseSignatureInviteSignature', id: number, createdAt: any, User: { __typename?: 'CommonUser', id: number, name?: string | null, email: string, cpf?: string | null } }> }> }>, Histories: Array<{ __typename?: 'DocumentBaseHistory', id: number, description?: string | null, status?: string | null, createdAt: any, data?: any | null, UserCreated?: { __typename?: 'CommonUser', id: number, name?: string | null, photo?: string | null, email: string } | null }> }, ChildDocuments: Array<{ __typename?: 'DocumentFinalAcademicTranscript', id: string, status: DocumentFinalAcademicTranscriptStatus, DocumentBase: { __typename?: 'DocumentBase', id: string, internalSeqId: string, version: string, createdAt: any } }> } | null };

export type FindUniqueSignSignatureImageSubSubscriptionVariables = Exact<{
  where: SignSignatureImageWhereUniqueInput;
}>;


export type FindUniqueSignSignatureImageSubSubscription = { findUniqueSignSignatureImage?: { __typename?: 'SignSignatureImage', id: string, base64Image: string, description: string, percentageBelowTheLine: number, createdAt: any } | null };

export type GeneratedCertificateSubscriptionVariables = Exact<{
  institutionId: Scalars['Int']['input'];
  bulkCertificateRecordId: Scalars['String']['input'];
}>;


export type GeneratedCertificateSubscription = { generatedCertificate: { __typename?: 'GeneratedCertificateData', id: string, institutionId: number, bulkCertificateRecordId: string, certificateId?: string | null, totalIssued: number, totalCertificates: number } };

export type WatchSignBulkCertificateSubscriptionVariables = Exact<{
  bulkId: Scalars['String']['input'];
}>;


export type WatchSignBulkCertificateSubscription = { watchSignBulkCertificate: { __typename?: 'WatchSignBulkCertificate', id: string, documentsCompleted: number, status: string, totalInviteForSign: number } };

export type WatchSignValidationBulkCertificateSubscriptionVariables = Exact<{
  bulkId: Scalars['String']['input'];
}>;


export type WatchSignValidationBulkCertificateSubscription = { watchSignValidationBulkCertificate: { __typename?: 'WatchSignValidationBulkCertificate', id: string, status: string } };

export type WatchSingleCertificateSignValidationEventSubscriptionVariables = Exact<{
  inviteId: Scalars['String']['input'];
}>;


export type WatchSingleCertificateSignValidationEventSubscription = { watchSingleCertificateSignValidationEvent: { __typename?: 'WatchSingleCertificateSignValidationEvent', id: string, status: string } };

export type WatchCertificateTemplateDataSubscriptionVariables = Exact<{
  teamId: Scalars['Int']['input'];
  templateId: Scalars['String']['input'];
}>;


export type WatchCertificateTemplateDataSubscription = { watchCertificateTemplateData: { __typename?: 'WatchCertificateTemplateData', id: string, data?: any | null } };

export type WatchDocumentFocusFieldsFragment = { __typename?: 'WatchDocumentFocus', id: number, fieldPath: string, user: { __typename?: 'WatchDocumentObjectUser', id: number, email: string, photo?: string | null, name?: string | null } };

export type WatchDocumentFocusSubscriptionVariables = Exact<{
  documentId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
}>;


export type WatchDocumentFocusSubscription = { watchDocumentFocus: Array<{ __typename?: 'WatchDocumentFocus', id: number, fieldPath: string, user: { __typename?: 'WatchDocumentObjectUser', id: number, email: string, photo?: string | null, name?: string | null } }> };

export type WatchDocumentPatchFieldsFragment = { __typename?: 'WatchDocumentPatch', id: string, changes: Array<{ __typename?: 'WatchDocumentPatchesChanges', id: string, propertyPath: string, type: string, value?: any | null }> };

export type WatchDocumentPatchesSubscriptionVariables = Exact<{
  documentId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
}>;


export type WatchDocumentPatchesSubscription = { watchDocumentPatches: { __typename?: 'WatchDocumentPatch', id: string, changes: Array<{ __typename?: 'WatchDocumentPatchesChanges', id: string, propertyPath: string, type: string, value?: any | null }> } };

export type WatchDocumentStatusSubscriptionVariables = Exact<{
  documentId: Scalars['String']['input'];
  teamId: Scalars['Int']['input'];
}>;


export type WatchDocumentStatusSubscription = { watchDocumentStatus: string };

export type WatchFinancialTeamWalletSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type WatchFinancialTeamWalletSubscription = { watchFinancialTeamWallet: { __typename?: 'FinancialTeamWallet', id: number, creditsPlanVisual: number, creditsPlanTrial: number, creditsPlanRb: number, creditsPlanRtRa: number, creditsDetachedVisual: number, creditsDetachedRb: number, creditsDetachedRtRa: number, teamId: number } };

export type WatchTeamSpaceUsageSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type WatchTeamSpaceUsageSubscription = { watchTeamSpaceUsage?: { __typename?: 'Team', id: number, spaceUsage: number, storage: number, maintainerSpace?: { __typename?: 'MaintainerSpace', id: number, usage: number, storage: number } | null } | null };

export const TeamMemberFieldsFragmentDoc = gql`
    fragment TeamMemberFields on TeamMember {
  id
  role
  User {
    id
    email
    cpf
    name
    photo
  }
  createdAt
  TeamMemberPermissions {
    id
    Permission {
      id
      code
    }
  }
}
    `;
export const DocumentBaseSignatureInviteGroupFieldsFragmentDoc = gql`
    fragment DocumentBaseSignatureInviteGroupFields on DocumentBaseSignatureInviteGroup {
  order
  id
  Invites {
    id
    TeamMember {
      ...TeamMemberFields
    }
    Signatures {
      id
      createdAt
      User {
        id
        name
        email
        cpf
      }
    }
  }
}
    ${TeamMemberFieldsFragmentDoc}`;
export const DocumentBaseFieldsFragmentDoc = gql`
    fragment DocumentBaseFields on DocumentBase {
  id
  type
  internalSeqId
  version
  createdAt
  updatedAt
  creationType
  data
  filePath
  fileSize
  signatureConfig
  UserOwner {
    id
    email
  }
  DocumentBaseSignatureInviteGroups(orderBy: {order: asc}) {
    ...DocumentBaseSignatureInviteGroupFields
  }
  Histories(orderBy: {createdAt: asc}) {
    id
    description
    status
    createdAt
    data
    UserCreated {
      id
      name
      photo
      email
    }
  }
}
    ${DocumentBaseSignatureInviteGroupFieldsFragmentDoc}`;
export const DocumentAcademicDocumentationFieldsFragmentDoc = gql`
    fragment DocumentAcademicDocumentationFields on DocumentAcademicDocumentation {
  id
  DocumentBase {
    ...DocumentBaseFields
  }
  documentBaseId
  type
  ChildDocuments {
    id
    documentBaseId
    status
    DocumentBase {
      id
      type
      internalSeqId
      version
      createdAt
    }
  }
  LinkedDegreeList {
    id
    documentBaseId
    status
    DocumentBase {
      id
      deletedAt
    }
  }
  status
}
    ${DocumentBaseFieldsFragmentDoc}`;
export const DocumentBaseSignatureInviteFieldsFragmentDoc = gql`
    fragment DocumentBaseSignatureInviteFields on DocumentBaseSignatureInvite {
  id
  createdAt
  Signatures {
    id
    createdAt
    User {
      id
      name
      email
      cpf
    }
  }
  TeamMember {
    id
    User {
      id
      cpf
    }
  }
  Group {
    id
    order
    DocumentBase {
      id
      internalSeqId
      version
      UserOwner {
        id
        email
      }
      type
      DocumentBaseSignatureInviteGroups(orderBy: {order: asc}) {
        ...DocumentBaseSignatureInviteGroupFields
      }
      DocumentAcademicDocumentation {
        id
        searchStudentName
        searchCourse
        searchCPF
        searchEmecCode
      }
      DocumentDegree {
        id
        searchStudentName
        searchCourse
        searchCPF
        searchEmecCode
      }
      DocumentFinalAcademicTranscript {
        id
        searchStudentName
        searchCourse
        searchCPF
        searchEmecCode
      }
      DocumentAuditFileIssuer {
        id
        searchAuditStartDate
        searchAuditEndDate
      }
      createdAt
    }
  }
}
    ${DocumentBaseSignatureInviteGroupFieldsFragmentDoc}`;
export const DocumentDegreeFieldsFragmentDoc = gql`
    fragment DocumentDegreeFields on DocumentDegree {
  id
  documentBaseId
  searchStudentName
  searchCPF
  searchCourse
  searchEmecCode
  status
  searchValidationCode
  searchIssueDate
  searchRegistrationDate
  visualRepresentationCreationType
  visualRepresentationFileSize
  isSentToGraduate
  DocumentBase {
    id
    internalSeqId
    creationType
    fileSize
    hasFile
    createdAt
    deletedAt
  }
}
    `;
export const DocumentDegreeUniqueFieldsFragmentDoc = gql`
    fragment DocumentDegreeUniqueFields on DocumentDegree {
  id
  documentBaseId
  visualRepresentationPath
  visualRepresentationFileSize
  searchStudentName
  searchCPF
  searchCourse
  searchValidationCode
  status
  ParentAcademicDocumentation {
    id
    DocumentBase {
      id
      internalSeqId
    }
  }
  DocumentBase {
    ...DocumentBaseFields
    filePath
    type
    UserOwner {
      id
    }
  }
}
    ${DocumentBaseFieldsFragmentDoc}`;
export const PersonFieldsFragmentDoc = gql`
    fragment PersonFields on Person {
  id
  name
  receivesCertificateEmail
  receivesCertificateWhatsapp
  Phones {
    id
    number
  }
  cpf
  birthDate
  identityDocument
  email
  isForeign
  passport
  Address {
    id
    city
    complement
    neighborhood
    postalCode
    state
    street
  }
}
    `;
export const DocumentSchoolCurriculumFieldsFragmentDoc = gql`
    fragment DocumentSchoolCurriculumFields on DocumentSchoolCurriculum {
  id
  DocumentBase {
    ...DocumentBaseFields
  }
  searchSchoolCurriculumName
  searchSchoolCurriculumCode
  documentBaseId
  status
}
    ${DocumentBaseFieldsFragmentDoc}`;
export const TeamFieldsFragmentDoc = gql`
    fragment TeamFields on Team {
  id
  isNSF
  showImportDiploma
  showCreateDiploma
  cnpj
  createdAt
  TeamMember(where: $teamMemberWhere, skip: $skip, take: $take, orderBy: $orderBy) {
    id
    role
    User {
      id
      name
      cpf
      email
      createdAt
    }
  }
  TeamEducationLevel {
    id
    educationLevelType
  }
}
    `;
export const TeamIdNamesActiveFieldsFragmentDoc = gql`
    fragment TeamIdNamesActiveFields on Team {
  id
  isActive
  issuerName
  placeholderName
}
    `;
export const SystemGlobalAlertFieldsFragmentDoc = gql`
    fragment SystemGlobalAlertFields on SystemGlobalAlert {
  id
  type
  value
  actionUrl
  actionTitle
  message
  forcedTitle
  forcedDescription
  forcedActionUrl
  myDismissonsCount
  targetEducationLevels
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on CommonUser {
  id
  email
  createdAt
  institutionCnpj
  name
  cpf
  photo
  permissions
  teamId
  computedResolvedAt
  UserConfigs {
    id
    key
    value
  }
  TeamMember {
    id
    Team {
      ...TeamIdNamesActiveFields
    }
  }
  Team {
    id
    FinancialTeamWallet {
      id
      creditsPlanVisual
      creditsPlanTrial
      creditsPlanRb
      creditsPlanRtRa
      creditsDetachedVisual
      creditsDetachedRb
      creditsDetachedRtRa
      SubscriptionActive {
        id
        plan
        billingCycle
        planName
        canceledAt
        nextDueDate
        annualCreditQuotaResetDate
        createdAt
        planUpdatedPrice
      }
      teamId
    }
    financialShouldCharge
    isNSF
    showImportDiploma
    showCreateDiploma
    issuerData
    id
    configAddDocumentSignerNode
    publicViewDegreeDomainPath
    publicViewFinalAcademicTranscriptDomainPath
    publicViewSchoolCurriculumDomainPath
    externalSignatureWebhookURL
    TeamEducationLevel {
      id
      educationLevelType
    }
    placeholderName
    spaceUsage
    storage
    maintainerSpace {
      id
      usage
      storage
    }
  }
  loggedAs
  defaultSignatureImageId
  UserAlerts {
    ...SystemGlobalAlertFields
  }
  MaintainerAdmin {
    id
    Maintainer {
      id
      Teams {
        ...TeamIdNamesActiveFields
      }
    }
  }
}
    ${TeamIdNamesActiveFieldsFragmentDoc}
${SystemGlobalAlertFieldsFragmentDoc}`;
export const SignSignatureImageFieldsFragmentDoc = gql`
    fragment SignSignatureImageFields on SignSignatureImage {
  id
  base64Image
  createdAt
  description
  UserUsingAsPrimary {
    id
  }
  percentageBelowTheLine
}
    `;
export const DocumentAcademicDocumentationTableFieldsFragmentDoc = gql`
    fragment DocumentAcademicDocumentationTableFields on DocumentAcademicDocumentation {
  id
  documentBaseId
  status
  type
  searchStudentName
  searchCPF
  searchCourse
  searchEmecCode
  isSentToRegistrar
  DocumentBase {
    id
    internalSeqId
    creationType
    version
    hasFile
    createdAt
    deletedAt
  }
}
    `;
export const CertificateCourseFieldsFragmentDoc = gql`
    fragment CertificateCourseFields on CertificateCourse {
  id
  certificateBaseId
  name
  areaKnowledge
  metaData
  CertificateBase {
    id
    createdAt
  }
  CourseLevel {
    id
    certificateBaseId
    name
  }
}
    `;
export const CertificateCourseLevelFieldsFragmentDoc = gql`
    fragment CertificateCourseLevelFields on CertificateCourseLevel {
  id
  certificateBaseId
  name
  CertificateBase {
    id
    createdAt
  }
}
    `;
export const CertificateCurriculumFieldsFragmentDoc = gql`
    fragment CertificateCurriculumFields on CertificateCurriculum {
  id
  certificateBaseId
  name
  amountOfHours
  CertificateBase {
    id
    createdAt
  }
  CertificateCurriculumSelectedDisciplines {
    id
    SelectedDiscipline {
      id
      name
      certificateBaseId
    }
  }
}
    `;
export const CertificateEventFieldsFragmentDoc = gql`
    fragment CertificateEventFields on CertificateEvent {
  id
  certificateBaseId
  name
  CertificateBase {
    id
    createdAt
  }
}
    `;
export const CertificateTemplateManyFieldsFragmentDoc = gql`
    fragment CertificateTemplateManyFields on CertificateTemplate {
  id
  name
  description
  createdAt
  commonUserId
  TeamUsingAsPrimary {
    id
  }
}
    `;
export const DocumentRenotarizationHistoryTableFieldsFragmentDoc = gql`
    fragment DocumentRenotarizationHistoryTableFields on DocumentRenotarizationHistory {
  id
  type
  signatureId
  userName
  userEmail
  archiveTimestamp
  archiveTimestampCertificateExpiration
  archiveTimestampAuthority
  archiveTimestampAlgorithm
  archiveTimestampSerial
  createdAt
}
    `;
export const DocumentRenotarizationTableFieldsFragmentDoc = gql`
    fragment DocumentRenotarizationTableFields on DocumentRenotarization {
  id
  documentBaseId
  archiveTimestampCertificateExpiration
  createdAt
  updatedAt
  signatureId
  Histories {
    ...DocumentRenotarizationHistoryTableFields
  }
  DocumentBase {
    id
    internalSeqId
    createdAt
    type
    version
    deletedAt
    data
    Team {
      id
      placeholderName
      issuerName
      EnabledInstitution {
        id
        placeholderName
      }
    }
    Renotarizations {
      id
      archiveTimestampCertificateExpiration
      createdAt
    }
    DocumentAcademicDocumentation {
      id
      searchStudentName
    }
    DocumentFinalAcademicTranscript {
      id
      searchStudentName
    }
    DocumentDegree {
      id
      searchStudentName
    }
    DocumentCertificate {
      id
      documentCertificateName
    }
    DocumentSchoolCurriculum {
      id
      searchSchoolCurriculumName
    }
  }
}
    ${DocumentRenotarizationHistoryTableFieldsFragmentDoc}`;
export const SpaceFieldsFragmentDoc = gql`
    fragment SpaceFields on Team {
  id
  spaceUsage
  storage
  maintainerSpace {
    id
    usage
    storage
  }
}
    `;
export const EnabledInstitutionFieldsFragmentDoc = gql`
    fragment EnabledInstitutionFields on EnabledInstitution {
  id
  cnpj
  email
  isMaintainer
  placeholderName
  Team {
    id
    ...SpaceFields
    placeholderName
    contract
    observations
    syncWithLedgerDoc
    isNSF
    showImportDiploma
    showCreateDiploma
    lastActivityAt
    issuedCount
    logoBase64
    faviconBase64
    publicViewDegreeDomainPath
    publicViewFinalAcademicTranscriptDomainPath
    publicViewSchoolCurriculumDomainPath
    publicViewInstitutionName
    publicViewPrimaryColor
    publicViewSecondaryColor
    externalSignatureWebhookURL
    validateCertificateURL
    isActive
    deactivationReason
    TeamEducationLevel {
      id
      educationLevelType
    }
    issuerData
    issuerName
    Maintainer {
      id
      MainTeam {
        id
        issuerName
        placeholderName
      }
      Teams {
        id
      }
    }
    TeamContracts(where: {isActive: {equals: true}}) {
      id
      contractUrl
      startOfContract
      endOfContract
      isActive
    }
  }
}
    ${SpaceFieldsFragmentDoc}`;
export const PlanAndConditionsFieldsFragmentDoc = gql`
    fragment PlanAndConditionsFields on PlanAndConditions {
  id
  includedCertificates
  name
  monthlyPricing
  yearlyPricing
  plan
  disabled
}
    `;
export const FinancialTeamWalletSubscriptionPaymentFieldsFragmentDoc = gql`
    fragment FinancialTeamWalletSubscriptionPaymentFields on FinancialTeamWalletSubscriptionPayment {
  id
  dueDate
  cost
  createdAt
  status
}
    `;
export const ReusableFormDataCurriculumFieldsFragmentDoc = gql`
    fragment ReusableFormDataCurriculumFields on ReusableFormDataCurriculum {
  id
  name
  Course {
    id
    data
  }
  createdAt
}
    `;
export const SystemGlobalAlertManyFieldsFragmentDoc = gql`
    fragment SystemGlobalAlertManyFields on SystemGlobalAlert {
  actionTitle
  actionUrl
  active
  createdAt
  forcedDescription
  forcedTitle
  id
  message
  type
  updatedAt
  createdAt
  value
  dismissonsCount
  targetEducationLevels
}
    `;
export const TeamManyFieldsFragmentDoc = gql`
    fragment TeamManyFields on Team {
  id
  issuedCount
  placeholderName
  validateCertificateURL
  cnpj
  lastActivityAt
  isActive
  deactivationReason
  Owner {
    id
    name
    email
  }
  ...SpaceFields
}
    ${SpaceFieldsFragmentDoc}`;
export const TeamContractManyFieldsFragmentDoc = gql`
    fragment TeamContractManyFields on TeamContract {
  id
  contractUrl
  isActive
  startOfContract
  endOfContract
  createdAt
  updatedAt
  teamId
  observations
  storageInGb
}
    `;
export const TeamDocumentTypeSpecificSignaturePolicyConfigManyFieldsFragmentDoc = gql`
    fragment TeamDocumentTypeSpecificSignaturePolicyConfigManyFields on TeamDocumentTypeSpecificSignaturePolicyConfig {
  id
  teamId
  documentType
  groupPolicies
}
    `;
export const SystemAuditLogFieldsFragmentDoc = gql`
    fragment SystemAuditLogFields on SystemAuditLog {
  id
  table
  operation
  teamId
  User {
    id
    name
    photo
    email
  }
  operationTranslated
  moduleTranslated
  createdAt
  after
  args
  extraContext
  primaryKey
  translatedAfter {
    id
    key
    value
  }
}
    `;
export const TeamAndPublicDocumentBaseTypeFieldsFragmentDoc = gql`
    fragment TeamAndPublicDocumentBaseTypeFields on TeamAndPublicDocumentBaseType {
  id
  team {
    id
    publicViewDegreeDomainPath
    publicViewFinalAcademicTranscriptDomainPath
    publicViewSchoolCurriculumDomainPath
    publicViewInstitutionName
    publicViewPrimaryColor
    publicViewSecondaryColor
    externalSignatureWebhookURL
    logoBase64
    faviconBase64
  }
  documentSeeType
  url
}
    `;
export const SelectedDisciplineFieldsFragmentDoc = gql`
    fragment SelectedDisciplineFields on CertificateCurriculumSelectedDiscipline {
  id
  SelectedDiscipline {
    id
    certificateBaseId
    name
  }
  SelectedTeacher {
    id
    certificateBaseId
    name
  }
  amountOfHours
}
    `;
export const CertificateTemplateFieldsFragmentDoc = gql`
    fragment CertificateTemplateFields on CertificateTemplate {
  id
  name
  description
  createdAt
  data
}
    `;
export const DegreeViewDegreeFragmentDoc = gql`
    fragment DegreeViewDegree on DocumentDegree {
  id
  documentBaseId
  searchCourse
  searchCPF
  searchEmecCode
  searchStudentName
  searchValidationCode
  status
  visualRepresentationPath
  DocumentBase {
    id
    Team {
      id
      publicViewDegreeDomainPath
      publicViewFinalAcademicTranscriptDomainPath
      publicViewSchoolCurriculumDomainPath
      externalSignatureWebhookURL
      publicViewInstitutionName
      publicViewPrimaryColor
      publicViewSecondaryColor
    }
    createdAt
  }
}
    `;
export const DocumentAuditFileIssuerFieldsFragmentDoc = gql`
    fragment DocumentAuditFileIssuerFields on DocumentAuditFileIssuer {
  id
  documentBaseId
  searchAuditStartDate
  searchAuditEndDate
  status
  DocumentBase {
    ...DocumentBaseFields
  }
}
    ${DocumentBaseFieldsFragmentDoc}`;
export const DocumentCertificateSignatureItemBaseFieldsFragmentDoc = gql`
    fragment DocumentCertificateSignatureItemBaseFields on DocumentCertificateSignatureItem {
  id
  predefinedImageBase64
  type
  createdAt
  PossibleSigners {
    id
    TeamMember {
      id
      User {
        id
        name
        email
      }
    }
    DocumentCertificateSignatureItemPossibleSignerInviteSignature {
      id
      success
      createdAt
    }
  }
}
    `;
export const DocumentCertificateFieldsFragmentDoc = gql`
    fragment DocumentCertificateFields on DocumentCertificate {
  id
  documentBaseId
  uuid
  documentCertificateCPF
  documentCertificateName
  certificateTemplateId
  status
  hasOnlyPredefinedVisualSignature
  Person {
    id
    name
    cpf
    email
  }
  Curriculum {
    id
    name
    CertificateCourse {
      id
      name
    }
  }
  BulkCertificateRecord {
    id
    status
    bulkCertificateRecordName
  }
  DocumentCertificateSignatureItems {
    id
  }
  DocumentCertificateHashHistory {
    id
    hash
  }
  TeamEducationLevel {
    id
    educationLevelType
  }
  DocumentBase {
    ...DocumentBaseFields
  }
  DocumentCertificateSignatureItems {
    ...DocumentCertificateSignatureItemBaseFields
  }
}
    ${DocumentBaseFieldsFragmentDoc}
${DocumentCertificateSignatureItemBaseFieldsFragmentDoc}`;
export const DocumentCertificateSignatureItemFieldsFragmentDoc = gql`
    fragment DocumentCertificateSignatureItemFields on DocumentCertificateSignatureItem {
  id
  predefinedImageBase64
  type
  DocumentCertificate {
    ...DocumentCertificateFields
    DocumentBase {
      id
      type
      internalSeqId
    }
    DocumentCertificateSignatureItems {
      id
      type
      predefinedImageBase64
      PossibleSigners {
        id
        TeamMember {
          id
          User {
            id
            cpf
            name
            email
          }
        }
        DocumentCertificateSignatureItemPossibleSignerInviteSignature {
          id
          success
          createdAt
        }
      }
    }
  }
  PossibleSigners {
    id
    TeamMember {
      id
      User {
        id
        name
        email
        cpf
      }
    }
    DocumentCertificateSignatureItemPossibleSignerInviteSignature {
      id
      success
      createdAt
    }
  }
}
    ${DocumentCertificateFieldsFragmentDoc}`;
export const DocumentFinalAcademicTranscriptFieldsFragmentDoc = gql`
    fragment DocumentFinalAcademicTranscriptFields on DocumentFinalAcademicTranscript {
  id
  DocumentBase {
    ...DocumentBaseFields
  }
  documentBaseId
  status
}
    ${DocumentBaseFieldsFragmentDoc}`;
export const ExternalSignatureInviteFieldsFragmentDoc = gql`
    fragment ExternalSignatureInviteFields on ExternalSignatureInvite {
  id
  isSigned
  callbackUrl
  createdAt
  documentBaseInternalSeqId
  groupIndex
  documentStudentName
  DocumentBase {
    id
    type
  }
  enabledPersonIdList
  DocumentBase {
    id
    ExternalSignatureInvite {
      id
      groupIndex
      isSigned
    }
  }
}
    `;
export const ReusableFormDataCurriculumUniqueFieldsFragmentDoc = gql`
    fragment ReusableFormDataCurriculumUniqueFields on ReusableFormDataCurriculum {
  id
  name
  Course {
    id
    data
  }
  DisciplineLinks {
    id
    Discipline {
      id
      id
      data
    }
  }
}
    `;
export const SignSignatureImageUniqueFieldsFragmentDoc = gql`
    fragment SignSignatureImageUniqueFields on SignSignatureImage {
  id
  base64Image
  description
  percentageBelowTheLine
  createdAt
}
    `;
export const UniqueTeamFieldsFragmentDoc = gql`
    fragment UniqueTeamFields on Team {
  id
  TeamMember(take: $take, skip: $skip, orderBy: $orderBy, where: $teamMemberWhere) {
    id
    role
    User {
      id
      lastActivityAt
      name
      email
      cpf
      createdAt
    }
  }
  publicViewInstitutionName
  memberCount
  TeamEducationLevel {
    id
    educationLevelType
    teamId
  }
}
    `;
export const PublicViewFieldsFragmentDoc = gql`
    fragment PublicViewFields on PublicView {
  id
  dataKeyValues {
    id
    key
    value
  }
  documentTypeName
  isValid
  isVisualRepresentationEnabled
  securityCode
  validationDatetime
}
    `;
export const RechargeOptionsFieldsFragmentDoc = gql`
    fragment RechargeOptionsFields on RechargeOptions {
  discounts {
    id
    count
    valueInPercent
  }
  presets {
    id
    count
  }
  servicesPrices {
    id
    service
    unitPrice
  }
}
    `;
export const DocumentCertificateValidateFieldsFragmentDoc = gql`
    fragment DocumentCertificateValidateFields on DocumentCertificateHashHistory {
  id
  hash
  documentBaseId
  createdAt
  DocumentCertificate {
    id
    uuid
    documentBaseId
    MetadataList {
      id
      key
      value
    }
    DocumentBase {
      id
      createdAt
      updatedAt
      Team {
        id
        publicViewInstitutionName
      }
      Histories {
        id
        data
        status
      }
    }
    documentCertificateCPF
    documentCertificateName
    DocumentCertificateSignatureItems {
      id
      createdAt
      PossibleSigners {
        id
        DocumentCertificateSignatureItemPossibleSignerInviteSignature {
          id
          success
          createdAt
        }
        TeamMember {
          id
          User {
            id
            name
          }
        }
      }
    }
    status
  }
}
    `;
export const WatchDocumentFocusFieldsFragmentDoc = gql`
    fragment WatchDocumentFocusFields on WatchDocumentFocus {
  id
  fieldPath
  user {
    id
    email
    photo
    name
  }
}
    `;
export const WatchDocumentPatchFieldsFragmentDoc = gql`
    fragment WatchDocumentPatchFields on WatchDocumentPatch {
  id
  changes {
    id
    propertyPath
    type
    value
  }
}
    `;
export const AddOneTeamMemberDocument = gql`
    mutation addOneTeamMember($email: String!, $permissions: [String!]!, $role: String) {
  addOneTeamMember(email: $email, permissions: $permissions, role: $role) {
    id
  }
}
    `;

/**
 * __useAddOneTeamMemberMutation__
 *
 * To run a mutation, you first call `useAddOneTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOneTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOneTeamMemberMutation, { data, loading, error }] = useAddOneTeamMemberMutation({
 *   variables: {
 *      email: // value for 'email'
 *      permissions: // value for 'permissions'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useAddOneTeamMemberMutation(baseOptions?: ApolloReact.useMutation.Options<AddOneTeamMemberMutation, AddOneTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<AddOneTeamMemberMutation, AddOneTeamMemberMutationVariables>(AddOneTeamMemberDocument, options);
      }
export type AddOneTeamMemberMutationHookResult = ReturnType<typeof useAddOneTeamMemberMutation>;
export type AddOneTeamMemberMutationResult = ApolloReact.useMutation.Result<AddOneTeamMemberMutation>;
export const BuildOneDegreeVisualRepresentationDocument = gql`
    mutation buildOneDegreeVisualRepresentation($degreeId: String!, $templateId: String!, $variables: Json!) {
  buildOneDegreeVisualRepresentation(
    degreeId: $degreeId
    templateId: $templateId
    variables: $variables
  ) {
    id
    documentBaseId
    visualRepresentationPath
  }
}
    `;

/**
 * __useBuildOneDegreeVisualRepresentationMutation__
 *
 * To run a mutation, you first call `useBuildOneDegreeVisualRepresentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuildOneDegreeVisualRepresentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buildOneDegreeVisualRepresentationMutation, { data, loading, error }] = useBuildOneDegreeVisualRepresentationMutation({
 *   variables: {
 *      degreeId: // value for 'degreeId'
 *      templateId: // value for 'templateId'
 *      variables: // value for 'variables'
 *   },
 * });
 */
export function useBuildOneDegreeVisualRepresentationMutation(baseOptions?: ApolloReact.useMutation.Options<BuildOneDegreeVisualRepresentationMutation, BuildOneDegreeVisualRepresentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<BuildOneDegreeVisualRepresentationMutation, BuildOneDegreeVisualRepresentationMutationVariables>(BuildOneDegreeVisualRepresentationDocument, options);
      }
export type BuildOneDegreeVisualRepresentationMutationHookResult = ReturnType<typeof useBuildOneDegreeVisualRepresentationMutation>;
export type BuildOneDegreeVisualRepresentationMutationResult = ApolloReact.useMutation.Result<BuildOneDegreeVisualRepresentationMutation>;
export const CodeAuthLoginLedgerSignDocument = gql`
    mutation codeAuthLoginLedgerSign($token: String!, $subservice: SubService!) {
  codeAuthLoginLedgerSign(token: $token, subservice: $subservice) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useCodeAuthLoginLedgerSignMutation__
 *
 * To run a mutation, you first call `useCodeAuthLoginLedgerSignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCodeAuthLoginLedgerSignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [codeAuthLoginLedgerSignMutation, { data, loading, error }] = useCodeAuthLoginLedgerSignMutation({
 *   variables: {
 *      token: // value for 'token'
 *      subservice: // value for 'subservice'
 *   },
 * });
 */
export function useCodeAuthLoginLedgerSignMutation(baseOptions?: ApolloReact.useMutation.Options<CodeAuthLoginLedgerSignMutation, CodeAuthLoginLedgerSignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CodeAuthLoginLedgerSignMutation, CodeAuthLoginLedgerSignMutationVariables>(CodeAuthLoginLedgerSignDocument, options);
      }
export type CodeAuthLoginLedgerSignMutationHookResult = ReturnType<typeof useCodeAuthLoginLedgerSignMutation>;
export type CodeAuthLoginLedgerSignMutationResult = ApolloReact.useMutation.Result<CodeAuthLoginLedgerSignMutation>;
export const CodeAuthRefreshTokensDocument = gql`
    mutation codeAuthRefreshTokens($token: String!) {
  codeAuthRefreshTokens(token: $token) {
    id
  }
}
    `;

/**
 * __useCodeAuthRefreshTokensMutation__
 *
 * To run a mutation, you first call `useCodeAuthRefreshTokensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCodeAuthRefreshTokensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [codeAuthRefreshTokensMutation, { data, loading, error }] = useCodeAuthRefreshTokensMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useCodeAuthRefreshTokensMutation(baseOptions?: ApolloReact.useMutation.Options<CodeAuthRefreshTokensMutation, CodeAuthRefreshTokensMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CodeAuthRefreshTokensMutation, CodeAuthRefreshTokensMutationVariables>(CodeAuthRefreshTokensDocument, options);
      }
export type CodeAuthRefreshTokensMutationHookResult = ReturnType<typeof useCodeAuthRefreshTokensMutation>;
export type CodeAuthRefreshTokensMutationResult = ApolloReact.useMutation.Result<CodeAuthRefreshTokensMutation>;
export const CodeServiceSendMessageToSlackDocument = gql`
    mutation codeServiceSendMessageToSlack($message: String!) {
  codeServiceSendMessageToSlack(message: $message)
}
    `;

/**
 * __useCodeServiceSendMessageToSlackMutation__
 *
 * To run a mutation, you first call `useCodeServiceSendMessageToSlackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCodeServiceSendMessageToSlackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [codeServiceSendMessageToSlackMutation, { data, loading, error }] = useCodeServiceSendMessageToSlackMutation({
 *   variables: {
 *      message: // value for 'message'
 *   },
 * });
 */
export function useCodeServiceSendMessageToSlackMutation(baseOptions?: ApolloReact.useMutation.Options<CodeServiceSendMessageToSlackMutation, CodeServiceSendMessageToSlackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CodeServiceSendMessageToSlackMutation, CodeServiceSendMessageToSlackMutationVariables>(CodeServiceSendMessageToSlackDocument, options);
      }
export type CodeServiceSendMessageToSlackMutationHookResult = ReturnType<typeof useCodeServiceSendMessageToSlackMutation>;
export type CodeServiceSendMessageToSlackMutationResult = ApolloReact.useMutation.Result<CodeServiceSendMessageToSlackMutation>;
export const CompleteOneTemporarySignatureImageDocument = gql`
    mutation completeOneTemporarySignatureImage($completeData: CompleteSignatureImage!) {
  completeOneTemporarySignatureImage(completeData: $completeData) {
    id
  }
}
    `;

/**
 * __useCompleteOneTemporarySignatureImageMutation__
 *
 * To run a mutation, you first call `useCompleteOneTemporarySignatureImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteOneTemporarySignatureImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeOneTemporarySignatureImageMutation, { data, loading, error }] = useCompleteOneTemporarySignatureImageMutation({
 *   variables: {
 *      completeData: // value for 'completeData'
 *   },
 * });
 */
export function useCompleteOneTemporarySignatureImageMutation(baseOptions?: ApolloReact.useMutation.Options<CompleteOneTemporarySignatureImageMutation, CompleteOneTemporarySignatureImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CompleteOneTemporarySignatureImageMutation, CompleteOneTemporarySignatureImageMutationVariables>(CompleteOneTemporarySignatureImageDocument, options);
      }
export type CompleteOneTemporarySignatureImageMutationHookResult = ReturnType<typeof useCompleteOneTemporarySignatureImageMutation>;
export type CompleteOneTemporarySignatureImageMutationResult = ApolloReact.useMutation.Result<CompleteOneTemporarySignatureImageMutation>;
export const CorrectOneDocumentAuditFileIssuerDocument = gql`
    mutation correctOneDocumentAuditFileIssuer($degreeCount: Int!, $documentBaseId: String!, $endDate: Date!, $startDate: Date!, $excludeRevoked: Boolean!) {
  correctOneDocumentAuditFileIssuer(
    degreeCount: $degreeCount
    documentBaseId: $documentBaseId
    endDate: $endDate
    startDate: $startDate
    excludeRevoked: $excludeRevoked
  ) {
    id
    documentBaseId
  }
}
    `;

/**
 * __useCorrectOneDocumentAuditFileIssuerMutation__
 *
 * To run a mutation, you first call `useCorrectOneDocumentAuditFileIssuerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCorrectOneDocumentAuditFileIssuerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [correctOneDocumentAuditFileIssuerMutation, { data, loading, error }] = useCorrectOneDocumentAuditFileIssuerMutation({
 *   variables: {
 *      degreeCount: // value for 'degreeCount'
 *      documentBaseId: // value for 'documentBaseId'
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      excludeRevoked: // value for 'excludeRevoked'
 *   },
 * });
 */
export function useCorrectOneDocumentAuditFileIssuerMutation(baseOptions?: ApolloReact.useMutation.Options<CorrectOneDocumentAuditFileIssuerMutation, CorrectOneDocumentAuditFileIssuerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CorrectOneDocumentAuditFileIssuerMutation, CorrectOneDocumentAuditFileIssuerMutationVariables>(CorrectOneDocumentAuditFileIssuerDocument, options);
      }
export type CorrectOneDocumentAuditFileIssuerMutationHookResult = ReturnType<typeof useCorrectOneDocumentAuditFileIssuerMutation>;
export type CorrectOneDocumentAuditFileIssuerMutationResult = ApolloReact.useMutation.Result<CorrectOneDocumentAuditFileIssuerMutation>;
export const CreateApiKeyDocument = gql`
    mutation createApiKey($description: String!) {
  createApiKey(description: $description)
}
    `;

/**
 * __useCreateApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiKeyMutation, { data, loading, error }] = useCreateApiKeyMutation({
 *   variables: {
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateApiKeyMutation(baseOptions?: ApolloReact.useMutation.Options<CreateApiKeyMutation, CreateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CreateApiKeyMutation, CreateApiKeyMutationVariables>(CreateApiKeyDocument, options);
      }
export type CreateApiKeyMutationHookResult = ReturnType<typeof useCreateApiKeyMutation>;
export type CreateApiKeyMutationResult = ApolloReact.useMutation.Result<CreateApiKeyMutation>;
export const CreateBulkDocumentCertificateDocument = gql`
    mutation createBulkDocumentCertificate($curriculumId: String, $templateId: String!, $variables: Json!, $importedRecords: Json!, $bulkCertificateRecordName: String!, $eventId: String, $ignoreUsingExpensiveCreditsError: Boolean) {
  createBulkDocumentCertificate(
    curriculumId: $curriculumId
    templateId: $templateId
    variables: $variables
    importedRecords: $importedRecords
    bulkCertificateRecordName: $bulkCertificateRecordName
    eventId: $eventId
    ignoreUsingExpensiveCreditsError: $ignoreUsingExpensiveCreditsError
  ) {
    id
    createdAt
    totalCertificates
  }
}
    `;

/**
 * __useCreateBulkDocumentCertificateMutation__
 *
 * To run a mutation, you first call `useCreateBulkDocumentCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBulkDocumentCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBulkDocumentCertificateMutation, { data, loading, error }] = useCreateBulkDocumentCertificateMutation({
 *   variables: {
 *      curriculumId: // value for 'curriculumId'
 *      templateId: // value for 'templateId'
 *      variables: // value for 'variables'
 *      importedRecords: // value for 'importedRecords'
 *      bulkCertificateRecordName: // value for 'bulkCertificateRecordName'
 *      eventId: // value for 'eventId'
 *      ignoreUsingExpensiveCreditsError: // value for 'ignoreUsingExpensiveCreditsError'
 *   },
 * });
 */
export function useCreateBulkDocumentCertificateMutation(baseOptions?: ApolloReact.useMutation.Options<CreateBulkDocumentCertificateMutation, CreateBulkDocumentCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CreateBulkDocumentCertificateMutation, CreateBulkDocumentCertificateMutationVariables>(CreateBulkDocumentCertificateDocument, options);
      }
export type CreateBulkDocumentCertificateMutationHookResult = ReturnType<typeof useCreateBulkDocumentCertificateMutation>;
export type CreateBulkDocumentCertificateMutationResult = ApolloReact.useMutation.Result<CreateBulkDocumentCertificateMutation>;
export const CreateOneDocumentAcademicDocumentationDocument = gql`
    mutation createOneDocumentAcademicDocumentation($draftId: String!) {
  createOneDocumentAcademicDocumentation(draftId: $draftId) {
    ...DocumentAcademicDocumentationFields
  }
}
    ${DocumentAcademicDocumentationFieldsFragmentDoc}`;

/**
 * __useCreateOneDocumentAcademicDocumentationMutation__
 *
 * To run a mutation, you first call `useCreateOneDocumentAcademicDocumentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneDocumentAcademicDocumentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneDocumentAcademicDocumentationMutation, { data, loading, error }] = useCreateOneDocumentAcademicDocumentationMutation({
 *   variables: {
 *      draftId: // value for 'draftId'
 *   },
 * });
 */
export function useCreateOneDocumentAcademicDocumentationMutation(baseOptions?: ApolloReact.useMutation.Options<CreateOneDocumentAcademicDocumentationMutation, CreateOneDocumentAcademicDocumentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CreateOneDocumentAcademicDocumentationMutation, CreateOneDocumentAcademicDocumentationMutationVariables>(CreateOneDocumentAcademicDocumentationDocument, options);
      }
export type CreateOneDocumentAcademicDocumentationMutationHookResult = ReturnType<typeof useCreateOneDocumentAcademicDocumentationMutation>;
export type CreateOneDocumentAcademicDocumentationMutationResult = ApolloReact.useMutation.Result<CreateOneDocumentAcademicDocumentationMutation>;
export const CreateOneDocumentAcademicDocumentationFromRevokedDocumentDocument = gql`
    mutation createOneDocumentAcademicDocumentationFromRevokedDocument($documentId: String!) {
  createOneDocumentAcademicDocumentationFromRevokedDocument(
    documentId: $documentId
  ) {
    id
    DocumentBase {
      id
      internalSeqId
      type
    }
  }
}
    `;

/**
 * __useCreateOneDocumentAcademicDocumentationFromRevokedDocumentMutation__
 *
 * To run a mutation, you first call `useCreateOneDocumentAcademicDocumentationFromRevokedDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneDocumentAcademicDocumentationFromRevokedDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneDocumentAcademicDocumentationFromRevokedDocumentMutation, { data, loading, error }] = useCreateOneDocumentAcademicDocumentationFromRevokedDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useCreateOneDocumentAcademicDocumentationFromRevokedDocumentMutation(baseOptions?: ApolloReact.useMutation.Options<CreateOneDocumentAcademicDocumentationFromRevokedDocumentMutation, CreateOneDocumentAcademicDocumentationFromRevokedDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CreateOneDocumentAcademicDocumentationFromRevokedDocumentMutation, CreateOneDocumentAcademicDocumentationFromRevokedDocumentMutationVariables>(CreateOneDocumentAcademicDocumentationFromRevokedDocumentDocument, options);
      }
export type CreateOneDocumentAcademicDocumentationFromRevokedDocumentMutationHookResult = ReturnType<typeof useCreateOneDocumentAcademicDocumentationFromRevokedDocumentMutation>;
export type CreateOneDocumentAcademicDocumentationFromRevokedDocumentMutationResult = ApolloReact.useMutation.Result<CreateOneDocumentAcademicDocumentationFromRevokedDocumentMutation>;
export const CreateOneCertificateCourseDocument = gql`
    mutation createOneCertificateCourse($areaKnowledge: String!, $metaData: [String!]!, $name: String!, $courseLevelId: String) {
  createOneCertificateCourse(
    areaKnowledge: $areaKnowledge
    metaData: $metaData
    name: $name
    courseLevelId: $courseLevelId
  ) {
    id
    certificateBaseId
    name
    areaKnowledge
    metaData
  }
}
    `;

/**
 * __useCreateOneCertificateCourseMutation__
 *
 * To run a mutation, you first call `useCreateOneCertificateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneCertificateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneCertificateCourseMutation, { data, loading, error }] = useCreateOneCertificateCourseMutation({
 *   variables: {
 *      areaKnowledge: // value for 'areaKnowledge'
 *      metaData: // value for 'metaData'
 *      name: // value for 'name'
 *      courseLevelId: // value for 'courseLevelId'
 *   },
 * });
 */
export function useCreateOneCertificateCourseMutation(baseOptions?: ApolloReact.useMutation.Options<CreateOneCertificateCourseMutation, CreateOneCertificateCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CreateOneCertificateCourseMutation, CreateOneCertificateCourseMutationVariables>(CreateOneCertificateCourseDocument, options);
      }
export type CreateOneCertificateCourseMutationHookResult = ReturnType<typeof useCreateOneCertificateCourseMutation>;
export type CreateOneCertificateCourseMutationResult = ApolloReact.useMutation.Result<CreateOneCertificateCourseMutation>;
export const CreateOneCertificateCourseLevelDocument = gql`
    mutation createOneCertificateCourseLevel($name: String!) {
  createOneCertificateCourseLevel(name: $name) {
    id
    certificateBaseId
    name
  }
}
    `;

/**
 * __useCreateOneCertificateCourseLevelMutation__
 *
 * To run a mutation, you first call `useCreateOneCertificateCourseLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneCertificateCourseLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneCertificateCourseLevelMutation, { data, loading, error }] = useCreateOneCertificateCourseLevelMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateOneCertificateCourseLevelMutation(baseOptions?: ApolloReact.useMutation.Options<CreateOneCertificateCourseLevelMutation, CreateOneCertificateCourseLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CreateOneCertificateCourseLevelMutation, CreateOneCertificateCourseLevelMutationVariables>(CreateOneCertificateCourseLevelDocument, options);
      }
export type CreateOneCertificateCourseLevelMutationHookResult = ReturnType<typeof useCreateOneCertificateCourseLevelMutation>;
export type CreateOneCertificateCourseLevelMutationResult = ApolloReact.useMutation.Result<CreateOneCertificateCourseLevelMutation>;
export const CreateOneCertificateCurriculumDocument = gql`
    mutation createOneCertificateCurriculum($amountOfHours: Int, $certificateCourseId: String!, $name: String!, $selectedDisciplines: [CirriculumSelectedDiscipline!]!) {
  createOneCertificateCurriculum(
    amountOfHours: $amountOfHours
    certificateCourseId: $certificateCourseId
    name: $name
    selectedDisciplines: $selectedDisciplines
  ) {
    id
    certificateBaseId
    name
    amountOfHours
  }
}
    `;

/**
 * __useCreateOneCertificateCurriculumMutation__
 *
 * To run a mutation, you first call `useCreateOneCertificateCurriculumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneCertificateCurriculumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneCertificateCurriculumMutation, { data, loading, error }] = useCreateOneCertificateCurriculumMutation({
 *   variables: {
 *      amountOfHours: // value for 'amountOfHours'
 *      certificateCourseId: // value for 'certificateCourseId'
 *      name: // value for 'name'
 *      selectedDisciplines: // value for 'selectedDisciplines'
 *   },
 * });
 */
export function useCreateOneCertificateCurriculumMutation(baseOptions?: ApolloReact.useMutation.Options<CreateOneCertificateCurriculumMutation, CreateOneCertificateCurriculumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CreateOneCertificateCurriculumMutation, CreateOneCertificateCurriculumMutationVariables>(CreateOneCertificateCurriculumDocument, options);
      }
export type CreateOneCertificateCurriculumMutationHookResult = ReturnType<typeof useCreateOneCertificateCurriculumMutation>;
export type CreateOneCertificateCurriculumMutationResult = ApolloReact.useMutation.Result<CreateOneCertificateCurriculumMutation>;
export const CreateOneCertificateDisciplineDocument = gql`
    mutation createOneCertificateDiscipline($name: String!, $viewOnDegree: Boolean!) {
  createOneCertificateDiscipline(name: $name, viewOnDegree: $viewOnDegree) {
    id
    certificateBaseId
    name
    viewOnDegree
  }
}
    `;

/**
 * __useCreateOneCertificateDisciplineMutation__
 *
 * To run a mutation, you first call `useCreateOneCertificateDisciplineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneCertificateDisciplineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneCertificateDisciplineMutation, { data, loading, error }] = useCreateOneCertificateDisciplineMutation({
 *   variables: {
 *      name: // value for 'name'
 *      viewOnDegree: // value for 'viewOnDegree'
 *   },
 * });
 */
export function useCreateOneCertificateDisciplineMutation(baseOptions?: ApolloReact.useMutation.Options<CreateOneCertificateDisciplineMutation, CreateOneCertificateDisciplineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CreateOneCertificateDisciplineMutation, CreateOneCertificateDisciplineMutationVariables>(CreateOneCertificateDisciplineDocument, options);
      }
export type CreateOneCertificateDisciplineMutationHookResult = ReturnType<typeof useCreateOneCertificateDisciplineMutation>;
export type CreateOneCertificateDisciplineMutationResult = ApolloReact.useMutation.Result<CreateOneCertificateDisciplineMutation>;
export const CreateOneCertificateEventDocument = gql`
    mutation createOneCertificateEvent($name: String!) {
  createOneCertificateEvent(name: $name) {
    id
    certificateBaseId
    name
  }
}
    `;

/**
 * __useCreateOneCertificateEventMutation__
 *
 * To run a mutation, you first call `useCreateOneCertificateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneCertificateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneCertificateEventMutation, { data, loading, error }] = useCreateOneCertificateEventMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateOneCertificateEventMutation(baseOptions?: ApolloReact.useMutation.Options<CreateOneCertificateEventMutation, CreateOneCertificateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CreateOneCertificateEventMutation, CreateOneCertificateEventMutationVariables>(CreateOneCertificateEventDocument, options);
      }
export type CreateOneCertificateEventMutationHookResult = ReturnType<typeof useCreateOneCertificateEventMutation>;
export type CreateOneCertificateEventMutationResult = ApolloReact.useMutation.Result<CreateOneCertificateEventMutation>;
export const CreateOneCertificateTeacherDocument = gql`
    mutation createOneCertificateTeacher($name: String!, $titration: String!) {
  createOneCertificateTeacher(name: $name, titration: $titration) {
    id
    certificateBaseId
    name
    titration
  }
}
    `;

/**
 * __useCreateOneCertificateTeacherMutation__
 *
 * To run a mutation, you first call `useCreateOneCertificateTeacherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneCertificateTeacherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneCertificateTeacherMutation, { data, loading, error }] = useCreateOneCertificateTeacherMutation({
 *   variables: {
 *      name: // value for 'name'
 *      titration: // value for 'titration'
 *   },
 * });
 */
export function useCreateOneCertificateTeacherMutation(baseOptions?: ApolloReact.useMutation.Options<CreateOneCertificateTeacherMutation, CreateOneCertificateTeacherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CreateOneCertificateTeacherMutation, CreateOneCertificateTeacherMutationVariables>(CreateOneCertificateTeacherDocument, options);
      }
export type CreateOneCertificateTeacherMutationHookResult = ReturnType<typeof useCreateOneCertificateTeacherMutation>;
export type CreateOneCertificateTeacherMutationResult = ApolloReact.useMutation.Result<CreateOneCertificateTeacherMutation>;
export const CreateOneCertificateTemplateDocument = gql`
    mutation createOneCertificateTemplate($name: String!, $description: String, $data: Json!) {
  createOneCertificateTemplate(
    name: $name
    description: $description
    data: $data
  ) {
    id
  }
}
    `;

/**
 * __useCreateOneCertificateTemplateMutation__
 *
 * To run a mutation, you first call `useCreateOneCertificateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneCertificateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneCertificateTemplateMutation, { data, loading, error }] = useCreateOneCertificateTemplateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneCertificateTemplateMutation(baseOptions?: ApolloReact.useMutation.Options<CreateOneCertificateTemplateMutation, CreateOneCertificateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CreateOneCertificateTemplateMutation, CreateOneCertificateTemplateMutationVariables>(CreateOneCertificateTemplateDocument, options);
      }
export type CreateOneCertificateTemplateMutationHookResult = ReturnType<typeof useCreateOneCertificateTemplateMutation>;
export type CreateOneCertificateTemplateMutationResult = ApolloReact.useMutation.Result<CreateOneCertificateTemplateMutation>;
export const CreateOneDegreeDocument = gql`
    mutation createOneDegree($degreeDocumentAcademicDocumentationId: String, $visualRepresentation: Upload, $xml: Upload!) {
  createOneDegree(
    degreeAcademicDocumentationId: $degreeDocumentAcademicDocumentationId
    visualRepresentation: $visualRepresentation
    xml: $xml
  ) {
    id
    documentBaseId
    DocumentBase {
      id
      filePath
    }
    searchCPF
    searchCourse
  }
}
    `;

/**
 * __useCreateOneDegreeMutation__
 *
 * To run a mutation, you first call `useCreateOneDegreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneDegreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneDegreeMutation, { data, loading, error }] = useCreateOneDegreeMutation({
 *   variables: {
 *      degreeDocumentAcademicDocumentationId: // value for 'degreeDocumentAcademicDocumentationId'
 *      visualRepresentation: // value for 'visualRepresentation'
 *      xml: // value for 'xml'
 *   },
 * });
 */
export function useCreateOneDegreeMutation(baseOptions?: ApolloReact.useMutation.Options<CreateOneDegreeMutation, CreateOneDegreeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CreateOneDegreeMutation, CreateOneDegreeMutationVariables>(CreateOneDegreeDocument, options);
      }
export type CreateOneDegreeMutationHookResult = ReturnType<typeof useCreateOneDegreeMutation>;
export type CreateOneDegreeMutationResult = ApolloReact.useMutation.Result<CreateOneDegreeMutation>;
export const CreateOneDegreeFromAcademicDocumentationDocument = gql`
    mutation createOneDegreeFromAcademicDocumentation($academicDocumentationId: String!) {
  createOneDegreeFromAcademicDocumentation(
    academicDocumentationId: $academicDocumentationId
  ) {
    ...DocumentDegreeUniqueFields
  }
}
    ${DocumentDegreeUniqueFieldsFragmentDoc}`;

/**
 * __useCreateOneDegreeFromAcademicDocumentationMutation__
 *
 * To run a mutation, you first call `useCreateOneDegreeFromAcademicDocumentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneDegreeFromAcademicDocumentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneDegreeFromAcademicDocumentationMutation, { data, loading, error }] = useCreateOneDegreeFromAcademicDocumentationMutation({
 *   variables: {
 *      academicDocumentationId: // value for 'academicDocumentationId'
 *   },
 * });
 */
export function useCreateOneDegreeFromAcademicDocumentationMutation(baseOptions?: ApolloReact.useMutation.Options<CreateOneDegreeFromAcademicDocumentationMutation, CreateOneDegreeFromAcademicDocumentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CreateOneDegreeFromAcademicDocumentationMutation, CreateOneDegreeFromAcademicDocumentationMutationVariables>(CreateOneDegreeFromAcademicDocumentationDocument, options);
      }
export type CreateOneDegreeFromAcademicDocumentationMutationHookResult = ReturnType<typeof useCreateOneDegreeFromAcademicDocumentationMutation>;
export type CreateOneDegreeFromAcademicDocumentationMutationResult = ApolloReact.useMutation.Result<CreateOneDegreeFromAcademicDocumentationMutation>;
export const CreateOneDocumentAuditFileIssuerDocument = gql`
    mutation createOneDocumentAuditFileIssuer($degreeCount: Int!, $endDate: Date!, $startDate: Date!, $version: String!, $excludeRevoked: Boolean!) {
  createOneDocumentAuditFileIssuer(
    degreeCount: $degreeCount
    endDate: $endDate
    startDate: $startDate
    version: $version
    excludeRevoked: $excludeRevoked
  ) {
    id
    documentBaseId
  }
}
    `;

/**
 * __useCreateOneDocumentAuditFileIssuerMutation__
 *
 * To run a mutation, you first call `useCreateOneDocumentAuditFileIssuerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneDocumentAuditFileIssuerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneDocumentAuditFileIssuerMutation, { data, loading, error }] = useCreateOneDocumentAuditFileIssuerMutation({
 *   variables: {
 *      degreeCount: // value for 'degreeCount'
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      version: // value for 'version'
 *      excludeRevoked: // value for 'excludeRevoked'
 *   },
 * });
 */
export function useCreateOneDocumentAuditFileIssuerMutation(baseOptions?: ApolloReact.useMutation.Options<CreateOneDocumentAuditFileIssuerMutation, CreateOneDocumentAuditFileIssuerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CreateOneDocumentAuditFileIssuerMutation, CreateOneDocumentAuditFileIssuerMutationVariables>(CreateOneDocumentAuditFileIssuerDocument, options);
      }
export type CreateOneDocumentAuditFileIssuerMutationHookResult = ReturnType<typeof useCreateOneDocumentAuditFileIssuerMutation>;
export type CreateOneDocumentAuditFileIssuerMutationResult = ApolloReact.useMutation.Result<CreateOneDocumentAuditFileIssuerMutation>;
export const CreateOneDocumentCertificateDocument = gql`
    mutation createOneDocumentCertificate($curriculumId: String, $studentCpf: String!, $studentName: String!, $studentEmail: String!, $templateId: String!, $variables: Json!, $curriculumDisciplinesVariables: [CurriculumDisciplineVariable!]!, $eventId: String, $ignoreUsingExpensiveCreditsError: Boolean, $personId: String) {
  createOneDocumentCertificate(
    curriculumId: $curriculumId
    studentCPF: $studentCpf
    studentName: $studentName
    studentEmail: $studentEmail
    templateId: $templateId
    variables: $variables
    curriculumDisciplinesVariables: $curriculumDisciplinesVariables
    eventId: $eventId
    ignoreUsingExpensiveCreditsError: $ignoreUsingExpensiveCreditsError
    personId: $personId
  ) {
    id
    documentBaseId
    DocumentCertificateSignatureItems {
      id
      PossibleSigners {
        id
        TeamMember {
          id
          commonUserId
        }
      }
      type
    }
  }
}
    `;

/**
 * __useCreateOneDocumentCertificateMutation__
 *
 * To run a mutation, you first call `useCreateOneDocumentCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneDocumentCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneDocumentCertificateMutation, { data, loading, error }] = useCreateOneDocumentCertificateMutation({
 *   variables: {
 *      curriculumId: // value for 'curriculumId'
 *      studentCpf: // value for 'studentCpf'
 *      studentName: // value for 'studentName'
 *      studentEmail: // value for 'studentEmail'
 *      templateId: // value for 'templateId'
 *      variables: // value for 'variables'
 *      curriculumDisciplinesVariables: // value for 'curriculumDisciplinesVariables'
 *      eventId: // value for 'eventId'
 *      ignoreUsingExpensiveCreditsError: // value for 'ignoreUsingExpensiveCreditsError'
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useCreateOneDocumentCertificateMutation(baseOptions?: ApolloReact.useMutation.Options<CreateOneDocumentCertificateMutation, CreateOneDocumentCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CreateOneDocumentCertificateMutation, CreateOneDocumentCertificateMutationVariables>(CreateOneDocumentCertificateDocument, options);
      }
export type CreateOneDocumentCertificateMutationHookResult = ReturnType<typeof useCreateOneDocumentCertificateMutation>;
export type CreateOneDocumentCertificateMutationResult = ApolloReact.useMutation.Result<CreateOneDocumentCertificateMutation>;
export const CreateOneDocumentCertificatePreviewDocument = gql`
    mutation createOneDocumentCertificatePreview($curriculumId: String, $studentCpf: String!, $studentName: String!, $studentEmail: String!, $templateId: String!, $variables: Json!, $curriculumDisciplinesVariables: [CurriculumDisciplineVariable!]!, $eventId: String, $degreeId: String) {
  createOneDocumentCertificatePreview(
    curriculumId: $curriculumId
    studentCPF: $studentCpf
    studentName: $studentName
    studentEmail: $studentEmail
    templateId: $templateId
    variables: $variables
    curriculumDisciplinesVariables: $curriculumDisciplinesVariables
    eventId: $eventId
    degreeId: $degreeId
  )
}
    `;

/**
 * __useCreateOneDocumentCertificatePreviewMutation__
 *
 * To run a mutation, you first call `useCreateOneDocumentCertificatePreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneDocumentCertificatePreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneDocumentCertificatePreviewMutation, { data, loading, error }] = useCreateOneDocumentCertificatePreviewMutation({
 *   variables: {
 *      curriculumId: // value for 'curriculumId'
 *      studentCpf: // value for 'studentCpf'
 *      studentName: // value for 'studentName'
 *      studentEmail: // value for 'studentEmail'
 *      templateId: // value for 'templateId'
 *      variables: // value for 'variables'
 *      curriculumDisciplinesVariables: // value for 'curriculumDisciplinesVariables'
 *      eventId: // value for 'eventId'
 *      degreeId: // value for 'degreeId'
 *   },
 * });
 */
export function useCreateOneDocumentCertificatePreviewMutation(baseOptions?: ApolloReact.useMutation.Options<CreateOneDocumentCertificatePreviewMutation, CreateOneDocumentCertificatePreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CreateOneDocumentCertificatePreviewMutation, CreateOneDocumentCertificatePreviewMutationVariables>(CreateOneDocumentCertificatePreviewDocument, options);
      }
export type CreateOneDocumentCertificatePreviewMutationHookResult = ReturnType<typeof useCreateOneDocumentCertificatePreviewMutation>;
export type CreateOneDocumentCertificatePreviewMutationResult = ApolloReact.useMutation.Result<CreateOneDocumentCertificatePreviewMutation>;
export const CreateOneDocumentSchoolCurriculumDocument = gql`
    mutation CreateOneDocumentSchoolCurriculum($createOneDocumentSchoolCurriculumId: String!) {
  createOneDocumentSchoolCurriculum(id: $createOneDocumentSchoolCurriculumId) {
    ...DocumentSchoolCurriculumFields
  }
}
    ${DocumentSchoolCurriculumFieldsFragmentDoc}`;

/**
 * __useCreateOneDocumentSchoolCurriculumMutation__
 *
 * To run a mutation, you first call `useCreateOneDocumentSchoolCurriculumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneDocumentSchoolCurriculumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneDocumentSchoolCurriculumMutation, { data, loading, error }] = useCreateOneDocumentSchoolCurriculumMutation({
 *   variables: {
 *      createOneDocumentSchoolCurriculumId: // value for 'createOneDocumentSchoolCurriculumId'
 *   },
 * });
 */
export function useCreateOneDocumentSchoolCurriculumMutation(baseOptions?: ApolloReact.useMutation.Options<CreateOneDocumentSchoolCurriculumMutation, CreateOneDocumentSchoolCurriculumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CreateOneDocumentSchoolCurriculumMutation, CreateOneDocumentSchoolCurriculumMutationVariables>(CreateOneDocumentSchoolCurriculumDocument, options);
      }
export type CreateOneDocumentSchoolCurriculumMutationHookResult = ReturnType<typeof useCreateOneDocumentSchoolCurriculumMutation>;
export type CreateOneDocumentSchoolCurriculumMutationResult = ApolloReact.useMutation.Result<CreateOneDocumentSchoolCurriculumMutation>;
export const CreateOneEnabledInstitutionDocument = gql`
    mutation createOneEnabledInstitution($data: CreateOneEnabledInstitutionInput!) {
  createOneEnabledInstitution(data: $data) {
    id
    email
    cnpj
    educationLevelType
    isMaintainer
  }
}
    `;

/**
 * __useCreateOneEnabledInstitutionMutation__
 *
 * To run a mutation, you first call `useCreateOneEnabledInstitutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneEnabledInstitutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneEnabledInstitutionMutation, { data, loading, error }] = useCreateOneEnabledInstitutionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneEnabledInstitutionMutation(baseOptions?: ApolloReact.useMutation.Options<CreateOneEnabledInstitutionMutation, CreateOneEnabledInstitutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CreateOneEnabledInstitutionMutation, CreateOneEnabledInstitutionMutationVariables>(CreateOneEnabledInstitutionDocument, options);
      }
export type CreateOneEnabledInstitutionMutationHookResult = ReturnType<typeof useCreateOneEnabledInstitutionMutation>;
export type CreateOneEnabledInstitutionMutationResult = ApolloReact.useMutation.Result<CreateOneEnabledInstitutionMutation>;
export const CreateOneDocumentFinalAcademicTranscriptDocument = gql`
    mutation createOneDocumentFinalAcademicTranscript($baseAcademicId: String!) {
  createOneDocumentFinalAcademicTranscript(baseAcademicId: $baseAcademicId) {
    id
    DocumentBase {
      id
      internalSeqId
      version
    }
  }
}
    `;

/**
 * __useCreateOneDocumentFinalAcademicTranscriptMutation__
 *
 * To run a mutation, you first call `useCreateOneDocumentFinalAcademicTranscriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneDocumentFinalAcademicTranscriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneDocumentFinalAcademicTranscriptMutation, { data, loading, error }] = useCreateOneDocumentFinalAcademicTranscriptMutation({
 *   variables: {
 *      baseAcademicId: // value for 'baseAcademicId'
 *   },
 * });
 */
export function useCreateOneDocumentFinalAcademicTranscriptMutation(baseOptions?: ApolloReact.useMutation.Options<CreateOneDocumentFinalAcademicTranscriptMutation, CreateOneDocumentFinalAcademicTranscriptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CreateOneDocumentFinalAcademicTranscriptMutation, CreateOneDocumentFinalAcademicTranscriptMutationVariables>(CreateOneDocumentFinalAcademicTranscriptDocument, options);
      }
export type CreateOneDocumentFinalAcademicTranscriptMutationHookResult = ReturnType<typeof useCreateOneDocumentFinalAcademicTranscriptMutation>;
export type CreateOneDocumentFinalAcademicTranscriptMutationResult = ApolloReact.useMutation.Result<CreateOneDocumentFinalAcademicTranscriptMutation>;
export const CreateOneFinancialRechargeDocument = gql`
    mutation createOneFinancialRecharge($data: CreateOneFinancialRechargeInput!) {
  createOneFinancialRecharge(data: $data) {
    id
  }
}
    `;

/**
 * __useCreateOneFinancialRechargeMutation__
 *
 * To run a mutation, you first call `useCreateOneFinancialRechargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneFinancialRechargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneFinancialRechargeMutation, { data, loading, error }] = useCreateOneFinancialRechargeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneFinancialRechargeMutation(baseOptions?: ApolloReact.useMutation.Options<CreateOneFinancialRechargeMutation, CreateOneFinancialRechargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CreateOneFinancialRechargeMutation, CreateOneFinancialRechargeMutationVariables>(CreateOneFinancialRechargeDocument, options);
      }
export type CreateOneFinancialRechargeMutationHookResult = ReturnType<typeof useCreateOneFinancialRechargeMutation>;
export type CreateOneFinancialRechargeMutationResult = ApolloReact.useMutation.Result<CreateOneFinancialRechargeMutation>;
export const CreateOneMaintainerAdminDocument = gql`
    mutation createOneMaintainerAdmin($email: String!) {
  createOneMaintainerAdmin(email: $email) {
    id
    maintainerId
  }
}
    `;

/**
 * __useCreateOneMaintainerAdminMutation__
 *
 * To run a mutation, you first call `useCreateOneMaintainerAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneMaintainerAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneMaintainerAdminMutation, { data, loading, error }] = useCreateOneMaintainerAdminMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCreateOneMaintainerAdminMutation(baseOptions?: ApolloReact.useMutation.Options<CreateOneMaintainerAdminMutation, CreateOneMaintainerAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CreateOneMaintainerAdminMutation, CreateOneMaintainerAdminMutationVariables>(CreateOneMaintainerAdminDocument, options);
      }
export type CreateOneMaintainerAdminMutationHookResult = ReturnType<typeof useCreateOneMaintainerAdminMutation>;
export type CreateOneMaintainerAdminMutationResult = ApolloReact.useMutation.Result<CreateOneMaintainerAdminMutation>;
export const CreateOnePersonDocument = gql`
    mutation CreateOnePerson($isForeign: Boolean!, $name: String!, $receivesCertificateEmail: Boolean!, $receivesCertificateWhatsapp: Boolean!, $phones: [String!]!, $cpf: String, $passport: String, $email: String, $identityDocument: String, $birthDate: String, $address: AddressInput) {
  createOnePerson(
    isForeign: $isForeign
    name: $name
    receivesCertificateEmail: $receivesCertificateEmail
    receivesCertificateWhatsapp: $receivesCertificateWhatsapp
    phones: $phones
    cpf: $cpf
    passport: $passport
    email: $email
    identityDocument: $identityDocument
    birthDate: $birthDate
    address: $address
  ) {
    id
    name
    createdAt
  }
}
    `;

/**
 * __useCreateOnePersonMutation__
 *
 * To run a mutation, you first call `useCreateOnePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOnePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOnePersonMutation, { data, loading, error }] = useCreateOnePersonMutation({
 *   variables: {
 *      isForeign: // value for 'isForeign'
 *      name: // value for 'name'
 *      receivesCertificateEmail: // value for 'receivesCertificateEmail'
 *      receivesCertificateWhatsapp: // value for 'receivesCertificateWhatsapp'
 *      phones: // value for 'phones'
 *      cpf: // value for 'cpf'
 *      passport: // value for 'passport'
 *      email: // value for 'email'
 *      identityDocument: // value for 'identityDocument'
 *      birthDate: // value for 'birthDate'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useCreateOnePersonMutation(baseOptions?: ApolloReact.useMutation.Options<CreateOnePersonMutation, CreateOnePersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CreateOnePersonMutation, CreateOnePersonMutationVariables>(CreateOnePersonDocument, options);
      }
export type CreateOnePersonMutationHookResult = ReturnType<typeof useCreateOnePersonMutation>;
export type CreateOnePersonMutationResult = ApolloReact.useMutation.Result<CreateOnePersonMutation>;
export const CreateOneReusableFormDataCurriculumDocument = gql`
    mutation createOneReusableFormDataCurriculum($data: ReusableFormDataCurriculumCreateInputCustom!) {
  createOneReusableFormDataCurriculum(data: $data) {
    id
  }
}
    `;

/**
 * __useCreateOneReusableFormDataCurriculumMutation__
 *
 * To run a mutation, you first call `useCreateOneReusableFormDataCurriculumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneReusableFormDataCurriculumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneReusableFormDataCurriculumMutation, { data, loading, error }] = useCreateOneReusableFormDataCurriculumMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneReusableFormDataCurriculumMutation(baseOptions?: ApolloReact.useMutation.Options<CreateOneReusableFormDataCurriculumMutation, CreateOneReusableFormDataCurriculumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CreateOneReusableFormDataCurriculumMutation, CreateOneReusableFormDataCurriculumMutationVariables>(CreateOneReusableFormDataCurriculumDocument, options);
      }
export type CreateOneReusableFormDataCurriculumMutationHookResult = ReturnType<typeof useCreateOneReusableFormDataCurriculumMutation>;
export type CreateOneReusableFormDataCurriculumMutationResult = ApolloReact.useMutation.Result<CreateOneReusableFormDataCurriculumMutation>;
export const CreateOneSignSignatureImageDocument = gql`
    mutation createOneSignSignatureImage($data: CreateOneSignSignatureImageData!) {
  createOneSignSignatureImage(data: $data) {
    id
  }
}
    `;

/**
 * __useCreateOneSignSignatureImageMutation__
 *
 * To run a mutation, you first call `useCreateOneSignSignatureImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneSignSignatureImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneSignSignatureImageMutation, { data, loading, error }] = useCreateOneSignSignatureImageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneSignSignatureImageMutation(baseOptions?: ApolloReact.useMutation.Options<CreateOneSignSignatureImageMutation, CreateOneSignSignatureImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CreateOneSignSignatureImageMutation, CreateOneSignSignatureImageMutationVariables>(CreateOneSignSignatureImageDocument, options);
      }
export type CreateOneSignSignatureImageMutationHookResult = ReturnType<typeof useCreateOneSignSignatureImageMutation>;
export type CreateOneSignSignatureImageMutationResult = ApolloReact.useMutation.Result<CreateOneSignSignatureImageMutation>;
export const CreateOneSystemGlobalAlertDocument = gql`
    mutation createOneSystemGlobalAlert($data: SystemGlobalAlertCreateInput!) {
  createOneSystemGlobalAlert(data: $data) {
    id
  }
}
    `;

/**
 * __useCreateOneSystemGlobalAlertMutation__
 *
 * To run a mutation, you first call `useCreateOneSystemGlobalAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneSystemGlobalAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneSystemGlobalAlertMutation, { data, loading, error }] = useCreateOneSystemGlobalAlertMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneSystemGlobalAlertMutation(baseOptions?: ApolloReact.useMutation.Options<CreateOneSystemGlobalAlertMutation, CreateOneSystemGlobalAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CreateOneSystemGlobalAlertMutation, CreateOneSystemGlobalAlertMutationVariables>(CreateOneSystemGlobalAlertDocument, options);
      }
export type CreateOneSystemGlobalAlertMutationHookResult = ReturnType<typeof useCreateOneSystemGlobalAlertMutation>;
export type CreateOneSystemGlobalAlertMutationResult = ApolloReact.useMutation.Result<CreateOneSystemGlobalAlertMutation>;
export const CreateOneTeamContractDocument = gql`
    mutation createOneTeamContract($data: TeamContractCreateInput!) {
  createOneTeamContract(data: $data) {
    id
    contractUrl
    isActive
    startOfContract
    endOfContract
    createdAt
    teamId
    observations
    storageInGb
  }
}
    `;

/**
 * __useCreateOneTeamContractMutation__
 *
 * To run a mutation, you first call `useCreateOneTeamContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneTeamContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneTeamContractMutation, { data, loading, error }] = useCreateOneTeamContractMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOneTeamContractMutation(baseOptions?: ApolloReact.useMutation.Options<CreateOneTeamContractMutation, CreateOneTeamContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CreateOneTeamContractMutation, CreateOneTeamContractMutationVariables>(CreateOneTeamContractDocument, options);
      }
export type CreateOneTeamContractMutationHookResult = ReturnType<typeof useCreateOneTeamContractMutation>;
export type CreateOneTeamContractMutationResult = ApolloReact.useMutation.Result<CreateOneTeamContractMutation>;
export const DefineOneSignSignatureImageAsPrimaryDocument = gql`
    mutation defineOneSignSignatureImageAsPrimary($where: SignSignatureImageWhereUniqueInput!) {
  defineOneSignSignatureImageAsPrimary(where: $where) {
    id
  }
}
    `;

/**
 * __useDefineOneSignSignatureImageAsPrimaryMutation__
 *
 * To run a mutation, you first call `useDefineOneSignSignatureImageAsPrimaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDefineOneSignSignatureImageAsPrimaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [defineOneSignSignatureImageAsPrimaryMutation, { data, loading, error }] = useDefineOneSignSignatureImageAsPrimaryMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDefineOneSignSignatureImageAsPrimaryMutation(baseOptions?: ApolloReact.useMutation.Options<DefineOneSignSignatureImageAsPrimaryMutation, DefineOneSignSignatureImageAsPrimaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<DefineOneSignSignatureImageAsPrimaryMutation, DefineOneSignSignatureImageAsPrimaryMutationVariables>(DefineOneSignSignatureImageAsPrimaryDocument, options);
      }
export type DefineOneSignSignatureImageAsPrimaryMutationHookResult = ReturnType<typeof useDefineOneSignSignatureImageAsPrimaryMutation>;
export type DefineOneSignSignatureImageAsPrimaryMutationResult = ApolloReact.useMutation.Result<DefineOneSignSignatureImageAsPrimaryMutation>;
export const DefineSignersDocument = gql`
    mutation defineSigners($data: InviteGroups!, $addSignersNode: Boolean, $saveDefault: Boolean) {
  defineSigners(
    data: $data
    addSignersNode: $addSignersNode
    saveDefault: $saveDefault
  ) {
    id
  }
}
    `;

/**
 * __useDefineSignersMutation__
 *
 * To run a mutation, you first call `useDefineSignersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDefineSignersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [defineSignersMutation, { data, loading, error }] = useDefineSignersMutation({
 *   variables: {
 *      data: // value for 'data'
 *      addSignersNode: // value for 'addSignersNode'
 *      saveDefault: // value for 'saveDefault'
 *   },
 * });
 */
export function useDefineSignersMutation(baseOptions?: ApolloReact.useMutation.Options<DefineSignersMutation, DefineSignersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<DefineSignersMutation, DefineSignersMutationVariables>(DefineSignersDocument, options);
      }
export type DefineSignersMutationHookResult = ReturnType<typeof useDefineSignersMutation>;
export type DefineSignersMutationResult = ApolloReact.useMutation.Result<DefineSignersMutation>;
export const DeleteOneApiKeyDocument = gql`
    mutation deleteOneApiKey($apiKeyId: Int!) {
  deleteOneApiKey(apiKeyId: $apiKeyId) {
    id
  }
}
    `;

/**
 * __useDeleteOneApiKeyMutation__
 *
 * To run a mutation, you first call `useDeleteOneApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneApiKeyMutation, { data, loading, error }] = useDeleteOneApiKeyMutation({
 *   variables: {
 *      apiKeyId: // value for 'apiKeyId'
 *   },
 * });
 */
export function useDeleteOneApiKeyMutation(baseOptions?: ApolloReact.useMutation.Options<DeleteOneApiKeyMutation, DeleteOneApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<DeleteOneApiKeyMutation, DeleteOneApiKeyMutationVariables>(DeleteOneApiKeyDocument, options);
      }
export type DeleteOneApiKeyMutationHookResult = ReturnType<typeof useDeleteOneApiKeyMutation>;
export type DeleteOneApiKeyMutationResult = ApolloReact.useMutation.Result<DeleteOneApiKeyMutation>;
export const DeleteOneCertificateBaseDocument = gql`
    mutation deleteOneCertificateBase($certificateId: String!) {
  deleteOneCertificateBase(certificateId: $certificateId) {
    id
  }
}
    `;

/**
 * __useDeleteOneCertificateBaseMutation__
 *
 * To run a mutation, you first call `useDeleteOneCertificateBaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneCertificateBaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneCertificateBaseMutation, { data, loading, error }] = useDeleteOneCertificateBaseMutation({
 *   variables: {
 *      certificateId: // value for 'certificateId'
 *   },
 * });
 */
export function useDeleteOneCertificateBaseMutation(baseOptions?: ApolloReact.useMutation.Options<DeleteOneCertificateBaseMutation, DeleteOneCertificateBaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<DeleteOneCertificateBaseMutation, DeleteOneCertificateBaseMutationVariables>(DeleteOneCertificateBaseDocument, options);
      }
export type DeleteOneCertificateBaseMutationHookResult = ReturnType<typeof useDeleteOneCertificateBaseMutation>;
export type DeleteOneCertificateBaseMutationResult = ApolloReact.useMutation.Result<DeleteOneCertificateBaseMutation>;
export const DeleteOneCertificateTemplateDocument = gql`
    mutation deleteOneCertificateTemplate($where: CertificateTemplateWhereUniqueInput!) {
  deleteOneCertificateTemplate(where: $where) {
    id
  }
}
    `;

/**
 * __useDeleteOneCertificateTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteOneCertificateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneCertificateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneCertificateTemplateMutation, { data, loading, error }] = useDeleteOneCertificateTemplateMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteOneCertificateTemplateMutation(baseOptions?: ApolloReact.useMutation.Options<DeleteOneCertificateTemplateMutation, DeleteOneCertificateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<DeleteOneCertificateTemplateMutation, DeleteOneCertificateTemplateMutationVariables>(DeleteOneCertificateTemplateDocument, options);
      }
export type DeleteOneCertificateTemplateMutationHookResult = ReturnType<typeof useDeleteOneCertificateTemplateMutation>;
export type DeleteOneCertificateTemplateMutationResult = ApolloReact.useMutation.Result<DeleteOneCertificateTemplateMutation>;
export const DeleteOneDegreeVisualRepresentationDocument = gql`
    mutation deleteOneDegreeVisualRepresentation($degreeId: String!) {
  deleteOneDegreeVisualRepresentation(degreeId: $degreeId) {
    id
    documentBaseId
    visualRepresentationPath
  }
}
    `;

/**
 * __useDeleteOneDegreeVisualRepresentationMutation__
 *
 * To run a mutation, you first call `useDeleteOneDegreeVisualRepresentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneDegreeVisualRepresentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneDegreeVisualRepresentationMutation, { data, loading, error }] = useDeleteOneDegreeVisualRepresentationMutation({
 *   variables: {
 *      degreeId: // value for 'degreeId'
 *   },
 * });
 */
export function useDeleteOneDegreeVisualRepresentationMutation(baseOptions?: ApolloReact.useMutation.Options<DeleteOneDegreeVisualRepresentationMutation, DeleteOneDegreeVisualRepresentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<DeleteOneDegreeVisualRepresentationMutation, DeleteOneDegreeVisualRepresentationMutationVariables>(DeleteOneDegreeVisualRepresentationDocument, options);
      }
export type DeleteOneDegreeVisualRepresentationMutationHookResult = ReturnType<typeof useDeleteOneDegreeVisualRepresentationMutation>;
export type DeleteOneDegreeVisualRepresentationMutationResult = ApolloReact.useMutation.Result<DeleteOneDegreeVisualRepresentationMutation>;
export const DeleteOneDocumentBaseDocument = gql`
    mutation deleteOneDocumentBase($deleteOneDocumentBaseId: String!) {
  deleteOneDocumentBase(id: $deleteOneDocumentBaseId) {
    id
    internalSeqId
    type
  }
}
    `;

/**
 * __useDeleteOneDocumentBaseMutation__
 *
 * To run a mutation, you first call `useDeleteOneDocumentBaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneDocumentBaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneDocumentBaseMutation, { data, loading, error }] = useDeleteOneDocumentBaseMutation({
 *   variables: {
 *      deleteOneDocumentBaseId: // value for 'deleteOneDocumentBaseId'
 *   },
 * });
 */
export function useDeleteOneDocumentBaseMutation(baseOptions?: ApolloReact.useMutation.Options<DeleteOneDocumentBaseMutation, DeleteOneDocumentBaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<DeleteOneDocumentBaseMutation, DeleteOneDocumentBaseMutationVariables>(DeleteOneDocumentBaseDocument, options);
      }
export type DeleteOneDocumentBaseMutationHookResult = ReturnType<typeof useDeleteOneDocumentBaseMutation>;
export type DeleteOneDocumentBaseMutationResult = ApolloReact.useMutation.Result<DeleteOneDocumentBaseMutation>;
export const DeleteOneDocumentBaseDefaultSignatureInviteConfigurationDocument = gql`
    mutation deleteOneDocumentBaseDefaultSignatureInviteConfiguration($id: Int!) {
  deleteOneDocumentBaseDefaultSignatureInviteConfiguration(id: $id) {
    id
  }
}
    `;

/**
 * __useDeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutation__
 *
 * To run a mutation, you first call `useDeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneDocumentBaseDefaultSignatureInviteConfigurationMutation, { data, loading, error }] = useDeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutation(baseOptions?: ApolloReact.useMutation.Options<DeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutation, DeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<DeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutation, DeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutationVariables>(DeleteOneDocumentBaseDefaultSignatureInviteConfigurationDocument, options);
      }
export type DeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutationHookResult = ReturnType<typeof useDeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutation>;
export type DeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutationResult = ApolloReact.useMutation.Result<DeleteOneDocumentBaseDefaultSignatureInviteConfigurationMutation>;
export const DeleteOneFinancialCreditCardSavedDocument = gql`
    mutation deleteOneFinancialCreditCardSaved($where: FinancialCreditCardSavedWhereUniqueInput!) {
  deleteOneFinancialCreditCardSaved(where: $where) {
    id
  }
}
    `;

/**
 * __useDeleteOneFinancialCreditCardSavedMutation__
 *
 * To run a mutation, you first call `useDeleteOneFinancialCreditCardSavedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneFinancialCreditCardSavedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneFinancialCreditCardSavedMutation, { data, loading, error }] = useDeleteOneFinancialCreditCardSavedMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteOneFinancialCreditCardSavedMutation(baseOptions?: ApolloReact.useMutation.Options<DeleteOneFinancialCreditCardSavedMutation, DeleteOneFinancialCreditCardSavedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<DeleteOneFinancialCreditCardSavedMutation, DeleteOneFinancialCreditCardSavedMutationVariables>(DeleteOneFinancialCreditCardSavedDocument, options);
      }
export type DeleteOneFinancialCreditCardSavedMutationHookResult = ReturnType<typeof useDeleteOneFinancialCreditCardSavedMutation>;
export type DeleteOneFinancialCreditCardSavedMutationResult = ApolloReact.useMutation.Result<DeleteOneFinancialCreditCardSavedMutation>;
export const DeleteOneMaintainerAdminDocument = gql`
    mutation deleteOneMaintainerAdmin($where: MaintainerAdminWhereUniqueInput!) {
  deleteOneMaintainerAdmin(where: $where) {
    id
    commonUserId
  }
}
    `;

/**
 * __useDeleteOneMaintainerAdminMutation__
 *
 * To run a mutation, you first call `useDeleteOneMaintainerAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneMaintainerAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneMaintainerAdminMutation, { data, loading, error }] = useDeleteOneMaintainerAdminMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteOneMaintainerAdminMutation(baseOptions?: ApolloReact.useMutation.Options<DeleteOneMaintainerAdminMutation, DeleteOneMaintainerAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<DeleteOneMaintainerAdminMutation, DeleteOneMaintainerAdminMutationVariables>(DeleteOneMaintainerAdminDocument, options);
      }
export type DeleteOneMaintainerAdminMutationHookResult = ReturnType<typeof useDeleteOneMaintainerAdminMutation>;
export type DeleteOneMaintainerAdminMutationResult = ApolloReact.useMutation.Result<DeleteOneMaintainerAdminMutation>;
export const DeleteOneMaintainerTeamDocument = gql`
    mutation deleteOneMaintainerTeam($where: TeamWhereUniqueInput!) {
  deleteOneMaintainerTeam(where: $where) {
    id
  }
}
    `;

/**
 * __useDeleteOneMaintainerTeamMutation__
 *
 * To run a mutation, you first call `useDeleteOneMaintainerTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneMaintainerTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneMaintainerTeamMutation, { data, loading, error }] = useDeleteOneMaintainerTeamMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteOneMaintainerTeamMutation(baseOptions?: ApolloReact.useMutation.Options<DeleteOneMaintainerTeamMutation, DeleteOneMaintainerTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<DeleteOneMaintainerTeamMutation, DeleteOneMaintainerTeamMutationVariables>(DeleteOneMaintainerTeamDocument, options);
      }
export type DeleteOneMaintainerTeamMutationHookResult = ReturnType<typeof useDeleteOneMaintainerTeamMutation>;
export type DeleteOneMaintainerTeamMutationResult = ApolloReact.useMutation.Result<DeleteOneMaintainerTeamMutation>;
export const DeleteOneReusableFormDataDocument = gql`
    mutation deleteOneReusableFormData($where: ReusableFormDataWhereUniqueInput!) {
  deleteOneReusableFormData(where: $where) {
    id
  }
}
    `;

/**
 * __useDeleteOneReusableFormDataMutation__
 *
 * To run a mutation, you first call `useDeleteOneReusableFormDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneReusableFormDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneReusableFormDataMutation, { data, loading, error }] = useDeleteOneReusableFormDataMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteOneReusableFormDataMutation(baseOptions?: ApolloReact.useMutation.Options<DeleteOneReusableFormDataMutation, DeleteOneReusableFormDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<DeleteOneReusableFormDataMutation, DeleteOneReusableFormDataMutationVariables>(DeleteOneReusableFormDataDocument, options);
      }
export type DeleteOneReusableFormDataMutationHookResult = ReturnType<typeof useDeleteOneReusableFormDataMutation>;
export type DeleteOneReusableFormDataMutationResult = ApolloReact.useMutation.Result<DeleteOneReusableFormDataMutation>;
export const DeleteOnePersonDocument = gql`
    mutation deleteOnePerson($id: String!) {
  deleteOnePerson(id: $id) {
    id
  }
}
    `;

/**
 * __useDeleteOnePersonMutation__
 *
 * To run a mutation, you first call `useDeleteOnePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOnePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOnePersonMutation, { data, loading, error }] = useDeleteOnePersonMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOnePersonMutation(baseOptions?: ApolloReact.useMutation.Options<DeleteOnePersonMutation, DeleteOnePersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<DeleteOnePersonMutation, DeleteOnePersonMutationVariables>(DeleteOnePersonDocument, options);
      }
export type DeleteOnePersonMutationHookResult = ReturnType<typeof useDeleteOnePersonMutation>;
export type DeleteOnePersonMutationResult = ApolloReact.useMutation.Result<DeleteOnePersonMutation>;
export const DeleteOneReusableFormDataCurriculumDocument = gql`
    mutation deleteOneReusableFormDataCurriculum($deleteOneReusableFormDataCurriculumId: Int!) {
  deleteOneReusableFormDataCurriculum(id: $deleteOneReusableFormDataCurriculumId) {
    id
  }
}
    `;

/**
 * __useDeleteOneReusableFormDataCurriculumMutation__
 *
 * To run a mutation, you first call `useDeleteOneReusableFormDataCurriculumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneReusableFormDataCurriculumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneReusableFormDataCurriculumMutation, { data, loading, error }] = useDeleteOneReusableFormDataCurriculumMutation({
 *   variables: {
 *      deleteOneReusableFormDataCurriculumId: // value for 'deleteOneReusableFormDataCurriculumId'
 *   },
 * });
 */
export function useDeleteOneReusableFormDataCurriculumMutation(baseOptions?: ApolloReact.useMutation.Options<DeleteOneReusableFormDataCurriculumMutation, DeleteOneReusableFormDataCurriculumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<DeleteOneReusableFormDataCurriculumMutation, DeleteOneReusableFormDataCurriculumMutationVariables>(DeleteOneReusableFormDataCurriculumDocument, options);
      }
export type DeleteOneReusableFormDataCurriculumMutationHookResult = ReturnType<typeof useDeleteOneReusableFormDataCurriculumMutation>;
export type DeleteOneReusableFormDataCurriculumMutationResult = ApolloReact.useMutation.Result<DeleteOneReusableFormDataCurriculumMutation>;
export const DeleteOneSignSignatureImageDocument = gql`
    mutation deleteOneSignSignatureImage($where: SignSignatureImageWhereUniqueInput!) {
  deleteOneSignSignatureImage(where: $where) {
    id
  }
}
    `;

/**
 * __useDeleteOneSignSignatureImageMutation__
 *
 * To run a mutation, you first call `useDeleteOneSignSignatureImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneSignSignatureImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneSignSignatureImageMutation, { data, loading, error }] = useDeleteOneSignSignatureImageMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteOneSignSignatureImageMutation(baseOptions?: ApolloReact.useMutation.Options<DeleteOneSignSignatureImageMutation, DeleteOneSignSignatureImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<DeleteOneSignSignatureImageMutation, DeleteOneSignSignatureImageMutationVariables>(DeleteOneSignSignatureImageDocument, options);
      }
export type DeleteOneSignSignatureImageMutationHookResult = ReturnType<typeof useDeleteOneSignSignatureImageMutation>;
export type DeleteOneSignSignatureImageMutationResult = ApolloReact.useMutation.Result<DeleteOneSignSignatureImageMutation>;
export const DeleteOneSystemGlobalAlertDocument = gql`
    mutation deleteOneSystemGlobalAlert($where: SystemGlobalAlertWhereUniqueInput!) {
  deleteOneSystemGlobalAlert(where: $where) {
    id
  }
}
    `;

/**
 * __useDeleteOneSystemGlobalAlertMutation__
 *
 * To run a mutation, you first call `useDeleteOneSystemGlobalAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneSystemGlobalAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneSystemGlobalAlertMutation, { data, loading, error }] = useDeleteOneSystemGlobalAlertMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteOneSystemGlobalAlertMutation(baseOptions?: ApolloReact.useMutation.Options<DeleteOneSystemGlobalAlertMutation, DeleteOneSystemGlobalAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<DeleteOneSystemGlobalAlertMutation, DeleteOneSystemGlobalAlertMutationVariables>(DeleteOneSystemGlobalAlertDocument, options);
      }
export type DeleteOneSystemGlobalAlertMutationHookResult = ReturnType<typeof useDeleteOneSystemGlobalAlertMutation>;
export type DeleteOneSystemGlobalAlertMutationResult = ApolloReact.useMutation.Result<DeleteOneSystemGlobalAlertMutation>;
export const DeleteOneTeamContractDocument = gql`
    mutation deleteOneTeamContract($where: TeamContractWhereUniqueInput!) {
  deleteOneTeamContract(where: $where) {
    id
  }
}
    `;

/**
 * __useDeleteOneTeamContractMutation__
 *
 * To run a mutation, you first call `useDeleteOneTeamContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneTeamContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneTeamContractMutation, { data, loading, error }] = useDeleteOneTeamContractMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteOneTeamContractMutation(baseOptions?: ApolloReact.useMutation.Options<DeleteOneTeamContractMutation, DeleteOneTeamContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<DeleteOneTeamContractMutation, DeleteOneTeamContractMutationVariables>(DeleteOneTeamContractDocument, options);
      }
export type DeleteOneTeamContractMutationHookResult = ReturnType<typeof useDeleteOneTeamContractMutation>;
export type DeleteOneTeamContractMutationResult = ApolloReact.useMutation.Result<DeleteOneTeamContractMutation>;
export const DeleteOneTeamDocumentTypeSpecificSignaturePolicyConfigDocument = gql`
    mutation deleteOneTeamDocumentTypeSpecificSignaturePolicyConfig($id: Int!) {
  deleteOneTeamDocumentTypeSpecificSignaturePolicyConfig(id: $id) {
    id
  }
}
    `;

/**
 * __useDeleteOneTeamDocumentTypeSpecificSignaturePolicyConfigMutation__
 *
 * To run a mutation, you first call `useDeleteOneTeamDocumentTypeSpecificSignaturePolicyConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneTeamDocumentTypeSpecificSignaturePolicyConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneTeamDocumentTypeSpecificSignaturePolicyConfigMutation, { data, loading, error }] = useDeleteOneTeamDocumentTypeSpecificSignaturePolicyConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOneTeamDocumentTypeSpecificSignaturePolicyConfigMutation(baseOptions?: ApolloReact.useMutation.Options<DeleteOneTeamDocumentTypeSpecificSignaturePolicyConfigMutation, DeleteOneTeamDocumentTypeSpecificSignaturePolicyConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<DeleteOneTeamDocumentTypeSpecificSignaturePolicyConfigMutation, DeleteOneTeamDocumentTypeSpecificSignaturePolicyConfigMutationVariables>(DeleteOneTeamDocumentTypeSpecificSignaturePolicyConfigDocument, options);
      }
export type DeleteOneTeamDocumentTypeSpecificSignaturePolicyConfigMutationHookResult = ReturnType<typeof useDeleteOneTeamDocumentTypeSpecificSignaturePolicyConfigMutation>;
export type DeleteOneTeamDocumentTypeSpecificSignaturePolicyConfigMutationResult = ApolloReact.useMutation.Result<DeleteOneTeamDocumentTypeSpecificSignaturePolicyConfigMutation>;
export const DeleteOneTeamMemberDocument = gql`
    mutation deleteOneTeamMember($where: TeamMemberWhereUniqueInput!) {
  deleteOneTeamMember(where: $where) {
    id
  }
}
    `;

/**
 * __useDeleteOneTeamMemberMutation__
 *
 * To run a mutation, you first call `useDeleteOneTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOneTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOneTeamMemberMutation, { data, loading, error }] = useDeleteOneTeamMemberMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteOneTeamMemberMutation(baseOptions?: ApolloReact.useMutation.Options<DeleteOneTeamMemberMutation, DeleteOneTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<DeleteOneTeamMemberMutation, DeleteOneTeamMemberMutationVariables>(DeleteOneTeamMemberDocument, options);
      }
export type DeleteOneTeamMemberMutationHookResult = ReturnType<typeof useDeleteOneTeamMemberMutation>;
export type DeleteOneTeamMemberMutationResult = ApolloReact.useMutation.Result<DeleteOneTeamMemberMutation>;
export const DismissSystemGlobalAlertDocument = gql`
    mutation dismissSystemGlobalAlert($dismissSystemGlobalAlertId: Int!) {
  dismissSystemGlobalAlert(id: $dismissSystemGlobalAlertId)
}
    `;

/**
 * __useDismissSystemGlobalAlertMutation__
 *
 * To run a mutation, you first call `useDismissSystemGlobalAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissSystemGlobalAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissSystemGlobalAlertMutation, { data, loading, error }] = useDismissSystemGlobalAlertMutation({
 *   variables: {
 *      dismissSystemGlobalAlertId: // value for 'dismissSystemGlobalAlertId'
 *   },
 * });
 */
export function useDismissSystemGlobalAlertMutation(baseOptions?: ApolloReact.useMutation.Options<DismissSystemGlobalAlertMutation, DismissSystemGlobalAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<DismissSystemGlobalAlertMutation, DismissSystemGlobalAlertMutationVariables>(DismissSystemGlobalAlertDocument, options);
      }
export type DismissSystemGlobalAlertMutationHookResult = ReturnType<typeof useDismissSystemGlobalAlertMutation>;
export type DismissSystemGlobalAlertMutationResult = ApolloReact.useMutation.Result<DismissSystemGlobalAlertMutation>;
export const DuplicateOneCertificateTemplateDocument = gql`
    mutation duplicateOneCertificateTemplate($templateId: String!) {
  duplicateOneCertificateTemplate(templateId: $templateId) {
    id
  }
}
    `;

/**
 * __useDuplicateOneCertificateTemplateMutation__
 *
 * To run a mutation, you first call `useDuplicateOneCertificateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateOneCertificateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateOneCertificateTemplateMutation, { data, loading, error }] = useDuplicateOneCertificateTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useDuplicateOneCertificateTemplateMutation(baseOptions?: ApolloReact.useMutation.Options<DuplicateOneCertificateTemplateMutation, DuplicateOneCertificateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<DuplicateOneCertificateTemplateMutation, DuplicateOneCertificateTemplateMutationVariables>(DuplicateOneCertificateTemplateDocument, options);
      }
export type DuplicateOneCertificateTemplateMutationHookResult = ReturnType<typeof useDuplicateOneCertificateTemplateMutation>;
export type DuplicateOneCertificateTemplateMutationResult = ApolloReact.useMutation.Result<DuplicateOneCertificateTemplateMutation>;
export const FinalizeOneCertificateSignatureDocument = gql`
    mutation finalizeOneCertificateSignature($certificate: String!, $initialize: InitializeResponseInput!, $inviteId: String!, $signatureImageId: String) {
  finalizeOneCertificateSignature(
    certificate: $certificate
    initialize: $initialize
    inviteId: $inviteId
    signatureImageId: $signatureImageId
  ) {
    id
  }
}
    `;

/**
 * __useFinalizeOneCertificateSignatureMutation__
 *
 * To run a mutation, you first call `useFinalizeOneCertificateSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeOneCertificateSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeOneCertificateSignatureMutation, { data, loading, error }] = useFinalizeOneCertificateSignatureMutation({
 *   variables: {
 *      certificate: // value for 'certificate'
 *      initialize: // value for 'initialize'
 *      inviteId: // value for 'inviteId'
 *      signatureImageId: // value for 'signatureImageId'
 *   },
 * });
 */
export function useFinalizeOneCertificateSignatureMutation(baseOptions?: ApolloReact.useMutation.Options<FinalizeOneCertificateSignatureMutation, FinalizeOneCertificateSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<FinalizeOneCertificateSignatureMutation, FinalizeOneCertificateSignatureMutationVariables>(FinalizeOneCertificateSignatureDocument, options);
      }
export type FinalizeOneCertificateSignatureMutationHookResult = ReturnType<typeof useFinalizeOneCertificateSignatureMutation>;
export type FinalizeOneCertificateSignatureMutationResult = ApolloReact.useMutation.Result<FinalizeOneCertificateSignatureMutation>;
export const FinalizeOneSignatureDocument = gql`
    mutation finalizeOneSignature($certificate: String!, $initialize: InitializeResponseInput!, $inviteId: Int!) {
  finalizeOneSignature(
    certificate: $certificate
    initialize: $initialize
    inviteId: $inviteId
  ) {
    id
  }
}
    `;

/**
 * __useFinalizeOneSignatureMutation__
 *
 * To run a mutation, you first call `useFinalizeOneSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeOneSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeOneSignatureMutation, { data, loading, error }] = useFinalizeOneSignatureMutation({
 *   variables: {
 *      certificate: // value for 'certificate'
 *      initialize: // value for 'initialize'
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useFinalizeOneSignatureMutation(baseOptions?: ApolloReact.useMutation.Options<FinalizeOneSignatureMutation, FinalizeOneSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<FinalizeOneSignatureMutation, FinalizeOneSignatureMutationVariables>(FinalizeOneSignatureDocument, options);
      }
export type FinalizeOneSignatureMutationHookResult = ReturnType<typeof useFinalizeOneSignatureMutation>;
export type FinalizeOneSignatureMutationResult = ApolloReact.useMutation.Result<FinalizeOneSignatureMutation>;
export const FinalizeOneSignatureExternalSignatureInviteDocument = gql`
    mutation finalizeOneSignatureExternalSignatureInvite($certificate: String!, $initialize: InitializeResponseInput!, $inviteId: String!) {
  finalizeOneSignature: finalizeOneSignatureExternalSignatureInvite(
    certificate: $certificate
    initialize: $initialize
    inviteId: $inviteId
  ) {
    id
  }
}
    `;

/**
 * __useFinalizeOneSignatureExternalSignatureInviteMutation__
 *
 * To run a mutation, you first call `useFinalizeOneSignatureExternalSignatureInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeOneSignatureExternalSignatureInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeOneSignatureExternalSignatureInviteMutation, { data, loading, error }] = useFinalizeOneSignatureExternalSignatureInviteMutation({
 *   variables: {
 *      certificate: // value for 'certificate'
 *      initialize: // value for 'initialize'
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useFinalizeOneSignatureExternalSignatureInviteMutation(baseOptions?: ApolloReact.useMutation.Options<FinalizeOneSignatureExternalSignatureInviteMutation, FinalizeOneSignatureExternalSignatureInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<FinalizeOneSignatureExternalSignatureInviteMutation, FinalizeOneSignatureExternalSignatureInviteMutationVariables>(FinalizeOneSignatureExternalSignatureInviteDocument, options);
      }
export type FinalizeOneSignatureExternalSignatureInviteMutationHookResult = ReturnType<typeof useFinalizeOneSignatureExternalSignatureInviteMutation>;
export type FinalizeOneSignatureExternalSignatureInviteMutationResult = ApolloReact.useMutation.Result<FinalizeOneSignatureExternalSignatureInviteMutation>;
export const FinancialTeamWalletActivateTrialDocument = gql`
    mutation financialTeamWalletActivateTrial {
  financialTeamWalletActivateTrial {
    id
    teamId
    creditsPlanTrial
    SubscriptionActive {
      id
      plan
    }
  }
}
    `;

/**
 * __useFinancialTeamWalletActivateTrialMutation__
 *
 * To run a mutation, you first call `useFinancialTeamWalletActivateTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinancialTeamWalletActivateTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [financialTeamWalletActivateTrialMutation, { data, loading, error }] = useFinancialTeamWalletActivateTrialMutation({
 *   variables: {
 *   },
 * });
 */
export function useFinancialTeamWalletActivateTrialMutation(baseOptions?: ApolloReact.useMutation.Options<FinancialTeamWalletActivateTrialMutation, FinancialTeamWalletActivateTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<FinancialTeamWalletActivateTrialMutation, FinancialTeamWalletActivateTrialMutationVariables>(FinancialTeamWalletActivateTrialDocument, options);
      }
export type FinancialTeamWalletActivateTrialMutationHookResult = ReturnType<typeof useFinancialTeamWalletActivateTrialMutation>;
export type FinancialTeamWalletActivateTrialMutationResult = ApolloReact.useMutation.Result<FinancialTeamWalletActivateTrialMutation>;
export const FinancialTeamWalletPurchasePlanDocument = gql`
    mutation financialTeamWalletPurchasePlan($data: FinancialTeamWalletPurchasePlanInput!) {
  financialTeamWalletPurchasePlan(data: $data) {
    id
    Wallet {
      id
      teamId
    }
    isFirstPlan
  }
}
    `;

/**
 * __useFinancialTeamWalletPurchasePlanMutation__
 *
 * To run a mutation, you first call `useFinancialTeamWalletPurchasePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinancialTeamWalletPurchasePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [financialTeamWalletPurchasePlanMutation, { data, loading, error }] = useFinancialTeamWalletPurchasePlanMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useFinancialTeamWalletPurchasePlanMutation(baseOptions?: ApolloReact.useMutation.Options<FinancialTeamWalletPurchasePlanMutation, FinancialTeamWalletPurchasePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<FinancialTeamWalletPurchasePlanMutation, FinancialTeamWalletPurchasePlanMutationVariables>(FinancialTeamWalletPurchasePlanDocument, options);
      }
export type FinancialTeamWalletPurchasePlanMutationHookResult = ReturnType<typeof useFinancialTeamWalletPurchasePlanMutation>;
export type FinancialTeamWalletPurchasePlanMutationResult = ApolloReact.useMutation.Result<FinancialTeamWalletPurchasePlanMutation>;
export const FinancialTeamWalletSubscriptionCancelPlanDocument = gql`
    mutation financialTeamWalletSubscriptionCancelPlan {
  financialTeamWalletSubscriptionCancelPlan {
    id
  }
}
    `;

/**
 * __useFinancialTeamWalletSubscriptionCancelPlanMutation__
 *
 * To run a mutation, you first call `useFinancialTeamWalletSubscriptionCancelPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinancialTeamWalletSubscriptionCancelPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [financialTeamWalletSubscriptionCancelPlanMutation, { data, loading, error }] = useFinancialTeamWalletSubscriptionCancelPlanMutation({
 *   variables: {
 *   },
 * });
 */
export function useFinancialTeamWalletSubscriptionCancelPlanMutation(baseOptions?: ApolloReact.useMutation.Options<FinancialTeamWalletSubscriptionCancelPlanMutation, FinancialTeamWalletSubscriptionCancelPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<FinancialTeamWalletSubscriptionCancelPlanMutation, FinancialTeamWalletSubscriptionCancelPlanMutationVariables>(FinancialTeamWalletSubscriptionCancelPlanDocument, options);
      }
export type FinancialTeamWalletSubscriptionCancelPlanMutationHookResult = ReturnType<typeof useFinancialTeamWalletSubscriptionCancelPlanMutation>;
export type FinancialTeamWalletSubscriptionCancelPlanMutationResult = ApolloReact.useMutation.Result<FinancialTeamWalletSubscriptionCancelPlanMutation>;
export const FindManySignSignatureImageDocument = gql`
    query findManySignSignatureImage($where: SignSignatureImageWhereInput, $take: Int, $skip: Int, $orderBy: [SignSignatureImageOrderByWithRelationInput!]) {
  findManySignSignatureImage(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    ...SignSignatureImageFields
  }
  countSignSignatureImage(where: $where)
}
    ${SignSignatureImageFieldsFragmentDoc}`;

/**
 * __useFindManySignSignatureImageQuery__
 *
 * To run a query within a React component, call `useFindManySignSignatureImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManySignSignatureImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManySignSignatureImageQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManySignSignatureImageQuery(baseOptions?: ApolloReact.useQuery.Options<FindManySignSignatureImageQuery, FindManySignSignatureImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManySignSignatureImageQuery, FindManySignSignatureImageQueryVariables>(FindManySignSignatureImageDocument, options);
      }
export function useFindManySignSignatureImageLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManySignSignatureImageQuery, FindManySignSignatureImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManySignSignatureImageQuery, FindManySignSignatureImageQueryVariables>(FindManySignSignatureImageDocument, options);
        }
export function useFindManySignSignatureImageSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManySignSignatureImageQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManySignSignatureImageQuery, FindManySignSignatureImageQueryVariables>(FindManySignSignatureImageDocument, options);
        }
export type FindManySignSignatureImageQueryHookResult = ReturnType<typeof useFindManySignSignatureImageQuery>;
export type FindManySignSignatureImageLazyQueryHookResult = ReturnType<typeof useFindManySignSignatureImageLazyQuery>;
export type FindManySignSignatureImageSuspenseQueryHookResult = ReturnType<typeof useFindManySignSignatureImageSuspenseQuery>;
export type FindManySignSignatureImageQueryResult = ApolloReact.useQuery.Result<FindManySignSignatureImageQuery, FindManySignSignatureImageQueryVariables>;
export const ForceDocumentRenotarizationDocument = gql`
    mutation forceDocumentRenotarization($documentId: String!) {
  forceDocumentRenotarization(documentId: $documentId)
}
    `;

/**
 * __useForceDocumentRenotarizationMutation__
 *
 * To run a mutation, you first call `useForceDocumentRenotarizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceDocumentRenotarizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceDocumentRenotarizationMutation, { data, loading, error }] = useForceDocumentRenotarizationMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useForceDocumentRenotarizationMutation(baseOptions?: ApolloReact.useMutation.Options<ForceDocumentRenotarizationMutation, ForceDocumentRenotarizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<ForceDocumentRenotarizationMutation, ForceDocumentRenotarizationMutationVariables>(ForceDocumentRenotarizationDocument, options);
      }
export type ForceDocumentRenotarizationMutationHookResult = ReturnType<typeof useForceDocumentRenotarizationMutation>;
export type ForceDocumentRenotarizationMutationResult = ApolloReact.useMutation.Result<ForceDocumentRenotarizationMutation>;
export const ForceDocumentRenotarizationWindowDocument = gql`
    mutation forceDocumentRenotarizationWindow($documentId: String!) {
  forceDocumentRenotarizationWindow(documentId: $documentId)
}
    `;

/**
 * __useForceDocumentRenotarizationWindowMutation__
 *
 * To run a mutation, you first call `useForceDocumentRenotarizationWindowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceDocumentRenotarizationWindowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceDocumentRenotarizationWindowMutation, { data, loading, error }] = useForceDocumentRenotarizationWindowMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useForceDocumentRenotarizationWindowMutation(baseOptions?: ApolloReact.useMutation.Options<ForceDocumentRenotarizationWindowMutation, ForceDocumentRenotarizationWindowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<ForceDocumentRenotarizationWindowMutation, ForceDocumentRenotarizationWindowMutationVariables>(ForceDocumentRenotarizationWindowDocument, options);
      }
export type ForceDocumentRenotarizationWindowMutationHookResult = ReturnType<typeof useForceDocumentRenotarizationWindowMutation>;
export type ForceDocumentRenotarizationWindowMutationResult = ApolloReact.useMutation.Result<ForceDocumentRenotarizationWindowMutation>;
export const ForceSignDegreeDocument = gql`
    mutation forceSignDegree($degreeId: String!) {
  forceSignDegree(degreeId: $degreeId) {
    id
    documentBaseId
  }
}
    `;

/**
 * __useForceSignDegreeMutation__
 *
 * To run a mutation, you first call `useForceSignDegreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceSignDegreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceSignDegreeMutation, { data, loading, error }] = useForceSignDegreeMutation({
 *   variables: {
 *      degreeId: // value for 'degreeId'
 *   },
 * });
 */
export function useForceSignDegreeMutation(baseOptions?: ApolloReact.useMutation.Options<ForceSignDegreeMutation, ForceSignDegreeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<ForceSignDegreeMutation, ForceSignDegreeMutationVariables>(ForceSignDegreeDocument, options);
      }
export type ForceSignDegreeMutationHookResult = ReturnType<typeof useForceSignDegreeMutation>;
export type ForceSignDegreeMutationResult = ApolloReact.useMutation.Result<ForceSignDegreeMutation>;
export const PatchOneDocumentAcademicDocumentationDocument = gql`
    mutation patchOneDocumentAcademicDocumentation($changes: [DocumentChange!]!, $patchOneDocumentAcademicDocumentationId: String!) {
  patchOneDocumentAcademicDocumentation(
    changes: $changes
    id: $patchOneDocumentAcademicDocumentationId
  )
}
    `;

/**
 * __usePatchOneDocumentAcademicDocumentationMutation__
 *
 * To run a mutation, you first call `usePatchOneDocumentAcademicDocumentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchOneDocumentAcademicDocumentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchOneDocumentAcademicDocumentationMutation, { data, loading, error }] = usePatchOneDocumentAcademicDocumentationMutation({
 *   variables: {
 *      changes: // value for 'changes'
 *      patchOneDocumentAcademicDocumentationId: // value for 'patchOneDocumentAcademicDocumentationId'
 *   },
 * });
 */
export function usePatchOneDocumentAcademicDocumentationMutation(baseOptions?: ApolloReact.useMutation.Options<PatchOneDocumentAcademicDocumentationMutation, PatchOneDocumentAcademicDocumentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<PatchOneDocumentAcademicDocumentationMutation, PatchOneDocumentAcademicDocumentationMutationVariables>(PatchOneDocumentAcademicDocumentationDocument, options);
      }
export type PatchOneDocumentAcademicDocumentationMutationHookResult = ReturnType<typeof usePatchOneDocumentAcademicDocumentationMutation>;
export type PatchOneDocumentAcademicDocumentationMutationResult = ApolloReact.useMutation.Result<PatchOneDocumentAcademicDocumentationMutation>;
export const PatchOneDegreeDocument = gql`
    mutation patchOneDegree($changes: [DocumentChange!]!, $patchOneDegreeId: String!) {
  patchOneDegree(changes: $changes, id: $patchOneDegreeId)
}
    `;

/**
 * __usePatchOneDegreeMutation__
 *
 * To run a mutation, you first call `usePatchOneDegreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchOneDegreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchOneDegreeMutation, { data, loading, error }] = usePatchOneDegreeMutation({
 *   variables: {
 *      changes: // value for 'changes'
 *      patchOneDegreeId: // value for 'patchOneDegreeId'
 *   },
 * });
 */
export function usePatchOneDegreeMutation(baseOptions?: ApolloReact.useMutation.Options<PatchOneDegreeMutation, PatchOneDegreeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<PatchOneDegreeMutation, PatchOneDegreeMutationVariables>(PatchOneDegreeDocument, options);
      }
export type PatchOneDegreeMutationHookResult = ReturnType<typeof usePatchOneDegreeMutation>;
export type PatchOneDegreeMutationResult = ApolloReact.useMutation.Result<PatchOneDegreeMutation>;
export const PatchOneDocumentSchoolCurriculumDocument = gql`
    mutation patchOneDocumentSchoolCurriculum($changes: [DocumentChange!]!, $patchOneDocumentSchoolCurriculumId: String!) {
  patchOneDocumentSchoolCurriculum(
    changes: $changes
    id: $patchOneDocumentSchoolCurriculumId
  )
}
    `;

/**
 * __usePatchOneDocumentSchoolCurriculumMutation__
 *
 * To run a mutation, you first call `usePatchOneDocumentSchoolCurriculumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchOneDocumentSchoolCurriculumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchOneDocumentSchoolCurriculumMutation, { data, loading, error }] = usePatchOneDocumentSchoolCurriculumMutation({
 *   variables: {
 *      changes: // value for 'changes'
 *      patchOneDocumentSchoolCurriculumId: // value for 'patchOneDocumentSchoolCurriculumId'
 *   },
 * });
 */
export function usePatchOneDocumentSchoolCurriculumMutation(baseOptions?: ApolloReact.useMutation.Options<PatchOneDocumentSchoolCurriculumMutation, PatchOneDocumentSchoolCurriculumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<PatchOneDocumentSchoolCurriculumMutation, PatchOneDocumentSchoolCurriculumMutationVariables>(PatchOneDocumentSchoolCurriculumDocument, options);
      }
export type PatchOneDocumentSchoolCurriculumMutationHookResult = ReturnType<typeof usePatchOneDocumentSchoolCurriculumMutation>;
export type PatchOneDocumentSchoolCurriculumMutationResult = ApolloReact.useMutation.Result<PatchOneDocumentSchoolCurriculumMutation>;
export const PayOverduePaymentsDocument = gql`
    mutation payOverduePayments($data: PlanPayOverduePaymentsInput!) {
  payOverduePayments(data: $data) {
    id
  }
}
    `;

/**
 * __usePayOverduePaymentsMutation__
 *
 * To run a mutation, you first call `usePayOverduePaymentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayOverduePaymentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payOverduePaymentsMutation, { data, loading, error }] = usePayOverduePaymentsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePayOverduePaymentsMutation(baseOptions?: ApolloReact.useMutation.Options<PayOverduePaymentsMutation, PayOverduePaymentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<PayOverduePaymentsMutation, PayOverduePaymentsMutationVariables>(PayOverduePaymentsDocument, options);
      }
export type PayOverduePaymentsMutationHookResult = ReturnType<typeof usePayOverduePaymentsMutation>;
export type PayOverduePaymentsMutationResult = ApolloReact.useMutation.Result<PayOverduePaymentsMutation>;
export const RenotarizeDocumentDocument = gql`
    mutation RenotarizeDocument($documentId: String!, $signatureId: String) {
  renotarizeDocument(documentId: $documentId, signatureId: $signatureId) {
    id
    internalSeqId
    fileSize
  }
}
    `;

/**
 * __useRenotarizeDocumentMutation__
 *
 * To run a mutation, you first call `useRenotarizeDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenotarizeDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renotarizeDocumentMutation, { data, loading, error }] = useRenotarizeDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      signatureId: // value for 'signatureId'
 *   },
 * });
 */
export function useRenotarizeDocumentMutation(baseOptions?: ApolloReact.useMutation.Options<RenotarizeDocumentMutation, RenotarizeDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<RenotarizeDocumentMutation, RenotarizeDocumentMutationVariables>(RenotarizeDocumentDocument, options);
      }
export type RenotarizeDocumentMutationHookResult = ReturnType<typeof useRenotarizeDocumentMutation>;
export type RenotarizeDocumentMutationResult = ApolloReact.useMutation.Result<RenotarizeDocumentMutation>;
export const ReplaceOneDegreeVisualRepresentationDocument = gql`
    mutation replaceOneDegreeVisualRepresentation($degreeId: String!, $visualRepresentation: Upload!) {
  replaceOneDegreeVisualRepresentation(
    degreeId: $degreeId
    visualRepresentation: $visualRepresentation
  ) {
    id
    documentBaseId
    visualRepresentationPath
  }
}
    `;

/**
 * __useReplaceOneDegreeVisualRepresentationMutation__
 *
 * To run a mutation, you first call `useReplaceOneDegreeVisualRepresentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceOneDegreeVisualRepresentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceOneDegreeVisualRepresentationMutation, { data, loading, error }] = useReplaceOneDegreeVisualRepresentationMutation({
 *   variables: {
 *      degreeId: // value for 'degreeId'
 *      visualRepresentation: // value for 'visualRepresentation'
 *   },
 * });
 */
export function useReplaceOneDegreeVisualRepresentationMutation(baseOptions?: ApolloReact.useMutation.Options<ReplaceOneDegreeVisualRepresentationMutation, ReplaceOneDegreeVisualRepresentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<ReplaceOneDegreeVisualRepresentationMutation, ReplaceOneDegreeVisualRepresentationMutationVariables>(ReplaceOneDegreeVisualRepresentationDocument, options);
      }
export type ReplaceOneDegreeVisualRepresentationMutationHookResult = ReturnType<typeof useReplaceOneDegreeVisualRepresentationMutation>;
export type ReplaceOneDegreeVisualRepresentationMutationResult = ApolloReact.useMutation.Result<ReplaceOneDegreeVisualRepresentationMutation>;
export const ResendOneTeamMemberEmailDocument = gql`
    mutation resendOneTeamMemberEmail($memberId: Int!) {
  resendOneTeamMemberEmail(memberId: $memberId) {
    id
  }
}
    `;

/**
 * __useResendOneTeamMemberEmailMutation__
 *
 * To run a mutation, you first call `useResendOneTeamMemberEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendOneTeamMemberEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendOneTeamMemberEmailMutation, { data, loading, error }] = useResendOneTeamMemberEmailMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useResendOneTeamMemberEmailMutation(baseOptions?: ApolloReact.useMutation.Options<ResendOneTeamMemberEmailMutation, ResendOneTeamMemberEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<ResendOneTeamMemberEmailMutation, ResendOneTeamMemberEmailMutationVariables>(ResendOneTeamMemberEmailDocument, options);
      }
export type ResendOneTeamMemberEmailMutationHookResult = ReturnType<typeof useResendOneTeamMemberEmailMutation>;
export type ResendOneTeamMemberEmailMutationResult = ApolloReact.useMutation.Result<ResendOneTeamMemberEmailMutation>;
export const RevalidateOneDocumentAcademicDocumentationDocument = gql`
    mutation revalidateOneDocumentAcademicDocumentation($documentId: String!) {
  revalidateOneDocumentAcademicDocumentation(documentId: $documentId) {
    id
    documentBaseId
  }
}
    `;

/**
 * __useRevalidateOneDocumentAcademicDocumentationMutation__
 *
 * To run a mutation, you first call `useRevalidateOneDocumentAcademicDocumentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevalidateOneDocumentAcademicDocumentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revalidateOneDocumentAcademicDocumentationMutation, { data, loading, error }] = useRevalidateOneDocumentAcademicDocumentationMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useRevalidateOneDocumentAcademicDocumentationMutation(baseOptions?: ApolloReact.useMutation.Options<RevalidateOneDocumentAcademicDocumentationMutation, RevalidateOneDocumentAcademicDocumentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<RevalidateOneDocumentAcademicDocumentationMutation, RevalidateOneDocumentAcademicDocumentationMutationVariables>(RevalidateOneDocumentAcademicDocumentationDocument, options);
      }
export type RevalidateOneDocumentAcademicDocumentationMutationHookResult = ReturnType<typeof useRevalidateOneDocumentAcademicDocumentationMutation>;
export type RevalidateOneDocumentAcademicDocumentationMutationResult = ApolloReact.useMutation.Result<RevalidateOneDocumentAcademicDocumentationMutation>;
export const RevalidateOneDegreeDocument = gql`
    mutation revalidateOneDegree($degreeId: String!) {
  revalidateOneDegree(degreeId: $degreeId) {
    id
    documentBaseId
  }
}
    `;

/**
 * __useRevalidateOneDegreeMutation__
 *
 * To run a mutation, you first call `useRevalidateOneDegreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevalidateOneDegreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revalidateOneDegreeMutation, { data, loading, error }] = useRevalidateOneDegreeMutation({
 *   variables: {
 *      degreeId: // value for 'degreeId'
 *   },
 * });
 */
export function useRevalidateOneDegreeMutation(baseOptions?: ApolloReact.useMutation.Options<RevalidateOneDegreeMutation, RevalidateOneDegreeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<RevalidateOneDegreeMutation, RevalidateOneDegreeMutationVariables>(RevalidateOneDegreeDocument, options);
      }
export type RevalidateOneDegreeMutationHookResult = ReturnType<typeof useRevalidateOneDegreeMutation>;
export type RevalidateOneDegreeMutationResult = ApolloReact.useMutation.Result<RevalidateOneDegreeMutation>;
export const ReviewOneDocumentAcademicDocumentationDocument = gql`
    mutation reviewOneDocumentAcademicDocumentation($academicDocumentationId: String!, $reproveReason: String) {
  reviewOneDocumentAcademicDocumentation(
    academicDocumentationId: $academicDocumentationId
    reproveReason: $reproveReason
  ) {
    id
    documentBaseId
    status
  }
}
    `;

/**
 * __useReviewOneDocumentAcademicDocumentationMutation__
 *
 * To run a mutation, you first call `useReviewOneDocumentAcademicDocumentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewOneDocumentAcademicDocumentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewOneDocumentAcademicDocumentationMutation, { data, loading, error }] = useReviewOneDocumentAcademicDocumentationMutation({
 *   variables: {
 *      academicDocumentationId: // value for 'academicDocumentationId'
 *      reproveReason: // value for 'reproveReason'
 *   },
 * });
 */
export function useReviewOneDocumentAcademicDocumentationMutation(baseOptions?: ApolloReact.useMutation.Options<ReviewOneDocumentAcademicDocumentationMutation, ReviewOneDocumentAcademicDocumentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<ReviewOneDocumentAcademicDocumentationMutation, ReviewOneDocumentAcademicDocumentationMutationVariables>(ReviewOneDocumentAcademicDocumentationDocument, options);
      }
export type ReviewOneDocumentAcademicDocumentationMutationHookResult = ReturnType<typeof useReviewOneDocumentAcademicDocumentationMutation>;
export type ReviewOneDocumentAcademicDocumentationMutationResult = ApolloReact.useMutation.Result<ReviewOneDocumentAcademicDocumentationMutation>;
export const ReviewOneDegreeDocument = gql`
    mutation reviewOneDegree($degreeId: String!, $reproveReason: String) {
  reviewOneDegree(degreeId: $degreeId, reproveReason: $reproveReason) {
    ...DocumentDegreeUniqueFields
  }
}
    ${DocumentDegreeUniqueFieldsFragmentDoc}`;

/**
 * __useReviewOneDegreeMutation__
 *
 * To run a mutation, you first call `useReviewOneDegreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewOneDegreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewOneDegreeMutation, { data, loading, error }] = useReviewOneDegreeMutation({
 *   variables: {
 *      degreeId: // value for 'degreeId'
 *      reproveReason: // value for 'reproveReason'
 *   },
 * });
 */
export function useReviewOneDegreeMutation(baseOptions?: ApolloReact.useMutation.Options<ReviewOneDegreeMutation, ReviewOneDegreeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<ReviewOneDegreeMutation, ReviewOneDegreeMutationVariables>(ReviewOneDegreeDocument, options);
      }
export type ReviewOneDegreeMutationHookResult = ReturnType<typeof useReviewOneDegreeMutation>;
export type ReviewOneDegreeMutationResult = ApolloReact.useMutation.Result<ReviewOneDegreeMutation>;
export const ReviewOneDocumentAuditFileIssuerDocument = gql`
    mutation reviewOneDocumentAuditFileIssuer($documentBaseId: String!, $reproveReason: String) {
  reviewOneDocumentAuditFileIssuer(
    documentBaseId: $documentBaseId
    reproveReason: $reproveReason
  ) {
    id
    documentBaseId
    DocumentBase {
      id
      DocumentBaseSignatureInviteGroups {
        id
        Invites {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useReviewOneDocumentAuditFileIssuerMutation__
 *
 * To run a mutation, you first call `useReviewOneDocumentAuditFileIssuerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewOneDocumentAuditFileIssuerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewOneDocumentAuditFileIssuerMutation, { data, loading, error }] = useReviewOneDocumentAuditFileIssuerMutation({
 *   variables: {
 *      documentBaseId: // value for 'documentBaseId'
 *      reproveReason: // value for 'reproveReason'
 *   },
 * });
 */
export function useReviewOneDocumentAuditFileIssuerMutation(baseOptions?: ApolloReact.useMutation.Options<ReviewOneDocumentAuditFileIssuerMutation, ReviewOneDocumentAuditFileIssuerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<ReviewOneDocumentAuditFileIssuerMutation, ReviewOneDocumentAuditFileIssuerMutationVariables>(ReviewOneDocumentAuditFileIssuerDocument, options);
      }
export type ReviewOneDocumentAuditFileIssuerMutationHookResult = ReturnType<typeof useReviewOneDocumentAuditFileIssuerMutation>;
export type ReviewOneDocumentAuditFileIssuerMutationResult = ApolloReact.useMutation.Result<ReviewOneDocumentAuditFileIssuerMutation>;
export const ReviewOneDocumentSchoolCurriculumDocument = gql`
    mutation reviewOneDocumentSchoolCurriculum($schoolCurriculumId: String!, $reproveReason: String) {
  reviewOneDocumentSchoolCurriculum(
    schoolCurriculumId: $schoolCurriculumId
    reproveReason: $reproveReason
  ) {
    id
    documentBaseId
    DocumentBase {
      id
      DocumentBaseSignatureInviteGroups {
        id
        Invites {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useReviewOneDocumentSchoolCurriculumMutation__
 *
 * To run a mutation, you first call `useReviewOneDocumentSchoolCurriculumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewOneDocumentSchoolCurriculumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewOneDocumentSchoolCurriculumMutation, { data, loading, error }] = useReviewOneDocumentSchoolCurriculumMutation({
 *   variables: {
 *      schoolCurriculumId: // value for 'schoolCurriculumId'
 *      reproveReason: // value for 'reproveReason'
 *   },
 * });
 */
export function useReviewOneDocumentSchoolCurriculumMutation(baseOptions?: ApolloReact.useMutation.Options<ReviewOneDocumentSchoolCurriculumMutation, ReviewOneDocumentSchoolCurriculumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<ReviewOneDocumentSchoolCurriculumMutation, ReviewOneDocumentSchoolCurriculumMutationVariables>(ReviewOneDocumentSchoolCurriculumDocument, options);
      }
export type ReviewOneDocumentSchoolCurriculumMutationHookResult = ReturnType<typeof useReviewOneDocumentSchoolCurriculumMutation>;
export type ReviewOneDocumentSchoolCurriculumMutationResult = ApolloReact.useMutation.Result<ReviewOneDocumentSchoolCurriculumMutation>;
export const RevokeOneDocumentBaseDocument = gql`
    mutation revokeOneDocumentBase($id: String!, $revokeReason: String!) {
  revokeOneDocumentBase(id: $id, revokeReason: $revokeReason) {
    id
    internalSeqId
    type
  }
}
    `;

/**
 * __useRevokeOneDocumentBaseMutation__
 *
 * To run a mutation, you first call `useRevokeOneDocumentBaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeOneDocumentBaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeOneDocumentBaseMutation, { data, loading, error }] = useRevokeOneDocumentBaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      revokeReason: // value for 'revokeReason'
 *   },
 * });
 */
export function useRevokeOneDocumentBaseMutation(baseOptions?: ApolloReact.useMutation.Options<RevokeOneDocumentBaseMutation, RevokeOneDocumentBaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<RevokeOneDocumentBaseMutation, RevokeOneDocumentBaseMutationVariables>(RevokeOneDocumentBaseDocument, options);
      }
export type RevokeOneDocumentBaseMutationHookResult = ReturnType<typeof useRevokeOneDocumentBaseMutation>;
export type RevokeOneDocumentBaseMutationResult = ApolloReact.useMutation.Result<RevokeOneDocumentBaseMutation>;
export const SaveOneDocumentAcademicDocumentationDocument = gql`
    mutation saveOneDocumentAcademicDocumentation($data: Json!, $type: DocumentAcademicDocumentationType, $version: String!) {
  saveOneDocumentAcademicDocumentation(
    data: $data
    type: $type
    version: $version
  ) {
    ...DocumentAcademicDocumentationFields
  }
}
    ${DocumentAcademicDocumentationFieldsFragmentDoc}`;

/**
 * __useSaveOneDocumentAcademicDocumentationMutation__
 *
 * To run a mutation, you first call `useSaveOneDocumentAcademicDocumentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOneDocumentAcademicDocumentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOneDocumentAcademicDocumentationMutation, { data, loading, error }] = useSaveOneDocumentAcademicDocumentationMutation({
 *   variables: {
 *      data: // value for 'data'
 *      type: // value for 'type'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useSaveOneDocumentAcademicDocumentationMutation(baseOptions?: ApolloReact.useMutation.Options<SaveOneDocumentAcademicDocumentationMutation, SaveOneDocumentAcademicDocumentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<SaveOneDocumentAcademicDocumentationMutation, SaveOneDocumentAcademicDocumentationMutationVariables>(SaveOneDocumentAcademicDocumentationDocument, options);
      }
export type SaveOneDocumentAcademicDocumentationMutationHookResult = ReturnType<typeof useSaveOneDocumentAcademicDocumentationMutation>;
export type SaveOneDocumentAcademicDocumentationMutationResult = ApolloReact.useMutation.Result<SaveOneDocumentAcademicDocumentationMutation>;
export const SaveOneCommonUserConfigDocument = gql`
    mutation saveOneCommonUserConfig($data: SaveOneCommonUserConfigInputData!) {
  saveOneCommonUserConfig(data: $data) {
    id
    key
  }
}
    `;

/**
 * __useSaveOneCommonUserConfigMutation__
 *
 * To run a mutation, you first call `useSaveOneCommonUserConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOneCommonUserConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOneCommonUserConfigMutation, { data, loading, error }] = useSaveOneCommonUserConfigMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSaveOneCommonUserConfigMutation(baseOptions?: ApolloReact.useMutation.Options<SaveOneCommonUserConfigMutation, SaveOneCommonUserConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<SaveOneCommonUserConfigMutation, SaveOneCommonUserConfigMutationVariables>(SaveOneCommonUserConfigDocument, options);
      }
export type SaveOneCommonUserConfigMutationHookResult = ReturnType<typeof useSaveOneCommonUserConfigMutation>;
export type SaveOneCommonUserConfigMutationResult = ApolloReact.useMutation.Result<SaveOneCommonUserConfigMutation>;
export const SaveOneReusableFormDataDocument = gql`
    mutation saveOneReusableFormData($data: Json!, $type: String!, $id: Int) {
  saveOneReusableFormData(data: $data, type: $type, id: $id) {
    id
    data
  }
}
    `;

/**
 * __useSaveOneReusableFormDataMutation__
 *
 * To run a mutation, you first call `useSaveOneReusableFormDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOneReusableFormDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOneReusableFormDataMutation, { data, loading, error }] = useSaveOneReusableFormDataMutation({
 *   variables: {
 *      data: // value for 'data'
 *      type: // value for 'type'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSaveOneReusableFormDataMutation(baseOptions?: ApolloReact.useMutation.Options<SaveOneReusableFormDataMutation, SaveOneReusableFormDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<SaveOneReusableFormDataMutation, SaveOneReusableFormDataMutationVariables>(SaveOneReusableFormDataDocument, options);
      }
export type SaveOneReusableFormDataMutationHookResult = ReturnType<typeof useSaveOneReusableFormDataMutation>;
export type SaveOneReusableFormDataMutationResult = ApolloReact.useMutation.Result<SaveOneReusableFormDataMutation>;
export const SaveOneDocumentSchoolCurriculumDocument = gql`
    mutation saveOneDocumentSchoolCurriculum($data: Json!, $version: String!) {
  saveOneDocumentSchoolCurriculum(data: $data, version: $version) {
    ...DocumentSchoolCurriculumFields
  }
}
    ${DocumentSchoolCurriculumFieldsFragmentDoc}`;

/**
 * __useSaveOneDocumentSchoolCurriculumMutation__
 *
 * To run a mutation, you first call `useSaveOneDocumentSchoolCurriculumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOneDocumentSchoolCurriculumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOneDocumentSchoolCurriculumMutation, { data, loading, error }] = useSaveOneDocumentSchoolCurriculumMutation({
 *   variables: {
 *      data: // value for 'data'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useSaveOneDocumentSchoolCurriculumMutation(baseOptions?: ApolloReact.useMutation.Options<SaveOneDocumentSchoolCurriculumMutation, SaveOneDocumentSchoolCurriculumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<SaveOneDocumentSchoolCurriculumMutation, SaveOneDocumentSchoolCurriculumMutationVariables>(SaveOneDocumentSchoolCurriculumDocument, options);
      }
export type SaveOneDocumentSchoolCurriculumMutationHookResult = ReturnType<typeof useSaveOneDocumentSchoolCurriculumMutation>;
export type SaveOneDocumentSchoolCurriculumMutationResult = ApolloReact.useMutation.Result<SaveOneDocumentSchoolCurriculumMutation>;
export const SendActivityDocument = gql`
    mutation sendActivity($input: WatchDocumentInput!) {
  sendActivity(input: $input)
}
    `;

/**
 * __useSendActivityMutation__
 *
 * To run a mutation, you first call `useSendActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendActivityMutation, { data, loading, error }] = useSendActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendActivityMutation(baseOptions?: ApolloReact.useMutation.Options<SendActivityMutation, SendActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<SendActivityMutation, SendActivityMutationVariables>(SendActivityDocument, options);
      }
export type SendActivityMutationHookResult = ReturnType<typeof useSendActivityMutation>;
export type SendActivityMutationResult = ApolloReact.useMutation.Result<SendActivityMutation>;
export const SendOneDegreeToReviewDocument = gql`
    mutation sendOneDegreeToReview($degreeId: String!) {
  sendOneDegreeToReview(degreeId: $degreeId) {
    ...DocumentDegreeUniqueFields
  }
}
    ${DocumentDegreeUniqueFieldsFragmentDoc}`;

/**
 * __useSendOneDegreeToReviewMutation__
 *
 * To run a mutation, you first call `useSendOneDegreeToReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOneDegreeToReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOneDegreeToReviewMutation, { data, loading, error }] = useSendOneDegreeToReviewMutation({
 *   variables: {
 *      degreeId: // value for 'degreeId'
 *   },
 * });
 */
export function useSendOneDegreeToReviewMutation(baseOptions?: ApolloReact.useMutation.Options<SendOneDegreeToReviewMutation, SendOneDegreeToReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<SendOneDegreeToReviewMutation, SendOneDegreeToReviewMutationVariables>(SendOneDegreeToReviewDocument, options);
      }
export type SendOneDegreeToReviewMutationHookResult = ReturnType<typeof useSendOneDegreeToReviewMutation>;
export type SendOneDegreeToReviewMutationResult = ApolloReact.useMutation.Result<SendOneDegreeToReviewMutation>;
export const SignOnlyVisualOneSignatureDocument = gql`
    mutation signOnlyVisualOneSignature($inviteId: String!, $signatureImageId: String) {
  signOnlyVisualOneSignature(
    inviteId: $inviteId
    signatureImageId: $signatureImageId
  ) {
    id
  }
}
    `;

/**
 * __useSignOnlyVisualOneSignatureMutation__
 *
 * To run a mutation, you first call `useSignOnlyVisualOneSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOnlyVisualOneSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOnlyVisualOneSignatureMutation, { data, loading, error }] = useSignOnlyVisualOneSignatureMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *      signatureImageId: // value for 'signatureImageId'
 *   },
 * });
 */
export function useSignOnlyVisualOneSignatureMutation(baseOptions?: ApolloReact.useMutation.Options<SignOnlyVisualOneSignatureMutation, SignOnlyVisualOneSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<SignOnlyVisualOneSignatureMutation, SignOnlyVisualOneSignatureMutationVariables>(SignOnlyVisualOneSignatureDocument, options);
      }
export type SignOnlyVisualOneSignatureMutationHookResult = ReturnType<typeof useSignOnlyVisualOneSignatureMutation>;
export type SignOnlyVisualOneSignatureMutationResult = ApolloReact.useMutation.Result<SignOnlyVisualOneSignatureMutation>;
export const SimulateDegreeValidationResponseDocument = gql`
    mutation simulateDegreeValidationResponse($degreeId: String!, $status: DegreeValidationVerdict!) {
  simulateDegreeValidationResponse(degreeId: $degreeId, status: $status) {
    id
    documentBaseId
  }
}
    `;

/**
 * __useSimulateDegreeValidationResponseMutation__
 *
 * To run a mutation, you first call `useSimulateDegreeValidationResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSimulateDegreeValidationResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [simulateDegreeValidationResponseMutation, { data, loading, error }] = useSimulateDegreeValidationResponseMutation({
 *   variables: {
 *      degreeId: // value for 'degreeId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSimulateDegreeValidationResponseMutation(baseOptions?: ApolloReact.useMutation.Options<SimulateDegreeValidationResponseMutation, SimulateDegreeValidationResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<SimulateDegreeValidationResponseMutation, SimulateDegreeValidationResponseMutationVariables>(SimulateDegreeValidationResponseDocument, options);
      }
export type SimulateDegreeValidationResponseMutationHookResult = ReturnType<typeof useSimulateDegreeValidationResponseMutation>;
export type SimulateDegreeValidationResponseMutationResult = ApolloReact.useMutation.Result<SimulateDegreeValidationResponseMutation>;
export const SingBulkCertificateVisualRepresentationDocument = gql`
    mutation singBulkCertificateVisualRepresentation($certificateList: [String!]!, $signatureImageId: String, $bulkId: String!) {
  singBulkCertificateVisualRepresentation(
    certificateList: $certificateList
    signatureImageId: $signatureImageId
    bulkId: $bulkId
  ) {
    id
    success
    total
  }
}
    `;

/**
 * __useSingBulkCertificateVisualRepresentationMutation__
 *
 * To run a mutation, you first call `useSingBulkCertificateVisualRepresentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSingBulkCertificateVisualRepresentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [singBulkCertificateVisualRepresentationMutation, { data, loading, error }] = useSingBulkCertificateVisualRepresentationMutation({
 *   variables: {
 *      certificateList: // value for 'certificateList'
 *      signatureImageId: // value for 'signatureImageId'
 *      bulkId: // value for 'bulkId'
 *   },
 * });
 */
export function useSingBulkCertificateVisualRepresentationMutation(baseOptions?: ApolloReact.useMutation.Options<SingBulkCertificateVisualRepresentationMutation, SingBulkCertificateVisualRepresentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<SingBulkCertificateVisualRepresentationMutation, SingBulkCertificateVisualRepresentationMutationVariables>(SingBulkCertificateVisualRepresentationDocument, options);
      }
export type SingBulkCertificateVisualRepresentationMutationHookResult = ReturnType<typeof useSingBulkCertificateVisualRepresentationMutation>;
export type SingBulkCertificateVisualRepresentationMutationResult = ApolloReact.useMutation.Result<SingBulkCertificateVisualRepresentationMutation>;
export const StartOneCertificateSignatureDocument = gql`
    mutation startOneCertificateSignature($certificate: String!, $inviteId: String!, $signatureImageId: String) {
  startOneCertificateSignature(
    certificate: $certificate
    inviteId: $inviteId
    signatureImageId: $signatureImageId
  ) {
    id
    signingTime
    dataToSign
    lastSignatureIsoString
  }
}
    `;

/**
 * __useStartOneCertificateSignatureMutation__
 *
 * To run a mutation, you first call `useStartOneCertificateSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartOneCertificateSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startOneCertificateSignatureMutation, { data, loading, error }] = useStartOneCertificateSignatureMutation({
 *   variables: {
 *      certificate: // value for 'certificate'
 *      inviteId: // value for 'inviteId'
 *      signatureImageId: // value for 'signatureImageId'
 *   },
 * });
 */
export function useStartOneCertificateSignatureMutation(baseOptions?: ApolloReact.useMutation.Options<StartOneCertificateSignatureMutation, StartOneCertificateSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<StartOneCertificateSignatureMutation, StartOneCertificateSignatureMutationVariables>(StartOneCertificateSignatureDocument, options);
      }
export type StartOneCertificateSignatureMutationHookResult = ReturnType<typeof useStartOneCertificateSignatureMutation>;
export type StartOneCertificateSignatureMutationResult = ApolloReact.useMutation.Result<StartOneCertificateSignatureMutation>;
export const UpdateOneCertificateCourseDocument = gql`
    mutation updateOneCertificateCourse($areaKnowledge: String!, $certificateId: String!, $metaData: [String!]!, $name: String!, $courseLevelId: String) {
  updateOneCertificateCourse(
    areaKnowledge: $areaKnowledge
    certificateId: $certificateId
    metaData: $metaData
    name: $name
    courseLevelId: $courseLevelId
  ) {
    id
    areaKnowledge
    certificateBaseId
    name
    metaData
  }
}
    `;

/**
 * __useUpdateOneCertificateCourseMutation__
 *
 * To run a mutation, you first call `useUpdateOneCertificateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneCertificateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneCertificateCourseMutation, { data, loading, error }] = useUpdateOneCertificateCourseMutation({
 *   variables: {
 *      areaKnowledge: // value for 'areaKnowledge'
 *      certificateId: // value for 'certificateId'
 *      metaData: // value for 'metaData'
 *      name: // value for 'name'
 *      courseLevelId: // value for 'courseLevelId'
 *   },
 * });
 */
export function useUpdateOneCertificateCourseMutation(baseOptions?: ApolloReact.useMutation.Options<UpdateOneCertificateCourseMutation, UpdateOneCertificateCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<UpdateOneCertificateCourseMutation, UpdateOneCertificateCourseMutationVariables>(UpdateOneCertificateCourseDocument, options);
      }
export type UpdateOneCertificateCourseMutationHookResult = ReturnType<typeof useUpdateOneCertificateCourseMutation>;
export type UpdateOneCertificateCourseMutationResult = ApolloReact.useMutation.Result<UpdateOneCertificateCourseMutation>;
export const UpdateOneCertificateCourseLevelDocument = gql`
    mutation updateOneCertificateCourseLevel($certificateBaseId: String!, $name: String!) {
  updateOneCertificateCourseLevel(
    certificateBaseId: $certificateBaseId
    name: $name
  ) {
    id
    certificateBaseId
  }
}
    `;

/**
 * __useUpdateOneCertificateCourseLevelMutation__
 *
 * To run a mutation, you first call `useUpdateOneCertificateCourseLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneCertificateCourseLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneCertificateCourseLevelMutation, { data, loading, error }] = useUpdateOneCertificateCourseLevelMutation({
 *   variables: {
 *      certificateBaseId: // value for 'certificateBaseId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateOneCertificateCourseLevelMutation(baseOptions?: ApolloReact.useMutation.Options<UpdateOneCertificateCourseLevelMutation, UpdateOneCertificateCourseLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<UpdateOneCertificateCourseLevelMutation, UpdateOneCertificateCourseLevelMutationVariables>(UpdateOneCertificateCourseLevelDocument, options);
      }
export type UpdateOneCertificateCourseLevelMutationHookResult = ReturnType<typeof useUpdateOneCertificateCourseLevelMutation>;
export type UpdateOneCertificateCourseLevelMutationResult = ApolloReact.useMutation.Result<UpdateOneCertificateCourseLevelMutation>;
export const UpdateOneCertificateCurriculumDocument = gql`
    mutation updateOneCertificateCurriculum($amountOfHours: Int, $certificateCourseId: String!, $certificateId: String!, $name: String!, $selectedDisciplines: [CirriculumSelectedDiscipline!]!) {
  updateOneCertificateCurriculum(
    amountOfHours: $amountOfHours
    certificateCourseId: $certificateCourseId
    certificateId: $certificateId
    name: $name
    selectedDisciplines: $selectedDisciplines
  ) {
    id
    certificateBaseId
    name
    amountOfHours
  }
}
    `;

/**
 * __useUpdateOneCertificateCurriculumMutation__
 *
 * To run a mutation, you first call `useUpdateOneCertificateCurriculumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneCertificateCurriculumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneCertificateCurriculumMutation, { data, loading, error }] = useUpdateOneCertificateCurriculumMutation({
 *   variables: {
 *      amountOfHours: // value for 'amountOfHours'
 *      certificateCourseId: // value for 'certificateCourseId'
 *      certificateId: // value for 'certificateId'
 *      name: // value for 'name'
 *      selectedDisciplines: // value for 'selectedDisciplines'
 *   },
 * });
 */
export function useUpdateOneCertificateCurriculumMutation(baseOptions?: ApolloReact.useMutation.Options<UpdateOneCertificateCurriculumMutation, UpdateOneCertificateCurriculumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<UpdateOneCertificateCurriculumMutation, UpdateOneCertificateCurriculumMutationVariables>(UpdateOneCertificateCurriculumDocument, options);
      }
export type UpdateOneCertificateCurriculumMutationHookResult = ReturnType<typeof useUpdateOneCertificateCurriculumMutation>;
export type UpdateOneCertificateCurriculumMutationResult = ApolloReact.useMutation.Result<UpdateOneCertificateCurriculumMutation>;
export const UpdateOneCertificateDisciplineDocument = gql`
    mutation updateOneCertificateDiscipline($certificateId: String!, $name: String!, $viewOnDegree: Boolean!) {
  updateOneCertificateDiscipline(
    certificateId: $certificateId
    name: $name
    viewOnDegree: $viewOnDegree
  ) {
    id
    certificateBaseId
    name
    viewOnDegree
  }
}
    `;

/**
 * __useUpdateOneCertificateDisciplineMutation__
 *
 * To run a mutation, you first call `useUpdateOneCertificateDisciplineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneCertificateDisciplineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneCertificateDisciplineMutation, { data, loading, error }] = useUpdateOneCertificateDisciplineMutation({
 *   variables: {
 *      certificateId: // value for 'certificateId'
 *      name: // value for 'name'
 *      viewOnDegree: // value for 'viewOnDegree'
 *   },
 * });
 */
export function useUpdateOneCertificateDisciplineMutation(baseOptions?: ApolloReact.useMutation.Options<UpdateOneCertificateDisciplineMutation, UpdateOneCertificateDisciplineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<UpdateOneCertificateDisciplineMutation, UpdateOneCertificateDisciplineMutationVariables>(UpdateOneCertificateDisciplineDocument, options);
      }
export type UpdateOneCertificateDisciplineMutationHookResult = ReturnType<typeof useUpdateOneCertificateDisciplineMutation>;
export type UpdateOneCertificateDisciplineMutationResult = ApolloReact.useMutation.Result<UpdateOneCertificateDisciplineMutation>;
export const UpdateOneCertificateEventDocument = gql`
    mutation updateOneCertificateEvent($certificateId: String!, $name: String!) {
  updateOneCertificateEvent(certificateId: $certificateId, name: $name) {
    id
    certificateBaseId
    name
  }
}
    `;

/**
 * __useUpdateOneCertificateEventMutation__
 *
 * To run a mutation, you first call `useUpdateOneCertificateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneCertificateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneCertificateEventMutation, { data, loading, error }] = useUpdateOneCertificateEventMutation({
 *   variables: {
 *      certificateId: // value for 'certificateId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateOneCertificateEventMutation(baseOptions?: ApolloReact.useMutation.Options<UpdateOneCertificateEventMutation, UpdateOneCertificateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<UpdateOneCertificateEventMutation, UpdateOneCertificateEventMutationVariables>(UpdateOneCertificateEventDocument, options);
      }
export type UpdateOneCertificateEventMutationHookResult = ReturnType<typeof useUpdateOneCertificateEventMutation>;
export type UpdateOneCertificateEventMutationResult = ApolloReact.useMutation.Result<UpdateOneCertificateEventMutation>;
export const UpdateOneCertificateTeacherDocument = gql`
    mutation updateOneCertificateTeacher($name: String!, $titration: String!, $certificateId: String!) {
  updateOneCertificateTeacher(
    name: $name
    titration: $titration
    certificateId: $certificateId
  ) {
    id
    certificateBaseId
    name
    titration
  }
}
    `;

/**
 * __useUpdateOneCertificateTeacherMutation__
 *
 * To run a mutation, you first call `useUpdateOneCertificateTeacherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneCertificateTeacherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneCertificateTeacherMutation, { data, loading, error }] = useUpdateOneCertificateTeacherMutation({
 *   variables: {
 *      name: // value for 'name'
 *      titration: // value for 'titration'
 *      certificateId: // value for 'certificateId'
 *   },
 * });
 */
export function useUpdateOneCertificateTeacherMutation(baseOptions?: ApolloReact.useMutation.Options<UpdateOneCertificateTeacherMutation, UpdateOneCertificateTeacherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<UpdateOneCertificateTeacherMutation, UpdateOneCertificateTeacherMutationVariables>(UpdateOneCertificateTeacherDocument, options);
      }
export type UpdateOneCertificateTeacherMutationHookResult = ReturnType<typeof useUpdateOneCertificateTeacherMutation>;
export type UpdateOneCertificateTeacherMutationResult = ApolloReact.useMutation.Result<UpdateOneCertificateTeacherMutation>;
export const UpdateOneCertificateTemplateDocument = gql`
    mutation updateOneCertificateTemplate($data: CertificateTemplateUpdateInput!, $where: CertificateTemplateWhereUniqueInput!) {
  updateOneCertificateTemplate(data: $data, where: $where) {
    id
  }
}
    `;

/**
 * __useUpdateOneCertificateTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateOneCertificateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneCertificateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneCertificateTemplateMutation, { data, loading, error }] = useUpdateOneCertificateTemplateMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateOneCertificateTemplateMutation(baseOptions?: ApolloReact.useMutation.Options<UpdateOneCertificateTemplateMutation, UpdateOneCertificateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<UpdateOneCertificateTemplateMutation, UpdateOneCertificateTemplateMutationVariables>(UpdateOneCertificateTemplateDocument, options);
      }
export type UpdateOneCertificateTemplateMutationHookResult = ReturnType<typeof useUpdateOneCertificateTemplateMutation>;
export type UpdateOneCertificateTemplateMutationResult = ApolloReact.useMutation.Result<UpdateOneCertificateTemplateMutation>;
export const UpdateOneDegreeSentToGraduateStatusDocument = gql`
    mutation updateOneDegreeSentToGraduateStatus($degreeId: String!, $isSentToGraduate: Boolean!) {
  updateOneDegreeSentToGraduateStatus(
    degreeId: $degreeId
    isSentToGraduate: $isSentToGraduate
  ) {
    id
    documentBaseId
    isSentToGraduate
    status
  }
}
    `;

/**
 * __useUpdateOneDegreeSentToGraduateStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOneDegreeSentToGraduateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneDegreeSentToGraduateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneDegreeSentToGraduateStatusMutation, { data, loading, error }] = useUpdateOneDegreeSentToGraduateStatusMutation({
 *   variables: {
 *      degreeId: // value for 'degreeId'
 *      isSentToGraduate: // value for 'isSentToGraduate'
 *   },
 * });
 */
export function useUpdateOneDegreeSentToGraduateStatusMutation(baseOptions?: ApolloReact.useMutation.Options<UpdateOneDegreeSentToGraduateStatusMutation, UpdateOneDegreeSentToGraduateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<UpdateOneDegreeSentToGraduateStatusMutation, UpdateOneDegreeSentToGraduateStatusMutationVariables>(UpdateOneDegreeSentToGraduateStatusDocument, options);
      }
export type UpdateOneDegreeSentToGraduateStatusMutationHookResult = ReturnType<typeof useUpdateOneDegreeSentToGraduateStatusMutation>;
export type UpdateOneDegreeSentToGraduateStatusMutationResult = ApolloReact.useMutation.Result<UpdateOneDegreeSentToGraduateStatusMutation>;
export const UpdateOnePersonDocument = gql`
    mutation updateOnePerson($isForeign: Boolean!, $phones: [String!]!, $receivesCertificateEmail: Boolean!, $receivesCertificateWhatsapp: Boolean!, $address: AddressInput, $birthDate: String, $cpf: String, $email: String, $id: String, $identityDocument: String, $passport: String, $name: String!) {
  updateOnePerson(
    isForeign: $isForeign
    phones: $phones
    receivesCertificateEmail: $receivesCertificateEmail
    receivesCertificateWhatsapp: $receivesCertificateWhatsapp
    address: $address
    birthDate: $birthDate
    cpf: $cpf
    email: $email
    id: $id
    identityDocument: $identityDocument
    passport: $passport
    name: $name
  ) {
    id
    name
  }
}
    `;

/**
 * __useUpdateOnePersonMutation__
 *
 * To run a mutation, you first call `useUpdateOnePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOnePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOnePersonMutation, { data, loading, error }] = useUpdateOnePersonMutation({
 *   variables: {
 *      isForeign: // value for 'isForeign'
 *      phones: // value for 'phones'
 *      receivesCertificateEmail: // value for 'receivesCertificateEmail'
 *      receivesCertificateWhatsapp: // value for 'receivesCertificateWhatsapp'
 *      address: // value for 'address'
 *      birthDate: // value for 'birthDate'
 *      cpf: // value for 'cpf'
 *      email: // value for 'email'
 *      id: // value for 'id'
 *      identityDocument: // value for 'identityDocument'
 *      passport: // value for 'passport'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateOnePersonMutation(baseOptions?: ApolloReact.useMutation.Options<UpdateOnePersonMutation, UpdateOnePersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<UpdateOnePersonMutation, UpdateOnePersonMutationVariables>(UpdateOnePersonDocument, options);
      }
export type UpdateOnePersonMutationHookResult = ReturnType<typeof useUpdateOnePersonMutation>;
export type UpdateOnePersonMutationResult = ApolloReact.useMutation.Result<UpdateOnePersonMutation>;
export const UpdateOneReusableFormDataCurriculumDocument = gql`
    mutation updateOneReusableFormDataCurriculum($data: ReusableFormDataCurriculumCreateInputCustom!, $where: ReusableFormDataCurriculumWhereUniqueInput!) {
  updateOneReusableFormDataCurriculum(data: $data, where: $where) {
    id
  }
}
    `;

/**
 * __useUpdateOneReusableFormDataCurriculumMutation__
 *
 * To run a mutation, you first call `useUpdateOneReusableFormDataCurriculumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneReusableFormDataCurriculumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneReusableFormDataCurriculumMutation, { data, loading, error }] = useUpdateOneReusableFormDataCurriculumMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateOneReusableFormDataCurriculumMutation(baseOptions?: ApolloReact.useMutation.Options<UpdateOneReusableFormDataCurriculumMutation, UpdateOneReusableFormDataCurriculumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<UpdateOneReusableFormDataCurriculumMutation, UpdateOneReusableFormDataCurriculumMutationVariables>(UpdateOneReusableFormDataCurriculumDocument, options);
      }
export type UpdateOneReusableFormDataCurriculumMutationHookResult = ReturnType<typeof useUpdateOneReusableFormDataCurriculumMutation>;
export type UpdateOneReusableFormDataCurriculumMutationResult = ApolloReact.useMutation.Result<UpdateOneReusableFormDataCurriculumMutation>;
export const UpdateOneSystemGlobalAlertDocument = gql`
    mutation updateOneSystemGlobalAlert($data: SystemGlobalAlertUpdateInput!, $where: SystemGlobalAlertWhereUniqueInput!) {
  updateOneSystemGlobalAlert(data: $data, where: $where) {
    id
  }
}
    `;

/**
 * __useUpdateOneSystemGlobalAlertMutation__
 *
 * To run a mutation, you first call `useUpdateOneSystemGlobalAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneSystemGlobalAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneSystemGlobalAlertMutation, { data, loading, error }] = useUpdateOneSystemGlobalAlertMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateOneSystemGlobalAlertMutation(baseOptions?: ApolloReact.useMutation.Options<UpdateOneSystemGlobalAlertMutation, UpdateOneSystemGlobalAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<UpdateOneSystemGlobalAlertMutation, UpdateOneSystemGlobalAlertMutationVariables>(UpdateOneSystemGlobalAlertDocument, options);
      }
export type UpdateOneSystemGlobalAlertMutationHookResult = ReturnType<typeof useUpdateOneSystemGlobalAlertMutation>;
export type UpdateOneSystemGlobalAlertMutationResult = ApolloReact.useMutation.Result<UpdateOneSystemGlobalAlertMutation>;
export const UpdateOneTeamDocument = gql`
    mutation updateOneTeam($data: UpdateOneTeamData!) {
  updateOneTeam(data: $data) {
    cnpj
    id
    TeamEducationLevel {
      id
      educationLevelType
    }
  }
}
    `;

/**
 * __useUpdateOneTeamMutation__
 *
 * To run a mutation, you first call `useUpdateOneTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneTeamMutation, { data, loading, error }] = useUpdateOneTeamMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOneTeamMutation(baseOptions?: ApolloReact.useMutation.Options<UpdateOneTeamMutation, UpdateOneTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<UpdateOneTeamMutation, UpdateOneTeamMutationVariables>(UpdateOneTeamDocument, options);
      }
export type UpdateOneTeamMutationHookResult = ReturnType<typeof useUpdateOneTeamMutation>;
export type UpdateOneTeamMutationResult = ApolloReact.useMutation.Result<UpdateOneTeamMutation>;
export const UpdateOneTeamContractDocument = gql`
    mutation updateOneTeamContract($data: TeamContractUpdateInput!, $where: TeamContractWhereUniqueInput!) {
  updateOneTeamContract(data: $data, where: $where) {
    id
    contractUrl
    isActive
    startOfContract
    endOfContract
    updatedAt
    teamId
    observations
    storageInGb
  }
}
    `;

/**
 * __useUpdateOneTeamContractMutation__
 *
 * To run a mutation, you first call `useUpdateOneTeamContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneTeamContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneTeamContractMutation, { data, loading, error }] = useUpdateOneTeamContractMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateOneTeamContractMutation(baseOptions?: ApolloReact.useMutation.Options<UpdateOneTeamContractMutation, UpdateOneTeamContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<UpdateOneTeamContractMutation, UpdateOneTeamContractMutationVariables>(UpdateOneTeamContractDocument, options);
      }
export type UpdateOneTeamContractMutationHookResult = ReturnType<typeof useUpdateOneTeamContractMutation>;
export type UpdateOneTeamContractMutationResult = ApolloReact.useMutation.Result<UpdateOneTeamContractMutation>;
export const UpdateOneTeamDefaultDegreeCertificateTemplateDocument = gql`
    mutation updateOneTeamDefaultDegreeCertificateTemplate($certificateTemplateId: String) {
  updateOneTeamDefaultDegreeCertificateTemplate(
    certificateTemplateId: $certificateTemplateId
  ) {
    id
    DefaultDegreeCertificateTemplate {
      id
      name
    }
  }
}
    `;

/**
 * __useUpdateOneTeamDefaultDegreeCertificateTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateOneTeamDefaultDegreeCertificateTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneTeamDefaultDegreeCertificateTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneTeamDefaultDegreeCertificateTemplateMutation, { data, loading, error }] = useUpdateOneTeamDefaultDegreeCertificateTemplateMutation({
 *   variables: {
 *      certificateTemplateId: // value for 'certificateTemplateId'
 *   },
 * });
 */
export function useUpdateOneTeamDefaultDegreeCertificateTemplateMutation(baseOptions?: ApolloReact.useMutation.Options<UpdateOneTeamDefaultDegreeCertificateTemplateMutation, UpdateOneTeamDefaultDegreeCertificateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<UpdateOneTeamDefaultDegreeCertificateTemplateMutation, UpdateOneTeamDefaultDegreeCertificateTemplateMutationVariables>(UpdateOneTeamDefaultDegreeCertificateTemplateDocument, options);
      }
export type UpdateOneTeamDefaultDegreeCertificateTemplateMutationHookResult = ReturnType<typeof useUpdateOneTeamDefaultDegreeCertificateTemplateMutation>;
export type UpdateOneTeamDefaultDegreeCertificateTemplateMutationResult = ApolloReact.useMutation.Result<UpdateOneTeamDefaultDegreeCertificateTemplateMutation>;
export const UpdateOneTeamMemberDocument = gql`
    mutation updateOneTeamMember($updateOneTeamMemberId: Int!, $permissions: [String!], $role: String) {
  updateOneTeamMember(
    id: $updateOneTeamMemberId
    permissions: $permissions
    role: $role
  ) {
    id
    User {
      id
    }
  }
}
    `;

/**
 * __useUpdateOneTeamMemberMutation__
 *
 * To run a mutation, you first call `useUpdateOneTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneTeamMemberMutation, { data, loading, error }] = useUpdateOneTeamMemberMutation({
 *   variables: {
 *      updateOneTeamMemberId: // value for 'updateOneTeamMemberId'
 *      permissions: // value for 'permissions'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdateOneTeamMemberMutation(baseOptions?: ApolloReact.useMutation.Options<UpdateOneTeamMemberMutation, UpdateOneTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<UpdateOneTeamMemberMutation, UpdateOneTeamMemberMutationVariables>(UpdateOneTeamMemberDocument, options);
      }
export type UpdateOneTeamMemberMutationHookResult = ReturnType<typeof useUpdateOneTeamMemberMutation>;
export type UpdateOneTeamMemberMutationResult = ApolloReact.useMutation.Result<UpdateOneTeamMemberMutation>;
export const UpdateOneAcademicDocumentationSentToRegistrarStatusDocument = gql`
    mutation updateOneAcademicDocumentationSentToRegistrarStatus($updateSentToRegistrarStatusId: String!, $isSentToRegistrar: Boolean!) {
  updateOneAcademicDocumentationSentToRegistrarStatus(
    id: $updateSentToRegistrarStatusId
    isSentToRegistrar: $isSentToRegistrar
  ) {
    id
    documentBaseId
    isSentToRegistrar
  }
}
    `;

/**
 * __useUpdateOneAcademicDocumentationSentToRegistrarStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOneAcademicDocumentationSentToRegistrarStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneAcademicDocumentationSentToRegistrarStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneAcademicDocumentationSentToRegistrarStatusMutation, { data, loading, error }] = useUpdateOneAcademicDocumentationSentToRegistrarStatusMutation({
 *   variables: {
 *      updateSentToRegistrarStatusId: // value for 'updateSentToRegistrarStatusId'
 *      isSentToRegistrar: // value for 'isSentToRegistrar'
 *   },
 * });
 */
export function useUpdateOneAcademicDocumentationSentToRegistrarStatusMutation(baseOptions?: ApolloReact.useMutation.Options<UpdateOneAcademicDocumentationSentToRegistrarStatusMutation, UpdateOneAcademicDocumentationSentToRegistrarStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<UpdateOneAcademicDocumentationSentToRegistrarStatusMutation, UpdateOneAcademicDocumentationSentToRegistrarStatusMutationVariables>(UpdateOneAcademicDocumentationSentToRegistrarStatusDocument, options);
      }
export type UpdateOneAcademicDocumentationSentToRegistrarStatusMutationHookResult = ReturnType<typeof useUpdateOneAcademicDocumentationSentToRegistrarStatusMutation>;
export type UpdateOneAcademicDocumentationSentToRegistrarStatusMutationResult = ApolloReact.useMutation.Result<UpdateOneAcademicDocumentationSentToRegistrarStatusMutation>;
export const UpdateTeamActivationStatusDocument = gql`
    mutation updateTeamActivationStatus($data: updateTeamActivationStatusArgs!) {
  updateTeamActivationStatus(data: $data) {
    id
    isActive
  }
}
    `;

/**
 * __useUpdateTeamActivationStatusMutation__
 *
 * To run a mutation, you first call `useUpdateTeamActivationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamActivationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamActivationStatusMutation, { data, loading, error }] = useUpdateTeamActivationStatusMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTeamActivationStatusMutation(baseOptions?: ApolloReact.useMutation.Options<UpdateTeamActivationStatusMutation, UpdateTeamActivationStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<UpdateTeamActivationStatusMutation, UpdateTeamActivationStatusMutationVariables>(UpdateTeamActivationStatusDocument, options);
      }
export type UpdateTeamActivationStatusMutationHookResult = ReturnType<typeof useUpdateTeamActivationStatusMutation>;
export type UpdateTeamActivationStatusMutationResult = ApolloReact.useMutation.Result<UpdateTeamActivationStatusMutation>;
export const UpdateTeamConfigAddDocumentSignerNodeDocument = gql`
    mutation updateTeamConfigAddDocumentSignerNode($addSigners: Boolean!) {
  updateTeamConfigAddDocumentSignerNode(addSigners: $addSigners) {
    id
  }
}
    `;

/**
 * __useUpdateTeamConfigAddDocumentSignerNodeMutation__
 *
 * To run a mutation, you first call `useUpdateTeamConfigAddDocumentSignerNodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamConfigAddDocumentSignerNodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamConfigAddDocumentSignerNodeMutation, { data, loading, error }] = useUpdateTeamConfigAddDocumentSignerNodeMutation({
 *   variables: {
 *      addSigners: // value for 'addSigners'
 *   },
 * });
 */
export function useUpdateTeamConfigAddDocumentSignerNodeMutation(baseOptions?: ApolloReact.useMutation.Options<UpdateTeamConfigAddDocumentSignerNodeMutation, UpdateTeamConfigAddDocumentSignerNodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<UpdateTeamConfigAddDocumentSignerNodeMutation, UpdateTeamConfigAddDocumentSignerNodeMutationVariables>(UpdateTeamConfigAddDocumentSignerNodeDocument, options);
      }
export type UpdateTeamConfigAddDocumentSignerNodeMutationHookResult = ReturnType<typeof useUpdateTeamConfigAddDocumentSignerNodeMutation>;
export type UpdateTeamConfigAddDocumentSignerNodeMutationResult = ApolloReact.useMutation.Result<UpdateTeamConfigAddDocumentSignerNodeMutation>;
export const UpsertDocumentBaseDefaultSignatureInviteConfigurationDocument = gql`
    mutation upsertDocumentBaseDefaultSignatureInviteConfiguration($data: UpsertDocumentBaseDefaultSignatureInviteConfigurationInput!) {
  upsertDocumentBaseDefaultSignatureInviteConfiguration(data: $data) {
    id
  }
}
    `;

/**
 * __useUpsertDocumentBaseDefaultSignatureInviteConfigurationMutation__
 *
 * To run a mutation, you first call `useUpsertDocumentBaseDefaultSignatureInviteConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDocumentBaseDefaultSignatureInviteConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDocumentBaseDefaultSignatureInviteConfigurationMutation, { data, loading, error }] = useUpsertDocumentBaseDefaultSignatureInviteConfigurationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpsertDocumentBaseDefaultSignatureInviteConfigurationMutation(baseOptions?: ApolloReact.useMutation.Options<UpsertDocumentBaseDefaultSignatureInviteConfigurationMutation, UpsertDocumentBaseDefaultSignatureInviteConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<UpsertDocumentBaseDefaultSignatureInviteConfigurationMutation, UpsertDocumentBaseDefaultSignatureInviteConfigurationMutationVariables>(UpsertDocumentBaseDefaultSignatureInviteConfigurationDocument, options);
      }
export type UpsertDocumentBaseDefaultSignatureInviteConfigurationMutationHookResult = ReturnType<typeof useUpsertDocumentBaseDefaultSignatureInviteConfigurationMutation>;
export type UpsertDocumentBaseDefaultSignatureInviteConfigurationMutationResult = ApolloReact.useMutation.Result<UpsertDocumentBaseDefaultSignatureInviteConfigurationMutation>;
export const UpsertOneTemporarySignatureImageDocument = gql`
    mutation upsertOneTemporarySignatureImage($description: String!) {
  upsertOneTemporarySignatureImage(description: $description) {
    ...SignSignatureImageUniqueFields
  }
}
    ${SignSignatureImageUniqueFieldsFragmentDoc}`;

/**
 * __useUpsertOneTemporarySignatureImageMutation__
 *
 * To run a mutation, you first call `useUpsertOneTemporarySignatureImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOneTemporarySignatureImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertOneTemporarySignatureImageMutation, { data, loading, error }] = useUpsertOneTemporarySignatureImageMutation({
 *   variables: {
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpsertOneTemporarySignatureImageMutation(baseOptions?: ApolloReact.useMutation.Options<UpsertOneTemporarySignatureImageMutation, UpsertOneTemporarySignatureImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<UpsertOneTemporarySignatureImageMutation, UpsertOneTemporarySignatureImageMutationVariables>(UpsertOneTemporarySignatureImageDocument, options);
      }
export type UpsertOneTemporarySignatureImageMutationHookResult = ReturnType<typeof useUpsertOneTemporarySignatureImageMutation>;
export type UpsertOneTemporarySignatureImageMutationResult = ApolloReact.useMutation.Result<UpsertOneTemporarySignatureImageMutation>;
export const UpsertTeamDocumentTypeSpecificSignaturePolicyConfigDocument = gql`
    mutation upsertTeamDocumentTypeSpecificSignaturePolicyConfig($data: UpsertTeamDocumentTypeSpecificSignaturePolicyConfigInput!) {
  upsertTeamDocumentTypeSpecificSignaturePolicyConfig(data: $data) {
    id
    teamId
    documentType
    groupPolicies
  }
}
    `;

/**
 * __useUpsertTeamDocumentTypeSpecificSignaturePolicyConfigMutation__
 *
 * To run a mutation, you first call `useUpsertTeamDocumentTypeSpecificSignaturePolicyConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTeamDocumentTypeSpecificSignaturePolicyConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTeamDocumentTypeSpecificSignaturePolicyConfigMutation, { data, loading, error }] = useUpsertTeamDocumentTypeSpecificSignaturePolicyConfigMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpsertTeamDocumentTypeSpecificSignaturePolicyConfigMutation(baseOptions?: ApolloReact.useMutation.Options<UpsertTeamDocumentTypeSpecificSignaturePolicyConfigMutation, UpsertTeamDocumentTypeSpecificSignaturePolicyConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<UpsertTeamDocumentTypeSpecificSignaturePolicyConfigMutation, UpsertTeamDocumentTypeSpecificSignaturePolicyConfigMutationVariables>(UpsertTeamDocumentTypeSpecificSignaturePolicyConfigDocument, options);
      }
export type UpsertTeamDocumentTypeSpecificSignaturePolicyConfigMutationHookResult = ReturnType<typeof useUpsertTeamDocumentTypeSpecificSignaturePolicyConfigMutation>;
export type UpsertTeamDocumentTypeSpecificSignaturePolicyConfigMutationResult = ApolloReact.useMutation.Result<UpsertTeamDocumentTypeSpecificSignaturePolicyConfigMutation>;
export const ValidateOnePdfaDocument = gql`
    mutation validateOnePdfa($base64: String!) {
  validateOnePdfa(base64: $base64)
}
    `;

/**
 * __useValidateOnePdfaMutation__
 *
 * To run a mutation, you first call `useValidateOnePdfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateOnePdfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateOnePdfaMutation, { data, loading, error }] = useValidateOnePdfaMutation({
 *   variables: {
 *      base64: // value for 'base64'
 *   },
 * });
 */
export function useValidateOnePdfaMutation(baseOptions?: ApolloReact.useMutation.Options<ValidateOnePdfaMutation, ValidateOnePdfaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<ValidateOnePdfaMutation, ValidateOnePdfaMutationVariables>(ValidateOnePdfaDocument, options);
      }
export type ValidateOnePdfaMutationHookResult = ReturnType<typeof useValidateOnePdfaMutation>;
export type ValidateOnePdfaMutationResult = ApolloReact.useMutation.Result<ValidateOnePdfaMutation>;
export const CountDocumentAcademicDocumentationDocument = gql`
    query countDocumentAcademicDocumentation($where: DocumentAcademicDocumentationWhereInput) {
  count: countDocumentAcademicDocumentation(where: $where)
}
    `;

/**
 * __useCountDocumentAcademicDocumentationQuery__
 *
 * To run a query within a React component, call `useCountDocumentAcademicDocumentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountDocumentAcademicDocumentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountDocumentAcademicDocumentationQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountDocumentAcademicDocumentationQuery(baseOptions?: ApolloReact.useQuery.Options<CountDocumentAcademicDocumentationQuery, CountDocumentAcademicDocumentationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<CountDocumentAcademicDocumentationQuery, CountDocumentAcademicDocumentationQueryVariables>(CountDocumentAcademicDocumentationDocument, options);
      }
export function useCountDocumentAcademicDocumentationLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<CountDocumentAcademicDocumentationQuery, CountDocumentAcademicDocumentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<CountDocumentAcademicDocumentationQuery, CountDocumentAcademicDocumentationQueryVariables>(CountDocumentAcademicDocumentationDocument, options);
        }
export function useCountDocumentAcademicDocumentationSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<CountDocumentAcademicDocumentationQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<CountDocumentAcademicDocumentationQuery, CountDocumentAcademicDocumentationQueryVariables>(CountDocumentAcademicDocumentationDocument, options);
        }
export type CountDocumentAcademicDocumentationQueryHookResult = ReturnType<typeof useCountDocumentAcademicDocumentationQuery>;
export type CountDocumentAcademicDocumentationLazyQueryHookResult = ReturnType<typeof useCountDocumentAcademicDocumentationLazyQuery>;
export type CountDocumentAcademicDocumentationSuspenseQueryHookResult = ReturnType<typeof useCountDocumentAcademicDocumentationSuspenseQuery>;
export type CountDocumentAcademicDocumentationQueryResult = ApolloReact.useQuery.Result<CountDocumentAcademicDocumentationQuery, CountDocumentAcademicDocumentationQueryVariables>;
export const CountDocumentAuditFileIssuerDocument = gql`
    query countDocumentAuditFileIssuer($where: DocumentAuditFileIssuerWhereInput) {
  count: countDocumentAuditFileIssuer(where: $where)
}
    `;

/**
 * __useCountDocumentAuditFileIssuerQuery__
 *
 * To run a query within a React component, call `useCountDocumentAuditFileIssuerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountDocumentAuditFileIssuerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountDocumentAuditFileIssuerQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountDocumentAuditFileIssuerQuery(baseOptions?: ApolloReact.useQuery.Options<CountDocumentAuditFileIssuerQuery, CountDocumentAuditFileIssuerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<CountDocumentAuditFileIssuerQuery, CountDocumentAuditFileIssuerQueryVariables>(CountDocumentAuditFileIssuerDocument, options);
      }
export function useCountDocumentAuditFileIssuerLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<CountDocumentAuditFileIssuerQuery, CountDocumentAuditFileIssuerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<CountDocumentAuditFileIssuerQuery, CountDocumentAuditFileIssuerQueryVariables>(CountDocumentAuditFileIssuerDocument, options);
        }
export function useCountDocumentAuditFileIssuerSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<CountDocumentAuditFileIssuerQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<CountDocumentAuditFileIssuerQuery, CountDocumentAuditFileIssuerQueryVariables>(CountDocumentAuditFileIssuerDocument, options);
        }
export type CountDocumentAuditFileIssuerQueryHookResult = ReturnType<typeof useCountDocumentAuditFileIssuerQuery>;
export type CountDocumentAuditFileIssuerLazyQueryHookResult = ReturnType<typeof useCountDocumentAuditFileIssuerLazyQuery>;
export type CountDocumentAuditFileIssuerSuspenseQueryHookResult = ReturnType<typeof useCountDocumentAuditFileIssuerSuspenseQuery>;
export type CountDocumentAuditFileIssuerQueryResult = ApolloReact.useQuery.Result<CountDocumentAuditFileIssuerQuery, CountDocumentAuditFileIssuerQueryVariables>;
export const CountDocumentBaseByTypeDocument = gql`
    query countDocumentBaseByType($where: DocumentBaseWhereInput!) {
  count: countDocumentBaseByType(where: $where)
}
    `;

/**
 * __useCountDocumentBaseByTypeQuery__
 *
 * To run a query within a React component, call `useCountDocumentBaseByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountDocumentBaseByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountDocumentBaseByTypeQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountDocumentBaseByTypeQuery(baseOptions: ApolloReact.useQuery.Options<CountDocumentBaseByTypeQuery, CountDocumentBaseByTypeQueryVariables> & ({ variables: CountDocumentBaseByTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<CountDocumentBaseByTypeQuery, CountDocumentBaseByTypeQueryVariables>(CountDocumentBaseByTypeDocument, options);
      }
export function useCountDocumentBaseByTypeLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<CountDocumentBaseByTypeQuery, CountDocumentBaseByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<CountDocumentBaseByTypeQuery, CountDocumentBaseByTypeQueryVariables>(CountDocumentBaseByTypeDocument, options);
        }
export function useCountDocumentBaseByTypeSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<CountDocumentBaseByTypeQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<CountDocumentBaseByTypeQuery, CountDocumentBaseByTypeQueryVariables>(CountDocumentBaseByTypeDocument, options);
        }
export type CountDocumentBaseByTypeQueryHookResult = ReturnType<typeof useCountDocumentBaseByTypeQuery>;
export type CountDocumentBaseByTypeLazyQueryHookResult = ReturnType<typeof useCountDocumentBaseByTypeLazyQuery>;
export type CountDocumentBaseByTypeSuspenseQueryHookResult = ReturnType<typeof useCountDocumentBaseByTypeSuspenseQuery>;
export type CountDocumentBaseByTypeQueryResult = ApolloReact.useQuery.Result<CountDocumentBaseByTypeQuery, CountDocumentBaseByTypeQueryVariables>;
export const CountDocumentCertificateDocument = gql`
    query countDocumentCertificate($where: DocumentCertificateWhereInput) {
  count: countDocumentCertificate(where: $where)
}
    `;

/**
 * __useCountDocumentCertificateQuery__
 *
 * To run a query within a React component, call `useCountDocumentCertificateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountDocumentCertificateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountDocumentCertificateQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountDocumentCertificateQuery(baseOptions?: ApolloReact.useQuery.Options<CountDocumentCertificateQuery, CountDocumentCertificateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<CountDocumentCertificateQuery, CountDocumentCertificateQueryVariables>(CountDocumentCertificateDocument, options);
      }
export function useCountDocumentCertificateLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<CountDocumentCertificateQuery, CountDocumentCertificateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<CountDocumentCertificateQuery, CountDocumentCertificateQueryVariables>(CountDocumentCertificateDocument, options);
        }
export function useCountDocumentCertificateSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<CountDocumentCertificateQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<CountDocumentCertificateQuery, CountDocumentCertificateQueryVariables>(CountDocumentCertificateDocument, options);
        }
export type CountDocumentCertificateQueryHookResult = ReturnType<typeof useCountDocumentCertificateQuery>;
export type CountDocumentCertificateLazyQueryHookResult = ReturnType<typeof useCountDocumentCertificateLazyQuery>;
export type CountDocumentCertificateSuspenseQueryHookResult = ReturnType<typeof useCountDocumentCertificateSuspenseQuery>;
export type CountDocumentCertificateQueryResult = ApolloReact.useQuery.Result<CountDocumentCertificateQuery, CountDocumentCertificateQueryVariables>;
export const CountDocumentDegreeDocument = gql`
    query countDocumentDegree($where: DocumentDegreeWhereInput) {
  count: countDegree(where: $where)
}
    `;

/**
 * __useCountDocumentDegreeQuery__
 *
 * To run a query within a React component, call `useCountDocumentDegreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountDocumentDegreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountDocumentDegreeQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountDocumentDegreeQuery(baseOptions?: ApolloReact.useQuery.Options<CountDocumentDegreeQuery, CountDocumentDegreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<CountDocumentDegreeQuery, CountDocumentDegreeQueryVariables>(CountDocumentDegreeDocument, options);
      }
export function useCountDocumentDegreeLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<CountDocumentDegreeQuery, CountDocumentDegreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<CountDocumentDegreeQuery, CountDocumentDegreeQueryVariables>(CountDocumentDegreeDocument, options);
        }
export function useCountDocumentDegreeSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<CountDocumentDegreeQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<CountDocumentDegreeQuery, CountDocumentDegreeQueryVariables>(CountDocumentDegreeDocument, options);
        }
export type CountDocumentDegreeQueryHookResult = ReturnType<typeof useCountDocumentDegreeQuery>;
export type CountDocumentDegreeLazyQueryHookResult = ReturnType<typeof useCountDocumentDegreeLazyQuery>;
export type CountDocumentDegreeSuspenseQueryHookResult = ReturnType<typeof useCountDocumentDegreeSuspenseQuery>;
export type CountDocumentDegreeQueryResult = ApolloReact.useQuery.Result<CountDocumentDegreeQuery, CountDocumentDegreeQueryVariables>;
export const CountDocumentFinalAcademicTranscriptDocument = gql`
    query countDocumentFinalAcademicTranscript($where: DocumentFinalAcademicTranscriptWhereInput) {
  count: countDocumentFinalAcademicTranscript(where: $where)
}
    `;

/**
 * __useCountDocumentFinalAcademicTranscriptQuery__
 *
 * To run a query within a React component, call `useCountDocumentFinalAcademicTranscriptQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountDocumentFinalAcademicTranscriptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountDocumentFinalAcademicTranscriptQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountDocumentFinalAcademicTranscriptQuery(baseOptions?: ApolloReact.useQuery.Options<CountDocumentFinalAcademicTranscriptQuery, CountDocumentFinalAcademicTranscriptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<CountDocumentFinalAcademicTranscriptQuery, CountDocumentFinalAcademicTranscriptQueryVariables>(CountDocumentFinalAcademicTranscriptDocument, options);
      }
export function useCountDocumentFinalAcademicTranscriptLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<CountDocumentFinalAcademicTranscriptQuery, CountDocumentFinalAcademicTranscriptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<CountDocumentFinalAcademicTranscriptQuery, CountDocumentFinalAcademicTranscriptQueryVariables>(CountDocumentFinalAcademicTranscriptDocument, options);
        }
export function useCountDocumentFinalAcademicTranscriptSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<CountDocumentFinalAcademicTranscriptQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<CountDocumentFinalAcademicTranscriptQuery, CountDocumentFinalAcademicTranscriptQueryVariables>(CountDocumentFinalAcademicTranscriptDocument, options);
        }
export type CountDocumentFinalAcademicTranscriptQueryHookResult = ReturnType<typeof useCountDocumentFinalAcademicTranscriptQuery>;
export type CountDocumentFinalAcademicTranscriptLazyQueryHookResult = ReturnType<typeof useCountDocumentFinalAcademicTranscriptLazyQuery>;
export type CountDocumentFinalAcademicTranscriptSuspenseQueryHookResult = ReturnType<typeof useCountDocumentFinalAcademicTranscriptSuspenseQuery>;
export type CountDocumentFinalAcademicTranscriptQueryResult = ApolloReact.useQuery.Result<CountDocumentFinalAcademicTranscriptQuery, CountDocumentFinalAcademicTranscriptQueryVariables>;
export const CountDocumentRenotarizationDocument = gql`
    query countDocumentRenotarization($where: DocumentRenotarizationWhereInput) {
  count: countDocumentRenotarization(where: $where)
}
    `;

/**
 * __useCountDocumentRenotarizationQuery__
 *
 * To run a query within a React component, call `useCountDocumentRenotarizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountDocumentRenotarizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountDocumentRenotarizationQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountDocumentRenotarizationQuery(baseOptions?: ApolloReact.useQuery.Options<CountDocumentRenotarizationQuery, CountDocumentRenotarizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<CountDocumentRenotarizationQuery, CountDocumentRenotarizationQueryVariables>(CountDocumentRenotarizationDocument, options);
      }
export function useCountDocumentRenotarizationLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<CountDocumentRenotarizationQuery, CountDocumentRenotarizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<CountDocumentRenotarizationQuery, CountDocumentRenotarizationQueryVariables>(CountDocumentRenotarizationDocument, options);
        }
export function useCountDocumentRenotarizationSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<CountDocumentRenotarizationQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<CountDocumentRenotarizationQuery, CountDocumentRenotarizationQueryVariables>(CountDocumentRenotarizationDocument, options);
        }
export type CountDocumentRenotarizationQueryHookResult = ReturnType<typeof useCountDocumentRenotarizationQuery>;
export type CountDocumentRenotarizationLazyQueryHookResult = ReturnType<typeof useCountDocumentRenotarizationLazyQuery>;
export type CountDocumentRenotarizationSuspenseQueryHookResult = ReturnType<typeof useCountDocumentRenotarizationSuspenseQuery>;
export type CountDocumentRenotarizationQueryResult = ApolloReact.useQuery.Result<CountDocumentRenotarizationQuery, CountDocumentRenotarizationQueryVariables>;
export const CountDocumentSchoolCurriculumDocument = gql`
    query countDocumentSchoolCurriculum($where: DocumentSchoolCurriculumWhereInput) {
  count: countDocumentSchoolCurriculum(where: $where)
}
    `;

/**
 * __useCountDocumentSchoolCurriculumQuery__
 *
 * To run a query within a React component, call `useCountDocumentSchoolCurriculumQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountDocumentSchoolCurriculumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountDocumentSchoolCurriculumQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountDocumentSchoolCurriculumQuery(baseOptions?: ApolloReact.useQuery.Options<CountDocumentSchoolCurriculumQuery, CountDocumentSchoolCurriculumQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<CountDocumentSchoolCurriculumQuery, CountDocumentSchoolCurriculumQueryVariables>(CountDocumentSchoolCurriculumDocument, options);
      }
export function useCountDocumentSchoolCurriculumLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<CountDocumentSchoolCurriculumQuery, CountDocumentSchoolCurriculumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<CountDocumentSchoolCurriculumQuery, CountDocumentSchoolCurriculumQueryVariables>(CountDocumentSchoolCurriculumDocument, options);
        }
export function useCountDocumentSchoolCurriculumSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<CountDocumentSchoolCurriculumQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<CountDocumentSchoolCurriculumQuery, CountDocumentSchoolCurriculumQueryVariables>(CountDocumentSchoolCurriculumDocument, options);
        }
export type CountDocumentSchoolCurriculumQueryHookResult = ReturnType<typeof useCountDocumentSchoolCurriculumQuery>;
export type CountDocumentSchoolCurriculumLazyQueryHookResult = ReturnType<typeof useCountDocumentSchoolCurriculumLazyQuery>;
export type CountDocumentSchoolCurriculumSuspenseQueryHookResult = ReturnType<typeof useCountDocumentSchoolCurriculumSuspenseQuery>;
export type CountDocumentSchoolCurriculumQueryResult = ApolloReact.useQuery.Result<CountDocumentSchoolCurriculumQuery, CountDocumentSchoolCurriculumQueryVariables>;
export const CreateOneMaintainerTeamDocument = gql`
    mutation createOneMaintainerTeam($cnpj: String!, $educationLevelType: [EducationLevelType!]!, $placeholderName: String!) {
  createOneMaintainerTeam(
    CNPJ: $cnpj
    educationLevelType: $educationLevelType
    placeholderName: $placeholderName
  ) {
    id
    cnpj
  }
}
    `;

/**
 * __useCreateOneMaintainerTeamMutation__
 *
 * To run a mutation, you first call `useCreateOneMaintainerTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneMaintainerTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneMaintainerTeamMutation, { data, loading, error }] = useCreateOneMaintainerTeamMutation({
 *   variables: {
 *      cnpj: // value for 'cnpj'
 *      educationLevelType: // value for 'educationLevelType'
 *      placeholderName: // value for 'placeholderName'
 *   },
 * });
 */
export function useCreateOneMaintainerTeamMutation(baseOptions?: ApolloReact.useMutation.Options<CreateOneMaintainerTeamMutation, CreateOneMaintainerTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<CreateOneMaintainerTeamMutation, CreateOneMaintainerTeamMutationVariables>(CreateOneMaintainerTeamDocument, options);
      }
export type CreateOneMaintainerTeamMutationHookResult = ReturnType<typeof useCreateOneMaintainerTeamMutation>;
export type CreateOneMaintainerTeamMutationResult = ApolloReact.useMutation.Result<CreateOneMaintainerTeamMutation>;
export const FindAllCountDocumentRenotarizationDocument = gql`
    query FindAllCountDocumentRenotarization($documentBaseType: DocumentBaseType!) {
  findAllCountDocumentRenotarization(documentBaseType: $documentBaseType) {
    id
    totalDocumentsWithRA
    totalRASignatures
    pending
    expiresIn90Days
    expired
    renotarized
  }
}
    `;

/**
 * __useFindAllCountDocumentRenotarizationQuery__
 *
 * To run a query within a React component, call `useFindAllCountDocumentRenotarizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAllCountDocumentRenotarizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAllCountDocumentRenotarizationQuery({
 *   variables: {
 *      documentBaseType: // value for 'documentBaseType'
 *   },
 * });
 */
export function useFindAllCountDocumentRenotarizationQuery(baseOptions: ApolloReact.useQuery.Options<FindAllCountDocumentRenotarizationQuery, FindAllCountDocumentRenotarizationQueryVariables> & ({ variables: FindAllCountDocumentRenotarizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindAllCountDocumentRenotarizationQuery, FindAllCountDocumentRenotarizationQueryVariables>(FindAllCountDocumentRenotarizationDocument, options);
      }
export function useFindAllCountDocumentRenotarizationLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindAllCountDocumentRenotarizationQuery, FindAllCountDocumentRenotarizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindAllCountDocumentRenotarizationQuery, FindAllCountDocumentRenotarizationQueryVariables>(FindAllCountDocumentRenotarizationDocument, options);
        }
export function useFindAllCountDocumentRenotarizationSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindAllCountDocumentRenotarizationQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindAllCountDocumentRenotarizationQuery, FindAllCountDocumentRenotarizationQueryVariables>(FindAllCountDocumentRenotarizationDocument, options);
        }
export type FindAllCountDocumentRenotarizationQueryHookResult = ReturnType<typeof useFindAllCountDocumentRenotarizationQuery>;
export type FindAllCountDocumentRenotarizationLazyQueryHookResult = ReturnType<typeof useFindAllCountDocumentRenotarizationLazyQuery>;
export type FindAllCountDocumentRenotarizationSuspenseQueryHookResult = ReturnType<typeof useFindAllCountDocumentRenotarizationSuspenseQuery>;
export type FindAllCountDocumentRenotarizationQueryResult = ApolloReact.useQuery.Result<FindAllCountDocumentRenotarizationQuery, FindAllCountDocumentRenotarizationQueryVariables>;
export const FindFirstDocumentAcademicDocumentationDocument = gql`
    query findFirstDocumentAcademicDocumentation($where: DocumentAcademicDocumentationWhereInput!) {
  findFirstDocumentAcademicDocumentation(where: $where) {
    ...DocumentAcademicDocumentationFields
  }
}
    ${DocumentAcademicDocumentationFieldsFragmentDoc}`;

/**
 * __useFindFirstDocumentAcademicDocumentationQuery__
 *
 * To run a query within a React component, call `useFindFirstDocumentAcademicDocumentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindFirstDocumentAcademicDocumentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindFirstDocumentAcademicDocumentationQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindFirstDocumentAcademicDocumentationQuery(baseOptions: ApolloReact.useQuery.Options<FindFirstDocumentAcademicDocumentationQuery, FindFirstDocumentAcademicDocumentationQueryVariables> & ({ variables: FindFirstDocumentAcademicDocumentationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindFirstDocumentAcademicDocumentationQuery, FindFirstDocumentAcademicDocumentationQueryVariables>(FindFirstDocumentAcademicDocumentationDocument, options);
      }
export function useFindFirstDocumentAcademicDocumentationLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindFirstDocumentAcademicDocumentationQuery, FindFirstDocumentAcademicDocumentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindFirstDocumentAcademicDocumentationQuery, FindFirstDocumentAcademicDocumentationQueryVariables>(FindFirstDocumentAcademicDocumentationDocument, options);
        }
export function useFindFirstDocumentAcademicDocumentationSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindFirstDocumentAcademicDocumentationQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindFirstDocumentAcademicDocumentationQuery, FindFirstDocumentAcademicDocumentationQueryVariables>(FindFirstDocumentAcademicDocumentationDocument, options);
        }
export type FindFirstDocumentAcademicDocumentationQueryHookResult = ReturnType<typeof useFindFirstDocumentAcademicDocumentationQuery>;
export type FindFirstDocumentAcademicDocumentationLazyQueryHookResult = ReturnType<typeof useFindFirstDocumentAcademicDocumentationLazyQuery>;
export type FindFirstDocumentAcademicDocumentationSuspenseQueryHookResult = ReturnType<typeof useFindFirstDocumentAcademicDocumentationSuspenseQuery>;
export type FindFirstDocumentAcademicDocumentationQueryResult = ApolloReact.useQuery.Result<FindFirstDocumentAcademicDocumentationQuery, FindFirstDocumentAcademicDocumentationQueryVariables>;
export const FindFirstDocumentBaseSignatureInviteDocument = gql`
    query findFirstDocumentBaseSignatureInvite($where: DocumentBaseSignatureInviteWhereInput) {
  findFirstDocumentBaseSignatureInvite(where: $where) {
    ...DocumentBaseSignatureInviteFields
  }
}
    ${DocumentBaseSignatureInviteFieldsFragmentDoc}`;

/**
 * __useFindFirstDocumentBaseSignatureInviteQuery__
 *
 * To run a query within a React component, call `useFindFirstDocumentBaseSignatureInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindFirstDocumentBaseSignatureInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindFirstDocumentBaseSignatureInviteQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindFirstDocumentBaseSignatureInviteQuery(baseOptions?: ApolloReact.useQuery.Options<FindFirstDocumentBaseSignatureInviteQuery, FindFirstDocumentBaseSignatureInviteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindFirstDocumentBaseSignatureInviteQuery, FindFirstDocumentBaseSignatureInviteQueryVariables>(FindFirstDocumentBaseSignatureInviteDocument, options);
      }
export function useFindFirstDocumentBaseSignatureInviteLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindFirstDocumentBaseSignatureInviteQuery, FindFirstDocumentBaseSignatureInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindFirstDocumentBaseSignatureInviteQuery, FindFirstDocumentBaseSignatureInviteQueryVariables>(FindFirstDocumentBaseSignatureInviteDocument, options);
        }
export function useFindFirstDocumentBaseSignatureInviteSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindFirstDocumentBaseSignatureInviteQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindFirstDocumentBaseSignatureInviteQuery, FindFirstDocumentBaseSignatureInviteQueryVariables>(FindFirstDocumentBaseSignatureInviteDocument, options);
        }
export type FindFirstDocumentBaseSignatureInviteQueryHookResult = ReturnType<typeof useFindFirstDocumentBaseSignatureInviteQuery>;
export type FindFirstDocumentBaseSignatureInviteLazyQueryHookResult = ReturnType<typeof useFindFirstDocumentBaseSignatureInviteLazyQuery>;
export type FindFirstDocumentBaseSignatureInviteSuspenseQueryHookResult = ReturnType<typeof useFindFirstDocumentBaseSignatureInviteSuspenseQuery>;
export type FindFirstDocumentBaseSignatureInviteQueryResult = ApolloReact.useQuery.Result<FindFirstDocumentBaseSignatureInviteQuery, FindFirstDocumentBaseSignatureInviteQueryVariables>;
export const FindFirstDocumentDegreeDocument = gql`
    query findFirstDocumentDegree($where: DocumentDegreeWhereInput!) {
  findFirstDocumentDegree(where: $where) {
    ...DocumentDegreeUniqueFields
  }
}
    ${DocumentDegreeUniqueFieldsFragmentDoc}`;

/**
 * __useFindFirstDocumentDegreeQuery__
 *
 * To run a query within a React component, call `useFindFirstDocumentDegreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindFirstDocumentDegreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindFirstDocumentDegreeQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindFirstDocumentDegreeQuery(baseOptions: ApolloReact.useQuery.Options<FindFirstDocumentDegreeQuery, FindFirstDocumentDegreeQueryVariables> & ({ variables: FindFirstDocumentDegreeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindFirstDocumentDegreeQuery, FindFirstDocumentDegreeQueryVariables>(FindFirstDocumentDegreeDocument, options);
      }
export function useFindFirstDocumentDegreeLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindFirstDocumentDegreeQuery, FindFirstDocumentDegreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindFirstDocumentDegreeQuery, FindFirstDocumentDegreeQueryVariables>(FindFirstDocumentDegreeDocument, options);
        }
export function useFindFirstDocumentDegreeSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindFirstDocumentDegreeQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindFirstDocumentDegreeQuery, FindFirstDocumentDegreeQueryVariables>(FindFirstDocumentDegreeDocument, options);
        }
export type FindFirstDocumentDegreeQueryHookResult = ReturnType<typeof useFindFirstDocumentDegreeQuery>;
export type FindFirstDocumentDegreeLazyQueryHookResult = ReturnType<typeof useFindFirstDocumentDegreeLazyQuery>;
export type FindFirstDocumentDegreeSuspenseQueryHookResult = ReturnType<typeof useFindFirstDocumentDegreeSuspenseQuery>;
export type FindFirstDocumentDegreeQueryResult = ApolloReact.useQuery.Result<FindFirstDocumentDegreeQuery, FindFirstDocumentDegreeQueryVariables>;
export const FindFirstReusableFormDataDocument = gql`
    query findFirstReusableFormData($where: ReusableFormDataWhereInput) {
  findFirstReusableFormData(where: $where) {
    id
    createdAt
    data
    type
  }
}
    `;

/**
 * __useFindFirstReusableFormDataQuery__
 *
 * To run a query within a React component, call `useFindFirstReusableFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindFirstReusableFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindFirstReusableFormDataQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindFirstReusableFormDataQuery(baseOptions?: ApolloReact.useQuery.Options<FindFirstReusableFormDataQuery, FindFirstReusableFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindFirstReusableFormDataQuery, FindFirstReusableFormDataQueryVariables>(FindFirstReusableFormDataDocument, options);
      }
export function useFindFirstReusableFormDataLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindFirstReusableFormDataQuery, FindFirstReusableFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindFirstReusableFormDataQuery, FindFirstReusableFormDataQueryVariables>(FindFirstReusableFormDataDocument, options);
        }
export function useFindFirstReusableFormDataSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindFirstReusableFormDataQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindFirstReusableFormDataQuery, FindFirstReusableFormDataQueryVariables>(FindFirstReusableFormDataDocument, options);
        }
export type FindFirstReusableFormDataQueryHookResult = ReturnType<typeof useFindFirstReusableFormDataQuery>;
export type FindFirstReusableFormDataLazyQueryHookResult = ReturnType<typeof useFindFirstReusableFormDataLazyQuery>;
export type FindFirstReusableFormDataSuspenseQueryHookResult = ReturnType<typeof useFindFirstReusableFormDataSuspenseQuery>;
export type FindFirstReusableFormDataQueryResult = ApolloReact.useQuery.Result<FindFirstReusableFormDataQuery, FindFirstReusableFormDataQueryVariables>;
export const FindFirstTeamMemberDocument = gql`
    query findFirstTeamMember($where: TeamMemberWhereInput) {
  findFirstTeamMember(where: $where) {
    ...TeamMemberFields
  }
}
    ${TeamMemberFieldsFragmentDoc}`;

/**
 * __useFindFirstTeamMemberQuery__
 *
 * To run a query within a React component, call `useFindFirstTeamMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindFirstTeamMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindFirstTeamMemberQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindFirstTeamMemberQuery(baseOptions?: ApolloReact.useQuery.Options<FindFirstTeamMemberQuery, FindFirstTeamMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindFirstTeamMemberQuery, FindFirstTeamMemberQueryVariables>(FindFirstTeamMemberDocument, options);
      }
export function useFindFirstTeamMemberLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindFirstTeamMemberQuery, FindFirstTeamMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindFirstTeamMemberQuery, FindFirstTeamMemberQueryVariables>(FindFirstTeamMemberDocument, options);
        }
export function useFindFirstTeamMemberSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindFirstTeamMemberQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindFirstTeamMemberQuery, FindFirstTeamMemberQueryVariables>(FindFirstTeamMemberDocument, options);
        }
export type FindFirstTeamMemberQueryHookResult = ReturnType<typeof useFindFirstTeamMemberQuery>;
export type FindFirstTeamMemberLazyQueryHookResult = ReturnType<typeof useFindFirstTeamMemberLazyQuery>;
export type FindFirstTeamMemberSuspenseQueryHookResult = ReturnType<typeof useFindFirstTeamMemberSuspenseQuery>;
export type FindFirstTeamMemberQueryResult = ApolloReact.useQuery.Result<FindFirstTeamMemberQuery, FindFirstTeamMemberQueryVariables>;
export const FindManyDocumentAcademicDocumentationDocument = gql`
    query findManyDocumentAcademicDocumentation($take: Int, $orderBy: [DocumentAcademicDocumentationOrderByWithRelationInput!], $skip: Int, $where: DocumentAcademicDocumentationWhereInput) {
  findManyDocumentAcademicDocumentation(
    take: $take
    orderBy: $orderBy
    skip: $skip
    where: $where
  ) {
    ...DocumentAcademicDocumentationTableFields
  }
  count: countDocumentAcademicDocumentation(where: $where)
}
    ${DocumentAcademicDocumentationTableFieldsFragmentDoc}`;

/**
 * __useFindManyDocumentAcademicDocumentationQuery__
 *
 * To run a query within a React component, call `useFindManyDocumentAcademicDocumentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyDocumentAcademicDocumentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyDocumentAcademicDocumentationQuery({
 *   variables: {
 *      take: // value for 'take'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindManyDocumentAcademicDocumentationQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyDocumentAcademicDocumentationQuery, FindManyDocumentAcademicDocumentationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyDocumentAcademicDocumentationQuery, FindManyDocumentAcademicDocumentationQueryVariables>(FindManyDocumentAcademicDocumentationDocument, options);
      }
export function useFindManyDocumentAcademicDocumentationLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyDocumentAcademicDocumentationQuery, FindManyDocumentAcademicDocumentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyDocumentAcademicDocumentationQuery, FindManyDocumentAcademicDocumentationQueryVariables>(FindManyDocumentAcademicDocumentationDocument, options);
        }
export function useFindManyDocumentAcademicDocumentationSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyDocumentAcademicDocumentationQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyDocumentAcademicDocumentationQuery, FindManyDocumentAcademicDocumentationQueryVariables>(FindManyDocumentAcademicDocumentationDocument, options);
        }
export type FindManyDocumentAcademicDocumentationQueryHookResult = ReturnType<typeof useFindManyDocumentAcademicDocumentationQuery>;
export type FindManyDocumentAcademicDocumentationLazyQueryHookResult = ReturnType<typeof useFindManyDocumentAcademicDocumentationLazyQuery>;
export type FindManyDocumentAcademicDocumentationSuspenseQueryHookResult = ReturnType<typeof useFindManyDocumentAcademicDocumentationSuspenseQuery>;
export type FindManyDocumentAcademicDocumentationQueryResult = ApolloReact.useQuery.Result<FindManyDocumentAcademicDocumentationQuery, FindManyDocumentAcademicDocumentationQueryVariables>;
export const FindManyDocumentBaseSignatureInviteDocument = gql`
    query findManyDocumentBaseSignatureInvite($where: DocumentBaseSignatureInviteWhereInput, $take: Int, $skip: Int, $orderBy: [DocumentBaseSignatureInviteOrderByWithRelationInput!]) {
  findManyDocumentBaseSignatureInvite(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    ...DocumentBaseSignatureInviteFields
  }
  count: countDocumentBaseSignatureInvite(where: $where)
}
    ${DocumentBaseSignatureInviteFieldsFragmentDoc}`;

/**
 * __useFindManyDocumentBaseSignatureInviteQuery__
 *
 * To run a query within a React component, call `useFindManyDocumentBaseSignatureInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyDocumentBaseSignatureInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyDocumentBaseSignatureInviteQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyDocumentBaseSignatureInviteQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyDocumentBaseSignatureInviteQuery, FindManyDocumentBaseSignatureInviteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyDocumentBaseSignatureInviteQuery, FindManyDocumentBaseSignatureInviteQueryVariables>(FindManyDocumentBaseSignatureInviteDocument, options);
      }
export function useFindManyDocumentBaseSignatureInviteLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyDocumentBaseSignatureInviteQuery, FindManyDocumentBaseSignatureInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyDocumentBaseSignatureInviteQuery, FindManyDocumentBaseSignatureInviteQueryVariables>(FindManyDocumentBaseSignatureInviteDocument, options);
        }
export function useFindManyDocumentBaseSignatureInviteSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyDocumentBaseSignatureInviteQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyDocumentBaseSignatureInviteQuery, FindManyDocumentBaseSignatureInviteQueryVariables>(FindManyDocumentBaseSignatureInviteDocument, options);
        }
export type FindManyDocumentBaseSignatureInviteQueryHookResult = ReturnType<typeof useFindManyDocumentBaseSignatureInviteQuery>;
export type FindManyDocumentBaseSignatureInviteLazyQueryHookResult = ReturnType<typeof useFindManyDocumentBaseSignatureInviteLazyQuery>;
export type FindManyDocumentBaseSignatureInviteSuspenseQueryHookResult = ReturnType<typeof useFindManyDocumentBaseSignatureInviteSuspenseQuery>;
export type FindManyDocumentBaseSignatureInviteQueryResult = ApolloReact.useQuery.Result<FindManyDocumentBaseSignatureInviteQuery, FindManyDocumentBaseSignatureInviteQueryVariables>;
export const FindManyApiKeyDocument = gql`
    query findManyApiKey($where: ApiKeyWhereInput, $take: Int, $skip: Int, $orderBy: [ApiKeyOrderByWithRelationInput!]) {
  findManyApiKey(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    id
    description
    createdAt
  }
  count: countApiKey(where: $where)
}
    `;

/**
 * __useFindManyApiKeyQuery__
 *
 * To run a query within a React component, call `useFindManyApiKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyApiKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyApiKeyQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyApiKeyQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyApiKeyQuery, FindManyApiKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyApiKeyQuery, FindManyApiKeyQueryVariables>(FindManyApiKeyDocument, options);
      }
export function useFindManyApiKeyLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyApiKeyQuery, FindManyApiKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyApiKeyQuery, FindManyApiKeyQueryVariables>(FindManyApiKeyDocument, options);
        }
export function useFindManyApiKeySuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyApiKeyQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyApiKeyQuery, FindManyApiKeyQueryVariables>(FindManyApiKeyDocument, options);
        }
export type FindManyApiKeyQueryHookResult = ReturnType<typeof useFindManyApiKeyQuery>;
export type FindManyApiKeyLazyQueryHookResult = ReturnType<typeof useFindManyApiKeyLazyQuery>;
export type FindManyApiKeySuspenseQueryHookResult = ReturnType<typeof useFindManyApiKeySuspenseQuery>;
export type FindManyApiKeyQueryResult = ApolloReact.useQuery.Result<FindManyApiKeyQuery, FindManyApiKeyQueryVariables>;
export const FindManyBulkCertificateRecordDocument = gql`
    query findManyBulkCertificateRecord($where: BulkCertificateRecordWhereInput, $take: Int, $skip: Int, $orderBy: [BulkCertificateRecordOrderByWithRelationInput!]) {
  findManyBulkCertificateRecord(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    id
    bulkCertificateRecordName
    totalCertificates
    createdAt
  }
  count: countBulkCertificateRecord(where: $where)
}
    `;

/**
 * __useFindManyBulkCertificateRecordQuery__
 *
 * To run a query within a React component, call `useFindManyBulkCertificateRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyBulkCertificateRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyBulkCertificateRecordQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyBulkCertificateRecordQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyBulkCertificateRecordQuery, FindManyBulkCertificateRecordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyBulkCertificateRecordQuery, FindManyBulkCertificateRecordQueryVariables>(FindManyBulkCertificateRecordDocument, options);
      }
export function useFindManyBulkCertificateRecordLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyBulkCertificateRecordQuery, FindManyBulkCertificateRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyBulkCertificateRecordQuery, FindManyBulkCertificateRecordQueryVariables>(FindManyBulkCertificateRecordDocument, options);
        }
export function useFindManyBulkCertificateRecordSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyBulkCertificateRecordQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyBulkCertificateRecordQuery, FindManyBulkCertificateRecordQueryVariables>(FindManyBulkCertificateRecordDocument, options);
        }
export type FindManyBulkCertificateRecordQueryHookResult = ReturnType<typeof useFindManyBulkCertificateRecordQuery>;
export type FindManyBulkCertificateRecordLazyQueryHookResult = ReturnType<typeof useFindManyBulkCertificateRecordLazyQuery>;
export type FindManyBulkCertificateRecordSuspenseQueryHookResult = ReturnType<typeof useFindManyBulkCertificateRecordSuspenseQuery>;
export type FindManyBulkCertificateRecordQueryResult = ApolloReact.useQuery.Result<FindManyBulkCertificateRecordQuery, FindManyBulkCertificateRecordQueryVariables>;
export const FindManyCertificateCourseDocument = gql`
    query findManyCertificateCourse($where: CertificateCourseWhereInput, $take: Int, $skip: Int, $orderBy: [CertificateCourseOrderByWithRelationInput!]) {
  findManyCertificateCourse(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    ...CertificateCourseFields
  }
  count: countCertificateCourse(where: $where)
}
    ${CertificateCourseFieldsFragmentDoc}`;

/**
 * __useFindManyCertificateCourseQuery__
 *
 * To run a query within a React component, call `useFindManyCertificateCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyCertificateCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyCertificateCourseQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyCertificateCourseQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyCertificateCourseQuery, FindManyCertificateCourseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyCertificateCourseQuery, FindManyCertificateCourseQueryVariables>(FindManyCertificateCourseDocument, options);
      }
export function useFindManyCertificateCourseLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyCertificateCourseQuery, FindManyCertificateCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyCertificateCourseQuery, FindManyCertificateCourseQueryVariables>(FindManyCertificateCourseDocument, options);
        }
export function useFindManyCertificateCourseSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyCertificateCourseQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyCertificateCourseQuery, FindManyCertificateCourseQueryVariables>(FindManyCertificateCourseDocument, options);
        }
export type FindManyCertificateCourseQueryHookResult = ReturnType<typeof useFindManyCertificateCourseQuery>;
export type FindManyCertificateCourseLazyQueryHookResult = ReturnType<typeof useFindManyCertificateCourseLazyQuery>;
export type FindManyCertificateCourseSuspenseQueryHookResult = ReturnType<typeof useFindManyCertificateCourseSuspenseQuery>;
export type FindManyCertificateCourseQueryResult = ApolloReact.useQuery.Result<FindManyCertificateCourseQuery, FindManyCertificateCourseQueryVariables>;
export const FindManyCertificateCourseLevelDocument = gql`
    query findManyCertificateCourseLevel($where: CertificateCourseLevelWhereInput, $take: Int, $skip: Int, $orderBy: [CertificateCourseLevelOrderByWithRelationInput!]) {
  findManyCertificateCourseLevel(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    ...CertificateCourseLevelFields
  }
  count: countCertificateCourseLevel(where: $where)
}
    ${CertificateCourseLevelFieldsFragmentDoc}`;

/**
 * __useFindManyCertificateCourseLevelQuery__
 *
 * To run a query within a React component, call `useFindManyCertificateCourseLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyCertificateCourseLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyCertificateCourseLevelQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyCertificateCourseLevelQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyCertificateCourseLevelQuery, FindManyCertificateCourseLevelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyCertificateCourseLevelQuery, FindManyCertificateCourseLevelQueryVariables>(FindManyCertificateCourseLevelDocument, options);
      }
export function useFindManyCertificateCourseLevelLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyCertificateCourseLevelQuery, FindManyCertificateCourseLevelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyCertificateCourseLevelQuery, FindManyCertificateCourseLevelQueryVariables>(FindManyCertificateCourseLevelDocument, options);
        }
export function useFindManyCertificateCourseLevelSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyCertificateCourseLevelQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyCertificateCourseLevelQuery, FindManyCertificateCourseLevelQueryVariables>(FindManyCertificateCourseLevelDocument, options);
        }
export type FindManyCertificateCourseLevelQueryHookResult = ReturnType<typeof useFindManyCertificateCourseLevelQuery>;
export type FindManyCertificateCourseLevelLazyQueryHookResult = ReturnType<typeof useFindManyCertificateCourseLevelLazyQuery>;
export type FindManyCertificateCourseLevelSuspenseQueryHookResult = ReturnType<typeof useFindManyCertificateCourseLevelSuspenseQuery>;
export type FindManyCertificateCourseLevelQueryResult = ApolloReact.useQuery.Result<FindManyCertificateCourseLevelQuery, FindManyCertificateCourseLevelQueryVariables>;
export const FindManyCertificateCurriculumDocument = gql`
    query findManyCertificateCurriculum($where: CertificateCurriculumWhereInput, $take: Int, $skip: Int, $orderBy: [CertificateCurriculumOrderByWithRelationInput!]) {
  findManyCertificateCurriculum(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    ...CertificateCurriculumFields
  }
  count: countCertificateCurriculum(where: $where)
}
    ${CertificateCurriculumFieldsFragmentDoc}`;

/**
 * __useFindManyCertificateCurriculumQuery__
 *
 * To run a query within a React component, call `useFindManyCertificateCurriculumQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyCertificateCurriculumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyCertificateCurriculumQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyCertificateCurriculumQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyCertificateCurriculumQuery, FindManyCertificateCurriculumQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyCertificateCurriculumQuery, FindManyCertificateCurriculumQueryVariables>(FindManyCertificateCurriculumDocument, options);
      }
export function useFindManyCertificateCurriculumLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyCertificateCurriculumQuery, FindManyCertificateCurriculumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyCertificateCurriculumQuery, FindManyCertificateCurriculumQueryVariables>(FindManyCertificateCurriculumDocument, options);
        }
export function useFindManyCertificateCurriculumSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyCertificateCurriculumQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyCertificateCurriculumQuery, FindManyCertificateCurriculumQueryVariables>(FindManyCertificateCurriculumDocument, options);
        }
export type FindManyCertificateCurriculumQueryHookResult = ReturnType<typeof useFindManyCertificateCurriculumQuery>;
export type FindManyCertificateCurriculumLazyQueryHookResult = ReturnType<typeof useFindManyCertificateCurriculumLazyQuery>;
export type FindManyCertificateCurriculumSuspenseQueryHookResult = ReturnType<typeof useFindManyCertificateCurriculumSuspenseQuery>;
export type FindManyCertificateCurriculumQueryResult = ApolloReact.useQuery.Result<FindManyCertificateCurriculumQuery, FindManyCertificateCurriculumQueryVariables>;
export const FindManyCertificateDisciplineDocument = gql`
    query findManyCertificateDiscipline($where: CertificateDisciplineWhereInput, $take: Int, $skip: Int, $orderBy: [CertificateDisciplineOrderByWithRelationInput!]) {
  findManyCertificateDiscipline(
    take: $take
    skip: $skip
    orderBy: $orderBy
    where: $where
  ) {
    id
    certificateBaseId
    name
    viewOnDegree
    CertificateBase {
      id
      createdAt
    }
  }
  count: countCertificateDiscipline(where: $where)
}
    `;

/**
 * __useFindManyCertificateDisciplineQuery__
 *
 * To run a query within a React component, call `useFindManyCertificateDisciplineQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyCertificateDisciplineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyCertificateDisciplineQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyCertificateDisciplineQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyCertificateDisciplineQuery, FindManyCertificateDisciplineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyCertificateDisciplineQuery, FindManyCertificateDisciplineQueryVariables>(FindManyCertificateDisciplineDocument, options);
      }
export function useFindManyCertificateDisciplineLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyCertificateDisciplineQuery, FindManyCertificateDisciplineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyCertificateDisciplineQuery, FindManyCertificateDisciplineQueryVariables>(FindManyCertificateDisciplineDocument, options);
        }
export function useFindManyCertificateDisciplineSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyCertificateDisciplineQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyCertificateDisciplineQuery, FindManyCertificateDisciplineQueryVariables>(FindManyCertificateDisciplineDocument, options);
        }
export type FindManyCertificateDisciplineQueryHookResult = ReturnType<typeof useFindManyCertificateDisciplineQuery>;
export type FindManyCertificateDisciplineLazyQueryHookResult = ReturnType<typeof useFindManyCertificateDisciplineLazyQuery>;
export type FindManyCertificateDisciplineSuspenseQueryHookResult = ReturnType<typeof useFindManyCertificateDisciplineSuspenseQuery>;
export type FindManyCertificateDisciplineQueryResult = ApolloReact.useQuery.Result<FindManyCertificateDisciplineQuery, FindManyCertificateDisciplineQueryVariables>;
export const FindManyCertificateEventDocument = gql`
    query findManyCertificateEvent($where: CertificateEventWhereInput, $take: Int, $skip: Int, $orderBy: [CertificateEventOrderByWithRelationInput!]) {
  findManyCertificateEvent(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    ...CertificateEventFields
  }
  count: countCertificateEvent(where: $where)
}
    ${CertificateEventFieldsFragmentDoc}`;

/**
 * __useFindManyCertificateEventQuery__
 *
 * To run a query within a React component, call `useFindManyCertificateEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyCertificateEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyCertificateEventQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyCertificateEventQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyCertificateEventQuery, FindManyCertificateEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyCertificateEventQuery, FindManyCertificateEventQueryVariables>(FindManyCertificateEventDocument, options);
      }
export function useFindManyCertificateEventLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyCertificateEventQuery, FindManyCertificateEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyCertificateEventQuery, FindManyCertificateEventQueryVariables>(FindManyCertificateEventDocument, options);
        }
export function useFindManyCertificateEventSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyCertificateEventQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyCertificateEventQuery, FindManyCertificateEventQueryVariables>(FindManyCertificateEventDocument, options);
        }
export type FindManyCertificateEventQueryHookResult = ReturnType<typeof useFindManyCertificateEventQuery>;
export type FindManyCertificateEventLazyQueryHookResult = ReturnType<typeof useFindManyCertificateEventLazyQuery>;
export type FindManyCertificateEventSuspenseQueryHookResult = ReturnType<typeof useFindManyCertificateEventSuspenseQuery>;
export type FindManyCertificateEventQueryResult = ApolloReact.useQuery.Result<FindManyCertificateEventQuery, FindManyCertificateEventQueryVariables>;
export const FindManyCertificateTeacherDocument = gql`
    query findManyCertificateTeacher($where: CertificateTeacherWhereInput, $take: Int, $skip: Int, $orderBy: [CertificateTeacherOrderByWithRelationInput!]) {
  findManyCertificateTeacher(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    id
    certificateBaseId
    name
    titration
    CertificateBase {
      id
      createdAt
    }
  }
  count: countCertificateTeacher(where: $where)
}
    `;

/**
 * __useFindManyCertificateTeacherQuery__
 *
 * To run a query within a React component, call `useFindManyCertificateTeacherQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyCertificateTeacherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyCertificateTeacherQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyCertificateTeacherQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyCertificateTeacherQuery, FindManyCertificateTeacherQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyCertificateTeacherQuery, FindManyCertificateTeacherQueryVariables>(FindManyCertificateTeacherDocument, options);
      }
export function useFindManyCertificateTeacherLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyCertificateTeacherQuery, FindManyCertificateTeacherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyCertificateTeacherQuery, FindManyCertificateTeacherQueryVariables>(FindManyCertificateTeacherDocument, options);
        }
export function useFindManyCertificateTeacherSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyCertificateTeacherQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyCertificateTeacherQuery, FindManyCertificateTeacherQueryVariables>(FindManyCertificateTeacherDocument, options);
        }
export type FindManyCertificateTeacherQueryHookResult = ReturnType<typeof useFindManyCertificateTeacherQuery>;
export type FindManyCertificateTeacherLazyQueryHookResult = ReturnType<typeof useFindManyCertificateTeacherLazyQuery>;
export type FindManyCertificateTeacherSuspenseQueryHookResult = ReturnType<typeof useFindManyCertificateTeacherSuspenseQuery>;
export type FindManyCertificateTeacherQueryResult = ApolloReact.useQuery.Result<FindManyCertificateTeacherQuery, FindManyCertificateTeacherQueryVariables>;
export const FindManyCertificateTemplateDocument = gql`
    query findManyCertificateTemplate($where: CertificateTemplateWhereInput, $take: Int, $skip: Int, $orderBy: [CertificateTemplateOrderByWithRelationInput!]) {
  items: findManyCertificateTemplate(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    ...CertificateTemplateManyFields
  }
  count: countCertificateTemplate(where: $where)
}
    ${CertificateTemplateManyFieldsFragmentDoc}`;

/**
 * __useFindManyCertificateTemplateQuery__
 *
 * To run a query within a React component, call `useFindManyCertificateTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyCertificateTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyCertificateTemplateQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyCertificateTemplateQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyCertificateTemplateQuery, FindManyCertificateTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyCertificateTemplateQuery, FindManyCertificateTemplateQueryVariables>(FindManyCertificateTemplateDocument, options);
      }
export function useFindManyCertificateTemplateLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyCertificateTemplateQuery, FindManyCertificateTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyCertificateTemplateQuery, FindManyCertificateTemplateQueryVariables>(FindManyCertificateTemplateDocument, options);
        }
export function useFindManyCertificateTemplateSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyCertificateTemplateQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyCertificateTemplateQuery, FindManyCertificateTemplateQueryVariables>(FindManyCertificateTemplateDocument, options);
        }
export type FindManyCertificateTemplateQueryHookResult = ReturnType<typeof useFindManyCertificateTemplateQuery>;
export type FindManyCertificateTemplateLazyQueryHookResult = ReturnType<typeof useFindManyCertificateTemplateLazyQuery>;
export type FindManyCertificateTemplateSuspenseQueryHookResult = ReturnType<typeof useFindManyCertificateTemplateSuspenseQuery>;
export type FindManyCertificateTemplateQueryResult = ApolloReact.useQuery.Result<FindManyCertificateTemplateQuery, FindManyCertificateTemplateQueryVariables>;
export const FindManyCertificateTemplatePresetDocument = gql`
    query findManyCertificateTemplatePreset($where: CertificateTemplatePresetWhereInput, $take: Int, $skip: Int, $orderBy: [CertificateTemplatePresetOrderByWithRelationInput!]) {
  findManyCertificateTemplatePreset(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    name
    imageUrl
    id
    createdAt
  }
  count: countCertificateTemplatePreset(where: $where)
}
    `;

/**
 * __useFindManyCertificateTemplatePresetQuery__
 *
 * To run a query within a React component, call `useFindManyCertificateTemplatePresetQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyCertificateTemplatePresetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyCertificateTemplatePresetQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyCertificateTemplatePresetQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyCertificateTemplatePresetQuery, FindManyCertificateTemplatePresetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyCertificateTemplatePresetQuery, FindManyCertificateTemplatePresetQueryVariables>(FindManyCertificateTemplatePresetDocument, options);
      }
export function useFindManyCertificateTemplatePresetLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyCertificateTemplatePresetQuery, FindManyCertificateTemplatePresetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyCertificateTemplatePresetQuery, FindManyCertificateTemplatePresetQueryVariables>(FindManyCertificateTemplatePresetDocument, options);
        }
export function useFindManyCertificateTemplatePresetSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyCertificateTemplatePresetQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyCertificateTemplatePresetQuery, FindManyCertificateTemplatePresetQueryVariables>(FindManyCertificateTemplatePresetDocument, options);
        }
export type FindManyCertificateTemplatePresetQueryHookResult = ReturnType<typeof useFindManyCertificateTemplatePresetQuery>;
export type FindManyCertificateTemplatePresetLazyQueryHookResult = ReturnType<typeof useFindManyCertificateTemplatePresetLazyQuery>;
export type FindManyCertificateTemplatePresetSuspenseQueryHookResult = ReturnType<typeof useFindManyCertificateTemplatePresetSuspenseQuery>;
export type FindManyCertificateTemplatePresetQueryResult = ApolloReact.useQuery.Result<FindManyCertificateTemplatePresetQuery, FindManyCertificateTemplatePresetQueryVariables>;
export const FindManyCertificatesByBatchIdDocument = gql`
    query FindManyCertificatesByBatchId($batchId: String) {
  findManyCertificatesByBatchId(batchId: $batchId) {
    id
    documentBaseId
    documentCertificateName
    documentCertificateCPF
    status
    DocumentBase {
      id
      createdAt
      filePath
    }
    DocumentCertificateSignatureItems {
      ...DocumentCertificateSignatureItemFields
    }
  }
}
    ${DocumentCertificateSignatureItemFieldsFragmentDoc}`;

/**
 * __useFindManyCertificatesByBatchIdQuery__
 *
 * To run a query within a React component, call `useFindManyCertificatesByBatchIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyCertificatesByBatchIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyCertificatesByBatchIdQuery({
 *   variables: {
 *      batchId: // value for 'batchId'
 *   },
 * });
 */
export function useFindManyCertificatesByBatchIdQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyCertificatesByBatchIdQuery, FindManyCertificatesByBatchIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyCertificatesByBatchIdQuery, FindManyCertificatesByBatchIdQueryVariables>(FindManyCertificatesByBatchIdDocument, options);
      }
export function useFindManyCertificatesByBatchIdLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyCertificatesByBatchIdQuery, FindManyCertificatesByBatchIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyCertificatesByBatchIdQuery, FindManyCertificatesByBatchIdQueryVariables>(FindManyCertificatesByBatchIdDocument, options);
        }
export function useFindManyCertificatesByBatchIdSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyCertificatesByBatchIdQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyCertificatesByBatchIdQuery, FindManyCertificatesByBatchIdQueryVariables>(FindManyCertificatesByBatchIdDocument, options);
        }
export type FindManyCertificatesByBatchIdQueryHookResult = ReturnType<typeof useFindManyCertificatesByBatchIdQuery>;
export type FindManyCertificatesByBatchIdLazyQueryHookResult = ReturnType<typeof useFindManyCertificatesByBatchIdLazyQuery>;
export type FindManyCertificatesByBatchIdSuspenseQueryHookResult = ReturnType<typeof useFindManyCertificatesByBatchIdSuspenseQuery>;
export type FindManyCertificatesByBatchIdQueryResult = ApolloReact.useQuery.Result<FindManyCertificatesByBatchIdQuery, FindManyCertificatesByBatchIdQueryVariables>;
export const FindManyCommonUserDocument = gql`
    query findManyCommonUser($where: CommonUserWhereInput, $take: Int, $skip: Int, $orderBy: [CommonUserOrderByWithRelationInput!]) {
  findManyCommonUser(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    name
    id
    email
    photo
    Team {
      id
      issuerName
      placeholderName
    }
  }
}
    `;

/**
 * __useFindManyCommonUserQuery__
 *
 * To run a query within a React component, call `useFindManyCommonUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyCommonUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyCommonUserQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyCommonUserQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyCommonUserQuery, FindManyCommonUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyCommonUserQuery, FindManyCommonUserQueryVariables>(FindManyCommonUserDocument, options);
      }
export function useFindManyCommonUserLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyCommonUserQuery, FindManyCommonUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyCommonUserQuery, FindManyCommonUserQueryVariables>(FindManyCommonUserDocument, options);
        }
export function useFindManyCommonUserSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyCommonUserQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyCommonUserQuery, FindManyCommonUserQueryVariables>(FindManyCommonUserDocument, options);
        }
export type FindManyCommonUserQueryHookResult = ReturnType<typeof useFindManyCommonUserQuery>;
export type FindManyCommonUserLazyQueryHookResult = ReturnType<typeof useFindManyCommonUserLazyQuery>;
export type FindManyCommonUserSuspenseQueryHookResult = ReturnType<typeof useFindManyCommonUserSuspenseQuery>;
export type FindManyCommonUserQueryResult = ApolloReact.useQuery.Result<FindManyCommonUserQuery, FindManyCommonUserQueryVariables>;
export const FindManyDegreeDocument = gql`
    query FindManyDegree($where: DocumentDegreeWhereInput, $take: Int, $skip: Int, $orderBy: [DocumentDegreeOrderByWithRelationInput!], $isAdminView: Boolean) {
  findManyDegree(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
    isAdminView: $isAdminView
  ) {
    ...DocumentDegreeFields
  }
  count: countDegree(where: $where)
}
    ${DocumentDegreeFieldsFragmentDoc}`;

/**
 * __useFindManyDegreeQuery__
 *
 * To run a query within a React component, call `useFindManyDegreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyDegreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyDegreeQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *      isAdminView: // value for 'isAdminView'
 *   },
 * });
 */
export function useFindManyDegreeQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyDegreeQuery, FindManyDegreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyDegreeQuery, FindManyDegreeQueryVariables>(FindManyDegreeDocument, options);
      }
export function useFindManyDegreeLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyDegreeQuery, FindManyDegreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyDegreeQuery, FindManyDegreeQueryVariables>(FindManyDegreeDocument, options);
        }
export function useFindManyDegreeSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyDegreeQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyDegreeQuery, FindManyDegreeQueryVariables>(FindManyDegreeDocument, options);
        }
export type FindManyDegreeQueryHookResult = ReturnType<typeof useFindManyDegreeQuery>;
export type FindManyDegreeLazyQueryHookResult = ReturnType<typeof useFindManyDegreeLazyQuery>;
export type FindManyDegreeSuspenseQueryHookResult = ReturnType<typeof useFindManyDegreeSuspenseQuery>;
export type FindManyDegreeQueryResult = ApolloReact.useQuery.Result<FindManyDegreeQuery, FindManyDegreeQueryVariables>;
export const FindManyDocumentAuditFileIssuerDocument = gql`
    query findManyDocumentAuditFileIssuer($take: Int, $skip: Int, $where: DocumentAuditFileIssuerWhereInput, $orderBy: [DocumentAuditFileIssuerOrderByWithRelationInput!]) {
  findManyDocumentAuditFileIssuer(
    take: $take
    skip: $skip
    where: $where
    orderBy: $orderBy
  ) {
    id
    documentBaseId
    searchAuditStartDate
    searchAuditEndDate
    status
    DocumentBase {
      id
      filePath
      createdAt
      deletedAt
    }
  }
  count: countDocumentAuditFileIssuer(where: $where)
}
    `;

/**
 * __useFindManyDocumentAuditFileIssuerQuery__
 *
 * To run a query within a React component, call `useFindManyDocumentAuditFileIssuerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyDocumentAuditFileIssuerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyDocumentAuditFileIssuerQuery({
 *   variables: {
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyDocumentAuditFileIssuerQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyDocumentAuditFileIssuerQuery, FindManyDocumentAuditFileIssuerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyDocumentAuditFileIssuerQuery, FindManyDocumentAuditFileIssuerQueryVariables>(FindManyDocumentAuditFileIssuerDocument, options);
      }
export function useFindManyDocumentAuditFileIssuerLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyDocumentAuditFileIssuerQuery, FindManyDocumentAuditFileIssuerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyDocumentAuditFileIssuerQuery, FindManyDocumentAuditFileIssuerQueryVariables>(FindManyDocumentAuditFileIssuerDocument, options);
        }
export function useFindManyDocumentAuditFileIssuerSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyDocumentAuditFileIssuerQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyDocumentAuditFileIssuerQuery, FindManyDocumentAuditFileIssuerQueryVariables>(FindManyDocumentAuditFileIssuerDocument, options);
        }
export type FindManyDocumentAuditFileIssuerQueryHookResult = ReturnType<typeof useFindManyDocumentAuditFileIssuerQuery>;
export type FindManyDocumentAuditFileIssuerLazyQueryHookResult = ReturnType<typeof useFindManyDocumentAuditFileIssuerLazyQuery>;
export type FindManyDocumentAuditFileIssuerSuspenseQueryHookResult = ReturnType<typeof useFindManyDocumentAuditFileIssuerSuspenseQuery>;
export type FindManyDocumentAuditFileIssuerQueryResult = ApolloReact.useQuery.Result<FindManyDocumentAuditFileIssuerQuery, FindManyDocumentAuditFileIssuerQueryVariables>;
export const FindManyDocumentBaseDefaultSignatureInviteConfigurationDocument = gql`
    query findManyDocumentBaseDefaultSignatureInviteConfiguration($where: DocumentBaseDefaultSignatureInviteConfigurationWhereInput, $take: Int, $skip: Int, $orderBy: [DocumentBaseDefaultSignatureInviteConfigurationOrderByWithRelationInput!]) {
  countDocumentBaseDefaultSignatureInviteConfiguration(where: $where)
  findManyDocumentBaseDefaultSignatureInviteConfiguration(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    id
    type
    createdAt
    updatedAt
    Groups {
      id
      Items {
        id
        teamMemberId
        TeamMember {
          id
          User {
            id
            name
            email
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFindManyDocumentBaseDefaultSignatureInviteConfigurationQuery__
 *
 * To run a query within a React component, call `useFindManyDocumentBaseDefaultSignatureInviteConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyDocumentBaseDefaultSignatureInviteConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyDocumentBaseDefaultSignatureInviteConfigurationQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyDocumentBaseDefaultSignatureInviteConfigurationQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyDocumentBaseDefaultSignatureInviteConfigurationQuery, FindManyDocumentBaseDefaultSignatureInviteConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyDocumentBaseDefaultSignatureInviteConfigurationQuery, FindManyDocumentBaseDefaultSignatureInviteConfigurationQueryVariables>(FindManyDocumentBaseDefaultSignatureInviteConfigurationDocument, options);
      }
export function useFindManyDocumentBaseDefaultSignatureInviteConfigurationLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyDocumentBaseDefaultSignatureInviteConfigurationQuery, FindManyDocumentBaseDefaultSignatureInviteConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyDocumentBaseDefaultSignatureInviteConfigurationQuery, FindManyDocumentBaseDefaultSignatureInviteConfigurationQueryVariables>(FindManyDocumentBaseDefaultSignatureInviteConfigurationDocument, options);
        }
export function useFindManyDocumentBaseDefaultSignatureInviteConfigurationSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyDocumentBaseDefaultSignatureInviteConfigurationQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyDocumentBaseDefaultSignatureInviteConfigurationQuery, FindManyDocumentBaseDefaultSignatureInviteConfigurationQueryVariables>(FindManyDocumentBaseDefaultSignatureInviteConfigurationDocument, options);
        }
export type FindManyDocumentBaseDefaultSignatureInviteConfigurationQueryHookResult = ReturnType<typeof useFindManyDocumentBaseDefaultSignatureInviteConfigurationQuery>;
export type FindManyDocumentBaseDefaultSignatureInviteConfigurationLazyQueryHookResult = ReturnType<typeof useFindManyDocumentBaseDefaultSignatureInviteConfigurationLazyQuery>;
export type FindManyDocumentBaseDefaultSignatureInviteConfigurationSuspenseQueryHookResult = ReturnType<typeof useFindManyDocumentBaseDefaultSignatureInviteConfigurationSuspenseQuery>;
export type FindManyDocumentBaseDefaultSignatureInviteConfigurationQueryResult = ApolloReact.useQuery.Result<FindManyDocumentBaseDefaultSignatureInviteConfigurationQuery, FindManyDocumentBaseDefaultSignatureInviteConfigurationQueryVariables>;
export const FindManyDocumentCertificateDocument = gql`
    query findManyDocumentCertificate($where: DocumentCertificateWhereInput, $take: Int, $skip: Int, $orderBy: [DocumentCertificateOrderByWithRelationInput!]) {
  findManyDocumentCertificate(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    id
    documentBaseId
    documentCertificateName
    documentCertificateCPF
    status
    DocumentBase {
      id
      createdAt
      hasFile
      deletedAt
    }
    DocumentCertificateSignatureItems {
      ...DocumentCertificateSignatureItemFields
    }
  }
  count: countDocumentCertificate(where: $where)
}
    ${DocumentCertificateSignatureItemFieldsFragmentDoc}`;

/**
 * __useFindManyDocumentCertificateQuery__
 *
 * To run a query within a React component, call `useFindManyDocumentCertificateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyDocumentCertificateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyDocumentCertificateQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyDocumentCertificateQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyDocumentCertificateQuery, FindManyDocumentCertificateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyDocumentCertificateQuery, FindManyDocumentCertificateQueryVariables>(FindManyDocumentCertificateDocument, options);
      }
export function useFindManyDocumentCertificateLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyDocumentCertificateQuery, FindManyDocumentCertificateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyDocumentCertificateQuery, FindManyDocumentCertificateQueryVariables>(FindManyDocumentCertificateDocument, options);
        }
export function useFindManyDocumentCertificateSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyDocumentCertificateQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyDocumentCertificateQuery, FindManyDocumentCertificateQueryVariables>(FindManyDocumentCertificateDocument, options);
        }
export type FindManyDocumentCertificateQueryHookResult = ReturnType<typeof useFindManyDocumentCertificateQuery>;
export type FindManyDocumentCertificateLazyQueryHookResult = ReturnType<typeof useFindManyDocumentCertificateLazyQuery>;
export type FindManyDocumentCertificateSuspenseQueryHookResult = ReturnType<typeof useFindManyDocumentCertificateSuspenseQuery>;
export type FindManyDocumentCertificateQueryResult = ApolloReact.useQuery.Result<FindManyDocumentCertificateQuery, FindManyDocumentCertificateQueryVariables>;
export const FindManyDocumentCertificateSignatureItemDocument = gql`
    query findManyDocumentCertificateSignatureItem($where: DocumentCertificateSignatureItemWhereInput, $take: Int, $skip: Int, $orderBy: [DocumentCertificateSignatureItemOrderByWithRelationInput!]) {
  findManyDocumentCertificateSignatureItem(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    ...DocumentCertificateSignatureItemBaseFields
    DocumentCertificate {
      id
      DocumentBase {
        id
        internalSeqId
      }
      documentCertificateName
      documentCertificateCPF
      DocumentCertificateSignatureItems {
        ...DocumentCertificateSignatureItemBaseFields
      }
    }
  }
  countDocumentCertificateSignatureItem(where: $where)
}
    ${DocumentCertificateSignatureItemBaseFieldsFragmentDoc}`;

/**
 * __useFindManyDocumentCertificateSignatureItemQuery__
 *
 * To run a query within a React component, call `useFindManyDocumentCertificateSignatureItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyDocumentCertificateSignatureItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyDocumentCertificateSignatureItemQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyDocumentCertificateSignatureItemQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyDocumentCertificateSignatureItemQuery, FindManyDocumentCertificateSignatureItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyDocumentCertificateSignatureItemQuery, FindManyDocumentCertificateSignatureItemQueryVariables>(FindManyDocumentCertificateSignatureItemDocument, options);
      }
export function useFindManyDocumentCertificateSignatureItemLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyDocumentCertificateSignatureItemQuery, FindManyDocumentCertificateSignatureItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyDocumentCertificateSignatureItemQuery, FindManyDocumentCertificateSignatureItemQueryVariables>(FindManyDocumentCertificateSignatureItemDocument, options);
        }
export function useFindManyDocumentCertificateSignatureItemSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyDocumentCertificateSignatureItemQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyDocumentCertificateSignatureItemQuery, FindManyDocumentCertificateSignatureItemQueryVariables>(FindManyDocumentCertificateSignatureItemDocument, options);
        }
export type FindManyDocumentCertificateSignatureItemQueryHookResult = ReturnType<typeof useFindManyDocumentCertificateSignatureItemQuery>;
export type FindManyDocumentCertificateSignatureItemLazyQueryHookResult = ReturnType<typeof useFindManyDocumentCertificateSignatureItemLazyQuery>;
export type FindManyDocumentCertificateSignatureItemSuspenseQueryHookResult = ReturnType<typeof useFindManyDocumentCertificateSignatureItemSuspenseQuery>;
export type FindManyDocumentCertificateSignatureItemQueryResult = ApolloReact.useQuery.Result<FindManyDocumentCertificateSignatureItemQuery, FindManyDocumentCertificateSignatureItemQueryVariables>;
export const FindManyDocumentFinalAcademicTranscriptDocument = gql`
    query findManyDocumentFinalAcademicTranscript($where: DocumentFinalAcademicTranscriptWhereInput, $take: Int, $skip: Int, $orderBy: [DocumentFinalAcademicTranscriptOrderByWithRelationInput!]) {
  findManyDocumentFinalAcademicTranscript(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    id
    documentBaseId
    status
    DocumentBase {
      id
      type
      createdAt
      deletedAt
    }
    searchStudentName
    searchCourse
    searchCPF
    searchEmecCode
  }
  count: countDocumentFinalAcademicTranscript(where: $where)
}
    `;

/**
 * __useFindManyDocumentFinalAcademicTranscriptQuery__
 *
 * To run a query within a React component, call `useFindManyDocumentFinalAcademicTranscriptQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyDocumentFinalAcademicTranscriptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyDocumentFinalAcademicTranscriptQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyDocumentFinalAcademicTranscriptQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyDocumentFinalAcademicTranscriptQuery, FindManyDocumentFinalAcademicTranscriptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyDocumentFinalAcademicTranscriptQuery, FindManyDocumentFinalAcademicTranscriptQueryVariables>(FindManyDocumentFinalAcademicTranscriptDocument, options);
      }
export function useFindManyDocumentFinalAcademicTranscriptLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyDocumentFinalAcademicTranscriptQuery, FindManyDocumentFinalAcademicTranscriptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyDocumentFinalAcademicTranscriptQuery, FindManyDocumentFinalAcademicTranscriptQueryVariables>(FindManyDocumentFinalAcademicTranscriptDocument, options);
        }
export function useFindManyDocumentFinalAcademicTranscriptSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyDocumentFinalAcademicTranscriptQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyDocumentFinalAcademicTranscriptQuery, FindManyDocumentFinalAcademicTranscriptQueryVariables>(FindManyDocumentFinalAcademicTranscriptDocument, options);
        }
export type FindManyDocumentFinalAcademicTranscriptQueryHookResult = ReturnType<typeof useFindManyDocumentFinalAcademicTranscriptQuery>;
export type FindManyDocumentFinalAcademicTranscriptLazyQueryHookResult = ReturnType<typeof useFindManyDocumentFinalAcademicTranscriptLazyQuery>;
export type FindManyDocumentFinalAcademicTranscriptSuspenseQueryHookResult = ReturnType<typeof useFindManyDocumentFinalAcademicTranscriptSuspenseQuery>;
export type FindManyDocumentFinalAcademicTranscriptQueryResult = ApolloReact.useQuery.Result<FindManyDocumentFinalAcademicTranscriptQuery, FindManyDocumentFinalAcademicTranscriptQueryVariables>;
export const FindManyDocumentRenotarizationDocument = gql`
    query findManyDocumentRenotarization($take: Int, $orderBy: [DocumentRenotarizationOrderByWithRelationInput!], $skip: Int, $where: DocumentRenotarizationWhereInput) {
  findManyDocumentRenotarization(
    take: $take
    orderBy: $orderBy
    skip: $skip
    where: $where
  ) {
    ...DocumentRenotarizationTableFields
  }
  count: countDocumentRenotarization(where: $where)
}
    ${DocumentRenotarizationTableFieldsFragmentDoc}`;

/**
 * __useFindManyDocumentRenotarizationQuery__
 *
 * To run a query within a React component, call `useFindManyDocumentRenotarizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyDocumentRenotarizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyDocumentRenotarizationQuery({
 *   variables: {
 *      take: // value for 'take'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindManyDocumentRenotarizationQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyDocumentRenotarizationQuery, FindManyDocumentRenotarizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyDocumentRenotarizationQuery, FindManyDocumentRenotarizationQueryVariables>(FindManyDocumentRenotarizationDocument, options);
      }
export function useFindManyDocumentRenotarizationLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyDocumentRenotarizationQuery, FindManyDocumentRenotarizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyDocumentRenotarizationQuery, FindManyDocumentRenotarizationQueryVariables>(FindManyDocumentRenotarizationDocument, options);
        }
export function useFindManyDocumentRenotarizationSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyDocumentRenotarizationQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyDocumentRenotarizationQuery, FindManyDocumentRenotarizationQueryVariables>(FindManyDocumentRenotarizationDocument, options);
        }
export type FindManyDocumentRenotarizationQueryHookResult = ReturnType<typeof useFindManyDocumentRenotarizationQuery>;
export type FindManyDocumentRenotarizationLazyQueryHookResult = ReturnType<typeof useFindManyDocumentRenotarizationLazyQuery>;
export type FindManyDocumentRenotarizationSuspenseQueryHookResult = ReturnType<typeof useFindManyDocumentRenotarizationSuspenseQuery>;
export type FindManyDocumentRenotarizationQueryResult = ApolloReact.useQuery.Result<FindManyDocumentRenotarizationQuery, FindManyDocumentRenotarizationQueryVariables>;
export const FindManyDocumentRenotarizationForSelectionDocument = gql`
    query findManyDocumentRenotarizationForSelection($where: DocumentRenotarizationWhereInput, $orderBy: [DocumentRenotarizationOrderByWithRelationInput!]) {
  findManyDocumentRenotarization(where: $where, orderBy: $orderBy) {
    id
    documentBaseId
    signatureId
    createdAt
    Histories {
      id
      type
      userName
    }
    DocumentBase {
      id
      internalSeqId
    }
  }
}
    `;

/**
 * __useFindManyDocumentRenotarizationForSelectionQuery__
 *
 * To run a query within a React component, call `useFindManyDocumentRenotarizationForSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyDocumentRenotarizationForSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyDocumentRenotarizationForSelectionQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyDocumentRenotarizationForSelectionQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyDocumentRenotarizationForSelectionQuery, FindManyDocumentRenotarizationForSelectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyDocumentRenotarizationForSelectionQuery, FindManyDocumentRenotarizationForSelectionQueryVariables>(FindManyDocumentRenotarizationForSelectionDocument, options);
      }
export function useFindManyDocumentRenotarizationForSelectionLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyDocumentRenotarizationForSelectionQuery, FindManyDocumentRenotarizationForSelectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyDocumentRenotarizationForSelectionQuery, FindManyDocumentRenotarizationForSelectionQueryVariables>(FindManyDocumentRenotarizationForSelectionDocument, options);
        }
export function useFindManyDocumentRenotarizationForSelectionSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyDocumentRenotarizationForSelectionQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyDocumentRenotarizationForSelectionQuery, FindManyDocumentRenotarizationForSelectionQueryVariables>(FindManyDocumentRenotarizationForSelectionDocument, options);
        }
export type FindManyDocumentRenotarizationForSelectionQueryHookResult = ReturnType<typeof useFindManyDocumentRenotarizationForSelectionQuery>;
export type FindManyDocumentRenotarizationForSelectionLazyQueryHookResult = ReturnType<typeof useFindManyDocumentRenotarizationForSelectionLazyQuery>;
export type FindManyDocumentRenotarizationForSelectionSuspenseQueryHookResult = ReturnType<typeof useFindManyDocumentRenotarizationForSelectionSuspenseQuery>;
export type FindManyDocumentRenotarizationForSelectionQueryResult = ApolloReact.useQuery.Result<FindManyDocumentRenotarizationForSelectionQuery, FindManyDocumentRenotarizationForSelectionQueryVariables>;
export const FindManyDocumentSchoolCurriculumDocument = gql`
    query findManyDocumentSchoolCurriculum($orderBy: [DocumentSchoolCurriculumOrderByWithRelationInput!], $skip: Int, $take: Int, $where: DocumentSchoolCurriculumWhereInput) {
  findManyDocumentSchoolCurriculum(
    orderBy: $orderBy
    skip: $skip
    take: $take
    where: $where
  ) {
    id
    documentBaseId
    searchSchoolCurriculumName
    searchSchoolCurriculumCode
    searchSelectedCourse
    status
    DocumentBase {
      id
      createdAt
      deletedAt
      hasFile
    }
  }
  count: countDocumentSchoolCurriculum(where: $where)
}
    `;

/**
 * __useFindManyDocumentSchoolCurriculumQuery__
 *
 * To run a query within a React component, call `useFindManyDocumentSchoolCurriculumQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyDocumentSchoolCurriculumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyDocumentSchoolCurriculumQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindManyDocumentSchoolCurriculumQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyDocumentSchoolCurriculumQuery, FindManyDocumentSchoolCurriculumQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyDocumentSchoolCurriculumQuery, FindManyDocumentSchoolCurriculumQueryVariables>(FindManyDocumentSchoolCurriculumDocument, options);
      }
export function useFindManyDocumentSchoolCurriculumLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyDocumentSchoolCurriculumQuery, FindManyDocumentSchoolCurriculumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyDocumentSchoolCurriculumQuery, FindManyDocumentSchoolCurriculumQueryVariables>(FindManyDocumentSchoolCurriculumDocument, options);
        }
export function useFindManyDocumentSchoolCurriculumSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyDocumentSchoolCurriculumQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyDocumentSchoolCurriculumQuery, FindManyDocumentSchoolCurriculumQueryVariables>(FindManyDocumentSchoolCurriculumDocument, options);
        }
export type FindManyDocumentSchoolCurriculumQueryHookResult = ReturnType<typeof useFindManyDocumentSchoolCurriculumQuery>;
export type FindManyDocumentSchoolCurriculumLazyQueryHookResult = ReturnType<typeof useFindManyDocumentSchoolCurriculumLazyQuery>;
export type FindManyDocumentSchoolCurriculumSuspenseQueryHookResult = ReturnType<typeof useFindManyDocumentSchoolCurriculumSuspenseQuery>;
export type FindManyDocumentSchoolCurriculumQueryResult = ApolloReact.useQuery.Result<FindManyDocumentSchoolCurriculumQuery, FindManyDocumentSchoolCurriculumQueryVariables>;
export const FindManyEnabledInstitutionDocument = gql`
    query findManyEnabledInstitution($where: EnabledInstitutionWhereInput, $take: Int, $skip: Int, $orderBy: [EnabledInstitutionOrderByWithRelationInput!]) {
  findManyEnabledInstitution(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    ...EnabledInstitutionFields
  }
  count: countEnabledInstitution(where: $where)
  totalIssuedDocuments: countTotalIssuedDocuments
}
    ${EnabledInstitutionFieldsFragmentDoc}`;

/**
 * __useFindManyEnabledInstitutionQuery__
 *
 * To run a query within a React component, call `useFindManyEnabledInstitutionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyEnabledInstitutionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyEnabledInstitutionQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyEnabledInstitutionQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyEnabledInstitutionQuery, FindManyEnabledInstitutionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyEnabledInstitutionQuery, FindManyEnabledInstitutionQueryVariables>(FindManyEnabledInstitutionDocument, options);
      }
export function useFindManyEnabledInstitutionLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyEnabledInstitutionQuery, FindManyEnabledInstitutionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyEnabledInstitutionQuery, FindManyEnabledInstitutionQueryVariables>(FindManyEnabledInstitutionDocument, options);
        }
export function useFindManyEnabledInstitutionSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyEnabledInstitutionQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyEnabledInstitutionQuery, FindManyEnabledInstitutionQueryVariables>(FindManyEnabledInstitutionDocument, options);
        }
export type FindManyEnabledInstitutionQueryHookResult = ReturnType<typeof useFindManyEnabledInstitutionQuery>;
export type FindManyEnabledInstitutionLazyQueryHookResult = ReturnType<typeof useFindManyEnabledInstitutionLazyQuery>;
export type FindManyEnabledInstitutionSuspenseQueryHookResult = ReturnType<typeof useFindManyEnabledInstitutionSuspenseQuery>;
export type FindManyEnabledInstitutionQueryResult = ApolloReact.useQuery.Result<FindManyEnabledInstitutionQuery, FindManyEnabledInstitutionQueryVariables>;
export const FindManyFinancialChargeDocument = gql`
    query findManyFinancialCharge($where: FinancialChargeWhereInput, $take: Int, $skip: Int, $orderBy: [FinancialChargeOrderByWithRelationInput!]) {
  findManyFinancialCharge(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    id
    service
    createdAt
    UserExecuted {
      id
      name
      email
      photo
    }
    creditsDeducted
  }
  count: countFinancialCharge(where: $where)
}
    `;

/**
 * __useFindManyFinancialChargeQuery__
 *
 * To run a query within a React component, call `useFindManyFinancialChargeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyFinancialChargeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyFinancialChargeQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyFinancialChargeQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyFinancialChargeQuery, FindManyFinancialChargeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyFinancialChargeQuery, FindManyFinancialChargeQueryVariables>(FindManyFinancialChargeDocument, options);
      }
export function useFindManyFinancialChargeLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyFinancialChargeQuery, FindManyFinancialChargeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyFinancialChargeQuery, FindManyFinancialChargeQueryVariables>(FindManyFinancialChargeDocument, options);
        }
export function useFindManyFinancialChargeSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyFinancialChargeQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyFinancialChargeQuery, FindManyFinancialChargeQueryVariables>(FindManyFinancialChargeDocument, options);
        }
export type FindManyFinancialChargeQueryHookResult = ReturnType<typeof useFindManyFinancialChargeQuery>;
export type FindManyFinancialChargeLazyQueryHookResult = ReturnType<typeof useFindManyFinancialChargeLazyQuery>;
export type FindManyFinancialChargeSuspenseQueryHookResult = ReturnType<typeof useFindManyFinancialChargeSuspenseQuery>;
export type FindManyFinancialChargeQueryResult = ApolloReact.useQuery.Result<FindManyFinancialChargeQuery, FindManyFinancialChargeQueryVariables>;
export const FindManyFinancialCreditCardSavedDocument = gql`
    query findManyFinancialCreditCardSaved {
  findManyFinancialCreditCardSaved {
    id
    token
    number
    brand
  }
}
    `;

/**
 * __useFindManyFinancialCreditCardSavedQuery__
 *
 * To run a query within a React component, call `useFindManyFinancialCreditCardSavedQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyFinancialCreditCardSavedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyFinancialCreditCardSavedQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindManyFinancialCreditCardSavedQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyFinancialCreditCardSavedQuery, FindManyFinancialCreditCardSavedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyFinancialCreditCardSavedQuery, FindManyFinancialCreditCardSavedQueryVariables>(FindManyFinancialCreditCardSavedDocument, options);
      }
export function useFindManyFinancialCreditCardSavedLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyFinancialCreditCardSavedQuery, FindManyFinancialCreditCardSavedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyFinancialCreditCardSavedQuery, FindManyFinancialCreditCardSavedQueryVariables>(FindManyFinancialCreditCardSavedDocument, options);
        }
export function useFindManyFinancialCreditCardSavedSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyFinancialCreditCardSavedQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyFinancialCreditCardSavedQuery, FindManyFinancialCreditCardSavedQueryVariables>(FindManyFinancialCreditCardSavedDocument, options);
        }
export type FindManyFinancialCreditCardSavedQueryHookResult = ReturnType<typeof useFindManyFinancialCreditCardSavedQuery>;
export type FindManyFinancialCreditCardSavedLazyQueryHookResult = ReturnType<typeof useFindManyFinancialCreditCardSavedLazyQuery>;
export type FindManyFinancialCreditCardSavedSuspenseQueryHookResult = ReturnType<typeof useFindManyFinancialCreditCardSavedSuspenseQuery>;
export type FindManyFinancialCreditCardSavedQueryResult = ApolloReact.useQuery.Result<FindManyFinancialCreditCardSavedQuery, FindManyFinancialCreditCardSavedQueryVariables>;
export const FindManyFinancialPlanDocument = gql`
    query findManyFinancialPlan {
  findManyFinancialPlan {
    ...PlanAndConditionsFields
  }
}
    ${PlanAndConditionsFieldsFragmentDoc}`;

/**
 * __useFindManyFinancialPlanQuery__
 *
 * To run a query within a React component, call `useFindManyFinancialPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyFinancialPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyFinancialPlanQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindManyFinancialPlanQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyFinancialPlanQuery, FindManyFinancialPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyFinancialPlanQuery, FindManyFinancialPlanQueryVariables>(FindManyFinancialPlanDocument, options);
      }
export function useFindManyFinancialPlanLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyFinancialPlanQuery, FindManyFinancialPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyFinancialPlanQuery, FindManyFinancialPlanQueryVariables>(FindManyFinancialPlanDocument, options);
        }
export function useFindManyFinancialPlanSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyFinancialPlanQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyFinancialPlanQuery, FindManyFinancialPlanQueryVariables>(FindManyFinancialPlanDocument, options);
        }
export type FindManyFinancialPlanQueryHookResult = ReturnType<typeof useFindManyFinancialPlanQuery>;
export type FindManyFinancialPlanLazyQueryHookResult = ReturnType<typeof useFindManyFinancialPlanLazyQuery>;
export type FindManyFinancialPlanSuspenseQueryHookResult = ReturnType<typeof useFindManyFinancialPlanSuspenseQuery>;
export type FindManyFinancialPlanQueryResult = ApolloReact.useQuery.Result<FindManyFinancialPlanQuery, FindManyFinancialPlanQueryVariables>;
export const FindManyFinancialPaymentDocument = gql`
    query findManyFinancialPayment($where: FinancialPaymentWhereInput, $take: Int, $skip: Int, $orderBy: [FinancialPaymentOrderByWithRelationInput!]) {
  count: countFinancialPayment(where: $where)
  items: findManyFinancialPayment(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    id
    createdAt
    Recharge {
      id
      createdAt
      UserExecuted {
        id
        name
        email
        photo
      }
      cost
      creditsCount
      creditsType
    }
    SubscriptionPayment {
      dueDate
      cost
      id
      createdAt
      Subscription {
        id
        plan
        planName
      }
    }
  }
}
    `;

/**
 * __useFindManyFinancialPaymentQuery__
 *
 * To run a query within a React component, call `useFindManyFinancialPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyFinancialPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyFinancialPaymentQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyFinancialPaymentQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyFinancialPaymentQuery, FindManyFinancialPaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyFinancialPaymentQuery, FindManyFinancialPaymentQueryVariables>(FindManyFinancialPaymentDocument, options);
      }
export function useFindManyFinancialPaymentLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyFinancialPaymentQuery, FindManyFinancialPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyFinancialPaymentQuery, FindManyFinancialPaymentQueryVariables>(FindManyFinancialPaymentDocument, options);
        }
export function useFindManyFinancialPaymentSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyFinancialPaymentQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyFinancialPaymentQuery, FindManyFinancialPaymentQueryVariables>(FindManyFinancialPaymentDocument, options);
        }
export type FindManyFinancialPaymentQueryHookResult = ReturnType<typeof useFindManyFinancialPaymentQuery>;
export type FindManyFinancialPaymentLazyQueryHookResult = ReturnType<typeof useFindManyFinancialPaymentLazyQuery>;
export type FindManyFinancialPaymentSuspenseQueryHookResult = ReturnType<typeof useFindManyFinancialPaymentSuspenseQuery>;
export type FindManyFinancialPaymentQueryResult = ApolloReact.useQuery.Result<FindManyFinancialPaymentQuery, FindManyFinancialPaymentQueryVariables>;
export const FindManyFinancialTeamWalletSubscriptionPaymentDocument = gql`
    query findManyFinancialTeamWalletSubscriptionPayment($where: FinancialTeamWalletSubscriptionPaymentWhereInput, $take: Int, $skip: Int, $orderBy: [FinancialTeamWalletSubscriptionPaymentOrderByWithRelationInput!]) {
  items: findManyFinancialTeamWalletSubscriptionPayment(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    ...FinancialTeamWalletSubscriptionPaymentFields
  }
  count: countFinancialTeamWalletSubscriptionPayment(where: $where)
}
    ${FinancialTeamWalletSubscriptionPaymentFieldsFragmentDoc}`;

/**
 * __useFindManyFinancialTeamWalletSubscriptionPaymentQuery__
 *
 * To run a query within a React component, call `useFindManyFinancialTeamWalletSubscriptionPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyFinancialTeamWalletSubscriptionPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyFinancialTeamWalletSubscriptionPaymentQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyFinancialTeamWalletSubscriptionPaymentQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyFinancialTeamWalletSubscriptionPaymentQuery, FindManyFinancialTeamWalletSubscriptionPaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyFinancialTeamWalletSubscriptionPaymentQuery, FindManyFinancialTeamWalletSubscriptionPaymentQueryVariables>(FindManyFinancialTeamWalletSubscriptionPaymentDocument, options);
      }
export function useFindManyFinancialTeamWalletSubscriptionPaymentLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyFinancialTeamWalletSubscriptionPaymentQuery, FindManyFinancialTeamWalletSubscriptionPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyFinancialTeamWalletSubscriptionPaymentQuery, FindManyFinancialTeamWalletSubscriptionPaymentQueryVariables>(FindManyFinancialTeamWalletSubscriptionPaymentDocument, options);
        }
export function useFindManyFinancialTeamWalletSubscriptionPaymentSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyFinancialTeamWalletSubscriptionPaymentQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyFinancialTeamWalletSubscriptionPaymentQuery, FindManyFinancialTeamWalletSubscriptionPaymentQueryVariables>(FindManyFinancialTeamWalletSubscriptionPaymentDocument, options);
        }
export type FindManyFinancialTeamWalletSubscriptionPaymentQueryHookResult = ReturnType<typeof useFindManyFinancialTeamWalletSubscriptionPaymentQuery>;
export type FindManyFinancialTeamWalletSubscriptionPaymentLazyQueryHookResult = ReturnType<typeof useFindManyFinancialTeamWalletSubscriptionPaymentLazyQuery>;
export type FindManyFinancialTeamWalletSubscriptionPaymentSuspenseQueryHookResult = ReturnType<typeof useFindManyFinancialTeamWalletSubscriptionPaymentSuspenseQuery>;
export type FindManyFinancialTeamWalletSubscriptionPaymentQueryResult = ApolloReact.useQuery.Result<FindManyFinancialTeamWalletSubscriptionPaymentQuery, FindManyFinancialTeamWalletSubscriptionPaymentQueryVariables>;
export const FindManyMaintainerAdminDocument = gql`
    query findManyMaintainerAdmin($where: MaintainerAdminWhereInput, $take: Int, $skip: Int, $orderBy: [MaintainerAdminOrderByWithRelationInput!]) {
  findManyMaintainerAdmin(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    id
    createdAt
    User {
      id
      email
      idLedgerSign
      name
      cpf
    }
  }
  countMaintainerAdmin(where: $where)
}
    `;

/**
 * __useFindManyMaintainerAdminQuery__
 *
 * To run a query within a React component, call `useFindManyMaintainerAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyMaintainerAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyMaintainerAdminQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyMaintainerAdminQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyMaintainerAdminQuery, FindManyMaintainerAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyMaintainerAdminQuery, FindManyMaintainerAdminQueryVariables>(FindManyMaintainerAdminDocument, options);
      }
export function useFindManyMaintainerAdminLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyMaintainerAdminQuery, FindManyMaintainerAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyMaintainerAdminQuery, FindManyMaintainerAdminQueryVariables>(FindManyMaintainerAdminDocument, options);
        }
export function useFindManyMaintainerAdminSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyMaintainerAdminQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyMaintainerAdminQuery, FindManyMaintainerAdminQueryVariables>(FindManyMaintainerAdminDocument, options);
        }
export type FindManyMaintainerAdminQueryHookResult = ReturnType<typeof useFindManyMaintainerAdminQuery>;
export type FindManyMaintainerAdminLazyQueryHookResult = ReturnType<typeof useFindManyMaintainerAdminLazyQuery>;
export type FindManyMaintainerAdminSuspenseQueryHookResult = ReturnType<typeof useFindManyMaintainerAdminSuspenseQuery>;
export type FindManyMaintainerAdminQueryResult = ApolloReact.useQuery.Result<FindManyMaintainerAdminQuery, FindManyMaintainerAdminQueryVariables>;
export const FindManyMaintainerAdministeredDocument = gql`
    query findManyMaintainerAdministered($maintainerTeamId: String!) {
  findManyMaintainerAdministered(maintainerTeamId: $maintainerTeamId) {
    ...EnabledInstitutionFields
  }
}
    ${EnabledInstitutionFieldsFragmentDoc}`;

/**
 * __useFindManyMaintainerAdministeredQuery__
 *
 * To run a query within a React component, call `useFindManyMaintainerAdministeredQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyMaintainerAdministeredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyMaintainerAdministeredQuery({
 *   variables: {
 *      maintainerTeamId: // value for 'maintainerTeamId'
 *   },
 * });
 */
export function useFindManyMaintainerAdministeredQuery(baseOptions: ApolloReact.useQuery.Options<FindManyMaintainerAdministeredQuery, FindManyMaintainerAdministeredQueryVariables> & ({ variables: FindManyMaintainerAdministeredQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyMaintainerAdministeredQuery, FindManyMaintainerAdministeredQueryVariables>(FindManyMaintainerAdministeredDocument, options);
      }
export function useFindManyMaintainerAdministeredLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyMaintainerAdministeredQuery, FindManyMaintainerAdministeredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyMaintainerAdministeredQuery, FindManyMaintainerAdministeredQueryVariables>(FindManyMaintainerAdministeredDocument, options);
        }
export function useFindManyMaintainerAdministeredSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyMaintainerAdministeredQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyMaintainerAdministeredQuery, FindManyMaintainerAdministeredQueryVariables>(FindManyMaintainerAdministeredDocument, options);
        }
export type FindManyMaintainerAdministeredQueryHookResult = ReturnType<typeof useFindManyMaintainerAdministeredQuery>;
export type FindManyMaintainerAdministeredLazyQueryHookResult = ReturnType<typeof useFindManyMaintainerAdministeredLazyQuery>;
export type FindManyMaintainerAdministeredSuspenseQueryHookResult = ReturnType<typeof useFindManyMaintainerAdministeredSuspenseQuery>;
export type FindManyMaintainerAdministeredQueryResult = ApolloReact.useQuery.Result<FindManyMaintainerAdministeredQuery, FindManyMaintainerAdministeredQueryVariables>;
export const FindManyPermissionDocument = gql`
    query findManyPermission {
  findManyPermission {
    id
    code
    title
    description
  }
}
    `;

/**
 * __useFindManyPermissionQuery__
 *
 * To run a query within a React component, call `useFindManyPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyPermissionQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindManyPermissionQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyPermissionQuery, FindManyPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyPermissionQuery, FindManyPermissionQueryVariables>(FindManyPermissionDocument, options);
      }
export function useFindManyPermissionLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyPermissionQuery, FindManyPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyPermissionQuery, FindManyPermissionQueryVariables>(FindManyPermissionDocument, options);
        }
export function useFindManyPermissionSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyPermissionQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyPermissionQuery, FindManyPermissionQueryVariables>(FindManyPermissionDocument, options);
        }
export type FindManyPermissionQueryHookResult = ReturnType<typeof useFindManyPermissionQuery>;
export type FindManyPermissionLazyQueryHookResult = ReturnType<typeof useFindManyPermissionLazyQuery>;
export type FindManyPermissionSuspenseQueryHookResult = ReturnType<typeof useFindManyPermissionSuspenseQuery>;
export type FindManyPermissionQueryResult = ApolloReact.useQuery.Result<FindManyPermissionQuery, FindManyPermissionQueryVariables>;
export const FindManyPersonDocument = gql`
    query FindManyPerson($cursor: PersonWhereUniqueInput, $distinct: [PersonScalarFieldEnum!], $orderBy: [PersonOrderByWithRelationInput!], $skip: Int, $take: Int, $where: PersonWhereInput) {
  findManyPerson(
    cursor: $cursor
    distinct: $distinct
    orderBy: $orderBy
    skip: $skip
    take: $take
    where: $where
  ) {
    id
    cpf
    passport
    name
    birthDate
    email
    createdAt
  }
  count: countPerson(where: $where)
}
    `;

/**
 * __useFindManyPersonQuery__
 *
 * To run a query within a React component, call `useFindManyPersonQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyPersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyPersonQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      distinct: // value for 'distinct'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindManyPersonQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyPersonQuery, FindManyPersonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyPersonQuery, FindManyPersonQueryVariables>(FindManyPersonDocument, options);
      }
export function useFindManyPersonLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyPersonQuery, FindManyPersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyPersonQuery, FindManyPersonQueryVariables>(FindManyPersonDocument, options);
        }
export function useFindManyPersonSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyPersonQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyPersonQuery, FindManyPersonQueryVariables>(FindManyPersonDocument, options);
        }
export type FindManyPersonQueryHookResult = ReturnType<typeof useFindManyPersonQuery>;
export type FindManyPersonLazyQueryHookResult = ReturnType<typeof useFindManyPersonLazyQuery>;
export type FindManyPersonSuspenseQueryHookResult = ReturnType<typeof useFindManyPersonSuspenseQuery>;
export type FindManyPersonQueryResult = ApolloReact.useQuery.Result<FindManyPersonQuery, FindManyPersonQueryVariables>;
export const FindManyReusableFormDataDocument = gql`
    query findManyReusableFormData($where: ReusableFormDataWhereInputCustom, $take: Int, $skip: Int, $orderBy: [ReusableFormDataOrderByWithRelationInput!]) {
  findManyReusableFormData(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    id
    data
    createdAt
  }
  count: countReusableFormData(where: $where)
}
    `;

/**
 * __useFindManyReusableFormDataQuery__
 *
 * To run a query within a React component, call `useFindManyReusableFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyReusableFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyReusableFormDataQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyReusableFormDataQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyReusableFormDataQuery, FindManyReusableFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyReusableFormDataQuery, FindManyReusableFormDataQueryVariables>(FindManyReusableFormDataDocument, options);
      }
export function useFindManyReusableFormDataLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyReusableFormDataQuery, FindManyReusableFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyReusableFormDataQuery, FindManyReusableFormDataQueryVariables>(FindManyReusableFormDataDocument, options);
        }
export function useFindManyReusableFormDataSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyReusableFormDataQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyReusableFormDataQuery, FindManyReusableFormDataQueryVariables>(FindManyReusableFormDataDocument, options);
        }
export type FindManyReusableFormDataQueryHookResult = ReturnType<typeof useFindManyReusableFormDataQuery>;
export type FindManyReusableFormDataLazyQueryHookResult = ReturnType<typeof useFindManyReusableFormDataLazyQuery>;
export type FindManyReusableFormDataSuspenseQueryHookResult = ReturnType<typeof useFindManyReusableFormDataSuspenseQuery>;
export type FindManyReusableFormDataQueryResult = ApolloReact.useQuery.Result<FindManyReusableFormDataQuery, FindManyReusableFormDataQueryVariables>;
export const FindManyReusableFormDataCurriculumDocument = gql`
    query findManyReusableFormDataCurriculum($where: ReusableFormDataCurriculumWhereInput, $take: Int, $skip: Int, $orderBy: [ReusableFormDataCurriculumOrderByWithRelationInput!]) {
  items: findManyReusableFormDataCurriculum(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    ...ReusableFormDataCurriculumFields
  }
  count: countReusableFormDataCurriculum(where: $where)
}
    ${ReusableFormDataCurriculumFieldsFragmentDoc}`;

/**
 * __useFindManyReusableFormDataCurriculumQuery__
 *
 * To run a query within a React component, call `useFindManyReusableFormDataCurriculumQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyReusableFormDataCurriculumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyReusableFormDataCurriculumQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyReusableFormDataCurriculumQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyReusableFormDataCurriculumQuery, FindManyReusableFormDataCurriculumQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyReusableFormDataCurriculumQuery, FindManyReusableFormDataCurriculumQueryVariables>(FindManyReusableFormDataCurriculumDocument, options);
      }
export function useFindManyReusableFormDataCurriculumLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyReusableFormDataCurriculumQuery, FindManyReusableFormDataCurriculumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyReusableFormDataCurriculumQuery, FindManyReusableFormDataCurriculumQueryVariables>(FindManyReusableFormDataCurriculumDocument, options);
        }
export function useFindManyReusableFormDataCurriculumSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyReusableFormDataCurriculumQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyReusableFormDataCurriculumQuery, FindManyReusableFormDataCurriculumQueryVariables>(FindManyReusableFormDataCurriculumDocument, options);
        }
export type FindManyReusableFormDataCurriculumQueryHookResult = ReturnType<typeof useFindManyReusableFormDataCurriculumQuery>;
export type FindManyReusableFormDataCurriculumLazyQueryHookResult = ReturnType<typeof useFindManyReusableFormDataCurriculumLazyQuery>;
export type FindManyReusableFormDataCurriculumSuspenseQueryHookResult = ReturnType<typeof useFindManyReusableFormDataCurriculumSuspenseQuery>;
export type FindManyReusableFormDataCurriculumQueryResult = ApolloReact.useQuery.Result<FindManyReusableFormDataCurriculumQuery, FindManyReusableFormDataCurriculumQueryVariables>;
export const FindManySignableDocumentBaseSignatureInviteDocument = gql`
    query findManySignableDocumentBaseSignatureInvite($where: DocumentBaseSignatureInviteWhereInput, $take: Int, $skip: Int, $orderBy: [DocumentBaseSignatureInviteOrderByWithRelationInput!], $personId: String!) {
  findManySignableDocumentBaseSignatureInvite(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
    personId: $personId
  ) {
    items {
      ...DocumentBaseSignatureInviteFields
    }
    count
  }
}
    ${DocumentBaseSignatureInviteFieldsFragmentDoc}`;

/**
 * __useFindManySignableDocumentBaseSignatureInviteQuery__
 *
 * To run a query within a React component, call `useFindManySignableDocumentBaseSignatureInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManySignableDocumentBaseSignatureInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManySignableDocumentBaseSignatureInviteQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useFindManySignableDocumentBaseSignatureInviteQuery(baseOptions: ApolloReact.useQuery.Options<FindManySignableDocumentBaseSignatureInviteQuery, FindManySignableDocumentBaseSignatureInviteQueryVariables> & ({ variables: FindManySignableDocumentBaseSignatureInviteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManySignableDocumentBaseSignatureInviteQuery, FindManySignableDocumentBaseSignatureInviteQueryVariables>(FindManySignableDocumentBaseSignatureInviteDocument, options);
      }
export function useFindManySignableDocumentBaseSignatureInviteLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManySignableDocumentBaseSignatureInviteQuery, FindManySignableDocumentBaseSignatureInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManySignableDocumentBaseSignatureInviteQuery, FindManySignableDocumentBaseSignatureInviteQueryVariables>(FindManySignableDocumentBaseSignatureInviteDocument, options);
        }
export function useFindManySignableDocumentBaseSignatureInviteSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManySignableDocumentBaseSignatureInviteQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManySignableDocumentBaseSignatureInviteQuery, FindManySignableDocumentBaseSignatureInviteQueryVariables>(FindManySignableDocumentBaseSignatureInviteDocument, options);
        }
export type FindManySignableDocumentBaseSignatureInviteQueryHookResult = ReturnType<typeof useFindManySignableDocumentBaseSignatureInviteQuery>;
export type FindManySignableDocumentBaseSignatureInviteLazyQueryHookResult = ReturnType<typeof useFindManySignableDocumentBaseSignatureInviteLazyQuery>;
export type FindManySignableDocumentBaseSignatureInviteSuspenseQueryHookResult = ReturnType<typeof useFindManySignableDocumentBaseSignatureInviteSuspenseQuery>;
export type FindManySignableDocumentBaseSignatureInviteQueryResult = ApolloReact.useQuery.Result<FindManySignableDocumentBaseSignatureInviteQuery, FindManySignableDocumentBaseSignatureInviteQueryVariables>;
export const FindManySystemGlobalAlertDocument = gql`
    query findManySystemGlobalAlert($where: SystemGlobalAlertWhereInput, $take: Int, $skip: Int, $orderBy: [SystemGlobalAlertOrderByWithRelationInput!]) {
  findManySystemGlobalAlert(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    ...SystemGlobalAlertManyFields
  }
  count: countSystemGlobalAlert(where: $where)
}
    ${SystemGlobalAlertManyFieldsFragmentDoc}`;

/**
 * __useFindManySystemGlobalAlertQuery__
 *
 * To run a query within a React component, call `useFindManySystemGlobalAlertQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManySystemGlobalAlertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManySystemGlobalAlertQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManySystemGlobalAlertQuery(baseOptions?: ApolloReact.useQuery.Options<FindManySystemGlobalAlertQuery, FindManySystemGlobalAlertQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManySystemGlobalAlertQuery, FindManySystemGlobalAlertQueryVariables>(FindManySystemGlobalAlertDocument, options);
      }
export function useFindManySystemGlobalAlertLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManySystemGlobalAlertQuery, FindManySystemGlobalAlertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManySystemGlobalAlertQuery, FindManySystemGlobalAlertQueryVariables>(FindManySystemGlobalAlertDocument, options);
        }
export function useFindManySystemGlobalAlertSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManySystemGlobalAlertQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManySystemGlobalAlertQuery, FindManySystemGlobalAlertQueryVariables>(FindManySystemGlobalAlertDocument, options);
        }
export type FindManySystemGlobalAlertQueryHookResult = ReturnType<typeof useFindManySystemGlobalAlertQuery>;
export type FindManySystemGlobalAlertLazyQueryHookResult = ReturnType<typeof useFindManySystemGlobalAlertLazyQuery>;
export type FindManySystemGlobalAlertSuspenseQueryHookResult = ReturnType<typeof useFindManySystemGlobalAlertSuspenseQuery>;
export type FindManySystemGlobalAlertQueryResult = ApolloReact.useQuery.Result<FindManySystemGlobalAlertQuery, FindManySystemGlobalAlertQueryVariables>;
export const FindManyTeamDocument = gql`
    query FindManyTeam($where: TeamWhereInput, $take: Int, $skip: Int, $orderBy: [TeamOrderByWithRelationInput!]) {
  count: countTeam(where: $where)
  totalIssuedDocuments: countTotalIssuedDocuments
  items: findManyTeam(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    ...TeamManyFields
  }
}
    ${TeamManyFieldsFragmentDoc}`;

/**
 * __useFindManyTeamQuery__
 *
 * To run a query within a React component, call `useFindManyTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyTeamQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyTeamQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyTeamQuery, FindManyTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyTeamQuery, FindManyTeamQueryVariables>(FindManyTeamDocument, options);
      }
export function useFindManyTeamLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyTeamQuery, FindManyTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyTeamQuery, FindManyTeamQueryVariables>(FindManyTeamDocument, options);
        }
export function useFindManyTeamSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyTeamQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyTeamQuery, FindManyTeamQueryVariables>(FindManyTeamDocument, options);
        }
export type FindManyTeamQueryHookResult = ReturnType<typeof useFindManyTeamQuery>;
export type FindManyTeamLazyQueryHookResult = ReturnType<typeof useFindManyTeamLazyQuery>;
export type FindManyTeamSuspenseQueryHookResult = ReturnType<typeof useFindManyTeamSuspenseQuery>;
export type FindManyTeamQueryResult = ApolloReact.useQuery.Result<FindManyTeamQuery, FindManyTeamQueryVariables>;
export const FindManyTeamContractDocument = gql`
    query findManyTeamContract($where: TeamContractWhereInput, $take: Int, $skip: Int, $orderBy: [TeamContractOrderByWithRelationInput!]) {
  findManyTeamContract(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    ...TeamContractManyFields
  }
  count: countTeamContract(where: $where)
}
    ${TeamContractManyFieldsFragmentDoc}`;

/**
 * __useFindManyTeamContractQuery__
 *
 * To run a query within a React component, call `useFindManyTeamContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyTeamContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyTeamContractQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyTeamContractQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyTeamContractQuery, FindManyTeamContractQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyTeamContractQuery, FindManyTeamContractQueryVariables>(FindManyTeamContractDocument, options);
      }
export function useFindManyTeamContractLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyTeamContractQuery, FindManyTeamContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyTeamContractQuery, FindManyTeamContractQueryVariables>(FindManyTeamContractDocument, options);
        }
export function useFindManyTeamContractSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyTeamContractQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyTeamContractQuery, FindManyTeamContractQueryVariables>(FindManyTeamContractDocument, options);
        }
export type FindManyTeamContractQueryHookResult = ReturnType<typeof useFindManyTeamContractQuery>;
export type FindManyTeamContractLazyQueryHookResult = ReturnType<typeof useFindManyTeamContractLazyQuery>;
export type FindManyTeamContractSuspenseQueryHookResult = ReturnType<typeof useFindManyTeamContractSuspenseQuery>;
export type FindManyTeamContractQueryResult = ApolloReact.useQuery.Result<FindManyTeamContractQuery, FindManyTeamContractQueryVariables>;
export const FindManyTeamDocumentTypeSpecificSignaturePolicyConfigDocument = gql`
    query findManyTeamDocumentTypeSpecificSignaturePolicyConfig($where: TeamDocumentTypeSpecificSignaturePolicyConfigWhereInput, $take: Int, $skip: Int, $orderBy: [TeamDocumentTypeSpecificSignaturePolicyConfigOrderByWithRelationInput!]) {
  findManyTeamDocumentTypeSpecificSignaturePolicyConfig(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    ...TeamDocumentTypeSpecificSignaturePolicyConfigManyFields
  }
  count: countTeamDocumentTypeSpecificSignaturePolicyConfig(where: $where)
}
    ${TeamDocumentTypeSpecificSignaturePolicyConfigManyFieldsFragmentDoc}`;

/**
 * __useFindManyTeamDocumentTypeSpecificSignaturePolicyConfigQuery__
 *
 * To run a query within a React component, call `useFindManyTeamDocumentTypeSpecificSignaturePolicyConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyTeamDocumentTypeSpecificSignaturePolicyConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyTeamDocumentTypeSpecificSignaturePolicyConfigQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyTeamDocumentTypeSpecificSignaturePolicyConfigQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyTeamDocumentTypeSpecificSignaturePolicyConfigQuery, FindManyTeamDocumentTypeSpecificSignaturePolicyConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyTeamDocumentTypeSpecificSignaturePolicyConfigQuery, FindManyTeamDocumentTypeSpecificSignaturePolicyConfigQueryVariables>(FindManyTeamDocumentTypeSpecificSignaturePolicyConfigDocument, options);
      }
export function useFindManyTeamDocumentTypeSpecificSignaturePolicyConfigLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyTeamDocumentTypeSpecificSignaturePolicyConfigQuery, FindManyTeamDocumentTypeSpecificSignaturePolicyConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyTeamDocumentTypeSpecificSignaturePolicyConfigQuery, FindManyTeamDocumentTypeSpecificSignaturePolicyConfigQueryVariables>(FindManyTeamDocumentTypeSpecificSignaturePolicyConfigDocument, options);
        }
export function useFindManyTeamDocumentTypeSpecificSignaturePolicyConfigSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyTeamDocumentTypeSpecificSignaturePolicyConfigQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyTeamDocumentTypeSpecificSignaturePolicyConfigQuery, FindManyTeamDocumentTypeSpecificSignaturePolicyConfigQueryVariables>(FindManyTeamDocumentTypeSpecificSignaturePolicyConfigDocument, options);
        }
export type FindManyTeamDocumentTypeSpecificSignaturePolicyConfigQueryHookResult = ReturnType<typeof useFindManyTeamDocumentTypeSpecificSignaturePolicyConfigQuery>;
export type FindManyTeamDocumentTypeSpecificSignaturePolicyConfigLazyQueryHookResult = ReturnType<typeof useFindManyTeamDocumentTypeSpecificSignaturePolicyConfigLazyQuery>;
export type FindManyTeamDocumentTypeSpecificSignaturePolicyConfigSuspenseQueryHookResult = ReturnType<typeof useFindManyTeamDocumentTypeSpecificSignaturePolicyConfigSuspenseQuery>;
export type FindManyTeamDocumentTypeSpecificSignaturePolicyConfigQueryResult = ApolloReact.useQuery.Result<FindManyTeamDocumentTypeSpecificSignaturePolicyConfigQuery, FindManyTeamDocumentTypeSpecificSignaturePolicyConfigQueryVariables>;
export const FindManyTeamMaintainedDocument = gql`
    query findManyTeamMaintained($where: TeamWhereInput, $take: Int, $skip: Int, $orderBy: [TeamOrderByWithRelationInput!]) {
  findManyTeamMaintained(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    id
    issuerName
    placeholderName
    cnpj
    createdAt
    MainTeamOfMaintainer {
      id
      mainTeamId
    }
    Owner {
      id
      name
    }
  }
  countTeamMaintained(where: $where)
}
    `;

/**
 * __useFindManyTeamMaintainedQuery__
 *
 * To run a query within a React component, call `useFindManyTeamMaintainedQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyTeamMaintainedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyTeamMaintainedQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyTeamMaintainedQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyTeamMaintainedQuery, FindManyTeamMaintainedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyTeamMaintainedQuery, FindManyTeamMaintainedQueryVariables>(FindManyTeamMaintainedDocument, options);
      }
export function useFindManyTeamMaintainedLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyTeamMaintainedQuery, FindManyTeamMaintainedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyTeamMaintainedQuery, FindManyTeamMaintainedQueryVariables>(FindManyTeamMaintainedDocument, options);
        }
export function useFindManyTeamMaintainedSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyTeamMaintainedQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyTeamMaintainedQuery, FindManyTeamMaintainedQueryVariables>(FindManyTeamMaintainedDocument, options);
        }
export type FindManyTeamMaintainedQueryHookResult = ReturnType<typeof useFindManyTeamMaintainedQuery>;
export type FindManyTeamMaintainedLazyQueryHookResult = ReturnType<typeof useFindManyTeamMaintainedLazyQuery>;
export type FindManyTeamMaintainedSuspenseQueryHookResult = ReturnType<typeof useFindManyTeamMaintainedSuspenseQuery>;
export type FindManyTeamMaintainedQueryResult = ApolloReact.useQuery.Result<FindManyTeamMaintainedQuery, FindManyTeamMaintainedQueryVariables>;
export const FindManyTeamMemberDocument = gql`
    query findManyTeamMember($where: TeamMemberWhereInput, $take: Int, $skip: Int, $orderBy: [TeamMemberOrderByWithRelationInput!]) {
  findManyTeamMember(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    ...TeamMemberFields
  }
  count: countTeamMember(where: $where)
}
    ${TeamMemberFieldsFragmentDoc}`;

/**
 * __useFindManyTeamMemberQuery__
 *
 * To run a query within a React component, call `useFindManyTeamMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyTeamMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyTeamMemberQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManyTeamMemberQuery(baseOptions?: ApolloReact.useQuery.Options<FindManyTeamMemberQuery, FindManyTeamMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManyTeamMemberQuery, FindManyTeamMemberQueryVariables>(FindManyTeamMemberDocument, options);
      }
export function useFindManyTeamMemberLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManyTeamMemberQuery, FindManyTeamMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManyTeamMemberQuery, FindManyTeamMemberQueryVariables>(FindManyTeamMemberDocument, options);
        }
export function useFindManyTeamMemberSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManyTeamMemberQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManyTeamMemberQuery, FindManyTeamMemberQueryVariables>(FindManyTeamMemberDocument, options);
        }
export type FindManyTeamMemberQueryHookResult = ReturnType<typeof useFindManyTeamMemberQuery>;
export type FindManyTeamMemberLazyQueryHookResult = ReturnType<typeof useFindManyTeamMemberLazyQuery>;
export type FindManyTeamMemberSuspenseQueryHookResult = ReturnType<typeof useFindManyTeamMemberSuspenseQuery>;
export type FindManyTeamMemberQueryResult = ApolloReact.useQuery.Result<FindManyTeamMemberQuery, FindManyTeamMemberQueryVariables>;
export const FindManySystemAuditLogDocument = gql`
    query findManySystemAuditLog($where: SystemAuditLogWhereInput, $take: Int, $skip: Int, $orderBy: [SystemAuditLogOrderByWithRelationInput!]) {
  findManySystemAuditLog(
    where: $where
    take: $take
    skip: $skip
    orderBy: $orderBy
  ) {
    ...SystemAuditLogFields
  }
  countSystemAuditLog(where: $where)
}
    ${SystemAuditLogFieldsFragmentDoc}`;

/**
 * __useFindManySystemAuditLogQuery__
 *
 * To run a query within a React component, call `useFindManySystemAuditLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManySystemAuditLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManySystemAuditLogQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFindManySystemAuditLogQuery(baseOptions?: ApolloReact.useQuery.Options<FindManySystemAuditLogQuery, FindManySystemAuditLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindManySystemAuditLogQuery, FindManySystemAuditLogQueryVariables>(FindManySystemAuditLogDocument, options);
      }
export function useFindManySystemAuditLogLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindManySystemAuditLogQuery, FindManySystemAuditLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindManySystemAuditLogQuery, FindManySystemAuditLogQueryVariables>(FindManySystemAuditLogDocument, options);
        }
export function useFindManySystemAuditLogSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindManySystemAuditLogQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindManySystemAuditLogQuery, FindManySystemAuditLogQueryVariables>(FindManySystemAuditLogDocument, options);
        }
export type FindManySystemAuditLogQueryHookResult = ReturnType<typeof useFindManySystemAuditLogQuery>;
export type FindManySystemAuditLogLazyQueryHookResult = ReturnType<typeof useFindManySystemAuditLogLazyQuery>;
export type FindManySystemAuditLogSuspenseQueryHookResult = ReturnType<typeof useFindManySystemAuditLogSuspenseQuery>;
export type FindManySystemAuditLogQueryResult = ApolloReact.useQuery.Result<FindManySystemAuditLogQuery, FindManySystemAuditLogQueryVariables>;
export const FindOneExternalCepAddressDocument = gql`
    query findOneExternalCepAddress($cep: String!) {
  findOneExternalCepAddress(cep: $cep) {
    id
    street
    state
    service
    neighborhood
    city
    cep
  }
}
    `;

/**
 * __useFindOneExternalCepAddressQuery__
 *
 * To run a query within a React component, call `useFindOneExternalCepAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOneExternalCepAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOneExternalCepAddressQuery({
 *   variables: {
 *      cep: // value for 'cep'
 *   },
 * });
 */
export function useFindOneExternalCepAddressQuery(baseOptions: ApolloReact.useQuery.Options<FindOneExternalCepAddressQuery, FindOneExternalCepAddressQueryVariables> & ({ variables: FindOneExternalCepAddressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindOneExternalCepAddressQuery, FindOneExternalCepAddressQueryVariables>(FindOneExternalCepAddressDocument, options);
      }
export function useFindOneExternalCepAddressLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindOneExternalCepAddressQuery, FindOneExternalCepAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindOneExternalCepAddressQuery, FindOneExternalCepAddressQueryVariables>(FindOneExternalCepAddressDocument, options);
        }
export function useFindOneExternalCepAddressSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindOneExternalCepAddressQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindOneExternalCepAddressQuery, FindOneExternalCepAddressQueryVariables>(FindOneExternalCepAddressDocument, options);
        }
export type FindOneExternalCepAddressQueryHookResult = ReturnType<typeof useFindOneExternalCepAddressQuery>;
export type FindOneExternalCepAddressLazyQueryHookResult = ReturnType<typeof useFindOneExternalCepAddressLazyQuery>;
export type FindOneExternalCepAddressSuspenseQueryHookResult = ReturnType<typeof useFindOneExternalCepAddressSuspenseQuery>;
export type FindOneExternalCepAddressQueryResult = ApolloReact.useQuery.Result<FindOneExternalCepAddressQuery, FindOneExternalCepAddressQueryVariables>;
export const FindPublicViewDegreeDomainPathDocument = gql`
    query findPublicViewDegreeDomainPath($searchValidationCode: String!, $teamId: Int!) {
  findPublicViewDegreeDomainPath(
    searchValidationCode: $searchValidationCode
    teamId: $teamId
  ) {
    id
    foundTeam
    publicViewDegreeDomainPath
  }
}
    `;

/**
 * __useFindPublicViewDegreeDomainPathQuery__
 *
 * To run a query within a React component, call `useFindPublicViewDegreeDomainPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPublicViewDegreeDomainPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPublicViewDegreeDomainPathQuery({
 *   variables: {
 *      searchValidationCode: // value for 'searchValidationCode'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useFindPublicViewDegreeDomainPathQuery(baseOptions: ApolloReact.useQuery.Options<FindPublicViewDegreeDomainPathQuery, FindPublicViewDegreeDomainPathQueryVariables> & ({ variables: FindPublicViewDegreeDomainPathQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindPublicViewDegreeDomainPathQuery, FindPublicViewDegreeDomainPathQueryVariables>(FindPublicViewDegreeDomainPathDocument, options);
      }
export function useFindPublicViewDegreeDomainPathLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindPublicViewDegreeDomainPathQuery, FindPublicViewDegreeDomainPathQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindPublicViewDegreeDomainPathQuery, FindPublicViewDegreeDomainPathQueryVariables>(FindPublicViewDegreeDomainPathDocument, options);
        }
export function useFindPublicViewDegreeDomainPathSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindPublicViewDegreeDomainPathQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindPublicViewDegreeDomainPathQuery, FindPublicViewDegreeDomainPathQueryVariables>(FindPublicViewDegreeDomainPathDocument, options);
        }
export type FindPublicViewDegreeDomainPathQueryHookResult = ReturnType<typeof useFindPublicViewDegreeDomainPathQuery>;
export type FindPublicViewDegreeDomainPathLazyQueryHookResult = ReturnType<typeof useFindPublicViewDegreeDomainPathLazyQuery>;
export type FindPublicViewDegreeDomainPathSuspenseQueryHookResult = ReturnType<typeof useFindPublicViewDegreeDomainPathSuspenseQuery>;
export type FindPublicViewDegreeDomainPathQueryResult = ApolloReact.useQuery.Result<FindPublicViewDegreeDomainPathQuery, FindPublicViewDegreeDomainPathQueryVariables>;
export const FindUniqueBulkCertificateRecordDocument = gql`
    query findUniqueBulkCertificateRecord($where: BulkCertificateRecordWhereUniqueInput!, $countInSignaturesDocumentCertificatesWhere: DocumentCertificateWhereInput) {
  findUniqueBulkCertificateRecord(where: $where) {
    id
    createdAt
    bulkCertificateRecordName
    totalCertificates
    status
    countDocumentCertificates
    countDocumentCertificatesStatusInSignature: countDocumentCertificates(
      where: $countInSignaturesDocumentCertificatesWhere
    )
  }
}
    `;

/**
 * __useFindUniqueBulkCertificateRecordQuery__
 *
 * To run a query within a React component, call `useFindUniqueBulkCertificateRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueBulkCertificateRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueBulkCertificateRecordQuery({
 *   variables: {
 *      where: // value for 'where'
 *      countInSignaturesDocumentCertificatesWhere: // value for 'countInSignaturesDocumentCertificatesWhere'
 *   },
 * });
 */
export function useFindUniqueBulkCertificateRecordQuery(baseOptions: ApolloReact.useQuery.Options<FindUniqueBulkCertificateRecordQuery, FindUniqueBulkCertificateRecordQueryVariables> & ({ variables: FindUniqueBulkCertificateRecordQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniqueBulkCertificateRecordQuery, FindUniqueBulkCertificateRecordQueryVariables>(FindUniqueBulkCertificateRecordDocument, options);
      }
export function useFindUniqueBulkCertificateRecordLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniqueBulkCertificateRecordQuery, FindUniqueBulkCertificateRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniqueBulkCertificateRecordQuery, FindUniqueBulkCertificateRecordQueryVariables>(FindUniqueBulkCertificateRecordDocument, options);
        }
export function useFindUniqueBulkCertificateRecordSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniqueBulkCertificateRecordQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniqueBulkCertificateRecordQuery, FindUniqueBulkCertificateRecordQueryVariables>(FindUniqueBulkCertificateRecordDocument, options);
        }
export type FindUniqueBulkCertificateRecordQueryHookResult = ReturnType<typeof useFindUniqueBulkCertificateRecordQuery>;
export type FindUniqueBulkCertificateRecordLazyQueryHookResult = ReturnType<typeof useFindUniqueBulkCertificateRecordLazyQuery>;
export type FindUniqueBulkCertificateRecordSuspenseQueryHookResult = ReturnType<typeof useFindUniqueBulkCertificateRecordSuspenseQuery>;
export type FindUniqueBulkCertificateRecordQueryResult = ApolloReact.useQuery.Result<FindUniqueBulkCertificateRecordQuery, FindUniqueBulkCertificateRecordQueryVariables>;
export const FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlDocument = gql`
    query findUniqueTeamAndPublicDocumentBaseTypeByPublicUrl {
  findUniqueTeamAndPublicDocumentBaseTypeByPublicUrl {
    ...TeamAndPublicDocumentBaseTypeFields
  }
}
    ${TeamAndPublicDocumentBaseTypeFieldsFragmentDoc}`;

/**
 * __useFindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery__
 *
 * To run a query within a React component, call `useFindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery(baseOptions?: ApolloReact.useQuery.Options<FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery, FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery, FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQueryVariables>(FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlDocument, options);
      }
export function useFindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery, FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery, FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQueryVariables>(FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlDocument, options);
        }
export function useFindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery, FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQueryVariables>(FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlDocument, options);
        }
export type FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQueryHookResult = ReturnType<typeof useFindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery>;
export type FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlLazyQueryHookResult = ReturnType<typeof useFindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlLazyQuery>;
export type FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlSuspenseQueryHookResult = ReturnType<typeof useFindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlSuspenseQuery>;
export type FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQueryResult = ApolloReact.useQuery.Result<FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQuery, FindUniqueTeamAndPublicDocumentBaseTypeByPublicUrlQueryVariables>;
export const FindUniqueCertificateCourseDocument = gql`
    query findUniqueCertificateCourse($where: CertificateCourseWhereUniqueInput!) {
  findUniqueCertificateCourse(where: $where) {
    id
    certificateBaseId
    name
    areaKnowledge
    metaData
    CertificateBase {
      id
      createdAt
    }
    CourseLevel {
      id
      certificateBaseId
      name
    }
  }
}
    `;

/**
 * __useFindUniqueCertificateCourseQuery__
 *
 * To run a query within a React component, call `useFindUniqueCertificateCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueCertificateCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueCertificateCourseQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueCertificateCourseQuery(baseOptions: ApolloReact.useQuery.Options<FindUniqueCertificateCourseQuery, FindUniqueCertificateCourseQueryVariables> & ({ variables: FindUniqueCertificateCourseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniqueCertificateCourseQuery, FindUniqueCertificateCourseQueryVariables>(FindUniqueCertificateCourseDocument, options);
      }
export function useFindUniqueCertificateCourseLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniqueCertificateCourseQuery, FindUniqueCertificateCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniqueCertificateCourseQuery, FindUniqueCertificateCourseQueryVariables>(FindUniqueCertificateCourseDocument, options);
        }
export function useFindUniqueCertificateCourseSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniqueCertificateCourseQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniqueCertificateCourseQuery, FindUniqueCertificateCourseQueryVariables>(FindUniqueCertificateCourseDocument, options);
        }
export type FindUniqueCertificateCourseQueryHookResult = ReturnType<typeof useFindUniqueCertificateCourseQuery>;
export type FindUniqueCertificateCourseLazyQueryHookResult = ReturnType<typeof useFindUniqueCertificateCourseLazyQuery>;
export type FindUniqueCertificateCourseSuspenseQueryHookResult = ReturnType<typeof useFindUniqueCertificateCourseSuspenseQuery>;
export type FindUniqueCertificateCourseQueryResult = ApolloReact.useQuery.Result<FindUniqueCertificateCourseQuery, FindUniqueCertificateCourseQueryVariables>;
export const FindUniqueCertificateCourseLevelDocument = gql`
    query findUniqueCertificateCourseLevel($where: CertificateCourseLevelWhereUniqueInput!) {
  findUniqueCertificateCourseLevel(where: $where) {
    id
    name
    certificateBaseId
    CertificateBase {
      id
      createdAt
    }
  }
}
    `;

/**
 * __useFindUniqueCertificateCourseLevelQuery__
 *
 * To run a query within a React component, call `useFindUniqueCertificateCourseLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueCertificateCourseLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueCertificateCourseLevelQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueCertificateCourseLevelQuery(baseOptions: ApolloReact.useQuery.Options<FindUniqueCertificateCourseLevelQuery, FindUniqueCertificateCourseLevelQueryVariables> & ({ variables: FindUniqueCertificateCourseLevelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniqueCertificateCourseLevelQuery, FindUniqueCertificateCourseLevelQueryVariables>(FindUniqueCertificateCourseLevelDocument, options);
      }
export function useFindUniqueCertificateCourseLevelLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniqueCertificateCourseLevelQuery, FindUniqueCertificateCourseLevelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniqueCertificateCourseLevelQuery, FindUniqueCertificateCourseLevelQueryVariables>(FindUniqueCertificateCourseLevelDocument, options);
        }
export function useFindUniqueCertificateCourseLevelSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniqueCertificateCourseLevelQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniqueCertificateCourseLevelQuery, FindUniqueCertificateCourseLevelQueryVariables>(FindUniqueCertificateCourseLevelDocument, options);
        }
export type FindUniqueCertificateCourseLevelQueryHookResult = ReturnType<typeof useFindUniqueCertificateCourseLevelQuery>;
export type FindUniqueCertificateCourseLevelLazyQueryHookResult = ReturnType<typeof useFindUniqueCertificateCourseLevelLazyQuery>;
export type FindUniqueCertificateCourseLevelSuspenseQueryHookResult = ReturnType<typeof useFindUniqueCertificateCourseLevelSuspenseQuery>;
export type FindUniqueCertificateCourseLevelQueryResult = ApolloReact.useQuery.Result<FindUniqueCertificateCourseLevelQuery, FindUniqueCertificateCourseLevelQueryVariables>;
export const FindUniqueCertificateCurriculumDocument = gql`
    query findUniqueCertificateCurriculum($where: CertificateCurriculumWhereUniqueInput!) {
  findUniqueCertificateCurriculum(where: $where) {
    id
    name
    amountOfHours
    CertificateCourse {
      id
      certificateBaseId
      name
    }
    CertificateCurriculumSelectedDisciplines {
      ...SelectedDisciplineFields
    }
  }
}
    ${SelectedDisciplineFieldsFragmentDoc}`;

/**
 * __useFindUniqueCertificateCurriculumQuery__
 *
 * To run a query within a React component, call `useFindUniqueCertificateCurriculumQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueCertificateCurriculumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueCertificateCurriculumQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueCertificateCurriculumQuery(baseOptions: ApolloReact.useQuery.Options<FindUniqueCertificateCurriculumQuery, FindUniqueCertificateCurriculumQueryVariables> & ({ variables: FindUniqueCertificateCurriculumQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniqueCertificateCurriculumQuery, FindUniqueCertificateCurriculumQueryVariables>(FindUniqueCertificateCurriculumDocument, options);
      }
export function useFindUniqueCertificateCurriculumLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniqueCertificateCurriculumQuery, FindUniqueCertificateCurriculumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniqueCertificateCurriculumQuery, FindUniqueCertificateCurriculumQueryVariables>(FindUniqueCertificateCurriculumDocument, options);
        }
export function useFindUniqueCertificateCurriculumSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniqueCertificateCurriculumQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniqueCertificateCurriculumQuery, FindUniqueCertificateCurriculumQueryVariables>(FindUniqueCertificateCurriculumDocument, options);
        }
export type FindUniqueCertificateCurriculumQueryHookResult = ReturnType<typeof useFindUniqueCertificateCurriculumQuery>;
export type FindUniqueCertificateCurriculumLazyQueryHookResult = ReturnType<typeof useFindUniqueCertificateCurriculumLazyQuery>;
export type FindUniqueCertificateCurriculumSuspenseQueryHookResult = ReturnType<typeof useFindUniqueCertificateCurriculumSuspenseQuery>;
export type FindUniqueCertificateCurriculumQueryResult = ApolloReact.useQuery.Result<FindUniqueCertificateCurriculumQuery, FindUniqueCertificateCurriculumQueryVariables>;
export const FindUniqueCertificateDisciplineDocument = gql`
    query findUniqueCertificateDiscipline($where: CertificateDisciplineWhereUniqueInput!) {
  findUniqueCertificateDiscipline(where: $where) {
    id
    certificateBaseId
    name
    viewOnDegree
  }
}
    `;

/**
 * __useFindUniqueCertificateDisciplineQuery__
 *
 * To run a query within a React component, call `useFindUniqueCertificateDisciplineQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueCertificateDisciplineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueCertificateDisciplineQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueCertificateDisciplineQuery(baseOptions: ApolloReact.useQuery.Options<FindUniqueCertificateDisciplineQuery, FindUniqueCertificateDisciplineQueryVariables> & ({ variables: FindUniqueCertificateDisciplineQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniqueCertificateDisciplineQuery, FindUniqueCertificateDisciplineQueryVariables>(FindUniqueCertificateDisciplineDocument, options);
      }
export function useFindUniqueCertificateDisciplineLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniqueCertificateDisciplineQuery, FindUniqueCertificateDisciplineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniqueCertificateDisciplineQuery, FindUniqueCertificateDisciplineQueryVariables>(FindUniqueCertificateDisciplineDocument, options);
        }
export function useFindUniqueCertificateDisciplineSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniqueCertificateDisciplineQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniqueCertificateDisciplineQuery, FindUniqueCertificateDisciplineQueryVariables>(FindUniqueCertificateDisciplineDocument, options);
        }
export type FindUniqueCertificateDisciplineQueryHookResult = ReturnType<typeof useFindUniqueCertificateDisciplineQuery>;
export type FindUniqueCertificateDisciplineLazyQueryHookResult = ReturnType<typeof useFindUniqueCertificateDisciplineLazyQuery>;
export type FindUniqueCertificateDisciplineSuspenseQueryHookResult = ReturnType<typeof useFindUniqueCertificateDisciplineSuspenseQuery>;
export type FindUniqueCertificateDisciplineQueryResult = ApolloReact.useQuery.Result<FindUniqueCertificateDisciplineQuery, FindUniqueCertificateDisciplineQueryVariables>;
export const FindUniqueCertificateEventDocument = gql`
    query findUniqueCertificateEvent($where: CertificateEventWhereUniqueInput!) {
  findUniqueCertificateEvent(where: $where) {
    id
    certificateBaseId
    name
    CertificateBase {
      id
      createdAt
    }
  }
}
    `;

/**
 * __useFindUniqueCertificateEventQuery__
 *
 * To run a query within a React component, call `useFindUniqueCertificateEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueCertificateEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueCertificateEventQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueCertificateEventQuery(baseOptions: ApolloReact.useQuery.Options<FindUniqueCertificateEventQuery, FindUniqueCertificateEventQueryVariables> & ({ variables: FindUniqueCertificateEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniqueCertificateEventQuery, FindUniqueCertificateEventQueryVariables>(FindUniqueCertificateEventDocument, options);
      }
export function useFindUniqueCertificateEventLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniqueCertificateEventQuery, FindUniqueCertificateEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniqueCertificateEventQuery, FindUniqueCertificateEventQueryVariables>(FindUniqueCertificateEventDocument, options);
        }
export function useFindUniqueCertificateEventSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniqueCertificateEventQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniqueCertificateEventQuery, FindUniqueCertificateEventQueryVariables>(FindUniqueCertificateEventDocument, options);
        }
export type FindUniqueCertificateEventQueryHookResult = ReturnType<typeof useFindUniqueCertificateEventQuery>;
export type FindUniqueCertificateEventLazyQueryHookResult = ReturnType<typeof useFindUniqueCertificateEventLazyQuery>;
export type FindUniqueCertificateEventSuspenseQueryHookResult = ReturnType<typeof useFindUniqueCertificateEventSuspenseQuery>;
export type FindUniqueCertificateEventQueryResult = ApolloReact.useQuery.Result<FindUniqueCertificateEventQuery, FindUniqueCertificateEventQueryVariables>;
export const FindUniqueCertificateTeacherDocument = gql`
    query findUniqueCertificateTeacher($where: CertificateTeacherWhereUniqueInput!) {
  findUniqueCertificateTeacher(where: $where) {
    id
    certificateBaseId
    name
    titration
    CertificateBase {
      id
      createdAt
    }
  }
}
    `;

/**
 * __useFindUniqueCertificateTeacherQuery__
 *
 * To run a query within a React component, call `useFindUniqueCertificateTeacherQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueCertificateTeacherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueCertificateTeacherQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueCertificateTeacherQuery(baseOptions: ApolloReact.useQuery.Options<FindUniqueCertificateTeacherQuery, FindUniqueCertificateTeacherQueryVariables> & ({ variables: FindUniqueCertificateTeacherQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniqueCertificateTeacherQuery, FindUniqueCertificateTeacherQueryVariables>(FindUniqueCertificateTeacherDocument, options);
      }
export function useFindUniqueCertificateTeacherLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniqueCertificateTeacherQuery, FindUniqueCertificateTeacherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniqueCertificateTeacherQuery, FindUniqueCertificateTeacherQueryVariables>(FindUniqueCertificateTeacherDocument, options);
        }
export function useFindUniqueCertificateTeacherSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniqueCertificateTeacherQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniqueCertificateTeacherQuery, FindUniqueCertificateTeacherQueryVariables>(FindUniqueCertificateTeacherDocument, options);
        }
export type FindUniqueCertificateTeacherQueryHookResult = ReturnType<typeof useFindUniqueCertificateTeacherQuery>;
export type FindUniqueCertificateTeacherLazyQueryHookResult = ReturnType<typeof useFindUniqueCertificateTeacherLazyQuery>;
export type FindUniqueCertificateTeacherSuspenseQueryHookResult = ReturnType<typeof useFindUniqueCertificateTeacherSuspenseQuery>;
export type FindUniqueCertificateTeacherQueryResult = ApolloReact.useQuery.Result<FindUniqueCertificateTeacherQuery, FindUniqueCertificateTeacherQueryVariables>;
export const FindUniqueCertificateTemplateDocument = gql`
    query findUniqueCertificateTemplate($where: CertificateTemplateWhereUniqueInput!) {
  findUniqueCertificateTemplate(where: $where) {
    ...CertificateTemplateFields
  }
}
    ${CertificateTemplateFieldsFragmentDoc}`;

/**
 * __useFindUniqueCertificateTemplateQuery__
 *
 * To run a query within a React component, call `useFindUniqueCertificateTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueCertificateTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueCertificateTemplateQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueCertificateTemplateQuery(baseOptions: ApolloReact.useQuery.Options<FindUniqueCertificateTemplateQuery, FindUniqueCertificateTemplateQueryVariables> & ({ variables: FindUniqueCertificateTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniqueCertificateTemplateQuery, FindUniqueCertificateTemplateQueryVariables>(FindUniqueCertificateTemplateDocument, options);
      }
export function useFindUniqueCertificateTemplateLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniqueCertificateTemplateQuery, FindUniqueCertificateTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniqueCertificateTemplateQuery, FindUniqueCertificateTemplateQueryVariables>(FindUniqueCertificateTemplateDocument, options);
        }
export function useFindUniqueCertificateTemplateSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniqueCertificateTemplateQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniqueCertificateTemplateQuery, FindUniqueCertificateTemplateQueryVariables>(FindUniqueCertificateTemplateDocument, options);
        }
export type FindUniqueCertificateTemplateQueryHookResult = ReturnType<typeof useFindUniqueCertificateTemplateQuery>;
export type FindUniqueCertificateTemplateLazyQueryHookResult = ReturnType<typeof useFindUniqueCertificateTemplateLazyQuery>;
export type FindUniqueCertificateTemplateSuspenseQueryHookResult = ReturnType<typeof useFindUniqueCertificateTemplateSuspenseQuery>;
export type FindUniqueCertificateTemplateQueryResult = ApolloReact.useQuery.Result<FindUniqueCertificateTemplateQuery, FindUniqueCertificateTemplateQueryVariables>;
export const FindUniqueCertificateTemplatePresetDocument = gql`
    query findUniqueCertificateTemplatePreset($where: CertificateTemplatePresetWhereUniqueInput!) {
  findUniqueCertificateTemplatePreset(where: $where) {
    id
    data
  }
}
    `;

/**
 * __useFindUniqueCertificateTemplatePresetQuery__
 *
 * To run a query within a React component, call `useFindUniqueCertificateTemplatePresetQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueCertificateTemplatePresetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueCertificateTemplatePresetQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueCertificateTemplatePresetQuery(baseOptions: ApolloReact.useQuery.Options<FindUniqueCertificateTemplatePresetQuery, FindUniqueCertificateTemplatePresetQueryVariables> & ({ variables: FindUniqueCertificateTemplatePresetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniqueCertificateTemplatePresetQuery, FindUniqueCertificateTemplatePresetQueryVariables>(FindUniqueCertificateTemplatePresetDocument, options);
      }
export function useFindUniqueCertificateTemplatePresetLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniqueCertificateTemplatePresetQuery, FindUniqueCertificateTemplatePresetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniqueCertificateTemplatePresetQuery, FindUniqueCertificateTemplatePresetQueryVariables>(FindUniqueCertificateTemplatePresetDocument, options);
        }
export function useFindUniqueCertificateTemplatePresetSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniqueCertificateTemplatePresetQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniqueCertificateTemplatePresetQuery, FindUniqueCertificateTemplatePresetQueryVariables>(FindUniqueCertificateTemplatePresetDocument, options);
        }
export type FindUniqueCertificateTemplatePresetQueryHookResult = ReturnType<typeof useFindUniqueCertificateTemplatePresetQuery>;
export type FindUniqueCertificateTemplatePresetLazyQueryHookResult = ReturnType<typeof useFindUniqueCertificateTemplatePresetLazyQuery>;
export type FindUniqueCertificateTemplatePresetSuspenseQueryHookResult = ReturnType<typeof useFindUniqueCertificateTemplatePresetSuspenseQuery>;
export type FindUniqueCertificateTemplatePresetQueryResult = ApolloReact.useQuery.Result<FindUniqueCertificateTemplatePresetQuery, FindUniqueCertificateTemplatePresetQueryVariables>;
export const FindUniqueDocumentDegreeDocument = gql`
    query findUniqueDocumentDegree($where: DocumentDegreeWhereUniqueInput!) {
  findUniqueDocumentDegree(where: $where) {
    ...DocumentDegreeUniqueFields
  }
}
    ${DocumentDegreeUniqueFieldsFragmentDoc}`;

/**
 * __useFindUniqueDocumentDegreeQuery__
 *
 * To run a query within a React component, call `useFindUniqueDocumentDegreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueDocumentDegreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueDocumentDegreeQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueDocumentDegreeQuery(baseOptions: ApolloReact.useQuery.Options<FindUniqueDocumentDegreeQuery, FindUniqueDocumentDegreeQueryVariables> & ({ variables: FindUniqueDocumentDegreeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniqueDocumentDegreeQuery, FindUniqueDocumentDegreeQueryVariables>(FindUniqueDocumentDegreeDocument, options);
      }
export function useFindUniqueDocumentDegreeLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniqueDocumentDegreeQuery, FindUniqueDocumentDegreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniqueDocumentDegreeQuery, FindUniqueDocumentDegreeQueryVariables>(FindUniqueDocumentDegreeDocument, options);
        }
export function useFindUniqueDocumentDegreeSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniqueDocumentDegreeQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniqueDocumentDegreeQuery, FindUniqueDocumentDegreeQueryVariables>(FindUniqueDocumentDegreeDocument, options);
        }
export type FindUniqueDocumentDegreeQueryHookResult = ReturnType<typeof useFindUniqueDocumentDegreeQuery>;
export type FindUniqueDocumentDegreeLazyQueryHookResult = ReturnType<typeof useFindUniqueDocumentDegreeLazyQuery>;
export type FindUniqueDocumentDegreeSuspenseQueryHookResult = ReturnType<typeof useFindUniqueDocumentDegreeSuspenseQuery>;
export type FindUniqueDocumentDegreeQueryResult = ApolloReact.useQuery.Result<FindUniqueDocumentDegreeQuery, FindUniqueDocumentDegreeQueryVariables>;
export const FindUniqueDegreeToSeeBySecurityCodeDocument = gql`
    query findUniqueDegreeToSeeBySecurityCode($domain: String!, $recaptchaResponse: String!, $securityCode: String!) {
  findUniqueDegreeToSeeBySecurityCode(
    domain: $domain
    recaptchaResponse: $recaptchaResponse
    securityCode: $securityCode
  ) {
    ...DegreeViewDegree
  }
}
    ${DegreeViewDegreeFragmentDoc}`;

/**
 * __useFindUniqueDegreeToSeeBySecurityCodeQuery__
 *
 * To run a query within a React component, call `useFindUniqueDegreeToSeeBySecurityCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueDegreeToSeeBySecurityCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueDegreeToSeeBySecurityCodeQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *      recaptchaResponse: // value for 'recaptchaResponse'
 *      securityCode: // value for 'securityCode'
 *   },
 * });
 */
export function useFindUniqueDegreeToSeeBySecurityCodeQuery(baseOptions: ApolloReact.useQuery.Options<FindUniqueDegreeToSeeBySecurityCodeQuery, FindUniqueDegreeToSeeBySecurityCodeQueryVariables> & ({ variables: FindUniqueDegreeToSeeBySecurityCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniqueDegreeToSeeBySecurityCodeQuery, FindUniqueDegreeToSeeBySecurityCodeQueryVariables>(FindUniqueDegreeToSeeBySecurityCodeDocument, options);
      }
export function useFindUniqueDegreeToSeeBySecurityCodeLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniqueDegreeToSeeBySecurityCodeQuery, FindUniqueDegreeToSeeBySecurityCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniqueDegreeToSeeBySecurityCodeQuery, FindUniqueDegreeToSeeBySecurityCodeQueryVariables>(FindUniqueDegreeToSeeBySecurityCodeDocument, options);
        }
export function useFindUniqueDegreeToSeeBySecurityCodeSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniqueDegreeToSeeBySecurityCodeQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniqueDegreeToSeeBySecurityCodeQuery, FindUniqueDegreeToSeeBySecurityCodeQueryVariables>(FindUniqueDegreeToSeeBySecurityCodeDocument, options);
        }
export type FindUniqueDegreeToSeeBySecurityCodeQueryHookResult = ReturnType<typeof useFindUniqueDegreeToSeeBySecurityCodeQuery>;
export type FindUniqueDegreeToSeeBySecurityCodeLazyQueryHookResult = ReturnType<typeof useFindUniqueDegreeToSeeBySecurityCodeLazyQuery>;
export type FindUniqueDegreeToSeeBySecurityCodeSuspenseQueryHookResult = ReturnType<typeof useFindUniqueDegreeToSeeBySecurityCodeSuspenseQuery>;
export type FindUniqueDegreeToSeeBySecurityCodeQueryResult = ApolloReact.useQuery.Result<FindUniqueDegreeToSeeBySecurityCodeQuery, FindUniqueDegreeToSeeBySecurityCodeQueryVariables>;
export const FindUniqueDocumentAcademicDocumentationDocument = gql`
    query findUniqueDocumentAcademicDocumentation($where: DocumentAcademicDocumentationWhereUniqueInput!) {
  findUnique: findUniqueDocumentAcademicDocumentation(where: $where) {
    ...DocumentAcademicDocumentationFields
  }
}
    ${DocumentAcademicDocumentationFieldsFragmentDoc}`;

/**
 * __useFindUniqueDocumentAcademicDocumentationQuery__
 *
 * To run a query within a React component, call `useFindUniqueDocumentAcademicDocumentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueDocumentAcademicDocumentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueDocumentAcademicDocumentationQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueDocumentAcademicDocumentationQuery(baseOptions: ApolloReact.useQuery.Options<FindUniqueDocumentAcademicDocumentationQuery, FindUniqueDocumentAcademicDocumentationQueryVariables> & ({ variables: FindUniqueDocumentAcademicDocumentationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniqueDocumentAcademicDocumentationQuery, FindUniqueDocumentAcademicDocumentationQueryVariables>(FindUniqueDocumentAcademicDocumentationDocument, options);
      }
export function useFindUniqueDocumentAcademicDocumentationLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniqueDocumentAcademicDocumentationQuery, FindUniqueDocumentAcademicDocumentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniqueDocumentAcademicDocumentationQuery, FindUniqueDocumentAcademicDocumentationQueryVariables>(FindUniqueDocumentAcademicDocumentationDocument, options);
        }
export function useFindUniqueDocumentAcademicDocumentationSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniqueDocumentAcademicDocumentationQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniqueDocumentAcademicDocumentationQuery, FindUniqueDocumentAcademicDocumentationQueryVariables>(FindUniqueDocumentAcademicDocumentationDocument, options);
        }
export type FindUniqueDocumentAcademicDocumentationQueryHookResult = ReturnType<typeof useFindUniqueDocumentAcademicDocumentationQuery>;
export type FindUniqueDocumentAcademicDocumentationLazyQueryHookResult = ReturnType<typeof useFindUniqueDocumentAcademicDocumentationLazyQuery>;
export type FindUniqueDocumentAcademicDocumentationSuspenseQueryHookResult = ReturnType<typeof useFindUniqueDocumentAcademicDocumentationSuspenseQuery>;
export type FindUniqueDocumentAcademicDocumentationQueryResult = ApolloReact.useQuery.Result<FindUniqueDocumentAcademicDocumentationQuery, FindUniqueDocumentAcademicDocumentationQueryVariables>;
export const FindUniqueDocumentAuditFileIssuerDocument = gql`
    query findUniqueDocumentAuditFileIssuer($where: DocumentAuditFileIssuerWhereUniqueInput!) {
  findUnique: findUniqueDocumentAuditFileIssuer(where: $where) {
    ...DocumentAuditFileIssuerFields
  }
}
    ${DocumentAuditFileIssuerFieldsFragmentDoc}`;

/**
 * __useFindUniqueDocumentAuditFileIssuerQuery__
 *
 * To run a query within a React component, call `useFindUniqueDocumentAuditFileIssuerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueDocumentAuditFileIssuerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueDocumentAuditFileIssuerQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueDocumentAuditFileIssuerQuery(baseOptions: ApolloReact.useQuery.Options<FindUniqueDocumentAuditFileIssuerQuery, FindUniqueDocumentAuditFileIssuerQueryVariables> & ({ variables: FindUniqueDocumentAuditFileIssuerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniqueDocumentAuditFileIssuerQuery, FindUniqueDocumentAuditFileIssuerQueryVariables>(FindUniqueDocumentAuditFileIssuerDocument, options);
      }
export function useFindUniqueDocumentAuditFileIssuerLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniqueDocumentAuditFileIssuerQuery, FindUniqueDocumentAuditFileIssuerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniqueDocumentAuditFileIssuerQuery, FindUniqueDocumentAuditFileIssuerQueryVariables>(FindUniqueDocumentAuditFileIssuerDocument, options);
        }
export function useFindUniqueDocumentAuditFileIssuerSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniqueDocumentAuditFileIssuerQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniqueDocumentAuditFileIssuerQuery, FindUniqueDocumentAuditFileIssuerQueryVariables>(FindUniqueDocumentAuditFileIssuerDocument, options);
        }
export type FindUniqueDocumentAuditFileIssuerQueryHookResult = ReturnType<typeof useFindUniqueDocumentAuditFileIssuerQuery>;
export type FindUniqueDocumentAuditFileIssuerLazyQueryHookResult = ReturnType<typeof useFindUniqueDocumentAuditFileIssuerLazyQuery>;
export type FindUniqueDocumentAuditFileIssuerSuspenseQueryHookResult = ReturnType<typeof useFindUniqueDocumentAuditFileIssuerSuspenseQuery>;
export type FindUniqueDocumentAuditFileIssuerQueryResult = ApolloReact.useQuery.Result<FindUniqueDocumentAuditFileIssuerQuery, FindUniqueDocumentAuditFileIssuerQueryVariables>;
export const FindUniqueDocumentBaseDefaultSignatureInviteConfigurationDocument = gql`
    query findUniqueDocumentBaseDefaultSignatureInviteConfiguration($where: DocumentBaseDefaultSignatureInviteConfigurationWhereUniqueInput!) {
  findUniqueDocumentBaseDefaultSignatureInviteConfiguration(where: $where) {
    id
    type
    createdAt
    updatedAt
    addSignersNode
    signatureConfig
    Groups {
      id
      Items {
        id
        teamMemberId
        TeamMember {
          id
          User {
            id
            name
            email
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFindUniqueDocumentBaseDefaultSignatureInviteConfigurationQuery__
 *
 * To run a query within a React component, call `useFindUniqueDocumentBaseDefaultSignatureInviteConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueDocumentBaseDefaultSignatureInviteConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueDocumentBaseDefaultSignatureInviteConfigurationQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueDocumentBaseDefaultSignatureInviteConfigurationQuery(baseOptions: ApolloReact.useQuery.Options<FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQuery, FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQueryVariables> & ({ variables: FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQuery, FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQueryVariables>(FindUniqueDocumentBaseDefaultSignatureInviteConfigurationDocument, options);
      }
export function useFindUniqueDocumentBaseDefaultSignatureInviteConfigurationLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQuery, FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQuery, FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQueryVariables>(FindUniqueDocumentBaseDefaultSignatureInviteConfigurationDocument, options);
        }
export function useFindUniqueDocumentBaseDefaultSignatureInviteConfigurationSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQuery, FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQueryVariables>(FindUniqueDocumentBaseDefaultSignatureInviteConfigurationDocument, options);
        }
export type FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQueryHookResult = ReturnType<typeof useFindUniqueDocumentBaseDefaultSignatureInviteConfigurationQuery>;
export type FindUniqueDocumentBaseDefaultSignatureInviteConfigurationLazyQueryHookResult = ReturnType<typeof useFindUniqueDocumentBaseDefaultSignatureInviteConfigurationLazyQuery>;
export type FindUniqueDocumentBaseDefaultSignatureInviteConfigurationSuspenseQueryHookResult = ReturnType<typeof useFindUniqueDocumentBaseDefaultSignatureInviteConfigurationSuspenseQuery>;
export type FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQueryResult = ApolloReact.useQuery.Result<FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQuery, FindUniqueDocumentBaseDefaultSignatureInviteConfigurationQueryVariables>;
export const FindUniqueDocumentBaseSignatureInviteDocument = gql`
    query findUniqueDocumentBaseSignatureInvite($where: DocumentBaseSignatureInviteWhereUniqueInput!) {
  findUniqueDocumentBaseSignatureInvite(where: $where) {
    ...DocumentBaseSignatureInviteFields
  }
}
    ${DocumentBaseSignatureInviteFieldsFragmentDoc}`;

/**
 * __useFindUniqueDocumentBaseSignatureInviteQuery__
 *
 * To run a query within a React component, call `useFindUniqueDocumentBaseSignatureInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueDocumentBaseSignatureInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueDocumentBaseSignatureInviteQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueDocumentBaseSignatureInviteQuery(baseOptions: ApolloReact.useQuery.Options<FindUniqueDocumentBaseSignatureInviteQuery, FindUniqueDocumentBaseSignatureInviteQueryVariables> & ({ variables: FindUniqueDocumentBaseSignatureInviteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniqueDocumentBaseSignatureInviteQuery, FindUniqueDocumentBaseSignatureInviteQueryVariables>(FindUniqueDocumentBaseSignatureInviteDocument, options);
      }
export function useFindUniqueDocumentBaseSignatureInviteLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniqueDocumentBaseSignatureInviteQuery, FindUniqueDocumentBaseSignatureInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniqueDocumentBaseSignatureInviteQuery, FindUniqueDocumentBaseSignatureInviteQueryVariables>(FindUniqueDocumentBaseSignatureInviteDocument, options);
        }
export function useFindUniqueDocumentBaseSignatureInviteSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniqueDocumentBaseSignatureInviteQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniqueDocumentBaseSignatureInviteQuery, FindUniqueDocumentBaseSignatureInviteQueryVariables>(FindUniqueDocumentBaseSignatureInviteDocument, options);
        }
export type FindUniqueDocumentBaseSignatureInviteQueryHookResult = ReturnType<typeof useFindUniqueDocumentBaseSignatureInviteQuery>;
export type FindUniqueDocumentBaseSignatureInviteLazyQueryHookResult = ReturnType<typeof useFindUniqueDocumentBaseSignatureInviteLazyQuery>;
export type FindUniqueDocumentBaseSignatureInviteSuspenseQueryHookResult = ReturnType<typeof useFindUniqueDocumentBaseSignatureInviteSuspenseQuery>;
export type FindUniqueDocumentBaseSignatureInviteQueryResult = ApolloReact.useQuery.Result<FindUniqueDocumentBaseSignatureInviteQuery, FindUniqueDocumentBaseSignatureInviteQueryVariables>;
export const FindUniqueDocumentCertificateDocument = gql`
    query findUniqueDocumentCertificate($where: DocumentCertificateWhereUniqueInput!) {
  findUniqueDocumentCertificate(where: $where) {
    ...DocumentCertificateFields
  }
}
    ${DocumentCertificateFieldsFragmentDoc}`;

/**
 * __useFindUniqueDocumentCertificateQuery__
 *
 * To run a query within a React component, call `useFindUniqueDocumentCertificateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueDocumentCertificateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueDocumentCertificateQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueDocumentCertificateQuery(baseOptions: ApolloReact.useQuery.Options<FindUniqueDocumentCertificateQuery, FindUniqueDocumentCertificateQueryVariables> & ({ variables: FindUniqueDocumentCertificateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniqueDocumentCertificateQuery, FindUniqueDocumentCertificateQueryVariables>(FindUniqueDocumentCertificateDocument, options);
      }
export function useFindUniqueDocumentCertificateLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniqueDocumentCertificateQuery, FindUniqueDocumentCertificateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniqueDocumentCertificateQuery, FindUniqueDocumentCertificateQueryVariables>(FindUniqueDocumentCertificateDocument, options);
        }
export function useFindUniqueDocumentCertificateSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniqueDocumentCertificateQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniqueDocumentCertificateQuery, FindUniqueDocumentCertificateQueryVariables>(FindUniqueDocumentCertificateDocument, options);
        }
export type FindUniqueDocumentCertificateQueryHookResult = ReturnType<typeof useFindUniqueDocumentCertificateQuery>;
export type FindUniqueDocumentCertificateLazyQueryHookResult = ReturnType<typeof useFindUniqueDocumentCertificateLazyQuery>;
export type FindUniqueDocumentCertificateSuspenseQueryHookResult = ReturnType<typeof useFindUniqueDocumentCertificateSuspenseQuery>;
export type FindUniqueDocumentCertificateQueryResult = ApolloReact.useQuery.Result<FindUniqueDocumentCertificateQuery, FindUniqueDocumentCertificateQueryVariables>;
export const FindUniqueDocumentCertificateSignatureItemDocument = gql`
    query findUniqueDocumentCertificateSignatureItem($where: DocumentCertificateSignatureItemWhereUniqueInput!) {
  findUniqueDocumentCertificateSignatureItem(where: $where) {
    ...DocumentCertificateSignatureItemFields
  }
}
    ${DocumentCertificateSignatureItemFieldsFragmentDoc}`;

/**
 * __useFindUniqueDocumentCertificateSignatureItemQuery__
 *
 * To run a query within a React component, call `useFindUniqueDocumentCertificateSignatureItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueDocumentCertificateSignatureItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueDocumentCertificateSignatureItemQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueDocumentCertificateSignatureItemQuery(baseOptions: ApolloReact.useQuery.Options<FindUniqueDocumentCertificateSignatureItemQuery, FindUniqueDocumentCertificateSignatureItemQueryVariables> & ({ variables: FindUniqueDocumentCertificateSignatureItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniqueDocumentCertificateSignatureItemQuery, FindUniqueDocumentCertificateSignatureItemQueryVariables>(FindUniqueDocumentCertificateSignatureItemDocument, options);
      }
export function useFindUniqueDocumentCertificateSignatureItemLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniqueDocumentCertificateSignatureItemQuery, FindUniqueDocumentCertificateSignatureItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniqueDocumentCertificateSignatureItemQuery, FindUniqueDocumentCertificateSignatureItemQueryVariables>(FindUniqueDocumentCertificateSignatureItemDocument, options);
        }
export function useFindUniqueDocumentCertificateSignatureItemSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniqueDocumentCertificateSignatureItemQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniqueDocumentCertificateSignatureItemQuery, FindUniqueDocumentCertificateSignatureItemQueryVariables>(FindUniqueDocumentCertificateSignatureItemDocument, options);
        }
export type FindUniqueDocumentCertificateSignatureItemQueryHookResult = ReturnType<typeof useFindUniqueDocumentCertificateSignatureItemQuery>;
export type FindUniqueDocumentCertificateSignatureItemLazyQueryHookResult = ReturnType<typeof useFindUniqueDocumentCertificateSignatureItemLazyQuery>;
export type FindUniqueDocumentCertificateSignatureItemSuspenseQueryHookResult = ReturnType<typeof useFindUniqueDocumentCertificateSignatureItemSuspenseQuery>;
export type FindUniqueDocumentCertificateSignatureItemQueryResult = ApolloReact.useQuery.Result<FindUniqueDocumentCertificateSignatureItemQuery, FindUniqueDocumentCertificateSignatureItemQueryVariables>;
export const FindUniqueDocumentFinalAcademicTranscriptDocument = gql`
    query findUniqueDocumentFinalAcademicTranscript($where: DocumentFinalAcademicTranscriptWhereUniqueInput!) {
  findUnique: findUniqueDocumentFinalAcademicTranscript(where: $where) {
    ...DocumentFinalAcademicTranscriptFields
  }
}
    ${DocumentFinalAcademicTranscriptFieldsFragmentDoc}`;

/**
 * __useFindUniqueDocumentFinalAcademicTranscriptQuery__
 *
 * To run a query within a React component, call `useFindUniqueDocumentFinalAcademicTranscriptQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueDocumentFinalAcademicTranscriptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueDocumentFinalAcademicTranscriptQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueDocumentFinalAcademicTranscriptQuery(baseOptions: ApolloReact.useQuery.Options<FindUniqueDocumentFinalAcademicTranscriptQuery, FindUniqueDocumentFinalAcademicTranscriptQueryVariables> & ({ variables: FindUniqueDocumentFinalAcademicTranscriptQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniqueDocumentFinalAcademicTranscriptQuery, FindUniqueDocumentFinalAcademicTranscriptQueryVariables>(FindUniqueDocumentFinalAcademicTranscriptDocument, options);
      }
export function useFindUniqueDocumentFinalAcademicTranscriptLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniqueDocumentFinalAcademicTranscriptQuery, FindUniqueDocumentFinalAcademicTranscriptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniqueDocumentFinalAcademicTranscriptQuery, FindUniqueDocumentFinalAcademicTranscriptQueryVariables>(FindUniqueDocumentFinalAcademicTranscriptDocument, options);
        }
export function useFindUniqueDocumentFinalAcademicTranscriptSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniqueDocumentFinalAcademicTranscriptQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniqueDocumentFinalAcademicTranscriptQuery, FindUniqueDocumentFinalAcademicTranscriptQueryVariables>(FindUniqueDocumentFinalAcademicTranscriptDocument, options);
        }
export type FindUniqueDocumentFinalAcademicTranscriptQueryHookResult = ReturnType<typeof useFindUniqueDocumentFinalAcademicTranscriptQuery>;
export type FindUniqueDocumentFinalAcademicTranscriptLazyQueryHookResult = ReturnType<typeof useFindUniqueDocumentFinalAcademicTranscriptLazyQuery>;
export type FindUniqueDocumentFinalAcademicTranscriptSuspenseQueryHookResult = ReturnType<typeof useFindUniqueDocumentFinalAcademicTranscriptSuspenseQuery>;
export type FindUniqueDocumentFinalAcademicTranscriptQueryResult = ApolloReact.useQuery.Result<FindUniqueDocumentFinalAcademicTranscriptQuery, FindUniqueDocumentFinalAcademicTranscriptQueryVariables>;
export const FindUniqueDocumentSchoolCurriculumDocument = gql`
    query findUniqueDocumentSchoolCurriculum($where: DocumentSchoolCurriculumWhereUniqueInput!) {
  findUniqueDocumentSchoolCurriculum(where: $where) {
    ...DocumentSchoolCurriculumFields
  }
}
    ${DocumentSchoolCurriculumFieldsFragmentDoc}`;

/**
 * __useFindUniqueDocumentSchoolCurriculumQuery__
 *
 * To run a query within a React component, call `useFindUniqueDocumentSchoolCurriculumQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueDocumentSchoolCurriculumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueDocumentSchoolCurriculumQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueDocumentSchoolCurriculumQuery(baseOptions: ApolloReact.useQuery.Options<FindUniqueDocumentSchoolCurriculumQuery, FindUniqueDocumentSchoolCurriculumQueryVariables> & ({ variables: FindUniqueDocumentSchoolCurriculumQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniqueDocumentSchoolCurriculumQuery, FindUniqueDocumentSchoolCurriculumQueryVariables>(FindUniqueDocumentSchoolCurriculumDocument, options);
      }
export function useFindUniqueDocumentSchoolCurriculumLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniqueDocumentSchoolCurriculumQuery, FindUniqueDocumentSchoolCurriculumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniqueDocumentSchoolCurriculumQuery, FindUniqueDocumentSchoolCurriculumQueryVariables>(FindUniqueDocumentSchoolCurriculumDocument, options);
        }
export function useFindUniqueDocumentSchoolCurriculumSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniqueDocumentSchoolCurriculumQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniqueDocumentSchoolCurriculumQuery, FindUniqueDocumentSchoolCurriculumQueryVariables>(FindUniqueDocumentSchoolCurriculumDocument, options);
        }
export type FindUniqueDocumentSchoolCurriculumQueryHookResult = ReturnType<typeof useFindUniqueDocumentSchoolCurriculumQuery>;
export type FindUniqueDocumentSchoolCurriculumLazyQueryHookResult = ReturnType<typeof useFindUniqueDocumentSchoolCurriculumLazyQuery>;
export type FindUniqueDocumentSchoolCurriculumSuspenseQueryHookResult = ReturnType<typeof useFindUniqueDocumentSchoolCurriculumSuspenseQuery>;
export type FindUniqueDocumentSchoolCurriculumQueryResult = ApolloReact.useQuery.Result<FindUniqueDocumentSchoolCurriculumQuery, FindUniqueDocumentSchoolCurriculumQueryVariables>;
export const FindUniqueExternalSignatureInviteDocument = gql`
    query findUniqueExternalSignatureInvite($where: ExternalSignatureInviteWhereUniqueInput!) {
  findUniqueExternalSignatureInvite(where: $where) {
    ...ExternalSignatureInviteFields
  }
}
    ${ExternalSignatureInviteFieldsFragmentDoc}`;

/**
 * __useFindUniqueExternalSignatureInviteQuery__
 *
 * To run a query within a React component, call `useFindUniqueExternalSignatureInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueExternalSignatureInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueExternalSignatureInviteQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueExternalSignatureInviteQuery(baseOptions: ApolloReact.useQuery.Options<FindUniqueExternalSignatureInviteQuery, FindUniqueExternalSignatureInviteQueryVariables> & ({ variables: FindUniqueExternalSignatureInviteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniqueExternalSignatureInviteQuery, FindUniqueExternalSignatureInviteQueryVariables>(FindUniqueExternalSignatureInviteDocument, options);
      }
export function useFindUniqueExternalSignatureInviteLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniqueExternalSignatureInviteQuery, FindUniqueExternalSignatureInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniqueExternalSignatureInviteQuery, FindUniqueExternalSignatureInviteQueryVariables>(FindUniqueExternalSignatureInviteDocument, options);
        }
export function useFindUniqueExternalSignatureInviteSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniqueExternalSignatureInviteQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniqueExternalSignatureInviteQuery, FindUniqueExternalSignatureInviteQueryVariables>(FindUniqueExternalSignatureInviteDocument, options);
        }
export type FindUniqueExternalSignatureInviteQueryHookResult = ReturnType<typeof useFindUniqueExternalSignatureInviteQuery>;
export type FindUniqueExternalSignatureInviteLazyQueryHookResult = ReturnType<typeof useFindUniqueExternalSignatureInviteLazyQuery>;
export type FindUniqueExternalSignatureInviteSuspenseQueryHookResult = ReturnType<typeof useFindUniqueExternalSignatureInviteSuspenseQuery>;
export type FindUniqueExternalSignatureInviteQueryResult = ApolloReact.useQuery.Result<FindUniqueExternalSignatureInviteQuery, FindUniqueExternalSignatureInviteQueryVariables>;
export const FindUniquePersonDocument = gql`
    query findUniquePerson($where: PersonWhereUniqueInput!) {
  findUniquePerson(where: $where) {
    ...PersonFields
  }
}
    ${PersonFieldsFragmentDoc}`;

/**
 * __useFindUniquePersonQuery__
 *
 * To run a query within a React component, call `useFindUniquePersonQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniquePersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniquePersonQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniquePersonQuery(baseOptions: ApolloReact.useQuery.Options<FindUniquePersonQuery, FindUniquePersonQueryVariables> & ({ variables: FindUniquePersonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniquePersonQuery, FindUniquePersonQueryVariables>(FindUniquePersonDocument, options);
      }
export function useFindUniquePersonLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniquePersonQuery, FindUniquePersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniquePersonQuery, FindUniquePersonQueryVariables>(FindUniquePersonDocument, options);
        }
export function useFindUniquePersonSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniquePersonQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniquePersonQuery, FindUniquePersonQueryVariables>(FindUniquePersonDocument, options);
        }
export type FindUniquePersonQueryHookResult = ReturnType<typeof useFindUniquePersonQuery>;
export type FindUniquePersonLazyQueryHookResult = ReturnType<typeof useFindUniquePersonLazyQuery>;
export type FindUniquePersonSuspenseQueryHookResult = ReturnType<typeof useFindUniquePersonSuspenseQuery>;
export type FindUniquePersonQueryResult = ApolloReact.useQuery.Result<FindUniquePersonQuery, FindUniquePersonQueryVariables>;
export const FindUniqueReusableFormDataCurriculumDocument = gql`
    query findUniqueReusableFormDataCurriculum($where: ReusableFormDataCurriculumWhereUniqueInput!) {
  findUniqueReusableFormDataCurriculum(where: $where) {
    ...ReusableFormDataCurriculumUniqueFields
  }
}
    ${ReusableFormDataCurriculumUniqueFieldsFragmentDoc}`;

/**
 * __useFindUniqueReusableFormDataCurriculumQuery__
 *
 * To run a query within a React component, call `useFindUniqueReusableFormDataCurriculumQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueReusableFormDataCurriculumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueReusableFormDataCurriculumQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueReusableFormDataCurriculumQuery(baseOptions: ApolloReact.useQuery.Options<FindUniqueReusableFormDataCurriculumQuery, FindUniqueReusableFormDataCurriculumQueryVariables> & ({ variables: FindUniqueReusableFormDataCurriculumQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniqueReusableFormDataCurriculumQuery, FindUniqueReusableFormDataCurriculumQueryVariables>(FindUniqueReusableFormDataCurriculumDocument, options);
      }
export function useFindUniqueReusableFormDataCurriculumLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniqueReusableFormDataCurriculumQuery, FindUniqueReusableFormDataCurriculumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniqueReusableFormDataCurriculumQuery, FindUniqueReusableFormDataCurriculumQueryVariables>(FindUniqueReusableFormDataCurriculumDocument, options);
        }
export function useFindUniqueReusableFormDataCurriculumSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniqueReusableFormDataCurriculumQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniqueReusableFormDataCurriculumQuery, FindUniqueReusableFormDataCurriculumQueryVariables>(FindUniqueReusableFormDataCurriculumDocument, options);
        }
export type FindUniqueReusableFormDataCurriculumQueryHookResult = ReturnType<typeof useFindUniqueReusableFormDataCurriculumQuery>;
export type FindUniqueReusableFormDataCurriculumLazyQueryHookResult = ReturnType<typeof useFindUniqueReusableFormDataCurriculumLazyQuery>;
export type FindUniqueReusableFormDataCurriculumSuspenseQueryHookResult = ReturnType<typeof useFindUniqueReusableFormDataCurriculumSuspenseQuery>;
export type FindUniqueReusableFormDataCurriculumQueryResult = ApolloReact.useQuery.Result<FindUniqueReusableFormDataCurriculumQuery, FindUniqueReusableFormDataCurriculumQueryVariables>;
export const FindUniqueSignSignatureImageDocument = gql`
    query findUniqueSignSignatureImage($where: SignSignatureImageWhereUniqueInput!) {
  findUniqueSignSignatureImage(where: $where) {
    ...SignSignatureImageUniqueFields
  }
}
    ${SignSignatureImageUniqueFieldsFragmentDoc}`;

/**
 * __useFindUniqueSignSignatureImageQuery__
 *
 * To run a query within a React component, call `useFindUniqueSignSignatureImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueSignSignatureImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueSignSignatureImageQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueSignSignatureImageQuery(baseOptions: ApolloReact.useQuery.Options<FindUniqueSignSignatureImageQuery, FindUniqueSignSignatureImageQueryVariables> & ({ variables: FindUniqueSignSignatureImageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniqueSignSignatureImageQuery, FindUniqueSignSignatureImageQueryVariables>(FindUniqueSignSignatureImageDocument, options);
      }
export function useFindUniqueSignSignatureImageLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniqueSignSignatureImageQuery, FindUniqueSignSignatureImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniqueSignSignatureImageQuery, FindUniqueSignSignatureImageQueryVariables>(FindUniqueSignSignatureImageDocument, options);
        }
export function useFindUniqueSignSignatureImageSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniqueSignSignatureImageQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniqueSignSignatureImageQuery, FindUniqueSignSignatureImageQueryVariables>(FindUniqueSignSignatureImageDocument, options);
        }
export type FindUniqueSignSignatureImageQueryHookResult = ReturnType<typeof useFindUniqueSignSignatureImageQuery>;
export type FindUniqueSignSignatureImageLazyQueryHookResult = ReturnType<typeof useFindUniqueSignSignatureImageLazyQuery>;
export type FindUniqueSignSignatureImageSuspenseQueryHookResult = ReturnType<typeof useFindUniqueSignSignatureImageSuspenseQuery>;
export type FindUniqueSignSignatureImageQueryResult = ApolloReact.useQuery.Result<FindUniqueSignSignatureImageQuery, FindUniqueSignSignatureImageQueryVariables>;
export const FindUniqueTeamDocument = gql`
    query findUniqueTeam($where: TeamWhereUniqueInput!, $take: Int, $skip: Int, $orderBy: [TeamMemberOrderByWithRelationInput!], $teamMemberWhere: TeamMemberWhereInput) {
  findUniqueTeam(where: $where) {
    ...UniqueTeamFields
  }
}
    ${UniqueTeamFieldsFragmentDoc}`;

/**
 * __useFindUniqueTeamQuery__
 *
 * To run a query within a React component, call `useFindUniqueTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueTeamQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *      teamMemberWhere: // value for 'teamMemberWhere'
 *   },
 * });
 */
export function useFindUniqueTeamQuery(baseOptions: ApolloReact.useQuery.Options<FindUniqueTeamQuery, FindUniqueTeamQueryVariables> & ({ variables: FindUniqueTeamQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniqueTeamQuery, FindUniqueTeamQueryVariables>(FindUniqueTeamDocument, options);
      }
export function useFindUniqueTeamLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniqueTeamQuery, FindUniqueTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniqueTeamQuery, FindUniqueTeamQueryVariables>(FindUniqueTeamDocument, options);
        }
export function useFindUniqueTeamSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniqueTeamQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniqueTeamQuery, FindUniqueTeamQueryVariables>(FindUniqueTeamDocument, options);
        }
export type FindUniqueTeamQueryHookResult = ReturnType<typeof useFindUniqueTeamQuery>;
export type FindUniqueTeamLazyQueryHookResult = ReturnType<typeof useFindUniqueTeamLazyQuery>;
export type FindUniqueTeamSuspenseQueryHookResult = ReturnType<typeof useFindUniqueTeamSuspenseQuery>;
export type FindUniqueTeamQueryResult = ApolloReact.useQuery.Result<FindUniqueTeamQuery, FindUniqueTeamQueryVariables>;
export const FindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigDocument = gql`
    query findUniqueTeamDocumentTypeSpecificSignaturePolicyConfig($where: TeamDocumentTypeSpecificSignaturePolicyConfigWhereUniqueInput!) {
  findUniqueTeamDocumentTypeSpecificSignaturePolicyConfig(where: $where) {
    id
    teamId
    documentType
    groupPolicies
  }
}
    `;

/**
 * __useFindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigQuery__
 *
 * To run a query within a React component, call `useFindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigQuery(baseOptions: ApolloReact.useQuery.Options<FindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigQuery, FindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigQueryVariables> & ({ variables: FindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigQuery, FindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigQueryVariables>(FindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigDocument, options);
      }
export function useFindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigQuery, FindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigQuery, FindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigQueryVariables>(FindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigDocument, options);
        }
export function useFindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigQuery, FindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigQueryVariables>(FindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigDocument, options);
        }
export type FindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigQueryHookResult = ReturnType<typeof useFindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigQuery>;
export type FindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigLazyQueryHookResult = ReturnType<typeof useFindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigLazyQuery>;
export type FindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigSuspenseQueryHookResult = ReturnType<typeof useFindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigSuspenseQuery>;
export type FindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigQueryResult = ApolloReact.useQuery.Result<FindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigQuery, FindUniqueTeamDocumentTypeSpecificSignaturePolicyConfigQueryVariables>;
export const FindUniqueTeamForUsagePanelDocument = gql`
    query findUniqueTeamForUsagePanel($where: TeamWhereUniqueInput!) {
  findUniqueTeam(where: $where) {
    id
    spaceUsage
    storage
    issuerName
    publicViewInstitutionName
    EnabledInstitution {
      id
      placeholderName
    }
    maintainerSpace {
      id
      usage
      storage
    }
  }
}
    `;

/**
 * __useFindUniqueTeamForUsagePanelQuery__
 *
 * To run a query within a React component, call `useFindUniqueTeamForUsagePanelQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueTeamForUsagePanelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueTeamForUsagePanelQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueTeamForUsagePanelQuery(baseOptions: ApolloReact.useQuery.Options<FindUniqueTeamForUsagePanelQuery, FindUniqueTeamForUsagePanelQueryVariables> & ({ variables: FindUniqueTeamForUsagePanelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniqueTeamForUsagePanelQuery, FindUniqueTeamForUsagePanelQueryVariables>(FindUniqueTeamForUsagePanelDocument, options);
      }
export function useFindUniqueTeamForUsagePanelLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniqueTeamForUsagePanelQuery, FindUniqueTeamForUsagePanelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniqueTeamForUsagePanelQuery, FindUniqueTeamForUsagePanelQueryVariables>(FindUniqueTeamForUsagePanelDocument, options);
        }
export function useFindUniqueTeamForUsagePanelSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniqueTeamForUsagePanelQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniqueTeamForUsagePanelQuery, FindUniqueTeamForUsagePanelQueryVariables>(FindUniqueTeamForUsagePanelDocument, options);
        }
export type FindUniqueTeamForUsagePanelQueryHookResult = ReturnType<typeof useFindUniqueTeamForUsagePanelQuery>;
export type FindUniqueTeamForUsagePanelLazyQueryHookResult = ReturnType<typeof useFindUniqueTeamForUsagePanelLazyQuery>;
export type FindUniqueTeamForUsagePanelSuspenseQueryHookResult = ReturnType<typeof useFindUniqueTeamForUsagePanelSuspenseQuery>;
export type FindUniqueTeamForUsagePanelQueryResult = ApolloReact.useQuery.Result<FindUniqueTeamForUsagePanelQuery, FindUniqueTeamForUsagePanelQueryVariables>;
export const FindUniqueToSeePublicDocumentDocument = gql`
    query findUniqueToSeePublicDocument($recaptchaResponse: String!) {
  findUniqueToSeePublicDocument(recaptchaResponse: $recaptchaResponse) {
    ...PublicViewFields
  }
}
    ${PublicViewFieldsFragmentDoc}`;

/**
 * __useFindUniqueToSeePublicDocumentQuery__
 *
 * To run a query within a React component, call `useFindUniqueToSeePublicDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueToSeePublicDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueToSeePublicDocumentQuery({
 *   variables: {
 *      recaptchaResponse: // value for 'recaptchaResponse'
 *   },
 * });
 */
export function useFindUniqueToSeePublicDocumentQuery(baseOptions: ApolloReact.useQuery.Options<FindUniqueToSeePublicDocumentQuery, FindUniqueToSeePublicDocumentQueryVariables> & ({ variables: FindUniqueToSeePublicDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<FindUniqueToSeePublicDocumentQuery, FindUniqueToSeePublicDocumentQueryVariables>(FindUniqueToSeePublicDocumentDocument, options);
      }
export function useFindUniqueToSeePublicDocumentLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<FindUniqueToSeePublicDocumentQuery, FindUniqueToSeePublicDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<FindUniqueToSeePublicDocumentQuery, FindUniqueToSeePublicDocumentQueryVariables>(FindUniqueToSeePublicDocumentDocument, options);
        }
export function useFindUniqueToSeePublicDocumentSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<FindUniqueToSeePublicDocumentQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<FindUniqueToSeePublicDocumentQuery, FindUniqueToSeePublicDocumentQueryVariables>(FindUniqueToSeePublicDocumentDocument, options);
        }
export type FindUniqueToSeePublicDocumentQueryHookResult = ReturnType<typeof useFindUniqueToSeePublicDocumentQuery>;
export type FindUniqueToSeePublicDocumentLazyQueryHookResult = ReturnType<typeof useFindUniqueToSeePublicDocumentLazyQuery>;
export type FindUniqueToSeePublicDocumentSuspenseQueryHookResult = ReturnType<typeof useFindUniqueToSeePublicDocumentSuspenseQuery>;
export type FindUniqueToSeePublicDocumentQueryResult = ApolloReact.useQuery.Result<FindUniqueToSeePublicDocumentQuery, FindUniqueToSeePublicDocumentQueryVariables>;
export const ForceGenerateDocumentAcademicDocumentationDocument = gql`
    mutation forceGenerateDocumentAcademicDocumentation($docId: String!) {
  forceGenerateDocumentAcademicDocumentation(docId: $docId) {
    id
    documentBaseId
  }
}
    `;

/**
 * __useForceGenerateDocumentAcademicDocumentationMutation__
 *
 * To run a mutation, you first call `useForceGenerateDocumentAcademicDocumentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceGenerateDocumentAcademicDocumentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceGenerateDocumentAcademicDocumentationMutation, { data, loading, error }] = useForceGenerateDocumentAcademicDocumentationMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useForceGenerateDocumentAcademicDocumentationMutation(baseOptions?: ApolloReact.useMutation.Options<ForceGenerateDocumentAcademicDocumentationMutation, ForceGenerateDocumentAcademicDocumentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<ForceGenerateDocumentAcademicDocumentationMutation, ForceGenerateDocumentAcademicDocumentationMutationVariables>(ForceGenerateDocumentAcademicDocumentationDocument, options);
      }
export type ForceGenerateDocumentAcademicDocumentationMutationHookResult = ReturnType<typeof useForceGenerateDocumentAcademicDocumentationMutation>;
export type ForceGenerateDocumentAcademicDocumentationMutationResult = ApolloReact.useMutation.Result<ForceGenerateDocumentAcademicDocumentationMutation>;
export const ForceGenerateDocumentSchoolCurriculumDocument = gql`
    mutation forceGenerateDocumentSchoolCurriculum($docId: String!) {
  forceGenerateDocumentSchoolCurriculum(docId: $docId) {
    id
    documentBaseId
  }
}
    `;

/**
 * __useForceGenerateDocumentSchoolCurriculumMutation__
 *
 * To run a mutation, you first call `useForceGenerateDocumentSchoolCurriculumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceGenerateDocumentSchoolCurriculumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceGenerateDocumentSchoolCurriculumMutation, { data, loading, error }] = useForceGenerateDocumentSchoolCurriculumMutation({
 *   variables: {
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function useForceGenerateDocumentSchoolCurriculumMutation(baseOptions?: ApolloReact.useMutation.Options<ForceGenerateDocumentSchoolCurriculumMutation, ForceGenerateDocumentSchoolCurriculumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<ForceGenerateDocumentSchoolCurriculumMutation, ForceGenerateDocumentSchoolCurriculumMutationVariables>(ForceGenerateDocumentSchoolCurriculumDocument, options);
      }
export type ForceGenerateDocumentSchoolCurriculumMutationHookResult = ReturnType<typeof useForceGenerateDocumentSchoolCurriculumMutation>;
export type ForceGenerateDocumentSchoolCurriculumMutationResult = ApolloReact.useMutation.Result<ForceGenerateDocumentSchoolCurriculumMutation>;
export const GenerateSampleCertificatePdfBase64Document = gql`
    query generateSampleCertificatePdfBase64($template: Json!) {
  generateSampleCertificatePdfBase64(template: $template)
}
    `;

/**
 * __useGenerateSampleCertificatePdfBase64Query__
 *
 * To run a query within a React component, call `useGenerateSampleCertificatePdfBase64Query` and pass it any options that fit your needs.
 * When your component renders, `useGenerateSampleCertificatePdfBase64Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateSampleCertificatePdfBase64Query({
 *   variables: {
 *      template: // value for 'template'
 *   },
 * });
 */
export function useGenerateSampleCertificatePdfBase64Query(baseOptions: ApolloReact.useQuery.Options<GenerateSampleCertificatePdfBase64Query, GenerateSampleCertificatePdfBase64QueryVariables> & ({ variables: GenerateSampleCertificatePdfBase64QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<GenerateSampleCertificatePdfBase64Query, GenerateSampleCertificatePdfBase64QueryVariables>(GenerateSampleCertificatePdfBase64Document, options);
      }
export function useGenerateSampleCertificatePdfBase64LazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<GenerateSampleCertificatePdfBase64Query, GenerateSampleCertificatePdfBase64QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<GenerateSampleCertificatePdfBase64Query, GenerateSampleCertificatePdfBase64QueryVariables>(GenerateSampleCertificatePdfBase64Document, options);
        }
export function useGenerateSampleCertificatePdfBase64SuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<GenerateSampleCertificatePdfBase64QueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<GenerateSampleCertificatePdfBase64Query, GenerateSampleCertificatePdfBase64QueryVariables>(GenerateSampleCertificatePdfBase64Document, options);
        }
export type GenerateSampleCertificatePdfBase64QueryHookResult = ReturnType<typeof useGenerateSampleCertificatePdfBase64Query>;
export type GenerateSampleCertificatePdfBase64LazyQueryHookResult = ReturnType<typeof useGenerateSampleCertificatePdfBase64LazyQuery>;
export type GenerateSampleCertificatePdfBase64SuspenseQueryHookResult = ReturnType<typeof useGenerateSampleCertificatePdfBase64SuspenseQuery>;
export type GenerateSampleCertificatePdfBase64QueryResult = ApolloReact.useQuery.Result<GenerateSampleCertificatePdfBase64Query, GenerateSampleCertificatePdfBase64QueryVariables>;
export const GetDocumentJsonDocument = gql`
    query getDocumentJson($where: DocumentAcademicDocumentationWhereInput) {
  findFirstDocumentAcademicDocumentation(where: $where) {
    id
    documentBaseId
    DocumentBase {
      id
      dataWithIesAndFiles
    }
  }
}
    `;

/**
 * __useGetDocumentJsonQuery__
 *
 * To run a query within a React component, call `useGetDocumentJsonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentJsonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentJsonQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetDocumentJsonQuery(baseOptions?: ApolloReact.useQuery.Options<GetDocumentJsonQuery, GetDocumentJsonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<GetDocumentJsonQuery, GetDocumentJsonQueryVariables>(GetDocumentJsonDocument, options);
      }
export function useGetDocumentJsonLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<GetDocumentJsonQuery, GetDocumentJsonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<GetDocumentJsonQuery, GetDocumentJsonQueryVariables>(GetDocumentJsonDocument, options);
        }
export function useGetDocumentJsonSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<GetDocumentJsonQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<GetDocumentJsonQuery, GetDocumentJsonQueryVariables>(GetDocumentJsonDocument, options);
        }
export type GetDocumentJsonQueryHookResult = ReturnType<typeof useGetDocumentJsonQuery>;
export type GetDocumentJsonLazyQueryHookResult = ReturnType<typeof useGetDocumentJsonLazyQuery>;
export type GetDocumentJsonSuspenseQueryHookResult = ReturnType<typeof useGetDocumentJsonSuspenseQuery>;
export type GetDocumentJsonQueryResult = ApolloReact.useQuery.Result<GetDocumentJsonQuery, GetDocumentJsonQueryVariables>;
export const GetDocumentJsonSchoolCurriculumDocument = gql`
    query getDocumentJsonSchoolCurriculum($where: DocumentSchoolCurriculumWhereUniqueInput!) {
  findUniqueDocumentSchoolCurriculum(where: $where) {
    ...DocumentSchoolCurriculumFields
  }
}
    ${DocumentSchoolCurriculumFieldsFragmentDoc}`;

/**
 * __useGetDocumentJsonSchoolCurriculumQuery__
 *
 * To run a query within a React component, call `useGetDocumentJsonSchoolCurriculumQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentJsonSchoolCurriculumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentJsonSchoolCurriculumQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetDocumentJsonSchoolCurriculumQuery(baseOptions: ApolloReact.useQuery.Options<GetDocumentJsonSchoolCurriculumQuery, GetDocumentJsonSchoolCurriculumQueryVariables> & ({ variables: GetDocumentJsonSchoolCurriculumQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<GetDocumentJsonSchoolCurriculumQuery, GetDocumentJsonSchoolCurriculumQueryVariables>(GetDocumentJsonSchoolCurriculumDocument, options);
      }
export function useGetDocumentJsonSchoolCurriculumLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<GetDocumentJsonSchoolCurriculumQuery, GetDocumentJsonSchoolCurriculumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<GetDocumentJsonSchoolCurriculumQuery, GetDocumentJsonSchoolCurriculumQueryVariables>(GetDocumentJsonSchoolCurriculumDocument, options);
        }
export function useGetDocumentJsonSchoolCurriculumSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<GetDocumentJsonSchoolCurriculumQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<GetDocumentJsonSchoolCurriculumQuery, GetDocumentJsonSchoolCurriculumQueryVariables>(GetDocumentJsonSchoolCurriculumDocument, options);
        }
export type GetDocumentJsonSchoolCurriculumQueryHookResult = ReturnType<typeof useGetDocumentJsonSchoolCurriculumQuery>;
export type GetDocumentJsonSchoolCurriculumLazyQueryHookResult = ReturnType<typeof useGetDocumentJsonSchoolCurriculumLazyQuery>;
export type GetDocumentJsonSchoolCurriculumSuspenseQueryHookResult = ReturnType<typeof useGetDocumentJsonSchoolCurriculumSuspenseQuery>;
export type GetDocumentJsonSchoolCurriculumQueryResult = ApolloReact.useQuery.Result<GetDocumentJsonSchoolCurriculumQuery, GetDocumentJsonSchoolCurriculumQueryVariables>;
export const GetDocumentVariableJsonDocument = gql`
    query getDocumentVariableJson($removeFiles: Boolean, $coverWithMetaAndData: Boolean, $clean: Boolean, $where: DocumentAcademicDocumentationWhereInput) {
  findFirstDocumentAcademicDocumentation(where: $where) {
    id
    DocumentBase {
      id
      internalSeqId
      filePath
      variableJson(
        removeFiles: $removeFiles
        coverWithMetaAndData: $coverWithMetaAndData
        clean: $clean
      )
    }
  }
}
    `;

/**
 * __useGetDocumentVariableJsonQuery__
 *
 * To run a query within a React component, call `useGetDocumentVariableJsonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentVariableJsonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentVariableJsonQuery({
 *   variables: {
 *      removeFiles: // value for 'removeFiles'
 *      coverWithMetaAndData: // value for 'coverWithMetaAndData'
 *      clean: // value for 'clean'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetDocumentVariableJsonQuery(baseOptions?: ApolloReact.useQuery.Options<GetDocumentVariableJsonQuery, GetDocumentVariableJsonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<GetDocumentVariableJsonQuery, GetDocumentVariableJsonQueryVariables>(GetDocumentVariableJsonDocument, options);
      }
export function useGetDocumentVariableJsonLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<GetDocumentVariableJsonQuery, GetDocumentVariableJsonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<GetDocumentVariableJsonQuery, GetDocumentVariableJsonQueryVariables>(GetDocumentVariableJsonDocument, options);
        }
export function useGetDocumentVariableJsonSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<GetDocumentVariableJsonQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<GetDocumentVariableJsonQuery, GetDocumentVariableJsonQueryVariables>(GetDocumentVariableJsonDocument, options);
        }
export type GetDocumentVariableJsonQueryHookResult = ReturnType<typeof useGetDocumentVariableJsonQuery>;
export type GetDocumentVariableJsonLazyQueryHookResult = ReturnType<typeof useGetDocumentVariableJsonLazyQuery>;
export type GetDocumentVariableJsonSuspenseQueryHookResult = ReturnType<typeof useGetDocumentVariableJsonSuspenseQuery>;
export type GetDocumentVariableJsonQueryResult = ApolloReact.useQuery.Result<GetDocumentVariableJsonQuery, GetDocumentVariableJsonQueryVariables>;
export const GetFinancialRechargeDataDocument = gql`
    query getFinancialRechargeData {
  getFinancialRechargePlans {
    discounts {
      id
      count
      valueInPercent
    }
    presets {
      id
      count
    }
    servicesPrices {
      id
      service
      unitPrice
    }
  }
  findManyFinancialCreditCardSaved {
    id
    token
    number
    brand
  }
}
    `;

/**
 * __useGetFinancialRechargeDataQuery__
 *
 * To run a query within a React component, call `useGetFinancialRechargeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialRechargeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialRechargeDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFinancialRechargeDataQuery(baseOptions?: ApolloReact.useQuery.Options<GetFinancialRechargeDataQuery, GetFinancialRechargeDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<GetFinancialRechargeDataQuery, GetFinancialRechargeDataQueryVariables>(GetFinancialRechargeDataDocument, options);
      }
export function useGetFinancialRechargeDataLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<GetFinancialRechargeDataQuery, GetFinancialRechargeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<GetFinancialRechargeDataQuery, GetFinancialRechargeDataQueryVariables>(GetFinancialRechargeDataDocument, options);
        }
export function useGetFinancialRechargeDataSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<GetFinancialRechargeDataQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<GetFinancialRechargeDataQuery, GetFinancialRechargeDataQueryVariables>(GetFinancialRechargeDataDocument, options);
        }
export type GetFinancialRechargeDataQueryHookResult = ReturnType<typeof useGetFinancialRechargeDataQuery>;
export type GetFinancialRechargeDataLazyQueryHookResult = ReturnType<typeof useGetFinancialRechargeDataLazyQuery>;
export type GetFinancialRechargeDataSuspenseQueryHookResult = ReturnType<typeof useGetFinancialRechargeDataSuspenseQuery>;
export type GetFinancialRechargeDataQueryResult = ApolloReact.useQuery.Result<GetFinancialRechargeDataQuery, GetFinancialRechargeDataQueryVariables>;
export const GetFinancialRechargePlansDocument = gql`
    query getFinancialRechargePlans {
  getFinancialRechargePlans {
    ...RechargeOptionsFields
  }
}
    ${RechargeOptionsFieldsFragmentDoc}`;

/**
 * __useGetFinancialRechargePlansQuery__
 *
 * To run a query within a React component, call `useGetFinancialRechargePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialRechargePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialRechargePlansQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFinancialRechargePlansQuery(baseOptions?: ApolloReact.useQuery.Options<GetFinancialRechargePlansQuery, GetFinancialRechargePlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<GetFinancialRechargePlansQuery, GetFinancialRechargePlansQueryVariables>(GetFinancialRechargePlansDocument, options);
      }
export function useGetFinancialRechargePlansLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<GetFinancialRechargePlansQuery, GetFinancialRechargePlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<GetFinancialRechargePlansQuery, GetFinancialRechargePlansQueryVariables>(GetFinancialRechargePlansDocument, options);
        }
export function useGetFinancialRechargePlansSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<GetFinancialRechargePlansQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<GetFinancialRechargePlansQuery, GetFinancialRechargePlansQueryVariables>(GetFinancialRechargePlansDocument, options);
        }
export type GetFinancialRechargePlansQueryHookResult = ReturnType<typeof useGetFinancialRechargePlansQuery>;
export type GetFinancialRechargePlansLazyQueryHookResult = ReturnType<typeof useGetFinancialRechargePlansLazyQuery>;
export type GetFinancialRechargePlansSuspenseQueryHookResult = ReturnType<typeof useGetFinancialRechargePlansSuspenseQuery>;
export type GetFinancialRechargePlansQueryResult = ApolloReact.useQuery.Result<GetFinancialRechargePlansQuery, GetFinancialRechargePlansQueryVariables>;
export const GetMineTeamDocument = gql`
    query getMineTeam($orderBy: [TeamOrderByWithRelationInput!], $skip: Int, $take: Int, $where: TeamWhereInput) {
  getMineTeam(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
    id
    createdAt
    updatedAt
    TeamMember {
      ...TeamMemberFields
    }
    Documents {
      id
      type
    }
  }
  count: getMineTeamCount(where: $where)
}
    ${TeamMemberFieldsFragmentDoc}`;

/**
 * __useGetMineTeamQuery__
 *
 * To run a query within a React component, call `useGetMineTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMineTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMineTeamQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetMineTeamQuery(baseOptions?: ApolloReact.useQuery.Options<GetMineTeamQuery, GetMineTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<GetMineTeamQuery, GetMineTeamQueryVariables>(GetMineTeamDocument, options);
      }
export function useGetMineTeamLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<GetMineTeamQuery, GetMineTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<GetMineTeamQuery, GetMineTeamQueryVariables>(GetMineTeamDocument, options);
        }
export function useGetMineTeamSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<GetMineTeamQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<GetMineTeamQuery, GetMineTeamQueryVariables>(GetMineTeamDocument, options);
        }
export type GetMineTeamQueryHookResult = ReturnType<typeof useGetMineTeamQuery>;
export type GetMineTeamLazyQueryHookResult = ReturnType<typeof useGetMineTeamLazyQuery>;
export type GetMineTeamSuspenseQueryHookResult = ReturnType<typeof useGetMineTeamSuspenseQuery>;
export type GetMineTeamQueryResult = ApolloReact.useQuery.Result<GetMineTeamQuery, GetMineTeamQueryVariables>;
export const GetPrimaryDegreeCertificateTemplateDocument = gql`
    query getPrimaryDegreeCertificateTemplate {
  getMineTeam {
    id
    DefaultDegreeCertificateTemplate {
      id
      name
    }
  }
}
    `;

/**
 * __useGetPrimaryDegreeCertificateTemplateQuery__
 *
 * To run a query within a React component, call `useGetPrimaryDegreeCertificateTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrimaryDegreeCertificateTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrimaryDegreeCertificateTemplateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPrimaryDegreeCertificateTemplateQuery(baseOptions?: ApolloReact.useQuery.Options<GetPrimaryDegreeCertificateTemplateQuery, GetPrimaryDegreeCertificateTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<GetPrimaryDegreeCertificateTemplateQuery, GetPrimaryDegreeCertificateTemplateQueryVariables>(GetPrimaryDegreeCertificateTemplateDocument, options);
      }
export function useGetPrimaryDegreeCertificateTemplateLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<GetPrimaryDegreeCertificateTemplateQuery, GetPrimaryDegreeCertificateTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<GetPrimaryDegreeCertificateTemplateQuery, GetPrimaryDegreeCertificateTemplateQueryVariables>(GetPrimaryDegreeCertificateTemplateDocument, options);
        }
export function useGetPrimaryDegreeCertificateTemplateSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<GetPrimaryDegreeCertificateTemplateQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<GetPrimaryDegreeCertificateTemplateQuery, GetPrimaryDegreeCertificateTemplateQueryVariables>(GetPrimaryDegreeCertificateTemplateDocument, options);
        }
export type GetPrimaryDegreeCertificateTemplateQueryHookResult = ReturnType<typeof useGetPrimaryDegreeCertificateTemplateQuery>;
export type GetPrimaryDegreeCertificateTemplateLazyQueryHookResult = ReturnType<typeof useGetPrimaryDegreeCertificateTemplateLazyQuery>;
export type GetPrimaryDegreeCertificateTemplateSuspenseQueryHookResult = ReturnType<typeof useGetPrimaryDegreeCertificateTemplateSuspenseQuery>;
export type GetPrimaryDegreeCertificateTemplateQueryResult = ApolloReact.useQuery.Result<GetPrimaryDegreeCertificateTemplateQuery, GetPrimaryDegreeCertificateTemplateQueryVariables>;
export const GetTeamConfigsDocument = gql`
    query getTeamConfigs($orderBy: [TeamOrderByWithRelationInput!], $skip: Int, $take: Int, $where: TeamWhereInput) {
  getMineTeam(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
    id
    configAddDocumentSignerNode
  }
}
    `;

/**
 * __useGetTeamConfigsQuery__
 *
 * To run a query within a React component, call `useGetTeamConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamConfigsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetTeamConfigsQuery(baseOptions?: ApolloReact.useQuery.Options<GetTeamConfigsQuery, GetTeamConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<GetTeamConfigsQuery, GetTeamConfigsQueryVariables>(GetTeamConfigsDocument, options);
      }
export function useGetTeamConfigsLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<GetTeamConfigsQuery, GetTeamConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<GetTeamConfigsQuery, GetTeamConfigsQueryVariables>(GetTeamConfigsDocument, options);
        }
export function useGetTeamConfigsSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<GetTeamConfigsQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<GetTeamConfigsQuery, GetTeamConfigsQueryVariables>(GetTeamConfigsDocument, options);
        }
export type GetTeamConfigsQueryHookResult = ReturnType<typeof useGetTeamConfigsQuery>;
export type GetTeamConfigsLazyQueryHookResult = ReturnType<typeof useGetTeamConfigsLazyQuery>;
export type GetTeamConfigsSuspenseQueryHookResult = ReturnType<typeof useGetTeamConfigsSuspenseQuery>;
export type GetTeamConfigsQueryResult = ApolloReact.useQuery.Result<GetTeamConfigsQuery, GetTeamConfigsQueryVariables>;
export const MeDocument = gql`
    query me {
  me {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: ApolloReact.useQuery.Options<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<MeQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = ApolloReact.useQuery.Result<MeQuery, MeQueryVariables>;
export const RenotarizationForceStageDocument = gql`
    query renotarizationForceStage($documentId: String!) {
  renotarizationForceStage(documentId: $documentId)
}
    `;

/**
 * __useRenotarizationForceStageQuery__
 *
 * To run a query within a React component, call `useRenotarizationForceStageQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenotarizationForceStageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenotarizationForceStageQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useRenotarizationForceStageQuery(baseOptions: ApolloReact.useQuery.Options<RenotarizationForceStageQuery, RenotarizationForceStageQueryVariables> & ({ variables: RenotarizationForceStageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<RenotarizationForceStageQuery, RenotarizationForceStageQueryVariables>(RenotarizationForceStageDocument, options);
      }
export function useRenotarizationForceStageLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<RenotarizationForceStageQuery, RenotarizationForceStageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<RenotarizationForceStageQuery, RenotarizationForceStageQueryVariables>(RenotarizationForceStageDocument, options);
        }
export function useRenotarizationForceStageSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<RenotarizationForceStageQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<RenotarizationForceStageQuery, RenotarizationForceStageQueryVariables>(RenotarizationForceStageDocument, options);
        }
export type RenotarizationForceStageQueryHookResult = ReturnType<typeof useRenotarizationForceStageQuery>;
export type RenotarizationForceStageLazyQueryHookResult = ReturnType<typeof useRenotarizationForceStageLazyQuery>;
export type RenotarizationForceStageSuspenseQueryHookResult = ReturnType<typeof useRenotarizationForceStageSuspenseQuery>;
export type RenotarizationForceStageQueryResult = ApolloReact.useQuery.Result<RenotarizationForceStageQuery, RenotarizationForceStageQueryVariables>;
export const StartOneSignatureDocument = gql`
    mutation startOneSignature($inviteId: Int!, $certificate: String!) {
  startOneSignature(inviteId: $inviteId, certificate: $certificate) {
    id
    dataToSign
    signingTime
    lastSignatureIsoString
  }
}
    `;

/**
 * __useStartOneSignatureMutation__
 *
 * To run a mutation, you first call `useStartOneSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartOneSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startOneSignatureMutation, { data, loading, error }] = useStartOneSignatureMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *      certificate: // value for 'certificate'
 *   },
 * });
 */
export function useStartOneSignatureMutation(baseOptions?: ApolloReact.useMutation.Options<StartOneSignatureMutation, StartOneSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<StartOneSignatureMutation, StartOneSignatureMutationVariables>(StartOneSignatureDocument, options);
      }
export type StartOneSignatureMutationHookResult = ReturnType<typeof useStartOneSignatureMutation>;
export type StartOneSignatureMutationResult = ApolloReact.useMutation.Result<StartOneSignatureMutation>;
export const StartOneSignatureExternalSignatureInviteDocument = gql`
    mutation startOneSignatureExternalSignatureInvite($inviteId: String!, $certificate: String!) {
  startOneSignature: startOneSignatureExternalSignatureInvite(
    inviteId: $inviteId
    certificate: $certificate
  ) {
    id
    dataToSign
    signingTime
    lastSignatureIsoString
  }
}
    `;

/**
 * __useStartOneSignatureExternalSignatureInviteMutation__
 *
 * To run a mutation, you first call `useStartOneSignatureExternalSignatureInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartOneSignatureExternalSignatureInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startOneSignatureExternalSignatureInviteMutation, { data, loading, error }] = useStartOneSignatureExternalSignatureInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *      certificate: // value for 'certificate'
 *   },
 * });
 */
export function useStartOneSignatureExternalSignatureInviteMutation(baseOptions?: ApolloReact.useMutation.Options<StartOneSignatureExternalSignatureInviteMutation, StartOneSignatureExternalSignatureInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<StartOneSignatureExternalSignatureInviteMutation, StartOneSignatureExternalSignatureInviteMutationVariables>(StartOneSignatureExternalSignatureInviteDocument, options);
      }
export type StartOneSignatureExternalSignatureInviteMutationHookResult = ReturnType<typeof useStartOneSignatureExternalSignatureInviteMutation>;
export type StartOneSignatureExternalSignatureInviteMutationResult = ApolloReact.useMutation.Result<StartOneSignatureExternalSignatureInviteMutation>;
export const SummaryFinancialChargeDocument = gql`
    query summaryFinancialCharge($where: FinancialChargeWhereInput) {
  summaryFinancialCharge(where: $where) {
    id
    sum
    count
  }
}
    `;

/**
 * __useSummaryFinancialChargeQuery__
 *
 * To run a query within a React component, call `useSummaryFinancialChargeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummaryFinancialChargeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummaryFinancialChargeQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSummaryFinancialChargeQuery(baseOptions?: ApolloReact.useQuery.Options<SummaryFinancialChargeQuery, SummaryFinancialChargeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<SummaryFinancialChargeQuery, SummaryFinancialChargeQueryVariables>(SummaryFinancialChargeDocument, options);
      }
export function useSummaryFinancialChargeLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<SummaryFinancialChargeQuery, SummaryFinancialChargeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<SummaryFinancialChargeQuery, SummaryFinancialChargeQueryVariables>(SummaryFinancialChargeDocument, options);
        }
export function useSummaryFinancialChargeSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<SummaryFinancialChargeQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<SummaryFinancialChargeQuery, SummaryFinancialChargeQueryVariables>(SummaryFinancialChargeDocument, options);
        }
export type SummaryFinancialChargeQueryHookResult = ReturnType<typeof useSummaryFinancialChargeQuery>;
export type SummaryFinancialChargeLazyQueryHookResult = ReturnType<typeof useSummaryFinancialChargeLazyQuery>;
export type SummaryFinancialChargeSuspenseQueryHookResult = ReturnType<typeof useSummaryFinancialChargeSuspenseQuery>;
export type SummaryFinancialChargeQueryResult = ApolloReact.useQuery.Result<SummaryFinancialChargeQuery, SummaryFinancialChargeQueryVariables>;
export const UpdateOneDegreeVisualRepresentationDocument = gql`
    mutation updateOneDegreeVisualRepresentation($degreeId: String!, $visualRepresentation: Upload!) {
  updateOneDegreeVisualRepresentation(
    degreeId: $degreeId
    visualRepresentation: $visualRepresentation
  ) {
    id
    documentBaseId
  }
}
    `;

/**
 * __useUpdateOneDegreeVisualRepresentationMutation__
 *
 * To run a mutation, you first call `useUpdateOneDegreeVisualRepresentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneDegreeVisualRepresentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneDegreeVisualRepresentationMutation, { data, loading, error }] = useUpdateOneDegreeVisualRepresentationMutation({
 *   variables: {
 *      degreeId: // value for 'degreeId'
 *      visualRepresentation: // value for 'visualRepresentation'
 *   },
 * });
 */
export function useUpdateOneDegreeVisualRepresentationMutation(baseOptions?: ApolloReact.useMutation.Options<UpdateOneDegreeVisualRepresentationMutation, UpdateOneDegreeVisualRepresentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useMutation<UpdateOneDegreeVisualRepresentationMutation, UpdateOneDegreeVisualRepresentationMutationVariables>(UpdateOneDegreeVisualRepresentationDocument, options);
      }
export type UpdateOneDegreeVisualRepresentationMutationHookResult = ReturnType<typeof useUpdateOneDegreeVisualRepresentationMutation>;
export type UpdateOneDegreeVisualRepresentationMutationResult = ApolloReact.useMutation.Result<UpdateOneDegreeVisualRepresentationMutation>;
export const ValidateOneDocumentCertificateDocument = gql`
    query validateOneDocumentCertificate($file: Upload, $docId: String, $recaptchaResponse: String!) {
  validateOneDocumentCertificate(
    file: $file
    docId: $docId
    recaptchaResponse: $recaptchaResponse
  ) {
    id
    certificate {
      ...DocumentCertificateValidateFields
    }
    validationResult {
      id
      isValid
    }
  }
}
    ${DocumentCertificateValidateFieldsFragmentDoc}`;

/**
 * __useValidateOneDocumentCertificateQuery__
 *
 * To run a query within a React component, call `useValidateOneDocumentCertificateQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateOneDocumentCertificateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateOneDocumentCertificateQuery({
 *   variables: {
 *      file: // value for 'file'
 *      docId: // value for 'docId'
 *      recaptchaResponse: // value for 'recaptchaResponse'
 *   },
 * });
 */
export function useValidateOneDocumentCertificateQuery(baseOptions: ApolloReact.useQuery.Options<ValidateOneDocumentCertificateQuery, ValidateOneDocumentCertificateQueryVariables> & ({ variables: ValidateOneDocumentCertificateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useQuery<ValidateOneDocumentCertificateQuery, ValidateOneDocumentCertificateQueryVariables>(ValidateOneDocumentCertificateDocument, options);
      }
export function useValidateOneDocumentCertificateLazyQuery(baseOptions?: ApolloReact.useLazyQuery.Options<ValidateOneDocumentCertificateQuery, ValidateOneDocumentCertificateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReact.useLazyQuery<ValidateOneDocumentCertificateQuery, ValidateOneDocumentCertificateQueryVariables>(ValidateOneDocumentCertificateDocument, options);
        }
export function useValidateOneDocumentCertificateSuspenseQuery(baseOptions: ApolloReact.SkipToken | ApolloReact.useSuspenseQuery.Options<ValidateOneDocumentCertificateQueryVariables> ) {
          const options = baseOptions === ApolloReact.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReact.useSuspenseQuery<ValidateOneDocumentCertificateQuery, ValidateOneDocumentCertificateQueryVariables>(ValidateOneDocumentCertificateDocument, options);
        }
export type ValidateOneDocumentCertificateQueryHookResult = ReturnType<typeof useValidateOneDocumentCertificateQuery>;
export type ValidateOneDocumentCertificateLazyQueryHookResult = ReturnType<typeof useValidateOneDocumentCertificateLazyQuery>;
export type ValidateOneDocumentCertificateSuspenseQueryHookResult = ReturnType<typeof useValidateOneDocumentCertificateSuspenseQuery>;
export type ValidateOneDocumentCertificateQueryResult = ApolloReact.useQuery.Result<ValidateOneDocumentCertificateQuery, ValidateOneDocumentCertificateQueryVariables>;
export const WatchFindFirstDocumentAcademicDocumentationDocument = gql`
    subscription watchFindFirstDocumentAcademicDocumentation($where: DocumentAcademicDocumentationWhereInput!) {
  findFirstDocumentAcademicDocumentation(where: $where) {
    id
    documentBaseId
    type
    DocumentBase {
      id
      type
      internalSeqId
      version
      createdAt
      creationType
      data
      filePath
      signatureConfig
      UserOwner {
        id
        email
      }
      DocumentBaseSignatureInviteGroups {
        ...DocumentBaseSignatureInviteGroupFields
      }
      Histories(orderBy: {createdAt: asc}) {
        id
        description
        status
        createdAt
        data
        UserCreated {
          id
          name
          photo
          email
        }
      }
    }
    ChildDocuments {
      id
      status
      DocumentBase {
        id
        internalSeqId
        version
        createdAt
      }
    }
    status
  }
}
    ${DocumentBaseSignatureInviteGroupFieldsFragmentDoc}`;

/**
 * __useWatchFindFirstDocumentAcademicDocumentationSubscription__
 *
 * To run a query within a React component, call `useWatchFindFirstDocumentAcademicDocumentationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchFindFirstDocumentAcademicDocumentationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchFindFirstDocumentAcademicDocumentationSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useWatchFindFirstDocumentAcademicDocumentationSubscription(baseOptions: ApolloReact.useSubscription.Options<WatchFindFirstDocumentAcademicDocumentationSubscription, WatchFindFirstDocumentAcademicDocumentationSubscriptionVariables> & ({ variables: WatchFindFirstDocumentAcademicDocumentationSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useSubscription<WatchFindFirstDocumentAcademicDocumentationSubscription, WatchFindFirstDocumentAcademicDocumentationSubscriptionVariables>(WatchFindFirstDocumentAcademicDocumentationDocument, options);
      }
export type WatchFindFirstDocumentAcademicDocumentationSubscriptionHookResult = ReturnType<typeof useWatchFindFirstDocumentAcademicDocumentationSubscription>;
export type WatchFindFirstDocumentAcademicDocumentationSubscriptionResult = ApolloReact.useSubscription.Result<WatchFindFirstDocumentAcademicDocumentationSubscription>;
export const FindUniqueSignSignatureImageSubDocument = gql`
    subscription findUniqueSignSignatureImageSub($where: SignSignatureImageWhereUniqueInput!) {
  findUniqueSignSignatureImage(where: $where) {
    ...SignSignatureImageUniqueFields
  }
}
    ${SignSignatureImageUniqueFieldsFragmentDoc}`;

/**
 * __useFindUniqueSignSignatureImageSubSubscription__
 *
 * To run a query within a React component, call `useFindUniqueSignSignatureImageSubSubscription` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueSignSignatureImageSubSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueSignSignatureImageSubSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueSignSignatureImageSubSubscription(baseOptions: ApolloReact.useSubscription.Options<FindUniqueSignSignatureImageSubSubscription, FindUniqueSignSignatureImageSubSubscriptionVariables> & ({ variables: FindUniqueSignSignatureImageSubSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useSubscription<FindUniqueSignSignatureImageSubSubscription, FindUniqueSignSignatureImageSubSubscriptionVariables>(FindUniqueSignSignatureImageSubDocument, options);
      }
export type FindUniqueSignSignatureImageSubSubscriptionHookResult = ReturnType<typeof useFindUniqueSignSignatureImageSubSubscription>;
export type FindUniqueSignSignatureImageSubSubscriptionResult = ApolloReact.useSubscription.Result<FindUniqueSignSignatureImageSubSubscription>;
export const GeneratedCertificateDocument = gql`
    subscription GeneratedCertificate($institutionId: Int!, $bulkCertificateRecordId: String!) {
  generatedCertificate(
    institutionId: $institutionId
    bulkCertificateRecordId: $bulkCertificateRecordId
  ) {
    id
    institutionId
    bulkCertificateRecordId
    certificateId
    totalIssued
    totalCertificates
  }
}
    `;

/**
 * __useGeneratedCertificateSubscription__
 *
 * To run a query within a React component, call `useGeneratedCertificateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGeneratedCertificateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneratedCertificateSubscription({
 *   variables: {
 *      institutionId: // value for 'institutionId'
 *      bulkCertificateRecordId: // value for 'bulkCertificateRecordId'
 *   },
 * });
 */
export function useGeneratedCertificateSubscription(baseOptions: ApolloReact.useSubscription.Options<GeneratedCertificateSubscription, GeneratedCertificateSubscriptionVariables> & ({ variables: GeneratedCertificateSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useSubscription<GeneratedCertificateSubscription, GeneratedCertificateSubscriptionVariables>(GeneratedCertificateDocument, options);
      }
export type GeneratedCertificateSubscriptionHookResult = ReturnType<typeof useGeneratedCertificateSubscription>;
export type GeneratedCertificateSubscriptionResult = ApolloReact.useSubscription.Result<GeneratedCertificateSubscription>;
export const WatchSignBulkCertificateDocument = gql`
    subscription watchSignBulkCertificate($bulkId: String!) {
  watchSignBulkCertificate(bulkId: $bulkId) {
    id
    documentsCompleted
    status
    totalInviteForSign
  }
}
    `;

/**
 * __useWatchSignBulkCertificateSubscription__
 *
 * To run a query within a React component, call `useWatchSignBulkCertificateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchSignBulkCertificateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchSignBulkCertificateSubscription({
 *   variables: {
 *      bulkId: // value for 'bulkId'
 *   },
 * });
 */
export function useWatchSignBulkCertificateSubscription(baseOptions: ApolloReact.useSubscription.Options<WatchSignBulkCertificateSubscription, WatchSignBulkCertificateSubscriptionVariables> & ({ variables: WatchSignBulkCertificateSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useSubscription<WatchSignBulkCertificateSubscription, WatchSignBulkCertificateSubscriptionVariables>(WatchSignBulkCertificateDocument, options);
      }
export type WatchSignBulkCertificateSubscriptionHookResult = ReturnType<typeof useWatchSignBulkCertificateSubscription>;
export type WatchSignBulkCertificateSubscriptionResult = ApolloReact.useSubscription.Result<WatchSignBulkCertificateSubscription>;
export const WatchSignValidationBulkCertificateDocument = gql`
    subscription watchSignValidationBulkCertificate($bulkId: String!) {
  watchSignValidationBulkCertificate(bulkId: $bulkId) {
    id
    status
  }
}
    `;

/**
 * __useWatchSignValidationBulkCertificateSubscription__
 *
 * To run a query within a React component, call `useWatchSignValidationBulkCertificateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchSignValidationBulkCertificateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchSignValidationBulkCertificateSubscription({
 *   variables: {
 *      bulkId: // value for 'bulkId'
 *   },
 * });
 */
export function useWatchSignValidationBulkCertificateSubscription(baseOptions: ApolloReact.useSubscription.Options<WatchSignValidationBulkCertificateSubscription, WatchSignValidationBulkCertificateSubscriptionVariables> & ({ variables: WatchSignValidationBulkCertificateSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useSubscription<WatchSignValidationBulkCertificateSubscription, WatchSignValidationBulkCertificateSubscriptionVariables>(WatchSignValidationBulkCertificateDocument, options);
      }
export type WatchSignValidationBulkCertificateSubscriptionHookResult = ReturnType<typeof useWatchSignValidationBulkCertificateSubscription>;
export type WatchSignValidationBulkCertificateSubscriptionResult = ApolloReact.useSubscription.Result<WatchSignValidationBulkCertificateSubscription>;
export const WatchSingleCertificateSignValidationEventDocument = gql`
    subscription watchSingleCertificateSignValidationEvent($inviteId: String!) {
  watchSingleCertificateSignValidationEvent(inviteId: $inviteId) {
    id
    status
  }
}
    `;

/**
 * __useWatchSingleCertificateSignValidationEventSubscription__
 *
 * To run a query within a React component, call `useWatchSingleCertificateSignValidationEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchSingleCertificateSignValidationEventSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchSingleCertificateSignValidationEventSubscription({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useWatchSingleCertificateSignValidationEventSubscription(baseOptions: ApolloReact.useSubscription.Options<WatchSingleCertificateSignValidationEventSubscription, WatchSingleCertificateSignValidationEventSubscriptionVariables> & ({ variables: WatchSingleCertificateSignValidationEventSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useSubscription<WatchSingleCertificateSignValidationEventSubscription, WatchSingleCertificateSignValidationEventSubscriptionVariables>(WatchSingleCertificateSignValidationEventDocument, options);
      }
export type WatchSingleCertificateSignValidationEventSubscriptionHookResult = ReturnType<typeof useWatchSingleCertificateSignValidationEventSubscription>;
export type WatchSingleCertificateSignValidationEventSubscriptionResult = ApolloReact.useSubscription.Result<WatchSingleCertificateSignValidationEventSubscription>;
export const WatchCertificateTemplateDataDocument = gql`
    subscription watchCertificateTemplateData($teamId: Int!, $templateId: String!) {
  watchCertificateTemplateData(teamId: $teamId, templateId: $templateId) {
    id
    data
  }
}
    `;

/**
 * __useWatchCertificateTemplateDataSubscription__
 *
 * To run a query within a React component, call `useWatchCertificateTemplateDataSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchCertificateTemplateDataSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchCertificateTemplateDataSubscription({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useWatchCertificateTemplateDataSubscription(baseOptions: ApolloReact.useSubscription.Options<WatchCertificateTemplateDataSubscription, WatchCertificateTemplateDataSubscriptionVariables> & ({ variables: WatchCertificateTemplateDataSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useSubscription<WatchCertificateTemplateDataSubscription, WatchCertificateTemplateDataSubscriptionVariables>(WatchCertificateTemplateDataDocument, options);
      }
export type WatchCertificateTemplateDataSubscriptionHookResult = ReturnType<typeof useWatchCertificateTemplateDataSubscription>;
export type WatchCertificateTemplateDataSubscriptionResult = ApolloReact.useSubscription.Result<WatchCertificateTemplateDataSubscription>;
export const WatchDocumentFocusDocument = gql`
    subscription watchDocumentFocus($documentId: String!, $teamId: Int!) {
  watchDocumentFocus(documentId: $documentId, teamId: $teamId) {
    ...WatchDocumentFocusFields
  }
}
    ${WatchDocumentFocusFieldsFragmentDoc}`;

/**
 * __useWatchDocumentFocusSubscription__
 *
 * To run a query within a React component, call `useWatchDocumentFocusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchDocumentFocusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchDocumentFocusSubscription({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useWatchDocumentFocusSubscription(baseOptions: ApolloReact.useSubscription.Options<WatchDocumentFocusSubscription, WatchDocumentFocusSubscriptionVariables> & ({ variables: WatchDocumentFocusSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useSubscription<WatchDocumentFocusSubscription, WatchDocumentFocusSubscriptionVariables>(WatchDocumentFocusDocument, options);
      }
export type WatchDocumentFocusSubscriptionHookResult = ReturnType<typeof useWatchDocumentFocusSubscription>;
export type WatchDocumentFocusSubscriptionResult = ApolloReact.useSubscription.Result<WatchDocumentFocusSubscription>;
export const WatchDocumentPatchesDocument = gql`
    subscription watchDocumentPatches($documentId: String!, $teamId: Int!) {
  watchDocumentPatches(documentId: $documentId, teamId: $teamId) {
    ...WatchDocumentPatchFields
  }
}
    ${WatchDocumentPatchFieldsFragmentDoc}`;

/**
 * __useWatchDocumentPatchesSubscription__
 *
 * To run a query within a React component, call `useWatchDocumentPatchesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchDocumentPatchesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchDocumentPatchesSubscription({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useWatchDocumentPatchesSubscription(baseOptions: ApolloReact.useSubscription.Options<WatchDocumentPatchesSubscription, WatchDocumentPatchesSubscriptionVariables> & ({ variables: WatchDocumentPatchesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useSubscription<WatchDocumentPatchesSubscription, WatchDocumentPatchesSubscriptionVariables>(WatchDocumentPatchesDocument, options);
      }
export type WatchDocumentPatchesSubscriptionHookResult = ReturnType<typeof useWatchDocumentPatchesSubscription>;
export type WatchDocumentPatchesSubscriptionResult = ApolloReact.useSubscription.Result<WatchDocumentPatchesSubscription>;
export const WatchDocumentStatusDocument = gql`
    subscription watchDocumentStatus($documentId: String!, $teamId: Int!) {
  watchDocumentStatus(documentId: $documentId, teamId: $teamId)
}
    `;

/**
 * __useWatchDocumentStatusSubscription__
 *
 * To run a query within a React component, call `useWatchDocumentStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchDocumentStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchDocumentStatusSubscription({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useWatchDocumentStatusSubscription(baseOptions: ApolloReact.useSubscription.Options<WatchDocumentStatusSubscription, WatchDocumentStatusSubscriptionVariables> & ({ variables: WatchDocumentStatusSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useSubscription<WatchDocumentStatusSubscription, WatchDocumentStatusSubscriptionVariables>(WatchDocumentStatusDocument, options);
      }
export type WatchDocumentStatusSubscriptionHookResult = ReturnType<typeof useWatchDocumentStatusSubscription>;
export type WatchDocumentStatusSubscriptionResult = ApolloReact.useSubscription.Result<WatchDocumentStatusSubscription>;
export const WatchFinancialTeamWalletDocument = gql`
    subscription watchFinancialTeamWallet {
  watchFinancialTeamWallet {
    id
    creditsPlanVisual
    creditsPlanTrial
    creditsPlanRb
    creditsPlanRtRa
    creditsDetachedVisual
    creditsDetachedRb
    creditsDetachedRtRa
    teamId
  }
}
    `;

/**
 * __useWatchFinancialTeamWalletSubscription__
 *
 * To run a query within a React component, call `useWatchFinancialTeamWalletSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchFinancialTeamWalletSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchFinancialTeamWalletSubscription({
 *   variables: {
 *   },
 * });
 */
export function useWatchFinancialTeamWalletSubscription(baseOptions?: ApolloReact.useSubscription.Options<WatchFinancialTeamWalletSubscription, WatchFinancialTeamWalletSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useSubscription<WatchFinancialTeamWalletSubscription, WatchFinancialTeamWalletSubscriptionVariables>(WatchFinancialTeamWalletDocument, options);
      }
export type WatchFinancialTeamWalletSubscriptionHookResult = ReturnType<typeof useWatchFinancialTeamWalletSubscription>;
export type WatchFinancialTeamWalletSubscriptionResult = ApolloReact.useSubscription.Result<WatchFinancialTeamWalletSubscription>;
export const WatchTeamSpaceUsageDocument = gql`
    subscription watchTeamSpaceUsage {
  watchTeamSpaceUsage {
    id
    spaceUsage
    storage
    maintainerSpace {
      id
      usage
      storage
    }
  }
}
    `;

/**
 * __useWatchTeamSpaceUsageSubscription__
 *
 * To run a query within a React component, call `useWatchTeamSpaceUsageSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchTeamSpaceUsageSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchTeamSpaceUsageSubscription({
 *   variables: {
 *   },
 * });
 */
export function useWatchTeamSpaceUsageSubscription(baseOptions?: ApolloReact.useSubscription.Options<WatchTeamSpaceUsageSubscription, WatchTeamSpaceUsageSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReact.useSubscription<WatchTeamSpaceUsageSubscription, WatchTeamSpaceUsageSubscriptionVariables>(WatchTeamSpaceUsageDocument, options);
      }
export type WatchTeamSpaceUsageSubscriptionHookResult = ReturnType<typeof useWatchTeamSpaceUsageSubscription>;
export type WatchTeamSpaceUsageSubscriptionResult = ApolloReact.useSubscription.Result<WatchTeamSpaceUsageSubscription>;